var hD = Object.defineProperty;
var pD = (ce, ie, me) => ie in ce ? hD(ce, ie, { enumerable: !0, configurable: !0, writable: !0, value: me }) : ce[ie] = me;
var M1 = (ce, ie, me) => pD(ce, typeof ie != "symbol" ? ie + "" : ie, me);
import * as React from "react";
import React__default, { useState, useLayoutEffect as useLayoutEffect$2, version, isValidElement, useRef, useEffect, forwardRef, useImperativeHandle, PureComponent, Component, useCallback, useMemo as useMemo$1, useContext, Fragment, createContext, memo, cloneElement, createElement as createElement$1, Suspense } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal, flushSync, unstable_batchedUpdates } from "react-dom";
import r from "./assets/d917998a89bbcd7b.svg";
import o$1 from "./assets/359a872511e20bc8.svg";
import e$1 from "./assets/7edf40b8579faa30.svg";
import a$1 from "./assets/b05be70f0d805070.svg";
import i$2 from "./assets/66839984f643ea2b.svg";
import t$1 from "./assets/cd4b21e95186aab2.svg";
import l$1 from "./assets/21cd316eb9e21e2f.svg";
import m$1 from "./assets/6151dccfb85686e4.svg";
import n$1 from "./assets/a763755d0e3ef326.svg";
import c$2 from "./assets/d9766e27fe0a7573.svg";
import s$1 from "./assets/c3fb9cb0f44e0511.svg";
import p$2 from "./assets/5229cd45e3a9966f.svg";
import d$2 from "./assets/0d12f96709ce71ff.svg";
import f$2 from "./assets/2d5121e35c96e25d.svg";
import h$2 from "./assets/4c21eb0392854f50.svg";
import g$1 from "./assets/7df9a04bf0e21dc6.svg";
import u$2 from "./assets/725941f0132cc713.svg";
import w$2 from "./assets/d56467651f917f25.svg";
import b$1 from "./assets/e767753b22b4b842.svg";
import U$1 from "./assets/9fbf8d4f954a2f5f.svg";
import k$1 from "./assets/f5e12b067a9977ec.svg";
import y$1 from "./assets/169b664b6867fba7.svg";
import v$1 from "./assets/0f7f53baa90e9568.svg";
import $ from "./assets/d1fa05c7755fd60b.svg";
import x$2 from "./assets/3d71e164da1d1c6a.svg";
import A$1 from "./assets/0f9dbdfb410fcf14.svg";
import C$1 from "./assets/5ce36069ac26d4a9.svg";
import D$1 from "./assets/5e5a874960958825.svg";
import z from "./assets/04b0ec336b1dc30b.svg";
import S$1 from "./assets/f975e983f80f84b9.svg";
import M$1 from "./assets/c2176f5fbc5f1ec4.svg";
import q$1 from "./assets/aadf93c13b27518e.svg";
import P$1 from "./assets/d7938744f0e1f052.svg";
import R$1 from "./assets/a00f9d5fe3e59fef.svg";
import B$1 from "./assets/ddba01796cb14fff.svg";
import L$1 from "./assets/564abc87729d8774.svg";
import T from "./assets/e6e9bb14878b33c6.svg";
import E from "./assets/be3d64a218f9885c.svg";
import H from "./assets/d5f40c50a8575ce3.svg";
import F$1 from "./assets/483e07f307a95ff1.svg";
import G from "./assets/258735fccf26eeb6.svg";
import O$1 from "./assets/45a8744e6fceea44.svg";
import j$1 from "./assets/ccf4a8061dc46bdf.svg";
import I from "./assets/26f49824379c1c46.svg";
import X$1 from "./assets/fd0f8f70329ae95f.svg";
import K$1 from "./assets/183f53235c0d9657.svg";
import Q from "./assets/a13e986cb9081af1.svg";
import V$2 from "./assets/c65dfa860e60b26b.svg";
import N from "./assets/7daa9d656fba57e3.svg";
import W$2 from "./assets/2d32c13917262e7d.svg";
import Z$2 from "./assets/3b2e37552d2c59ad.svg";
import J$1 from "./assets/cda1a182e992cbf0.svg";
import Y$2 from "./assets/0c0528030c884838.svg";
import _$1 from "./assets/f55ff1ecc56efcc8.svg";
import rr from "./assets/7517d0e90baddb22.svg";
import or from "./assets/18fc18fcf865bdf7.svg";
import er from "./assets/d317f5a70266591c.svg";
import ar from "./assets/1b9015c67c57a06e.svg";
import ir from "./assets/2b2aaea69b8ebe3f.svg";
import tr from "./assets/be8a4f5ed9dfb474.svg";
import lr from "./assets/3caaee14a0fe97a2.svg";
import mr$1 from "./assets/47bc977d8044df12.svg";
import nr from "./assets/6db92e52d2888808.svg";
import cr from "./assets/25220e734dece026.svg";
import sr from "./assets/8a061f5f00e35ab5.svg";
import pr$1 from "./assets/26ff3da5ffa6f9c5.svg";
import dr$1 from "./assets/58e18c0d3e8bbc19.svg";
import fr$2 from "./assets/2851f98dce6d04e4.svg";
import hr$1 from "./assets/249793256707c78f.svg";
import gr$1 from "./assets/7014e9d5f83d2d71.svg";
import ur from "./assets/37c8749b536d6a27.svg";
import wr$1 from "./assets/db2c823e9ecd3576.svg";
import br$1 from "./assets/3e6676e0986ec757.svg";
import Ur$1 from "./assets/61b82ea959a495fc.svg";
import kr$1 from "./assets/b5c648ff276a15e7.svg";
import yr$1 from "./assets/e453e201122d7f77.svg";
import vr$1 from "./assets/675c5de437bcb7aa.svg";
import $r$1 from "./assets/be305e31aed8f29e.svg";
import xr$1 from "./assets/712d054956ced01c.svg";
import Ar$1 from "./assets/5b42eaca0625ac0b.svg";
import Cr$1 from "./assets/dbe10f22605e96c6.svg";
import Dr$1 from "./assets/98bf022bdefbce34.svg";
import zr$1 from "./assets/c49dff427b756aab.svg";
import Sr$1 from "./assets/bf0a2111d8cc3c29.svg";
import Mr$1 from "./assets/c3f5121184dd46bf.svg";
import qr$1 from "./assets/e13733178bbf1e53.svg";
import Pr$1 from "./assets/e08f45dd3972359b.svg";
import Rr$1 from "./assets/5eb611b0e73cbac3.svg";
import Br$1 from "./assets/cee494450f117376.svg";
import Lr$1 from "./assets/8cde8397ea9a748e.svg";
import Tr$1 from "./assets/c5455ea4f0f593e6.svg";
import "./assets/90acf2ed32052560.svg";
import "./assets/e93db083cd1ecf6e.svg";
import "./assets/9c9994c305c33f2d.svg";
import "./assets/38da7de36057af07.svg";
import "./assets/fe6cc71e770e2c6e.svg";
import "./assets/227f547c58d13bce.svg";
import "./assets/cf32ee49f9484daa.svg";
import "./assets/eed7daf4b748a396.svg";
import "./assets/f4e19294e5ca831b.svg";
import "./assets/90bf153b7743ba8d.svg";
import "./assets/c9937356d3f67444.svg";
import "./assets/68b91b161e5afaca.svg";
import "./assets/bf745de25a6ebece.svg";
import "./assets/26ec3886f9c4f57f.svg";
import "./assets/fb00509ebe5ea0ec.svg";
import "./assets/2db3933934719fb1.svg";
import "./assets/783e00dc26e3fa59.svg";
import "./assets/1a5821e0d3dd722c.svg";
import "./assets/602e99e6b4e073e4.svg";
import "./assets/aaa5be5cebf703b0.svg";
import "./assets/a3651330c8c6922b.svg";
import "./assets/47017149cc68e7d0.svg";
import "./assets/62548266dcc0a60d.svg";
import "./assets/3722f3306c0ffbba.svg";
import "./assets/edf2359d6810a31e.svg";
import "./assets/7c2bc884d57ffd06.svg";
import "./assets/cd409711559b435d.svg";
import "./assets/4b5e46a157819e4c.svg";
import "./assets/ae7ee922fff859d7.svg";
import "./assets/8788f309ff9a9cd2.svg";
import "./assets/65355061e83da121.svg";
import "./assets/0b44134d86a6cf02.svg";
import "./assets/73b153e58be6c566.svg";
import "./assets/9e063e56779cf06d.svg";
import "./assets/8c03b284b195c24b.svg";
import "./assets/5f8c90a6399a217f.svg";
import "./assets/8b1bc6a872bee828.svg";
import "./assets/7ef65c8f2ad0839c.svg";
import "./assets/2ef09122439b62a2.svg";
import "./assets/7a70754f71d42ba8.svg";
import "./assets/aea7d39df5bf92af.svg";
import "./assets/3a96bc92e1fa5803.svg";
import "./assets/0fa17012252f2f2c.svg";
import "./assets/a60c0888b231a032.svg";
import "./assets/ca758cdb2e888b0f.svg";
import "./assets/2c5b12c8f2a18b2a.svg";
import "./assets/5bcfcfcd0838ba24.svg";
import "./assets/1e1efe171dd451bd.svg";
import "./assets/44b81db313baeefc.svg";
import "./assets/938f52f7bc17f163.svg";
import "./assets/2de967028b73d3ad.svg";
import "./assets/90943e0b579f5714.svg";
import "./assets/31fb7599c2716d4a.svg";
import "./assets/bc055cbef804633f.svg";
import "./assets/d317141e36097ac5.svg";
import "./assets/ba4c6b4d4ea19b20.svg";
import "./assets/98f49ee410193c84.svg";
import "./assets/aa9929b5afdfac72.svg";
import "./assets/6c837504da58a177.svg";
import "./assets/ea28972f0ca4eb85.svg";
import "./assets/8d5476a0ea9334a9.svg";
import "./assets/18146b42fccd9097.svg";
import "./assets/00562c83127d3e5c.svg";
import "./assets/a3ace5fd461d77a7.svg";
import "./assets/a9df93f2d0b45960.svg";
import "./assets/e1946c7d8ced7ba0.svg";
import "./assets/9d40e44fd686a6d3.svg";
import "./assets/d4c91e6b89beef76.svg";
import "./assets/78b40d84c041268f.svg";
import "./assets/32a87b1a2d449a72.svg";
import "./assets/00d9de3d51a7c229.svg";
import "./assets/79cbe576557eb480.svg";
import "./assets/4a3b8067fe3baabc.svg";
import "./assets/b47a30708798c208.svg";
import "./assets/d41a883982ec3682.svg";
import "./assets/1c348688be0ae0e3.svg";
import "./assets/2b85b2d4da772f9c.svg";
import "./assets/5bbd1fa266bea27f.svg";
import "./assets/8bb62dba053f0252.svg";
import "./assets/25a31967edeff2c2.svg";
import "./assets/395b47fd7c0f81bd.svg";
import "./assets/158ccbff9a2039f9.svg";
import "./assets/d30ccf2460aa5589.svg";
import "./assets/38dc908ac99bd73d.svg";
import "./assets/d34135d031a5d9f1.svg";
import "./assets/94902d4390fa8165.svg";
import "./assets/3670797f3ccbffb9.svg";
import "./assets/3a54497862c283aa.svg";
import "./assets/2c7da4b8026440b0.svg";
import "./assets/e38fc2b4e220f706.svg";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(ce) {
  return ce && ce.__esModule && Object.prototype.hasOwnProperty.call(ce, "default") ? ce.default : ce;
}
function getAugmentedNamespace(ce) {
  if (ce.__esModule) return ce;
  var ie = ce.default;
  if (typeof ie == "function") {
    var me = function we() {
      return this instanceof we ? Reflect.construct(ie, arguments, this.constructor) : ie.apply(this, arguments);
    };
    me.prototype = ie.prototype;
  } else me = {};
  return Object.defineProperty(me, "__esModule", { value: !0 }), Object.keys(ce).forEach(function(we) {
    var Re = Object.getOwnPropertyDescriptor(ce, we);
    Object.defineProperty(me, we, Re.get ? Re : {
      enumerable: !0,
      get: function() {
        return ce[we];
      }
    });
  }), me;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var ce = React__default, ie = Symbol.for("react.element"), me = Symbol.for("react.fragment"), we = Object.prototype.hasOwnProperty, Re = ce.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, je = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Ue(qe, Ge, Xe) {
    var ot, vt = {}, bt = null, Tt = null;
    Xe !== void 0 && (bt = "" + Xe), Ge.key !== void 0 && (bt = "" + Ge.key), Ge.ref !== void 0 && (Tt = Ge.ref);
    for (ot in Ge) we.call(Ge, ot) && !je.hasOwnProperty(ot) && (vt[ot] = Ge[ot]);
    if (qe && qe.defaultProps) for (ot in Ge = qe.defaultProps, Ge) vt[ot] === void 0 && (vt[ot] = Ge[ot]);
    return { $$typeof: ie, type: qe, key: bt, ref: Tt, props: vt, _owner: Re.current };
  }
  return reactJsxRuntime_production_min.Fragment = me, reactJsxRuntime_production_min.jsx = Ue, reactJsxRuntime_production_min.jsxs = Ue, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var ce = React__default, ie = Symbol.for("react.element"), me = Symbol.for("react.portal"), we = Symbol.for("react.fragment"), Re = Symbol.for("react.strict_mode"), je = Symbol.for("react.profiler"), Ue = Symbol.for("react.provider"), qe = Symbol.for("react.context"), Ge = Symbol.for("react.forward_ref"), Xe = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), vt = Symbol.for("react.memo"), bt = Symbol.for("react.lazy"), Tt = Symbol.for("react.offscreen"), wt = Symbol.iterator, St = "@@iterator";
    function It(mn) {
      if (mn === null || typeof mn != "object")
        return null;
      var ai = wt && mn[wt] || mn[St];
      return typeof ai == "function" ? ai : null;
    }
    var Pt = ce.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function kt(mn) {
      {
        for (var ai = arguments.length, $i = new Array(ai > 1 ? ai - 1 : 0), Ha = 1; Ha < ai; Ha++)
          $i[Ha - 1] = arguments[Ha];
        Ot("error", mn, $i);
      }
    }
    function Ot(mn, ai, $i) {
      {
        var Ha = Pt.ReactDebugCurrentFrame, Va = Ha.getStackAddendum();
        Va !== "" && (ai += "%s", $i = $i.concat([Va]));
        var Us = $i.map(function($s) {
          return String($s);
        });
        Us.unshift("Warning: " + ai), Function.prototype.apply.call(console[mn], console, Us);
      }
    }
    var Jr = !1, en = !1, nn = !1, ln = !1, fn = !1, vn;
    vn = Symbol.for("react.module.reference");
    function Tn(mn) {
      return !!(typeof mn == "string" || typeof mn == "function" || mn === we || mn === je || fn || mn === Re || mn === Xe || mn === ot || ln || mn === Tt || Jr || en || nn || typeof mn == "object" && mn !== null && (mn.$$typeof === bt || mn.$$typeof === vt || mn.$$typeof === Ue || mn.$$typeof === qe || mn.$$typeof === Ge || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      mn.$$typeof === vn || mn.getModuleId !== void 0));
    }
    function xn(mn, ai, $i) {
      var Ha = mn.displayName;
      if (Ha)
        return Ha;
      var Va = ai.displayName || ai.name || "";
      return Va !== "" ? $i + "(" + Va + ")" : $i;
    }
    function bn(mn) {
      return mn.displayName || "Context";
    }
    function Sn(mn) {
      if (mn == null)
        return null;
      if (typeof mn.tag == "number" && kt("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof mn == "function")
        return mn.displayName || mn.name || null;
      if (typeof mn == "string")
        return mn;
      switch (mn) {
        case we:
          return "Fragment";
        case me:
          return "Portal";
        case je:
          return "Profiler";
        case Re:
          return "StrictMode";
        case Xe:
          return "Suspense";
        case ot:
          return "SuspenseList";
      }
      if (typeof mn == "object")
        switch (mn.$$typeof) {
          case qe:
            var ai = mn;
            return bn(ai) + ".Consumer";
          case Ue:
            var $i = mn;
            return bn($i._context) + ".Provider";
          case Ge:
            return xn(mn, mn.render, "ForwardRef");
          case vt:
            var Ha = mn.displayName || null;
            return Ha !== null ? Ha : Sn(mn.type) || "Memo";
          case bt: {
            var Va = mn, Us = Va._payload, $s = Va._init;
            try {
              return Sn($s(Us));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Cn = Object.assign, kn = 0, cn, gn, an, un, pn, hn, An;
    function In() {
    }
    In.__reactDisabledLog = !0;
    function qn() {
      {
        if (kn === 0) {
          cn = console.log, gn = console.info, an = console.warn, un = console.error, pn = console.group, hn = console.groupCollapsed, An = console.groupEnd;
          var mn = {
            configurable: !0,
            enumerable: !0,
            value: In,
            writable: !0
          };
          Object.defineProperties(console, {
            info: mn,
            log: mn,
            warn: mn,
            error: mn,
            group: mn,
            groupCollapsed: mn,
            groupEnd: mn
          });
        }
        kn++;
      }
    }
    function si() {
      {
        if (kn--, kn === 0) {
          var mn = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Cn({}, mn, {
              value: cn
            }),
            info: Cn({}, mn, {
              value: gn
            }),
            warn: Cn({}, mn, {
              value: an
            }),
            error: Cn({}, mn, {
              value: un
            }),
            group: Cn({}, mn, {
              value: pn
            }),
            groupCollapsed: Cn({}, mn, {
              value: hn
            }),
            groupEnd: Cn({}, mn, {
              value: An
            })
          });
        }
        kn < 0 && kt("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var bi = Pt.ReactCurrentDispatcher, xi;
    function ji(mn, ai, $i) {
      {
        if (xi === void 0)
          try {
            throw Error();
          } catch (Va) {
            var Ha = Va.stack.trim().match(/\n( *(at )?)/);
            xi = Ha && Ha[1] || "";
          }
        return `
` + xi + mn;
      }
    }
    var zi = !1, Vi;
    {
      var Hi = typeof WeakMap == "function" ? WeakMap : Map;
      Vi = new Hi();
    }
    function ii(mn, ai) {
      if (!mn || zi)
        return "";
      {
        var $i = Vi.get(mn);
        if ($i !== void 0)
          return $i;
      }
      var Ha;
      zi = !0;
      var Va = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Us;
      Us = bi.current, bi.current = null, qn();
      try {
        if (ai) {
          var $s = function() {
            throw Error();
          };
          if (Object.defineProperty($s.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($s, []);
            } catch (Xi) {
              Ha = Xi;
            }
            Reflect.construct(mn, [], $s);
          } else {
            try {
              $s.call();
            } catch (Xi) {
              Ha = Xi;
            }
            mn.call($s.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xi) {
            Ha = Xi;
          }
          mn();
        }
      } catch (Xi) {
        if (Xi && Ha && typeof Xi.stack == "string") {
          for (var Za = Xi.stack.split(`
`), ml = Ha.stack.split(`
`), Ys = Za.length - 1, Bs = ml.length - 1; Ys >= 1 && Bs >= 0 && Za[Ys] !== ml[Bs]; )
            Bs--;
          for (; Ys >= 1 && Bs >= 0; Ys--, Bs--)
            if (Za[Ys] !== ml[Bs]) {
              if (Ys !== 1 || Bs !== 1)
                do
                  if (Ys--, Bs--, Bs < 0 || Za[Ys] !== ml[Bs]) {
                    var Wa = `
` + Za[Ys].replace(" at new ", " at ");
                    return mn.displayName && Wa.includes("<anonymous>") && (Wa = Wa.replace("<anonymous>", mn.displayName)), typeof mn == "function" && Vi.set(mn, Wa), Wa;
                  }
                while (Ys >= 1 && Bs >= 0);
              break;
            }
        }
      } finally {
        zi = !1, bi.current = Us, si(), Error.prepareStackTrace = Va;
      }
      var js = mn ? mn.displayName || mn.name : "", Fs = js ? ji(js) : "";
      return typeof mn == "function" && Vi.set(mn, Fs), Fs;
    }
    function Fi(mn, ai, $i) {
      return ii(mn, !1);
    }
    function ni(mn) {
      var ai = mn.prototype;
      return !!(ai && ai.isReactComponent);
    }
    function Ui(mn, ai, $i) {
      if (mn == null)
        return "";
      if (typeof mn == "function")
        return ii(mn, ni(mn));
      if (typeof mn == "string")
        return ji(mn);
      switch (mn) {
        case Xe:
          return ji("Suspense");
        case ot:
          return ji("SuspenseList");
      }
      if (typeof mn == "object")
        switch (mn.$$typeof) {
          case Ge:
            return Fi(mn.render);
          case vt:
            return Ui(mn.type, ai, $i);
          case bt: {
            var Ha = mn, Va = Ha._payload, Us = Ha._init;
            try {
              return Ui(Us(Va), ai, $i);
            } catch {
            }
          }
        }
      return "";
    }
    var ja = Object.prototype.hasOwnProperty, Ga = {}, Xa = Pt.ReactDebugCurrentFrame;
    function Ns(mn) {
      if (mn) {
        var ai = mn._owner, $i = Ui(mn.type, mn._source, ai ? ai.type : null);
        Xa.setExtraStackFrame($i);
      } else
        Xa.setExtraStackFrame(null);
    }
    function Ya(mn, ai, $i, Ha, Va) {
      {
        var Us = Function.call.bind(ja);
        for (var $s in mn)
          if (Us(mn, $s)) {
            var Za = void 0;
            try {
              if (typeof mn[$s] != "function") {
                var ml = Error((Ha || "React class") + ": " + $i + " type `" + $s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof mn[$s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ml.name = "Invariant Violation", ml;
              }
              Za = mn[$s](ai, $s, Ha, $i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ys) {
              Za = Ys;
            }
            Za && !(Za instanceof Error) && (Ns(Va), kt("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ha || "React class", $i, $s, typeof Za), Ns(null)), Za instanceof Error && !(Za.message in Ga) && (Ga[Za.message] = !0, Ns(Va), kt("Failed %s type: %s", $i, Za.message), Ns(null));
          }
      }
    }
    var Qa = Array.isArray;
    function Ja(mn) {
      return Qa(mn);
    }
    function Ms(mn) {
      {
        var ai = typeof Symbol == "function" && Symbol.toStringTag, $i = ai && mn[Symbol.toStringTag] || mn.constructor.name || "Object";
        return $i;
      }
    }
    function Hs(mn) {
      try {
        return no(mn), !1;
      } catch {
        return !0;
      }
    }
    function no(mn) {
      return "" + mn;
    }
    function Qs(mn) {
      if (Hs(mn))
        return kt("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ms(mn)), no(mn);
    }
    var Zs = Pt.ReactCurrentOwner, so = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, io, dl;
    function vl(mn) {
      if (ja.call(mn, "ref")) {
        var ai = Object.getOwnPropertyDescriptor(mn, "ref").get;
        if (ai && ai.isReactWarning)
          return !1;
      }
      return mn.ref !== void 0;
    }
    function lo(mn) {
      if (ja.call(mn, "key")) {
        var ai = Object.getOwnPropertyDescriptor(mn, "key").get;
        if (ai && ai.isReactWarning)
          return !1;
      }
      return mn.key !== void 0;
    }
    function yl(mn, ai) {
      typeof mn.ref == "string" && Zs.current;
    }
    function bl(mn, ai) {
      {
        var $i = function() {
          io || (io = !0, kt("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ai));
        };
        $i.isReactWarning = !0, Object.defineProperty(mn, "key", {
          get: $i,
          configurable: !0
        });
      }
    }
    function Al(mn, ai) {
      {
        var $i = function() {
          dl || (dl = !0, kt("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ai));
        };
        $i.isReactWarning = !0, Object.defineProperty(mn, "ref", {
          get: $i,
          configurable: !0
        });
      }
    }
    var Xl = function(mn, ai, $i, Ha, Va, Us, $s) {
      var Za = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: ie,
        // Built-in properties that belong on the element
        type: mn,
        key: ai,
        ref: $i,
        props: $s,
        // Record the component responsible for creating this element.
        _owner: Us
      };
      return Za._store = {}, Object.defineProperty(Za._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Za, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ha
      }), Object.defineProperty(Za, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Va
      }), Object.freeze && (Object.freeze(Za.props), Object.freeze(Za)), Za;
    };
    function $l(mn, ai, $i, Ha, Va) {
      {
        var Us, $s = {}, Za = null, ml = null;
        $i !== void 0 && (Qs($i), Za = "" + $i), lo(ai) && (Qs(ai.key), Za = "" + ai.key), vl(ai) && (ml = ai.ref, yl(ai, Va));
        for (Us in ai)
          ja.call(ai, Us) && !so.hasOwnProperty(Us) && ($s[Us] = ai[Us]);
        if (mn && mn.defaultProps) {
          var Ys = mn.defaultProps;
          for (Us in Ys)
            $s[Us] === void 0 && ($s[Us] = Ys[Us]);
        }
        if (Za || ml) {
          var Bs = typeof mn == "function" ? mn.displayName || mn.name || "Unknown" : mn;
          Za && bl($s, Bs), ml && Al($s, Bs);
        }
        return Xl(mn, Za, ml, Va, Ha, Zs.current, $s);
      }
    }
    var Bl = Pt.ReactCurrentOwner, Fl = Pt.ReactDebugCurrentFrame;
    function kl(mn) {
      if (mn) {
        var ai = mn._owner, $i = Ui(mn.type, mn._source, ai ? ai.type : null);
        Fl.setExtraStackFrame($i);
      } else
        Fl.setExtraStackFrame(null);
    }
    var ql;
    ql = !1;
    function _l(mn) {
      return typeof mn == "object" && mn !== null && mn.$$typeof === ie;
    }
    function Ol() {
      {
        if (Bl.current) {
          var mn = Sn(Bl.current.type);
          if (mn)
            return `

Check the render method of \`` + mn + "`.";
        }
        return "";
      }
    }
    function Ll(mn) {
      return "";
    }
    var Ql = {};
    function wl(mn) {
      {
        var ai = Ol();
        if (!ai) {
          var $i = typeof mn == "string" ? mn : mn.displayName || mn.name;
          $i && (ai = `

Check the top-level render call using <` + $i + ">.");
        }
        return ai;
      }
    }
    function to(mn, ai) {
      {
        if (!mn._store || mn._store.validated || mn.key != null)
          return;
        mn._store.validated = !0;
        var $i = wl(ai);
        if (Ql[$i])
          return;
        Ql[$i] = !0;
        var Ha = "";
        mn && mn._owner && mn._owner !== Bl.current && (Ha = " It was passed a child from " + Sn(mn._owner.type) + "."), kl(mn), kt('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $i, Ha), kl(null);
      }
    }
    function zs(mn, ai) {
      {
        if (typeof mn != "object")
          return;
        if (Ja(mn))
          for (var $i = 0; $i < mn.length; $i++) {
            var Ha = mn[$i];
            _l(Ha) && to(Ha, ai);
          }
        else if (_l(mn))
          mn._store && (mn._store.validated = !0);
        else if (mn) {
          var Va = It(mn);
          if (typeof Va == "function" && Va !== mn.entries)
            for (var Us = Va.call(mn), $s; !($s = Us.next()).done; )
              _l($s.value) && to($s.value, ai);
        }
      }
    }
    function Gs(mn) {
      {
        var ai = mn.type;
        if (ai == null || typeof ai == "string")
          return;
        var $i;
        if (typeof ai == "function")
          $i = ai.propTypes;
        else if (typeof ai == "object" && (ai.$$typeof === Ge || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ai.$$typeof === vt))
          $i = ai.propTypes;
        else
          return;
        if ($i) {
          var Ha = Sn(ai);
          Ya($i, mn.props, "prop", Ha, mn);
        } else if (ai.PropTypes !== void 0 && !ql) {
          ql = !0;
          var Va = Sn(ai);
          kt("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Va || "Unknown");
        }
        typeof ai.getDefaultProps == "function" && !ai.getDefaultProps.isReactClassApproved && kt("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Pl(mn) {
      {
        for (var ai = Object.keys(mn.props), $i = 0; $i < ai.length; $i++) {
          var Ha = ai[$i];
          if (Ha !== "children" && Ha !== "key") {
            kl(mn), kt("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ha), kl(null);
            break;
          }
        }
        mn.ref !== null && (kl(mn), kt("Invalid attribute `ref` supplied to `React.Fragment`."), kl(null));
      }
    }
    var Ml = {};
    function Ws(mn, ai, $i, Ha, Va, Us) {
      {
        var $s = Tn(mn);
        if (!$s) {
          var Za = "";
          (mn === void 0 || typeof mn == "object" && mn !== null && Object.keys(mn).length === 0) && (Za += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ml = Ll();
          ml ? Za += ml : Za += Ol();
          var Ys;
          mn === null ? Ys = "null" : Ja(mn) ? Ys = "array" : mn !== void 0 && mn.$$typeof === ie ? (Ys = "<" + (Sn(mn.type) || "Unknown") + " />", Za = " Did you accidentally export a JSX literal instead of a component?") : Ys = typeof mn, kt("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ys, Za);
        }
        var Bs = $l(mn, ai, $i, Va, Us);
        if (Bs == null)
          return Bs;
        if ($s) {
          var Wa = ai.children;
          if (Wa !== void 0)
            if (Ha)
              if (Ja(Wa)) {
                for (var js = 0; js < Wa.length; js++)
                  zs(Wa[js], mn);
                Object.freeze && Object.freeze(Wa);
              } else
                kt("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              zs(Wa, mn);
        }
        if (ja.call(ai, "key")) {
          var Fs = Sn(mn), Xi = Object.keys(ai).filter(function(xl) {
            return xl !== "key";
          }), ao = Xi.length > 0 ? "{key: someKey, " + Xi.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ml[Fs + ao]) {
            var Sl = Xi.length > 0 ? "{" + Xi.join(": ..., ") + ": ...}" : "{}";
            kt(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ao, Fs, Sl, Fs), Ml[Fs + ao] = !0;
          }
        }
        return mn === we ? Pl(Bs) : Gs(Bs), Bs;
      }
    }
    function Ks(mn, ai, $i) {
      return Ws(mn, ai, $i, !0);
    }
    function Js(mn, ai, $i) {
      return Ws(mn, ai, $i, !1);
    }
    var qs = Js, ho = Ks;
    reactJsxRuntime_development.Fragment = we, reactJsxRuntime_development.jsx = qs, reactJsxRuntime_development.jsxs = ho;
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
function ownKeys$e(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread2$4(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$e(Object(me), !0).forEach(function(we) {
      _defineProperty$u(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$e(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _typeof$d(ce) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$d(ce);
}
function _classCallCheck$u(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$j(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$s(ce, ie, me) {
  return ie && _defineProperties$j(ce.prototype, ie), Object.defineProperty(ce, "prototype", {
    writable: !1
  }), ce;
}
function _defineProperty$u(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, {
    value: me,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ce[ie] = me, ce;
}
function _slicedToArray$9(ce, ie) {
  return _arrayWithHoles$9(ce) || _iterableToArrayLimit$9(ce, ie) || _unsupportedIterableToArray$b(ce, ie) || _nonIterableRest$9();
}
function _toConsumableArray$3(ce) {
  return _arrayWithoutHoles$3(ce) || _iterableToArray$3(ce) || _unsupportedIterableToArray$b(ce) || _nonIterableSpread$3();
}
function _arrayWithoutHoles$3(ce) {
  if (Array.isArray(ce)) return _arrayLikeToArray$b(ce);
}
function _arrayWithHoles$9(ce) {
  if (Array.isArray(ce)) return ce;
}
function _iterableToArray$3(ce) {
  if (typeof Symbol < "u" && ce[Symbol.iterator] != null || ce["@@iterator"] != null) return Array.from(ce);
}
function _iterableToArrayLimit$9(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _unsupportedIterableToArray$b(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$b(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$b(ce, ie);
  }
}
function _arrayLikeToArray$b(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++) we[me] = ce[me];
  return we;
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var noop$1 = function() {
}, _WINDOW = {}, _DOCUMENT = {}, _MUTATION_OBSERVER = null, _PERFORMANCE = {
  mark: noop$1,
  measure: noop$1
};
try {
  typeof window < "u" && (_WINDOW = window), typeof document < "u" && (_DOCUMENT = document), typeof MutationObserver < "u" && (_MUTATION_OBSERVER = MutationObserver), typeof performance < "u" && (_PERFORMANCE = performance);
} catch {
}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent, WINDOW = _WINDOW, DOCUMENT = _DOCUMENT, MUTATION_OBSERVER = _MUTATION_OBSERVER, PERFORMANCE = _PERFORMANCE;
WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener == "function" && typeof DOCUMENT.createElement == "function", IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/"), _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5, NAMESPACE_IDENTIFIER = "___FONT_AWESOME___", UNITS_IN_GRID = 16, DEFAULT_CSS_PREFIX = "fa", DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa", DATA_FA_I2SVG = "data-fa-i2svg", DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element", DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending", DATA_PREFIX = "data-prefix", DATA_ICON = "data-icon", HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg", MUTATION_APPROACH_ASYNC = "async", TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"], PRODUCTION$1 = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), FAMILY_CLASSIC = "classic", FAMILY_SHARP = "sharp", FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];
function familyProxy(ce) {
  return new Proxy(ce, {
    get: function(me, we) {
      return we in me ? me[we] : me[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty$u(_familyProxy, FAMILY_CLASSIC, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), _defineProperty$u(_familyProxy, FAMILY_SHARP, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), _familyProxy)), STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty$u(_familyProxy2, FAMILY_CLASSIC, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), _defineProperty$u(_familyProxy2, FAMILY_SHARP, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), _familyProxy2)), PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty$u(_familyProxy3, FAMILY_CLASSIC, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), _defineProperty$u(_familyProxy3, FAMILY_SHARP, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), _familyProxy3)), LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty$u(_familyProxy4, FAMILY_CLASSIC, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), _defineProperty$u(_familyProxy4, FAMILY_SHARP, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), _familyProxy4)), ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, LAYERS_TEXT_CLASSNAME = "fa-layers-text", FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty$u(_familyProxy5, FAMILY_CLASSIC, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), _defineProperty$u(_familyProxy5, FAMILY_SHARP, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), _familyProxy5)), oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, prefixes = /* @__PURE__ */ new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray$3(prefixes), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function(ce) {
  return "".concat(ce, "x");
})).concat(oneToTwenty.map(function(ce) {
  return "w-".concat(ce);
})), initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(ce) {
  var ie = DOCUMENT.querySelector("script[" + ce + "]");
  if (ie)
    return ie.getAttribute(ce);
}
function coerce(ce) {
  return ce === "" ? !0 : ce === "false" ? !1 : ce === "true" ? !0 : ce;
}
if (DOCUMENT && typeof DOCUMENT.querySelector == "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function(ce) {
    var ie = _slicedToArray$9(ce, 2), me = ie[0], we = ie[1], Re = coerce(getAttrConfig(me));
    Re != null && (initial[we] = Re);
  });
}
var _default$4 = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
initial.familyPrefix && (initial.cssPrefix = initial.familyPrefix);
var _config = _objectSpread2$4(_objectSpread2$4({}, _default$4), initial);
_config.autoReplaceSvg || (_config.observeMutations = !1);
var config = {};
Object.keys(_default$4).forEach(function(ce) {
  Object.defineProperty(config, ce, {
    enumerable: !0,
    set: function(me) {
      _config[ce] = me, _onChangeCb.forEach(function(we) {
        return we(config);
      });
    },
    get: function() {
      return _config[ce];
    }
  });
});
Object.defineProperty(config, "familyPrefix", {
  enumerable: !0,
  set: function(ie) {
    _config.cssPrefix = ie, _onChangeCb.forEach(function(me) {
      return me(config);
    });
  },
  get: function() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(ce) {
  return _onChangeCb.push(ce), function() {
    _onChangeCb.splice(_onChangeCb.indexOf(ce), 1);
  };
}
var d$1 = UNITS_IN_GRID, meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function insertCss(ce) {
  if (!(!ce || !IS_DOM)) {
    var ie = DOCUMENT.createElement("style");
    ie.setAttribute("type", "text/css"), ie.innerHTML = ce;
    for (var me = DOCUMENT.head.childNodes, we = null, Re = me.length - 1; Re > -1; Re--) {
      var je = me[Re], Ue = (je.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(Ue) > -1 && (we = je);
    }
    return DOCUMENT.head.insertBefore(ie, we), ce;
  }
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId$1() {
  for (var ce = 12, ie = ""; ce-- > 0; )
    ie += idPool[Math.random() * 62 | 0];
  return ie;
}
function toArray$3(ce) {
  for (var ie = [], me = (ce || []).length >>> 0; me--; )
    ie[me] = ce[me];
  return ie;
}
function classArray(ce) {
  return ce.classList ? toArray$3(ce.classList) : (ce.getAttribute("class") || "").split(" ").filter(function(ie) {
    return ie;
  });
}
function htmlEscape(ce) {
  return "".concat(ce).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(ce) {
  return Object.keys(ce || {}).reduce(function(ie, me) {
    return ie + "".concat(me, '="').concat(htmlEscape(ce[me]), '" ');
  }, "").trim();
}
function joinStyles(ce) {
  return Object.keys(ce || {}).reduce(function(ie, me) {
    return ie + "".concat(me, ": ").concat(ce[me].trim(), ";");
  }, "");
}
function transformIsMeaningful(ce) {
  return ce.size !== meaninglessTransform.size || ce.x !== meaninglessTransform.x || ce.y !== meaninglessTransform.y || ce.rotate !== meaninglessTransform.rotate || ce.flipX || ce.flipY;
}
function transformForSvg(ce) {
  var ie = ce.transform, me = ce.containerWidth, we = ce.iconWidth, Re = {
    transform: "translate(".concat(me / 2, " 256)")
  }, je = "translate(".concat(ie.x * 32, ", ").concat(ie.y * 32, ") "), Ue = "scale(".concat(ie.size / 16 * (ie.flipX ? -1 : 1), ", ").concat(ie.size / 16 * (ie.flipY ? -1 : 1), ") "), qe = "rotate(".concat(ie.rotate, " 0 0)"), Ge = {
    transform: "".concat(je, " ").concat(Ue, " ").concat(qe)
  }, Xe = {
    transform: "translate(".concat(we / 2 * -1, " -256)")
  };
  return {
    outer: Re,
    inner: Ge,
    path: Xe
  };
}
function transformForCss(ce) {
  var ie = ce.transform, me = ce.width, we = me === void 0 ? UNITS_IN_GRID : me, Re = ce.height, je = Re === void 0 ? UNITS_IN_GRID : Re, Ue = "";
  return IS_IE ? Ue += "translate(".concat(ie.x / d$1 - we / 2, "em, ").concat(ie.y / d$1 - je / 2, "em) ") : Ue += "translate(calc(-50% + ".concat(ie.x / d$1, "em), calc(-50% + ").concat(ie.y / d$1, "em)) "), Ue += "scale(".concat(ie.size / d$1 * (ie.flipX ? -1 : 1), ", ").concat(ie.size / d$1 * (ie.flipY ? -1 : 1), ") "), Ue += "rotate(".concat(ie.rotate, "deg) "), Ue;
}
var baseStyles = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, 0));
          transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function css$1() {
  var ce = DEFAULT_CSS_PREFIX, ie = DEFAULT_REPLACEMENT_CLASS, me = config.cssPrefix, we = config.replacementClass, Re = baseStyles;
  if (me !== ce || we !== ie) {
    var je = new RegExp("\\.".concat(ce, "\\-"), "g"), Ue = new RegExp("\\--".concat(ce, "\\-"), "g"), qe = new RegExp("\\.".concat(ie), "g");
    Re = Re.replace(je, ".".concat(me, "-")).replace(Ue, "--".concat(me, "-")).replace(qe, ".".concat(we));
  }
  return Re;
}
var _cssInserted = !1;
function ensureCss() {
  config.autoAddCss && !_cssInserted && (insertCss(css$1()), _cssInserted = !0);
}
var InjectCSS = {
  mixout: function() {
    return {
      dom: {
        css: css$1,
        insertCss: ensureCss
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        ensureCss();
      },
      beforeI2svg: function() {
        ensureCss();
      }
    };
  }
}, w$1 = WINDOW || {};
w$1[NAMESPACE_IDENTIFIER] || (w$1[NAMESPACE_IDENTIFIER] = {});
w$1[NAMESPACE_IDENTIFIER].styles || (w$1[NAMESPACE_IDENTIFIER].styles = {});
w$1[NAMESPACE_IDENTIFIER].hooks || (w$1[NAMESPACE_IDENTIFIER].hooks = {});
w$1[NAMESPACE_IDENTIFIER].shims || (w$1[NAMESPACE_IDENTIFIER].shims = []);
var namespace = w$1[NAMESPACE_IDENTIFIER], functions = [], listener = function ce() {
  DOCUMENT.removeEventListener("DOMContentLoaded", ce), loaded = 1, functions.map(function(ie) {
    return ie();
  });
}, loaded = !1;
IS_DOM && (loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState), loaded || DOCUMENT.addEventListener("DOMContentLoaded", listener));
function domready(ce) {
  IS_DOM && (loaded ? setTimeout(ce, 0) : functions.push(ce));
}
function toHtml(ce) {
  var ie = ce.tag, me = ce.attributes, we = me === void 0 ? {} : me, Re = ce.children, je = Re === void 0 ? [] : Re;
  return typeof ce == "string" ? htmlEscape(ce) : "<".concat(ie, " ").concat(joinAttributes(we), ">").concat(je.map(toHtml).join(""), "</").concat(ie, ">");
}
function iconFromMapping(ce, ie, me) {
  if (ce && ce[ie] && ce[ie][me])
    return {
      prefix: ie,
      iconName: me,
      icon: ce[ie][me]
    };
}
var reduce$6 = function(ie, me, we, Re) {
  var je = Object.keys(ie), Ue = je.length, qe = me, Ge, Xe, ot;
  for (we === void 0 ? (Ge = 1, ot = ie[je[0]]) : (Ge = 0, ot = we); Ge < Ue; Ge++)
    Xe = je[Ge], ot = qe(ot, ie[Xe], Xe, ie);
  return ot;
};
function ucs2decode(ce) {
  for (var ie = [], me = 0, we = ce.length; me < we; ) {
    var Re = ce.charCodeAt(me++);
    if (Re >= 55296 && Re <= 56319 && me < we) {
      var je = ce.charCodeAt(me++);
      (je & 64512) == 56320 ? ie.push(((Re & 1023) << 10) + (je & 1023) + 65536) : (ie.push(Re), me--);
    } else
      ie.push(Re);
  }
  return ie;
}
function toHex(ce) {
  var ie = ucs2decode(ce);
  return ie.length === 1 ? ie[0].toString(16) : null;
}
function codePointAt(ce, ie) {
  var me = ce.length, we = ce.charCodeAt(ie), Re;
  return we >= 55296 && we <= 56319 && me > ie + 1 && (Re = ce.charCodeAt(ie + 1), Re >= 56320 && Re <= 57343) ? (we - 55296) * 1024 + Re - 56320 + 65536 : we;
}
function normalizeIcons(ce) {
  return Object.keys(ce).reduce(function(ie, me) {
    var we = ce[me], Re = !!we.icon;
    return Re ? ie[we.iconName] = we.icon : ie[me] = we, ie;
  }, {});
}
function defineIcons(ce, ie) {
  var me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = me.skipHooks, Re = we === void 0 ? !1 : we, je = normalizeIcons(ie);
  typeof namespace.hooks.addPack == "function" && !Re ? namespace.hooks.addPack(ce, normalizeIcons(ie)) : namespace.styles[ce] = _objectSpread2$4(_objectSpread2$4({}, namespace.styles[ce] || {}), je), ce === "fas" && defineIcons("fa", ie);
}
var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY, styles$1 = namespace.styles, shims = namespace.shims, LONG_STYLE = (_LONG_STYLE = {}, _defineProperty$u(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty$u(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE), _defaultUsablePrefix = null, _byUnicode = {}, _byLigature = {}, _byOldName = {}, _byOldUnicode = {}, _byAlias = {}, PREFIXES = (_PREFIXES = {}, _defineProperty$u(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty$u(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);
function isReserved(ce) {
  return ~RESERVED_CLASSES.indexOf(ce);
}
function getIconName(ce, ie) {
  var me = ie.split("-"), we = me[0], Re = me.slice(1).join("-");
  return we === ce && Re !== "" && !isReserved(Re) ? Re : null;
}
var build = function() {
  var ie = function(je) {
    return reduce$6(styles$1, function(Ue, qe, Ge) {
      return Ue[Ge] = reduce$6(qe, je, {}), Ue;
    }, {});
  };
  _byUnicode = ie(function(Re, je, Ue) {
    if (je[3] && (Re[je[3]] = Ue), je[2]) {
      var qe = je[2].filter(function(Ge) {
        return typeof Ge == "number";
      });
      qe.forEach(function(Ge) {
        Re[Ge.toString(16)] = Ue;
      });
    }
    return Re;
  }), _byLigature = ie(function(Re, je, Ue) {
    if (Re[Ue] = Ue, je[2]) {
      var qe = je[2].filter(function(Ge) {
        return typeof Ge == "string";
      });
      qe.forEach(function(Ge) {
        Re[Ge] = Ue;
      });
    }
    return Re;
  }), _byAlias = ie(function(Re, je, Ue) {
    var qe = je[2];
    return Re[Ue] = Ue, qe.forEach(function(Ge) {
      Re[Ge] = Ue;
    }), Re;
  });
  var me = "far" in styles$1 || config.autoFetchSvg, we = reduce$6(shims, function(Re, je) {
    var Ue = je[0], qe = je[1], Ge = je[2];
    return qe === "far" && !me && (qe = "fas"), typeof Ue == "string" && (Re.names[Ue] = {
      prefix: qe,
      iconName: Ge
    }), typeof Ue == "number" && (Re.unicodes[Ue.toString(16)] = {
      prefix: qe,
      iconName: Ge
    }), Re;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = we.names, _byOldUnicode = we.unicodes, _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function(ce) {
  _defaultUsablePrefix = getCanonicalPrefix(ce.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(ce, ie) {
  return (_byUnicode[ce] || {})[ie];
}
function byLigature(ce, ie) {
  return (_byLigature[ce] || {})[ie];
}
function byAlias(ce, ie) {
  return (_byAlias[ce] || {})[ie];
}
function byOldName(ce) {
  return _byOldName[ce] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(ce) {
  var ie = _byOldUnicode[ce], me = byUnicode("fas", ce);
  return ie || (me ? {
    prefix: "fas",
    iconName: me
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = ie.family, we = me === void 0 ? FAMILY_CLASSIC : me, Re = PREFIX_TO_STYLE[we][ce], je = STYLE_TO_PREFIX[we][ce] || STYLE_TO_PREFIX[we][Re], Ue = ce in namespace.styles ? ce : null;
  return je || Ue || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty$u(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty$u(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(ce) {
  var ie, me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, we = me.skipLookups, Re = we === void 0 ? !1 : we, je = (ie = {}, _defineProperty$u(ie, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty$u(ie, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), ie), Ue = null, qe = FAMILY_CLASSIC;
  (ce.includes(je[FAMILY_CLASSIC]) || ce.some(function(Xe) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(Xe);
  })) && (qe = FAMILY_CLASSIC), (ce.includes(je[FAMILY_SHARP]) || ce.some(function(Xe) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(Xe);
  })) && (qe = FAMILY_SHARP);
  var Ge = ce.reduce(function(Xe, ot) {
    var vt = getIconName(config.cssPrefix, ot);
    if (styles$1[ot] ? (ot = LONG_STYLE[qe].includes(ot) ? LONG_STYLE_TO_PREFIX[qe][ot] : ot, Ue = ot, Xe.prefix = ot) : PREFIXES[qe].indexOf(ot) > -1 ? (Ue = ot, Xe.prefix = getCanonicalPrefix(ot, {
      family: qe
    })) : vt ? Xe.iconName = vt : ot !== config.replacementClass && ot !== je[FAMILY_CLASSIC] && ot !== je[FAMILY_SHARP] && Xe.rest.push(ot), !Re && Xe.prefix && Xe.iconName) {
      var bt = Ue === "fa" ? byOldName(Xe.iconName) : {}, Tt = byAlias(Xe.prefix, Xe.iconName);
      bt.prefix && (Ue = null), Xe.iconName = bt.iconName || Tt || Xe.iconName, Xe.prefix = bt.prefix || Xe.prefix, Xe.prefix === "far" && !styles$1.far && styles$1.fas && !config.autoFetchSvg && (Xe.prefix = "fas");
    }
    return Xe;
  }, emptyCanonicalIcon());
  return (ce.includes("fa-brands") || ce.includes("fab")) && (Ge.prefix = "fab"), (ce.includes("fa-duotone") || ce.includes("fad")) && (Ge.prefix = "fad"), !Ge.prefix && qe === FAMILY_SHARP && (styles$1.fass || config.autoFetchSvg) && (Ge.prefix = "fass", Ge.iconName = byAlias(Ge.prefix, Ge.iconName) || Ge.iconName), (Ge.prefix === "fa" || Ue === "fa") && (Ge.prefix = getDefaultUsablePrefix() || "fas"), Ge;
}
var Library = /* @__PURE__ */ function() {
  function ce() {
    _classCallCheck$u(this, ce), this.definitions = {};
  }
  return _createClass$s(ce, [{
    key: "add",
    value: function() {
      for (var me = this, we = arguments.length, Re = new Array(we), je = 0; je < we; je++)
        Re[je] = arguments[je];
      var Ue = Re.reduce(this._pullDefinitions, {});
      Object.keys(Ue).forEach(function(qe) {
        me.definitions[qe] = _objectSpread2$4(_objectSpread2$4({}, me.definitions[qe] || {}), Ue[qe]), defineIcons(qe, Ue[qe]);
        var Ge = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][qe];
        Ge && defineIcons(Ge, Ue[qe]), build();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(me, we) {
      var Re = we.prefix && we.iconName && we.icon ? {
        0: we
      } : we;
      return Object.keys(Re).map(function(je) {
        var Ue = Re[je], qe = Ue.prefix, Ge = Ue.iconName, Xe = Ue.icon, ot = Xe[2];
        me[qe] || (me[qe] = {}), ot.length > 0 && ot.forEach(function(vt) {
          typeof vt == "string" && (me[qe][vt] = Xe);
        }), me[qe][Ge] = Xe;
      }), me;
    }
  }]), ce;
}(), _plugins = [], _hooks = {}, providers = {}, defaultProviderKeys = Object.keys(providers);
function registerPlugins(ce, ie) {
  var me = ie.mixoutsTo;
  return _plugins = ce, _hooks = {}, Object.keys(providers).forEach(function(we) {
    defaultProviderKeys.indexOf(we) === -1 && delete providers[we];
  }), _plugins.forEach(function(we) {
    var Re = we.mixout ? we.mixout() : {};
    if (Object.keys(Re).forEach(function(Ue) {
      typeof Re[Ue] == "function" && (me[Ue] = Re[Ue]), _typeof$d(Re[Ue]) === "object" && Object.keys(Re[Ue]).forEach(function(qe) {
        me[Ue] || (me[Ue] = {}), me[Ue][qe] = Re[Ue][qe];
      });
    }), we.hooks) {
      var je = we.hooks();
      Object.keys(je).forEach(function(Ue) {
        _hooks[Ue] || (_hooks[Ue] = []), _hooks[Ue].push(je[Ue]);
      });
    }
    we.provides && we.provides(providers);
  }), me;
}
function chainHooks(ce, ie) {
  for (var me = arguments.length, we = new Array(me > 2 ? me - 2 : 0), Re = 2; Re < me; Re++)
    we[Re - 2] = arguments[Re];
  var je = _hooks[ce] || [];
  return je.forEach(function(Ue) {
    ie = Ue.apply(null, [ie].concat(we));
  }), ie;
}
function callHooks(ce) {
  for (var ie = arguments.length, me = new Array(ie > 1 ? ie - 1 : 0), we = 1; we < ie; we++)
    me[we - 1] = arguments[we];
  var Re = _hooks[ce] || [];
  Re.forEach(function(je) {
    je.apply(null, me);
  });
}
function callProvided() {
  var ce = arguments[0], ie = Array.prototype.slice.call(arguments, 1);
  return providers[ce] ? providers[ce].apply(null, ie) : void 0;
}
function findIconDefinition(ce) {
  ce.prefix === "fa" && (ce.prefix = "fas");
  var ie = ce.iconName, me = ce.prefix || getDefaultUsablePrefix();
  if (ie)
    return ie = byAlias(me, ie) || ie, iconFromMapping(library.definitions, me, ie) || iconFromMapping(namespace.styles, me, ie);
}
var library = new Library(), noAuto = function() {
  config.autoReplaceSvg = !1, config.observeMutations = !1, callHooks("noAuto");
}, dom = {
  i2svg: function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return IS_DOM ? (callHooks("beforeI2svg", ie), callProvided("pseudoElements2svg", ie), callProvided("i2svg", ie)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, me = ie.autoReplaceSvgRoot;
    config.autoReplaceSvg === !1 && (config.autoReplaceSvg = !0), config.observeMutations = !0, domready(function() {
      autoReplace({
        autoReplaceSvgRoot: me
      }), callHooks("watch", ie);
    });
  }
}, parse = {
  icon: function(ie) {
    if (ie === null)
      return null;
    if (_typeof$d(ie) === "object" && ie.prefix && ie.iconName)
      return {
        prefix: ie.prefix,
        iconName: byAlias(ie.prefix, ie.iconName) || ie.iconName
      };
    if (Array.isArray(ie) && ie.length === 2) {
      var me = ie[1].indexOf("fa-") === 0 ? ie[1].slice(3) : ie[1], we = getCanonicalPrefix(ie[0]);
      return {
        prefix: we,
        iconName: byAlias(we, me) || me
      };
    }
    if (typeof ie == "string" && (ie.indexOf("".concat(config.cssPrefix, "-")) > -1 || ie.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var Re = getCanonicalIcon(ie.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: Re.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(Re.prefix, Re.iconName) || Re.iconName
      };
    }
    if (typeof ie == "string") {
      var je = getDefaultUsablePrefix();
      return {
        prefix: je,
        iconName: byAlias(je, ie) || ie
      };
    }
  }
}, api = {
  noAuto,
  config,
  dom,
  parse,
  library,
  findIconDefinition,
  toHtml
}, autoReplace = function() {
  var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, me = ie.autoReplaceSvgRoot, we = me === void 0 ? DOCUMENT : me;
  (Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg && api.dom.i2svg({
    node: we
  });
};
function domVariants(ce, ie) {
  return Object.defineProperty(ce, "abstract", {
    get: ie
  }), Object.defineProperty(ce, "html", {
    get: function() {
      return ce.abstract.map(function(we) {
        return toHtml(we);
      });
    }
  }), Object.defineProperty(ce, "node", {
    get: function() {
      if (IS_DOM) {
        var we = DOCUMENT.createElement("div");
        return we.innerHTML = ce.html, we.children;
      }
    }
  }), ce;
}
function asIcon(ce) {
  var ie = ce.children, me = ce.main, we = ce.mask, Re = ce.attributes, je = ce.styles, Ue = ce.transform;
  if (transformIsMeaningful(Ue) && me.found && !we.found) {
    var qe = me.width, Ge = me.height, Xe = {
      x: qe / Ge / 2,
      y: 0.5
    };
    Re.style = joinStyles(_objectSpread2$4(_objectSpread2$4({}, je), {}, {
      "transform-origin": "".concat(Xe.x + Ue.x / 16, "em ").concat(Xe.y + Ue.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: Re,
    children: ie
  }];
}
function asSymbol(ce) {
  var ie = ce.prefix, me = ce.iconName, we = ce.children, Re = ce.attributes, je = ce.symbol, Ue = je === !0 ? "".concat(ie, "-").concat(config.cssPrefix, "-").concat(me) : je;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$4(_objectSpread2$4({}, Re), {}, {
        id: Ue
      }),
      children: we
    }]
  }];
}
function makeInlineSvgAbstract(ce) {
  var ie = ce.icons, me = ie.main, we = ie.mask, Re = ce.prefix, je = ce.iconName, Ue = ce.transform, qe = ce.symbol, Ge = ce.title, Xe = ce.maskId, ot = ce.titleId, vt = ce.extra, bt = ce.watchable, Tt = bt === void 0 ? !1 : bt, wt = we.found ? we : me, St = wt.width, It = wt.height, Pt = Re === "fak", kt = [config.replacementClass, je ? "".concat(config.cssPrefix, "-").concat(je) : ""].filter(function(vn) {
    return vt.classes.indexOf(vn) === -1;
  }).filter(function(vn) {
    return vn !== "" || !!vn;
  }).concat(vt.classes).join(" "), Ot = {
    children: [],
    attributes: _objectSpread2$4(_objectSpread2$4({}, vt.attributes), {}, {
      "data-prefix": Re,
      "data-icon": je,
      class: kt,
      role: vt.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(St, " ").concat(It)
    })
  }, Jr = Pt && !~vt.classes.indexOf("fa-fw") ? {
    width: "".concat(St / It * 16 * 0.0625, "em")
  } : {};
  Tt && (Ot.attributes[DATA_FA_I2SVG] = ""), Ge && (Ot.children.push({
    tag: "title",
    attributes: {
      id: Ot.attributes["aria-labelledby"] || "title-".concat(ot || nextUniqueId$1())
    },
    children: [Ge]
  }), delete Ot.attributes.title);
  var en = _objectSpread2$4(_objectSpread2$4({}, Ot), {}, {
    prefix: Re,
    iconName: je,
    main: me,
    mask: we,
    maskId: Xe,
    transform: Ue,
    symbol: qe,
    styles: _objectSpread2$4(_objectSpread2$4({}, Jr), vt.styles)
  }), nn = we.found && me.found ? callProvided("generateAbstractMask", en) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", en) || {
    children: [],
    attributes: {}
  }, ln = nn.children, fn = nn.attributes;
  return en.children = ln, en.attributes = fn, qe ? asSymbol(en) : asIcon(en);
}
function makeLayersTextAbstract(ce) {
  var ie = ce.content, me = ce.width, we = ce.height, Re = ce.transform, je = ce.title, Ue = ce.extra, qe = ce.watchable, Ge = qe === void 0 ? !1 : qe, Xe = _objectSpread2$4(_objectSpread2$4(_objectSpread2$4({}, Ue.attributes), je ? {
    title: je
  } : {}), {}, {
    class: Ue.classes.join(" ")
  });
  Ge && (Xe[DATA_FA_I2SVG] = "");
  var ot = _objectSpread2$4({}, Ue.styles);
  transformIsMeaningful(Re) && (ot.transform = transformForCss({
    transform: Re,
    width: me,
    height: we
  }), ot["-webkit-transform"] = ot.transform);
  var vt = joinStyles(ot);
  vt.length > 0 && (Xe.style = vt);
  var bt = [];
  return bt.push({
    tag: "span",
    attributes: Xe,
    children: [ie]
  }), je && bt.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [je]
  }), bt;
}
function makeLayersCounterAbstract(ce) {
  var ie = ce.content, me = ce.title, we = ce.extra, Re = _objectSpread2$4(_objectSpread2$4(_objectSpread2$4({}, we.attributes), me ? {
    title: me
  } : {}), {}, {
    class: we.classes.join(" ")
  }), je = joinStyles(we.styles);
  je.length > 0 && (Re.style = je);
  var Ue = [];
  return Ue.push({
    tag: "span",
    attributes: Re,
    children: [ie]
  }), me && Ue.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [me]
  }), Ue;
}
var styles$1$1 = namespace.styles;
function asFoundIcon(ce) {
  var ie = ce[0], me = ce[1], we = ce.slice(4), Re = _slicedToArray$9(we, 1), je = Re[0], Ue = null;
  return Array.isArray(je) ? Ue = {
    tag: "g",
    attributes: {
      class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
        fill: "currentColor",
        d: je[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
        fill: "currentColor",
        d: je[1]
      }
    }]
  } : Ue = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: je
    }
  }, {
    found: !0,
    width: ie,
    height: me,
    icon: Ue
  };
}
var missingIconResolutionMixin = {
  found: !1,
  width: 512,
  height: 512
};
function maybeNotifyMissing(ce, ie) {
  !PRODUCTION$1 && !config.showMissingIcons && ce && console.error('Icon with name "'.concat(ce, '" and prefix "').concat(ie, '" is missing.'));
}
function findIcon(ce, ie) {
  var me = ie;
  return ie === "fa" && config.styleDefault !== null && (ie = getDefaultUsablePrefix()), new Promise(function(we, Re) {
    if (callProvided("missingIconAbstract"), me === "fa") {
      var je = byOldName(ce) || {};
      ce = je.iconName || ce, ie = je.prefix || ie;
    }
    if (ce && ie && styles$1$1[ie] && styles$1$1[ie][ce]) {
      var Ue = styles$1$1[ie][ce];
      return we(asFoundIcon(Ue));
    }
    maybeNotifyMissing(ce, ie), we(_objectSpread2$4(_objectSpread2$4({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && ce ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1$1 = function() {
}, p$1 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
}, preamble = 'FA "6.5.2"', begin = function(ie) {
  return p$1.mark("".concat(preamble, " ").concat(ie, " begins")), function() {
    return end(ie);
  };
}, end = function(ie) {
  p$1.mark("".concat(preamble, " ").concat(ie, " ends")), p$1.measure("".concat(preamble, " ").concat(ie), "".concat(preamble, " ").concat(ie, " begins"), "".concat(preamble, " ").concat(ie, " ends"));
}, perf = {
  begin,
  end
}, noop$2 = function() {
};
function isWatched(ce) {
  var ie = ce.getAttribute ? ce.getAttribute(DATA_FA_I2SVG) : null;
  return typeof ie == "string";
}
function hasPrefixAndIcon(ce) {
  var ie = ce.getAttribute ? ce.getAttribute(DATA_PREFIX) : null, me = ce.getAttribute ? ce.getAttribute(DATA_ICON) : null;
  return ie && me;
}
function hasBeenReplaced(ce) {
  return ce && ce.classList && ce.classList.contains && ce.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === !0)
    return mutators.replace;
  var ce = mutators[config.autoReplaceSvg];
  return ce || mutators.replace;
}
function createElementNS(ce) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", ce);
}
function createElement(ce) {
  return DOCUMENT.createElement(ce);
}
function convertSVG(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = ie.ceFn, we = me === void 0 ? ce.tag === "svg" ? createElementNS : createElement : me;
  if (typeof ce == "string")
    return DOCUMENT.createTextNode(ce);
  var Re = we(ce.tag);
  Object.keys(ce.attributes || []).forEach(function(Ue) {
    Re.setAttribute(Ue, ce.attributes[Ue]);
  });
  var je = ce.children || [];
  return je.forEach(function(Ue) {
    Re.appendChild(convertSVG(Ue, {
      ceFn: we
    }));
  }), Re;
}
function nodeAsComment(ce) {
  var ie = " ".concat(ce.outerHTML, " ");
  return ie = "".concat(ie, "Font Awesome fontawesome.com "), ie;
}
var mutators = {
  replace: function(ie) {
    var me = ie[0];
    if (me.parentNode)
      if (ie[1].forEach(function(Re) {
        me.parentNode.insertBefore(convertSVG(Re), me);
      }), me.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var we = DOCUMENT.createComment(nodeAsComment(me));
        me.parentNode.replaceChild(we, me);
      } else
        me.remove();
  },
  nest: function(ie) {
    var me = ie[0], we = ie[1];
    if (~classArray(me).indexOf(config.replacementClass))
      return mutators.replace(ie);
    var Re = new RegExp("".concat(config.cssPrefix, "-.*"));
    if (delete we[0].attributes.id, we[0].attributes.class) {
      var je = we[0].attributes.class.split(" ").reduce(function(qe, Ge) {
        return Ge === config.replacementClass || Ge.match(Re) ? qe.toSvg.push(Ge) : qe.toNode.push(Ge), qe;
      }, {
        toNode: [],
        toSvg: []
      });
      we[0].attributes.class = je.toSvg.join(" "), je.toNode.length === 0 ? me.removeAttribute("class") : me.setAttribute("class", je.toNode.join(" "));
    }
    var Ue = we.map(function(qe) {
      return toHtml(qe);
    }).join(`
`);
    me.setAttribute(DATA_FA_I2SVG, ""), me.innerHTML = Ue;
  }
};
function performOperationSync(ce) {
  ce();
}
function perform(ce, ie) {
  var me = typeof ie == "function" ? ie : noop$2;
  if (ce.length === 0)
    me();
  else {
    var we = performOperationSync;
    config.mutateApproach === MUTATION_APPROACH_ASYNC && (we = WINDOW.requestAnimationFrame || performOperationSync), we(function() {
      var Re = getMutator(), je = perf.begin("mutate");
      ce.map(Re), je(), me();
    });
  }
}
var disabled = !1;
function disableObservation() {
  disabled = !0;
}
function enableObservation() {
  disabled = !1;
}
var mo$1 = null;
function observe$1(ce) {
  if (MUTATION_OBSERVER && config.observeMutations) {
    var ie = ce.treeCallback, me = ie === void 0 ? noop$2 : ie, we = ce.nodeCallback, Re = we === void 0 ? noop$2 : we, je = ce.pseudoElementsCallback, Ue = je === void 0 ? noop$2 : je, qe = ce.observeMutationsRoot, Ge = qe === void 0 ? DOCUMENT : qe;
    mo$1 = new MUTATION_OBSERVER(function(Xe) {
      if (!disabled) {
        var ot = getDefaultUsablePrefix();
        toArray$3(Xe).forEach(function(vt) {
          if (vt.type === "childList" && vt.addedNodes.length > 0 && !isWatched(vt.addedNodes[0]) && (config.searchPseudoElements && Ue(vt.target), me(vt.target)), vt.type === "attributes" && vt.target.parentNode && config.searchPseudoElements && Ue(vt.target.parentNode), vt.type === "attributes" && isWatched(vt.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(vt.attributeName))
            if (vt.attributeName === "class" && hasPrefixAndIcon(vt.target)) {
              var bt = getCanonicalIcon(classArray(vt.target)), Tt = bt.prefix, wt = bt.iconName;
              vt.target.setAttribute(DATA_PREFIX, Tt || ot), wt && vt.target.setAttribute(DATA_ICON, wt);
            } else hasBeenReplaced(vt.target) && Re(vt.target);
        });
      }
    }), IS_DOM && mo$1.observe(Ge, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function disconnect() {
  mo$1 && mo$1.disconnect();
}
function styleParser(ce) {
  var ie = ce.getAttribute("style"), me = [];
  return ie && (me = ie.split(";").reduce(function(we, Re) {
    var je = Re.split(":"), Ue = je[0], qe = je.slice(1);
    return Ue && qe.length > 0 && (we[Ue] = qe.join(":").trim()), we;
  }, {})), me;
}
function classParser(ce) {
  var ie = ce.getAttribute("data-prefix"), me = ce.getAttribute("data-icon"), we = ce.innerText !== void 0 ? ce.innerText.trim() : "", Re = getCanonicalIcon(classArray(ce));
  return Re.prefix || (Re.prefix = getDefaultUsablePrefix()), ie && me && (Re.prefix = ie, Re.iconName = me), Re.iconName && Re.prefix || (Re.prefix && we.length > 0 && (Re.iconName = byLigature(Re.prefix, ce.innerText) || byUnicode(Re.prefix, toHex(ce.innerText))), !Re.iconName && config.autoFetchSvg && ce.firstChild && ce.firstChild.nodeType === Node.TEXT_NODE && (Re.iconName = ce.firstChild.data)), Re;
}
function attributesParser(ce) {
  var ie = toArray$3(ce.attributes).reduce(function(Re, je) {
    return Re.name !== "class" && Re.name !== "style" && (Re[je.name] = je.value), Re;
  }, {}), me = ce.getAttribute("title"), we = ce.getAttribute("data-fa-title-id");
  return config.autoA11y && (me ? ie["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(we || nextUniqueId$1()) : (ie["aria-hidden"] = "true", ie.focusable = "false")), ie;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, me = classParser(ce), we = me.iconName, Re = me.prefix, je = me.rest, Ue = attributesParser(ce), qe = chainHooks("parseNodeAttributes", {}, ce), Ge = ie.styleParser ? styleParser(ce) : [];
  return _objectSpread2$4({
    iconName: we,
    title: ce.getAttribute("title"),
    titleId: ce.getAttribute("data-fa-title-id"),
    prefix: Re,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: je,
      styles: Ge,
      attributes: Ue
    }
  }, qe);
}
var styles$2 = namespace.styles;
function generateMutation(ce) {
  var ie = config.autoReplaceSvg === "nest" ? parseMeta(ce, {
    styleParser: !1
  }) : parseMeta(ce);
  return ~ie.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME) ? callProvided("generateLayersText", ce, ie) : callProvided("generateSvgReplacementMutation", ce, ie);
}
var knownPrefixes = /* @__PURE__ */ new Set();
FAMILIES.map(function(ce) {
  knownPrefixes.add("fa-".concat(ce));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray$3(knownPrefixes);
function onTree(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var me = DOCUMENT.documentElement.classList, we = function(vt) {
    return me.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(vt));
  }, Re = function(vt) {
    return me.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(vt));
  }, je = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function(ot) {
    return "fa-".concat(ot);
  }).concat(Object.keys(styles$2));
  je.includes("fa") || je.push("fa");
  var Ue = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(je.map(function(ot) {
    return ".".concat(ot, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (Ue.length === 0)
    return Promise.resolve();
  var qe = [];
  try {
    qe = toArray$3(ce.querySelectorAll(Ue));
  } catch {
  }
  if (qe.length > 0)
    we("pending"), Re("complete");
  else
    return Promise.resolve();
  var Ge = perf.begin("onTree"), Xe = qe.reduce(function(ot, vt) {
    try {
      var bt = generateMutation(vt);
      bt && ot.push(bt);
    } catch (Tt) {
      PRODUCTION$1 || Tt.name === "MissingIcon" && console.error(Tt);
    }
    return ot;
  }, []);
  return new Promise(function(ot, vt) {
    Promise.all(Xe).then(function(bt) {
      perform(bt, function() {
        we("active"), we("complete"), Re("pending"), typeof ie == "function" && ie(), Ge(), ot();
      });
    }).catch(function(bt) {
      Ge(), vt(bt);
    });
  });
}
function onNode(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(ce).then(function(me) {
    me && perform([me], ie);
  });
}
function resolveIcons(ce) {
  return function(ie) {
    var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, we = (ie || {}).icon ? ie : findIconDefinition(ie || {}), Re = me.mask;
    return Re && (Re = (Re || {}).icon ? Re : findIconDefinition(Re || {})), ce(we, _objectSpread2$4(_objectSpread2$4({}, me), {}, {
      mask: Re
    }));
  };
}
var render$1 = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, we = me.transform, Re = we === void 0 ? meaninglessTransform : we, je = me.symbol, Ue = je === void 0 ? !1 : je, qe = me.mask, Ge = qe === void 0 ? null : qe, Xe = me.maskId, ot = Xe === void 0 ? null : Xe, vt = me.title, bt = vt === void 0 ? null : vt, Tt = me.titleId, wt = Tt === void 0 ? null : Tt, St = me.classes, It = St === void 0 ? [] : St, Pt = me.attributes, kt = Pt === void 0 ? {} : Pt, Ot = me.styles, Jr = Ot === void 0 ? {} : Ot;
  if (ie) {
    var en = ie.prefix, nn = ie.iconName, ln = ie.icon;
    return domVariants(_objectSpread2$4({
      type: "icon"
    }, ie), function() {
      return callHooks("beforeDOMElementCreation", {
        iconDefinition: ie,
        params: me
      }), config.autoA11y && (bt ? kt["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(wt || nextUniqueId$1()) : (kt["aria-hidden"] = "true", kt.focusable = "false")), makeInlineSvgAbstract({
        icons: {
          main: asFoundIcon(ln),
          mask: Ge ? asFoundIcon(Ge.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: en,
        iconName: nn,
        transform: _objectSpread2$4(_objectSpread2$4({}, meaninglessTransform), Re),
        symbol: Ue,
        title: bt,
        maskId: ot,
        titleId: wt,
        extra: {
          attributes: kt,
          styles: Jr,
          classes: It
        }
      });
    });
  }
}, ReplaceElements = {
  mixout: function() {
    return {
      icon: resolveIcons(render$1)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(me) {
        return me.treeCallback = onTree, me.nodeCallback = onNode, me;
      }
    };
  },
  provides: function(ie) {
    ie.i2svg = function(me) {
      var we = me.node, Re = we === void 0 ? DOCUMENT : we, je = me.callback, Ue = je === void 0 ? function() {
      } : je;
      return onTree(Re, Ue);
    }, ie.generateSvgReplacementMutation = function(me, we) {
      var Re = we.iconName, je = we.title, Ue = we.titleId, qe = we.prefix, Ge = we.transform, Xe = we.symbol, ot = we.mask, vt = we.maskId, bt = we.extra;
      return new Promise(function(Tt, wt) {
        Promise.all([findIcon(Re, qe), ot.iconName ? findIcon(ot.iconName, ot.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(St) {
          var It = _slicedToArray$9(St, 2), Pt = It[0], kt = It[1];
          Tt([me, makeInlineSvgAbstract({
            icons: {
              main: Pt,
              mask: kt
            },
            prefix: qe,
            iconName: Re,
            transform: Ge,
            symbol: Xe,
            maskId: vt,
            title: je,
            titleId: Ue,
            extra: bt,
            watchable: !0
          })]);
        }).catch(wt);
      });
    }, ie.generateAbstractIcon = function(me) {
      var we = me.children, Re = me.attributes, je = me.main, Ue = me.transform, qe = me.styles, Ge = joinStyles(qe);
      Ge.length > 0 && (Re.style = Ge);
      var Xe;
      return transformIsMeaningful(Ue) && (Xe = callProvided("generateAbstractTransformGrouping", {
        main: je,
        transform: Ue,
        containerWidth: je.width,
        iconWidth: je.width
      })), we.push(Xe || je.icon), {
        children: we,
        attributes: Re
      };
    };
  }
}, Layers = {
  mixout: function() {
    return {
      layer: function(me) {
        var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Re = we.classes, je = Re === void 0 ? [] : Re;
        return domVariants({
          type: "layer"
        }, function() {
          callHooks("beforeDOMElementCreation", {
            assembler: me,
            params: we
          });
          var Ue = [];
          return me(function(qe) {
            Array.isArray(qe) ? qe.map(function(Ge) {
              Ue = Ue.concat(Ge.abstract);
            }) : Ue = Ue.concat(qe.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray$3(je)).join(" ")
            },
            children: Ue
          }];
        });
      }
    };
  }
}, LayersCounter = {
  mixout: function() {
    return {
      counter: function(me) {
        var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Re = we.title, je = Re === void 0 ? null : Re, Ue = we.classes, qe = Ue === void 0 ? [] : Ue, Ge = we.attributes, Xe = Ge === void 0 ? {} : Ge, ot = we.styles, vt = ot === void 0 ? {} : ot;
        return domVariants({
          type: "counter",
          content: me
        }, function() {
          return callHooks("beforeDOMElementCreation", {
            content: me,
            params: we
          }), makeLayersCounterAbstract({
            content: me.toString(),
            title: je,
            extra: {
              attributes: Xe,
              styles: vt,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray$3(qe))
            }
          });
        });
      }
    };
  }
}, LayersText = {
  mixout: function() {
    return {
      text: function(me) {
        var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Re = we.transform, je = Re === void 0 ? meaninglessTransform : Re, Ue = we.title, qe = Ue === void 0 ? null : Ue, Ge = we.classes, Xe = Ge === void 0 ? [] : Ge, ot = we.attributes, vt = ot === void 0 ? {} : ot, bt = we.styles, Tt = bt === void 0 ? {} : bt;
        return domVariants({
          type: "text",
          content: me
        }, function() {
          return callHooks("beforeDOMElementCreation", {
            content: me,
            params: we
          }), makeLayersTextAbstract({
            content: me,
            transform: _objectSpread2$4(_objectSpread2$4({}, meaninglessTransform), je),
            title: qe,
            extra: {
              attributes: vt,
              styles: Tt,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray$3(Xe))
            }
          });
        });
      }
    };
  },
  provides: function(ie) {
    ie.generateLayersText = function(me, we) {
      var Re = we.title, je = we.transform, Ue = we.extra, qe = null, Ge = null;
      if (IS_IE) {
        var Xe = parseInt(getComputedStyle(me).fontSize, 10), ot = me.getBoundingClientRect();
        qe = ot.width / Xe, Ge = ot.height / Xe;
      }
      return config.autoA11y && !Re && (Ue.attributes["aria-hidden"] = "true"), Promise.resolve([me, makeLayersTextAbstract({
        content: me.innerHTML,
        width: qe,
        height: Ge,
        transform: je,
        title: Re,
        extra: Ue,
        watchable: !0
      })]);
    };
  }
}, CLEAN_CONTENT_PATTERN = new RegExp('"', "ug"), SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(ce) {
  var ie = ce.replace(CLEAN_CONTENT_PATTERN, ""), me = codePointAt(ie, 0), we = me >= SECONDARY_UNICODE_RANGE[0] && me <= SECONDARY_UNICODE_RANGE[1], Re = ie.length === 2 ? ie[0] === ie[1] : !1;
  return {
    value: toHex(Re ? ie[0] : ie),
    isSecondary: we || Re
  };
}
function replaceForPosition(ce, ie) {
  var me = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(ie.replace(":", "-"));
  return new Promise(function(we, Re) {
    if (ce.getAttribute(me) !== null)
      return we();
    var je = toArray$3(ce.children), Ue = je.filter(function(ln) {
      return ln.getAttribute(DATA_FA_PSEUDO_ELEMENT) === ie;
    })[0], qe = WINDOW.getComputedStyle(ce, ie), Ge = qe.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN), Xe = qe.getPropertyValue("font-weight"), ot = qe.getPropertyValue("content");
    if (Ue && !Ge)
      return ce.removeChild(Ue), we();
    if (Ge && ot !== "none" && ot !== "") {
      var vt = qe.getPropertyValue("content"), bt = ~["Sharp"].indexOf(Ge[2]) ? FAMILY_SHARP : FAMILY_CLASSIC, Tt = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(Ge[2]) ? STYLE_TO_PREFIX[bt][Ge[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[bt][Xe], wt = hexValueFromContent(vt), St = wt.value, It = wt.isSecondary, Pt = Ge[0].startsWith("FontAwesome"), kt = byUnicode(Tt, St), Ot = kt;
      if (Pt) {
        var Jr = byOldUnicode(St);
        Jr.iconName && Jr.prefix && (kt = Jr.iconName, Tt = Jr.prefix);
      }
      if (kt && !It && (!Ue || Ue.getAttribute(DATA_PREFIX) !== Tt || Ue.getAttribute(DATA_ICON) !== Ot)) {
        ce.setAttribute(me, Ot), Ue && ce.removeChild(Ue);
        var en = blankMeta(), nn = en.extra;
        nn.attributes[DATA_FA_PSEUDO_ELEMENT] = ie, findIcon(kt, Tt).then(function(ln) {
          var fn = makeInlineSvgAbstract(_objectSpread2$4(_objectSpread2$4({}, en), {}, {
            icons: {
              main: ln,
              mask: emptyCanonicalIcon()
            },
            prefix: Tt,
            iconName: Ot,
            extra: nn,
            watchable: !0
          })), vn = DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
          ie === "::before" ? ce.insertBefore(vn, ce.firstChild) : ce.appendChild(vn), vn.outerHTML = fn.map(function(Tn) {
            return toHtml(Tn);
          }).join(`
`), ce.removeAttribute(me), we();
        }).catch(Re);
      } else
        we();
    } else
      we();
  });
}
function replace(ce) {
  return Promise.all([replaceForPosition(ce, "::before"), replaceForPosition(ce, "::after")]);
}
function processable(ce) {
  return ce.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(ce.tagName.toUpperCase()) && !ce.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!ce.parentNode || ce.parentNode.tagName !== "svg");
}
function searchPseudoElements(ce) {
  if (IS_DOM)
    return new Promise(function(ie, me) {
      var we = toArray$3(ce.querySelectorAll("*")).filter(processable).map(replace), Re = perf.begin("searchPseudoElements");
      disableObservation(), Promise.all(we).then(function() {
        Re(), enableObservation(), ie();
      }).catch(function() {
        Re(), enableObservation(), me();
      });
    });
}
var PseudoElements = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(me) {
        return me.pseudoElementsCallback = searchPseudoElements, me;
      }
    };
  },
  provides: function(ie) {
    ie.pseudoElements2svg = function(me) {
      var we = me.node, Re = we === void 0 ? DOCUMENT : we;
      config.searchPseudoElements && searchPseudoElements(Re);
    };
  }
}, _unwatched = !1, MutationObserver$1 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          disableObservation(), _unwatched = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        observe$1(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        disconnect();
      },
      watch: function(me) {
        var we = me.observeMutationsRoot;
        _unwatched ? enableObservation() : observe$1(chainHooks("mutationObserverCallbacks", {
          observeMutationsRoot: we
        }));
      }
    };
  }
}, parseTransformString = function(ie) {
  var me = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return ie.toLowerCase().split(" ").reduce(function(we, Re) {
    var je = Re.toLowerCase().split("-"), Ue = je[0], qe = je.slice(1).join("-");
    if (Ue && qe === "h")
      return we.flipX = !0, we;
    if (Ue && qe === "v")
      return we.flipY = !0, we;
    if (qe = parseFloat(qe), isNaN(qe))
      return we;
    switch (Ue) {
      case "grow":
        we.size = we.size + qe;
        break;
      case "shrink":
        we.size = we.size - qe;
        break;
      case "left":
        we.x = we.x - qe;
        break;
      case "right":
        we.x = we.x + qe;
        break;
      case "up":
        we.y = we.y - qe;
        break;
      case "down":
        we.y = we.y + qe;
        break;
      case "rotate":
        we.rotate = we.rotate + qe;
        break;
    }
    return we;
  }, me);
}, PowerTransforms = {
  mixout: function() {
    return {
      parse: {
        transform: function(me) {
          return parseTransformString(me);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(me, we) {
        var Re = we.getAttribute("data-fa-transform");
        return Re && (me.transform = parseTransformString(Re)), me;
      }
    };
  },
  provides: function(ie) {
    ie.generateAbstractTransformGrouping = function(me) {
      var we = me.main, Re = me.transform, je = me.containerWidth, Ue = me.iconWidth, qe = {
        transform: "translate(".concat(je / 2, " 256)")
      }, Ge = "translate(".concat(Re.x * 32, ", ").concat(Re.y * 32, ") "), Xe = "scale(".concat(Re.size / 16 * (Re.flipX ? -1 : 1), ", ").concat(Re.size / 16 * (Re.flipY ? -1 : 1), ") "), ot = "rotate(".concat(Re.rotate, " 0 0)"), vt = {
        transform: "".concat(Ge, " ").concat(Xe, " ").concat(ot)
      }, bt = {
        transform: "translate(".concat(Ue / 2 * -1, " -256)")
      }, Tt = {
        outer: qe,
        inner: vt,
        path: bt
      };
      return {
        tag: "g",
        attributes: _objectSpread2$4({}, Tt.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$4({}, Tt.inner),
          children: [{
            tag: we.icon.tag,
            children: we.icon.children,
            attributes: _objectSpread2$4(_objectSpread2$4({}, we.icon.attributes), Tt.path)
          }]
        }]
      };
    };
  }
}, ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return ce.attributes && (ce.attributes.fill || ie) && (ce.attributes.fill = "black"), ce;
}
function deGroup(ce) {
  return ce.tag === "g" ? ce.children : [ce];
}
var Masks = {
  hooks: function() {
    return {
      parseNodeAttributes: function(me, we) {
        var Re = we.getAttribute("data-fa-mask"), je = Re ? getCanonicalIcon(Re.split(" ").map(function(Ue) {
          return Ue.trim();
        })) : emptyCanonicalIcon();
        return je.prefix || (je.prefix = getDefaultUsablePrefix()), me.mask = je, me.maskId = we.getAttribute("data-fa-mask-id"), me;
      }
    };
  },
  provides: function(ie) {
    ie.generateAbstractMask = function(me) {
      var we = me.children, Re = me.attributes, je = me.main, Ue = me.mask, qe = me.maskId, Ge = me.transform, Xe = je.width, ot = je.icon, vt = Ue.width, bt = Ue.icon, Tt = transformForSvg({
        transform: Ge,
        containerWidth: vt,
        iconWidth: Xe
      }), wt = {
        tag: "rect",
        attributes: _objectSpread2$4(_objectSpread2$4({}, ALL_SPACE), {}, {
          fill: "white"
        })
      }, St = ot.children ? {
        children: ot.children.map(fillBlack)
      } : {}, It = {
        tag: "g",
        attributes: _objectSpread2$4({}, Tt.inner),
        children: [fillBlack(_objectSpread2$4({
          tag: ot.tag,
          attributes: _objectSpread2$4(_objectSpread2$4({}, ot.attributes), Tt.path)
        }, St))]
      }, Pt = {
        tag: "g",
        attributes: _objectSpread2$4({}, Tt.outer),
        children: [It]
      }, kt = "mask-".concat(qe || nextUniqueId$1()), Ot = "clip-".concat(qe || nextUniqueId$1()), Jr = {
        tag: "mask",
        attributes: _objectSpread2$4(_objectSpread2$4({}, ALL_SPACE), {}, {
          id: kt,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [wt, Pt]
      }, en = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: Ot
          },
          children: deGroup(bt)
        }, Jr]
      };
      return we.push(en, {
        tag: "rect",
        attributes: _objectSpread2$4({
          fill: "currentColor",
          "clip-path": "url(#".concat(Ot, ")"),
          mask: "url(#".concat(kt, ")")
        }, ALL_SPACE)
      }), {
        children: we,
        attributes: Re
      };
    };
  }
}, MissingIconIndicator = {
  provides: function(ie) {
    var me = !1;
    WINDOW.matchMedia && (me = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches), ie.missingIconAbstract = function() {
      var we = [], Re = {
        fill: "currentColor"
      }, je = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      we.push({
        tag: "path",
        attributes: _objectSpread2$4(_objectSpread2$4({}, Re), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var Ue = _objectSpread2$4(_objectSpread2$4({}, je), {}, {
        attributeName: "opacity"
      }), qe = {
        tag: "circle",
        attributes: _objectSpread2$4(_objectSpread2$4({}, Re), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return me || qe.children.push({
        tag: "animate",
        attributes: _objectSpread2$4(_objectSpread2$4({}, je), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _objectSpread2$4(_objectSpread2$4({}, Ue), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), we.push(qe), we.push({
        tag: "path",
        attributes: _objectSpread2$4(_objectSpread2$4({}, Re), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: me ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$4(_objectSpread2$4({}, Ue), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), me || we.push({
        tag: "path",
        attributes: _objectSpread2$4(_objectSpread2$4({}, Re), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _objectSpread2$4(_objectSpread2$4({}, Ue), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: we
      };
    };
  }
}, SvgSymbols = {
  hooks: function() {
    return {
      parseNodeAttributes: function(me, we) {
        var Re = we.getAttribute("data-fa-symbol"), je = Re === null ? !1 : Re === "" ? !0 : Re;
        return me.symbol = je, me;
      }
    };
  }
}, plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var ce = typeof Symbol == "function" && Symbol.for, ie = ce ? Symbol.for("react.element") : 60103, me = ce ? Symbol.for("react.portal") : 60106, we = ce ? Symbol.for("react.fragment") : 60107, Re = ce ? Symbol.for("react.strict_mode") : 60108, je = ce ? Symbol.for("react.profiler") : 60114, Ue = ce ? Symbol.for("react.provider") : 60109, qe = ce ? Symbol.for("react.context") : 60110, Ge = ce ? Symbol.for("react.async_mode") : 60111, Xe = ce ? Symbol.for("react.concurrent_mode") : 60111, ot = ce ? Symbol.for("react.forward_ref") : 60112, vt = ce ? Symbol.for("react.suspense") : 60113, bt = ce ? Symbol.for("react.suspense_list") : 60120, Tt = ce ? Symbol.for("react.memo") : 60115, wt = ce ? Symbol.for("react.lazy") : 60116, St = ce ? Symbol.for("react.block") : 60121, It = ce ? Symbol.for("react.fundamental") : 60117, Pt = ce ? Symbol.for("react.responder") : 60118, kt = ce ? Symbol.for("react.scope") : 60119;
  function Ot(en) {
    if (typeof en == "object" && en !== null) {
      var nn = en.$$typeof;
      switch (nn) {
        case ie:
          switch (en = en.type, en) {
            case Ge:
            case Xe:
            case we:
            case je:
            case Re:
            case vt:
              return en;
            default:
              switch (en = en && en.$$typeof, en) {
                case qe:
                case ot:
                case wt:
                case Tt:
                case Ue:
                  return en;
                default:
                  return nn;
              }
          }
        case me:
          return nn;
      }
    }
  }
  function Jr(en) {
    return Ot(en) === Xe;
  }
  return reactIs_production_min$1.AsyncMode = Ge, reactIs_production_min$1.ConcurrentMode = Xe, reactIs_production_min$1.ContextConsumer = qe, reactIs_production_min$1.ContextProvider = Ue, reactIs_production_min$1.Element = ie, reactIs_production_min$1.ForwardRef = ot, reactIs_production_min$1.Fragment = we, reactIs_production_min$1.Lazy = wt, reactIs_production_min$1.Memo = Tt, reactIs_production_min$1.Portal = me, reactIs_production_min$1.Profiler = je, reactIs_production_min$1.StrictMode = Re, reactIs_production_min$1.Suspense = vt, reactIs_production_min$1.isAsyncMode = function(en) {
    return Jr(en) || Ot(en) === Ge;
  }, reactIs_production_min$1.isConcurrentMode = Jr, reactIs_production_min$1.isContextConsumer = function(en) {
    return Ot(en) === qe;
  }, reactIs_production_min$1.isContextProvider = function(en) {
    return Ot(en) === Ue;
  }, reactIs_production_min$1.isElement = function(en) {
    return typeof en == "object" && en !== null && en.$$typeof === ie;
  }, reactIs_production_min$1.isForwardRef = function(en) {
    return Ot(en) === ot;
  }, reactIs_production_min$1.isFragment = function(en) {
    return Ot(en) === we;
  }, reactIs_production_min$1.isLazy = function(en) {
    return Ot(en) === wt;
  }, reactIs_production_min$1.isMemo = function(en) {
    return Ot(en) === Tt;
  }, reactIs_production_min$1.isPortal = function(en) {
    return Ot(en) === me;
  }, reactIs_production_min$1.isProfiler = function(en) {
    return Ot(en) === je;
  }, reactIs_production_min$1.isStrictMode = function(en) {
    return Ot(en) === Re;
  }, reactIs_production_min$1.isSuspense = function(en) {
    return Ot(en) === vt;
  }, reactIs_production_min$1.isValidElementType = function(en) {
    return typeof en == "string" || typeof en == "function" || en === we || en === Xe || en === je || en === Re || en === vt || en === bt || typeof en == "object" && en !== null && (en.$$typeof === wt || en.$$typeof === Tt || en.$$typeof === Ue || en.$$typeof === qe || en.$$typeof === ot || en.$$typeof === It || en.$$typeof === Pt || en.$$typeof === kt || en.$$typeof === St);
  }, reactIs_production_min$1.typeOf = Ot, reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    var ce = typeof Symbol == "function" && Symbol.for, ie = ce ? Symbol.for("react.element") : 60103, me = ce ? Symbol.for("react.portal") : 60106, we = ce ? Symbol.for("react.fragment") : 60107, Re = ce ? Symbol.for("react.strict_mode") : 60108, je = ce ? Symbol.for("react.profiler") : 60114, Ue = ce ? Symbol.for("react.provider") : 60109, qe = ce ? Symbol.for("react.context") : 60110, Ge = ce ? Symbol.for("react.async_mode") : 60111, Xe = ce ? Symbol.for("react.concurrent_mode") : 60111, ot = ce ? Symbol.for("react.forward_ref") : 60112, vt = ce ? Symbol.for("react.suspense") : 60113, bt = ce ? Symbol.for("react.suspense_list") : 60120, Tt = ce ? Symbol.for("react.memo") : 60115, wt = ce ? Symbol.for("react.lazy") : 60116, St = ce ? Symbol.for("react.block") : 60121, It = ce ? Symbol.for("react.fundamental") : 60117, Pt = ce ? Symbol.for("react.responder") : 60118, kt = ce ? Symbol.for("react.scope") : 60119;
    function Ot(ii) {
      return typeof ii == "string" || typeof ii == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ii === we || ii === Xe || ii === je || ii === Re || ii === vt || ii === bt || typeof ii == "object" && ii !== null && (ii.$$typeof === wt || ii.$$typeof === Tt || ii.$$typeof === Ue || ii.$$typeof === qe || ii.$$typeof === ot || ii.$$typeof === It || ii.$$typeof === Pt || ii.$$typeof === kt || ii.$$typeof === St);
    }
    function Jr(ii) {
      if (typeof ii == "object" && ii !== null) {
        var Fi = ii.$$typeof;
        switch (Fi) {
          case ie:
            var ni = ii.type;
            switch (ni) {
              case Ge:
              case Xe:
              case we:
              case je:
              case Re:
              case vt:
                return ni;
              default:
                var Ui = ni && ni.$$typeof;
                switch (Ui) {
                  case qe:
                  case ot:
                  case wt:
                  case Tt:
                  case Ue:
                    return Ui;
                  default:
                    return Fi;
                }
            }
          case me:
            return Fi;
        }
      }
    }
    var en = Ge, nn = Xe, ln = qe, fn = Ue, vn = ie, Tn = ot, xn = we, bn = wt, Sn = Tt, Cn = me, kn = je, cn = Re, gn = vt, an = !1;
    function un(ii) {
      return an || (an = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), pn(ii) || Jr(ii) === Ge;
    }
    function pn(ii) {
      return Jr(ii) === Xe;
    }
    function hn(ii) {
      return Jr(ii) === qe;
    }
    function An(ii) {
      return Jr(ii) === Ue;
    }
    function In(ii) {
      return typeof ii == "object" && ii !== null && ii.$$typeof === ie;
    }
    function qn(ii) {
      return Jr(ii) === ot;
    }
    function si(ii) {
      return Jr(ii) === we;
    }
    function bi(ii) {
      return Jr(ii) === wt;
    }
    function xi(ii) {
      return Jr(ii) === Tt;
    }
    function ji(ii) {
      return Jr(ii) === me;
    }
    function zi(ii) {
      return Jr(ii) === je;
    }
    function Vi(ii) {
      return Jr(ii) === Re;
    }
    function Hi(ii) {
      return Jr(ii) === vt;
    }
    reactIs_development$1.AsyncMode = en, reactIs_development$1.ConcurrentMode = nn, reactIs_development$1.ContextConsumer = ln, reactIs_development$1.ContextProvider = fn, reactIs_development$1.Element = vn, reactIs_development$1.ForwardRef = Tn, reactIs_development$1.Fragment = xn, reactIs_development$1.Lazy = bn, reactIs_development$1.Memo = Sn, reactIs_development$1.Portal = Cn, reactIs_development$1.Profiler = kn, reactIs_development$1.StrictMode = cn, reactIs_development$1.Suspense = gn, reactIs_development$1.isAsyncMode = un, reactIs_development$1.isConcurrentMode = pn, reactIs_development$1.isContextConsumer = hn, reactIs_development$1.isContextProvider = An, reactIs_development$1.isElement = In, reactIs_development$1.isForwardRef = qn, reactIs_development$1.isFragment = si, reactIs_development$1.isLazy = bi, reactIs_development$1.isMemo = xi, reactIs_development$1.isPortal = ji, reactIs_development$1.isProfiler = zi, reactIs_development$1.isStrictMode = Vi, reactIs_development$1.isSuspense = Hi, reactIs_development$1.isValidElementType = Ot, reactIs_development$1.typeOf = Jr;
  }()), reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var ce = Object.getOwnPropertySymbols, ie = Object.prototype.hasOwnProperty, me = Object.prototype.propertyIsEnumerable;
  function we(je) {
    if (je == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(je);
  }
  function Re() {
    try {
      if (!Object.assign)
        return !1;
      var je = new String("abc");
      if (je[5] = "de", Object.getOwnPropertyNames(je)[0] === "5")
        return !1;
      for (var Ue = {}, qe = 0; qe < 10; qe++)
        Ue["_" + String.fromCharCode(qe)] = qe;
      var Ge = Object.getOwnPropertyNames(Ue).map(function(ot) {
        return Ue[ot];
      });
      if (Ge.join("") !== "0123456789")
        return !1;
      var Xe = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(ot) {
        Xe[ot] = ot;
      }), Object.keys(Object.assign({}, Xe)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = Re() ? Object.assign : function(je, Ue) {
    for (var qe, Ge = we(je), Xe, ot = 1; ot < arguments.length; ot++) {
      qe = Object(arguments[ot]);
      for (var vt in qe)
        ie.call(qe, vt) && (Ge[vt] = qe[vt]);
      if (ce) {
        Xe = ce(qe);
        for (var bt = 0; bt < Xe.length; bt++)
          me.call(qe, Xe[bt]) && (Ge[Xe[bt]] = qe[Xe[bt]]);
      }
    }
    return Ge;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ce = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = ce, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var ce = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ie = requireReactPropTypesSecret(), me = {}, we = requireHas();
    ce = function(je) {
      var Ue = "Warning: " + je;
      typeof console < "u" && console.error(Ue);
      try {
        throw new Error(Ue);
      } catch {
      }
    };
  }
  function Re(je, Ue, qe, Ge, Xe) {
    if (process.env.NODE_ENV !== "production") {
      for (var ot in je)
        if (we(je, ot)) {
          var vt;
          try {
            if (typeof je[ot] != "function") {
              var bt = Error(
                (Ge || "React class") + ": " + qe + " type `" + ot + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof je[ot] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw bt.name = "Invariant Violation", bt;
            }
            vt = je[ot](Ue, ot, Ge, qe, null, ie);
          } catch (wt) {
            vt = wt;
          }
          if (vt && !(vt instanceof Error) && ce(
            (Ge || "React class") + ": type specification of " + qe + " `" + ot + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof vt + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), vt instanceof Error && !(vt.message in me)) {
            me[vt.message] = !0;
            var Tt = Xe ? Xe() : "";
            ce(
              "Failed " + qe + " type: " + vt.message + (Tt ?? "")
            );
          }
        }
    }
  }
  return Re.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (me = {});
  }, checkPropTypes_1 = Re, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ce = requireReactIs(), ie = requireObjectAssign(), me = requireReactPropTypesSecret(), we = requireHas(), Re = requireCheckPropTypes(), je = function() {
  };
  process.env.NODE_ENV !== "production" && (je = function(qe) {
    var Ge = "Warning: " + qe;
    typeof console < "u" && console.error(Ge);
    try {
      throw new Error(Ge);
    } catch {
    }
  });
  function Ue() {
    return null;
  }
  return factoryWithTypeCheckers = function(qe, Ge) {
    var Xe = typeof Symbol == "function" && Symbol.iterator, ot = "@@iterator";
    function vt(pn) {
      var hn = pn && (Xe && pn[Xe] || pn[ot]);
      if (typeof hn == "function")
        return hn;
    }
    var bt = "<<anonymous>>", Tt = {
      array: Pt("array"),
      bigint: Pt("bigint"),
      bool: Pt("boolean"),
      func: Pt("function"),
      number: Pt("number"),
      object: Pt("object"),
      string: Pt("string"),
      symbol: Pt("symbol"),
      any: kt(),
      arrayOf: Ot,
      element: Jr(),
      elementType: en(),
      instanceOf: nn,
      node: Tn(),
      objectOf: fn,
      oneOf: ln,
      oneOfType: vn,
      shape: bn,
      exact: Sn
    };
    function wt(pn, hn) {
      return pn === hn ? pn !== 0 || 1 / pn === 1 / hn : pn !== pn && hn !== hn;
    }
    function St(pn, hn) {
      this.message = pn, this.data = hn && typeof hn == "object" ? hn : {}, this.stack = "";
    }
    St.prototype = Error.prototype;
    function It(pn) {
      if (process.env.NODE_ENV !== "production")
        var hn = {}, An = 0;
      function In(si, bi, xi, ji, zi, Vi, Hi) {
        if (ji = ji || bt, Vi = Vi || xi, Hi !== me) {
          if (Ge) {
            var ii = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ii.name = "Invariant Violation", ii;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fi = ji + ":" + xi;
            !hn[Fi] && // Avoid spamming the console because they are often not actionable except for lib authors
            An < 3 && (je(
              "You are manually calling a React.PropTypes validation function for the `" + Vi + "` prop on `" + ji + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), hn[Fi] = !0, An++);
          }
        }
        return bi[xi] == null ? si ? bi[xi] === null ? new St("The " + zi + " `" + Vi + "` is marked as required " + ("in `" + ji + "`, but its value is `null`.")) : new St("The " + zi + " `" + Vi + "` is marked as required in " + ("`" + ji + "`, but its value is `undefined`.")) : null : pn(bi, xi, ji, zi, Vi);
      }
      var qn = In.bind(null, !1);
      return qn.isRequired = In.bind(null, !0), qn;
    }
    function Pt(pn) {
      function hn(An, In, qn, si, bi, xi) {
        var ji = An[In], zi = cn(ji);
        if (zi !== pn) {
          var Vi = gn(ji);
          return new St(
            "Invalid " + si + " `" + bi + "` of type " + ("`" + Vi + "` supplied to `" + qn + "`, expected ") + ("`" + pn + "`."),
            { expectedType: pn }
          );
        }
        return null;
      }
      return It(hn);
    }
    function kt() {
      return It(Ue);
    }
    function Ot(pn) {
      function hn(An, In, qn, si, bi) {
        if (typeof pn != "function")
          return new St("Property `" + bi + "` of component `" + qn + "` has invalid PropType notation inside arrayOf.");
        var xi = An[In];
        if (!Array.isArray(xi)) {
          var ji = cn(xi);
          return new St("Invalid " + si + " `" + bi + "` of type " + ("`" + ji + "` supplied to `" + qn + "`, expected an array."));
        }
        for (var zi = 0; zi < xi.length; zi++) {
          var Vi = pn(xi, zi, qn, si, bi + "[" + zi + "]", me);
          if (Vi instanceof Error)
            return Vi;
        }
        return null;
      }
      return It(hn);
    }
    function Jr() {
      function pn(hn, An, In, qn, si) {
        var bi = hn[An];
        if (!qe(bi)) {
          var xi = cn(bi);
          return new St("Invalid " + qn + " `" + si + "` of type " + ("`" + xi + "` supplied to `" + In + "`, expected a single ReactElement."));
        }
        return null;
      }
      return It(pn);
    }
    function en() {
      function pn(hn, An, In, qn, si) {
        var bi = hn[An];
        if (!ce.isValidElementType(bi)) {
          var xi = cn(bi);
          return new St("Invalid " + qn + " `" + si + "` of type " + ("`" + xi + "` supplied to `" + In + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return It(pn);
    }
    function nn(pn) {
      function hn(An, In, qn, si, bi) {
        if (!(An[In] instanceof pn)) {
          var xi = pn.name || bt, ji = un(An[In]);
          return new St("Invalid " + si + " `" + bi + "` of type " + ("`" + ji + "` supplied to `" + qn + "`, expected ") + ("instance of `" + xi + "`."));
        }
        return null;
      }
      return It(hn);
    }
    function ln(pn) {
      if (!Array.isArray(pn))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? je(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : je("Invalid argument supplied to oneOf, expected an array.")), Ue;
      function hn(An, In, qn, si, bi) {
        for (var xi = An[In], ji = 0; ji < pn.length; ji++)
          if (wt(xi, pn[ji]))
            return null;
        var zi = JSON.stringify(pn, function(Hi, ii) {
          var Fi = gn(ii);
          return Fi === "symbol" ? String(ii) : ii;
        });
        return new St("Invalid " + si + " `" + bi + "` of value `" + String(xi) + "` " + ("supplied to `" + qn + "`, expected one of " + zi + "."));
      }
      return It(hn);
    }
    function fn(pn) {
      function hn(An, In, qn, si, bi) {
        if (typeof pn != "function")
          return new St("Property `" + bi + "` of component `" + qn + "` has invalid PropType notation inside objectOf.");
        var xi = An[In], ji = cn(xi);
        if (ji !== "object")
          return new St("Invalid " + si + " `" + bi + "` of type " + ("`" + ji + "` supplied to `" + qn + "`, expected an object."));
        for (var zi in xi)
          if (we(xi, zi)) {
            var Vi = pn(xi, zi, qn, si, bi + "." + zi, me);
            if (Vi instanceof Error)
              return Vi;
          }
        return null;
      }
      return It(hn);
    }
    function vn(pn) {
      if (!Array.isArray(pn))
        return process.env.NODE_ENV !== "production" && je("Invalid argument supplied to oneOfType, expected an instance of array."), Ue;
      for (var hn = 0; hn < pn.length; hn++) {
        var An = pn[hn];
        if (typeof An != "function")
          return je(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + an(An) + " at index " + hn + "."
          ), Ue;
      }
      function In(qn, si, bi, xi, ji) {
        for (var zi = [], Vi = 0; Vi < pn.length; Vi++) {
          var Hi = pn[Vi], ii = Hi(qn, si, bi, xi, ji, me);
          if (ii == null)
            return null;
          ii.data && we(ii.data, "expectedType") && zi.push(ii.data.expectedType);
        }
        var Fi = zi.length > 0 ? ", expected one of type [" + zi.join(", ") + "]" : "";
        return new St("Invalid " + xi + " `" + ji + "` supplied to " + ("`" + bi + "`" + Fi + "."));
      }
      return It(In);
    }
    function Tn() {
      function pn(hn, An, In, qn, si) {
        return Cn(hn[An]) ? null : new St("Invalid " + qn + " `" + si + "` supplied to " + ("`" + In + "`, expected a ReactNode."));
      }
      return It(pn);
    }
    function xn(pn, hn, An, In, qn) {
      return new St(
        (pn || "React class") + ": " + hn + " type `" + An + "." + In + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + qn + "`."
      );
    }
    function bn(pn) {
      function hn(An, In, qn, si, bi) {
        var xi = An[In], ji = cn(xi);
        if (ji !== "object")
          return new St("Invalid " + si + " `" + bi + "` of type `" + ji + "` " + ("supplied to `" + qn + "`, expected `object`."));
        for (var zi in pn) {
          var Vi = pn[zi];
          if (typeof Vi != "function")
            return xn(qn, si, bi, zi, gn(Vi));
          var Hi = Vi(xi, zi, qn, si, bi + "." + zi, me);
          if (Hi)
            return Hi;
        }
        return null;
      }
      return It(hn);
    }
    function Sn(pn) {
      function hn(An, In, qn, si, bi) {
        var xi = An[In], ji = cn(xi);
        if (ji !== "object")
          return new St("Invalid " + si + " `" + bi + "` of type `" + ji + "` " + ("supplied to `" + qn + "`, expected `object`."));
        var zi = ie({}, An[In], pn);
        for (var Vi in zi) {
          var Hi = pn[Vi];
          if (we(pn, Vi) && typeof Hi != "function")
            return xn(qn, si, bi, Vi, gn(Hi));
          if (!Hi)
            return new St(
              "Invalid " + si + " `" + bi + "` key `" + Vi + "` supplied to `" + qn + "`.\nBad object: " + JSON.stringify(An[In], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(pn), null, "  ")
            );
          var ii = Hi(xi, Vi, qn, si, bi + "." + Vi, me);
          if (ii)
            return ii;
        }
        return null;
      }
      return It(hn);
    }
    function Cn(pn) {
      switch (typeof pn) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !pn;
        case "object":
          if (Array.isArray(pn))
            return pn.every(Cn);
          if (pn === null || qe(pn))
            return !0;
          var hn = vt(pn);
          if (hn) {
            var An = hn.call(pn), In;
            if (hn !== pn.entries) {
              for (; !(In = An.next()).done; )
                if (!Cn(In.value))
                  return !1;
            } else
              for (; !(In = An.next()).done; ) {
                var qn = In.value;
                if (qn && !Cn(qn[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function kn(pn, hn) {
      return pn === "symbol" ? !0 : hn ? hn["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && hn instanceof Symbol : !1;
    }
    function cn(pn) {
      var hn = typeof pn;
      return Array.isArray(pn) ? "array" : pn instanceof RegExp ? "object" : kn(hn, pn) ? "symbol" : hn;
    }
    function gn(pn) {
      if (typeof pn > "u" || pn === null)
        return "" + pn;
      var hn = cn(pn);
      if (hn === "object") {
        if (pn instanceof Date)
          return "date";
        if (pn instanceof RegExp)
          return "regexp";
      }
      return hn;
    }
    function an(pn) {
      var hn = gn(pn);
      switch (hn) {
        case "array":
        case "object":
          return "an " + hn;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + hn;
        default:
          return hn;
      }
    }
    function un(pn) {
      return !pn.constructor || !pn.constructor.name ? bt : pn.constructor.name;
    }
    return Tt.checkPropTypes = Re, Tt.resetWarningCache = Re.resetWarningCache, Tt.PropTypes = Tt, Tt;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ce = requireReactPropTypesSecret();
  function ie() {
  }
  function me() {
  }
  return me.resetWarningCache = ie, factoryWithThrowingShims = function() {
    function we(Ue, qe, Ge, Xe, ot, vt) {
      if (vt !== ce) {
        var bt = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw bt.name = "Invariant Violation", bt;
      }
    }
    we.isRequired = we;
    function Re() {
      return we;
    }
    var je = {
      array: we,
      bigint: we,
      bool: we,
      func: we,
      number: we,
      object: we,
      string: we,
      symbol: we,
      any: we,
      arrayOf: Re,
      element: we,
      elementType: we,
      instanceOf: Re,
      node: we,
      objectOf: Re,
      oneOf: Re,
      oneOfType: Re,
      shape: Re,
      exact: Re,
      checkPropTypes: me,
      resetWarningCache: ie
    };
    return je.PropTypes = je, je;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function ownKeys$d(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread2$3(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$d(Object(me), !0).forEach(function(we) {
      _defineProperty$t(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$d(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _typeof$c(ce) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$c(ce);
}
function _defineProperty$t(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, {
    value: me,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ce[ie] = me, ce;
}
function _objectWithoutPropertiesLoose$4(ce, ie) {
  if (ce == null) return {};
  var me = {}, we = Object.keys(ce), Re, je;
  for (je = 0; je < we.length; je++)
    Re = we[je], !(ie.indexOf(Re) >= 0) && (me[Re] = ce[Re]);
  return me;
}
function _objectWithoutProperties$7(ce, ie) {
  if (ce == null) return {};
  var me = _objectWithoutPropertiesLoose$4(ce, ie), we, Re;
  if (Object.getOwnPropertySymbols) {
    var je = Object.getOwnPropertySymbols(ce);
    for (Re = 0; Re < je.length; Re++)
      we = je[Re], !(ie.indexOf(we) >= 0) && Object.prototype.propertyIsEnumerable.call(ce, we) && (me[we] = ce[we]);
  }
  return me;
}
function _toConsumableArray$2(ce) {
  return _arrayWithoutHoles$2(ce) || _iterableToArray$2(ce) || _unsupportedIterableToArray$a(ce) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(ce) {
  if (Array.isArray(ce)) return _arrayLikeToArray$a(ce);
}
function _iterableToArray$2(ce) {
  if (typeof Symbol < "u" && ce[Symbol.iterator] != null || ce["@@iterator"] != null) return Array.from(ce);
}
function _unsupportedIterableToArray$a(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$a(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$a(ce, ie);
  }
}
function _arrayLikeToArray$a(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++) we[me] = ce[me];
  return we;
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function classList(ce) {
  var ie, me = ce.beat, we = ce.fade, Re = ce.beatFade, je = ce.bounce, Ue = ce.shake, qe = ce.flash, Ge = ce.spin, Xe = ce.spinPulse, ot = ce.spinReverse, vt = ce.pulse, bt = ce.fixedWidth, Tt = ce.inverse, wt = ce.border, St = ce.listItem, It = ce.flip, Pt = ce.size, kt = ce.rotation, Ot = ce.pull, Jr = (ie = {
    "fa-beat": me,
    "fa-fade": we,
    "fa-beat-fade": Re,
    "fa-bounce": je,
    "fa-shake": Ue,
    "fa-flash": qe,
    "fa-spin": Ge,
    "fa-spin-reverse": ot,
    "fa-spin-pulse": Xe,
    "fa-pulse": vt,
    "fa-fw": bt,
    "fa-inverse": Tt,
    "fa-border": wt,
    "fa-li": St,
    "fa-flip": It === !0,
    "fa-flip-horizontal": It === "horizontal" || It === "both",
    "fa-flip-vertical": It === "vertical" || It === "both"
  }, _defineProperty$t(ie, "fa-".concat(Pt), typeof Pt < "u" && Pt !== null), _defineProperty$t(ie, "fa-rotate-".concat(kt), typeof kt < "u" && kt !== null && kt !== 0), _defineProperty$t(ie, "fa-pull-".concat(Ot), typeof Ot < "u" && Ot !== null), _defineProperty$t(ie, "fa-swap-opacity", ce.swapOpacity), ie);
  return Object.keys(Jr).map(function(en) {
    return Jr[en] ? en : null;
  }).filter(function(en) {
    return en;
  });
}
function _isNumerical(ce) {
  return ce = ce - 0, ce === ce;
}
function camelize(ce) {
  return _isNumerical(ce) ? ce : (ce = ce.replace(/[\-_\s]+(.)?/g, function(ie, me) {
    return me ? me.toUpperCase() : "";
  }), ce.substr(0, 1).toLowerCase() + ce.substr(1));
}
var _excluded$i = ["style"];
function capitalize(ce) {
  return ce.charAt(0).toUpperCase() + ce.slice(1);
}
function styleToObject(ce) {
  return ce.split(";").map(function(ie) {
    return ie.trim();
  }).filter(function(ie) {
    return ie;
  }).reduce(function(ie, me) {
    var we = me.indexOf(":"), Re = camelize(me.slice(0, we)), je = me.slice(we + 1).trim();
    return Re.startsWith("webkit") ? ie[capitalize(Re)] = je : ie[Re] = je, ie;
  }, {});
}
function convert(ce, ie) {
  var me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof ie == "string")
    return ie;
  var we = (ie.children || []).map(function(Ge) {
    return convert(ce, Ge);
  }), Re = Object.keys(ie.attributes || {}).reduce(function(Ge, Xe) {
    var ot = ie.attributes[Xe];
    switch (Xe) {
      case "class":
        Ge.attrs.className = ot, delete ie.attributes.class;
        break;
      case "style":
        Ge.attrs.style = styleToObject(ot);
        break;
      default:
        Xe.indexOf("aria-") === 0 || Xe.indexOf("data-") === 0 ? Ge.attrs[Xe.toLowerCase()] = ot : Ge.attrs[camelize(Xe)] = ot;
    }
    return Ge;
  }, {
    attrs: {}
  }), je = me.style, Ue = je === void 0 ? {} : je, qe = _objectWithoutProperties$7(me, _excluded$i);
  return Re.attrs.style = _objectSpread2$3(_objectSpread2$3({}, Re.attrs.style), Ue), ce.apply(void 0, [ie.tag, _objectSpread2$3(_objectSpread2$3({}, Re.attrs), qe)].concat(_toConsumableArray$2(we)));
}
var PRODUCTION = !1;
try {
  PRODUCTION = process.env.NODE_ENV === "production";
} catch {
}
function log() {
  if (!PRODUCTION && console && typeof console.error == "function") {
    var ce;
    (ce = console).error.apply(ce, arguments);
  }
}
function normalizeIconArgs(ce) {
  if (ce && _typeof$c(ce) === "object" && ce.prefix && ce.iconName && ce.icon)
    return ce;
  if (parse$1.icon)
    return parse$1.icon(ce);
  if (ce === null)
    return null;
  if (ce && _typeof$c(ce) === "object" && ce.prefix && ce.iconName)
    return ce;
  if (Array.isArray(ce) && ce.length === 2)
    return {
      prefix: ce[0],
      iconName: ce[1]
    };
  if (typeof ce == "string")
    return {
      prefix: "fas",
      iconName: ce
    };
}
function objectWithKey(ce, ie) {
  return Array.isArray(ie) && ie.length > 0 || !Array.isArray(ie) && ie ? _defineProperty$t({}, ce, ie) : {};
}
var defaultProps$1 = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, FontAwesomeIcon = /* @__PURE__ */ React__default.forwardRef(function(ce, ie) {
  var me = _objectSpread2$3(_objectSpread2$3({}, defaultProps$1), ce), we = me.icon, Re = me.mask, je = me.symbol, Ue = me.className, qe = me.title, Ge = me.titleId, Xe = me.maskId, ot = normalizeIconArgs(we), vt = objectWithKey("classes", [].concat(_toConsumableArray$2(classList(me)), _toConsumableArray$2((Ue || "").split(" ")))), bt = objectWithKey("transform", typeof me.transform == "string" ? parse$1.transform(me.transform) : me.transform), Tt = objectWithKey("mask", normalizeIconArgs(Re)), wt = icon(ot, _objectSpread2$3(_objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, vt), bt), Tt), {}, {
    symbol: je,
    title: qe,
    titleId: Ge,
    maskId: Xe
  }));
  if (!wt)
    return log("Could not find icon", ot), null;
  var St = wt.abstract, It = {
    ref: ie
  };
  return Object.keys(me).forEach(function(Pt) {
    defaultProps$1.hasOwnProperty(Pt) || (It[Pt] = me[Pt]);
  }), convertCurry(St[0], It);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  beatFade: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
var convertCurry = convert.bind(null, React__default.createElement), classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(ce) {
  (function() {
    var ie = {}.hasOwnProperty;
    function me() {
      for (var je = "", Ue = 0; Ue < arguments.length; Ue++) {
        var qe = arguments[Ue];
        qe && (je = Re(je, we(qe)));
      }
      return je;
    }
    function we(je) {
      if (typeof je == "string" || typeof je == "number")
        return je;
      if (typeof je != "object")
        return "";
      if (Array.isArray(je))
        return me.apply(null, je);
      if (je.toString !== Object.prototype.toString && !je.toString.toString().includes("[native code]"))
        return je.toString();
      var Ue = "";
      for (var qe in je)
        ie.call(je, qe) && je[qe] && (Ue = Re(Ue, qe));
      return Ue;
    }
    function Re(je, Ue) {
      return Ue ? je ? je + " " + Ue : je + Ue : je;
    }
    ce.exports ? (me.default = me, ce.exports = me) : window.classNames = me;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports), RotateToClassname = {
  0: "",
  180: "rotate-180",
  270: "rotate-270",
  90: "rotate-90"
}, Icon = ({ rotate: ce = "0", ...ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("flex justify-center items-center h-4"), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie.icon, className: classNames("h-2.5", RotateToClassname[ce]) }) }), Action = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cursor-pointer p-2 w-fit text-grey-400", onClick: ce.onClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: ce.icon }) }), AnimatedBackground = React__default.forwardRef(
  ({ className: ce, paused: ie, children: me }, we) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: we,
      className: classNames(ce, "animated-background", { "animated-background--paused": ie }),
      children: me
    }
  )
), SPOTLIGHT_OFFSET = 8, BackdropOverlay = ({ refForSpotlight: ce }) => {
  const [ie, me] = useState(), we = () => {
    ce != null && ce.current && me(ce.current.getBoundingClientRect());
  };
  return useLayoutEffect$2(() => {
    if (ce != null && ce.current)
      return we(), window.addEventListener("resize", we), () => window.removeEventListener("resize", we);
  }, [ce]), ReactDOM__default.createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fixed inset-0 bg-overlay mix-blend-hard-light z-50", children: ie && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "absolute bg-[grey] rounded-md",
        style: {
          top: `${ie.top - SPOTLIGHT_OFFSET}px`,
          left: `${ie.left - SPOTLIGHT_OFFSET}px`,
          width: `${ie.width + SPOTLIGHT_OFFSET * 2}px`,
          height: `${ie.height + SPOTLIGHT_OFFSET * 2}px`
        }
      }
    ) }),
    document.body
  );
}, Badge = (ce) => {
  const ie = !!ce.badgeContent, me = ce.showZero || ie;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
    ce.children,
    me && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute -bottom-0.7 -right-0.7 bg-red-600 w-3 h-3 border-rd-24 text-white flex justify-center items-center text-xxs font-700", children: ce.badgeContent })
  ] });
};
var ButtonVariant = /* @__PURE__ */ ((ce) => (ce.PRIMARY = "primary", ce.SECONDARY = "secondary", ce.TEXT = "text", ce.SUCCESS = "success", ce.DANGER = "danger", ce.BLUE = "blue", ce))(ButtonVariant || {});
const VariantToDefault = {
  primary: "text-black bg-yellow-600 ",
  blue: "text-white bg-blue-500",
  danger: "text-white bg-red-500",
  // was 600
  secondary: "dark:text-white light:text-black bg-background border border-stroke",
  success: "text-white bg-green-500",
  // was 600
  text: "dark:text-white light:text-black"
}, VariantToHover = {
  blue: "hover:bg-opacity-90 dark:hover:shadow-sm light:hover:shadow-xs",
  danger: "hover:bg-opacity-90 dark:hover:shadow-sm light:hover:shadow-xs",
  primary: "hover:bg-opacity-90 dark:hover:shadow-sm light:hover:shadow-xs",
  secondary: "hover:bg-opacity-90 dark:hover:shadow-sm light:hover:shadow-xs",
  success: "hover:bg-opacity-90 dark:hover:shadow-sm light:hover:shadow-xs",
  text: "hover:opacity-60"
}, VariantToPressed = {
  blue: "active:bg-opacity-100",
  danger: "active:bg-opacity-100",
  primary: "active:bg-opacity-100",
  secondary: "active:bg-opacity-100",
  success: "active:bg-opacity-100",
  text: "active:opacity-100"
}, VariantToDisabled = {
  blue: "text-opacity-50! bg-opacity-50!",
  danger: "text-opacity-50! bg-opacity-50!",
  primary: "text-opacity-50! bg-opacity-50!",
  secondary: "text-opacity-50! bg-opacity-50!",
  success: "text-opacity-50! bg-opacity-50!",
  text: "opacity-40!"
}, Button = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    onClick: (ie) => {
      var me;
      ce.disabled || (me = ce.onClick) == null || me.call(ce, ie);
    },
    className: classNames(
      ce.overrideTheme,
      "inline-flex gap-2 px-3 py-2 justify-center items-center font-semibold text-xs h-fit max-w-full",
      "transition duration-150 ease-out hover:ease-in rounded-lg select-none relative",
      ce.fullWidth ? "w-full" : "w-fit",
      [VariantToDefault[ce.variant]],
      {
        [VariantToHover[ce.variant]]: !ce.disabled,
        [VariantToPressed[ce.variant]]: !ce.disabled,
        [VariantToDisabled[ce.variant]]: ce.disabled,
        "hover:cursor-pointer": !ce.disabled,
        "hover:cursor-default": ce.disabled,
        "active:shadow-none": !ce.disabled,
        "pointer-events-none": ce.onClick === void 0
      }
    ),
    children: [
      ce.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: ce.icon }),
      ce.children && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-overflow-ellipsis", children: ce.children }),
      ce.variant !== "text" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute bg-background w-full h-full rounded-lg z--1" })
    ]
  }
), Checkbox = ({ label: ce, onClick: ie, value: me, disabled: we, big: Re }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: classNames("component-checkbox", {
      "component-checkbox--disabled": we,
      "component-checkbox--big": Re
    }),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          className: "component-checkbox__input",
          type: "checkbox",
          checked: me,
          onChange: ie,
          disabled: we
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "1", onClick: ie }),
      ce && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("label", { className: "component-checkbox__label", htmlFor: "1", onClick: ie, children: ce }) })
    ]
  }
);
var faFileLines = {
  prefix: "fas",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, faFileAlt = faFileLines, faCircleExclamation$1 = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, faExclamationCircle$1 = faCircleExclamation$1, faImage = {
  prefix: "fas",
  iconName: "image",
  icon: [512, 512, [], "f03e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
}, faRotateLeft = {
  prefix: "fas",
  iconName: "rotate-left",
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
}, faUndoAlt = faRotateLeft, faPause = {
  prefix: "fas",
  iconName: "pause",
  icon: [320, 512, [9208], "f04c", "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"]
}, faLockKeyhole = {
  prefix: "fas",
  iconName: "lock-keyhole",
  icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
}, faLockAlt = faLockKeyhole, faCircleQuestion = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, faRotateRight = {
  prefix: "fas",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
}, faRedoAlt = faRotateRight, faEllipsis = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
}, faEllipsisH = faEllipsis, faPlay = {
  prefix: "fas",
  iconName: "play",
  icon: [384, 512, [9654], "f04b", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]
}, faPlus$1 = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
}, faXmark$2 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, faTimes$1 = faXmark$2, faChevronLeft = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, faChevronRight = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, faBook = {
  prefix: "fas",
  iconName: "book",
  icon: [448, 512, [128212], "f02d", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, faTriangleExclamation$1 = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, faWarning = faTriangleExclamation$1;
function Popup$2(ce) {
  var ie = ce.children, me = ce.prefixCls, we = ce.id, Re = ce.overlayInnerStyle, je = ce.bodyClassName, Ue = ce.className, qe = ce.style;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(me, "-content"), Ue),
    style: qe
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(me, "-inner"), je),
    id: we,
    role: "tooltip",
    style: Re
  }, typeof ie == "function" ? ie() : ie));
}
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(ce) {
    for (var ie = 1; ie < arguments.length; ie++) {
      var me = arguments[ie];
      for (var we in me) ({}).hasOwnProperty.call(me, we) && (ce[we] = me[we]);
    }
    return ce;
  }, _extends$j.apply(null, arguments);
}
function _typeof$b(ce) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$b(ce);
}
function toPrimitive(ce, ie) {
  if (_typeof$b(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$b(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ie === "string" ? String : Number)(ce);
}
function toPropertyKey(ce) {
  var ie = toPrimitive(ce, "string");
  return _typeof$b(ie) == "symbol" ? ie : ie + "";
}
function _defineProperty$s(ce, ie, me) {
  return (ie = toPropertyKey(ie)) in ce ? Object.defineProperty(ce, ie, {
    value: me,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ce[ie] = me, ce;
}
function ownKeys$c(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread2$2(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$c(Object(me), !0).forEach(function(we) {
      _defineProperty$s(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$c(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _objectWithoutPropertiesLoose$3(ce, ie) {
  if (ce == null) return {};
  var me = {};
  for (var we in ce) if ({}.hasOwnProperty.call(ce, we)) {
    if (ie.indexOf(we) !== -1) continue;
    me[we] = ce[we];
  }
  return me;
}
function _objectWithoutProperties$6(ce, ie) {
  if (ce == null) return {};
  var me, we, Re = _objectWithoutPropertiesLoose$3(ce, ie);
  if (Object.getOwnPropertySymbols) {
    var je = Object.getOwnPropertySymbols(ce);
    for (we = 0; we < je.length; we++) me = je[we], ie.indexOf(me) === -1 && {}.propertyIsEnumerable.call(ce, me) && (Re[me] = ce[me]);
  }
  return Re;
}
function _arrayWithHoles$8(ce) {
  if (Array.isArray(ce)) return ce;
}
function _iterableToArrayLimit$8(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we, Re, je, Ue, qe = [], Ge = !0, Xe = !1;
    try {
      if (je = (me = me.call(ce)).next, ie === 0) {
        if (Object(me) !== me) return;
        Ge = !1;
      } else for (; !(Ge = (we = je.call(me)).done) && (qe.push(we.value), qe.length !== ie); Ge = !0) ;
    } catch (ot) {
      Xe = !0, Re = ot;
    } finally {
      try {
        if (!Ge && me.return != null && (Ue = me.return(), Object(Ue) !== Ue)) return;
      } finally {
        if (Xe) throw Re;
      }
    }
    return qe;
  }
}
function _arrayLikeToArray$9(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = Array(ie); me < ie; me++) we[me] = ce[me];
  return we;
}
function _unsupportedIterableToArray$9(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$9(ce, ie);
    var me = {}.toString.call(ce).slice(8, -1);
    return me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set" ? Array.from(ce) : me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me) ? _arrayLikeToArray$9(ce, ie) : void 0;
  }
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$8(ce, ie) {
  return _arrayWithHoles$8(ce) || _iterableToArrayLimit$8(ce, ie) || _unsupportedIterableToArray$9(ce, ie) || _nonIterableRest$8();
}
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var warned = {}, preWarningFns = [], preMessage = function(ie) {
  preWarningFns.push(ie);
};
function warning$1(ce, ie) {
  if (process.env.NODE_ENV !== "production" && !ce && console !== void 0) {
    var me = preWarningFns.reduce(function(we, Re) {
      return Re(we ?? "", "warning");
    }, ie);
    me && console.error("Warning: ".concat(me));
  }
}
function note(ce, ie) {
  if (process.env.NODE_ENV !== "production" && !ce && console !== void 0) {
    var me = preWarningFns.reduce(function(we, Re) {
      return Re(we ?? "", "note");
    }, ie);
    me && console.warn("Note: ".concat(me));
  }
}
function resetWarned() {
  warned = {};
}
function call(ce, ie, me) {
  !ie && !warned[me] && (ce(!1, me), warned[me] = !0);
}
function warningOnce(ce, ie) {
  call(warning$1, ce, ie);
}
function noteOnce(ce, ie) {
  call(note, ce, ie);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var ce = Symbol.for("react.element"), ie = Symbol.for("react.portal"), me = Symbol.for("react.fragment"), we = Symbol.for("react.strict_mode"), Re = Symbol.for("react.profiler"), je = Symbol.for("react.provider"), Ue = Symbol.for("react.context"), qe = Symbol.for("react.server_context"), Ge = Symbol.for("react.forward_ref"), Xe = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), vt = Symbol.for("react.memo"), bt = Symbol.for("react.lazy"), Tt = Symbol.for("react.offscreen"), wt;
  wt = Symbol.for("react.module.reference");
  function St(It) {
    if (typeof It == "object" && It !== null) {
      var Pt = It.$$typeof;
      switch (Pt) {
        case ce:
          switch (It = It.type, It) {
            case me:
            case Re:
            case we:
            case Xe:
            case ot:
              return It;
            default:
              switch (It = It && It.$$typeof, It) {
                case qe:
                case Ue:
                case Ge:
                case bt:
                case vt:
                case je:
                  return It;
                default:
                  return Pt;
              }
          }
        case ie:
          return Pt;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = Ue, reactIs_production_min.ContextProvider = je, reactIs_production_min.Element = ce, reactIs_production_min.ForwardRef = Ge, reactIs_production_min.Fragment = me, reactIs_production_min.Lazy = bt, reactIs_production_min.Memo = vt, reactIs_production_min.Portal = ie, reactIs_production_min.Profiler = Re, reactIs_production_min.StrictMode = we, reactIs_production_min.Suspense = Xe, reactIs_production_min.SuspenseList = ot, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(It) {
    return St(It) === Ue;
  }, reactIs_production_min.isContextProvider = function(It) {
    return St(It) === je;
  }, reactIs_production_min.isElement = function(It) {
    return typeof It == "object" && It !== null && It.$$typeof === ce;
  }, reactIs_production_min.isForwardRef = function(It) {
    return St(It) === Ge;
  }, reactIs_production_min.isFragment = function(It) {
    return St(It) === me;
  }, reactIs_production_min.isLazy = function(It) {
    return St(It) === bt;
  }, reactIs_production_min.isMemo = function(It) {
    return St(It) === vt;
  }, reactIs_production_min.isPortal = function(It) {
    return St(It) === ie;
  }, reactIs_production_min.isProfiler = function(It) {
    return St(It) === Re;
  }, reactIs_production_min.isStrictMode = function(It) {
    return St(It) === we;
  }, reactIs_production_min.isSuspense = function(It) {
    return St(It) === Xe;
  }, reactIs_production_min.isSuspenseList = function(It) {
    return St(It) === ot;
  }, reactIs_production_min.isValidElementType = function(It) {
    return typeof It == "string" || typeof It == "function" || It === me || It === Re || It === we || It === Xe || It === ot || It === Tt || typeof It == "object" && It !== null && (It.$$typeof === bt || It.$$typeof === vt || It.$$typeof === je || It.$$typeof === Ue || It.$$typeof === Ge || It.$$typeof === wt || It.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = St, reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var ce = Symbol.for("react.element"), ie = Symbol.for("react.portal"), me = Symbol.for("react.fragment"), we = Symbol.for("react.strict_mode"), Re = Symbol.for("react.profiler"), je = Symbol.for("react.provider"), Ue = Symbol.for("react.context"), qe = Symbol.for("react.server_context"), Ge = Symbol.for("react.forward_ref"), Xe = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), vt = Symbol.for("react.memo"), bt = Symbol.for("react.lazy"), Tt = Symbol.for("react.offscreen"), wt = !1, St = !1, It = !1, Pt = !1, kt = !1, Ot;
    Ot = Symbol.for("react.module.reference");
    function Jr(ni) {
      return !!(typeof ni == "string" || typeof ni == "function" || ni === me || ni === Re || kt || ni === we || ni === Xe || ni === ot || Pt || ni === Tt || wt || St || It || typeof ni == "object" && ni !== null && (ni.$$typeof === bt || ni.$$typeof === vt || ni.$$typeof === je || ni.$$typeof === Ue || ni.$$typeof === Ge || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ni.$$typeof === Ot || ni.getModuleId !== void 0));
    }
    function en(ni) {
      if (typeof ni == "object" && ni !== null) {
        var Ui = ni.$$typeof;
        switch (Ui) {
          case ce:
            var ja = ni.type;
            switch (ja) {
              case me:
              case Re:
              case we:
              case Xe:
              case ot:
                return ja;
              default:
                var Ga = ja && ja.$$typeof;
                switch (Ga) {
                  case qe:
                  case Ue:
                  case Ge:
                  case bt:
                  case vt:
                  case je:
                    return Ga;
                  default:
                    return Ui;
                }
            }
          case ie:
            return Ui;
        }
      }
    }
    var nn = Ue, ln = je, fn = ce, vn = Ge, Tn = me, xn = bt, bn = vt, Sn = ie, Cn = Re, kn = we, cn = Xe, gn = ot, an = !1, un = !1;
    function pn(ni) {
      return an || (an = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function hn(ni) {
      return un || (un = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function An(ni) {
      return en(ni) === Ue;
    }
    function In(ni) {
      return en(ni) === je;
    }
    function qn(ni) {
      return typeof ni == "object" && ni !== null && ni.$$typeof === ce;
    }
    function si(ni) {
      return en(ni) === Ge;
    }
    function bi(ni) {
      return en(ni) === me;
    }
    function xi(ni) {
      return en(ni) === bt;
    }
    function ji(ni) {
      return en(ni) === vt;
    }
    function zi(ni) {
      return en(ni) === ie;
    }
    function Vi(ni) {
      return en(ni) === Re;
    }
    function Hi(ni) {
      return en(ni) === we;
    }
    function ii(ni) {
      return en(ni) === Xe;
    }
    function Fi(ni) {
      return en(ni) === ot;
    }
    reactIs_development.ContextConsumer = nn, reactIs_development.ContextProvider = ln, reactIs_development.Element = fn, reactIs_development.ForwardRef = vn, reactIs_development.Fragment = Tn, reactIs_development.Lazy = xn, reactIs_development.Memo = bn, reactIs_development.Portal = Sn, reactIs_development.Profiler = Cn, reactIs_development.StrictMode = kn, reactIs_development.Suspense = cn, reactIs_development.SuspenseList = gn, reactIs_development.isAsyncMode = pn, reactIs_development.isConcurrentMode = hn, reactIs_development.isContextConsumer = An, reactIs_development.isContextProvider = In, reactIs_development.isElement = qn, reactIs_development.isForwardRef = si, reactIs_development.isFragment = bi, reactIs_development.isLazy = xi, reactIs_development.isMemo = ji, reactIs_development.isPortal = zi, reactIs_development.isProfiler = Vi, reactIs_development.isStrictMode = Hi, reactIs_development.isSuspense = ii, reactIs_development.isSuspenseList = Fi, reactIs_development.isValidElementType = Jr, reactIs_development.typeOf = en;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports;
function useMemo(ce, ie, me) {
  var we = React.useRef({});
  return (!("value" in we.current) || me(we.current.condition, ie)) && (we.current.value = ce(), we.current.condition = ie), we.current.value;
}
var REACT_ELEMENT_TYPE_18 = Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function isFragment(ce) {
  return (
    // Base object type
    ce && _typeof$b(ce) === "object" && // React Element type
    (ce.$$typeof === REACT_ELEMENT_TYPE_18 || ce.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    ce.type === REACT_FRAGMENT_TYPE
  );
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function(ie, me) {
  typeof ie == "function" ? ie(me) : _typeof$b(ie) === "object" && ie && "current" in ie && (ie.current = me);
}, composeRef = function() {
  for (var ie = arguments.length, me = new Array(ie), we = 0; we < ie; we++)
    me[we] = arguments[we];
  var Re = me.filter(Boolean);
  return Re.length <= 1 ? Re[0] : function(je) {
    me.forEach(function(Ue) {
      fillRef(Ue, je);
    });
  };
}, useComposeRef = function() {
  for (var ie = arguments.length, me = new Array(ie), we = 0; we < ie; we++)
    me[we] = arguments[we];
  return useMemo(function() {
    return composeRef.apply(void 0, me);
  }, me, function(Re, je) {
    return Re.length !== je.length || Re.every(function(Ue, qe) {
      return Ue !== je[qe];
    });
  });
}, supportRef = function(ie) {
  var me, we;
  if (!ie)
    return !1;
  if (isReactElement(ie) && ReactMajorVersion >= 19)
    return !0;
  var Re = reactIsExports.isMemo(ie) ? ie.type.type : ie.type;
  return !(typeof Re == "function" && !((me = Re.prototype) !== null && me !== void 0 && me.render) && Re.$$typeof !== reactIsExports.ForwardRef || typeof ie == "function" && !((we = ie.prototype) !== null && we !== void 0 && we.render) && ie.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(ce) {
  return /* @__PURE__ */ isValidElement(ce) && !isFragment(ce);
}
var getNodeRef = function(ie) {
  if (ie && isReactElement(ie)) {
    var me = ie;
    return me.props.propertyIsEnumerable("ref") ? me.props.ref : me.ref;
  }
  return null;
}, OrderContext = /* @__PURE__ */ React.createContext(null);
function _arrayWithoutHoles$1(ce) {
  if (Array.isArray(ce)) return _arrayLikeToArray$9(ce);
}
function _iterableToArray$1(ce) {
  if (typeof Symbol < "u" && ce[Symbol.iterator] != null || ce["@@iterator"] != null) return Array.from(ce);
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$1(ce) {
  return _arrayWithoutHoles$1(ce) || _iterableToArray$1(ce) || _unsupportedIterableToArray$9(ce) || _nonIterableSpread$1();
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect$1 = function(ie, me) {
  var we = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return ie(we.current);
  }, me), useInternalLayoutEffect(function() {
    return we.current = !1, function() {
      we.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function(ie, me) {
  useLayoutEffect$1(function(we) {
    if (!we)
      return ie();
  }, me);
}, EMPTY_LIST = [];
function useDom(ce, ie) {
  var me = React.useState(function() {
    if (!canUseDom())
      return null;
    var wt = document.createElement("div");
    return process.env.NODE_ENV !== "production" && ie && wt.setAttribute("data-debug", ie), wt;
  }), we = _slicedToArray$8(me, 1), Re = we[0], je = React.useRef(!1), Ue = React.useContext(OrderContext), qe = React.useState(EMPTY_LIST), Ge = _slicedToArray$8(qe, 2), Xe = Ge[0], ot = Ge[1], vt = Ue || (je.current ? void 0 : function(wt) {
    ot(function(St) {
      var It = [wt].concat(_toConsumableArray$1(St));
      return It;
    });
  });
  function bt() {
    Re.parentElement || document.body.appendChild(Re), je.current = !0;
  }
  function Tt() {
    var wt;
    (wt = Re.parentElement) === null || wt === void 0 || wt.removeChild(Re), je.current = !1;
  }
  return useLayoutEffect$1(function() {
    return ce ? Ue ? Ue(bt) : bt() : Tt(), Tt;
  }, [ce]), useLayoutEffect$1(function() {
    Xe.length && (Xe.forEach(function(wt) {
      return wt();
    }), ot(EMPTY_LIST));
  }, [Xe]), [Re, vt];
}
function contains(ce, ie) {
  if (!ce)
    return !1;
  if (ce.contains)
    return ce.contains(ie);
  for (var me = ie; me; ) {
    if (me === ce)
      return !0;
    me = me.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ie = ce.mark;
  return ie ? ie.startsWith("data-") ? ie : "data-".concat(ie) : MARK_KEY;
}
function getContainer(ce) {
  if (ce.attachTo)
    return ce.attachTo;
  var ie = document.querySelector("head");
  return ie || document.body;
}
function getOrder(ce) {
  return ce === "queue" ? "prependQueue" : ce ? "prepend" : "append";
}
function findStyles(ce) {
  return Array.from((containerCache.get(ce) || ce).children).filter(function(ie) {
    return ie.tagName === "STYLE";
  });
}
function injectCSS(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom())
    return null;
  var me = ie.csp, we = ie.prepend, Re = ie.priority, je = Re === void 0 ? 0 : Re, Ue = getOrder(we), qe = Ue === "prependQueue", Ge = document.createElement("style");
  Ge.setAttribute(APPEND_ORDER, Ue), qe && je && Ge.setAttribute(APPEND_PRIORITY, "".concat(je)), me != null && me.nonce && (Ge.nonce = me == null ? void 0 : me.nonce), Ge.innerHTML = ce;
  var Xe = getContainer(ie), ot = Xe.firstChild;
  if (we) {
    if (qe) {
      var vt = (ie.styles || findStyles(Xe)).filter(function(bt) {
        if (!["prepend", "prependQueue"].includes(bt.getAttribute(APPEND_ORDER)))
          return !1;
        var Tt = Number(bt.getAttribute(APPEND_PRIORITY) || 0);
        return je >= Tt;
      });
      if (vt.length)
        return Xe.insertBefore(Ge, vt[vt.length - 1].nextSibling), Ge;
    }
    Xe.insertBefore(Ge, ot);
  } else
    Xe.appendChild(Ge);
  return Ge;
}
function findExistNode(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = getContainer(ie);
  return (ie.styles || findStyles(me)).find(function(we) {
    return we.getAttribute(getMark(ie)) === ce;
  });
}
function removeCSS(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = findExistNode(ce, ie);
  if (me) {
    var we = getContainer(ie);
    we.removeChild(me);
  }
}
function syncRealContainer(ce, ie) {
  var me = containerCache.get(ce);
  if (!me || !contains(document, me)) {
    var we = injectCSS("", ie), Re = we.parentNode;
    containerCache.set(ce, Re), ce.removeChild(we);
  }
}
function updateCSS(ce, ie) {
  var me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = getContainer(me), Re = findStyles(we), je = _objectSpread2$2(_objectSpread2$2({}, me), {}, {
    styles: Re
  });
  syncRealContainer(we, je);
  var Ue = findExistNode(ie, je);
  if (Ue) {
    var qe, Ge;
    if ((qe = je.csp) !== null && qe !== void 0 && qe.nonce && Ue.nonce !== ((Ge = je.csp) === null || Ge === void 0 ? void 0 : Ge.nonce)) {
      var Xe;
      Ue.nonce = (Xe = je.csp) === null || Xe === void 0 ? void 0 : Xe.nonce;
    }
    return Ue.innerHTML !== ce && (Ue.innerHTML = ce), Ue;
  }
  var ot = injectCSS(ce, je);
  return ot.setAttribute(getMark(je), ie), ot;
}
function measureScrollbarSize(ce) {
  var ie = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), me = document.createElement("div");
  me.id = ie;
  var we = me.style;
  we.position = "absolute", we.left = "0", we.top = "0", we.width = "100px", we.height = "100px", we.overflow = "scroll";
  var Re, je;
  if (ce) {
    var Ue = getComputedStyle(ce);
    we.scrollbarColor = Ue.scrollbarColor, we.scrollbarWidth = Ue.scrollbarWidth;
    var qe = getComputedStyle(ce, "::-webkit-scrollbar"), Ge = parseInt(qe.width, 10), Xe = parseInt(qe.height, 10);
    try {
      var ot = Ge ? "width: ".concat(qe.width, ";") : "", vt = Xe ? "height: ".concat(qe.height, ";") : "";
      updateCSS(`
#`.concat(ie, `::-webkit-scrollbar {
`).concat(ot, `
`).concat(vt, `
}`), ie);
    } catch (wt) {
      console.error(wt), Re = Ge, je = Xe;
    }
  }
  document.body.appendChild(me);
  var bt = ce && Re && !isNaN(Re) ? Re : me.offsetWidth - me.clientWidth, Tt = ce && je && !isNaN(je) ? je : me.offsetHeight - me.clientHeight;
  return document.body.removeChild(me), removeCSS(ie), {
    width: bt,
    height: Tt
  };
}
function getTargetScrollBarSize(ce) {
  return typeof document > "u" || !ce || !(ce instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(ce);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$3 = 0;
function useScrollLocker(ce) {
  var ie = !!ce, me = React.useState(function() {
    return uuid$3 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$3);
  }), we = _slicedToArray$8(me, 1), Re = we[0];
  useLayoutEffect$1(function() {
    if (ie) {
      var je = getTargetScrollBarSize(document.body).width, Ue = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(Ue ? "width: calc(100% - ".concat(je, "px);") : "", `
}`), Re);
    } else
      removeCSS(Re);
    return function() {
      removeCSS(Re);
    };
  }, [ie, Re]);
}
var inline = !1;
function inlineMock(ce) {
  return inline;
}
var getPortalContainer = function(ie) {
  return ie === !1 ? !1 : !canUseDom() || !ie ? null : typeof ie == "string" ? document.querySelector(ie) : typeof ie == "function" ? ie() : ie;
}, Portal$1 = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.open, we = ce.autoLock, Re = ce.getContainer, je = ce.debug, Ue = ce.autoDestroy, qe = Ue === void 0 ? !0 : Ue, Ge = ce.children, Xe = React.useState(me), ot = _slicedToArray$8(Xe, 2), vt = ot[0], bt = ot[1], Tt = vt || me;
  process.env.NODE_ENV !== "production" && warningOnce(canUseDom() || !me, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), React.useEffect(function() {
    (qe || me) && bt(me);
  }, [me, qe]);
  var wt = React.useState(function() {
    return getPortalContainer(Re);
  }), St = _slicedToArray$8(wt, 2), It = St[0], Pt = St[1];
  React.useEffect(function() {
    var bn = getPortalContainer(Re);
    Pt(bn ?? null);
  });
  var kt = useDom(Tt && !It, je), Ot = _slicedToArray$8(kt, 2), Jr = Ot[0], en = Ot[1], nn = It ?? Jr;
  useScrollLocker(we && me && canUseDom() && (nn === Jr || nn === document.body));
  var ln = null;
  if (Ge && supportRef(Ge) && ie) {
    var fn = Ge;
    ln = fn.ref;
  }
  var vn = useComposeRef(ln, ie);
  if (!Tt || !canUseDom() || It === void 0)
    return null;
  var Tn = nn === !1 || inlineMock(), xn = Ge;
  return ie && (xn = /* @__PURE__ */ React.cloneElement(Ge, {
    ref: vn
  })), /* @__PURE__ */ React.createElement(OrderContext.Provider, {
    value: en
  }, Tn ? xn : /* @__PURE__ */ createPortal(xn, nn));
});
process.env.NODE_ENV !== "production" && (Portal$1.displayName = "Portal");
function toArray$2(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = [];
  return React__default.Children.forEach(ce, function(we) {
    we == null && !ie.keepEmpty || (Array.isArray(we) ? me = me.concat(toArray$2(we)) : isFragment(we) && we.props ? me = me.concat(toArray$2(we.props.children, ie)) : me.push(we));
  }), me;
}
function isDOM(ce) {
  return ce instanceof HTMLElement || ce instanceof SVGElement;
}
function getDOM(ce) {
  return ce && _typeof$b(ce) === "object" && isDOM(ce.nativeElement) ? ce.nativeElement : isDOM(ce) ? ce : null;
}
function findDOMNode(ce) {
  var ie = getDOM(ce);
  if (ie)
    return ie;
  if (ce instanceof React__default.Component) {
    var me;
    return (me = ReactDOM__default.findDOMNode) === null || me === void 0 ? void 0 : me.call(ReactDOM__default, ce);
  }
  return null;
}
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(ce) {
  var ie = ce.children, me = ce.onBatchResize, we = React.useRef(0), Re = React.useRef([]), je = React.useContext(CollectionContext), Ue = React.useCallback(function(qe, Ge, Xe) {
    we.current += 1;
    var ot = we.current;
    Re.current.push({
      size: qe,
      element: Ge,
      data: Xe
    }), Promise.resolve().then(function() {
      ot === we.current && (me == null || me(Re.current), Re.current = []);
    }), je == null || je(qe, Ge, Xe);
  }, [me, je]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: Ue
  }, ie);
}
var MapShim = function() {
  if (typeof Map < "u")
    return Map;
  function ce(ie, me) {
    var we = -1;
    return ie.some(function(Re, je) {
      return Re[0] === me ? (we = je, !0) : !1;
    }), we;
  }
  return (
    /** @class */
    function() {
      function ie() {
        this.__entries__ = [];
      }
      return Object.defineProperty(ie.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), ie.prototype.get = function(me) {
        var we = ce(this.__entries__, me), Re = this.__entries__[we];
        return Re && Re[1];
      }, ie.prototype.set = function(me, we) {
        var Re = ce(this.__entries__, me);
        ~Re ? this.__entries__[Re][1] = we : this.__entries__.push([me, we]);
      }, ie.prototype.delete = function(me) {
        var we = this.__entries__, Re = ce(we, me);
        ~Re && we.splice(Re, 1);
      }, ie.prototype.has = function(me) {
        return !!~ce(this.__entries__, me);
      }, ie.prototype.clear = function() {
        this.__entries__.splice(0);
      }, ie.prototype.forEach = function(me, we) {
        we === void 0 && (we = null);
        for (var Re = 0, je = this.__entries__; Re < je.length; Re++) {
          var Ue = je[Re];
          me.call(we, Ue[1], Ue[0]);
        }
      }, ie;
    }()
  );
}(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), requestAnimationFrame$1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(ce) {
    return setTimeout(function() {
      return ce(Date.now());
    }, 1e3 / 60);
  };
}(), trailingTimeout = 2;
function throttle$1(ce, ie) {
  var me = !1, we = !1, Re = 0;
  function je() {
    me && (me = !1, ce()), we && qe();
  }
  function Ue() {
    requestAnimationFrame$1(je);
  }
  function qe() {
    var Ge = Date.now();
    if (me) {
      if (Ge - Re < trailingTimeout)
        return;
      we = !0;
    } else
      me = !0, we = !1, setTimeout(Ue, ie);
    Re = Ge;
  }
  return qe;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  function() {
    function ce() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    return ce.prototype.addObserver = function(ie) {
      ~this.observers_.indexOf(ie) || this.observers_.push(ie), this.connected_ || this.connect_();
    }, ce.prototype.removeObserver = function(ie) {
      var me = this.observers_, we = me.indexOf(ie);
      ~we && me.splice(we, 1), !me.length && this.connected_ && this.disconnect_();
    }, ce.prototype.refresh = function() {
      var ie = this.updateObservers_();
      ie && this.refresh();
    }, ce.prototype.updateObservers_ = function() {
      var ie = this.observers_.filter(function(me) {
        return me.gatherActive(), me.hasActive();
      });
      return ie.forEach(function(me) {
        return me.broadcastActive();
      }), ie.length > 0;
    }, ce.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, ce.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, ce.prototype.onTransitionEnd_ = function(ie) {
      var me = ie.propertyName, we = me === void 0 ? "" : me, Re = transitionKeys.some(function(je) {
        return !!~we.indexOf(je);
      });
      Re && this.refresh();
    }, ce.getInstance = function() {
      return this.instance_ || (this.instance_ = new ce()), this.instance_;
    }, ce.instance_ = null, ce;
  }()
), defineConfigurable = function(ce, ie) {
  for (var me = 0, we = Object.keys(ie); me < we.length; me++) {
    var Re = we[me];
    Object.defineProperty(ce, Re, {
      value: ie[Re],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return ce;
}, getWindowOf = function(ce) {
  var ie = ce && ce.ownerDocument && ce.ownerDocument.defaultView;
  return ie || global$1;
}, emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(ce) {
  return parseFloat(ce) || 0;
}
function getBordersSize(ce) {
  for (var ie = [], me = 1; me < arguments.length; me++)
    ie[me - 1] = arguments[me];
  return ie.reduce(function(we, Re) {
    var je = ce["border-" + Re + "-width"];
    return we + toFloat(je);
  }, 0);
}
function getPaddings(ce) {
  for (var ie = ["top", "right", "bottom", "left"], me = {}, we = 0, Re = ie; we < Re.length; we++) {
    var je = Re[we], Ue = ce["padding-" + je];
    me[je] = toFloat(Ue);
  }
  return me;
}
function getSVGContentRect(ce) {
  var ie = ce.getBBox();
  return createRectInit(0, 0, ie.width, ie.height);
}
function getHTMLElementContentRect(ce) {
  var ie = ce.clientWidth, me = ce.clientHeight;
  if (!ie && !me)
    return emptyRect;
  var we = getWindowOf(ce).getComputedStyle(ce), Re = getPaddings(we), je = Re.left + Re.right, Ue = Re.top + Re.bottom, qe = toFloat(we.width), Ge = toFloat(we.height);
  if (we.boxSizing === "border-box" && (Math.round(qe + je) !== ie && (qe -= getBordersSize(we, "left", "right") + je), Math.round(Ge + Ue) !== me && (Ge -= getBordersSize(we, "top", "bottom") + Ue)), !isDocumentElement(ce)) {
    var Xe = Math.round(qe + je) - ie, ot = Math.round(Ge + Ue) - me;
    Math.abs(Xe) !== 1 && (qe -= Xe), Math.abs(ot) !== 1 && (Ge -= ot);
  }
  return createRectInit(Re.left, Re.top, qe, Ge);
}
var isSVGGraphicsElement = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(ce) {
    return ce instanceof getWindowOf(ce).SVGGraphicsElement;
  } : function(ce) {
    return ce instanceof getWindowOf(ce).SVGElement && typeof ce.getBBox == "function";
  };
}();
function isDocumentElement(ce) {
  return ce === getWindowOf(ce).document.documentElement;
}
function getContentRect(ce) {
  return isBrowser ? isSVGGraphicsElement(ce) ? getSVGContentRect(ce) : getHTMLElementContentRect(ce) : emptyRect;
}
function createReadOnlyRect(ce) {
  var ie = ce.x, me = ce.y, we = ce.width, Re = ce.height, je = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, Ue = Object.create(je.prototype);
  return defineConfigurable(Ue, {
    x: ie,
    y: me,
    width: we,
    height: Re,
    top: me,
    right: ie + we,
    bottom: Re + me,
    left: ie
  }), Ue;
}
function createRectInit(ce, ie, me, we) {
  return { x: ce, y: ie, width: me, height: we };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ce(ie) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = ie;
    }
    return ce.prototype.isActive = function() {
      var ie = getContentRect(this.target);
      return this.contentRect_ = ie, ie.width !== this.broadcastWidth || ie.height !== this.broadcastHeight;
    }, ce.prototype.broadcastRect = function() {
      var ie = this.contentRect_;
      return this.broadcastWidth = ie.width, this.broadcastHeight = ie.height, ie;
    }, ce;
  }()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ce(ie, me) {
      var we = createReadOnlyRect(me);
      defineConfigurable(this, { target: ie, contentRect: we });
    }
    return ce;
  }()
), ResizeObserverSPI = (
  /** @class */
  function() {
    function ce(ie, me, we) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof ie != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = ie, this.controller_ = me, this.callbackCtx_ = we;
    }
    return ce.prototype.observe = function(ie) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(ie instanceof getWindowOf(ie).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var me = this.observations_;
        me.has(ie) || (me.set(ie, new ResizeObservation(ie)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, ce.prototype.unobserve = function(ie) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(ie instanceof getWindowOf(ie).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var me = this.observations_;
        me.has(ie) && (me.delete(ie), me.size || this.controller_.removeObserver(this));
      }
    }, ce.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, ce.prototype.gatherActive = function() {
      var ie = this;
      this.clearActive(), this.observations_.forEach(function(me) {
        me.isActive() && ie.activeObservations_.push(me);
      });
    }, ce.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var ie = this.callbackCtx_, me = this.activeObservations_.map(function(we) {
          return new ResizeObserverEntry(we.target, we.broadcastRect());
        });
        this.callback_.call(ie, me, ie), this.clearActive();
      }
    }, ce.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, ce.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, ce;
  }()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function ce(ie) {
      if (!(this instanceof ce))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var me = ResizeObserverController.getInstance(), we = new ResizeObserverSPI(ie, me, this);
      observers.set(this, we);
    }
    return ce;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(ce) {
  ResizeObserver$2.prototype[ce] = function() {
    var ie;
    return (ie = observers.get(this))[ce].apply(ie, arguments);
  };
});
var index = function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
}();
const ResizeObserver_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index
}, Symbol.toStringTag, { value: "Module" }));
var elementListeners = /* @__PURE__ */ new Map();
function onResize(ce) {
  ce.forEach(function(ie) {
    var me, we = ie.target;
    (me = elementListeners.get(we)) === null || me === void 0 || me.forEach(function(Re) {
      return Re(we);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(ce, ie) {
  elementListeners.has(ce) || (elementListeners.set(ce, /* @__PURE__ */ new Set()), resizeObserver.observe(ce)), elementListeners.get(ce).add(ie);
}
function unobserve(ce, ie) {
  elementListeners.has(ce) && (elementListeners.get(ce).delete(ie), elementListeners.get(ce).size || (resizeObserver.unobserve(ce), elementListeners.delete(ce)));
}
function _classCallCheck$t(ce, ie) {
  if (!(ce instanceof ie)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$i(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, toPropertyKey(we.key), we);
  }
}
function _createClass$r(ce, ie, me) {
  return ie && _defineProperties$i(ce.prototype, ie), me && _defineProperties$i(ce, me), Object.defineProperty(ce, "prototype", {
    writable: !1
  }), ce;
}
function _setPrototypeOf$4(ce, ie) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(me, we) {
    return me.__proto__ = we, me;
  }, _setPrototypeOf$4(ce, ie);
}
function _inherits$f(ce, ie) {
  if (typeof ie != "function" && ie !== null) throw new TypeError("Super expression must either be null or a function");
  ce.prototype = Object.create(ie && ie.prototype, {
    constructor: {
      value: ce,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(ce, "prototype", {
    writable: !1
  }), ie && _setPrototypeOf$4(ce, ie);
}
function _getPrototypeOf$4(ce) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ie) {
    return ie.__proto__ || Object.getPrototypeOf(ie);
  }, _getPrototypeOf$4(ce);
}
function _isNativeReflectConstruct$4() {
  try {
    var ce = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$4 = function() {
    return !!ce;
  })();
}
function _assertThisInitialized$4(ce) {
  if (ce === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ce;
}
function _possibleConstructorReturn$f(ce, ie) {
  if (ie && (_typeof$b(ie) == "object" || typeof ie == "function")) return ie;
  if (ie !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(ce);
}
function _createSuper$4(ce) {
  var ie = _isNativeReflectConstruct$4();
  return function() {
    var me, we = _getPrototypeOf$4(ce);
    if (ie) {
      var Re = _getPrototypeOf$4(this).constructor;
      me = Reflect.construct(we, arguments, Re);
    } else me = we.apply(this, arguments);
    return _possibleConstructorReturn$f(this, me);
  };
}
var DomWrapper$1 = /* @__PURE__ */ function(ce) {
  _inherits$f(me, ce);
  var ie = _createSuper$4(me);
  function me() {
    return _classCallCheck$t(this, me), ie.apply(this, arguments);
  }
  return _createClass$r(me, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), me;
}(React.Component);
function SingleObserver(ce, ie) {
  var me = ce.children, we = ce.disabled, Re = React.useRef(null), je = React.useRef(null), Ue = React.useContext(CollectionContext), qe = typeof me == "function", Ge = qe ? me(Re) : me, Xe = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), ot = !qe && /* @__PURE__ */ React.isValidElement(Ge) && supportRef(Ge), vt = ot ? getNodeRef(Ge) : null, bt = useComposeRef(vt, Re), Tt = function() {
    var Pt;
    return findDOMNode(Re.current) || // Support `nativeElement` format
    (Re.current && _typeof$b(Re.current) === "object" ? findDOMNode((Pt = Re.current) === null || Pt === void 0 ? void 0 : Pt.nativeElement) : null) || findDOMNode(je.current);
  };
  React.useImperativeHandle(ie, function() {
    return Tt();
  });
  var wt = React.useRef(ce);
  wt.current = ce;
  var St = React.useCallback(function(It) {
    var Pt = wt.current, kt = Pt.onResize, Ot = Pt.data, Jr = It.getBoundingClientRect(), en = Jr.width, nn = Jr.height, ln = It.offsetWidth, fn = It.offsetHeight, vn = Math.floor(en), Tn = Math.floor(nn);
    if (Xe.current.width !== vn || Xe.current.height !== Tn || Xe.current.offsetWidth !== ln || Xe.current.offsetHeight !== fn) {
      var xn = {
        width: vn,
        height: Tn,
        offsetWidth: ln,
        offsetHeight: fn
      };
      Xe.current = xn;
      var bn = ln === Math.round(en) ? en : ln, Sn = fn === Math.round(nn) ? nn : fn, Cn = _objectSpread2$2(_objectSpread2$2({}, xn), {}, {
        offsetWidth: bn,
        offsetHeight: Sn
      });
      Ue == null || Ue(Cn, It, Ot), kt && Promise.resolve().then(function() {
        kt(Cn, It);
      });
    }
  }, []);
  return React.useEffect(function() {
    var It = Tt();
    return It && !we && observe(It, St), function() {
      return unobserve(It, St);
    };
  }, [Re.current, we]), /* @__PURE__ */ React.createElement(DomWrapper$1, {
    ref: je
  }, ot ? /* @__PURE__ */ React.cloneElement(Ge, {
    ref: bt
  }) : Ge);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(ce, ie) {
  var me = ce.children, we = typeof me == "function" ? [me] : toArray$2(me);
  return process.env.NODE_ENV !== "production" && (we.length > 1 ? warning$1(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : we.length === 0 && warning$1(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), we.map(function(Re, je) {
    var Ue = (Re == null ? void 0 : Re.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(je);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$j({}, ce, {
      key: Ue,
      ref: je === 0 ? ie : void 0
    }), Re);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function getRoot(ce) {
  var ie;
  return ce == null || (ie = ce.getRootNode) === null || ie === void 0 ? void 0 : ie.call(ce);
}
function inShadow(ce) {
  return getRoot(ce) instanceof ShadowRoot;
}
function getShadowRoot(ce) {
  return inShadow(ce) ? getRoot(ce) : null;
}
function useEvent(ce) {
  var ie = React.useRef();
  ie.current = ce;
  var me = React.useCallback(function() {
    for (var we, Re = arguments.length, je = new Array(Re), Ue = 0; Ue < Re; Ue++)
      je[Ue] = arguments[Ue];
    return (we = ie.current) === null || we === void 0 ? void 0 : we.call.apply(we, [ie].concat(je));
  }, []);
  return me;
}
function getUseId() {
  var ce = _objectSpread2$2({}, React);
  return ce.useId;
}
var uuid$2 = 0, useOriginId = getUseId();
const useId$1 = useOriginId ? (
  // Use React `useId`
  function(ie) {
    var me = useOriginId();
    return ie || (process.env.NODE_ENV === "test" ? "test-id" : me);
  }
) : (
  // Use compatible of `useId`
  function(ie) {
    var me = React.useState("ssr-id"), we = _slicedToArray$8(me, 2), Re = we[0], je = we[1];
    return React.useEffect(function() {
      var Ue = uuid$2;
      uuid$2 += 1, je("rc_unique_".concat(Ue));
    }, []), ie || (process.env.NODE_ENV === "test" ? "test-id" : Re);
  }
), isMobile = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var ce = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ce) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ce == null ? void 0 : ce.substr(0, 4));
};
var Context$1 = /* @__PURE__ */ React.createContext({}), DomWrapper = /* @__PURE__ */ function(ce) {
  _inherits$f(me, ce);
  var ie = _createSuper$4(me);
  function me() {
    return _classCallCheck$t(this, me), ie.apply(this, arguments);
  }
  return _createClass$r(me, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), me;
}(React.Component);
function useSafeState(ce) {
  var ie = React.useRef(!1), me = React.useState(ce), we = _slicedToArray$8(me, 2), Re = we[0], je = we[1];
  React.useEffect(function() {
    return ie.current = !1, function() {
      ie.current = !0;
    };
  }, []);
  function Ue(qe, Ge) {
    Ge && ie.current || je(qe);
  }
  return [Re, Ue];
}
function hasValue$1(ce) {
  return ce !== void 0;
}
function useMergedState(ce, ie) {
  var me = ie || {}, we = me.defaultValue, Re = me.value, je = me.onChange, Ue = me.postState, qe = useSafeState(function() {
    return hasValue$1(Re) ? Re : hasValue$1(we) ? typeof we == "function" ? we() : we : typeof ce == "function" ? ce() : ce;
  }), Ge = _slicedToArray$8(qe, 2), Xe = Ge[0], ot = Ge[1], vt = Re !== void 0 ? Re : Xe, bt = Ue ? Ue(vt) : vt, Tt = useEvent(je), wt = useSafeState([vt]), St = _slicedToArray$8(wt, 2), It = St[0], Pt = St[1];
  useLayoutUpdateEffect(function() {
    var Ot = It[0];
    Xe !== Ot && Tt(Xe, Ot);
  }, [It]), useLayoutUpdateEffect(function() {
    hasValue$1(Re) || ot(Re);
  }, [Re]);
  var kt = useEvent(function(Ot, Jr) {
    ot(Ot, Jr), Pt([vt], Jr);
  });
  return [bt, kt];
}
function _toArray(ce) {
  return _arrayWithHoles$8(ce) || _iterableToArray$1(ce) || _unsupportedIterableToArray$9(ce) || _nonIterableRest$8();
}
function useSyncState(ce) {
  var ie = React.useReducer(function(qe) {
    return qe + 1;
  }, 0), me = _slicedToArray$8(ie, 2), we = me[1], Re = React.useRef(ce), je = useEvent(function() {
    return Re.current;
  }), Ue = useEvent(function(qe) {
    Re.current = typeof qe == "function" ? qe(Re.current) : qe, we();
  });
  return [je, Ue];
}
var STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(ce, ie) {
  var me = {};
  return me[ce.toLowerCase()] = ie.toLowerCase(), me["Webkit".concat(ce)] = "webkit".concat(ie), me["Moz".concat(ce)] = "moz".concat(ie), me["ms".concat(ce)] = "MS".concat(ie), me["O".concat(ce)] = "o".concat(ie.toLowerCase()), me;
}
function getVendorPrefixes(ce, ie) {
  var me = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return ce && ("AnimationEvent" in ie || delete me.animationend.animation, "TransitionEvent" in ie || delete me.transitionend.transition), me;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window < "u" ? window : {}), style = {};
if (canUseDom()) {
  var _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(ce) {
  if (prefixedEventNames[ce])
    return prefixedEventNames[ce];
  var ie = vendorPrefixes[ce];
  if (ie)
    for (var me = Object.keys(ie), we = me.length, Re = 0; Re < we; Re += 1) {
      var je = me[Re];
      if (Object.prototype.hasOwnProperty.call(ie, je) && je in style)
        return prefixedEventNames[ce] = ie[je], prefixedEventNames[ce];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$1(ce, ie) {
  if (!ce) return null;
  if (_typeof$b(ce) === "object") {
    var me = ie.replace(/-\w/g, function(we) {
      return we[1].toUpperCase();
    });
    return ce[me];
  }
  return "".concat(ce, "-").concat(ie);
}
const useDomMotionEvents = function(ce) {
  var ie = useRef();
  function me(Re) {
    Re && (Re.removeEventListener(transitionEndName, ce), Re.removeEventListener(animationEndName, ce));
  }
  function we(Re) {
    ie.current && ie.current !== Re && me(ie.current), Re && Re !== ie.current && (Re.addEventListener(transitionEndName, ce), Re.addEventListener(animationEndName, ce), ie.current = Re);
  }
  return React.useEffect(function() {
    return function() {
      me(ie.current);
    };
  }, []), [we, me];
};
var useIsomorphicLayoutEffect$1 = canUseDom() ? useLayoutEffect$2 : useEffect, raf$2 = function(ie) {
  return +setTimeout(ie, 16);
}, caf$1 = function(ie) {
  return clearTimeout(ie);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf$2 = function(ie) {
  return window.requestAnimationFrame(ie);
}, caf$1 = function(ie) {
  return window.cancelAnimationFrame(ie);
});
var rafUUID$1 = 0, rafIds$1 = /* @__PURE__ */ new Map();
function cleanup$1(ce) {
  rafIds$1.delete(ce);
}
var wrapperRaf$1 = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID$1 += 1;
  var we = rafUUID$1;
  function Re(je) {
    if (je === 0)
      cleanup$1(we), ie();
    else {
      var Ue = raf$2(function() {
        Re(je - 1);
      });
      rafIds$1.set(we, Ue);
    }
  }
  return Re(me), we;
};
wrapperRaf$1.cancel = function(ce) {
  var ie = rafIds$1.get(ce);
  return cleanup$1(ce), caf$1(ie);
};
process.env.NODE_ENV !== "production" && (wrapperRaf$1.ids = function() {
  return rafIds$1;
});
const useNextFrame = function() {
  var ce = React.useRef(null);
  function ie() {
    wrapperRaf$1.cancel(ce.current);
  }
  function me(we) {
    var Re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    ie();
    var je = wrapperRaf$1(function() {
      Re <= 1 ? we({
        isCanceled: function() {
          return je !== ce.current;
        }
      }) : me(we, Re - 1);
    });
    ce.current = je;
  }
  return React.useEffect(function() {
    return function() {
      ie();
    };
  }, []), [me, ie];
};
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(ce) {
  return ce === STEP_ACTIVE || ce === STEP_ACTIVATED;
}
const useStepQueue = function(ce, ie, me) {
  var we = useSafeState(STEP_NONE), Re = _slicedToArray$8(we, 2), je = Re[0], Ue = Re[1], qe = useNextFrame(), Ge = _slicedToArray$8(qe, 2), Xe = Ge[0], ot = Ge[1];
  function vt() {
    Ue(STEP_PREPARE, !0);
  }
  var bt = ie ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect$1(function() {
    if (je !== STEP_NONE && je !== STEP_ACTIVATED) {
      var Tt = bt.indexOf(je), wt = bt[Tt + 1], St = me(je);
      St === SkipStep ? Ue(wt, !0) : wt && Xe(function(It) {
        function Pt() {
          It.isCanceled() || Ue(wt, !0);
        }
        St === !0 ? Pt() : Promise.resolve(St).then(Pt);
      });
    }
  }, [ce, je]), React.useEffect(function() {
    return function() {
      ot();
    };
  }, []), [vt, je];
};
function useStatus(ce, ie, me, we) {
  var Re = we.motionEnter, je = Re === void 0 ? !0 : Re, Ue = we.motionAppear, qe = Ue === void 0 ? !0 : Ue, Ge = we.motionLeave, Xe = Ge === void 0 ? !0 : Ge, ot = we.motionDeadline, vt = we.motionLeaveImmediately, bt = we.onAppearPrepare, Tt = we.onEnterPrepare, wt = we.onLeavePrepare, St = we.onAppearStart, It = we.onEnterStart, Pt = we.onLeaveStart, kt = we.onAppearActive, Ot = we.onEnterActive, Jr = we.onLeaveActive, en = we.onAppearEnd, nn = we.onEnterEnd, ln = we.onLeaveEnd, fn = we.onVisibleChanged, vn = useSafeState(), Tn = _slicedToArray$8(vn, 2), xn = Tn[0], bn = Tn[1], Sn = useSyncState(STATUS_NONE), Cn = _slicedToArray$8(Sn, 2), kn = Cn[0], cn = Cn[1], gn = useSafeState(null), an = _slicedToArray$8(gn, 2), un = an[0], pn = an[1], hn = kn(), An = useRef(!1), In = useRef(null);
  function qn() {
    return me();
  }
  var si = useRef(!1);
  function bi() {
    cn(STATUS_NONE), pn(null, !0);
  }
  var xi = useEvent(function(Qa) {
    var Ja = kn();
    if (Ja !== STATUS_NONE) {
      var Ms = qn();
      if (!(Qa && !Qa.deadline && Qa.target !== Ms)) {
        var Hs = si.current, no;
        Ja === STATUS_APPEAR && Hs ? no = en == null ? void 0 : en(Ms, Qa) : Ja === STATUS_ENTER && Hs ? no = nn == null ? void 0 : nn(Ms, Qa) : Ja === STATUS_LEAVE && Hs && (no = ln == null ? void 0 : ln(Ms, Qa)), Hs && no !== !1 && bi();
      }
    }
  }), ji = useDomMotionEvents(xi), zi = _slicedToArray$8(ji, 1), Vi = zi[0], Hi = function(Ja) {
    switch (Ja) {
      case STATUS_APPEAR:
        return _defineProperty$s(_defineProperty$s(_defineProperty$s({}, STEP_PREPARE, bt), STEP_START, St), STEP_ACTIVE, kt);
      case STATUS_ENTER:
        return _defineProperty$s(_defineProperty$s(_defineProperty$s({}, STEP_PREPARE, Tt), STEP_START, It), STEP_ACTIVE, Ot);
      case STATUS_LEAVE:
        return _defineProperty$s(_defineProperty$s(_defineProperty$s({}, STEP_PREPARE, wt), STEP_START, Pt), STEP_ACTIVE, Jr);
      default:
        return {};
    }
  }, ii = React.useMemo(function() {
    return Hi(hn);
  }, [hn]), Fi = useStepQueue(hn, !ce, function(Qa) {
    if (Qa === STEP_PREPARE) {
      var Ja = ii[STEP_PREPARE];
      return Ja ? Ja(qn()) : SkipStep;
    }
    if (ja in ii) {
      var Ms;
      pn(((Ms = ii[ja]) === null || Ms === void 0 ? void 0 : Ms.call(ii, qn(), null)) || null);
    }
    return ja === STEP_ACTIVE && hn !== STATUS_NONE && (Vi(qn()), ot > 0 && (clearTimeout(In.current), In.current = setTimeout(function() {
      xi({
        deadline: !0
      });
    }, ot))), ja === STEP_PREPARED && bi(), DoStep;
  }), ni = _slicedToArray$8(Fi, 2), Ui = ni[0], ja = ni[1], Ga = isActive(ja);
  si.current = Ga;
  var Xa = useRef(null);
  useIsomorphicLayoutEffect$1(function() {
    if (!(An.current && Xa.current === ie)) {
      bn(ie);
      var Qa = An.current;
      An.current = !0;
      var Ja;
      !Qa && ie && qe && (Ja = STATUS_APPEAR), Qa && ie && je && (Ja = STATUS_ENTER), (Qa && !ie && Xe || !Qa && vt && !ie && Xe) && (Ja = STATUS_LEAVE);
      var Ms = Hi(Ja);
      Ja && (ce || Ms[STEP_PREPARE]) ? (cn(Ja), Ui()) : cn(STATUS_NONE), Xa.current = ie;
    }
  }, [ie]), useEffect(function() {
    // Cancel appear
    (hn === STATUS_APPEAR && !qe || // Cancel enter
    hn === STATUS_ENTER && !je || // Cancel leave
    hn === STATUS_LEAVE && !Xe) && cn(STATUS_NONE);
  }, [qe, je, Xe]), useEffect(function() {
    return function() {
      An.current = !1, clearTimeout(In.current);
    };
  }, []);
  var Ns = React.useRef(!1);
  useEffect(function() {
    xn && (Ns.current = !0), xn !== void 0 && hn === STATUS_NONE && ((Ns.current || xn) && (fn == null || fn(xn)), Ns.current = !0);
  }, [xn, hn]);
  var Ya = un;
  return ii[STEP_PREPARE] && ja === STEP_START && (Ya = _objectSpread2$2({
    transition: "none"
  }, Ya)), [hn, ja, Ya, xn ?? ie];
}
function genCSSMotion(ce) {
  var ie = ce;
  _typeof$b(ce) === "object" && (ie = ce.transitionSupport);
  function me(Re, je) {
    return !!(Re.motionName && ie && je !== !1);
  }
  var we = /* @__PURE__ */ React.forwardRef(function(Re, je) {
    var Ue = Re.visible, qe = Ue === void 0 ? !0 : Ue, Ge = Re.removeOnLeave, Xe = Ge === void 0 ? !0 : Ge, ot = Re.forceRender, vt = Re.children, bt = Re.motionName, Tt = Re.leavedClassName, wt = Re.eventProps, St = React.useContext(Context$1), It = St.motion, Pt = me(Re, It), kt = useRef(), Ot = useRef();
    function Jr() {
      try {
        return kt.current instanceof HTMLElement ? kt.current : findDOMNode(Ot.current);
      } catch {
        return null;
      }
    }
    var en = useStatus(Pt, qe, Jr, Re), nn = _slicedToArray$8(en, 4), ln = nn[0], fn = nn[1], vn = nn[2], Tn = nn[3], xn = React.useRef(Tn);
    Tn && (xn.current = !0);
    var bn = React.useCallback(function(an) {
      kt.current = an, fillRef(je, an);
    }, [je]), Sn, Cn = _objectSpread2$2(_objectSpread2$2({}, wt), {}, {
      visible: qe
    });
    if (!vt)
      Sn = null;
    else if (ln === STATUS_NONE)
      Tn ? Sn = vt(_objectSpread2$2({}, Cn), bn) : !Xe && xn.current && Tt ? Sn = vt(_objectSpread2$2(_objectSpread2$2({}, Cn), {}, {
        className: Tt
      }), bn) : ot || !Xe && !Tt ? Sn = vt(_objectSpread2$2(_objectSpread2$2({}, Cn), {}, {
        style: {
          display: "none"
        }
      }), bn) : Sn = null;
    else {
      var kn;
      fn === STEP_PREPARE ? kn = "prepare" : isActive(fn) ? kn = "active" : fn === STEP_START && (kn = "start");
      var cn = getTransitionName$1(bt, "".concat(ln, "-").concat(kn));
      Sn = vt(_objectSpread2$2(_objectSpread2$2({}, Cn), {}, {
        className: classNames(getTransitionName$1(bt, ln), _defineProperty$s(_defineProperty$s({}, cn, cn && kn), bt, typeof bt == "string")),
        style: vn
      }), bn);
    }
    if (/* @__PURE__ */ React.isValidElement(Sn) && supportRef(Sn)) {
      var gn = getNodeRef(Sn);
      gn || (Sn = /* @__PURE__ */ React.cloneElement(Sn, {
        ref: bn
      }));
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: Ot
    }, Sn);
  });
  return we.displayName = "CSSMotion", we;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(ce) {
  var ie;
  return ce && _typeof$b(ce) === "object" && "key" in ce ? ie = ce : ie = {
    key: ce
  }, _objectSpread2$2(_objectSpread2$2({}, ie), {}, {
    key: String(ie.key)
  });
}
function parseKeys() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return ce.map(wrapKeyToObject);
}
function diffKeys() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], me = [], we = 0, Re = ie.length, je = parseKeys(ce), Ue = parseKeys(ie);
  je.forEach(function(Xe) {
    for (var ot = !1, vt = we; vt < Re; vt += 1) {
      var bt = Ue[vt];
      if (bt.key === Xe.key) {
        we < vt && (me = me.concat(Ue.slice(we, vt).map(function(Tt) {
          return _objectSpread2$2(_objectSpread2$2({}, Tt), {}, {
            status: STATUS_ADD
          });
        })), we = vt), me.push(_objectSpread2$2(_objectSpread2$2({}, bt), {}, {
          status: STATUS_KEEP
        })), we += 1, ot = !0;
        break;
      }
    }
    ot || me.push(_objectSpread2$2(_objectSpread2$2({}, Xe), {}, {
      status: STATUS_REMOVE
    }));
  }), we < Re && (me = me.concat(Ue.slice(we).map(function(Xe) {
    return _objectSpread2$2(_objectSpread2$2({}, Xe), {}, {
      status: STATUS_ADD
    });
  })));
  var qe = {};
  me.forEach(function(Xe) {
    var ot = Xe.key;
    qe[ot] = (qe[ot] || 0) + 1;
  });
  var Ge = Object.keys(qe).filter(function(Xe) {
    return qe[Xe] > 1;
  });
  return Ge.forEach(function(Xe) {
    me = me.filter(function(ot) {
      var vt = ot.key, bt = ot.status;
      return vt !== Xe || bt !== STATUS_REMOVE;
    }), me.forEach(function(ot) {
      ot.key === Xe && (ot.status = STATUS_KEEP);
    });
  }), me;
}
var _excluded$h = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$2 = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, me = /* @__PURE__ */ function(we) {
    _inherits$f(je, we);
    var Re = _createSuper$4(je);
    function je() {
      var Ue;
      _classCallCheck$t(this, je);
      for (var qe = arguments.length, Ge = new Array(qe), Xe = 0; Xe < qe; Xe++)
        Ge[Xe] = arguments[Xe];
      return Ue = Re.call.apply(Re, [this].concat(Ge)), _defineProperty$s(_assertThisInitialized$4(Ue), "state", {
        keyEntities: []
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "removeKey", function(ot) {
        Ue.setState(function(vt) {
          var bt = vt.keyEntities.map(function(Tt) {
            return Tt.key !== ot ? Tt : _objectSpread2$2(_objectSpread2$2({}, Tt), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: bt
          };
        }, function() {
          var vt = Ue.state.keyEntities, bt = vt.filter(function(Tt) {
            var wt = Tt.status;
            return wt !== STATUS_REMOVED;
          }).length;
          bt === 0 && Ue.props.onAllRemoved && Ue.props.onAllRemoved();
        });
      }), Ue;
    }
    return _createClass$r(je, [{
      key: "render",
      value: function() {
        var qe = this, Ge = this.state.keyEntities, Xe = this.props, ot = Xe.component, vt = Xe.children, bt = Xe.onVisibleChanged;
        Xe.onAllRemoved;
        var Tt = _objectWithoutProperties$6(Xe, _excluded$h), wt = ot || React.Fragment, St = {};
        return MOTION_PROP_NAMES.forEach(function(It) {
          St[It] = Tt[It], delete Tt[It];
        }), delete Tt.keys, /* @__PURE__ */ React.createElement(wt, Tt, Ge.map(function(It, Pt) {
          var kt = It.status, Ot = _objectWithoutProperties$6(It, _excluded2$2), Jr = kt === STATUS_ADD || kt === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(ie, _extends$j({}, St, {
            key: Ot.key,
            visible: Jr,
            eventProps: Ot,
            onVisibleChanged: function(nn) {
              bt == null || bt(nn, {
                key: Ot.key
              }), nn || qe.removeKey(Ot.key);
            }
          }), function(en, nn) {
            return vt(_objectSpread2$2(_objectSpread2$2({}, en), {}, {
              index: Pt
            }), nn);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(qe, Ge) {
        var Xe = qe.keys, ot = Ge.keyEntities, vt = parseKeys(Xe), bt = diffKeys(ot, vt);
        return {
          keyEntities: bt.filter(function(Tt) {
            var wt = ot.find(function(St) {
              var It = St.key;
              return Tt.key === It;
            });
            return !(wt && wt.status === STATUS_REMOVED && Tt.status === STATUS_REMOVE);
          })
        };
      }
    }]), je;
  }(React.Component);
  return _defineProperty$s(me, "defaultProps", {
    component: "div"
  }), me;
}
genCSSMotionList(supportTransition);
function Arrow(ce) {
  var ie = ce.prefixCls, me = ce.align, we = ce.arrow, Re = ce.arrowPos, je = we || {}, Ue = je.className, qe = je.content, Ge = Re.x, Xe = Ge === void 0 ? 0 : Ge, ot = Re.y, vt = ot === void 0 ? 0 : ot, bt = React.useRef();
  if (!me || !me.points)
    return null;
  var Tt = {
    position: "absolute"
  };
  if (me.autoArrow !== !1) {
    var wt = me.points[0], St = me.points[1], It = wt[0], Pt = wt[1], kt = St[0], Ot = St[1];
    It === kt || !["t", "b"].includes(It) ? Tt.top = vt : It === "t" ? Tt.top = 0 : Tt.bottom = 0, Pt === Ot || !["l", "r"].includes(Pt) ? Tt.left = Xe : Pt === "l" ? Tt.left = 0 : Tt.right = 0;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref: bt,
    className: classNames("".concat(ie, "-arrow"), Ue),
    style: Tt
  }, qe);
}
function Mask$1(ce) {
  var ie = ce.prefixCls, me = ce.open, we = ce.zIndex, Re = ce.mask, je = ce.motion;
  return Re ? /* @__PURE__ */ React.createElement(CSSMotion, _extends$j({}, je, {
    motionAppear: !0,
    visible: me,
    removeOnLeave: !0
  }), function(Ue) {
    var qe = Ue.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex: we
      },
      className: classNames("".concat(ie, "-mask"), qe)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ React.memo(function(ce) {
  var ie = ce.children;
  return ie;
}, function(ce, ie) {
  return ie.cache;
});
process.env.NODE_ENV !== "production" && (PopupContent.displayName = "PopupContent");
var Popup$1 = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.popup, we = ce.className, Re = ce.prefixCls, je = ce.style, Ue = ce.target, qe = ce.onVisibleChanged, Ge = ce.open, Xe = ce.keepDom, ot = ce.fresh, vt = ce.onClick, bt = ce.mask, Tt = ce.arrow, wt = ce.arrowPos, St = ce.align, It = ce.motion, Pt = ce.maskMotion, kt = ce.forceRender, Ot = ce.getPopupContainer, Jr = ce.autoDestroy, en = ce.portal, nn = ce.zIndex, ln = ce.onMouseEnter, fn = ce.onMouseLeave, vn = ce.onPointerEnter, Tn = ce.onPointerDownCapture, xn = ce.ready, bn = ce.offsetX, Sn = ce.offsetY, Cn = ce.offsetR, kn = ce.offsetB, cn = ce.onAlign, gn = ce.onPrepare, an = ce.stretch, un = ce.targetWidth, pn = ce.targetHeight, hn = typeof me == "function" ? me() : me, An = Ge || Xe, In = (Ot == null ? void 0 : Ot.length) > 0, qn = React.useState(!Ot || !In), si = _slicedToArray$8(qn, 2), bi = si[0], xi = si[1];
  if (useLayoutEffect$1(function() {
    !bi && In && Ue && xi(!0);
  }, [bi, In, Ue]), !bi)
    return null;
  var ji = "auto", zi = {
    left: "-1000vw",
    top: "-1000vh",
    right: ji,
    bottom: ji
  };
  if (xn || !Ge) {
    var Vi, Hi = St.points, ii = St.dynamicInset || ((Vi = St._experimental) === null || Vi === void 0 ? void 0 : Vi.dynamicInset), Fi = ii && Hi[0][1] === "r", ni = ii && Hi[0][0] === "b";
    Fi ? (zi.right = Cn, zi.left = ji) : (zi.left = bn, zi.right = ji), ni ? (zi.bottom = kn, zi.top = ji) : (zi.top = Sn, zi.bottom = ji);
  }
  var Ui = {};
  return an && (an.includes("height") && pn ? Ui.height = pn : an.includes("minHeight") && pn && (Ui.minHeight = pn), an.includes("width") && un ? Ui.width = un : an.includes("minWidth") && un && (Ui.minWidth = un)), Ge || (Ui.pointerEvents = "none"), /* @__PURE__ */ React.createElement(en, {
    open: kt || An,
    getContainer: Ot && function() {
      return Ot(Ue);
    },
    autoDestroy: Jr
  }, /* @__PURE__ */ React.createElement(Mask$1, {
    prefixCls: Re,
    open: Ge,
    zIndex: nn,
    mask: bt,
    motion: Pt
  }), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: cn,
    disabled: !Ge
  }, function(ja) {
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends$j({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: kt,
      leavedClassName: "".concat(Re, "-hidden")
    }, It, {
      onAppearPrepare: gn,
      onEnterPrepare: gn,
      visible: Ge,
      onVisibleChanged: function(Xa) {
        var Ns;
        It == null || (Ns = It.onVisibleChanged) === null || Ns === void 0 || Ns.call(It, Xa), qe(Xa);
      }
    }), function(Ga, Xa) {
      var Ns = Ga.className, Ya = Ga.style, Qa = classNames(Re, Ns, we);
      return /* @__PURE__ */ React.createElement("div", {
        ref: composeRef(ja, ie, Xa),
        className: Qa,
        style: _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
          "--arrow-x": "".concat(wt.x || 0, "px"),
          "--arrow-y": "".concat(wt.y || 0, "px")
        }, zi), Ui), Ya), {}, {
          boxSizing: "border-box",
          zIndex: nn
        }, je),
        onMouseEnter: ln,
        onMouseLeave: fn,
        onPointerEnter: vn,
        onClick: vt,
        onPointerDownCapture: Tn
      }, Tt && /* @__PURE__ */ React.createElement(Arrow, {
        prefixCls: Re,
        arrow: Tt,
        arrowPos: wt,
        align: St
      }), /* @__PURE__ */ React.createElement(PopupContent, {
        cache: !Ge && !ot
      }, hn));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Popup$1.displayName = "Popup");
var TriggerWrapper = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.children, we = ce.getTriggerDOMNode, Re = supportRef(me), je = React.useCallback(function(qe) {
    fillRef(ie, we ? we(qe) : qe);
  }, [we]), Ue = useComposeRef(je, getNodeRef(me));
  return Re ? /* @__PURE__ */ React.cloneElement(me, {
    ref: Ue
  }) : me;
});
process.env.NODE_ENV !== "production" && (TriggerWrapper.displayName = "TriggerWrapper");
var TriggerContext$1 = /* @__PURE__ */ React.createContext(null);
function toArray$1(ce) {
  return ce ? Array.isArray(ce) ? ce : [ce] : [];
}
function useAction(ce, ie, me, we) {
  return React.useMemo(function() {
    var Re = toArray$1(me ?? ie), je = toArray$1(we ?? ie), Ue = new Set(Re), qe = new Set(je);
    return ce && (Ue.has("hover") && (Ue.delete("hover"), Ue.add("click")), qe.has("hover") && (qe.delete("hover"), qe.add("click"))), [Ue, qe];
  }, [ce, ie, me, we]);
}
const isVisible = function(ce) {
  if (!ce)
    return !1;
  if (ce instanceof Element) {
    if (ce.offsetParent)
      return !0;
    if (ce.getBBox) {
      var ie = ce.getBBox(), me = ie.width, we = ie.height;
      if (me || we)
        return !0;
    }
    if (ce.getBoundingClientRect) {
      var Re = ce.getBoundingClientRect(), je = Re.width, Ue = Re.height;
      if (je || Ue)
        return !0;
    }
  }
  return !1;
};
function isPointsEq$1() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], me = arguments.length > 2 ? arguments[2] : void 0;
  return me ? ce[0] === ie[0] : ce[0] === ie[0] && ce[1] === ie[1];
}
function getAlignPopupClassName$1(ce, ie, me, we) {
  for (var Re = me.points, je = Object.keys(ce), Ue = 0; Ue < je.length; Ue += 1) {
    var qe, Ge = je[Ue];
    if (isPointsEq$1((qe = ce[Ge]) === null || qe === void 0 ? void 0 : qe.points, Re, we))
      return "".concat(ie, "-placement-").concat(Ge);
  }
  return "";
}
function getMotion$1(ce, ie, me, we) {
  return ie || (me ? {
    motionName: "".concat(ce, "-").concat(me)
  } : we ? {
    motionName: we
  } : null);
}
function getWin(ce) {
  return ce.ownerDocument.defaultView;
}
function collectScroller(ce) {
  for (var ie = [], me = ce == null ? void 0 : ce.parentElement, we = ["hidden", "scroll", "clip", "auto"]; me; ) {
    var Re = getWin(me).getComputedStyle(me), je = Re.overflowX, Ue = Re.overflowY, qe = Re.overflow;
    [je, Ue, qe].some(function(Ge) {
      return we.includes(Ge);
    }) && ie.push(me), me = me.parentElement;
  }
  return ie;
}
function toNum(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(ce) ? ie : ce;
}
function getPxValue(ce) {
  return toNum(parseFloat(ce), 0);
}
function getVisibleArea(ce, ie) {
  var me = _objectSpread2$2({}, ce);
  return (ie || []).forEach(function(we) {
    if (!(we instanceof HTMLBodyElement || we instanceof HTMLHtmlElement)) {
      var Re = getWin(we).getComputedStyle(we), je = Re.overflow, Ue = Re.overflowClipMargin, qe = Re.borderTopWidth, Ge = Re.borderBottomWidth, Xe = Re.borderLeftWidth, ot = Re.borderRightWidth, vt = we.getBoundingClientRect(), bt = we.offsetHeight, Tt = we.clientHeight, wt = we.offsetWidth, St = we.clientWidth, It = getPxValue(qe), Pt = getPxValue(Ge), kt = getPxValue(Xe), Ot = getPxValue(ot), Jr = toNum(Math.round(vt.width / wt * 1e3) / 1e3), en = toNum(Math.round(vt.height / bt * 1e3) / 1e3), nn = (wt - St - kt - Ot) * Jr, ln = (bt - Tt - It - Pt) * en, fn = It * en, vn = Pt * en, Tn = kt * Jr, xn = Ot * Jr, bn = 0, Sn = 0;
      if (je === "clip") {
        var Cn = getPxValue(Ue);
        bn = Cn * Jr, Sn = Cn * en;
      }
      var kn = vt.x + Tn - bn, cn = vt.y + fn - Sn, gn = kn + vt.width + 2 * bn - Tn - xn - nn, an = cn + vt.height + 2 * Sn - fn - vn - ln;
      me.left = Math.max(me.left, kn), me.top = Math.max(me.top, cn), me.right = Math.min(me.right, gn), me.bottom = Math.min(me.bottom, an);
    }
  }), me;
}
function getUnitOffset(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, me = "".concat(ie), we = me.match(/^(.*)\%$/);
  return we ? ce * (parseFloat(we[1]) / 100) : parseFloat(me);
}
function getNumberOffset(ce, ie) {
  var me = ie || [], we = _slicedToArray$8(me, 2), Re = we[0], je = we[1];
  return [getUnitOffset(ce.width, Re), getUnitOffset(ce.height, je)];
}
function splitPoints() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [ce[0], ce[1]];
}
function getAlignPoint(ce, ie) {
  var me = ie[0], we = ie[1], Re, je;
  return me === "t" ? je = ce.y : me === "b" ? je = ce.y + ce.height : je = ce.y + ce.height / 2, we === "l" ? Re = ce.x : we === "r" ? Re = ce.x + ce.width : Re = ce.x + ce.width / 2, {
    x: Re,
    y: je
  };
}
function reversePoints(ce, ie) {
  var me = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return ce.map(function(we, Re) {
    return Re === ie ? me[we] || "c" : we;
  }).join("");
}
function useAlign(ce, ie, me, we, Re, je, Ue) {
  var qe = React.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: Re[we] || {}
  }), Ge = _slicedToArray$8(qe, 2), Xe = Ge[0], ot = Ge[1], vt = React.useRef(0), bt = React.useMemo(function() {
    return ie ? collectScroller(ie) : [];
  }, [ie]), Tt = React.useRef({}), wt = function() {
    Tt.current = {};
  };
  ce || wt();
  var St = useEvent(function() {
    if (ie && me && ce) {
      let km = function(yg, cg) {
        var zm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Hs, Eg = qn.x + yg, Mg = qn.y + cg, h1 = Eg + Fi, L1 = Mg + ii, p1 = Math.max(Eg, zm.left), ro = Math.max(Mg, zm.top), co = Math.min(h1, zm.right), Wl = Math.min(L1, zm.bottom);
        return Math.max(0, (co - p1) * (Wl - ro));
      }, Og = function() {
        Us = qn.y + Gs, $s = Us + ii, Za = qn.x + zs, ml = Za + Fi;
      };
      var kt, Ot, Jr, en, nn = ie, ln = nn.ownerDocument, fn = getWin(nn), vn = fn.getComputedStyle(nn), Tn = vn.width, xn = vn.height, bn = vn.position, Sn = nn.style.left, Cn = nn.style.top, kn = nn.style.right, cn = nn.style.bottom, gn = nn.style.overflow, an = _objectSpread2$2(_objectSpread2$2({}, Re[we]), je), un = ln.createElement("div");
      (kt = nn.parentElement) === null || kt === void 0 || kt.appendChild(un), un.style.left = "".concat(nn.offsetLeft, "px"), un.style.top = "".concat(nn.offsetTop, "px"), un.style.position = bn, un.style.height = "".concat(nn.offsetHeight, "px"), un.style.width = "".concat(nn.offsetWidth, "px"), nn.style.left = "0", nn.style.top = "0", nn.style.right = "auto", nn.style.bottom = "auto", nn.style.overflow = "hidden";
      var pn;
      if (Array.isArray(me))
        pn = {
          x: me[0],
          y: me[1],
          width: 0,
          height: 0
        };
      else {
        var hn, An, In = me.getBoundingClientRect();
        In.x = (hn = In.x) !== null && hn !== void 0 ? hn : In.left, In.y = (An = In.y) !== null && An !== void 0 ? An : In.top, pn = {
          x: In.x,
          y: In.y,
          width: In.width,
          height: In.height
        };
      }
      var qn = nn.getBoundingClientRect();
      qn.x = (Ot = qn.x) !== null && Ot !== void 0 ? Ot : qn.left, qn.y = (Jr = qn.y) !== null && Jr !== void 0 ? Jr : qn.top;
      var si = ln.documentElement, bi = si.clientWidth, xi = si.clientHeight, ji = si.scrollWidth, zi = si.scrollHeight, Vi = si.scrollTop, Hi = si.scrollLeft, ii = qn.height, Fi = qn.width, ni = pn.height, Ui = pn.width, ja = {
        left: 0,
        top: 0,
        right: bi,
        bottom: xi
      }, Ga = {
        left: -Hi,
        top: -Vi,
        right: ji - Hi,
        bottom: zi - Vi
      }, Xa = an.htmlRegion, Ns = "visible", Ya = "visibleFirst";
      Xa !== "scroll" && Xa !== Ya && (Xa = Ns);
      var Qa = Xa === Ya, Ja = getVisibleArea(Ga, bt), Ms = getVisibleArea(ja, bt), Hs = Xa === Ns ? Ms : Ja, no = Qa ? Ms : Hs;
      nn.style.left = "auto", nn.style.top = "auto", nn.style.right = "0", nn.style.bottom = "0";
      var Qs = nn.getBoundingClientRect();
      nn.style.left = Sn, nn.style.top = Cn, nn.style.right = kn, nn.style.bottom = cn, nn.style.overflow = gn, (en = nn.parentElement) === null || en === void 0 || en.removeChild(un);
      var Zs = toNum(Math.round(Fi / parseFloat(Tn) * 1e3) / 1e3), so = toNum(Math.round(ii / parseFloat(xn) * 1e3) / 1e3);
      if (Zs === 0 || so === 0 || isDOM(me) && !isVisible(me))
        return;
      var io = an.offset, dl = an.targetOffset, vl = getNumberOffset(qn, io), lo = _slicedToArray$8(vl, 2), yl = lo[0], bl = lo[1], Al = getNumberOffset(pn, dl), Xl = _slicedToArray$8(Al, 2), $l = Xl[0], Bl = Xl[1];
      pn.x -= $l, pn.y -= Bl;
      var Fl = an.points || [], kl = _slicedToArray$8(Fl, 2), ql = kl[0], _l = kl[1], Ol = splitPoints(_l), Ll = splitPoints(ql), Ql = getAlignPoint(pn, Ol), wl = getAlignPoint(qn, Ll), to = _objectSpread2$2({}, an), zs = Ql.x - wl.x + yl, Gs = Ql.y - wl.y + bl, Pl = km(zs, Gs), Ml = km(zs, Gs, Ms), Ws = getAlignPoint(pn, ["t", "l"]), Ks = getAlignPoint(qn, ["t", "l"]), Js = getAlignPoint(pn, ["b", "r"]), qs = getAlignPoint(qn, ["b", "r"]), ho = an.overflow || {}, mn = ho.adjustX, ai = ho.adjustY, $i = ho.shiftX, Ha = ho.shiftY, Va = function(cg) {
        return typeof cg == "boolean" ? cg : cg >= 0;
      }, Us, $s, Za, ml;
      Og();
      var Ys = Va(ai), Bs = Ll[0] === Ol[0];
      if (Ys && Ll[0] === "t" && ($s > no.bottom || Tt.current.bt)) {
        var Wa = Gs;
        Bs ? Wa -= ii - ni : Wa = Ws.y - qs.y - bl;
        var js = km(zs, Wa), Fs = km(zs, Wa, Ms);
        // Of course use larger one
        js > Pl || js === Pl && (!Qa || // Choose recommend one
        Fs >= Ml) ? (Tt.current.bt = !0, Gs = Wa, bl = -bl, to.points = [reversePoints(Ll, 0), reversePoints(Ol, 0)]) : Tt.current.bt = !1;
      }
      if (Ys && Ll[0] === "b" && (Us < no.top || Tt.current.tb)) {
        var Xi = Gs;
        Bs ? Xi += ii - ni : Xi = Js.y - Ks.y - bl;
        var ao = km(zs, Xi), Sl = km(zs, Xi, Ms);
        // Of course use larger one
        ao > Pl || ao === Pl && (!Qa || // Choose recommend one
        Sl >= Ml) ? (Tt.current.tb = !0, Gs = Xi, bl = -bl, to.points = [reversePoints(Ll, 0), reversePoints(Ol, 0)]) : Tt.current.tb = !1;
      }
      var xl = Va(mn), fm = Ll[1] === Ol[1];
      if (xl && Ll[1] === "l" && (ml > no.right || Tt.current.rl)) {
        var Jp = zs;
        fm ? Jp -= Fi - Ui : Jp = Ws.x - qs.x - yl;
        var um = km(Jp, Gs), sm = km(Jp, Gs, Ms);
        // Of course use larger one
        um > Pl || um === Pl && (!Qa || // Choose recommend one
        sm >= Ml) ? (Tt.current.rl = !0, zs = Jp, yl = -yl, to.points = [reversePoints(Ll, 1), reversePoints(Ol, 1)]) : Tt.current.rl = !1;
      }
      if (xl && Ll[1] === "r" && (Za < no.left || Tt.current.lr)) {
        var em = zs;
        fm ? em += Fi - Ui : em = Js.x - Ks.x - yl;
        var _m = km(em, Gs), wm = km(em, Gs, Ms);
        // Of course use larger one
        _m > Pl || _m === Pl && (!Qa || // Choose recommend one
        wm >= Ml) ? (Tt.current.lr = !0, zs = em, yl = -yl, to.points = [reversePoints(Ll, 1), reversePoints(Ol, 1)]) : Tt.current.lr = !1;
      }
      Og();
      var tm = $i === !0 ? 0 : $i;
      typeof tm == "number" && (Za < Ms.left && (zs -= Za - Ms.left - yl, pn.x + Ui < Ms.left + tm && (zs += pn.x - Ms.left + Ui - tm)), ml > Ms.right && (zs -= ml - Ms.right - yl, pn.x > Ms.right - tm && (zs += pn.x - Ms.right + tm)));
      var cm = Ha === !0 ? 0 : Ha;
      typeof cm == "number" && (Us < Ms.top && (Gs -= Us - Ms.top - bl, pn.y + ni < Ms.top + cm && (Gs += pn.y - Ms.top + ni - cm)), $s > Ms.bottom && (Gs -= $s - Ms.bottom - bl, pn.y > Ms.bottom - cm && (Gs += pn.y - Ms.bottom + cm)));
      var Lm = qn.x + zs, Om = Lm + Fi, Vm = qn.y + Gs, ug = Vm + ii, qm = pn.x, Tl = qm + Ui, uo = pn.y, om = uo + ni, pm = Math.max(Lm, qm), zl = Math.min(Om, Tl), rm = (pm + zl) / 2, Zp = rm - Lm, Am = Math.max(Vm, uo), Sm = Math.min(ug, om), mm = (Am + Sm) / 2, Rm = mm - Vm;
      Ue == null || Ue(ie, to);
      var $m = Qs.right - qn.x - (zs + qn.width), xm = Qs.bottom - qn.y - (Gs + qn.height);
      Zs === 1 && (zs = Math.round(zs), $m = Math.round($m)), so === 1 && (Gs = Math.round(Gs), xm = Math.round(xm));
      var Ig = {
        ready: !0,
        offsetX: zs / Zs,
        offsetY: Gs / so,
        offsetR: $m / Zs,
        offsetB: xm / so,
        arrowX: Zp / Zs,
        arrowY: Rm / so,
        scaleX: Zs,
        scaleY: so,
        align: to
      };
      ot(Ig);
    }
  }), It = function() {
    vt.current += 1;
    var Ot = vt.current;
    Promise.resolve().then(function() {
      vt.current === Ot && St();
    });
  }, Pt = function() {
    ot(function(Ot) {
      return _objectSpread2$2(_objectSpread2$2({}, Ot), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$1(Pt, [we]), useLayoutEffect$1(function() {
    ce || Pt();
  }, [ce]), [Xe.ready, Xe.offsetX, Xe.offsetY, Xe.offsetR, Xe.offsetB, Xe.arrowX, Xe.arrowY, Xe.scaleX, Xe.scaleY, Xe.align, It];
}
function useWatch(ce, ie, me, we, Re) {
  useLayoutEffect$1(function() {
    if (ce && ie && me) {
      let vt = function() {
        we(), Re();
      };
      var je = ie, Ue = me, qe = collectScroller(je), Ge = collectScroller(Ue), Xe = getWin(Ue), ot = new Set([Xe].concat(_toConsumableArray$1(qe), _toConsumableArray$1(Ge)));
      return ot.forEach(function(bt) {
        bt.addEventListener("scroll", vt, {
          passive: !0
        });
      }), Xe.addEventListener("resize", vt, {
        passive: !0
      }), we(), function() {
        ot.forEach(function(bt) {
          bt.removeEventListener("scroll", vt), Xe.removeEventListener("resize", vt);
        });
      };
    }
  }, [ce, ie, me]);
}
function useWinClick(ce, ie, me, we, Re, je, Ue, qe) {
  var Ge = React.useRef(ce);
  Ge.current = ce;
  var Xe = React.useRef(!1);
  React.useEffect(function() {
    if (ie && we && (!Re || je)) {
      var vt = function() {
        Xe.current = !1;
      }, bt = function(Jr) {
        var en;
        Ge.current && !Ue(((en = Jr.composedPath) === null || en === void 0 || (en = en.call(Jr)) === null || en === void 0 ? void 0 : en[0]) || Jr.target) && !Xe.current && qe(!1);
      }, Tt = getWin(we);
      Tt.addEventListener("pointerdown", vt, !0), Tt.addEventListener("mousedown", bt, !0), Tt.addEventListener("contextmenu", bt, !0);
      var wt = getShadowRoot(me);
      if (wt && (wt.addEventListener("mousedown", bt, !0), wt.addEventListener("contextmenu", bt, !0)), process.env.NODE_ENV !== "production") {
        var St, It, Pt = me == null || (St = me.getRootNode) === null || St === void 0 ? void 0 : St.call(me), kt = (It = we.getRootNode) === null || It === void 0 ? void 0 : It.call(we);
        warning$1(Pt === kt, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        Tt.removeEventListener("pointerdown", vt, !0), Tt.removeEventListener("mousedown", bt, !0), Tt.removeEventListener("contextmenu", bt, !0), wt && (wt.removeEventListener("mousedown", bt, !0), wt.removeEventListener("contextmenu", bt, !0));
      };
    }
  }, [ie, me, we, Re, je]);
  function ot() {
    Xe.current = !0;
  }
  return ot;
}
var _excluded$g = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger$1() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal$1, ie = /* @__PURE__ */ React.forwardRef(function(me, we) {
    var Re = me.prefixCls, je = Re === void 0 ? "rc-trigger-popup" : Re, Ue = me.children, qe = me.action, Ge = qe === void 0 ? "hover" : qe, Xe = me.showAction, ot = me.hideAction, vt = me.popupVisible, bt = me.defaultPopupVisible, Tt = me.onPopupVisibleChange, wt = me.afterPopupVisibleChange, St = me.mouseEnterDelay, It = me.mouseLeaveDelay, Pt = It === void 0 ? 0.1 : It, kt = me.focusDelay, Ot = me.blurDelay, Jr = me.mask, en = me.maskClosable, nn = en === void 0 ? !0 : en, ln = me.getPopupContainer, fn = me.forceRender, vn = me.autoDestroy, Tn = me.destroyPopupOnHide, xn = me.popup, bn = me.popupClassName, Sn = me.popupStyle, Cn = me.popupPlacement, kn = me.builtinPlacements, cn = kn === void 0 ? {} : kn, gn = me.popupAlign, an = me.zIndex, un = me.stretch, pn = me.getPopupClassNameFromAlign, hn = me.fresh, An = me.alignPoint, In = me.onPopupClick, qn = me.onPopupAlign, si = me.arrow, bi = me.popupMotion, xi = me.maskMotion, ji = me.popupTransitionName, zi = me.popupAnimation, Vi = me.maskTransitionName, Hi = me.maskAnimation, ii = me.className, Fi = me.getTriggerDOMNode, ni = _objectWithoutProperties$6(me, _excluded$g), Ui = vn || Tn || !1, ja = React.useState(!1), Ga = _slicedToArray$8(ja, 2), Xa = Ga[0], Ns = Ga[1];
    useLayoutEffect$1(function() {
      Ns(isMobile());
    }, []);
    var Ya = React.useRef({}), Qa = React.useContext(TriggerContext$1), Ja = React.useMemo(function() {
      return {
        registerSubPopup: function(co, Wl) {
          Ya.current[co] = Wl, Qa == null || Qa.registerSubPopup(co, Wl);
        }
      };
    }, [Qa]), Ms = useId$1(), Hs = React.useState(null), no = _slicedToArray$8(Hs, 2), Qs = no[0], Zs = no[1], so = React.useRef(null), io = useEvent(function(ro) {
      so.current = ro, isDOM(ro) && Qs !== ro && Zs(ro), Qa == null || Qa.registerSubPopup(Ms, ro);
    }), dl = React.useState(null), vl = _slicedToArray$8(dl, 2), lo = vl[0], yl = vl[1], bl = React.useRef(null), Al = useEvent(function(ro) {
      isDOM(ro) && lo !== ro && (yl(ro), bl.current = ro);
    }), Xl = React.Children.only(Ue), $l = (Xl == null ? void 0 : Xl.props) || {}, Bl = {}, Fl = useEvent(function(ro) {
      var co, Wl, hm = lo;
      return (hm == null ? void 0 : hm.contains(ro)) || ((co = getShadowRoot(hm)) === null || co === void 0 ? void 0 : co.host) === ro || ro === hm || (Qs == null ? void 0 : Qs.contains(ro)) || ((Wl = getShadowRoot(Qs)) === null || Wl === void 0 ? void 0 : Wl.host) === ro || ro === Qs || Object.values(Ya.current).some(function(lm) {
        return (lm == null ? void 0 : lm.contains(ro)) || ro === lm;
      });
    }), kl = getMotion$1(je, bi, zi, ji), ql = getMotion$1(je, xi, Hi, Vi), _l = React.useState(bt || !1), Ol = _slicedToArray$8(_l, 2), Ll = Ol[0], Ql = Ol[1], wl = vt ?? Ll, to = useEvent(function(ro) {
      vt === void 0 && Ql(ro);
    });
    useLayoutEffect$1(function() {
      Ql(vt || !1);
    }, [vt]);
    var zs = React.useRef(wl);
    zs.current = wl;
    var Gs = React.useRef([]);
    Gs.current = [];
    var Pl = useEvent(function(ro) {
      var co;
      to(ro), ((co = Gs.current[Gs.current.length - 1]) !== null && co !== void 0 ? co : wl) !== ro && (Gs.current.push(ro), Tt == null || Tt(ro));
    }), Ml = React.useRef(), Ws = function() {
      clearTimeout(Ml.current);
    }, Ks = function(co) {
      var Wl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ws(), Wl === 0 ? Pl(co) : Ml.current = setTimeout(function() {
        Pl(co);
      }, Wl * 1e3);
    };
    React.useEffect(function() {
      return Ws;
    }, []);
    var Js = React.useState(!1), qs = _slicedToArray$8(Js, 2), ho = qs[0], mn = qs[1];
    useLayoutEffect$1(function(ro) {
      (!ro || wl) && mn(!0);
    }, [wl]);
    var ai = React.useState(null), $i = _slicedToArray$8(ai, 2), Ha = $i[0], Va = $i[1], Us = React.useState(null), $s = _slicedToArray$8(Us, 2), Za = $s[0], ml = $s[1], Ys = function(co) {
      ml([co.clientX, co.clientY]);
    }, Bs = useAlign(wl, Qs, An && Za !== null ? Za : lo, Cn, cn, gn, qn), Wa = _slicedToArray$8(Bs, 11), js = Wa[0], Fs = Wa[1], Xi = Wa[2], ao = Wa[3], Sl = Wa[4], xl = Wa[5], fm = Wa[6], Jp = Wa[7], um = Wa[8], sm = Wa[9], em = Wa[10], _m = useAction(Xa, Ge, Xe, ot), wm = _slicedToArray$8(_m, 2), tm = wm[0], cm = wm[1], Lm = tm.has("click"), Om = cm.has("click") || cm.has("contextMenu"), Vm = useEvent(function() {
      ho || em();
    }), ug = function() {
      zs.current && An && Om && Ks(!1);
    };
    useWatch(wl, lo, Qs, Vm, ug), useLayoutEffect$1(function() {
      Vm();
    }, [Za, Cn]), useLayoutEffect$1(function() {
      wl && !(cn != null && cn[Cn]) && Vm();
    }, [JSON.stringify(gn)]);
    var qm = React.useMemo(function() {
      var ro = getAlignPopupClassName$1(cn, je, sm, An);
      return classNames(ro, pn == null ? void 0 : pn(sm));
    }, [sm, pn, cn, je, An]);
    React.useImperativeHandle(we, function() {
      return {
        nativeElement: bl.current,
        popupElement: so.current,
        forceAlign: Vm
      };
    });
    var Tl = React.useState(0), uo = _slicedToArray$8(Tl, 2), om = uo[0], pm = uo[1], zl = React.useState(0), rm = _slicedToArray$8(zl, 2), Zp = rm[0], Am = rm[1], Sm = function() {
      if (un && lo) {
        var co = lo.getBoundingClientRect();
        pm(co.width), Am(co.height);
      }
    }, mm = function() {
      Sm(), Vm();
    }, Rm = function(co) {
      mn(!1), em(), wt == null || wt(co);
    }, $m = function() {
      return new Promise(function(co) {
        Sm(), Va(function() {
          return co;
        });
      });
    };
    useLayoutEffect$1(function() {
      Ha && (em(), Ha(), Va(null));
    }, [Ha]);
    function xm(ro, co, Wl, hm) {
      Bl[ro] = function(lm) {
        var m1;
        hm == null || hm(lm), Ks(co, Wl);
        for (var g1 = arguments.length, Gl = new Array(g1 > 1 ? g1 - 1 : 0), Vl = 1; Vl < g1; Vl++)
          Gl[Vl - 1] = arguments[Vl];
        (m1 = $l[ro]) === null || m1 === void 0 || m1.call.apply(m1, [$l, lm].concat(Gl));
      };
    }
    (Lm || Om) && (Bl.onClick = function(ro) {
      var co;
      zs.current && Om ? Ks(!1) : !zs.current && Lm && (Ys(ro), Ks(!0));
      for (var Wl = arguments.length, hm = new Array(Wl > 1 ? Wl - 1 : 0), lm = 1; lm < Wl; lm++)
        hm[lm - 1] = arguments[lm];
      (co = $l.onClick) === null || co === void 0 || co.call.apply(co, [$l, ro].concat(hm));
    });
    var Ig = useWinClick(wl, Om, lo, Qs, Jr, nn, Fl, Ks), km = tm.has("hover"), Og = cm.has("hover"), yg, cg;
    km && (xm("onMouseEnter", !0, St, function(ro) {
      Ys(ro);
    }), xm("onPointerEnter", !0, St, function(ro) {
      Ys(ro);
    }), yg = function(co) {
      (wl || ho) && Qs !== null && Qs !== void 0 && Qs.contains(co.target) && Ks(!0, St);
    }, An && (Bl.onMouseMove = function(ro) {
      var co;
      (co = $l.onMouseMove) === null || co === void 0 || co.call($l, ro);
    })), Og && (xm("onMouseLeave", !1, Pt), xm("onPointerLeave", !1, Pt), cg = function() {
      Ks(!1, Pt);
    }), tm.has("focus") && xm("onFocus", !0, kt), cm.has("focus") && xm("onBlur", !1, Ot), tm.has("contextMenu") && (Bl.onContextMenu = function(ro) {
      var co;
      zs.current && cm.has("contextMenu") ? Ks(!1) : (Ys(ro), Ks(!0)), ro.preventDefault();
      for (var Wl = arguments.length, hm = new Array(Wl > 1 ? Wl - 1 : 0), lm = 1; lm < Wl; lm++)
        hm[lm - 1] = arguments[lm];
      (co = $l.onContextMenu) === null || co === void 0 || co.call.apply(co, [$l, ro].concat(hm));
    }), ii && (Bl.className = classNames($l.className, ii));
    var zm = _objectSpread2$2(_objectSpread2$2({}, $l), Bl), Eg = {}, Mg = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Mg.forEach(function(ro) {
      ni[ro] && (Eg[ro] = function() {
        for (var co, Wl = arguments.length, hm = new Array(Wl), lm = 0; lm < Wl; lm++)
          hm[lm] = arguments[lm];
        (co = zm[ro]) === null || co === void 0 || co.call.apply(co, [zm].concat(hm)), ni[ro].apply(ni, hm);
      });
    });
    var h1 = /* @__PURE__ */ React.cloneElement(Xl, _objectSpread2$2(_objectSpread2$2({}, zm), Eg)), L1 = {
      x: xl,
      y: fm
    }, p1 = si ? _objectSpread2$2({}, si !== !0 ? si : {}) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RefResizeObserver, {
      disabled: !wl,
      ref: Al,
      onResize: mm
    }, /* @__PURE__ */ React.createElement(TriggerWrapper, {
      getTriggerDOMNode: Fi
    }, h1)), /* @__PURE__ */ React.createElement(TriggerContext$1.Provider, {
      value: Ja
    }, /* @__PURE__ */ React.createElement(Popup$1, {
      portal: ce,
      ref: io,
      prefixCls: je,
      popup: xn,
      className: classNames(bn, qm),
      style: Sn,
      target: lo,
      onMouseEnter: yg,
      onMouseLeave: cg,
      onPointerEnter: yg,
      zIndex: an,
      open: wl,
      keepDom: ho,
      fresh: hn,
      onClick: In,
      onPointerDownCapture: Ig,
      mask: Jr,
      motion: kl,
      maskMotion: ql,
      onVisibleChanged: Rm,
      onPrepare: $m,
      forceRender: fn,
      autoDestroy: Ui,
      getPopupContainer: ln,
      align: sm,
      arrow: p1,
      arrowPos: L1,
      ready: js,
      offsetX: Fs,
      offsetY: Xi,
      offsetR: ao,
      offsetB: Sl,
      onAlign: Vm,
      stretch: un,
      targetWidth: om / Jp,
      targetHeight: Zp / um
    })));
  });
  return process.env.NODE_ENV !== "production" && (ie.displayName = "Trigger"), ie;
}
const Trigger$1 = generateTrigger$1(Portal$1);
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
}, autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: !0
}, targetOffset = [0, 0], placements = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  }
}, _excluded$f = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], Tooltip$1 = function(ie, me) {
  var we = ie.overlayClassName, Re = ie.trigger, je = Re === void 0 ? ["hover"] : Re, Ue = ie.mouseEnterDelay, qe = Ue === void 0 ? 0 : Ue, Ge = ie.mouseLeaveDelay, Xe = Ge === void 0 ? 0.1 : Ge, ot = ie.overlayStyle, vt = ie.prefixCls, bt = vt === void 0 ? "rc-tooltip" : vt, Tt = ie.children, wt = ie.onVisibleChange, St = ie.afterVisibleChange, It = ie.transitionName, Pt = ie.animation, kt = ie.motion, Ot = ie.placement, Jr = Ot === void 0 ? "right" : Ot, en = ie.align, nn = en === void 0 ? {} : en, ln = ie.destroyTooltipOnHide, fn = ln === void 0 ? !1 : ln, vn = ie.defaultVisible, Tn = ie.getTooltipContainer, xn = ie.overlayInnerStyle;
  ie.arrowContent;
  var bn = ie.overlay, Sn = ie.id, Cn = ie.showArrow, kn = Cn === void 0 ? !0 : Cn, cn = ie.classNames, gn = ie.styles, an = _objectWithoutProperties$6(ie, _excluded$f), un = useId$1(Sn), pn = useRef(null);
  useImperativeHandle(me, function() {
    return pn.current;
  });
  var hn = _objectSpread2$2({}, an);
  "visible" in ie && (hn.popupVisible = ie.visible);
  var An = function() {
    return /* @__PURE__ */ React.createElement(Popup$2, {
      key: "content",
      prefixCls: bt,
      id: un,
      bodyClassName: cn == null ? void 0 : cn.body,
      overlayInnerStyle: _objectSpread2$2(_objectSpread2$2({}, xn), gn == null ? void 0 : gn.body)
    }, bn);
  }, In = function() {
    var si = React.Children.only(Tt), bi = (si == null ? void 0 : si.props) || {}, xi = _objectSpread2$2(_objectSpread2$2({}, bi), {}, {
      "aria-describedby": bn ? un : null
    });
    return /* @__PURE__ */ React.cloneElement(Tt, xi);
  };
  return /* @__PURE__ */ React.createElement(Trigger$1, _extends$j({
    popupClassName: classNames(we, cn == null ? void 0 : cn.root),
    prefixCls: bt,
    popup: An,
    action: je,
    builtinPlacements: placements,
    popupPlacement: Jr,
    ref: pn,
    popupAlign: nn,
    getPopupContainer: Tn,
    onPopupVisibleChange: wt,
    afterPopupVisibleChange: St,
    popupTransitionName: It,
    popupAnimation: Pt,
    popupMotion: kt,
    defaultPopupVisible: vn,
    autoDestroy: fn,
    mouseLeaveDelay: Xe,
    popupStyle: _objectSpread2$2(_objectSpread2$2({}, ot), gn == null ? void 0 : gn.root),
    mouseEnterDelay: qe,
    arrow: kn
  }, hn), In());
};
const Tooltip$2 = /* @__PURE__ */ forwardRef(Tooltip$1);
var HotspotStyle;
(function(ce) {
  ce.HotspotWithText = "teach-hotspot", ce.HotspotIcon = "student-hotspot-non-sequenced", ce.HotspotIconVisited = "student-hotspot-non-sequenced--visited", ce.HotspotPolygonal = "hotspot-non-sequenced-polygonal", ce.HotspotPolygonalInvisible = "hotspot-non-sequenced-polygonal-invisible", ce.HotspotPolygonalManager = "hotspot-non-sequenced-polygonal--manager", ce.HotspotPolygonalManagerInvisible = "hotspot-non-sequenced-polygonal--manager-invisible", ce.HotspotPolygonalVisited = "hotspot-non-sequenced-polygonal--visited", ce.HotspotIndicator = "hotspot-indicator", ce.HotspotIndicatorVisited = "hotspot-indicator--visited", ce.HotspotTeleportArrow = "hotspot-teleport-arrow", ce.HotspotConfirmClick = "hotspot-confirm-click";
})(HotspotStyle || (HotspotStyle = {}));
var LayerStyle;
(function(ce) {
  ce.LayerText = "hotspot-text", ce.LayerTextTestMe = "hotspot-text-testme";
})(LayerStyle || (LayerStyle = {}));
var rngBrowser = { exports: {} }, getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  var rnds8 = new Uint8Array(16);
  rngBrowser.exports = function() {
    return getRandomValues(rnds8), rnds8;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function() {
    for (var ie = 0, me; ie < 16; ie++)
      (ie & 3) === 0 && (me = Math.random() * 4294967296), rnds[ie] = me >>> ((ie & 3) << 3) & 255;
    return rnds;
  };
}
var rngBrowserExports = rngBrowser.exports, byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex[i$1] = (i$1 + 256).toString(16).substr(1);
function bytesToUuid$2(ce, ie) {
  var me = ie || 0, we = byteToHex;
  return [
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]],
    "-",
    we[ce[me++]],
    we[ce[me++]],
    "-",
    we[ce[me++]],
    we[ce[me++]],
    "-",
    we[ce[me++]],
    we[ce[me++]],
    "-",
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]],
    we[ce[me++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid$2, rng$1 = rngBrowserExports, bytesToUuid$1 = bytesToUuid_1, _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1$1(ce, ie, me) {
  var we = ie && me || 0, Re = ie || [];
  ce = ce || {};
  var je = ce.node || _nodeId, Ue = ce.clockseq !== void 0 ? ce.clockseq : _clockseq;
  if (je == null || Ue == null) {
    var qe = rng$1();
    je == null && (je = _nodeId = [
      qe[0] | 1,
      qe[1],
      qe[2],
      qe[3],
      qe[4],
      qe[5]
    ]), Ue == null && (Ue = _clockseq = (qe[6] << 8 | qe[7]) & 16383);
  }
  var Ge = ce.msecs !== void 0 ? ce.msecs : (/* @__PURE__ */ new Date()).getTime(), Xe = ce.nsecs !== void 0 ? ce.nsecs : _lastNSecs + 1, ot = Ge - _lastMSecs + (Xe - _lastNSecs) / 1e4;
  if (ot < 0 && ce.clockseq === void 0 && (Ue = Ue + 1 & 16383), (ot < 0 || Ge > _lastMSecs) && ce.nsecs === void 0 && (Xe = 0), Xe >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = Ge, _lastNSecs = Xe, _clockseq = Ue, Ge += 122192928e5;
  var vt = ((Ge & 268435455) * 1e4 + Xe) % 4294967296;
  Re[we++] = vt >>> 24 & 255, Re[we++] = vt >>> 16 & 255, Re[we++] = vt >>> 8 & 255, Re[we++] = vt & 255;
  var bt = Ge / 4294967296 * 1e4 & 268435455;
  Re[we++] = bt >>> 8 & 255, Re[we++] = bt & 255, Re[we++] = bt >>> 24 & 15 | 16, Re[we++] = bt >>> 16 & 255, Re[we++] = Ue >>> 8 | 128, Re[we++] = Ue & 255;
  for (var Tt = 0; Tt < 6; ++Tt)
    Re[we + Tt] = je[Tt];
  return ie || bytesToUuid$1(Re);
}
var v1_1 = v1$1, rng = rngBrowserExports, bytesToUuid = bytesToUuid_1;
function v4$1(ce, ie, me) {
  var we = ie && me || 0;
  typeof ce == "string" && (ie = ce === "binary" ? new Array(16) : null, ce = null), ce = ce || {};
  var Re = ce.random || (ce.rng || rng)();
  if (Re[6] = Re[6] & 15 | 64, Re[8] = Re[8] & 63 | 128, ie)
    for (var je = 0; je < 16; ++je)
      ie[we + je] = Re[je];
  return ie || bytesToUuid(Re);
}
var v4_1 = v4$1, v1 = v1_1, v4 = v4_1, uuid$1 = v4;
uuid$1.v1 = v1;
uuid$1.v4 = v4;
var he$2 = { exports: {} };
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
he$2.exports;
(function(ce, ie) {
  (function(me) {
    var we = ie, Re = ce && ce.exports == we && ce, je = typeof commonjsGlobal == "object" && commonjsGlobal;
    (je.global === je || je.window === je) && (me = je);
    var Ue = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, qe = /[\x01-\x7F]/g, Ge = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g, Xe = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g, ot = { "­": "shy", "‌": "zwnj", "‍": "zwj", "‎": "lrm", "⁣": "ic", "⁢": "it", "⁡": "af", "‏": "rlm", "​": "ZeroWidthSpace", "⁠": "NoBreak", "̑": "DownBreve", "⃛": "tdot", "⃜": "DotDot", "	": "Tab", "\n": "NewLine", " ": "puncsp", " ": "MediumSpace", " ": "thinsp", " ": "hairsp", " ": "emsp13", " ": "ensp", " ": "emsp14", " ": "emsp", " ": "numsp", " ": "nbsp", "  ": "ThickSpace", "‾": "oline", _: "lowbar", "‐": "dash", "–": "ndash", "—": "mdash", "―": "horbar", ",": "comma", ";": "semi", "⁏": "bsemi", ":": "colon", "⩴": "Colone", "!": "excl", "¡": "iexcl", "?": "quest", "¿": "iquest", ".": "period", "‥": "nldr", "…": "mldr", "·": "middot", "'": "apos", "‘": "lsquo", "’": "rsquo", "‚": "sbquo", "‹": "lsaquo", "›": "rsaquo", '"': "quot", "“": "ldquo", "”": "rdquo", "„": "bdquo", "«": "laquo", "»": "raquo", "(": "lpar", ")": "rpar", "[": "lsqb", "]": "rsqb", "{": "lcub", "}": "rcub", "⌈": "lceil", "⌉": "rceil", "⌊": "lfloor", "⌋": "rfloor", "⦅": "lopar", "⦆": "ropar", "⦋": "lbrke", "⦌": "rbrke", "⦍": "lbrkslu", "⦎": "rbrksld", "⦏": "lbrksld", "⦐": "rbrkslu", "⦑": "langd", "⦒": "rangd", "⦓": "lparlt", "⦔": "rpargt", "⦕": "gtlPar", "⦖": "ltrPar", "⟦": "lobrk", "⟧": "robrk", "⟨": "lang", "⟩": "rang", "⟪": "Lang", "⟫": "Rang", "⟬": "loang", "⟭": "roang", "❲": "lbbrk", "❳": "rbbrk", "‖": "Vert", "§": "sect", "¶": "para", "@": "commat", "*": "ast", "/": "sol", undefined: null, "&": "amp", "#": "num", "%": "percnt", "‰": "permil", "‱": "pertenk", "†": "dagger", "‡": "Dagger", "•": "bull", "⁃": "hybull", "′": "prime", "″": "Prime", "‴": "tprime", "⁗": "qprime", "‵": "bprime", "⁁": "caret", "`": "grave", "´": "acute", "˜": "tilde", "^": "Hat", "¯": "macr", "˘": "breve", "˙": "dot", "¨": "die", "˚": "ring", "˝": "dblac", "¸": "cedil", "˛": "ogon", "ˆ": "circ", "ˇ": "caron", "°": "deg", "©": "copy", "®": "reg", "℗": "copysr", "℘": "wp", "℞": "rx", "℧": "mho", "℩": "iiota", "←": "larr", "↚": "nlarr", "→": "rarr", "↛": "nrarr", "↑": "uarr", "↓": "darr", "↔": "harr", "↮": "nharr", "↕": "varr", "↖": "nwarr", "↗": "nearr", "↘": "searr", "↙": "swarr", "↝": "rarrw", "↝̸": "nrarrw", "↞": "Larr", "↟": "Uarr", "↠": "Rarr", "↡": "Darr", "↢": "larrtl", "↣": "rarrtl", "↤": "mapstoleft", "↥": "mapstoup", "↦": "map", "↧": "mapstodown", "↩": "larrhk", "↪": "rarrhk", "↫": "larrlp", "↬": "rarrlp", "↭": "harrw", "↰": "lsh", "↱": "rsh", "↲": "ldsh", "↳": "rdsh", "↵": "crarr", "↶": "cularr", "↷": "curarr", "↺": "olarr", "↻": "orarr", "↼": "lharu", "↽": "lhard", "↾": "uharr", "↿": "uharl", "⇀": "rharu", "⇁": "rhard", "⇂": "dharr", "⇃": "dharl", "⇄": "rlarr", "⇅": "udarr", "⇆": "lrarr", "⇇": "llarr", "⇈": "uuarr", "⇉": "rrarr", "⇊": "ddarr", "⇋": "lrhar", "⇌": "rlhar", "⇐": "lArr", "⇍": "nlArr", "⇑": "uArr", "⇒": "rArr", "⇏": "nrArr", "⇓": "dArr", "⇔": "iff", "⇎": "nhArr", "⇕": "vArr", "⇖": "nwArr", "⇗": "neArr", "⇘": "seArr", "⇙": "swArr", "⇚": "lAarr", "⇛": "rAarr", "⇝": "zigrarr", "⇤": "larrb", "⇥": "rarrb", "⇵": "duarr", "⇽": "loarr", "⇾": "roarr", "⇿": "hoarr", "∀": "forall", "∁": "comp", "∂": "part", "∂̸": "npart", "∃": "exist", "∄": "nexist", "∅": "empty", "∇": "Del", "∈": "in", "∉": "notin", "∋": "ni", "∌": "notni", "϶": "bepsi", "∏": "prod", "∐": "coprod", "∑": "sum", "+": "plus", "±": "pm", "÷": "div", "×": "times", "<": "lt", "≮": "nlt", "<⃒": "nvlt", "=": "equals", "≠": "ne", "=⃥": "bne", "⩵": "Equal", ">": "gt", "≯": "ngt", ">⃒": "nvgt", "¬": "not", "|": "vert", "¦": "brvbar", "−": "minus", "∓": "mp", "∔": "plusdo", "⁄": "frasl", "∖": "setmn", "∗": "lowast", "∘": "compfn", "√": "Sqrt", "∝": "prop", "∞": "infin", "∟": "angrt", "∠": "ang", "∠⃒": "nang", "∡": "angmsd", "∢": "angsph", "∣": "mid", "∤": "nmid", "∥": "par", "∦": "npar", "∧": "and", "∨": "or", "∩": "cap", "∩︀": "caps", "∪": "cup", "∪︀": "cups", "∫": "int", "∬": "Int", "∭": "tint", "⨌": "qint", "∮": "oint", "∯": "Conint", "∰": "Cconint", "∱": "cwint", "∲": "cwconint", "∳": "awconint", "∴": "there4", "∵": "becaus", "∶": "ratio", "∷": "Colon", "∸": "minusd", "∺": "mDDot", "∻": "homtht", "∼": "sim", "≁": "nsim", "∼⃒": "nvsim", "∽": "bsim", "∽̱": "race", "∾": "ac", "∾̳": "acE", "∿": "acd", "≀": "wr", "≂": "esim", "≂̸": "nesim", "≃": "sime", "≄": "nsime", "≅": "cong", "≇": "ncong", "≆": "simne", "≈": "ap", "≉": "nap", "≊": "ape", "≋": "apid", "≋̸": "napid", "≌": "bcong", "≍": "CupCap", "≭": "NotCupCap", "≍⃒": "nvap", "≎": "bump", "≎̸": "nbump", "≏": "bumpe", "≏̸": "nbumpe", "≐": "doteq", "≐̸": "nedot", "≑": "eDot", "≒": "efDot", "≓": "erDot", "≔": "colone", "≕": "ecolon", "≖": "ecir", "≗": "cire", "≙": "wedgeq", "≚": "veeeq", "≜": "trie", "≟": "equest", "≡": "equiv", "≢": "nequiv", "≡⃥": "bnequiv", "≤": "le", "≰": "nle", "≤⃒": "nvle", "≥": "ge", "≱": "nge", "≥⃒": "nvge", "≦": "lE", "≦̸": "nlE", "≧": "gE", "≧̸": "ngE", "≨︀": "lvnE", "≨": "lnE", "≩": "gnE", "≩︀": "gvnE", "≪": "ll", "≪̸": "nLtv", "≪⃒": "nLt", "≫": "gg", "≫̸": "nGtv", "≫⃒": "nGt", "≬": "twixt", "≲": "lsim", "≴": "nlsim", "≳": "gsim", "≵": "ngsim", "≶": "lg", "≸": "ntlg", "≷": "gl", "≹": "ntgl", "≺": "pr", "⊀": "npr", "≻": "sc", "⊁": "nsc", "≼": "prcue", "⋠": "nprcue", "≽": "sccue", "⋡": "nsccue", "≾": "prsim", "≿": "scsim", "≿̸": "NotSucceedsTilde", "⊂": "sub", "⊄": "nsub", "⊂⃒": "vnsub", "⊃": "sup", "⊅": "nsup", "⊃⃒": "vnsup", "⊆": "sube", "⊈": "nsube", "⊇": "supe", "⊉": "nsupe", "⊊︀": "vsubne", "⊊": "subne", "⊋︀": "vsupne", "⊋": "supne", "⊍": "cupdot", "⊎": "uplus", "⊏": "sqsub", "⊏̸": "NotSquareSubset", "⊐": "sqsup", "⊐̸": "NotSquareSuperset", "⊑": "sqsube", "⋢": "nsqsube", "⊒": "sqsupe", "⋣": "nsqsupe", "⊓": "sqcap", "⊓︀": "sqcaps", "⊔": "sqcup", "⊔︀": "sqcups", "⊕": "oplus", "⊖": "ominus", "⊗": "otimes", "⊘": "osol", "⊙": "odot", "⊚": "ocir", "⊛": "oast", "⊝": "odash", "⊞": "plusb", "⊟": "minusb", "⊠": "timesb", "⊡": "sdotb", "⊢": "vdash", "⊬": "nvdash", "⊣": "dashv", "⊤": "top", "⊥": "bot", "⊧": "models", "⊨": "vDash", "⊭": "nvDash", "⊩": "Vdash", "⊮": "nVdash", "⊪": "Vvdash", "⊫": "VDash", "⊯": "nVDash", "⊰": "prurel", "⊲": "vltri", "⋪": "nltri", "⊳": "vrtri", "⋫": "nrtri", "⊴": "ltrie", "⋬": "nltrie", "⊴⃒": "nvltrie", "⊵": "rtrie", "⋭": "nrtrie", "⊵⃒": "nvrtrie", "⊶": "origof", "⊷": "imof", "⊸": "mumap", "⊹": "hercon", "⊺": "intcal", "⊻": "veebar", "⊽": "barvee", "⊾": "angrtvb", "⊿": "lrtri", "⋀": "Wedge", "⋁": "Vee", "⋂": "xcap", "⋃": "xcup", "⋄": "diam", "⋅": "sdot", "⋆": "Star", "⋇": "divonx", "⋈": "bowtie", "⋉": "ltimes", "⋊": "rtimes", "⋋": "lthree", "⋌": "rthree", "⋍": "bsime", "⋎": "cuvee", "⋏": "cuwed", "⋐": "Sub", "⋑": "Sup", "⋒": "Cap", "⋓": "Cup", "⋔": "fork", "⋕": "epar", "⋖": "ltdot", "⋗": "gtdot", "⋘": "Ll", "⋘̸": "nLl", "⋙": "Gg", "⋙̸": "nGg", "⋚︀": "lesg", "⋚": "leg", "⋛": "gel", "⋛︀": "gesl", "⋞": "cuepr", "⋟": "cuesc", "⋦": "lnsim", "⋧": "gnsim", "⋨": "prnsim", "⋩": "scnsim", "⋮": "vellip", "⋯": "ctdot", "⋰": "utdot", "⋱": "dtdot", "⋲": "disin", "⋳": "isinsv", "⋴": "isins", "⋵": "isindot", "⋵̸": "notindot", "⋶": "notinvc", "⋷": "notinvb", "⋹": "isinE", "⋹̸": "notinE", "⋺": "nisd", "⋻": "xnis", "⋼": "nis", "⋽": "notnivc", "⋾": "notnivb", "⌅": "barwed", "⌆": "Barwed", "⌌": "drcrop", "⌍": "dlcrop", "⌎": "urcrop", "⌏": "ulcrop", "⌐": "bnot", "⌒": "profline", "⌓": "profsurf", "⌕": "telrec", "⌖": "target", "⌜": "ulcorn", "⌝": "urcorn", "⌞": "dlcorn", "⌟": "drcorn", "⌢": "frown", "⌣": "smile", "⌭": "cylcty", "⌮": "profalar", "⌶": "topbot", "⌽": "ovbar", "⌿": "solbar", "⍼": "angzarr", "⎰": "lmoust", "⎱": "rmoust", "⎴": "tbrk", "⎵": "bbrk", "⎶": "bbrktbrk", "⏜": "OverParenthesis", "⏝": "UnderParenthesis", "⏞": "OverBrace", "⏟": "UnderBrace", "⏢": "trpezium", "⏧": "elinters", "␣": "blank", "─": "boxh", "│": "boxv", "┌": "boxdr", "┐": "boxdl", "└": "boxur", "┘": "boxul", "├": "boxvr", "┤": "boxvl", "┬": "boxhd", "┴": "boxhu", "┼": "boxvh", "═": "boxH", "║": "boxV", "╒": "boxdR", "╓": "boxDr", "╔": "boxDR", "╕": "boxdL", "╖": "boxDl", "╗": "boxDL", "╘": "boxuR", "╙": "boxUr", "╚": "boxUR", "╛": "boxuL", "╜": "boxUl", "╝": "boxUL", "╞": "boxvR", "╟": "boxVr", "╠": "boxVR", "╡": "boxvL", "╢": "boxVl", "╣": "boxVL", "╤": "boxHd", "╥": "boxhD", "╦": "boxHD", "╧": "boxHu", "╨": "boxhU", "╩": "boxHU", "╪": "boxvH", "╫": "boxVh", "╬": "boxVH", "▀": "uhblk", "▄": "lhblk", "█": "block", "░": "blk14", "▒": "blk12", "▓": "blk34", "□": "squ", "▪": "squf", "▫": "EmptyVerySmallSquare", "▭": "rect", "▮": "marker", "▱": "fltns", "△": "xutri", "▴": "utrif", "▵": "utri", "▸": "rtrif", "▹": "rtri", "▽": "xdtri", "▾": "dtrif", "▿": "dtri", "◂": "ltrif", "◃": "ltri", "◊": "loz", "○": "cir", "◬": "tridot", "◯": "xcirc", "◸": "ultri", "◹": "urtri", "◺": "lltri", "◻": "EmptySmallSquare", "◼": "FilledSmallSquare", "★": "starf", "☆": "star", "☎": "phone", "♀": "female", "♂": "male", "♠": "spades", "♣": "clubs", "♥": "hearts", "♦": "diams", "♪": "sung", "✓": "check", "✗": "cross", "✠": "malt", "✶": "sext", "❘": "VerticalSeparator", "⟈": "bsolhsub", "⟉": "suphsol", "⟵": "xlarr", "⟶": "xrarr", "⟷": "xharr", "⟸": "xlArr", "⟹": "xrArr", "⟺": "xhArr", "⟼": "xmap", "⟿": "dzigrarr", "⤂": "nvlArr", "⤃": "nvrArr", "⤄": "nvHarr", "⤅": "Map", "⤌": "lbarr", "⤍": "rbarr", "⤎": "lBarr", "⤏": "rBarr", "⤐": "RBarr", "⤑": "DDotrahd", "⤒": "UpArrowBar", "⤓": "DownArrowBar", "⤖": "Rarrtl", "⤙": "latail", "⤚": "ratail", "⤛": "lAtail", "⤜": "rAtail", "⤝": "larrfs", "⤞": "rarrfs", "⤟": "larrbfs", "⤠": "rarrbfs", "⤣": "nwarhk", "⤤": "nearhk", "⤥": "searhk", "⤦": "swarhk", "⤧": "nwnear", "⤨": "toea", "⤩": "tosa", "⤪": "swnwar", "⤳": "rarrc", "⤳̸": "nrarrc", "⤵": "cudarrr", "⤶": "ldca", "⤷": "rdca", "⤸": "cudarrl", "⤹": "larrpl", "⤼": "curarrm", "⤽": "cularrp", "⥅": "rarrpl", "⥈": "harrcir", "⥉": "Uarrocir", "⥊": "lurdshar", "⥋": "ldrushar", "⥎": "LeftRightVector", "⥏": "RightUpDownVector", "⥐": "DownLeftRightVector", "⥑": "LeftUpDownVector", "⥒": "LeftVectorBar", "⥓": "RightVectorBar", "⥔": "RightUpVectorBar", "⥕": "RightDownVectorBar", "⥖": "DownLeftVectorBar", "⥗": "DownRightVectorBar", "⥘": "LeftUpVectorBar", "⥙": "LeftDownVectorBar", "⥚": "LeftTeeVector", "⥛": "RightTeeVector", "⥜": "RightUpTeeVector", "⥝": "RightDownTeeVector", "⥞": "DownLeftTeeVector", "⥟": "DownRightTeeVector", "⥠": "LeftUpTeeVector", "⥡": "LeftDownTeeVector", "⥢": "lHar", "⥣": "uHar", "⥤": "rHar", "⥥": "dHar", "⥦": "luruhar", "⥧": "ldrdhar", "⥨": "ruluhar", "⥩": "rdldhar", "⥪": "lharul", "⥫": "llhard", "⥬": "rharul", "⥭": "lrhard", "⥮": "udhar", "⥯": "duhar", "⥰": "RoundImplies", "⥱": "erarr", "⥲": "simrarr", "⥳": "larrsim", "⥴": "rarrsim", "⥵": "rarrap", "⥶": "ltlarr", "⥸": "gtrarr", "⥹": "subrarr", "⥻": "suplarr", "⥼": "lfisht", "⥽": "rfisht", "⥾": "ufisht", "⥿": "dfisht", "⦚": "vzigzag", "⦜": "vangrt", "⦝": "angrtvbd", "⦤": "ange", "⦥": "range", "⦦": "dwangle", "⦧": "uwangle", "⦨": "angmsdaa", "⦩": "angmsdab", "⦪": "angmsdac", "⦫": "angmsdad", "⦬": "angmsdae", "⦭": "angmsdaf", "⦮": "angmsdag", "⦯": "angmsdah", "⦰": "bemptyv", "⦱": "demptyv", "⦲": "cemptyv", "⦳": "raemptyv", "⦴": "laemptyv", "⦵": "ohbar", "⦶": "omid", "⦷": "opar", "⦹": "operp", "⦻": "olcross", "⦼": "odsold", "⦾": "olcir", "⦿": "ofcir", "⧀": "olt", "⧁": "ogt", "⧂": "cirscir", "⧃": "cirE", "⧄": "solb", "⧅": "bsolb", "⧉": "boxbox", "⧍": "trisb", "⧎": "rtriltri", "⧏": "LeftTriangleBar", "⧏̸": "NotLeftTriangleBar", "⧐": "RightTriangleBar", "⧐̸": "NotRightTriangleBar", "⧜": "iinfin", "⧝": "infintie", "⧞": "nvinfin", "⧣": "eparsl", "⧤": "smeparsl", "⧥": "eqvparsl", "⧫": "lozf", "⧴": "RuleDelayed", "⧶": "dsol", "⨀": "xodot", "⨁": "xoplus", "⨂": "xotime", "⨄": "xuplus", "⨆": "xsqcup", "⨍": "fpartint", "⨐": "cirfnint", "⨑": "awint", "⨒": "rppolint", "⨓": "scpolint", "⨔": "npolint", "⨕": "pointint", "⨖": "quatint", "⨗": "intlarhk", "⨢": "pluscir", "⨣": "plusacir", "⨤": "simplus", "⨥": "plusdu", "⨦": "plussim", "⨧": "plustwo", "⨩": "mcomma", "⨪": "minusdu", "⨭": "loplus", "⨮": "roplus", "⨯": "Cross", "⨰": "timesd", "⨱": "timesbar", "⨳": "smashp", "⨴": "lotimes", "⨵": "rotimes", "⨶": "otimesas", "⨷": "Otimes", "⨸": "odiv", "⨹": "triplus", "⨺": "triminus", "⨻": "tritime", "⨼": "iprod", "⨿": "amalg", "⩀": "capdot", "⩂": "ncup", "⩃": "ncap", "⩄": "capand", "⩅": "cupor", "⩆": "cupcap", "⩇": "capcup", "⩈": "cupbrcap", "⩉": "capbrcup", "⩊": "cupcup", "⩋": "capcap", "⩌": "ccups", "⩍": "ccaps", "⩐": "ccupssm", "⩓": "And", "⩔": "Or", "⩕": "andand", "⩖": "oror", "⩗": "orslope", "⩘": "andslope", "⩚": "andv", "⩛": "orv", "⩜": "andd", "⩝": "ord", "⩟": "wedbar", "⩦": "sdote", "⩪": "simdot", "⩭": "congdot", "⩭̸": "ncongdot", "⩮": "easter", "⩯": "apacir", "⩰": "apE", "⩰̸": "napE", "⩱": "eplus", "⩲": "pluse", "⩳": "Esim", "⩷": "eDDot", "⩸": "equivDD", "⩹": "ltcir", "⩺": "gtcir", "⩻": "ltquest", "⩼": "gtquest", "⩽": "les", "⩽̸": "nles", "⩾": "ges", "⩾̸": "nges", "⩿": "lesdot", "⪀": "gesdot", "⪁": "lesdoto", "⪂": "gesdoto", "⪃": "lesdotor", "⪄": "gesdotol", "⪅": "lap", "⪆": "gap", "⪇": "lne", "⪈": "gne", "⪉": "lnap", "⪊": "gnap", "⪋": "lEg", "⪌": "gEl", "⪍": "lsime", "⪎": "gsime", "⪏": "lsimg", "⪐": "gsiml", "⪑": "lgE", "⪒": "glE", "⪓": "lesges", "⪔": "gesles", "⪕": "els", "⪖": "egs", "⪗": "elsdot", "⪘": "egsdot", "⪙": "el", "⪚": "eg", "⪝": "siml", "⪞": "simg", "⪟": "simlE", "⪠": "simgE", "⪡": "LessLess", "⪡̸": "NotNestedLessLess", "⪢": "GreaterGreater", "⪢̸": "NotNestedGreaterGreater", "⪤": "glj", "⪥": "gla", "⪦": "ltcc", "⪧": "gtcc", "⪨": "lescc", "⪩": "gescc", "⪪": "smt", "⪫": "lat", "⪬": "smte", "⪬︀": "smtes", "⪭": "late", "⪭︀": "lates", "⪮": "bumpE", "⪯": "pre", "⪯̸": "npre", "⪰": "sce", "⪰̸": "nsce", "⪳": "prE", "⪴": "scE", "⪵": "prnE", "⪶": "scnE", "⪷": "prap", "⪸": "scap", "⪹": "prnap", "⪺": "scnap", "⪻": "Pr", "⪼": "Sc", "⪽": "subdot", "⪾": "supdot", "⪿": "subplus", "⫀": "supplus", "⫁": "submult", "⫂": "supmult", "⫃": "subedot", "⫄": "supedot", "⫅": "subE", "⫅̸": "nsubE", "⫆": "supE", "⫆̸": "nsupE", "⫇": "subsim", "⫈": "supsim", "⫋︀": "vsubnE", "⫋": "subnE", "⫌︀": "vsupnE", "⫌": "supnE", "⫏": "csub", "⫐": "csup", "⫑": "csube", "⫒": "csupe", "⫓": "subsup", "⫔": "supsub", "⫕": "subsub", "⫖": "supsup", "⫗": "suphsub", "⫘": "supdsub", "⫙": "forkv", "⫚": "topfork", "⫛": "mlcp", "⫤": "Dashv", "⫦": "Vdashl", "⫧": "Barv", "⫨": "vBar", "⫩": "vBarv", "⫫": "Vbar", "⫬": "Not", "⫭": "bNot", "⫮": "rnmid", "⫯": "cirmid", "⫰": "midcir", "⫱": "topcir", "⫲": "nhpar", "⫳": "parsim", "⫽": "parsl", "⫽⃥": "nparsl", "♭": "flat", "♮": "natur", "♯": "sharp", "¤": "curren", "¢": "cent", $: "dollar", "£": "pound", "¥": "yen", "€": "euro", "¹": "sup1", "½": "half", "⅓": "frac13", "¼": "frac14", "⅕": "frac15", "⅙": "frac16", "⅛": "frac18", "²": "sup2", "⅔": "frac23", "⅖": "frac25", "³": "sup3", "¾": "frac34", "⅗": "frac35", "⅜": "frac38", "⅘": "frac45", "⅚": "frac56", "⅝": "frac58", "⅞": "frac78", "𝒶": "ascr", "𝕒": "aopf", "𝔞": "afr", "𝔸": "Aopf", "𝔄": "Afr", "𝒜": "Ascr", ª: "ordf", á: "aacute", Á: "Aacute", à: "agrave", À: "Agrave", ă: "abreve", Ă: "Abreve", â: "acirc", Â: "Acirc", å: "aring", Å: "angst", ä: "auml", Ä: "Auml", ã: "atilde", Ã: "Atilde", ą: "aogon", Ą: "Aogon", ā: "amacr", Ā: "Amacr", æ: "aelig", Æ: "AElig", "𝒷": "bscr", "𝕓": "bopf", "𝔟": "bfr", "𝔹": "Bopf", ℬ: "Bscr", "𝔅": "Bfr", "𝔠": "cfr", "𝒸": "cscr", "𝕔": "copf", ℭ: "Cfr", "𝒞": "Cscr", ℂ: "Copf", ć: "cacute", Ć: "Cacute", ĉ: "ccirc", Ĉ: "Ccirc", č: "ccaron", Č: "Ccaron", ċ: "cdot", Ċ: "Cdot", ç: "ccedil", Ç: "Ccedil", "℅": "incare", "𝔡": "dfr", "ⅆ": "dd", "𝕕": "dopf", "𝒹": "dscr", "𝒟": "Dscr", "𝔇": "Dfr", "ⅅ": "DD", "𝔻": "Dopf", ď: "dcaron", Ď: "Dcaron", đ: "dstrok", Đ: "Dstrok", ð: "eth", Ð: "ETH", "ⅇ": "ee", ℯ: "escr", "𝔢": "efr", "𝕖": "eopf", ℰ: "Escr", "𝔈": "Efr", "𝔼": "Eopf", é: "eacute", É: "Eacute", è: "egrave", È: "Egrave", ê: "ecirc", Ê: "Ecirc", ě: "ecaron", Ě: "Ecaron", ë: "euml", Ë: "Euml", ė: "edot", Ė: "Edot", ę: "eogon", Ę: "Eogon", ē: "emacr", Ē: "Emacr", "𝔣": "ffr", "𝕗": "fopf", "𝒻": "fscr", "𝔉": "Ffr", "𝔽": "Fopf", ℱ: "Fscr", ﬀ: "fflig", ﬃ: "ffilig", ﬄ: "ffllig", ﬁ: "filig", fj: "fjlig", ﬂ: "fllig", ƒ: "fnof", ℊ: "gscr", "𝕘": "gopf", "𝔤": "gfr", "𝒢": "Gscr", "𝔾": "Gopf", "𝔊": "Gfr", ǵ: "gacute", ğ: "gbreve", Ğ: "Gbreve", ĝ: "gcirc", Ĝ: "Gcirc", ġ: "gdot", Ġ: "Gdot", Ģ: "Gcedil", "𝔥": "hfr", ℎ: "planckh", "𝒽": "hscr", "𝕙": "hopf", ℋ: "Hscr", ℌ: "Hfr", ℍ: "Hopf", ĥ: "hcirc", Ĥ: "Hcirc", ℏ: "hbar", ħ: "hstrok", Ħ: "Hstrok", "𝕚": "iopf", "𝔦": "ifr", "𝒾": "iscr", "ⅈ": "ii", "𝕀": "Iopf", ℐ: "Iscr", ℑ: "Im", í: "iacute", Í: "Iacute", ì: "igrave", Ì: "Igrave", î: "icirc", Î: "Icirc", ï: "iuml", Ï: "Iuml", ĩ: "itilde", Ĩ: "Itilde", İ: "Idot", į: "iogon", Į: "Iogon", ī: "imacr", Ī: "Imacr", ĳ: "ijlig", Ĳ: "IJlig", ı: "imath", "𝒿": "jscr", "𝕛": "jopf", "𝔧": "jfr", "𝒥": "Jscr", "𝔍": "Jfr", "𝕁": "Jopf", ĵ: "jcirc", Ĵ: "Jcirc", "ȷ": "jmath", "𝕜": "kopf", "𝓀": "kscr", "𝔨": "kfr", "𝒦": "Kscr", "𝕂": "Kopf", "𝔎": "Kfr", ķ: "kcedil", Ķ: "Kcedil", "𝔩": "lfr", "𝓁": "lscr", ℓ: "ell", "𝕝": "lopf", ℒ: "Lscr", "𝔏": "Lfr", "𝕃": "Lopf", ĺ: "lacute", Ĺ: "Lacute", ľ: "lcaron", Ľ: "Lcaron", ļ: "lcedil", Ļ: "Lcedil", ł: "lstrok", Ł: "Lstrok", ŀ: "lmidot", Ŀ: "Lmidot", "𝔪": "mfr", "𝕞": "mopf", "𝓂": "mscr", "𝔐": "Mfr", "𝕄": "Mopf", ℳ: "Mscr", "𝔫": "nfr", "𝕟": "nopf", "𝓃": "nscr", ℕ: "Nopf", "𝒩": "Nscr", "𝔑": "Nfr", ń: "nacute", Ń: "Nacute", ň: "ncaron", Ň: "Ncaron", ñ: "ntilde", Ñ: "Ntilde", ņ: "ncedil", Ņ: "Ncedil", "№": "numero", ŋ: "eng", Ŋ: "ENG", "𝕠": "oopf", "𝔬": "ofr", ℴ: "oscr", "𝒪": "Oscr", "𝔒": "Ofr", "𝕆": "Oopf", º: "ordm", ó: "oacute", Ó: "Oacute", ò: "ograve", Ò: "Ograve", ô: "ocirc", Ô: "Ocirc", ö: "ouml", Ö: "Ouml", ő: "odblac", Ő: "Odblac", õ: "otilde", Õ: "Otilde", ø: "oslash", Ø: "Oslash", ō: "omacr", Ō: "Omacr", œ: "oelig", Œ: "OElig", "𝔭": "pfr", "𝓅": "pscr", "𝕡": "popf", ℙ: "Popf", "𝔓": "Pfr", "𝒫": "Pscr", "𝕢": "qopf", "𝔮": "qfr", "𝓆": "qscr", "𝒬": "Qscr", "𝔔": "Qfr", ℚ: "Qopf", ĸ: "kgreen", "𝔯": "rfr", "𝕣": "ropf", "𝓇": "rscr", ℛ: "Rscr", ℜ: "Re", ℝ: "Ropf", ŕ: "racute", Ŕ: "Racute", ř: "rcaron", Ř: "Rcaron", ŗ: "rcedil", Ŗ: "Rcedil", "𝕤": "sopf", "𝓈": "sscr", "𝔰": "sfr", "𝕊": "Sopf", "𝔖": "Sfr", "𝒮": "Sscr", "Ⓢ": "oS", ś: "sacute", Ś: "Sacute", ŝ: "scirc", Ŝ: "Scirc", š: "scaron", Š: "Scaron", ş: "scedil", Ş: "Scedil", ß: "szlig", "𝔱": "tfr", "𝓉": "tscr", "𝕥": "topf", "𝒯": "Tscr", "𝔗": "Tfr", "𝕋": "Topf", ť: "tcaron", Ť: "Tcaron", ţ: "tcedil", Ţ: "Tcedil", "™": "trade", ŧ: "tstrok", Ŧ: "Tstrok", "𝓊": "uscr", "𝕦": "uopf", "𝔲": "ufr", "𝕌": "Uopf", "𝔘": "Ufr", "𝒰": "Uscr", ú: "uacute", Ú: "Uacute", ù: "ugrave", Ù: "Ugrave", ŭ: "ubreve", Ŭ: "Ubreve", û: "ucirc", Û: "Ucirc", ů: "uring", Ů: "Uring", ü: "uuml", Ü: "Uuml", ű: "udblac", Ű: "Udblac", ũ: "utilde", Ũ: "Utilde", ų: "uogon", Ų: "Uogon", ū: "umacr", Ū: "Umacr", "𝔳": "vfr", "𝕧": "vopf", "𝓋": "vscr", "𝔙": "Vfr", "𝕍": "Vopf", "𝒱": "Vscr", "𝕨": "wopf", "𝓌": "wscr", "𝔴": "wfr", "𝒲": "Wscr", "𝕎": "Wopf", "𝔚": "Wfr", ŵ: "wcirc", Ŵ: "Wcirc", "𝔵": "xfr", "𝓍": "xscr", "𝕩": "xopf", "𝕏": "Xopf", "𝔛": "Xfr", "𝒳": "Xscr", "𝔶": "yfr", "𝓎": "yscr", "𝕪": "yopf", "𝒴": "Yscr", "𝔜": "Yfr", "𝕐": "Yopf", ý: "yacute", Ý: "Yacute", ŷ: "ycirc", Ŷ: "Ycirc", ÿ: "yuml", Ÿ: "Yuml", "𝓏": "zscr", "𝔷": "zfr", "𝕫": "zopf", ℨ: "Zfr", ℤ: "Zopf", "𝒵": "Zscr", ź: "zacute", Ź: "Zacute", ž: "zcaron", Ž: "Zcaron", ż: "zdot", Ż: "Zdot", Ƶ: "imped", þ: "thorn", Þ: "THORN", ŉ: "napos", α: "alpha", Α: "Alpha", β: "beta", Β: "Beta", γ: "gamma", Γ: "Gamma", δ: "delta", Δ: "Delta", ε: "epsi", "ϵ": "epsiv", Ε: "Epsilon", ϝ: "gammad", Ϝ: "Gammad", ζ: "zeta", Ζ: "Zeta", η: "eta", Η: "Eta", θ: "theta", ϑ: "thetav", Θ: "Theta", ι: "iota", Ι: "Iota", κ: "kappa", ϰ: "kappav", Κ: "Kappa", λ: "lambda", Λ: "Lambda", μ: "mu", µ: "micro", Μ: "Mu", ν: "nu", Ν: "Nu", ξ: "xi", Ξ: "Xi", ο: "omicron", Ο: "Omicron", π: "pi", ϖ: "piv", Π: "Pi", ρ: "rho", ϱ: "rhov", Ρ: "Rho", σ: "sigma", Σ: "Sigma", ς: "sigmaf", τ: "tau", Τ: "Tau", υ: "upsi", Υ: "Upsilon", ϒ: "Upsi", φ: "phi", ϕ: "phiv", Φ: "Phi", χ: "chi", Χ: "Chi", ψ: "psi", Ψ: "Psi", ω: "omega", Ω: "ohm", а: "acy", А: "Acy", б: "bcy", Б: "Bcy", в: "vcy", В: "Vcy", г: "gcy", Г: "Gcy", ѓ: "gjcy", Ѓ: "GJcy", д: "dcy", Д: "Dcy", ђ: "djcy", Ђ: "DJcy", е: "iecy", Е: "IEcy", ё: "iocy", Ё: "IOcy", є: "jukcy", Є: "Jukcy", ж: "zhcy", Ж: "ZHcy", з: "zcy", З: "Zcy", ѕ: "dscy", Ѕ: "DScy", и: "icy", И: "Icy", і: "iukcy", І: "Iukcy", ї: "yicy", Ї: "YIcy", й: "jcy", Й: "Jcy", ј: "jsercy", Ј: "Jsercy", к: "kcy", К: "Kcy", ќ: "kjcy", Ќ: "KJcy", л: "lcy", Л: "Lcy", љ: "ljcy", Љ: "LJcy", м: "mcy", М: "Mcy", н: "ncy", Н: "Ncy", њ: "njcy", Њ: "NJcy", о: "ocy", О: "Ocy", п: "pcy", П: "Pcy", р: "rcy", Р: "Rcy", с: "scy", С: "Scy", т: "tcy", Т: "Tcy", ћ: "tshcy", Ћ: "TSHcy", у: "ucy", У: "Ucy", ў: "ubrcy", Ў: "Ubrcy", ф: "fcy", Ф: "Fcy", х: "khcy", Х: "KHcy", ц: "tscy", Ц: "TScy", ч: "chcy", Ч: "CHcy", џ: "dzcy", Џ: "DZcy", ш: "shcy", Ш: "SHcy", щ: "shchcy", Щ: "SHCHcy", ъ: "hardcy", Ъ: "HARDcy", ы: "ycy", Ы: "Ycy", ь: "softcy", Ь: "SOFTcy", э: "ecy", Э: "Ecy", ю: "yucy", Ю: "YUcy", я: "yacy", Я: "YAcy", ℵ: "aleph", ℶ: "beth", ℷ: "gimel", ℸ: "daleth" }, vt = /["&'<>`]/g, bt = {
      '"': "&quot;",
      "&": "&amp;",
      "'": "&#x27;",
      "<": "&lt;",
      // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
      // following is not strictly necessary unless it’s part of a tag or an
      // unquoted attribute value. We’re only escaping it to support those
      // situations, and for XML support.
      ">": "&gt;",
      // In Internet Explorer ≤ 8, the backtick character can be used
      // to break out of (un)quoted attribute values or HTML comments.
      // See http://html5sec.org/#102, http://html5sec.org/#108, and
      // http://html5sec.org/#133.
      "`": "&#x60;"
    }, Tt = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/, wt = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, St = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g, It = { aacute: "á", Aacute: "Á", abreve: "ă", Abreve: "Ă", ac: "∾", acd: "∿", acE: "∾̳", acirc: "â", Acirc: "Â", acute: "´", acy: "а", Acy: "А", aelig: "æ", AElig: "Æ", af: "⁡", afr: "𝔞", Afr: "𝔄", agrave: "à", Agrave: "À", alefsym: "ℵ", aleph: "ℵ", alpha: "α", Alpha: "Α", amacr: "ā", Amacr: "Ā", amalg: "⨿", amp: "&", AMP: "&", and: "∧", And: "⩓", andand: "⩕", andd: "⩜", andslope: "⩘", andv: "⩚", ang: "∠", ange: "⦤", angle: "∠", angmsd: "∡", angmsdaa: "⦨", angmsdab: "⦩", angmsdac: "⦪", angmsdad: "⦫", angmsdae: "⦬", angmsdaf: "⦭", angmsdag: "⦮", angmsdah: "⦯", angrt: "∟", angrtvb: "⊾", angrtvbd: "⦝", angsph: "∢", angst: "Å", angzarr: "⍼", aogon: "ą", Aogon: "Ą", aopf: "𝕒", Aopf: "𝔸", ap: "≈", apacir: "⩯", ape: "≊", apE: "⩰", apid: "≋", apos: "'", ApplyFunction: "⁡", approx: "≈", approxeq: "≊", aring: "å", Aring: "Å", ascr: "𝒶", Ascr: "𝒜", Assign: "≔", ast: "*", asymp: "≈", asympeq: "≍", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", awconint: "∳", awint: "⨑", backcong: "≌", backepsilon: "϶", backprime: "‵", backsim: "∽", backsimeq: "⋍", Backslash: "∖", Barv: "⫧", barvee: "⊽", barwed: "⌅", Barwed: "⌆", barwedge: "⌅", bbrk: "⎵", bbrktbrk: "⎶", bcong: "≌", bcy: "б", Bcy: "Б", bdquo: "„", becaus: "∵", because: "∵", Because: "∵", bemptyv: "⦰", bepsi: "϶", bernou: "ℬ", Bernoullis: "ℬ", beta: "β", Beta: "Β", beth: "ℶ", between: "≬", bfr: "𝔟", Bfr: "𝔅", bigcap: "⋂", bigcirc: "◯", bigcup: "⋃", bigodot: "⨀", bigoplus: "⨁", bigotimes: "⨂", bigsqcup: "⨆", bigstar: "★", bigtriangledown: "▽", bigtriangleup: "△", biguplus: "⨄", bigvee: "⋁", bigwedge: "⋀", bkarow: "⤍", blacklozenge: "⧫", blacksquare: "▪", blacktriangle: "▴", blacktriangledown: "▾", blacktriangleleft: "◂", blacktriangleright: "▸", blank: "␣", blk12: "▒", blk14: "░", blk34: "▓", block: "█", bne: "=⃥", bnequiv: "≡⃥", bnot: "⌐", bNot: "⫭", bopf: "𝕓", Bopf: "𝔹", bot: "⊥", bottom: "⊥", bowtie: "⋈", boxbox: "⧉", boxdl: "┐", boxdL: "╕", boxDl: "╖", boxDL: "╗", boxdr: "┌", boxdR: "╒", boxDr: "╓", boxDR: "╔", boxh: "─", boxH: "═", boxhd: "┬", boxhD: "╥", boxHd: "╤", boxHD: "╦", boxhu: "┴", boxhU: "╨", boxHu: "╧", boxHU: "╩", boxminus: "⊟", boxplus: "⊞", boxtimes: "⊠", boxul: "┘", boxuL: "╛", boxUl: "╜", boxUL: "╝", boxur: "└", boxuR: "╘", boxUr: "╙", boxUR: "╚", boxv: "│", boxV: "║", boxvh: "┼", boxvH: "╪", boxVh: "╫", boxVH: "╬", boxvl: "┤", boxvL: "╡", boxVl: "╢", boxVL: "╣", boxvr: "├", boxvR: "╞", boxVr: "╟", boxVR: "╠", bprime: "‵", breve: "˘", Breve: "˘", brvbar: "¦", bscr: "𝒷", Bscr: "ℬ", bsemi: "⁏", bsim: "∽", bsime: "⋍", bsol: "\\", bsolb: "⧅", bsolhsub: "⟈", bull: "•", bullet: "•", bump: "≎", bumpe: "≏", bumpE: "⪮", bumpeq: "≏", Bumpeq: "≎", cacute: "ć", Cacute: "Ć", cap: "∩", Cap: "⋒", capand: "⩄", capbrcup: "⩉", capcap: "⩋", capcup: "⩇", capdot: "⩀", CapitalDifferentialD: "ⅅ", caps: "∩︀", caret: "⁁", caron: "ˇ", Cayleys: "ℭ", ccaps: "⩍", ccaron: "č", Ccaron: "Č", ccedil: "ç", Ccedil: "Ç", ccirc: "ĉ", Ccirc: "Ĉ", Cconint: "∰", ccups: "⩌", ccupssm: "⩐", cdot: "ċ", Cdot: "Ċ", cedil: "¸", Cedilla: "¸", cemptyv: "⦲", cent: "¢", centerdot: "·", CenterDot: "·", cfr: "𝔠", Cfr: "ℭ", chcy: "ч", CHcy: "Ч", check: "✓", checkmark: "✓", chi: "χ", Chi: "Χ", cir: "○", circ: "ˆ", circeq: "≗", circlearrowleft: "↺", circlearrowright: "↻", circledast: "⊛", circledcirc: "⊚", circleddash: "⊝", CircleDot: "⊙", circledR: "®", circledS: "Ⓢ", CircleMinus: "⊖", CirclePlus: "⊕", CircleTimes: "⊗", cire: "≗", cirE: "⧃", cirfnint: "⨐", cirmid: "⫯", cirscir: "⧂", ClockwiseContourIntegral: "∲", CloseCurlyDoubleQuote: "”", CloseCurlyQuote: "’", clubs: "♣", clubsuit: "♣", colon: ":", Colon: "∷", colone: "≔", Colone: "⩴", coloneq: "≔", comma: ",", commat: "@", comp: "∁", compfn: "∘", complement: "∁", complexes: "ℂ", cong: "≅", congdot: "⩭", Congruent: "≡", conint: "∮", Conint: "∯", ContourIntegral: "∮", copf: "𝕔", Copf: "ℂ", coprod: "∐", Coproduct: "∐", copy: "©", COPY: "©", copysr: "℗", CounterClockwiseContourIntegral: "∳", crarr: "↵", cross: "✗", Cross: "⨯", cscr: "𝒸", Cscr: "𝒞", csub: "⫏", csube: "⫑", csup: "⫐", csupe: "⫒", ctdot: "⋯", cudarrl: "⤸", cudarrr: "⤵", cuepr: "⋞", cuesc: "⋟", cularr: "↶", cularrp: "⤽", cup: "∪", Cup: "⋓", cupbrcap: "⩈", cupcap: "⩆", CupCap: "≍", cupcup: "⩊", cupdot: "⊍", cupor: "⩅", cups: "∪︀", curarr: "↷", curarrm: "⤼", curlyeqprec: "⋞", curlyeqsucc: "⋟", curlyvee: "⋎", curlywedge: "⋏", curren: "¤", curvearrowleft: "↶", curvearrowright: "↷", cuvee: "⋎", cuwed: "⋏", cwconint: "∲", cwint: "∱", cylcty: "⌭", dagger: "†", Dagger: "‡", daleth: "ℸ", darr: "↓", dArr: "⇓", Darr: "↡", dash: "‐", dashv: "⊣", Dashv: "⫤", dbkarow: "⤏", dblac: "˝", dcaron: "ď", Dcaron: "Ď", dcy: "д", Dcy: "Д", dd: "ⅆ", DD: "ⅅ", ddagger: "‡", ddarr: "⇊", DDotrahd: "⤑", ddotseq: "⩷", deg: "°", Del: "∇", delta: "δ", Delta: "Δ", demptyv: "⦱", dfisht: "⥿", dfr: "𝔡", Dfr: "𝔇", dHar: "⥥", dharl: "⇃", dharr: "⇂", DiacriticalAcute: "´", DiacriticalDot: "˙", DiacriticalDoubleAcute: "˝", DiacriticalGrave: "`", DiacriticalTilde: "˜", diam: "⋄", diamond: "⋄", Diamond: "⋄", diamondsuit: "♦", diams: "♦", die: "¨", DifferentialD: "ⅆ", digamma: "ϝ", disin: "⋲", div: "÷", divide: "÷", divideontimes: "⋇", divonx: "⋇", djcy: "ђ", DJcy: "Ђ", dlcorn: "⌞", dlcrop: "⌍", dollar: "$", dopf: "𝕕", Dopf: "𝔻", dot: "˙", Dot: "¨", DotDot: "⃜", doteq: "≐", doteqdot: "≑", DotEqual: "≐", dotminus: "∸", dotplus: "∔", dotsquare: "⊡", doublebarwedge: "⌆", DoubleContourIntegral: "∯", DoubleDot: "¨", DoubleDownArrow: "⇓", DoubleLeftArrow: "⇐", DoubleLeftRightArrow: "⇔", DoubleLeftTee: "⫤", DoubleLongLeftArrow: "⟸", DoubleLongLeftRightArrow: "⟺", DoubleLongRightArrow: "⟹", DoubleRightArrow: "⇒", DoubleRightTee: "⊨", DoubleUpArrow: "⇑", DoubleUpDownArrow: "⇕", DoubleVerticalBar: "∥", downarrow: "↓", Downarrow: "⇓", DownArrow: "↓", DownArrowBar: "⤓", DownArrowUpArrow: "⇵", DownBreve: "̑", downdownarrows: "⇊", downharpoonleft: "⇃", downharpoonright: "⇂", DownLeftRightVector: "⥐", DownLeftTeeVector: "⥞", DownLeftVector: "↽", DownLeftVectorBar: "⥖", DownRightTeeVector: "⥟", DownRightVector: "⇁", DownRightVectorBar: "⥗", DownTee: "⊤", DownTeeArrow: "↧", drbkarow: "⤐", drcorn: "⌟", drcrop: "⌌", dscr: "𝒹", Dscr: "𝒟", dscy: "ѕ", DScy: "Ѕ", dsol: "⧶", dstrok: "đ", Dstrok: "Đ", dtdot: "⋱", dtri: "▿", dtrif: "▾", duarr: "⇵", duhar: "⥯", dwangle: "⦦", dzcy: "џ", DZcy: "Џ", dzigrarr: "⟿", eacute: "é", Eacute: "É", easter: "⩮", ecaron: "ě", Ecaron: "Ě", ecir: "≖", ecirc: "ê", Ecirc: "Ê", ecolon: "≕", ecy: "э", Ecy: "Э", eDDot: "⩷", edot: "ė", eDot: "≑", Edot: "Ė", ee: "ⅇ", efDot: "≒", efr: "𝔢", Efr: "𝔈", eg: "⪚", egrave: "è", Egrave: "È", egs: "⪖", egsdot: "⪘", el: "⪙", Element: "∈", elinters: "⏧", ell: "ℓ", els: "⪕", elsdot: "⪗", emacr: "ē", Emacr: "Ē", empty: "∅", emptyset: "∅", EmptySmallSquare: "◻", emptyv: "∅", EmptyVerySmallSquare: "▫", emsp: " ", emsp13: " ", emsp14: " ", eng: "ŋ", ENG: "Ŋ", ensp: " ", eogon: "ę", Eogon: "Ę", eopf: "𝕖", Eopf: "𝔼", epar: "⋕", eparsl: "⧣", eplus: "⩱", epsi: "ε", epsilon: "ε", Epsilon: "Ε", epsiv: "ϵ", eqcirc: "≖", eqcolon: "≕", eqsim: "≂", eqslantgtr: "⪖", eqslantless: "⪕", Equal: "⩵", equals: "=", EqualTilde: "≂", equest: "≟", Equilibrium: "⇌", equiv: "≡", equivDD: "⩸", eqvparsl: "⧥", erarr: "⥱", erDot: "≓", escr: "ℯ", Escr: "ℰ", esdot: "≐", esim: "≂", Esim: "⩳", eta: "η", Eta: "Η", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", euro: "€", excl: "!", exist: "∃", Exists: "∃", expectation: "ℰ", exponentiale: "ⅇ", ExponentialE: "ⅇ", fallingdotseq: "≒", fcy: "ф", Fcy: "Ф", female: "♀", ffilig: "ﬃ", fflig: "ﬀ", ffllig: "ﬄ", ffr: "𝔣", Ffr: "𝔉", filig: "ﬁ", FilledSmallSquare: "◼", FilledVerySmallSquare: "▪", fjlig: "fj", flat: "♭", fllig: "ﬂ", fltns: "▱", fnof: "ƒ", fopf: "𝕗", Fopf: "𝔽", forall: "∀", ForAll: "∀", fork: "⋔", forkv: "⫙", Fouriertrf: "ℱ", fpartint: "⨍", frac12: "½", frac13: "⅓", frac14: "¼", frac15: "⅕", frac16: "⅙", frac18: "⅛", frac23: "⅔", frac25: "⅖", frac34: "¾", frac35: "⅗", frac38: "⅜", frac45: "⅘", frac56: "⅚", frac58: "⅝", frac78: "⅞", frasl: "⁄", frown: "⌢", fscr: "𝒻", Fscr: "ℱ", gacute: "ǵ", gamma: "γ", Gamma: "Γ", gammad: "ϝ", Gammad: "Ϝ", gap: "⪆", gbreve: "ğ", Gbreve: "Ğ", Gcedil: "Ģ", gcirc: "ĝ", Gcirc: "Ĝ", gcy: "г", Gcy: "Г", gdot: "ġ", Gdot: "Ġ", ge: "≥", gE: "≧", gel: "⋛", gEl: "⪌", geq: "≥", geqq: "≧", geqslant: "⩾", ges: "⩾", gescc: "⪩", gesdot: "⪀", gesdoto: "⪂", gesdotol: "⪄", gesl: "⋛︀", gesles: "⪔", gfr: "𝔤", Gfr: "𝔊", gg: "≫", Gg: "⋙", ggg: "⋙", gimel: "ℷ", gjcy: "ѓ", GJcy: "Ѓ", gl: "≷", gla: "⪥", glE: "⪒", glj: "⪤", gnap: "⪊", gnapprox: "⪊", gne: "⪈", gnE: "≩", gneq: "⪈", gneqq: "≩", gnsim: "⋧", gopf: "𝕘", Gopf: "𝔾", grave: "`", GreaterEqual: "≥", GreaterEqualLess: "⋛", GreaterFullEqual: "≧", GreaterGreater: "⪢", GreaterLess: "≷", GreaterSlantEqual: "⩾", GreaterTilde: "≳", gscr: "ℊ", Gscr: "𝒢", gsim: "≳", gsime: "⪎", gsiml: "⪐", gt: ">", Gt: "≫", GT: ">", gtcc: "⪧", gtcir: "⩺", gtdot: "⋗", gtlPar: "⦕", gtquest: "⩼", gtrapprox: "⪆", gtrarr: "⥸", gtrdot: "⋗", gtreqless: "⋛", gtreqqless: "⪌", gtrless: "≷", gtrsim: "≳", gvertneqq: "≩︀", gvnE: "≩︀", Hacek: "ˇ", hairsp: " ", half: "½", hamilt: "ℋ", hardcy: "ъ", HARDcy: "Ъ", harr: "↔", hArr: "⇔", harrcir: "⥈", harrw: "↭", Hat: "^", hbar: "ℏ", hcirc: "ĥ", Hcirc: "Ĥ", hearts: "♥", heartsuit: "♥", hellip: "…", hercon: "⊹", hfr: "𝔥", Hfr: "ℌ", HilbertSpace: "ℋ", hksearow: "⤥", hkswarow: "⤦", hoarr: "⇿", homtht: "∻", hookleftarrow: "↩", hookrightarrow: "↪", hopf: "𝕙", Hopf: "ℍ", horbar: "―", HorizontalLine: "─", hscr: "𝒽", Hscr: "ℋ", hslash: "ℏ", hstrok: "ħ", Hstrok: "Ħ", HumpDownHump: "≎", HumpEqual: "≏", hybull: "⁃", hyphen: "‐", iacute: "í", Iacute: "Í", ic: "⁣", icirc: "î", Icirc: "Î", icy: "и", Icy: "И", Idot: "İ", iecy: "е", IEcy: "Е", iexcl: "¡", iff: "⇔", ifr: "𝔦", Ifr: "ℑ", igrave: "ì", Igrave: "Ì", ii: "ⅈ", iiiint: "⨌", iiint: "∭", iinfin: "⧜", iiota: "℩", ijlig: "ĳ", IJlig: "Ĳ", Im: "ℑ", imacr: "ī", Imacr: "Ī", image: "ℑ", ImaginaryI: "ⅈ", imagline: "ℐ", imagpart: "ℑ", imath: "ı", imof: "⊷", imped: "Ƶ", Implies: "⇒", in: "∈", incare: "℅", infin: "∞", infintie: "⧝", inodot: "ı", int: "∫", Int: "∬", intcal: "⊺", integers: "ℤ", Integral: "∫", intercal: "⊺", Intersection: "⋂", intlarhk: "⨗", intprod: "⨼", InvisibleComma: "⁣", InvisibleTimes: "⁢", iocy: "ё", IOcy: "Ё", iogon: "į", Iogon: "Į", iopf: "𝕚", Iopf: "𝕀", iota: "ι", Iota: "Ι", iprod: "⨼", iquest: "¿", iscr: "𝒾", Iscr: "ℐ", isin: "∈", isindot: "⋵", isinE: "⋹", isins: "⋴", isinsv: "⋳", isinv: "∈", it: "⁢", itilde: "ĩ", Itilde: "Ĩ", iukcy: "і", Iukcy: "І", iuml: "ï", Iuml: "Ï", jcirc: "ĵ", Jcirc: "Ĵ", jcy: "й", Jcy: "Й", jfr: "𝔧", Jfr: "𝔍", jmath: "ȷ", jopf: "𝕛", Jopf: "𝕁", jscr: "𝒿", Jscr: "𝒥", jsercy: "ј", Jsercy: "Ј", jukcy: "є", Jukcy: "Є", kappa: "κ", Kappa: "Κ", kappav: "ϰ", kcedil: "ķ", Kcedil: "Ķ", kcy: "к", Kcy: "К", kfr: "𝔨", Kfr: "𝔎", kgreen: "ĸ", khcy: "х", KHcy: "Х", kjcy: "ќ", KJcy: "Ќ", kopf: "𝕜", Kopf: "𝕂", kscr: "𝓀", Kscr: "𝒦", lAarr: "⇚", lacute: "ĺ", Lacute: "Ĺ", laemptyv: "⦴", lagran: "ℒ", lambda: "λ", Lambda: "Λ", lang: "⟨", Lang: "⟪", langd: "⦑", langle: "⟨", lap: "⪅", Laplacetrf: "ℒ", laquo: "«", larr: "←", lArr: "⇐", Larr: "↞", larrb: "⇤", larrbfs: "⤟", larrfs: "⤝", larrhk: "↩", larrlp: "↫", larrpl: "⤹", larrsim: "⥳", larrtl: "↢", lat: "⪫", latail: "⤙", lAtail: "⤛", late: "⪭", lates: "⪭︀", lbarr: "⤌", lBarr: "⤎", lbbrk: "❲", lbrace: "{", lbrack: "[", lbrke: "⦋", lbrksld: "⦏", lbrkslu: "⦍", lcaron: "ľ", Lcaron: "Ľ", lcedil: "ļ", Lcedil: "Ļ", lceil: "⌈", lcub: "{", lcy: "л", Lcy: "Л", ldca: "⤶", ldquo: "“", ldquor: "„", ldrdhar: "⥧", ldrushar: "⥋", ldsh: "↲", le: "≤", lE: "≦", LeftAngleBracket: "⟨", leftarrow: "←", Leftarrow: "⇐", LeftArrow: "←", LeftArrowBar: "⇤", LeftArrowRightArrow: "⇆", leftarrowtail: "↢", LeftCeiling: "⌈", LeftDoubleBracket: "⟦", LeftDownTeeVector: "⥡", LeftDownVector: "⇃", LeftDownVectorBar: "⥙", LeftFloor: "⌊", leftharpoondown: "↽", leftharpoonup: "↼", leftleftarrows: "⇇", leftrightarrow: "↔", Leftrightarrow: "⇔", LeftRightArrow: "↔", leftrightarrows: "⇆", leftrightharpoons: "⇋", leftrightsquigarrow: "↭", LeftRightVector: "⥎", LeftTee: "⊣", LeftTeeArrow: "↤", LeftTeeVector: "⥚", leftthreetimes: "⋋", LeftTriangle: "⊲", LeftTriangleBar: "⧏", LeftTriangleEqual: "⊴", LeftUpDownVector: "⥑", LeftUpTeeVector: "⥠", LeftUpVector: "↿", LeftUpVectorBar: "⥘", LeftVector: "↼", LeftVectorBar: "⥒", leg: "⋚", lEg: "⪋", leq: "≤", leqq: "≦", leqslant: "⩽", les: "⩽", lescc: "⪨", lesdot: "⩿", lesdoto: "⪁", lesdotor: "⪃", lesg: "⋚︀", lesges: "⪓", lessapprox: "⪅", lessdot: "⋖", lesseqgtr: "⋚", lesseqqgtr: "⪋", LessEqualGreater: "⋚", LessFullEqual: "≦", LessGreater: "≶", lessgtr: "≶", LessLess: "⪡", lesssim: "≲", LessSlantEqual: "⩽", LessTilde: "≲", lfisht: "⥼", lfloor: "⌊", lfr: "𝔩", Lfr: "𝔏", lg: "≶", lgE: "⪑", lHar: "⥢", lhard: "↽", lharu: "↼", lharul: "⥪", lhblk: "▄", ljcy: "љ", LJcy: "Љ", ll: "≪", Ll: "⋘", llarr: "⇇", llcorner: "⌞", Lleftarrow: "⇚", llhard: "⥫", lltri: "◺", lmidot: "ŀ", Lmidot: "Ŀ", lmoust: "⎰", lmoustache: "⎰", lnap: "⪉", lnapprox: "⪉", lne: "⪇", lnE: "≨", lneq: "⪇", lneqq: "≨", lnsim: "⋦", loang: "⟬", loarr: "⇽", lobrk: "⟦", longleftarrow: "⟵", Longleftarrow: "⟸", LongLeftArrow: "⟵", longleftrightarrow: "⟷", Longleftrightarrow: "⟺", LongLeftRightArrow: "⟷", longmapsto: "⟼", longrightarrow: "⟶", Longrightarrow: "⟹", LongRightArrow: "⟶", looparrowleft: "↫", looparrowright: "↬", lopar: "⦅", lopf: "𝕝", Lopf: "𝕃", loplus: "⨭", lotimes: "⨴", lowast: "∗", lowbar: "_", LowerLeftArrow: "↙", LowerRightArrow: "↘", loz: "◊", lozenge: "◊", lozf: "⧫", lpar: "(", lparlt: "⦓", lrarr: "⇆", lrcorner: "⌟", lrhar: "⇋", lrhard: "⥭", lrm: "‎", lrtri: "⊿", lsaquo: "‹", lscr: "𝓁", Lscr: "ℒ", lsh: "↰", Lsh: "↰", lsim: "≲", lsime: "⪍", lsimg: "⪏", lsqb: "[", lsquo: "‘", lsquor: "‚", lstrok: "ł", Lstrok: "Ł", lt: "<", Lt: "≪", LT: "<", ltcc: "⪦", ltcir: "⩹", ltdot: "⋖", lthree: "⋋", ltimes: "⋉", ltlarr: "⥶", ltquest: "⩻", ltri: "◃", ltrie: "⊴", ltrif: "◂", ltrPar: "⦖", lurdshar: "⥊", luruhar: "⥦", lvertneqq: "≨︀", lvnE: "≨︀", macr: "¯", male: "♂", malt: "✠", maltese: "✠", map: "↦", Map: "⤅", mapsto: "↦", mapstodown: "↧", mapstoleft: "↤", mapstoup: "↥", marker: "▮", mcomma: "⨩", mcy: "м", Mcy: "М", mdash: "—", mDDot: "∺", measuredangle: "∡", MediumSpace: " ", Mellintrf: "ℳ", mfr: "𝔪", Mfr: "𝔐", mho: "℧", micro: "µ", mid: "∣", midast: "*", midcir: "⫰", middot: "·", minus: "−", minusb: "⊟", minusd: "∸", minusdu: "⨪", MinusPlus: "∓", mlcp: "⫛", mldr: "…", mnplus: "∓", models: "⊧", mopf: "𝕞", Mopf: "𝕄", mp: "∓", mscr: "𝓂", Mscr: "ℳ", mstpos: "∾", mu: "μ", Mu: "Μ", multimap: "⊸", mumap: "⊸", nabla: "∇", nacute: "ń", Nacute: "Ń", nang: "∠⃒", nap: "≉", napE: "⩰̸", napid: "≋̸", napos: "ŉ", napprox: "≉", natur: "♮", natural: "♮", naturals: "ℕ", nbsp: " ", nbump: "≎̸", nbumpe: "≏̸", ncap: "⩃", ncaron: "ň", Ncaron: "Ň", ncedil: "ņ", Ncedil: "Ņ", ncong: "≇", ncongdot: "⩭̸", ncup: "⩂", ncy: "н", Ncy: "Н", ndash: "–", ne: "≠", nearhk: "⤤", nearr: "↗", neArr: "⇗", nearrow: "↗", nedot: "≐̸", NegativeMediumSpace: "​", NegativeThickSpace: "​", NegativeThinSpace: "​", NegativeVeryThinSpace: "​", nequiv: "≢", nesear: "⤨", nesim: "≂̸", NestedGreaterGreater: "≫", NestedLessLess: "≪", NewLine: `
`, nexist: "∄", nexists: "∄", nfr: "𝔫", Nfr: "𝔑", nge: "≱", ngE: "≧̸", ngeq: "≱", ngeqq: "≧̸", ngeqslant: "⩾̸", nges: "⩾̸", nGg: "⋙̸", ngsim: "≵", ngt: "≯", nGt: "≫⃒", ngtr: "≯", nGtv: "≫̸", nharr: "↮", nhArr: "⇎", nhpar: "⫲", ni: "∋", nis: "⋼", nisd: "⋺", niv: "∋", njcy: "њ", NJcy: "Њ", nlarr: "↚", nlArr: "⇍", nldr: "‥", nle: "≰", nlE: "≦̸", nleftarrow: "↚", nLeftarrow: "⇍", nleftrightarrow: "↮", nLeftrightarrow: "⇎", nleq: "≰", nleqq: "≦̸", nleqslant: "⩽̸", nles: "⩽̸", nless: "≮", nLl: "⋘̸", nlsim: "≴", nlt: "≮", nLt: "≪⃒", nltri: "⋪", nltrie: "⋬", nLtv: "≪̸", nmid: "∤", NoBreak: "⁠", NonBreakingSpace: " ", nopf: "𝕟", Nopf: "ℕ", not: "¬", Not: "⫬", NotCongruent: "≢", NotCupCap: "≭", NotDoubleVerticalBar: "∦", NotElement: "∉", NotEqual: "≠", NotEqualTilde: "≂̸", NotExists: "∄", NotGreater: "≯", NotGreaterEqual: "≱", NotGreaterFullEqual: "≧̸", NotGreaterGreater: "≫̸", NotGreaterLess: "≹", NotGreaterSlantEqual: "⩾̸", NotGreaterTilde: "≵", NotHumpDownHump: "≎̸", NotHumpEqual: "≏̸", notin: "∉", notindot: "⋵̸", notinE: "⋹̸", notinva: "∉", notinvb: "⋷", notinvc: "⋶", NotLeftTriangle: "⋪", NotLeftTriangleBar: "⧏̸", NotLeftTriangleEqual: "⋬", NotLess: "≮", NotLessEqual: "≰", NotLessGreater: "≸", NotLessLess: "≪̸", NotLessSlantEqual: "⩽̸", NotLessTilde: "≴", NotNestedGreaterGreater: "⪢̸", NotNestedLessLess: "⪡̸", notni: "∌", notniva: "∌", notnivb: "⋾", notnivc: "⋽", NotPrecedes: "⊀", NotPrecedesEqual: "⪯̸", NotPrecedesSlantEqual: "⋠", NotReverseElement: "∌", NotRightTriangle: "⋫", NotRightTriangleBar: "⧐̸", NotRightTriangleEqual: "⋭", NotSquareSubset: "⊏̸", NotSquareSubsetEqual: "⋢", NotSquareSuperset: "⊐̸", NotSquareSupersetEqual: "⋣", NotSubset: "⊂⃒", NotSubsetEqual: "⊈", NotSucceeds: "⊁", NotSucceedsEqual: "⪰̸", NotSucceedsSlantEqual: "⋡", NotSucceedsTilde: "≿̸", NotSuperset: "⊃⃒", NotSupersetEqual: "⊉", NotTilde: "≁", NotTildeEqual: "≄", NotTildeFullEqual: "≇", NotTildeTilde: "≉", NotVerticalBar: "∤", npar: "∦", nparallel: "∦", nparsl: "⫽⃥", npart: "∂̸", npolint: "⨔", npr: "⊀", nprcue: "⋠", npre: "⪯̸", nprec: "⊀", npreceq: "⪯̸", nrarr: "↛", nrArr: "⇏", nrarrc: "⤳̸", nrarrw: "↝̸", nrightarrow: "↛", nRightarrow: "⇏", nrtri: "⋫", nrtrie: "⋭", nsc: "⊁", nsccue: "⋡", nsce: "⪰̸", nscr: "𝓃", Nscr: "𝒩", nshortmid: "∤", nshortparallel: "∦", nsim: "≁", nsime: "≄", nsimeq: "≄", nsmid: "∤", nspar: "∦", nsqsube: "⋢", nsqsupe: "⋣", nsub: "⊄", nsube: "⊈", nsubE: "⫅̸", nsubset: "⊂⃒", nsubseteq: "⊈", nsubseteqq: "⫅̸", nsucc: "⊁", nsucceq: "⪰̸", nsup: "⊅", nsupe: "⊉", nsupE: "⫆̸", nsupset: "⊃⃒", nsupseteq: "⊉", nsupseteqq: "⫆̸", ntgl: "≹", ntilde: "ñ", Ntilde: "Ñ", ntlg: "≸", ntriangleleft: "⋪", ntrianglelefteq: "⋬", ntriangleright: "⋫", ntrianglerighteq: "⋭", nu: "ν", Nu: "Ν", num: "#", numero: "№", numsp: " ", nvap: "≍⃒", nvdash: "⊬", nvDash: "⊭", nVdash: "⊮", nVDash: "⊯", nvge: "≥⃒", nvgt: ">⃒", nvHarr: "⤄", nvinfin: "⧞", nvlArr: "⤂", nvle: "≤⃒", nvlt: "<⃒", nvltrie: "⊴⃒", nvrArr: "⤃", nvrtrie: "⊵⃒", nvsim: "∼⃒", nwarhk: "⤣", nwarr: "↖", nwArr: "⇖", nwarrow: "↖", nwnear: "⤧", oacute: "ó", Oacute: "Ó", oast: "⊛", ocir: "⊚", ocirc: "ô", Ocirc: "Ô", ocy: "о", Ocy: "О", odash: "⊝", odblac: "ő", Odblac: "Ő", odiv: "⨸", odot: "⊙", odsold: "⦼", oelig: "œ", OElig: "Œ", ofcir: "⦿", ofr: "𝔬", Ofr: "𝔒", ogon: "˛", ograve: "ò", Ograve: "Ò", ogt: "⧁", ohbar: "⦵", ohm: "Ω", oint: "∮", olarr: "↺", olcir: "⦾", olcross: "⦻", oline: "‾", olt: "⧀", omacr: "ō", Omacr: "Ō", omega: "ω", Omega: "Ω", omicron: "ο", Omicron: "Ο", omid: "⦶", ominus: "⊖", oopf: "𝕠", Oopf: "𝕆", opar: "⦷", OpenCurlyDoubleQuote: "“", OpenCurlyQuote: "‘", operp: "⦹", oplus: "⊕", or: "∨", Or: "⩔", orarr: "↻", ord: "⩝", order: "ℴ", orderof: "ℴ", ordf: "ª", ordm: "º", origof: "⊶", oror: "⩖", orslope: "⩗", orv: "⩛", oS: "Ⓢ", oscr: "ℴ", Oscr: "𝒪", oslash: "ø", Oslash: "Ø", osol: "⊘", otilde: "õ", Otilde: "Õ", otimes: "⊗", Otimes: "⨷", otimesas: "⨶", ouml: "ö", Ouml: "Ö", ovbar: "⌽", OverBar: "‾", OverBrace: "⏞", OverBracket: "⎴", OverParenthesis: "⏜", par: "∥", para: "¶", parallel: "∥", parsim: "⫳", parsl: "⫽", part: "∂", PartialD: "∂", pcy: "п", Pcy: "П", percnt: "%", period: ".", permil: "‰", perp: "⊥", pertenk: "‱", pfr: "𝔭", Pfr: "𝔓", phi: "φ", Phi: "Φ", phiv: "ϕ", phmmat: "ℳ", phone: "☎", pi: "π", Pi: "Π", pitchfork: "⋔", piv: "ϖ", planck: "ℏ", planckh: "ℎ", plankv: "ℏ", plus: "+", plusacir: "⨣", plusb: "⊞", pluscir: "⨢", plusdo: "∔", plusdu: "⨥", pluse: "⩲", PlusMinus: "±", plusmn: "±", plussim: "⨦", plustwo: "⨧", pm: "±", Poincareplane: "ℌ", pointint: "⨕", popf: "𝕡", Popf: "ℙ", pound: "£", pr: "≺", Pr: "⪻", prap: "⪷", prcue: "≼", pre: "⪯", prE: "⪳", prec: "≺", precapprox: "⪷", preccurlyeq: "≼", Precedes: "≺", PrecedesEqual: "⪯", PrecedesSlantEqual: "≼", PrecedesTilde: "≾", preceq: "⪯", precnapprox: "⪹", precneqq: "⪵", precnsim: "⋨", precsim: "≾", prime: "′", Prime: "″", primes: "ℙ", prnap: "⪹", prnE: "⪵", prnsim: "⋨", prod: "∏", Product: "∏", profalar: "⌮", profline: "⌒", profsurf: "⌓", prop: "∝", Proportion: "∷", Proportional: "∝", propto: "∝", prsim: "≾", prurel: "⊰", pscr: "𝓅", Pscr: "𝒫", psi: "ψ", Psi: "Ψ", puncsp: " ", qfr: "𝔮", Qfr: "𝔔", qint: "⨌", qopf: "𝕢", Qopf: "ℚ", qprime: "⁗", qscr: "𝓆", Qscr: "𝒬", quaternions: "ℍ", quatint: "⨖", quest: "?", questeq: "≟", quot: '"', QUOT: '"', rAarr: "⇛", race: "∽̱", racute: "ŕ", Racute: "Ŕ", radic: "√", raemptyv: "⦳", rang: "⟩", Rang: "⟫", rangd: "⦒", range: "⦥", rangle: "⟩", raquo: "»", rarr: "→", rArr: "⇒", Rarr: "↠", rarrap: "⥵", rarrb: "⇥", rarrbfs: "⤠", rarrc: "⤳", rarrfs: "⤞", rarrhk: "↪", rarrlp: "↬", rarrpl: "⥅", rarrsim: "⥴", rarrtl: "↣", Rarrtl: "⤖", rarrw: "↝", ratail: "⤚", rAtail: "⤜", ratio: "∶", rationals: "ℚ", rbarr: "⤍", rBarr: "⤏", RBarr: "⤐", rbbrk: "❳", rbrace: "}", rbrack: "]", rbrke: "⦌", rbrksld: "⦎", rbrkslu: "⦐", rcaron: "ř", Rcaron: "Ř", rcedil: "ŗ", Rcedil: "Ŗ", rceil: "⌉", rcub: "}", rcy: "р", Rcy: "Р", rdca: "⤷", rdldhar: "⥩", rdquo: "”", rdquor: "”", rdsh: "↳", Re: "ℜ", real: "ℜ", realine: "ℛ", realpart: "ℜ", reals: "ℝ", rect: "▭", reg: "®", REG: "®", ReverseElement: "∋", ReverseEquilibrium: "⇋", ReverseUpEquilibrium: "⥯", rfisht: "⥽", rfloor: "⌋", rfr: "𝔯", Rfr: "ℜ", rHar: "⥤", rhard: "⇁", rharu: "⇀", rharul: "⥬", rho: "ρ", Rho: "Ρ", rhov: "ϱ", RightAngleBracket: "⟩", rightarrow: "→", Rightarrow: "⇒", RightArrow: "→", RightArrowBar: "⇥", RightArrowLeftArrow: "⇄", rightarrowtail: "↣", RightCeiling: "⌉", RightDoubleBracket: "⟧", RightDownTeeVector: "⥝", RightDownVector: "⇂", RightDownVectorBar: "⥕", RightFloor: "⌋", rightharpoondown: "⇁", rightharpoonup: "⇀", rightleftarrows: "⇄", rightleftharpoons: "⇌", rightrightarrows: "⇉", rightsquigarrow: "↝", RightTee: "⊢", RightTeeArrow: "↦", RightTeeVector: "⥛", rightthreetimes: "⋌", RightTriangle: "⊳", RightTriangleBar: "⧐", RightTriangleEqual: "⊵", RightUpDownVector: "⥏", RightUpTeeVector: "⥜", RightUpVector: "↾", RightUpVectorBar: "⥔", RightVector: "⇀", RightVectorBar: "⥓", ring: "˚", risingdotseq: "≓", rlarr: "⇄", rlhar: "⇌", rlm: "‏", rmoust: "⎱", rmoustache: "⎱", rnmid: "⫮", roang: "⟭", roarr: "⇾", robrk: "⟧", ropar: "⦆", ropf: "𝕣", Ropf: "ℝ", roplus: "⨮", rotimes: "⨵", RoundImplies: "⥰", rpar: ")", rpargt: "⦔", rppolint: "⨒", rrarr: "⇉", Rrightarrow: "⇛", rsaquo: "›", rscr: "𝓇", Rscr: "ℛ", rsh: "↱", Rsh: "↱", rsqb: "]", rsquo: "’", rsquor: "’", rthree: "⋌", rtimes: "⋊", rtri: "▹", rtrie: "⊵", rtrif: "▸", rtriltri: "⧎", RuleDelayed: "⧴", ruluhar: "⥨", rx: "℞", sacute: "ś", Sacute: "Ś", sbquo: "‚", sc: "≻", Sc: "⪼", scap: "⪸", scaron: "š", Scaron: "Š", sccue: "≽", sce: "⪰", scE: "⪴", scedil: "ş", Scedil: "Ş", scirc: "ŝ", Scirc: "Ŝ", scnap: "⪺", scnE: "⪶", scnsim: "⋩", scpolint: "⨓", scsim: "≿", scy: "с", Scy: "С", sdot: "⋅", sdotb: "⊡", sdote: "⩦", searhk: "⤥", searr: "↘", seArr: "⇘", searrow: "↘", sect: "§", semi: ";", seswar: "⤩", setminus: "∖", setmn: "∖", sext: "✶", sfr: "𝔰", Sfr: "𝔖", sfrown: "⌢", sharp: "♯", shchcy: "щ", SHCHcy: "Щ", shcy: "ш", SHcy: "Ш", ShortDownArrow: "↓", ShortLeftArrow: "←", shortmid: "∣", shortparallel: "∥", ShortRightArrow: "→", ShortUpArrow: "↑", shy: "­", sigma: "σ", Sigma: "Σ", sigmaf: "ς", sigmav: "ς", sim: "∼", simdot: "⩪", sime: "≃", simeq: "≃", simg: "⪞", simgE: "⪠", siml: "⪝", simlE: "⪟", simne: "≆", simplus: "⨤", simrarr: "⥲", slarr: "←", SmallCircle: "∘", smallsetminus: "∖", smashp: "⨳", smeparsl: "⧤", smid: "∣", smile: "⌣", smt: "⪪", smte: "⪬", smtes: "⪬︀", softcy: "ь", SOFTcy: "Ь", sol: "/", solb: "⧄", solbar: "⌿", sopf: "𝕤", Sopf: "𝕊", spades: "♠", spadesuit: "♠", spar: "∥", sqcap: "⊓", sqcaps: "⊓︀", sqcup: "⊔", sqcups: "⊔︀", Sqrt: "√", sqsub: "⊏", sqsube: "⊑", sqsubset: "⊏", sqsubseteq: "⊑", sqsup: "⊐", sqsupe: "⊒", sqsupset: "⊐", sqsupseteq: "⊒", squ: "□", square: "□", Square: "□", SquareIntersection: "⊓", SquareSubset: "⊏", SquareSubsetEqual: "⊑", SquareSuperset: "⊐", SquareSupersetEqual: "⊒", SquareUnion: "⊔", squarf: "▪", squf: "▪", srarr: "→", sscr: "𝓈", Sscr: "𝒮", ssetmn: "∖", ssmile: "⌣", sstarf: "⋆", star: "☆", Star: "⋆", starf: "★", straightepsilon: "ϵ", straightphi: "ϕ", strns: "¯", sub: "⊂", Sub: "⋐", subdot: "⪽", sube: "⊆", subE: "⫅", subedot: "⫃", submult: "⫁", subne: "⊊", subnE: "⫋", subplus: "⪿", subrarr: "⥹", subset: "⊂", Subset: "⋐", subseteq: "⊆", subseteqq: "⫅", SubsetEqual: "⊆", subsetneq: "⊊", subsetneqq: "⫋", subsim: "⫇", subsub: "⫕", subsup: "⫓", succ: "≻", succapprox: "⪸", succcurlyeq: "≽", Succeeds: "≻", SucceedsEqual: "⪰", SucceedsSlantEqual: "≽", SucceedsTilde: "≿", succeq: "⪰", succnapprox: "⪺", succneqq: "⪶", succnsim: "⋩", succsim: "≿", SuchThat: "∋", sum: "∑", Sum: "∑", sung: "♪", sup: "⊃", Sup: "⋑", sup1: "¹", sup2: "²", sup3: "³", supdot: "⪾", supdsub: "⫘", supe: "⊇", supE: "⫆", supedot: "⫄", Superset: "⊃", SupersetEqual: "⊇", suphsol: "⟉", suphsub: "⫗", suplarr: "⥻", supmult: "⫂", supne: "⊋", supnE: "⫌", supplus: "⫀", supset: "⊃", Supset: "⋑", supseteq: "⊇", supseteqq: "⫆", supsetneq: "⊋", supsetneqq: "⫌", supsim: "⫈", supsub: "⫔", supsup: "⫖", swarhk: "⤦", swarr: "↙", swArr: "⇙", swarrow: "↙", swnwar: "⤪", szlig: "ß", Tab: "	", target: "⌖", tau: "τ", Tau: "Τ", tbrk: "⎴", tcaron: "ť", Tcaron: "Ť", tcedil: "ţ", Tcedil: "Ţ", tcy: "т", Tcy: "Т", tdot: "⃛", telrec: "⌕", tfr: "𝔱", Tfr: "𝔗", there4: "∴", therefore: "∴", Therefore: "∴", theta: "θ", Theta: "Θ", thetasym: "ϑ", thetav: "ϑ", thickapprox: "≈", thicksim: "∼", ThickSpace: "  ", thinsp: " ", ThinSpace: " ", thkap: "≈", thksim: "∼", thorn: "þ", THORN: "Þ", tilde: "˜", Tilde: "∼", TildeEqual: "≃", TildeFullEqual: "≅", TildeTilde: "≈", times: "×", timesb: "⊠", timesbar: "⨱", timesd: "⨰", tint: "∭", toea: "⤨", top: "⊤", topbot: "⌶", topcir: "⫱", topf: "𝕥", Topf: "𝕋", topfork: "⫚", tosa: "⤩", tprime: "‴", trade: "™", TRADE: "™", triangle: "▵", triangledown: "▿", triangleleft: "◃", trianglelefteq: "⊴", triangleq: "≜", triangleright: "▹", trianglerighteq: "⊵", tridot: "◬", trie: "≜", triminus: "⨺", TripleDot: "⃛", triplus: "⨹", trisb: "⧍", tritime: "⨻", trpezium: "⏢", tscr: "𝓉", Tscr: "𝒯", tscy: "ц", TScy: "Ц", tshcy: "ћ", TSHcy: "Ћ", tstrok: "ŧ", Tstrok: "Ŧ", twixt: "≬", twoheadleftarrow: "↞", twoheadrightarrow: "↠", uacute: "ú", Uacute: "Ú", uarr: "↑", uArr: "⇑", Uarr: "↟", Uarrocir: "⥉", ubrcy: "ў", Ubrcy: "Ў", ubreve: "ŭ", Ubreve: "Ŭ", ucirc: "û", Ucirc: "Û", ucy: "у", Ucy: "У", udarr: "⇅", udblac: "ű", Udblac: "Ű", udhar: "⥮", ufisht: "⥾", ufr: "𝔲", Ufr: "𝔘", ugrave: "ù", Ugrave: "Ù", uHar: "⥣", uharl: "↿", uharr: "↾", uhblk: "▀", ulcorn: "⌜", ulcorner: "⌜", ulcrop: "⌏", ultri: "◸", umacr: "ū", Umacr: "Ū", uml: "¨", UnderBar: "_", UnderBrace: "⏟", UnderBracket: "⎵", UnderParenthesis: "⏝", Union: "⋃", UnionPlus: "⊎", uogon: "ų", Uogon: "Ų", uopf: "𝕦", Uopf: "𝕌", uparrow: "↑", Uparrow: "⇑", UpArrow: "↑", UpArrowBar: "⤒", UpArrowDownArrow: "⇅", updownarrow: "↕", Updownarrow: "⇕", UpDownArrow: "↕", UpEquilibrium: "⥮", upharpoonleft: "↿", upharpoonright: "↾", uplus: "⊎", UpperLeftArrow: "↖", UpperRightArrow: "↗", upsi: "υ", Upsi: "ϒ", upsih: "ϒ", upsilon: "υ", Upsilon: "Υ", UpTee: "⊥", UpTeeArrow: "↥", upuparrows: "⇈", urcorn: "⌝", urcorner: "⌝", urcrop: "⌎", uring: "ů", Uring: "Ů", urtri: "◹", uscr: "𝓊", Uscr: "𝒰", utdot: "⋰", utilde: "ũ", Utilde: "Ũ", utri: "▵", utrif: "▴", uuarr: "⇈", uuml: "ü", Uuml: "Ü", uwangle: "⦧", vangrt: "⦜", varepsilon: "ϵ", varkappa: "ϰ", varnothing: "∅", varphi: "ϕ", varpi: "ϖ", varpropto: "∝", varr: "↕", vArr: "⇕", varrho: "ϱ", varsigma: "ς", varsubsetneq: "⊊︀", varsubsetneqq: "⫋︀", varsupsetneq: "⊋︀", varsupsetneqq: "⫌︀", vartheta: "ϑ", vartriangleleft: "⊲", vartriangleright: "⊳", vBar: "⫨", Vbar: "⫫", vBarv: "⫩", vcy: "в", Vcy: "В", vdash: "⊢", vDash: "⊨", Vdash: "⊩", VDash: "⊫", Vdashl: "⫦", vee: "∨", Vee: "⋁", veebar: "⊻", veeeq: "≚", vellip: "⋮", verbar: "|", Verbar: "‖", vert: "|", Vert: "‖", VerticalBar: "∣", VerticalLine: "|", VerticalSeparator: "❘", VerticalTilde: "≀", VeryThinSpace: " ", vfr: "𝔳", Vfr: "𝔙", vltri: "⊲", vnsub: "⊂⃒", vnsup: "⊃⃒", vopf: "𝕧", Vopf: "𝕍", vprop: "∝", vrtri: "⊳", vscr: "𝓋", Vscr: "𝒱", vsubne: "⊊︀", vsubnE: "⫋︀", vsupne: "⊋︀", vsupnE: "⫌︀", Vvdash: "⊪", vzigzag: "⦚", wcirc: "ŵ", Wcirc: "Ŵ", wedbar: "⩟", wedge: "∧", Wedge: "⋀", wedgeq: "≙", weierp: "℘", wfr: "𝔴", Wfr: "𝔚", wopf: "𝕨", Wopf: "𝕎", wp: "℘", wr: "≀", wreath: "≀", wscr: "𝓌", Wscr: "𝒲", xcap: "⋂", xcirc: "◯", xcup: "⋃", xdtri: "▽", xfr: "𝔵", Xfr: "𝔛", xharr: "⟷", xhArr: "⟺", xi: "ξ", Xi: "Ξ", xlarr: "⟵", xlArr: "⟸", xmap: "⟼", xnis: "⋻", xodot: "⨀", xopf: "𝕩", Xopf: "𝕏", xoplus: "⨁", xotime: "⨂", xrarr: "⟶", xrArr: "⟹", xscr: "𝓍", Xscr: "𝒳", xsqcup: "⨆", xuplus: "⨄", xutri: "△", xvee: "⋁", xwedge: "⋀", yacute: "ý", Yacute: "Ý", yacy: "я", YAcy: "Я", ycirc: "ŷ", Ycirc: "Ŷ", ycy: "ы", Ycy: "Ы", yen: "¥", yfr: "𝔶", Yfr: "𝔜", yicy: "ї", YIcy: "Ї", yopf: "𝕪", Yopf: "𝕐", yscr: "𝓎", Yscr: "𝒴", yucy: "ю", YUcy: "Ю", yuml: "ÿ", Yuml: "Ÿ", zacute: "ź", Zacute: "Ź", zcaron: "ž", Zcaron: "Ž", zcy: "з", Zcy: "З", zdot: "ż", Zdot: "Ż", zeetrf: "ℨ", ZeroWidthSpace: "​", zeta: "ζ", Zeta: "Ζ", zfr: "𝔷", Zfr: "ℨ", zhcy: "ж", ZHcy: "Ж", zigrarr: "⇝", zopf: "𝕫", Zopf: "ℤ", zscr: "𝓏", Zscr: "𝒵", zwj: "‍", zwnj: "‌" }, Pt = { aacute: "á", Aacute: "Á", acirc: "â", Acirc: "Â", acute: "´", aelig: "æ", AElig: "Æ", agrave: "à", Agrave: "À", amp: "&", AMP: "&", aring: "å", Aring: "Å", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", brvbar: "¦", ccedil: "ç", Ccedil: "Ç", cedil: "¸", cent: "¢", copy: "©", COPY: "©", curren: "¤", deg: "°", divide: "÷", eacute: "é", Eacute: "É", ecirc: "ê", Ecirc: "Ê", egrave: "è", Egrave: "È", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", GT: ">", iacute: "í", Iacute: "Í", icirc: "î", Icirc: "Î", iexcl: "¡", igrave: "ì", Igrave: "Ì", iquest: "¿", iuml: "ï", Iuml: "Ï", laquo: "«", lt: "<", LT: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", ntilde: "ñ", Ntilde: "Ñ", oacute: "ó", Oacute: "Ó", ocirc: "ô", Ocirc: "Ô", ograve: "ò", Ograve: "Ò", ordf: "ª", ordm: "º", oslash: "ø", Oslash: "Ø", otilde: "õ", Otilde: "Õ", ouml: "ö", Ouml: "Ö", para: "¶", plusmn: "±", pound: "£", quot: '"', QUOT: '"', raquo: "»", reg: "®", REG: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", thorn: "þ", THORN: "Þ", times: "×", uacute: "ú", Uacute: "Ú", ucirc: "û", Ucirc: "Û", ugrave: "ù", Ugrave: "Ù", uml: "¨", uuml: "ü", Uuml: "Ü", yacute: "ý", Yacute: "Ý", yen: "¥", yuml: "ÿ" }, kt = { 0: "�", 128: "€", 130: "‚", 131: "ƒ", 132: "„", 133: "…", 134: "†", 135: "‡", 136: "ˆ", 137: "‰", 138: "Š", 139: "‹", 140: "Œ", 142: "Ž", 145: "‘", 146: "’", 147: "“", 148: "”", 149: "•", 150: "–", 151: "—", 152: "˜", 153: "™", 154: "š", 155: "›", 156: "œ", 158: "ž", 159: "Ÿ" }, Ot = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65e3, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111], Jr = String.fromCharCode, en = {}, nn = en.hasOwnProperty, ln = function(un, pn) {
      return nn.call(un, pn);
    }, fn = function(un, pn) {
      for (var hn = -1, An = un.length; ++hn < An; )
        if (un[hn] == pn)
          return !0;
      return !1;
    }, vn = function(un, pn) {
      if (!un)
        return pn;
      var hn = {}, An;
      for (An in pn)
        hn[An] = ln(un, An) ? un[An] : pn[An];
      return hn;
    }, Tn = function(un, pn) {
      var hn = "";
      return un >= 55296 && un <= 57343 || un > 1114111 ? (pn && Sn("character reference outside the permissible Unicode range"), "�") : ln(kt, un) ? (pn && Sn("disallowed character reference"), kt[un]) : (pn && fn(Ot, un) && Sn("disallowed character reference"), un > 65535 && (un -= 65536, hn += Jr(un >>> 10 & 1023 | 55296), un = 56320 | un & 1023), hn += Jr(un), hn);
    }, xn = function(un) {
      return "&#x" + un.toString(16).toUpperCase() + ";";
    }, bn = function(un) {
      return "&#" + un + ";";
    }, Sn = function(un) {
      throw Error("Parse error: " + un);
    }, Cn = function(un, pn) {
      pn = vn(pn, Cn.options);
      var hn = pn.strict;
      hn && wt.test(un) && Sn("forbidden code point");
      var An = pn.encodeEverything, In = pn.useNamedReferences, qn = pn.allowUnsafeSymbols, si = pn.decimal ? bn : xn, bi = function(xi) {
        return si(xi.charCodeAt(0));
      };
      return An ? (un = un.replace(qe, function(xi) {
        return In && ln(ot, xi) ? "&" + ot[xi] + ";" : bi(xi);
      }), In && (un = un.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;")), In && (un = un.replace(Xe, function(xi) {
        return "&" + ot[xi] + ";";
      }))) : In ? (qn || (un = un.replace(vt, function(xi) {
        return "&" + ot[xi] + ";";
      })), un = un.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;"), un = un.replace(Xe, function(xi) {
        return "&" + ot[xi] + ";";
      })) : qn || (un = un.replace(vt, bi)), un.replace(Ue, function(xi) {
        var ji = xi.charCodeAt(0), zi = xi.charCodeAt(1), Vi = (ji - 55296) * 1024 + zi - 56320 + 65536;
        return si(Vi);
      }).replace(Ge, bi);
    };
    Cn.options = {
      allowUnsafeSymbols: !1,
      encodeEverything: !1,
      strict: !1,
      useNamedReferences: !1,
      decimal: !1
    };
    var kn = function(un, pn) {
      pn = vn(pn, kn.options);
      var hn = pn.strict;
      return hn && Tt.test(un) && Sn("malformed character reference"), un.replace(St, function(An, In, qn, si, bi, xi, ji, zi, Vi) {
        var Hi, ii, Fi, ni, Ui, ja;
        return In ? (Ui = In, It[Ui]) : qn ? (Ui = qn, ja = si, ja && pn.isAttributeValue ? (hn && ja == "=" && Sn("`&` did not start a character reference"), An) : (hn && Sn(
          "named character reference was not terminated by a semicolon"
        ), Pt[Ui] + (ja || ""))) : bi ? (Fi = bi, ii = xi, hn && !ii && Sn("character reference was not terminated by a semicolon"), Hi = parseInt(Fi, 10), Tn(Hi, hn)) : ji ? (ni = ji, ii = zi, hn && !ii && Sn("character reference was not terminated by a semicolon"), Hi = parseInt(ni, 16), Tn(Hi, hn)) : (hn && Sn(
          "named character reference was not terminated by a semicolon"
        ), An);
      });
    };
    kn.options = {
      isAttributeValue: !1,
      strict: !1
    };
    var cn = function(un) {
      return un.replace(vt, function(pn) {
        return bt[pn];
      });
    }, gn = {
      version: "1.2.0",
      encode: Cn,
      decode: kn,
      escape: cn,
      unescape: kn
    };
    if (we && !we.nodeType)
      if (Re)
        Re.exports = gn;
      else
        for (var an in gn)
          ln(gn, an) && (we[an] = gn[an]);
    else
      me.he = gn;
  })(commonjsGlobal);
})(he$2, he$2.exports);
he$2.exports;
var ArrowType;
(function(ce) {
  ce[ce.Simple = 0] = "Simple", ce[ce.Polygon = 1] = "Polygon", ce[ce.Teleport = 2] = "Teleport";
})(ArrowType || (ArrowType = {}));
var IndicatorType;
(function(ce) {
  ce[ce.PolygonalShape = 0] = "PolygonalShape", ce[ce.PolygonalWithIndicator = 1] = "PolygonalWithIndicator", ce[ce.IndicatorOnly = 2] = "IndicatorOnly", ce[ce.Invisible = 3] = "Invisible";
})(IndicatorType || (IndicatorType = {}));
var WidgetType;
(function(ce) {
  ce.text = "text", ce.image = "image", ce.textOnImage = "textOnImage", ce.pdf = "pdf", ce.video = "video", ce.question = "question", ce.html = "html", ce.hiddenArea = "hiddenArea", ce.fillInQuestion = "fillInQuestion", ce.multipleResponseQuestion = "multipleResponseQuestion", ce.sortation = "sortation", ce.audio = "audio", ce.interactiveProcess = "interactiveProcess", ce.imageCarousel = "imageCarousel", ce.interactiveTabs = "interactiveTabs", ce.flipCard = "flipCard", ce.labeledGraphic = "labeledGraphic", ce.list = "list", ce.divider = "divider";
})(WidgetType || (WidgetType = {}));
var ContentFragmentType;
(function(ce) {
  ce[ce.Root = 0] = "Root", ce[ce.Section = 1] = "Section", ce[ce.Column = 2] = "Column", ce[ce.Widget = 3] = "Widget";
})(ContentFragmentType || (ContentFragmentType = {}));
var Alignment;
(function(ce) {
  ce.left = "left", ce.right = "right", ce.center = "center";
})(Alignment || (Alignment = {}));
var PdfViewMode;
(function(ce) {
  ce[ce.InNewWindow = 0] = "InNewWindow", ce[ce.Preview = 1] = "Preview";
})(PdfViewMode || (PdfViewMode = {}));
var TextType;
(function(ce) {
  ce.text = "text", ce.note = "imageFull";
})(TextType || (TextType = {}));
var NoteColorTheme;
(function(ce) {
  ce.default = "default", ce.sky = "sky", ce.blueberry = "blueberry", ce.jelly = "jelly", ce.cherry = "cherry", ce.tangerine = "tangerine", ce.basil = "basil";
})(NoteColorTheme || (NoteColorTheme = {}));
var VideoSource;
(function(ce) {
  ce.embedded = "embedded", ce.url = "url", ce.mediaLibrary = "mediaLibrary";
})(VideoSource || (VideoSource = {}));
var FlipCardType;
(function(ce) {
  ce.text = "text", ce.imageFull = "imageFull";
})(FlipCardType || (FlipCardType = {}));
var ColumnLayout;
(function(ce) {
  ce.SingleColumn = "SingleColumn", ce.TwoColumns = "TwoColumns", ce.ThreeColumns = "ThreeColumns", ce.FourColumns = "FourColumns", ce.LeftSideDominantTwoColumns = "LeftSideDominantTwoColumns", ce.RightSideDominantTwoColumns = "RightSideDominantTwoColumns";
})(ColumnLayout || (ColumnLayout = {}));
const TwoColumnsConfig = {
  columnsCount: 2
}, SingleColumnConfig = {
  columnsCount: 1
}, ThreeColumnsConfig = {
  columnsCount: 3
}, FourColumnsConfig = {
  columnsCount: 4
}, LeftSideDominantTwoColumnsConfig = {
  columnsCount: 2
}, RightSideDominantTwoColumnsConfig = {
  columnsCount: 2
};
ColumnLayout.SingleColumn, ColumnLayout.TwoColumns, ColumnLayout.ThreeColumns, ColumnLayout.FourColumns, ColumnLayout.LeftSideDominantTwoColumns, ColumnLayout.RightSideDominantTwoColumns;
var ItemType;
(function(ce) {
  ce.MenuItem = "menuItem", ce.SequencedFlow = "sequencedFlow", ce.NonSequencedFlow = "nonSequencedFlow", ce.Quiz = "quiz", ce.ResourcesFolder = "resourcesFolder", ce.Question = "note", ce.Split = "split", ce.Section = "section", ce.StartingMessage = "startingMessage", ce.Hotspot = "hotspot", ce.BlindMapQuestion = "blindMapQuestion", ce.SequencedFlowStep = "sequencedFlowStep", ce.Resource = "resource", ce.HotspotTab = "hotspotTab", ce.Answer = "answer";
})(ItemType || (ItemType = {}));
var RestrictionType;
(function(ce) {
  ce.none = "none", ce.customTime = "customTime", ce.audioDuration = "audioDuration";
})(RestrictionType || (RestrictionType = {}));
RestrictionType.none;
var ModalSize;
(function(ce) {
  ce.Fullscreen = "Fullscreen", ce.Small = "Small", ce.Sidebar = "Sidebar";
})(ModalSize || (ModalSize = {}));
var ContentTypeServerEnum;
(function(ce) {
  ce[ce.Split = -1] = "Split", ce[ce.Question = 1] = "Question", ce[ce.Section = 3] = "Section", ce[ce.BlindMapQuestion = 6] = "BlindMapQuestion", ce[ce.HotspotTab = 7] = "HotspotTab", ce[ce.Hotspot = 8] = "Hotspot", ce[ce.StartingMessage = 9] = "StartingMessage", ce[ce.Resource = 12] = "Resource", ce[ce.SequencedFlowStep = 13] = "SequencedFlowStep";
})(ContentTypeServerEnum || (ContentTypeServerEnum = {}));
var ServerRestrictionType;
(function(ce) {
  ce.CustomDuration = "CustomDuration", ce.AudioDuration = "AudioDuration", ce.None = "None";
})(ServerRestrictionType || (ServerRestrictionType = {}));
ModalSize.Fullscreen;
var ItemTypeServer;
(function(ce) {
  ce[ce.menuItem = 1] = "menuItem", ce[ce.sequencedFlow = 2] = "sequencedFlow", ce[ce.nonSequencedFlow = 3] = "nonSequencedFlow", ce[ce.quiz = 5] = "quiz", ce[ce.resources = 6] = "resources";
})(ItemTypeServer || (ItemTypeServer = {}));
var ElementId;
(function(ce) {
  ce.NavigationMenu = "NavigationMenu", ce.AddNew = "AddNew", ce.AddNewSequencedContent = "AddNewSequencedContent", ce.AddNewNonSequencedContent = "AddNewNonSequencedContent", ce.AddNewQuiz = "AddNewQuiz", ce.AddNewSubmenu = "AddNewSubmenu", ce.EditSqItemName = "EditSqItemName", ce.AddNewItemButton = "AddNewItemButton", ce.AddNewAction = "AddNewAction", ce.AddNewQuestion = "AddNewQuestion", ce.AddNewSplitSequence = "AddNewSplitSequence", ce.RestartGuidedTour = "RestartGuidedTour", ce.Loader = "Loader", ce.NextNavigationButton = "NextNavigationButton", ce.FinishNavigationButton = "FinishNavigationButton";
})(ElementId || (ElementId = {}));
const getValidIndexForArrayAndCurrentIndex = (ce, ie) => ce.length - 1 < ie ? ce.length - 1 : ie < 0 ? 0 : ie, isStringEmptyOrWhiteSpace = (ce) => ce === null || /^ *$/.exec(ce) !== null, isTouchScreen = typeof document < "u" && "ontouchstart" in document.documentElement, Tooltip = ({
  children: ce,
  bodyText: ie,
  trigger: me,
  title: we,
  attachment: Re,
  placement: je,
  hideArrow: Ue,
  mouseEnterDelay: qe,
  mouseLeaveDelay: Ge,
  destroyTooltipOnHide: Xe,
  dontWrapWithSpan: ot
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Tooltip$2,
  {
    prefixCls: "tooltip",
    overlay: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      Re && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tooltip__attachment", children: Re }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tooltip__text-wrapper", children: [
        we && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tooltip__title", children: we }),
        ie
      ] })
    ] }),
    trigger: me,
    placement: je,
    showArrow: !Ue,
    mouseEnterDelay: qe,
    mouseLeaveDelay: Ge,
    destroyTooltipOnHide: Xe,
    visible: isTouchScreen ? !1 : void 0,
    children: ot ? ce : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ce })
  }
), ChoiceSelection = ({ title: ce, options: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "choice-selection__wrapper", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "choice-selection__title", children: ce }),
  ie.map((me, we) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChoiceSelectionOption, { ...me }, we))
] }), ChoiceSelectionOption = ({
  text: ce,
  icon: ie,
  tooltipText: me,
  active: we,
  onClick: Re
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: classNames("choice-selection__option", {
      "choice-selection__option--active": we
    }),
    onClick: Re,
    children: [
      ie && /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "choice-selection__option-icon", icon: ie, fixedWidth: !0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "choice-selection__option-text", children: ce }),
      me && !!me && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { bodyText: me, placement: "left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "choice-selection__option-tooltip-icon", icon: faCircleQuestion, fixedWidth: !0 }) })
    ]
  }
), CircleIconButton = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    onClick: (ie) => {
      var me;
      ce.disabled || (me = ce.onClick) == null || me.call(ce, ie);
    },
    className: classNames(
      "flex h-8 w-8 justify-center items-center",
      "transition duration-150 ease-out hover:ease-in rounded-full",
      {
        "bg-accent border border-solid border-yellow-400 text-grey-900": !ce.disabled,
        "hover:bg-yellow-400 hover:border-yellow-300": !ce.disabled,
        "active:bg-yellow-600 active:border-accent ": !ce.disabled,
        "bg-yellow-900 border border-solid border-yellow-800 text-grey-900": ce.disabled,
        "hover:cursor-pointer": !ce.disabled,
        "hover:cursor-default": ce.disabled,
        "hover:shadow-sm active:shadow-none": !ce.disabled
      }
    ),
    children: ce.children
  }
);
var lib$1 = {}, flattenNames$1 = {}, freeGlobal$3 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$3, freeGlobal$2 = _freeGlobal, freeSelf$2 = typeof self == "object" && self && self.Object === Object && self, root$a = freeGlobal$2 || freeSelf$2 || Function("return this")(), _root = root$a, root$9 = _root, Symbol$7 = root$9.Symbol, _Symbol = Symbol$7, Symbol$6 = _Symbol, objectProto$v = Object.prototype, hasOwnProperty$o = objectProto$v.hasOwnProperty, nativeObjectToString$3 = objectProto$v.toString, symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$2(ce) {
  var ie = hasOwnProperty$o.call(ce, symToStringTag$3), me = ce[symToStringTag$3];
  try {
    ce[symToStringTag$3] = void 0;
    var we = !0;
  } catch {
  }
  var Re = nativeObjectToString$3.call(ce);
  return we && (ie ? ce[symToStringTag$3] = me : delete ce[symToStringTag$3]), Re;
}
var _getRawTag = getRawTag$2, objectProto$u = Object.prototype, nativeObjectToString$2 = objectProto$u.toString;
function objectToString$3(ce) {
  return nativeObjectToString$2.call(ce);
}
var _objectToString = objectToString$3, Symbol$5 = _Symbol, getRawTag$1 = _getRawTag, objectToString$2 = _objectToString, nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]", symToStringTag$2 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$8(ce) {
  return ce == null ? ce === void 0 ? undefinedTag$1 : nullTag$1 : symToStringTag$2 && symToStringTag$2 in Object(ce) ? getRawTag$1(ce) : objectToString$2(ce);
}
var _baseGetTag = baseGetTag$8, isArray$c = Array.isArray, isArray_1 = isArray$c;
function isObjectLike$b(ce) {
  return ce != null && typeof ce == "object";
}
var isObjectLike_1 = isObjectLike$b, baseGetTag$7 = _baseGetTag, isArray$b = isArray_1, isObjectLike$a = isObjectLike_1, stringTag$6 = "[object String]";
function isString(ce) {
  return typeof ce == "string" || !isArray$b(ce) && isObjectLike$a(ce) && baseGetTag$7(ce) == stringTag$6;
}
var isString_1 = isString;
function createBaseFor$2(ce) {
  return function(ie, me, we) {
    for (var Re = -1, je = Object(ie), Ue = we(ie), qe = Ue.length; qe--; ) {
      var Ge = Ue[ce ? qe : ++Re];
      if (me(je[Ge], Ge, je) === !1)
        break;
    }
    return ie;
  };
}
var _createBaseFor = createBaseFor$2, createBaseFor$1 = _createBaseFor, baseFor$2 = createBaseFor$1(), _baseFor = baseFor$2;
function baseTimes$2(ce, ie) {
  for (var me = -1, we = Array(ce); ++me < ce; )
    we[me] = ie(me);
  return we;
}
var _baseTimes = baseTimes$2, baseGetTag$6 = _baseGetTag, isObjectLike$9 = isObjectLike_1, argsTag$6 = "[object Arguments]";
function baseIsArguments$2(ce) {
  return isObjectLike$9(ce) && baseGetTag$6(ce) == argsTag$6;
}
var _baseIsArguments = baseIsArguments$2, baseIsArguments$1 = _baseIsArguments, isObjectLike$8 = isObjectLike_1, objectProto$t = Object.prototype, hasOwnProperty$n = objectProto$t.hasOwnProperty, propertyIsEnumerable$3 = objectProto$t.propertyIsEnumerable, isArguments$3 = baseIsArguments$1(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments$1 : function(ce) {
  return isObjectLike$8(ce) && hasOwnProperty$n.call(ce, "callee") && !propertyIsEnumerable$3.call(ce, "callee");
}, isArguments_1 = isArguments$3, isBuffer$4 = { exports: {} };
function stubFalse$1() {
  return !1;
}
var stubFalse_1 = stubFalse$1;
isBuffer$4.exports;
(function(ce, ie) {
  var me = _root, we = stubFalse_1, Re = ie && !ie.nodeType && ie, je = Re && !0 && ce && !ce.nodeType && ce, Ue = je && je.exports === Re, qe = Ue ? me.Buffer : void 0, Ge = qe ? qe.isBuffer : void 0, Xe = Ge || we;
  ce.exports = Xe;
})(isBuffer$4, isBuffer$4.exports);
var isBufferExports = isBuffer$4.exports, MAX_SAFE_INTEGER$3 = 9007199254740991, reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$3(ce, ie) {
  var me = typeof ce;
  return ie = ie ?? MAX_SAFE_INTEGER$3, !!ie && (me == "number" || me != "symbol" && reIsUint$1.test(ce)) && ce > -1 && ce % 1 == 0 && ce < ie;
}
var _isIndex = isIndex$3, MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$4(ce) {
  return typeof ce == "number" && ce > -1 && ce % 1 == 0 && ce <= MAX_SAFE_INTEGER$2;
}
var isLength_1 = isLength$4, baseGetTag$5 = _baseGetTag, isLength$3 = isLength_1, isObjectLike$7 = isObjectLike_1, argsTag$5 = "[object Arguments]", arrayTag$4 = "[object Array]", boolTag$5 = "[object Boolean]", dateTag$5 = "[object Date]", errorTag$4 = "[object Error]", funcTag$4 = "[object Function]", mapTag$8 = "[object Map]", numberTag$5 = "[object Number]", objectTag$8 = "[object Object]", regexpTag$5 = "[object RegExp]", setTag$8 = "[object Set]", stringTag$5 = "[object String]", weakMapTag$4 = "[object WeakMap]", arrayBufferTag$5 = "[object ArrayBuffer]", dataViewTag$7 = "[object DataView]", float32Tag$3 = "[object Float32Array]", float64Tag$3 = "[object Float64Array]", int8Tag$3 = "[object Int8Array]", int16Tag$3 = "[object Int16Array]", int32Tag$3 = "[object Int32Array]", uint8Tag$3 = "[object Uint8Array]", uint8ClampedTag$3 = "[object Uint8ClampedArray]", uint16Tag$3 = "[object Uint16Array]", uint32Tag$3 = "[object Uint32Array]", typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = !0;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$4] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$5] = typedArrayTags$1[weakMapTag$4] = !1;
function baseIsTypedArray$2(ce) {
  return isObjectLike$7(ce) && isLength$3(ce.length) && !!typedArrayTags$1[baseGetTag$5(ce)];
}
var _baseIsTypedArray = baseIsTypedArray$2;
function baseUnary$4(ce) {
  return function(ie) {
    return ce(ie);
  };
}
var _baseUnary = baseUnary$4, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(ce, ie) {
  var me = _freeGlobal, we = ie && !ie.nodeType && ie, Re = we && !0 && ce && !ce.nodeType && ce, je = Re && Re.exports === we, Ue = je && me.process, qe = function() {
    try {
      var Ge = Re && Re.require && Re.require("util").types;
      return Ge || Ue && Ue.binding && Ue.binding("util");
    } catch {
    }
  }();
  ce.exports = qe;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray$1 = _baseIsTypedArray, baseUnary$3 = _baseUnary, nodeUtil$3 = _nodeUtilExports, nodeIsTypedArray$1 = nodeUtil$3 && nodeUtil$3.isTypedArray, isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1, isTypedArray_1 = isTypedArray$3, baseTimes$1 = _baseTimes, isArguments$2 = isArguments_1, isArray$a = isArray_1, isBuffer$3 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$2 = isTypedArray_1, objectProto$s = Object.prototype, hasOwnProperty$m = objectProto$s.hasOwnProperty;
function arrayLikeKeys$3(ce, ie) {
  var me = isArray$a(ce), we = !me && isArguments$2(ce), Re = !me && !we && isBuffer$3(ce), je = !me && !we && !Re && isTypedArray$2(ce), Ue = me || we || Re || je, qe = Ue ? baseTimes$1(ce.length, String) : [], Ge = qe.length;
  for (var Xe in ce)
    (ie || hasOwnProperty$m.call(ce, Xe)) && !(Ue && // Safari 9 has enumerable `arguments.length` in strict mode.
    (Xe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    Re && (Xe == "offset" || Xe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    je && (Xe == "buffer" || Xe == "byteLength" || Xe == "byteOffset") || // Skip index properties.
    isIndex$2(Xe, Ge))) && qe.push(Xe);
  return qe;
}
var _arrayLikeKeys = arrayLikeKeys$3, objectProto$r = Object.prototype;
function isPrototype$4(ce) {
  var ie = ce && ce.constructor, me = typeof ie == "function" && ie.prototype || objectProto$r;
  return ce === me;
}
var _isPrototype = isPrototype$4;
function overArg$3(ce, ie) {
  return function(me) {
    return ce(ie(me));
  };
}
var _overArg = overArg$3, overArg$2 = _overArg, nativeKeys$2 = overArg$2(Object.keys, Object), _nativeKeys = nativeKeys$2, isPrototype$3 = _isPrototype, nativeKeys$1 = _nativeKeys, objectProto$q = Object.prototype, hasOwnProperty$l = objectProto$q.hasOwnProperty;
function baseKeys$2(ce) {
  if (!isPrototype$3(ce))
    return nativeKeys$1(ce);
  var ie = [];
  for (var me in Object(ce))
    hasOwnProperty$l.call(ce, me) && me != "constructor" && ie.push(me);
  return ie;
}
var _baseKeys = baseKeys$2;
function isObject$9(ce) {
  var ie = typeof ce;
  return ce != null && (ie == "object" || ie == "function");
}
var isObject_1 = isObject$9, baseGetTag$4 = _baseGetTag, isObject$8 = isObject_1, asyncTag$1 = "[object AsyncFunction]", funcTag$3 = "[object Function]", genTag$2 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$3(ce) {
  if (!isObject$8(ce))
    return !1;
  var ie = baseGetTag$4(ce);
  return ie == funcTag$3 || ie == genTag$2 || ie == asyncTag$1 || ie == proxyTag$1;
}
var isFunction_1 = isFunction$3, isFunction$2 = isFunction_1, isLength$2 = isLength_1;
function isArrayLike$5(ce) {
  return ce != null && isLength$2(ce.length) && !isFunction$2(ce);
}
var isArrayLike_1 = isArrayLike$5, arrayLikeKeys$2 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$6(ce) {
  return isArrayLike$4(ce) ? arrayLikeKeys$2(ce) : baseKeys$1(ce);
}
var keys_1 = keys$6, baseFor$1 = _baseFor, keys$5 = keys_1;
function baseForOwn$3(ce, ie) {
  return ce && baseFor$1(ce, ie, keys$5);
}
var _baseForOwn = baseForOwn$3;
function identity$3(ce) {
  return ce;
}
var identity_1 = identity$3, identity$2 = identity_1;
function castFunction$2(ce) {
  return typeof ce == "function" ? ce : identity$2;
}
var _castFunction = castFunction$2, baseForOwn$2 = _baseForOwn, castFunction$1 = _castFunction;
function forOwn(ce, ie) {
  return ce && baseForOwn$2(ce, castFunction$1(ie));
}
var forOwn_1 = forOwn, overArg$1 = _overArg, getPrototype$4 = overArg$1(Object.getPrototypeOf, Object), _getPrototype = getPrototype$4, baseGetTag$3 = _baseGetTag, getPrototype$3 = _getPrototype, isObjectLike$6 = isObjectLike_1, objectTag$7 = "[object Object]", funcProto$5 = Function.prototype, objectProto$p = Object.prototype, funcToString$5 = funcProto$5.toString, hasOwnProperty$k = objectProto$p.hasOwnProperty, objectCtorString$1 = funcToString$5.call(Object);
function isPlainObject$2(ce) {
  if (!isObjectLike$6(ce) || baseGetTag$3(ce) != objectTag$7)
    return !1;
  var ie = getPrototype$3(ce);
  if (ie === null)
    return !0;
  var me = hasOwnProperty$k.call(ie, "constructor") && ie.constructor;
  return typeof me == "function" && me instanceof me && funcToString$5.call(me) == objectCtorString$1;
}
var isPlainObject_1 = isPlainObject$2;
function arrayMap$3(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length, Re = Array(we); ++me < we; )
    Re[me] = ie(ce[me], me, ce);
  return Re;
}
var _arrayMap = arrayMap$3;
function listCacheClear$2() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$2;
function eq$4(ce, ie) {
  return ce === ie || ce !== ce && ie !== ie;
}
var eq_1 = eq$4, eq$3 = eq_1;
function assocIndexOf$5(ce, ie) {
  for (var me = ce.length; me--; )
    if (eq$3(ce[me][0], ie))
      return me;
  return -1;
}
var _assocIndexOf = assocIndexOf$5, assocIndexOf$4 = _assocIndexOf, arrayProto$1 = Array.prototype, splice$1 = arrayProto$1.splice;
function listCacheDelete$2(ce) {
  var ie = this.__data__, me = assocIndexOf$4(ie, ce);
  if (me < 0)
    return !1;
  var we = ie.length - 1;
  return me == we ? ie.pop() : splice$1.call(ie, me, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$2, assocIndexOf$3 = _assocIndexOf;
function listCacheGet$2(ce) {
  var ie = this.__data__, me = assocIndexOf$3(ie, ce);
  return me < 0 ? void 0 : ie[me][1];
}
var _listCacheGet = listCacheGet$2, assocIndexOf$2 = _assocIndexOf;
function listCacheHas$2(ce) {
  return assocIndexOf$2(this.__data__, ce) > -1;
}
var _listCacheHas = listCacheHas$2, assocIndexOf$1 = _assocIndexOf;
function listCacheSet$2(ce, ie) {
  var me = this.__data__, we = assocIndexOf$1(me, ce);
  return we < 0 ? (++this.size, me.push([ce, ie])) : me[we][1] = ie, this;
}
var _listCacheSet = listCacheSet$2, listCacheClear$1 = _listCacheClear, listCacheDelete$1 = _listCacheDelete, listCacheGet$1 = _listCacheGet, listCacheHas$1 = _listCacheHas, listCacheSet$1 = _listCacheSet;
function ListCache$5(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype.delete = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;
var _ListCache = ListCache$5, ListCache$4 = _ListCache;
function stackClear$2() {
  this.__data__ = new ListCache$4(), this.size = 0;
}
var _stackClear = stackClear$2;
function stackDelete$2(ce) {
  var ie = this.__data__, me = ie.delete(ce);
  return this.size = ie.size, me;
}
var _stackDelete = stackDelete$2;
function stackGet$2(ce) {
  return this.__data__.get(ce);
}
var _stackGet = stackGet$2;
function stackHas$2(ce) {
  return this.__data__.has(ce);
}
var _stackHas = stackHas$2, root$8 = _root, coreJsData$2 = root$8["__core-js_shared__"], _coreJsData = coreJsData$2, coreJsData$1 = _coreJsData, maskSrcKey$1 = function() {
  var ce = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return ce ? "Symbol(src)_1." + ce : "";
}();
function isMasked$2(ce) {
  return !!maskSrcKey$1 && maskSrcKey$1 in ce;
}
var _isMasked = isMasked$2, funcProto$4 = Function.prototype, funcToString$4 = funcProto$4.toString;
function toSource$3(ce) {
  if (ce != null) {
    try {
      return funcToString$4.call(ce);
    } catch {
    }
    try {
      return ce + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$3, isFunction$1 = isFunction_1, isMasked$1 = _isMasked, isObject$7 = isObject_1, toSource$2 = _toSource, reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor$1 = /^\[object .+?Constructor\]$/, funcProto$3 = Function.prototype, objectProto$o = Object.prototype, funcToString$3 = funcProto$3.toString, hasOwnProperty$j = objectProto$o.hasOwnProperty, reIsNative$1 = RegExp(
  "^" + funcToString$3.call(hasOwnProperty$j).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(ce) {
  if (!isObject$7(ce) || isMasked$1(ce))
    return !1;
  var ie = isFunction$1(ce) ? reIsNative$1 : reIsHostCtor$1;
  return ie.test(toSource$2(ce));
}
var _baseIsNative = baseIsNative$2;
function getValue$2(ce, ie) {
  return ce == null ? void 0 : ce[ie];
}
var _getValue = getValue$2, baseIsNative$1 = _baseIsNative, getValue$1 = _getValue;
function getNative$8(ce, ie) {
  var me = getValue$1(ce, ie);
  return baseIsNative$1(me) ? me : void 0;
}
var _getNative = getNative$8, getNative$7 = _getNative, root$7 = _root, Map$5 = getNative$7(root$7, "Map"), _Map = Map$5, getNative$6 = _getNative, nativeCreate$5 = getNative$6(Object, "create"), _nativeCreate = nativeCreate$5, nativeCreate$4 = _nativeCreate;
function hashClear$2() {
  this.__data__ = nativeCreate$4 ? nativeCreate$4(null) : {}, this.size = 0;
}
var _hashClear = hashClear$2;
function hashDelete$2(ce) {
  var ie = this.has(ce) && delete this.__data__[ce];
  return this.size -= ie ? 1 : 0, ie;
}
var _hashDelete = hashDelete$2, nativeCreate$3 = _nativeCreate, HASH_UNDEFINED$5 = "__lodash_hash_undefined__", objectProto$n = Object.prototype, hasOwnProperty$i = objectProto$n.hasOwnProperty;
function hashGet$2(ce) {
  var ie = this.__data__;
  if (nativeCreate$3) {
    var me = ie[ce];
    return me === HASH_UNDEFINED$5 ? void 0 : me;
  }
  return hasOwnProperty$i.call(ie, ce) ? ie[ce] : void 0;
}
var _hashGet = hashGet$2, nativeCreate$2 = _nativeCreate, objectProto$m = Object.prototype, hasOwnProperty$h = objectProto$m.hasOwnProperty;
function hashHas$2(ce) {
  var ie = this.__data__;
  return nativeCreate$2 ? ie[ce] !== void 0 : hasOwnProperty$h.call(ie, ce);
}
var _hashHas = hashHas$2, nativeCreate$1 = _nativeCreate, HASH_UNDEFINED$4 = "__lodash_hash_undefined__";
function hashSet$2(ce, ie) {
  var me = this.__data__;
  return this.size += this.has(ce) ? 0 : 1, me[ce] = nativeCreate$1 && ie === void 0 ? HASH_UNDEFINED$4 : ie, this;
}
var _hashSet = hashSet$2, hashClear$1 = _hashClear, hashDelete$1 = _hashDelete, hashGet$1 = _hashGet, hashHas$1 = _hashHas, hashSet$1 = _hashSet;
function Hash$2(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype.delete = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;
var _Hash = Hash$2, Hash$1 = _Hash, ListCache$3 = _ListCache, Map$4 = _Map;
function mapCacheClear$2() {
  this.size = 0, this.__data__ = {
    hash: new Hash$1(),
    map: new (Map$4 || ListCache$3)(),
    string: new Hash$1()
  };
}
var _mapCacheClear = mapCacheClear$2;
function isKeyable$2(ce) {
  var ie = typeof ce;
  return ie == "string" || ie == "number" || ie == "symbol" || ie == "boolean" ? ce !== "__proto__" : ce === null;
}
var _isKeyable = isKeyable$2, isKeyable$1 = _isKeyable;
function getMapData$5(ce, ie) {
  var me = ce.__data__;
  return isKeyable$1(ie) ? me[typeof ie == "string" ? "string" : "hash"] : me.map;
}
var _getMapData = getMapData$5, getMapData$4 = _getMapData;
function mapCacheDelete$2(ce) {
  var ie = getMapData$4(this, ce).delete(ce);
  return this.size -= ie ? 1 : 0, ie;
}
var _mapCacheDelete = mapCacheDelete$2, getMapData$3 = _getMapData;
function mapCacheGet$2(ce) {
  return getMapData$3(this, ce).get(ce);
}
var _mapCacheGet = mapCacheGet$2, getMapData$2 = _getMapData;
function mapCacheHas$2(ce) {
  return getMapData$2(this, ce).has(ce);
}
var _mapCacheHas = mapCacheHas$2, getMapData$1 = _getMapData;
function mapCacheSet$2(ce, ie) {
  var me = getMapData$1(this, ce), we = me.size;
  return me.set(ce, ie), this.size += me.size == we ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$2, mapCacheClear$1 = _mapCacheClear, mapCacheDelete$1 = _mapCacheDelete, mapCacheGet$1 = _mapCacheGet, mapCacheHas$1 = _mapCacheHas, mapCacheSet$1 = _mapCacheSet;
function MapCache$4(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype.delete = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$4, ListCache$2 = _ListCache, Map$3 = _Map, MapCache$3 = _MapCache, LARGE_ARRAY_SIZE$1 = 200;
function stackSet$2(ce, ie) {
  var me = this.__data__;
  if (me instanceof ListCache$2) {
    var we = me.__data__;
    if (!Map$3 || we.length < LARGE_ARRAY_SIZE$1 - 1)
      return we.push([ce, ie]), this.size = ++me.size, this;
    me = this.__data__ = new MapCache$3(we);
  }
  return me.set(ce, ie), this.size = me.size, this;
}
var _stackSet = stackSet$2, ListCache$1 = _ListCache, stackClear$1 = _stackClear, stackDelete$1 = _stackDelete, stackGet$1 = _stackGet, stackHas$1 = _stackHas, stackSet$1 = _stackSet;
function Stack$4(ce) {
  var ie = this.__data__ = new ListCache$1(ce);
  this.size = ie.size;
}
Stack$4.prototype.clear = stackClear$1;
Stack$4.prototype.delete = stackDelete$1;
Stack$4.prototype.get = stackGet$1;
Stack$4.prototype.has = stackHas$1;
Stack$4.prototype.set = stackSet$1;
var _Stack = Stack$4, HASH_UNDEFINED$3 = "__lodash_hash_undefined__";
function setCacheAdd$2(ce) {
  return this.__data__.set(ce, HASH_UNDEFINED$3), this;
}
var _setCacheAdd = setCacheAdd$2;
function setCacheHas$2(ce) {
  return this.__data__.has(ce);
}
var _setCacheHas = setCacheHas$2, MapCache$2 = _MapCache, setCacheAdd$1 = _setCacheAdd, setCacheHas$1 = _setCacheHas;
function SetCache$2(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.__data__ = new MapCache$2(); ++ie < me; )
    this.add(ce[ie]);
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;
var _SetCache = SetCache$2;
function arraySome$2(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length; ++me < we; )
    if (ie(ce[me], me, ce))
      return !0;
  return !1;
}
var _arraySome = arraySome$2;
function cacheHas$2(ce, ie) {
  return ce.has(ie);
}
var _cacheHas = cacheHas$2, SetCache$1 = _SetCache, arraySome$1 = _arraySome, cacheHas$1 = _cacheHas, COMPARE_PARTIAL_FLAG$b = 1, COMPARE_UNORDERED_FLAG$7 = 2;
function equalArrays$3(ce, ie, me, we, Re, je) {
  var Ue = me & COMPARE_PARTIAL_FLAG$b, qe = ce.length, Ge = ie.length;
  if (qe != Ge && !(Ue && Ge > qe))
    return !1;
  var Xe = je.get(ce), ot = je.get(ie);
  if (Xe && ot)
    return Xe == ie && ot == ce;
  var vt = -1, bt = !0, Tt = me & COMPARE_UNORDERED_FLAG$7 ? new SetCache$1() : void 0;
  for (je.set(ce, ie), je.set(ie, ce); ++vt < qe; ) {
    var wt = ce[vt], St = ie[vt];
    if (we)
      var It = Ue ? we(St, wt, vt, ie, ce, je) : we(wt, St, vt, ce, ie, je);
    if (It !== void 0) {
      if (It)
        continue;
      bt = !1;
      break;
    }
    if (Tt) {
      if (!arraySome$1(ie, function(Pt, kt) {
        if (!cacheHas$1(Tt, kt) && (wt === Pt || Re(wt, Pt, me, we, je)))
          return Tt.push(kt);
      })) {
        bt = !1;
        break;
      }
    } else if (!(wt === St || Re(wt, St, me, we, je))) {
      bt = !1;
      break;
    }
  }
  return je.delete(ce), je.delete(ie), bt;
}
var _equalArrays = equalArrays$3, root$6 = _root, Uint8Array$4 = root$6.Uint8Array, _Uint8Array = Uint8Array$4;
function mapToArray$2(ce) {
  var ie = -1, me = Array(ce.size);
  return ce.forEach(function(we, Re) {
    me[++ie] = [Re, we];
  }), me;
}
var _mapToArray = mapToArray$2;
function setToArray$2(ce) {
  var ie = -1, me = Array(ce.size);
  return ce.forEach(function(we) {
    me[++ie] = we;
  }), me;
}
var _setToArray = setToArray$2, Symbol$4 = _Symbol, Uint8Array$3 = _Uint8Array, eq$2 = eq_1, equalArrays$2 = _equalArrays, mapToArray$1 = _mapToArray, setToArray$1 = _setToArray, COMPARE_PARTIAL_FLAG$a = 1, COMPARE_UNORDERED_FLAG$6 = 2, boolTag$4 = "[object Boolean]", dateTag$4 = "[object Date]", errorTag$3 = "[object Error]", mapTag$7 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$4 = "[object RegExp]", setTag$7 = "[object Set]", stringTag$4 = "[object String]", symbolTag$6 = "[object Symbol]", arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$6 = "[object DataView]", symbolProto$4 = Symbol$4 ? Symbol$4.prototype : void 0, symbolValueOf$2 = symbolProto$4 ? symbolProto$4.valueOf : void 0;
function equalByTag$2(ce, ie, me, we, Re, je, Ue) {
  switch (me) {
    case dataViewTag$6:
      if (ce.byteLength != ie.byteLength || ce.byteOffset != ie.byteOffset)
        return !1;
      ce = ce.buffer, ie = ie.buffer;
    case arrayBufferTag$4:
      return !(ce.byteLength != ie.byteLength || !je(new Uint8Array$3(ce), new Uint8Array$3(ie)));
    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      return eq$2(+ce, +ie);
    case errorTag$3:
      return ce.name == ie.name && ce.message == ie.message;
    case regexpTag$4:
    case stringTag$4:
      return ce == ie + "";
    case mapTag$7:
      var qe = mapToArray$1;
    case setTag$7:
      var Ge = we & COMPARE_PARTIAL_FLAG$a;
      if (qe || (qe = setToArray$1), ce.size != ie.size && !Ge)
        return !1;
      var Xe = Ue.get(ce);
      if (Xe)
        return Xe == ie;
      we |= COMPARE_UNORDERED_FLAG$6, Ue.set(ce, ie);
      var ot = equalArrays$2(qe(ce), qe(ie), we, Re, je, Ue);
      return Ue.delete(ce), ot;
    case symbolTag$6:
      if (symbolValueOf$2)
        return symbolValueOf$2.call(ce) == symbolValueOf$2.call(ie);
  }
  return !1;
}
var _equalByTag = equalByTag$2;
function arrayPush$3(ce, ie) {
  for (var me = -1, we = ie.length, Re = ce.length; ++me < we; )
    ce[Re + me] = ie[me];
  return ce;
}
var _arrayPush = arrayPush$3, arrayPush$2 = _arrayPush, isArray$9 = isArray_1;
function baseGetAllKeys$3(ce, ie, me) {
  var we = ie(ce);
  return isArray$9(ce) ? we : arrayPush$2(we, me(ce));
}
var _baseGetAllKeys = baseGetAllKeys$3;
function arrayFilter$2(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length, Re = 0, je = []; ++me < we; ) {
    var Ue = ce[me];
    ie(Ue, me, ce) && (je[Re++] = Ue);
  }
  return je;
}
var _arrayFilter = arrayFilter$2;
function stubArray$3() {
  return [];
}
var stubArray_1 = stubArray$3, arrayFilter$1 = _arrayFilter, stubArray$2 = stubArray_1, objectProto$l = Object.prototype, propertyIsEnumerable$2 = objectProto$l.propertyIsEnumerable, nativeGetSymbols$2 = Object.getOwnPropertySymbols, getSymbols$4 = nativeGetSymbols$2 ? function(ce) {
  return ce == null ? [] : (ce = Object(ce), arrayFilter$1(nativeGetSymbols$2(ce), function(ie) {
    return propertyIsEnumerable$2.call(ce, ie);
  }));
} : stubArray$2, _getSymbols = getSymbols$4, baseGetAllKeys$2 = _baseGetAllKeys, getSymbols$3 = _getSymbols, keys$4 = keys_1;
function getAllKeys$3(ce) {
  return baseGetAllKeys$2(ce, keys$4, getSymbols$3);
}
var _getAllKeys = getAllKeys$3, getAllKeys$2 = _getAllKeys, COMPARE_PARTIAL_FLAG$9 = 1, objectProto$k = Object.prototype, hasOwnProperty$g = objectProto$k.hasOwnProperty;
function equalObjects$2(ce, ie, me, we, Re, je) {
  var Ue = me & COMPARE_PARTIAL_FLAG$9, qe = getAllKeys$2(ce), Ge = qe.length, Xe = getAllKeys$2(ie), ot = Xe.length;
  if (Ge != ot && !Ue)
    return !1;
  for (var vt = Ge; vt--; ) {
    var bt = qe[vt];
    if (!(Ue ? bt in ie : hasOwnProperty$g.call(ie, bt)))
      return !1;
  }
  var Tt = je.get(ce), wt = je.get(ie);
  if (Tt && wt)
    return Tt == ie && wt == ce;
  var St = !0;
  je.set(ce, ie), je.set(ie, ce);
  for (var It = Ue; ++vt < Ge; ) {
    bt = qe[vt];
    var Pt = ce[bt], kt = ie[bt];
    if (we)
      var Ot = Ue ? we(kt, Pt, bt, ie, ce, je) : we(Pt, kt, bt, ce, ie, je);
    if (!(Ot === void 0 ? Pt === kt || Re(Pt, kt, me, we, je) : Ot)) {
      St = !1;
      break;
    }
    It || (It = bt == "constructor");
  }
  if (St && !It) {
    var Jr = ce.constructor, en = ie.constructor;
    Jr != en && "constructor" in ce && "constructor" in ie && !(typeof Jr == "function" && Jr instanceof Jr && typeof en == "function" && en instanceof en) && (St = !1);
  }
  return je.delete(ce), je.delete(ie), St;
}
var _equalObjects = equalObjects$2, getNative$5 = _getNative, root$5 = _root, DataView$3 = getNative$5(root$5, "DataView"), _DataView = DataView$3, getNative$4 = _getNative, root$4 = _root, Promise$3 = getNative$4(root$4, "Promise"), _Promise = Promise$3, getNative$3 = _getNative, root$3 = _root, Set$3 = getNative$3(root$3, "Set"), _Set = Set$3, getNative$2 = _getNative, root$2 = _root, WeakMap$3 = getNative$2(root$2, "WeakMap"), _WeakMap = WeakMap$3, DataView$2 = _DataView, Map$2 = _Map, Promise$2 = _Promise, Set$2 = _Set, WeakMap$2 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource$1 = _toSource, mapTag$6 = "[object Map]", objectTag$6 = "[object Object]", promiseTag$1 = "[object Promise]", setTag$6 = "[object Set]", weakMapTag$3 = "[object WeakMap]", dataViewTag$5 = "[object DataView]", dataViewCtorString$1 = toSource$1(DataView$2), mapCtorString$1 = toSource$1(Map$2), promiseCtorString$1 = toSource$1(Promise$2), setCtorString$1 = toSource$1(Set$2), weakMapCtorString$1 = toSource$1(WeakMap$2), getTag$5 = baseGetTag$2;
(DataView$2 && getTag$5(new DataView$2(new ArrayBuffer(1))) != dataViewTag$5 || Map$2 && getTag$5(new Map$2()) != mapTag$6 || Promise$2 && getTag$5(Promise$2.resolve()) != promiseTag$1 || Set$2 && getTag$5(new Set$2()) != setTag$6 || WeakMap$2 && getTag$5(new WeakMap$2()) != weakMapTag$3) && (getTag$5 = function(ce) {
  var ie = baseGetTag$2(ce), me = ie == objectTag$6 ? ce.constructor : void 0, we = me ? toSource$1(me) : "";
  if (we)
    switch (we) {
      case dataViewCtorString$1:
        return dataViewTag$5;
      case mapCtorString$1:
        return mapTag$6;
      case promiseCtorString$1:
        return promiseTag$1;
      case setCtorString$1:
        return setTag$6;
      case weakMapCtorString$1:
        return weakMapTag$3;
    }
  return ie;
});
var _getTag = getTag$5, Stack$3 = _Stack, equalArrays$1 = _equalArrays, equalByTag$1 = _equalByTag, equalObjects$1 = _equalObjects, getTag$4 = _getTag, isArray$8 = isArray_1, isBuffer$2 = isBufferExports, isTypedArray$1 = isTypedArray_1, COMPARE_PARTIAL_FLAG$8 = 1, argsTag$4 = "[object Arguments]", arrayTag$3 = "[object Array]", objectTag$5 = "[object Object]", objectProto$j = Object.prototype, hasOwnProperty$f = objectProto$j.hasOwnProperty;
function baseIsEqualDeep$2(ce, ie, me, we, Re, je) {
  var Ue = isArray$8(ce), qe = isArray$8(ie), Ge = Ue ? arrayTag$3 : getTag$4(ce), Xe = qe ? arrayTag$3 : getTag$4(ie);
  Ge = Ge == argsTag$4 ? objectTag$5 : Ge, Xe = Xe == argsTag$4 ? objectTag$5 : Xe;
  var ot = Ge == objectTag$5, vt = Xe == objectTag$5, bt = Ge == Xe;
  if (bt && isBuffer$2(ce)) {
    if (!isBuffer$2(ie))
      return !1;
    Ue = !0, ot = !1;
  }
  if (bt && !ot)
    return je || (je = new Stack$3()), Ue || isTypedArray$1(ce) ? equalArrays$1(ce, ie, me, we, Re, je) : equalByTag$1(ce, ie, Ge, me, we, Re, je);
  if (!(me & COMPARE_PARTIAL_FLAG$8)) {
    var Tt = ot && hasOwnProperty$f.call(ce, "__wrapped__"), wt = vt && hasOwnProperty$f.call(ie, "__wrapped__");
    if (Tt || wt) {
      var St = Tt ? ce.value() : ce, It = wt ? ie.value() : ie;
      return je || (je = new Stack$3()), Re(St, It, me, we, je);
    }
  }
  return bt ? (je || (je = new Stack$3()), equalObjects$1(ce, ie, me, we, Re, je)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$2, baseIsEqualDeep$1 = _baseIsEqualDeep, isObjectLike$5 = isObjectLike_1;
function baseIsEqual$3(ce, ie, me, we, Re) {
  return ce === ie ? !0 : ce == null || ie == null || !isObjectLike$5(ce) && !isObjectLike$5(ie) ? ce !== ce && ie !== ie : baseIsEqualDeep$1(ce, ie, me, we, baseIsEqual$3, Re);
}
var _baseIsEqual = baseIsEqual$3, Stack$2 = _Stack, baseIsEqual$2 = _baseIsEqual, COMPARE_PARTIAL_FLAG$7 = 1, COMPARE_UNORDERED_FLAG$5 = 2;
function baseIsMatch$2(ce, ie, me, we) {
  var Re = me.length, je = Re, Ue = !we;
  if (ce == null)
    return !je;
  for (ce = Object(ce); Re--; ) {
    var qe = me[Re];
    if (Ue && qe[2] ? qe[1] !== ce[qe[0]] : !(qe[0] in ce))
      return !1;
  }
  for (; ++Re < je; ) {
    qe = me[Re];
    var Ge = qe[0], Xe = ce[Ge], ot = qe[1];
    if (Ue && qe[2]) {
      if (Xe === void 0 && !(Ge in ce))
        return !1;
    } else {
      var vt = new Stack$2();
      if (we)
        var bt = we(Xe, ot, Ge, ce, ie, vt);
      if (!(bt === void 0 ? baseIsEqual$2(ot, Xe, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, we, vt) : bt))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$2, isObject$6 = isObject_1;
function isStrictComparable$3(ce) {
  return ce === ce && !isObject$6(ce);
}
var _isStrictComparable = isStrictComparable$3, isStrictComparable$2 = _isStrictComparable, keys$3 = keys_1;
function getMatchData$2(ce) {
  for (var ie = keys$3(ce), me = ie.length; me--; ) {
    var we = ie[me], Re = ce[we];
    ie[me] = [we, Re, isStrictComparable$2(Re)];
  }
  return ie;
}
var _getMatchData = getMatchData$2;
function matchesStrictComparable$3(ce, ie) {
  return function(me) {
    return me == null ? !1 : me[ce] === ie && (ie !== void 0 || ce in Object(me));
  };
}
var _matchesStrictComparable = matchesStrictComparable$3, baseIsMatch$1 = _baseIsMatch, getMatchData$1 = _getMatchData, matchesStrictComparable$2 = _matchesStrictComparable;
function baseMatches$2(ce) {
  var ie = getMatchData$1(ce);
  return ie.length == 1 && ie[0][2] ? matchesStrictComparable$2(ie[0][0], ie[0][1]) : function(me) {
    return me === ce || baseIsMatch$1(me, ce, ie);
  };
}
var _baseMatches = baseMatches$2, baseGetTag$1 = _baseGetTag, isObjectLike$4 = isObjectLike_1, symbolTag$5 = "[object Symbol]";
function isSymbol$5(ce) {
  return typeof ce == "symbol" || isObjectLike$4(ce) && baseGetTag$1(ce) == symbolTag$5;
}
var isSymbol_1 = isSymbol$5, isArray$7 = isArray_1, isSymbol$4 = isSymbol_1, reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$4(ce, ie) {
  if (isArray$7(ce))
    return !1;
  var me = typeof ce;
  return me == "number" || me == "symbol" || me == "boolean" || ce == null || isSymbol$4(ce) ? !0 : reIsPlainProp$1.test(ce) || !reIsDeepProp$1.test(ce) || ie != null && ce in Object(ie);
}
var _isKey = isKey$4, MapCache$1 = _MapCache, FUNC_ERROR_TEXT$4 = "Expected a function";
function memoize$3(ce, ie) {
  if (typeof ce != "function" || ie != null && typeof ie != "function")
    throw new TypeError(FUNC_ERROR_TEXT$4);
  var me = function() {
    var we = arguments, Re = ie ? ie.apply(this, we) : we[0], je = me.cache;
    if (je.has(Re))
      return je.get(Re);
    var Ue = ce.apply(this, we);
    return me.cache = je.set(Re, Ue) || je, Ue;
  };
  return me.cache = new (memoize$3.Cache || MapCache$1)(), me;
}
memoize$3.Cache = MapCache$1;
var memoize_1 = memoize$3, memoize$2 = memoize_1, MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$2(ce) {
  var ie = memoize$2(ce, function(we) {
    return me.size === MAX_MEMOIZE_SIZE$1 && me.clear(), we;
  }), me = ie.cache;
  return ie;
}
var _memoizeCapped = memoizeCapped$2, memoizeCapped$1 = _memoizeCapped, rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar$1 = /\\(\\)?/g, stringToPath$2 = memoizeCapped$1(function(ce) {
  var ie = [];
  return ce.charCodeAt(0) === 46 && ie.push(""), ce.replace(rePropName$1, function(me, we, Re, je) {
    ie.push(Re ? je.replace(reEscapeChar$1, "$1") : we || me);
  }), ie;
}), _stringToPath = stringToPath$2, Symbol$3 = _Symbol, arrayMap$2 = _arrayMap, isArray$6 = isArray_1, isSymbol$3 = isSymbol_1, symbolProto$3 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : void 0;
function baseToString$2(ce) {
  if (typeof ce == "string")
    return ce;
  if (isArray$6(ce))
    return arrayMap$2(ce, baseToString$2) + "";
  if (isSymbol$3(ce))
    return symbolToString$1 ? symbolToString$1.call(ce) : "";
  var ie = ce + "";
  return ie == "0" && 1 / ce == -1 / 0 ? "-0" : ie;
}
var _baseToString = baseToString$2, baseToString$1 = _baseToString;
function toString$2(ce) {
  return ce == null ? "" : baseToString$1(ce);
}
var toString_1 = toString$2, isArray$5 = isArray_1, isKey$3 = _isKey, stringToPath$1 = _stringToPath, toString$1 = toString_1;
function castPath$3(ce, ie) {
  return isArray$5(ce) ? ce : isKey$3(ce, ie) ? [ce] : stringToPath$1(toString$1(ce));
}
var _castPath = castPath$3, isSymbol$2 = isSymbol_1;
function toKey$5(ce) {
  if (typeof ce == "string" || isSymbol$2(ce))
    return ce;
  var ie = ce + "";
  return ie == "0" && 1 / ce == -1 / 0 ? "-0" : ie;
}
var _toKey = toKey$5, castPath$2 = _castPath, toKey$4 = _toKey;
function baseGet$3(ce, ie) {
  ie = castPath$2(ie, ce);
  for (var me = 0, we = ie.length; ce != null && me < we; )
    ce = ce[toKey$4(ie[me++])];
  return me && me == we ? ce : void 0;
}
var _baseGet = baseGet$3, baseGet$2 = _baseGet;
function get$4(ce, ie, me) {
  var we = ce == null ? void 0 : baseGet$2(ce, ie);
  return we === void 0 ? me : we;
}
var get_1 = get$4;
function baseHasIn$2(ce, ie) {
  return ce != null && ie in Object(ce);
}
var _baseHasIn = baseHasIn$2, castPath$1 = _castPath, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isIndex$1 = _isIndex, isLength$1 = isLength_1, toKey$3 = _toKey;
function hasPath$2(ce, ie, me) {
  ie = castPath$1(ie, ce);
  for (var we = -1, Re = ie.length, je = !1; ++we < Re; ) {
    var Ue = toKey$3(ie[we]);
    if (!(je = ce != null && me(ce, Ue)))
      break;
    ce = ce[Ue];
  }
  return je || ++we != Re ? je : (Re = ce == null ? 0 : ce.length, !!Re && isLength$1(Re) && isIndex$1(Ue, Re) && (isArray$4(ce) || isArguments$1(ce)));
}
var _hasPath = hasPath$2, baseHasIn$1 = _baseHasIn, hasPath$1 = _hasPath;
function hasIn$2(ce, ie) {
  return ce != null && hasPath$1(ce, ie, baseHasIn$1);
}
var hasIn_1 = hasIn$2, baseIsEqual$1 = _baseIsEqual, get$3 = get_1, hasIn$1 = hasIn_1, isKey$2 = _isKey, isStrictComparable$1 = _isStrictComparable, matchesStrictComparable$1 = _matchesStrictComparable, toKey$2 = _toKey, COMPARE_PARTIAL_FLAG$6 = 1, COMPARE_UNORDERED_FLAG$4 = 2;
function baseMatchesProperty$2(ce, ie) {
  return isKey$2(ce) && isStrictComparable$1(ie) ? matchesStrictComparable$1(toKey$2(ce), ie) : function(me) {
    var we = get$3(me, ce);
    return we === void 0 && we === ie ? hasIn$1(me, ce) : baseIsEqual$1(ie, we, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}
var _baseMatchesProperty = baseMatchesProperty$2;
function baseProperty$2(ce) {
  return function(ie) {
    return ie == null ? void 0 : ie[ce];
  };
}
var _baseProperty = baseProperty$2, baseGet$1 = _baseGet;
function basePropertyDeep$2(ce) {
  return function(ie) {
    return baseGet$1(ie, ce);
  };
}
var _basePropertyDeep = basePropertyDeep$2, baseProperty$1 = _baseProperty, basePropertyDeep$1 = _basePropertyDeep, isKey$1 = _isKey, toKey$1 = _toKey;
function property$2(ce) {
  return isKey$1(ce) ? baseProperty$1(toKey$1(ce)) : basePropertyDeep$1(ce);
}
var property_1 = property$2, baseMatches$1 = _baseMatches, baseMatchesProperty$1 = _baseMatchesProperty, identity$1 = identity_1, isArray$3 = isArray_1, property$1 = property_1;
function baseIteratee$2(ce) {
  return typeof ce == "function" ? ce : ce == null ? identity$1 : typeof ce == "object" ? isArray$3(ce) ? baseMatchesProperty$1(ce[0], ce[1]) : baseMatches$1(ce) : property$1(ce);
}
var _baseIteratee = baseIteratee$2, isArrayLike$3 = isArrayLike_1;
function createBaseEach$2(ce, ie) {
  return function(me, we) {
    if (me == null)
      return me;
    if (!isArrayLike$3(me))
      return ce(me, we);
    for (var Re = me.length, je = ie ? Re : -1, Ue = Object(me); (ie ? je-- : ++je < Re) && we(Ue[je], je, Ue) !== !1; )
      ;
    return me;
  };
}
var _createBaseEach = createBaseEach$2, baseForOwn$1 = _baseForOwn, createBaseEach$1 = _createBaseEach, baseEach$2 = createBaseEach$1(baseForOwn$1), _baseEach = baseEach$2, baseEach$1 = _baseEach, isArrayLike$2 = isArrayLike_1;
function baseMap$2(ce, ie) {
  var me = -1, we = isArrayLike$2(ce) ? Array(ce.length) : [];
  return baseEach$1(ce, function(Re, je, Ue) {
    we[++me] = ie(Re, je, Ue);
  }), we;
}
var _baseMap = baseMap$2, arrayMap$1 = _arrayMap, baseIteratee$1 = _baseIteratee, baseMap$1 = _baseMap, isArray$2 = isArray_1;
function map$1(ce, ie) {
  var me = isArray$2(ce) ? arrayMap$1 : baseMap$1;
  return me(ce, baseIteratee$1(ie));
}
var map_1 = map$1;
Object.defineProperty(flattenNames$1, "__esModule", {
  value: !0
});
flattenNames$1.flattenNames = void 0;
var _isString2 = isString_1, _isString3 = _interopRequireDefault$f(_isString2), _forOwn2$2 = forOwn_1, _forOwn3$2 = _interopRequireDefault$f(_forOwn2$2), _isPlainObject2 = isPlainObject_1, _isPlainObject3 = _interopRequireDefault$f(_isPlainObject2), _map2 = map_1, _map3 = _interopRequireDefault$f(_map2);
function _interopRequireDefault$f(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
var flattenNames = flattenNames$1.flattenNames = function ce() {
  var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], me = [];
  return (0, _map3.default)(ie, function(we) {
    Array.isArray(we) ? ce(we).map(function(Re) {
      return me.push(Re);
    }) : (0, _isPlainObject3.default)(we) ? (0, _forOwn3$2.default)(we, function(Re, je) {
      Re === !0 && me.push(je), me.push(je + "-" + Re);
    }) : (0, _isString3.default)(we) && me.push(we);
  }), me;
};
flattenNames$1.default = flattenNames;
var mergeClasses$1 = {};
function arrayEach$2(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length; ++me < we && ie(ce[me], me, ce) !== !1; )
    ;
  return ce;
}
var _arrayEach = arrayEach$2, getNative$1 = _getNative, defineProperty$2 = function() {
  try {
    var ce = getNative$1(Object, "defineProperty");
    return ce({}, "", {}), ce;
  } catch {
  }
}(), _defineProperty$r = defineProperty$2, defineProperty$1 = _defineProperty$r;
function baseAssignValue$3(ce, ie, me) {
  ie == "__proto__" && defineProperty$1 ? defineProperty$1(ce, ie, {
    configurable: !0,
    enumerable: !0,
    value: me,
    writable: !0
  }) : ce[ie] = me;
}
var _baseAssignValue = baseAssignValue$3, baseAssignValue$2 = _baseAssignValue, eq$1 = eq_1, objectProto$i = Object.prototype, hasOwnProperty$e = objectProto$i.hasOwnProperty;
function assignValue$3(ce, ie, me) {
  var we = ce[ie];
  (!(hasOwnProperty$e.call(ce, ie) && eq$1(we, me)) || me === void 0 && !(ie in ce)) && baseAssignValue$2(ce, ie, me);
}
var _assignValue = assignValue$3, assignValue$2 = _assignValue, baseAssignValue$1 = _baseAssignValue;
function copyObject$5(ce, ie, me, we) {
  var Re = !me;
  me || (me = {});
  for (var je = -1, Ue = ie.length; ++je < Ue; ) {
    var qe = ie[je], Ge = we ? we(me[qe], ce[qe], qe, me, ce) : void 0;
    Ge === void 0 && (Ge = ce[qe]), Re ? baseAssignValue$1(me, qe, Ge) : assignValue$2(me, qe, Ge);
  }
  return me;
}
var _copyObject = copyObject$5, copyObject$4 = _copyObject, keys$2 = keys_1;
function baseAssign$1(ce, ie) {
  return ce && copyObject$4(ie, keys$2(ie), ce);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$2(ce) {
  var ie = [];
  if (ce != null)
    for (var me in Object(ce))
      ie.push(me);
  return ie;
}
var _nativeKeysIn = nativeKeysIn$2, isObject$5 = isObject_1, isPrototype$2 = _isPrototype, nativeKeysIn$1 = _nativeKeysIn, objectProto$h = Object.prototype, hasOwnProperty$d = objectProto$h.hasOwnProperty;
function baseKeysIn$2(ce) {
  if (!isObject$5(ce))
    return nativeKeysIn$1(ce);
  var ie = isPrototype$2(ce), me = [];
  for (var we in ce)
    we == "constructor" && (ie || !hasOwnProperty$d.call(ce, we)) || me.push(we);
  return me;
}
var _baseKeysIn = baseKeysIn$2, arrayLikeKeys$1 = _arrayLikeKeys, baseKeysIn$1 = _baseKeysIn, isArrayLike$1 = isArrayLike_1;
function keysIn$4(ce) {
  return isArrayLike$1(ce) ? arrayLikeKeys$1(ce, !0) : baseKeysIn$1(ce);
}
var keysIn_1 = keysIn$4, copyObject$3 = _copyObject, keysIn$3 = keysIn_1;
function baseAssignIn$1(ce, ie) {
  return ce && copyObject$3(ie, keysIn$3(ie), ce);
}
var _baseAssignIn = baseAssignIn$1, _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
(function(ce, ie) {
  var me = _root, we = ie && !ie.nodeType && ie, Re = we && !0 && ce && !ce.nodeType && ce, je = Re && Re.exports === we, Ue = je ? me.Buffer : void 0, qe = Ue ? Ue.allocUnsafe : void 0;
  function Ge(Xe, ot) {
    if (ot)
      return Xe.slice();
    var vt = Xe.length, bt = qe ? qe(vt) : new Xe.constructor(vt);
    return Xe.copy(bt), bt;
  }
  ce.exports = Ge;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;
function copyArray$2(ce, ie) {
  var me = -1, we = ce.length;
  for (ie || (ie = Array(we)); ++me < we; )
    ie[me] = ce[me];
  return ie;
}
var _copyArray = copyArray$2, copyObject$2 = _copyObject, getSymbols$2 = _getSymbols;
function copySymbols$1(ce, ie) {
  return copyObject$2(ce, getSymbols$2(ce), ie);
}
var _copySymbols = copySymbols$1, arrayPush$1 = _arrayPush, getPrototype$2 = _getPrototype, getSymbols$1 = _getSymbols, stubArray$1 = stubArray_1, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbolsIn$2 = nativeGetSymbols$1 ? function(ce) {
  for (var ie = []; ce; )
    arrayPush$1(ie, getSymbols$1(ce)), ce = getPrototype$2(ce);
  return ie;
} : stubArray$1, _getSymbolsIn = getSymbolsIn$2, copyObject$1 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(ce, ie) {
  return copyObject$1(ce, getSymbolsIn$1(ce), ie);
}
var _copySymbolsIn = copySymbolsIn$1, baseGetAllKeys$1 = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$2 = keysIn_1;
function getAllKeysIn$1(ce) {
  return baseGetAllKeys$1(ce, keysIn$2, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1, objectProto$g = Object.prototype, hasOwnProperty$c = objectProto$g.hasOwnProperty;
function initCloneArray$1(ce) {
  var ie = ce.length, me = new ce.constructor(ie);
  return ie && typeof ce[0] == "string" && hasOwnProperty$c.call(ce, "index") && (me.index = ce.index, me.input = ce.input), me;
}
var _initCloneArray = initCloneArray$1, Uint8Array$2 = _Uint8Array;
function cloneArrayBuffer$4(ce) {
  var ie = new ce.constructor(ce.byteLength);
  return new Uint8Array$2(ie).set(new Uint8Array$2(ce)), ie;
}
var _cloneArrayBuffer = cloneArrayBuffer$4, cloneArrayBuffer$3 = _cloneArrayBuffer;
function cloneDataView$1(ce, ie) {
  var me = ie ? cloneArrayBuffer$3(ce.buffer) : ce.buffer;
  return new ce.constructor(me, ce.byteOffset, ce.byteLength);
}
var _cloneDataView = cloneDataView$1, reFlags = /\w*$/;
function cloneRegExp$1(ce) {
  var ie = new ce.constructor(ce.source, reFlags.exec(ce));
  return ie.lastIndex = ce.lastIndex, ie;
}
var _cloneRegExp = cloneRegExp$1, Symbol$2 = _Symbol, symbolProto$2 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function cloneSymbol$1(ce) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(ce)) : {};
}
var _cloneSymbol = cloneSymbol$1, cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneTypedArray$2(ce, ie) {
  var me = ie ? cloneArrayBuffer$2(ce.buffer) : ce.buffer;
  return new ce.constructor(me, ce.byteOffset, ce.length);
}
var _cloneTypedArray = cloneTypedArray$2, cloneArrayBuffer$1 = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray$1 = _cloneTypedArray, boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$4 = "[object Symbol]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
function initCloneByTag$1(ce, ie, me) {
  var we = ce.constructor;
  switch (ie) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(ce);
    case boolTag$3:
    case dateTag$3:
      return new we(+ce);
    case dataViewTag$4:
      return cloneDataView(ce, me);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray$1(ce, me);
    case mapTag$5:
      return new we();
    case numberTag$3:
    case stringTag$3:
      return new we(ce);
    case regexpTag$3:
      return cloneRegExp(ce);
    case setTag$5:
      return new we();
    case symbolTag$4:
      return cloneSymbol(ce);
  }
}
var _initCloneByTag = initCloneByTag$1, isObject$4 = isObject_1, objectCreate$1 = Object.create, baseCreate$2 = /* @__PURE__ */ function() {
  function ce() {
  }
  return function(ie) {
    if (!isObject$4(ie))
      return {};
    if (objectCreate$1)
      return objectCreate$1(ie);
    ce.prototype = ie;
    var me = new ce();
    return ce.prototype = void 0, me;
  };
}(), _baseCreate = baseCreate$2, baseCreate$1 = _baseCreate, getPrototype$1 = _getPrototype, isPrototype$1 = _isPrototype;
function initCloneObject$2(ce) {
  return typeof ce.constructor == "function" && !isPrototype$1(ce) ? baseCreate$1(getPrototype$1(ce)) : {};
}
var _initCloneObject = initCloneObject$2, getTag$3 = _getTag, isObjectLike$3 = isObjectLike_1, mapTag$4 = "[object Map]";
function baseIsMap$1(ce) {
  return isObjectLike$3(ce) && getTag$3(ce) == mapTag$4;
}
var _baseIsMap = baseIsMap$1, baseIsMap = _baseIsMap, baseUnary$2 = _baseUnary, nodeUtil$2 = _nodeUtilExports, nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap, isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap, isMap_1 = isMap$1, getTag$2 = _getTag, isObjectLike$2 = isObjectLike_1, setTag$4 = "[object Set]";
function baseIsSet$1(ce) {
  return isObjectLike$2(ce) && getTag$2(ce) == setTag$4;
}
var _baseIsSet = baseIsSet$1, baseIsSet = _baseIsSet, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports, nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet, isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet, isSet_1 = isSet$1, Stack$1 = _Stack, arrayEach$1 = _arrayEach, assignValue$1 = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer$1 = _cloneBufferExports, copyArray$1 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys$1 = _getAllKeys, getAllKeysIn = _getAllKeysIn, getTag$1 = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject$1 = _initCloneObject, isArray$1 = isArray_1, isBuffer$1 = isBufferExports, isMap = isMap_1, isObject$3 = isObject_1, isSet = isSet_1, keys$1 = keys_1, keysIn$1 = keysIn_1, CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4, argsTag$3 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$2 = "[object Error]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$4] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = !0;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = !1;
function baseClone$1(ce, ie, me, we, Re, je) {
  var Ue, qe = ie & CLONE_DEEP_FLAG$1, Ge = ie & CLONE_FLAT_FLAG, Xe = ie & CLONE_SYMBOLS_FLAG$1;
  if (me && (Ue = Re ? me(ce, we, Re, je) : me(ce)), Ue !== void 0)
    return Ue;
  if (!isObject$3(ce))
    return ce;
  var ot = isArray$1(ce);
  if (ot) {
    if (Ue = initCloneArray(ce), !qe)
      return copyArray$1(ce, Ue);
  } else {
    var vt = getTag$1(ce), bt = vt == funcTag$2 || vt == genTag$1;
    if (isBuffer$1(ce))
      return cloneBuffer$1(ce, qe);
    if (vt == objectTag$4 || vt == argsTag$3 || bt && !Re) {
      if (Ue = Ge || bt ? {} : initCloneObject$1(ce), !qe)
        return Ge ? copySymbolsIn(ce, baseAssignIn(Ue, ce)) : copySymbols(ce, baseAssign(Ue, ce));
    } else {
      if (!cloneableTags[vt])
        return Re ? ce : {};
      Ue = initCloneByTag(ce, vt, qe);
    }
  }
  je || (je = new Stack$1());
  var Tt = je.get(ce);
  if (Tt)
    return Tt;
  je.set(ce, Ue), isSet(ce) ? ce.forEach(function(It) {
    Ue.add(baseClone$1(It, ie, me, It, ce, je));
  }) : isMap(ce) && ce.forEach(function(It, Pt) {
    Ue.set(Pt, baseClone$1(It, ie, me, Pt, ce, je));
  });
  var wt = Xe ? Ge ? getAllKeysIn : getAllKeys$1 : Ge ? keysIn$1 : keys$1, St = ot ? void 0 : wt(ce);
  return arrayEach$1(St || ce, function(It, Pt) {
    St && (Pt = It, It = ce[Pt]), assignValue$1(Ue, Pt, baseClone$1(It, ie, me, Pt, ce, je));
  }), Ue;
}
var _baseClone = baseClone$1, baseClone = _baseClone, CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(ce) {
  return baseClone(ce, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep;
Object.defineProperty(mergeClasses$1, "__esModule", {
  value: !0
});
mergeClasses$1.mergeClasses = void 0;
var _forOwn2$1 = forOwn_1, _forOwn3$1 = _interopRequireDefault$e(_forOwn2$1), _cloneDeep2 = cloneDeep_1, _cloneDeep3 = _interopRequireDefault$e(_cloneDeep2), _extends$i = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
};
function _interopRequireDefault$e(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
var mergeClasses = mergeClasses$1.mergeClasses = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], we = ie.default && (0, _cloneDeep3.default)(ie.default) || {};
  return me.map(function(Re) {
    var je = ie[Re];
    return je && (0, _forOwn3$1.default)(je, function(Ue, qe) {
      we[qe] || (we[qe] = {}), we[qe] = _extends$i({}, we[qe], je[qe]);
    }), Re;
  }), we;
};
mergeClasses$1.default = mergeClasses;
var autoprefix$1 = {};
Object.defineProperty(autoprefix$1, "__esModule", {
  value: !0
});
autoprefix$1.autoprefix = void 0;
var _forOwn2 = forOwn_1, _forOwn3 = _interopRequireDefault$d(_forOwn2), _extends$h = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
};
function _interopRequireDefault$d(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
var transforms = {
  borderRadius: function(ie) {
    return {
      msBorderRadius: ie,
      MozBorderRadius: ie,
      OBorderRadius: ie,
      WebkitBorderRadius: ie,
      borderRadius: ie
    };
  },
  boxShadow: function(ie) {
    return {
      msBoxShadow: ie,
      MozBoxShadow: ie,
      OBoxShadow: ie,
      WebkitBoxShadow: ie,
      boxShadow: ie
    };
  },
  userSelect: function(ie) {
    return {
      WebkitTouchCallout: ie,
      KhtmlUserSelect: ie,
      MozUserSelect: ie,
      msUserSelect: ie,
      WebkitUserSelect: ie,
      userSelect: ie
    };
  },
  flex: function(ie) {
    return {
      WebkitBoxFlex: ie,
      MozBoxFlex: ie,
      WebkitFlex: ie,
      msFlex: ie,
      flex: ie
    };
  },
  flexBasis: function(ie) {
    return {
      WebkitFlexBasis: ie,
      flexBasis: ie
    };
  },
  justifyContent: function(ie) {
    return {
      WebkitJustifyContent: ie,
      justifyContent: ie
    };
  },
  transition: function(ie) {
    return {
      msTransition: ie,
      MozTransition: ie,
      OTransition: ie,
      WebkitTransition: ie,
      transition: ie
    };
  },
  transform: function(ie) {
    return {
      msTransform: ie,
      MozTransform: ie,
      OTransform: ie,
      WebkitTransform: ie,
      transform: ie
    };
  },
  absolute: function(ie) {
    var me = ie && ie.split(" ");
    return {
      position: "absolute",
      top: me && me[0],
      right: me && me[1],
      bottom: me && me[2],
      left: me && me[3]
    };
  },
  extend: function(ie, me) {
    var we = me[ie];
    return we || {
      extend: ie
    };
  }
}, autoprefix = autoprefix$1.autoprefix = function(ie) {
  var me = {};
  return (0, _forOwn3.default)(ie, function(we, Re) {
    var je = {};
    (0, _forOwn3.default)(we, function(Ue, qe) {
      var Ge = transforms[qe];
      Ge ? je = _extends$h({}, je, Ge(Ue)) : je[qe] = Ue;
    }), me[Re] = je;
  }), me;
};
autoprefix$1.default = autoprefix;
var hover$1 = {};
Object.defineProperty(hover$1, "__esModule", {
  value: !0
});
hover$1.hover = void 0;
var _extends$g = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _react$b = React__default, _react2$6 = _interopRequireDefault$c(_react$b);
function _interopRequireDefault$c(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _classCallCheck$s(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$e(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$e(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var hover = hover$1.hover = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(we) {
    _inherits$e(Re, we);
    function Re() {
      var je, Ue, qe, Ge;
      _classCallCheck$s(this, Re);
      for (var Xe = arguments.length, ot = Array(Xe), vt = 0; vt < Xe; vt++)
        ot[vt] = arguments[vt];
      return Ge = (Ue = (qe = _possibleConstructorReturn$e(this, (je = Re.__proto__ || Object.getPrototypeOf(Re)).call.apply(je, [this].concat(ot))), qe), qe.state = { hover: !1 }, qe.handleMouseOver = function() {
        return qe.setState({ hover: !0 });
      }, qe.handleMouseOut = function() {
        return qe.setState({ hover: !1 });
      }, qe.render = function() {
        return _react2$6.default.createElement(
          me,
          { onMouseOver: qe.handleMouseOver, onMouseOut: qe.handleMouseOut },
          _react2$6.default.createElement(ie, _extends$g({}, qe.props, qe.state))
        );
      }, Ue), _possibleConstructorReturn$e(qe, Ge);
    }
    return Re;
  }(_react2$6.default.Component);
};
hover$1.default = hover;
var active$1 = {};
Object.defineProperty(active$1, "__esModule", {
  value: !0
});
active$1.active = void 0;
var _extends$f = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _react$a = React__default, _react2$5 = _interopRequireDefault$b(_react$a);
function _interopRequireDefault$b(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _classCallCheck$r(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$d(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$d(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var active = active$1.active = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(we) {
    _inherits$d(Re, we);
    function Re() {
      var je, Ue, qe, Ge;
      _classCallCheck$r(this, Re);
      for (var Xe = arguments.length, ot = Array(Xe), vt = 0; vt < Xe; vt++)
        ot[vt] = arguments[vt];
      return Ge = (Ue = (qe = _possibleConstructorReturn$d(this, (je = Re.__proto__ || Object.getPrototypeOf(Re)).call.apply(je, [this].concat(ot))), qe), qe.state = { active: !1 }, qe.handleMouseDown = function() {
        return qe.setState({ active: !0 });
      }, qe.handleMouseUp = function() {
        return qe.setState({ active: !1 });
      }, qe.render = function() {
        return _react2$5.default.createElement(
          me,
          { onMouseDown: qe.handleMouseDown, onMouseUp: qe.handleMouseUp },
          _react2$5.default.createElement(ie, _extends$f({}, qe.props, qe.state))
        );
      }, Ue), _possibleConstructorReturn$d(qe, Ge);
    }
    return Re;
  }(_react2$5.default.Component);
};
active$1.default = active;
var loop = {};
Object.defineProperty(loop, "__esModule", {
  value: !0
});
var loopable = function(ie, me) {
  var we = {}, Re = function(Ue) {
    var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    we[Ue] = qe;
  };
  return ie === 0 && Re("first-child"), ie === me - 1 && Re("last-child"), (ie === 0 || ie % 2 === 0) && Re("even"), Math.abs(ie % 2) === 1 && Re("odd"), Re("nth-child", ie), we;
};
loop.default = loopable;
Object.defineProperty(lib$1, "__esModule", {
  value: !0
});
lib$1.ReactCSS = lib$1.loop = lib$1.handleActive = handleHover = lib$1.handleHover = lib$1.hover = void 0;
var _flattenNames = flattenNames$1, _flattenNames2 = _interopRequireDefault$a(_flattenNames), _mergeClasses = mergeClasses$1, _mergeClasses2 = _interopRequireDefault$a(_mergeClasses), _autoprefix = autoprefix$1, _autoprefix2 = _interopRequireDefault$a(_autoprefix), _hover2 = hover$1, _hover3 = _interopRequireDefault$a(_hover2), _active = active$1, _active2 = _interopRequireDefault$a(_active), _loop2 = loop, _loop3 = _interopRequireDefault$a(_loop2);
function _interopRequireDefault$a(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
lib$1.hover = _hover3.default;
var handleHover = lib$1.handleHover = _hover3.default;
lib$1.handleActive = _active2.default;
lib$1.loop = _loop3.default;
var ReactCSS = lib$1.ReactCSS = function(ie) {
  for (var me = arguments.length, we = Array(me > 1 ? me - 1 : 0), Re = 1; Re < me; Re++)
    we[Re - 1] = arguments[Re];
  var je = (0, _flattenNames2.default)(we), Ue = (0, _mergeClasses2.default)(ie, je);
  return (0, _autoprefix2.default)(Ue);
}, _default$3 = lib$1.default = ReactCSS, calculateChange$2 = function(ie, me, we, Re, je) {
  var Ue = je.clientWidth, qe = je.clientHeight, Ge = typeof ie.pageX == "number" ? ie.pageX : ie.touches[0].pageX, Xe = typeof ie.pageY == "number" ? ie.pageY : ie.touches[0].pageY, ot = Ge - (je.getBoundingClientRect().left + window.pageXOffset), vt = Xe - (je.getBoundingClientRect().top + window.pageYOffset);
  if (we === "vertical") {
    var bt = void 0;
    if (vt < 0 ? bt = 0 : vt > qe ? bt = 1 : bt = Math.round(vt * 100 / qe) / 100, me.a !== bt)
      return {
        h: me.h,
        s: me.s,
        l: me.l,
        a: bt,
        source: "rgb"
      };
  } else {
    var Tt = void 0;
    if (ot < 0 ? Tt = 0 : ot > Ue ? Tt = 1 : Tt = Math.round(ot * 100 / Ue) / 100, Re !== Tt)
      return {
        h: me.h,
        s: me.s,
        l: me.l,
        a: Tt,
        source: "rgb"
      };
  }
  return null;
}, checkboardCache = {}, render = function(ie, me, we, Re) {
  if (typeof document > "u" && !Re)
    return null;
  var je = Re ? new Re() : document.createElement("canvas");
  je.width = we * 2, je.height = we * 2;
  var Ue = je.getContext("2d");
  return Ue ? (Ue.fillStyle = ie, Ue.fillRect(0, 0, je.width, je.height), Ue.fillStyle = me, Ue.fillRect(0, 0, we, we), Ue.translate(we, we), Ue.fillRect(0, 0, we, we), je.toDataURL()) : null;
}, get$2 = function(ie, me, we, Re) {
  var je = ie + "-" + me + "-" + we + (Re ? "-server" : "");
  if (checkboardCache[je])
    return checkboardCache[je];
  var Ue = render(ie, me, we, Re);
  return checkboardCache[je] = Ue, Ue;
}, _extends$e = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, Checkboard = function(ie) {
  var me = ie.white, we = ie.grey, Re = ie.size, je = ie.renderers, Ue = ie.borderRadius, qe = ie.boxShadow, Ge = ie.children, Xe = _default$3({
    default: {
      grid: {
        borderRadius: Ue,
        boxShadow: qe,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get$2(me, we, Re, je.canvas) + ") center left"
      }
    }
  });
  return isValidElement(Ge) ? React__default.cloneElement(Ge, _extends$e({}, Ge.props, { style: _extends$e({}, Ge.props.style, Xe.grid) })) : React__default.createElement("div", { style: Xe.grid });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$d = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _createClass$q = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$q(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$c(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$c(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var Alpha = function(ce) {
  _inherits$c(ie, ce);
  function ie() {
    var me, we, Re, je;
    _classCallCheck$q(this, ie);
    for (var Ue = arguments.length, qe = Array(Ue), Ge = 0; Ge < Ue; Ge++)
      qe[Ge] = arguments[Ge];
    return je = (we = (Re = _possibleConstructorReturn$c(this, (me = ie.__proto__ || Object.getPrototypeOf(ie)).call.apply(me, [this].concat(qe))), Re), Re.handleChange = function(Xe) {
      var ot = calculateChange$2(Xe, Re.props.hsl, Re.props.direction, Re.props.a, Re.container);
      ot && typeof Re.props.onChange == "function" && Re.props.onChange(ot, Xe);
    }, Re.handleMouseDown = function(Xe) {
      Re.handleChange(Xe), window.addEventListener("mousemove", Re.handleChange), window.addEventListener("mouseup", Re.handleMouseUp);
    }, Re.handleMouseUp = function() {
      Re.unbindEventListeners();
    }, Re.unbindEventListeners = function() {
      window.removeEventListener("mousemove", Re.handleChange), window.removeEventListener("mouseup", Re.handleMouseUp);
    }, we), _possibleConstructorReturn$c(Re, je);
  }
  return _createClass$q(ie, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var we = this, Re = this.props.rgb, je = _default$3({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + Re.r + "," + Re.g + "," + Re.b + `, 0) 0%,
           rgba(` + Re.r + "," + Re.g + "," + Re.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: Re.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + Re.r + "," + Re.g + "," + Re.b + `, 0) 0%,
           rgba(` + Re.r + "," + Re.g + "," + Re.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: Re.a * 100 + "%"
          }
        },
        overwrite: _extends$d({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return React__default.createElement(
        "div",
        { style: je.alpha },
        React__default.createElement(
          "div",
          { style: je.checkboard },
          React__default.createElement(Checkboard, { renderers: this.props.renderers })
        ),
        React__default.createElement("div", { style: je.gradient }),
        React__default.createElement(
          "div",
          {
            style: je.container,
            ref: function(qe) {
              return we.container = qe;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "div",
            { style: je.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: je.slider })
          )
        )
      );
    }
  }]), ie;
}(PureComponent || Component), _createClass$p = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _defineProperty$q(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _classCallCheck$p(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$b(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$b(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var DEFAULT_ARROW_OFFSET = 1, UP_KEY_CODE = 38, DOWN_KEY_CODE = 40, VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE], isValidKeyCode = function(ie) {
  return VALID_KEY_CODES.indexOf(ie) > -1;
}, getNumberValue = function(ie) {
  return Number(String(ie).replace(/%/g, ""));
}, idCounter = 1, EditableInput = function(ce) {
  _inherits$b(ie, ce);
  function ie(me) {
    _classCallCheck$p(this, ie);
    var we = _possibleConstructorReturn$b(this, (ie.__proto__ || Object.getPrototypeOf(ie)).call(this));
    return we.handleBlur = function() {
      we.state.blurValue && we.setState({ value: we.state.blurValue, blurValue: null });
    }, we.handleChange = function(Re) {
      we.setUpdatedValue(Re.target.value, Re);
    }, we.handleKeyDown = function(Re) {
      var je = getNumberValue(Re.target.value);
      if (!isNaN(je) && isValidKeyCode(Re.keyCode)) {
        var Ue = we.getArrowOffset(), qe = Re.keyCode === UP_KEY_CODE ? je + Ue : je - Ue;
        we.setUpdatedValue(qe, Re);
      }
    }, we.handleDrag = function(Re) {
      if (we.props.dragLabel) {
        var je = Math.round(we.props.value + Re.movementX);
        je >= 0 && je <= we.props.dragMax && we.props.onChange && we.props.onChange(we.getValueObjectWithLabel(je), Re);
      }
    }, we.handleMouseDown = function(Re) {
      we.props.dragLabel && (Re.preventDefault(), we.handleDrag(Re), window.addEventListener("mousemove", we.handleDrag), window.addEventListener("mouseup", we.handleMouseUp));
    }, we.handleMouseUp = function() {
      we.unbindEventListeners();
    }, we.unbindEventListeners = function() {
      window.removeEventListener("mousemove", we.handleDrag), window.removeEventListener("mouseup", we.handleMouseUp);
    }, we.state = {
      value: String(me.value).toUpperCase(),
      blurValue: String(me.value).toUpperCase()
    }, we.inputId = "rc-editable-input-" + idCounter++, we;
  }
  return _createClass$p(ie, [{
    key: "componentDidUpdate",
    value: function(we, Re) {
      this.props.value !== this.state.value && (we.value !== this.props.value || Re.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(we) {
      return _defineProperty$q({}, this.props.label, we);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function(we, Re) {
      var je = this.props.label ? this.getValueObjectWithLabel(we) : we;
      this.props.onChange && this.props.onChange(je, Re), this.setState({ value: we });
    }
  }, {
    key: "render",
    value: function() {
      var we = this, Re = _default$3({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return React__default.createElement(
        "div",
        { style: Re.wrap },
        React__default.createElement("input", {
          id: this.inputId,
          style: Re.input,
          ref: function(Ue) {
            return we.input = Ue;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? React__default.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: Re.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), ie;
}(PureComponent || Component), calculateChange$1 = function(ie, me, we, Re) {
  var je = Re.clientWidth, Ue = Re.clientHeight, qe = typeof ie.pageX == "number" ? ie.pageX : ie.touches[0].pageX, Ge = typeof ie.pageY == "number" ? ie.pageY : ie.touches[0].pageY, Xe = qe - (Re.getBoundingClientRect().left + window.pageXOffset), ot = Ge - (Re.getBoundingClientRect().top + window.pageYOffset);
  if (me === "vertical") {
    var vt = void 0;
    if (ot < 0)
      vt = 359;
    else if (ot > Ue)
      vt = 0;
    else {
      var bt = -(ot * 100 / Ue) + 100;
      vt = 360 * bt / 100;
    }
    if (we.h !== vt)
      return {
        h: vt,
        s: we.s,
        l: we.l,
        a: we.a,
        source: "hsl"
      };
  } else {
    var Tt = void 0;
    if (Xe < 0)
      Tt = 0;
    else if (Xe > je)
      Tt = 359;
    else {
      var wt = Xe * 100 / je;
      Tt = 360 * wt / 100;
    }
    if (we.h !== Tt)
      return {
        h: Tt,
        s: we.s,
        l: we.l,
        a: we.a,
        source: "hsl"
      };
  }
  return null;
}, _createClass$o = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$o(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$a(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$a(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var Hue = function(ce) {
  _inherits$a(ie, ce);
  function ie() {
    var me, we, Re, je;
    _classCallCheck$o(this, ie);
    for (var Ue = arguments.length, qe = Array(Ue), Ge = 0; Ge < Ue; Ge++)
      qe[Ge] = arguments[Ge];
    return je = (we = (Re = _possibleConstructorReturn$a(this, (me = ie.__proto__ || Object.getPrototypeOf(ie)).call.apply(me, [this].concat(qe))), Re), Re.handleChange = function(Xe) {
      var ot = calculateChange$1(Xe, Re.props.direction, Re.props.hsl, Re.container);
      ot && typeof Re.props.onChange == "function" && Re.props.onChange(ot, Xe);
    }, Re.handleMouseDown = function(Xe) {
      Re.handleChange(Xe), window.addEventListener("mousemove", Re.handleChange), window.addEventListener("mouseup", Re.handleMouseUp);
    }, Re.handleMouseUp = function() {
      Re.unbindEventListeners();
    }, we), _possibleConstructorReturn$a(Re, je);
  }
  return _createClass$o(ie, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var we = this, Re = this.props.direction, je = Re === void 0 ? "horizontal" : Re, Ue = _default$3({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: je === "vertical" });
      return React__default.createElement(
        "div",
        { style: Ue.hue },
        React__default.createElement(
          "div",
          {
            className: "hue-" + je,
            style: Ue.container,
            ref: function(Ge) {
              return we.container = Ge;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          React__default.createElement(
            "div",
            { style: Ue.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: Ue.slider })
          )
        )
      );
    }
  }]), ie;
}(PureComponent || Component);
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function eq(ce, ie) {
  return ce === ie || ce !== ce && ie !== ie;
}
function assocIndexOf(ce, ie) {
  for (var me = ce.length; me--; )
    if (eq(ce[me][0], ie))
      return me;
  return -1;
}
var arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(ce) {
  var ie = this.__data__, me = assocIndexOf(ie, ce);
  if (me < 0)
    return !1;
  var we = ie.length - 1;
  return me == we ? ie.pop() : splice.call(ie, me, 1), --this.size, !0;
}
function listCacheGet(ce) {
  var ie = this.__data__, me = assocIndexOf(ie, ce);
  return me < 0 ? void 0 : ie[me][1];
}
function listCacheHas(ce) {
  return assocIndexOf(this.__data__, ce) > -1;
}
function listCacheSet(ce, ie) {
  var me = this.__data__, we = assocIndexOf(me, ce);
  return we < 0 ? (++this.size, me.push([ce, ie])) : me[we][1] = ie, this;
}
function ListCache(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(ce) {
  var ie = this.__data__, me = ie.delete(ce);
  return this.size = ie.size, me;
}
function stackGet(ce) {
  return this.__data__.get(ce);
}
function stackHas(ce) {
  return this.__data__.has(ce);
}
var freeGlobal$1 = typeof global == "object" && global && global.Object === Object && global, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")(), Symbol$1 = root$1.Symbol, objectProto$f = Object.prototype, hasOwnProperty$b = objectProto$f.hasOwnProperty, nativeObjectToString$1 = objectProto$f.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(ce) {
  var ie = hasOwnProperty$b.call(ce, symToStringTag$1), me = ce[symToStringTag$1];
  try {
    ce[symToStringTag$1] = void 0;
    var we = !0;
  } catch {
  }
  var Re = nativeObjectToString$1.call(ce);
  return we && (ie ? ce[symToStringTag$1] = me : delete ce[symToStringTag$1]), Re;
}
var objectProto$e = Object.prototype, nativeObjectToString = objectProto$e.toString;
function objectToString$1(ce) {
  return nativeObjectToString.call(ce);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(ce) {
  return ce == null ? ce === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(ce) ? getRawTag(ce) : objectToString$1(ce);
}
function isObject$2(ce) {
  var ie = typeof ce;
  return ce != null && (ie == "object" || ie == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(ce) {
  if (!isObject$2(ce))
    return !1;
  var ie = baseGetTag(ce);
  return ie == funcTag$1 || ie == genTag || ie == asyncTag || ie == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"], maskSrcKey = function() {
  var ce = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return ce ? "Symbol(src)_1." + ce : "";
}();
function isMasked(ce) {
  return !!maskSrcKey && maskSrcKey in ce;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(ce) {
  if (ce != null) {
    try {
      return funcToString$2.call(ce);
    } catch {
    }
    try {
      return ce + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$d = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$a = objectProto$d.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(ce) {
  if (!isObject$2(ce) || isMasked(ce))
    return !1;
  var ie = isFunction(ce) ? reIsNative : reIsHostCtor;
  return ie.test(toSource(ce));
}
function getValue(ce, ie) {
  return ce == null ? void 0 : ce[ie];
}
function getNative(ce, ie) {
  var me = getValue(ce, ie);
  return baseIsNative(me) ? me : void 0;
}
var Map$1 = getNative(root$1, "Map"), nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(ce) {
  var ie = this.has(ce) && delete this.__data__[ce];
  return this.size -= ie ? 1 : 0, ie;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$c = Object.prototype, hasOwnProperty$9 = objectProto$c.hasOwnProperty;
function hashGet(ce) {
  var ie = this.__data__;
  if (nativeCreate) {
    var me = ie[ce];
    return me === HASH_UNDEFINED$2 ? void 0 : me;
  }
  return hasOwnProperty$9.call(ie, ce) ? ie[ce] : void 0;
}
var objectProto$b = Object.prototype, hasOwnProperty$8 = objectProto$b.hasOwnProperty;
function hashHas(ce) {
  var ie = this.__data__;
  return nativeCreate ? ie[ce] !== void 0 : hasOwnProperty$8.call(ie, ce);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(ce, ie) {
  var me = this.__data__;
  return this.size += this.has(ce) ? 0 : 1, me[ce] = nativeCreate && ie === void 0 ? HASH_UNDEFINED$1 : ie, this;
}
function Hash(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$1 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(ce) {
  var ie = typeof ce;
  return ie == "string" || ie == "number" || ie == "symbol" || ie == "boolean" ? ce !== "__proto__" : ce === null;
}
function getMapData(ce, ie) {
  var me = ce.__data__;
  return isKeyable(ie) ? me[typeof ie == "string" ? "string" : "hash"] : me.map;
}
function mapCacheDelete(ce) {
  var ie = getMapData(this, ce).delete(ce);
  return this.size -= ie ? 1 : 0, ie;
}
function mapCacheGet(ce) {
  return getMapData(this, ce).get(ce);
}
function mapCacheHas(ce) {
  return getMapData(this, ce).has(ce);
}
function mapCacheSet(ce, ie) {
  var me = getMapData(this, ce), we = me.size;
  return me.set(ce, ie), this.size += me.size == we ? 0 : 1, this;
}
function MapCache(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.clear(); ++ie < me; ) {
    var we = ce[ie];
    this.set(we[0], we[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(ce, ie) {
  var me = this.__data__;
  if (me instanceof ListCache) {
    var we = me.__data__;
    if (!Map$1 || we.length < LARGE_ARRAY_SIZE - 1)
      return we.push([ce, ie]), this.size = ++me.size, this;
    me = this.__data__ = new MapCache(we);
  }
  return me.set(ce, ie), this.size = me.size, this;
}
function Stack(ce) {
  var ie = this.__data__ = new ListCache(ce);
  this.size = ie.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var defineProperty = function() {
  try {
    var ce = getNative(Object, "defineProperty");
    return ce({}, "", {}), ce;
  } catch {
  }
}();
function baseAssignValue(ce, ie, me) {
  ie == "__proto__" && defineProperty ? defineProperty(ce, ie, {
    configurable: !0,
    enumerable: !0,
    value: me,
    writable: !0
  }) : ce[ie] = me;
}
function assignMergeValue(ce, ie, me) {
  (me !== void 0 && !eq(ce[ie], me) || me === void 0 && !(ie in ce)) && baseAssignValue(ce, ie, me);
}
function createBaseFor(ce) {
  return function(ie, me, we) {
    for (var Re = -1, je = Object(ie), Ue = we(ie), qe = Ue.length; qe--; ) {
      var Ge = Ue[++Re];
      if (me(je[Ge], Ge, je) === !1)
        break;
    }
    return ie;
  };
}
var baseFor = createBaseFor(), freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$2 = moduleExports$2 ? root$1.Buffer : void 0;
Buffer$2 && Buffer$2.allocUnsafe;
function cloneBuffer(ce, ie) {
  return ce.slice();
}
var Uint8Array$1 = root$1.Uint8Array;
function cloneArrayBuffer(ce) {
  var ie = new ce.constructor(ce.byteLength);
  return new Uint8Array$1(ie).set(new Uint8Array$1(ce)), ie;
}
function cloneTypedArray(ce, ie) {
  var me = cloneArrayBuffer(ce.buffer);
  return new ce.constructor(me, ce.byteOffset, ce.length);
}
function copyArray(ce, ie) {
  var me = -1, we = ce.length;
  for (ie || (ie = Array(we)); ++me < we; )
    ie[me] = ce[me];
  return ie;
}
var objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function ce() {
  }
  return function(ie) {
    if (!isObject$2(ie))
      return {};
    if (objectCreate)
      return objectCreate(ie);
    ce.prototype = ie;
    var me = new ce();
    return ce.prototype = void 0, me;
  };
}();
function overArg(ce, ie) {
  return function(me) {
    return ce(ie(me));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectProto$a = Object.prototype;
function isPrototype(ce) {
  var ie = ce && ce.constructor, me = typeof ie == "function" && ie.prototype || objectProto$a;
  return ce === me;
}
function initCloneObject(ce) {
  return typeof ce.constructor == "function" && !isPrototype(ce) ? baseCreate(getPrototype(ce)) : {};
}
function isObjectLike$1(ce) {
  return ce != null && typeof ce == "object";
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(ce) {
  return isObjectLike$1(ce) && baseGetTag(ce) == argsTag$2;
}
var objectProto$9 = Object.prototype, hasOwnProperty$7 = objectProto$9.hasOwnProperty, propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(ce) {
  return isObjectLike$1(ce) && hasOwnProperty$7.call(ce, "callee") && !propertyIsEnumerable$1.call(ce, "callee");
}, isArray = Array.isArray, MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(ce) {
  return typeof ce == "number" && ce > -1 && ce % 1 == 0 && ce <= MAX_SAFE_INTEGER$1;
}
function isArrayLike(ce) {
  return ce != null && isLength(ce.length) && !isFunction(ce);
}
function isArrayLikeObject(ce) {
  return isObjectLike$1(ce) && isArrayLike(ce);
}
function stubFalse() {
  return !1;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, Buffer$1 = moduleExports$1 ? root$1.Buffer : void 0, nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$8 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$6 = objectProto$8.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject$1(ce) {
  if (!isObjectLike$1(ce) || baseGetTag(ce) != objectTag$3)
    return !1;
  var ie = getPrototype(ce);
  if (ie === null)
    return !0;
  var me = hasOwnProperty$6.call(ie, "constructor") && ie.constructor;
  return typeof me == "function" && me instanceof me && funcToString.call(me) == objectCtorString;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray(ce) {
  return isObjectLike$1(ce) && isLength(ce.length) && !!typedArrayTags[baseGetTag(ce)];
}
function baseUnary(ce) {
  return function(ie) {
    return ce(ie);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, freeProcess = moduleExports && freeGlobal$1.process, nodeUtil = function() {
  try {
    var ce = freeModule && freeModule.require && freeModule.require("util").types;
    return ce || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
}(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
function safeGet(ce, ie) {
  if (!(ie === "constructor" && typeof ce[ie] == "function") && ie != "__proto__")
    return ce[ie];
}
var objectProto$7 = Object.prototype, hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function assignValue(ce, ie, me) {
  var we = ce[ie];
  (!(hasOwnProperty$5.call(ce, ie) && eq(we, me)) || me === void 0 && !(ie in ce)) && baseAssignValue(ce, ie, me);
}
function copyObject(ce, ie, me, we) {
  var Re = !me;
  me || (me = {});
  for (var je = -1, Ue = ie.length; ++je < Ue; ) {
    var qe = ie[je], Ge = void 0;
    Ge === void 0 && (Ge = ce[qe]), Re ? baseAssignValue(me, qe, Ge) : assignValue(me, qe, Ge);
  }
  return me;
}
function baseTimes(ce, ie) {
  for (var me = -1, we = Array(ce); ++me < ce; )
    we[me] = ie(me);
  return we;
}
var MAX_SAFE_INTEGER = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(ce, ie) {
  var me = typeof ce;
  return ie = ie ?? MAX_SAFE_INTEGER, !!ie && (me == "number" || me != "symbol" && reIsUint.test(ce)) && ce > -1 && ce % 1 == 0 && ce < ie;
}
var objectProto$6 = Object.prototype, hasOwnProperty$4 = objectProto$6.hasOwnProperty;
function arrayLikeKeys(ce, ie) {
  var me = isArray(ce), we = !me && isArguments(ce), Re = !me && !we && isBuffer(ce), je = !me && !we && !Re && isTypedArray(ce), Ue = me || we || Re || je, qe = Ue ? baseTimes(ce.length, String) : [], Ge = qe.length;
  for (var Xe in ce)
    (ie || hasOwnProperty$4.call(ce, Xe)) && !(Ue && // Safari 9 has enumerable `arguments.length` in strict mode.
    (Xe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    Re && (Xe == "offset" || Xe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    je && (Xe == "buffer" || Xe == "byteLength" || Xe == "byteOffset") || // Skip index properties.
    isIndex(Xe, Ge))) && qe.push(Xe);
  return qe;
}
function nativeKeysIn(ce) {
  var ie = [];
  if (ce != null)
    for (var me in Object(ce))
      ie.push(me);
  return ie;
}
var objectProto$5 = Object.prototype, hasOwnProperty$3 = objectProto$5.hasOwnProperty;
function baseKeysIn(ce) {
  if (!isObject$2(ce))
    return nativeKeysIn(ce);
  var ie = isPrototype(ce), me = [];
  for (var we in ce)
    we == "constructor" && (ie || !hasOwnProperty$3.call(ce, we)) || me.push(we);
  return me;
}
function keysIn(ce) {
  return isArrayLike(ce) ? arrayLikeKeys(ce, !0) : baseKeysIn(ce);
}
function toPlainObject(ce) {
  return copyObject(ce, keysIn(ce));
}
function baseMergeDeep(ce, ie, me, we, Re, je, Ue) {
  var qe = safeGet(ce, me), Ge = safeGet(ie, me), Xe = Ue.get(Ge);
  if (Xe) {
    assignMergeValue(ce, me, Xe);
    return;
  }
  var ot = je ? je(qe, Ge, me + "", ce, ie, Ue) : void 0, vt = ot === void 0;
  if (vt) {
    var bt = isArray(Ge), Tt = !bt && isBuffer(Ge), wt = !bt && !Tt && isTypedArray(Ge);
    ot = Ge, bt || Tt || wt ? isArray(qe) ? ot = qe : isArrayLikeObject(qe) ? ot = copyArray(qe) : Tt ? (vt = !1, ot = cloneBuffer(Ge)) : wt ? (vt = !1, ot = cloneTypedArray(Ge)) : ot = [] : isPlainObject$1(Ge) || isArguments(Ge) ? (ot = qe, isArguments(qe) ? ot = toPlainObject(qe) : (!isObject$2(qe) || isFunction(qe)) && (ot = initCloneObject(Ge))) : vt = !1;
  }
  vt && (Ue.set(Ge, ot), Re(ot, Ge, we, je, Ue), Ue.delete(Ge)), assignMergeValue(ce, me, ot);
}
function baseMerge(ce, ie, me, we, Re) {
  ce !== ie && baseFor(ie, function(je, Ue) {
    if (Re || (Re = new Stack()), isObject$2(je))
      baseMergeDeep(ce, ie, Ue, me, baseMerge, we, Re);
    else {
      var qe = we ? we(safeGet(ce, Ue), je, Ue + "", ce, ie, Re) : void 0;
      qe === void 0 && (qe = je), assignMergeValue(ce, Ue, qe);
    }
  }, keysIn);
}
function identity(ce) {
  return ce;
}
function apply(ce, ie, me) {
  switch (me.length) {
    case 0:
      return ce.call(ie);
    case 1:
      return ce.call(ie, me[0]);
    case 2:
      return ce.call(ie, me[0], me[1]);
    case 3:
      return ce.call(ie, me[0], me[1], me[2]);
  }
  return ce.apply(ie, me);
}
var nativeMax$2 = Math.max;
function overRest(ce, ie, me) {
  return ie = nativeMax$2(ie === void 0 ? ce.length - 1 : ie, 0), function() {
    for (var we = arguments, Re = -1, je = nativeMax$2(we.length - ie, 0), Ue = Array(je); ++Re < je; )
      Ue[Re] = we[ie + Re];
    Re = -1;
    for (var qe = Array(ie + 1); ++Re < ie; )
      qe[Re] = we[Re];
    return qe[ie] = me(Ue), apply(ce, this, qe);
  };
}
function constant(ce) {
  return function() {
    return ce;
  };
}
var baseSetToString = defineProperty ? function(ce, ie) {
  return defineProperty(ce, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(ie),
    writable: !0
  });
} : identity, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(ce) {
  var ie = 0, me = 0;
  return function() {
    var we = nativeNow(), Re = HOT_SPAN - (we - me);
    if (me = we, Re > 0) {
      if (++ie >= HOT_COUNT)
        return arguments[0];
    } else
      ie = 0;
    return ce.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString);
function baseRest(ce, ie) {
  return setToString(overRest(ce, ie, identity), ce + "");
}
function isIterateeCall(ce, ie, me) {
  if (!isObject$2(me))
    return !1;
  var we = typeof ie;
  return (we == "number" ? isArrayLike(me) && isIndex(ie, me.length) : we == "string" && ie in me) ? eq(me[ie], ce) : !1;
}
function createAssigner(ce) {
  return baseRest(function(ie, me) {
    var we = -1, Re = me.length, je = Re > 1 ? me[Re - 1] : void 0, Ue = Re > 2 ? me[2] : void 0;
    for (je = ce.length > 3 && typeof je == "function" ? (Re--, je) : void 0, Ue && isIterateeCall(me[0], me[1], Ue) && (je = Re < 3 ? void 0 : je, Re = 1), ie = Object(ie); ++we < Re; ) {
      var qe = me[we];
      qe && ce(ie, qe, we, je);
    }
    return ie;
  });
}
var merge = createAssigner(function(ce, ie, me) {
  baseMerge(ce, ie, me);
}), Raised = function(ie) {
  var me = ie.zDepth, we = ie.radius, Re = ie.background, je = ie.children, Ue = ie.styles, qe = Ue === void 0 ? {} : Ue, Ge = _default$3(merge({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + me + "px " + me * 4 + "px rgba(0,0,0,.24)",
        borderRadius: we,
        background: Re
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, qe), { "zDepth-1": me === 1 });
  return React__default.createElement(
    "div",
    { style: Ge.wrap },
    React__default.createElement("div", { style: Ge.bg }),
    React__default.createElement(
      "div",
      { style: Ge.content },
      je
    )
  );
};
Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now$2 = function() {
  return root$1.Date.now();
}, reWhitespace = /\s/;
function trimmedEndIndex(ce) {
  for (var ie = ce.length; ie-- && reWhitespace.test(ce.charAt(ie)); )
    ;
  return ie;
}
var reTrimStart = /^\s+/;
function baseTrim(ce) {
  return ce && ce.slice(0, trimmedEndIndex(ce) + 1).replace(reTrimStart, "");
}
var symbolTag$2 = "[object Symbol]";
function isSymbol$1(ce) {
  return typeof ce == "symbol" || isObjectLike$1(ce) && baseGetTag(ce) == symbolTag$2;
}
var NAN$1 = NaN, reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i, reIsBinary$1 = /^0b[01]+$/i, reIsOctal$1 = /^0o[0-7]+$/i, freeParseInt$1 = parseInt;
function toNumber$1(ce) {
  if (typeof ce == "number")
    return ce;
  if (isSymbol$1(ce))
    return NAN$1;
  if (isObject$2(ce)) {
    var ie = typeof ce.valueOf == "function" ? ce.valueOf() : ce;
    ce = isObject$2(ie) ? ie + "" : ie;
  }
  if (typeof ce != "string")
    return ce === 0 ? ce : +ce;
  ce = baseTrim(ce);
  var me = reIsBinary$1.test(ce);
  return me || reIsOctal$1.test(ce) ? freeParseInt$1(ce.slice(2), me ? 2 : 8) : reIsBadHex$1.test(ce) ? NAN$1 : +ce;
}
var FUNC_ERROR_TEXT$3 = "Expected a function", nativeMax$1 = Math.max, nativeMin$1 = Math.min;
function debounce$1(ce, ie, me) {
  var we, Re, je, Ue, qe, Ge, Xe = 0, ot = !1, vt = !1, bt = !0;
  if (typeof ce != "function")
    throw new TypeError(FUNC_ERROR_TEXT$3);
  ie = toNumber$1(ie) || 0, isObject$2(me) && (ot = !!me.leading, vt = "maxWait" in me, je = vt ? nativeMax$1(toNumber$1(me.maxWait) || 0, ie) : je, bt = "trailing" in me ? !!me.trailing : bt);
  function Tt(nn) {
    var ln = we, fn = Re;
    return we = Re = void 0, Xe = nn, Ue = ce.apply(fn, ln), Ue;
  }
  function wt(nn) {
    return Xe = nn, qe = setTimeout(Pt, ie), ot ? Tt(nn) : Ue;
  }
  function St(nn) {
    var ln = nn - Ge, fn = nn - Xe, vn = ie - ln;
    return vt ? nativeMin$1(vn, je - fn) : vn;
  }
  function It(nn) {
    var ln = nn - Ge, fn = nn - Xe;
    return Ge === void 0 || ln >= ie || ln < 0 || vt && fn >= je;
  }
  function Pt() {
    var nn = now$2();
    if (It(nn))
      return kt(nn);
    qe = setTimeout(Pt, St(nn));
  }
  function kt(nn) {
    return qe = void 0, bt && we ? Tt(nn) : (we = Re = void 0, Ue);
  }
  function Ot() {
    qe !== void 0 && clearTimeout(qe), Xe = 0, we = Ge = Re = qe = void 0;
  }
  function Jr() {
    return qe === void 0 ? Ue : kt(now$2());
  }
  function en() {
    var nn = now$2(), ln = It(nn);
    if (we = arguments, Re = this, Ge = nn, ln) {
      if (qe === void 0)
        return wt(Ge);
      if (vt)
        return clearTimeout(qe), qe = setTimeout(Pt, ie), Tt(Ge);
    }
    return qe === void 0 && (qe = setTimeout(Pt, ie)), Ue;
  }
  return en.cancel = Ot, en.flush = Jr, en;
}
var FUNC_ERROR_TEXT$2 = "Expected a function";
function throttle(ce, ie, me) {
  var we = !0, Re = !0;
  if (typeof ce != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  return isObject$2(me) && (we = "leading" in me ? !!me.leading : we, Re = "trailing" in me ? !!me.trailing : Re), debounce$1(ce, ie, {
    leading: we,
    maxWait: ie,
    trailing: Re
  });
}
var calculateChange = function(ie, me, we) {
  var Re = we.getBoundingClientRect(), je = Re.width, Ue = Re.height, qe = typeof ie.pageX == "number" ? ie.pageX : ie.touches[0].pageX, Ge = typeof ie.pageY == "number" ? ie.pageY : ie.touches[0].pageY, Xe = qe - (we.getBoundingClientRect().left + window.pageXOffset), ot = Ge - (we.getBoundingClientRect().top + window.pageYOffset);
  Xe < 0 ? Xe = 0 : Xe > je && (Xe = je), ot < 0 ? ot = 0 : ot > Ue && (ot = Ue);
  var vt = Xe / je, bt = 1 - ot / Ue;
  return {
    h: me.h,
    s: vt,
    v: bt,
    a: me.a,
    source: "hsv"
  };
}, _createClass$n = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$n(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$9(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$9(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var Saturation = function(ce) {
  _inherits$9(ie, ce);
  function ie(me) {
    _classCallCheck$n(this, ie);
    var we = _possibleConstructorReturn$9(this, (ie.__proto__ || Object.getPrototypeOf(ie)).call(this, me));
    return we.handleChange = function(Re) {
      typeof we.props.onChange == "function" && we.throttle(we.props.onChange, calculateChange(Re, we.props.hsl, we.container), Re);
    }, we.handleMouseDown = function(Re) {
      we.handleChange(Re);
      var je = we.getContainerRenderWindow();
      je.addEventListener("mousemove", we.handleChange), je.addEventListener("mouseup", we.handleMouseUp);
    }, we.handleMouseUp = function() {
      we.unbindEventListeners();
    }, we.throttle = throttle(function(Re, je, Ue) {
      Re(je, Ue);
    }, 50), we;
  }
  return _createClass$n(ie, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var we = this.container, Re = window; !Re.document.contains(we) && Re.parent !== Re; )
        Re = Re.parent;
      return Re;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var we = this.getContainerRenderWindow();
      we.removeEventListener("mousemove", this.handleChange), we.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var we = this, Re = this.props.style || {}, je = Re.color, Ue = Re.white, qe = Re.black, Ge = Re.pointer, Xe = Re.circle, ot = _default$3({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: je,
          white: Ue,
          black: qe,
          pointer: Ge,
          circle: Xe
        }
      }, { custom: !!this.props.style });
      return React__default.createElement(
        "div",
        {
          style: ot.color,
          ref: function(bt) {
            return we.container = bt;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React__default.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        React__default.createElement(
          "div",
          { style: ot.white, className: "saturation-white" },
          React__default.createElement("div", { style: ot.black, className: "saturation-black" }),
          React__default.createElement(
            "div",
            { style: ot.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: ot.circle })
          )
        )
      );
    }
  }]), ie;
}(PureComponent || Component);
function arrayEach(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length; ++me < we && ie(ce[me], me, ce) !== !1; )
    ;
  return ce;
}
var nativeKeys = overArg(Object.keys, Object), objectProto$4 = Object.prototype, hasOwnProperty$2 = objectProto$4.hasOwnProperty;
function baseKeys(ce) {
  if (!isPrototype(ce))
    return nativeKeys(ce);
  var ie = [];
  for (var me in Object(ce))
    hasOwnProperty$2.call(ce, me) && me != "constructor" && ie.push(me);
  return ie;
}
function keys(ce) {
  return isArrayLike(ce) ? arrayLikeKeys(ce) : baseKeys(ce);
}
function baseForOwn(ce, ie) {
  return ce && baseFor(ce, ie, keys);
}
function createBaseEach(ce, ie) {
  return function(me, we) {
    if (me == null)
      return me;
    if (!isArrayLike(me))
      return ce(me, we);
    for (var Re = me.length, je = -1, Ue = Object(me); ++je < Re && we(Ue[je], je, Ue) !== !1; )
      ;
    return me;
  };
}
var baseEach = createBaseEach(baseForOwn);
function castFunction(ce) {
  return typeof ce == "function" ? ce : identity;
}
function forEach(ce, ie) {
  var me = isArray(ce) ? arrayEach : baseEach;
  return me(ce, castFunction(ie));
}
function _typeof$a(ce) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$a(ce);
}
var trimLeft = /^\s+/, trimRight = /\s+$/;
function tinycolor(ce, ie) {
  if (ce = ce || "", ie = ie || {}, ce instanceof tinycolor)
    return ce;
  if (!(this instanceof tinycolor))
    return new tinycolor(ce, ie);
  var me = inputToRGB(ce);
  this._originalInput = ce, this._r = me.r, this._g = me.g, this._b = me.b, this._a = me.a, this._roundA = Math.round(100 * this._a) / 100, this._format = ie.format || me.format, this._gradientType = ie.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = me.ok;
}
tinycolor.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var ie = this.toRgb();
    return (ie.r * 299 + ie.g * 587 + ie.b * 114) / 1e3;
  },
  getLuminance: function() {
    var ie = this.toRgb(), me, we, Re, je, Ue, qe;
    return me = ie.r / 255, we = ie.g / 255, Re = ie.b / 255, me <= 0.03928 ? je = me / 12.92 : je = Math.pow((me + 0.055) / 1.055, 2.4), we <= 0.03928 ? Ue = we / 12.92 : Ue = Math.pow((we + 0.055) / 1.055, 2.4), Re <= 0.03928 ? qe = Re / 12.92 : qe = Math.pow((Re + 0.055) / 1.055, 2.4), 0.2126 * je + 0.7152 * Ue + 0.0722 * qe;
  },
  setAlpha: function(ie) {
    return this._a = boundAlpha(ie), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var ie = rgbToHsv(this._r, this._g, this._b);
    return {
      h: ie.h * 360,
      s: ie.s,
      v: ie.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var ie = rgbToHsv(this._r, this._g, this._b), me = Math.round(ie.h * 360), we = Math.round(ie.s * 100), Re = Math.round(ie.v * 100);
    return this._a == 1 ? "hsv(" + me + ", " + we + "%, " + Re + "%)" : "hsva(" + me + ", " + we + "%, " + Re + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var ie = rgbToHsl(this._r, this._g, this._b);
    return {
      h: ie.h * 360,
      s: ie.s,
      l: ie.l,
      a: this._a
    };
  },
  toHslString: function() {
    var ie = rgbToHsl(this._r, this._g, this._b), me = Math.round(ie.h * 360), we = Math.round(ie.s * 100), Re = Math.round(ie.l * 100);
    return this._a == 1 ? "hsl(" + me + ", " + we + "%, " + Re + "%)" : "hsla(" + me + ", " + we + "%, " + Re + "%, " + this._roundA + ")";
  },
  toHex: function(ie) {
    return rgbToHex(this._r, this._g, this._b, ie);
  },
  toHexString: function(ie) {
    return "#" + this.toHex(ie);
  },
  toHex8: function(ie) {
    return rgbaToHex(this._r, this._g, this._b, this._a, ie);
  },
  toHex8String: function(ie) {
    return "#" + this.toHex8(ie);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : hexNames[rgbToHex(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(ie) {
    var me = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a), we = me, Re = this._gradientType ? "GradientType = 1, " : "";
    if (ie) {
      var je = tinycolor(ie);
      we = "#" + rgbaToArgbHex(je._r, je._g, je._b, je._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + Re + "startColorstr=" + me + ",endColorstr=" + we + ")";
  },
  toString: function(ie) {
    var me = !!ie;
    ie = ie || this._format;
    var we = !1, Re = this._a < 1 && this._a >= 0, je = !me && Re && (ie === "hex" || ie === "hex6" || ie === "hex3" || ie === "hex4" || ie === "hex8" || ie === "name");
    return je ? ie === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (ie === "rgb" && (we = this.toRgbString()), ie === "prgb" && (we = this.toPercentageRgbString()), (ie === "hex" || ie === "hex6") && (we = this.toHexString()), ie === "hex3" && (we = this.toHexString(!0)), ie === "hex4" && (we = this.toHex8String(!0)), ie === "hex8" && (we = this.toHex8String()), ie === "name" && (we = this.toName()), ie === "hsl" && (we = this.toHslString()), ie === "hsv" && (we = this.toHsvString()), we || this.toHexString());
  },
  clone: function() {
    return tinycolor(this.toString());
  },
  _applyModification: function(ie, me) {
    var we = ie.apply(null, [this].concat([].slice.call(me)));
    return this._r = we._r, this._g = we._g, this._b = we._b, this.setAlpha(we._a), this;
  },
  lighten: function() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function(ie, me) {
    return ie.apply(null, [this].concat([].slice.call(me)));
  },
  analogous: function() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(ce, ie) {
  if (_typeof$a(ce) == "object") {
    var me = {};
    for (var we in ce)
      ce.hasOwnProperty(we) && (we === "a" ? me[we] = ce[we] : me[we] = convertToPercentage(ce[we]));
    ce = me;
  }
  return tinycolor(ce, ie);
};
function inputToRGB(ce) {
  var ie = {
    r: 0,
    g: 0,
    b: 0
  }, me = 1, we = null, Re = null, je = null, Ue = !1, qe = !1;
  return typeof ce == "string" && (ce = stringInputToObject(ce)), _typeof$a(ce) == "object" && (isValidCSSUnit(ce.r) && isValidCSSUnit(ce.g) && isValidCSSUnit(ce.b) ? (ie = rgbToRgb(ce.r, ce.g, ce.b), Ue = !0, qe = String(ce.r).substr(-1) === "%" ? "prgb" : "rgb") : isValidCSSUnit(ce.h) && isValidCSSUnit(ce.s) && isValidCSSUnit(ce.v) ? (we = convertToPercentage(ce.s), Re = convertToPercentage(ce.v), ie = hsvToRgb(ce.h, we, Re), Ue = !0, qe = "hsv") : isValidCSSUnit(ce.h) && isValidCSSUnit(ce.s) && isValidCSSUnit(ce.l) && (we = convertToPercentage(ce.s), je = convertToPercentage(ce.l), ie = hslToRgb(ce.h, we, je), Ue = !0, qe = "hsl"), ce.hasOwnProperty("a") && (me = ce.a)), me = boundAlpha(me), {
    ok: Ue,
    format: ce.format || qe,
    r: Math.min(255, Math.max(ie.r, 0)),
    g: Math.min(255, Math.max(ie.g, 0)),
    b: Math.min(255, Math.max(ie.b, 0)),
    a: me
  };
}
function rgbToRgb(ce, ie, me) {
  return {
    r: bound01(ce, 255) * 255,
    g: bound01(ie, 255) * 255,
    b: bound01(me, 255) * 255
  };
}
function rgbToHsl(ce, ie, me) {
  ce = bound01(ce, 255), ie = bound01(ie, 255), me = bound01(me, 255);
  var we = Math.max(ce, ie, me), Re = Math.min(ce, ie, me), je, Ue, qe = (we + Re) / 2;
  if (we == Re)
    je = Ue = 0;
  else {
    var Ge = we - Re;
    switch (Ue = qe > 0.5 ? Ge / (2 - we - Re) : Ge / (we + Re), we) {
      case ce:
        je = (ie - me) / Ge + (ie < me ? 6 : 0);
        break;
      case ie:
        je = (me - ce) / Ge + 2;
        break;
      case me:
        je = (ce - ie) / Ge + 4;
        break;
    }
    je /= 6;
  }
  return {
    h: je,
    s: Ue,
    l: qe
  };
}
function hslToRgb(ce, ie, me) {
  var we, Re, je;
  ce = bound01(ce, 360), ie = bound01(ie, 100), me = bound01(me, 100);
  function Ue(Xe, ot, vt) {
    return vt < 0 && (vt += 1), vt > 1 && (vt -= 1), vt < 1 / 6 ? Xe + (ot - Xe) * 6 * vt : vt < 1 / 2 ? ot : vt < 2 / 3 ? Xe + (ot - Xe) * (2 / 3 - vt) * 6 : Xe;
  }
  if (ie === 0)
    we = Re = je = me;
  else {
    var qe = me < 0.5 ? me * (1 + ie) : me + ie - me * ie, Ge = 2 * me - qe;
    we = Ue(Ge, qe, ce + 1 / 3), Re = Ue(Ge, qe, ce), je = Ue(Ge, qe, ce - 1 / 3);
  }
  return {
    r: we * 255,
    g: Re * 255,
    b: je * 255
  };
}
function rgbToHsv(ce, ie, me) {
  ce = bound01(ce, 255), ie = bound01(ie, 255), me = bound01(me, 255);
  var we = Math.max(ce, ie, me), Re = Math.min(ce, ie, me), je, Ue, qe = we, Ge = we - Re;
  if (Ue = we === 0 ? 0 : Ge / we, we == Re)
    je = 0;
  else {
    switch (we) {
      case ce:
        je = (ie - me) / Ge + (ie < me ? 6 : 0);
        break;
      case ie:
        je = (me - ce) / Ge + 2;
        break;
      case me:
        je = (ce - ie) / Ge + 4;
        break;
    }
    je /= 6;
  }
  return {
    h: je,
    s: Ue,
    v: qe
  };
}
function hsvToRgb(ce, ie, me) {
  ce = bound01(ce, 360) * 6, ie = bound01(ie, 100), me = bound01(me, 100);
  var we = Math.floor(ce), Re = ce - we, je = me * (1 - ie), Ue = me * (1 - Re * ie), qe = me * (1 - (1 - Re) * ie), Ge = we % 6, Xe = [me, Ue, je, je, qe, me][Ge], ot = [qe, me, me, Ue, je, je][Ge], vt = [je, je, qe, me, me, Ue][Ge];
  return {
    r: Xe * 255,
    g: ot * 255,
    b: vt * 255
  };
}
function rgbToHex(ce, ie, me, we) {
  var Re = [pad2(Math.round(ce).toString(16)), pad2(Math.round(ie).toString(16)), pad2(Math.round(me).toString(16))];
  return we && Re[0].charAt(0) == Re[0].charAt(1) && Re[1].charAt(0) == Re[1].charAt(1) && Re[2].charAt(0) == Re[2].charAt(1) ? Re[0].charAt(0) + Re[1].charAt(0) + Re[2].charAt(0) : Re.join("");
}
function rgbaToHex(ce, ie, me, we, Re) {
  var je = [pad2(Math.round(ce).toString(16)), pad2(Math.round(ie).toString(16)), pad2(Math.round(me).toString(16)), pad2(convertDecimalToHex(we))];
  return Re && je[0].charAt(0) == je[0].charAt(1) && je[1].charAt(0) == je[1].charAt(1) && je[2].charAt(0) == je[2].charAt(1) && je[3].charAt(0) == je[3].charAt(1) ? je[0].charAt(0) + je[1].charAt(0) + je[2].charAt(0) + je[3].charAt(0) : je.join("");
}
function rgbaToArgbHex(ce, ie, me, we) {
  var Re = [pad2(convertDecimalToHex(we)), pad2(Math.round(ce).toString(16)), pad2(Math.round(ie).toString(16)), pad2(Math.round(me).toString(16))];
  return Re.join("");
}
tinycolor.equals = function(ce, ie) {
  return !ce || !ie ? !1 : tinycolor(ce).toRgbString() == tinycolor(ie).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(ce, ie) {
  ie = ie === 0 ? 0 : ie || 10;
  var me = tinycolor(ce).toHsl();
  return me.s -= ie / 100, me.s = clamp01(me.s), tinycolor(me);
}
function _saturate(ce, ie) {
  ie = ie === 0 ? 0 : ie || 10;
  var me = tinycolor(ce).toHsl();
  return me.s += ie / 100, me.s = clamp01(me.s), tinycolor(me);
}
function _greyscale(ce) {
  return tinycolor(ce).desaturate(100);
}
function _lighten(ce, ie) {
  ie = ie === 0 ? 0 : ie || 10;
  var me = tinycolor(ce).toHsl();
  return me.l += ie / 100, me.l = clamp01(me.l), tinycolor(me);
}
function _brighten(ce, ie) {
  ie = ie === 0 ? 0 : ie || 10;
  var me = tinycolor(ce).toRgb();
  return me.r = Math.max(0, Math.min(255, me.r - Math.round(255 * -(ie / 100)))), me.g = Math.max(0, Math.min(255, me.g - Math.round(255 * -(ie / 100)))), me.b = Math.max(0, Math.min(255, me.b - Math.round(255 * -(ie / 100)))), tinycolor(me);
}
function _darken(ce, ie) {
  ie = ie === 0 ? 0 : ie || 10;
  var me = tinycolor(ce).toHsl();
  return me.l -= ie / 100, me.l = clamp01(me.l), tinycolor(me);
}
function _spin(ce, ie) {
  var me = tinycolor(ce).toHsl(), we = (me.h + ie) % 360;
  return me.h = we < 0 ? 360 + we : we, tinycolor(me);
}
function _complement(ce) {
  var ie = tinycolor(ce).toHsl();
  return ie.h = (ie.h + 180) % 360, tinycolor(ie);
}
function polyad(ce, ie) {
  if (isNaN(ie) || ie <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var me = tinycolor(ce).toHsl(), we = [tinycolor(ce)], Re = 360 / ie, je = 1; je < ie; je++)
    we.push(tinycolor({
      h: (me.h + je * Re) % 360,
      s: me.s,
      l: me.l
    }));
  return we;
}
function _splitcomplement(ce) {
  var ie = tinycolor(ce).toHsl(), me = ie.h;
  return [tinycolor(ce), tinycolor({
    h: (me + 72) % 360,
    s: ie.s,
    l: ie.l
  }), tinycolor({
    h: (me + 216) % 360,
    s: ie.s,
    l: ie.l
  })];
}
function _analogous(ce, ie, me) {
  ie = ie || 6, me = me || 30;
  var we = tinycolor(ce).toHsl(), Re = 360 / me, je = [tinycolor(ce)];
  for (we.h = (we.h - (Re * ie >> 1) + 720) % 360; --ie; )
    we.h = (we.h + Re) % 360, je.push(tinycolor(we));
  return je;
}
function _monochromatic(ce, ie) {
  ie = ie || 6;
  for (var me = tinycolor(ce).toHsv(), we = me.h, Re = me.s, je = me.v, Ue = [], qe = 1 / ie; ie--; )
    Ue.push(tinycolor({
      h: we,
      s: Re,
      v: je
    })), je = (je + qe) % 1;
  return Ue;
}
tinycolor.mix = function(ce, ie, me) {
  me = me === 0 ? 0 : me || 50;
  var we = tinycolor(ce).toRgb(), Re = tinycolor(ie).toRgb(), je = me / 100, Ue = {
    r: (Re.r - we.r) * je + we.r,
    g: (Re.g - we.g) * je + we.g,
    b: (Re.b - we.b) * je + we.b,
    a: (Re.a - we.a) * je + we.a
  };
  return tinycolor(Ue);
};
tinycolor.readability = function(ce, ie) {
  var me = tinycolor(ce), we = tinycolor(ie);
  return (Math.max(me.getLuminance(), we.getLuminance()) + 0.05) / (Math.min(me.getLuminance(), we.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(ce, ie, me) {
  var we = tinycolor.readability(ce, ie), Re, je;
  switch (je = !1, Re = validateWCAG2Parms(me), Re.level + Re.size) {
    case "AAsmall":
    case "AAAlarge":
      je = we >= 4.5;
      break;
    case "AAlarge":
      je = we >= 3;
      break;
    case "AAAsmall":
      je = we >= 7;
      break;
  }
  return je;
};
tinycolor.mostReadable = function(ce, ie, me) {
  var we = null, Re = 0, je, Ue, qe, Ge;
  me = me || {}, Ue = me.includeFallbackColors, qe = me.level, Ge = me.size;
  for (var Xe = 0; Xe < ie.length; Xe++)
    je = tinycolor.readability(ce, ie[Xe]), je > Re && (Re = je, we = tinycolor(ie[Xe]));
  return tinycolor.isReadable(ce, we, {
    level: qe,
    size: Ge
  }) || !Ue ? we : (me.includeFallbackColors = !1, tinycolor.mostReadable(ce, ["#fff", "#000"], me));
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, hexNames = tinycolor.hexNames = flip$1(names);
function flip$1(ce) {
  var ie = {};
  for (var me in ce)
    ce.hasOwnProperty(me) && (ie[ce[me]] = me);
  return ie;
}
function boundAlpha(ce) {
  return ce = parseFloat(ce), (isNaN(ce) || ce < 0 || ce > 1) && (ce = 1), ce;
}
function bound01(ce, ie) {
  isOnePointZero(ce) && (ce = "100%");
  var me = isPercentage$1(ce);
  return ce = Math.min(ie, Math.max(0, parseFloat(ce))), me && (ce = parseInt(ce * ie, 10) / 100), Math.abs(ce - ie) < 1e-6 ? 1 : ce % ie / parseFloat(ie);
}
function clamp01(ce) {
  return Math.min(1, Math.max(0, ce));
}
function parseIntFromHex(ce) {
  return parseInt(ce, 16);
}
function isOnePointZero(ce) {
  return typeof ce == "string" && ce.indexOf(".") != -1 && parseFloat(ce) === 1;
}
function isPercentage$1(ce) {
  return typeof ce == "string" && ce.indexOf("%") != -1;
}
function pad2(ce) {
  return ce.length == 1 ? "0" + ce : "" + ce;
}
function convertToPercentage(ce) {
  return ce <= 1 && (ce = ce * 100 + "%"), ce;
}
function convertDecimalToHex(ce) {
  return Math.round(parseFloat(ce) * 255).toString(16);
}
function convertHexToDecimal(ce) {
  return parseIntFromHex(ce) / 255;
}
var matchers = function() {
  var ce = "[-\\+]?\\d+%?", ie = "[-\\+]?\\d*\\.\\d+%?", me = "(?:" + ie + ")|(?:" + ce + ")", we = "[\\s|\\(]+(" + me + ")[,|\\s]+(" + me + ")[,|\\s]+(" + me + ")\\s*\\)?", Re = "[\\s|\\(]+(" + me + ")[,|\\s]+(" + me + ")[,|\\s]+(" + me + ")[,|\\s]+(" + me + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(me),
    rgb: new RegExp("rgb" + we),
    rgba: new RegExp("rgba" + Re),
    hsl: new RegExp("hsl" + we),
    hsla: new RegExp("hsla" + Re),
    hsv: new RegExp("hsv" + we),
    hsva: new RegExp("hsva" + Re),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function isValidCSSUnit(ce) {
  return !!matchers.CSS_UNIT.exec(ce);
}
function stringInputToObject(ce) {
  ce = ce.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var ie = !1;
  if (names[ce])
    ce = names[ce], ie = !0;
  else if (ce == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var me;
  return (me = matchers.rgb.exec(ce)) ? {
    r: me[1],
    g: me[2],
    b: me[3]
  } : (me = matchers.rgba.exec(ce)) ? {
    r: me[1],
    g: me[2],
    b: me[3],
    a: me[4]
  } : (me = matchers.hsl.exec(ce)) ? {
    h: me[1],
    s: me[2],
    l: me[3]
  } : (me = matchers.hsla.exec(ce)) ? {
    h: me[1],
    s: me[2],
    l: me[3],
    a: me[4]
  } : (me = matchers.hsv.exec(ce)) ? {
    h: me[1],
    s: me[2],
    v: me[3]
  } : (me = matchers.hsva.exec(ce)) ? {
    h: me[1],
    s: me[2],
    v: me[3],
    a: me[4]
  } : (me = matchers.hex8.exec(ce)) ? {
    r: parseIntFromHex(me[1]),
    g: parseIntFromHex(me[2]),
    b: parseIntFromHex(me[3]),
    a: convertHexToDecimal(me[4]),
    format: ie ? "name" : "hex8"
  } : (me = matchers.hex6.exec(ce)) ? {
    r: parseIntFromHex(me[1]),
    g: parseIntFromHex(me[2]),
    b: parseIntFromHex(me[3]),
    format: ie ? "name" : "hex"
  } : (me = matchers.hex4.exec(ce)) ? {
    r: parseIntFromHex(me[1] + "" + me[1]),
    g: parseIntFromHex(me[2] + "" + me[2]),
    b: parseIntFromHex(me[3] + "" + me[3]),
    a: convertHexToDecimal(me[4] + "" + me[4]),
    format: ie ? "name" : "hex8"
  } : (me = matchers.hex3.exec(ce)) ? {
    r: parseIntFromHex(me[1] + "" + me[1]),
    g: parseIntFromHex(me[2] + "" + me[2]),
    b: parseIntFromHex(me[3] + "" + me[3]),
    format: ie ? "name" : "hex"
  } : !1;
}
function validateWCAG2Parms(ce) {
  var ie, me;
  return ce = ce || {
    level: "AA",
    size: "small"
  }, ie = (ce.level || "AA").toUpperCase(), me = (ce.size || "small").toLowerCase(), ie !== "AA" && ie !== "AAA" && (ie = "AA"), me !== "small" && me !== "large" && (me = "small"), {
    level: ie,
    size: me
  };
}
var simpleCheckForValidColor = function(ie) {
  var me = ["r", "g", "b", "a", "h", "s", "l", "v"], we = 0, Re = 0;
  return forEach(me, function(je) {
    if (ie[je] && (we += 1, isNaN(ie[je]) || (Re += 1), je === "s" || je === "l")) {
      var Ue = /^\d+%$/;
      Ue.test(ie[je]) && (Re += 1);
    }
  }), we === Re ? ie : !1;
}, toState = function(ie, me) {
  var we = ie.hex ? tinycolor(ie.hex) : tinycolor(ie), Re = we.toHsl(), je = we.toHsv(), Ue = we.toRgb(), qe = we.toHex();
  Re.s === 0 && (Re.h = me || 0, je.h = me || 0);
  var Ge = qe === "000000" && Ue.a === 0;
  return {
    hsl: Re,
    hex: Ge ? "transparent" : "#" + qe,
    rgb: Ue,
    hsv: je,
    oldHue: ie.h || me || Re.h,
    source: ie.source
  };
}, isValidHex = function(ie) {
  if (ie === "transparent")
    return !0;
  var me = String(ie).charAt(0) === "#" ? 1 : 0;
  return ie.length !== 4 + me && ie.length < 7 + me && tinycolor(ie).isValid();
}, getContrastingColor = function(ie) {
  if (!ie)
    return "#fff";
  var me = toState(ie);
  if (me.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var we = (me.rgb.r * 299 + me.rgb.g * 587 + me.rgb.b * 114) / 1e3;
  return we >= 128 ? "#000" : "#fff";
}, isvalidColorString = function(ie, me) {
  var we = ie.replace("°", "");
  return tinycolor(me + " (" + we + ")")._ok;
}, _extends$c = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _createClass$m = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$m(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$8(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$8(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var ColorWrap = function(ie) {
  var me = function(we) {
    _inherits$8(Re, we);
    function Re(je) {
      _classCallCheck$m(this, Re);
      var Ue = _possibleConstructorReturn$8(this, (Re.__proto__ || Object.getPrototypeOf(Re)).call(this));
      return Ue.handleChange = function(qe, Ge) {
        var Xe = simpleCheckForValidColor(qe);
        if (Xe) {
          var ot = toState(qe, qe.h || Ue.state.oldHue);
          Ue.setState(ot), Ue.props.onChangeComplete && Ue.debounce(Ue.props.onChangeComplete, ot, Ge), Ue.props.onChange && Ue.props.onChange(ot, Ge);
        }
      }, Ue.handleSwatchHover = function(qe, Ge) {
        var Xe = simpleCheckForValidColor(qe);
        if (Xe) {
          var ot = toState(qe, qe.h || Ue.state.oldHue);
          Ue.props.onSwatchHover && Ue.props.onSwatchHover(ot, Ge);
        }
      }, Ue.state = _extends$c({}, toState(je.color, 0)), Ue.debounce = debounce$1(function(qe, Ge, Xe) {
        qe(Ge, Xe);
      }, 100), Ue;
    }
    return _createClass$m(Re, [{
      key: "render",
      value: function() {
        var Ue = {};
        return this.props.onSwatchHover && (Ue.onSwatchHover = this.handleSwatchHover), React__default.createElement(ie, _extends$c({}, this.props, this.state, {
          onChange: this.handleChange
        }, Ue));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(Ue, qe) {
        return _extends$c({}, toState(Ue.color, qe.oldHue));
      }
    }]), Re;
  }(PureComponent || Component);
  return me.propTypes = _extends$c({}, ie.propTypes), me.defaultProps = _extends$c({}, ie.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), me;
}, _extends$b = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _createClass$l = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$l(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$7(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$7(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var handleFocus = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(we) {
    _inherits$7(Re, we);
    function Re() {
      var je, Ue, qe, Ge;
      _classCallCheck$l(this, Re);
      for (var Xe = arguments.length, ot = Array(Xe), vt = 0; vt < Xe; vt++)
        ot[vt] = arguments[vt];
      return Ge = (Ue = (qe = _possibleConstructorReturn$7(this, (je = Re.__proto__ || Object.getPrototypeOf(Re)).call.apply(je, [this].concat(ot))), qe), qe.state = { focus: !1 }, qe.handleFocus = function() {
        return qe.setState({ focus: !0 });
      }, qe.handleBlur = function() {
        return qe.setState({ focus: !1 });
      }, Ue), _possibleConstructorReturn$7(qe, Ge);
    }
    return _createClass$l(Re, [{
      key: "render",
      value: function() {
        return React__default.createElement(
          me,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          React__default.createElement(ie, _extends$b({}, this.props, this.state))
        );
      }
    }]), Re;
  }(React__default.Component);
}, _extends$a = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, ENTER = 13, Swatch = function(ie) {
  var me = ie.color, we = ie.style, Re = ie.onClick, je = Re === void 0 ? function() {
  } : Re, Ue = ie.onHover, qe = ie.title, Ge = qe === void 0 ? me : qe, Xe = ie.children, ot = ie.focus, vt = ie.focusStyle, bt = vt === void 0 ? {} : vt, Tt = me === "transparent", wt = _default$3({
    default: {
      swatch: _extends$a({
        background: me,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, we, ot ? bt : {})
    }
  }), St = function(Jr) {
    return je(me, Jr);
  }, It = function(Jr) {
    return Jr.keyCode === ENTER && je(me, Jr);
  }, Pt = function(Jr) {
    return Ue(me, Jr);
  }, kt = {};
  return Ue && (kt.onMouseOver = Pt), React__default.createElement(
    "div",
    _extends$a({
      style: wt.swatch,
      onClick: St,
      title: Ge,
      tabIndex: 0,
      onKeyDown: It
    }, kt),
    Xe,
    Tt && React__default.createElement(Checkboard, {
      borderRadius: wt.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Swatch$1 = handleFocus(Swatch);
var AlphaPointer = function(ie) {
  var me = ie.direction, we = _default$3({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: me === "vertical" });
  return React__default.createElement("div", { style: we.picker });
}, _extends$9 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, AlphaPicker = function(ie) {
  var me = ie.rgb, we = ie.hsl, Re = ie.width, je = ie.height, Ue = ie.onChange, qe = ie.direction, Ge = ie.style, Xe = ie.renderers, ot = ie.pointer, vt = ie.className, bt = vt === void 0 ? "" : vt, Tt = _default$3({
    default: {
      picker: {
        position: "relative",
        width: Re,
        height: je
      },
      alpha: {
        radius: "2px",
        style: Ge
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: Tt.picker, className: "alpha-picker " + bt },
    React__default.createElement(Alpha, _extends$9({}, Tt.alpha, {
      rgb: me,
      hsl: we,
      pointer: ot,
      renderers: Xe,
      onChange: Ue,
      direction: qe
    }))
  );
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);
function arrayMap(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length, Re = Array(we); ++me < we; )
    Re[me] = ie(ce[me], me, ce);
  return Re;
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(ce) {
  return this.__data__.set(ce, HASH_UNDEFINED), this;
}
function setCacheHas(ce) {
  return this.__data__.has(ce);
}
function SetCache(ce) {
  var ie = -1, me = ce == null ? 0 : ce.length;
  for (this.__data__ = new MapCache(); ++ie < me; )
    this.add(ce[ie]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length; ++me < we; )
    if (ie(ce[me], me, ce))
      return !0;
  return !1;
}
function cacheHas(ce, ie) {
  return ce.has(ie);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(ce, ie, me, we, Re, je) {
  var Ue = me & COMPARE_PARTIAL_FLAG$5, qe = ce.length, Ge = ie.length;
  if (qe != Ge && !(Ue && Ge > qe))
    return !1;
  var Xe = je.get(ce), ot = je.get(ie);
  if (Xe && ot)
    return Xe == ie && ot == ce;
  var vt = -1, bt = !0, Tt = me & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (je.set(ce, ie), je.set(ie, ce); ++vt < qe; ) {
    var wt = ce[vt], St = ie[vt];
    if (we)
      var It = Ue ? we(St, wt, vt, ie, ce, je) : we(wt, St, vt, ce, ie, je);
    if (It !== void 0) {
      if (It)
        continue;
      bt = !1;
      break;
    }
    if (Tt) {
      if (!arraySome(ie, function(Pt, kt) {
        if (!cacheHas(Tt, kt) && (wt === Pt || Re(wt, Pt, me, we, je)))
          return Tt.push(kt);
      })) {
        bt = !1;
        break;
      }
    } else if (!(wt === St || Re(wt, St, me, we, je))) {
      bt = !1;
      break;
    }
  }
  return je.delete(ce), je.delete(ie), bt;
}
function mapToArray(ce) {
  var ie = -1, me = Array(ce.size);
  return ce.forEach(function(we, Re) {
    me[++ie] = [Re, we];
  }), me;
}
function setToArray(ce) {
  var ie = -1, me = Array(ce.size);
  return ce.forEach(function(we) {
    me[++ie] = we;
  }), me;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag(ce, ie, me, we, Re, je, Ue) {
  switch (me) {
    case dataViewTag$1:
      if (ce.byteLength != ie.byteLength || ce.byteOffset != ie.byteOffset)
        return !1;
      ce = ce.buffer, ie = ie.buffer;
    case arrayBufferTag:
      return !(ce.byteLength != ie.byteLength || !je(new Uint8Array$1(ce), new Uint8Array$1(ie)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+ce, +ie);
    case errorTag:
      return ce.name == ie.name && ce.message == ie.message;
    case regexpTag:
    case stringTag:
      return ce == ie + "";
    case mapTag$1:
      var qe = mapToArray;
    case setTag$1:
      var Ge = we & COMPARE_PARTIAL_FLAG$4;
      if (qe || (qe = setToArray), ce.size != ie.size && !Ge)
        return !1;
      var Xe = Ue.get(ce);
      if (Xe)
        return Xe == ie;
      we |= COMPARE_UNORDERED_FLAG$2, Ue.set(ce, ie);
      var ot = equalArrays(qe(ce), qe(ie), we, Re, je, Ue);
      return Ue.delete(ce), ot;
    case symbolTag$1:
      if (symbolValueOf)
        return symbolValueOf.call(ce) == symbolValueOf.call(ie);
  }
  return !1;
}
function arrayPush(ce, ie) {
  for (var me = -1, we = ie.length, Re = ce.length; ++me < we; )
    ce[Re + me] = ie[me];
  return ce;
}
function baseGetAllKeys(ce, ie, me) {
  var we = ie(ce);
  return isArray(ce) ? we : arrayPush(we, me(ce));
}
function arrayFilter(ce, ie) {
  for (var me = -1, we = ce == null ? 0 : ce.length, Re = 0, je = []; ++me < we; ) {
    var Ue = ce[me];
    ie(Ue, me, ce) && (je[Re++] = Ue);
  }
  return je;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype, propertyIsEnumerable = objectProto$3.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols ? function(ce) {
  return ce == null ? [] : (ce = Object(ce), arrayFilter(nativeGetSymbols(ce), function(ie) {
    return propertyIsEnumerable.call(ce, ie);
  }));
} : stubArray;
function getAllKeys(ce) {
  return baseGetAllKeys(ce, keys, getSymbols);
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$2 = Object.prototype, hasOwnProperty$1 = objectProto$2.hasOwnProperty;
function equalObjects(ce, ie, me, we, Re, je) {
  var Ue = me & COMPARE_PARTIAL_FLAG$3, qe = getAllKeys(ce), Ge = qe.length, Xe = getAllKeys(ie), ot = Xe.length;
  if (Ge != ot && !Ue)
    return !1;
  for (var vt = Ge; vt--; ) {
    var bt = qe[vt];
    if (!(Ue ? bt in ie : hasOwnProperty$1.call(ie, bt)))
      return !1;
  }
  var Tt = je.get(ce), wt = je.get(ie);
  if (Tt && wt)
    return Tt == ie && wt == ce;
  var St = !0;
  je.set(ce, ie), je.set(ie, ce);
  for (var It = Ue; ++vt < Ge; ) {
    bt = qe[vt];
    var Pt = ce[bt], kt = ie[bt];
    if (we)
      var Ot = Ue ? we(kt, Pt, bt, ie, ce, je) : we(Pt, kt, bt, ce, ie, je);
    if (!(Ot === void 0 ? Pt === kt || Re(Pt, kt, me, we, je) : Ot)) {
      St = !1;
      break;
    }
    It || (It = bt == "constructor");
  }
  if (St && !It) {
    var Jr = ce.constructor, en = ie.constructor;
    Jr != en && "constructor" in ce && "constructor" in ie && !(typeof Jr == "function" && Jr instanceof Jr && typeof en == "function" && en instanceof en) && (St = !1);
  }
  return je.delete(ce), je.delete(ie), St;
}
var DataView$1 = getNative(root$1, "DataView"), Promise$1 = getNative(root$1, "Promise"), Set$1 = getNative(root$1, "Set"), WeakMap$1 = getNative(root$1, "WeakMap"), mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag(new Map$1()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) && (getTag = function(ce) {
  var ie = baseGetTag(ce), me = ie == objectTag$1 ? ce.constructor : void 0, we = me ? toSource(me) : "";
  if (we)
    switch (we) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return ie;
});
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$1 = Object.prototype, hasOwnProperty = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(ce, ie, me, we, Re, je) {
  var Ue = isArray(ce), qe = isArray(ie), Ge = Ue ? arrayTag : getTag(ce), Xe = qe ? arrayTag : getTag(ie);
  Ge = Ge == argsTag ? objectTag : Ge, Xe = Xe == argsTag ? objectTag : Xe;
  var ot = Ge == objectTag, vt = Xe == objectTag, bt = Ge == Xe;
  if (bt && isBuffer(ce)) {
    if (!isBuffer(ie))
      return !1;
    Ue = !0, ot = !1;
  }
  if (bt && !ot)
    return je || (je = new Stack()), Ue || isTypedArray(ce) ? equalArrays(ce, ie, me, we, Re, je) : equalByTag(ce, ie, Ge, me, we, Re, je);
  if (!(me & COMPARE_PARTIAL_FLAG$2)) {
    var Tt = ot && hasOwnProperty.call(ce, "__wrapped__"), wt = vt && hasOwnProperty.call(ie, "__wrapped__");
    if (Tt || wt) {
      var St = Tt ? ce.value() : ce, It = wt ? ie.value() : ie;
      return je || (je = new Stack()), Re(St, It, me, we, je);
    }
  }
  return bt ? (je || (je = new Stack()), equalObjects(ce, ie, me, we, Re, je)) : !1;
}
function baseIsEqual(ce, ie, me, we, Re) {
  return ce === ie ? !0 : ce == null || ie == null || !isObjectLike$1(ce) && !isObjectLike$1(ie) ? ce !== ce && ie !== ie : baseIsEqualDeep(ce, ie, me, we, baseIsEqual, Re);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(ce, ie, me, we) {
  var Re = me.length, je = Re;
  if (ce == null)
    return !je;
  for (ce = Object(ce); Re--; ) {
    var Ue = me[Re];
    if (Ue[2] ? Ue[1] !== ce[Ue[0]] : !(Ue[0] in ce))
      return !1;
  }
  for (; ++Re < je; ) {
    Ue = me[Re];
    var qe = Ue[0], Ge = ce[qe], Xe = Ue[1];
    if (Ue[2]) {
      if (Ge === void 0 && !(qe in ce))
        return !1;
    } else {
      var ot = new Stack(), vt;
      if (!(vt === void 0 ? baseIsEqual(Xe, Ge, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, we, ot) : vt))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(ce) {
  return ce === ce && !isObject$2(ce);
}
function getMatchData(ce) {
  for (var ie = keys(ce), me = ie.length; me--; ) {
    var we = ie[me], Re = ce[we];
    ie[me] = [we, Re, isStrictComparable(Re)];
  }
  return ie;
}
function matchesStrictComparable(ce, ie) {
  return function(me) {
    return me == null ? !1 : me[ce] === ie && (ie !== void 0 || ce in Object(me));
  };
}
function baseMatches(ce) {
  var ie = getMatchData(ce);
  return ie.length == 1 && ie[0][2] ? matchesStrictComparable(ie[0][0], ie[0][1]) : function(me) {
    return me === ce || baseIsMatch(me, ce, ie);
  };
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(ce, ie) {
  if (isArray(ce))
    return !1;
  var me = typeof ce;
  return me == "number" || me == "symbol" || me == "boolean" || ce == null || isSymbol$1(ce) ? !0 : reIsPlainProp.test(ce) || !reIsDeepProp.test(ce) || ie != null && ce in Object(ie);
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$1(ce, ie) {
  if (typeof ce != "function" || ie != null && typeof ie != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var me = function() {
    var we = arguments, Re = ie ? ie.apply(this, we) : we[0], je = me.cache;
    if (je.has(Re))
      return je.get(Re);
    var Ue = ce.apply(this, we);
    return me.cache = je.set(Re, Ue) || je, Ue;
  };
  return me.cache = new (memoize$1.Cache || MapCache)(), me;
}
memoize$1.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(ce) {
  var ie = memoize$1(ce, function(we) {
    return me.size === MAX_MEMOIZE_SIZE && me.clear(), we;
  }), me = ie.cache;
  return ie;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(ce) {
  var ie = [];
  return ce.charCodeAt(0) === 46 && ie.push(""), ce.replace(rePropName, function(me, we, Re, je) {
    ie.push(Re ? je.replace(reEscapeChar, "$1") : we || me);
  }), ie;
}), symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(ce) {
  if (typeof ce == "string")
    return ce;
  if (isArray(ce))
    return arrayMap(ce, baseToString) + "";
  if (isSymbol$1(ce))
    return symbolToString ? symbolToString.call(ce) : "";
  var ie = ce + "";
  return ie == "0" && 1 / ce == -1 / 0 ? "-0" : ie;
}
function toString(ce) {
  return ce == null ? "" : baseToString(ce);
}
function castPath(ce, ie) {
  return isArray(ce) ? ce : isKey(ce, ie) ? [ce] : stringToPath(toString(ce));
}
function toKey(ce) {
  if (typeof ce == "string" || isSymbol$1(ce))
    return ce;
  var ie = ce + "";
  return ie == "0" && 1 / ce == -1 / 0 ? "-0" : ie;
}
function baseGet(ce, ie) {
  ie = castPath(ie, ce);
  for (var me = 0, we = ie.length; ce != null && me < we; )
    ce = ce[toKey(ie[me++])];
  return me && me == we ? ce : void 0;
}
function get$1(ce, ie, me) {
  var we = ce == null ? void 0 : baseGet(ce, ie);
  return we === void 0 ? me : we;
}
function baseHasIn(ce, ie) {
  return ce != null && ie in Object(ce);
}
function hasPath(ce, ie, me) {
  ie = castPath(ie, ce);
  for (var we = -1, Re = ie.length, je = !1; ++we < Re; ) {
    var Ue = toKey(ie[we]);
    if (!(je = ce != null && me(ce, Ue)))
      break;
    ce = ce[Ue];
  }
  return je || ++we != Re ? je : (Re = ce == null ? 0 : ce.length, !!Re && isLength(Re) && isIndex(Ue, Re) && (isArray(ce) || isArguments(ce)));
}
function hasIn(ce, ie) {
  return ce != null && hasPath(ce, ie, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(ce, ie) {
  return isKey(ce) && isStrictComparable(ie) ? matchesStrictComparable(toKey(ce), ie) : function(me) {
    var we = get$1(me, ce);
    return we === void 0 && we === ie ? hasIn(me, ce) : baseIsEqual(ie, we, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(ce) {
  return function(ie) {
    return ie == null ? void 0 : ie[ce];
  };
}
function basePropertyDeep(ce) {
  return function(ie) {
    return baseGet(ie, ce);
  };
}
function property(ce) {
  return isKey(ce) ? baseProperty(toKey(ce)) : basePropertyDeep(ce);
}
function baseIteratee(ce) {
  return typeof ce == "function" ? ce : ce == null ? identity : typeof ce == "object" ? isArray(ce) ? baseMatchesProperty(ce[0], ce[1]) : baseMatches(ce) : property(ce);
}
function baseMap(ce, ie) {
  var me = -1, we = isArrayLike(ce) ? Array(ce.length) : [];
  return baseEach(ce, function(Re, je, Ue) {
    we[++me] = ie(Re, je, Ue);
  }), we;
}
function map(ce, ie) {
  var me = isArray(ce) ? arrayMap : baseMap;
  return me(ce, baseIteratee(ie));
}
var BlockSwatches = function(ie) {
  var me = ie.colors, we = ie.onClick, Re = ie.onSwatchHover, je = _default$3({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: je.swatches },
    map(me, function(Ue) {
      return React__default.createElement(Swatch$1, {
        key: Ue,
        color: Ue,
        style: je.swatch,
        onClick: we,
        onHover: Re,
        focusStyle: {
          boxShadow: "0 0 4px " + Ue
        }
      });
    }),
    React__default.createElement("div", { style: je.clear })
  );
}, Block = function(ie) {
  var me = ie.onChange, we = ie.onSwatchHover, Re = ie.hex, je = ie.colors, Ue = ie.width, qe = ie.triangle, Ge = ie.styles, Xe = Ge === void 0 ? {} : Ge, ot = ie.className, vt = ot === void 0 ? "" : ot, bt = Re === "transparent", Tt = function(It, Pt) {
    isValidHex(It) && me({
      hex: It,
      source: "hex"
    }, Pt);
  }, wt = _default$3(merge({
    default: {
      card: {
        width: Ue,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: Re,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(Re),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + Re + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, Xe), { "hide-triangle": qe === "hide" });
  return React__default.createElement(
    "div",
    { style: wt.card, className: "block-picker " + vt },
    React__default.createElement("div", { style: wt.triangle }),
    React__default.createElement(
      "div",
      { style: wt.head },
      bt && React__default.createElement(Checkboard, { borderRadius: "6px 6px 0 0" }),
      React__default.createElement(
        "div",
        { style: wt.label },
        Re
      )
    ),
    React__default.createElement(
      "div",
      { style: wt.body },
      React__default.createElement(BlockSwatches, { colors: je, onClick: Tt, onSwatchHover: we }),
      React__default.createElement(EditableInput, {
        style: { input: wt.input },
        value: Re,
        onChange: Tt
      })
    )
  );
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["top", "hide"]),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap(Block);
var red = { 100: "#ffcdd2", 300: "#e57373", 500: "#f44336", 700: "#d32f2f", 900: "#b71c1c" }, pink = { 100: "#f8bbd0", 300: "#f06292", 500: "#e91e63", 700: "#c2185b", 900: "#880e4f" }, purple = { 100: "#e1bee7", 300: "#ba68c8", 500: "#9c27b0", 700: "#7b1fa2", 900: "#4a148c" }, deepPurple = { 100: "#d1c4e9", 300: "#9575cd", 500: "#673ab7", 700: "#512da8", 900: "#311b92" }, indigo = { 100: "#c5cae9", 300: "#7986cb", 500: "#3f51b5", 700: "#303f9f", 900: "#1a237e" }, blue = { 100: "#bbdefb", 300: "#64b5f6", 500: "#2196f3", 700: "#1976d2", 900: "#0d47a1" }, lightBlue = { 100: "#b3e5fc", 300: "#4fc3f7", 500: "#03a9f4", 700: "#0288d1", 900: "#01579b" }, cyan = { 100: "#b2ebf2", 300: "#4dd0e1", 500: "#00bcd4", 700: "#0097a7", 900: "#006064" }, teal = { 100: "#b2dfdb", 300: "#4db6ac", 500: "#009688", 700: "#00796b", 900: "#004d40" }, green = { 100: "#c8e6c9", 300: "#81c784", 500: "#4caf50", 700: "#388e3c" }, lightGreen = { 100: "#dcedc8", 300: "#aed581", 500: "#8bc34a", 700: "#689f38", 900: "#33691e" }, lime = { 100: "#f0f4c3", 300: "#dce775", 500: "#cddc39", 700: "#afb42b", 900: "#827717" }, yellow = { 100: "#fff9c4", 300: "#fff176", 500: "#ffeb3b", 700: "#fbc02d", 900: "#f57f17" }, amber = { 100: "#ffecb3", 300: "#ffd54f", 500: "#ffc107", 700: "#ffa000", 900: "#ff6f00" }, orange = { 100: "#ffe0b2", 300: "#ffb74d", 500: "#ff9800", 700: "#f57c00", 900: "#e65100" }, deepOrange = { 100: "#ffccbc", 300: "#ff8a65", 500: "#ff5722", 700: "#e64a19", 900: "#bf360c" }, brown = { 100: "#d7ccc8", 300: "#a1887f", 500: "#795548", 700: "#5d4037", 900: "#3e2723" }, blueGrey = { 100: "#cfd8dc", 300: "#90a4ae", 500: "#607d8b", 700: "#455a64", 900: "#263238" }, CircleSwatch = function(ie) {
  var me = ie.color, we = ie.onClick, Re = ie.onSwatchHover, je = ie.hover, Ue = ie.active, qe = ie.circleSize, Ge = ie.circleSpacing, Xe = _default$3({
    default: {
      swatch: {
        width: qe,
        height: qe,
        marginRight: Ge,
        marginBottom: Ge,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (qe / 2 + 1) + "px " + me,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + me
      }
    }
  }, { hover: je, active: Ue });
  return React__default.createElement(
    "div",
    { style: Xe.swatch },
    React__default.createElement(Swatch$1, {
      style: Xe.Swatch,
      color: me,
      onClick: we,
      onHover: Re,
      focusStyle: { boxShadow: Xe.Swatch.boxShadow + ", 0 0 5px " + me }
    })
  );
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = handleHover(CircleSwatch);
var Circle = function(ie) {
  var me = ie.width, we = ie.onChange, Re = ie.onSwatchHover, je = ie.colors, Ue = ie.hex, qe = ie.circleSize, Ge = ie.styles, Xe = Ge === void 0 ? {} : Ge, ot = ie.circleSpacing, vt = ie.className, bt = vt === void 0 ? "" : vt, Tt = _default$3(merge({
    default: {
      card: {
        width: me,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -ot,
        marginBottom: -ot
      }
    }
  }, Xe)), wt = function(It, Pt) {
    return we({ hex: It, source: "hex" }, Pt);
  };
  return React__default.createElement(
    "div",
    { style: Tt.card, className: "circle-picker " + bt },
    map(je, function(St) {
      return React__default.createElement(CircleSwatch$1, {
        key: St,
        color: St,
        onClick: wt,
        onSwatchHover: Re,
        active: Ue === St.toLowerCase(),
        circleSize: qe,
        circleSpacing: ot
      });
    })
  );
};
Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red[500], pink[500], purple[500], deepPurple[500], indigo[500], blue[500], lightBlue[500], cyan[500], teal[500], green[500], lightGreen[500], lime[500], yellow[500], amber[500], orange[500], deepOrange[500], brown[500], blueGrey[500]],
  styles: {}
};
ColorWrap(Circle);
function isUndefined(ce) {
  return ce === void 0;
}
var UnfoldMoreHorizontalIcon = {};
Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: !0
});
var _extends$8 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _react$9 = React__default, _react2$4 = _interopRequireDefault$9(_react$9);
function _interopRequireDefault$9(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _objectWithoutProperties$5(ce, ie) {
  var me = {};
  for (var we in ce)
    ie.indexOf(we) >= 0 || Object.prototype.hasOwnProperty.call(ce, we) && (me[we] = ce[we]);
  return me;
}
var DEFAULT_SIZE$1 = 24, _default$2 = UnfoldMoreHorizontalIcon.default = function(ce) {
  var ie = ce.fill, me = ie === void 0 ? "currentColor" : ie, we = ce.width, Re = we === void 0 ? DEFAULT_SIZE$1 : we, je = ce.height, Ue = je === void 0 ? DEFAULT_SIZE$1 : je, qe = ce.style, Ge = qe === void 0 ? {} : qe, Xe = _objectWithoutProperties$5(ce, ["fill", "width", "height", "style"]);
  return _react2$4.default.createElement(
    "svg",
    _extends$8({
      viewBox: "0 0 " + DEFAULT_SIZE$1 + " " + DEFAULT_SIZE$1,
      style: _extends$8({ fill: me, width: Re, height: Ue }, Ge)
    }, Xe),
    _react2$4.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, _createClass$k = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$k(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$6(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$6(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var ChromeFields = function(ce) {
  _inherits$6(ie, ce);
  function ie(me) {
    _classCallCheck$k(this, ie);
    var we = _possibleConstructorReturn$6(this, (ie.__proto__ || Object.getPrototypeOf(ie)).call(this));
    return we.toggleViews = function() {
      we.state.view === "hex" ? we.setState({ view: "rgb" }) : we.state.view === "rgb" ? we.setState({ view: "hsl" }) : we.state.view === "hsl" && (we.props.hsl.a === 1 ? we.setState({ view: "hex" }) : we.setState({ view: "rgb" }));
    }, we.handleChange = function(Re, je) {
      Re.hex ? isValidHex(Re.hex) && we.props.onChange({
        hex: Re.hex,
        source: "hex"
      }, je) : Re.r || Re.g || Re.b ? we.props.onChange({
        r: Re.r || we.props.rgb.r,
        g: Re.g || we.props.rgb.g,
        b: Re.b || we.props.rgb.b,
        source: "rgb"
      }, je) : Re.a ? (Re.a < 0 ? Re.a = 0 : Re.a > 1 && (Re.a = 1), we.props.onChange({
        h: we.props.hsl.h,
        s: we.props.hsl.s,
        l: we.props.hsl.l,
        a: Math.round(Re.a * 100) / 100,
        source: "rgb"
      }, je)) : (Re.h || Re.s || Re.l) && (typeof Re.s == "string" && Re.s.includes("%") && (Re.s = Re.s.replace("%", "")), typeof Re.l == "string" && Re.l.includes("%") && (Re.l = Re.l.replace("%", "")), Re.s == 1 ? Re.s = 0.01 : Re.l == 1 && (Re.l = 0.01), we.props.onChange({
        h: Re.h || we.props.hsl.h,
        s: Number(isUndefined(Re.s) ? we.props.hsl.s : Re.s),
        l: Number(isUndefined(Re.l) ? we.props.hsl.l : Re.l),
        source: "hsl"
      }, je));
    }, we.showHighlight = function(Re) {
      Re.currentTarget.style.background = "#eee";
    }, we.hideHighlight = function(Re) {
      Re.currentTarget.style.background = "transparent";
    }, me.hsl.a !== 1 && me.view === "hex" ? we.state = {
      view: "rgb"
    } : we.state = {
      view: me.view
    }, we;
  }
  return _createClass$k(ie, [{
    key: "render",
    value: function() {
      var we = this, Re = _default$3({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), je = void 0;
      return this.state.view === "hex" ? je = React__default.createElement(
        "div",
        { style: Re.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? je = React__default.createElement(
        "div",
        { style: Re.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.alpha },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (je = React__default.createElement(
        "div",
        { style: Re.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.field },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: Re.alpha },
          React__default.createElement(EditableInput, {
            style: { input: Re.input, label: Re.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), React__default.createElement(
        "div",
        { style: Re.wrap, className: "flexbox-fix" },
        je,
        React__default.createElement(
          "div",
          { style: Re.toggle },
          React__default.createElement(
            "div",
            { style: Re.icon, onClick: this.toggleViews, ref: function(qe) {
              return we.icon = qe;
            } },
            React__default.createElement(_default$2, {
              style: Re.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(we, Re) {
      return we.hsl.a !== 1 && Re.view === "hex" ? { view: "rgb" } : null;
    }
  }]), ie;
}(React__default.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function() {
  var ie = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: ie.picker });
}, ChromePointerCircle = function() {
  var ie = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return React__default.createElement("div", { style: ie.picker });
}, Chrome = function(ie) {
  var me = ie.width, we = ie.onChange, Re = ie.disableAlpha, je = ie.rgb, Ue = ie.hsl, qe = ie.hsv, Ge = ie.hex, Xe = ie.renderers, ot = ie.styles, vt = ot === void 0 ? {} : ot, bt = ie.className, Tt = bt === void 0 ? "" : bt, wt = ie.defaultView, St = _default$3(merge({
    default: {
      picker: {
        width: me,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + je.r + ", " + je.g + ", " + je.b + ", " + je.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, vt), { disableAlpha: Re });
  return React__default.createElement(
    "div",
    { style: St.picker, className: "chrome-picker " + Tt },
    React__default.createElement(
      "div",
      { style: St.saturation },
      React__default.createElement(Saturation, {
        style: St.Saturation,
        hsl: Ue,
        hsv: qe,
        pointer: ChromePointerCircle,
        onChange: we
      })
    ),
    React__default.createElement(
      "div",
      { style: St.body },
      React__default.createElement(
        "div",
        { style: St.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: St.color },
          React__default.createElement(
            "div",
            { style: St.swatch },
            React__default.createElement("div", { style: St.active }),
            React__default.createElement(Checkboard, { renderers: Xe })
          )
        ),
        React__default.createElement(
          "div",
          { style: St.toggles },
          React__default.createElement(
            "div",
            { style: St.hue },
            React__default.createElement(Hue, {
              style: St.Hue,
              hsl: Ue,
              pointer: ChromePointer,
              onChange: we
            })
          ),
          React__default.createElement(
            "div",
            { style: St.alpha },
            React__default.createElement(Alpha, {
              style: St.Alpha,
              rgb: je,
              hsl: Ue,
              pointer: ChromePointer,
              renderers: Xe,
              onChange: we
            })
          )
        )
      ),
      React__default.createElement(ChromeFields, {
        rgb: je,
        hsl: Ue,
        hex: Ge,
        view: wt,
        onChange: we,
        disableAlpha: Re
      })
    )
  );
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
ColorWrap(Chrome);
var CompactColor = function(ie) {
  var me = ie.color, we = ie.onClick, Re = we === void 0 ? function() {
  } : we, je = ie.onSwatchHover, Ue = ie.active, qe = _default$3({
    default: {
      color: {
        background: me,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(me),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: Ue, "color-#FFFFFF": me === "#FFFFFF", transparent: me === "transparent" });
  return React__default.createElement(
    Swatch$1,
    {
      style: qe.color,
      color: me,
      onClick: Re,
      onHover: je,
      focusStyle: { boxShadow: "0 0 4px " + me }
    },
    React__default.createElement("div", { style: qe.dot })
  );
}, CompactFields = function(ie) {
  var me = ie.hex, we = ie.rgb, Re = ie.onChange, je = _default$3({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: me
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), Ue = function(Ge, Xe) {
    Ge.r || Ge.g || Ge.b ? Re({
      r: Ge.r || we.r,
      g: Ge.g || we.g,
      b: Ge.b || we.b,
      source: "rgb"
    }, Xe) : Re({
      hex: Ge.hex,
      source: "hex"
    }, Xe);
  };
  return React__default.createElement(
    "div",
    { style: je.fields, className: "flexbox-fix" },
    React__default.createElement("div", { style: je.active }),
    React__default.createElement(EditableInput, {
      style: { wrap: je.HEXwrap, input: je.HEXinput, label: je.HEXlabel },
      label: "hex",
      value: me,
      onChange: Ue
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: je.RGBwrap, input: je.RGBinput, label: je.RGBlabel },
      label: "r",
      value: we.r,
      onChange: Ue
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: je.RGBwrap, input: je.RGBinput, label: je.RGBlabel },
      label: "g",
      value: we.g,
      onChange: Ue
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: je.RGBwrap, input: je.RGBinput, label: je.RGBlabel },
      label: "b",
      value: we.b,
      onChange: Ue
    })
  );
}, Compact = function(ie) {
  var me = ie.onChange, we = ie.onSwatchHover, Re = ie.colors, je = ie.hex, Ue = ie.rgb, qe = ie.styles, Ge = qe === void 0 ? {} : qe, Xe = ie.className, ot = Xe === void 0 ? "" : Xe, vt = _default$3(merge({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, Ge)), bt = function(wt, St) {
    wt.hex ? isValidHex(wt.hex) && me({
      hex: wt.hex,
      source: "hex"
    }, St) : me(wt, St);
  };
  return React__default.createElement(
    Raised,
    { style: vt.Compact, styles: Ge },
    React__default.createElement(
      "div",
      { style: vt.compact, className: "compact-picker " + ot },
      React__default.createElement(
        "div",
        null,
        map(Re, function(Tt) {
          return React__default.createElement(CompactColor, {
            key: Tt,
            color: Tt,
            active: Tt.toLowerCase() === je,
            onClick: bt,
            onSwatchHover: we
          });
        }),
        React__default.createElement("div", { style: vt.clear })
      ),
      React__default.createElement(CompactFields, { hex: je, rgb: Ue, onChange: bt })
    )
  );
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap(Compact);
var GithubSwatch = function(ie) {
  var me = ie.hover, we = ie.color, Re = ie.onClick, je = ie.onSwatchHover, Ue = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, qe = _default$3({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: Ue
    }
  }, { hover: me });
  return React__default.createElement(
    "div",
    { style: qe.swatch },
    React__default.createElement(Swatch$1, {
      color: we,
      onClick: Re,
      onHover: je,
      focusStyle: Ue
    })
  );
};
const GithubSwatch$1 = handleHover(GithubSwatch);
var Github = function(ie) {
  var me = ie.width, we = ie.colors, Re = ie.onChange, je = ie.onSwatchHover, Ue = ie.triangle, qe = ie.styles, Ge = qe === void 0 ? {} : qe, Xe = ie.className, ot = Xe === void 0 ? "" : Xe, vt = _default$3(merge({
    default: {
      card: {
        width: me,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, Ge), {
    "hide-triangle": Ue === "hide",
    "top-left-triangle": Ue === "top-left",
    "top-right-triangle": Ue === "top-right",
    "bottom-left-triangle": Ue === "bottom-left",
    "bottom-right-triangle": Ue === "bottom-right"
  }), bt = function(wt, St) {
    return Re({ hex: wt, source: "hex" }, St);
  };
  return React__default.createElement(
    "div",
    { style: vt.card, className: "github-picker " + ot },
    React__default.createElement("div", { style: vt.triangleShadow }),
    React__default.createElement("div", { style: vt.triangle }),
    map(we, function(Tt) {
      return React__default.createElement(GithubSwatch$1, {
        color: Tt,
        key: Tt,
        onClick: bt,
        onSwatchHover: je
      });
    })
  );
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Github);
var SliderPointer$1 = function(ie) {
  var me = ie.direction, we = _default$3({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: me === "vertical" });
  return React__default.createElement("div", { style: we.picker });
}, _extends$7 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, HuePicker = function(ie) {
  var me = ie.width, we = ie.height, Re = ie.onChange, je = ie.hsl, Ue = ie.direction, qe = ie.pointer, Ge = ie.styles, Xe = Ge === void 0 ? {} : Ge, ot = ie.className, vt = ot === void 0 ? "" : ot, bt = _default$3(merge({
    default: {
      picker: {
        position: "relative",
        width: me,
        height: we
      },
      hue: {
        radius: "2px"
      }
    }
  }, Xe)), Tt = function(St) {
    return Re({ a: 1, h: St.h, l: 0.5, s: 1 });
  };
  return React__default.createElement(
    "div",
    { style: bt.picker, className: "hue-picker " + vt },
    React__default.createElement(Hue, _extends$7({}, bt.hue, {
      hsl: je,
      pointer: qe,
      onChange: Tt,
      direction: Ue
    }))
  );
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);
var Material = function(ie) {
  var me = ie.onChange, we = ie.hex, Re = ie.rgb, je = ie.styles, Ue = je === void 0 ? {} : je, qe = ie.className, Ge = qe === void 0 ? "" : qe, Xe = _default$3(merge({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + we,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, Ue)), ot = function(bt, Tt) {
    bt.hex ? isValidHex(bt.hex) && me({
      hex: bt.hex,
      source: "hex"
    }, Tt) : (bt.r || bt.g || bt.b) && me({
      r: bt.r || Re.r,
      g: bt.g || Re.g,
      b: bt.b || Re.b,
      source: "rgb"
    }, Tt);
  };
  return React__default.createElement(
    Raised,
    { styles: Ue },
    React__default.createElement(
      "div",
      { style: Xe.material, className: "material-picker " + Ge },
      React__default.createElement(EditableInput, {
        style: { wrap: Xe.HEXwrap, input: Xe.HEXinput, label: Xe.HEXlabel },
        label: "hex",
        value: we,
        onChange: ot
      }),
      React__default.createElement(
        "div",
        { style: Xe.split, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: Xe.third },
          React__default.createElement(EditableInput, {
            style: { wrap: Xe.RGBwrap, input: Xe.RGBinput, label: Xe.RGBlabel },
            label: "r",
            value: Re.r,
            onChange: ot
          })
        ),
        React__default.createElement(
          "div",
          { style: Xe.third },
          React__default.createElement(EditableInput, {
            style: { wrap: Xe.RGBwrap, input: Xe.RGBinput, label: Xe.RGBlabel },
            label: "g",
            value: Re.g,
            onChange: ot
          })
        ),
        React__default.createElement(
          "div",
          { style: Xe.third },
          React__default.createElement(EditableInput, {
            style: { wrap: Xe.RGBwrap, input: Xe.RGBinput, label: Xe.RGBlabel },
            label: "b",
            value: Re.b,
            onChange: ot
          })
        )
      )
    )
  );
};
ColorWrap(Material);
var PhotoshopPicker = function(ie) {
  var me = ie.onChange, we = ie.rgb, Re = ie.hsv, je = ie.hex, Ue = _default$3({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), qe = function(Xe, ot) {
    Xe["#"] ? isValidHex(Xe["#"]) && me({
      hex: Xe["#"],
      source: "hex"
    }, ot) : Xe.r || Xe.g || Xe.b ? me({
      r: Xe.r || we.r,
      g: Xe.g || we.g,
      b: Xe.b || we.b,
      source: "rgb"
    }, ot) : (Xe.h || Xe.s || Xe.v) && me({
      h: Xe.h || Re.h,
      s: Xe.s || Re.s,
      v: Xe.v || Re.v,
      source: "hsv"
    }, ot);
  };
  return React__default.createElement(
    "div",
    { style: Ue.fields },
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "h",
      value: Math.round(Re.h),
      onChange: qe
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "s",
      value: Math.round(Re.s * 100),
      onChange: qe
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "v",
      value: Math.round(Re.v * 100),
      onChange: qe
    }),
    React__default.createElement("div", { style: Ue.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "r",
      value: we.r,
      onChange: qe
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "g",
      value: we.g,
      onChange: qe
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.RGBwrap, input: Ue.RGBinput, label: Ue.RGBlabel },
      label: "b",
      value: we.b,
      onChange: qe
    }),
    React__default.createElement("div", { style: Ue.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: Ue.HEXwrap, input: Ue.HEXinput, label: Ue.HEXlabel },
      label: "#",
      value: je.replace("#", ""),
      onChange: qe
    }),
    React__default.createElement(
      "div",
      { style: Ue.fieldSymbols },
      React__default.createElement(
        "div",
        { style: Ue.symbol },
        "°"
      ),
      React__default.createElement(
        "div",
        { style: Ue.symbol },
        "%"
      ),
      React__default.createElement(
        "div",
        { style: Ue.symbol },
        "%"
      )
    )
  );
}, PhotoshopPointerCircle$1 = function(ie) {
  var me = ie.hsl, we = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": me.l > 0.5 });
  return React__default.createElement("div", { style: we.picker });
}, PhotoshopPointerCircle = function() {
  var ie = _default$3({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: ie.pointer },
    React__default.createElement(
      "div",
      { style: ie.left },
      React__default.createElement("div", { style: ie.leftInside })
    ),
    React__default.createElement(
      "div",
      { style: ie.right },
      React__default.createElement("div", { style: ie.rightInside })
    )
  );
}, PhotoshopButton = function(ie) {
  var me = ie.onClick, we = ie.label, Re = ie.children, je = ie.active, Ue = _default$3({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: je });
  return React__default.createElement(
    "div",
    { style: Ue.button, onClick: me },
    we || Re
  );
}, PhotoshopPreviews = function(ie) {
  var me = ie.rgb, we = ie.currentColor, Re = _default$3({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + me.r + "," + me.g + ", " + me.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: we,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      "div",
      { style: Re.label },
      "new"
    ),
    React__default.createElement(
      "div",
      { style: Re.swatches },
      React__default.createElement("div", { style: Re.new }),
      React__default.createElement("div", { style: Re.current })
    ),
    React__default.createElement(
      "div",
      { style: Re.label },
      "current"
    )
  );
}, _createClass$j = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}();
function _classCallCheck$j(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$5(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$5(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var Photoshop = function(ce) {
  _inherits$5(ie, ce);
  function ie(me) {
    _classCallCheck$j(this, ie);
    var we = _possibleConstructorReturn$5(this, (ie.__proto__ || Object.getPrototypeOf(ie)).call(this));
    return we.state = {
      currentColor: me.hex
    }, we;
  }
  return _createClass$j(ie, [{
    key: "render",
    value: function() {
      var we = this.props, Re = we.styles, je = Re === void 0 ? {} : Re, Ue = we.className, qe = Ue === void 0 ? "" : Ue, Ge = _default$3(merge({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, je));
      return React__default.createElement(
        "div",
        { style: Ge.picker, className: "photoshop-picker " + qe },
        React__default.createElement(
          "div",
          { style: Ge.head },
          this.props.header
        ),
        React__default.createElement(
          "div",
          { style: Ge.body, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: Ge.saturation },
            React__default.createElement(Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle$1,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: Ge.hue },
            React__default.createElement(Hue, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: Ge.controls },
            React__default.createElement(
              "div",
              { style: Ge.top, className: "flexbox-fix" },
              React__default.createElement(
                "div",
                { style: Ge.previews },
                React__default.createElement(PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              React__default.createElement(
                "div",
                { style: Ge.actions },
                React__default.createElement(PhotoshopButton, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                React__default.createElement(PhotoshopButton, { label: "Cancel", onClick: this.props.onCancel }),
                React__default.createElement(PhotoshopPicker, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), ie;
}(React__default.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap(Photoshop);
var SketchFields = function(ie) {
  var me = ie.onChange, we = ie.rgb, Re = ie.hsl, je = ie.hex, Ue = ie.disableAlpha, qe = _default$3({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: Ue }), Ge = function(ot, vt) {
    ot.hex ? isValidHex(ot.hex) && me({
      hex: ot.hex,
      source: "hex"
    }, vt) : ot.r || ot.g || ot.b ? me({
      r: ot.r || we.r,
      g: ot.g || we.g,
      b: ot.b || we.b,
      a: we.a,
      source: "rgb"
    }, vt) : ot.a && (ot.a < 0 ? ot.a = 0 : ot.a > 100 && (ot.a = 100), ot.a /= 100, me({
      h: Re.h,
      s: Re.s,
      l: Re.l,
      a: ot.a,
      source: "rgb"
    }, vt));
  };
  return React__default.createElement(
    "div",
    { style: qe.fields, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: qe.double },
      React__default.createElement(EditableInput, {
        style: { input: qe.input, label: qe.label },
        label: "hex",
        value: je.replace("#", ""),
        onChange: Ge
      })
    ),
    React__default.createElement(
      "div",
      { style: qe.single },
      React__default.createElement(EditableInput, {
        style: { input: qe.input, label: qe.label },
        label: "r",
        value: we.r,
        onChange: Ge,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: qe.single },
      React__default.createElement(EditableInput, {
        style: { input: qe.input, label: qe.label },
        label: "g",
        value: we.g,
        onChange: Ge,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: qe.single },
      React__default.createElement(EditableInput, {
        style: { input: qe.input, label: qe.label },
        label: "b",
        value: we.b,
        onChange: Ge,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: qe.alpha },
      React__default.createElement(EditableInput, {
        style: { input: qe.input, label: qe.label },
        label: "a",
        value: Math.round(we.a * 100),
        onChange: Ge,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, _extends$6 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, SketchPresetColors = function(ie) {
  var me = ie.colors, we = ie.onClick, Re = we === void 0 ? function() {
  } : we, je = ie.onSwatchHover, Ue = _default$3({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !me || !me.length
  }), qe = function(Xe, ot) {
    Re({
      hex: Xe,
      source: "hex"
    }, ot);
  };
  return React__default.createElement(
    "div",
    { style: Ue.colors, className: "flexbox-fix" },
    me.map(function(Ge) {
      var Xe = typeof Ge == "string" ? { color: Ge } : Ge, ot = "" + Xe.color + (Xe.title || "");
      return React__default.createElement(
        "div",
        { key: ot, style: Ue.swatchWrap },
        React__default.createElement(Swatch$1, _extends$6({}, Xe, {
          style: Ue.swatch,
          onClick: qe,
          onHover: je,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + Xe.color
          }
        }))
      );
    })
  );
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};
var _extends$5 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, Sketch = function(ie) {
  var me = ie.width, we = ie.rgb, Re = ie.hex, je = ie.hsv, Ue = ie.hsl, qe = ie.onChange, Ge = ie.onSwatchHover, Xe = ie.disableAlpha, ot = ie.presetColors, vt = ie.renderers, bt = ie.styles, Tt = bt === void 0 ? {} : bt, wt = ie.className, St = wt === void 0 ? "" : wt, It = _default$3(merge({
    default: _extends$5({
      picker: {
        width: me,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + we.r + "," + we.g + "," + we.b + "," + we.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, Tt),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, Tt), { disableAlpha: Xe });
  return React__default.createElement(
    "div",
    { style: It.picker, className: "sketch-picker " + St },
    React__default.createElement(
      "div",
      { style: It.saturation },
      React__default.createElement(Saturation, {
        style: It.Saturation,
        hsl: Ue,
        hsv: je,
        onChange: qe
      })
    ),
    React__default.createElement(
      "div",
      { style: It.controls, className: "flexbox-fix" },
      React__default.createElement(
        "div",
        { style: It.sliders },
        React__default.createElement(
          "div",
          { style: It.hue },
          React__default.createElement(Hue, {
            style: It.Hue,
            hsl: Ue,
            onChange: qe
          })
        ),
        React__default.createElement(
          "div",
          { style: It.alpha },
          React__default.createElement(Alpha, {
            style: It.Alpha,
            rgb: we,
            hsl: Ue,
            renderers: vt,
            onChange: qe
          })
        )
      ),
      React__default.createElement(
        "div",
        { style: It.color },
        React__default.createElement(Checkboard, null),
        React__default.createElement("div", { style: It.activeColor })
      )
    ),
    React__default.createElement(SketchFields, {
      rgb: we,
      hsl: Ue,
      hex: Re,
      onChange: qe,
      disableAlpha: Xe
    }),
    React__default.createElement(SketchPresetColors, {
      colors: ot,
      onClick: qe,
      onSwatchHover: Ge
    })
  );
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const SketchPicker = ColorWrap(Sketch);
var SliderSwatch = function(ie) {
  var me = ie.hsl, we = ie.offset, Re = ie.onClick, je = Re === void 0 ? function() {
  } : Re, Ue = ie.active, qe = ie.first, Ge = ie.last, Xe = _default$3({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + me.h + ", 50%, " + we * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: Ue, first: qe, last: Ge }), ot = function(bt) {
    return je({
      h: me.h,
      s: 0.5,
      l: we,
      source: "hsl"
    }, bt);
  };
  return React__default.createElement("div", { style: Xe.swatch, onClick: ot });
}, SliderSwatches = function(ie) {
  var me = ie.onClick, we = ie.hsl, Re = _default$3({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), je = 0.1;
  return React__default.createElement(
    "div",
    { style: Re.swatches },
    React__default.createElement(
      "div",
      { style: Re.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: we,
        offset: ".80",
        active: Math.abs(we.l - 0.8) < je && Math.abs(we.s - 0.5) < je,
        onClick: me,
        first: !0
      })
    ),
    React__default.createElement(
      "div",
      { style: Re.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: we,
        offset: ".65",
        active: Math.abs(we.l - 0.65) < je && Math.abs(we.s - 0.5) < je,
        onClick: me
      })
    ),
    React__default.createElement(
      "div",
      { style: Re.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: we,
        offset: ".50",
        active: Math.abs(we.l - 0.5) < je && Math.abs(we.s - 0.5) < je,
        onClick: me
      })
    ),
    React__default.createElement(
      "div",
      { style: Re.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: we,
        offset: ".35",
        active: Math.abs(we.l - 0.35) < je && Math.abs(we.s - 0.5) < je,
        onClick: me
      })
    ),
    React__default.createElement(
      "div",
      { style: Re.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: we,
        offset: ".20",
        active: Math.abs(we.l - 0.2) < je && Math.abs(we.s - 0.5) < je,
        onClick: me,
        last: !0
      })
    ),
    React__default.createElement("div", { style: Re.clear })
  );
}, SliderPointer = function() {
  var ie = _default$3({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: ie.picker });
}, Slider$2 = function(ie) {
  var me = ie.hsl, we = ie.onChange, Re = ie.pointer, je = ie.styles, Ue = je === void 0 ? {} : je, qe = ie.className, Ge = qe === void 0 ? "" : qe, Xe = _default$3(merge({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, Ue));
  return React__default.createElement(
    "div",
    { style: Xe.wrap || {}, className: "slider-picker " + Ge },
    React__default.createElement(
      "div",
      { style: Xe.hue },
      React__default.createElement(Hue, {
        style: Xe.Hue,
        hsl: me,
        pointer: Re,
        onChange: we
      })
    ),
    React__default.createElement(
      "div",
      { style: Xe.swatches },
      React__default.createElement(SliderSwatches, { hsl: me, onClick: we })
    )
  );
};
Slider$2.propTypes = {
  styles: PropTypes.object
};
Slider$2.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap(Slider$2);
var CheckIcon = {};
Object.defineProperty(CheckIcon, "__esModule", {
  value: !0
});
var _extends$4 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _react$8 = React__default, _react2$3 = _interopRequireDefault$8(_react$8);
function _interopRequireDefault$8(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _objectWithoutProperties$4(ce, ie) {
  var me = {};
  for (var we in ce)
    ie.indexOf(we) >= 0 || Object.prototype.hasOwnProperty.call(ce, we) && (me[we] = ce[we]);
  return me;
}
var DEFAULT_SIZE = 24, _default$1 = CheckIcon.default = function(ce) {
  var ie = ce.fill, me = ie === void 0 ? "currentColor" : ie, we = ce.width, Re = we === void 0 ? DEFAULT_SIZE : we, je = ce.height, Ue = je === void 0 ? DEFAULT_SIZE : je, qe = ce.style, Ge = qe === void 0 ? {} : qe, Xe = _objectWithoutProperties$4(ce, ["fill", "width", "height", "style"]);
  return _react2$3.default.createElement(
    "svg",
    _extends$4({
      viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
      style: _extends$4({ fill: me, width: Re, height: Ue }, Ge)
    }, Xe),
    _react2$3.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, SwatchesColor = function(ie) {
  var me = ie.color, we = ie.onClick, Re = we === void 0 ? function() {
  } : we, je = ie.onSwatchHover, Ue = ie.first, qe = ie.last, Ge = ie.active, Xe = _default$3({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: me,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(me),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: Ue,
    last: qe,
    active: Ge,
    "color-#FFFFFF": me === "#FFFFFF",
    transparent: me === "transparent"
  });
  return React__default.createElement(
    Swatch$1,
    {
      color: me,
      style: Xe.color,
      onClick: Re,
      onHover: je,
      focusStyle: { boxShadow: "0 0 4px " + me }
    },
    React__default.createElement(
      "div",
      { style: Xe.check },
      React__default.createElement(_default$1, null)
    )
  );
}, SwatchesGroup = function(ie) {
  var me = ie.onClick, we = ie.onSwatchHover, Re = ie.group, je = ie.active, Ue = _default$3({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: Ue.group },
    map(Re, function(qe, Ge) {
      return React__default.createElement(SwatchesColor, {
        key: qe,
        color: qe,
        active: qe.toLowerCase() === je,
        first: Ge === 0,
        last: Ge === Re.length - 1,
        onClick: me,
        onSwatchHover: we
      });
    })
  );
}, Swatches = function(ie) {
  var me = ie.width, we = ie.height, Re = ie.onChange, je = ie.onSwatchHover, Ue = ie.colors, qe = ie.hex, Ge = ie.styles, Xe = Ge === void 0 ? {} : Ge, ot = ie.className, vt = ot === void 0 ? "" : ot, bt = _default$3(merge({
    default: {
      picker: {
        width: me,
        height: we
      },
      overflow: {
        height: we,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, Xe)), Tt = function(St, It) {
    return Re({ hex: St, source: "hex" }, It);
  };
  return React__default.createElement(
    "div",
    { style: bt.picker, className: "swatches-picker " + vt },
    React__default.createElement(
      Raised,
      null,
      React__default.createElement(
        "div",
        { style: bt.overflow },
        React__default.createElement(
          "div",
          { style: bt.body },
          map(Ue, function(wt) {
            return React__default.createElement(SwatchesGroup, {
              key: wt.toString(),
              group: wt,
              active: qe,
              onClick: Tt,
              onSwatchHover: je
            });
          }),
          React__default.createElement("div", { style: bt.clear })
        )
      )
    )
  );
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red[900], red[700], red[500], red[300], red[100]], [pink[900], pink[700], pink[500], pink[300], pink[100]], [purple[900], purple[700], purple[500], purple[300], purple[100]], [deepPurple[900], deepPurple[700], deepPurple[500], deepPurple[300], deepPurple[100]], [indigo[900], indigo[700], indigo[500], indigo[300], indigo[100]], [blue[900], blue[700], blue[500], blue[300], blue[100]], [lightBlue[900], lightBlue[700], lightBlue[500], lightBlue[300], lightBlue[100]], [cyan[900], cyan[700], cyan[500], cyan[300], cyan[100]], [teal[900], teal[700], teal[500], teal[300], teal[100]], ["#194D33", green[700], green[500], green[300], green[100]], [lightGreen[900], lightGreen[700], lightGreen[500], lightGreen[300], lightGreen[100]], [lime[900], lime[700], lime[500], lime[300], lime[100]], [yellow[900], yellow[700], yellow[500], yellow[300], yellow[100]], [amber[900], amber[700], amber[500], amber[300], amber[100]], [orange[900], orange[700], orange[500], orange[300], orange[100]], [deepOrange[900], deepOrange[700], deepOrange[500], deepOrange[300], deepOrange[100]], [brown[900], brown[700], brown[500], brown[300], brown[100]], [blueGrey[900], blueGrey[700], blueGrey[500], blueGrey[300], blueGrey[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap(Swatches);
var Twitter = function(ie) {
  var me = ie.onChange, we = ie.onSwatchHover, Re = ie.hex, je = ie.colors, Ue = ie.width, qe = ie.triangle, Ge = ie.styles, Xe = Ge === void 0 ? {} : Ge, ot = ie.className, vt = ot === void 0 ? "" : ot, bt = _default$3(merge({
    default: {
      card: {
        width: Ue,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, Xe), {
    "hide-triangle": qe === "hide",
    "top-left-triangle": qe === "top-left",
    "top-right-triangle": qe === "top-right"
  }), Tt = function(St, It) {
    isValidHex(St) && me({
      hex: St,
      source: "hex"
    }, It);
  };
  return React__default.createElement(
    "div",
    { style: bt.card, className: "twitter-picker " + vt },
    React__default.createElement("div", { style: bt.triangleShadow }),
    React__default.createElement("div", { style: bt.triangle }),
    React__default.createElement(
      "div",
      { style: bt.body },
      map(je, function(wt, St) {
        return React__default.createElement(Swatch$1, {
          key: St,
          color: wt,
          hex: wt,
          style: bt.swatch,
          onClick: Tt,
          onHover: we,
          focusStyle: {
            boxShadow: "0 0 4px " + wt
          }
        });
      }),
      React__default.createElement(
        "div",
        { style: bt.hash },
        "#"
      ),
      React__default.createElement(EditableInput, {
        label: null,
        style: { input: bt.input },
        value: Re.replace("#", ""),
        onChange: Tt
      }),
      React__default.createElement("div", { style: bt.clear })
    )
  );
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right"]),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Twitter);
var GooglePointerCircle = function(ie) {
  var me = _default$3({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(ie.hsl.h) + ", " + Math.round(ie.hsl.s * 100) + "%, " + Math.round(ie.hsl.l * 100) + "%)"
      }
    }
  });
  return React__default.createElement("div", { style: me.picker });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GooglePointer = function(ie) {
  var me = _default$3({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(ie.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return React__default.createElement("div", { style: me.picker });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GoogleFields = function(ie) {
  var me = ie.onChange, we = ie.rgb, Re = ie.hsl, je = ie.hex, Ue = ie.hsv, qe = function(Tt, wt) {
    if (Tt.hex)
      isValidHex(Tt.hex) && me({
        hex: Tt.hex,
        source: "hex"
      }, wt);
    else if (Tt.rgb) {
      var St = Tt.rgb.split(",");
      isvalidColorString(Tt.rgb, "rgb") && me({
        r: St[0],
        g: St[1],
        b: St[2],
        a: 1,
        source: "rgb"
      }, wt);
    } else if (Tt.hsv) {
      var It = Tt.hsv.split(",");
      isvalidColorString(Tt.hsv, "hsv") && (It[2] = It[2].replace("%", ""), It[1] = It[1].replace("%", ""), It[0] = It[0].replace("°", ""), It[1] == 1 ? It[1] = 0.01 : It[2] == 1 && (It[2] = 0.01), me({
        h: Number(It[0]),
        s: Number(It[1]),
        v: Number(It[2]),
        source: "hsv"
      }, wt));
    } else if (Tt.hsl) {
      var Pt = Tt.hsl.split(",");
      isvalidColorString(Tt.hsl, "hsl") && (Pt[2] = Pt[2].replace("%", ""), Pt[1] = Pt[1].replace("%", ""), Pt[0] = Pt[0].replace("°", ""), vt[1] == 1 ? vt[1] = 0.01 : vt[2] == 1 && (vt[2] = 0.01), me({
        h: Number(Pt[0]),
        s: Number(Pt[1]),
        v: Number(Pt[2]),
        source: "hsl"
      }, wt));
    }
  }, Ge = _default$3({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), Xe = we.r + ", " + we.g + ", " + we.b, ot = Math.round(Re.h) + "°, " + Math.round(Re.s * 100) + "%, " + Math.round(Re.l * 100) + "%", vt = Math.round(Ue.h) + "°, " + Math.round(Ue.s * 100) + "%, " + Math.round(Ue.v * 100) + "%";
  return React__default.createElement(
    "div",
    { style: Ge.wrap, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: Ge.fields },
      React__default.createElement(
        "div",
        { style: Ge.double },
        React__default.createElement(EditableInput, {
          style: { input: Ge.input, label: Ge.label },
          label: "hex",
          value: je,
          onChange: qe
        })
      ),
      React__default.createElement(
        "div",
        { style: Ge.column },
        React__default.createElement(
          "div",
          { style: Ge.single },
          React__default.createElement(EditableInput, {
            style: { input: Ge.input2, label: Ge.label2 },
            label: "rgb",
            value: Xe,
            onChange: qe
          })
        ),
        React__default.createElement(
          "div",
          { style: Ge.single },
          React__default.createElement(EditableInput, {
            style: { input: Ge.input2, label: Ge.label2 },
            label: "hsv",
            value: vt,
            onChange: qe
          })
        ),
        React__default.createElement(
          "div",
          { style: Ge.single },
          React__default.createElement(EditableInput, {
            style: { input: Ge.input2, label: Ge.label2 },
            label: "hsl",
            value: ot,
            onChange: qe
          })
        )
      )
    )
  );
}, Google = function(ie) {
  var me = ie.width, we = ie.onChange, Re = ie.rgb, je = ie.hsl, Ue = ie.hsv, qe = ie.hex, Ge = ie.header, Xe = ie.styles, ot = Xe === void 0 ? {} : Xe, vt = ie.className, bt = vt === void 0 ? "" : vt, Tt = _default$3(merge({
    default: {
      picker: {
        width: me,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + Re.r + ", " + Re.g + ", " + Re.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, ot));
  return React__default.createElement(
    "div",
    { style: Tt.picker, className: "google-picker " + bt },
    React__default.createElement(
      "div",
      { style: Tt.head },
      Ge
    ),
    React__default.createElement("div", { style: Tt.swatch }),
    React__default.createElement(
      "div",
      { style: Tt.saturation },
      React__default.createElement(Saturation, {
        hsl: je,
        hsv: Ue,
        pointer: GooglePointerCircle,
        onChange: we
      })
    ),
    React__default.createElement(
      "div",
      { style: Tt.body },
      React__default.createElement(
        "div",
        { style: Tt.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: Tt.hue },
          React__default.createElement(Hue, {
            style: Tt.Hue,
            hsl: je,
            radius: "4px",
            pointer: GooglePointer,
            onChange: we
          })
        )
      ),
      React__default.createElement(GoogleFields, {
        rgb: Re,
        hsl: je,
        hex: qe,
        hsv: Ue,
        onChange: we
      })
    )
  );
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap(Google);
const useOnMount = (ce) => {
  const ie = useRef(), me = useRef(!1), we = useRef(!1), [, Re] = useState(0);
  me.current && (we.current = !0), useEffect(() => (me.current || (ie.current = ce(), me.current = !0), Re((je) => je + 1), () => {
    we.current && ie.current && ie.current();
  }), []);
}, useClickOut = (ce, ie, me) => {
  const [we, Re] = React__default.useState(ce), je = React__default.useRef(!1), Ue = React__default.useRef(!0);
  return useOnMount(() => (Ue.current = !0, () => {
    Ue.current = !1;
  })), useEffect(() => {
    const qe = (Xe) => {
      var ot;
      je.current = !!((ot = ie.current) != null && ot.contains(Xe.target));
    }, Ge = (Xe) => {
      we && ie.current && !ie.current.contains(Xe.target) && !je.current && Ue.current && (Re(!1), me == null || me());
    };
    return document.addEventListener("mousedown", qe), document.addEventListener("mouseup", Ge), document.addEventListener("touchend", Ge), () => {
      document.removeEventListener("mousedown", qe), document.removeEventListener("mouseup", Ge), document.removeEventListener("touchend", Ge);
    };
  }, [we, ie, me]), { isOpen: we, setIsOpen: Re };
}, VariantToClassname = {
  bottomLeft: "top-40px left--113px",
  bottomRight: "top-40px left-0",
  left: "left--220px top-0",
  right: "left-108px top-0"
}, ColorPicker = ({
  label: ce = "",
  color: ie,
  resetColorTo: me,
  dialogPosition: we = "bottomRight",
  onChange: Re
}) => {
  const je = useRef(null), { isOpen: Ue, setIsOpen: qe } = useClickOut(!1, je), Ge = useCallback(() => {
    qe((bt) => !bt);
  }, [qe]), Xe = useCallback(
    ({ hex: bt }) => {
      Re(bt.toUpperCase());
    },
    [Re]
  ), ot = useCallback(() => {
    Re(me);
  }, [me, Re]), vt = useCallback(
    (bt) => {
      bt.key === "Enter" && qe(!1);
    },
    [qe]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: je, className: "w-full", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "color-picker gap-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: classNames("color-picker__input", {
          "color-picker__input--active": Ue
        }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-picker__indicator", onClick: Ge, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-picker__indicator__picked", style: { backgroundColor: ie } }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-picker__label", onClick: Ge, children: ce || ie || "None" })
        ]
      }
    ),
    ie !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "color-picker__reset-button", onClick: ot, children: "Reset" }),
    Ue && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: classNames("absolute z-9999", VariantToClassname[we]),
        onKeyDown: vt,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SketchPicker, { color: ie, disableAlpha: !0, onChange: Xe })
      }
    )
  ] }) });
};
var Vn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jr(ce) {
  return ce && ce.__esModule && Object.prototype.hasOwnProperty.call(ce, "default") ? ce.default : ce;
}
function Ng(ce) {
  if (ce.__esModule) return ce;
  var ie = ce.default;
  if (typeof ie == "function") {
    var me = function we() {
      return this instanceof we ? Reflect.construct(ie, arguments, this.constructor) : ie.apply(this, arguments);
    };
    me.prototype = ie.prototype;
  } else me = {};
  return Object.defineProperty(me, "__esModule", { value: !0 }), Object.keys(ce).forEach(function(we) {
    var Re = Object.getOwnPropertyDescriptor(ce, we);
    Object.defineProperty(me, we, Re.get ? Re : {
      enumerable: !0,
      get: function() {
        return ce[we];
      }
    });
  }), me;
}
var No = { exports: {} }, dr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jl;
function Bg() {
  if (Jl) return dr;
  Jl = 1;
  var ce = React__default, ie = Symbol.for("react.element"), me = Symbol.for("react.fragment"), we = Object.prototype.hasOwnProperty, Re = ce.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, je = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Ue(qe, Ge, Xe) {
    var ot, vt = {}, bt = null, Tt = null;
    Xe !== void 0 && (bt = "" + Xe), Ge.key !== void 0 && (bt = "" + Ge.key), Ge.ref !== void 0 && (Tt = Ge.ref);
    for (ot in Ge) we.call(Ge, ot) && !je.hasOwnProperty(ot) && (vt[ot] = Ge[ot]);
    if (qe && qe.defaultProps) for (ot in Ge = qe.defaultProps, Ge) vt[ot] === void 0 && (vt[ot] = Ge[ot]);
    return { $$typeof: ie, type: qe, key: bt, ref: Tt, props: vt, _owner: Re.current };
  }
  return dr.Fragment = me, dr.jsx = Ue, dr.jsxs = Ue, dr;
}
var hr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zl;
function Fg() {
  return Zl || (Zl = 1, process.env.NODE_ENV !== "production" && function() {
    var ce = React__default, ie = Symbol.for("react.element"), me = Symbol.for("react.portal"), we = Symbol.for("react.fragment"), Re = Symbol.for("react.strict_mode"), je = Symbol.for("react.profiler"), Ue = Symbol.for("react.provider"), qe = Symbol.for("react.context"), Ge = Symbol.for("react.forward_ref"), Xe = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), vt = Symbol.for("react.memo"), bt = Symbol.for("react.lazy"), Tt = Symbol.for("react.offscreen"), wt = Symbol.iterator, St = "@@iterator";
    function It(mn) {
      if (mn === null || typeof mn != "object")
        return null;
      var ai = wt && mn[wt] || mn[St];
      return typeof ai == "function" ? ai : null;
    }
    var Pt = ce.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function kt(mn) {
      {
        for (var ai = arguments.length, $i = new Array(ai > 1 ? ai - 1 : 0), Ha = 1; Ha < ai; Ha++)
          $i[Ha - 1] = arguments[Ha];
        Ot("error", mn, $i);
      }
    }
    function Ot(mn, ai, $i) {
      {
        var Ha = Pt.ReactDebugCurrentFrame, Va = Ha.getStackAddendum();
        Va !== "" && (ai += "%s", $i = $i.concat([Va]));
        var Us = $i.map(function($s) {
          return String($s);
        });
        Us.unshift("Warning: " + ai), Function.prototype.apply.call(console[mn], console, Us);
      }
    }
    var Jr = !1, en = !1, nn = !1, ln = !1, fn = !1, vn;
    vn = Symbol.for("react.module.reference");
    function Tn(mn) {
      return !!(typeof mn == "string" || typeof mn == "function" || mn === we || mn === je || fn || mn === Re || mn === Xe || mn === ot || ln || mn === Tt || Jr || en || nn || typeof mn == "object" && mn !== null && (mn.$$typeof === bt || mn.$$typeof === vt || mn.$$typeof === Ue || mn.$$typeof === qe || mn.$$typeof === Ge || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      mn.$$typeof === vn || mn.getModuleId !== void 0));
    }
    function xn(mn, ai, $i) {
      var Ha = mn.displayName;
      if (Ha)
        return Ha;
      var Va = ai.displayName || ai.name || "";
      return Va !== "" ? $i + "(" + Va + ")" : $i;
    }
    function bn(mn) {
      return mn.displayName || "Context";
    }
    function Sn(mn) {
      if (mn == null)
        return null;
      if (typeof mn.tag == "number" && kt("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof mn == "function")
        return mn.displayName || mn.name || null;
      if (typeof mn == "string")
        return mn;
      switch (mn) {
        case we:
          return "Fragment";
        case me:
          return "Portal";
        case je:
          return "Profiler";
        case Re:
          return "StrictMode";
        case Xe:
          return "Suspense";
        case ot:
          return "SuspenseList";
      }
      if (typeof mn == "object")
        switch (mn.$$typeof) {
          case qe:
            var ai = mn;
            return bn(ai) + ".Consumer";
          case Ue:
            var $i = mn;
            return bn($i._context) + ".Provider";
          case Ge:
            return xn(mn, mn.render, "ForwardRef");
          case vt:
            var Ha = mn.displayName || null;
            return Ha !== null ? Ha : Sn(mn.type) || "Memo";
          case bt: {
            var Va = mn, Us = Va._payload, $s = Va._init;
            try {
              return Sn($s(Us));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Cn = Object.assign, kn = 0, cn, gn, an, un, pn, hn, An;
    function In() {
    }
    In.__reactDisabledLog = !0;
    function qn() {
      {
        if (kn === 0) {
          cn = console.log, gn = console.info, an = console.warn, un = console.error, pn = console.group, hn = console.groupCollapsed, An = console.groupEnd;
          var mn = {
            configurable: !0,
            enumerable: !0,
            value: In,
            writable: !0
          };
          Object.defineProperties(console, {
            info: mn,
            log: mn,
            warn: mn,
            error: mn,
            group: mn,
            groupCollapsed: mn,
            groupEnd: mn
          });
        }
        kn++;
      }
    }
    function si() {
      {
        if (kn--, kn === 0) {
          var mn = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Cn({}, mn, {
              value: cn
            }),
            info: Cn({}, mn, {
              value: gn
            }),
            warn: Cn({}, mn, {
              value: an
            }),
            error: Cn({}, mn, {
              value: un
            }),
            group: Cn({}, mn, {
              value: pn
            }),
            groupCollapsed: Cn({}, mn, {
              value: hn
            }),
            groupEnd: Cn({}, mn, {
              value: An
            })
          });
        }
        kn < 0 && kt("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var bi = Pt.ReactCurrentDispatcher, xi;
    function ji(mn, ai, $i) {
      {
        if (xi === void 0)
          try {
            throw Error();
          } catch (Va) {
            var Ha = Va.stack.trim().match(/\n( *(at )?)/);
            xi = Ha && Ha[1] || "";
          }
        return `
` + xi + mn;
      }
    }
    var zi = !1, Vi;
    {
      var Hi = typeof WeakMap == "function" ? WeakMap : Map;
      Vi = new Hi();
    }
    function ii(mn, ai) {
      if (!mn || zi)
        return "";
      {
        var $i = Vi.get(mn);
        if ($i !== void 0)
          return $i;
      }
      var Ha;
      zi = !0;
      var Va = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Us;
      Us = bi.current, bi.current = null, qn();
      try {
        if (ai) {
          var $s = function() {
            throw Error();
          };
          if (Object.defineProperty($s.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($s, []);
            } catch (Xi) {
              Ha = Xi;
            }
            Reflect.construct(mn, [], $s);
          } else {
            try {
              $s.call();
            } catch (Xi) {
              Ha = Xi;
            }
            mn.call($s.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xi) {
            Ha = Xi;
          }
          mn();
        }
      } catch (Xi) {
        if (Xi && Ha && typeof Xi.stack == "string") {
          for (var Za = Xi.stack.split(`
`), ml = Ha.stack.split(`
`), Ys = Za.length - 1, Bs = ml.length - 1; Ys >= 1 && Bs >= 0 && Za[Ys] !== ml[Bs]; )
            Bs--;
          for (; Ys >= 1 && Bs >= 0; Ys--, Bs--)
            if (Za[Ys] !== ml[Bs]) {
              if (Ys !== 1 || Bs !== 1)
                do
                  if (Ys--, Bs--, Bs < 0 || Za[Ys] !== ml[Bs]) {
                    var Wa = `
` + Za[Ys].replace(" at new ", " at ");
                    return mn.displayName && Wa.includes("<anonymous>") && (Wa = Wa.replace("<anonymous>", mn.displayName)), typeof mn == "function" && Vi.set(mn, Wa), Wa;
                  }
                while (Ys >= 1 && Bs >= 0);
              break;
            }
        }
      } finally {
        zi = !1, bi.current = Us, si(), Error.prepareStackTrace = Va;
      }
      var js = mn ? mn.displayName || mn.name : "", Fs = js ? ji(js) : "";
      return typeof mn == "function" && Vi.set(mn, Fs), Fs;
    }
    function Fi(mn, ai, $i) {
      return ii(mn, !1);
    }
    function ni(mn) {
      var ai = mn.prototype;
      return !!(ai && ai.isReactComponent);
    }
    function Ui(mn, ai, $i) {
      if (mn == null)
        return "";
      if (typeof mn == "function")
        return ii(mn, ni(mn));
      if (typeof mn == "string")
        return ji(mn);
      switch (mn) {
        case Xe:
          return ji("Suspense");
        case ot:
          return ji("SuspenseList");
      }
      if (typeof mn == "object")
        switch (mn.$$typeof) {
          case Ge:
            return Fi(mn.render);
          case vt:
            return Ui(mn.type, ai, $i);
          case bt: {
            var Ha = mn, Va = Ha._payload, Us = Ha._init;
            try {
              return Ui(Us(Va), ai, $i);
            } catch {
            }
          }
        }
      return "";
    }
    var ja = Object.prototype.hasOwnProperty, Ga = {}, Xa = Pt.ReactDebugCurrentFrame;
    function Ns(mn) {
      if (mn) {
        var ai = mn._owner, $i = Ui(mn.type, mn._source, ai ? ai.type : null);
        Xa.setExtraStackFrame($i);
      } else
        Xa.setExtraStackFrame(null);
    }
    function Ya(mn, ai, $i, Ha, Va) {
      {
        var Us = Function.call.bind(ja);
        for (var $s in mn)
          if (Us(mn, $s)) {
            var Za = void 0;
            try {
              if (typeof mn[$s] != "function") {
                var ml = Error((Ha || "React class") + ": " + $i + " type `" + $s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof mn[$s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ml.name = "Invariant Violation", ml;
              }
              Za = mn[$s](ai, $s, Ha, $i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ys) {
              Za = Ys;
            }
            Za && !(Za instanceof Error) && (Ns(Va), kt("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ha || "React class", $i, $s, typeof Za), Ns(null)), Za instanceof Error && !(Za.message in Ga) && (Ga[Za.message] = !0, Ns(Va), kt("Failed %s type: %s", $i, Za.message), Ns(null));
          }
      }
    }
    var Qa = Array.isArray;
    function Ja(mn) {
      return Qa(mn);
    }
    function Ms(mn) {
      {
        var ai = typeof Symbol == "function" && Symbol.toStringTag, $i = ai && mn[Symbol.toStringTag] || mn.constructor.name || "Object";
        return $i;
      }
    }
    function Hs(mn) {
      try {
        return no(mn), !1;
      } catch {
        return !0;
      }
    }
    function no(mn) {
      return "" + mn;
    }
    function Qs(mn) {
      if (Hs(mn))
        return kt("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ms(mn)), no(mn);
    }
    var Zs = Pt.ReactCurrentOwner, so = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, io, dl;
    function vl(mn) {
      if (ja.call(mn, "ref")) {
        var ai = Object.getOwnPropertyDescriptor(mn, "ref").get;
        if (ai && ai.isReactWarning)
          return !1;
      }
      return mn.ref !== void 0;
    }
    function lo(mn) {
      if (ja.call(mn, "key")) {
        var ai = Object.getOwnPropertyDescriptor(mn, "key").get;
        if (ai && ai.isReactWarning)
          return !1;
      }
      return mn.key !== void 0;
    }
    function yl(mn, ai) {
      typeof mn.ref == "string" && Zs.current;
    }
    function bl(mn, ai) {
      {
        var $i = function() {
          io || (io = !0, kt("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ai));
        };
        $i.isReactWarning = !0, Object.defineProperty(mn, "key", {
          get: $i,
          configurable: !0
        });
      }
    }
    function Al(mn, ai) {
      {
        var $i = function() {
          dl || (dl = !0, kt("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ai));
        };
        $i.isReactWarning = !0, Object.defineProperty(mn, "ref", {
          get: $i,
          configurable: !0
        });
      }
    }
    var Xl = function(mn, ai, $i, Ha, Va, Us, $s) {
      var Za = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: ie,
        // Built-in properties that belong on the element
        type: mn,
        key: ai,
        ref: $i,
        props: $s,
        // Record the component responsible for creating this element.
        _owner: Us
      };
      return Za._store = {}, Object.defineProperty(Za._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Za, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ha
      }), Object.defineProperty(Za, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Va
      }), Object.freeze && (Object.freeze(Za.props), Object.freeze(Za)), Za;
    };
    function $l(mn, ai, $i, Ha, Va) {
      {
        var Us, $s = {}, Za = null, ml = null;
        $i !== void 0 && (Qs($i), Za = "" + $i), lo(ai) && (Qs(ai.key), Za = "" + ai.key), vl(ai) && (ml = ai.ref, yl(ai));
        for (Us in ai)
          ja.call(ai, Us) && !so.hasOwnProperty(Us) && ($s[Us] = ai[Us]);
        if (mn && mn.defaultProps) {
          var Ys = mn.defaultProps;
          for (Us in Ys)
            $s[Us] === void 0 && ($s[Us] = Ys[Us]);
        }
        if (Za || ml) {
          var Bs = typeof mn == "function" ? mn.displayName || mn.name || "Unknown" : mn;
          Za && bl($s, Bs), ml && Al($s, Bs);
        }
        return Xl(mn, Za, ml, Va, Ha, Zs.current, $s);
      }
    }
    var Bl = Pt.ReactCurrentOwner, Fl = Pt.ReactDebugCurrentFrame;
    function kl(mn) {
      if (mn) {
        var ai = mn._owner, $i = Ui(mn.type, mn._source, ai ? ai.type : null);
        Fl.setExtraStackFrame($i);
      } else
        Fl.setExtraStackFrame(null);
    }
    var ql;
    ql = !1;
    function _l(mn) {
      return typeof mn == "object" && mn !== null && mn.$$typeof === ie;
    }
    function Ol() {
      {
        if (Bl.current) {
          var mn = Sn(Bl.current.type);
          if (mn)
            return `

Check the render method of \`` + mn + "`.";
        }
        return "";
      }
    }
    function Ll(mn) {
      return "";
    }
    var Ql = {};
    function wl(mn) {
      {
        var ai = Ol();
        if (!ai) {
          var $i = typeof mn == "string" ? mn : mn.displayName || mn.name;
          $i && (ai = `

Check the top-level render call using <` + $i + ">.");
        }
        return ai;
      }
    }
    function to(mn, ai) {
      {
        if (!mn._store || mn._store.validated || mn.key != null)
          return;
        mn._store.validated = !0;
        var $i = wl(ai);
        if (Ql[$i])
          return;
        Ql[$i] = !0;
        var Ha = "";
        mn && mn._owner && mn._owner !== Bl.current && (Ha = " It was passed a child from " + Sn(mn._owner.type) + "."), kl(mn), kt('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $i, Ha), kl(null);
      }
    }
    function zs(mn, ai) {
      {
        if (typeof mn != "object")
          return;
        if (Ja(mn))
          for (var $i = 0; $i < mn.length; $i++) {
            var Ha = mn[$i];
            _l(Ha) && to(Ha, ai);
          }
        else if (_l(mn))
          mn._store && (mn._store.validated = !0);
        else if (mn) {
          var Va = It(mn);
          if (typeof Va == "function" && Va !== mn.entries)
            for (var Us = Va.call(mn), $s; !($s = Us.next()).done; )
              _l($s.value) && to($s.value, ai);
        }
      }
    }
    function Gs(mn) {
      {
        var ai = mn.type;
        if (ai == null || typeof ai == "string")
          return;
        var $i;
        if (typeof ai == "function")
          $i = ai.propTypes;
        else if (typeof ai == "object" && (ai.$$typeof === Ge || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ai.$$typeof === vt))
          $i = ai.propTypes;
        else
          return;
        if ($i) {
          var Ha = Sn(ai);
          Ya($i, mn.props, "prop", Ha, mn);
        } else if (ai.PropTypes !== void 0 && !ql) {
          ql = !0;
          var Va = Sn(ai);
          kt("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Va || "Unknown");
        }
        typeof ai.getDefaultProps == "function" && !ai.getDefaultProps.isReactClassApproved && kt("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Pl(mn) {
      {
        for (var ai = Object.keys(mn.props), $i = 0; $i < ai.length; $i++) {
          var Ha = ai[$i];
          if (Ha !== "children" && Ha !== "key") {
            kl(mn), kt("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ha), kl(null);
            break;
          }
        }
        mn.ref !== null && (kl(mn), kt("Invalid attribute `ref` supplied to `React.Fragment`."), kl(null));
      }
    }
    var Ml = {};
    function Ws(mn, ai, $i, Ha, Va, Us) {
      {
        var $s = Tn(mn);
        if (!$s) {
          var Za = "";
          (mn === void 0 || typeof mn == "object" && mn !== null && Object.keys(mn).length === 0) && (Za += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ml = Ll();
          ml ? Za += ml : Za += Ol();
          var Ys;
          mn === null ? Ys = "null" : Ja(mn) ? Ys = "array" : mn !== void 0 && mn.$$typeof === ie ? (Ys = "<" + (Sn(mn.type) || "Unknown") + " />", Za = " Did you accidentally export a JSX literal instead of a component?") : Ys = typeof mn, kt("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ys, Za);
        }
        var Bs = $l(mn, ai, $i, Va, Us);
        if (Bs == null)
          return Bs;
        if ($s) {
          var Wa = ai.children;
          if (Wa !== void 0)
            if (Ha)
              if (Ja(Wa)) {
                for (var js = 0; js < Wa.length; js++)
                  zs(Wa[js], mn);
                Object.freeze && Object.freeze(Wa);
              } else
                kt("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              zs(Wa, mn);
        }
        if (ja.call(ai, "key")) {
          var Fs = Sn(mn), Xi = Object.keys(ai).filter(function(xl) {
            return xl !== "key";
          }), ao = Xi.length > 0 ? "{key: someKey, " + Xi.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ml[Fs + ao]) {
            var Sl = Xi.length > 0 ? "{" + Xi.join(": ..., ") + ": ...}" : "{}";
            kt(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ao, Fs, Sl, Fs), Ml[Fs + ao] = !0;
          }
        }
        return mn === we ? Pl(Bs) : Gs(Bs), Bs;
      }
    }
    function Ks(mn, ai, $i) {
      return Ws(mn, ai, $i, !0);
    }
    function Js(mn, ai, $i) {
      return Ws(mn, ai, $i, !1);
    }
    var qs = Js, ho = Ks;
    hr.Fragment = we, hr.jsx = qs, hr.jsxs = ho;
  }()), hr;
}
process.env.NODE_ENV === "production" ? No.exports = Bg() : No.exports = Fg();
var Ug = No.exports;
const $g = (ce) => {
  const ie = useRef();
  return useEffect(() => void (ie.current = ce), [ce]), ie.current;
};
var vr;
typeof window < "u" ? vr = window : typeof Vn < "u" ? vr = Vn : typeof self < "u" ? vr = self : vr = {};
var ma = vr;
const S = /* @__PURE__ */ jr(ma), jg = {}, qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jg
}, Symbol.toStringTag, { value: "Module" })), Vg = /* @__PURE__ */ Ng(qg);
var ec = typeof Vn < "u" ? Vn : typeof window < "u" ? window : {}, Hg = Vg, br;
typeof document < "u" ? br = document : (br = ec["__GLOBAL_DOCUMENT_CACHE@4"], br || (br = ec["__GLOBAL_DOCUMENT_CACHE@4"] = Hg));
var kd = br;
const V$1 = /* @__PURE__ */ jr(kd);
var fu = { exports: {} }, Id = { exports: {} };
(function(ce) {
  function ie() {
    return ce.exports = ie = Object.assign ? Object.assign.bind() : function(me) {
      for (var we = 1; we < arguments.length; we++) {
        var Re = arguments[we];
        for (var je in Re) ({}).hasOwnProperty.call(Re, je) && (me[je] = Re[je]);
      }
      return me;
    }, ce.exports.__esModule = !0, ce.exports.default = ce.exports, ie.apply(null, arguments);
  }
  ce.exports = ie, ce.exports.__esModule = !0, ce.exports.default = ce.exports;
})(Id);
var zg = Id.exports, Wg = Xg, Gg = Object.prototype.toString;
function Xg(ce) {
  if (!ce)
    return !1;
  var ie = Gg.call(ce);
  return ie === "[object Function]" || typeof ce == "function" && ie !== "[object RegExp]" || typeof window < "u" && // IE8 and below
  (ce === window.setTimeout || ce === window.alert || ce === window.confirm || ce === window.prompt);
}
function Kg(ce, ie) {
  var me = typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me) return (me = me.call(ce)).next.bind(me);
  if (Array.isArray(ce) || (me = Yg(ce)) || ie) {
    me && (ce = me);
    var we = 0;
    return function() {
      return we >= ce.length ? { done: !0 } : { done: !1, value: ce[we++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yg(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return tc(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return tc(ce, ie);
  }
}
function tc(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
var Qg = /* @__PURE__ */ function() {
  function ce() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }
  var ie = ce.prototype;
  return ie.getIsEnabled = function() {
    return this.enabled_;
  }, ie.enable = function() {
    this.enabled_ = !0;
  }, ie.disable = function() {
    this.enabled_ = !1;
  }, ie.reset = function() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }, ie.addInterceptor = function(me, we) {
    this.typeToInterceptorsMap_.has(me) || this.typeToInterceptorsMap_.set(me, /* @__PURE__ */ new Set());
    var Re = this.typeToInterceptorsMap_.get(me);
    return Re.has(we) ? !1 : (Re.add(we), !0);
  }, ie.removeInterceptor = function(me, we) {
    var Re = this.typeToInterceptorsMap_.get(me);
    return Re && Re.has(we) ? (Re.delete(we), !0) : !1;
  }, ie.clearInterceptorsByType = function(me) {
    var we = this.typeToInterceptorsMap_.get(me);
    return we ? (this.typeToInterceptorsMap_.delete(me), this.typeToInterceptorsMap_.set(me, /* @__PURE__ */ new Set()), !0) : !1;
  }, ie.clear = function() {
    return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
  }, ie.getForType = function(me) {
    return this.typeToInterceptorsMap_.get(me) || /* @__PURE__ */ new Set();
  }, ie.execute = function(me, we) {
    for (var Re = this.getForType(me), je = Kg(Re), Ue; !(Ue = je()).done; ) {
      var qe = Ue.value;
      try {
        we = qe(we);
      } catch {
      }
    }
    return we;
  }, ce;
}(), Jg = Qg, Zg = /* @__PURE__ */ function() {
  function ce() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }
  var ie = ce.prototype;
  return ie.getIsEnabled = function() {
    return this.enabled_;
  }, ie.enable = function() {
    this.enabled_ = !0;
  }, ie.disable = function() {
    this.enabled_ = !1;
  }, ie.reset = function() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }, ie.getMaxAttempts = function() {
    return this.maxAttempts_;
  }, ie.setMaxAttempts = function(me) {
    this.maxAttempts_ = me;
  }, ie.getDelayFactor = function() {
    return this.delayFactor_;
  }, ie.setDelayFactor = function(me) {
    this.delayFactor_ = me;
  }, ie.getFuzzFactor = function() {
    return this.fuzzFactor_;
  }, ie.setFuzzFactor = function(me) {
    this.fuzzFactor_ = me;
  }, ie.getInitialDelay = function() {
    return this.initialDelay_;
  }, ie.setInitialDelay = function(me) {
    this.initialDelay_ = me;
  }, ie.createRetry = function(me) {
    var we = me === void 0 ? {} : me, Re = we.maxAttempts, je = we.delayFactor, Ue = we.fuzzFactor, qe = we.initialDelay;
    return new e0({
      maxAttempts: Re || this.maxAttempts_,
      delayFactor: je || this.delayFactor_,
      fuzzFactor: Ue || this.fuzzFactor_,
      initialDelay: qe || this.initialDelay_
    });
  }, ce;
}(), e0 = /* @__PURE__ */ function() {
  function ce(me) {
    this.maxAttempts_ = me.maxAttempts, this.delayFactor_ = me.delayFactor, this.fuzzFactor_ = me.fuzzFactor, this.currentDelay_ = me.initialDelay, this.currentAttempt_ = 1;
  }
  var ie = ce.prototype;
  return ie.moveToNextAttempt = function() {
    this.currentAttempt_++;
    var me = this.currentDelay_ * this.delayFactor_;
    this.currentDelay_ = this.currentDelay_ + me;
  }, ie.shouldRetry = function() {
    return this.currentAttempt_ < this.maxAttempts_;
  }, ie.getCurrentDelay = function() {
    return this.currentDelay_;
  }, ie.getCurrentMinPossibleDelay = function() {
    return (1 - this.fuzzFactor_) * this.currentDelay_;
  }, ie.getCurrentMaxPossibleDelay = function() {
    return (1 + this.fuzzFactor_) * this.currentDelay_;
  }, ie.getCurrentFuzzedDelay = function() {
    var me = this.getCurrentMinPossibleDelay(), we = this.getCurrentMaxPossibleDelay();
    return me + Math.random() * (we - me);
  }, ce;
}(), t0 = Zg, i0 = ma, s0 = function(ce, ie) {
  return ie === void 0 && (ie = !1), function(me, we, Re) {
    if (me) {
      ce(me);
      return;
    }
    if (we.statusCode >= 400 && we.statusCode <= 599) {
      var je = Re;
      if (ie)
        if (i0.TextDecoder) {
          var Ue = r0(we.headers && we.headers["content-type"]);
          try {
            je = new TextDecoder(Ue).decode(Re);
          } catch {
          }
        } else
          je = String.fromCharCode.apply(null, new Uint8Array(Re));
      ce({
        cause: je
      });
      return;
    }
    ce(null, Re);
  };
};
function r0(ce) {
  return ce === void 0 && (ce = ""), ce.toLowerCase().split(";").reduce(function(ie, me) {
    var we = me.split("="), Re = we[0], je = we[1];
    return Re.trim() === "charset" ? je.trim() : ie;
  }, "utf-8");
}
var n0 = s0, Pd = ma, a0 = zg, o0 = Wg, Od = Jg, u0 = t0;
Ie.httpHandler = n0;
Ie.requestInterceptorsStorage = new Od();
Ie.responseInterceptorsStorage = new Od();
Ie.retryManager = new u0();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var l0 = function(ce) {
  var ie = {};
  return ce && ce.trim().split(`
`).forEach(function(me) {
    var we = me.indexOf(":"), Re = me.slice(0, we).trim().toLowerCase(), je = me.slice(we + 1).trim();
    typeof ie[Re] > "u" ? ie[Re] = je : Array.isArray(ie[Re]) ? ie[Re].push(je) : ie[Re] = [ie[Re], je];
  }), ie;
};
fu.exports = Ie;
fu.exports.default = Ie;
Ie.XMLHttpRequest = Pd.XMLHttpRequest || f0;
Ie.XDomainRequest = "withCredentials" in new Ie.XMLHttpRequest() ? Ie.XMLHttpRequest : Pd.XDomainRequest;
c0(["get", "put", "post", "patch", "head", "delete"], function(ce) {
  Ie[ce === "delete" ? "del" : ce] = function(ie, me, we) {
    return me = Ld(ie, me, we), me.method = ce.toUpperCase(), pu(me);
  };
});
function c0(ce, ie) {
  for (var me = 0; me < ce.length; me++)
    ie(ce[me]);
}
function d0(ce) {
  for (var ie in ce)
    if (ce.hasOwnProperty(ie)) return !1;
  return !0;
}
function Ld(ce, ie, me) {
  var we = ce;
  return o0(ie) ? (me = ie, typeof ce == "string" && (we = {
    uri: ce
  })) : we = a0({}, ie, {
    uri: ce
  }), we.callback = me, we;
}
function Ie(ce, ie, me) {
  return ie = Ld(ce, ie, me), pu(ie);
}
function pu(ce) {
  if (typeof ce.callback > "u")
    throw new Error("callback argument missing");
  if (ce.requestType && Ie.requestInterceptorsStorage.getIsEnabled()) {
    var ie = {
      uri: ce.uri || ce.url,
      headers: ce.headers || {},
      body: ce.body,
      metadata: ce.metadata || {},
      retry: ce.retry,
      timeout: ce.timeout
    }, me = Ie.requestInterceptorsStorage.execute(ce.requestType, ie);
    ce.uri = me.uri, ce.headers = me.headers, ce.body = me.body, ce.metadata = me.metadata, ce.retry = me.retry, ce.timeout = me.timeout;
  }
  var we = !1, Re = function(Jr, en, nn) {
    we || (we = !0, ce.callback(Jr, en, nn));
  };
  function je() {
    Xe.readyState === 4 && !Ie.responseInterceptorsStorage.getIsEnabled() && setTimeout(Ge, 0);
  }
  function Ue() {
    var Jr = void 0;
    if (Xe.response ? Jr = Xe.response : Jr = Xe.responseText || h0(Xe), Pt)
      try {
        Jr = JSON.parse(Jr);
      } catch {
      }
    return Jr;
  }
  function qe(Jr) {
    if (clearTimeout(kt), clearTimeout(ce.retryTimeout), Jr instanceof Error || (Jr = new Error("" + (Jr || "Unknown XMLHttpRequest Error"))), Jr.statusCode = 0, !vt && Ie.retryManager.getIsEnabled() && ce.retry && ce.retry.shouldRetry()) {
      ce.retryTimeout = setTimeout(function() {
        ce.retry.moveToNextAttempt(), ce.xhr = Xe, pu(ce);
      }, ce.retry.getCurrentFuzzedDelay());
      return;
    }
    if (ce.requestType && Ie.responseInterceptorsStorage.getIsEnabled()) {
      var en = {
        headers: Ot.headers || {},
        body: Ot.body,
        responseUrl: Xe.responseURL,
        responseType: Xe.responseType
      }, nn = Ie.responseInterceptorsStorage.execute(ce.requestType, en);
      Ot.body = nn.body, Ot.headers = nn.headers;
    }
    return Re(Jr, Ot);
  }
  function Ge() {
    if (!vt) {
      var Jr;
      clearTimeout(kt), clearTimeout(ce.retryTimeout), ce.useXDR && Xe.status === void 0 ? Jr = 200 : Jr = Xe.status === 1223 ? 204 : Xe.status;
      var en = Ot, nn = null;
      if (Jr !== 0 ? (en = {
        body: Ue(),
        statusCode: Jr,
        method: Tt,
        headers: {},
        url: bt,
        rawRequest: Xe
      }, Xe.getAllResponseHeaders && (en.headers = l0(Xe.getAllResponseHeaders()))) : nn = new Error("Internal XMLHttpRequest Error"), ce.requestType && Ie.responseInterceptorsStorage.getIsEnabled()) {
        var ln = {
          headers: en.headers || {},
          body: en.body,
          responseUrl: Xe.responseURL,
          responseType: Xe.responseType
        }, fn = Ie.responseInterceptorsStorage.execute(ce.requestType, ln);
        en.body = fn.body, en.headers = fn.headers;
      }
      return Re(nn, en, en.body);
    }
  }
  var Xe = ce.xhr || null;
  Xe || (ce.cors || ce.useXDR ? Xe = new Ie.XDomainRequest() : Xe = new Ie.XMLHttpRequest());
  var ot, vt, bt = Xe.url = ce.uri || ce.url, Tt = Xe.method = ce.method || "GET", wt = ce.body || ce.data, St = Xe.headers = ce.headers || {}, It = !!ce.sync, Pt = !1, kt, Ot = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: Tt,
    url: bt,
    rawRequest: Xe
  };
  if ("json" in ce && ce.json !== !1 && (Pt = !0, St.accept || St.Accept || (St.Accept = "application/json"), Tt !== "GET" && Tt !== "HEAD" && (St["content-type"] || St["Content-Type"] || (St["Content-Type"] = "application/json"), wt = JSON.stringify(ce.json === !0 ? wt : ce.json))), Xe.onreadystatechange = je, Xe.onload = Ge, Xe.onerror = qe, Xe.onprogress = function() {
  }, Xe.onabort = function() {
    vt = !0, clearTimeout(ce.retryTimeout);
  }, Xe.ontimeout = qe, Xe.open(Tt, bt, !It, ce.username, ce.password), It || (Xe.withCredentials = !!ce.withCredentials), !It && ce.timeout > 0 && (kt = setTimeout(function() {
    if (!vt) {
      vt = !0, Xe.abort("timeout");
      var Jr = new Error("XMLHttpRequest timeout");
      Jr.code = "ETIMEDOUT", qe(Jr);
    }
  }, ce.timeout)), Xe.setRequestHeader)
    for (ot in St)
      St.hasOwnProperty(ot) && Xe.setRequestHeader(ot, St[ot]);
  else if (ce.headers && !d0(ce.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in ce && (Xe.responseType = ce.responseType), "beforeSend" in ce && typeof ce.beforeSend == "function" && ce.beforeSend(Xe), Xe.send(wt || null), Xe;
}
function h0(ce) {
  try {
    if (ce.responseType === "document")
      return ce.responseXML;
    var ie = ce.responseXML && ce.responseXML.documentElement.nodeName === "parsererror";
    if (ce.responseType === "" && !ie)
      return ce.responseXML;
  } catch {
  }
  return null;
}
function f0() {
}
var p0 = fu.exports;
const Rd = /* @__PURE__ */ jr(p0);
var Md = { exports: {} }, ic = kd, mu = Object.create || /* @__PURE__ */ function() {
  function ce() {
  }
  return function(ie) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return ce.prototype = ie, new ce();
  };
}();
function ct(ce, ie) {
  this.name = "ParsingError", this.code = ce.code, this.message = ie || ce.message;
}
ct.prototype = mu(Error.prototype);
ct.prototype.constructor = ct;
ct.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function gu(ce) {
  function ie(we, Re, je, Ue) {
    return (we | 0) * 3600 + (Re | 0) * 60 + (je | 0) + (Ue | 0) / 1e3;
  }
  var me = ce.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return me ? me[3] ? ie(me[1], me[2], me[3].replace(":", ""), me[4]) : me[1] > 59 ? ie(me[1], me[2], 0, me[4]) : ie(0, me[1], me[2], me[4]) : null;
}
function Ar() {
  this.values = mu(null);
}
Ar.prototype = {
  // Only accept the first assignment to any key.
  set: function(ce, ie) {
    !this.get(ce) && ie !== "" && (this.values[ce] = ie);
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(ce, ie, me) {
    return me ? this.has(ce) ? this.values[ce] : ie[me] : this.has(ce) ? this.values[ce] : ie;
  },
  // Check whether we have a value for a key.
  has: function(ce) {
    return ce in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(ce, ie, me) {
    for (var we = 0; we < me.length; ++we)
      if (ie === me[we]) {
        this.set(ce, ie);
        break;
      }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(ce, ie) {
    /^-?\d+$/.test(ie) && this.set(ce, parseInt(ie, 10));
  },
  // Accept a setting if its a valid percentage.
  percent: function(ce, ie) {
    return ie.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (ie = parseFloat(ie), ie >= 0 && ie <= 100) ? (this.set(ce, ie), !0) : !1;
  }
};
function xr(ce, ie, me, we) {
  var Re = we ? ce.split(we) : [ce];
  for (var je in Re)
    if (typeof Re[je] == "string") {
      var Ue = Re[je].split(me);
      if (Ue.length === 2) {
        var qe = Ue[0].trim(), Ge = Ue[1].trim();
        ie(qe, Ge);
      }
    }
}
function m0(ce, ie, me) {
  var we = ce;
  function Re() {
    var qe = gu(ce);
    if (qe === null)
      throw new ct(
        ct.Errors.BadTimeStamp,
        "Malformed timestamp: " + we
      );
    return ce = ce.replace(/^[^\sa-zA-Z-]+/, ""), qe;
  }
  function je(qe, Ge) {
    var Xe = new Ar();
    xr(qe, function(ot, vt) {
      switch (ot) {
        case "region":
          for (var bt = me.length - 1; bt >= 0; bt--)
            if (me[bt].id === vt) {
              Xe.set(ot, me[bt].region);
              break;
            }
          break;
        case "vertical":
          Xe.alt(ot, vt, ["rl", "lr"]);
          break;
        case "line":
          var Tt = vt.split(","), wt = Tt[0];
          Xe.integer(ot, wt), Xe.percent(ot, wt) && Xe.set("snapToLines", !1), Xe.alt(ot, wt, ["auto"]), Tt.length === 2 && Xe.alt("lineAlign", Tt[1], ["start", "center", "end"]);
          break;
        case "position":
          Tt = vt.split(","), Xe.percent(ot, Tt[0]), Tt.length === 2 && Xe.alt("positionAlign", Tt[1], ["start", "center", "end"]);
          break;
        case "size":
          Xe.percent(ot, vt);
          break;
        case "align":
          Xe.alt(ot, vt, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), Ge.region = Xe.get("region", null), Ge.vertical = Xe.get("vertical", "");
    try {
      Ge.line = Xe.get("line", "auto");
    } catch {
    }
    Ge.lineAlign = Xe.get("lineAlign", "start"), Ge.snapToLines = Xe.get("snapToLines", !0), Ge.size = Xe.get("size", 100);
    try {
      Ge.align = Xe.get("align", "center");
    } catch {
      Ge.align = Xe.get("align", "middle");
    }
    try {
      Ge.position = Xe.get("position", "auto");
    } catch {
      Ge.position = Xe.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, Ge.align);
    }
    Ge.positionAlign = Xe.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, Ge.align);
  }
  function Ue() {
    ce = ce.replace(/^\s+/, "");
  }
  if (Ue(), ie.startTime = Re(), Ue(), ce.substr(0, 3) !== "-->")
    throw new ct(
      ct.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + we
    );
  ce = ce.substr(3), Ue(), ie.endTime = Re(), Ue(), je(ce, ie);
}
var po = ic.createElement && ic.createElement("textarea"), g0 = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, sc = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, _0 = {
  v: "title",
  lang: "lang"
}, rc = {
  rt: "ruby"
};
function Nd(ce, ie) {
  function me() {
    if (!ie)
      return null;
    function wt(It) {
      return ie = ie.substr(It.length), It;
    }
    var St = ie.match(/^([^<]*)(<[^>]*>?)?/);
    return wt(St[1] ? St[1] : St[2]);
  }
  function we(wt) {
    return po.innerHTML = wt, wt = po.textContent, po.textContent = "", wt;
  }
  function Re(wt, St) {
    return !rc[St.localName] || rc[St.localName] === wt.localName;
  }
  function je(wt, St) {
    var It = g0[wt];
    if (!It)
      return null;
    var Pt = ce.document.createElement(It), kt = _0[wt];
    return kt && St && (Pt[kt] = St.trim()), Pt;
  }
  for (var Ue = ce.document.createElement("div"), qe = Ue, Ge, Xe = []; (Ge = me()) !== null; ) {
    if (Ge[0] === "<") {
      if (Ge[1] === "/") {
        Xe.length && Xe[Xe.length - 1] === Ge.substr(2).replace(">", "") && (Xe.pop(), qe = qe.parentNode);
        continue;
      }
      var ot = gu(Ge.substr(1, Ge.length - 2)), vt;
      if (ot) {
        vt = ce.document.createProcessingInstruction("timestamp", ot), qe.appendChild(vt);
        continue;
      }
      var bt = Ge.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!bt || (vt = je(bt[1], bt[3]), !vt) || !Re(qe, vt))
        continue;
      if (bt[2]) {
        var Tt = bt[2].split(".");
        Tt.forEach(function(wt) {
          var St = /^bg_/.test(wt), It = St ? wt.slice(3) : wt;
          if (sc.hasOwnProperty(It)) {
            var Pt = St ? "background-color" : "color", kt = sc[It];
            vt.style[Pt] = kt;
          }
        }), vt.className = Tt.join(" ");
      }
      Xe.push(bt[1]), qe.appendChild(vt), qe = vt;
      continue;
    }
    qe.appendChild(ce.document.createTextNode(we(Ge)));
  }
  return Ue;
}
var nc = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function y0(ce) {
  for (var ie = 0; ie < nc.length; ie++) {
    var me = nc[ie];
    if (ce >= me[0] && ce <= me[1])
      return !0;
  }
  return !1;
}
function T0(ce) {
  var ie = [], me = "", we;
  if (!ce || !ce.childNodes)
    return "ltr";
  function Re(qe, Ge) {
    for (var Xe = Ge.childNodes.length - 1; Xe >= 0; Xe--)
      qe.push(Ge.childNodes[Xe]);
  }
  function je(qe) {
    if (!qe || !qe.length)
      return null;
    var Ge = qe.pop(), Xe = Ge.textContent || Ge.innerText;
    if (Xe) {
      var ot = Xe.match(/^.*(\n|\r)/);
      return ot ? (qe.length = 0, ot[0]) : Xe;
    }
    if (Ge.tagName === "ruby")
      return je(qe);
    if (Ge.childNodes)
      return Re(qe, Ge), je(qe);
  }
  for (Re(ie, ce); me = je(ie); )
    for (var Ue = 0; Ue < me.length; Ue++)
      if (we = me.charCodeAt(Ue), y0(we))
        return "rtl";
  return "ltr";
}
function v0(ce) {
  if (typeof ce.line == "number" && (ce.snapToLines || ce.line >= 0 && ce.line <= 100))
    return ce.line;
  if (!ce.track || !ce.track.textTrackList || !ce.track.textTrackList.mediaElement)
    return -1;
  for (var ie = ce.track, me = ie.textTrackList, we = 0, Re = 0; Re < me.length && me[Re] !== ie; Re++)
    me[Re].mode === "showing" && we++;
  return ++we * -1;
}
function ga() {
}
ga.prototype.applyStyles = function(ce, ie) {
  ie = ie || this.div;
  for (var me in ce)
    ce.hasOwnProperty(me) && (ie.style[me] = ce[me]);
};
ga.prototype.formatStyle = function(ce, ie) {
  return ce === 0 ? 0 : ce + ie;
};
function Hn(ce, ie, me) {
  ga.call(this), this.cue = ie, this.cueDiv = Nd(ce, ie.text);
  var we = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: ie.vertical === "" ? "horizontal-tb" : ie.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(we, this.cueDiv), this.div = ce.document.createElement("div"), we = {
    direction: T0(this.cueDiv),
    writingMode: ie.vertical === "" ? "horizontal-tb" : ie.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: ie.align === "middle" ? "center" : ie.align,
    font: me.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(we), this.div.appendChild(this.cueDiv);
  var Re = 0;
  switch (ie.positionAlign) {
    case "start":
    case "line-left":
      Re = ie.position;
      break;
    case "center":
      Re = ie.position - ie.size / 2;
      break;
    case "end":
    case "line-right":
      Re = ie.position - ie.size;
      break;
  }
  ie.vertical === "" ? this.applyStyles({
    left: this.formatStyle(Re, "%"),
    width: this.formatStyle(ie.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(Re, "%"),
    height: this.formatStyle(ie.size, "%")
  }), this.move = function(je) {
    this.applyStyles({
      top: this.formatStyle(je.top, "px"),
      bottom: this.formatStyle(je.bottom, "px"),
      left: this.formatStyle(je.left, "px"),
      right: this.formatStyle(je.right, "px"),
      height: this.formatStyle(je.height, "px"),
      width: this.formatStyle(je.width, "px")
    });
  };
}
Hn.prototype = mu(ga.prototype);
Hn.prototype.constructor = Hn;
function Je(ce) {
  var ie, me, we, Re;
  if (ce.div) {
    me = ce.div.offsetHeight, we = ce.div.offsetWidth, Re = ce.div.offsetTop;
    var je = (je = ce.div.childNodes) && (je = je[0]) && je.getClientRects && je.getClientRects();
    ce = ce.div.getBoundingClientRect(), ie = je ? Math.max(je[0] && je[0].height || 0, ce.height / je.length) : 0;
  }
  this.left = ce.left, this.right = ce.right, this.top = ce.top || Re, this.height = ce.height || me, this.bottom = ce.bottom || Re + (ce.height || me), this.width = ce.width || we, this.lineHeight = ie !== void 0 ? ie : ce.lineHeight;
}
Je.prototype.move = function(ce, ie) {
  switch (ie = ie !== void 0 ? ie : this.lineHeight, ce) {
    case "+x":
      this.left += ie, this.right += ie;
      break;
    case "-x":
      this.left -= ie, this.right -= ie;
      break;
    case "+y":
      this.top += ie, this.bottom += ie;
      break;
    case "-y":
      this.top -= ie, this.bottom -= ie;
      break;
  }
};
Je.prototype.overlaps = function(ce) {
  return this.left < ce.right && this.right > ce.left && this.top < ce.bottom && this.bottom > ce.top;
};
Je.prototype.overlapsAny = function(ce) {
  for (var ie = 0; ie < ce.length; ie++)
    if (this.overlaps(ce[ie]))
      return !0;
  return !1;
};
Je.prototype.within = function(ce) {
  return this.top >= ce.top && this.bottom <= ce.bottom && this.left >= ce.left && this.right <= ce.right;
};
Je.prototype.overlapsOppositeAxis = function(ce, ie) {
  switch (ie) {
    case "+x":
      return this.left < ce.left;
    case "-x":
      return this.right > ce.right;
    case "+y":
      return this.top < ce.top;
    case "-y":
      return this.bottom > ce.bottom;
  }
};
Je.prototype.intersectPercentage = function(ce) {
  var ie = Math.max(0, Math.min(this.right, ce.right) - Math.max(this.left, ce.left)), me = Math.max(0, Math.min(this.bottom, ce.bottom) - Math.max(this.top, ce.top)), we = ie * me;
  return we / (this.height * this.width);
};
Je.prototype.toCSSCompatValues = function(ce) {
  return {
    top: this.top - ce.top,
    bottom: ce.bottom - this.bottom,
    left: this.left - ce.left,
    right: ce.right - this.right,
    height: this.height,
    width: this.width
  };
};
Je.getSimpleBoxPosition = function(ce) {
  var ie = ce.div ? ce.div.offsetHeight : ce.tagName ? ce.offsetHeight : 0, me = ce.div ? ce.div.offsetWidth : ce.tagName ? ce.offsetWidth : 0, we = ce.div ? ce.div.offsetTop : ce.tagName ? ce.offsetTop : 0;
  ce = ce.div ? ce.div.getBoundingClientRect() : ce.tagName ? ce.getBoundingClientRect() : ce;
  var Re = {
    left: ce.left,
    right: ce.right,
    top: ce.top || we,
    height: ce.height || ie,
    bottom: ce.bottom || we + (ce.height || ie),
    width: ce.width || me
  };
  return Re;
};
function b0(ce, ie, me, we) {
  function Re(It, Pt) {
    for (var kt, Ot = new Je(It), Jr = 1, en = 0; en < Pt.length; en++) {
      for (; It.overlapsOppositeAxis(me, Pt[en]) || It.within(me) && It.overlapsAny(we); )
        It.move(Pt[en]);
      if (It.within(me))
        return It;
      var nn = It.intersectPercentage(me);
      Jr > nn && (kt = new Je(It), Jr = nn), It = new Je(Ot);
    }
    return kt || Ot;
  }
  var je = new Je(ie), Ue = ie.cue, qe = v0(Ue), Ge = [];
  if (Ue.snapToLines) {
    var Xe;
    switch (Ue.vertical) {
      case "":
        Ge = ["+y", "-y"], Xe = "height";
        break;
      case "rl":
        Ge = ["+x", "-x"], Xe = "width";
        break;
      case "lr":
        Ge = ["-x", "+x"], Xe = "width";
        break;
    }
    var ot = je.lineHeight, vt = ot * Math.round(qe), bt = me[Xe] + ot, Tt = Ge[0];
    Math.abs(vt) > bt && (vt = vt < 0 ? -1 : 1, vt *= Math.ceil(bt / ot) * ot), qe < 0 && (vt += Ue.vertical === "" ? me.height : me.width, Ge = Ge.reverse()), je.move(Tt, vt);
  } else {
    var wt = je.lineHeight / me.height * 100;
    switch (Ue.lineAlign) {
      case "center":
        qe -= wt / 2;
        break;
      case "end":
        qe -= wt;
        break;
    }
    switch (Ue.vertical) {
      case "":
        ie.applyStyles({
          top: ie.formatStyle(qe, "%")
        });
        break;
      case "rl":
        ie.applyStyles({
          left: ie.formatStyle(qe, "%")
        });
        break;
      case "lr":
        ie.applyStyles({
          right: ie.formatStyle(qe, "%")
        });
        break;
    }
    Ge = ["+y", "-x", "+x", "-y"], je = new Je(ie);
  }
  var St = Re(je, Ge);
  ie.move(St.toCSSCompatValues(me));
}
function Ds() {
}
Ds.StringDecoder = function() {
  return {
    decode: function(ce) {
      if (!ce)
        return "";
      if (typeof ce != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(ce));
    }
  };
};
Ds.convertCueToDOMTree = function(ce, ie) {
  return !ce || !ie ? null : Nd(ce, ie);
};
var x0 = 0.05, S0 = "sans-serif", E0 = "1.5%";
Ds.processCues = function(ce, ie, me) {
  if (!ce || !ie || !me)
    return null;
  for (; me.firstChild; )
    me.removeChild(me.firstChild);
  var we = ce.document.createElement("div");
  we.style.position = "absolute", we.style.left = "0", we.style.right = "0", we.style.top = "0", we.style.bottom = "0", we.style.margin = E0, me.appendChild(we);
  function Re(ot) {
    for (var vt = 0; vt < ot.length; vt++)
      if (ot[vt].hasBeenReset || !ot[vt].displayState)
        return !0;
    return !1;
  }
  if (!Re(ie)) {
    for (var je = 0; je < ie.length; je++)
      we.appendChild(ie[je].displayState);
    return;
  }
  var Ue = [], qe = Je.getSimpleBoxPosition(we), Ge = Math.round(qe.height * x0 * 100) / 100, Xe = {
    font: Ge + "px " + S0
  };
  (function() {
    for (var ot, vt, bt = 0; bt < ie.length; bt++)
      vt = ie[bt], ot = new Hn(ce, vt, Xe), we.appendChild(ot.div), b0(ce, ot, qe, Ue), vt.displayState = ot.div, Ue.push(Je.getSimpleBoxPosition(ot));
  })();
};
Ds.Parser = function(ce, ie, me) {
  me || (me = ie, ie = {}), ie || (ie = {}), this.window = ce, this.vttjs = ie, this.state = "INITIAL", this.buffer = "", this.decoder = me || new TextDecoder("utf8"), this.regionList = [];
};
Ds.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(ce) {
    if (ce instanceof ct)
      this.onparsingerror && this.onparsingerror(ce);
    else
      throw ce;
  },
  parse: function(ce) {
    var ie = this;
    ce && (ie.buffer += ie.decoder.decode(ce, { stream: !0 }));
    function me() {
      for (var ot = ie.buffer, vt = 0; vt < ot.length && ot[vt] !== "\r" && ot[vt] !== `
`; )
        ++vt;
      var bt = ot.substr(0, vt);
      return ot[vt] === "\r" && ++vt, ot[vt] === `
` && ++vt, ie.buffer = ot.substr(vt), bt;
    }
    function we(ot) {
      var vt = new Ar();
      if (xr(ot, function(Tt, wt) {
        switch (Tt) {
          case "id":
            vt.set(Tt, wt);
            break;
          case "width":
            vt.percent(Tt, wt);
            break;
          case "lines":
            vt.integer(Tt, wt);
            break;
          case "regionanchor":
          case "viewportanchor":
            var St = wt.split(",");
            if (St.length !== 2)
              break;
            var It = new Ar();
            if (It.percent("x", St[0]), It.percent("y", St[1]), !It.has("x") || !It.has("y"))
              break;
            vt.set(Tt + "X", It.get("x")), vt.set(Tt + "Y", It.get("y"));
            break;
          case "scroll":
            vt.alt(Tt, wt, ["up"]);
            break;
        }
      }, /=/, /\s/), vt.has("id")) {
        var bt = new (ie.vttjs.VTTRegion || ie.window.VTTRegion)();
        bt.width = vt.get("width", 100), bt.lines = vt.get("lines", 3), bt.regionAnchorX = vt.get("regionanchorX", 0), bt.regionAnchorY = vt.get("regionanchorY", 100), bt.viewportAnchorX = vt.get("viewportanchorX", 0), bt.viewportAnchorY = vt.get("viewportanchorY", 100), bt.scroll = vt.get("scroll", ""), ie.onregion && ie.onregion(bt), ie.regionList.push({
          id: vt.get("id"),
          region: bt
        });
      }
    }
    function Re(ot) {
      var vt = new Ar();
      xr(ot, function(bt, Tt) {
        switch (bt) {
          case "MPEGT":
            vt.integer(bt + "S", Tt);
            break;
          case "LOCA":
            vt.set(bt + "L", gu(Tt));
            break;
        }
      }, /[^\d]:/, /,/), ie.ontimestampmap && ie.ontimestampmap({
        MPEGTS: vt.get("MPEGTS"),
        LOCAL: vt.get("LOCAL")
      });
    }
    function je(ot) {
      ot.match(/X-TIMESTAMP-MAP/) ? xr(ot, function(vt, bt) {
        switch (vt) {
          case "X-TIMESTAMP-MAP":
            Re(bt);
            break;
        }
      }, /=/) : xr(ot, function(vt, bt) {
        switch (vt) {
          case "Region":
            we(bt);
            break;
        }
      }, /:/);
    }
    try {
      var Ue;
      if (ie.state === "INITIAL") {
        if (!/\r\n|\n/.test(ie.buffer))
          return this;
        Ue = me();
        var qe = Ue.match(/^WEBVTT([ \t].*)?$/);
        if (!qe || !qe[0])
          throw new ct(ct.Errors.BadSignature);
        ie.state = "HEADER";
      }
      for (var Ge = !1; ie.buffer; ) {
        if (!/\r\n|\n/.test(ie.buffer))
          return this;
        switch (Ge ? Ge = !1 : Ue = me(), ie.state) {
          case "HEADER":
            /:/.test(Ue) ? je(Ue) : Ue || (ie.state = "ID");
            continue;
          case "NOTE":
            Ue || (ie.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(Ue)) {
              ie.state = "NOTE";
              break;
            }
            if (!Ue)
              continue;
            ie.cue = new (ie.vttjs.VTTCue || ie.window.VTTCue)(0, 0, "");
            try {
              ie.cue.align = "center";
            } catch {
              ie.cue.align = "middle";
            }
            if (ie.state = "CUE", Ue.indexOf("-->") === -1) {
              ie.cue.id = Ue;
              continue;
            }
          // Process line as start of a cue.
          /*falls through*/
          case "CUE":
            try {
              m0(Ue, ie.cue, ie.regionList);
            } catch (ot) {
              ie.reportOrThrowError(ot), ie.cue = null, ie.state = "BADCUE";
              continue;
            }
            ie.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var Xe = Ue.indexOf("-->") !== -1;
            if (!Ue || Xe && (Ge = !0)) {
              ie.oncue && ie.oncue(ie.cue), ie.cue = null, ie.state = "ID";
              continue;
            }
            ie.cue.text && (ie.cue.text += `
`), ie.cue.text += Ue.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            Ue || (ie.state = "ID");
            continue;
        }
      }
    } catch (ot) {
      ie.reportOrThrowError(ot), ie.state === "CUETEXT" && ie.cue && ie.oncue && ie.oncue(ie.cue), ie.cue = null, ie.state = ie.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var ce = this;
    try {
      if (ce.buffer += ce.decoder.decode(), (ce.cue || ce.state === "HEADER") && (ce.buffer += `

`, ce.parse()), ce.state === "INITIAL")
        throw new ct(ct.Errors.BadSignature);
    } catch (ie) {
      ce.reportOrThrowError(ie);
    }
    return ce.onflush && ce.onflush(), this;
  }
};
var C0 = Ds, A0 = "auto", D0 = {
  "": 1,
  lr: 1,
  rl: 1
}, w0 = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function k0(ce) {
  if (typeof ce != "string")
    return !1;
  var ie = D0[ce.toLowerCase()];
  return ie ? ce.toLowerCase() : !1;
}
function mo(ce) {
  if (typeof ce != "string")
    return !1;
  var ie = w0[ce.toLowerCase()];
  return ie ? ce.toLowerCase() : !1;
}
function Bd(ce, ie, me) {
  this.hasBeenReset = !1;
  var we = "", Re = !1, je = ce, Ue = ie, qe = me, Ge = null, Xe = "", ot = !0, vt = "auto", bt = "start", Tt = "auto", wt = "auto", St = 100, It = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return we;
      },
      set: function(Pt) {
        we = "" + Pt;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return Re;
      },
      set: function(Pt) {
        Re = !!Pt;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return je;
      },
      set: function(Pt) {
        if (typeof Pt != "number")
          throw new TypeError("Start time must be set to a number.");
        je = Pt, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return Ue;
      },
      set: function(Pt) {
        if (typeof Pt != "number")
          throw new TypeError("End time must be set to a number.");
        Ue = Pt, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return qe;
      },
      set: function(Pt) {
        qe = "" + Pt, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return Ge;
      },
      set: function(Pt) {
        Ge = Pt, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return Xe;
      },
      set: function(Pt) {
        var kt = k0(Pt);
        if (kt === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        Xe = kt, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return ot;
      },
      set: function(Pt) {
        ot = !!Pt, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return vt;
      },
      set: function(Pt) {
        if (typeof Pt != "number" && Pt !== A0)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        vt = Pt, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return bt;
      },
      set: function(Pt) {
        var kt = mo(Pt);
        kt ? (bt = kt, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return Tt;
      },
      set: function(Pt) {
        if (Pt < 0 || Pt > 100)
          throw new Error("Position must be between 0 and 100.");
        Tt = Pt, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return wt;
      },
      set: function(Pt) {
        var kt = mo(Pt);
        kt ? (wt = kt, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return St;
      },
      set: function(Pt) {
        if (Pt < 0 || Pt > 100)
          throw new Error("Size must be between 0 and 100.");
        St = Pt, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return It;
      },
      set: function(Pt) {
        var kt = mo(Pt);
        if (!kt)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        It = kt, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
Bd.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var I0 = Bd, P0 = {
  "": !0,
  up: !0
};
function O0(ce) {
  if (typeof ce != "string")
    return !1;
  var ie = P0[ce.toLowerCase()];
  return ie ? ce.toLowerCase() : !1;
}
function fr$1(ce) {
  return typeof ce == "number" && ce >= 0 && ce <= 100;
}
function L0() {
  var ce = 100, ie = 3, me = 0, we = 100, Re = 0, je = 100, Ue = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return ce;
      },
      set: function(qe) {
        if (!fr$1(qe))
          throw new Error("Width must be between 0 and 100.");
        ce = qe;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return ie;
      },
      set: function(qe) {
        if (typeof qe != "number")
          throw new TypeError("Lines must be set to a number.");
        ie = qe;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return we;
      },
      set: function(qe) {
        if (!fr$1(qe))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        we = qe;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return me;
      },
      set: function(qe) {
        if (!fr$1(qe))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        me = qe;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return je;
      },
      set: function(qe) {
        if (!fr$1(qe))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        je = qe;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return Re;
      },
      set: function(qe) {
        if (!fr$1(qe))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        Re = qe;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return Ue;
      },
      set: function(qe) {
        var Ge = O0(qe);
        Ge === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : Ue = Ge;
      }
    }
  });
}
var R0 = L0, Qt = ma, Bi = Md.exports = {
  WebVTT: C0,
  VTTCue: I0,
  VTTRegion: R0
};
Qt.vttjs = Bi;
Qt.WebVTT = Bi.WebVTT;
var M0 = Bi.VTTCue, N0 = Bi.VTTRegion, B0 = Qt.VTTCue, F0 = Qt.VTTRegion;
Bi.shim = function() {
  Qt.VTTCue = M0, Qt.VTTRegion = N0;
};
Bi.restore = function() {
  Qt.VTTCue = B0, Qt.VTTRegion = F0;
};
Qt.VTTCue || Bi.shim();
var U0 = Md.exports;
const ac = /* @__PURE__ */ jr(U0);
function Oe$1() {
  return Oe$1 = Object.assign ? Object.assign.bind() : function(ce) {
    for (var ie = 1; ie < arguments.length; ie++) {
      var me = arguments[ie];
      for (var we in me) ({}).hasOwnProperty.call(me, we) && (ce[we] = me[we]);
    }
    return ce;
  }, Oe$1.apply(null, arguments);
}
var oc = "https://example.com", _a = function(ce, ie) {
  if (/^[a-z]+:/i.test(ie))
    return ie;
  /^data:/.test(ce) && (ce = S.location && S.location.href || "");
  var me = /^\/\//.test(ce), we = !S.location && !/\/\//i.test(ce);
  ce = new S.URL(ce, S.location || oc);
  var Re = new URL(ie, ce);
  return we ? Re.href.slice(oc.length) : me ? Re.href.slice(Re.protocol.length) : Re.href;
}, _u = /* @__PURE__ */ function() {
  function ce() {
    this.listeners = {};
  }
  var ie = ce.prototype;
  return ie.on = function(me, we) {
    this.listeners[me] || (this.listeners[me] = []), this.listeners[me].push(we);
  }, ie.off = function(me, we) {
    if (!this.listeners[me])
      return !1;
    var Re = this.listeners[me].indexOf(we);
    return this.listeners[me] = this.listeners[me].slice(0), this.listeners[me].splice(Re, 1), Re > -1;
  }, ie.trigger = function(me) {
    var we = this.listeners[me];
    if (we)
      if (arguments.length === 2)
        for (var Re = we.length, je = 0; je < Re; ++je)
          we[je].call(this, arguments[1]);
      else
        for (var Ue = Array.prototype.slice.call(arguments, 1), qe = we.length, Ge = 0; Ge < qe; ++Ge)
          we[Ge].apply(this, Ue);
  }, ie.dispose = function() {
    this.listeners = {};
  }, ie.pipe = function(me) {
    this.on("data", function(we) {
      me.push(we);
    });
  }, ce;
}(), $0 = function(ce) {
  return S.atob ? S.atob(ce) : Buffer.from(ce, "base64").toString("binary");
};
function Fd(ce) {
  for (var ie = $0(ce), me = new Uint8Array(ie.length), we = 0; we < ie.length; we++)
    me[we] = ie.charCodeAt(we);
  return me;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class j0 extends _u {
  constructor() {
    super(), this.buffer = "";
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */
  push(ie) {
    let me;
    for (this.buffer += ie, me = this.buffer.indexOf(`
`); me > -1; me = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, me)), this.buffer = this.buffer.substring(me + 1);
  }
}
const q0 = "	", go = function(ce) {
  const ie = /([0-9.]*)?@?([0-9.]*)?/.exec(ce || ""), me = {};
  return ie[1] && (me.length = parseInt(ie[1], 10)), ie[2] && (me.offset = parseInt(ie[2], 10)), me;
}, V0 = function() {
  const ce = '(?:[^=]*)=(?:"[^"]*"|[^,]*)';
  return new RegExp("(?:^|,)(" + ce + ")");
}, Ke = function(ce) {
  const ie = {};
  if (!ce)
    return ie;
  const me = ce.split(V0());
  let we = me.length, Re;
  for (; we--; )
    me[we] !== "" && (Re = /([^=]*)=(.*)/.exec(me[we]).slice(1), Re[0] = Re[0].replace(/^\s+|\s+$/g, ""), Re[1] = Re[1].replace(/^\s+|\s+$/g, ""), Re[1] = Re[1].replace(/^['"](.*)['"]$/g, "$1"), ie[Re[0]] = Re[1]);
  return ie;
}, uc = (ce) => {
  const ie = ce.split("x"), me = {};
  return ie[0] && (me.width = parseInt(ie[0], 10)), ie[1] && (me.height = parseInt(ie[1], 10)), me;
};
class H0 extends _u {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */
  push(ie) {
    let me, we;
    if (ie = ie.trim(), ie.length !== 0) {
      if (ie[0] !== "#") {
        this.trigger("data", {
          type: "uri",
          uri: ie
        });
        return;
      }
      this.tagMappers.reduce((Re, je) => {
        const Ue = je(ie);
        return Ue === ie ? Re : Re.concat([Ue]);
      }, [ie]).forEach((Re) => {
        for (let je = 0; je < this.customParsers.length; je++)
          if (this.customParsers[je].call(this, Re))
            return;
        if (Re.indexOf("#EXT") !== 0) {
          this.trigger("data", {
            type: "comment",
            text: Re.slice(1)
          });
          return;
        }
        if (Re = Re.replace("\r", ""), me = /^#EXTM3U/.exec(Re), me) {
          this.trigger("data", {
            type: "tag",
            tagType: "m3u"
          });
          return;
        }
        if (me = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "inf"
          }, me[1] && (we.duration = parseFloat(me[1])), me[2] && (we.title = me[2]), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "targetduration"
          }, me[1] && (we.duration = parseInt(me[1], 10)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-VERSION:([0-9.]*)?/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "version"
          }, me[1] && (we.version = parseInt(me[1], 10)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "media-sequence"
          }, me[1] && (we.number = parseInt(me[1], 10)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "discontinuity-sequence"
          }, me[1] && (we.number = parseInt(me[1], 10)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "playlist-type"
          }, me[1] && (we.playlistType = me[1]), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-BYTERANGE:(.*)?$/.exec(Re), me) {
          we = Oe$1(go(me[1]), {
            type: "tag",
            tagType: "byterange"
          }), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "allow-cache"
          }, me[1] && (we.allowed = !/NO/.test(me[1])), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-MAP:(.*)$/.exec(Re), me) {
          if (we = {
            type: "tag",
            tagType: "map"
          }, me[1]) {
            const je = Ke(me[1]);
            je.URI && (we.uri = je.URI), je.BYTERANGE && (we.byterange = go(je.BYTERANGE));
          }
          this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-STREAM-INF:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "stream-inf"
          }, me[1] && (we.attributes = Ke(me[1]), we.attributes.RESOLUTION && (we.attributes.RESOLUTION = uc(we.attributes.RESOLUTION)), we.attributes.BANDWIDTH && (we.attributes.BANDWIDTH = parseInt(we.attributes.BANDWIDTH, 10)), we.attributes["FRAME-RATE"] && (we.attributes["FRAME-RATE"] = parseFloat(we.attributes["FRAME-RATE"])), we.attributes["PROGRAM-ID"] && (we.attributes["PROGRAM-ID"] = parseInt(we.attributes["PROGRAM-ID"], 10))), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-MEDIA:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "media"
          }, me[1] && (we.attributes = Ke(me[1])), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-ENDLIST/.exec(Re), me) {
          this.trigger("data", {
            type: "tag",
            tagType: "endlist"
          });
          return;
        }
        if (me = /^#EXT-X-DISCONTINUITY/.exec(Re), me) {
          this.trigger("data", {
            type: "tag",
            tagType: "discontinuity"
          });
          return;
        }
        if (me = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "program-date-time"
          }, me[1] && (we.dateTimeString = me[1], we.dateTimeObject = new Date(me[1])), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-KEY:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "key"
          }, me[1] && (we.attributes = Ke(me[1]), we.attributes.IV && (we.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (we.attributes.IV = we.attributes.IV.substring(2)), we.attributes.IV = we.attributes.IV.match(/.{8}/g), we.attributes.IV[0] = parseInt(we.attributes.IV[0], 16), we.attributes.IV[1] = parseInt(we.attributes.IV[1], 16), we.attributes.IV[2] = parseInt(we.attributes.IV[2], 16), we.attributes.IV[3] = parseInt(we.attributes.IV[3], 16), we.attributes.IV = new Uint32Array(we.attributes.IV))), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-START:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "start"
          }, me[1] && (we.attributes = Ke(me[1]), we.attributes["TIME-OFFSET"] = parseFloat(we.attributes["TIME-OFFSET"]), we.attributes.PRECISE = /YES/.test(we.attributes.PRECISE)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "cue-out-cont"
          }, me[1] ? we.data = me[1] : we.data = "", this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-CUE-OUT:(.*)?$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "cue-out"
          }, me[1] ? we.data = me[1] : we.data = "", this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-CUE-IN:?(.*)?$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "cue-in"
          }, me[1] ? we.data = me[1] : we.data = "", this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-SKIP:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "skip"
          }, we.attributes = Ke(me[1]), we.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (we.attributes["SKIPPED-SEGMENTS"] = parseInt(we.attributes["SKIPPED-SEGMENTS"], 10)), we.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (we.attributes["RECENTLY-REMOVED-DATERANGES"] = we.attributes["RECENTLY-REMOVED-DATERANGES"].split(q0)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-PART:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "part"
          }, we.attributes = Ke(me[1]), ["DURATION"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = parseFloat(we.attributes[je]));
          }), ["INDEPENDENT", "GAP"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = /YES/.test(we.attributes[je]));
          }), we.attributes.hasOwnProperty("BYTERANGE") && (we.attributes.byterange = go(we.attributes.BYTERANGE)), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "server-control"
          }, we.attributes = Ke(me[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = parseFloat(we.attributes[je]));
          }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = /YES/.test(we.attributes[je]));
          }), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-PART-INF:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "part-inf"
          }, we.attributes = Ke(me[1]), ["PART-TARGET"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = parseFloat(we.attributes[je]));
          }), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "preload-hint"
          }, we.attributes = Ke(me[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(je) {
            if (we.attributes.hasOwnProperty(je)) {
              we.attributes[je] = parseInt(we.attributes[je], 10);
              const Ue = je === "BYTERANGE-LENGTH" ? "length" : "offset";
              we.attributes.byterange = we.attributes.byterange || {}, we.attributes.byterange[Ue] = we.attributes[je], delete we.attributes[je];
            }
          }), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "rendition-report"
          }, we.attributes = Ke(me[1]), ["LAST-MSN", "LAST-PART"].forEach(function(je) {
            we.attributes.hasOwnProperty(je) && (we.attributes[je] = parseInt(we.attributes[je], 10));
          }), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-DATERANGE:(.*)$/.exec(Re), me && me[1]) {
          we = {
            type: "tag",
            tagType: "daterange"
          }, we.attributes = Ke(me[1]), ["ID", "CLASS"].forEach(function(Ue) {
            we.attributes.hasOwnProperty(Ue) && (we.attributes[Ue] = String(we.attributes[Ue]));
          }), ["START-DATE", "END-DATE"].forEach(function(Ue) {
            we.attributes.hasOwnProperty(Ue) && (we.attributes[Ue] = new Date(we.attributes[Ue]));
          }), ["DURATION", "PLANNED-DURATION"].forEach(function(Ue) {
            we.attributes.hasOwnProperty(Ue) && (we.attributes[Ue] = parseFloat(we.attributes[Ue]));
          }), ["END-ON-NEXT"].forEach(function(Ue) {
            we.attributes.hasOwnProperty(Ue) && (we.attributes[Ue] = /YES/i.test(we.attributes[Ue]));
          }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(Ue) {
            we.attributes.hasOwnProperty(Ue) && (we.attributes[Ue] = we.attributes[Ue].toString(16));
          });
          const je = /^X-([A-Z]+-)+[A-Z]+$/;
          for (const Ue in we.attributes) {
            if (!je.test(Ue))
              continue;
            const qe = /[0-9A-Fa-f]{6}/g.test(we.attributes[Ue]), Ge = /^\d+(\.\d+)?$/.test(we.attributes[Ue]);
            we.attributes[Ue] = qe ? we.attributes[Ue].toString(16) : Ge ? parseFloat(we.attributes[Ue]) : String(we.attributes[Ue]);
          }
          this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(Re), me) {
          this.trigger("data", {
            type: "tag",
            tagType: "independent-segments"
          });
          return;
        }
        if (me = /^#EXT-X-I-FRAMES-ONLY/.exec(Re), me) {
          this.trigger("data", {
            type: "tag",
            tagType: "i-frames-only"
          });
          return;
        }
        if (me = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "content-steering"
          }, we.attributes = Ke(me[1]), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "i-frame-playlist"
          }, we.attributes = Ke(me[1]), we.attributes.URI && (we.uri = we.attributes.URI), we.attributes.BANDWIDTH && (we.attributes.BANDWIDTH = parseInt(we.attributes.BANDWIDTH, 10)), we.attributes.RESOLUTION && (we.attributes.RESOLUTION = uc(we.attributes.RESOLUTION)), we.attributes["AVERAGE-BANDWIDTH"] && (we.attributes["AVERAGE-BANDWIDTH"] = parseInt(we.attributes["AVERAGE-BANDWIDTH"], 10)), we.attributes["FRAME-RATE"] && (we.attributes["FRAME-RATE"] = parseFloat(we.attributes["FRAME-RATE"])), this.trigger("data", we);
          return;
        }
        if (me = /^#EXT-X-DEFINE:(.*)$/.exec(Re), me) {
          we = {
            type: "tag",
            tagType: "define"
          }, we.attributes = Ke(me[1]), this.trigger("data", we);
          return;
        }
        this.trigger("data", {
          type: "tag",
          data: Re.slice(4)
        });
      });
    }
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser({
    expression: ie,
    customType: me,
    dataParser: we,
    segment: Re
  }) {
    typeof we != "function" && (we = (je) => je), this.customParsers.push((je) => {
      if (ie.exec(je))
        return this.trigger("data", {
          type: "custom",
          data: we(je),
          customType: me,
          segment: Re
        }), !0;
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper({
    expression: ie,
    map: me
  }) {
    const we = (Re) => ie.test(Re) ? me(Re) : Re;
    this.tagMappers.push(we);
  }
}
const z0 = (ce) => ce.toLowerCase().replace(/-(\w)/g, (ie) => ie[1].toUpperCase()), oi = function(ce) {
  const ie = {};
  return Object.keys(ce).forEach(function(me) {
    ie[z0(me)] = ce[me];
  }), ie;
}, _o = function(ce) {
  const {
    serverControl: ie,
    targetDuration: me,
    partTargetDuration: we
  } = ce;
  if (!ie)
    return;
  const Re = "#EXT-X-SERVER-CONTROL", je = "holdBack", Ue = "partHoldBack", qe = me && me * 3, Ge = we && we * 2;
  me && !ie.hasOwnProperty(je) && (ie[je] = qe, this.trigger("info", {
    message: `${Re} defaulting HOLD-BACK to targetDuration * 3 (${qe}).`
  })), qe && ie[je] < qe && (this.trigger("warn", {
    message: `${Re} clamping HOLD-BACK (${ie[je]}) to targetDuration * 3 (${qe})`
  }), ie[je] = qe), we && !ie.hasOwnProperty(Ue) && (ie[Ue] = we * 3, this.trigger("info", {
    message: `${Re} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${ie[Ue]}).`
  })), we && ie[Ue] < Ge && (this.trigger("warn", {
    message: `${Re} clamping PART-HOLD-BACK (${ie[Ue]}) to partTargetDuration * 2 (${Ge}).`
  }), ie[Ue] = Ge);
};
class W0 extends _u {
  constructor(ie = {}) {
    super(), this.lineStream = new j0(), this.parseStream = new H0(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = ie.mainDefinitions || {}, this.params = new URL(ie.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const me = this, we = [];
    let Re = {}, je, Ue, qe = !1;
    const Ge = function() {
    }, Xe = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, ot = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let vt = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let bt = 0, Tt = 0;
    const wt = {};
    this.on("end", () => {
      Re.uri || !Re.parts && !Re.preloadHints || (!Re.map && je && (Re.map = je), !Re.key && Ue && (Re.key = Ue), !Re.timeline && typeof vt == "number" && (Re.timeline = vt), this.manifest.preloadSegment = Re);
    }), this.parseStream.on("data", function(St) {
      let It, Pt;
      if (me.manifest.definitions) {
        for (const kt in me.manifest.definitions)
          if (St.uri && (St.uri = St.uri.replace(`{$${kt}}`, me.manifest.definitions[kt])), St.attributes)
            for (const Ot in St.attributes)
              typeof St.attributes[Ot] == "string" && (St.attributes[Ot] = St.attributes[Ot].replace(`{$${kt}}`, me.manifest.definitions[kt]));
      }
      ({
        tag() {
          ({
            version() {
              St.version && (this.manifest.version = St.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = St.allowed, "allowed" in St || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const kt = {};
              "length" in St && (Re.byterange = kt, kt.length = St.length, "offset" in St || (St.offset = bt)), "offset" in St && (Re.byterange = kt, kt.offset = St.offset), bt = kt.offset + kt.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), St.title && (Re.title = St.title), St.duration > 0 && (Re.duration = St.duration), St.duration === 0 && (Re.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = we;
            },
            key() {
              if (!St.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (St.attributes.METHOD === "NONE") {
                Ue = null;
                return;
              }
              if (!St.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (St.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: St.attributes
                };
                return;
              }
              if (St.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: St.attributes.URI
                };
                return;
              }
              if (St.attributes.KEYFORMAT === ot) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(St.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (St.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), St.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(St.attributes.KEYID && St.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: St.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: St.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: Fd(St.attributes.URI.split(",")[1])
                };
                return;
              }
              St.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), Ue = {
                method: St.attributes.METHOD || "AES-128",
                uri: St.attributes.URI
              }, typeof St.attributes.IV < "u" && (Ue.iv = St.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(St.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + St.number
                });
                return;
              }
              this.manifest.mediaSequence = St.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(St.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + St.number
                });
                return;
              }
              this.manifest.discontinuitySequence = St.number, vt = St.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(St.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + St.playlist
                });
                return;
              }
              this.manifest.playlistType = St.playlistType;
            },
            map() {
              je = {}, St.uri && (je.uri = St.uri), St.byterange && (je.byterange = St.byterange), Ue && (je.key = Ue);
            },
            "stream-inf"() {
              if (this.manifest.playlists = we, this.manifest.mediaGroups = this.manifest.mediaGroups || Xe, !St.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              Re.attributes || (Re.attributes = {}), Oe$1(Re.attributes, St.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || Xe, !(St.attributes && St.attributes.TYPE && St.attributes["GROUP-ID"] && St.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const kt = this.manifest.mediaGroups[St.attributes.TYPE];
              kt[St.attributes["GROUP-ID"]] = kt[St.attributes["GROUP-ID"]] || {}, It = kt[St.attributes["GROUP-ID"]], Pt = {
                default: /yes/i.test(St.attributes.DEFAULT)
              }, Pt.default ? Pt.autoselect = !0 : Pt.autoselect = /yes/i.test(St.attributes.AUTOSELECT), St.attributes.LANGUAGE && (Pt.language = St.attributes.LANGUAGE), St.attributes.URI && (Pt.uri = St.attributes.URI), St.attributes["INSTREAM-ID"] && (Pt.instreamId = St.attributes["INSTREAM-ID"]), St.attributes.CHARACTERISTICS && (Pt.characteristics = St.attributes.CHARACTERISTICS), St.attributes.FORCED && (Pt.forced = /yes/i.test(St.attributes.FORCED)), It[St.attributes.NAME] = Pt;
            },
            discontinuity() {
              vt += 1, Re.discontinuity = !0, this.manifest.discontinuityStarts.push(we.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = St.dateTimeString, this.manifest.dateTimeObject = St.dateTimeObject), Re.dateTimeString = St.dateTimeString, Re.dateTimeObject = St.dateTimeObject;
              const {
                lastProgramDateTime: kt
              } = this;
              this.lastProgramDateTime = new Date(St.dateTimeString).getTime(), kt === null && this.manifest.segments.reduceRight((Ot, Jr) => (Jr.programDateTime = Ot - Jr.duration * 1e3, Jr.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(St.duration) || St.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + St.duration
                });
                return;
              }
              this.manifest.targetDuration = St.duration, _o.call(this, this.manifest);
            },
            start() {
              if (!St.attributes || isNaN(St.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: St.attributes["TIME-OFFSET"],
                precise: St.attributes.PRECISE
              };
            },
            "cue-out"() {
              Re.cueOut = St.data;
            },
            "cue-out-cont"() {
              Re.cueOutCont = St.data;
            },
            "cue-in"() {
              Re.cueIn = St.data;
            },
            skip() {
              this.manifest.skip = oi(St.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", St.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              qe = !0;
              const kt = this.manifest.segments.length, Ot = oi(St.attributes);
              Re.parts = Re.parts || [], Re.parts.push(Ot), Ot.byterange && (Ot.byterange.hasOwnProperty("offset") || (Ot.byterange.offset = Tt), Tt = Ot.byterange.offset + Ot.byterange.length);
              const Jr = Re.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${Jr} for segment #${kt}`, St.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((en, nn) => {
                en.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${nn} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const kt = this.manifest.serverControl = oi(St.attributes);
              kt.hasOwnProperty("canBlockReload") || (kt.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), _o.call(this, this.manifest), kt.canSkipDateranges && !kt.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const kt = this.manifest.segments.length, Ot = oi(St.attributes), Jr = Ot.type && Ot.type === "PART";
              Re.preloadHints = Re.preloadHints || [], Re.preloadHints.push(Ot), Ot.byterange && (Ot.byterange.hasOwnProperty("offset") || (Ot.byterange.offset = Jr ? Tt : 0, Jr && (Tt = Ot.byterange.offset + Ot.byterange.length)));
              const en = Re.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${en} for segment #${kt}`, St.attributes, ["TYPE", "URI"]), !!Ot.type)
                for (let nn = 0; nn < Re.preloadHints.length - 1; nn++) {
                  const ln = Re.preloadHints[nn];
                  ln.type && ln.type === Ot.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${en} for segment #${kt} has the same TYPE ${Ot.type} as preload hint #${nn}`
                  });
                }
            },
            "rendition-report"() {
              const kt = oi(St.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(kt);
              const Ot = this.manifest.renditionReports.length - 1, Jr = ["LAST-MSN", "URI"];
              qe && Jr.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${Ot}`, St.attributes, Jr);
            },
            "part-inf"() {
              this.manifest.partInf = oi(St.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", St.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), _o.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push(oi(St.attributes));
              const kt = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${kt}`, St.attributes, ["ID", "START-DATE"]);
              const Ot = this.manifest.dateRanges[kt];
              Ot.endDate && Ot.startDate && new Date(Ot.endDate) < new Date(Ot.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), Ot.duration && Ot.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), Ot.plannedDuration && Ot.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const Jr = !!Ot.endOnNext;
              if (Jr && !Ot.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), Jr && (Ot.duration || Ot.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), Ot.duration && Ot.endDate) {
                const en = Ot.startDate.getTime() + Ot.duration * 1e3;
                this.manifest.dateRanges[kt].endDate = new Date(en);
              }
              if (!wt[Ot.id])
                wt[Ot.id] = Ot;
              else {
                for (const nn in wt[Ot.id])
                  if (Ot[nn] && JSON.stringify(wt[Ot.id][nn]) !== JSON.stringify(Ot[nn])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const en = this.manifest.dateRanges.findIndex((nn) => nn.id === Ot.id);
                this.manifest.dateRanges[en] = Oe$1(this.manifest.dateRanges[en], Ot), wt[Ot.id] = Oe$1(wt[Ot.id], Ot), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = oi(St.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", St.attributes, ["SERVER-URI"]);
            },
            /** @this {Parser} */
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const kt = (Ot, Jr) => {
                if (Ot in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${Ot}`
                  });
                  return;
                }
                this.manifest.definitions[Ot] = Jr;
              };
              if ("QUERYPARAM" in St.attributes) {
                if ("NAME" in St.attributes || "IMPORT" in St.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const Ot = this.params.get(St.attributes.QUERYPARAM);
                if (!Ot) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${St.attributes.QUERYPARAM}`
                  });
                  return;
                }
                kt(St.attributes.QUERYPARAM, decodeURIComponent(Ot));
                return;
              }
              if ("NAME" in St.attributes) {
                if ("IMPORT" in St.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in St.attributes) || typeof St.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${St.attributes.NAME}`
                  });
                  return;
                }
                kt(St.attributes.NAME, St.attributes.VALUE);
                return;
              }
              if ("IMPORT" in St.attributes) {
                if (!this.mainDefinitions[St.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${St.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                kt(St.attributes.IMPORT, this.mainDefinitions[St.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: St.attributes,
                uri: St.uri,
                timeline: vt
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", St.attributes, ["BANDWIDTH", "URI"]);
            }
          }[St.tagType] || Ge).call(me);
        },
        uri() {
          Re.uri = St.uri, we.push(Re), this.manifest.targetDuration && !("duration" in Re) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), Re.duration = this.manifest.targetDuration), Ue && (Re.key = Ue), Re.timeline = vt, je && (Re.map = je), Tt = 0, this.lastProgramDateTime !== null && (Re.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += Re.duration * 1e3), Re = {};
        },
        comment() {
        },
        custom() {
          St.segment ? (Re.custom = Re.custom || {}, Re.custom[St.customType] = St.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[St.customType] = St.data);
        }
      })[St.type].call(me);
    });
  }
  requiredCompatibilityversion(ie, me) {
    (ie < me || !ie) && this.trigger("warn", {
      message: `manifest must be at least version ${me}`
    });
  }
  warnOnMissingAttributes_(ie, me, we) {
    const Re = [];
    we.forEach(function(je) {
      me.hasOwnProperty(je) || Re.push(je);
    }), Re.length && this.trigger("warn", {
      message: `${ie} lacks required attribute(s): ${Re.join(", ")}`
    });
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */
  push(ie) {
    this.lineStream.push(ie);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser(ie) {
    this.parseStream.addParser(ie);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper(ie) {
    this.parseStream.addTagMapper(ie);
  }
}
var ki = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, G0 = ["video", "audio", "text"], lc = ["Video", "Audio", "Text"], Ud = function(ce) {
  return ce && ce.replace(/avc1\.(\d+)\.(\d+)/i, function(ie, me, we) {
    var Re = ("00" + Number(me).toString(16)).slice(-2), je = ("00" + Number(we).toString(16)).slice(-2);
    return "avc1." + Re + "00" + je;
  });
}, Rt = function(ce) {
  ce === void 0 && (ce = "");
  var ie = ce.split(","), me = [];
  return ie.forEach(function(we) {
    we = we.trim();
    var Re;
    G0.forEach(function(je) {
      var Ue = ki[je].exec(we.toLowerCase());
      if (!(!Ue || Ue.length <= 1)) {
        Re = je;
        var qe = we.substring(0, Ue[1].length), Ge = we.replace(qe, "");
        me.push({
          type: qe,
          details: Ge,
          mediaType: je
        });
      }
    }), Re || me.push({
      type: we,
      details: "",
      mediaType: "unknown"
    });
  }), me;
}, X0 = function(ce, ie) {
  if (!ce.mediaGroups.AUDIO || !ie)
    return null;
  var me = ce.mediaGroups.AUDIO[ie];
  if (!me)
    return null;
  for (var we in me) {
    var Re = me[we];
    if (Re.default && Re.playlists)
      return Rt(Re.playlists[0].attributes.CODECS);
  }
  return null;
}, $d = function(ce) {
  return ce === void 0 && (ce = ""), ki.audio.test(ce.trim().toLowerCase());
}, K0 = function(ce) {
  return ce === void 0 && (ce = ""), ki.text.test(ce.trim().toLowerCase());
}, ms = function(ce) {
  if (!(!ce || typeof ce != "string")) {
    var ie = ce.toLowerCase().split(",").map(function(Re) {
      return Ud(Re.trim());
    }), me = "video";
    ie.length === 1 && $d(ie[0]) ? me = "audio" : ie.length === 1 && K0(ie[0]) && (me = "application");
    var we = "mp4";
    return ie.every(function(Re) {
      return ki.mp4.test(Re);
    }) ? we = "mp4" : ie.every(function(Re) {
      return ki.webm.test(Re);
    }) ? we = "webm" : ie.every(function(Re) {
      return ki.ogg.test(Re);
    }) && (we = "ogg"), me + "/" + we + ';codecs="' + ce + '"';
  }
}, Dr = function(ce, ie) {
  return ce === void 0 && (ce = ""), ie === void 0 && (ie = !1), S.MediaSource && S.MediaSource.isTypeSupported && S.MediaSource.isTypeSupported(ms(ce)) || ie && S.ManagedMediaSource && S.ManagedMediaSource.isTypeSupported && S.ManagedMediaSource.isTypeSupported(ms(ce)) || !1;
}, yo = function(ce) {
  return ce === void 0 && (ce = ""), ce.toLowerCase().split(",").every(function(ie) {
    ie = ie.trim();
    for (var me = 0; me < lc.length; me++) {
      var we = lc[me];
      if (ki["muxer" + we].test(ie))
        return !0;
    }
    return !1;
  });
}, cc = "mp4a.40.2", Y0 = "avc1.4d400d", Q0 = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, J0 = /^application\/dash\+xml/i, jd = function(ce) {
  return Q0.test(ce) ? "hls" : J0.test(ce) ? "dash" : ce === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, Z0 = function(ce) {
  return ce.toString(2).length;
}, e_ = function(ce) {
  return Math.ceil(Z0(ce) / 8);
}, qd = function(ce) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(ce) : ce && ce.buffer instanceof ArrayBuffer;
}, t_ = function(ce) {
  return qd(ce);
}, Y$1 = function(ce) {
  return ce instanceof Uint8Array ? ce : (!Array.isArray(ce) && !t_(ce) && !(ce instanceof ArrayBuffer) && (typeof ce != "number" || typeof ce == "number" && ce !== ce ? ce = 0 : ce = [ce]), new Uint8Array(ce && ce.buffer || ce, ce && ce.byteOffset || 0, ce && ce.byteLength || 0));
}, $e = S.BigInt || Number, Bo = [$e("0x1"), $e("0x100"), $e("0x10000"), $e("0x1000000"), $e("0x100000000"), $e("0x10000000000"), $e("0x1000000000000"), $e("0x100000000000000"), $e("0x10000000000000000")];
(function() {
  var ce = new Uint16Array([65484]), ie = new Uint8Array(ce.buffer, ce.byteOffset, ce.byteLength);
  return ie[0] === 255 ? "big" : ie[0] === 204 ? "little" : "unknown";
})();
var i_ = function(ce, ie) {
  var me = ie === void 0 ? {} : ie, we = me.signed, Re = we === void 0 ? !1 : we, je = me.le, Ue = je === void 0 ? !1 : je;
  ce = Y$1(ce);
  var qe = Ue ? "reduce" : "reduceRight", Ge = ce[qe] ? ce[qe] : Array.prototype[qe], Xe = Ge.call(ce, function(vt, bt, Tt) {
    var wt = Ue ? Tt : Math.abs(Tt + 1 - ce.length);
    return vt + $e(bt) * Bo[wt];
  }, $e(0));
  if (Re) {
    var ot = Bo[ce.length] / $e(2) - $e(1);
    Xe = $e(Xe), Xe > ot && (Xe -= ot, Xe -= ot, Xe -= $e(2));
  }
  return Number(Xe);
}, s_ = function(ce, ie) {
  var me = {}, we = me.le, Re = we === void 0 ? !1 : we;
  (typeof ce != "bigint" && typeof ce != "number" || typeof ce == "number" && ce !== ce) && (ce = 0), ce = $e(ce);
  for (var je = e_(ce), Ue = new Uint8Array(new ArrayBuffer(je)), qe = 0; qe < je; qe++) {
    var Ge = Re ? qe : Math.abs(qe + 1 - Ue.length);
    Ue[Ge] = Number(ce / Bo[qe] & $e(255)), ce < 0 && (Ue[Ge] = Math.abs(~Ue[Ge]), Ue[Ge] -= qe === 0 ? 1 : 2);
  }
  return Ue;
}, Vd = function(ce, ie) {
  if (typeof ce != "string" && ce && typeof ce.toString == "function" && (ce = ce.toString()), typeof ce != "string")
    return new Uint8Array();
  ie || (ce = unescape(encodeURIComponent(ce)));
  for (var me = new Uint8Array(ce.length), we = 0; we < ce.length; we++)
    me[we] = ce.charCodeAt(we);
  return me;
}, r_ = function() {
  for (var ce = arguments.length, ie = new Array(ce), me = 0; me < ce; me++)
    ie[me] = arguments[me];
  if (ie = ie.filter(function(Ue) {
    return Ue && (Ue.byteLength || Ue.length) && typeof Ue != "string";
  }), ie.length <= 1)
    return Y$1(ie[0]);
  var we = ie.reduce(function(Ue, qe, Ge) {
    return Ue + (qe.byteLength || qe.length);
  }, 0), Re = new Uint8Array(we), je = 0;
  return ie.forEach(function(Ue) {
    Ue = Y$1(Ue), Re.set(Ue, je), je += Ue.byteLength;
  }), Re;
}, Se$1 = function(ce, ie, me) {
  var we = me === void 0 ? {} : me, Re = we.offset, je = Re === void 0 ? 0 : Re, Ue = we.mask, qe = Ue === void 0 ? [] : Ue;
  ce = Y$1(ce), ie = Y$1(ie);
  var Ge = ie.every ? ie.every : Array.prototype.every;
  return ie.length && ce.length - je >= ie.length && // ie 11 doesn't support every on uin8
  Ge.call(ie, function(Xe, ot) {
    var vt = qe[ot] ? qe[ot] & ce[je + ot] : ce[je + ot];
    return Xe === vt;
  });
}, n_ = function(ce, ie, me) {
  ie.forEach(function(we) {
    for (var Re in ce.mediaGroups[we])
      for (var je in ce.mediaGroups[we][Re]) {
        var Ue = ce.mediaGroups[we][Re][je];
        me(Ue, we, Re, je);
      }
  });
}, gi = {}, ti = {};
function a_(ce, ie, me) {
  if (me === void 0 && (me = Array.prototype), ce && typeof me.find == "function")
    return me.find.call(ce, ie);
  for (var we = 0; we < ce.length; we++)
    if (Object.prototype.hasOwnProperty.call(ce, we)) {
      var Re = ce[we];
      if (ie.call(void 0, Re, we, ce))
        return Re;
    }
}
function yu(ce, ie) {
  return ie === void 0 && (ie = Object), ie && typeof ie.freeze == "function" ? ie.freeze(ce) : ce;
}
function o_(ce, ie) {
  if (ce === null || typeof ce != "object")
    throw new TypeError("target is not an object");
  for (var me in ie)
    Object.prototype.hasOwnProperty.call(ie, me) && (ce[me] = ie[me]);
  return ce;
}
var Hd = yu({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(ce) {
    return ce === Hd.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), zd = yu({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(ce) {
    return ce === zd.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
ti.assign = o_;
ti.find = a_;
ti.freeze = yu;
ti.MIME_TYPE = Hd;
ti.NAMESPACE = zd;
var Wd = ti, $t = Wd.find, Lr = Wd.NAMESPACE;
function u_(ce) {
  return ce !== "";
}
function l_(ce) {
  return ce ? ce.split(/[\t\n\f\r ]+/).filter(u_) : [];
}
function c_(ce, ie) {
  return ce.hasOwnProperty(ie) || (ce[ie] = !0), ce;
}
function dc(ce) {
  if (!ce) return [];
  var ie = l_(ce);
  return Object.keys(ie.reduce(c_, {}));
}
function d_(ce) {
  return function(ie) {
    return ce && ce.indexOf(ie) !== -1;
  };
}
function qr(ce, ie) {
  for (var me in ce)
    Object.prototype.hasOwnProperty.call(ce, me) && (ie[me] = ce[me]);
}
function nt(ce, ie) {
  var me = ce.prototype;
  if (!(me instanceof ie)) {
    let we = function() {
    };
    we.prototype = ie.prototype, we = new we(), qr(me, we), ce.prototype = me = we;
  }
  me.constructor != ce && (typeof ce != "function" && console.error("unknown Class:" + ce), me.constructor = ce);
}
var at = {}, Et = at.ELEMENT_NODE = 1, gs = at.ATTRIBUTE_NODE = 2, zn = at.TEXT_NODE = 3, Gd = at.CDATA_SECTION_NODE = 4, Xd = at.ENTITY_REFERENCE_NODE = 5, h_ = at.ENTITY_NODE = 6, Kd = at.PROCESSING_INSTRUCTION_NODE = 7, Yd = at.COMMENT_NODE = 8, Qd = at.DOCUMENT_NODE = 9, Jd = at.DOCUMENT_TYPE_NODE = 10, Jt = at.DOCUMENT_FRAGMENT_NODE = 11, f_ = at.NOTATION_NODE = 12, We = {}, Fe = {};
We.INDEX_SIZE_ERR = (Fe[1] = "Index size error", 1);
We.DOMSTRING_SIZE_ERR = (Fe[2] = "DOMString size error", 2);
var tt = We.HIERARCHY_REQUEST_ERR = (Fe[3] = "Hierarchy request error", 3);
We.WRONG_DOCUMENT_ERR = (Fe[4] = "Wrong document", 4);
We.INVALID_CHARACTER_ERR = (Fe[5] = "Invalid character", 5);
We.NO_DATA_ALLOWED_ERR = (Fe[6] = "No data allowed", 6);
We.NO_MODIFICATION_ALLOWED_ERR = (Fe[7] = "No modification allowed", 7);
var Zd = We.NOT_FOUND_ERR = (Fe[8] = "Not found", 8);
We.NOT_SUPPORTED_ERR = (Fe[9] = "Not supported", 9);
var hc = We.INUSE_ATTRIBUTE_ERR = (Fe[10] = "Attribute in use", 10);
We.INVALID_STATE_ERR = (Fe[11] = "Invalid state", 11);
We.SYNTAX_ERR = (Fe[12] = "Syntax error", 12);
We.INVALID_MODIFICATION_ERR = (Fe[13] = "Invalid modification", 13);
We.NAMESPACE_ERR = (Fe[14] = "Invalid namespace", 14);
We.INVALID_ACCESS_ERR = (Fe[15] = "Invalid access", 15);
function Pe(ce, ie) {
  if (ie instanceof Error)
    var me = ie;
  else
    me = this, Error.call(this, Fe[ce]), this.message = Fe[ce], Error.captureStackTrace && Error.captureStackTrace(this, Pe);
  return me.code = ce, ie && (this.message = this.message + ": " + ie), me;
}
Pe.prototype = Error.prototype;
qr(We, Pe);
function Kt() {
}
Kt.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(ce) {
    return ce >= 0 && ce < this.length ? this[ce] : null;
  },
  toString: function(ce, ie) {
    for (var me = [], we = 0; we < this.length; we++)
      is(this[we], me, ce, ie);
    return me.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(ce) {
    return Array.prototype.filter.call(this, ce);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(ce) {
    return Array.prototype.indexOf.call(this, ce);
  }
};
function _s(ce, ie) {
  this._node = ce, this._refresh = ie, Tu(this);
}
function Tu(ce) {
  var ie = ce._node._inc || ce._node.ownerDocument._inc;
  if (ce._inc !== ie) {
    var me = ce._refresh(ce._node);
    if (dh(ce, "length", me.length), !ce.$$length || me.length < ce.$$length)
      for (var we = me.length; we in ce; we++)
        Object.prototype.hasOwnProperty.call(ce, we) && delete ce[we];
    qr(me, ce), ce._inc = ie;
  }
}
_s.prototype.item = function(ce) {
  return Tu(this), this[ce] || null;
};
nt(_s, Kt);
function Wn() {
}
function eh(ce, ie) {
  for (var me = ce.length; me--; )
    if (ce[me] === ie)
      return me;
}
function fc(ce, ie, me, we) {
  if (we ? ie[eh(ie, we)] = me : ie[ie.length++] = me, ce) {
    me.ownerElement = ce;
    var Re = ce.ownerDocument;
    Re && (we && sh(Re, ce, we), p_(Re, ce, me));
  }
}
function pc(ce, ie, me) {
  var we = eh(ie, me);
  if (we >= 0) {
    for (var Re = ie.length - 1; we < Re; )
      ie[we] = ie[++we];
    if (ie.length = Re, ce) {
      var je = ce.ownerDocument;
      je && (sh(je, ce, me), me.ownerElement = null);
    }
  } else
    throw new Pe(Zd, new Error(ce.tagName + "@" + me));
}
Wn.prototype = {
  length: 0,
  item: Kt.prototype.item,
  getNamedItem: function(ce) {
    for (var ie = this.length; ie--; ) {
      var me = this[ie];
      if (me.nodeName == ce)
        return me;
    }
  },
  setNamedItem: function(ce) {
    var ie = ce.ownerElement;
    if (ie && ie != this._ownerElement)
      throw new Pe(hc);
    var me = this.getNamedItem(ce.nodeName);
    return fc(this._ownerElement, this, ce, me), me;
  },
  /* returns Node */
  setNamedItemNS: function(ce) {
    var ie = ce.ownerElement, me;
    if (ie && ie != this._ownerElement)
      throw new Pe(hc);
    return me = this.getNamedItemNS(ce.namespaceURI, ce.localName), fc(this._ownerElement, this, ce, me), me;
  },
  /* returns Node */
  removeNamedItem: function(ce) {
    var ie = this.getNamedItem(ce);
    return pc(this._ownerElement, this, ie), ie;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(ce, ie) {
    var me = this.getNamedItemNS(ce, ie);
    return pc(this._ownerElement, this, me), me;
  },
  getNamedItemNS: function(ce, ie) {
    for (var me = this.length; me--; ) {
      var we = this[me];
      if (we.localName == ie && we.namespaceURI == ce)
        return we;
    }
    return null;
  }
};
function th() {
}
th.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(ce, ie) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(ce, ie, me) {
    var we = new Vr();
    if (we.implementation = this, we.childNodes = new Kt(), we.doctype = me || null, me && we.appendChild(me), ie) {
      var Re = we.createElementNS(ce, ie);
      we.appendChild(Re);
    }
    return we;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(ce, ie, me) {
    var we = new ya();
    return we.name = ce, we.nodeName = ce, we.publicId = ie || "", we.systemId = me || "", we;
  }
};
function _e() {
}
_e.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(ce, ie) {
    return Gn(this, ce, ie);
  },
  replaceChild: function(ce, ie) {
    Gn(this, ce, ie, nh), ie && this.removeChild(ie);
  },
  removeChild: function(ce) {
    return rh(this, ce);
  },
  appendChild: function(ce) {
    return this.insertBefore(ce, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(ce) {
    return Fo(this.ownerDocument || this, this, ce);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var ce = this.firstChild; ce; ) {
      var ie = ce.nextSibling;
      ie && ie.nodeType == zn && ce.nodeType == zn ? (this.removeChild(ie), ce.appendData(ie.data)) : (ce.normalize(), ce = ie);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(ce, ie) {
    return this.ownerDocument.implementation.hasFeature(ce, ie);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(ce) {
    for (var ie = this; ie; ) {
      var me = ie._nsMap;
      if (me) {
        for (var we in me)
          if (Object.prototype.hasOwnProperty.call(me, we) && me[we] === ce)
            return we;
      }
      ie = ie.nodeType == gs ? ie.ownerDocument : ie.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(ce) {
    for (var ie = this; ie; ) {
      var me = ie._nsMap;
      if (me && Object.prototype.hasOwnProperty.call(me, ce))
        return me[ce];
      ie = ie.nodeType == gs ? ie.ownerDocument : ie.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(ce) {
    var ie = this.lookupPrefix(ce);
    return ie == null;
  }
};
function ih(ce) {
  return ce == "<" && "&lt;" || ce == ">" && "&gt;" || ce == "&" && "&amp;" || ce == '"' && "&quot;" || "&#" + ce.charCodeAt() + ";";
}
qr(at, _e);
qr(at, _e.prototype);
function Rr(ce, ie) {
  if (ie(ce))
    return !0;
  if (ce = ce.firstChild)
    do
      if (Rr(ce, ie))
        return !0;
    while (ce = ce.nextSibling);
}
function Vr() {
  this.ownerDocument = this;
}
function p_(ce, ie, me) {
  ce && ce._inc++;
  var we = me.namespaceURI;
  we === Lr.XMLNS && (ie._nsMap[me.prefix ? me.localName : ""] = me.value);
}
function sh(ce, ie, me, we) {
  ce && ce._inc++;
  var Re = me.namespaceURI;
  Re === Lr.XMLNS && delete ie._nsMap[me.prefix ? me.localName : ""];
}
function vu(ce, ie, me) {
  if (ce && ce._inc) {
    ce._inc++;
    var we = ie.childNodes;
    if (me)
      we[we.length++] = me;
    else {
      for (var Re = ie.firstChild, je = 0; Re; )
        we[je++] = Re, Re = Re.nextSibling;
      we.length = je, delete we[we.length];
    }
  }
}
function rh(ce, ie) {
  var me = ie.previousSibling, we = ie.nextSibling;
  return me ? me.nextSibling = we : ce.firstChild = we, we ? we.previousSibling = me : ce.lastChild = me, ie.parentNode = null, ie.previousSibling = null, ie.nextSibling = null, vu(ce.ownerDocument, ce), ie;
}
function m_(ce) {
  return ce && (ce.nodeType === _e.DOCUMENT_NODE || ce.nodeType === _e.DOCUMENT_FRAGMENT_NODE || ce.nodeType === _e.ELEMENT_NODE);
}
function g_(ce) {
  return ce && (jt$1(ce) || bu(ce) || Zt(ce) || ce.nodeType === _e.DOCUMENT_FRAGMENT_NODE || ce.nodeType === _e.COMMENT_NODE || ce.nodeType === _e.PROCESSING_INSTRUCTION_NODE);
}
function Zt(ce) {
  return ce && ce.nodeType === _e.DOCUMENT_TYPE_NODE;
}
function jt$1(ce) {
  return ce && ce.nodeType === _e.ELEMENT_NODE;
}
function bu(ce) {
  return ce && ce.nodeType === _e.TEXT_NODE;
}
function mc(ce, ie) {
  var me = ce.childNodes || [];
  if ($t(me, jt$1) || Zt(ie))
    return !1;
  var we = $t(me, Zt);
  return !(ie && we && me.indexOf(we) > me.indexOf(ie));
}
function gc(ce, ie) {
  var me = ce.childNodes || [];
  function we(je) {
    return jt$1(je) && je !== ie;
  }
  if ($t(me, we))
    return !1;
  var Re = $t(me, Zt);
  return !(ie && Re && me.indexOf(Re) > me.indexOf(ie));
}
function __(ce, ie, me) {
  if (!m_(ce))
    throw new Pe(tt, "Unexpected parent node type " + ce.nodeType);
  if (me && me.parentNode !== ce)
    throw new Pe(Zd, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !g_(ie) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    Zt(ie) && ce.nodeType !== _e.DOCUMENT_NODE
  )
    throw new Pe(
      tt,
      "Unexpected node type " + ie.nodeType + " for parent node type " + ce.nodeType
    );
}
function y_(ce, ie, me) {
  var we = ce.childNodes || [], Re = ie.childNodes || [];
  if (ie.nodeType === _e.DOCUMENT_FRAGMENT_NODE) {
    var je = Re.filter(jt$1);
    if (je.length > 1 || $t(Re, bu))
      throw new Pe(tt, "More than one element or text in fragment");
    if (je.length === 1 && !mc(ce, me))
      throw new Pe(tt, "Element in fragment can not be inserted before doctype");
  }
  if (jt$1(ie) && !mc(ce, me))
    throw new Pe(tt, "Only one element can be added and only after doctype");
  if (Zt(ie)) {
    if ($t(we, Zt))
      throw new Pe(tt, "Only one doctype is allowed");
    var Ue = $t(we, jt$1);
    if (me && we.indexOf(Ue) < we.indexOf(me))
      throw new Pe(tt, "Doctype can only be inserted before an element");
    if (!me && Ue)
      throw new Pe(tt, "Doctype can not be appended since element is present");
  }
}
function nh(ce, ie, me) {
  var we = ce.childNodes || [], Re = ie.childNodes || [];
  if (ie.nodeType === _e.DOCUMENT_FRAGMENT_NODE) {
    var je = Re.filter(jt$1);
    if (je.length > 1 || $t(Re, bu))
      throw new Pe(tt, "More than one element or text in fragment");
    if (je.length === 1 && !gc(ce, me))
      throw new Pe(tt, "Element in fragment can not be inserted before doctype");
  }
  if (jt$1(ie) && !gc(ce, me))
    throw new Pe(tt, "Only one element can be added and only after doctype");
  if (Zt(ie)) {
    if ($t(we, function(qe) {
      return Zt(qe) && qe !== me;
    }))
      throw new Pe(tt, "Only one doctype is allowed");
    var Ue = $t(we, jt$1);
    if (me && we.indexOf(Ue) < we.indexOf(me))
      throw new Pe(tt, "Doctype can only be inserted before an element");
  }
}
function Gn(ce, ie, me, we) {
  __(ce, ie, me), ce.nodeType === _e.DOCUMENT_NODE && (we || y_)(ce, ie, me);
  var Re = ie.parentNode;
  if (Re && Re.removeChild(ie), ie.nodeType === Jt) {
    var je = ie.firstChild;
    if (je == null)
      return ie;
    var Ue = ie.lastChild;
  } else
    je = Ue = ie;
  var qe = me ? me.previousSibling : ce.lastChild;
  je.previousSibling = qe, Ue.nextSibling = me, qe ? qe.nextSibling = je : ce.firstChild = je, me == null ? ce.lastChild = Ue : me.previousSibling = Ue;
  do
    je.parentNode = ce;
  while (je !== Ue && (je = je.nextSibling));
  return vu(ce.ownerDocument || ce, ce), ie.nodeType == Jt && (ie.firstChild = ie.lastChild = null), ie;
}
function T_(ce, ie) {
  return ie.parentNode && ie.parentNode.removeChild(ie), ie.parentNode = ce, ie.previousSibling = ce.lastChild, ie.nextSibling = null, ie.previousSibling ? ie.previousSibling.nextSibling = ie : ce.firstChild = ie, ce.lastChild = ie, vu(ce.ownerDocument, ce, ie), ie;
}
Vr.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: Qd,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(ce, ie) {
    if (ce.nodeType == Jt) {
      for (var me = ce.firstChild; me; ) {
        var we = me.nextSibling;
        this.insertBefore(me, ie), me = we;
      }
      return ce;
    }
    return Gn(this, ce, ie), ce.ownerDocument = this, this.documentElement === null && ce.nodeType === Et && (this.documentElement = ce), ce;
  },
  removeChild: function(ce) {
    return this.documentElement == ce && (this.documentElement = null), rh(this, ce);
  },
  replaceChild: function(ce, ie) {
    Gn(this, ce, ie, nh), ce.ownerDocument = this, ie && this.removeChild(ie), jt$1(ce) && (this.documentElement = ce);
  },
  // Introduced in DOM Level 2:
  importNode: function(ce, ie) {
    return ch(this, ce, ie);
  },
  // Introduced in DOM Level 2:
  getElementById: function(ce) {
    var ie = null;
    return Rr(this.documentElement, function(me) {
      if (me.nodeType == Et && me.getAttribute("id") == ce)
        return ie = me, !0;
    }), ie;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(ce) {
    var ie = dc(ce);
    return new _s(this, function(me) {
      var we = [];
      return ie.length > 0 && Rr(me.documentElement, function(Re) {
        if (Re !== me && Re.nodeType === Et) {
          var je = Re.getAttribute("class");
          if (je) {
            var Ue = ce === je;
            if (!Ue) {
              var qe = dc(je);
              Ue = ie.every(d_(qe));
            }
            Ue && we.push(Re);
          }
        }
      }), we;
    });
  },
  //document factory method:
  createElement: function(ce) {
    var ie = new Ri();
    ie.ownerDocument = this, ie.nodeName = ce, ie.tagName = ce, ie.localName = ce, ie.childNodes = new Kt();
    var me = ie.attributes = new Wn();
    return me._ownerElement = ie, ie;
  },
  createDocumentFragment: function() {
    var ce = new Ta();
    return ce.ownerDocument = this, ce.childNodes = new Kt(), ce;
  },
  createTextNode: function(ce) {
    var ie = new xu();
    return ie.ownerDocument = this, ie.appendData(ce), ie;
  },
  createComment: function(ce) {
    var ie = new Su();
    return ie.ownerDocument = this, ie.appendData(ce), ie;
  },
  createCDATASection: function(ce) {
    var ie = new Eu();
    return ie.ownerDocument = this, ie.appendData(ce), ie;
  },
  createProcessingInstruction: function(ce, ie) {
    var me = new Au();
    return me.ownerDocument = this, me.tagName = me.nodeName = me.target = ce, me.nodeValue = me.data = ie, me;
  },
  createAttribute: function(ce) {
    var ie = new Xn();
    return ie.ownerDocument = this, ie.name = ce, ie.nodeName = ce, ie.localName = ce, ie.specified = !0, ie;
  },
  createEntityReference: function(ce) {
    var ie = new Cu();
    return ie.ownerDocument = this, ie.nodeName = ce, ie;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(ce, ie) {
    var me = new Ri(), we = ie.split(":"), Re = me.attributes = new Wn();
    return me.childNodes = new Kt(), me.ownerDocument = this, me.nodeName = ie, me.tagName = ie, me.namespaceURI = ce, we.length == 2 ? (me.prefix = we[0], me.localName = we[1]) : me.localName = ie, Re._ownerElement = me, me;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(ce, ie) {
    var me = new Xn(), we = ie.split(":");
    return me.ownerDocument = this, me.nodeName = ie, me.name = ie, me.namespaceURI = ce, me.specified = !0, we.length == 2 ? (me.prefix = we[0], me.localName = we[1]) : me.localName = ie, me;
  }
};
nt(Vr, _e);
function Ri() {
  this._nsMap = {};
}
Ri.prototype = {
  nodeType: Et,
  hasAttribute: function(ce) {
    return this.getAttributeNode(ce) != null;
  },
  getAttribute: function(ce) {
    var ie = this.getAttributeNode(ce);
    return ie && ie.value || "";
  },
  getAttributeNode: function(ce) {
    return this.attributes.getNamedItem(ce);
  },
  setAttribute: function(ce, ie) {
    var me = this.ownerDocument.createAttribute(ce);
    me.value = me.nodeValue = "" + ie, this.setAttributeNode(me);
  },
  removeAttribute: function(ce) {
    var ie = this.getAttributeNode(ce);
    ie && this.removeAttributeNode(ie);
  },
  //four real opeartion method
  appendChild: function(ce) {
    return ce.nodeType === Jt ? this.insertBefore(ce, null) : T_(this, ce);
  },
  setAttributeNode: function(ce) {
    return this.attributes.setNamedItem(ce);
  },
  setAttributeNodeNS: function(ce) {
    return this.attributes.setNamedItemNS(ce);
  },
  removeAttributeNode: function(ce) {
    return this.attributes.removeNamedItem(ce.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(ce, ie) {
    var me = this.getAttributeNodeNS(ce, ie);
    me && this.removeAttributeNode(me);
  },
  hasAttributeNS: function(ce, ie) {
    return this.getAttributeNodeNS(ce, ie) != null;
  },
  getAttributeNS: function(ce, ie) {
    var me = this.getAttributeNodeNS(ce, ie);
    return me && me.value || "";
  },
  setAttributeNS: function(ce, ie, me) {
    var we = this.ownerDocument.createAttributeNS(ce, ie);
    we.value = we.nodeValue = "" + me, this.setAttributeNode(we);
  },
  getAttributeNodeNS: function(ce, ie) {
    return this.attributes.getNamedItemNS(ce, ie);
  },
  getElementsByTagName: function(ce) {
    return new _s(this, function(ie) {
      var me = [];
      return Rr(ie, function(we) {
        we !== ie && we.nodeType == Et && (ce === "*" || we.tagName == ce) && me.push(we);
      }), me;
    });
  },
  getElementsByTagNameNS: function(ce, ie) {
    return new _s(this, function(me) {
      var we = [];
      return Rr(me, function(Re) {
        Re !== me && Re.nodeType === Et && (ce === "*" || Re.namespaceURI === ce) && (ie === "*" || Re.localName == ie) && we.push(Re);
      }), we;
    });
  }
};
Vr.prototype.getElementsByTagName = Ri.prototype.getElementsByTagName;
Vr.prototype.getElementsByTagNameNS = Ri.prototype.getElementsByTagNameNS;
nt(Ri, _e);
function Xn() {
}
Xn.prototype.nodeType = gs;
nt(Xn, _e);
function Hr() {
}
Hr.prototype = {
  data: "",
  substringData: function(ce, ie) {
    return this.data.substring(ce, ce + ie);
  },
  appendData: function(ce) {
    ce = this.data + ce, this.nodeValue = this.data = ce, this.length = ce.length;
  },
  insertData: function(ce, ie) {
    this.replaceData(ce, 0, ie);
  },
  appendChild: function(ce) {
    throw new Error(Fe[tt]);
  },
  deleteData: function(ce, ie) {
    this.replaceData(ce, ie, "");
  },
  replaceData: function(ce, ie, me) {
    var we = this.data.substring(0, ce), Re = this.data.substring(ce + ie);
    me = we + me + Re, this.nodeValue = this.data = me, this.length = me.length;
  }
};
nt(Hr, _e);
function xu() {
}
xu.prototype = {
  nodeName: "#text",
  nodeType: zn,
  splitText: function(ce) {
    var ie = this.data, me = ie.substring(ce);
    ie = ie.substring(0, ce), this.data = this.nodeValue = ie, this.length = ie.length;
    var we = this.ownerDocument.createTextNode(me);
    return this.parentNode && this.parentNode.insertBefore(we, this.nextSibling), we;
  }
};
nt(xu, Hr);
function Su() {
}
Su.prototype = {
  nodeName: "#comment",
  nodeType: Yd
};
nt(Su, Hr);
function Eu() {
}
Eu.prototype = {
  nodeName: "#cdata-section",
  nodeType: Gd
};
nt(Eu, Hr);
function ya() {
}
ya.prototype.nodeType = Jd;
nt(ya, _e);
function ah() {
}
ah.prototype.nodeType = f_;
nt(ah, _e);
function oh() {
}
oh.prototype.nodeType = h_;
nt(oh, _e);
function Cu() {
}
Cu.prototype.nodeType = Xd;
nt(Cu, _e);
function Ta() {
}
Ta.prototype.nodeName = "#document-fragment";
Ta.prototype.nodeType = Jt;
nt(Ta, _e);
function Au() {
}
Au.prototype.nodeType = Kd;
nt(Au, _e);
function uh() {
}
uh.prototype.serializeToString = function(ce, ie, me) {
  return lh.call(ce, ie, me);
};
_e.prototype.toString = lh;
function lh(ce, ie) {
  var me = [], we = this.nodeType == 9 && this.documentElement || this, Re = we.prefix, je = we.namespaceURI;
  if (je && Re == null) {
    var Re = we.lookupPrefix(je);
    if (Re == null)
      var Ue = [
        { namespace: je, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return is(this, me, ce, ie, Ue), me.join("");
}
function _c(ce, ie, me) {
  var we = ce.prefix || "", Re = ce.namespaceURI;
  if (!Re || we === "xml" && Re === Lr.XML || Re === Lr.XMLNS)
    return !1;
  for (var je = me.length; je--; ) {
    var Ue = me[je];
    if (Ue.prefix === we)
      return Ue.namespace !== Re;
  }
  return !0;
}
function To(ce, ie, me) {
  ce.push(" ", ie, '="', me.replace(/[<>&"\t\n\r]/g, ih), '"');
}
function is(ce, ie, me, we, Re) {
  if (Re || (Re = []), we)
    if (ce = we(ce), ce) {
      if (typeof ce == "string") {
        ie.push(ce);
        return;
      }
    } else
      return;
  switch (ce.nodeType) {
    case Et:
      var je = ce.attributes, Ue = je.length, qe = ce.firstChild, Ge = ce.tagName;
      me = Lr.isHTML(ce.namespaceURI) || me;
      var Xe = Ge;
      if (!me && !ce.prefix && ce.namespaceURI) {
        for (var ot, vt = 0; vt < je.length; vt++)
          if (je.item(vt).name === "xmlns") {
            ot = je.item(vt).value;
            break;
          }
        if (!ot)
          for (var bt = Re.length - 1; bt >= 0; bt--) {
            var Tt = Re[bt];
            if (Tt.prefix === "" && Tt.namespace === ce.namespaceURI) {
              ot = Tt.namespace;
              break;
            }
          }
        if (ot !== ce.namespaceURI)
          for (var bt = Re.length - 1; bt >= 0; bt--) {
            var Tt = Re[bt];
            if (Tt.namespace === ce.namespaceURI) {
              Tt.prefix && (Xe = Tt.prefix + ":" + Ge);
              break;
            }
          }
      }
      ie.push("<", Xe);
      for (var wt = 0; wt < Ue; wt++) {
        var St = je.item(wt);
        St.prefix == "xmlns" ? Re.push({ prefix: St.localName, namespace: St.value }) : St.nodeName == "xmlns" && Re.push({ prefix: "", namespace: St.value });
      }
      for (var wt = 0; wt < Ue; wt++) {
        var St = je.item(wt);
        if (_c(St, me, Re)) {
          var It = St.prefix || "", Pt = St.namespaceURI;
          To(ie, It ? "xmlns:" + It : "xmlns", Pt), Re.push({ prefix: It, namespace: Pt });
        }
        is(St, ie, me, we, Re);
      }
      if (Ge === Xe && _c(ce, me, Re)) {
        var It = ce.prefix || "", Pt = ce.namespaceURI;
        To(ie, It ? "xmlns:" + It : "xmlns", Pt), Re.push({ prefix: It, namespace: Pt });
      }
      if (qe || me && !/^(?:meta|link|img|br|hr|input)$/i.test(Ge)) {
        if (ie.push(">"), me && /^script$/i.test(Ge))
          for (; qe; )
            qe.data ? ie.push(qe.data) : is(qe, ie, me, we, Re.slice()), qe = qe.nextSibling;
        else
          for (; qe; )
            is(qe, ie, me, we, Re.slice()), qe = qe.nextSibling;
        ie.push("</", Xe, ">");
      } else
        ie.push("/>");
      return;
    case Qd:
    case Jt:
      for (var qe = ce.firstChild; qe; )
        is(qe, ie, me, we, Re.slice()), qe = qe.nextSibling;
      return;
    case gs:
      return To(ie, ce.name, ce.value);
    case zn:
      return ie.push(
        ce.data.replace(/[<&>]/g, ih)
      );
    case Gd:
      return ie.push("<![CDATA[", ce.data, "]]>");
    case Yd:
      return ie.push("<!--", ce.data, "-->");
    case Jd:
      var kt = ce.publicId, Ot = ce.systemId;
      if (ie.push("<!DOCTYPE ", ce.name), kt)
        ie.push(" PUBLIC ", kt), Ot && Ot != "." && ie.push(" ", Ot), ie.push(">");
      else if (Ot && Ot != ".")
        ie.push(" SYSTEM ", Ot, ">");
      else {
        var Jr = ce.internalSubset;
        Jr && ie.push(" [", Jr, "]"), ie.push(">");
      }
      return;
    case Kd:
      return ie.push("<?", ce.target, " ", ce.data, "?>");
    case Xd:
      return ie.push("&", ce.nodeName, ";");
    //case ENTITY_NODE:
    //case NOTATION_NODE:
    default:
      ie.push("??", ce.nodeName);
  }
}
function ch(ce, ie, me) {
  var we;
  switch (ie.nodeType) {
    case Et:
      we = ie.cloneNode(!1), we.ownerDocument = ce;
    //var attrs = node2.attributes;
    //var len = attrs.length;
    //for(var i=0;i<len;i++){
    //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
    //}
    case Jt:
      break;
    case gs:
      me = !0;
      break;
  }
  if (we || (we = ie.cloneNode(!1)), we.ownerDocument = ce, we.parentNode = null, me)
    for (var Re = ie.firstChild; Re; )
      we.appendChild(ch(ce, Re, me)), Re = Re.nextSibling;
  return we;
}
function Fo(ce, ie, me) {
  var we = new ie.constructor();
  for (var Re in ie)
    if (Object.prototype.hasOwnProperty.call(ie, Re)) {
      var je = ie[Re];
      typeof je != "object" && je != we[Re] && (we[Re] = je);
    }
  switch (ie.childNodes && (we.childNodes = new Kt()), we.ownerDocument = ce, we.nodeType) {
    case Et:
      var Ue = ie.attributes, qe = we.attributes = new Wn(), Ge = Ue.length;
      qe._ownerElement = we;
      for (var Xe = 0; Xe < Ge; Xe++)
        we.setAttributeNode(Fo(ce, Ue.item(Xe), !0));
      break;
    case gs:
      me = !0;
  }
  if (me)
    for (var ot = ie.firstChild; ot; )
      we.appendChild(Fo(ce, ot, me)), ot = ot.nextSibling;
  return we;
}
function dh(ce, ie, me) {
  ce[ie] = me;
}
try {
  if (Object.defineProperty) {
    let ce = function(ie) {
      switch (ie.nodeType) {
        case Et:
        case Jt:
          var me = [];
          for (ie = ie.firstChild; ie; )
            ie.nodeType !== 7 && ie.nodeType !== 8 && me.push(ce(ie)), ie = ie.nextSibling;
          return me.join("");
        default:
          return ie.nodeValue;
      }
    };
    Object.defineProperty(_s.prototype, "length", {
      get: function() {
        return Tu(this), this.$$length;
      }
    }), Object.defineProperty(_e.prototype, "textContent", {
      get: function() {
        return ce(this);
      },
      set: function(ie) {
        switch (this.nodeType) {
          case Et:
          case Jt:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (ie || String(ie)) && this.appendChild(this.ownerDocument.createTextNode(ie));
            break;
          default:
            this.data = ie, this.value = ie, this.nodeValue = ie;
        }
      }
    }), dh = function(ie, me, we) {
      ie["$$" + me] = we;
    };
  }
} catch {
}
gi.DocumentType = ya;
gi.DOMException = Pe;
gi.DOMImplementation = th;
gi.Element = Ri;
gi.Node = _e;
gi.NodeList = Kt;
gi.XMLSerializer = uh;
var va = {}, hh = {};
(function(ce) {
  var ie = ti.freeze;
  ce.XML_ENTITIES = ie({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), ce.HTML_ENTITIES = ie({
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    AMP: "&",
    amp: "&",
    And: "⩓",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    ap: "≈",
    apacir: "⩯",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    Barwed: "⌆",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    Because: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxDL: "╗",
    boxDl: "╖",
    boxdL: "╕",
    boxdl: "┐",
    boxDR: "╔",
    boxDr: "╓",
    boxdR: "╒",
    boxdr: "┌",
    boxH: "═",
    boxh: "─",
    boxHD: "╦",
    boxHd: "╤",
    boxhD: "╥",
    boxhd: "┬",
    boxHU: "╩",
    boxHu: "╧",
    boxhU: "╨",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxUL: "╝",
    boxUl: "╜",
    boxuL: "╛",
    boxul: "┘",
    boxUR: "╚",
    boxUr: "╙",
    boxuR: "╘",
    boxur: "└",
    boxV: "║",
    boxv: "│",
    boxVH: "╬",
    boxVh: "╫",
    boxvH: "╪",
    boxvh: "┼",
    boxVL: "╣",
    boxVl: "╢",
    boxvL: "╡",
    boxvl: "┤",
    boxVR: "╠",
    boxVr: "╟",
    boxvR: "╞",
    boxvr: "├",
    bprime: "‵",
    Breve: "˘",
    breve: "˘",
    brvbar: "¦",
    Bscr: "ℬ",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    Cap: "⋒",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    CenterDot: "·",
    centerdot: "·",
    Cfr: "ℭ",
    cfr: "𝔠",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    cir: "○",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    Colon: "∷",
    colon: ":",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    Conint: "∯",
    conint: "∮",
    ContourIntegral: "∮",
    Copf: "ℂ",
    copf: "𝕔",
    coprod: "∐",
    Coproduct: "∐",
    COPY: "©",
    copy: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    Cross: "⨯",
    cross: "✗",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    Cup: "⋓",
    cup: "∪",
    cupbrcap: "⩈",
    CupCap: "≍",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    Dagger: "‡",
    dagger: "†",
    daleth: "ℸ",
    Darr: "↡",
    dArr: "⇓",
    darr: "↓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    DD: "ⅅ",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    Diamond: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    Downarrow: "⇓",
    downarrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    ecir: "≖",
    Ecirc: "Ê",
    ecirc: "ê",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    eDot: "≑",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp: " ",
    emsp13: " ",
    emsp14: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    Escr: "ℰ",
    escr: "ℯ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    ExponentialE: "ⅇ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    ForAll: "∀",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    Fscr: "ℱ",
    fscr: "𝒻",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    gE: "≧",
    ge: "≥",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    Gg: "⋙",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gl: "≷",
    gla: "⪥",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gnE: "≩",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    Gt: "≫",
    GT: ">",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    hArr: "⇔",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    Hfr: "ℌ",
    hfr: "𝔥",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    Hopf: "ℍ",
    hopf: "𝕙",
    horbar: "―",
    HorizontalLine: "─",
    Hscr: "ℋ",
    hscr: "𝒽",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    Ifr: "ℑ",
    ifr: "𝔦",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Im: "ℑ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    Int: "∬",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    Iscr: "ℐ",
    iscr: "𝒾",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    Lang: "⟪",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    Larr: "↞",
    lArr: "⇐",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    lAtail: "⤛",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lBarr: "⤎",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    lE: "≦",
    le: "≤",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    Leftarrow: "⇐",
    leftarrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    Ll: "⋘",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lnE: "≨",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftarrow: "⟵",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    Lscr: "ℒ",
    lscr: "𝓁",
    Lsh: "↰",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    Lt: "≪",
    LT: "<",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    Mscr: "ℳ",
    mscr: "𝓂",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    nearhk: "⤤",
    neArr: "⇗",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlArr: "⇍",
    nlarr: "↚",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nLeftarrow: "⇍",
    nleftarrow: "↚",
    nLeftrightarrow: "⇎",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    nopf: "𝕟",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nRightarrow: "⇏",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nVDash: "⊯",
    nVdash: "⊮",
    nvDash: "⊭",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwArr: "⇖",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    Ocirc: "Ô",
    ocirc: "ô",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    Or: "⩔",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    Otimes: "⨷",
    otimes: "⊗",
    otimesas: "⨶",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    Popf: "ℙ",
    popf: "𝕡",
    pound: "£",
    Pr: "⪻",
    pr: "≺",
    prap: "⪷",
    prcue: "≼",
    prE: "⪳",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    Prime: "″",
    prime: "′",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportion: "∷",
    Proportional: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    Qopf: "ℚ",
    qopf: "𝕢",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    QUOT: '"',
    quot: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    Rang: "⟫",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    Rarr: "↠",
    rArr: "⇒",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    rAtail: "⤜",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    RBarr: "⤐",
    rBarr: "⤏",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    Re: "ℜ",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    REG: "®",
    reg: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    Rfr: "ℜ",
    rfr: "𝔯",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    Rightarrow: "⇒",
    rightarrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    Ropf: "ℝ",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    Rscr: "ℛ",
    rscr: "𝓇",
    Rsh: "↱",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    Sc: "⪼",
    sc: "≻",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    sccue: "≽",
    scE: "⪴",
    sce: "⪰",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    searhk: "⤥",
    seArr: "⇘",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    Square: "□",
    square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    Sub: "⋐",
    sub: "⊂",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    Subset: "⋐",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    Sum: "∑",
    sum: "∑",
    sung: "♪",
    Sup: "⋑",
    sup: "⊃",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    Supset: "⋑",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swArr: "⇙",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    Therefore: "∴",
    therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    thinsp: " ",
    ThinSpace: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    Tilde: "∼",
    tilde: "˜",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    TRADE: "™",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    Uarr: "↟",
    uArr: "⇑",
    uarr: "↑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrow: "↑",
    Uparrow: "⇑",
    uparrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    updownarrow: "↕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    upsi: "υ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    vArr: "⇕",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    Vbar: "⫫",
    vBar: "⫨",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    VDash: "⊫",
    Vdash: "⊩",
    vDash: "⊨",
    vdash: "⊢",
    Vdashl: "⫦",
    Vee: "⋁",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    Verbar: "‖",
    verbar: "|",
    Vert: "‖",
    vert: "|",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    Wedge: "⋀",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    Xi: "Ξ",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    Yuml: "Ÿ",
    yuml: "ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    Zfr: "ℨ",
    zfr: "𝔷",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    Zopf: "ℤ",
    zopf: "𝕫",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  }), ce.entityMap = ce.HTML_ENTITIES;
})(hh);
var Du = {}, Mr = ti.NAMESPACE, Uo = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, yc = new RegExp("[\\-\\.0-9" + Uo.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), Tc = new RegExp("^" + Uo.source + yc.source + "*(?::" + Uo.source + yc.source + "*)?$"), pr = 0, ui = 1, Ki = 2, mr = 3, Yi = 4, Qi = 5, gr = 6, Pn = 7;
function ys(ce, ie) {
  this.message = ce, this.locator = ie, Error.captureStackTrace && Error.captureStackTrace(this, ys);
}
ys.prototype = new Error();
ys.prototype.name = ys.name;
function fh() {
}
fh.prototype = {
  parse: function(ce, ie, me) {
    var we = this.domBuilder;
    we.startDocument(), ph(ie, ie = {}), v_(
      ce,
      ie,
      me,
      we,
      this.errorHandler
    ), we.endDocument();
  }
};
function v_(ce, ie, me, we, Re) {
  function je(cn) {
    if (cn > 65535) {
      cn -= 65536;
      var gn = 55296 + (cn >> 10), an = 56320 + (cn & 1023);
      return String.fromCharCode(gn, an);
    } else
      return String.fromCharCode(cn);
  }
  function Ue(cn) {
    var gn = cn.slice(1, -1);
    return Object.hasOwnProperty.call(me, gn) ? me[gn] : gn.charAt(0) === "#" ? je(parseInt(gn.substr(1).replace("x", "0x"))) : (Re.error("entity not found:" + cn), cn);
  }
  function qe(cn) {
    if (cn > St) {
      var gn = ce.substring(St, cn).replace(/&#?\w+;/g, Ue);
      bt && Ge(St), we.characters(gn, 0, cn - St), St = cn;
    }
  }
  function Ge(cn, gn) {
    for (; cn >= ot && (gn = vt.exec(ce)); )
      Xe = gn.index, ot = Xe + gn[0].length, bt.lineNumber++;
    bt.columnNumber = cn - Xe + 1;
  }
  for (var Xe = 0, ot = 0, vt = /.*(?:\r\n?|\n)|.*$/g, bt = we.locator, Tt = [{ currentNSMap: ie }], wt = {}, St = 0; ; ) {
    try {
      var It = ce.indexOf("<", St);
      if (It < 0) {
        if (!ce.substr(St).match(/^\s*$/)) {
          var Pt = we.doc, kt = Pt.createTextNode(ce.substr(St));
          Pt.appendChild(kt), we.currentElement = kt;
        }
        return;
      }
      switch (It > St && qe(It), ce.charAt(It + 1)) {
        case "/":
          var xn = ce.indexOf(">", It + 3), Ot = ce.substring(It + 2, xn).replace(/[ \t\n\r]+$/g, ""), Jr = Tt.pop();
          xn < 0 ? (Ot = ce.substring(It + 2).replace(/[\s<].*/, ""), Re.error("end tag name: " + Ot + " is not complete:" + Jr.tagName), xn = It + 1 + Ot.length) : Ot.match(/\s</) && (Ot = Ot.replace(/[\s<].*/, ""), Re.error("end tag name: " + Ot + " maybe not complete"), xn = It + 1 + Ot.length);
          var en = Jr.localNSMap, nn = Jr.tagName == Ot, ln = nn || Jr.tagName && Jr.tagName.toLowerCase() == Ot.toLowerCase();
          if (ln) {
            if (we.endElement(Jr.uri, Jr.localName, Ot), en)
              for (var fn in en)
                Object.prototype.hasOwnProperty.call(en, fn) && we.endPrefixMapping(fn);
            nn || Re.fatalError("end tag name: " + Ot + " is not match the current start tagName:" + Jr.tagName);
          } else
            Tt.push(Jr);
          xn++;
          break;
        // end elment
        case "?":
          bt && Ge(It), xn = C_(ce, It, we);
          break;
        case "!":
          bt && Ge(It), xn = E_(ce, It, we, Re);
          break;
        default:
          bt && Ge(It);
          var vn = new mh(), Tn = Tt[Tt.length - 1].currentNSMap, xn = b_(ce, It, vn, Tn, Ue, Re), bn = vn.length;
          if (!vn.closed && S_(ce, xn, vn.tagName, wt) && (vn.closed = !0, me.nbsp || Re.warning("unclosed xml attribute")), bt && bn) {
            for (var Sn = vc(bt, {}), Cn = 0; Cn < bn; Cn++) {
              var kn = vn[Cn];
              Ge(kn.offset), kn.locator = vc(bt, {});
            }
            we.locator = Sn, bc(vn, we, Tn) && Tt.push(vn), we.locator = bt;
          } else
            bc(vn, we, Tn) && Tt.push(vn);
          Mr.isHTML(vn.uri) && !vn.closed ? xn = x_(ce, xn, vn.tagName, Ue, we) : xn++;
      }
    } catch (cn) {
      if (cn instanceof ys)
        throw cn;
      Re.error("element parse error: " + cn), xn = -1;
    }
    xn > St ? St = xn : qe(Math.max(It, St) + 1);
  }
}
function vc(ce, ie) {
  return ie.lineNumber = ce.lineNumber, ie.columnNumber = ce.columnNumber, ie;
}
function b_(ce, ie, me, we, Re, je) {
  function Ue(bt, Tt, wt) {
    me.attributeNames.hasOwnProperty(bt) && je.fatalError("Attribute " + bt + " redefined"), me.addValue(
      bt,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      Tt.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, Re),
      wt
    );
  }
  for (var qe, Ge, Xe = ++ie, ot = pr; ; ) {
    var vt = ce.charAt(Xe);
    switch (vt) {
      case "=":
        if (ot === ui)
          qe = ce.slice(ie, Xe), ot = mr;
        else if (ot === Ki)
          ot = mr;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (ot === mr || ot === ui)
          if (ot === ui && (je.warning('attribute value must after "="'), qe = ce.slice(ie, Xe)), ie = Xe + 1, Xe = ce.indexOf(vt, ie), Xe > 0)
            Ge = ce.slice(ie, Xe), Ue(qe, Ge, ie - 1), ot = Qi;
          else
            throw new Error("attribute value no end '" + vt + "' match");
        else if (ot == Yi)
          Ge = ce.slice(ie, Xe), Ue(qe, Ge, ie), je.warning('attribute "' + qe + '" missed start quot(' + vt + ")!!"), ie = Xe + 1, ot = Qi;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (ot) {
          case pr:
            me.setTagName(ce.slice(ie, Xe));
          case Qi:
          case gr:
          case Pn:
            ot = Pn, me.closed = !0;
          case Yi:
          case ui:
            break;
          case Ki:
            me.closed = !0;
            break;
          //case S_EQ:
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return je.error("unexpected end of input"), ot == pr && me.setTagName(ce.slice(ie, Xe)), Xe;
      case ">":
        switch (ot) {
          case pr:
            me.setTagName(ce.slice(ie, Xe));
          case Qi:
          case gr:
          case Pn:
            break;
          //normal
          case Yi:
          //Compatible state
          case ui:
            Ge = ce.slice(ie, Xe), Ge.slice(-1) === "/" && (me.closed = !0, Ge = Ge.slice(0, -1));
          case Ki:
            ot === Ki && (Ge = qe), ot == Yi ? (je.warning('attribute "' + Ge + '" missed quot(")!'), Ue(qe, Ge, ie)) : ((!Mr.isHTML(we[""]) || !Ge.match(/^(?:disabled|checked|selected)$/i)) && je.warning('attribute "' + Ge + '" missed value!! "' + Ge + '" instead!!'), Ue(Ge, Ge, ie));
            break;
          case mr:
            throw new Error("attribute value missed!!");
        }
        return Xe;
      /*xml space '\x20' | #x9 | #xD | #xA; */
      case "":
        vt = " ";
      default:
        if (vt <= " ")
          switch (ot) {
            case pr:
              me.setTagName(ce.slice(ie, Xe)), ot = gr;
              break;
            case ui:
              qe = ce.slice(ie, Xe), ot = Ki;
              break;
            case Yi:
              var Ge = ce.slice(ie, Xe);
              je.warning('attribute "' + Ge + '" missed quot(")!!'), Ue(qe, Ge, ie);
            case Qi:
              ot = gr;
              break;
          }
        else
          switch (ot) {
            //case S_TAG:void();break;
            //case S_ATTR:void();break;
            //case S_ATTR_NOQUOT_VALUE:void();break;
            case Ki:
              me.tagName, (!Mr.isHTML(we[""]) || !qe.match(/^(?:disabled|checked|selected)$/i)) && je.warning('attribute "' + qe + '" missed value!! "' + qe + '" instead2!!'), Ue(qe, qe, ie), ie = Xe, ot = ui;
              break;
            case Qi:
              je.warning('attribute space is required"' + qe + '"!!');
            case gr:
              ot = ui, ie = Xe;
              break;
            case mr:
              ot = Yi, ie = Xe;
              break;
            case Pn:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    Xe++;
  }
}
function bc(ce, ie, me) {
  for (var we = ce.tagName, Re = null, je = ce.length; je--; ) {
    var Ue = ce[je], qe = Ue.qName, Ge = Ue.value, bt = qe.indexOf(":");
    if (bt > 0)
      var Xe = Ue.prefix = qe.slice(0, bt), ot = qe.slice(bt + 1), vt = Xe === "xmlns" && ot;
    else
      ot = qe, Xe = null, vt = qe === "xmlns" && "";
    Ue.localName = ot, vt !== !1 && (Re == null && (Re = {}, ph(me, me = {})), me[vt] = Re[vt] = Ge, Ue.uri = Mr.XMLNS, ie.startPrefixMapping(vt, Ge));
  }
  for (var je = ce.length; je--; ) {
    Ue = ce[je];
    var Xe = Ue.prefix;
    Xe && (Xe === "xml" && (Ue.uri = Mr.XML), Xe !== "xmlns" && (Ue.uri = me[Xe || ""]));
  }
  var bt = we.indexOf(":");
  bt > 0 ? (Xe = ce.prefix = we.slice(0, bt), ot = ce.localName = we.slice(bt + 1)) : (Xe = null, ot = ce.localName = we);
  var Tt = ce.uri = me[Xe || ""];
  if (ie.startElement(Tt, ot, we, ce), ce.closed) {
    if (ie.endElement(Tt, ot, we), Re)
      for (Xe in Re)
        Object.prototype.hasOwnProperty.call(Re, Xe) && ie.endPrefixMapping(Xe);
  } else
    return ce.currentNSMap = me, ce.localNSMap = Re, !0;
}
function x_(ce, ie, me, we, Re) {
  if (/^(?:script|textarea)$/i.test(me)) {
    var je = ce.indexOf("</" + me + ">", ie), Ue = ce.substring(ie + 1, je);
    if (/[&<]/.test(Ue))
      return /^script$/i.test(me) ? (Re.characters(Ue, 0, Ue.length), je) : (Ue = Ue.replace(/&#?\w+;/g, we), Re.characters(Ue, 0, Ue.length), je);
  }
  return ie + 1;
}
function S_(ce, ie, me, we) {
  var Re = we[me];
  return Re == null && (Re = ce.lastIndexOf("</" + me + ">"), Re < ie && (Re = ce.lastIndexOf("</" + me)), we[me] = Re), Re < ie;
}
function ph(ce, ie) {
  for (var me in ce)
    Object.prototype.hasOwnProperty.call(ce, me) && (ie[me] = ce[me]);
}
function E_(ce, ie, me, we) {
  var Re = ce.charAt(ie + 2);
  switch (Re) {
    case "-":
      if (ce.charAt(ie + 3) === "-") {
        var je = ce.indexOf("-->", ie + 4);
        return je > ie ? (me.comment(ce, ie + 4, je - ie - 4), je + 3) : (we.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (ce.substr(ie + 3, 6) == "CDATA[") {
        var je = ce.indexOf("]]>", ie + 9);
        return me.startCDATA(), me.characters(ce, ie + 9, je - ie - 9), me.endCDATA(), je + 3;
      }
      var Ue = A_(ce, ie), qe = Ue.length;
      if (qe > 1 && /!doctype/i.test(Ue[0][0])) {
        var Ge = Ue[1][0], Xe = !1, ot = !1;
        qe > 3 && (/^public$/i.test(Ue[2][0]) ? (Xe = Ue[3][0], ot = qe > 4 && Ue[4][0]) : /^system$/i.test(Ue[2][0]) && (ot = Ue[3][0]));
        var vt = Ue[qe - 1];
        return me.startDTD(Ge, Xe, ot), me.endDTD(), vt.index + vt[0].length;
      }
  }
  return -1;
}
function C_(ce, ie, me) {
  var we = ce.indexOf("?>", ie);
  if (we) {
    var Re = ce.substring(ie, we).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return Re ? (Re[0].length, me.processingInstruction(Re[1], Re[2]), we + 2) : -1;
  }
  return -1;
}
function mh() {
  this.attributeNames = {};
}
mh.prototype = {
  setTagName: function(ce) {
    if (!Tc.test(ce))
      throw new Error("invalid tagName:" + ce);
    this.tagName = ce;
  },
  addValue: function(ce, ie, me) {
    if (!Tc.test(ce))
      throw new Error("invalid attribute:" + ce);
    this.attributeNames[ce] = this.length, this[this.length++] = { qName: ce, value: ie, offset: me };
  },
  length: 0,
  getLocalName: function(ce) {
    return this[ce].localName;
  },
  getLocator: function(ce) {
    return this[ce].locator;
  },
  getQName: function(ce) {
    return this[ce].qName;
  },
  getURI: function(ce) {
    return this[ce].uri;
  },
  getValue: function(ce) {
    return this[ce].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function A_(ce, ie) {
  var me, we = [], Re = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (Re.lastIndex = ie, Re.exec(ce); me = Re.exec(ce); )
    if (we.push(me), me[1]) return we;
}
Du.XMLReader = fh;
Du.ParseError = ys;
var D_ = ti, w_ = gi, xc = hh, gh = Du, k_ = w_.DOMImplementation, Sc = D_.NAMESPACE, I_ = gh.ParseError, P_ = gh.XMLReader;
function _h(ce) {
  return ce.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function yh(ce) {
  this.options = ce || { locator: {} };
}
yh.prototype.parseFromString = function(ce, ie) {
  var me = this.options, we = new P_(), Re = me.domBuilder || new zr(), je = me.errorHandler, Ue = me.locator, qe = me.xmlns || {}, Ge = /\/x?html?$/.test(ie), Xe = Ge ? xc.HTML_ENTITIES : xc.XML_ENTITIES;
  Ue && Re.setDocumentLocator(Ue), we.errorHandler = O_(je, Re, Ue), we.domBuilder = me.domBuilder || Re, Ge && (qe[""] = Sc.HTML), qe.xml = qe.xml || Sc.XML;
  var ot = me.normalizeLineEndings || _h;
  return ce && typeof ce == "string" ? we.parse(
    ot(ce),
    qe,
    Xe
  ) : we.errorHandler.error("invalid doc source"), Re.doc;
};
function O_(ce, ie, me) {
  if (!ce) {
    if (ie instanceof zr)
      return ie;
    ce = ie;
  }
  var we = {}, Re = ce instanceof Function;
  me = me || {};
  function je(Ue) {
    var qe = ce[Ue];
    !qe && Re && (qe = ce.length == 2 ? function(Ge) {
      ce(Ue, Ge);
    } : ce), we[Ue] = qe && function(Ge) {
      qe("[xmldom " + Ue + "]	" + Ge + $o(me));
    } || function() {
    };
  }
  return je("warning"), je("error"), je("fatalError"), we;
}
function zr() {
  this.cdata = !1;
}
function Ji(ce, ie) {
  ie.lineNumber = ce.lineNumber, ie.columnNumber = ce.columnNumber;
}
zr.prototype = {
  startDocument: function() {
    this.doc = new k_().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(ce, ie, me, we) {
    var Re = this.doc, je = Re.createElementNS(ce, me || ie), Ue = we.length;
    On(this, je), this.currentElement = je, this.locator && Ji(this.locator, je);
    for (var qe = 0; qe < Ue; qe++) {
      var ce = we.getURI(qe), Ge = we.getValue(qe), me = we.getQName(qe), Xe = Re.createAttributeNS(ce, me);
      this.locator && Ji(we.getLocator(qe), Xe), Xe.value = Xe.nodeValue = Ge, je.setAttributeNode(Xe);
    }
  },
  endElement: function(ce, ie, me) {
    var we = this.currentElement;
    we.tagName, this.currentElement = we.parentNode;
  },
  startPrefixMapping: function(ce, ie) {
  },
  endPrefixMapping: function(ce) {
  },
  processingInstruction: function(ce, ie) {
    var me = this.doc.createProcessingInstruction(ce, ie);
    this.locator && Ji(this.locator, me), On(this, me);
  },
  ignorableWhitespace: function(ce, ie, me) {
  },
  characters: function(ce, ie, me) {
    if (ce = Ec.apply(this, arguments), ce) {
      if (this.cdata)
        var we = this.doc.createCDATASection(ce);
      else
        var we = this.doc.createTextNode(ce);
      this.currentElement ? this.currentElement.appendChild(we) : /^\s*$/.test(ce) && this.doc.appendChild(we), this.locator && Ji(this.locator, we);
    }
  },
  skippedEntity: function(ce) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(ce) {
    (this.locator = ce) && (ce.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(ce, ie, me) {
    ce = Ec.apply(this, arguments);
    var we = this.doc.createComment(ce);
    this.locator && Ji(this.locator, we), On(this, we);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(ce, ie, me) {
    var we = this.doc.implementation;
    if (we && we.createDocumentType) {
      var Re = we.createDocumentType(ce, ie, me);
      this.locator && Ji(this.locator, Re), On(this, Re), this.doc.doctype = Re;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(ce) {
    console.warn("[xmldom warning]	" + ce, $o(this.locator));
  },
  error: function(ce) {
    console.error("[xmldom error]	" + ce, $o(this.locator));
  },
  fatalError: function(ce) {
    throw new I_(ce, this.locator);
  }
};
function $o(ce) {
  if (ce)
    return `
@` + (ce.systemId || "") + "#[line:" + ce.lineNumber + ",col:" + ce.columnNumber + "]";
}
function Ec(ce, ie, me) {
  return typeof ce == "string" ? ce.substr(ie, me) : ce.length >= ie + me || ie ? new java.lang.String(ce, ie, me) + "" : ce;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(ce) {
  zr.prototype[ce] = function() {
    return null;
  };
});
function On(ce, ie) {
  ce.currentElement ? ce.currentElement.appendChild(ie) : ce.doc.appendChild(ie);
}
va.__DOMHandler = zr;
va.normalizeLineEndings = _h;
va.DOMParser = yh;
var L_ = va.DOMParser;
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */
const Cc = (ce) => !!ce && typeof ce == "object", Ne = (...ce) => ce.reduce((ie, me) => (typeof me != "object" || Object.keys(me).forEach((we) => {
  Array.isArray(ie[we]) && Array.isArray(me[we]) ? ie[we] = ie[we].concat(me[we]) : Cc(ie[we]) && Cc(me[we]) ? ie[we] = Ne(ie[we], me[we]) : ie[we] = me[we];
}), ie), {}), Th = (ce) => Object.keys(ce).map((ie) => ce[ie]), R_ = (ce, ie) => {
  const me = [];
  for (let we = ce; we < ie; we++)
    me.push(we);
  return me;
}, Ts = (ce) => ce.reduce((ie, me) => ie.concat(me), []), vh = (ce) => {
  if (!ce.length)
    return [];
  const ie = [];
  for (let me = 0; me < ce.length; me++)
    ie.push(ce[me]);
  return ie;
}, M_ = (ce, ie) => ce.reduce((me, we, Re) => (we[ie] && me.push(Re), me), []), N_ = (ce, ie) => Th(ce.reduce((me, we) => (we.forEach((Re) => {
  me[ie(Re)] = Re;
}), me), {}));
var vs = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
const Nr = ({
  baseUrl: ce = "",
  source: ie = "",
  range: me = "",
  indexRange: we = ""
}) => {
  const Re = {
    uri: ie,
    resolvedUri: _a(ce || "", ie)
  };
  if (me || we) {
    const je = (me || we).split("-");
    let Ue = S.BigInt ? S.BigInt(je[0]) : parseInt(je[0], 10), qe = S.BigInt ? S.BigInt(je[1]) : parseInt(je[1], 10);
    Ue < Number.MAX_SAFE_INTEGER && typeof Ue == "bigint" && (Ue = Number(Ue)), qe < Number.MAX_SAFE_INTEGER && typeof qe == "bigint" && (qe = Number(qe));
    let Ge;
    typeof qe == "bigint" || typeof Ue == "bigint" ? Ge = S.BigInt(qe) - S.BigInt(Ue) + S.BigInt(1) : Ge = qe - Ue + 1, typeof Ge == "bigint" && Ge < Number.MAX_SAFE_INTEGER && (Ge = Number(Ge)), Re.byterange = {
      length: Ge,
      offset: Ue
    };
  }
  return Re;
}, B_ = (ce) => {
  let ie;
  return typeof ce.offset == "bigint" || typeof ce.length == "bigint" ? ie = S.BigInt(ce.offset) + S.BigInt(ce.length) - S.BigInt(1) : ie = ce.offset + ce.length - 1, `${ce.offset}-${ie}`;
}, Ac = (ce) => (ce && typeof ce != "number" && (ce = parseInt(ce, 10)), isNaN(ce) ? null : ce), F_ = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static(ce) {
    const {
      duration: ie,
      timescale: me = 1,
      sourceDuration: we,
      periodDuration: Re
    } = ce, je = Ac(ce.endNumber), Ue = ie / me;
    return typeof je == "number" ? {
      start: 0,
      end: je
    } : typeof Re == "number" ? {
      start: 0,
      end: Re / Ue
    } : {
      start: 0,
      end: we / Ue
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic(ce) {
    const {
      NOW: ie,
      clientOffset: me,
      availabilityStartTime: we,
      timescale: Re = 1,
      duration: je,
      periodStart: Ue = 0,
      minimumUpdatePeriod: qe = 0,
      timeShiftBufferDepth: Ge = 1 / 0
    } = ce, Xe = Ac(ce.endNumber), ot = (ie + me) / 1e3, vt = we + Ue, bt = ot + qe - vt, Tt = Math.ceil(bt * Re / je), wt = Math.floor((ot - vt - Ge) * Re / je), St = Math.floor((ot - vt) * Re / je);
    return {
      start: Math.max(0, wt),
      end: typeof Xe == "number" ? Xe : Math.min(Tt, St)
    };
  }
}, U_ = (ce) => (ie) => {
  const {
    duration: me,
    timescale: we = 1,
    periodStart: Re,
    startNumber: je = 1
  } = ce;
  return {
    number: je + ie,
    duration: me / we,
    timeline: Re,
    time: ie * me
  };
}, wu = (ce) => {
  const {
    type: ie,
    duration: me,
    timescale: we = 1,
    periodDuration: Re,
    sourceDuration: je
  } = ce, {
    start: Ue,
    end: qe
  } = F_[ie](ce), Ge = R_(Ue, qe).map(U_(ce));
  if (ie === "static") {
    const Xe = Ge.length - 1, ot = typeof Re == "number" ? Re : je;
    Ge[Xe].duration = ot - me / we * Xe;
  }
  return Ge;
}, bh = (ce) => {
  const {
    baseUrl: ie,
    initialization: me = {},
    sourceDuration: we,
    indexRange: Re = "",
    periodStart: je,
    presentationTime: Ue,
    number: qe = 0,
    duration: Ge
  } = ce;
  if (!ie)
    throw new Error(vs.NO_BASE_URL);
  const Xe = Nr({
    baseUrl: ie,
    source: me.sourceURL,
    range: me.range
  }), ot = Nr({
    baseUrl: ie,
    source: ie,
    indexRange: Re
  });
  if (ot.map = Xe, Ge) {
    const vt = wu(ce);
    vt.length && (ot.duration = vt[0].duration, ot.timeline = vt[0].timeline);
  } else we && (ot.duration = we, ot.timeline = je);
  return ot.presentationTime = Ue || je, ot.number = qe, [ot];
}, ku = (ce, ie, me) => {
  const we = ce.sidx.map ? ce.sidx.map : null, Re = ce.sidx.duration, je = ce.timeline || 0, Ue = ce.sidx.byterange, qe = Ue.offset + Ue.length, Ge = ie.timescale, Xe = ie.references.filter((It) => It.referenceType !== 1), ot = [], vt = ce.endList ? "static" : "dynamic", bt = ce.sidx.timeline;
  let Tt = bt, wt = ce.mediaSequence || 0, St;
  typeof ie.firstOffset == "bigint" ? St = S.BigInt(qe) + ie.firstOffset : St = qe + ie.firstOffset;
  for (let It = 0; It < Xe.length; It++) {
    const Pt = ie.references[It], kt = Pt.referencedSize, Ot = Pt.subsegmentDuration;
    let Jr;
    typeof St == "bigint" ? Jr = St + S.BigInt(kt) - S.BigInt(1) : Jr = St + kt - 1;
    const en = `${St}-${Jr}`, nn = bh({
      baseUrl: me,
      timescale: Ge,
      timeline: je,
      periodStart: bt,
      presentationTime: Tt,
      number: wt,
      duration: Ot,
      sourceDuration: Re,
      indexRange: en,
      type: vt
    })[0];
    we && (nn.map = we), ot.push(nn), typeof St == "bigint" ? St += S.BigInt(kt) : St += kt, Tt += Ot / Ge, wt++;
  }
  return ce.segments = ot, ce;
}, $_ = ["AUDIO", "SUBTITLES"], j_ = 1 / 60, xh = (ce) => N_(ce, ({
  timeline: ie
}) => ie).sort((ie, me) => ie.timeline > me.timeline ? 1 : -1), q_ = (ce, ie) => {
  for (let me = 0; me < ce.length; me++)
    if (ce[me].attributes.NAME === ie)
      return ce[me];
  return null;
}, Dc = (ce) => {
  let ie = [];
  return n_(ce, $_, (me, we, Re, je) => {
    ie = ie.concat(me.playlists || []);
  }), ie;
}, wc = ({
  playlist: ce,
  mediaSequence: ie
}) => {
  ce.mediaSequence = ie, ce.segments.forEach((me, we) => {
    me.number = ce.mediaSequence + we;
  });
}, V_ = ({
  oldPlaylists: ce,
  newPlaylists: ie,
  timelineStarts: me
}) => {
  ie.forEach((we) => {
    we.discontinuitySequence = me.findIndex(function({
      timeline: qe
    }) {
      return qe === we.timeline;
    });
    const Re = q_(ce, we.attributes.NAME);
    if (!Re || we.sidx)
      return;
    const je = we.segments[0], Ue = Re.segments.findIndex(function(qe) {
      return Math.abs(qe.presentationTime - je.presentationTime) < j_;
    });
    if (Ue === -1) {
      wc({
        playlist: we,
        mediaSequence: Re.mediaSequence + Re.segments.length
      }), we.segments[0].discontinuity = !0, we.discontinuityStarts.unshift(0), (!Re.segments.length && we.timeline > Re.timeline || Re.segments.length && we.timeline > Re.segments[Re.segments.length - 1].timeline) && we.discontinuitySequence--;
      return;
    }
    Re.segments[Ue].discontinuity && !je.discontinuity && (je.discontinuity = !0, we.discontinuityStarts.unshift(0), we.discontinuitySequence--), wc({
      playlist: we,
      mediaSequence: Re.segments[Ue].number
    });
  });
}, H_ = ({
  oldManifest: ce,
  newManifest: ie
}) => {
  const me = ce.playlists.concat(Dc(ce)), we = ie.playlists.concat(Dc(ie));
  return ie.timelineStarts = xh([ce.timelineStarts, ie.timelineStarts]), V_({
    oldPlaylists: me,
    newPlaylists: we,
    timelineStarts: ie.timelineStarts
  }), ie;
}, ba = (ce) => ce && ce.uri + "-" + B_(ce.byterange), vo = (ce) => {
  const ie = ce.reduce(function(we, Re) {
    return we[Re.attributes.baseUrl] || (we[Re.attributes.baseUrl] = []), we[Re.attributes.baseUrl].push(Re), we;
  }, {});
  let me = [];
  return Object.values(ie).forEach((we) => {
    const Re = Th(we.reduce((je, Ue) => {
      const qe = Ue.attributes.id + (Ue.attributes.lang || "");
      return je[qe] ? (Ue.segments && (Ue.segments[0] && (Ue.segments[0].discontinuity = !0), je[qe].segments.push(...Ue.segments)), Ue.attributes.contentProtection && (je[qe].attributes.contentProtection = Ue.attributes.contentProtection)) : (je[qe] = Ue, je[qe].attributes.timelineStarts = []), je[qe].attributes.timelineStarts.push({
        // Although they represent the same number, it's important to have both to make it
        // compatible with HLS potentially having a similar attribute.
        start: Ue.attributes.periodStart,
        timeline: Ue.attributes.periodStart
      }), je;
    }, {}));
    me = me.concat(Re);
  }), me.map((we) => (we.discontinuityStarts = M_(we.segments || [], "discontinuity"), we));
}, Iu = (ce, ie) => {
  const me = ba(ce.sidx), we = me && ie[me] && ie[me].sidx;
  return we && ku(ce, we, ce.sidx.resolvedUri), ce;
}, z_ = (ce, ie = {}) => {
  if (!Object.keys(ie).length)
    return ce;
  for (const me in ce)
    ce[me] = Iu(ce[me], ie);
  return ce;
}, W_ = ({
  attributes: ce,
  segments: ie,
  sidx: me,
  mediaSequence: we,
  discontinuitySequence: Re,
  discontinuityStarts: je
}, Ue) => {
  const qe = {
    attributes: {
      NAME: ce.id,
      BANDWIDTH: ce.bandwidth,
      CODECS: ce.codecs,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: ce.type === "static",
    timeline: ce.periodStart,
    resolvedUri: ce.baseUrl || "",
    targetDuration: ce.duration,
    discontinuitySequence: Re,
    discontinuityStarts: je,
    timelineStarts: ce.timelineStarts,
    mediaSequence: we,
    segments: ie
  };
  return ce.contentProtection && (qe.contentProtection = ce.contentProtection), ce.serviceLocation && (qe.attributes.serviceLocation = ce.serviceLocation), me && (qe.sidx = me), Ue && (qe.attributes.AUDIO = "audio", qe.attributes.SUBTITLES = "subs"), qe;
}, G_ = ({
  attributes: ce,
  segments: ie,
  mediaSequence: me,
  discontinuityStarts: we,
  discontinuitySequence: Re
}) => {
  typeof ie > "u" && (ie = [{
    uri: ce.baseUrl,
    timeline: ce.periodStart,
    resolvedUri: ce.baseUrl || "",
    duration: ce.sourceDuration,
    number: 0
  }], ce.duration = ce.sourceDuration);
  const je = {
    NAME: ce.id,
    BANDWIDTH: ce.bandwidth,
    "PROGRAM-ID": 1
  };
  ce.codecs && (je.CODECS = ce.codecs);
  const Ue = {
    attributes: je,
    uri: "",
    endList: ce.type === "static",
    timeline: ce.periodStart,
    resolvedUri: ce.baseUrl || "",
    targetDuration: ce.duration,
    timelineStarts: ce.timelineStarts,
    discontinuityStarts: we,
    discontinuitySequence: Re,
    mediaSequence: me,
    segments: ie
  };
  return ce.serviceLocation && (Ue.attributes.serviceLocation = ce.serviceLocation), Ue;
}, X_ = (ce, ie = {}, me = !1) => {
  let we;
  const Re = ce.reduce((je, Ue) => {
    const qe = Ue.attributes.role && Ue.attributes.role.value || "", Ge = Ue.attributes.lang || "";
    let Xe = Ue.attributes.label || "main";
    if (Ge && !Ue.attributes.label) {
      const vt = qe ? ` (${qe})` : "";
      Xe = `${Ue.attributes.lang}${vt}`;
    }
    je[Xe] || (je[Xe] = {
      language: Ge,
      autoselect: !0,
      default: qe === "main",
      playlists: [],
      uri: ""
    });
    const ot = Iu(W_(Ue, me), ie);
    return je[Xe].playlists.push(ot), typeof we > "u" && qe === "main" && (we = Ue, we.default = !0), je;
  }, {});
  if (!we) {
    const je = Object.keys(Re)[0];
    Re[je].default = !0;
  }
  return Re;
}, K_ = (ce, ie = {}) => ce.reduce((me, we) => {
  const Re = we.attributes.label || we.attributes.lang || "text", je = we.attributes.lang || "und";
  return me[Re] || (me[Re] = {
    language: je,
    default: !1,
    autoselect: !1,
    playlists: [],
    uri: ""
  }), me[Re].playlists.push(Iu(G_(we), ie)), me;
}, {}), Y_ = (ce) => ce.reduce((ie, me) => (me && me.forEach((we) => {
  const {
    channel: Re,
    language: je
  } = we;
  ie[je] = {
    autoselect: !1,
    default: !1,
    instreamId: Re,
    language: je
  }, we.hasOwnProperty("aspectRatio") && (ie[je].aspectRatio = we.aspectRatio), we.hasOwnProperty("easyReader") && (ie[je].easyReader = we.easyReader), we.hasOwnProperty("3D") && (ie[je]["3D"] = we["3D"]);
}), ie), {}), Q_ = ({
  attributes: ce,
  segments: ie,
  sidx: me,
  discontinuityStarts: we
}) => {
  const Re = {
    attributes: {
      NAME: ce.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: ce.width,
        height: ce.height
      },
      CODECS: ce.codecs,
      BANDWIDTH: ce.bandwidth,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: ce.type === "static",
    timeline: ce.periodStart,
    resolvedUri: ce.baseUrl || "",
    targetDuration: ce.duration,
    discontinuityStarts: we,
    timelineStarts: ce.timelineStarts,
    segments: ie
  };
  return ce.frameRate && (Re.attributes["FRAME-RATE"] = ce.frameRate), ce.contentProtection && (Re.contentProtection = ce.contentProtection), ce.serviceLocation && (Re.attributes.serviceLocation = ce.serviceLocation), me && (Re.sidx = me), Re;
}, J_ = ({
  attributes: ce
}) => ce.mimeType === "video/mp4" || ce.mimeType === "video/webm" || ce.contentType === "video", Z_ = ({
  attributes: ce
}) => ce.mimeType === "audio/mp4" || ce.mimeType === "audio/webm" || ce.contentType === "audio", ey = ({
  attributes: ce
}) => ce.mimeType === "text/vtt" || ce.contentType === "text", ty = (ce, ie) => {
  ce.forEach((me) => {
    me.mediaSequence = 0, me.discontinuitySequence = ie.findIndex(function({
      timeline: we
    }) {
      return we === me.timeline;
    }), me.segments && me.segments.forEach((we, Re) => {
      we.number = Re;
    });
  });
}, kc = (ce) => ce ? Object.keys(ce).reduce((ie, me) => {
  const we = ce[me];
  return ie.concat(we.playlists);
}, []) : [], iy = ({
  dashPlaylists: ce,
  locations: ie,
  contentSteering: me,
  sidxMapping: we = {},
  previousManifest: Re,
  eventStream: je
}) => {
  if (!ce.length)
    return {};
  const {
    sourceDuration: Ue,
    type: qe,
    suggestedPresentationDelay: Ge,
    minimumUpdatePeriod: Xe
  } = ce[0].attributes, ot = vo(ce.filter(J_)).map(Q_), vt = vo(ce.filter(Z_)), bt = vo(ce.filter(ey)), Tt = ce.map((Jr) => Jr.attributes.captionServices).filter(Boolean), wt = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: "",
    duration: Ue,
    playlists: z_(ot, we)
  };
  Xe >= 0 && (wt.minimumUpdatePeriod = Xe * 1e3), ie && (wt.locations = ie), me && (wt.contentSteering = me), qe === "dynamic" && (wt.suggestedPresentationDelay = Ge), je && je.length > 0 && (wt.eventStream = je);
  const St = wt.playlists.length === 0, It = vt.length ? X_(vt, we, St) : null, Pt = bt.length ? K_(bt, we) : null, kt = ot.concat(kc(It), kc(Pt)), Ot = kt.map(({
    timelineStarts: Jr
  }) => Jr);
  return wt.timelineStarts = xh(Ot), ty(kt, wt.timelineStarts), It && (wt.mediaGroups.AUDIO.audio = It), Pt && (wt.mediaGroups.SUBTITLES.subs = Pt), Tt.length && (wt.mediaGroups["CLOSED-CAPTIONS"].cc = Y_(Tt)), Re ? H_({
    oldManifest: Re,
    newManifest: wt
  }) : wt;
}, sy = (ce, ie, me) => {
  const {
    NOW: we,
    clientOffset: Re,
    availabilityStartTime: je,
    timescale: Ue = 1,
    periodStart: qe = 0,
    minimumUpdatePeriod: Ge = 0
  } = ce, Xe = (we + Re) / 1e3, ot = je + qe, vt = Xe + Ge - ot;
  return Math.ceil((vt * Ue - ie) / me);
}, Sh = (ce, ie) => {
  const {
    type: me,
    minimumUpdatePeriod: we = 0,
    media: Re = "",
    sourceDuration: je,
    timescale: Ue = 1,
    startNumber: qe = 1,
    periodStart: Ge
  } = ce, Xe = [];
  let ot = -1;
  for (let vt = 0; vt < ie.length; vt++) {
    const bt = ie[vt], Tt = bt.d, wt = bt.r || 0, St = bt.t || 0;
    ot < 0 && (ot = St), St && St > ot && (ot = St);
    let It;
    if (wt < 0) {
      const Ot = vt + 1;
      Ot === ie.length ? me === "dynamic" && we > 0 && Re.indexOf("$Number$") > 0 ? It = sy(ce, ot, Tt) : It = (je * Ue - ot) / Tt : It = (ie[Ot].t - ot) / Tt;
    } else
      It = wt + 1;
    const Pt = qe + Xe.length + It;
    let kt = qe + Xe.length;
    for (; kt < Pt; )
      Xe.push({
        number: kt,
        duration: Tt / Ue,
        time: ot,
        timeline: Ge
      }), ot += Tt, kt++;
  }
  return Xe;
}, ry = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, ny = (ce) => (ie, me, we, Re) => {
  if (ie === "$$")
    return "$";
  if (typeof ce[me] > "u")
    return ie;
  const je = "" + ce[me];
  return me === "RepresentationID" || (we ? Re = parseInt(Re, 10) : Re = 1, je.length >= Re) ? je : `${new Array(Re - je.length + 1).join("0")}${je}`;
}, Ic = (ce, ie) => ce.replace(ry, ny(ie)), ay = (ce, ie) => !ce.duration && !ie ? [{
  number: ce.startNumber || 1,
  duration: ce.sourceDuration,
  time: 0,
  timeline: ce.periodStart
}] : ce.duration ? wu(ce) : Sh(ce, ie), oy = (ce, ie) => {
  const me = {
    RepresentationID: ce.id,
    Bandwidth: ce.bandwidth || 0
  }, {
    initialization: we = {
      sourceURL: "",
      range: ""
    }
  } = ce, Re = Nr({
    baseUrl: ce.baseUrl,
    source: Ic(we.sourceURL, me),
    range: we.range
  });
  return ay(ce, ie).map((je) => {
    me.Number = je.number, me.Time = je.time;
    const Ue = Ic(ce.media || "", me), qe = ce.timescale || 1, Ge = ce.presentationTimeOffset || 0, Xe = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      ce.periodStart + (je.time - Ge) / qe
    );
    return {
      uri: Ue,
      timeline: je.timeline,
      duration: je.duration,
      resolvedUri: _a(ce.baseUrl || "", Ue),
      map: Re,
      number: je.number,
      presentationTime: Xe
    };
  });
}, uy = (ce, ie) => {
  const {
    baseUrl: me,
    initialization: we = {}
  } = ce, Re = Nr({
    baseUrl: me,
    source: we.sourceURL,
    range: we.range
  }), je = Nr({
    baseUrl: me,
    source: ie.media,
    range: ie.mediaRange
  });
  return je.map = Re, je;
}, ly = (ce, ie) => {
  const {
    duration: me,
    segmentUrls: we = [],
    periodStart: Re
  } = ce;
  if (!me && !ie || me && ie)
    throw new Error(vs.SEGMENT_TIME_UNSPECIFIED);
  const je = we.map((qe) => uy(ce, qe));
  let Ue;
  return me && (Ue = wu(ce)), ie && (Ue = Sh(ce, ie)), Ue.map((qe, Ge) => {
    if (je[Ge]) {
      const Xe = je[Ge], ot = ce.timescale || 1, vt = ce.presentationTimeOffset || 0;
      return Xe.timeline = qe.timeline, Xe.duration = qe.duration, Xe.number = qe.number, Xe.presentationTime = Re + (qe.time - vt) / ot, Xe;
    }
  }).filter((qe) => qe);
}, cy = ({
  attributes: ce,
  segmentInfo: ie
}) => {
  let me, we;
  ie.template ? (we = oy, me = Ne(ce, ie.template)) : ie.base ? (we = bh, me = Ne(ce, ie.base)) : ie.list && (we = ly, me = Ne(ce, ie.list));
  const Re = {
    attributes: ce
  };
  if (!we)
    return Re;
  const je = we(me, ie.segmentTimeline);
  if (me.duration) {
    const {
      duration: Ue,
      timescale: qe = 1
    } = me;
    me.duration = Ue / qe;
  } else je.length ? me.duration = je.reduce((Ue, qe) => Math.max(Ue, Math.ceil(qe.duration)), 0) : me.duration = 0;
  return Re.attributes = me, Re.segments = je, ie.base && me.indexRange && (Re.sidx = je[0], Re.segments = []), Re;
}, dy = (ce) => ce.map(cy), Ee$1 = (ce, ie) => vh(ce.childNodes).filter(({
  tagName: me
}) => me === ie), Wr = (ce) => ce.textContent.trim(), hy = (ce) => parseFloat(ce.split("/").reduce((ie, me) => ie / me)), Zi = (ce) => {
  const ie = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(ce);
  if (!ie)
    return 0;
  const [me, we, Re, je, Ue, qe] = ie.slice(1);
  return parseFloat(me || 0) * 31536e3 + parseFloat(we || 0) * 2592e3 + parseFloat(Re || 0) * 86400 + parseFloat(je || 0) * 3600 + parseFloat(Ue || 0) * 60 + parseFloat(qe || 0);
}, fy = (ce) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(ce) && (ce += "Z"), Date.parse(ce)), Pc = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration(ce) {
    return Zi(ce);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime(ce) {
    return fy(ce) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod(ce) {
    return Zi(ce);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay(ce) {
    return Zi(ce);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type(ce) {
    return ce;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth(ce) {
    return Zi(ce);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start(ce) {
    return Zi(ce);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate(ce) {
    return hy(ce);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration(ce) {
    const ie = parseInt(ce, 10);
    return isNaN(ie) ? Zi(ce) : ie;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */
  presentationTime(ce) {
    return parseInt(ce, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT(ce) {
    return ce;
  }
}, Le = (ce) => ce && ce.attributes ? vh(ce.attributes).reduce((ie, me) => {
  const we = Pc[me.name] || Pc.DEFAULT;
  return ie[me.name] = we(me.value), ie;
}, {}) : {}, py = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
  // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
  "urn:mpeg:dash:mp4protection:2011": "mp4protection"
}, xa = (ce, ie) => ie.length ? Ts(ce.map(function(me) {
  return ie.map(function(we) {
    const Re = Wr(we), je = _a(me.baseUrl, Re), Ue = Ne(Le(we), {
      baseUrl: je
    });
    return je !== Re && !Ue.serviceLocation && me.serviceLocation && (Ue.serviceLocation = me.serviceLocation), Ue;
  });
})) : ce, Pu = (ce) => {
  const ie = Ee$1(ce, "SegmentTemplate")[0], me = Ee$1(ce, "SegmentList")[0], we = me && Ee$1(me, "SegmentURL").map((vt) => Ne({
    tag: "SegmentURL"
  }, Le(vt))), Re = Ee$1(ce, "SegmentBase")[0], je = me || ie, Ue = je && Ee$1(je, "SegmentTimeline")[0], qe = me || Re || ie, Ge = qe && Ee$1(qe, "Initialization")[0], Xe = ie && Le(ie);
  Xe && Ge ? Xe.initialization = Ge && Le(Ge) : Xe && Xe.initialization && (Xe.initialization = {
    sourceURL: Xe.initialization
  });
  const ot = {
    template: Xe,
    segmentTimeline: Ue && Ee$1(Ue, "S").map((vt) => Le(vt)),
    list: me && Ne(Le(me), {
      segmentUrls: we,
      initialization: Le(Ge)
    }),
    base: Re && Ne(Le(Re), {
      initialization: Le(Ge)
    })
  };
  return Object.keys(ot).forEach((vt) => {
    ot[vt] || delete ot[vt];
  }), ot;
}, my = (ce, ie, me) => (we) => {
  const Re = Ee$1(we, "BaseURL"), je = xa(ie, Re), Ue = Ne(ce, Le(we)), qe = Pu(we);
  return je.map((Ge) => ({
    segmentInfo: Ne(me, qe),
    attributes: Ne(Ue, Ge)
  }));
}, gy = (ce) => ce.reduce((ie, me) => {
  const we = Le(me);
  we.schemeIdUri && (we.schemeIdUri = we.schemeIdUri.toLowerCase());
  const Re = py[we.schemeIdUri];
  if (Re) {
    ie[Re] = {
      attributes: we
    };
    const je = Ee$1(me, "cenc:pssh")[0];
    if (je) {
      const Ue = Wr(je);
      ie[Re].pssh = Ue && Fd(Ue);
    }
  }
  return ie;
}, {}), _y = (ce) => {
  if (ce.schemeIdUri === "urn:scte:dash:cc:cea-608:2015")
    return (typeof ce.value != "string" ? [] : ce.value.split(";")).map((ie) => {
      let me, we;
      return we = ie, /^CC\d=/.test(ie) ? [me, we] = ie.split("=") : /^CC\d$/.test(ie) && (me = ie), {
        channel: me,
        language: we
      };
    });
  if (ce.schemeIdUri === "urn:scte:dash:cc:cea-708:2015")
    return (typeof ce.value != "string" ? [] : ce.value.split(";")).map((ie) => {
      const me = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(ie)) {
        const [we, Re = ""] = ie.split("=");
        me.channel = we, me.language = ie, Re.split(",").forEach((je) => {
          const [Ue, qe] = je.split(":");
          Ue === "lang" ? me.language = qe : Ue === "er" ? me.easyReader = Number(qe) : Ue === "war" ? me.aspectRatio = Number(qe) : Ue === "3D" && (me["3D"] = Number(qe));
        });
      } else
        me.language = ie;
      return me.channel && (me.channel = "SERVICE" + me.channel), me;
    });
}, yy = (ce) => Ts(Ee$1(ce.node, "EventStream").map((ie) => {
  const me = Le(ie), we = me.schemeIdUri;
  return Ee$1(ie, "Event").map((Re) => {
    const je = Le(Re), Ue = je.presentationTime || 0, qe = me.timescale || 1, Ge = je.duration || 0, Xe = Ue / qe + ce.attributes.start;
    return {
      schemeIdUri: we,
      value: me.value,
      id: je.id,
      start: Xe,
      end: Xe + Ge / qe,
      messageData: Wr(Re) || je.messageData,
      contentEncoding: me.contentEncoding,
      presentationTimeOffset: me.presentationTimeOffset || 0
    };
  });
})), Ty = (ce, ie, me) => (we) => {
  const Re = Le(we), je = xa(ie, Ee$1(we, "BaseURL")), Ue = Ee$1(we, "Role")[0], qe = {
    role: Le(Ue)
  };
  let Ge = Ne(ce, Re, qe);
  const Xe = Ee$1(we, "Accessibility")[0], ot = _y(Le(Xe));
  ot && (Ge = Ne(Ge, {
    captionServices: ot
  }));
  const vt = Ee$1(we, "Label")[0];
  if (vt && vt.childNodes.length) {
    const It = vt.childNodes[0].nodeValue.trim();
    Ge = Ne(Ge, {
      label: It
    });
  }
  const bt = gy(Ee$1(we, "ContentProtection"));
  Object.keys(bt).length && (Ge = Ne(Ge, {
    contentProtection: bt
  }));
  const Tt = Pu(we), wt = Ee$1(we, "Representation"), St = Ne(me, Tt);
  return Ts(wt.map(my(Ge, je, St)));
}, vy = (ce, ie) => (me, we) => {
  const Re = xa(ie, Ee$1(me.node, "BaseURL")), je = Ne(ce, {
    periodStart: me.attributes.start
  });
  typeof me.attributes.duration == "number" && (je.periodDuration = me.attributes.duration);
  const Ue = Ee$1(me.node, "AdaptationSet"), qe = Pu(me.node);
  return Ts(Ue.map(Ty(je, Re, qe)));
}, by = (ce, ie) => {
  if (ce.length > 1 && ie({
    type: "warn",
    message: "The MPD manifest should contain no more than one ContentSteering tag"
  }), !ce.length)
    return null;
  const me = Ne({
    serverURL: Wr(ce[0])
  }, Le(ce[0]));
  return me.queryBeforeStart = me.queryBeforeStart === "true", me;
}, xy = ({
  attributes: ce,
  priorPeriodAttributes: ie,
  mpdType: me
}) => typeof ce.start == "number" ? ce.start : ie && typeof ie.start == "number" && typeof ie.duration == "number" ? ie.start + ie.duration : !ie && me === "static" ? 0 : null, Sy = (ce, ie = {}) => {
  const {
    manifestUri: me = "",
    NOW: we = Date.now(),
    clientOffset: Re = 0,
    // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler: je = function() {
    }
  } = ie, Ue = Ee$1(ce, "Period");
  if (!Ue.length)
    throw new Error(vs.INVALID_NUMBER_OF_PERIOD);
  const qe = Ee$1(ce, "Location"), Ge = Le(ce), Xe = xa([{
    baseUrl: me
  }], Ee$1(ce, "BaseURL")), ot = Ee$1(ce, "ContentSteering");
  Ge.type = Ge.type || "static", Ge.sourceDuration = Ge.mediaPresentationDuration || 0, Ge.NOW = we, Ge.clientOffset = Re, qe.length && (Ge.locations = qe.map(Wr));
  const vt = [];
  return Ue.forEach((bt, Tt) => {
    const wt = Le(bt), St = vt[Tt - 1];
    wt.start = xy({
      attributes: wt,
      priorPeriodAttributes: St ? St.attributes : null,
      mpdType: Ge.type
    }), vt.push({
      node: bt,
      attributes: wt
    });
  }), {
    locations: Ge.locations,
    contentSteeringInfo: by(ot, je),
    // TODO: There are occurences where this `representationInfo` array contains undesired
    // duplicates. This generally occurs when there are multiple BaseURL nodes that are
    // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
    // parent BaseURL and a child BaseURL, and the value does not resolve,
    // we end up returning the child BaseURL multiple times.
    // We need to determine a way to remove these duplicates in a safe way.
    // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
    representationInfo: Ts(vt.map(vy(Ge, Xe))),
    eventStream: Ts(vt.map(yy))
  };
}, Eh = (ce) => {
  if (ce === "")
    throw new Error(vs.DASH_EMPTY_MANIFEST);
  const ie = new L_();
  let me, we;
  try {
    me = ie.parseFromString(ce, "application/xml"), we = me && me.documentElement.tagName === "MPD" ? me.documentElement : null;
  } catch {
  }
  if (!we || we && we.getElementsByTagName("parsererror").length > 0)
    throw new Error(vs.DASH_INVALID_XML);
  return we;
}, Ey = (ce) => {
  const ie = Ee$1(ce, "UTCTiming")[0];
  if (!ie)
    return null;
  const me = Le(ie);
  switch (me.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      me.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      me.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      me.method = "DIRECT", me.value = Date.parse(me.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(vs.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return me;
}, Cy = (ce, ie = {}) => {
  const me = Sy(Eh(ce), ie), we = dy(me.representationInfo);
  return iy({
    dashPlaylists: we,
    locations: me.locations,
    contentSteering: me.contentSteeringInfo,
    sidxMapping: ie.sidxMapping,
    previousManifest: ie.previousManifest,
    eventStream: me.eventStream
  });
}, Ay = (ce) => Ey(Eh(ce));
var Dy = Math.pow(2, 32), wy = function(ce) {
  var ie = new DataView(ce.buffer, ce.byteOffset, ce.byteLength), me;
  return ie.getBigUint64 ? (me = ie.getBigUint64(0), me < Number.MAX_SAFE_INTEGER ? Number(me) : me) : ie.getUint32(0) * Dy + ie.getUint32(4);
}, ky = {
  getUint64: wy
}, Oc = ky.getUint64, Iy = function(ce) {
  var ie = new DataView(ce.buffer, ce.byteOffset, ce.byteLength), me = {
    version: ce[0],
    flags: new Uint8Array(ce.subarray(1, 4)),
    references: [],
    referenceId: ie.getUint32(4),
    timescale: ie.getUint32(8)
  }, we = 12;
  me.version === 0 ? (me.earliestPresentationTime = ie.getUint32(we), me.firstOffset = ie.getUint32(we + 4), we += 8) : (me.earliestPresentationTime = Oc(ce.subarray(we)), me.firstOffset = Oc(ce.subarray(we + 8)), we += 16), we += 2;
  var Re = ie.getUint16(we);
  for (we += 2; Re > 0; we += 12, Re--)
    me.references.push({
      referenceType: (ce[we] & 128) >>> 7,
      referencedSize: ie.getUint32(we) & 2147483647,
      subsegmentDuration: ie.getUint32(we + 4),
      startsWithSap: !!(ce[we + 8] & 128),
      sapType: (ce[we + 8] & 112) >>> 4,
      sapDeltaTime: ie.getUint32(we + 8) & 268435455
    });
  return me;
}, Py = Iy;
const Oy = /* @__PURE__ */ jr(Py);
var Ly = Y$1([73, 68, 51]), Ry = function(ce, ie) {
  ie === void 0 && (ie = 0), ce = Y$1(ce);
  var me = ce[ie + 5], we = ce[ie + 6] << 21 | ce[ie + 7] << 14 | ce[ie + 8] << 7 | ce[ie + 9], Re = (me & 16) >> 4;
  return Re ? we + 20 : we + 10;
}, Sr = function ce(ie, me) {
  return me === void 0 && (me = 0), ie = Y$1(ie), ie.length - me < 10 || !Se$1(ie, Ly, {
    offset: me
  }) ? me : (me += Ry(ie, me), ce(ie, me));
}, Lc = function(ce) {
  return typeof ce == "string" ? Vd(ce) : ce;
}, My = function(ce) {
  return Array.isArray(ce) ? ce.map(function(ie) {
    return Lc(ie);
  }) : [Lc(ce)];
}, Ny = function ce(ie, me, we) {
  we === void 0 && (we = !1), me = My(me), ie = Y$1(ie);
  var Re = [];
  if (!me.length)
    return Re;
  for (var je = 0; je < ie.length; ) {
    var Ue = (ie[je] << 24 | ie[je + 1] << 16 | ie[je + 2] << 8 | ie[je + 3]) >>> 0, qe = ie.subarray(je + 4, je + 8);
    if (Ue === 0)
      break;
    var Ge = je + Ue;
    if (Ge > ie.length) {
      if (we)
        break;
      Ge = ie.length;
    }
    var Xe = ie.subarray(je + 8, Ge);
    Se$1(qe, me[0]) && (me.length === 1 ? Re.push(Xe) : Re.push.apply(Re, ce(Xe, me.slice(1), we))), je = Ge;
  }
  return Re;
}, Ln = {
  EBML: Y$1([26, 69, 223, 163]),
  DocType: Y$1([66, 130]),
  Segment: Y$1([24, 83, 128, 103]),
  SegmentInfo: Y$1([21, 73, 169, 102]),
  Tracks: Y$1([22, 84, 174, 107]),
  Track: Y$1([174]),
  TrackNumber: Y$1([215]),
  DefaultDuration: Y$1([35, 227, 131]),
  TrackEntry: Y$1([174]),
  TrackType: Y$1([131]),
  FlagDefault: Y$1([136]),
  CodecID: Y$1([134]),
  CodecPrivate: Y$1([99, 162]),
  VideoTrack: Y$1([224]),
  AudioTrack: Y$1([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: Y$1([31, 67, 182, 117]),
  Timestamp: Y$1([231]),
  TimestampScale: Y$1([42, 215, 177]),
  BlockGroup: Y$1([160]),
  BlockDuration: Y$1([155]),
  Block: Y$1([161]),
  SimpleBlock: Y$1([163])
}, jo = [128, 64, 32, 16, 8, 4, 2, 1], By = function(ce) {
  for (var ie = 1, me = 0; me < jo.length && !(ce & jo[me]); me++)
    ie++;
  return ie;
}, Kn = function(ce, ie, me, we) {
  me === void 0 && (me = !0), we === void 0 && (we = !1);
  var Re = By(ce[ie]), je = ce.subarray(ie, ie + Re);
  return me && (je = Array.prototype.slice.call(ce, ie, ie + Re), je[0] ^= jo[Re - 1]), {
    length: Re,
    value: i_(je, {
      signed: we
    }),
    bytes: je
  };
}, Rc = function ce(ie) {
  return typeof ie == "string" ? ie.match(/.{1,2}/g).map(function(me) {
    return ce(me);
  }) : typeof ie == "number" ? s_(ie) : ie;
}, Fy = function(ce) {
  return Array.isArray(ce) ? ce.map(function(ie) {
    return Rc(ie);
  }) : [Rc(ce)];
}, Uy = function ce(ie, me, we) {
  if (we >= me.length)
    return me.length;
  var Re = Kn(me, we, !1);
  if (Se$1(ie.bytes, Re.bytes))
    return we;
  var je = Kn(me, we + Re.length);
  return ce(ie, me, we + je.length + je.value + Re.length);
}, Mc = function ce(ie, me) {
  me = Fy(me), ie = Y$1(ie);
  var we = [];
  if (!me.length)
    return we;
  for (var Re = 0; Re < ie.length; ) {
    var je = Kn(ie, Re, !1), Ue = Kn(ie, Re + je.length), qe = Re + je.length + Ue.length;
    Ue.value === 127 && (Ue.value = Uy(je, ie, qe), Ue.value !== ie.length && (Ue.value -= qe));
    var Ge = qe + Ue.value > ie.length ? ie.length : qe + Ue.value, Xe = ie.subarray(qe, Ge);
    Se$1(me[0], je.bytes) && (me.length === 1 ? we.push(Xe) : we = we.concat(ce(Xe, me.slice(1))));
    var ot = je.length + Ue.length + Xe.length;
    Re += ot;
  }
  return we;
}, $y = Y$1([0, 0, 0, 1]), jy = Y$1([0, 0, 1]), qy = Y$1([0, 0, 3]), Vy = function(ce) {
  for (var ie = [], me = 1; me < ce.length - 2; )
    Se$1(ce.subarray(me, me + 3), qy) && (ie.push(me + 2), me++), me++;
  if (ie.length === 0)
    return ce;
  var we = ce.length - ie.length, Re = new Uint8Array(we), je = 0;
  for (me = 0; me < we; je++, me++)
    je === ie[0] && (je++, ie.shift()), Re[me] = ce[je];
  return Re;
}, Ch = function(ce, ie, me, we) {
  ce = Y$1(ce), me = [].concat(me);
  for (var Re = 0, je, Ue = 0; Re < ce.length && (Ue < we || je); ) {
    var qe = void 0;
    if (Se$1(ce.subarray(Re), $y) ? qe = 4 : Se$1(ce.subarray(Re), jy) && (qe = 3), !qe) {
      Re++;
      continue;
    }
    if (Ue++, je)
      return Vy(ce.subarray(je, Re));
    var Ge = void 0;
    ie === "h264" ? Ge = ce[Re + qe] & 31 : ie === "h265" && (Ge = ce[Re + qe] >> 1 & 63), me.indexOf(Ge) !== -1 && (je = Re + qe), Re += qe + (ie === "h264" ? 1 : 2);
  }
  return ce.subarray(0, 0);
}, Hy = function(ce, ie, me) {
  return Ch(ce, "h264", ie, me);
}, zy = function(ce, ie, me) {
  return Ch(ce, "h265", ie, me);
}, Ye = {
  // "webm" string literal in hex
  webm: Y$1([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: Y$1([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: Y$1([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: Y$1([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: Y$1([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: Y$1([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: Y$1([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: Y$1([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": Y$1([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: Y$1([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: Y$1([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: Y$1([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: Y$1([109, 111, 111, 118]),
  // moof string literal in hex
  moof: Y$1([109, 111, 111, 102])
}, bs = {
  aac: function(ce) {
    var ie = Sr(ce);
    return Se$1(ce, [255, 16], {
      offset: ie,
      mask: [255, 22]
    });
  },
  mp3: function(ce) {
    var ie = Sr(ce);
    return Se$1(ce, [255, 2], {
      offset: ie,
      mask: [255, 6]
    });
  },
  webm: function(ce) {
    var ie = Mc(ce, [Ln.EBML, Ln.DocType])[0];
    return Se$1(ie, Ye.webm);
  },
  mkv: function(ce) {
    var ie = Mc(ce, [Ln.EBML, Ln.DocType])[0];
    return Se$1(ie, Ye.matroska);
  },
  mp4: function(ce) {
    if (bs["3gp"](ce) || bs.mov(ce))
      return !1;
    if (Se$1(ce, Ye.mp4, {
      offset: 4
    }) || Se$1(ce, Ye.fmp4, {
      offset: 4
    }) || Se$1(ce, Ye.moof, {
      offset: 4
    }) || Se$1(ce, Ye.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(ce) {
    return Se$1(ce, Ye.mov, {
      offset: 4
    });
  },
  "3gp": function(ce) {
    return Se$1(ce, Ye["3gp"], {
      offset: 4
    });
  },
  ac3: function(ce) {
    var ie = Sr(ce);
    return Se$1(ce, Ye.ac3, {
      offset: ie
    });
  },
  ts: function(ce) {
    if (ce.length < 189 && ce.length >= 1)
      return ce[0] === 71;
    for (var ie = 0; ie + 188 < ce.length && ie < 188; ) {
      if (ce[ie] === 71 && ce[ie + 188] === 71)
        return !0;
      ie += 1;
    }
    return !1;
  },
  flac: function(ce) {
    var ie = Sr(ce);
    return Se$1(ce, Ye.flac, {
      offset: ie
    });
  },
  ogg: function(ce) {
    return Se$1(ce, Ye.ogg);
  },
  avi: function(ce) {
    return Se$1(ce, Ye.riff) && Se$1(ce, Ye.avi, {
      offset: 8
    });
  },
  wav: function(ce) {
    return Se$1(ce, Ye.riff) && Se$1(ce, Ye.wav, {
      offset: 8
    });
  },
  h264: function(ce) {
    return Hy(ce, 7, 3).length;
  },
  h265: function(ce) {
    return zy(ce, [32, 33], 3).length;
  }
}, qo = Object.keys(bs).filter(function(ce) {
  return ce !== "ts" && ce !== "h264" && ce !== "h265";
}).concat(["ts", "h264", "h265"]);
qo.forEach(function(ce) {
  var ie = bs[ce];
  bs[ce] = function(me) {
    return ie(Y$1(me));
  };
});
var Wy = bs, Ou = function(ce) {
  ce = Y$1(ce);
  for (var ie = 0; ie < qo.length; ie++) {
    var me = qo[ie];
    if (Wy[me](ce))
      return me;
  }
  return "";
}, Gy = function(ce) {
  return Ny(ce, ["moof"]).length > 0;
}, Di = {};
/**
 * @license
 * Video.js 8.23.3 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var Vo = "8.23.3";
const Gt = {}, pi = function(ce, ie) {
  return Gt[ce] = Gt[ce] || [], ie && (Gt[ce] = Gt[ce].concat(ie)), Gt[ce];
}, Xy = function(ce, ie) {
  pi(ce, ie);
}, Ah = function(ce, ie) {
  const me = pi(ce).indexOf(ie);
  return me <= -1 ? !1 : (Gt[ce] = Gt[ce].slice(), Gt[ce].splice(me, 1), !0);
}, Ky = function(ce, ie) {
  pi(ce, [].concat(ie).map((me) => {
    const we = (...Re) => (Ah(ce, we), me(...Re));
    return we;
  }));
}, Yn = {
  prefixed: !0
}, Un = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"]
], Nc = Un[0];
let Er;
for (let ce = 0; ce < Un.length; ce++)
  if (Un[ce][1] in V$1) {
    Er = Un[ce];
    break;
  }
if (Er) {
  for (let ce = 0; ce < Er.length; ce++)
    Yn[Nc[ce]] = Er[ce];
  Yn.prefixed = Er[0] !== Nc[0];
}
let et = [];
const Yy = (ce, ie, me) => (we, Re, je) => {
  const Ue = ie.levels[Re], qe = new RegExp(`^(${Ue})$`);
  let Ge = ce;
  if (we !== "log" && je.unshift(we.toUpperCase() + ":"), me && (Ge = `%c${ce}`, je.unshift(me)), je.unshift(Ge + ":"), et) {
    et.push([].concat(je));
    const ot = et.length - 1e3;
    et.splice(0, ot > 0 ? ot : 0);
  }
  if (!S.console)
    return;
  let Xe = S.console[we];
  !Xe && we === "debug" && (Xe = S.console.info || S.console.log), !(!Xe || !Ue || !qe.test(we)) && Xe[Array.isArray(je) ? "apply" : "call"](S.console, je);
};
function Ho(ce, ie = ":", me = "") {
  let we = "info", Re;
  function je(...Ue) {
    Re("log", we, Ue);
  }
  return Re = Yy(ce, je, me), je.createLogger = (Ue, qe, Ge) => {
    const Xe = qe !== void 0 ? qe : ie, ot = Ge !== void 0 ? Ge : me, vt = `${ce} ${Xe} ${Ue}`;
    return Ho(vt, Xe, ot);
  }, je.createNewLogger = (Ue, qe, Ge) => Ho(Ue, qe, Ge), je.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: we
  }, je.level = (Ue) => {
    if (typeof Ue == "string") {
      if (!je.levels.hasOwnProperty(Ue))
        throw new Error(`"${Ue}" in not a valid log level`);
      we = Ue;
    }
    return we;
  }, je.history = () => et ? [].concat(et) : [], je.history.filter = (Ue) => (et || []).filter((qe) => new RegExp(`.*${Ue}.*`).test(qe[0])), je.history.clear = () => {
    et && (et.length = 0);
  }, je.history.disable = () => {
    et !== null && (et.length = 0, et = null);
  }, je.history.enable = () => {
    et === null && (et = []);
  }, je.error = (...Ue) => Re("error", we, Ue), je.warn = (...Ue) => Re("warn", we, Ue), je.debug = (...Ue) => Re("debug", we, Ue), je;
}
const ae = Ho("VIDEOJS"), Dh = ae.createLogger, Qy = Object.prototype.toString, wh = function(ce) {
  return qt(ce) ? Object.keys(ce) : [];
};
function as(ce, ie) {
  wh(ce).forEach((me) => ie(ce[me], me));
}
function kh(ce, ie, me = 0) {
  return wh(ce).reduce((we, Re) => ie(we, ce[Re], Re), me);
}
function qt(ce) {
  return !!ce && typeof ce == "object";
}
function xs(ce) {
  return qt(ce) && Qy.call(ce) === "[object Object]" && ce.constructor === Object;
}
function ye$2(...ce) {
  const ie = {};
  return ce.forEach((me) => {
    me && as(me, (we, Re) => {
      if (!xs(we)) {
        ie[Re] = we;
        return;
      }
      xs(ie[Re]) || (ie[Re] = {}), ie[Re] = ye$2(ie[Re], we);
    });
  }), ie;
}
function Ih(ce = {}) {
  const ie = [];
  for (const me in ce)
    if (ce.hasOwnProperty(me)) {
      const we = ce[me];
      ie.push(we);
    }
  return ie;
}
function Sa(ce, ie, me, we = !0) {
  const Re = (Ue) => Object.defineProperty(ce, ie, {
    value: Ue,
    enumerable: !0,
    writable: !0
  }), je = {
    configurable: !0,
    enumerable: !0,
    get() {
      const Ue = me();
      return Re(Ue), Ue;
    }
  };
  return we && (je.set = Re), Object.defineProperty(ce, ie, je);
}
var Jy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  each: as,
  reduce: kh,
  isObject: qt,
  isPlain: xs,
  merge: ye$2,
  values: Ih,
  defineLazyProperty: Sa
});
let Lu = !1, Ph = null, At = !1, Oh, Lh = !1, os = !1, us = !1, Vt$1 = !1, Ru = null, Ea = null;
const Zy = !!(S.cast && S.cast.framework && S.cast.framework.CastReceiverContext);
let Rh = null, Qn = !1, Ca = !1, Jn = !1, Aa = !1, Zn = !1, ea = !1, ta = !1;
const Br = !!(ws() && ("ontouchstart" in S || S.navigator.maxTouchPoints || S.DocumentTouch && S.document instanceof S.DocumentTouch)), li = S.navigator && S.navigator.userAgentData;
li && li.platform && li.brands && (At = li.platform === "Android", os = !!li.brands.find((ce) => ce.brand === "Microsoft Edge"), us = !!li.brands.find((ce) => ce.brand === "Chromium"), Vt$1 = !os && us, Ru = Ea = (li.brands.find((ce) => ce.brand === "Chromium") || {}).version || null, Ca = li.platform === "Windows");
if (!us) {
  const ce = S.navigator && S.navigator.userAgent || "";
  Lu = /iPod/i.test(ce), Ph = function() {
    const ie = ce.match(/OS (\d+)_/i);
    return ie && ie[1] ? ie[1] : null;
  }(), At = /Android/i.test(ce), Oh = function() {
    const ie = ce.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
    if (!ie)
      return null;
    const me = ie[1] && parseFloat(ie[1]), we = ie[2] && parseFloat(ie[2]);
    return me && we ? parseFloat(ie[1] + "." + ie[2]) : me || null;
  }(), Lh = /Firefox/i.test(ce), os = /Edg/i.test(ce), us = /Chrome/i.test(ce) || /CriOS/i.test(ce), Vt$1 = !os && us, Ru = Ea = function() {
    const ie = ce.match(/(Chrome|CriOS)\/(\d+)/);
    return ie && ie[2] ? parseFloat(ie[2]) : null;
  }(), Rh = function() {
    const ie = /MSIE\s(\d+)\.\d/.exec(ce);
    let me = ie && parseFloat(ie[1]);
    return !me && /Trident\/7.0/i.test(ce) && /rv:11.0/.test(ce) && (me = 11), me;
  }(), Zn = /Tizen/i.test(ce), ea = /Web0S/i.test(ce), ta = Zn || ea, Qn = /Safari/i.test(ce) && !Vt$1 && !At && !os && !ta, Ca = /Windows/i.test(ce), Jn = /iPad/i.test(ce) || Qn && Br && !/iPhone/i.test(ce), Aa = /iPhone/i.test(ce) && !Jn;
}
const Ve = Aa || Jn || Lu, Da = (Qn || Ve) && !Vt$1;
var Mh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get IS_IPOD() {
    return Lu;
  },
  get IOS_VERSION() {
    return Ph;
  },
  get IS_ANDROID() {
    return At;
  },
  get ANDROID_VERSION() {
    return Oh;
  },
  get IS_FIREFOX() {
    return Lh;
  },
  get IS_EDGE() {
    return os;
  },
  get IS_CHROMIUM() {
    return us;
  },
  get IS_CHROME() {
    return Vt$1;
  },
  get CHROMIUM_VERSION() {
    return Ru;
  },
  get CHROME_VERSION() {
    return Ea;
  },
  IS_CHROMECAST_RECEIVER: Zy,
  get IE_VERSION() {
    return Rh;
  },
  get IS_SAFARI() {
    return Qn;
  },
  get IS_WINDOWS() {
    return Ca;
  },
  get IS_IPAD() {
    return Jn;
  },
  get IS_IPHONE() {
    return Aa;
  },
  get IS_TIZEN() {
    return Zn;
  },
  get IS_WEBOS() {
    return ea;
  },
  get IS_SMART_TV() {
    return ta;
  },
  TOUCH_ENABLED: Br,
  IS_IOS: Ve,
  IS_ANY_SAFARI: Da
});
function Bc(ce) {
  return typeof ce == "string" && !!ce.trim();
}
function eT(ce) {
  if (ce.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function ws() {
  return V$1 === S.document;
}
function ks(ce) {
  return qt(ce) && ce.nodeType === 1;
}
function Nh() {
  try {
    return S.parent !== S.self;
  } catch {
    return !0;
  }
}
function Bh(ce) {
  return function(ie, me) {
    if (!Bc(ie))
      return V$1[ce](null);
    Bc(me) && (me = V$1.querySelector(me));
    const we = ks(me) ? me : V$1;
    return we[ce] && we[ce](ie);
  };
}
function Z$1(ce = "div", ie = {}, me = {}, we) {
  const Re = V$1.createElement(ce);
  return Object.getOwnPropertyNames(ie).forEach(function(je) {
    const Ue = ie[je];
    je === "textContent" ? _i(Re, Ue) : (Re[je] !== Ue || je === "tabIndex") && (Re[je] = Ue);
  }), Object.getOwnPropertyNames(me).forEach(function(je) {
    Re.setAttribute(je, me[je]);
  }), we && Mu(Re, we), Re;
}
function _i(ce, ie) {
  return typeof ce.textContent > "u" ? ce.innerText = ie : ce.textContent = ie, ce;
}
function zo(ce, ie) {
  ie.firstChild ? ie.insertBefore(ce, ie.firstChild) : ie.appendChild(ce);
}
function wr(ce, ie) {
  return eT(ie), ce.classList.contains(ie);
}
function Ii(ce, ...ie) {
  return ce.classList.add(...ie.reduce((me, we) => me.concat(we.split(/\s+/)), [])), ce;
}
function wa(ce, ...ie) {
  return ce ? (ce.classList.remove(...ie.reduce((me, we) => me.concat(we.split(/\s+/)), [])), ce) : (ae.warn("removeClass was called with an element that doesn't exist"), null);
}
function Fh(ce, ie, me) {
  return typeof me == "function" && (me = me(ce, ie)), typeof me != "boolean" && (me = void 0), ie.split(/\s+/).forEach((we) => ce.classList.toggle(we, me)), ce;
}
function Uh(ce, ie) {
  Object.getOwnPropertyNames(ie).forEach(function(me) {
    const we = ie[me];
    we === null || typeof we > "u" || we === !1 ? ce.removeAttribute(me) : ce.setAttribute(me, we === !0 ? "" : we);
  });
}
function hi(ce) {
  const ie = {}, me = ["autoplay", "controls", "playsinline", "loop", "muted", "default", "defaultMuted"];
  if (ce && ce.attributes && ce.attributes.length > 0) {
    const we = ce.attributes;
    for (let Re = we.length - 1; Re >= 0; Re--) {
      const je = we[Re].name;
      let Ue = we[Re].value;
      me.includes(je) && (Ue = Ue !== null), ie[je] = Ue;
    }
  }
  return ie;
}
function $h(ce, ie) {
  return ce.getAttribute(ie);
}
function Ss(ce, ie, me) {
  ce.setAttribute(ie, me);
}
function ka(ce, ie) {
  ce.removeAttribute(ie);
}
function jh() {
  V$1.body.focus(), V$1.onselectstart = function() {
    return !1;
  };
}
function qh() {
  V$1.onselectstart = function() {
    return !0;
  };
}
function Es(ce) {
  if (ce && ce.getBoundingClientRect && ce.parentNode) {
    const ie = ce.getBoundingClientRect(), me = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach((we) => {
      ie[we] !== void 0 && (me[we] = ie[we]);
    }), me.height || (me.height = parseFloat(Cs(ce, "height"))), me.width || (me.width = parseFloat(Cs(ce, "width"))), me;
  }
}
function Fr(ce) {
  if (!ce || ce && !ce.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  const ie = ce.offsetWidth, me = ce.offsetHeight;
  let we = 0, Re = 0;
  for (; ce.offsetParent && ce !== V$1[Yn.fullscreenElement]; )
    we += ce.offsetLeft, Re += ce.offsetTop, ce = ce.offsetParent;
  return {
    left: we,
    top: Re,
    width: ie,
    height: me
  };
}
function Ia(ce, ie) {
  const me = {
    x: 0,
    y: 0
  };
  if (Ve) {
    let ot = ce;
    for (; ot && ot.nodeName.toLowerCase() !== "html"; ) {
      const vt = Cs(ot, "transform");
      if (/^matrix/.test(vt)) {
        const bt = vt.slice(7, -1).split(/,\s/).map(Number);
        me.x += bt[4], me.y += bt[5];
      } else if (/^matrix3d/.test(vt)) {
        const bt = vt.slice(9, -1).split(/,\s/).map(Number);
        me.x += bt[12], me.y += bt[13];
      }
      if (ot.assignedSlot && ot.assignedSlot.parentElement && S.WebKitCSSMatrix) {
        const bt = S.getComputedStyle(ot.assignedSlot.parentElement).transform, Tt = new S.WebKitCSSMatrix(bt);
        me.x += Tt.m41, me.y += Tt.m42;
      }
      ot = ot.parentNode || ot.host;
    }
  }
  const we = {}, Re = Fr(ie.target), je = Fr(ce), Ue = je.width, qe = je.height;
  let Ge = ie.offsetY - (je.top - Re.top), Xe = ie.offsetX - (je.left - Re.left);
  return ie.changedTouches && (Xe = ie.changedTouches[0].pageX - je.left, Ge = ie.changedTouches[0].pageY + je.top, Ve && (Xe -= me.x, Ge -= me.y)), we.y = 1 - Math.max(0, Math.min(1, Ge / qe)), we.x = Math.max(0, Math.min(1, Xe / Ue)), we;
}
function Vh(ce) {
  return qt(ce) && ce.nodeType === 3;
}
function Pa(ce) {
  for (; ce.firstChild; )
    ce.removeChild(ce.firstChild);
  return ce;
}
function Hh(ce) {
  return typeof ce == "function" && (ce = ce()), (Array.isArray(ce) ? ce : [ce]).map((ie) => {
    if (typeof ie == "function" && (ie = ie()), ks(ie) || Vh(ie))
      return ie;
    if (typeof ie == "string" && /\S/.test(ie))
      return V$1.createTextNode(ie);
  }).filter((ie) => ie);
}
function Mu(ce, ie) {
  return Hh(ie).forEach((me) => ce.appendChild(me)), ce;
}
function zh(ce, ie) {
  return Mu(Pa(ce), ie);
}
function Ur(ce) {
  return ce.button === void 0 && ce.buttons === void 0 || ce.button === 0 && ce.buttons === void 0 || ce.type === "mouseup" && ce.button === 0 && ce.buttons === 0 || ce.type === "mousedown" && ce.button === 0 && ce.buttons === 0 ? !0 : !(ce.button !== 0 || ce.buttons !== 1);
}
const mi = Bh("querySelector"), Wh = Bh("querySelectorAll");
function Cs(ce, ie) {
  if (!ce || !ie)
    return "";
  if (typeof S.getComputedStyle == "function") {
    let me;
    try {
      me = S.getComputedStyle(ce);
    } catch {
      return "";
    }
    return me ? me.getPropertyValue(ie) || me[ie] : "";
  }
  return "";
}
function Gh(ce) {
  [...V$1.styleSheets].forEach((ie) => {
    try {
      const me = [...ie.cssRules].map((Re) => Re.cssText).join(""), we = V$1.createElement("style");
      we.textContent = me, ce.document.head.appendChild(we);
    } catch {
      const me = V$1.createElement("link");
      me.rel = "stylesheet", me.type = ie.type, me.media = ie.media.mediaText, me.href = ie.href, ce.document.head.appendChild(me);
    }
  });
}
var Xh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: ws,
  isEl: ks,
  isInFrame: Nh,
  createEl: Z$1,
  textContent: _i,
  prependTo: zo,
  hasClass: wr,
  addClass: Ii,
  removeClass: wa,
  toggleClass: Fh,
  setAttributes: Uh,
  getAttributes: hi,
  getAttribute: $h,
  setAttribute: Ss,
  removeAttribute: ka,
  blockTextSelection: jh,
  unblockTextSelection: qh,
  getBoundingClientRect: Es,
  findPosition: Fr,
  getPointerPosition: Ia,
  isTextNode: Vh,
  emptyEl: Pa,
  normalizeContent: Hh,
  appendContent: Mu,
  insertContent: zh,
  isSingleLeftClick: Ur,
  $: mi,
  $$: Wh,
  computedStyle: Cs,
  copyStyleSheetsToWindow: Gh
});
let Kh = !1, Wo;
const tT = function() {
  if (Wo.options.autoSetup === !1)
    return;
  const ce = Array.prototype.slice.call(V$1.getElementsByTagName("video")), ie = Array.prototype.slice.call(V$1.getElementsByTagName("audio")), me = Array.prototype.slice.call(V$1.getElementsByTagName("video-js")), we = ce.concat(ie, me);
  if (we && we.length > 0)
    for (let Re = 0, je = we.length; Re < je; Re++) {
      const Ue = we[Re];
      if (Ue && Ue.getAttribute)
        Ue.player === void 0 && Ue.getAttribute("data-setup") !== null && Wo(Ue);
      else {
        Go(1);
        break;
      }
    }
  else Kh || Go(1);
};
function Go(ce, ie) {
  ws() && (ie && (Wo = ie), S.setTimeout(tT, ce));
}
function Xo() {
  Kh = !0, S.removeEventListener("load", Xo);
}
ws() && (V$1.readyState === "complete" ? Xo() : S.addEventListener("load", Xo));
const Yh = function(ce) {
  const ie = V$1.createElement("style");
  return ie.className = ce, ie;
}, Qh = function(ce, ie) {
  ce.styleSheet ? ce.styleSheet.cssText = ie : ce.textContent = ie;
};
var Ze = /* @__PURE__ */ new WeakMap();
const iT = 3;
let sT = iT;
function gt() {
  return sT++;
}
function Fc(ce, ie) {
  if (!Ze.has(ce))
    return;
  const me = Ze.get(ce);
  me.handlers[ie].length === 0 && (delete me.handlers[ie], ce.removeEventListener ? ce.removeEventListener(ie, me.dispatcher, !1) : ce.detachEvent && ce.detachEvent("on" + ie, me.dispatcher)), Object.getOwnPropertyNames(me.handlers).length <= 0 && (delete me.handlers, delete me.dispatcher, delete me.disabled), Object.getOwnPropertyNames(me).length === 0 && Ze.delete(ce);
}
function Nu(ce, ie, me, we) {
  me.forEach(function(Re) {
    ce(ie, Re, we);
  });
}
function Oa(ce) {
  if (ce.fixed_)
    return ce;
  function ie() {
    return !0;
  }
  function me() {
    return !1;
  }
  if (!ce || !ce.isPropagationStopped || !ce.isImmediatePropagationStopped) {
    const we = ce || S.event;
    ce = {};
    const Re = ["layerX", "layerY", "keyLocation", "path", "webkitMovementX", "webkitMovementY", "mozPressure", "mozInputSource"];
    for (const je in we)
      Re.includes(je) || je === "returnValue" && we.preventDefault || (ce[je] = we[je]);
    if (ce.target || (ce.target = ce.srcElement || V$1), ce.relatedTarget || (ce.relatedTarget = ce.fromElement === ce.target ? ce.toElement : ce.fromElement), ce.preventDefault = function() {
      we.preventDefault && we.preventDefault(), ce.returnValue = !1, we.returnValue = !1, ce.defaultPrevented = !0;
    }, ce.defaultPrevented = !1, ce.stopPropagation = function() {
      we.stopPropagation && we.stopPropagation(), ce.cancelBubble = !0, we.cancelBubble = !0, ce.isPropagationStopped = ie;
    }, ce.isPropagationStopped = me, ce.stopImmediatePropagation = function() {
      we.stopImmediatePropagation && we.stopImmediatePropagation(), ce.isImmediatePropagationStopped = ie, ce.stopPropagation();
    }, ce.isImmediatePropagationStopped = me, ce.clientX !== null && ce.clientX !== void 0) {
      const je = V$1.documentElement, Ue = V$1.body;
      ce.pageX = ce.clientX + (je && je.scrollLeft || Ue && Ue.scrollLeft || 0) - (je && je.clientLeft || Ue && Ue.clientLeft || 0), ce.pageY = ce.clientY + (je && je.scrollTop || Ue && Ue.scrollTop || 0) - (je && je.clientTop || Ue && Ue.clientTop || 0);
    }
    ce.which = ce.charCode || ce.keyCode, ce.button !== null && ce.button !== void 0 && (ce.button = ce.button & 1 ? 0 : ce.button & 4 ? 1 : ce.button & 2 ? 2 : 0);
  }
  return ce.fixed_ = !0, ce;
}
let Rn;
const rT = function() {
  if (typeof Rn != "boolean") {
    Rn = !1;
    try {
      const ce = Object.defineProperty({}, "passive", {
        get() {
          Rn = !0;
        }
      });
      S.addEventListener("test", null, ce), S.removeEventListener("test", null, ce);
    } catch {
    }
  }
  return Rn;
}, nT = ["touchstart", "touchmove"];
function dt(ce, ie, me) {
  if (Array.isArray(ie))
    return Nu(dt, ce, ie, me);
  Ze.has(ce) || Ze.set(ce, {});
  const we = Ze.get(ce);
  if (we.handlers || (we.handlers = {}), we.handlers[ie] || (we.handlers[ie] = []), me.guid || (me.guid = gt()), we.handlers[ie].push(me), we.dispatcher || (we.disabled = !1, we.dispatcher = function(Re, je) {
    if (we.disabled)
      return;
    Re = Oa(Re);
    const Ue = we.handlers[Re.type];
    if (Ue) {
      const qe = Ue.slice(0);
      for (let Ge = 0, Xe = qe.length; Ge < Xe && !Re.isImmediatePropagationStopped(); Ge++)
        try {
          qe[Ge].call(ce, Re, je);
        } catch (ot) {
          ae.error(ot);
        }
    }
  }), we.handlers[ie].length === 1)
    if (ce.addEventListener) {
      let Re = !1;
      rT() && nT.indexOf(ie) > -1 && (Re = {
        passive: !0
      }), ce.addEventListener(ie, we.dispatcher, Re);
    } else ce.attachEvent && ce.attachEvent("on" + ie, we.dispatcher);
}
function He(ce, ie, me) {
  if (!Ze.has(ce))
    return;
  const we = Ze.get(ce);
  if (!we.handlers)
    return;
  if (Array.isArray(ie))
    return Nu(He, ce, ie, me);
  const Re = function(Ue, qe) {
    we.handlers[qe] = [], Fc(Ue, qe);
  };
  if (ie === void 0) {
    for (const Ue in we.handlers)
      Object.prototype.hasOwnProperty.call(we.handlers || {}, Ue) && Re(ce, Ue);
    return;
  }
  const je = we.handlers[ie];
  if (je) {
    if (!me) {
      Re(ce, ie);
      return;
    }
    if (me.guid)
      for (let Ue = 0; Ue < je.length; Ue++)
        je[Ue].guid === me.guid && je.splice(Ue--, 1);
    Fc(ce, ie);
  }
}
function Is(ce, ie, me) {
  const we = Ze.has(ce) ? Ze.get(ce) : {}, Re = ce.parentNode || ce.ownerDocument;
  if (typeof ie == "string" ? ie = {
    type: ie,
    target: ce
  } : ie.target || (ie.target = ce), ie = Oa(ie), we.dispatcher && we.dispatcher.call(ce, ie, me), Re && !ie.isPropagationStopped() && ie.bubbles === !0)
    Is.call(null, Re, ie, me);
  else if (!Re && !ie.defaultPrevented && ie.target && ie.target[ie.type]) {
    Ze.has(ie.target) || Ze.set(ie.target, {});
    const je = Ze.get(ie.target);
    ie.target[ie.type] && (je.disabled = !0, typeof ie.target[ie.type] == "function" && ie.target[ie.type](), je.disabled = !1);
  }
  return !ie.defaultPrevented;
}
function La(ce, ie, me) {
  if (Array.isArray(ie))
    return Nu(La, ce, ie, me);
  const we = function() {
    He(ce, ie, we), me.apply(this, arguments);
  };
  we.guid = me.guid = me.guid || gt(), dt(ce, ie, we);
}
function Bu(ce, ie, me) {
  const we = function() {
    He(ce, ie, we), me.apply(this, arguments);
  };
  we.guid = me.guid = me.guid || gt(), dt(ce, ie, we);
}
var aT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: Oa,
  on: dt,
  off: He,
  trigger: Is,
  one: La,
  any: Bu
});
const _t = 30, ve$1 = function(ce, ie, me) {
  ie.guid || (ie.guid = gt());
  const we = ie.bind(ce);
  return we.guid = me ? me + "_" + ie.guid : ie.guid, we;
}, Ht = function(ce, ie) {
  let me = S.performance.now();
  return function(...we) {
    const Re = S.performance.now();
    Re - me >= ie && (ce(...we), me = Re);
  };
}, Jh = function(ce, ie, me, we = S) {
  let Re;
  const je = () => {
    we.clearTimeout(Re), Re = null;
  }, Ue = function() {
    const qe = this, Ge = arguments;
    let Xe = function() {
      Re = null, Xe = null, me || ce.apply(qe, Ge);
    };
    !Re && me && ce.apply(qe, Ge), we.clearTimeout(Re), Re = we.setTimeout(Xe, ie);
  };
  return Ue.cancel = je, Ue;
};
var oT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  UPDATE_REFRESH_INTERVAL: _t,
  bind_: ve$1,
  throttle: Ht,
  debounce: Jh
});
let _r;
class ht {
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  on(ie, me) {
    const we = this.addEventListener;
    this.addEventListener = () => {
    }, dt(this, ie, me), this.addEventListener = we;
  }
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */
  off(ie, me) {
    He(this, ie, me);
  }
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  one(ie, me) {
    const we = this.addEventListener;
    this.addEventListener = () => {
    }, La(this, ie, me), this.addEventListener = we;
  }
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  any(ie, me) {
    const we = this.addEventListener;
    this.addEventListener = () => {
    }, Bu(this, ie, me), this.addEventListener = we;
  }
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */
  trigger(ie) {
    const me = ie.type || ie;
    typeof ie == "string" && (ie = {
      type: me
    }), ie = Oa(ie), this.allowedEvents_[me] && this["on" + me] && this["on" + me](ie), Is(this, ie);
  }
  queueTrigger(ie) {
    _r || (_r = /* @__PURE__ */ new Map());
    const me = ie.type || ie;
    let we = _r.get(this);
    we || (we = /* @__PURE__ */ new Map(), _r.set(this, we));
    const Re = we.get(me);
    we.delete(me), S.clearTimeout(Re);
    const je = S.setTimeout(() => {
      we.delete(me), we.size === 0 && (we = null, _r.delete(this)), this.trigger(ie);
    }, 0);
    we.set(me, je);
  }
}
ht.prototype.allowedEvents_ = {};
ht.prototype.addEventListener = ht.prototype.on;
ht.prototype.removeEventListener = ht.prototype.off;
ht.prototype.dispatchEvent = ht.prototype.trigger;
const Ra = (ce) => typeof ce.name == "function" ? ce.name() : typeof ce.name == "string" ? ce.name : ce.name_ ? ce.name_ : ce.constructor && ce.constructor.name ? ce.constructor.name : typeof ce, Yt = (ce) => ce instanceof ht || !!ce.eventBusEl_ && ["on", "one", "off", "trigger"].every((ie) => typeof ce[ie] == "function"), uT = (ce, ie) => {
  Yt(ce) ? ie() : (ce.eventedCallbacks || (ce.eventedCallbacks = []), ce.eventedCallbacks.push(ie));
}, Ko = (ce) => (
  // The regex here verifies that the `type` contains at least one non-
  // whitespace character.
  typeof ce == "string" && /\S/.test(ce) || Array.isArray(ce) && !!ce.length
), ia = (ce, ie, me) => {
  if (!ce || !ce.nodeName && !Yt(ce))
    throw new Error(`Invalid target for ${Ra(ie)}#${me}; must be a DOM node or evented object.`);
}, Zh = (ce, ie, me) => {
  if (!Ko(ce))
    throw new Error(`Invalid event type for ${Ra(ie)}#${me}; must be a non-empty string or array.`);
}, ef = (ce, ie, me) => {
  if (typeof ce != "function")
    throw new Error(`Invalid listener for ${Ra(ie)}#${me}; must be a function.`);
}, bo = (ce, ie, me) => {
  const we = ie.length < 3 || ie[0] === ce || ie[0] === ce.eventBusEl_;
  let Re, je, Ue;
  return we ? (Re = ce.eventBusEl_, ie.length >= 3 && ie.shift(), [je, Ue] = ie) : (Re = ie[0], je = ie[1], Ue = ie[2]), ia(Re, ce, me), Zh(je, ce, me), ef(Ue, ce, me), Ue = ve$1(ce, Ue), {
    isTargetingSelf: we,
    target: Re,
    type: je,
    listener: Ue
  };
}, Ei = (ce, ie, me, we) => {
  ia(ce, ce, ie), ce.nodeName ? aT[ie](ce, me, we) : ce[ie](me, we);
}, lT = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on(...ce) {
    const {
      isTargetingSelf: ie,
      target: me,
      type: we,
      listener: Re
    } = bo(this, ce, "on");
    if (Ei(me, "on", we, Re), !ie) {
      const je = () => this.off(me, we, Re);
      je.guid = Re.guid;
      const Ue = () => this.off("dispose", je);
      Ue.guid = Re.guid, Ei(this, "on", "dispose", je), Ei(me, "on", "dispose", Ue);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one(...ce) {
    const {
      isTargetingSelf: ie,
      target: me,
      type: we,
      listener: Re
    } = bo(this, ce, "one");
    if (ie)
      Ei(me, "one", we, Re);
    else {
      const je = (...Ue) => {
        this.off(me, we, je), Re.apply(null, Ue);
      };
      je.guid = Re.guid, Ei(me, "one", we, je);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any(...ce) {
    const {
      isTargetingSelf: ie,
      target: me,
      type: we,
      listener: Re
    } = bo(this, ce, "any");
    if (ie)
      Ei(me, "any", we, Re);
    else {
      const je = (...Ue) => {
        this.off(me, we, je), Re.apply(null, Ue);
      };
      je.guid = Re.guid, Ei(me, "any", we, je);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off(ce, ie, me) {
    if (!ce || Ko(ce))
      He(this.eventBusEl_, ce, ie);
    else {
      const we = ce, Re = ie;
      ia(we, this, "off"), Zh(Re, this, "off"), ef(me, this, "off"), me = ve$1(this, me), this.off("dispose", me), we.nodeName ? (He(we, Re, me), He(we, "dispose", me)) : Yt(we) && (we.off(Re, me), we.off("dispose", me));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger(ce, ie) {
    ia(this.eventBusEl_, this, "trigger");
    const me = ce && typeof ce != "string" ? ce.type : ce;
    if (!Ko(me))
      throw new Error(`Invalid event type for ${Ra(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
    return Is(this.eventBusEl_, ce, ie);
  }
};
function Fu(ce, ie = {}) {
  const {
    eventBusKey: me
  } = ie;
  if (me) {
    if (!ce[me].nodeName)
      throw new Error(`The eventBusKey "${me}" does not refer to an element.`);
    ce.eventBusEl_ = ce[me];
  } else
    ce.eventBusEl_ = Z$1("span", {
      className: "vjs-event-bus"
    });
  return Object.assign(ce, lT), ce.eventedCallbacks && ce.eventedCallbacks.forEach((we) => {
    we();
  }), ce.on("dispose", () => {
    ce.off(), [ce, ce.el_, ce.eventBusEl_].forEach(function(we) {
      we && Ze.has(we) && Ze.delete(we);
    }), S.setTimeout(() => {
      ce.eventBusEl_ = null;
    }, 0);
  }), ce;
}
const cT = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState(ce) {
    typeof ce == "function" && (ce = ce());
    let ie;
    return as(ce, (me, we) => {
      this.state[we] !== me && (ie = ie || {}, ie[we] = {
        from: this.state[we],
        to: me
      }), this.state[we] = me;
    }), ie && Yt(this) && this.trigger({
      changes: ie,
      type: "statechanged"
    }), ie;
  }
};
function tf(ce, ie) {
  return Object.assign(ce, cT), ce.state = Object.assign({}, ce.state, ie), typeof ce.handleStateChanged == "function" && Yt(ce) && ce.on("statechanged", ce.handleStateChanged), ce;
}
const kr = function(ce) {
  return typeof ce != "string" ? ce : ce.replace(/./, (ie) => ie.toLowerCase());
}, De$1 = function(ce) {
  return typeof ce != "string" ? ce : ce.replace(/./, (ie) => ie.toUpperCase());
}, sf = function(ce, ie) {
  return De$1(ce) === De$1(ie);
};
var dT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toLowerCase: kr,
  toTitleCase: De$1,
  titleCaseEquals: sf
});
class B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  constructor(ie, me, we) {
    if (!ie && this.play ? this.player_ = ie = this : this.player_ = ie, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = ye$2({}, this.options_), me = this.options_ = ye$2(this.options_, me), this.id_ = me.id || me.el && me.el.id, !this.id_) {
      const Re = ie && ie.id && ie.id() || "no_player";
      this.id_ = `${Re}_component_${gt()}`;
    }
    this.name_ = me.name || null, me.el ? this.el_ = me.el : me.createEl !== !1 && (this.el_ = this.createEl()), me.className && this.el_ && me.className.split(" ").forEach((Re) => this.addClass(Re)), ["on", "off", "one", "any", "trigger"].forEach((Re) => {
      this[Re] = void 0;
    }), me.evented !== !1 && (Fu(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), tf(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, me.initChildren !== !1 && this.initChildren(), this.ready(we), me.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
  // They are replaced or removed in the constructor
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */
  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */
  dispose(ie = {}) {
    if (!this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (let me = this.children_.length - 1; me >= 0; me--)
          this.children_[me].dispose && this.children_[me].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (ie.restoreEl ? this.el_.parentNode.replaceChild(ie.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }
  /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */
  isDisposed() {
    return !!this.isDisposed_;
  }
  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */
  player() {
    return this.player_;
  }
  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */
  options(ie) {
    return ie ? (this.options_ = ye$2(this.options_, ie), this.options_) : this.options_;
  }
  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */
  el() {
    return this.el_;
  }
  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(ie, me, we) {
    return Z$1(ie, me, we);
  }
  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */
  localize(ie, me, we = ie) {
    const Re = this.player_.language && this.player_.language(), je = this.player_.languages && this.player_.languages(), Ue = je && je[Re], qe = Re && Re.split("-")[0], Ge = je && je[qe];
    let Xe = we;
    return Ue && Ue[ie] ? Xe = Ue[ie] : Ge && Ge[ie] && (Xe = Ge[ie]), me && (Xe = Xe.replace(/\{(\d+)\}/g, function(ot, vt) {
      const bt = me[vt - 1];
      let Tt = bt;
      return typeof bt > "u" && (Tt = ot), Tt;
    })), Xe;
  }
  /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */
  handleLanguagechange() {
  }
  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */
  contentEl() {
    return this.contentEl_ || this.el_;
  }
  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */
  id() {
    return this.id_;
  }
  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */
  name() {
    return this.name_;
  }
  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */
  children() {
    return this.children_;
  }
  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */
  getChildById(ie) {
    return this.childIndex_[ie];
  }
  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */
  getChild(ie) {
    if (ie)
      return this.childNameIndex_[ie];
  }
  /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */
  getDescendant(...ie) {
    ie = ie.reduce((we, Re) => we.concat(Re), []);
    let me = this;
    for (let we = 0; we < ie.length; we++)
      if (me = me.getChild(ie[we]), !me || !me.getChild)
        return;
    return me;
  }
  /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */
  setIcon(ie, me = this.el()) {
    if (!this.player_.options_.experimentalSvgIcons)
      return;
    const we = "http://www.w3.org/2000/svg", Re = Z$1("span", {
      className: "vjs-icon-placeholder vjs-svg-icon"
    }, {
      "aria-hidden": "true"
    }), je = V$1.createElementNS(we, "svg");
    je.setAttributeNS(null, "viewBox", "0 0 512 512");
    const Ue = V$1.createElementNS(we, "use");
    return je.appendChild(Ue), Ue.setAttributeNS(null, "href", `#vjs-icon-${ie}`), Re.appendChild(je), this.iconIsSet_ ? me.replaceChild(Re, me.querySelector(".vjs-icon-placeholder")) : me.appendChild(Re), this.iconIsSet_ = !0, Re;
  }
  /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */
  addChild(ie, me = {}, we = this.children_.length) {
    let Re, je;
    if (typeof ie == "string") {
      je = De$1(ie);
      const Ue = me.componentClass || je;
      me.name = je;
      const qe = B.getComponent(Ue);
      if (!qe)
        throw new Error(`Component ${Ue} does not exist`);
      if (typeof qe != "function")
        return null;
      Re = new qe(this.player_ || this, me);
    } else
      Re = ie;
    if (Re.parentComponent_ && Re.parentComponent_.removeChild(Re), this.children_.splice(we, 0, Re), Re.parentComponent_ = this, typeof Re.id == "function" && (this.childIndex_[Re.id()] = Re), je = je || Re.name && De$1(Re.name()), je && (this.childNameIndex_[je] = Re, this.childNameIndex_[kr(je)] = Re), typeof Re.el == "function" && Re.el()) {
      let Ue = null;
      this.children_[we + 1] && (this.children_[we + 1].el_ ? Ue = this.children_[we + 1].el_ : ks(this.children_[we + 1]) && (Ue = this.children_[we + 1])), this.contentEl().insertBefore(Re.el(), Ue);
    }
    return Re;
  }
  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */
  removeChild(ie) {
    if (typeof ie == "string" && (ie = this.getChild(ie)), !ie || !this.children_)
      return;
    let me = !1;
    for (let Re = this.children_.length - 1; Re >= 0; Re--)
      if (this.children_[Re] === ie) {
        me = !0, this.children_.splice(Re, 1);
        break;
      }
    if (!me)
      return;
    ie.parentComponent_ = null, this.childIndex_[ie.id()] = null, this.childNameIndex_[De$1(ie.name())] = null, this.childNameIndex_[kr(ie.name())] = null;
    const we = ie.el();
    we && we.parentNode === this.contentEl() && this.contentEl().removeChild(ie.el());
  }
  /**
   * Add and initialize default child `Component`s based upon options.
   */
  initChildren() {
    const ie = this.options_.children;
    if (ie) {
      const me = this.options_, we = (Ue) => {
        const qe = Ue.name;
        let Ge = Ue.opts;
        if (me[qe] !== void 0 && (Ge = me[qe]), Ge === !1)
          return;
        Ge === !0 && (Ge = {}), Ge.playerOptions = this.options_.playerOptions;
        const Xe = this.addChild(qe, Ge);
        Xe && (this[qe] = Xe);
      };
      let Re;
      const je = B.getComponent("Tech");
      Array.isArray(ie) ? Re = ie : Re = Object.keys(ie), Re.concat(Object.keys(this.options_).filter(function(Ue) {
        return !Re.some(function(qe) {
          return typeof qe == "string" ? Ue === qe : Ue === qe.name;
        });
      })).map((Ue) => {
        let qe, Ge;
        return typeof Ue == "string" ? (qe = Ue, Ge = ie[qe] || this.options_[qe] || {}) : (qe = Ue.name, Ge = Ue), {
          name: qe,
          opts: Ge
        };
      }).filter((Ue) => {
        const qe = B.getComponent(Ue.opts.componentClass || De$1(Ue.name));
        return qe && !je.isTech(qe);
      }).forEach(we);
    }
  }
  /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */
  buildCSSClass() {
    return "";
  }
  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */
  ready(ie, me = !1) {
    if (ie) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(ie);
        return;
      }
      me ? ie.call(this) : this.setTimeout(ie, 1);
    }
  }
  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */
  triggerReady() {
    this.isReady_ = !0, this.setTimeout(function() {
      const ie = this.readyQueue_;
      this.readyQueue_ = [], ie && ie.length > 0 && ie.forEach(function(me) {
        me.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }
  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $(ie, me) {
    return mi(ie, me || this.contentEl());
  }
  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $$(ie, me) {
    return Wh(ie, me || this.contentEl());
  }
  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */
  hasClass(ie) {
    return wr(this.el_, ie);
  }
  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */
  addClass(...ie) {
    Ii(this.el_, ...ie);
  }
  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */
  removeClass(...ie) {
    wa(this.el_, ...ie);
  }
  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */
  toggleClass(ie, me) {
    Fh(this.el_, ie, me);
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    this.removeClass("vjs-hidden");
  }
  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */
  hide() {
    this.addClass("vjs-hidden");
  }
  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  lockShowing() {
    this.addClass("vjs-lock-showing");
  }
  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  unlockShowing() {
    this.removeClass("vjs-lock-showing");
  }
  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */
  getAttribute(ie) {
    return $h(this.el_, ie);
  }
  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */
  setAttribute(ie, me) {
    Ss(this.el_, ie, me);
  }
  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */
  removeAttribute(ie) {
    ka(this.el_, ie);
  }
  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */
  width(ie, me) {
    return this.dimension("width", ie, me);
  }
  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */
  height(ie, me) {
    return this.dimension("height", ie, me);
  }
  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */
  dimensions(ie, me) {
    this.width(ie, !0), this.height(me);
  }
  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */
  dimension(ie, me, we) {
    if (me !== void 0) {
      (me === null || me !== me) && (me = 0), ("" + me).indexOf("%") !== -1 || ("" + me).indexOf("px") !== -1 ? this.el_.style[ie] = me : me === "auto" ? this.el_.style[ie] = "" : this.el_.style[ie] = me + "px", we || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    const Re = this.el_.style[ie], je = Re.indexOf("px");
    return parseInt(je !== -1 ? Re.slice(0, je) : this.el_["offset" + De$1(ie)], 10);
  }
  /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */
  currentDimension(ie) {
    let me = 0;
    if (ie !== "width" && ie !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (me = Cs(this.el_, ie), me = parseFloat(me), me === 0 || isNaN(me)) {
      const we = `offset${De$1(ie)}`;
      me = this.el_[we];
    }
    return me;
  }
  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */
  /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */
  currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }
  /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */
  currentWidth() {
    return this.currentDimension("width");
  }
  /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */
  currentHeight() {
    return this.currentDimension("height");
  }
  /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */
  getPositions() {
    const ie = this.el_.getBoundingClientRect(), me = {
      x: ie.x,
      y: ie.y,
      width: ie.width,
      height: ie.height,
      top: ie.top,
      right: ie.right,
      bottom: ie.bottom,
      left: ie.left
    }, we = {
      x: ie.left + ie.width / 2,
      y: ie.top + ie.height / 2,
      width: 0,
      height: 0,
      top: ie.top + ie.height / 2,
      right: ie.left + ie.width / 2,
      bottom: ie.top + ie.height / 2,
      left: ie.left + ie.width / 2
    };
    return {
      boundingClientRect: me,
      center: we
    };
  }
  /**
   * Set the focus to this component
   */
  focus() {
    this.el_.focus();
  }
  /**
   * Remove the focus from this component
   */
  blur() {
    this.el_.blur();
  }
  /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */
  handleKeyDown(ie) {
    this.player_ && (ie.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && ie.stopPropagation(), this.player_.handleKeyDown(ie));
  }
  /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */
  handleKeyPress(ie) {
    this.handleKeyDown(ie);
  }
  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */
  emitTapEvents() {
    let ie = 0, me = null;
    const we = 10, Re = 200;
    let je;
    this.on("touchstart", function(qe) {
      qe.touches.length === 1 && (me = {
        pageX: qe.touches[0].pageX,
        pageY: qe.touches[0].pageY
      }, ie = S.performance.now(), je = !0);
    }), this.on("touchmove", function(qe) {
      if (qe.touches.length > 1)
        je = !1;
      else if (me) {
        const Ge = qe.touches[0].pageX - me.pageX, Xe = qe.touches[0].pageY - me.pageY;
        Math.sqrt(Ge * Ge + Xe * Xe) > we && (je = !1);
      }
    });
    const Ue = function() {
      je = !1;
    };
    this.on("touchleave", Ue), this.on("touchcancel", Ue), this.on("touchend", function(qe) {
      me = null, je === !0 && S.performance.now() - ie < Re && (qe.preventDefault(), this.trigger("tap"));
    });
  }
  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */
  enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity)
      return;
    const ie = ve$1(this.player(), this.player().reportUserActivity);
    let me;
    this.on("touchstart", function() {
      ie(), this.clearInterval(me), me = this.setInterval(ie, 250);
    });
    const we = function(Re) {
      ie(), this.clearInterval(me);
    };
    this.on("touchmove", ie), this.on("touchend", we), this.on("touchcancel", we);
  }
  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */
  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */
  setTimeout(ie, me) {
    var we;
    return ie = ve$1(this, ie), this.clearTimersOnDispose_(), we = S.setTimeout(() => {
      this.setTimeoutIds_.has(we) && this.setTimeoutIds_.delete(we), ie();
    }, me), this.setTimeoutIds_.add(we), we;
  }
  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */
  clearTimeout(ie) {
    return this.setTimeoutIds_.has(ie) && (this.setTimeoutIds_.delete(ie), S.clearTimeout(ie)), ie;
  }
  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */
  setInterval(ie, me) {
    ie = ve$1(this, ie), this.clearTimersOnDispose_();
    const we = S.setInterval(ie, me);
    return this.setIntervalIds_.add(we), we;
  }
  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */
  clearInterval(ie) {
    return this.setIntervalIds_.has(ie) && (this.setIntervalIds_.delete(ie), S.clearInterval(ie)), ie;
  }
  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */
  requestAnimationFrame(ie) {
    this.clearTimersOnDispose_();
    var me;
    return ie = ve$1(this, ie), me = S.requestAnimationFrame(() => {
      this.rafIds_.has(me) && this.rafIds_.delete(me), ie();
    }), this.rafIds_.add(me), me;
  }
  /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */
  requestNamedAnimationFrame(ie, me) {
    this.namedRafs_.has(ie) && this.cancelNamedAnimationFrame(ie), this.clearTimersOnDispose_(), me = ve$1(this, me);
    const we = this.requestAnimationFrame(() => {
      me(), this.namedRafs_.has(ie) && this.namedRafs_.delete(ie);
    });
    return this.namedRafs_.set(ie, we), ie;
  }
  /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */
  cancelNamedAnimationFrame(ie) {
    this.namedRafs_.has(ie) && (this.cancelAnimationFrame(this.namedRafs_.get(ie)), this.namedRafs_.delete(ie));
  }
  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */
  cancelAnimationFrame(ie) {
    return this.rafIds_.has(ie) && (this.rafIds_.delete(ie), S.cancelAnimationFrame(ie)), ie;
  }
  /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */
  clearTimersOnDispose_() {
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(([ie, me]) => {
        this[ie].forEach((we, Re) => this[me](Re));
      }), this.clearingTimersOnDispose_ = !1;
    }));
  }
  /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */
  getIsDisabled() {
    return !!this.el_.disabled;
  }
  /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */
  getIsExpresslyInert() {
    return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
  }
  /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */
  getIsFocusable(ie) {
    return (ie || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
  }
  /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */
  getIsAvailableToBeFocused(ie) {
    function me(je) {
      const Ue = S.getComputedStyle(je, null), qe = Ue.getPropertyValue("visibility");
      return Ue.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(qe);
    }
    function we(je) {
      return !(!me(je.parentElement) || !me(je) || je.style.opacity === "0" || S.getComputedStyle(je).height === "0px" || S.getComputedStyle(je).width === "0px");
    }
    function Re(je) {
      if (je.offsetWidth + je.offsetHeight + je.getBoundingClientRect().height + je.getBoundingClientRect().width === 0)
        return !1;
      const Ue = {
        x: je.getBoundingClientRect().left + je.offsetWidth / 2,
        y: je.getBoundingClientRect().top + je.offsetHeight / 2
      };
      if (Ue.x < 0 || Ue.x > (V$1.documentElement.clientWidth || S.innerWidth) || Ue.y < 0 || Ue.y > (V$1.documentElement.clientHeight || S.innerHeight))
        return !1;
      let qe = V$1.elementFromPoint(Ue.x, Ue.y);
      for (; qe; ) {
        if (qe === je)
          return !0;
        if (qe.parentNode)
          qe = qe.parentNode;
        else
          return !1;
      }
    }
    return ie || (ie = this.el()), !!(Re(ie) && we(ie) && (!ie.parentElement || ie.tabIndex >= 0));
  }
  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */
  static registerComponent(ie, me) {
    if (typeof ie != "string" || !ie)
      throw new Error(`Illegal component name, "${ie}"; must be a non-empty string.`);
    const we = B.getComponent("Tech"), Re = we && we.isTech(me), je = B === me || B.prototype.isPrototypeOf(me.prototype);
    if (Re || !je) {
      let qe;
      throw Re ? qe = "techs must be registered using Tech.registerTech()" : qe = "must be a Component subclass", new Error(`Illegal component, "${ie}"; ${qe}.`);
    }
    ie = De$1(ie), B.components_ || (B.components_ = {});
    const Ue = B.getComponent("Player");
    if (ie === "Player" && Ue && Ue.players) {
      const qe = Ue.players, Ge = Object.keys(qe);
      if (qe && Ge.length > 0) {
        for (let Xe = 0; Xe < Ge.length; Xe++)
          if (qe[Ge[Xe]] !== null)
            throw new Error("Can not register Player component after player has been created.");
      }
    }
    return B.components_[ie] = me, B.components_[kr(ie)] = me, me;
  }
  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */
  static getComponent(ie) {
    if (!(!ie || !B.components_))
      return B.components_[ie];
  }
}
B.registerComponent("Component", B);
function hT(ce, ie, me) {
  if (typeof ie != "number" || ie < 0 || ie > me)
    throw new Error(`Failed to execute '${ce}' on 'TimeRanges': The index provided (${ie}) is non-numeric or out of bounds (0-${me}).`);
}
function Uc(ce, ie, me, we) {
  return hT(ce, we, me.length - 1), me[we][ie];
}
function xo(ce) {
  let ie;
  return ce === void 0 || ce.length === 0 ? ie = {
    length: 0,
    start() {
      throw new Error("This TimeRanges object is empty");
    },
    end() {
      throw new Error("This TimeRanges object is empty");
    }
  } : ie = {
    length: ce.length,
    start: Uc.bind(null, "start", 0, ce),
    end: Uc.bind(null, "end", 1, ce)
  }, S.Symbol && S.Symbol.iterator && (ie[S.Symbol.iterator] = () => (ce || []).values()), ie;
}
function Ct(ce, ie) {
  return Array.isArray(ce) ? xo(ce) : ce === void 0 || ie === void 0 ? xo() : xo([[ce, ie]]);
}
const rf = function(ce, ie) {
  ce = ce < 0 ? 0 : ce;
  let me = Math.floor(ce % 60), we = Math.floor(ce / 60 % 60), Re = Math.floor(ce / 3600);
  const je = Math.floor(ie / 60 % 60), Ue = Math.floor(ie / 3600);
  return (isNaN(ce) || ce === 1 / 0) && (Re = we = me = "-"), Re = Re > 0 || Ue > 0 ? Re + ":" : "", we = ((Re || je >= 10) && we < 10 ? "0" + we : we) + ":", me = me < 10 ? "0" + me : me, Re + we + me;
};
let Uu = rf;
function nf(ce) {
  Uu = ce;
}
function af() {
  Uu = rf;
}
function Mi(ce, ie = ce) {
  return Uu(ce, ie);
}
var fT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTimeRanges: Ct,
  createTimeRange: Ct,
  setFormatTime: nf,
  resetFormatTime: af,
  formatTime: Mi
});
function of(ce, ie) {
  let me = 0, we, Re;
  if (!ie)
    return 0;
  (!ce || !ce.length) && (ce = Ct(0, 0));
  for (let je = 0; je < ce.length; je++)
    we = ce.start(je), Re = ce.end(je), Re > ie && (Re = ie), me += Re - we;
  return me / ie;
}
function Ae$1(ce) {
  if (ce instanceof Ae$1)
    return ce;
  typeof ce == "number" ? this.code = ce : typeof ce == "string" ? this.message = ce : qt(ce) && (typeof ce.code == "number" && (this.code = ce.code), Object.assign(this, ce)), this.message || (this.message = Ae$1.defaultMessages[this.code] || "");
}
Ae$1.prototype.code = 0;
Ae$1.prototype.message = "";
Ae$1.prototype.status = null;
Ae$1.prototype.metadata = null;
Ae$1.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
Ae$1.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
Ae$1.MEDIA_ERR_CUSTOM = 0;
Ae$1.prototype.MEDIA_ERR_CUSTOM = 0;
Ae$1.MEDIA_ERR_ABORTED = 1;
Ae$1.prototype.MEDIA_ERR_ABORTED = 1;
Ae$1.MEDIA_ERR_NETWORK = 2;
Ae$1.prototype.MEDIA_ERR_NETWORK = 2;
Ae$1.MEDIA_ERR_DECODE = 3;
Ae$1.prototype.MEDIA_ERR_DECODE = 3;
Ae$1.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Ae$1.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Ae$1.MEDIA_ERR_ENCRYPTED = 5;
Ae$1.prototype.MEDIA_ERR_ENCRYPTED = 5;
function Ir(ce) {
  return ce != null && typeof ce.then == "function";
}
function Nt(ce) {
  Ir(ce) && ce.then(null, (ie) => {
  });
}
const Yo = function(ce) {
  return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce((ie, me, we) => (ce[me] && (ie[me] = ce[me]), ie), {
    cues: ce.cues && Array.prototype.map.call(ce.cues, function(ie) {
      return {
        startTime: ie.startTime,
        endTime: ie.endTime,
        text: ie.text,
        id: ie.id
      };
    })
  });
}, pT = function(ce) {
  const ie = ce.$$("track"), me = Array.prototype.map.call(ie, (we) => we.track);
  return Array.prototype.map.call(ie, function(we) {
    const Re = Yo(we.track);
    return we.src && (Re.src = we.src), Re;
  }).concat(Array.prototype.filter.call(ce.textTracks(), function(we) {
    return me.indexOf(we) === -1;
  }).map(Yo));
}, mT = function(ce, ie) {
  return ce.forEach(function(me) {
    const we = ie.addRemoteTextTrack(me).track;
    !me.src && me.cues && me.cues.forEach((Re) => we.addCue(Re));
  }), ie.textTracks();
};
var Qo = {
  textTracksToJson: pT,
  jsonToTextTracks: mT,
  trackToJson: Yo
};
const So = "vjs-modal-dialog";
class Ps extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  constructor(ie, me) {
    super(ie, me), this.handleKeyDown_ = (we) => this.handleKeyDown(we), this.close_ = (we) => this.close(we), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = Z$1("div", {
      className: `${So}-content`
    }, {
      role: "document"
    }), this.descEl_ = Z$1("p", {
      className: `${So}-description vjs-control-text`,
      id: this.el().getAttribute("aria-describedby")
    }), _i(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
  }
  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": `${this.id()}_description`,
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog",
      "aria-live": "polite"
    });
  }
  dispose() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `${So} vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */
  label() {
    return this.localize(this.options_.label || "Modal Window");
  }
  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */
  description() {
    let ie = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (ie += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), ie;
  }
  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */
  open() {
    if (this.opened_) {
      this.options_.fillAlways && this.fill();
      return;
    }
    const ie = this.player();
    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !ie.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && ie.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = ie.controls(), ie.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
  }
  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */
  opened(ie) {
    return typeof ie == "boolean" && this[ie ? "open" : "close"](), this.opened_;
  }
  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */
  close() {
    if (!this.opened_)
      return;
    const ie = this.player();
    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && ie.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && ie.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
      type: "modalclose",
      bubbles: !0
    }), this.conditionalBlur_(), this.options_.temporary && this.dispose();
  }
  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */
  closeable(ie) {
    if (typeof ie == "boolean") {
      const me = this.closeable_ = !!ie;
      let we = this.getChild("closeButton");
      if (me && !we) {
        const Re = this.contentEl_;
        this.contentEl_ = this.el_, we = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = Re, this.on(we, "close", this.close_);
      }
      !me && we && (this.off(we, "close", this.close_), this.removeChild(we), we.dispose());
    }
    return this.closeable_;
  }
  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */
  fill() {
    this.fillWith(this.content());
  }
  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */
  fillWith(ie) {
    const me = this.contentEl(), we = me.parentNode, Re = me.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, we.removeChild(me), this.empty(), zh(me, ie), this.trigger("modalfill"), Re ? we.insertBefore(me, Re) : we.appendChild(me);
    const je = this.getChild("closeButton");
    je && we.appendChild(je.el_), this.trigger("aftermodalfill");
  }
  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */
  empty() {
    this.trigger("beforemodalempty"), Pa(this.contentEl()), this.trigger("modalempty");
  }
  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */
  content(ie) {
    return typeof ie < "u" && (this.content_ = ie), this.content_;
  }
  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */
  conditionalFocus_() {
    const ie = V$1.activeElement, me = this.player_.el_;
    this.previouslyActiveEl_ = null, (me.contains(ie) || me === ie) && (this.previouslyActiveEl_ = ie, this.focus());
  }
  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */
  conditionalBlur_() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }
  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    if (this.trigger({
      type: "modalKeydown",
      originalEvent: ie,
      target: this,
      bubbles: !0
    }), ie.stopPropagation(), ie.key === "Escape" && this.closeable()) {
      ie.preventDefault(), this.close();
      return;
    }
    if (ie.key !== "Tab")
      return;
    const me = this.focusableEls_(), we = this.el_.querySelector(":focus");
    let Re;
    for (let je = 0; je < me.length; je++)
      if (we === me[je]) {
        Re = je;
        break;
      }
    V$1.activeElement === this.el_ && (Re = 0), ie.shiftKey && Re === 0 ? (me[me.length - 1].focus(), ie.preventDefault()) : !ie.shiftKey && Re === me.length - 1 && (me[0].focus(), ie.preventDefault());
  }
  /**
   * get all focusable elements
   *
   * @private
   */
  focusableEls_() {
    const ie = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(ie, (me) => (me instanceof S.HTMLAnchorElement || me instanceof S.HTMLAreaElement) && me.hasAttribute("href") || (me instanceof S.HTMLInputElement || me instanceof S.HTMLSelectElement || me instanceof S.HTMLTextAreaElement || me instanceof S.HTMLButtonElement) && !me.hasAttribute("disabled") || me instanceof S.HTMLIFrameElement || me instanceof S.HTMLObjectElement || me instanceof S.HTMLEmbedElement || me.hasAttribute("tabindex") && me.getAttribute("tabindex") !== -1 || me.hasAttribute("contenteditable"));
  }
}
Ps.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
B.registerComponent("ModalDialog", Ps);
class Ni extends ht {
  /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */
  constructor(ie = []) {
    super(), this.tracks_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.tracks_.length;
      }
    });
    for (let me = 0; me < ie.length; me++)
      this.addTrack(ie[me]);
  }
  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(ie) {
    const me = this.tracks_.length;
    "" + me in this || Object.defineProperty(this, me, {
      get() {
        return this.tracks_[me];
      }
    }), this.tracks_.indexOf(ie) === -1 && (this.tracks_.push(ie), this.trigger({
      track: ie,
      type: "addtrack",
      target: this
    })), ie.labelchange_ = () => {
      this.trigger({
        track: ie,
        type: "labelchange",
        target: this
      });
    }, Yt(ie) && ie.addEventListener("labelchange", ie.labelchange_);
  }
  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */
  removeTrack(ie) {
    let me;
    for (let we = 0, Re = this.length; we < Re; we++)
      if (this[we] === ie) {
        me = this[we], me.off && me.off(), this.tracks_.splice(we, 1);
        break;
      }
    me && this.trigger({
      track: me,
      type: "removetrack",
      target: this
    });
  }
  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */
  getTrackById(ie) {
    let me = null;
    for (let we = 0, Re = this.length; we < Re; we++) {
      const je = this[we];
      if (je.id === ie) {
        me = je;
        break;
      }
    }
    return me;
  }
}
Ni.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (const ce in Ni.prototype.allowedEvents_)
  Ni.prototype["on" + ce] = null;
const Eo = function(ce, ie) {
  for (let me = 0; me < ce.length; me++)
    !Object.keys(ce[me]).length || ie.id === ce[me].id || (ce[me].enabled = !1);
};
class uf extends Ni {
  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  constructor(ie = []) {
    for (let me = ie.length - 1; me >= 0; me--)
      if (ie[me].enabled) {
        Eo(ie, ie[me]);
        break;
      }
    super(ie), this.changing_ = !1;
  }
  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(ie) {
    ie.enabled && Eo(this, ie), super.addTrack(ie), ie.addEventListener && (ie.enabledChange_ = () => {
      this.changing_ || (this.changing_ = !0, Eo(this, ie), this.changing_ = !1, this.trigger("change"));
    }, ie.addEventListener("enabledchange", ie.enabledChange_));
  }
  removeTrack(ie) {
    super.removeTrack(ie), ie.removeEventListener && ie.enabledChange_ && (ie.removeEventListener("enabledchange", ie.enabledChange_), ie.enabledChange_ = null);
  }
}
const Co = function(ce, ie) {
  for (let me = 0; me < ce.length; me++)
    !Object.keys(ce[me]).length || ie.id === ce[me].id || (ce[me].selected = !1);
};
class lf extends Ni {
  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  constructor(ie = []) {
    for (let me = ie.length - 1; me >= 0; me--)
      if (ie[me].selected) {
        Co(ie, ie[me]);
        break;
      }
    super(ie), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
      get() {
        for (let me = 0; me < this.length; me++)
          if (this[me].selected)
            return me;
        return -1;
      },
      set() {
      }
    });
  }
  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(ie) {
    ie.selected && Co(this, ie), super.addTrack(ie), ie.addEventListener && (ie.selectedChange_ = () => {
      this.changing_ || (this.changing_ = !0, Co(this, ie), this.changing_ = !1, this.trigger("change"));
    }, ie.addEventListener("selectedchange", ie.selectedChange_));
  }
  removeTrack(ie) {
    super.removeTrack(ie), ie.removeEventListener && ie.selectedChange_ && (ie.removeEventListener("selectedchange", ie.selectedChange_), ie.selectedChange_ = null);
  }
}
class $u extends Ni {
  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(ie) {
    super.addTrack(ie), this.queueChange_ || (this.queueChange_ = () => this.queueTrigger("change")), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), ie.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(ie.kind) === -1 && ie.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }
  removeTrack(ie) {
    super.removeTrack(ie), ie.removeEventListener && (this.queueChange_ && ie.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && ie.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }
  /**
   * Creates a serializable array of objects that contains serialized copies
   * of each text track.
   *
   * @return {Object[]} A serializable list of objects for the text track list
   */
  toJSON() {
    return this.tracks_.map((ie) => ie.toJSON());
  }
}
class gT {
  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  constructor(ie = []) {
    this.trackElements_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.trackElements_.length;
      }
    });
    for (let me = 0, we = ie.length; me < we; me++)
      this.addTrackElement_(ie[me]);
  }
  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */
  addTrackElement_(ie) {
    const me = this.trackElements_.length;
    "" + me in this || Object.defineProperty(this, me, {
      get() {
        return this.trackElements_[me];
      }
    }), this.trackElements_.indexOf(ie) === -1 && this.trackElements_.push(ie);
  }
  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */
  getTrackElementByTrack_(ie) {
    let me;
    for (let we = 0, Re = this.trackElements_.length; we < Re; we++)
      if (ie === this.trackElements_[we].track) {
        me = this.trackElements_[we];
        break;
      }
    return me;
  }
  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */
  removeTrackElement_(ie) {
    for (let me = 0, we = this.trackElements_.length; me < we; me++)
      if (ie === this.trackElements_[me]) {
        this.trackElements_[me].track && typeof this.trackElements_[me].track.off == "function" && this.trackElements_[me].track.off(), typeof this.trackElements_[me].off == "function" && this.trackElements_[me].off(), this.trackElements_.splice(me, 1);
        break;
      }
  }
}
class sa {
  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  constructor(ie) {
    sa.prototype.setCues_.call(this, ie), Object.defineProperty(this, "length", {
      get() {
        return this.length_;
      }
    });
  }
  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */
  setCues_(ie) {
    const me = this.length || 0;
    let we = 0;
    const Re = ie.length;
    this.cues_ = ie, this.length_ = ie.length;
    const je = function(Ue) {
      "" + Ue in this || Object.defineProperty(this, "" + Ue, {
        get() {
          return this.cues_[Ue];
        }
      });
    };
    if (me < Re)
      for (we = me; we < Re; we++)
        je.call(this, we);
  }
  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */
  getCueById(ie) {
    let me = null;
    for (let we = 0, Re = this.length; we < Re; we++) {
      const je = this[we];
      if (je.id === ie) {
        me = je;
        break;
      }
    }
    return me;
  }
}
const _T = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, yT = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, TT = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, $c = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
class ju extends ht {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  constructor(ie = {}) {
    super();
    const me = {
      id: ie.id || "vjs_track_" + gt(),
      kind: ie.kind || "",
      language: ie.language || ""
    };
    let we = ie.label || "";
    for (const Re in me)
      Object.defineProperty(this, Re, {
        get() {
          return me[Re];
        },
        set() {
        }
      });
    Object.defineProperty(this, "label", {
      get() {
        return we;
      },
      set(Re) {
        Re !== we && (we = Re, this.trigger("labelchange"));
      }
    });
  }
}
const qu = function(ce) {
  return new URL(ce, V$1.baseURI);
}, cf = function(ce) {
  return new URL(ce, V$1.baseURI).href;
}, Vu = function(ce) {
  if (typeof ce == "string") {
    const ie = ce.split("?")[0].replace(/\/+$/, "").match(/\.([^.\/]+)$/);
    return ie ? ie[1].toLowerCase() : "";
  }
  return "";
}, Ma = function(ce, ie = S.location) {
  return qu(ce).origin !== ie.origin;
};
var vT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: qu,
  getAbsoluteURL: cf,
  getFileExtension: Vu,
  isCrossOrigin: Ma
});
const jc = function(ce, ie) {
  const me = new S.WebVTT.Parser(S, S.vttjs, S.WebVTT.StringDecoder()), we = [];
  me.oncue = function(Re) {
    ie.addCue(Re);
  }, me.onparsingerror = function(Re) {
    we.push(Re);
  }, me.onflush = function() {
    ie.trigger({
      type: "loadeddata",
      target: ie
    });
  }, me.parse(ce), we.length > 0 && (S.console && S.console.groupCollapsed && S.console.groupCollapsed(`Text Track parsing errors for ${ie.src}`), we.forEach((Re) => ae.error(Re)), S.console && S.console.groupEnd && S.console.groupEnd()), me.flush();
}, qc = function(ce, ie) {
  const me = {
    uri: ce
  }, we = Ma(ce);
  we && (me.cors = we);
  const Re = ie.tech_.crossOrigin() === "use-credentials";
  Re && (me.withCredentials = Re), Rd(me, ve$1(this, function(je, Ue, qe) {
    if (je)
      return ae.error(je, Ue);
    ie.loaded_ = !0, typeof S.WebVTT != "function" ? ie.tech_ && ie.tech_.any(["vttjsloaded", "vttjserror"], (Ge) => {
      if (Ge.type === "vttjserror") {
        ae.error(`vttjs failed to load, stopping trying to process ${ie.src}`);
        return;
      }
      return jc(qe, ie);
    }) : jc(qe, ie);
  }));
};
class Gr extends ju {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(ie = {}) {
    if (!ie.tech)
      throw new Error("A tech was not provided.");
    const me = ye$2(ie, {
      kind: TT[ie.kind] || "subtitles",
      language: ie.language || ie.srclang || ""
    });
    let we = $c[me.mode] || "disabled";
    const Re = me.default;
    (me.kind === "metadata" || me.kind === "chapters") && (we = "hidden"), super(me), this.tech_ = me.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
    const je = new sa(this.cues_), Ue = new sa(this.activeCues_);
    let qe = !1;
    this.timeupdateHandler = ve$1(this, function(Xe = {}) {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          Xe.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, qe && (this.trigger("cuechange"), qe = !1), Xe.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    const Ge = () => {
      this.stopTracking();
    };
    this.tech_.one("dispose", Ge), we !== "disabled" && this.startTracking(), Object.defineProperties(this, {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get() {
          return Re;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get() {
          return we;
        },
        set(Xe) {
          $c[Xe] && we !== Xe && (we = Xe, !this.preload_ && we !== "disabled" && this.cues.length === 0 && qc(this.src, this), this.stopTracking(), we !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get() {
          return this.loaded_ ? je : null;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return Ue;
          const Xe = this.tech_.currentTime(), ot = [];
          for (let vt = 0, bt = this.cues.length; vt < bt; vt++) {
            const Tt = this.cues[vt];
            Tt.startTime <= Xe && Tt.endTime >= Xe && ot.push(Tt);
          }
          if (qe = !1, ot.length !== this.activeCues_.length)
            qe = !0;
          else
            for (let vt = 0; vt < ot.length; vt++)
              this.activeCues_.indexOf(ot[vt]) === -1 && (qe = !0);
          return this.activeCues_ = ot, Ue.setCues_(this.activeCues_), Ue;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set() {
        }
      }
    }), me.src ? (this.src = me.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || me.kind !== "subtitles" && me.kind !== "captions") && qc(this.src, this)) : this.loaded_ = !0;
  }
  startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }
  stopTracking() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }
  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */
  addCue(ie) {
    let me = ie;
    if (!("getCueAsHTML" in me)) {
      me = new S.vttjs.VTTCue(ie.startTime, ie.endTime, ie.text);
      for (const Re in ie)
        Re in me || (me[Re] = ie[Re]);
      me.id = ie.id, me.originalCue_ = ie;
    }
    const we = this.tech_.textTracks();
    for (let Re = 0; Re < we.length; Re++)
      we[Re] !== this && we[Re].removeCue(me);
    this.cues_.push(me), this.cues.setCues_(this.cues_);
  }
  /**
   * Creates a copy of the text track and makes it serializable
   * by removing circular dependencies.
   *
   * @return {Object} The track information as a serializable object
   */
  toJSON() {
    return Qo.trackToJson(this);
  }
  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */
  removeCue(ie) {
    let me = this.cues_.length;
    for (; me--; ) {
      const we = this.cues_[me];
      if (we === ie || we.originalCue_ && we.originalCue_ === ie) {
        this.cues_.splice(me, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }
}
Gr.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
class df extends ju {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  constructor(ie = {}) {
    const me = ye$2(ie, {
      kind: yT[ie.kind] || ""
    });
    super(me);
    let we = !1;
    Object.defineProperty(this, "enabled", {
      get() {
        return we;
      },
      set(Re) {
        typeof Re != "boolean" || Re === we || (we = Re, this.trigger("enabledchange"));
      }
    }), me.enabled && (this.enabled = me.enabled), this.loaded_ = !0;
  }
}
class hf extends ju {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  constructor(ie = {}) {
    const me = ye$2(ie, {
      kind: _T[ie.kind] || ""
    });
    super(me);
    let we = !1;
    Object.defineProperty(this, "selected", {
      get() {
        return we;
      },
      set(Re) {
        typeof Re != "boolean" || Re === we || (we = Re, this.trigger("selectedchange"));
      }
    }), me.selected && (this.selected = me.selected);
  }
}
class ei extends ht {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(ie = {}) {
    super();
    let me;
    const we = new Gr(ie);
    this.kind = we.kind, this.src = we.src, this.srclang = we.language, this.label = we.label, this.default = we.default, Object.defineProperties(this, {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get() {
          return me;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get() {
          return we;
        }
      }
    }), me = ei.NONE, we.addEventListener("loadeddata", () => {
      me = ei.LOADED, this.trigger({
        type: "load",
        target: this
      });
    });
  }
}
ei.prototype.allowedEvents_ = {
  load: "load"
};
ei.NONE = 0;
ei.LOADING = 1;
ei.LOADED = 2;
ei.ERROR = 3;
const mt = {
  audio: {
    ListClass: uf,
    TrackClass: df,
    capitalName: "Audio"
  },
  video: {
    ListClass: lf,
    TrackClass: hf,
    capitalName: "Video"
  },
  text: {
    ListClass: $u,
    TrackClass: Gr,
    capitalName: "Text"
  }
};
Object.keys(mt).forEach(function(ce) {
  mt[ce].getterName = `${ce}Tracks`, mt[ce].privateName = `${ce}Tracks_`;
});
const As = {
  remoteText: {
    ListClass: $u,
    TrackClass: Gr,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: gT,
    TrackClass: ei,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, Qe = Object.assign({}, mt, As);
As.names = Object.keys(As);
mt.names = Object.keys(mt);
Qe.names = [].concat(As.names).concat(mt.names);
function bT(ce, ie, me, we, Re = {}) {
  const je = ce.textTracks();
  Re.kind = ie, me && (Re.label = me), we && (Re.language = we), Re.tech = ce;
  const Ue = new Qe.text.TrackClass(Re);
  return je.addTrack(Ue), Ue;
}
class te extends B {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(ie = {}, me = function() {
  }) {
    ie.reportTouchActivity = !1, super(null, ie, me), this.onDurationChange_ = (we) => this.onDurationChange(we), this.trackProgress_ = (we) => this.trackProgress(we), this.trackCurrentTime_ = (we) => this.trackCurrentTime(we), this.stopTrackingCurrentTime_ = (we) => this.stopTrackingCurrentTime(we), this.disposeSourceHandler_ = (we) => this.disposeSourceHandler(we), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
      this.hasStarted_ = !0;
    }), this.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), Qe.names.forEach((we) => {
      const Re = Qe[we];
      ie && ie[Re.getterName] && (this[Re.privateName] = ie[Re.getterName]);
    }), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach((we) => {
      ie[`native${we}Tracks`] === !1 && (this[`featuresNative${we}Tracks`] = !1);
    }), ie.nativeCaptions === !1 || ie.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (ie.nativeCaptions === !0 || ie.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = ie.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new Qe.text.ListClass(), this.initTrackListeners(), ie.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
  }
  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */
  triggerSourceset(ie) {
    this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(ie), 1)), this.trigger({
      src: ie,
      type: "sourceset"
    });
  }
  /* Fallbacks for unsupported event types
  ================================================================================ */
  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */
  manualProgressOn() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */
  manualProgressOff() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }
  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */
  trackProgress(ie) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(ve$1(this, function() {
      const me = this.bufferedPercent();
      this.bufferedPercent_ !== me && this.trigger("progress"), this.bufferedPercent_ = me, me === 1 && this.stopTrackingProgress();
    }), 500);
  }
  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */
  onDurationChange(ie) {
    this.duration_ = this.duration();
  }
  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */
  buffered() {
    return Ct(0, 0);
  }
  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */
  bufferedPercent() {
    return of(this.buffered(), this.duration_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */
  stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  }
  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */
  manualTimeUpdatesOn() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */
  manualTimeUpdatesOff() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */
  trackCurrentTime() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }
  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */
  stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */
  dispose() {
    this.clearTracks(mt.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
  }
  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */
  clearTracks(ie) {
    ie = [].concat(ie), ie.forEach((me) => {
      const we = this[`${me}Tracks`]() || [];
      let Re = we.length;
      for (; Re--; ) {
        const je = we[Re];
        me === "text" && this.removeRemoteTextTrack(je), we.removeTrack(je);
      }
    });
  }
  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */
  cleanupAutoTextTracks() {
    const ie = this.autoRemoteTextTracks_ || [];
    let me = ie.length;
    for (; me--; ) {
      const we = ie[me];
      this.removeRemoteTextTrack(we);
    }
  }
  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */
  reset() {
  }
  /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */
  crossOrigin() {
  }
  /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */
  setCrossOrigin() {
  }
  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */
  error(ie) {
    return ie !== void 0 && (this.error_ = new Ae$1(ie), this.trigger("error")), this.error_;
  }
  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */
  played() {
    return this.hasStarted_ ? Ct(0, 0) : Ct();
  }
  /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */
  play() {
  }
  /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */
  setScrubbing(ie) {
  }
  /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */
  scrubbing() {
  }
  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */
  setCurrentTime(ie) {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */
  initTrackListeners() {
    mt.names.forEach((ie) => {
      const me = mt[ie], we = () => {
        this.trigger(`${ie}trackchange`);
      }, Re = this[me.getterName]();
      Re.addEventListener("removetrack", we), Re.addEventListener("addtrack", we), this.on("dispose", () => {
        Re.removeEventListener("removetrack", we), Re.removeEventListener("addtrack", we);
      });
    });
  }
  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */
  addWebVttScript_() {
    if (!S.WebVTT)
      if (V$1.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && xs(ac) && Object.keys(ac).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        const ie = V$1.createElement("script");
        ie.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", ie.onload = () => {
          this.trigger("vttjsloaded");
        }, ie.onerror = () => {
          this.trigger("vttjserror");
        }, this.on("dispose", () => {
          ie.onload = null, ie.onerror = null;
        }), S.WebVTT = !0, this.el().parentNode.appendChild(ie);
      } else
        this.ready(this.addWebVttScript_);
  }
  /**
   * Emulate texttracks
   *
   */
  emulateTextTracks() {
    const ie = this.textTracks(), me = this.remoteTextTracks(), we = (qe) => ie.addTrack(qe.track), Re = (qe) => ie.removeTrack(qe.track);
    me.on("addtrack", we), me.on("removetrack", Re), this.addWebVttScript_();
    const je = () => this.trigger("texttrackchange"), Ue = () => {
      je();
      for (let qe = 0; qe < ie.length; qe++) {
        const Ge = ie[qe];
        Ge.removeEventListener("cuechange", je), Ge.mode === "showing" && Ge.addEventListener("cuechange", je);
      }
    };
    Ue(), ie.addEventListener("change", Ue), ie.addEventListener("addtrack", Ue), ie.addEventListener("removetrack", Ue), this.on("dispose", function() {
      me.off("addtrack", we), me.off("removetrack", Re), ie.removeEventListener("change", Ue), ie.removeEventListener("addtrack", Ue), ie.removeEventListener("removetrack", Ue);
      for (let qe = 0; qe < ie.length; qe++)
        ie[qe].removeEventListener("cuechange", je);
    });
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(ie, me, we) {
    if (!ie)
      throw new Error("TextTrack kind is required but was not provided");
    return bT(this, ie, me, we);
  }
  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(ie) {
    const me = ye$2(ie, {
      tech: this
    });
    return new As.remoteTextEl.TrackClass(me);
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */
  addRemoteTextTrack(ie = {}, me) {
    const we = this.createRemoteTextTrack(ie);
    return typeof me != "boolean" && (me = !1), this.remoteTextTrackEls().addTrackElement_(we), this.remoteTextTracks().addTrack(we.track), me === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(we.track)), we;
  }
  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */
  removeRemoteTextTrack(ie) {
    const me = this.remoteTextTrackEls().getTrackElementByTrack_(ie);
    this.remoteTextTrackEls().removeTrackElement_(me), this.remoteTextTracks().removeTrack(ie), this.autoRemoteTextTracks_.removeTrack(ie);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */
  getVideoPlaybackQuality() {
    return {};
  }
  /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */
  requestPictureInPicture() {
    return Promise.reject();
  }
  /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */
  disablePictureInPicture() {
    return !0;
  }
  /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */
  setDisablePictureInPicture() {
  }
  /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */
  requestVideoFrameCallback(ie) {
    const me = gt();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(me), this.one("playing", () => {
      this.queuedHanders_.has(me) && (this.queuedHanders_.delete(me), ie());
    })) : this.requestNamedAnimationFrame(me, ie), me;
  }
  /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */
  cancelVideoFrameCallback(ie) {
    this.queuedHanders_.has(ie) ? this.queuedHanders_.delete(ie) : this.cancelNamedAnimationFrame(ie);
  }
  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */
  setPoster() {
  }
  /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  playsinline() {
  }
  /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  setPlaysinline() {
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */
  overrideNativeAudioTracks(ie) {
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */
  overrideNativeVideoTracks(ie) {
  }
  /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */
  canPlayType(ie) {
    return "";
  }
  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */
  static canPlayType(ie) {
    return "";
  }
  /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */
  static canPlaySource(ie, me) {
    return te.canPlayType(ie.type);
  }
  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */
  static isTech(ie) {
    return ie.prototype instanceof te || ie instanceof te || ie === te;
  }
  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */
  static registerTech(ie, me) {
    if (te.techs_ || (te.techs_ = {}), !te.isTech(me))
      throw new Error(`Tech ${ie} must be a Tech`);
    if (!te.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!te.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return ie = De$1(ie), te.techs_[ie] = me, te.techs_[kr(ie)] = me, ie !== "Tech" && te.defaultTechOrder_.push(ie), me;
  }
  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */
  static getTech(ie) {
    if (ie) {
      if (te.techs_ && te.techs_[ie])
        return te.techs_[ie];
      if (ie = De$1(ie), S && S.videojs && S.videojs[ie])
        return ae.warn(`The ${ie} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), S.videojs[ie];
    }
  }
}
Qe.names.forEach(function(ce) {
  const ie = Qe[ce];
  te.prototype[ie.getterName] = function() {
    return this[ie.privateName] = this[ie.privateName] || new ie.ListClass(), this[ie.privateName];
  };
});
te.prototype.featuresVolumeControl = !0;
te.prototype.featuresMuteControl = !0;
te.prototype.featuresFullscreenResize = !1;
te.prototype.featuresPlaybackRate = !1;
te.prototype.featuresProgressEvents = !1;
te.prototype.featuresSourceset = !1;
te.prototype.featuresTimeupdateEvents = !1;
te.prototype.featuresNativeTextTracks = !1;
te.prototype.featuresVideoFrameCallback = !1;
te.withSourceHandlers = function(ce) {
  ce.registerSourceHandler = function(ie, me) {
    let we = ce.sourceHandlers;
    we || (we = ce.sourceHandlers = []), me === void 0 && (me = we.length), we.splice(me, 0, ie);
  }, ce.canPlayType = function(ie) {
    const me = ce.sourceHandlers || [];
    let we;
    for (let Re = 0; Re < me.length; Re++)
      if (we = me[Re].canPlayType(ie), we)
        return we;
    return "";
  }, ce.selectSourceHandler = function(ie, me) {
    const we = ce.sourceHandlers || [];
    let Re;
    for (let je = 0; je < we.length; je++)
      if (Re = we[je].canHandleSource(ie, me), Re)
        return we[je];
    return null;
  }, ce.canPlaySource = function(ie, me) {
    const we = ce.selectSourceHandler(ie, me);
    return we ? we.canHandleSource(ie, me) : "";
  }, ["seekable", "seeking", "duration"].forEach(function(ie) {
    const me = this[ie];
    typeof me == "function" && (this[ie] = function() {
      return this.sourceHandler_ && this.sourceHandler_[ie] ? this.sourceHandler_[ie].apply(this.sourceHandler_, arguments) : me.apply(this, arguments);
    });
  }, ce.prototype), ce.prototype.setSource = function(ie) {
    let me = ce.selectSourceHandler(ie, this.options_);
    me || (ce.nativeSourceHandler ? me = ce.nativeSourceHandler : ae.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), me !== ce.nativeSourceHandler && (this.currentSource_ = ie), this.sourceHandler_ = me.handleSource(ie, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, ce.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
B.registerComponent("Tech", te);
te.registerTech("Tech", te);
te.defaultTechOrder_ = [];
const Pi = {}, ra = {}, na = {};
function xT(ce, ie) {
  Pi[ce] = Pi[ce] || [], Pi[ce].push(ie);
}
function ST(ce, ie, me) {
  ce.setTimeout(() => Ci(ie, Pi[ie.type], me, ce), 1);
}
function ET(ce, ie) {
  ce.forEach((me) => me.setTech && me.setTech(ie));
}
function CT(ce, ie, me) {
  return ce.reduceRight(Hu(me), ie[me]());
}
function AT(ce, ie, me, we) {
  return ie[me](ce.reduce(Hu(me), we));
}
function Vc(ce, ie, me, we = null) {
  const Re = "call" + De$1(me), je = ce.reduce(Hu(Re), we), Ue = je === na, qe = Ue ? null : ie[me](je);
  return kT(ce, me, qe, Ue), qe;
}
const DT = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, wT = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, Hc = {
  play: 1,
  pause: 1
};
function Hu(ce) {
  return (ie, me) => ie === na ? na : me[ce] ? me[ce](ie) : ie;
}
function kT(ce, ie, me, we) {
  for (let Re = ce.length - 1; Re >= 0; Re--) {
    const je = ce[Re];
    je[ie] && je[ie](we, me);
  }
}
function IT(ce) {
  ra.hasOwnProperty(ce.id()) && delete ra[ce.id()];
}
function PT(ce, ie) {
  const me = ra[ce.id()];
  let we = null;
  if (me == null)
    return we = ie(ce), ra[ce.id()] = [[ie, we]], we;
  for (let Re = 0; Re < me.length; Re++) {
    const [je, Ue] = me[Re];
    je === ie && (we = Ue);
  }
  return we === null && (we = ie(ce), me.push([ie, we])), we;
}
function Ci(ce = {}, ie = [], me, we, Re = [], je = !1) {
  const [Ue, ...qe] = ie;
  if (typeof Ue == "string")
    Ci(ce, Pi[Ue], me, we, Re, je);
  else if (Ue) {
    const Ge = PT(we, Ue);
    if (!Ge.setSource)
      return Re.push(Ge), Ci(ce, qe, me, we, Re, je);
    Ge.setSource(Object.assign({}, ce), function(Xe, ot) {
      if (Xe)
        return Ci(ce, qe, me, we, Re, je);
      Re.push(Ge), Ci(ot, ce.type === ot.type ? qe : Pi[ot.type], me, we, Re, je);
    });
  } else qe.length ? Ci(ce, qe, me, we, Re, je) : je ? me(ce, Re) : Ci(ce, Pi["*"], me, we, Re, !0);
}
const OT = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, aa = function(ce = "") {
  const ie = Vu(ce);
  return OT[ie.toLowerCase()] || "";
}, LT = (ce, ie) => {
  if (!ie)
    return "";
  if (ce.cache_.source.src === ie && ce.cache_.source.type)
    return ce.cache_.source.type;
  const me = ce.cache_.sources.filter((Re) => Re.src === ie);
  if (me.length)
    return me[0].type;
  const we = ce.$$("source");
  for (let Re = 0; Re < we.length; Re++) {
    const je = we[Re];
    if (je.type && je.src && je.src === ie)
      return je.type;
  }
  return aa(ie);
}, ff = function(ce) {
  if (Array.isArray(ce)) {
    let ie = [];
    ce.forEach(function(me) {
      me = ff(me), Array.isArray(me) ? ie = ie.concat(me) : qt(me) && ie.push(me);
    }), ce = ie;
  } else typeof ce == "string" && ce.trim() ? ce = [zc({
    src: ce
  })] : qt(ce) && typeof ce.src == "string" && ce.src && ce.src.trim() ? ce = [zc(ce)] : ce = [];
  return ce;
};
function zc(ce) {
  if (!ce.type) {
    const ie = aa(ce.src);
    ie && (ce.type = ie);
  }
  return ce;
}
var RT = `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play">
      <path d="M16 10v28l22-14z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">
      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">
      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">
      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">
      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">
      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">
      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">
      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">
      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">
      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">
      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">
      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">
      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>
    </symbol>
    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">
      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>
    </symbol>
    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">
      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">
      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">
      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">
      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-share">
      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">
      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-square">
      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">
      <circle cx="24" cy="24" r="20"></circle>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">
      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">
      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">
      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">
      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">
      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">
      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">
      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">
      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">
      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>
    </symbol>
    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">
      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">
      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">
      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">
      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">
      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">
      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>
    </symbol>
    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">
      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>
      <path fill="none" d="M-1-3h24v24H-1z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">
      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">
      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>
    </symbol>
    <symbol viewBox="0 0 1200 1227" id="vjs-icon-twitter">
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">
      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">
      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>
    </symbol>
  </defs>
</svg>`;
const Wc = Zn ? 10009 : ea ? 461 : 8, es = {
  codes: {
    play: 415,
    pause: 19,
    ff: 417,
    rw: 412,
    back: Wc
  },
  names: {
    415: "play",
    19: "pause",
    417: "ff",
    412: "rw",
    [Wc]: "back"
  },
  isEventKey(ce, ie) {
    return ie = ie.toLowerCase(), !!(this.names[ce.keyCode] && this.names[ce.keyCode] === ie);
  },
  getEventName(ce) {
    if (this.names[ce.keyCode])
      return this.names[ce.keyCode];
    if (this.codes[ce.code]) {
      const ie = this.codes[ce.code];
      return this.names[ie];
    }
    return null;
  }
}, Gc = 5;
class MT extends ht {
  /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */
  constructor(ie) {
    super(), this.player_ = ie, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
  }
  /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */
  start() {
    this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
      this.focus(this.updateFocusableComponents()[0]);
    }), this.player_.on("modalclose", () => {
      this.refocusComponent();
    }), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
      this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
    }));
  }
  /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */
  stop() {
    this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
  }
  /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */
  onKeyDown_(ie) {
    const me = ie.originalEvent ? ie.originalEvent : ie;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(me.key)) {
      if (this.isPaused_)
        return;
      me.preventDefault();
      const we = me.key.substring(5).toLowerCase();
      this.move(we);
    } else if (es.isEventKey(me, "play") || es.isEventKey(me, "pause") || es.isEventKey(me, "ff") || es.isEventKey(me, "rw")) {
      me.preventDefault();
      const we = es.getEventName(me);
      this.performMediaAction_(we);
    } else es.isEventKey(me, "Back") && ie.target && typeof ie.target.closeable == "function" && ie.target.closeable() && (me.preventDefault(), ie.target.close());
  }
  /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */
  performMediaAction_(ie) {
    if (this.player_)
      switch (ie) {
        case "play":
          this.player_.paused() && this.player_.play();
          break;
        case "pause":
          this.player_.paused() || this.player_.pause();
          break;
        case "ff":
          this.userSeek_(this.player_.currentTime() + Gc);
          break;
        case "rw":
          this.userSeek_(this.player_.currentTime() - Gc);
          break;
      }
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(ie) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(ie);
  }
  /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */
  pause() {
    this.isPaused_ = !0;
  }
  /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */
  resume() {
    this.isPaused_ = !1;
  }
  /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */
  handlePlayerBlur_(ie) {
    const me = ie.relatedTarget;
    let we = null;
    const Re = this.getCurrentComponent(ie.target);
    me && (we = !!me.closest(".video-js"), me.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!ie.currentTarget.contains(ie.relatedTarget) && !we || !me) && (Re && Re.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), Re && Re.el() && (this.lastFocusedComponent_ = Re)));
  }
  /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */
  handlePlayerFocus_() {
    this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
  }
  /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */
  updateFocusableComponents() {
    const ie = this.player_, me = [];
    function we(Re) {
      for (const je of Re)
        je.hasOwnProperty("el_") && je.getIsFocusable() && je.getIsAvailableToBeFocused(je.el()) && me.push(je), je.hasOwnProperty("children_") && je.children_.length > 0 && we(je.children_);
    }
    return ie.children_.forEach((Re) => {
      if (Re.hasOwnProperty("el_"))
        if (Re.getIsFocusable && Re.getIsAvailableToBeFocused && Re.getIsFocusable() && Re.getIsAvailableToBeFocused(Re.el())) {
          me.push(Re);
          return;
        } else Re.hasOwnProperty("children_") && Re.children_.length > 0 ? we(Re.children_) : Re.hasOwnProperty("items") && Re.items.length > 0 ? we(Re.items) : this.findSuitableDOMChild(Re) && me.push(Re);
      if (Re.name_ === "ErrorDisplay" && Re.opened_) {
        const je = Re.el_.querySelector(".vjs-errors-ok-button-container");
        je && je.querySelectorAll("button").forEach((Ue, qe) => {
          me.push({
            name: () => "ModalButton" + (qe + 1),
            el: () => Ue,
            getPositions: () => {
              const Ge = Ue.getBoundingClientRect(), Xe = {
                x: Ge.x,
                y: Ge.y,
                width: Ge.width,
                height: Ge.height,
                top: Ge.top,
                right: Ge.right,
                bottom: Ge.bottom,
                left: Ge.left
              }, ot = {
                x: Ge.left + Ge.width / 2,
                y: Ge.top + Ge.height / 2,
                width: 0,
                height: 0,
                top: Ge.top + Ge.height / 2,
                right: Ge.left + Ge.width / 2,
                bottom: Ge.top + Ge.height / 2,
                left: Ge.left + Ge.width / 2
              };
              return {
                boundingClientRect: Xe,
                center: ot
              };
            },
            // Asume that the following are always focusable
            getIsAvailableToBeFocused: () => !0,
            getIsFocusable: (Ge) => !0,
            focus: () => Ue.focus()
          });
        });
      }
    }), this.focusableComponents = me, this.focusableComponents;
  }
  /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */
  findSuitableDOMChild(ie) {
    function me(we) {
      if (ie.getIsFocusable(we) && ie.getIsAvailableToBeFocused(we))
        return we;
      for (let Re = 0; Re < we.children.length; Re++) {
        const je = we.children[Re], Ue = me(je);
        if (Ue)
          return Ue;
      }
      return null;
    }
    return ie.el() ? me(ie.el()) : null;
  }
  /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */
  getCurrentComponent(ie) {
    this.updateFocusableComponents();
    const me = ie || document.activeElement;
    if (this.focusableComponents.length) {
      for (const we of this.focusableComponents)
        if (we.el() === me)
          return we;
    }
  }
  /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */
  add(ie) {
    const me = [...this.focusableComponents];
    ie.hasOwnProperty("el_") && ie.getIsFocusable() && ie.getIsAvailableToBeFocused(ie.el()) && me.push(ie), this.focusableComponents = me, this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    });
  }
  /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */
  remove(ie) {
    for (let me = 0; me < this.focusableComponents.length; me++)
      if (this.focusableComponents[me].name() === ie.name()) {
        this.focusableComponents.splice(me, 1), this.trigger({
          type: "focusableComponentsChanged",
          focusableComponents: this.focusableComponents
        });
        return;
      }
  }
  /**
   * Clears array of focusable components.
   */
  clear() {
    this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    }));
  }
  /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */
  move(ie) {
    const me = this.getCurrentComponent();
    if (!me)
      return;
    const we = me.getPositions(), Re = this.focusableComponents.filter((Ue) => Ue !== me && this.isInDirection_(we.boundingClientRect, Ue.getPositions().boundingClientRect, ie)), je = this.findBestCandidate_(we.center, Re, ie);
    je ? this.focus(je) : this.trigger({
      type: "endOfFocusableComponents",
      direction: ie,
      focusedComponent: me
    });
  }
  /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */
  findBestCandidate_(ie, me, we) {
    let Re = 1 / 0, je = null;
    for (const Ue of me) {
      const qe = Ue.getPositions().center, Ge = this.calculateDistance_(ie, qe, we);
      Ge < Re && (Re = Ge, je = Ue);
    }
    return je;
  }
  /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */
  isInDirection_(ie, me, we) {
    switch (we) {
      case "right":
        return me.left >= ie.right;
      case "left":
        return me.right <= ie.left;
      case "down":
        return me.top >= ie.bottom;
      case "up":
        return me.bottom <= ie.top;
      default:
        return !1;
    }
  }
  /**
   * Focus the last focused component saved before blur on player.
   */
  refocusComponent() {
    if (this.lastFocusedComponent_) {
      this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
      for (let ie = 0; ie < this.focusableComponents.length; ie++)
        if (this.focusableComponents[ie].name() === this.lastFocusedComponent_.name()) {
          this.focus(this.focusableComponents[ie]);
          return;
        }
    } else
      this.focus(this.updateFocusableComponents()[0]);
  }
  /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */
  focus(ie) {
    typeof ie == "object" && (ie.getIsAvailableToBeFocused(ie.el()) ? ie.focus() : this.findSuitableDOMChild(ie) && this.findSuitableDOMChild(ie).focus());
  }
  /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */
  calculateDistance_(ie, me, we) {
    const Re = Math.abs(ie.x - me.x), je = Math.abs(ie.y - me.y);
    let Ue;
    switch (we) {
      case "right":
      case "left":
        Ue = Re + je * 100;
        break;
      case "up":
        Ue = je * 2 + Re * 0.5;
        break;
      case "down":
        Ue = je * 5 + Re;
        break;
      default:
        Ue = Re + je;
    }
    return Ue;
  }
  /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */
  searchForTrackSelect_() {
    const ie = this;
    for (const me of ie.updateFocusableComponents())
      if (me.constructor.name === "TextTrackSelect") {
        ie.focus(me);
        break;
      }
  }
}
class NT extends B {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */
  constructor(ie, me, we) {
    const Re = ye$2({
      createEl: !1
    }, me);
    if (super(ie, Re, we), !me.playerOptions.sources || me.playerOptions.sources.length === 0)
      for (let je = 0, Ue = me.playerOptions.techOrder; je < Ue.length; je++) {
        const qe = De$1(Ue[je]);
        let Ge = te.getTech(qe);
        if (qe || (Ge = B.getComponent(qe)), Ge && Ge.isSupported()) {
          ie.loadTech_(qe);
          break;
        }
      }
    else
      ie.src(me.playerOptions.sources);
  }
}
B.registerComponent("MediaLoader", NT);
class Na extends B {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */
  constructor(ie, me) {
    super(ie, me), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (we) => this.handleMouseOver(we), this.handleMouseOut_ = (we) => this.handleMouseOut(we), this.handleClick_ = (we) => this.handleClick(we), this.handleKeyDown_ = (we) => this.handleKeyDown(we), this.emitTapEvents(), this.enable();
  }
  /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(ie = "div", me = {}, we = {}) {
    me = Object.assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, me), ie === "button" && ae.error(`Creating a ClickableComponent with an HTML element of ${ie} is not supported; use a Button instead.`), we = Object.assign({
      role: "button"
    }, we), this.tabIndex_ = me.tabIndex;
    const Re = Z$1(ie, me, we);
    return this.player_.options_.experimentalSvgIcons || Re.appendChild(Z$1("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(Re), Re;
  }
  dispose() {
    this.controlTextEl_ = null, super.dispose();
  }
  /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */
  createControlTextEl(ie) {
    return this.controlTextEl_ = Z$1("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), ie && ie.appendChild(this.controlTextEl_), this.controlText(this.controlText_, ie), this.controlTextEl_;
  }
  /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(ie, me = this.el()) {
    if (ie === void 0)
      return this.controlText_ || "Need Text";
    const we = this.localize(ie);
    this.controlText_ = ie, _i(this.controlTextEl_, we), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && me.setAttribute("title", we);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-control vjs-button ${super.buildCSSClass()}`;
  }
  /**
   * Enable this `ClickableComponent`
   */
  enable() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }
  /**
   * Disable this `ClickableComponent`
   */
  disable() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }
  /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */
  handleLanguagechange() {
    this.controlText(this.controlText_);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */
  handleClick(ie) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    ie.key === " " || ie.key === "Enter" ? (ie.preventDefault(), ie.stopPropagation(), this.trigger("click")) : super.handleKeyDown(ie);
  }
}
B.registerComponent("ClickableComponent", Na);
class Jo extends Na {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.update(), this.update_ = (we) => this.update(we), ie.on("posterchange", this.update_);
  }
  /**
   * Clean up and dispose of the `PosterImage`.
   */
  dispose() {
    this.player().off("posterchange", this.update_), super.dispose();
  }
  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return Z$1("div", {
      className: "vjs-poster"
    });
  }
  /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(ie) {
    if (typeof ie > "u")
      return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
    if (ie !== null && ie !== "anonymous" && ie !== "use-credentials") {
      this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${ie}"`);
      return;
    }
    this.$("img") && (this.$("img").crossOrigin = ie);
  }
  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */
  update(ie) {
    const me = this.player().poster();
    this.setSrc(me), me ? this.show() : this.hide();
  }
  /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */
  setSrc(ie) {
    if (!ie) {
      this.el_.textContent = "";
      return;
    }
    this.$("img") || this.el_.appendChild(Z$1("picture", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    }, {}, Z$1("img", {
      loading: "lazy",
      crossOrigin: this.crossOrigin()
    }, {
      alt: ""
    }))), this.$("img").src = ie;
  }
  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */
  handleClick(ie) {
    this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? Nt(this.player_.play()) : this.player_.pause());
  }
}
Jo.prototype.crossorigin = Jo.prototype.crossOrigin;
B.registerComponent("PosterImage", Jo);
const pt = "#222", Xc = "#ccc", BT = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Ao(ce, ie) {
  let me;
  if (ce.length === 4)
    me = ce[1] + ce[1] + ce[2] + ce[2] + ce[3] + ce[3];
  else if (ce.length === 7)
    me = ce.slice(1);
  else
    throw new Error("Invalid color code provided, " + ce + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(me.slice(0, 2), 16) + "," + parseInt(me.slice(2, 4), 16) + "," + parseInt(me.slice(4, 6), 16) + "," + ie + ")";
}
function Lt(ce, ie, me) {
  try {
    ce.style[ie] = me;
  } catch {
    return;
  }
}
function Kc(ce) {
  return ce ? `${ce}px` : "";
}
class FT extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  constructor(ie, me, we) {
    super(ie, me, we);
    const Re = (Ue) => this.updateDisplay(Ue), je = (Ue) => {
      this.updateDisplayOverlay(), this.updateDisplay(Ue);
    };
    ie.on("loadstart", (Ue) => this.toggleDisplay(Ue)), ie.on("useractive", Re), ie.on("userinactive", Re), ie.on("texttrackchange", Re), ie.on("loadedmetadata", (Ue) => {
      this.updateDisplayOverlay(), this.preselectTrack(Ue);
    }), ie.ready(ve$1(this, function() {
      if (ie.tech_ && ie.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      ie.on("fullscreenchange", je), ie.on("playerresize", je);
      const Ue = S.screen.orientation || S, qe = S.screen.orientation ? "change" : "orientationchange";
      Ue.addEventListener(qe, je), ie.on("dispose", () => Ue.removeEventListener(qe, je));
      const Ge = this.options_.playerOptions.tracks || [];
      for (let Xe = 0; Xe < Ge.length; Xe++)
        this.player_.addRemoteTextTrack(Ge[Xe], !0);
      this.preselectTrack();
    }));
  }
  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */
  preselectTrack() {
    const ie = {
      captions: 1,
      subtitles: 1
    }, me = this.player_.textTracks(), we = this.player_.cache_.selectedLanguage;
    let Re, je, Ue;
    for (let qe = 0; qe < me.length; qe++) {
      const Ge = me[qe];
      we && we.enabled && we.language && we.language === Ge.language && Ge.kind in ie ? Ge.kind === we.kind ? Ue = Ge : Ue || (Ue = Ge) : we && !we.enabled ? (Ue = null, Re = null, je = null) : Ge.default && (Ge.kind === "descriptions" && !Re ? Re = Ge : Ge.kind in ie && !je && (je = Ge));
    }
    Ue ? Ue.mode = "showing" : je ? je.mode = "showing" : Re && (Re.mode = "showing");
  }
  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */
  toggleDisplay() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }
  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }
  /**
   * Clear all displayed {@link TextTrack}s.
   */
  clearDisplay() {
    typeof S.WebVTT == "function" && S.WebVTT.processCues(S, [], this.el_);
  }
  /**
   * Update the displayed {@link TextTrack} when either a {@link Player#texttrackchange},
   * a {@link Player#fullscreenchange}, a {@link Player#useractive}, or a
   * {@link Player#userinactive} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   * @listens Player#useractive
   * @listens Player#userinactive
   */
  updateDisplay() {
    const ie = this.player_.textTracks(), me = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), me) {
      const Ue = [];
      for (let qe = 0; qe < ie.length; ++qe) {
        const Ge = ie[qe];
        Ge.mode === "showing" && Ue.push(Ge);
      }
      this.updateForTrack(Ue);
      return;
    }
    let we = null, Re = null, je = ie.length;
    for (; je--; ) {
      const Ue = ie[je];
      Ue.mode === "showing" && (Ue.kind === "descriptions" ? we = Ue : Re = Ue);
    }
    if (Re ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(Re)) : we && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(we)), !S.CSS.supports("inset", "10px")) {
      const Ue = this.el_, qe = Ue.querySelectorAll(".vjs-text-track-cue"), Ge = this.player_.controlBar.el_.getBoundingClientRect().height, Xe = this.player_.el_.getBoundingClientRect().height;
      Ue.style = "", Lt(Ue, "position", "relative"), Lt(Ue, "height", Xe - Ge + "px"), Lt(Ue, "top", "unset"), ta ? Lt(Ue, "bottom", Xe + "px") : Lt(Ue, "bottom", "0px"), qe.length > 0 && qe.forEach((ot) => {
        if (ot.style.inset) {
          const vt = ot.style.inset.split(" ");
          vt.length === 3 && Object.assign(ot.style, {
            top: vt[0],
            right: vt[1],
            bottom: vt[2],
            left: "unset"
          });
        }
      });
    }
  }
  /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */
  updateDisplayOverlay() {
    if (!this.player_.videoHeight() || !S.CSS.supports("inset-inline: 10px"))
      return;
    const ie = this.player_.currentWidth(), me = this.player_.currentHeight(), we = ie / me, Re = this.player_.videoWidth() / this.player_.videoHeight();
    let je = 0, Ue = 0;
    Math.abs(we - Re) > 0.1 && (we > Re ? je = Math.round((ie - me * Re) / 2) : Ue = Math.round((me - ie / Re) / 2)), Lt(this.el_, "insetInline", Kc(je)), Lt(this.el_, "insetBlock", Kc(Ue));
  }
  /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */
  updateDisplayState(ie) {
    const me = this.player_.textTrackSettings.getValues(), we = ie.activeCues;
    let Re = we.length;
    for (; Re--; ) {
      const je = we[Re];
      if (!je)
        continue;
      const Ue = je.displayState;
      if (me.color && (Ue.firstChild.style.color = me.color), me.textOpacity && Lt(Ue.firstChild, "color", Ao(me.color || "#fff", me.textOpacity)), me.backgroundColor && (Ue.firstChild.style.backgroundColor = me.backgroundColor), me.backgroundOpacity && Lt(Ue.firstChild, "backgroundColor", Ao(me.backgroundColor || "#000", me.backgroundOpacity)), me.windowColor && (me.windowOpacity ? Lt(Ue, "backgroundColor", Ao(me.windowColor, me.windowOpacity)) : Ue.style.backgroundColor = me.windowColor), me.edgeStyle && (me.edgeStyle === "dropshadow" ? Ue.firstChild.style.textShadow = `2px 2px 3px ${pt}, 2px 2px 4px ${pt}, 2px 2px 5px ${pt}` : me.edgeStyle === "raised" ? Ue.firstChild.style.textShadow = `1px 1px ${pt}, 2px 2px ${pt}, 3px 3px ${pt}` : me.edgeStyle === "depressed" ? Ue.firstChild.style.textShadow = `1px 1px ${Xc}, 0 1px ${Xc}, -1px -1px ${pt}, 0 -1px ${pt}` : me.edgeStyle === "uniform" && (Ue.firstChild.style.textShadow = `0 0 4px ${pt}, 0 0 4px ${pt}, 0 0 4px ${pt}, 0 0 4px ${pt}`)), me.fontPercent && me.fontPercent !== 1) {
        const qe = S.parseFloat(Ue.style.fontSize);
        Ue.style.fontSize = qe * me.fontPercent + "px", Ue.style.height = "auto", Ue.style.top = "auto";
      }
      me.fontFamily && me.fontFamily !== "default" && (me.fontFamily === "small-caps" ? Ue.firstChild.style.fontVariant = "small-caps" : Ue.firstChild.style.fontFamily = BT[me.fontFamily]);
    }
  }
  /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */
  updateForTrack(ie) {
    if (Array.isArray(ie) || (ie = [ie]), typeof S.WebVTT != "function" || ie.every((we) => !we.activeCues))
      return;
    const me = [];
    for (let we = 0; we < ie.length; ++we) {
      const Re = ie[we];
      for (let je = 0; je < Re.activeCues.length; ++je)
        me.push(Re.activeCues[je]);
    }
    S.WebVTT.processCues(S, me, this.el_);
    for (let we = 0; we < ie.length; ++we) {
      const Re = ie[we];
      for (let je = 0; je < Re.activeCues.length; ++je) {
        const Ue = Re.activeCues[je].displayState;
        Ii(Ue, "vjs-text-track-cue", "vjs-text-track-cue-" + (Re.language ? Re.language : we)), Re.language && Ss(Ue, "lang", Re.language);
      }
      this.player_.textTrackSettings && this.updateDisplayState(Re);
    }
  }
}
B.registerComponent("TextTrackDisplay", FT);
class UT extends B {
  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const ie = this.player_.isAudio(), me = this.localize(ie ? "Audio Player" : "Video Player"), we = Z$1("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [me])
    }), Re = super.createEl("div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return Re.appendChild(we), Re;
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
  }
}
B.registerComponent("LoadingSpinner", UT);
class ze extends Na {
  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(ie, me = {}, we = {}) {
    ie = "button", me = Object.assign({
      className: this.buildCSSClass()
    }, me), we = Object.assign({
      // Necessary since the default button type is "submit"
      type: "button"
    }, we);
    const Re = Z$1(ie, me, we);
    return this.player_.options_.experimentalSvgIcons || Re.appendChild(Z$1("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(Re), Re;
  }
  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */
  addChild(ie, me = {}) {
    const we = this.constructor.name;
    return ae.warn(`Adding an actionable (user controllable) child to a Button (${we}) is not supported; use a ClickableComponent instead.`), B.prototype.addChild.call(this, ie, me);
  }
  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */
  enable() {
    super.enable(), this.el_.removeAttribute("disabled");
  }
  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */
  disable() {
    super.disable(), this.el_.setAttribute("disabled", "disabled");
  }
  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    if (ie.key === " " || ie.key === "Enter") {
      ie.stopPropagation();
      return;
    }
    super.handleKeyDown(ie);
  }
}
B.registerComponent("Button", ze);
class pf extends ze {
  constructor(ie, me) {
    super(ie, me), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (we) => this.handleMouseDown(we));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */
  buildCSSClass() {
    return "vjs-big-play-button";
  }
  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    const me = this.player_.play();
    if (ie.type === "tap" || this.mouseused_ && "clientX" in ie && "clientY" in ie) {
      Nt(me), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    const we = this.player_.getChild("controlBar"), Re = we && we.getChild("playToggle");
    if (!Re) {
      this.player_.tech(!0).focus();
      return;
    }
    const je = () => Re.focus();
    Ir(me) ? me.then(je, () => {
    }) : this.setTimeout(je, 1);
  }
  /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    this.mouseused_ = !1, super.handleKeyDown(ie);
  }
  /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */
  handleMouseDown(ie) {
    this.mouseused_ = !0;
  }
}
pf.prototype.controlText_ = "Play Video";
B.registerComponent("BigPlayButton", pf);
class $T extends ze {
  /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */
  constructor(ie, me) {
    super(ie, me), this.setIcon("cancel"), this.controlText(me && me.controlText || this.localize("Close"));
  }
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-close-button ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */
  handleClick(ie) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }
  /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    ie.key === "Escape" ? (ie.preventDefault(), ie.stopPropagation(), this.trigger("click")) : super.handleKeyDown(ie);
  }
}
B.registerComponent("CloseButton", $T);
class mf extends ze {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    super(ie, me), me.replay = me.replay === void 0 || me.replay, this.setIcon("play"), this.on(ie, "play", (we) => this.handlePlay(we)), this.on(ie, "pause", (we) => this.handlePause(we)), me.replay && this.on(ie, "ended", (we) => this.handleEnded(we));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-play-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.player_.paused() ? Nt(this.player_.play()) : this.player_.pause();
  }
  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */
  handleSeeked(ie) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(ie) : this.handlePlay(ie);
  }
  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */
  handlePlay(ie) {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
  }
  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */
  handlePause(ie) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
  }
  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */
  handleEnded(ie) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (me) => this.handleSeeked(me));
  }
}
mf.prototype.controlText_ = "Play";
B.registerComponent("PlayToggle", mf);
class Os extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.on(ie, ["timeupdate", "ended", "seeking"], (we) => this.update(we)), this.updateTextNode_();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = this.buildCSSClass(), me = super.createEl("div", {
      className: `${ie} vjs-time-control vjs-control`
    }), we = Z$1("span", {
      className: "vjs-control-text",
      textContent: `${this.localize(this.labelText_)} `
    }, {
      role: "presentation"
    });
    return me.appendChild(we), this.contentEl_ = Z$1("span", {
      className: `${ie}-display`
    }, {
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), me.appendChild(this.contentEl_), me;
  }
  dispose() {
    this.contentEl_ = null, this.textNode_ = null, super.dispose();
  }
  /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */
  update(ie) {
    !this.player_.options_.enableSmoothSeeking && ie.type === "seeking" || this.updateContent(ie);
  }
  /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */
  updateTextNode_(ie = 0) {
    ie = Mi(ie), this.formattedTime_ !== ie && (this.formattedTime_ = ie, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
      if (!this.contentEl_)
        return;
      let me = this.textNode_;
      me && this.contentEl_.firstChild !== me && (me = null, ae.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = V$1.createTextNode(this.formattedTime_), this.textNode_ && (me ? this.contentEl_.replaceChild(this.textNode_, me) : this.contentEl_.appendChild(this.textNode_));
    }));
  }
  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(ie) {
  }
}
Os.prototype.labelText_ = "Time";
Os.prototype.controlText_ = "Time";
B.registerComponent("TimeDisplay", Os);
class zu extends Os {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-current-time";
  }
  /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(ie) {
    let me;
    this.player_.ended() ? me = this.player_.duration() : ie && ie.target && typeof ie.target.pendingSeekTime == "function" ? me = ie.target.pendingSeekTime() : me = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(me);
  }
}
zu.prototype.labelText_ = "Current Time";
zu.prototype.controlText_ = "Current Time";
B.registerComponent("CurrentTimeDisplay", zu);
class Wu extends Os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me);
    const we = (Re) => this.updateContent(Re);
    this.on(ie, "durationchange", we), this.on(ie, "loadstart", we), this.on(ie, "loadedmetadata", we);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-duration";
  }
  /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */
  updateContent(ie) {
    const me = this.player_.duration();
    this.updateTextNode_(me);
  }
}
Wu.prototype.labelText_ = "Duration";
Wu.prototype.controlText_ = "Duration";
B.registerComponent("DurationDisplay", Wu);
class jT extends B {
  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl("div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), me = super.createEl("div"), we = super.createEl("span", {
      textContent: "/"
    });
    return me.appendChild(we), ie.appendChild(me), ie;
  }
}
B.registerComponent("TimeDivider", jT);
class Gu extends Os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.on(ie, "durationchange", (we) => this.updateContent(we));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-remaining-time";
  }
  /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl();
    return this.options_.displayNegative !== !1 && ie.insertBefore(Z$1("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), ie;
  }
  /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */
  updateContent(ie) {
    if (typeof this.player_.duration() != "number")
      return;
    let me;
    this.player_.ended() ? me = 0 : this.player_.remainingTimeDisplay ? me = this.player_.remainingTimeDisplay() : me = this.player_.remainingTime(), this.updateTextNode_(me);
  }
}
Gu.prototype.labelText_ = "Remaining Time";
Gu.prototype.controlText_ = "Remaining Time";
B.registerComponent("RemainingTimeDisplay", Gu);
class qT extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.updateShowing(), this.on(this.player(), "durationchange", (we) => this.updateShowing(we));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl("div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = Z$1("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(Z$1("span", {
      className: "vjs-control-text",
      textContent: `${this.localize("Stream Type")} `
    })), this.contentEl_.appendChild(V$1.createTextNode(this.localize("LIVE"))), ie.appendChild(this.contentEl_), ie;
  }
  dispose() {
    this.contentEl_ = null, super.dispose();
  }
  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */
  updateShowing(ie) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }
}
B.registerComponent("LiveDisplay", qT);
class gf extends ze {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (we) => this.updateLiveEdgeStatus(we), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl("button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.setIcon("circle", ie), this.textEl_ = Z$1("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), ie.appendChild(this.textEl_), ie;
  }
  /**
   * Update the state of this button if we are at the live edge
   * or not
   */
  updateLiveEdgeStatus() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }
  /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */
  handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  }
  /**
   * Dispose of the element and stop tracking
   */
  dispose() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
  }
}
gf.prototype.controlText_ = "Seek to live, currently playing live";
B.registerComponent("SeekToLive", gf);
function Xr(ce, ie, me) {
  return ce = Number(ce), Math.min(me, Math.max(ie, isNaN(ce) ? ie : ce));
}
var VT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  clamp: Xr
});
class Xu extends B {
  /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */
  constructor(ie, me) {
    super(ie, me), this.handleMouseDown_ = (we) => this.handleMouseDown(we), this.handleMouseUp_ = (we) => this.handleMouseUp(we), this.handleKeyDown_ = (we) => this.handleKeyDown(we), this.handleClick_ = (we) => this.handleClick(we), this.handleMouseMove_ = (we) => this.handleMouseMove(we), this.update_ = (we) => this.update(we), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
  }
  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Enable controls for this slider if they are disabled
   */
  enable() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }
  /**
   * Disable controls for this slider if they are enabled
   */
  disable() {
    if (!this.enabled())
      return;
    const ie = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(ie, "mousemove", this.handleMouseMove_), this.off(ie, "mouseup", this.handleMouseUp_), this.off(ie, "touchmove", this.handleMouseMove_), this.off(ie, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
  }
  /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(ie, me = {}, we = {}) {
    return me.className = me.className + " vjs-slider", me = Object.assign({
      tabIndex: 0
    }, me), we = Object.assign({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, we), super.createEl(ie, me, we);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */
  handleMouseDown(ie) {
    const me = this.bar.el_.ownerDocument;
    ie.type === "mousedown" && ie.preventDefault(), ie.type === "touchstart" && !Vt$1 && ie.preventDefault(), jh(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(me, "mousemove", this.handleMouseMove_), this.on(me, "mouseup", this.handleMouseUp_), this.on(me, "touchmove", this.handleMouseMove_), this.on(me, "touchend", this.handleMouseUp_), this.handleMouseMove(ie, !0);
  }
  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseMove(ie) {
  }
  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */
  handleMouseUp(ie) {
    const me = this.bar.el_.ownerDocument;
    qh(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(me, "mousemove", this.handleMouseMove_), this.off(me, "mouseup", this.handleMouseUp_), this.off(me, "touchmove", this.handleMouseMove_), this.off(me, "touchend", this.handleMouseUp_), this.update();
  }
  /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */
  update() {
    if (!this.el_ || !this.bar)
      return;
    const ie = this.getProgress();
    return ie === this.progress_ || (this.progress_ = ie, this.requestNamedAnimationFrame("Slider#update", () => {
      const me = this.vertical() ? "height" : "width";
      this.bar.el().style[me] = (ie * 100).toFixed(2) + "%";
    })), ie;
  }
  /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */
  getProgress() {
    return Number(Xr(this.getPercent(), 0, 1).toFixed(4));
  }
  /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */
  calculateDistance(ie) {
    const me = Ia(this.el_, ie);
    return this.vertical() ? me.y : me.x;
  }
  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    const me = this.options_.playerOptions.spatialNavigation, we = me && me.enabled, Re = me && me.horizontalSeek;
    we ? Re && ie.key === "ArrowLeft" || !Re && ie.key === "ArrowDown" ? (ie.preventDefault(), ie.stopPropagation(), this.stepBack()) : Re && ie.key === "ArrowRight" || !Re && ie.key === "ArrowUp" ? (ie.preventDefault(), ie.stopPropagation(), this.stepForward()) : (this.pendingSeekTime() && (this.pendingSeekTime(null), this.userSeek_(this.player_.currentTime())), super.handleKeyDown(ie)) : ie.key === "ArrowLeft" || ie.key === "ArrowDown" ? (ie.preventDefault(), ie.stopPropagation(), this.stepBack()) : ie.key === "ArrowUp" || ie.key === "ArrowRight" ? (ie.preventDefault(), ie.stopPropagation(), this.stepForward()) : super.handleKeyDown(ie);
  }
  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */
  handleClick(ie) {
    ie.stopPropagation(), ie.preventDefault();
  }
  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */
  vertical(ie) {
    if (ie === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!ie, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }
}
B.registerComponent("Slider", Xu);
const Do = (ce, ie) => Xr(ce / ie * 100, 0, 100).toFixed(2) + "%";
class HT extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.partEls_ = [], this.on(ie, "progress", (we) => this.update(we));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl("div", {
      className: "vjs-load-progress"
    }), me = Z$1("span", {
      className: "vjs-control-text"
    }), we = Z$1("span", {
      textContent: this.localize("Loaded")
    }), Re = V$1.createTextNode(": ");
    return this.percentageEl_ = Z$1("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), ie.appendChild(me), me.appendChild(we), me.appendChild(Re), me.appendChild(this.percentageEl_), ie;
  }
  dispose() {
    this.partEls_ = null, this.percentageEl_ = null, super.dispose();
  }
  /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */
  update(ie) {
    this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
      const me = this.player_.liveTracker, we = this.player_.buffered(), Re = me && me.isLive() ? me.seekableEnd() : this.player_.duration(), je = this.player_.bufferedEnd(), Ue = this.partEls_, qe = Do(je, Re);
      this.percent_ !== qe && (this.el_.style.width = qe, _i(this.percentageEl_, qe), this.percent_ = qe);
      for (let Ge = 0; Ge < we.length; Ge++) {
        const Xe = we.start(Ge), ot = we.end(Ge);
        let vt = Ue[Ge];
        vt || (vt = this.el_.appendChild(Z$1()), Ue[Ge] = vt), !(vt.dataset.start === Xe && vt.dataset.end === ot) && (vt.dataset.start = Xe, vt.dataset.end = ot, vt.style.left = Do(Xe, je), vt.style.width = Do(ot - Xe, je));
      }
      for (let Ge = Ue.length; Ge > we.length; Ge--)
        this.el_.removeChild(Ue[Ge - 1]);
      Ue.length = we.length;
    });
  }
}
B.registerComponent("LoadProgressBar", HT);
class zT extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.update = Ht(ve$1(this, this.update), _t);
  }
  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(ie, me, we) {
    const Re = Fr(this.el_), je = Es(this.player_.el()), Ue = ie.width * me;
    if (!je || !Re)
      return;
    let qe = ie.left - je.left + Ue, Ge = ie.width - Ue + (je.right - ie.right);
    Ge || (Ge = ie.width - Ue, qe = Ue);
    let Xe = Re.width / 2;
    qe < Xe ? Xe += Xe - qe : Ge < Xe && (Xe = Ge), Xe < 0 ? Xe = 0 : Xe > Re.width && (Xe = Re.width), Xe = Math.round(Xe), this.el_.style.right = `-${Xe}px`, this.write(we);
  }
  /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */
  write(ie) {
    _i(this.el_, ie);
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateTime(ie, me, we, Re) {
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
      let je;
      const Ue = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        const qe = this.player_.liveTracker.liveWindow(), Ge = qe - me * qe;
        je = (Ge < 1 ? "" : "-") + Mi(Ge, qe);
      } else
        je = Mi(we, Ue);
      this.update(ie, me, je), Re && Re();
    });
  }
}
B.registerComponent("TimeTooltip", zT);
class Ku extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.setIcon("circle"), this.update = Ht(ve$1(this, this.update), _t);
  }
  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   */
  update(ie, me, we) {
    const Re = this.getChild("timeTooltip");
    if (!Re)
      return;
    const je = we && we.target && typeof we.target.pendingSeekTime == "function" ? we.target.pendingSeekTime() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    Re.updateTime(ie, me, je);
  }
}
Ku.prototype.options_ = {
  children: []
};
!Ve && !At && Ku.prototype.options_.children.push("timeTooltip");
B.registerComponent("PlayProgressBar", Ku);
class _f extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.update = Ht(ve$1(this, this.update), _t);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(ie, me) {
    const we = me * this.player_.duration();
    this.getChild("timeTooltip").updateTime(ie, me, we, () => {
      this.el_.style.left = `${ie.width * me}px`;
    });
  }
}
_f.prototype.options_ = {
  children: ["timeTooltip"]
};
B.registerComponent("MouseTimeDisplay", _f);
class Ba extends Xu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   * @param {number} [options.stepSeconds=5]
   *        The number of seconds to increment on keyboard control
   * @param {number} [options.pageMultiplier=12]
   *        The multiplier of stepSeconds that PgUp/PgDown move the timeline.
   */
  constructor(ie, me) {
    me = ye$2(Ba.prototype.options_, me), me.children = [...me.children];
    const we = ie.options_.disableSeekWhileScrubbingOnMobile && (Ve || At) || ie.options_.disableSeekWhileScrubbingOnSTV;
    (!Ve && !At || we) && me.children.splice(1, 0, "mouseTimeDisplay"), super(ie, me), this.shouldDisableSeekWhileScrubbing_ = we, this.pendingSeekTime_ = null, this.setEventHandlers_();
  }
  /**
   * Sets the event handlers
   *
   * @private
   */
  setEventHandlers_() {
    this.update_ = ve$1(this, this.update), this.update = Ht(this.update_, _t), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (ie) => this.enableInterval_(ie), this.disableIntervalHandler_ = (ie) => this.disableInterval_(ie), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in V$1 && "visibilityState" in V$1 && this.on(V$1, "visibilitychange", this.toggleVisibility_);
  }
  toggleVisibility_(ie) {
    V$1.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(ie)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }
  enableInterval_() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, _t));
  }
  disableInterval_(ie) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && ie && ie.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }
  /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */
  update(ie) {
    if (V$1.visibilityState === "hidden")
      return;
    const me = super.update();
    return this.requestNamedAnimationFrame("SeekBar#update", () => {
      const we = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), Re = this.player_.liveTracker;
      let je = this.player_.duration();
      Re && Re.isLive() && (je = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== me && (this.el_.setAttribute("aria-valuenow", (me * 100).toFixed(2)), this.percent_ = me), (this.currentTime_ !== we || this.duration_ !== je) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [Mi(we, je), Mi(je, je)], "{1} of {2}")), this.currentTime_ = we, this.duration_ = je), this.bar && this.bar.update(Es(this.el()), this.getProgress(), ie);
    }), me;
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(ie) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(ie);
  }
  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */
  getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }
  /**
   * Getter and setter for pendingSeekTime.
   * Ensures the value is clamped between 0 and duration.
   *
   * @param {number|null} [time] - Optional. The new pending seek time, can be a number or null.
   * @return {number|null} - The current pending seek time.
   */
  pendingSeekTime(ie) {
    if (ie !== void 0)
      if (ie !== null) {
        const me = this.player_.duration();
        this.pendingSeekTime_ = Math.max(0, Math.min(ie, me));
      } else
        this.pendingSeekTime_ = null;
    return this.pendingSeekTime_;
  }
  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */
  getPercent() {
    if (this.pendingSeekTime() !== null)
      return this.pendingSeekTime() / this.player_.duration();
    const ie = this.getCurrentTime_();
    let me;
    const we = this.player_.liveTracker;
    return we && we.isLive() ? (me = (ie - we.seekableStart()) / we.liveWindow(), we.atLiveEdge() && (me = 1)) : me = ie / this.player_.duration(), me;
  }
  /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(ie) {
    Ur(ie) && (ie.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbing_ || this.player_.pause(), super.handleMouseDown(ie));
  }
  /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */
  handleMouseMove(ie, me = !1) {
    if (!Ur(ie) || isNaN(this.player_.duration()))
      return;
    !me && !this.player_.scrubbing() && this.player_.scrubbing(!0);
    let we;
    const Re = this.calculateDistance(ie), je = this.player_.liveTracker;
    if (!je || !je.isLive())
      we = Re * this.player_.duration(), we === this.player_.duration() && (we = we - 0.1);
    else {
      if (Re >= 0.99) {
        je.seekToLiveEdge();
        return;
      }
      const Ue = je.seekableStart(), qe = je.liveCurrentTime();
      if (we = Ue + Re * je.liveWindow(), we >= qe && (we = qe), we <= Ue && (we = Ue + 0.1), we === 1 / 0)
        return;
    }
    this.shouldDisableSeekWhileScrubbing_ ? this.pendingSeekTime(we) : this.userSeek_(we), this.player_.options_.enableSmoothSeeking && this.update();
  }
  enable() {
    super.enable();
    const ie = this.getChild("mouseTimeDisplay");
    ie && ie.show();
  }
  disable() {
    super.disable();
    const ie = this.getChild("mouseTimeDisplay");
    ie && ie.hide();
  }
  /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */
  handleMouseUp(ie) {
    super.handleMouseUp(ie), ie && ie.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? Nt(this.player_.play()) : this.update_();
  }
  /**
   * Handles pending seek time when `disableSeekWhileScrubbingOnSTV` is enabled.
   *
   * @param {number} stepAmount - The number of seconds to step (positive for forward, negative for backward).
   */
  handlePendingSeek_(ie) {
    this.player_.paused() || this.player_.pause();
    const me = this.pendingSeekTime() !== null ? this.pendingSeekTime() : this.player_.currentTime();
    this.pendingSeekTime(me + ie), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Move more quickly fast forward for keyboard-only users
   */
  stepForward() {
    this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
  }
  /**
   * Move more quickly rewind for keyboard-only users
   */
  stepBack() {
    this.shouldDisableSeekWhileScrubbing_ ? this.handlePendingSeek_(-this.options().stepSeconds) : this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
  }
  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */
  handleAction(ie) {
    this.pendingSeekTime() !== null && (this.userSeek_(this.pendingSeekTime()), this.pendingSeekTime(null)), this.player_.paused() ? this.player_.play() : this.player_.pause();
  }
  /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    const me = this.player_.liveTracker;
    if (ie.key === " " || ie.key === "Enter")
      ie.preventDefault(), ie.stopPropagation(), this.handleAction(ie);
    else if (ie.key === "Home")
      ie.preventDefault(), ie.stopPropagation(), this.userSeek_(0);
    else if (ie.key === "End")
      ie.preventDefault(), ie.stopPropagation(), me && me.isLive() ? this.userSeek_(me.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(ie.key)) {
      ie.preventDefault(), ie.stopPropagation();
      const we = parseInt(ie.key, 10) * 0.1;
      me && me.isLive() ? this.userSeek_(me.seekableStart() + me.liveWindow() * we) : this.userSeek_(this.player_.duration() * we);
    } else ie.key === "PageDown" ? (ie.preventDefault(), ie.stopPropagation(), this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier)) : ie.key === "PageUp" ? (ie.preventDefault(), ie.stopPropagation(), this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier)) : super.handleKeyDown(ie);
  }
  dispose() {
    this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in V$1 && "visibilityState" in V$1 && this.off(V$1, "visibilitychange", this.toggleVisibility_), super.dispose();
  }
}
Ba.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar",
  stepSeconds: 5,
  pageMultiplier: 12
};
B.registerComponent("SeekBar", Ba);
class yf extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.handleMouseMove = Ht(ve$1(this, this.handleMouseMove), _t), this.throttledHandleMouseSeek = Ht(ve$1(this, this.handleMouseSeek), _t), this.handleMouseUpHandler_ = (we) => this.handleMouseUp(we), this.handleMouseDownHandler_ = (we) => this.handleMouseDown(we), this.enable();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-control vjs-control"
    });
  }
  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */
  handleMouseMove(ie) {
    const me = this.getChild("seekBar");
    if (!me)
      return;
    const we = me.getChild("playProgressBar"), Re = me.getChild("mouseTimeDisplay");
    if (!we && !Re)
      return;
    const je = me.el(), Ue = Fr(je);
    let qe = Ia(je, ie).x;
    qe = Xr(qe, 0, 1), Re && Re.update(Ue, qe), we && we.update(Ue, me.getProgress());
  }
  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */
  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseSeek(ie) {
    const me = this.getChild("seekBar");
    me && me.handleMouseMove(ie);
  }
  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Disable all controls on the progress control and its children
   */
  disable() {
    if (this.children().forEach((ie) => ie.disable && ie.disable()), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      const ie = this.getChild("seekBar");
      this.player_.scrubbing(!1), ie.videoWasPlaying && Nt(this.player_.play());
    }
  }
  /**
   * Enable all controls on the progress control and its children
   */
  enable() {
    this.children().forEach((ie) => ie.enable && ie.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }
  /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */
  removeListenersAddedOnMousedownAndTouchstart() {
    const ie = this.el_.ownerDocument;
    this.off(ie, "mousemove", this.throttledHandleMouseSeek), this.off(ie, "touchmove", this.throttledHandleMouseSeek), this.off(ie, "mouseup", this.handleMouseUpHandler_), this.off(ie, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(ie) {
    const me = this.el_.ownerDocument, we = this.getChild("seekBar");
    we && we.handleMouseDown(ie), this.on(me, "mousemove", this.throttledHandleMouseSeek), this.on(me, "touchmove", this.throttledHandleMouseSeek), this.on(me, "mouseup", this.handleMouseUpHandler_), this.on(me, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(ie) {
    const me = this.getChild("seekBar");
    me && me.handleMouseUp(ie), this.removeListenersAddedOnMousedownAndTouchstart();
  }
}
yf.prototype.options_ = {
  children: ["seekBar"]
};
B.registerComponent("ProgressControl", yf);
class Tf extends ze {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  constructor(ie, me) {
    super(ie, me), this.setIcon("picture-in-picture-enter"), this.on(ie, ["enterpictureinpicture", "leavepictureinpicture"], (we) => this.handlePictureInPictureChange(we)), this.on(ie, ["disablepictureinpicturechanged", "loadedmetadata"], (we) => this.handlePictureInPictureEnabledChange(we)), this.on(ie, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], () => this.handlePictureInPictureAudioModeChange()), this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */
  handlePictureInPictureAudioModeChange() {
    if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
      this.show();
      return;
    }
    this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
  }
  /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */
  handlePictureInPictureEnabledChange() {
    V$1.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in S ? this.enable() : this.disable();
  }
  /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  handlePictureInPictureChange(ie) {
    this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
  }
  /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */
  show() {
    typeof V$1.exitPictureInPicture == "function" && super.show();
  }
}
Tf.prototype.controlText_ = "Picture-in-Picture";
B.registerComponent("PictureInPictureToggle", Tf);
class vf extends ze {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.setIcon("fullscreen-enter"), this.on(ie, "fullscreenchange", (we) => this.handleFullscreenChange(we)), V$1[ie.fsApi_.fullscreenEnabled] === !1 && this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-fullscreen-control ${super.buildCSSClass()}`;
  }
  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */
  handleFullscreenChange(ie) {
    this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
  }
  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }
}
vf.prototype.controlText_ = "Fullscreen";
B.registerComponent("FullscreenToggle", vf);
const WT = function(ce, ie) {
  ie.tech_ && !ie.tech_.featuresVolumeControl && ce.addClass("vjs-hidden"), ce.on(ie, "loadstart", function() {
    ie.tech_.featuresVolumeControl ? ce.removeClass("vjs-hidden") : ce.addClass("vjs-hidden");
  });
};
class GT extends B {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl("div", {
      className: "vjs-volume-level"
    });
    return this.setIcon("circle", ie), ie.appendChild(super.createEl("span", {
      className: "vjs-control-text"
    })), ie;
  }
}
B.registerComponent("VolumeLevel", GT);
class XT extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.update = Ht(ve$1(this, this.update), _t);
  }
  /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(ie, me, we, Re) {
    if (!we) {
      const je = Es(this.el_), Ue = Es(this.player_.el()), qe = ie.width * me;
      if (!Ue || !je)
        return;
      const Ge = ie.left - Ue.left + qe, Xe = ie.width - qe + (Ue.right - ie.right);
      let ot = je.width / 2;
      Ge < ot ? ot += ot - Ge : Xe < ot && (ot = Xe), ot < 0 ? ot = 0 : ot > je.width && (ot = je.width), this.el_.style.right = `-${ot}px`;
    }
    this.write(`${Re}%`);
  }
  /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */
  write(ie) {
    _i(this.el_, ie);
  }
  /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateVolume(ie, me, we, Re, je) {
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
      this.update(ie, me, we, Re.toFixed(0)), je && je();
    });
  }
}
B.registerComponent("VolumeLevelTooltip", XT);
class bf extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.update = Ht(ve$1(this, this.update), _t);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(ie, me, we) {
    const Re = 100 * me;
    this.getChild("volumeLevelTooltip").updateVolume(ie, me, we, Re, () => {
      we ? this.el_.style.bottom = `${ie.height * me}px` : this.el_.style.left = `${ie.width * me}px`;
    });
  }
}
bf.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
B.registerComponent("MouseVolumeLevelDisplay", bf);
class Fa extends Xu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.on("slideractive", (we) => this.updateLastVolume_(we)), this.on(ie, "volumechange", (we) => this.updateARIAAttributes(we)), ie.ready(() => this.updateARIAAttributes());
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }
  /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(ie) {
    Ur(ie) && super.handleMouseDown(ie);
  }
  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */
  handleMouseMove(ie) {
    const me = this.getChild("mouseVolumeLevelDisplay");
    if (me) {
      const we = this.el(), Re = Es(we), je = this.vertical();
      let Ue = Ia(we, ie);
      Ue = je ? Ue.y : Ue.x, Ue = Xr(Ue, 0, 1), me.update(Re, Ue, je);
    }
    Ur(ie) && (this.checkMuted(), this.player_.volume(this.calculateDistance(ie)));
  }
  /**
   * If the player is muted unmute it.
   */
  checkMuted() {
    this.player_.muted() && this.player_.muted(!1);
  }
  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */
  getPercent() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }
  /**
   * Increase volume level for keyboard users
   */
  stepForward() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }
  /**
   * Decrease volume level for keyboard users
   */
  stepBack() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }
  /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */
  updateARIAAttributes(ie) {
    const me = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", me), this.el_.setAttribute("aria-valuetext", me + "%");
  }
  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */
  volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  }
  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */
  updateLastVolume_() {
    const ie = this.player_.volume();
    this.one("sliderinactive", () => {
      this.player_.volume() === 0 && this.player_.lastVolume_(ie);
    });
  }
}
Fa.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!Ve && !At && Fa.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
Fa.prototype.playerEvent = "volumechange";
B.registerComponent("VolumeBar", Fa);
class xf extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    me.vertical = me.vertical || !1, (typeof me.volumeBar > "u" || xs(me.volumeBar)) && (me.volumeBar = me.volumeBar || {}, me.volumeBar.vertical = me.vertical), super(ie, me), WT(this, ie), this.throttledHandleMouseMove = Ht(ve$1(this, this.handleMouseMove), _t), this.handleMouseUpHandler_ = (we) => this.handleMouseUp(we), this.on("mousedown", (we) => this.handleMouseDown(we)), this.on("touchstart", (we) => this.handleMouseDown(we)), this.on("mousemove", (we) => this.handleMouseMove(we)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
      this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
    }), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
      this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
    });
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let ie = "vjs-volume-horizontal";
    return this.options_.vertical && (ie = "vjs-volume-vertical"), super.createEl("div", {
      className: `vjs-volume-control vjs-control ${ie}`
    });
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(ie) {
    const me = this.el_.ownerDocument;
    this.on(me, "mousemove", this.throttledHandleMouseMove), this.on(me, "touchmove", this.throttledHandleMouseMove), this.on(me, "mouseup", this.handleMouseUpHandler_), this.on(me, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(ie) {
    const me = this.el_.ownerDocument;
    this.off(me, "mousemove", this.throttledHandleMouseMove), this.off(me, "touchmove", this.throttledHandleMouseMove), this.off(me, "mouseup", this.handleMouseUpHandler_), this.off(me, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseMove(ie) {
    this.volumeBar.handleMouseMove(ie);
  }
}
xf.prototype.options_ = {
  children: ["volumeBar"]
};
B.registerComponent("VolumeControl", xf);
const KT = function(ce, ie) {
  ie.tech_ && !ie.tech_.featuresMuteControl && ce.addClass("vjs-hidden"), ce.on(ie, "loadstart", function() {
    ie.tech_.featuresMuteControl ? ce.removeClass("vjs-hidden") : ce.addClass("vjs-hidden");
  });
};
class Sf extends ze {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), KT(this, ie), this.on(ie, ["loadstart", "volumechange"], (we) => this.update(we));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-mute-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    const me = this.player_.volume(), we = this.player_.lastVolume_();
    if (me === 0) {
      const Re = we < 0.1 ? 0.1 : we;
      this.player_.volume(Re), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }
  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */
  update(ie) {
    this.updateIcon_(), this.updateControlText_();
  }
  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */
  updateIcon_() {
    const ie = this.player_.volume();
    let me = 3;
    this.setIcon("volume-high"), Ve && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), ie === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), me = 0) : ie < 0.33 ? (this.setIcon("volume-low"), me = 1) : ie < 0.67 && (this.setIcon("volume-medium"), me = 2), wa(this.el_, [0, 1, 2, 3].reduce((we, Re) => we + `${Re ? " " : ""}vjs-vol-${Re}`, "")), Ii(this.el_, `vjs-vol-${me}`);
  }
  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */
  updateControlText_() {
    const ie = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
    this.controlText() !== ie && this.controlText(ie);
  }
}
Sf.prototype.controlText_ = "Mute";
B.registerComponent("MuteToggle", Sf);
class Ef extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    typeof me.inline < "u" ? me.inline = me.inline : me.inline = !0, (typeof me.volumeControl > "u" || xs(me.volumeControl)) && (me.volumeControl = me.volumeControl || {}, me.volumeControl.vertical = !me.inline), super(ie, me), this.handleKeyPressHandler_ = (we) => this.handleKeyPress(we), this.on(ie, ["loadstart"], (we) => this.volumePanelState_(we)), this.on(this.muteToggle, "keyup", (we) => this.handleKeyPress(we)), this.on(this.volumeControl, "keyup", (we) => this.handleVolumeControlKeyUp(we)), this.on("keydown", (we) => this.handleKeyPress(we)), this.on("mouseover", (we) => this.handleMouseOver(we)), this.on("mouseout", (we) => this.handleMouseOut(we)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
  }
  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */
  sliderActive_() {
    this.addClass("vjs-slider-active");
  }
  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */
  sliderInactive_() {
    this.removeClass("vjs-slider-active");
  }
  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */
  volumePanelState_() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let ie = "vjs-volume-panel-horizontal";
    return this.options_.inline || (ie = "vjs-volume-panel-vertical"), super.createEl("div", {
      className: `vjs-volume-panel vjs-control ${ie}`
    });
  }
  /**
   * Dispose of the `volume-panel` and all child components.
   */
  dispose() {
    this.handleMouseOut(), super.dispose();
  }
  /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */
  handleVolumeControlKeyUp(ie) {
    ie.key === "Escape" && this.muteToggle.focus();
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */
  handleMouseOver(ie) {
    this.addClass("vjs-hover"), dt(V$1, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */
  handleMouseOut(ie) {
    this.removeClass("vjs-hover"), He(V$1, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */
  handleKeyPress(ie) {
    ie.key === "Escape" && this.handleMouseOut();
  }
}
Ef.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
B.registerComponent("VolumePanel", Ef);
class Cf extends ze {
  constructor(ie, me) {
    super(ie, me), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(ie.language())])), this.show()) : this.hide();
  }
  getSkipForwardTime() {
    const ie = this.options_.playerOptions;
    return ie.controlBar && ie.controlBar.skipButtons && ie.controlBar.skipButtons.forward;
  }
  buildCSSClass() {
    return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(ie) {
    if (isNaN(this.player_.duration()))
      return;
    const me = this.player_.currentTime(), we = this.player_.liveTracker, Re = we && we.isLive() ? we.seekableEnd() : this.player_.duration();
    let je;
    me + this.skipTime <= Re ? je = me + this.skipTime : je = Re, this.player_.currentTime(je);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
  }
}
Cf.prototype.controlText_ = "Skip Forward";
B.registerComponent("SkipForward", Cf);
class Af extends ze {
  constructor(ie, me) {
    super(ie, me), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(ie.language())])), this.show()) : this.hide();
  }
  getSkipBackwardTime() {
    const ie = this.options_.playerOptions;
    return ie.controlBar && ie.controlBar.skipButtons && ie.controlBar.skipButtons.backward;
  }
  buildCSSClass() {
    return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(ie) {
    const me = this.player_.currentTime(), we = this.player_.liveTracker, Re = we && we.isLive() && we.seekableStart();
    let je;
    Re && me - this.skipTime <= Re ? je = Re : me >= this.skipTime ? je = me - this.skipTime : je = 0, this.player_.currentTime(je);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
  }
}
Af.prototype.controlText_ = "Skip Backward";
B.registerComponent("SkipBackward", Af);
class Df extends B {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  constructor(ie, me) {
    super(ie, me), me && (this.menuButton_ = me.menuButton), this.focusedChild_ = -1, this.on("keydown", (we) => this.handleKeyDown(we)), this.boundHandleBlur_ = (we) => this.handleBlur(we), this.boundHandleTapClick_ = (we) => this.handleTapClick(we);
  }
  /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */
  addEventListenerForItem(ie) {
    ie instanceof B && (this.on(ie, "blur", this.boundHandleBlur_), this.on(ie, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */
  removeEventListenerForItem(ie) {
    ie instanceof B && (this.off(ie, "blur", this.boundHandleBlur_), this.off(ie, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */
  removeChild(ie) {
    typeof ie == "string" && (ie = this.getChild(ie)), this.removeEventListenerForItem(ie), super.removeChild(ie);
  }
  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */
  addItem(ie) {
    const me = this.addChild(ie);
    me && this.addEventListenerForItem(me);
  }
  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */
  createEl() {
    const ie = this.options_.contentElType || "ul";
    this.contentEl_ = Z$1(ie, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    const me = super.createEl("div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return me.appendChild(this.contentEl_), dt(me, "click", function(we) {
      we.preventDefault(), we.stopImmediatePropagation();
    }), me;
  }
  dispose() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
  }
  /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */
  handleBlur(ie) {
    const me = ie.relatedTarget || V$1.activeElement;
    if (!this.children().some((we) => we.el() === me)) {
      const we = this.menuButton_;
      we && we.buttonPressed_ && me !== we.el().firstChild && we.unpressButton();
    }
  }
  /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */
  handleTapClick(ie) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      const me = this.children();
      if (!Array.isArray(me))
        return;
      const we = me.filter((Re) => Re.el() === ie.target)[0];
      if (!we)
        return;
      we.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }
  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    ie.key === "ArrowLeft" || ie.key === "ArrowDown" ? (ie.preventDefault(), ie.stopPropagation(), this.stepForward()) : (ie.key === "ArrowRight" || ie.key === "ArrowUp") && (ie.preventDefault(), ie.stopPropagation(), this.stepBack());
  }
  /**
   * Move to next (lower) menu item for keyboard users.
   */
  stepForward() {
    let ie = 0;
    this.focusedChild_ !== void 0 && (ie = this.focusedChild_ + 1), this.focus(ie);
  }
  /**
   * Move to previous (higher) menu item for keyboard users.
   */
  stepBack() {
    let ie = 0;
    this.focusedChild_ !== void 0 && (ie = this.focusedChild_ - 1), this.focus(ie);
  }
  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */
  focus(ie = 0) {
    const me = this.children().slice();
    me.length && me[0].hasClass("vjs-menu-title") && me.shift(), me.length > 0 && (ie < 0 ? ie = 0 : ie >= me.length && (ie = me.length - 1), this.focusedChild_ = ie, me[ie].el_.focus());
  }
}
B.registerComponent("Menu", Df);
class Yu extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    super(ie, me), this.menuButton_ = new ze(ie, me), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    const we = ze.prototype.buildCSSClass();
    this.menuButton_.el_.className = this.buildCSSClass() + " " + we, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
    const Re = (je) => this.handleClick(je);
    this.handleMenuKeyUp_ = (je) => this.handleMenuKeyUp(je), this.on(this.menuButton_, "tap", Re), this.on(this.menuButton_, "click", Re), this.on(this.menuButton_, "keydown", (je) => this.handleKeyDown(je)), this.on(this.menuButton_, "mouseenter", () => {
      this.addClass("vjs-hover"), this.menu.show(), dt(V$1, "keyup", this.handleMenuKeyUp_);
    }), this.on("mouseleave", (je) => this.handleMouseLeave(je)), this.on("keydown", (je) => this.handleSubmenuKeyDown(je));
  }
  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const ie = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = ie, this.addChild(ie), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }
  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    const ie = new Df(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      const me = Z$1("li", {
        className: "vjs-menu-title",
        textContent: De$1(this.options_.title),
        tabIndex: -1
      }), we = new B(this.player_, {
        el: me
      });
      ie.addItem(we);
    }
    if (this.items = this.createItems(), this.items)
      for (let me = 0; me < this.items.length; me++)
        ie.addItem(this.items[me]);
    return ie;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */
  createItems() {
  }
  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }
  /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */
  setIcon(ie) {
    super.setIcon(ie, this.menuButton_.el_);
  }
  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    let ie = "vjs-menu-button";
    this.options_.inline === !0 ? ie += "-inline" : ie += "-popup";
    const me = ze.prototype.buildCSSClass();
    return `vjs-menu-button ${ie} ${me} ${super.buildCSSClass()}`;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    let ie = "vjs-menu-button";
    return this.options_.inline === !0 ? ie += "-inline" : ie += "-popup", `vjs-menu-button ${ie} ${super.buildCSSClass()}`;
  }
  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(ie, me = this.menuButton_.el()) {
    return this.menuButton_.controlText(ie, me);
  }
  /**
   * Dispose of the `menu-button` and all child components.
   */
  dispose() {
    this.handleMouseLeave(), super.dispose();
  }
  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }
  /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */
  handleMouseLeave(ie) {
    this.removeClass("vjs-hover"), He(V$1, "keyup", this.handleMenuKeyUp_);
  }
  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.menuButton_.focus();
  }
  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.menuButton_.blur();
  }
  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    ie.key === "Escape" || ie.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !ie.key === "Tab" && (ie.preventDefault(), this.menuButton_.focus())) : (ie.key === "Up" || ie.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (ie.preventDefault(), this.pressButton()));
  }
  /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */
  handleMenuKeyUp(ie) {
    (ie.key === "Escape" || ie.key === "Tab") && this.removeClass("vjs-hover");
  }
  /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */
  handleSubmenuKeyPress(ie) {
    this.handleSubmenuKeyDown(ie);
  }
  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */
  handleSubmenuKeyDown(ie) {
    (ie.key === "Escape" || ie.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !ie.key === "Tab" && (ie.preventDefault(), this.menuButton_.focus()));
  }
  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), Ve && Nh())
        return;
      this.menu.focus();
    }
  }
  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }
  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  disable() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }
  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */
  enable() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }
}
B.registerComponent("MenuButton", Yu);
class Qu extends Yu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    const we = me.tracks;
    if (super(ie, me), this.items.length <= 1 && this.hide(), !we)
      return;
    const Re = ve$1(this, this.update);
    we.addEventListener("removetrack", Re), we.addEventListener("addtrack", Re), we.addEventListener("labelchange", Re), this.player_.on("ready", Re), this.player_.on("dispose", function() {
      we.removeEventListener("removetrack", Re), we.removeEventListener("addtrack", Re), we.removeEventListener("labelchange", Re);
    });
  }
}
B.registerComponent("TrackButton", Qu);
class Kr extends Na {
  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  constructor(ie, me) {
    super(ie, me), this.selectable = me.selectable, this.isSelected_ = me.selected || !1, this.multiSelectable = me.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
  }
  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(ie, me, we) {
    this.nonIconControl = !0;
    const Re = super.createEl("li", Object.assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, me), we), je = Z$1("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    });
    return this.player_.options_.experimentalSvgIcons ? Re.appendChild(je) : Re.replaceChild(je, Re.querySelector(".vjs-icon-placeholder")), Re;
  }
  /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    ["Tab", "Escape", "ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(ie.key) || super.handleKeyDown(ie);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.selected(!0);
  }
  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */
  selected(ie) {
    this.selectable && (ie ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }
}
B.registerComponent("MenuItem", Kr);
class Yr extends Kr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    const we = me.track, Re = ie.textTracks();
    me.label = we.label || we.language || "Unknown", me.selected = we.mode === "showing", super(ie, me), this.track = we, this.kinds = (me.kinds || [me.kind || this.track.kind]).filter(Boolean);
    const je = (...qe) => {
      this.handleTracksChange.apply(this, qe);
    }, Ue = (...qe) => {
      this.handleSelectedLanguageChange.apply(this, qe);
    };
    if (ie.on(["loadstart", "texttrackchange"], je), Re.addEventListener("change", je), Re.addEventListener("selectedlanguagechange", Ue), this.on("dispose", function() {
      ie.off(["loadstart", "texttrackchange"], je), Re.removeEventListener("change", je), Re.removeEventListener("selectedlanguagechange", Ue);
    }), Re.onchange === void 0) {
      let qe;
      this.on(["tap", "click"], function() {
        if (typeof S.Event != "object")
          try {
            qe = new S.Event("change");
          } catch {
          }
        qe || (qe = V$1.createEvent("Event"), qe.initEvent("change", !0, !0)), Re.dispatchEvent(qe);
      });
    }
    this.handleTracksChange();
  }
  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    const me = this.track, we = this.player_.textTracks();
    if (super.handleClick(ie), !!we)
      for (let Re = 0; Re < we.length; Re++) {
        const je = we[Re];
        this.kinds.indexOf(je.kind) !== -1 && (je === me ? je.mode !== "showing" && (je.mode = "showing") : je.mode !== "disabled" && (je.mode = "disabled"));
      }
  }
  /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(ie) {
    const me = this.track.mode === "showing";
    me !== this.isSelected_ && this.selected(me);
  }
  handleSelectedLanguageChange(ie) {
    if (this.track.mode === "showing") {
      const me = this.player_.cache_.selectedLanguage;
      if (me && me.enabled && me.language === this.track.language && me.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }
  dispose() {
    this.track = null, super.dispose();
  }
}
B.registerComponent("TextTrackMenuItem", Yr);
class wf extends Yr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    me.track = {
      player: ie,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: me.kind,
      kinds: me.kinds,
      default: !1,
      mode: "disabled"
    }, me.kinds || (me.kinds = [me.kind]), me.label ? me.track.label = me.label : me.track.label = me.kinds.join(" and ") + " off", me.selectable = !0, me.multiSelectable = !1, super(ie, me);
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */
  handleTracksChange(ie) {
    const me = this.player().textTracks();
    let we = !0;
    for (let Re = 0, je = me.length; Re < je; Re++) {
      const Ue = me[Re];
      if (this.options_.kinds.indexOf(Ue.kind) > -1 && Ue.mode === "showing") {
        we = !1;
        break;
      }
    }
    we !== this.isSelected_ && this.selected(we);
  }
  handleSelectedLanguageChange(ie) {
    const me = this.player().textTracks();
    let we = !0;
    for (let Re = 0, je = me.length; Re < je; Re++) {
      const Ue = me[Re];
      if (["captions", "descriptions", "subtitles"].indexOf(Ue.kind) > -1 && Ue.mode === "showing") {
        we = !1;
        break;
      }
    }
    we && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
  }
}
B.registerComponent("OffTextTrackMenuItem", wf);
class Ls extends Qu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    me.tracks = ie.textTracks(), super(ie, me);
  }
  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */
  createItems(ie = [], me = Yr) {
    let we;
    this.label_ && (we = `${this.label_} off`), ie.push(new wf(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: we
    })), this.hideThreshold_ += 1;
    const Re = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (let je = 0; je < Re.length; je++) {
      const Ue = Re[je];
      if (this.kinds_.indexOf(Ue.kind) > -1) {
        const qe = new me(this.player_, {
          track: Ue,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        qe.addClass(`vjs-${Ue.kind}-menu-item`), ie.push(qe);
      }
    }
    return ie;
  }
}
B.registerComponent("TextTrackButton", Ls);
class kf extends Kr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    const we = me.track, Re = me.cue, je = ie.currentTime();
    me.selectable = !0, me.multiSelectable = !1, me.label = Re.text, me.selected = Re.startTime <= je && je < Re.endTime, super(ie, me), this.track = we, this.cue = Re;
  }
  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    super.handleClick(), this.player_.currentTime(this.cue.startTime);
  }
}
B.registerComponent("ChaptersTrackMenuItem", kf);
class Ju extends Ls {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */
  constructor(ie, me, we) {
    super(ie, me, we), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
      this.items.forEach((Re) => {
        Re.selected(this.track_.activeCues[0] === Re.cue);
      });
    };
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-chapters-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */
  update(ie) {
    if (ie && ie.track && ie.track.kind !== "chapters")
      return;
    const me = this.findChaptersTrack();
    me !== this.track_ ? (this.setTrack(me), super.update()) : (!this.items || me && me.cues && me.cues.length !== this.items.length) && super.update();
  }
  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */
  setTrack(ie) {
    if (this.track_ !== ie) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        const me = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        me && me.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = ie, this.track_) {
        this.track_.mode = "hidden";
        const me = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        me && me.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }
  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */
  findChaptersTrack() {
    const ie = this.player_.textTracks() || [];
    for (let me = ie.length - 1; me >= 0; me--) {
      const we = ie[me];
      if (we.kind === this.kind_)
        return we;
    }
  }
  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */
  getMenuCaption() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(De$1(this.kind_));
  }
  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */
  createMenu() {
    return this.options_.title = this.getMenuCaption(), super.createMenu();
  }
  /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */
  createItems() {
    const ie = [];
    if (!this.track_)
      return ie;
    const me = this.track_.cues;
    if (!me)
      return ie;
    for (let we = 0, Re = me.length; we < Re; we++) {
      const je = me[we], Ue = new kf(this.player_, {
        track: this.track_,
        cue: je
      });
      ie.push(Ue);
    }
    return ie;
  }
}
Ju.prototype.kind_ = "chapters";
Ju.prototype.controlText_ = "Chapters";
B.registerComponent("ChaptersButton", Ju);
class Zu extends Ls {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(ie, me, we) {
    super(ie, me, we), this.setIcon("audio-description");
    const Re = ie.textTracks(), je = ve$1(this, this.handleTracksChange);
    Re.addEventListener("change", je), this.on("dispose", function() {
      Re.removeEventListener("change", je);
    });
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(ie) {
    const me = this.player().textTracks();
    let we = !1;
    for (let Re = 0, je = me.length; Re < je; Re++) {
      const Ue = me[Re];
      if (Ue.kind !== this.kind_ && Ue.mode === "showing") {
        we = !0;
        break;
      }
    }
    we ? this.disable() : this.enable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-descriptions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
  }
}
Zu.prototype.kind_ = "descriptions";
Zu.prototype.controlText_ = "Descriptions";
B.registerComponent("DescriptionsButton", Zu);
class el extends Ls {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(ie, me, we) {
    super(ie, me, we), this.setIcon("subtitles");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subtitles-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
  }
}
el.prototype.kind_ = "subtitles";
el.prototype.controlText_ = "Subtitles";
B.registerComponent("SubtitlesButton", el);
class tl extends Yr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    me.track = {
      player: ie,
      kind: me.kind,
      label: me.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, me.selectable = !1, me.name = "CaptionSettingsMenuItem", super(ie, me), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + me.kind + " settings dialog");
  }
  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    this.player().getChild("textTrackSettings").open();
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
  }
}
B.registerComponent("CaptionSettingsMenuItem", tl);
class il extends Ls {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(ie, me, we) {
    super(ie, me, we), this.setIcon("captions");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-captions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    const ie = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (ie.push(new tl(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), super.createItems(ie);
  }
}
il.prototype.kind_ = "captions";
il.prototype.controlText_ = "Captions";
B.registerComponent("CaptionsButton", il);
class If extends Yr {
  createEl(ie, me, we) {
    const Re = super.createEl(ie, me, we), je = Re.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", Re) : je.appendChild(Z$1("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), je.appendChild(Z$1("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: ` ${this.localize("Captions")}`
    }))), Re;
  }
}
B.registerComponent("SubsCapsMenuItem", If);
class sl extends Ls {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(ie, me = {}) {
    super(ie, me), this.label_ = "subtitles", this.setIcon("subtitles"), ["en", "en-us", "en-ca", "fr-ca"].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(De$1(this.label_));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subs-caps-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    let ie = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (ie.push(new tl(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), ie = super.createItems(ie, If), ie;
  }
}
sl.prototype.kinds_ = ["captions", "subtitles"];
sl.prototype.controlText_ = "Subtitles";
B.registerComponent("SubsCapsButton", sl);
class Pf extends Kr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    const we = me.track, Re = ie.audioTracks();
    me.label = we.label || we.language || "Unknown", me.selected = we.enabled, super(ie, me), this.track = we, this.addClass(`vjs-${we.kind}-menu-item`);
    const je = (...Ue) => {
      this.handleTracksChange.apply(this, Ue);
    };
    Re.addEventListener("change", je), this.on("dispose", () => {
      Re.removeEventListener("change", je);
    });
  }
  createEl(ie, me, we) {
    const Re = super.createEl(ie, me, we), je = Re.querySelector(".vjs-menu-item-text");
    return ["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0 && (je.appendChild(Z$1("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), je.appendChild(Z$1("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), Re;
  }
  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    if (super.handleClick(ie), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
      const me = this.player_.audioTracks();
      for (let we = 0; we < me.length; we++) {
        const Re = me[we];
        Re !== this.track && (Re.enabled = Re === this.track);
      }
    }
  }
  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */
  handleTracksChange(ie) {
    this.selected(this.track.enabled);
  }
}
B.registerComponent("AudioTrackMenuItem", Pf);
class Of extends Qu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(ie, me = {}) {
    me.tracks = ie.audioTracks(), super(ie, me), this.setIcon("audio");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-audio-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */
  createItems(ie = []) {
    this.hideThreshold_ = 1;
    const me = this.player_.audioTracks();
    for (let we = 0; we < me.length; we++) {
      const Re = me[we];
      ie.push(new Pf(this.player_, {
        track: Re,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return ie;
  }
}
Of.prototype.controlText_ = "Audio Track";
B.registerComponent("AudioTrackButton", Of);
class rl extends Kr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    const we = me.rate, Re = parseFloat(we, 10);
    me.label = we, me.selected = Re === ie.playbackRate(), me.selectable = !0, me.multiSelectable = !1, super(ie, me), this.label = we, this.rate = Re, this.on(ie, "ratechange", (je) => this.update(je));
  }
  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(ie) {
    super.handleClick(), this.player().playbackRate(this.rate);
  }
  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  update(ie) {
    this.selected(this.player().playbackRate() === this.rate);
  }
}
rl.prototype.contentElType = "button";
B.registerComponent("PlaybackRateMenuItem", rl);
class Lf extends Yu {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(ie, "loadstart", (we) => this.updateVisibility(we)), this.on(ie, "ratechange", (we) => this.updateLabel(we)), this.on(ie, "playbackrateschange", (we) => this.handlePlaybackRateschange(we));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const ie = super.createEl();
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = Z$1("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), ie.appendChild(this.labelEl_), ie;
  }
  dispose() {
    this.labelEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-playback-rate ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   */
  createItems() {
    const ie = this.playbackRates(), me = [];
    for (let we = ie.length - 1; we >= 0; we--)
      me.push(new rl(this.player(), {
        rate: ie[we] + "x"
      }));
    return me;
  }
  /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */
  handlePlaybackRateschange(ie) {
    this.update();
  }
  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */
  playbackRates() {
    const ie = this.player();
    return ie.playbackRates && ie.playbackRates() || [];
  }
  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */
  playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }
  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */
  updateVisibility(ie) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }
  /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  updateLabel(ie) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }
}
Lf.prototype.controlText_ = "Playback Rate";
B.registerComponent("PlaybackRateMenuButton", Lf);
class Rf extends B {
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl(ie = "div", me = {}, we = {}) {
    return me.className || (me.className = this.buildCSSClass()), super.createEl(ie, me, we);
  }
}
B.registerComponent("Spacer", Rf);
class YT extends Rf {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }
}
B.registerComponent("CustomControlSpacer", YT);
class Mf extends B {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }
}
Mf.prototype.options_ = {
  children: ["playToggle", "skipBackward", "skipForward", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "pictureInPictureToggle", "fullscreenToggle"]
};
B.registerComponent("ControlBar", Mf);
class Nf extends Ps {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  constructor(ie, me) {
    super(ie, me), this.on(ie, "error", (we) => {
      this.open(we);
    });
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */
  buildCSSClass() {
    return `vjs-error-display ${super.buildCSSClass()}`;
  }
  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */
  content() {
    const ie = this.player().error();
    return ie ? this.localize(ie.message) : "";
  }
}
Nf.prototype.options_ = Object.assign({}, Ps.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
B.registerComponent("ErrorDisplay", Nf);
class Bf extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */
  constructor(ie, me = {}) {
    super(ie, me), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
  }
  /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), Z$1("select", {
      id: this.options_.id
    }, {}, this.options_.SelectOptions.map((ie) => {
      const me = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${gt()}`) + "-" + ie[1].replace(/\W+/g, ""), we = Z$1("option", {
        id: me,
        value: this.localize(ie[0]),
        textContent: this.localize(ie[1])
      });
      return we.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${me}`), we;
    }));
  }
}
B.registerComponent("TextTrackSelect", Bf);
class Oi extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */
  constructor(ie, me = {}) {
    super(ie, me);
    const we = Z$1("legend", {
      textContent: this.localize(this.options_.legendText),
      id: this.options_.legendId
    });
    this.el().appendChild(we);
    const Re = this.options_.selects;
    for (const je of Re) {
      const Ue = this.options_.selectConfigs[je], qe = Ue.className, Ge = Ue.id.replace("%s", this.options_.id_);
      let Xe = null;
      const ot = `vjs_select_${gt()}`;
      if (this.options_.type === "colors") {
        Xe = Z$1("span", {
          className: qe
        });
        const bt = Z$1("label", {
          id: Ge,
          className: "vjs-label",
          textContent: this.localize(Ue.label)
        });
        bt.setAttribute("for", ot), Xe.appendChild(bt);
      }
      const vt = new Bf(ie, {
        SelectOptions: Ue.options,
        legendId: this.options_.legendId,
        id: ot,
        labelId: Ge
      });
      this.addChild(vt), this.options_.type === "colors" && (Xe.appendChild(vt.el()), this.el().appendChild(Xe));
    }
  }
  /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Z$1("fieldset", {
      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: this.options_.className
    });
  }
}
B.registerComponent("TextTrackFieldset", Oi);
class Ff extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(ie, me = {}) {
    super(ie, me);
    const we = this.options_.textTrackComponentid, Re = new Oi(ie, {
      id_: we,
      legendId: `captions-text-legend-${we}`,
      legendText: this.localize("Text"),
      className: "vjs-fg vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(Re);
    const je = new Oi(ie, {
      id_: we,
      legendId: `captions-background-${we}`,
      legendText: this.localize("Text Background"),
      className: "vjs-bg vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(je);
    const Ue = new Oi(ie, {
      id_: we,
      legendId: `captions-window-${we}`,
      legendText: this.localize("Caption Area Background"),
      className: "vjs-window vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(Ue);
  }
  /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Z$1("div", {
      className: "vjs-track-settings-colors"
    });
  }
}
B.registerComponent("TextTrackSettingsColors", Ff);
class Uf extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(ie, me = {}) {
    super(ie, me);
    const we = this.options_.textTrackComponentid, Re = new Oi(ie, {
      id_: we,
      legendId: `captions-font-size-${we}`,
      legendText: "Font Size",
      className: "vjs-font-percent vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(Re);
    const je = new Oi(ie, {
      id_: we,
      legendId: `captions-edge-style-${we}`,
      legendText: this.localize("Text Edge Style"),
      className: "vjs-edge-style vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(je);
    const Ue = new Oi(ie, {
      id_: we,
      legendId: `captions-font-family-${we}`,
      legendText: this.localize("Font Family"),
      className: "vjs-font-family vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(Ue);
  }
  /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Z$1("div", {
      className: "vjs-track-settings-font"
    });
  }
}
B.registerComponent("TextTrackSettingsFont", Uf);
class $f extends B {
  constructor(ie, me = {}) {
    super(ie, me);
    const we = new ze(ie, {
      controlText: this.localize("restore all settings to the default values"),
      className: "vjs-default-button"
    });
    we.el().classList.remove("vjs-control", "vjs-button"), we.el().textContent = this.localize("Reset"), this.addChild(we);
    const Re = this.localize("Done"), je = new ze(ie, {
      controlText: Re,
      className: "vjs-done-button"
    });
    je.el().classList.remove("vjs-control", "vjs-button"), je.el().textContent = Re, this.addChild(je);
  }
  /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Z$1("div", {
      className: "vjs-track-settings-controls"
    });
  }
}
B.registerComponent("TrackSettingsControls", $f);
const wo = "vjs-text-track-settings", Yc = ["#000", "Black"], Qc = ["#00F", "Blue"], Jc = ["#0FF", "Cyan"], Zc = ["#0F0", "Green"], ed = ["#F0F", "Magenta"], td = ["#F00", "Red"], id = ["#FFF", "White"], sd = ["#FF0", "Yellow"], ko = ["1", "Opaque"], Io = ["0.5", "Semi-Transparent"], rd = ["0", "Transparent"], fi = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [Yc, id, td, Zc, Qc, sd, ed, Jc],
    className: "vjs-bg-color"
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Opacity",
    options: [ko, Io, rd],
    className: "vjs-bg-opacity vjs-opacity"
  },
  color: {
    selector: ".vjs-text-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [id, Yc, td, Zc, Qc, sd, ed, Jc],
    className: "vjs-text-color"
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Drop shadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: (ce) => ce === "1.00" ? null : Number(ce)
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Opacity",
    options: [ko, Io],
    className: "vjs-text-opacity vjs-opacity"
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color",
    className: "vjs-window-color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Opacity",
    options: [rd, Io, ko],
    className: "vjs-window-opacity vjs-opacity"
  }
};
fi.windowColor.options = fi.backgroundColor.options;
function jf(ce, ie) {
  if (ie && (ce = ie(ce)), ce && ce !== "none")
    return ce;
}
function QT(ce, ie) {
  const me = ce.options[ce.options.selectedIndex].value;
  return jf(me, ie);
}
function JT(ce, ie, me) {
  if (ie) {
    for (let we = 0; we < ce.options.length; we++)
      if (jf(ce.options[we].value, me) === ie) {
        ce.selectedIndex = we;
        break;
      }
  }
}
class ZT extends Ps {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  constructor(ie, me) {
    me.temporary = !1, super(ie, me), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(ie), this.endDialog = Z$1("p", {
      className: "vjs-control-text",
      textContent: this.localize("End of dialog window.")
    }), this.el().appendChild(this.endDialog), this.setDefaults(), me.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
  }
  renderModalComponents(ie) {
    const me = new Ff(ie, {
      textTrackComponentid: this.id_,
      selectConfigs: fi,
      fieldSets: [["color", "textOpacity"], ["backgroundColor", "backgroundOpacity"], ["windowColor", "windowOpacity"]]
    });
    this.addChild(me);
    const we = new Uf(ie, {
      textTrackComponentid: this.id_,
      selectConfigs: fi,
      fieldSets: [["fontPercent"], ["edgeStyle"], ["fontFamily"]]
    });
    this.addChild(we);
    const Re = new $f(ie);
    this.addChild(Re);
  }
  bindFunctionsToSelectsAndButtons() {
    this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
      this.saveSettings(), this.close();
    }), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
      this.setDefaults(), this.updateDisplay();
    }), as(fi, (ie) => {
      this.on(this.$(ie.selector), "change", this.updateDisplay);
    });
  }
  dispose() {
    this.endDialog = null, super.dispose();
  }
  label() {
    return this.localize("Caption Settings Dialog");
  }
  description() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }
  buildCSSClass() {
    return super.buildCSSClass() + " vjs-text-track-settings";
  }
  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */
  getValues() {
    return kh(fi, (ie, me, we) => {
      const Re = QT(this.$(me.selector), me.parser);
      return Re !== void 0 && (ie[we] = Re), ie;
    }, {});
  }
  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */
  setValues(ie) {
    as(fi, (me, we) => {
      JT(this.$(me.selector), ie[we], me.parser);
    });
  }
  /**
   * Sets all `<select>` elements to their default values.
   */
  setDefaults() {
    as(fi, (ie) => {
      const me = ie.hasOwnProperty("default") ? ie.default : 0;
      this.$(ie.selector).selectedIndex = me;
    });
  }
  /**
   * Restore texttrack settings from localStorage
   */
  restoreSettings() {
    let ie;
    try {
      ie = JSON.parse(S.localStorage.getItem(wo));
    } catch (me) {
      ae.warn(me);
    }
    ie && this.setValues(ie);
  }
  /**
   * Save text track settings to localStorage
   */
  saveSettings() {
    if (!this.options_.persistTextTrackSettings)
      return;
    const ie = this.getValues();
    try {
      Object.keys(ie).length ? S.localStorage.setItem(wo, JSON.stringify(ie)) : S.localStorage.removeItem(wo);
    } catch (me) {
      ae.warn(me);
    }
  }
  /**
   * Update display of text track settings
   */
  updateDisplay() {
    const ie = this.player_.getChild("textTrackDisplay");
    ie && ie.updateDisplay();
  }
  /**
   * Repopulate dialog with new localizations on languagechange
   */
  handleLanguagechange() {
    this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
  }
}
B.registerComponent("TextTrackSettings", ZT);
class ev extends B {
  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  constructor(ie, me) {
    let we = me.ResizeObserver || S.ResizeObserver;
    me.ResizeObserver === null && (we = !1);
    const Re = ye$2({
      createEl: !we,
      reportTouchActivity: !1
    }, me);
    super(ie, Re), this.ResizeObserver = me.ResizeObserver || S.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = Jh(() => {
      this.resizeHandler();
    }, 100, !1, this), we ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(ie.el())) : (this.loadListener_ = () => {
      if (!this.el_ || !this.el_.contentWindow)
        return;
      const je = this.debouncedHandler_;
      let Ue = this.unloadListener_ = function() {
        He(this, "resize", je), He(this, "unload", Ue), Ue = null;
      };
      dt(this.el_.contentWindow, "unload", Ue), dt(this.el_.contentWindow, "resize", je);
    }, this.one("load", this.loadListener_));
  }
  createEl() {
    return super.createEl("iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */
  resizeHandler() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }
  dispose() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
  }
}
B.registerComponent("ResizeManager", ev);
const tv = {
  trackingThreshold: 20,
  liveTolerance: 15
};
class iv extends B {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */
  constructor(ie, me) {
    const we = ye$2(tv, me, {
      createEl: !1
    });
    super(ie, we), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (Re) => this.handlePlay(Re), this.handleFirstTimeupdate_ = (Re) => this.handleFirstTimeupdate(Re), this.handleSeeked_ = (Re) => this.handleSeeked(Re), this.seekToLiveEdge_ = (Re) => this.seekToLiveEdge(Re), this.reset_(), this.on(this.player_, "durationchange", (Re) => this.handleDurationchange(Re)), this.on(this.player_, "canplay", () => this.toggleTracking());
  }
  /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */
  trackLive_() {
    const ie = this.player_.seekable();
    if (!ie || !ie.length)
      return;
    const me = Number(S.performance.now().toFixed(4)), we = this.lastTime_ === -1 ? 0 : (me - this.lastTime_) / 1e3;
    this.lastTime_ = me, this.pastSeekEnd_ = this.pastSeekEnd() + we;
    const Re = this.liveCurrentTime(), je = this.player_.currentTime();
    let Ue = this.player_.paused() || this.seekedBehindLive_ || Math.abs(Re - je) > this.options_.liveTolerance;
    (!this.timeupdateSeen_ || Re === 1 / 0) && (Ue = !1), Ue !== this.behindLiveEdge_ && (this.behindLiveEdge_ = Ue, this.trigger("liveedgechange"));
  }
  /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */
  handleDurationchange() {
    this.toggleTracking();
  }
  /**
   * start/stop tracking
   */
  toggleTracking() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }
  /**
   * start tracking live playback
   */
  startTracking() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, _t), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }
  /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */
  handleFirstTimeupdate() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }
  /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */
  handleSeeked() {
    const ie = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && ie > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }
  /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */
  handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */
  reset_() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */
  nextSeekedFromUser() {
    this.nextSeekedFromUser_ = !0;
  }
  /**
   * stop tracking live playback
   */
  stopTracking() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }
  /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */
  seekableEnd() {
    const ie = this.player_.seekable(), me = [];
    let we = ie ? ie.length : 0;
    for (; we--; )
      me.push(ie.end(we));
    return me.length ? me.sort()[me.length - 1] : 1 / 0;
  }
  /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */
  seekableStart() {
    const ie = this.player_.seekable(), me = [];
    let we = ie ? ie.length : 0;
    for (; we--; )
      me.push(ie.start(we));
    return me.length ? me.sort()[0] : 0;
  }
  /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */
  liveWindow() {
    const ie = this.liveCurrentTime();
    return ie === 1 / 0 ? 0 : ie - this.seekableStart();
  }
  /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */
  isLive() {
    return this.isTracking();
  }
  /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */
  atLiveEdge() {
    return !this.behindLiveEdge();
  }
  /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */
  liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  }
  /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */
  pastSeekEnd() {
    const ie = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && ie !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = ie, this.pastSeekEnd_;
  }
  /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */
  behindLiveEdge() {
    return this.behindLiveEdge_;
  }
  /**
   * Whether live tracker is currently tracking or not.
   */
  isTracking() {
    return typeof this.trackingInterval_ == "number";
  }
  /**
   * Seek to the live edge if we are behind the live edge
   */
  seekToLiveEdge() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }
  /**
   * Dispose of liveTracker
   */
  dispose() {
    this.stopTracking(), super.dispose();
  }
}
B.registerComponent("LiveTracker", iv);
class sv extends B {
  constructor(ie, me) {
    super(ie, me), this.on("statechanged", (we) => this.updateDom_()), this.updateDom_();
  }
  /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return this.els = {
      title: Z$1("div", {
        className: "vjs-title-bar-title",
        id: `vjs-title-bar-title-${gt()}`
      }),
      description: Z$1("div", {
        className: "vjs-title-bar-description",
        id: `vjs-title-bar-description-${gt()}`
      })
    }, Z$1("div", {
      className: "vjs-title-bar"
    }, {}, Ih(this.els));
  }
  /**
   * Updates the DOM based on the component's state object.
   */
  updateDom_() {
    const ie = this.player_.tech_, me = ie && ie.el_, we = {
      title: "aria-labelledby",
      description: "aria-describedby"
    };
    ["title", "description"].forEach((Re) => {
      const je = this.state[Re], Ue = this.els[Re], qe = we[Re];
      Pa(Ue), je && _i(Ue, je), me && (me.removeAttribute(qe), je && me.setAttribute(qe, Ue.id));
    }), this.state.title || this.state.description ? this.show() : this.hide();
  }
  /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */
  update(ie) {
    this.setState(ie);
  }
  /**
   * Dispose the component.
   */
  dispose() {
    const ie = this.player_.tech_, me = ie && ie.el_;
    me && (me.removeAttribute("aria-labelledby"), me.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
  }
}
B.registerComponent("TitleBar", sv);
const rv = {
  initialDisplay: 4e3,
  position: [],
  takeFocus: !1
};
class nv extends ze {
  /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */
  constructor(ie, me) {
    me = ye$2(rv, me), super(ie, me), this.controlText(me.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (we) => {
      this.removeClass("force-display");
    });
  }
  /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */
  buildCSSClass() {
    return `vjs-transient-button focus-visible ${this.options_.position.map((ie) => `vjs-${ie}`).join(" ")}`;
  }
  /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */
  createEl() {
    const ie = Z$1("button", {}, {
      type: "button",
      class: this.buildCSSClass()
    }, Z$1("span"));
    return this.controlTextEl_ = ie.querySelector("span"), ie;
  }
  /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */
  show() {
    super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({
      preventScroll: !0
    }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
      this.removeClass("force-display");
    }, this.options_.initialDisplay);
  }
  /**
   * Hide the display, even if during the `initialDisplay` time.
   */
  hide() {
    this.removeClass("force-display"), super.hide();
  }
  /**
   * Dispose the component
   */
  dispose() {
    this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
  }
}
B.registerComponent("TransientButton", nv);
const Zo = (ce) => {
  const ie = ce.el();
  if (ie.hasAttribute("src"))
    return ce.triggerSourceset(ie.src), !0;
  const me = ce.$$("source"), we = [];
  let Re = "";
  if (!me.length)
    return !1;
  for (let je = 0; je < me.length; je++) {
    const Ue = me[je].src;
    Ue && we.indexOf(Ue) === -1 && we.push(Ue);
  }
  return we.length ? (we.length === 1 && (Re = we[0]), ce.triggerSourceset(Re), !0) : !1;
}, av = Object.defineProperty({}, "innerHTML", {
  get() {
    return this.cloneNode(!0).innerHTML;
  },
  set(ce) {
    const ie = V$1.createElement(this.nodeName.toLowerCase());
    ie.innerHTML = ce;
    const me = V$1.createDocumentFragment();
    for (; ie.childNodes.length; )
      me.appendChild(ie.childNodes[0]);
    return this.innerText = "", S.Element.prototype.appendChild.call(this, me), this.innerHTML;
  }
}), qf = (ce, ie) => {
  let me = {};
  for (let we = 0; we < ce.length && (me = Object.getOwnPropertyDescriptor(ce[we], ie), !(me && me.set && me.get)); we++)
    ;
  return me.enumerable = !0, me.configurable = !0, me;
}, ov = (ce) => qf([ce.el(), S.HTMLMediaElement.prototype, S.Element.prototype, av], "innerHTML"), nd = function(ce) {
  const ie = ce.el();
  if (ie.resetSourceWatch_)
    return;
  const me = {}, we = ov(ce), Re = (je) => (...Ue) => {
    const qe = je.apply(ie, Ue);
    return Zo(ce), qe;
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach((je) => {
    ie[je] && (me[je] = ie[je], ie[je] = Re(me[je]));
  }), Object.defineProperty(ie, "innerHTML", ye$2(we, {
    set: Re(we.set)
  })), ie.resetSourceWatch_ = () => {
    ie.resetSourceWatch_ = null, Object.keys(me).forEach((je) => {
      ie[je] = me[je];
    }), Object.defineProperty(ie, "innerHTML", we);
  }, ce.one("sourceset", ie.resetSourceWatch_);
}, uv = Object.defineProperty({}, "src", {
  get() {
    return this.hasAttribute("src") ? cf(S.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set(ce) {
    return S.Element.prototype.setAttribute.call(this, "src", ce), ce;
  }
}), lv = (ce) => qf([ce.el(), S.HTMLMediaElement.prototype, uv], "src"), cv = function(ce) {
  if (!ce.featuresSourceset)
    return;
  const ie = ce.el();
  if (ie.resetSourceset_)
    return;
  const me = lv(ce), we = ie.setAttribute, Re = ie.load;
  Object.defineProperty(ie, "src", ye$2(me, {
    set: (je) => {
      const Ue = me.set.call(ie, je);
      return ce.triggerSourceset(ie.src), Ue;
    }
  })), ie.setAttribute = (je, Ue) => {
    const qe = we.call(ie, je, Ue);
    return /src/i.test(je) && ce.triggerSourceset(ie.src), qe;
  }, ie.load = () => {
    const je = Re.call(ie);
    return Zo(ce) || (ce.triggerSourceset(""), nd(ce)), je;
  }, ie.currentSrc ? ce.triggerSourceset(ie.currentSrc) : Zo(ce) || nd(ce), ie.resetSourceset_ = () => {
    ie.resetSourceset_ = null, ie.load = Re, ie.setAttribute = we, Object.defineProperty(ie, "src", me), ie.resetSourceWatch_ && ie.resetSourceWatch_();
  };
};
let W$1 = class Ux extends te {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(ie, me) {
    super(ie, me);
    const we = ie.source;
    let Re = !1;
    if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", we && (this.el_.currentSrc !== we.src || ie.tag && ie.tag.initNetworkState_ === 3) ? this.setSource(we) : this.handleLateInit_(this.el_), ie.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
      const je = this.el_.childNodes;
      let Ue = je.length;
      const qe = [];
      for (; Ue--; ) {
        const Ge = je[Ue];
        Ge.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(Ge), this.remoteTextTracks().addTrack(Ge.track), this.textTracks().addTrack(Ge.track), !Re && !this.el_.hasAttribute("crossorigin") && Ma(Ge.src) && (Re = !0)) : qe.push(Ge));
      }
      for (let Ge = 0; Ge < qe.length; Ge++)
        this.el_.removeChild(qe[Ge]);
    }
    this.proxyNativeTracks_(), this.featuresNativeTextTracks && Re && ae.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), this.restoreMetadataTracksInIOSNativePlayer_(), (Br || Aa) && ie.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
  }
  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */
  dispose() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), Ux.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
  }
  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */
  setupSourcesetHandling_() {
    cv(this);
  }
  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */
  restoreMetadataTracksInIOSNativePlayer_() {
    const ie = this.textTracks();
    let me;
    const we = () => {
      me = [];
      for (let je = 0; je < ie.length; je++) {
        const Ue = ie[je];
        Ue.kind === "metadata" && me.push({
          track: Ue,
          storedMode: Ue.mode
        });
      }
    };
    we(), ie.addEventListener("change", we), this.on("dispose", () => ie.removeEventListener("change", we));
    const Re = () => {
      for (let je = 0; je < me.length; je++) {
        const Ue = me[je];
        Ue.track.mode === "disabled" && Ue.track.mode !== Ue.storedMode && (Ue.track.mode = Ue.storedMode);
      }
      ie.removeEventListener("change", Re);
    };
    this.on("webkitbeginfullscreen", () => {
      ie.removeEventListener("change", we), ie.removeEventListener("change", Re), ie.addEventListener("change", Re);
    }), this.on("webkitendfullscreen", () => {
      ie.removeEventListener("change", we), ie.addEventListener("change", we), ie.removeEventListener("change", Re);
    });
  }
  /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */
  overrideNative_(ie, me) {
    if (me !== this[`featuresNative${ie}Tracks`])
      return;
    const we = ie.toLowerCase();
    this[`${we}TracksListeners_`] && Object.keys(this[`${we}TracksListeners_`]).forEach((Re) => {
      this.el()[`${we}Tracks`].removeEventListener(Re, this[`${we}TracksListeners_`][Re]);
    }), this[`featuresNative${ie}Tracks`] = !me, this[`${we}TracksListeners_`] = null, this.proxyNativeTracksForType_(we);
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */
  overrideNativeAudioTracks(ie) {
    this.overrideNative_("Audio", ie);
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */
  overrideNativeVideoTracks(ie) {
    this.overrideNative_("Video", ie);
  }
  /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */
  proxyNativeTracksForType_(ie) {
    const me = mt[ie], we = this.el()[me.getterName], Re = this[me.getterName]();
    if (!this[`featuresNative${me.capitalName}Tracks`] || !we || !we.addEventListener)
      return;
    const je = {
      change: (qe) => {
        const Ge = {
          type: "change",
          target: Re,
          currentTarget: Re,
          srcElement: Re
        };
        Re.trigger(Ge), ie === "text" && this[As.remoteText.getterName]().trigger(Ge);
      },
      addtrack(qe) {
        Re.addTrack(qe.track);
      },
      removetrack(qe) {
        Re.removeTrack(qe.track);
      }
    }, Ue = function() {
      const qe = [];
      for (let Ge = 0; Ge < Re.length; Ge++) {
        let Xe = !1;
        for (let ot = 0; ot < we.length; ot++)
          if (we[ot] === Re[Ge]) {
            Xe = !0;
            break;
          }
        Xe || qe.push(Re[Ge]);
      }
      for (; qe.length; )
        Re.removeTrack(qe.shift());
    };
    this[me.getterName + "Listeners_"] = je, Object.keys(je).forEach((qe) => {
      const Ge = je[qe];
      we.addEventListener(qe, Ge), this.on("dispose", (Xe) => we.removeEventListener(qe, Ge));
    }), this.on("loadstart", Ue), this.on("dispose", (qe) => this.off("loadstart", Ue));
  }
  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */
  proxyNativeTracks_() {
    mt.names.forEach((ie) => {
      this.proxyNativeTracksForType_(ie);
    });
  }
  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    let ie = this.options_.tag;
    if (!ie || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (ie) {
        const we = ie.cloneNode(!0);
        ie.parentNode && ie.parentNode.insertBefore(we, ie), Ux.disposeMediaElement(ie), ie = we;
      } else {
        ie = V$1.createElement("video");
        const we = this.options_.tag && hi(this.options_.tag), Re = ye$2({}, we);
        (!Br || this.options_.nativeControlsForTouch !== !0) && delete Re.controls, Uh(ie, Object.assign(Re, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      ie.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && Ss(ie, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (ie.disablePictureInPicture = this.options_.disablePictureInPicture);
    const me = ["loop", "muted", "playsinline", "autoplay"];
    for (let we = 0; we < me.length; we++) {
      const Re = me[we], je = this.options_[Re];
      typeof je < "u" && (je ? Ss(ie, Re, Re) : ka(ie, Re), ie[Re] = je);
    }
    return ie;
  }
  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */
  handleLateInit_(ie) {
    if (ie.networkState === 0 || ie.networkState === 3)
      return;
    if (ie.readyState === 0) {
      let we = !1;
      const Re = function() {
        we = !0;
      };
      this.on("loadstart", Re);
      const je = function() {
        we || this.trigger("loadstart");
      };
      this.on("loadedmetadata", je), this.ready(function() {
        this.off("loadstart", Re), this.off("loadedmetadata", je), we || this.trigger("loadstart");
      });
      return;
    }
    const me = ["loadstart"];
    me.push("loadedmetadata"), ie.readyState >= 2 && me.push("loadeddata"), ie.readyState >= 3 && me.push("canplay"), ie.readyState >= 4 && me.push("canplaythrough"), this.ready(function() {
      me.forEach(function(we) {
        this.trigger(we);
      }, this);
    });
  }
  /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  setScrubbing(ie) {
    this.isScrubbing_ = ie;
  }
  /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  scrubbing() {
    return this.isScrubbing_;
  }
  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */
  setCurrentTime(ie) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && Da ? this.el_.fastSeek(ie) : this.el_.currentTime = ie;
    } catch (me) {
      ae(me, "Video is not ready. (Video.js)");
    }
  }
  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */
  duration() {
    if (this.el_.duration === 1 / 0 && At && Vt$1 && this.el_.currentTime === 0) {
      const ie = () => {
        this.el_.currentTime > 0 && (this.el_.duration === 1 / 0 && this.trigger("durationchange"), this.off("timeupdate", ie));
      };
      return this.on("timeupdate", ie), NaN;
    }
    return this.el_.duration || NaN;
  }
  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */
  width() {
    return this.el_.offsetWidth;
  }
  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */
  height() {
    return this.el_.offsetHeight;
  }
  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */
  proxyWebkitFullscreen_() {
    if (!("webkitDisplayingFullscreen" in this.el_))
      return;
    const ie = function() {
      this.trigger("fullscreenchange", {
        isFullscreen: !1
      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
    }, me = function() {
      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", ie), this.trigger("fullscreenchange", {
        isFullscreen: !0,
        // set a flag in case another tech triggers fullscreenchange
        nativeIOSFullscreen: !0
      }));
    };
    this.on("webkitbeginfullscreen", me), this.on("dispose", () => {
      this.off("webkitbeginfullscreen", me), this.off("webkitendfullscreen", ie);
    });
  }
  /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */
  supportsFullScreen() {
    return typeof this.el_.webkitEnterFullScreen == "function";
  }
  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */
  enterFullScreen() {
    const ie = this.el_;
    if (ie.paused && ie.networkState <= ie.HAVE_METADATA)
      Nt(this.el_.play()), this.setTimeout(function() {
        ie.pause();
        try {
          ie.webkitEnterFullScreen();
        } catch (me) {
          this.trigger("fullscreenerror", me);
        }
      }, 0);
    else
      try {
        ie.webkitEnterFullScreen();
      } catch (me) {
        this.trigger("fullscreenerror", me);
      }
  }
  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */
  exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  }
  /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */
  requestVideoFrameCallback(ie) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(ie) : super.requestVideoFrameCallback(ie);
  }
  /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */
  cancelVideoFrameCallback(ie) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(ie) : super.cancelVideoFrameCallback(ie);
  }
  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */
  src(ie) {
    if (ie === void 0)
      return this.el_.src;
    this.setSrc(ie);
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(ie, me) {
    if (!ie)
      return ae.error("Invalid source URL."), !1;
    const we = {
      src: ie
    };
    me && (we.type = me);
    const Re = Z$1("source", {}, we);
    return this.el_.appendChild(Re), !0;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(ie) {
    if (!ie)
      return ae.error("Source URL is required to remove the source element."), !1;
    const me = this.el_.querySelectorAll("source");
    for (const we of me)
      if (we.src === ie)
        return this.el_.removeChild(we), !0;
    return ae.warn(`No matching source element found with src: ${ie}`), !1;
  }
  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */
  reset() {
    Ux.resetMediaElement(this.el_);
  }
  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */
  currentSrc() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }
  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */
  setControls(ie) {
    this.el_.controls = !!ie;
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(ie, me, we) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(ie, me, we) : super.addTextTrack(ie, me, we);
  }
  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(ie) {
    if (!this.featuresNativeTextTracks)
      return super.createRemoteTextTrack(ie);
    const me = V$1.createElement("track");
    return ie.kind && (me.kind = ie.kind), ie.label && (me.label = ie.label), (ie.language || ie.srclang) && (me.srclang = ie.language || ie.srclang), ie.default && (me.default = ie.default), ie.id && (me.id = ie.id), ie.src && (me.src = ie.src), me;
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */
  addRemoteTextTrack(ie, me) {
    const we = super.addRemoteTextTrack(ie, me);
    return this.featuresNativeTextTracks && this.el().appendChild(we), we;
  }
  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */
  removeRemoteTextTrack(ie) {
    if (super.removeRemoteTextTrack(ie), this.featuresNativeTextTracks) {
      const me = this.$$("track");
      let we = me.length;
      for (; we--; )
        (ie === me[we] || ie === me[we].track) && this.el().removeChild(me[we]);
    }
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */
  getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    const ie = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (ie.droppedVideoFrames = this.el().webkitDroppedFrameCount, ie.totalVideoFrames = this.el().webkitDecodedFrameCount), S.performance && (ie.creationTime = S.performance.now()), ie;
  }
};
Sa(W$1, "TEST_VID", function() {
  if (!ws())
    return;
  const ce = V$1.createElement("video"), ie = V$1.createElement("track");
  return ie.kind = "captions", ie.srclang = "en", ie.label = "English", ce.appendChild(ie), ce;
});
W$1.isSupported = function() {
  try {
    W$1.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(W$1.TEST_VID && W$1.TEST_VID.canPlayType);
};
W$1.canPlayType = function(ce) {
  return W$1.TEST_VID.canPlayType(ce);
};
W$1.canPlaySource = function(ce, ie) {
  return W$1.canPlayType(ce.type);
};
W$1.canControlVolume = function() {
  try {
    const ce = W$1.TEST_VID.volume;
    W$1.TEST_VID.volume = ce / 2 + 0.1;
    const ie = ce !== W$1.TEST_VID.volume;
    return ie && Ve ? (S.setTimeout(() => {
      W$1 && W$1.prototype && (W$1.prototype.featuresVolumeControl = ce !== W$1.TEST_VID.volume);
    }), !1) : ie;
  } catch {
    return !1;
  }
};
W$1.canMuteVolume = function() {
  try {
    const ce = W$1.TEST_VID.muted;
    return W$1.TEST_VID.muted = !ce, W$1.TEST_VID.muted ? Ss(W$1.TEST_VID, "muted", "muted") : ka(W$1.TEST_VID, "muted", "muted"), ce !== W$1.TEST_VID.muted;
  } catch {
    return !1;
  }
};
W$1.canControlPlaybackRate = function() {
  if (At && Vt$1 && Ea < 58)
    return !1;
  try {
    const ce = W$1.TEST_VID.playbackRate;
    return W$1.TEST_VID.playbackRate = ce / 2 + 0.1, ce !== W$1.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
W$1.canOverrideAttributes = function() {
  try {
    const ce = () => {
    };
    Object.defineProperty(V$1.createElement("video"), "src", {
      get: ce,
      set: ce
    }), Object.defineProperty(V$1.createElement("audio"), "src", {
      get: ce,
      set: ce
    }), Object.defineProperty(V$1.createElement("video"), "innerHTML", {
      get: ce,
      set: ce
    }), Object.defineProperty(V$1.createElement("audio"), "innerHTML", {
      get: ce,
      set: ce
    });
  } catch {
    return !1;
  }
  return !0;
};
W$1.supportsNativeTextTracks = function() {
  return Da || Ve && Vt$1;
};
W$1.supportsNativeVideoTracks = function() {
  return !!(W$1.TEST_VID && W$1.TEST_VID.videoTracks);
};
W$1.supportsNativeAudioTracks = function() {
  return !!(W$1.TEST_VID && W$1.TEST_VID.audioTracks);
};
W$1.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function([ce, ie]) {
  Sa(W$1.prototype, ce, () => W$1[ie](), !0);
});
W$1.prototype.featuresVolumeControl = W$1.canControlVolume();
W$1.prototype.movingMediaElementInDOM = !Ve;
W$1.prototype.featuresFullscreenResize = !0;
W$1.prototype.featuresProgressEvents = !0;
W$1.prototype.featuresTimeupdateEvents = !0;
W$1.prototype.featuresVideoFrameCallback = !!(W$1.TEST_VID && W$1.TEST_VID.requestVideoFrameCallback);
W$1.disposeMediaElement = function(ce) {
  if (ce) {
    for (ce.parentNode && ce.parentNode.removeChild(ce); ce.hasChildNodes(); )
      ce.removeChild(ce.firstChild);
    ce.removeAttribute("src"), typeof ce.load == "function" && function() {
      try {
        ce.load();
      } catch {
      }
    }();
  }
};
W$1.resetMediaElement = function(ce) {
  if (!ce)
    return;
  const ie = ce.querySelectorAll("source");
  let me = ie.length;
  for (; me--; )
    ce.removeChild(ie[me]);
  ce.removeAttribute("src"), typeof ce.load == "function" && function() {
    try {
      ce.load();
    } catch {
    }
  }();
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(ce) {
  W$1.prototype[ce] = function() {
    return this.el_[ce] || this.el_.hasAttribute(ce);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(ce) {
  W$1.prototype["set" + De$1(ce)] = function(ie) {
    this.el_[ce] = ie, ie ? this.el_.setAttribute(ce, ce) : this.el_.removeAttribute(ce);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(ce) {
  W$1.prototype[ce] = function() {
    return this.el_[ce];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(ce) {
  W$1.prototype["set" + De$1(ce)] = function(ie) {
    this.el_[ce] = ie;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(ce) {
  W$1.prototype[ce] = function() {
    return this.el_[ce]();
  };
});
te.withSourceHandlers(W$1);
W$1.nativeSourceHandler = {};
W$1.nativeSourceHandler.canPlayType = function(ce) {
  try {
    return W$1.TEST_VID.canPlayType(ce);
  } catch {
    return "";
  }
};
W$1.nativeSourceHandler.canHandleSource = function(ce, ie) {
  if (ce.type)
    return W$1.nativeSourceHandler.canPlayType(ce.type);
  if (ce.src) {
    const me = Vu(ce.src);
    return W$1.nativeSourceHandler.canPlayType(`video/${me}`);
  }
  return "";
};
W$1.nativeSourceHandler.handleSource = function(ce, ie, me) {
  ie.setSrc(ce.src);
};
W$1.nativeSourceHandler.dispose = function() {
};
W$1.registerSourceHandler(W$1.nativeSourceHandler);
te.registerTech("Html5", W$1);
const Vf = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], Po = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, eu = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], $n = {};
eu.forEach((ce) => {
  const ie = ce.charAt(0) === "x" ? `x-${ce.substring(1)}` : ce;
  $n[ce] = `vjs-layout-${ie}`;
});
const dv = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
};
let he$1 = class CS extends B {
  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */
  constructor(ie, me, we) {
    if (ie.id = ie.id || me.id || `vjs_video_${gt()}`, me = Object.assign(CS.getTagSettings(ie), me), me.initChildren = !1, me.createEl = !1, me.evented = !1, me.reportTouchActivity = !1, !me.language) {
      const Ue = ie.closest("[lang]");
      Ue && (me.language = Ue.getAttribute("lang"));
    }
    if (super(null, me, we), this.boundDocumentFullscreenChange_ = (Ue) => this.documentFullscreenChange_(Ue), this.boundFullWindowOnEscKey_ = (Ue) => this.fullWindowOnEscKey(Ue), this.boundUpdateStyleEl_ = (Ue) => this.updateStyleEl_(Ue), this.boundApplyInitTime_ = (Ue) => this.applyInitTime_(Ue), this.boundUpdateCurrentBreakpoint_ = (Ue) => this.updateCurrentBreakpoint_(Ue), this.boundHandleTechClick_ = (Ue) => this.handleTechClick_(Ue), this.boundHandleTechDoubleClick_ = (Ue) => this.handleTechDoubleClick_(Ue), this.boundHandleTechTouchStart_ = (Ue) => this.handleTechTouchStart_(Ue), this.boundHandleTechTouchMove_ = (Ue) => this.handleTechTouchMove_(Ue), this.boundHandleTechTouchEnd_ = (Ue) => this.handleTechTouchEnd_(Ue), this.boundHandleTechTap_ = (Ue) => this.handleTechTap_(Ue), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (Ue) => this.updatePlayerHeightOnAudioOnlyMode_(Ue), this.isFullscreen_ = !1, this.log = Dh(this.id_), this.fsApi_ = Yn, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
      controlBarHeight: null,
      playerHeight: null,
      hiddenChildren: []
    }, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (this.tag = ie, this.tagAttributes = ie && hi(ie), this.language(this.options_.language), me.languages) {
      const Ue = {};
      Object.getOwnPropertyNames(me.languages).forEach(function(qe) {
        Ue[qe.toLowerCase()] = me.languages[qe];
      }), this.languages_ = Ue;
    } else
      this.languages_ = CS.prototype.options_.languages;
    this.resetCache_(), this.poster_ = me.poster || "", this.controls_ = !!me.controls, ie.controls = !1, ie.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], ie.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), me.plugins && Object.keys(me.plugins).forEach((Ue) => {
      if (typeof this[Ue] != "function")
        throw new Error(`plugin "${Ue}" does not exist`);
    }), this.scrubbing_ = !1, this.el_ = this.createEl(), Fu(this, {
      eventBusKey: "el_"
    }), this.fsApi_.requestFullscreen && (dt(V$1, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    const Re = ye$2(this.options_);
    if (me.plugins && Object.keys(me.plugins).forEach((Ue) => {
      this[Ue](me.plugins[Ue]);
    }), me.debug && this.debug(!0), this.options_.playerOptions = Re, this.middleware_ = [], this.playbackRates(me.playbackRates), me.experimentalSvgIcons) {
      const Ue = new S.DOMParser().parseFromString(RT, "image/svg+xml");
      if (Ue.querySelector("parsererror"))
        ae.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
      else {
        const qe = Ue.documentElement;
        qe.style.display = "none", this.el_.appendChild(qe), this.addClass("vjs-svg-icons-enabled");
      }
    }
    this.initChildren(), this.isAudio(ie.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), me.spatialNavigation && me.spatialNavigation.enabled && (this.spatialNavigation = new MT(this), this.addClass("vjs-spatial-navigation-enabled")), Br && this.addClass("vjs-touch-enabled"), Ve || this.addClass("vjs-workinghover"), CS.players[this.id_] = this;
    const je = Vo.split(".")[0];
    this.addClass(`vjs-v${je}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (Ue) => this.listenForUserActivity_(Ue)), this.on("keydown", (Ue) => this.handleKeyDown(Ue)), this.on("languagechange", (Ue) => this.handleLanguagechange(Ue)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
      this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
    });
  }
  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */
  dispose() {
    this.trigger("dispose"), this.off("dispose"), He(V$1, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), He(V$1, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), CS.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), IT(this), Qe.names.forEach((ie) => {
      const me = Qe[ie], we = this[me.getterName]();
      we && we.off && we.off();
    }), super.dispose({
      restoreEl: this.options_.restoreEl
    });
  }
  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    let ie = this.tag, me, we = this.playerElIngest_ = ie.parentNode && ie.parentNode.hasAttribute && ie.parentNode.hasAttribute("data-vjs-player");
    const Re = this.tag.tagName.toLowerCase() === "video-js";
    we ? me = this.el_ = ie.parentNode : Re || (me = this.el_ = super.createEl("div"));
    const je = hi(ie);
    if (Re) {
      for (me = this.el_ = ie, ie = this.tag = V$1.createElement("video"); me.children.length; )
        ie.appendChild(me.firstChild);
      wr(me, "video-js") || Ii(me, "video-js"), me.appendChild(ie), we = this.playerElIngest_ = me, Object.keys(me).forEach((Ge) => {
        try {
          ie[Ge] = me[Ge];
        } catch {
        }
      });
    }
    ie.setAttribute("tabindex", "-1"), je.tabindex = "-1", Vt$1 && Ca && (ie.setAttribute("role", "application"), je.role = "application"), ie.removeAttribute("width"), ie.removeAttribute("height"), "width" in je && delete je.width, "height" in je && delete je.height, Object.getOwnPropertyNames(je).forEach(function(Ge) {
      Re && Ge === "class" || me.setAttribute(Ge, je[Ge]), Re && ie.setAttribute(Ge, je[Ge]);
    }), ie.playerId = ie.id, ie.id += "_html5_api", ie.className = "vjs-tech", ie.player = me.player = this, this.addClass("vjs-paused");
    const Ue = ["IS_SMART_TV", "IS_TIZEN", "IS_WEBOS", "IS_ANDROID", "IS_IPAD", "IS_IPHONE", "IS_CHROMECAST_RECEIVER"].filter((Ge) => Mh[Ge]).map((Ge) => "vjs-device-" + Ge.substring(3).toLowerCase().replace(/\_/g, "-"));
    if (this.addClass(...Ue), S.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = Yh("vjs-styles-dimensions");
      const Ge = mi(".vjs-styles-defaults"), Xe = mi("head");
      Xe.insertBefore(this.styleEl_, Ge ? Ge.nextSibling : Xe.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    const qe = ie.getElementsByTagName("a");
    for (let Ge = 0; Ge < qe.length; Ge++) {
      const Xe = qe.item(Ge);
      Ii(Xe, "vjs-hidden"), Xe.setAttribute("hidden", "hidden");
    }
    return ie.initNetworkState_ = ie.networkState, ie.parentNode && !we && ie.parentNode.insertBefore(me, ie), zo(ie, me), this.children_.unshift(ie), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = me, me;
  }
  /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(ie) {
    if (typeof ie > "u")
      return this.techGet_("crossOrigin");
    if (ie !== null && ie !== "anonymous" && ie !== "use-credentials") {
      ae.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${ie}"`);
      return;
    }
    this.techCall_("setCrossOrigin", ie), this.posterImage && this.posterImage.crossOrigin(ie);
  }
  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */
  width(ie) {
    return this.dimension("width", ie);
  }
  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */
  height(ie) {
    return this.dimension("height", ie);
  }
  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */
  dimension(ie, me) {
    const we = ie + "_";
    if (me === void 0)
      return this[we] || 0;
    if (me === "" || me === "auto") {
      this[we] = void 0, this.updateStyleEl_();
      return;
    }
    const Re = parseFloat(me);
    if (isNaN(Re)) {
      ae.error(`Improper value "${me}" supplied for for ${ie}`);
      return;
    }
    this[we] = Re, this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fluid(ie) {
    if (ie === void 0)
      return !!this.fluid_;
    this.fluid_ = !!ie, Yt(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), ie ? (this.addClass("vjs-fluid"), this.fill(!1), uT(this, () => {
      this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fill(ie) {
    if (ie === void 0)
      return !!this.fill_;
    this.fill_ = !!ie, ie ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }
  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */
  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */
  aspectRatio(ie) {
    if (ie === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(ie))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = ie, this.fluid(!0), this.updateStyleEl_();
  }
  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */
  updateStyleEl_() {
    if (S.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      const qe = typeof this.width_ == "number" ? this.width_ : this.options_.width, Ge = typeof this.height_ == "number" ? this.height_ : this.options_.height, Xe = this.tech_ && this.tech_.el();
      Xe && (qe >= 0 && (Xe.width = qe), Ge >= 0 && (Xe.height = Ge));
      return;
    }
    let ie, me, we, Re;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? we = this.aspectRatio_ : this.videoWidth() > 0 ? we = this.videoWidth() + ":" + this.videoHeight() : we = "16:9";
    const je = we.split(":"), Ue = je[1] / je[0];
    this.width_ !== void 0 ? ie = this.width_ : this.height_ !== void 0 ? ie = this.height_ / Ue : ie = this.videoWidth() || 300, this.height_ !== void 0 ? me = this.height_ : me = ie * Ue, /^[^a-zA-Z]/.test(this.id()) ? Re = "dimensions-" + this.id() : Re = this.id() + "-dimensions", this.addClass(Re), Qh(this.styleEl_, `
      .${Re} {
        width: ${ie}px;
        height: ${me}px;
      }

      .${Re}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${Ue * 100}%;
      }
    `);
  }
  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */
  loadTech_(ie, me) {
    this.tech_ && this.unloadTech_();
    const we = De$1(ie), Re = ie.charAt(0).toLowerCase() + ie.slice(1);
    we !== "Html5" && this.tag && (te.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = we, this.isReady_ = !1;
    let je = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (je = !1);
    const Ue = {
      source: me,
      autoplay: je,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: `${this.id()}_${Re}_api`,
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset
    };
    Qe.names.forEach((Ge) => {
      const Xe = Qe[Ge];
      Ue[Xe.getterName] = this[Xe.privateName];
    }), Object.assign(Ue, this.options_[we]), Object.assign(Ue, this.options_[Re]), Object.assign(Ue, this.options_[ie.toLowerCase()]), this.tag && (Ue.tag = this.tag), me && me.src === this.cache_.src && this.cache_.currentTime > 0 && (Ue.startTime = this.cache_.currentTime);
    const qe = te.getTech(ie);
    if (!qe)
      throw new Error(`No Tech named '${we}' exists! '${we}' should be registered using videojs.registerTech()'`);
    this.tech_ = new qe(Ue), this.tech_.ready(ve$1(this, this.handleTechReady_), !0), Qo.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), Vf.forEach((Ge) => {
      this.on(this.tech_, Ge, (Xe) => this[`handleTech${De$1(Ge)}_`](Xe));
    }), Object.keys(Po).forEach((Ge) => {
      this.on(this.tech_, Ge, (Xe) => {
        if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
          this.queuedCallbacks_.push({
            callback: this[`handleTech${Po[Ge]}_`].bind(this),
            event: Xe
          });
          return;
        }
        this[`handleTech${Po[Ge]}_`](Xe);
      });
    }), this.on(this.tech_, "loadstart", (Ge) => this.handleTechLoadStart_(Ge)), this.on(this.tech_, "sourceset", (Ge) => this.handleTechSourceset_(Ge)), this.on(this.tech_, "waiting", (Ge) => this.handleTechWaiting_(Ge)), this.on(this.tech_, "ended", (Ge) => this.handleTechEnded_(Ge)), this.on(this.tech_, "seeking", (Ge) => this.handleTechSeeking_(Ge)), this.on(this.tech_, "play", (Ge) => this.handleTechPlay_(Ge)), this.on(this.tech_, "pause", (Ge) => this.handleTechPause_(Ge)), this.on(this.tech_, "durationchange", (Ge) => this.handleTechDurationChange_(Ge)), this.on(this.tech_, "fullscreenchange", (Ge, Xe) => this.handleTechFullscreenChange_(Ge, Xe)), this.on(this.tech_, "fullscreenerror", (Ge, Xe) => this.handleTechFullscreenError_(Ge, Xe)), this.on(this.tech_, "enterpictureinpicture", (Ge) => this.handleTechEnterPictureInPicture_(Ge)), this.on(this.tech_, "leavepictureinpicture", (Ge) => this.handleTechLeavePictureInPicture_(Ge)), this.on(this.tech_, "error", (Ge) => this.handleTechError_(Ge)), this.on(this.tech_, "posterchange", (Ge) => this.handleTechPosterChange_(Ge)), this.on(this.tech_, "textdata", (Ge) => this.handleTechTextData_(Ge)), this.on(this.tech_, "ratechange", (Ge) => this.handleTechRateChange_(Ge)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (we !== "Html5" || !this.tag) && zo(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }
  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */
  unloadTech_() {
    Qe.names.forEach((ie) => {
      const me = Qe[ie];
      this[me.privateName] = this[me.getterName]();
    }), this.textTracksJson_ = Qo.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }
  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */
  tech(ie) {
    return ie === void 0 && ae.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }
  /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */
  /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */
  version() {
    return {
      "video.js": Vo
    };
  }
  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */
  addTechControlsListeners_() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }
  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */
  removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }
  /**
   * Player waits for the tech to be ready
   *
   * @private
   */
  handleTechReady_() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }
  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */
  handleTechLoadStart_() {
    this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }
  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */
  manualAutoplay_(ie) {
    if (!this.tech_ || typeof ie != "string")
      return;
    const me = () => {
      const Re = this.muted();
      this.muted(!0);
      const je = () => {
        this.muted(Re);
      };
      this.playTerminatedQueue_.push(je);
      const Ue = this.play();
      if (Ir(Ue))
        return Ue.catch((qe) => {
          throw je(), new Error(`Rejection at manualAutoplay. Restoring muted value. ${qe || ""}`);
        });
    };
    let we;
    if (ie === "any" && !this.muted() ? (we = this.play(), Ir(we) && (we = we.catch(me))) : ie === "muted" && !this.muted() ? we = me() : we = this.play(), !!Ir(we))
      return we.then(() => {
        this.trigger({
          type: "autoplay-success",
          autoplay: ie
        });
      }).catch(() => {
        this.trigger({
          type: "autoplay-failure",
          autoplay: ie
        });
      });
  }
  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */
  updateSourceCaches_(ie = "") {
    let me = ie, we = "";
    typeof me != "string" && (me = ie.src, we = ie.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], me && !we && (we = LT(this, me)), this.cache_.source = ye$2({}, ie, {
      src: me,
      type: we
    });
    const Re = this.cache_.sources.filter((Ge) => Ge.src && Ge.src === me), je = [], Ue = this.$$("source"), qe = [];
    for (let Ge = 0; Ge < Ue.length; Ge++) {
      const Xe = hi(Ue[Ge]);
      je.push(Xe), Xe.src && Xe.src === me && qe.push(Xe.src);
    }
    qe.length && !Re.length ? this.cache_.sources = je : Re.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = me;
  }
  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */
  handleTechSourceset_(ie) {
    if (!this.changingSrc_) {
      let me = (je) => this.updateSourceCaches_(je);
      const we = this.currentSource().src, Re = ie.src;
      we && !/^blob:/.test(we) && /^blob:/.test(Re) && (!this.lastSource_ || this.lastSource_.tech !== Re && this.lastSource_.player !== we) && (me = () => {
      }), me(Re), ie.src || this.tech_.any(["sourceset", "loadstart"], (je) => {
        if (je.type === "sourceset")
          return;
        const Ue = this.techGet_("currentSrc");
        this.lastSource_.tech = Ue, this.updateSourceCaches_(Ue);
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: ie.src
    }, this.trigger({
      src: ie.src,
      type: "sourceset"
    });
  }
  /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */
  hasStarted(ie) {
    if (ie === void 0)
      return this.hasStarted_;
    ie !== this.hasStarted_ && (this.hasStarted_ = ie, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
  }
  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */
  handleTechPlay_() {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }
  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */
  handleTechRateChange_() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((ie) => ie.callback(ie.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }
  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */
  handleTechWaiting_() {
    this.addClass("vjs-waiting"), this.trigger("waiting");
    const ie = this.currentTime(), me = () => {
      ie !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", me));
    };
    this.on("timeupdate", me);
  }
  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */
  handleTechCanPlay_() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }
  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */
  handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }
  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */
  handleTechPlaying_() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }
  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */
  handleTechSeeking_() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }
  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */
  handleTechSeeked_() {
    this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
  }
  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */
  handleTechPause_() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }
  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */
  handleTechEnded_() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }
  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */
  handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  }
  /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */
  handleTechClick_(ie) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, ie) : this.paused() ? Nt(this.play()) : this.pause());
  }
  /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */
  handleTechDoubleClick_(ie) {
    this.controls_ && (Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (me) => me.contains(ie.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, ie) : this.isInPictureInPicture() && !V$1.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen()));
  }
  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */
  handleTechTap_() {
    this.userActive(!this.userActive());
  }
  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */
  handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  }
  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */
  handleTechTouchMove_() {
    this.userWasActive && this.reportUserActivity();
  }
  /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */
  handleTechTouchEnd_(ie) {
    ie.cancelable && ie.preventDefault();
  }
  /**
   * @private
   */
  toggleFullscreenClass_() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }
  /**
   * when the document fschange event triggers it calls this
   */
  documentFullscreenChange_(ie) {
    const me = ie.target.player;
    if (me && me !== this)
      return;
    const we = this.el();
    let Re = V$1[this.fsApi_.fullscreenElement] === we;
    !Re && we.matches && (Re = we.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(Re);
  }
  /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */
  handleTechFullscreenChange_(ie, me) {
    me && (me.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
      this.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(me.isFullscreen));
  }
  handleTechFullscreenError_(ie, me) {
    this.trigger("fullscreenerror", me);
  }
  /**
   * @private
   */
  togglePictureInPictureClass_() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }
  /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */
  handleTechEnterPictureInPicture_(ie) {
    this.isInPictureInPicture(!0);
  }
  /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */
  handleTechLeavePictureInPicture_(ie) {
    this.isInPictureInPicture(!1);
  }
  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */
  handleTechError_() {
    const ie = this.tech_.error();
    ie && this.error(ie);
  }
  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */
  handleTechTextData_() {
    let ie = null;
    arguments.length > 1 && (ie = arguments[1]), this.trigger("textdata", ie);
  }
  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */
  getCache() {
    return this.cache_;
  }
  /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */
  resetCache_() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }
  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */
  techCall_(ie, me) {
    this.ready(function() {
      if (ie in wT)
        return AT(this.middleware_, this.tech_, ie, me);
      if (ie in Hc)
        return Vc(this.middleware_, this.tech_, ie, me);
      try {
        this.tech_ && this.tech_[ie](me);
      } catch (we) {
        throw ae(we), we;
      }
    }, !0);
  }
  /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */
  techGet_(ie) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (ie in DT)
        return CT(this.middleware_, this.tech_, ie);
      if (ie in Hc)
        return Vc(this.middleware_, this.tech_, ie);
      try {
        return this.tech_[ie]();
      } catch (me) {
        throw this.tech_[ie] === void 0 ? (ae(`Video.js: ${ie} method not defined for ${this.techName_} playback technology.`, me), me) : me.name === "TypeError" ? (ae(`Video.js: ${ie} unavailable on ${this.techName_} playback technology element.`, me), this.tech_.isReady_ = !1, me) : (ae(me), me);
      }
    }
  }
  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */
  play() {
    return new Promise((ie) => {
      this.play_(ie);
    });
  }
  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */
  play_(ie = Nt) {
    this.playCallbacks_.push(ie);
    const me = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), we = !!(Da || Ve);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !me) {
      this.waitToPlay_ = (je) => {
        this.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !me && we && this.load();
      return;
    }
    const Re = this.techGet_("play");
    we && this.hasClass("vjs-ended") && this.resetProgressBar_(), Re === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(Re);
  }
  /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */
  runPlayTerminatedQueue_() {
    const ie = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], ie.forEach(function(me) {
      me();
    });
  }
  /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */
  runPlayCallbacks_(ie) {
    const me = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], me.forEach(function(we) {
      we(ie);
    });
  }
  /**
   * Pause the video playback
   */
  pause() {
    this.techCall_("pause");
  }
  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */
  paused() {
    return this.techGet_("paused") !== !1;
  }
  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */
  played() {
    return this.techGet_("played") || Ct(0, 0);
  }
  /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */
  scrubbing(ie) {
    if (typeof ie > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!ie, this.techCall_("setScrubbing", this.scrubbing_), ie ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }
  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */
  currentTime(ie) {
    if (ie === void 0)
      return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
    if (ie < 0 && (ie = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
      this.cache_.initTime = ie, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
      return;
    }
    this.techCall_("setCurrentTime", ie), this.cache_.initTime = 0, isFinite(ie) && (this.cache_.currentTime = Number(ie));
  }
  /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */
  applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  }
  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */
  duration(ie) {
    if (ie === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    ie = parseFloat(ie), ie < 0 && (ie = 1 / 0), ie !== this.cache_.duration && (this.cache_.duration = ie, ie === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(ie) || this.trigger("durationchange"));
  }
  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */
  remainingTime() {
    return this.duration() - this.currentTime();
  }
  /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */
  remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }
  //
  // Kind of like an array of portions of the video that have been downloaded.
  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  buffered() {
    let ie = this.techGet_("buffered");
    return (!ie || !ie.length) && (ie = Ct(0, 0)), ie;
  }
  /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  seekable() {
    let ie = this.techGet_("seekable");
    return (!ie || !ie.length) && (ie = Ct(0, 0)), ie;
  }
  /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */
  seeking() {
    return this.techGet_("seeking");
  }
  /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */
  ended() {
    return this.techGet_("ended");
  }
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */
  networkState() {
    return this.techGet_("networkState");
  }
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */
  readyState() {
    return this.techGet_("readyState");
  }
  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */
  bufferedPercent() {
    return of(this.buffered(), this.duration());
  }
  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */
  bufferedEnd() {
    const ie = this.buffered(), me = this.duration();
    let we = ie.end(ie.length - 1);
    return we > me && (we = me), we;
  }
  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */
  volume(ie) {
    let me;
    if (ie !== void 0) {
      me = Math.max(0, Math.min(1, ie)), this.cache_.volume = me, this.techCall_("setVolume", me), me > 0 && this.lastVolume_(me);
      return;
    }
    return me = parseFloat(this.techGet_("volume")), isNaN(me) ? 1 : me;
  }
  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */
  muted(ie) {
    if (ie !== void 0) {
      this.techCall_("setMuted", ie);
      return;
    }
    return this.techGet_("muted") || !1;
  }
  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */
  defaultMuted(ie) {
    return ie !== void 0 && this.techCall_("setDefaultMuted", ie), this.techGet_("defaultMuted") || !1;
  }
  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */
  lastVolume_(ie) {
    if (ie !== void 0 && ie !== 0) {
      this.cache_.lastVolume = ie;
      return;
    }
    return this.cache_.lastVolume;
  }
  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */
  supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || !1;
  }
  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */
  isFullscreen(ie) {
    if (ie !== void 0) {
      const me = this.isFullscreen_;
      this.isFullscreen_ = !!ie, this.isFullscreen_ !== me && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }
  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */
  requestFullscreen(ie) {
    this.isInPictureInPicture() && this.exitPictureInPicture();
    const me = this;
    return new Promise((we, Re) => {
      function je() {
        me.off("fullscreenerror", qe), me.off("fullscreenchange", Ue);
      }
      function Ue() {
        je(), we();
      }
      function qe(Xe, ot) {
        je(), Re(ot);
      }
      me.one("fullscreenchange", Ue), me.one("fullscreenerror", qe);
      const Ge = me.requestFullscreenHelper_(ie);
      Ge && (Ge.then(je, je), Ge.then(we, Re));
    });
  }
  requestFullscreenHelper_(ie) {
    let me;
    if (this.fsApi_.prefixed || (me = this.options_.fullscreen && this.options_.fullscreen.options || {}, ie !== void 0 && (me = ie)), this.fsApi_.requestFullscreen) {
      const we = this.el_[this.fsApi_.requestFullscreen](me);
      return we && we.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), we;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }
  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */
  exitFullscreen() {
    const ie = this;
    return new Promise((me, we) => {
      function Re() {
        ie.off("fullscreenerror", Ue), ie.off("fullscreenchange", je);
      }
      function je() {
        Re(), me();
      }
      function Ue(Ge, Xe) {
        Re(), we(Xe);
      }
      ie.one("fullscreenchange", je), ie.one("fullscreenerror", Ue);
      const qe = ie.exitFullscreenHelper_();
      qe && (qe.then(Re, Re), qe.then(me, we));
    });
  }
  exitFullscreenHelper_() {
    if (this.fsApi_.requestFullscreen) {
      const ie = V$1[this.fsApi_.exitFullscreen]();
      return ie && Nt(ie.then(() => this.isFullscreen(!1))), ie;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }
  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */
  enterFullWindow() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = V$1.documentElement.style.overflow, dt(V$1, "keydown", this.boundFullWindowOnEscKey_), V$1.documentElement.style.overflow = "hidden", Ii(V$1.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }
  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */
  fullWindowOnEscKey(ie) {
    ie.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }
  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */
  exitFullWindow() {
    this.isFullscreen(!1), this.isFullWindow = !1, He(V$1, "keydown", this.boundFullWindowOnEscKey_), V$1.documentElement.style.overflow = this.docOrigOverflow, wa(V$1.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }
  /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */
  disablePictureInPicture(ie) {
    if (ie === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", ie), this.options_.disablePictureInPicture = ie, this.trigger("disablepictureinpicturechanged");
  }
  /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */
  isInPictureInPicture(ie) {
    if (ie !== void 0) {
      this.isInPictureInPicture_ = !!ie, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    if (this.options_.enableDocumentPictureInPicture && S.documentPictureInPicture) {
      const ie = V$1.createElement(this.el().tagName);
      return ie.classList = this.el().classList, ie.classList.add("vjs-pip-container"), this.posterImage && ie.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && ie.appendChild(this.titleBar.el().cloneNode(!0)), ie.appendChild(Z$1("p", {
        className: "vjs-pip-text"
      }, {}, this.localize("Playing in picture-in-picture"))), S.documentPictureInPicture.requestWindow({
        // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
        width: this.videoWidth(),
        height: this.videoHeight()
      }).then((me) => (Gh(me), this.el_.parentNode.insertBefore(ie, this.el_), me.document.body.appendChild(this.el_), me.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
        type: "enterpictureinpicture",
        pipWindow: me
      }), me.addEventListener("pagehide", (we) => {
        const Re = we.target.querySelector(".video-js");
        ie.parentNode.replaceChild(Re, ie), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
      }), me));
    }
    return "pictureInPictureEnabled" in V$1 && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
  }
  /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */
  exitPictureInPicture() {
    if (S.documentPictureInPicture && S.documentPictureInPicture.window)
      return S.documentPictureInPicture.window.close(), Promise.resolve();
    if ("pictureInPictureEnabled" in V$1)
      return V$1.exitPictureInPicture();
  }
  /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(ie) {
    const {
      userActions: me
    } = this.options_;
    !me || !me.hotkeys || ((we) => {
      const Re = we.tagName.toLowerCase();
      return we.isContentEditable ? !0 : Re === "input" ? ["button", "checkbox", "hidden", "radio", "reset", "submit"].indexOf(we.type) === -1 : ["textarea"].indexOf(Re) !== -1;
    })(this.el_.ownerDocument.activeElement) || (typeof me.hotkeys == "function" ? me.hotkeys.call(this, ie) : this.handleHotkeys(ie));
  }
  /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */
  handleHotkeys(ie) {
    const me = this.options_.userActions ? this.options_.userActions.hotkeys : {}, {
      fullscreenKey: we = (Ue) => ie.key.toLowerCase() === "f",
      muteKey: Re = (Ue) => ie.key.toLowerCase() === "m",
      playPauseKey: je = (Ue) => ie.key.toLowerCase() === "k" || ie.key.toLowerCase() === " "
    } = me;
    if (we.call(this, ie)) {
      ie.preventDefault(), ie.stopPropagation();
      const Ue = B.getComponent("FullscreenToggle");
      V$1[this.fsApi_.fullscreenEnabled] !== !1 && Ue.prototype.handleClick.call(this, ie);
    } else Re.call(this, ie) ? (ie.preventDefault(), ie.stopPropagation(), B.getComponent("MuteToggle").prototype.handleClick.call(this, ie)) : je.call(this, ie) && (ie.preventDefault(), ie.stopPropagation(), B.getComponent("PlayToggle").prototype.handleClick.call(this, ie));
  }
  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  canPlayType(ie) {
    let me;
    for (let we = 0, Re = this.options_.techOrder; we < Re.length; we++) {
      const je = Re[we];
      let Ue = te.getTech(je);
      if (Ue || (Ue = B.getComponent(je)), !Ue) {
        ae.error(`The "${je}" tech is undefined. Skipped browser support check for that tech.`);
        continue;
      }
      if (Ue.isSupported() && (me = Ue.canPlayType(ie), me))
        return me;
    }
    return "";
  }
  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */
  selectSource(ie) {
    const me = this.options_.techOrder.map((qe) => [qe, te.getTech(qe)]).filter(([qe, Ge]) => Ge ? Ge.isSupported() : (ae.error(`The "${qe}" tech is undefined. Skipped browser support check for that tech.`), !1)), we = function(qe, Ge, Xe) {
      let ot;
      return qe.some((vt) => Ge.some((bt) => {
        if (ot = Xe(vt, bt), ot)
          return !0;
      })), ot;
    };
    let Re;
    const je = (qe) => (Ge, Xe) => qe(Xe, Ge), Ue = ([qe, Ge], Xe) => {
      if (Ge.canPlaySource(Xe, this.options_[qe.toLowerCase()]))
        return {
          source: Xe,
          tech: qe
        };
    };
    return this.options_.sourceOrder ? Re = we(ie, me, je(Ue)) : Re = we(me, ie, Ue), Re || !1;
  }
  /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  handleSrc_(ie, me) {
    if (typeof ie > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    const we = ff(ie);
    if (!we.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, me || (this.cache_.sources = we), this.updateSourceCaches_(we[0]), ST(this, we[0], (Re, je) => {
      if (this.middleware_ = je, me || (this.cache_.sources = we), this.updateSourceCaches_(Re), this.src_(Re)) {
        if (we.length > 1)
          return this.handleSrc_(we.slice(1));
        this.changingSrc_ = !1, this.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), this.triggerReady();
        return;
      }
      ET(je, this.tech_);
    }), we.length > 1) {
      const Re = () => {
        this.error(null), this.handleSrc_(we.slice(1), !0);
      }, je = () => {
        this.off("error", Re);
      };
      this.one("error", Re), this.one("playing", je), this.resetRetryOnError_ = () => {
        this.off("error", Re), this.off("playing", je);
      };
    }
  }
  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  src(ie) {
    return this.handleSrc_(ie, !1);
  }
  /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */
  src_(ie) {
    const me = this.selectSource([ie]);
    return me ? sf(me.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", ie) : this.techCall_("src", ie.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(me.tech, me.source), this.tech_.ready(() => {
      this.changingSrc_ = !1;
    }), !1) : !0;
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(ie, me) {
    return this.tech_ ? this.tech_.addSourceElement(ie, me) : !1;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(ie) {
    return this.tech_ ? this.tech_.removeSourceElement(ie) : !1;
  }
  /**
   * Begin loading the src data.
   */
  load() {
    if (this.tech_ && this.tech_.vhs) {
      this.src(this.currentSource());
      return;
    }
    this.techCall_("load");
  }
  /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */
  reset() {
    if (this.paused())
      this.doReset_();
    else {
      const ie = this.play();
      Nt(ie.then(() => this.doReset_()));
    }
  }
  doReset_() {
    this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
      title: void 0,
      description: void 0
    }), Yt(this) && this.trigger("playerreset");
  }
  /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */
  resetControlBarUI_() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }
  /**
   * Reset tech's progress so progress bar is reset in the UI
   */
  resetProgressBar_() {
    this.currentTime(0);
    const {
      currentTimeDisplay: ie,
      durationDisplay: me,
      progressControl: we,
      remainingTimeDisplay: Re
    } = this.controlBar || {}, {
      seekBar: je
    } = we || {};
    ie && ie.updateContent(), me && me.updateContent(), Re && Re.updateContent(), je && (je.update(), je.loadProgressBar && je.loadProgressBar.update());
  }
  /**
   * Reset Playback ratio
   */
  resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }
  /**
   * Reset Volume bar
   */
  resetVolumeBar_() {
    this.volume(1), this.trigger("volumechange");
  }
  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */
  currentSources() {
    const ie = this.currentSource(), me = [];
    return Object.keys(ie).length !== 0 && me.push(ie), this.cache_.sources || me;
  }
  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */
  currentSource() {
    return this.cache_.source || {};
  }
  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */
  currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  }
  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */
  currentType() {
    return this.currentSource() && this.currentSource().type || "";
  }
  /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */
  preload(ie) {
    if (ie !== void 0) {
      this.techCall_("setPreload", ie), this.options_.preload = ie;
      return;
    }
    return this.techGet_("preload");
  }
  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */
  autoplay(ie) {
    if (ie === void 0)
      return this.options_.autoplay || !1;
    let me;
    typeof ie == "string" && /(any|play|muted)/.test(ie) || ie === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = ie, this.manualAutoplay_(typeof ie == "string" ? ie : "play"), me = !1) : ie ? this.options_.autoplay = !0 : this.options_.autoplay = !1, me = typeof me > "u" ? this.options_.autoplay : me, this.tech_ && this.techCall_("setAutoplay", me);
  }
  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  playsinline(ie) {
    return ie !== void 0 && (this.techCall_("setPlaysinline", ie), this.options_.playsinline = ie), this.techGet_("playsinline");
  }
  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */
  loop(ie) {
    if (ie !== void 0) {
      this.techCall_("setLoop", ie), this.options_.loop = ie;
      return;
    }
    return this.techGet_("loop");
  }
  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */
  poster(ie) {
    if (ie === void 0)
      return this.poster_;
    ie || (ie = ""), ie !== this.poster_ && (this.poster_ = ie, this.techCall_("setPoster", ie), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }
  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */
  handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      const ie = this.tech_.poster() || "";
      ie !== this.poster_ && (this.poster_ = ie, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }
  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */
  controls(ie) {
    if (ie === void 0)
      return !!this.controls_;
    ie = !!ie, this.controls_ !== ie && (this.controls_ = ie, this.usingNativeControls() && this.techCall_("setControls", ie), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }
  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */
  usingNativeControls(ie) {
    if (ie === void 0)
      return !!this.usingNativeControls_;
    ie = !!ie, this.usingNativeControls_ !== ie && (this.usingNativeControls_ = ie, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }
  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */
  error(ie) {
    if (ie === void 0)
      return this.error_ || null;
    if (pi("beforeerror").forEach((me) => {
      const we = me(this, ie);
      if (!(qt(we) && !Array.isArray(we) || typeof we == "string" || typeof we == "number" || we === null)) {
        this.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      ie = we;
    }), this.options_.suppressNotSupportedError && ie && ie.code === 4) {
      const me = function() {
        this.error(ie);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], me), this.one("loadstart", function() {
        this.off(["click", "touchstart"], me);
      });
      return;
    }
    if (ie === null) {
      this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new Ae$1(ie), this.addClass("vjs-error"), ae.error(`(CODE:${this.error_.code} ${Ae$1.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), pi("error").forEach((me) => me(this, this.error_));
  }
  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */
  reportUserActivity(ie) {
    this.userActivity_ = !0;
  }
  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */
  userActive(ie) {
    if (ie === void 0)
      return this.userActive_;
    if (ie = !!ie, ie !== this.userActive_) {
      if (this.userActive_ = ie, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(me) {
        me.stopPropagation(), me.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }
  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */
  listenForUserActivity_() {
    let ie, me, we;
    const Re = ve$1(this, this.reportUserActivity), je = function(vt) {
      (vt.screenX !== me || vt.screenY !== we) && (me = vt.screenX, we = vt.screenY, Re());
    }, Ue = function() {
      Re(), this.clearInterval(ie), ie = this.setInterval(Re, 250);
    }, qe = function(vt) {
      Re(), this.clearInterval(ie);
    };
    this.on("mousedown", Ue), this.on("mousemove", je), this.on("mouseup", qe), this.on("mouseleave", qe);
    const Ge = this.getChild("controlBar");
    Ge && !Ve && !At && (Ge.on("mouseenter", function(vt) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), Ge.on("mouseleave", function(vt) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", Re), this.on("keyup", Re);
    let Xe;
    const ot = function() {
      if (!this.userActivity_)
        return;
      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(Xe);
      const vt = this.options_.inactivityTimeout;
      vt <= 0 || (Xe = this.setTimeout(function() {
        this.userActivity_ || this.userActive(!1);
      }, vt));
    };
    this.setInterval(ot, 250);
  }
  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */
  playbackRate(ie) {
    if (ie !== void 0) {
      this.techCall_("setPlaybackRate", ie);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }
  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */
  defaultPlaybackRate(ie) {
    return ie !== void 0 ? this.techCall_("setDefaultPlaybackRate", ie) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }
  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */
  isAudio(ie) {
    if (ie !== void 0) {
      this.isAudio_ = !!ie;
      return;
    }
    return !!this.isAudio_;
  }
  updatePlayerHeightOnAudioOnlyMode_() {
    const ie = this.getChild("ControlBar");
    !ie || this.audioOnlyCache_.controlBarHeight === ie.currentHeight() || (this.audioOnlyCache_.controlBarHeight = ie.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
  }
  enableAudioOnlyUI_() {
    this.addClass("vjs-audio-only-mode");
    const ie = this.children(), me = this.getChild("ControlBar"), we = me && me.currentHeight();
    ie.forEach((Re) => {
      Re !== me && Re.el_ && !Re.hasClass("vjs-hidden") && (Re.hide(), this.audioOnlyCache_.hiddenChildren.push(Re));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = we, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(we), this.trigger("audioonlymodechange");
  }
  disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((ie) => ie.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }
  /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioOnlyMode(ie) {
    if (typeof ie != "boolean" || ie === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    if (this.audioOnlyMode_ = ie, ie) {
      const me = [];
      return this.isInPictureInPicture() && me.push(this.exitPictureInPicture()), this.isFullscreen() && me.push(this.exitFullscreen()), this.audioPosterMode() && me.push(this.audioPosterMode(!1)), Promise.all(me).then(() => this.enableAudioOnlyUI_());
    }
    return Promise.resolve().then(() => this.disableAudioOnlyUI_());
  }
  enablePosterModeUI_() {
    (this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  disablePosterModeUI_() {
    (this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioPosterMode(ie) {
    return typeof ie != "boolean" || ie === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = ie, ie ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.disablePosterModeUI_();
    }));
  }
  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */
  addTextTrack(ie, me, we) {
    if (this.tech_)
      return this.tech_.addTextTrack(ie, me, we);
  }
  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */
  addRemoteTextTrack(ie, me) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(ie, me);
  }
  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */
  removeRemoteTextTrack(ie = {}) {
    let {
      track: me
    } = ie;
    if (me || (me = ie), this.tech_)
      return this.tech_.removeRemoteTextTrack(me);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */
  getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  }
  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */
  videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }
  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */
  videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }
  /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */
  language(ie) {
    if (ie === void 0)
      return this.language_;
    this.language_ !== String(ie).toLowerCase() && (this.language_ = String(ie).toLowerCase(), Yt(this) && this.trigger("languagechange"));
  }
  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */
  languages() {
    return ye$2(CS.prototype.options_.languages, this.languages_);
  }
  /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */
  toJSON() {
    const ie = ye$2(this.options_), me = ie.tracks;
    ie.tracks = [];
    for (let we = 0; we < me.length; we++) {
      let Re = me[we];
      Re = ye$2(Re), Re.player = void 0, ie.tracks[we] = Re;
    }
    return ie;
  }
  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */
  createModal(ie, me) {
    me = me || {}, me.content = ie || "";
    const we = new Ps(this, me);
    return this.addChild(we), we.on("dispose", () => {
      this.removeChild(we);
    }), we.open(), we;
  }
  /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */
  updateCurrentBreakpoint_() {
    if (!this.responsive())
      return;
    const ie = this.currentBreakpoint(), me = this.currentWidth();
    for (let we = 0; we < eu.length; we++) {
      const Re = eu[we], je = this.breakpoints_[Re];
      if (me <= je) {
        if (ie === Re)
          return;
        ie && this.removeClass($n[ie]), this.addClass($n[Re]), this.breakpoint_ = Re;
        break;
      }
    }
  }
  /**
   * Removes the current breakpoint.
   *
   * @private
   */
  removeCurrentBreakpoint_() {
    const ie = this.currentBreakpointClass();
    this.breakpoint_ = "", ie && this.removeClass(ie);
  }
  /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */
  breakpoints(ie) {
    return ie === void 0 ? Object.assign(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Object.assign({}, dv, ie), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
  }
  /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */
  responsive(ie) {
    if (ie === void 0)
      return this.responsive_;
    ie = !!ie;
    const me = this.responsive_;
    if (ie !== me)
      return this.responsive_ = ie, ie ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), ie;
  }
  /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */
  currentBreakpoint() {
    return this.breakpoint_;
  }
  /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */
  currentBreakpointClass() {
    return $n[this.breakpoint_] || "";
  }
  /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */
  /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */
  loadMedia(ie, me) {
    if (!ie || typeof ie != "object")
      return;
    const we = this.crossOrigin();
    this.reset(), this.cache_.media = ye$2(ie);
    const {
      artist: Re,
      artwork: je,
      description: Ue,
      poster: qe,
      src: Ge,
      textTracks: Xe,
      title: ot
    } = this.cache_.media;
    !je && qe && (this.cache_.media.artwork = [{
      src: qe,
      type: aa(qe)
    }]), we && this.crossOrigin(we), Ge && this.src(Ge), qe && this.poster(qe), Array.isArray(Xe) && Xe.forEach((vt) => this.addRemoteTextTrack(vt, !1)), this.titleBar && this.titleBar.update({
      title: ot,
      description: Ue || Re || ""
    }), this.ready(me);
  }
  /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */
  getMedia() {
    if (!this.cache_.media) {
      const ie = this.poster(), me = this.currentSources(), we = Array.prototype.map.call(this.remoteTextTracks(), (je) => ({
        kind: je.kind,
        label: je.label,
        language: je.language,
        src: je.src
      })), Re = {
        src: me,
        textTracks: we
      };
      return ie && (Re.poster = ie, Re.artwork = [{
        src: Re.poster,
        type: aa(Re.poster)
      }]), Re;
    }
    return ye$2(this.cache_.media);
  }
  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */
  static getTagSettings(ie) {
    const me = {
      sources: [],
      tracks: []
    }, we = hi(ie), Re = we["data-setup"];
    if (wr(ie, "vjs-fill") && (we.fill = !0), wr(ie, "vjs-fluid") && (we.fluid = !0), Re !== null)
      try {
        Object.assign(we, JSON.parse(Re || "{}"));
      } catch (je) {
        ae.error("data-setup", je);
      }
    if (Object.assign(me, we), ie.hasChildNodes()) {
      const je = ie.childNodes;
      for (let Ue = 0, qe = je.length; Ue < qe; Ue++) {
        const Ge = je[Ue], Xe = Ge.nodeName.toLowerCase();
        Xe === "source" ? me.sources.push(hi(Ge)) : Xe === "track" && me.tracks.push(hi(Ge));
      }
    }
    return me;
  }
  /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */
  debug(ie) {
    if (ie === void 0)
      return this.debugEnabled_;
    ie ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }
  /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */
  playbackRates(ie) {
    if (ie === void 0)
      return this.cache_.playbackRates;
    Array.isArray(ie) && ie.every((me) => typeof me == "number") && (this.cache_.playbackRates = ie, this.trigger("playbackrateschange"));
  }
  /**
   * Reports whether or not a player has a plugin available.
   *
   * This does not report whether or not the plugin has ever been initialized
   * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
   *
   * @method hasPlugin
   * @param  {string}  name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player has the requested plugin available.
   */
  /**
   * Reports whether or not a player is using a plugin by name.
   *
   * For basic plugins, this only reports whether the plugin has _ever_ been
   * initialized on this player.
   *
   * @method Player#usingPlugin
   * @param  {string} name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player is using the requested plugin.
   */
};
he$1.prototype.videoTracks = () => {
};
he$1.prototype.audioTracks = () => {
};
he$1.prototype.textTracks = () => {
};
he$1.prototype.remoteTextTracks = () => {
};
he$1.prototype.remoteTextTrackEls = () => {
};
Qe.names.forEach(function(ce) {
  const ie = Qe[ce];
  he$1.prototype[ie.getterName] = function() {
    return this.tech_ ? this.tech_[ie.getterName]() : (this[ie.privateName] = this[ie.privateName] || new ie.ListClass(), this[ie.privateName]);
  };
});
he$1.prototype.crossorigin = he$1.prototype.crossOrigin;
he$1.players = {};
const yr = S.navigator;
he$1.prototype.options_ = {
  // Default order of fallback technology
  techOrder: te.defaultTechOrder_,
  html5: {},
  // enable sourceset by default
  enableSourceset: !0,
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "titleBar", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: yr && (yr.languages && yr.languages[0] || yr.userLanguage || yr.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1,
  spatialNavigation: {
    enabled: !1,
    horizontalSeek: !1
  },
  // Default smooth seeking to false
  enableSmoothSeeking: !1,
  disableSeekWhileScrubbingOnMobile: !1,
  disableSeekWhileScrubbingOnSTV: !1
};
Vf.forEach(function(ce) {
  he$1.prototype[`handleTech${De$1(ce)}_`] = function() {
    return this.trigger(ce);
  };
});
B.registerComponent("Player", he$1);
const oa = "plugin", ls = "activePlugins_", ss = {}, ua = (ce) => ss.hasOwnProperty(ce), jn = (ce) => ua(ce) ? ss[ce] : void 0, Hf = (ce, ie) => {
  ce[ls] = ce[ls] || {}, ce[ls][ie] = !0;
}, la = (ce, ie, me) => {
  const we = (me ? "before" : "") + "pluginsetup";
  ce.trigger(we, ie), ce.trigger(we + ":" + ie.name, ie);
}, hv = function(ce, ie) {
  const me = function() {
    la(this, {
      name: ce,
      plugin: ie,
      instance: null
    }, !0);
    const we = ie.apply(this, arguments);
    return Hf(this, ce), la(this, {
      name: ce,
      plugin: ie,
      instance: we
    }), we;
  };
  return Object.keys(ie).forEach(function(we) {
    me[we] = ie[we];
  }), me;
}, ad = (ce, ie) => (ie.prototype.name = ce, function(...me) {
  la(this, {
    name: ce,
    plugin: ie,
    instance: null
  }, !0);
  const we = new ie(this, ...me);
  return this[ce] = () => we, la(this, we.getEventHash()), we;
});
class rt {
  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  constructor(ie) {
    if (this.constructor === rt)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = ie, this.log || (this.log = this.player.log.createLogger(this.name)), Fu(this), delete this.trigger, tf(this, this.constructor.defaultState), Hf(ie, this.name), this.dispose = this.dispose.bind(this), ie.on("dispose", this.dispose);
  }
  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */
  version() {
    return this.constructor.VERSION;
  }
  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */
  getEventHash(ie = {}) {
    return ie.name = this.name, ie.plugin = this.constructor, ie.instance = this, ie;
  }
  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */
  trigger(ie, me = {}) {
    return Is(this.eventBusEl_, ie, this.getEventHash(me));
  }
  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */
  handleStateChanged(ie) {
  }
  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */
  dispose() {
    const {
      name: ie,
      player: me
    } = this;
    this.trigger("dispose"), this.off(), me.off("dispose", this.dispose), me[ls][ie] = !1, this.player = this.state = null, me[ie] = ad(ie, ss[ie]);
  }
  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */
  static isBasic(ie) {
    const me = typeof ie == "string" ? jn(ie) : ie;
    return typeof me == "function" && !rt.prototype.isPrototypeOf(me.prototype);
  }
  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */
  static registerPlugin(ie, me) {
    if (typeof ie != "string")
      throw new Error(`Illegal plugin name, "${ie}", must be a string, was ${typeof ie}.`);
    if (ua(ie))
      ae.warn(`A plugin named "${ie}" already exists. You may want to avoid re-registering plugins!`);
    else if (he$1.prototype.hasOwnProperty(ie))
      throw new Error(`Illegal plugin name, "${ie}", cannot share a name with an existing player method!`);
    if (typeof me != "function")
      throw new Error(`Illegal plugin for "${ie}", must be a function, was ${typeof me}.`);
    return ss[ie] = me, ie !== oa && (rt.isBasic(me) ? he$1.prototype[ie] = hv(ie, me) : he$1.prototype[ie] = ad(ie, me)), me;
  }
  /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */
  static deregisterPlugin(ie) {
    if (ie === oa)
      throw new Error("Cannot de-register base plugin.");
    ua(ie) && (delete ss[ie], delete he$1.prototype[ie]);
  }
  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */
  static getPlugins(ie = Object.keys(ss)) {
    let me;
    return ie.forEach((we) => {
      const Re = jn(we);
      Re && (me = me || {}, me[we] = Re);
    }), me;
  }
  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */
  static getPluginVersion(ie) {
    const me = jn(ie);
    return me && me.VERSION || "";
  }
}
rt.getPlugin = jn;
rt.BASE_PLUGIN_NAME = oa;
rt.registerPlugin(oa, rt);
he$1.prototype.usingPlugin = function(ce) {
  return !!this[ls] && this[ls][ce] === !0;
};
he$1.prototype.hasPlugin = function(ce) {
  return !!ua(ce);
};
function fv(ce, ie) {
  let me = !1;
  return function(...we) {
    return me || ae.warn(ce), me = !0, ie.apply(this, we);
  };
}
function Dt(ce, ie, me, we) {
  return fv(`${ie} is deprecated and will be removed in ${ce}.0; please use ${me} instead.`, we);
}
var pv = {
  NetworkBadStatus: "networkbadstatus",
  NetworkRequestFailed: "networkrequestfailed",
  NetworkRequestAborted: "networkrequestaborted",
  NetworkRequestTimeout: "networkrequesttimeout",
  NetworkBodyParserFailed: "networkbodyparserfailed",
  StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
  StreamingDashManifestParserError: "streamingdashmanifestparsererror",
  StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
  StreamingVttParserError: "streamingvttparsererror",
  StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
  StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
  StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
  StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
  StreamingCodecsChangeError: "streamingcodecschangeerror"
};
const zf = (ce) => ce.indexOf("#") === 0 ? ce.slice(1) : ce;
function L(ce, ie, me) {
  let we = L.getPlayer(ce);
  if (we)
    return ie && ae.warn(`Player "${ce}" is already initialised. Options will not be applied.`), me && we.ready(me), we;
  const Re = typeof ce == "string" ? mi("#" + zf(ce)) : ce;
  if (!ks(Re))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  const je = "getRootNode" in Re && Re.getRootNode() instanceof S.ShadowRoot ? Re.getRootNode() : Re.ownerDocument.body;
  (!Re.ownerDocument.defaultView || !je.contains(Re)) && ae.warn("The element supplied is not included in the DOM"), ie = ie || {}, ie.restoreEl === !0 && (ie.restoreEl = (Re.parentNode && Re.parentNode.hasAttribute && Re.parentNode.hasAttribute("data-vjs-player") ? Re.parentNode : Re).cloneNode(!0)), pi("beforesetup").forEach((qe) => {
    const Ge = qe(Re, ye$2(ie));
    if (!qt(Ge) || Array.isArray(Ge)) {
      ae.error("please return an object in beforesetup hooks");
      return;
    }
    ie = ye$2(ie, Ge);
  });
  const Ue = B.getComponent("Player");
  return we = new Ue(Re, ie, me), pi("setup").forEach((qe) => qe(we)), we;
}
L.hooks_ = Gt;
L.hooks = pi;
L.hook = Xy;
L.hookOnce = Ky;
L.removeHook = Ah;
if (S.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && ws()) {
  let ce = mi(".vjs-styles-defaults");
  if (!ce) {
    ce = Yh("vjs-styles-defaults");
    const ie = mi("head");
    ie && ie.insertBefore(ce, ie.firstChild), Qh(ce, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
Go(1, L);
L.VERSION = Vo;
L.options = he$1.prototype.options_;
L.getPlayers = () => he$1.players;
L.getPlayer = (ce) => {
  const ie = he$1.players;
  let me;
  if (typeof ce == "string") {
    const we = zf(ce), Re = ie[we];
    if (Re)
      return Re;
    me = mi("#" + we);
  } else
    me = ce;
  if (ks(me)) {
    const {
      player: we,
      playerId: Re
    } = me;
    if (we || ie[Re])
      return we || ie[Re];
  }
};
L.getAllPlayers = () => (
  // Disposed players leave a key with a `null` value, so we need to make sure
  // we filter those out.
  Object.keys(he$1.players).map((ce) => he$1.players[ce]).filter(Boolean)
);
L.players = he$1.players;
L.getComponent = B.getComponent;
L.registerComponent = (ce, ie) => (te.isTech(ie) && ae.warn(`The ${ce} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), B.registerComponent.call(B, ce, ie));
L.getTech = te.getTech;
L.registerTech = te.registerTech;
L.use = xT;
Object.defineProperty(L, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(L.middleware, "TERMINATOR", {
  value: na,
  writeable: !1,
  enumerable: !0
});
L.browser = Mh;
L.obj = Jy;
L.mergeOptions = Dt(9, "videojs.mergeOptions", "videojs.obj.merge", ye$2);
L.defineLazyProperty = Dt(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", Sa);
L.bind = Dt(9, "videojs.bind", "native Function.prototype.bind", ve$1);
L.registerPlugin = rt.registerPlugin;
L.deregisterPlugin = rt.deregisterPlugin;
L.plugin = (ce, ie) => (ae.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), rt.registerPlugin(ce, ie));
L.getPlugins = rt.getPlugins;
L.getPlugin = rt.getPlugin;
L.getPluginVersion = rt.getPluginVersion;
L.addLanguage = function(ce, ie) {
  return ce = ("" + ce).toLowerCase(), L.options.languages = ye$2(L.options.languages, {
    [ce]: ie
  }), L.options.languages[ce];
};
L.log = ae;
L.createLogger = Dh;
L.time = fT;
L.createTimeRange = Dt(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", Ct);
L.createTimeRanges = Dt(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", Ct);
L.formatTime = Dt(9, "videojs.formatTime", "videojs.time.formatTime", Mi);
L.setFormatTime = Dt(9, "videojs.setFormatTime", "videojs.time.setFormatTime", nf);
L.resetFormatTime = Dt(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", af);
L.parseUrl = Dt(9, "videojs.parseUrl", "videojs.url.parseUrl", qu);
L.isCrossOrigin = Dt(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", Ma);
L.EventTarget = ht;
L.any = Bu;
L.on = dt;
L.one = La;
L.off = He;
L.trigger = Is;
L.xhr = Rd;
L.TrackList = Ni;
L.TextTrack = Gr;
L.TextTrackList = $u;
L.AudioTrack = df;
L.AudioTrackList = uf;
L.VideoTrack = hf;
L.VideoTrackList = lf;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach((ce) => {
  L[ce] = function() {
    return ae.warn(`videojs.${ce}() is deprecated; use videojs.dom.${ce}() instead`), Xh[ce].apply(null, arguments);
  };
});
L.computedStyle = Dt(9, "videojs.computedStyle", "videojs.dom.computedStyle", Cs);
L.dom = Xh;
L.fn = oT;
L.num = VT;
L.str = dT;
L.url = vT;
L.Error = pv;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
class mv {
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  constructor(ie) {
    let me = this;
    return me.id = ie.id, me.label = me.id, me.width = ie.width, me.height = ie.height, me.bitrate = ie.bandwidth, me.frameRate = ie.frameRate, me.enabled_ = ie.enabled, Object.defineProperty(me, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get() {
        return me.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set(we) {
        me.enabled_(we);
      }
    }), me;
  }
}
class ca extends L.EventTarget {
  /**
   * Creates a QualityLevelList.
   */
  constructor() {
    super();
    let ie = this;
    return ie.levels_ = [], ie.selectedIndex_ = -1, Object.defineProperty(ie, "selectedIndex", {
      get() {
        return ie.selectedIndex_;
      }
    }), Object.defineProperty(ie, "length", {
      get() {
        return ie.levels_.length;
      }
    }), ie[Symbol.iterator] = () => ie.levels_.values(), ie;
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */
  addQualityLevel(ie) {
    let me = this.getQualityLevelById(ie.id);
    if (me)
      return me;
    const we = this.levels_.length;
    return me = new mv(ie), "" + we in this || Object.defineProperty(this, we, {
      get() {
        return this.levels_[we];
      }
    }), this.levels_.push(me), this.trigger({
      qualityLevel: me,
      type: "addqualitylevel"
    }), me;
  }
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */
  removeQualityLevel(ie) {
    let me = null;
    for (let we = 0, Re = this.length; we < Re; we++)
      if (this[we] === ie) {
        me = this.levels_.splice(we, 1)[0], this.selectedIndex_ === we ? this.selectedIndex_ = -1 : this.selectedIndex_ > we && this.selectedIndex_--;
        break;
      }
    return me && this.trigger({
      qualityLevel: ie,
      type: "removequalitylevel"
    }), me;
  }
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */
  getQualityLevelById(ie) {
    for (let me = 0, we = this.length; me < we; me++) {
      const Re = this[me];
      if (Re.id === ie)
        return Re;
    }
    return null;
  }
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */
  dispose() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }
}
ca.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (const ce in ca.prototype.allowedEvents_)
  ca.prototype["on" + ce] = null;
var Wf = "4.1.0";
const gv = function(ce, ie) {
  const me = ce.qualityLevels, we = new ca(), Re = function() {
    we.dispose(), ce.qualityLevels = me, ce.off("dispose", Re);
  };
  return ce.on("dispose", Re), ce.qualityLevels = () => we, ce.qualityLevels.VERSION = Wf, we;
}, Gf = function(ce) {
  return gv(this, L.obj.merge({}, ce));
};
L.registerPlugin("qualityLevels", Gf);
Gf.VERSION = Wf;
/*! @name @videojs/http-streaming @version 3.17.0 @license Apache-2.0 */
const it = _a, da = (ce, ie) => ie && ie.responseURL && ce !== ie.responseURL ? ie.responseURL : ce, yt = (ce) => L.log.debug ? L.log.debug.bind(L, "VHS:", `${ce} >`) : function() {
};
function fe$1(...ce) {
  const ie = L.obj || L;
  return (ie.merge || ie.mergeOptions).apply(ie, ce);
}
function Be(...ce) {
  const ie = L.time || L;
  return (ie.createTimeRanges || ie.createTimeRanges).apply(ie, ce);
}
function _v(ce) {
  if (ce.length === 0)
    return "Buffered Ranges are empty";
  let ie = `Buffered Ranges: 
`;
  for (let me = 0; me < ce.length; me++) {
    const we = ce.start(me), Re = ce.end(me);
    ie += `${we} --> ${Re}. Duration (${Re - we})
`;
  }
  return ie;
}
const Bt = 1 / 30, Ft = Bt * 3, Xf = function(ce, ie) {
  const me = [];
  let we;
  if (ce && ce.length)
    for (we = 0; we < ce.length; we++)
      ie(ce.start(we), ce.end(we)) && me.push([ce.start(we), ce.end(we)]);
  return Be(me);
}, rs = function(ce, ie) {
  return Xf(ce, function(me, we) {
    return me - Ft <= ie && we + Ft >= ie;
  });
}, Mn = function(ce, ie) {
  return Xf(ce, function(me) {
    return me - Bt >= ie;
  });
}, yv = function(ce) {
  if (ce.length < 2)
    return Be();
  const ie = [];
  for (let me = 1; me < ce.length; me++) {
    const we = ce.end(me - 1), Re = ce.start(me);
    ie.push([we, Re]);
  }
  return Be(ie);
}, Tv = function(ce, ie) {
  let me = null, we = null, Re = 0;
  const je = [], Ue = [];
  if (!ce || !ce.length || !ie || !ie.length)
    return Be();
  let qe = ce.length;
  for (; qe--; )
    je.push({
      time: ce.start(qe),
      type: "start"
    }), je.push({
      time: ce.end(qe),
      type: "end"
    });
  for (qe = ie.length; qe--; )
    je.push({
      time: ie.start(qe),
      type: "start"
    }), je.push({
      time: ie.end(qe),
      type: "end"
    });
  for (je.sort(function(Ge, Xe) {
    return Ge.time - Xe.time;
  }), qe = 0; qe < je.length; qe++)
    je[qe].type === "start" ? (Re++, Re === 2 && (me = je[qe].time)) : je[qe].type === "end" && (Re--, Re === 1 && (we = je[qe].time)), me !== null && we !== null && (Ue.push([me, we]), me = null, we = null);
  return Be(Ue);
}, Kf = (ce) => {
  const ie = [];
  if (!ce || !ce.length)
    return "";
  for (let me = 0; me < ce.length; me++)
    ie.push(ce.start(me) + " => " + ce.end(me));
  return ie.join(", ");
}, vv = function(ce, ie, me = 1) {
  return ((ce.length ? ce.end(ce.length - 1) : 0) - ie) / me;
}, wi = (ce) => {
  const ie = [];
  for (let me = 0; me < ce.length; me++)
    ie.push({
      start: ce.start(me),
      end: ce.end(me)
    });
  return ie;
}, bv = function(ce, ie) {
  if (ce === ie)
    return !1;
  if (!ce && ie || !ie && ce || ce.length !== ie.length)
    return !0;
  for (let me = 0; me < ce.length; me++)
    if (ce.start(me) !== ie.start(me) || ce.end(me) !== ie.end(me))
      return !0;
  return !1;
}, Oo = function(ce) {
  if (!(!ce || !ce.length || !ce.end))
    return ce.end(ce.length - 1);
}, nl = function(ce, ie) {
  let me = 0;
  if (!ce || !ce.length)
    return me;
  for (let we = 0; we < ce.length; we++) {
    const Re = ce.start(we), je = ce.end(we);
    if (!(ie > je)) {
      if (ie > Re && ie <= je) {
        me += je - ie;
        continue;
      }
      me += je - Re;
    }
  }
  return me;
}, al = (ce, ie) => {
  if (!ie.preload)
    return ie.duration;
  let me = 0;
  return (ie.parts || []).forEach(function(we) {
    me += we.duration;
  }), (ie.preloadHints || []).forEach(function(we) {
    we.type === "PART" && (me += ce.partTargetDuration);
  }), me;
}, tu = (ce) => (ce.segments || []).reduce((ie, me, we) => (me.parts ? me.parts.forEach(function(Re, je) {
  ie.push({
    duration: Re.duration,
    segmentIndex: we,
    partIndex: je,
    part: Re,
    segment: me
  });
}) : ie.push({
  duration: me.duration,
  segmentIndex: we,
  partIndex: null,
  segment: me,
  part: null
}), ie), []), Yf = (ce) => {
  const ie = ce.segments && ce.segments.length && ce.segments[ce.segments.length - 1];
  return ie && ie.parts || [];
}, Qf = ({
  preloadSegment: ce
}) => {
  if (!ce)
    return;
  const {
    parts: ie,
    preloadHints: me
  } = ce;
  let we = (me || []).reduce((Re, je) => Re + (je.type === "PART" ? 1 : 0), 0);
  return we += ie && ie.length ? ie.length : 0, we;
}, Jf = (ce, ie) => {
  if (ie.endList)
    return 0;
  if (ce && ce.suggestedPresentationDelay)
    return ce.suggestedPresentationDelay;
  const me = Yf(ie).length > 0;
  return me && ie.serverControl && ie.serverControl.partHoldBack ? ie.serverControl.partHoldBack : me && ie.partTargetDuration ? ie.partTargetDuration * 3 : ie.serverControl && ie.serverControl.holdBack ? ie.serverControl.holdBack : ie.targetDuration ? ie.targetDuration * 3 : 0;
}, xv = function(ce, ie) {
  let me = 0, we = ie - ce.mediaSequence, Re = ce.segments[we];
  if (Re) {
    if (typeof Re.start < "u")
      return {
        result: Re.start,
        precise: !0
      };
    if (typeof Re.end < "u")
      return {
        result: Re.end - Re.duration,
        precise: !0
      };
  }
  for (; we--; ) {
    if (Re = ce.segments[we], typeof Re.end < "u")
      return {
        result: me + Re.end,
        precise: !0
      };
    if (me += al(ce, Re), typeof Re.start < "u")
      return {
        result: me + Re.start,
        precise: !0
      };
  }
  return {
    result: me,
    precise: !1
  };
}, Sv = function(ce, ie) {
  let me = 0, we, Re = ie - ce.mediaSequence;
  for (; Re < ce.segments.length; Re++) {
    if (we = ce.segments[Re], typeof we.start < "u")
      return {
        result: we.start - me,
        precise: !0
      };
    if (me += al(ce, we), typeof we.end < "u")
      return {
        result: we.end - me,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, Zf = function(ce, ie, me) {
  if (typeof ie > "u" && (ie = ce.mediaSequence + ce.segments.length), ie < ce.mediaSequence)
    return 0;
  const we = xv(ce, ie);
  if (we.precise)
    return we.result;
  const Re = Sv(ce, ie);
  return Re.precise ? Re.result : we.result + me;
}, ep = function(ce, ie, me) {
  if (!ce)
    return 0;
  if (typeof me != "number" && (me = 0), typeof ie > "u") {
    if (ce.totalDuration)
      return ce.totalDuration;
    if (!ce.endList)
      return S.Infinity;
  }
  return Zf(ce, ie, me);
}, Pr = function({
  defaultDuration: ce,
  durationList: ie,
  startIndex: me,
  endIndex: we
}) {
  let Re = 0;
  if (me > we && ([me, we] = [we, me]), me < 0) {
    for (let je = me; je < Math.min(0, we); je++)
      Re += ce;
    me = 0;
  }
  for (let je = me; je < we; je++)
    Re += ie[je].duration;
  return Re;
}, tp = function(ce, ie, me, we) {
  if (!ce || !ce.segments)
    return null;
  if (ce.endList)
    return ep(ce);
  if (ie === null)
    return null;
  ie = ie || 0;
  let Re = Zf(ce, ce.mediaSequence + ce.segments.length, ie);
  return me && (we = typeof we == "number" ? we : Jf(null, ce), Re -= we), Math.max(0, Re);
}, Ev = function(ce, ie, me) {
  const we = ie || 0;
  let Re = tp(ce, ie, !0, me);
  return Re === null ? Be() : (Re < we && (Re = we), Be(we, Re));
}, Cv = function({
  playlist: ce,
  currentTime: ie,
  startingSegmentIndex: me,
  startingPartIndex: we,
  startTime: Re,
  exactManifestTimings: je
}) {
  let Ue = ie - Re;
  const qe = tu(ce);
  let Ge = 0;
  for (let Xe = 0; Xe < qe.length; Xe++) {
    const ot = qe[Xe];
    if (me === ot.segmentIndex && !(typeof we == "number" && typeof ot.partIndex == "number" && we !== ot.partIndex)) {
      Ge = Xe;
      break;
    }
  }
  if (Ue < 0) {
    if (Ge > 0)
      for (let Xe = Ge - 1; Xe >= 0; Xe--) {
        const ot = qe[Xe];
        if (Ue += ot.duration, je) {
          if (Ue < 0)
            continue;
        } else if (Ue + Bt <= 0)
          continue;
        return {
          partIndex: ot.partIndex,
          segmentIndex: ot.segmentIndex,
          startTime: Re - Pr({
            defaultDuration: ce.targetDuration,
            durationList: qe,
            startIndex: Ge,
            endIndex: Xe
          })
        };
      }
    return {
      partIndex: qe[0] && qe[0].partIndex || null,
      segmentIndex: qe[0] && qe[0].segmentIndex || 0,
      startTime: ie
    };
  }
  if (Ge < 0) {
    for (let Xe = Ge; Xe < 0; Xe++)
      if (Ue -= ce.targetDuration, Ue < 0)
        return {
          partIndex: qe[0] && qe[0].partIndex || null,
          segmentIndex: qe[0] && qe[0].segmentIndex || 0,
          startTime: ie
        };
    Ge = 0;
  }
  for (let Xe = Ge; Xe < qe.length; Xe++) {
    const ot = qe[Xe];
    Ue -= ot.duration;
    const vt = ot.duration > Bt, bt = Ue === 0, Tt = vt && Ue + Bt >= 0;
    if (!((bt || Tt) && Xe !== qe.length - 1)) {
      if (je) {
        if (Ue > 0)
          continue;
      } else if (Ue - Bt >= 0)
        continue;
      return {
        partIndex: ot.partIndex,
        segmentIndex: ot.segmentIndex,
        startTime: Re + Pr({
          defaultDuration: ce.targetDuration,
          durationList: qe,
          startIndex: Ge,
          endIndex: Xe
        })
      };
    }
  }
  return {
    segmentIndex: qe[qe.length - 1].segmentIndex,
    partIndex: qe[qe.length - 1].partIndex,
    startTime: ie
  };
}, ip$1 = function(ce) {
  return ce.excludeUntil && ce.excludeUntil > Date.now();
}, ol = function(ce) {
  return ce.excludeUntil && ce.excludeUntil === 1 / 0;
}, Ua = function(ce) {
  const ie = ip$1(ce);
  return !ce.disabled && !ie;
}, Av = function(ce) {
  return ce.disabled;
}, Dv = function(ce) {
  for (let ie = 0; ie < ce.segments.length; ie++)
    if (ce.segments[ie].key)
      return !0;
  return !1;
}, sp = function(ce, ie) {
  return ie.attributes && ie.attributes[ce];
}, wv = function(ce, ie, me, we = 0) {
  return sp("BANDWIDTH", me) ? (ce * me.attributes.BANDWIDTH - we * 8) / ie : NaN;
}, iu = (ce, ie) => {
  if (ce.playlists.length === 1)
    return !0;
  const me = ie.attributes.BANDWIDTH || Number.MAX_VALUE;
  return ce.playlists.filter((we) => Ua(we) ? (we.attributes.BANDWIDTH || 0) < me : !1).length === 0;
}, ul = (ce, ie) => !ce && !ie || !ce && ie || ce && !ie ? !1 : !!(ce === ie || ce.id && ie.id && ce.id === ie.id || ce.resolvedUri && ie.resolvedUri && ce.resolvedUri === ie.resolvedUri || ce.uri && ie.uri && ce.uri === ie.uri), od = function(ce, ie) {
  const me = ce && ce.mediaGroups && ce.mediaGroups.AUDIO || {};
  let we = !1;
  for (const Re in me) {
    for (const je in me[Re])
      if (we = ie(me[Re][je]), we)
        break;
    if (we)
      break;
  }
  return !!we;
}, Qr = (ce) => {
  if (!ce || !ce.playlists || !ce.playlists.length)
    return od(ce, (ie) => ie.playlists && ie.playlists.length || ie.uri);
  for (let ie = 0; ie < ce.playlists.length; ie++) {
    const me = ce.playlists[ie], we = me.attributes && me.attributes.CODECS;
    if (!(we && we.split(",").every((Re) => $d(Re)) || od(ce, (Re) => ul(me, Re))))
      return !1;
  }
  return !0;
};
var st = {
  liveEdgeDelay: Jf,
  duration: ep,
  seekable: Ev,
  getMediaInfoForTime: Cv,
  isEnabled: Ua,
  isDisabled: Av,
  isExcluded: ip$1,
  isIncompatible: ol,
  playlistEnd: tp,
  isAes: Dv,
  hasAttribute: sp,
  estimateSegmentRequestTime: wv,
  isLowestEnabledRendition: iu,
  isAudioOnly: Qr,
  playlistMatch: ul,
  segmentDurationWithParts: al
};
const {
  log: rp
} = L, cs = (ce, ie) => `${ce}-${ie}`, np = (ce, ie, me) => `placeholder-uri-${ce}-${ie}-${me}`, kv = ({
  onwarn: ce,
  oninfo: ie,
  manifestString: me,
  customTagParsers: we = [],
  customTagMappers: Re = [],
  llhls: je
}) => {
  const Ue = new W0();
  ce && Ue.on("warn", ce), ie && Ue.on("info", ie), we.forEach((Xe) => Ue.addParser(Xe)), Re.forEach((Xe) => Ue.addTagMapper(Xe)), Ue.push(me), Ue.end();
  const qe = Ue.manifest;
  if (je || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(Xe) {
    qe.hasOwnProperty(Xe) && delete qe[Xe];
  }), qe.segments && qe.segments.forEach(function(Xe) {
    ["parts", "preloadHints"].forEach(function(ot) {
      Xe.hasOwnProperty(ot) && delete Xe[ot];
    });
  })), !qe.targetDuration) {
    let Xe = 10;
    qe.segments && qe.segments.length && (Xe = qe.segments.reduce((ot, vt) => Math.max(ot, vt.duration), 0)), ce && ce({
      message: `manifest has no targetDuration defaulting to ${Xe}`
    }), qe.targetDuration = Xe;
  }
  const Ge = Yf(qe);
  if (Ge.length && !qe.partTargetDuration) {
    const Xe = Ge.reduce((ot, vt) => Math.max(ot, vt.duration), 0);
    ce && (ce({
      message: `manifest has no partTargetDuration defaulting to ${Xe}`
    }), rp.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), qe.partTargetDuration = Xe;
  }
  return qe;
}, Rs = (ce, ie) => {
  ce.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((me) => {
    if (ce.mediaGroups[me])
      for (const we in ce.mediaGroups[me])
        for (const Re in ce.mediaGroups[me][we]) {
          const je = ce.mediaGroups[me][we][Re];
          ie(je, me, we, Re);
        }
  });
}, ap = ({
  playlist: ce,
  uri: ie,
  id: me
}) => {
  ce.id = me, ce.playlistErrors_ = 0, ie && (ce.uri = ie), ce.attributes = ce.attributes || {};
}, Iv = (ce) => {
  let ie = ce.playlists.length;
  for (; ie--; ) {
    const me = ce.playlists[ie];
    ap({
      playlist: me,
      id: cs(ie, me.uri)
    }), me.resolvedUri = it(ce.uri, me.uri), ce.playlists[me.id] = me, ce.playlists[me.uri] = me, me.attributes.BANDWIDTH || rp.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, Pv = (ce) => {
  Rs(ce, (ie) => {
    ie.uri && (ie.resolvedUri = it(ce.uri, ie.uri));
  });
}, Ov = (ce, ie) => {
  const me = cs(0, ie), we = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: S.location.href,
    resolvedUri: S.location.href,
    playlists: [{
      uri: ie,
      id: me,
      resolvedUri: ie,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return we.playlists[me] = we.playlists[0], we.playlists[ie] = we.playlists[0], we;
}, op$1 = (ce, ie, me = np) => {
  ce.uri = ie;
  for (let Re = 0; Re < ce.playlists.length; Re++)
    if (!ce.playlists[Re].uri) {
      const je = `placeholder-uri-${Re}`;
      ce.playlists[Re].uri = je;
    }
  const we = Qr(ce);
  Rs(ce, (Re, je, Ue, qe) => {
    if (!Re.playlists || !Re.playlists.length) {
      if (we && je === "AUDIO" && !Re.uri)
        for (let Ge = 0; Ge < ce.playlists.length; Ge++) {
          const Xe = ce.playlists[Ge];
          if (Xe.attributes && Xe.attributes.AUDIO && Xe.attributes.AUDIO === Ue)
            return;
        }
      Re.playlists = [Oe$1({}, Re)];
    }
    Re.playlists.forEach(function(Ge, Xe) {
      const ot = me(je, Ue, qe, Ge), vt = cs(Xe, ot);
      Ge.uri ? Ge.resolvedUri = Ge.resolvedUri || it(ce.uri, Ge.uri) : (Ge.uri = Xe === 0 ? ot : vt, Ge.resolvedUri = Ge.uri), Ge.id = Ge.id || vt, Ge.attributes = Ge.attributes || {}, ce.playlists[Ge.id] = Ge, ce.playlists[Ge.uri] = Ge;
    });
  }), Iv(ce), Pv(ce);
};
class ud {
  constructor() {
    this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
  }
  setOffset(ie = []) {
    if (this.offset_ !== null || !ie.length)
      return;
    const [me] = ie;
    me.programDateTime !== void 0 && (this.offset_ = me.programDateTime / 1e3);
  }
  setPendingDateRanges(ie = []) {
    if (!ie.length)
      return;
    const [me] = ie, we = me.startDate.getTime();
    this.trimProcessedDateRanges_(we), this.pendingDateRanges_ = ie.reduce((Re, je) => (Re.set(je.id, je), Re), /* @__PURE__ */ new Map());
  }
  processDateRange(ie) {
    this.pendingDateRanges_.delete(ie.id), this.processedDateRanges_.set(ie.id, ie);
  }
  getDateRangesToProcess() {
    if (this.offset_ === null)
      return [];
    const ie = {}, me = [];
    this.pendingDateRanges_.forEach((we, Re) => {
      if (!this.processedDateRanges_.has(Re) && (we.startTime = we.startDate.getTime() / 1e3 - this.offset_, we.processDateRange = () => this.processDateRange(we), me.push(we), !!we.class))
        if (ie[we.class]) {
          const je = ie[we.class].push(we);
          we.classListIndex = je - 1;
        } else
          ie[we.class] = [we], we.classListIndex = 0;
    });
    for (const we of me) {
      const Re = ie[we.class] || [];
      we.endDate ? we.endTime = we.endDate.getTime() / 1e3 - this.offset_ : we.endOnNext && Re[we.classListIndex + 1] ? we.endTime = Re[we.classListIndex + 1].startTime : we.duration ? we.endTime = we.startTime + we.duration : we.plannedDuration ? we.endTime = we.startTime + we.plannedDuration : we.endTime = we.startTime;
    }
    return me;
  }
  trimProcessedDateRanges_(ie) {
    new Map(this.processedDateRanges_).forEach((me, we) => {
      me.startDate.getTime() < ie && this.processedDateRanges_.delete(we);
    });
  }
}
const up = 22, Li = ({
  requestType: ce,
  request: ie,
  error: me,
  parseFailure: we
}) => {
  const Re = ie.status < 200 || ie.status > 299, je = ie.status >= 400 && ie.status <= 499, Ue = {
    uri: ie.uri,
    requestType: ce
  }, qe = Re && !je || we;
  if (me && je)
    Ue.error = Oe$1({}, me), Ue.errorType = L.Error.NetworkRequestFailed;
  else if (ie.aborted)
    Ue.errorType = L.Error.NetworkRequestAborted;
  else if (ie.timedout)
    Ue.erroType = L.Error.NetworkRequestTimeout;
  else if (qe) {
    const Ge = we ? L.Error.NetworkBodyParserFailed : L.Error.NetworkBadStatus;
    Ue.errorType = Ge, Ue.status = ie.status, Ue.headers = ie.headers;
  }
  return Ue;
}, Lv = yt("CodecUtils"), lp = function(ce) {
  const ie = ce.attributes || {};
  if (ie.CODECS)
    return Rt(ie.CODECS);
}, cp = (ce, ie) => {
  const me = ie.attributes || {};
  return ce && ce.mediaGroups && ce.mediaGroups.AUDIO && me.AUDIO && ce.mediaGroups.AUDIO[me.AUDIO];
}, Rv = (ce, ie) => {
  if (!cp(ce, ie))
    return !0;
  const me = ie.attributes || {}, we = ce.mediaGroups.AUDIO[me.AUDIO];
  for (const Re in we)
    if (!we[Re].uri && !we[Re].playlists)
      return !0;
  return !1;
}, $r = function(ce) {
  const ie = {};
  return ce.forEach(({
    mediaType: me,
    type: we,
    details: Re
  }) => {
    ie[me] = ie[me] || [], ie[me].push(Ud(`${we}${Re}`));
  }), Object.keys(ie).forEach(function(me) {
    if (ie[me].length > 1) {
      Lv(`multiple ${me} codecs found as attributes: ${ie[me].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), ie[me] = null;
      return;
    }
    ie[me] = ie[me][0];
  }), ie;
}, ld = function(ce) {
  let ie = 0;
  return ce.audio && ie++, ce.video && ie++, ie;
}, Or = function(ce, ie) {
  const me = ie.attributes || {}, we = $r(lp(ie) || []);
  if (cp(ce, ie) && !we.audio && !Rv(ce, ie)) {
    const Re = $r(X0(ce, me.AUDIO) || []);
    Re.audio && (we.audio = Re.audio);
  }
  return we;
}, {
  EventTarget: Mv
} = L, Nv = (ce, ie) => {
  if (ie.endList || !ie.serverControl)
    return ce;
  const me = {};
  if (ie.serverControl.canBlockReload) {
    const {
      preloadSegment: we
    } = ie;
    let Re = ie.mediaSequence + ie.segments.length;
    if (we) {
      const je = we.parts || [], Ue = Qf(ie) - 1;
      Ue > -1 && Ue !== je.length - 1 && (me._HLS_part = Ue), (Ue > -1 || je.length) && Re--;
    }
    me._HLS_msn = Re;
  }
  if (ie.serverControl && ie.serverControl.canSkipUntil && (me._HLS_skip = ie.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(me).length) {
    const we = new S.URL(ce);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(Re) {
      me.hasOwnProperty(Re) && we.searchParams.set(Re, me[Re]);
    }), ce = we.toString();
  }
  return ce;
}, Bv = (ce, ie) => {
  if (!ce)
    return ie;
  const me = fe$1(ce, ie);
  if (ce.preloadHints && !ie.preloadHints && delete me.preloadHints, ce.parts && !ie.parts)
    delete me.parts;
  else if (ce.parts && ie.parts)
    for (let we = 0; we < ie.parts.length; we++)
      ce.parts && ce.parts[we] && (me.parts[we] = fe$1(ce.parts[we], ie.parts[we]));
  return !ce.skipped && ie.skipped && (me.skipped = !1), ce.preload && !ie.preload && (me.preload = !1), me;
}, Fv = (ce, ie, me) => {
  const we = ce.slice(), Re = ie.slice();
  me = me || 0;
  const je = [];
  let Ue;
  for (let qe = 0; qe < Re.length; qe++) {
    const Ge = we[qe + me], Xe = Re[qe];
    Ge ? (Ue = Ge.map || Ue, je.push(Bv(Ge, Xe))) : (Ue && !Xe.map && (Xe.map = Ue), je.push(Xe));
  }
  return je;
}, dp = (ce, ie) => {
  !ce.resolvedUri && ce.uri && (ce.resolvedUri = it(ie, ce.uri)), ce.key && !ce.key.resolvedUri && (ce.key.resolvedUri = it(ie, ce.key.uri)), ce.map && !ce.map.resolvedUri && (ce.map.resolvedUri = it(ie, ce.map.uri)), ce.map && ce.map.key && !ce.map.key.resolvedUri && (ce.map.key.resolvedUri = it(ie, ce.map.key.uri)), ce.parts && ce.parts.length && ce.parts.forEach((me) => {
    me.resolvedUri || (me.resolvedUri = it(ie, me.uri));
  }), ce.preloadHints && ce.preloadHints.length && ce.preloadHints.forEach((me) => {
    me.resolvedUri || (me.resolvedUri = it(ie, me.uri));
  });
}, hp = function(ce) {
  const ie = ce.segments || [], me = ce.preloadSegment;
  if (me && me.parts && me.parts.length) {
    if (me.preloadHints) {
      for (let we = 0; we < me.preloadHints.length; we++)
        if (me.preloadHints[we].type === "MAP")
          return ie;
    }
    me.duration = ce.targetDuration, me.preload = !0, ie.push(me);
  }
  return ie;
}, fp = (ce, ie) => ce === ie || ce.segments && ie.segments && ce.segments.length === ie.segments.length && ce.endList === ie.endList && ce.mediaSequence === ie.mediaSequence && ce.preloadSegment === ie.preloadSegment, su = (ce, ie, me = fp) => {
  const we = fe$1(ce, {}), Re = we.playlists[ie.id];
  if (!Re || me(Re, ie))
    return null;
  ie.segments = hp(ie);
  const je = fe$1(Re, ie);
  if (je.preloadSegment && !ie.preloadSegment && delete je.preloadSegment, Re.segments) {
    if (ie.skip) {
      ie.segments = ie.segments || [];
      for (let Ue = 0; Ue < ie.skip.skippedSegments; Ue++)
        ie.segments.unshift({
          skipped: !0
        });
    }
    je.segments = Fv(Re.segments, ie.segments, ie.mediaSequence - Re.mediaSequence);
  }
  je.segments.forEach((Ue) => {
    dp(Ue, je.resolvedUri);
  });
  for (let Ue = 0; Ue < we.playlists.length; Ue++)
    we.playlists[Ue].id === ie.id && (we.playlists[Ue] = je);
  return we.playlists[ie.id] = je, we.playlists[ie.uri] = je, Rs(ce, (Ue, qe, Ge, Xe) => {
    if (Ue.playlists)
      for (let ot = 0; ot < Ue.playlists.length; ot++)
        ie.id === Ue.playlists[ot].id && (Ue.playlists[ot] = je);
  }), we;
}, ru = (ce, ie) => {
  const me = ce.segments || [], we = me[me.length - 1], Re = we && we.parts && we.parts[we.parts.length - 1], je = Re && Re.duration || we && we.duration;
  return ie && je ? je * 1e3 : (ce.partTargetDuration || ce.targetDuration || 10) * 500;
}, cd = (ce, ie, me) => {
  if (!ce)
    return;
  const we = [];
  return ce.forEach((Re) => {
    if (!Re.attributes)
      return;
    const {
      BANDWIDTH: je,
      RESOLUTION: Ue,
      CODECS: qe
    } = Re.attributes;
    we.push({
      id: Re.id,
      bandwidth: je,
      resolution: Ue,
      codecs: qe
    });
  }), {
    type: ie,
    isLive: me,
    renditions: we
  };
};
class ns extends Mv {
  constructor(ie, me, we = {}) {
    if (super(), !ie)
      throw new Error("A non-empty playlist URL or object is required");
    this.logger_ = yt("PlaylistLoader");
    const {
      withCredentials: Re = !1
    } = we;
    this.src = ie, this.vhs_ = me, this.withCredentials = Re, this.addDateRangesToTextTrack_ = we.addDateRangesToTextTrack;
    const je = me.options_;
    this.customTagParsers = je && je.customTagParsers || [], this.customTagMappers = je && je.customTagMappers || [], this.llhls = je && je.llhls, this.dateRangesStorage_ = new ud(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
  }
  handleLoadedPlaylist_() {
    const ie = this.media();
    if (!ie)
      return;
    this.dateRangesStorage_.setOffset(ie.segments), this.dateRangesStorage_.setPendingDateRanges(ie.dateRanges);
    const me = this.dateRangesStorage_.getDateRangesToProcess();
    !me.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(me);
  }
  handleMediaupdatetimeout_() {
    if (this.state !== "HAVE_METADATA")
      return;
    const ie = this.media();
    let me = it(this.main.uri, ie.uri);
    this.llhls && (me = Nv(me, ie)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
      uri: me,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (we, Re) => {
      if (this.request) {
        if (we)
          return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
        this.haveMetadata({
          playlistString: this.request.responseText,
          url: this.media().uri,
          id: this.media().id
        });
      }
    });
  }
  playlistRequestError(ie, me, we) {
    const {
      uri: Re,
      id: je
    } = me;
    this.request = null, we && (this.state = we), this.error = {
      playlist: this.main.playlists[je],
      status: ie.status,
      message: `HLS playlist request error at URL: ${Re}.`,
      responseText: ie.responseText,
      code: ie.status >= 500 ? 4 : 2,
      metadata: Li({
        requestType: ie.requestType,
        request: ie,
        error: ie.error
      })
    }, this.trigger("error");
  }
  parseManifest_({
    url: ie,
    manifestString: me
  }) {
    try {
      const we = kv({
        onwarn: ({
          message: Re
        }) => this.logger_(`m3u8-parser warn for ${ie}: ${Re}`),
        oninfo: ({
          message: Re
        }) => this.logger_(`m3u8-parser info for ${ie}: ${Re}`),
        manifestString: me,
        customTagParsers: this.customTagParsers,
        customTagMappers: this.customTagMappers,
        llhls: this.llhls
      });
      return !we.playlists || !we.playlists.length || this.excludeAudioOnlyVariants(we.playlists), we;
    } catch (we) {
      this.error = we, this.error.metadata = {
        errorType: L.Error.StreamingHlsPlaylistParserError,
        error: we
      };
    }
  }
  excludeAudioOnlyVariants(ie) {
    const me = (we) => {
      const Re = we.attributes || {}, {
        width: je,
        height: Ue
      } = Re.RESOLUTION || {};
      if (je && Ue)
        return !0;
      const qe = lp(we) || [];
      return !!$r(qe).video;
    };
    ie.some(me) && ie.forEach((we) => {
      me(we) || (we.excludeUntil = 1 / 0);
    });
  }
  /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */
  haveMetadata({
    playlistString: ie,
    playlistObject: me,
    url: we,
    id: Re
  }) {
    this.request = null, this.state = "HAVE_METADATA";
    const je = {
      playlistInfo: {
        type: "media",
        uri: we
      }
    };
    this.trigger({
      type: "playlistparsestart",
      metadata: je
    });
    const Ue = me || this.parseManifest_({
      url: we,
      manifestString: ie
    });
    Ue.lastRequest = Date.now(), ap({
      playlist: Ue,
      uri: we,
      id: Re
    });
    const qe = su(this.main, Ue);
    this.targetDuration = Ue.partTargetDuration || Ue.targetDuration, this.pendingMedia_ = null, qe ? (this.main = qe, this.media_ = this.main.playlists[Re]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(ru(this.media(), !!qe)), je.parsedPlaylist = cd(this.main.playlists, je.playlistInfo.type, !this.media_.endList), this.trigger({
      type: "playlistparsecomplete",
      metadata: je
    }), this.trigger("loadedplaylist");
  }
  /**
    * Abort any outstanding work and clean up.
    */
  dispose() {
    this.trigger("dispose"), this.stopRequest(), S.clearTimeout(this.mediaUpdateTimeout), S.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new ud(), this.off();
  }
  stopRequest() {
    if (this.request) {
      const ie = this.request;
      this.request = null, ie.onreadystatechange = null, ie.abort();
    }
  }
  /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */
  media(ie, me) {
    if (!ie)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof ie == "string") {
      if (!this.main.playlists[ie])
        throw new Error("Unknown playlist URI: " + ie);
      ie = this.main.playlists[ie];
    }
    if (S.clearTimeout(this.finalRenditionTimeout), me) {
      const qe = (ie.partTargetDuration || ie.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = S.setTimeout(this.media.bind(this, ie, !1), qe);
      return;
    }
    const we = this.state, Re = !this.media_ || ie.id !== this.media_.id, je = this.main.playlists[ie.id];
    if (je && je.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    ie.endList && ie.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = ie, Re && (this.trigger("mediachanging"), we === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(ru(ie, !0)), !Re)
      return;
    if (this.state = "SWITCHING_MEDIA", this.request) {
      if (ie.resolvedUri === this.request.url)
        return;
      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
    }
    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = ie;
    const Ue = {
      playlistInfo: {
        type: "media",
        uri: ie.uri
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: Ue
    }), this.request = this.vhs_.xhr({
      uri: ie.resolvedUri,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (qe, Ge) => {
      if (this.request) {
        if (ie.lastRequest = Date.now(), ie.resolvedUri = da(ie.resolvedUri, Ge), qe)
          return this.playlistRequestError(this.request, ie, we);
        this.trigger({
          type: "playlistrequestcomplete",
          metadata: Ue
        }), this.haveMetadata({
          playlistString: Ge.responseText,
          url: ie.uri,
          id: ie.id
        }), we === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
      }
    });
  }
  /**
   * pause loading of the playlist
   */
  pause() {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }
  /**
   * start loading of the playlist
   */
  load(ie) {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    const me = this.media();
    if (ie) {
      const we = me ? (me.partTargetDuration || me.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = S.setTimeout(() => {
        this.mediaUpdateTimeout = null, this.load();
      }, we);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    me && !me.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }
  updateMediaUpdateTimeout_(ie) {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = S.setTimeout(() => {
      this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(ie);
    }, ie));
  }
  /**
   * start loading of the playlist
   */
  start() {
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = S.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
        this.setupInitialPlaylist(this.src);
      }, 0);
      return;
    }
    const ie = {
      playlistInfo: {
        type: "multivariant",
        uri: this.src
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: ie
    }), this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (me, we) => {
      if (!this.request)
        return;
      if (this.request = null, me)
        return this.error = {
          status: we.status,
          message: `HLS playlist request error at URL: ${this.src}.`,
          responseText: we.responseText,
          // MEDIA_ERR_NETWORK
          code: 2,
          metadata: Li({
            requestType: we.requestType,
            request: we,
            error: me
          })
        }, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
      this.trigger({
        type: "playlistrequestcomplete",
        metadata: ie
      }), this.src = da(this.src, we), this.trigger({
        type: "playlistparsestart",
        metadata: ie
      });
      const Re = this.parseManifest_({
        manifestString: we.responseText,
        url: this.src
      });
      ie.parsedPlaylist = cd(Re.playlists, ie.playlistInfo.type, !1), this.trigger({
        type: "playlistparsecomplete",
        metadata: ie
      }), this.setupInitialPlaylist(Re);
    });
  }
  srcUri() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }
  /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */
  setupInitialPlaylist(ie) {
    if (this.state = "HAVE_MAIN_MANIFEST", ie.playlists) {
      this.main = ie, op$1(this.main, this.srcUri()), ie.playlists.forEach((we) => {
        we.segments = hp(we), we.segments.forEach((Re) => {
          dp(Re, we.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
      return;
    }
    const me = this.srcUri() || S.location.href;
    this.main = Ov(ie, me), this.haveMetadata({
      playlistObject: ie,
      url: me,
      id: this.main.playlists[0].id
    }), this.trigger("loadedmetadata");
  }
  /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteClone(ie, me) {
    const we = this.main, Re = ie.ID;
    let je = we.playlists.length;
    for (; je--; ) {
      const Ue = we.playlists[je];
      if (Ue.attributes["PATHWAY-ID"] === Re) {
        const qe = Ue.resolvedUri, Ge = Ue.id;
        if (me) {
          const Xe = this.createCloneURI_(Ue.resolvedUri, ie), ot = cs(Re, Xe), vt = this.createCloneAttributes_(Re, Ue.attributes), bt = this.createClonePlaylist_(Ue, ot, ie, vt);
          we.playlists[je] = bt, we.playlists[ot] = bt, we.playlists[Xe] = bt;
        } else
          we.playlists.splice(je, 1);
        delete we.playlists[Ge], delete we.playlists[qe];
      }
    }
    this.updateOrDeleteCloneMedia(ie, me);
  }
  /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteCloneMedia(ie, me) {
    const we = this.main, Re = ie.ID;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((je) => {
      if (!(!we.mediaGroups[je] || !we.mediaGroups[je][Re])) {
        for (const Ue in we.mediaGroups[je])
          if (Ue === Re) {
            for (const qe in we.mediaGroups[je][Ue])
              we.mediaGroups[je][Ue][qe].playlists.forEach((Ge, Xe) => {
                const ot = we.playlists[Ge.id], vt = ot.id, bt = ot.resolvedUri;
                delete we.playlists[vt], delete we.playlists[bt];
              });
            delete we.mediaGroups[je][Ue];
          }
      }
    }), me && this.createClonedMediaGroups_(ie);
  }
  /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */
  addClonePathway(ie, me = {}) {
    const we = this.main, Re = we.playlists.length, je = this.createCloneURI_(me.resolvedUri, ie), Ue = cs(ie.ID, je), qe = this.createCloneAttributes_(ie.ID, me.attributes), Ge = this.createClonePlaylist_(me, Ue, ie, qe);
    we.playlists[Re] = Ge, we.playlists[Ue] = Ge, we.playlists[je] = Ge, this.createClonedMediaGroups_(ie);
  }
  /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */
  createClonedMediaGroups_(ie) {
    const me = ie.ID, we = ie["BASE-ID"], Re = this.main;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((je) => {
      if (!(!Re.mediaGroups[je] || Re.mediaGroups[je][me]))
        for (const Ue in Re.mediaGroups[je]) {
          if (Ue === we)
            Re.mediaGroups[je][me] = {};
          else
            continue;
          for (const qe in Re.mediaGroups[je][Ue]) {
            const Ge = Re.mediaGroups[je][Ue][qe];
            Re.mediaGroups[je][me][qe] = Oe$1({}, Ge);
            const Xe = Re.mediaGroups[je][me][qe], ot = this.createCloneURI_(Ge.resolvedUri, ie);
            Xe.resolvedUri = ot, Xe.uri = ot, Xe.playlists = [], Ge.playlists.forEach((vt, bt) => {
              const Tt = Re.playlists[vt.id], wt = np(je, me, qe), St = cs(me, wt);
              if (Tt && !Re.playlists[St]) {
                const It = this.createClonePlaylist_(Tt, St, ie), Pt = It.resolvedUri;
                Re.playlists[St] = It, Re.playlists[Pt] = It;
              }
              Xe.playlists[bt] = this.createClonePlaylist_(vt, St, ie);
            });
          }
        }
    });
  }
  /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */
  createClonePlaylist_(ie, me, we, Re) {
    const je = this.createCloneURI_(ie.resolvedUri, we), Ue = {
      resolvedUri: je,
      uri: je,
      id: me
    };
    return ie.segments && (Ue.segments = []), Re && (Ue.attributes = Re), fe$1(ie, Ue);
  }
  /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */
  createCloneURI_(ie, me) {
    const we = new URL(ie);
    we.hostname = me["URI-REPLACEMENT"].HOST;
    const Re = me["URI-REPLACEMENT"].PARAMS;
    for (const je of Object.keys(Re))
      we.searchParams.set(je, Re[je]);
    return we.href;
  }
  /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */
  createCloneAttributes_(ie, me) {
    const we = {
      "PATHWAY-ID": ie
    };
    return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((Re) => {
      me[Re] && (we[Re] = ie);
    }), we;
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(ie) {
    if (ie.contentProtection) {
      const me = /* @__PURE__ */ new Set();
      for (const we in ie.contentProtection) {
        const Re = ie.contentProtection[we].attributes.keyId;
        Re && me.add(Re.toLowerCase());
      }
      return me;
    }
  }
}
const nu = function(ce, ie, me, we) {
  const Re = ce.responseType === "arraybuffer" ? ce.response : ce.responseText;
  !ie && Re && (ce.responseTime = Date.now(), ce.roundTripTime = ce.responseTime - ce.requestTime, ce.bytesReceived = Re.byteLength || Re.length, ce.bandwidth || (ce.bandwidth = Math.floor(ce.bytesReceived / ce.roundTripTime * 8 * 1e3))), me.headers && (ce.responseHeaders = me.headers), ie && ie.code === "ETIMEDOUT" && (ce.timedout = !0), !ie && !ce.aborted && me.statusCode !== 200 && me.statusCode !== 206 && me.statusCode !== 0 && (ie = new Error("XHR Failed with a response of: " + (ce && (Re || ce.responseText)))), we(ie, ce);
}, Uv = (ce, ie) => {
  if (!ce || !ce.size)
    return;
  let me = ie;
  return ce.forEach((we) => {
    me = we(me);
  }), me;
}, $v = (ce, ie, me, we) => {
  !ce || !ce.size || ce.forEach((Re) => {
    Re(ie, me, we);
  });
}, pp = function() {
  const ce = function ie(me, we) {
    me = fe$1({
      timeout: 45e3
    }, me);
    const Re = ie.beforeRequest || L.Vhs.xhr.beforeRequest, je = ie._requestCallbackSet || L.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), Ue = ie._responseCallbackSet || L.Vhs.xhr._responseCallbackSet;
    Re && typeof Re == "function" && (L.log.warn("beforeRequest is deprecated, use onRequest instead."), je.add(Re));
    const qe = L.Vhs.xhr.original === !0 ? L.xhr : L.Vhs.xhr, Ge = Uv(je, me);
    je.delete(Re);
    const Xe = qe(Ge || me, function(vt, bt) {
      return $v(Ue, Xe, vt, bt), nu(Xe, vt, bt, we);
    }), ot = Xe.abort;
    return Xe.abort = function() {
      return Xe.aborted = !0, ot.apply(Xe, arguments);
    }, Xe.uri = me.uri, Xe.requestType = me.requestType, Xe.requestTime = Date.now(), Xe;
  };
  return ce.original = !0, ce;
}, jv = function(ce) {
  let ie;
  const me = ce.offset;
  return typeof ce.offset == "bigint" || typeof ce.length == "bigint" ? ie = S.BigInt(ce.offset) + S.BigInt(ce.length) - S.BigInt(1) : ie = ce.offset + ce.length - 1, "bytes=" + me + "-" + ie;
}, au = function(ce) {
  const ie = {};
  return ce.byterange && (ie.Range = jv(ce.byterange)), ie;
}, qv = function(ce, ie) {
  return ce.start(ie) + "-" + ce.end(ie);
}, Vv = function(ce, ie) {
  const me = ce.toString(16);
  return "00".substring(0, 2 - me.length) + me + (ie % 2 ? " " : "");
}, Hv = function(ce) {
  return ce >= 32 && ce < 126 ? String.fromCharCode(ce) : ".";
}, mp = function(ce) {
  const ie = {};
  return Object.keys(ce).forEach((me) => {
    const we = ce[me];
    qd(we) ? ie[me] = {
      bytes: we.buffer,
      byteOffset: we.byteOffset,
      byteLength: we.byteLength
    } : ie[me] = we;
  }), ie;
}, ha = function(ce) {
  const ie = ce.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [ie.length, ie.offset, ce.resolvedUri].join(",");
}, gp = function(ce) {
  return ce.resolvedUri;
}, _p = (ce) => {
  const ie = Array.prototype.slice.call(ce), me = 16;
  let we = "", Re, je;
  for (let Ue = 0; Ue < ie.length / me; Ue++)
    Re = ie.slice(Ue * me, Ue * me + me).map(Vv).join(""), je = ie.slice(Ue * me, Ue * me + me).map(Hv).join(""), we += Re + " " + je + `
`;
  return we;
}, zv = ({
  bytes: ce
}) => _p(ce), Wv = (ce) => {
  let ie = "", me;
  for (me = 0; me < ce.length; me++)
    ie += qv(ce, me) + " ";
  return ie;
};
var Gv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: mp,
  initSegmentId: ha,
  segmentKeyId: gp,
  hexDump: _p,
  tagDump: zv,
  textRanges: Wv
});
const yp = 0.25, Xv = (ce, ie) => {
  if (!ie.dateTimeObject)
    return null;
  const me = ie.videoTimingInfo.transmuxerPrependedSeconds, we = ie.videoTimingInfo.transmuxedPresentationStart + me, Re = ce - we;
  return new Date(ie.dateTimeObject.getTime() + Re * 1e3);
}, Kv = (ce) => ce.transmuxedPresentationEnd - ce.transmuxedPresentationStart - ce.transmuxerPrependedSeconds, Yv = (ce, ie) => {
  let me;
  try {
    me = new Date(ce);
  } catch {
    return null;
  }
  if (!ie || !ie.segments || ie.segments.length === 0)
    return null;
  let we = ie.segments[0];
  if (me < new Date(we.dateTimeObject))
    return null;
  for (let Ge = 0; Ge < ie.segments.length - 1; Ge++) {
    we = ie.segments[Ge];
    const Xe = new Date(ie.segments[Ge + 1].dateTimeObject);
    if (me < Xe)
      break;
  }
  const Re = ie.segments[ie.segments.length - 1], je = Re.dateTimeObject, Ue = Re.videoTimingInfo ? Kv(Re.videoTimingInfo) : Re.duration + Re.duration * yp, qe = new Date(je.getTime() + Ue * 1e3);
  return me > qe ? null : (me > new Date(je) && (we = Re), {
    segment: we,
    estimatedStart: we.videoTimingInfo ? we.videoTimingInfo.transmuxedPresentationStart : st.duration(ie, ie.mediaSequence + ie.segments.indexOf(we)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: we.videoTimingInfo ? "accurate" : "estimate"
  });
}, Qv = (ce, ie) => {
  if (!ie || !ie.segments || ie.segments.length === 0)
    return null;
  let me = 0, we;
  for (let je = 0; je < ie.segments.length && (we = ie.segments[je], me = we.videoTimingInfo ? we.videoTimingInfo.transmuxedPresentationEnd : me + we.duration, !(ce <= me)); je++)
    ;
  const Re = ie.segments[ie.segments.length - 1];
  if (Re.videoTimingInfo && Re.videoTimingInfo.transmuxedPresentationEnd < ce)
    return null;
  if (ce > me) {
    if (ce > me + Re.duration * yp)
      return null;
    we = Re;
  }
  return {
    segment: we,
    estimatedStart: we.videoTimingInfo ? we.videoTimingInfo.transmuxedPresentationStart : me - we.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: we.videoTimingInfo ? "accurate" : "estimate"
  };
}, Jv = (ce, ie) => {
  let me, we;
  try {
    me = new Date(ce), we = new Date(ie);
  } catch {
  }
  const Re = me.getTime();
  return (we.getTime() - Re) / 1e3;
}, Zv = (ce) => {
  if (!ce.segments || ce.segments.length === 0)
    return !1;
  for (let ie = 0; ie < ce.segments.length; ie++)
    if (!ce.segments[ie].dateTimeObject)
      return !1;
  return !0;
}, eb = ({
  playlist: ce,
  time: ie = void 0,
  callback: me
}) => {
  if (!me)
    throw new Error("getProgramTime: callback must be provided");
  if (!ce || ie === void 0)
    return me({
      message: "getProgramTime: playlist and time must be provided"
    });
  const we = Qv(ie, ce);
  if (!we)
    return me({
      message: "valid programTime was not found"
    });
  if (we.type === "estimate")
    return me({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: we.estimatedStart
    });
  const Re = {
    mediaSeconds: ie
  }, je = Xv(ie, we.segment);
  return je && (Re.programDateTime = je.toISOString()), me(null, Re);
}, Tp = ({
  programTime: ce,
  playlist: ie,
  retryCount: me = 2,
  seekTo: we,
  pauseAfterSeek: Re = !0,
  tech: je,
  callback: Ue
}) => {
  if (!Ue)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof ce > "u" || !ie || !we)
    return Ue({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!ie.endList && !je.hasStarted_)
    return Ue({
      message: "player must be playing a live stream to start buffering"
    });
  if (!Zv(ie))
    return Ue({
      message: "programDateTime tags must be provided in the manifest " + ie.resolvedUri
    });
  const qe = Yv(ce, ie);
  if (!qe)
    return Ue({
      message: `${ce} was not found in the stream`
    });
  const Ge = qe.segment, Xe = Jv(Ge.dateTimeObject, ce);
  if (qe.type === "estimate") {
    if (me === 0)
      return Ue({
        message: `${ce} is not buffered yet. Try again`
      });
    we(qe.estimatedStart + Xe), je.one("seeked", () => {
      Tp({
        programTime: ce,
        playlist: ie,
        retryCount: me - 1,
        seekTo: we,
        pauseAfterSeek: Re,
        tech: je,
        callback: Ue
      });
    });
    return;
  }
  const ot = Ge.start + Xe, vt = () => Ue(null, je.currentTime());
  je.one("seeked", vt), Re && je.pause(), we(ot);
}, Lo = (ce, ie) => {
  if (ce.readyState === 4)
    return ie();
}, tb = (ce, ie, me, we) => {
  let Re = [], je, Ue = !1;
  const qe = function(ot, vt, bt, Tt) {
    return vt.abort(), Ue = !0, me(ot, vt, bt, Tt);
  }, Ge = function(ot, vt) {
    if (Ue)
      return;
    if (ot)
      return ot.metadata = Li({
        requestType: we,
        request: vt,
        error: ot
      }), qe(ot, vt, "", Re);
    const bt = vt.responseText.substring(Re && Re.byteLength || 0, vt.responseText.length);
    if (Re = r_(Re, Vd(bt, !0)), je = je || Sr(Re), Re.length < 10 || je && Re.length < je + 2)
      return Lo(vt, () => qe(ot, vt, "", Re));
    const Tt = Ou(Re);
    return Tt === "ts" && Re.length < 188 ? Lo(vt, () => qe(ot, vt, "", Re)) : !Tt && Re.length < 376 ? Lo(vt, () => qe(ot, vt, "", Re)) : qe(null, vt, Tt, Re);
  }, Xe = ie({
    uri: ce,
    beforeSend(ot) {
      ot.overrideMimeType("text/plain; charset=x-user-defined"), ot.addEventListener("progress", function({
        total: vt,
        loaded: bt
      }) {
        return nu(ot, null, {
          statusCode: ot.status
        }, Ge);
      });
    }
  }, function(ot, vt) {
    return nu(Xe, ot, vt, Ge);
  });
  return Xe;
}, {
  EventTarget: ib
} = L, dd = function(ce, ie) {
  if (!fp(ce, ie) || ce.sidx && ie.sidx && (ce.sidx.offset !== ie.sidx.offset || ce.sidx.length !== ie.sidx.length) || !ce.sidx && ie.sidx || ce.sidx && !ie.sidx || ce.segments && !ie.segments || !ce.segments && ie.segments)
    return !1;
  if (!ce.segments && !ie.segments)
    return !0;
  for (let me = 0; me < ce.segments.length; me++) {
    const we = ce.segments[me], Re = ie.segments[me];
    if (we.uri !== Re.uri)
      return !1;
    if (!we.byterange && !Re.byterange)
      continue;
    const je = we.byterange, Ue = Re.byterange;
    if (je && !Ue || !je && Ue || je.offset !== Ue.offset || je.length !== Ue.length)
      return !1;
  }
  return !0;
}, sb = (ce, ie, me, we) => {
  const Re = we.attributes.NAME || me;
  return `placeholder-uri-${ce}-${ie}-${Re}`;
}, rb = ({
  mainXml: ce,
  srcUrl: ie,
  clientOffset: me,
  sidxMapping: we,
  previousManifest: Re
}) => {
  const je = Cy(ce, {
    manifestUri: ie,
    clientOffset: me,
    sidxMapping: we,
    previousManifest: Re
  });
  return op$1(je, ie, sb), je;
}, nb = (ce, ie) => {
  Rs(ce, (me, we, Re, je) => {
    (!ie.mediaGroups[we][Re] || !(je in ie.mediaGroups[we][Re])) && delete ce.mediaGroups[we][Re][je];
  });
}, ab = (ce, ie, me) => {
  let we = !0, Re = fe$1(ce, {
    // These are top level properties that can be updated
    duration: ie.duration,
    minimumUpdatePeriod: ie.minimumUpdatePeriod,
    timelineStarts: ie.timelineStarts
  });
  for (let je = 0; je < ie.playlists.length; je++) {
    const Ue = ie.playlists[je];
    if (Ue.sidx) {
      const Ge = ba(Ue.sidx);
      me && me[Ge] && me[Ge].sidx && ku(Ue, me[Ge].sidx, Ue.sidx.resolvedUri);
    }
    const qe = su(Re, Ue, dd);
    qe && (Re = qe, we = !1);
  }
  return Rs(ie, (je, Ue, qe, Ge) => {
    if (je.playlists && je.playlists.length) {
      const Xe = je.playlists[0].id, ot = su(Re, je.playlists[0], dd);
      ot && (Re = ot, Ge in Re.mediaGroups[Ue][qe] || (Re.mediaGroups[Ue][qe][Ge] = je), Re.mediaGroups[Ue][qe][Ge].playlists[0] = Re.playlists[Xe], we = !1);
    }
  }), nb(Re, ie), ie.minimumUpdatePeriod !== ce.minimumUpdatePeriod && (we = !1), we ? null : Re;
}, ob = (ce, ie) => (!ce.map && !ie.map || !!(ce.map && ie.map && ce.map.byterange.offset === ie.map.byterange.offset && ce.map.byterange.length === ie.map.byterange.length)) && ce.uri === ie.uri && ce.byterange.offset === ie.byterange.offset && ce.byterange.length === ie.byterange.length, hd = (ce, ie) => {
  const me = {};
  for (const we in ce) {
    const Re = ce[we].sidx;
    if (Re) {
      const je = ba(Re);
      if (!ie[je])
        break;
      const Ue = ie[je].sidxInfo;
      ob(Ue, Re) && (me[je] = ie[je]);
    }
  }
  return me;
}, ub = (ce, ie) => {
  let me = hd(ce.playlists, ie);
  return Rs(ce, (we, Re, je, Ue) => {
    if (we.playlists && we.playlists.length) {
      const qe = we.playlists;
      me = fe$1(me, hd(qe, ie));
    }
  }), me;
};
class ou extends ib {
  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
  // playlist loader setups from media groups will expect to be able to pass a playlist
  // (since there aren't external URLs to media playlists with DASH)
  constructor(ie, me, we = {}, Re) {
    super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = Re || this, Re || (this.isMain_ = !0);
    const {
      withCredentials: je = !1
    } = we;
    if (this.vhs_ = me, this.withCredentials = je, this.addMetadataToTextTrack = we.addMetadataToTextTrack, !ie)
      throw new Error("A non-empty playlist URL or object is required");
    this.on("minimumUpdatePeriod", () => {
      this.refreshXml_();
    }), this.on("mediaupdatetimeout", () => {
      this.refreshMedia_(this.media().id);
    }), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = yt("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = ie, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = ie;
  }
  get isPaused() {
    return this.isPaused_;
  }
  requestErrored_(ie, me, we) {
    if (!this.request)
      return !0;
    if (this.request = null, ie)
      return this.error = typeof ie == "object" && !(ie instanceof Error) ? ie : {
        status: me.status,
        message: "DASH request error at URL: " + me.uri,
        response: me.response,
        // MEDIA_ERR_NETWORK
        code: 2,
        metadata: ie.metadata
      }, we && (this.state = we), this.trigger("error"), !0;
  }
  /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */
  addSidxSegments_(ie, me, we) {
    const Re = ie.sidx && ba(ie.sidx);
    if (!ie.sidx || !Re || this.mainPlaylistLoader_.sidxMapping_[Re]) {
      S.clearTimeout(this.mediaRequest_), this.mediaRequest_ = S.setTimeout(() => we(!1), 0);
      return;
    }
    const je = da(ie.sidx.resolvedUri), Ue = (Ge, Xe) => {
      if (this.requestErrored_(Ge, Xe, me))
        return;
      const ot = this.mainPlaylistLoader_.sidxMapping_, {
        requestType: vt
      } = Xe;
      let bt;
      try {
        bt = Oy(Y$1(Xe.response).subarray(8));
      } catch (Tt) {
        Tt.metadata = Li({
          requestType: vt,
          request: Xe,
          parseFailure: !0
        }), this.requestErrored_(Tt, Xe, me);
        return;
      }
      return ot[Re] = {
        sidxInfo: ie.sidx,
        sidx: bt
      }, ku(ie, bt, ie.sidx.resolvedUri), we(!0);
    }, qe = "dash-sidx";
    this.request = tb(je, this.vhs_.xhr, (Ge, Xe, ot, vt) => {
      if (Ge)
        return Ue(Ge, Xe);
      if (!ot || ot !== "mp4") {
        const wt = ot || "unknown";
        return Ue({
          status: Xe.status,
          message: `Unsupported ${wt} container type for sidx segment at URL: ${je}`,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: ie,
          internal: !0,
          playlistExclusionDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, Xe);
      }
      const {
        offset: bt,
        length: Tt
      } = ie.sidx.byterange;
      if (vt.length >= Tt + bt)
        return Ue(Ge, {
          response: vt.subarray(bt, bt + Tt),
          status: Xe.status,
          uri: Xe.uri
        });
      this.request = this.vhs_.xhr({
        uri: je,
        responseType: "arraybuffer",
        requestType: "dash-sidx",
        headers: au({
          byterange: ie.sidx.byterange
        })
      }, Ue);
    }, qe);
  }
  dispose() {
    this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, S.clearTimeout(this.minimumUpdatePeriodTimeout_), S.clearTimeout(this.mediaRequest_), S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }
  hasPendingRequest() {
    return this.request || this.mediaRequest_;
  }
  stopRequest() {
    if (this.request) {
      const ie = this.request;
      this.request = null, ie.onreadystatechange = null, ie.abort();
    }
  }
  media(ie) {
    if (!ie)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    const me = this.state;
    if (typeof ie == "string") {
      if (!this.mainPlaylistLoader_.main.playlists[ie])
        throw new Error("Unknown playlist URI: " + ie);
      ie = this.mainPlaylistLoader_.main.playlists[ie];
    }
    const we = !this.media_ || ie.id !== this.media_.id;
    if (we && this.loadedPlaylists_[ie.id] && this.loadedPlaylists_[ie.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = ie, we && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    we && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(ie, me, (Re) => {
      this.haveMetadata({
        startingState: me,
        playlist: ie
      });
    }));
  }
  haveMetadata({
    startingState: ie,
    playlist: me
  }) {
    this.state = "HAVE_METADATA", this.loadedPlaylists_[me.id] = me, S.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(me.id), ie === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }
  pause() {
    this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (S.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }
  load(ie) {
    this.isPaused_ = !1, S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    const me = this.media();
    if (ie) {
      const we = me ? me.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = S.setTimeout(() => this.load(), we);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    me && !me.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }
  start() {
    if (this.started = !0, !this.isMain_) {
      S.clearTimeout(this.mediaRequest_), this.mediaRequest_ = S.setTimeout(() => this.haveMain_(), 0);
      return;
    }
    this.requestMain_((ie, me) => {
      this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
    });
  }
  requestMain_(ie) {
    const me = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestrequeststart",
      metadata: me
    }), this.request = this.vhs_.xhr({
      uri: this.mainPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials,
      requestType: "dash-manifest"
    }, (we, Re) => {
      if (we) {
        const {
          requestType: Ue
        } = Re;
        we.metadata = Li({
          requestType: Ue,
          request: Re,
          error: we
        });
      }
      if (this.requestErrored_(we, Re)) {
        this.state === "HAVE_NOTHING" && (this.started = !1);
        return;
      }
      this.trigger({
        type: "manifestrequestcomplete",
        metadata: me
      });
      const je = Re.responseText !== this.mainPlaylistLoader_.mainXml_;
      if (this.mainPlaylistLoader_.mainXml_ = Re.responseText, Re.responseHeaders && Re.responseHeaders.date ? this.mainLoaded_ = Date.parse(Re.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = da(this.mainPlaylistLoader_.srcUrl, Re), je) {
        this.handleMain_(), this.syncClientServerClock_(() => ie(Re, je));
        return;
      }
      return ie(Re, je);
    });
  }
  /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */
  syncClientServerClock_(ie) {
    const me = Ay(this.mainPlaylistLoader_.mainXml_);
    if (me === null)
      return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), ie();
    if (me.method === "DIRECT")
      return this.mainPlaylistLoader_.clientOffset_ = me.value - Date.now(), ie();
    this.request = this.vhs_.xhr({
      uri: it(this.mainPlaylistLoader_.srcUrl, me.value),
      method: me.method,
      withCredentials: this.withCredentials,
      requestType: "dash-clock-sync"
    }, (we, Re) => {
      if (!this.request)
        return;
      if (we) {
        const {
          requestType: Ue
        } = Re;
        return this.error.metadata = Li({
          requestType: Ue,
          request: Re,
          error: we
        }), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), ie();
      }
      let je;
      me.method === "HEAD" ? !Re.responseHeaders || !Re.responseHeaders.date ? je = this.mainLoaded_ : je = Date.parse(Re.responseHeaders.date) : je = Date.parse(Re.responseText), this.mainPlaylistLoader_.clientOffset_ = je - Date.now(), ie();
    });
  }
  haveMain_() {
    this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }
  handleMain_() {
    S.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
    const ie = this.mainPlaylistLoader_.main, me = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestparsestart",
      metadata: me
    });
    let we;
    try {
      we = rb({
        mainXml: this.mainPlaylistLoader_.mainXml_,
        srcUrl: this.mainPlaylistLoader_.srcUrl,
        clientOffset: this.mainPlaylistLoader_.clientOffset_,
        sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
        previousManifest: ie
      });
    } catch (je) {
      this.error = je, this.error.metadata = {
        errorType: L.Error.StreamingDashManifestParserError,
        error: je
      }, this.trigger("error");
    }
    ie && (we = ab(ie, we, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = we || ie;
    const Re = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
    if (Re && Re !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = Re), (!ie || we && we.minimumUpdatePeriod !== ie.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(we), we) {
      const {
        duration: je,
        endList: Ue
      } = we, qe = [];
      we.playlists.forEach((Xe) => {
        qe.push({
          id: Xe.id,
          bandwidth: Xe.attributes.BANDWIDTH,
          resolution: Xe.attributes.RESOLUTION,
          codecs: Xe.attributes.CODECS
        });
      });
      const Ge = {
        duration: je,
        isLive: !Ue,
        renditions: qe
      };
      me.parsedManifest = Ge, this.trigger({
        type: "manifestparsecomplete",
        metadata: me
      });
    }
    return !!we;
  }
  updateMinimumUpdatePeriodTimeout_() {
    const ie = this.mainPlaylistLoader_;
    ie.createMupOnMedia_ && (ie.off("loadedmetadata", ie.createMupOnMedia_), ie.createMupOnMedia_ = null), ie.minimumUpdatePeriodTimeout_ && (S.clearTimeout(ie.minimumUpdatePeriodTimeout_), ie.minimumUpdatePeriodTimeout_ = null);
    let me = ie.main && ie.main.minimumUpdatePeriod;
    if (me === 0 && (ie.media() ? me = ie.media().targetDuration * 1e3 : (ie.createMupOnMedia_ = ie.updateMinimumUpdatePeriodTimeout_, ie.one("loadedmetadata", ie.createMupOnMedia_))), typeof me != "number" || me <= 0) {
      me < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${me}, not setting a timeout`);
      return;
    }
    this.createMUPTimeout_(me);
  }
  createMUPTimeout_(ie) {
    const me = this.mainPlaylistLoader_;
    me.minimumUpdatePeriodTimeout_ = S.setTimeout(() => {
      me.minimumUpdatePeriodTimeout_ = null, me.trigger("minimumUpdatePeriod"), me.createMUPTimeout_(ie);
    }, ie);
  }
  /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */
  refreshXml_() {
    this.requestMain_((ie, me) => {
      me && (this.media_ && (this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id]), this.mainPlaylistLoader_.sidxMapping_ = ub(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (we) => {
        this.refreshMedia_(this.media().id);
      }));
    });
  }
  /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */
  refreshMedia_(ie) {
    if (!ie)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMain_ && this.handleMain_();
    const me = this.mainPlaylistLoader_.main.playlists, we = !this.media_ || this.media_ !== me[ie];
    if (we ? this.media_ = me[ie] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      const Re = () => {
        this.media().endList || (this.mediaUpdateTimeout = S.setTimeout(() => {
          this.trigger("mediaupdatetimeout"), Re();
        }, ru(this.media(), !!we)));
      };
      Re();
    }
    this.trigger("loadedplaylist");
  }
  /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */
  addEventStreamToMetadataTrack_(ie) {
    if (ie && this.mainPlaylistLoader_.main.eventStream) {
      const me = this.mainPlaylistLoader_.main.eventStream.map((we) => ({
        cueTime: we.start,
        frames: [{
          data: we.messageData
        }]
      }));
      this.addMetadataToTextTrack("EventStream", me, this.mainPlaylistLoader_.main.duration);
    }
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(ie) {
    if (ie.contentProtection) {
      const me = /* @__PURE__ */ new Set();
      for (const we in ie.contentProtection) {
        const Re = ie.contentProtection[we].attributes["cenc:default_KID"];
        Re && me.add(Re.replace(/-/g, "").toLowerCase());
      }
      return me;
    }
  }
}
var Me = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
};
const lb = (ce) => {
  const ie = new Uint8Array(new ArrayBuffer(ce.length));
  for (let me = 0; me < ce.length; me++)
    ie[me] = ce.charCodeAt(me);
  return ie.buffer;
}, vp = function(ce) {
  return ce.on = ce.addEventListener, ce.off = ce.removeEventListener, ce;
}, cb = function(ce) {
  try {
    return URL.createObjectURL(new Blob([ce], {
      type: "application/javascript"
    }));
  } catch {
    const ie = new BlobBuilder();
    return ie.append(ce), URL.createObjectURL(ie.getBlob());
  }
}, bp = function(ce) {
  return function() {
    const ie = cb(ce), me = vp(new Worker(ie));
    me.objURL = ie;
    const we = me.terminate;
    return me.on = me.addEventListener, me.off = me.removeEventListener, me.terminate = function() {
      return URL.revokeObjectURL(ie), we.call(this);
    }, me;
  };
}, xp = function(ce) {
  return `var browserWorkerPolyFill = ${vp.toString()};
browserWorkerPolyFill(self);
` + ce;
}, Sp = function(ce) {
  return ce.toString().replace(/^function.+?{/, "").slice(0, -1);
}, db = xp(Sp(function() {
  var ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ie = function() {
    this.init = function() {
      var zt = {};
      this.on = function(tn, Wt) {
        zt[tn] || (zt[tn] = []), zt[tn] = zt[tn].concat(Wt);
      }, this.off = function(tn, Wt) {
        var rn;
        return zt[tn] ? (rn = zt[tn].indexOf(Wt), zt[tn] = zt[tn].slice(), zt[tn].splice(rn, 1), rn > -1) : !1;
      }, this.trigger = function(tn) {
        var Wt, rn, sn, dn;
        if (Wt = zt[tn], !!Wt)
          if (arguments.length === 2)
            for (sn = Wt.length, rn = 0; rn < sn; ++rn)
              Wt[rn].call(this, arguments[1]);
          else {
            for (dn = [], rn = arguments.length, rn = 1; rn < arguments.length; ++rn)
              dn.push(arguments[rn]);
            for (sn = Wt.length, rn = 0; rn < sn; ++rn)
              Wt[rn].apply(this, dn);
          }
      }, this.dispose = function() {
        zt = {};
      };
    };
  };
  ie.prototype.pipe = function(zt) {
    return this.on("data", function(tn) {
      zt.push(tn);
    }), this.on("done", function(tn) {
      zt.flush(tn);
    }), this.on("partialdone", function(tn) {
      zt.partialFlush(tn);
    }), this.on("endedtimeline", function(tn) {
      zt.endTimeline(tn);
    }), this.on("reset", function(tn) {
      zt.reset(tn);
    }), zt;
  }, ie.prototype.push = function(zt) {
    this.trigger("data", zt);
  }, ie.prototype.flush = function(zt) {
    this.trigger("done", zt);
  }, ie.prototype.partialFlush = function(zt) {
    this.trigger("partialdone", zt);
  }, ie.prototype.endTimeline = function(zt) {
    this.trigger("endedtimeline", zt);
  }, ie.prototype.reset = function(zt) {
    this.trigger("reset", zt);
  };
  var me = ie, we = Math.pow(2, 32), Re = function(zt) {
    var tn = new DataView(zt.buffer, zt.byteOffset, zt.byteLength), Wt;
    return tn.getBigUint64 ? (Wt = tn.getBigUint64(0), Wt < Number.MAX_SAFE_INTEGER ? Number(Wt) : Wt) : tn.getUint32(0) * we + tn.getUint32(4);
  }, je = {
    getUint64: Re,
    MAX_UINT32: we
  }, Ue = je.MAX_UINT32, qe, Ge, Xe, ot, vt, bt, Tt, wt, St, It, Pt, kt, Ot, Jr, en, nn, ln, fn, vn, Tn, xn, bn, Sn, Cn, kn, cn, gn, an, un, pn, hn, An, In, qn, si, bi;
  (function() {
    var zt;
    if (Sn = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (zt in Sn)
        Sn.hasOwnProperty(zt) && (Sn[zt] = [zt.charCodeAt(0), zt.charCodeAt(1), zt.charCodeAt(2), zt.charCodeAt(3)]);
      Cn = new Uint8Array([105, 115, 111, 109]), cn = new Uint8Array([97, 118, 99, 49]), kn = new Uint8Array([0, 0, 0, 1]), gn = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), an = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), un = {
        video: gn,
        audio: an
      }, An = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), hn = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), In = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), qn = In, si = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), bi = In, pn = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), qe = function(zt) {
    var tn = [], Wt = 0, rn, sn, dn;
    for (rn = 1; rn < arguments.length; rn++)
      tn.push(arguments[rn]);
    for (rn = tn.length; rn--; )
      Wt += tn[rn].byteLength;
    for (sn = new Uint8Array(Wt + 8), dn = new DataView(sn.buffer, sn.byteOffset, sn.byteLength), dn.setUint32(0, sn.byteLength), sn.set(zt, 4), rn = 0, Wt = 8; rn < tn.length; rn++)
      sn.set(tn[rn], Wt), Wt += tn[rn].byteLength;
    return sn;
  }, Ge = function() {
    return qe(Sn.dinf, qe(Sn.dref, An));
  }, Xe = function(zt) {
    return qe(Sn.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      zt.audioobjecttype << 3 | zt.samplingfrequencyindex >>> 1,
      zt.samplingfrequencyindex << 7 | zt.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, ot = function() {
    return qe(Sn.ftyp, Cn, kn, Cn, cn);
  }, nn = function(zt) {
    return qe(Sn.hdlr, un[zt]);
  }, vt = function(zt) {
    return qe(Sn.mdat, zt);
  }, en = function(zt) {
    var tn = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      zt.duration >>> 24 & 255,
      zt.duration >>> 16 & 255,
      zt.duration >>> 8 & 255,
      zt.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return zt.samplerate && (tn[12] = zt.samplerate >>> 24 & 255, tn[13] = zt.samplerate >>> 16 & 255, tn[14] = zt.samplerate >>> 8 & 255, tn[15] = zt.samplerate & 255), qe(Sn.mdhd, tn);
  }, Jr = function(zt) {
    return qe(Sn.mdia, en(zt), nn(zt.type), Tt(zt));
  }, bt = function(zt) {
    return qe(Sn.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (zt & 4278190080) >> 24,
      (zt & 16711680) >> 16,
      (zt & 65280) >> 8,
      zt & 255
      // sequence_number
    ]));
  }, Tt = function(zt) {
    return qe(Sn.minf, zt.type === "video" ? qe(Sn.vmhd, pn) : qe(Sn.smhd, hn), Ge(), fn(zt));
  }, wt = function(zt, tn) {
    for (var Wt = [], rn = tn.length; rn--; )
      Wt[rn] = Tn(tn[rn]);
    return qe.apply(null, [Sn.moof, bt(zt)].concat(Wt));
  }, St = function(zt) {
    for (var tn = zt.length, Wt = []; tn--; )
      Wt[tn] = kt(zt[tn]);
    return qe.apply(null, [Sn.moov, Pt(4294967295)].concat(Wt).concat(It(zt)));
  }, It = function(zt) {
    for (var tn = zt.length, Wt = []; tn--; )
      Wt[tn] = xn(zt[tn]);
    return qe.apply(null, [Sn.mvex].concat(Wt));
  }, Pt = function(zt) {
    var tn = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (zt & 4278190080) >> 24,
      (zt & 16711680) >> 16,
      (zt & 65280) >> 8,
      zt & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return qe(Sn.mvhd, tn);
  }, ln = function(zt) {
    var tn = zt.samples || [], Wt = new Uint8Array(4 + tn.length), rn, sn;
    for (sn = 0; sn < tn.length; sn++)
      rn = tn[sn].flags, Wt[sn + 4] = rn.dependsOn << 4 | rn.isDependedOn << 2 | rn.hasRedundancy;
    return qe(Sn.sdtp, Wt);
  }, fn = function(zt) {
    return qe(Sn.stbl, vn(zt), qe(Sn.stts, bi), qe(Sn.stsc, qn), qe(Sn.stsz, si), qe(Sn.stco, In));
  }, function() {
    var zt, tn;
    vn = function(Wt) {
      return qe(Sn.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), Wt.type === "video" ? zt(Wt) : tn(Wt));
    }, zt = function(Wt) {
      var rn = Wt.sps || [], sn = Wt.pps || [], dn = [], _n = [], wn, Dn;
      for (wn = 0; wn < rn.length; wn++)
        dn.push((rn[wn].byteLength & 65280) >>> 8), dn.push(rn[wn].byteLength & 255), dn = dn.concat(Array.prototype.slice.call(rn[wn]));
      for (wn = 0; wn < sn.length; wn++)
        _n.push((sn[wn].byteLength & 65280) >>> 8), _n.push(sn[wn].byteLength & 255), _n = _n.concat(Array.prototype.slice.call(sn[wn]));
      if (Dn = [Sn.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (Wt.width & 65280) >> 8,
        Wt.width & 255,
        // width
        (Wt.height & 65280) >> 8,
        Wt.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), qe(Sn.avcC, new Uint8Array([
        1,
        // configurationVersion
        Wt.profileIdc,
        // AVCProfileIndication
        Wt.profileCompatibility,
        // profile_compatibility
        Wt.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [rn.length],
        // numOfSequenceParameterSets
        dn,
        // "SPS"
        [sn.length],
        // numOfPictureParameterSets
        _n
        // "PPS"
      ))), qe(Sn.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], Wt.sarRatio) {
        var Fn = Wt.sarRatio[0], yi = Wt.sarRatio[1];
        Dn.push(qe(Sn.pasp, new Uint8Array([(Fn & 4278190080) >> 24, (Fn & 16711680) >> 16, (Fn & 65280) >> 8, Fn & 255, (yi & 4278190080) >> 24, (yi & 16711680) >> 16, (yi & 65280) >> 8, yi & 255])));
      }
      return qe.apply(null, Dn);
    }, tn = function(Wt) {
      return qe(Sn.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (Wt.channelcount & 65280) >> 8,
        Wt.channelcount & 255,
        // channelcount
        (Wt.samplesize & 65280) >> 8,
        Wt.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (Wt.samplerate & 65280) >> 8,
        Wt.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), Xe(Wt));
    };
  }(), Ot = function(zt) {
    var tn = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (zt.id & 4278190080) >> 24,
      (zt.id & 16711680) >> 16,
      (zt.id & 65280) >> 8,
      zt.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (zt.duration & 4278190080) >> 24,
      (zt.duration & 16711680) >> 16,
      (zt.duration & 65280) >> 8,
      zt.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (zt.width & 65280) >> 8,
      zt.width & 255,
      0,
      0,
      // width
      (zt.height & 65280) >> 8,
      zt.height & 255,
      0,
      0
      // height
    ]);
    return qe(Sn.tkhd, tn);
  }, Tn = function(zt) {
    var tn, Wt, rn, sn, dn, _n, wn;
    return tn = qe(Sn.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (zt.id & 4278190080) >> 24,
      (zt.id & 16711680) >> 16,
      (zt.id & 65280) >> 8,
      zt.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), _n = Math.floor(zt.baseMediaDecodeTime / Ue), wn = Math.floor(zt.baseMediaDecodeTime % Ue), Wt = qe(Sn.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      _n >>> 24 & 255,
      _n >>> 16 & 255,
      _n >>> 8 & 255,
      _n & 255,
      wn >>> 24 & 255,
      wn >>> 16 & 255,
      wn >>> 8 & 255,
      wn & 255
    ])), dn = 92, zt.type === "audio" ? (rn = bn(zt, dn), qe(Sn.traf, tn, Wt, rn)) : (sn = ln(zt), rn = bn(zt, sn.length + dn), qe(Sn.traf, tn, Wt, rn, sn));
  }, kt = function(zt) {
    return zt.duration = zt.duration || 4294967295, qe(Sn.trak, Ot(zt), Jr(zt));
  }, xn = function(zt) {
    var tn = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (zt.id & 4278190080) >> 24,
      (zt.id & 16711680) >> 16,
      (zt.id & 65280) >> 8,
      zt.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return zt.type !== "video" && (tn[tn.length - 1] = 0), qe(Sn.trex, tn);
  }, function() {
    var zt, tn, Wt;
    Wt = function(rn, sn) {
      var dn = 0, _n = 0, wn = 0, Dn = 0;
      return rn.length && (rn[0].duration !== void 0 && (dn = 1), rn[0].size !== void 0 && (_n = 2), rn[0].flags !== void 0 && (wn = 4), rn[0].compositionTimeOffset !== void 0 && (Dn = 8)), [
        0,
        // version 0
        0,
        dn | _n | wn | Dn,
        1,
        // flags
        (rn.length & 4278190080) >>> 24,
        (rn.length & 16711680) >>> 16,
        (rn.length & 65280) >>> 8,
        rn.length & 255,
        // sample_count
        (sn & 4278190080) >>> 24,
        (sn & 16711680) >>> 16,
        (sn & 65280) >>> 8,
        sn & 255
        // data_offset
      ];
    }, tn = function(rn, sn) {
      var dn, _n, wn, Dn, Fn, yi;
      for (Dn = rn.samples || [], sn += 20 + 16 * Dn.length, wn = Wt(Dn, sn), _n = new Uint8Array(wn.length + Dn.length * 16), _n.set(wn), dn = wn.length, yi = 0; yi < Dn.length; yi++)
        Fn = Dn[yi], _n[dn++] = (Fn.duration & 4278190080) >>> 24, _n[dn++] = (Fn.duration & 16711680) >>> 16, _n[dn++] = (Fn.duration & 65280) >>> 8, _n[dn++] = Fn.duration & 255, _n[dn++] = (Fn.size & 4278190080) >>> 24, _n[dn++] = (Fn.size & 16711680) >>> 16, _n[dn++] = (Fn.size & 65280) >>> 8, _n[dn++] = Fn.size & 255, _n[dn++] = Fn.flags.isLeading << 2 | Fn.flags.dependsOn, _n[dn++] = Fn.flags.isDependedOn << 6 | Fn.flags.hasRedundancy << 4 | Fn.flags.paddingValue << 1 | Fn.flags.isNonSyncSample, _n[dn++] = Fn.flags.degradationPriority & 61440, _n[dn++] = Fn.flags.degradationPriority & 15, _n[dn++] = (Fn.compositionTimeOffset & 4278190080) >>> 24, _n[dn++] = (Fn.compositionTimeOffset & 16711680) >>> 16, _n[dn++] = (Fn.compositionTimeOffset & 65280) >>> 8, _n[dn++] = Fn.compositionTimeOffset & 255;
      return qe(Sn.trun, _n);
    }, zt = function(rn, sn) {
      var dn, _n, wn, Dn, Fn, yi;
      for (Dn = rn.samples || [], sn += 20 + 8 * Dn.length, wn = Wt(Dn, sn), dn = new Uint8Array(wn.length + Dn.length * 8), dn.set(wn), _n = wn.length, yi = 0; yi < Dn.length; yi++)
        Fn = Dn[yi], dn[_n++] = (Fn.duration & 4278190080) >>> 24, dn[_n++] = (Fn.duration & 16711680) >>> 16, dn[_n++] = (Fn.duration & 65280) >>> 8, dn[_n++] = Fn.duration & 255, dn[_n++] = (Fn.size & 4278190080) >>> 24, dn[_n++] = (Fn.size & 16711680) >>> 16, dn[_n++] = (Fn.size & 65280) >>> 8, dn[_n++] = Fn.size & 255;
      return qe(Sn.trun, dn);
    }, bn = function(rn, sn) {
      return rn.type === "audio" ? zt(rn, sn) : tn(rn, sn);
    };
  }();
  var xi = {
    ftyp: ot,
    mdat: vt,
    moof: wt,
    moov: St,
    initSegment: function(zt) {
      var tn = ot(), Wt = St(zt), rn;
      return rn = new Uint8Array(tn.byteLength + Wt.byteLength), rn.set(tn), rn.set(Wt, tn.byteLength), rn;
    }
  }, ji = function(zt) {
    var tn, Wt, rn = [], sn = [];
    for (sn.byteLength = 0, sn.nalCount = 0, sn.duration = 0, rn.byteLength = 0, tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], Wt.nalUnitType === "access_unit_delimiter_rbsp" ? (rn.length && (rn.duration = Wt.dts - rn.dts, sn.byteLength += rn.byteLength, sn.nalCount += rn.length, sn.duration += rn.duration, sn.push(rn)), rn = [Wt], rn.byteLength = Wt.data.byteLength, rn.pts = Wt.pts, rn.dts = Wt.dts) : (Wt.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (rn.keyFrame = !0), rn.duration = Wt.dts - rn.dts, rn.byteLength += Wt.data.byteLength, rn.push(Wt));
    return sn.length && (!rn.duration || rn.duration <= 0) && (rn.duration = sn[sn.length - 1].duration), sn.byteLength += rn.byteLength, sn.nalCount += rn.length, sn.duration += rn.duration, sn.push(rn), sn;
  }, zi = function(zt) {
    var tn, Wt, rn = [], sn = [];
    for (rn.byteLength = 0, rn.nalCount = 0, rn.duration = 0, rn.pts = zt[0].pts, rn.dts = zt[0].dts, sn.byteLength = 0, sn.nalCount = 0, sn.duration = 0, sn.pts = zt[0].pts, sn.dts = zt[0].dts, tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], Wt.keyFrame ? (rn.length && (sn.push(rn), sn.byteLength += rn.byteLength, sn.nalCount += rn.nalCount, sn.duration += rn.duration), rn = [Wt], rn.nalCount = Wt.length, rn.byteLength = Wt.byteLength, rn.pts = Wt.pts, rn.dts = Wt.dts, rn.duration = Wt.duration) : (rn.duration += Wt.duration, rn.nalCount += Wt.length, rn.byteLength += Wt.byteLength, rn.push(Wt));
    return sn.length && rn.duration <= 0 && (rn.duration = sn[sn.length - 1].duration), sn.byteLength += rn.byteLength, sn.nalCount += rn.nalCount, sn.duration += rn.duration, sn.push(rn), sn;
  }, Vi = function(zt) {
    var tn;
    return !zt[0][0].keyFrame && zt.length > 1 && (tn = zt.shift(), zt.byteLength -= tn.byteLength, zt.nalCount -= tn.nalCount, zt[0][0].dts = tn.dts, zt[0][0].pts = tn.pts, zt[0][0].duration += tn.duration), zt;
  }, Hi = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, ii = function(zt, tn) {
    var Wt = Hi();
    return Wt.dataOffset = tn, Wt.compositionTimeOffset = zt.pts - zt.dts, Wt.duration = zt.duration, Wt.size = 4 * zt.length, Wt.size += zt.byteLength, zt.keyFrame && (Wt.flags.dependsOn = 2, Wt.flags.isNonSyncSample = 0), Wt;
  }, Fi = function(zt, tn) {
    var Wt, rn, sn, dn, _n, wn = tn || 0, Dn = [];
    for (Wt = 0; Wt < zt.length; Wt++)
      for (dn = zt[Wt], rn = 0; rn < dn.length; rn++)
        _n = dn[rn], sn = ii(_n, wn), wn += sn.size, Dn.push(sn);
    return Dn;
  }, ni = function(zt) {
    var tn, Wt, rn, sn, dn, _n, wn = 0, Dn = zt.byteLength, Fn = zt.nalCount, yi = Dn + 4 * Fn, Wi = new Uint8Array(yi), Vs = new DataView(Wi.buffer);
    for (tn = 0; tn < zt.length; tn++)
      for (sn = zt[tn], Wt = 0; Wt < sn.length; Wt++)
        for (dn = sn[Wt], rn = 0; rn < dn.length; rn++)
          _n = dn[rn], Vs.setUint32(wn, _n.data.byteLength), wn += 4, Wi.set(_n.data, wn), wn += _n.data.byteLength;
    return Wi;
  }, Ui = function(zt, tn) {
    var Wt, rn = tn || 0, sn = [];
    return Wt = ii(zt, rn), sn.push(Wt), sn;
  }, ja = function(zt) {
    var tn, Wt, rn = 0, sn = zt.byteLength, dn = zt.length, _n = sn + 4 * dn, wn = new Uint8Array(_n), Dn = new DataView(wn.buffer);
    for (tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], Dn.setUint32(rn, Wt.data.byteLength), rn += 4, wn.set(Wt.data, rn), rn += Wt.data.byteLength;
    return wn;
  }, Ga = {
    groupNalsIntoFrames: ji,
    groupFramesIntoGops: zi,
    extendFirstKeyFrame: Vi,
    generateSampleTable: Fi,
    concatenateNalData: ni,
    generateSampleTableForFrame: Ui,
    concatenateNalDataForFrame: ja
  }, Xa = [33, 16, 5, 32, 164, 27], Ns = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], Ya = function(zt) {
    for (var tn = []; zt--; )
      tn.push(0);
    return tn;
  }, Qa = function(zt) {
    return Object.keys(zt).reduce(function(tn, Wt) {
      return tn[Wt] = new Uint8Array(zt[Wt].reduce(function(rn, sn) {
        return rn.concat(sn);
      }, [])), tn;
    }, {});
  }, Ja, Ms = function() {
    if (!Ja) {
      var zt = {
        96e3: [Xa, [227, 64], Ya(154), [56]],
        88200: [Xa, [231], Ya(170), [56]],
        64e3: [Xa, [248, 192], Ya(240), [56]],
        48e3: [Xa, [255, 192], Ya(268), [55, 148, 128], Ya(54), [112]],
        44100: [Xa, [255, 192], Ya(268), [55, 163, 128], Ya(84), [112]],
        32e3: [Xa, [255, 192], Ya(268), [55, 234], Ya(226), [112]],
        24e3: [Xa, [255, 192], Ya(268), [55, 255, 128], Ya(268), [111, 112], Ya(126), [224]],
        16e3: [Xa, [255, 192], Ya(268), [55, 255, 128], Ya(268), [111, 255], Ya(269), [223, 108], Ya(195), [1, 192]],
        12e3: [Ns, Ya(268), [3, 127, 248], Ya(268), [6, 255, 240], Ya(268), [13, 255, 224], Ya(268), [27, 253, 128], Ya(259), [56]],
        11025: [Ns, Ya(268), [3, 127, 248], Ya(268), [6, 255, 240], Ya(268), [13, 255, 224], Ya(268), [27, 255, 192], Ya(268), [55, 175, 128], Ya(108), [112]],
        8e3: [Ns, Ya(268), [3, 121, 16], Ya(47), [7]]
      };
      Ja = Qa(zt);
    }
    return Ja;
  }, Hs = 9e4, no, Qs, Zs, so, io, dl, vl;
  no = function(zt) {
    return zt * Hs;
  }, Qs = function(zt, tn) {
    return zt * tn;
  }, Zs = function(zt) {
    return zt / Hs;
  }, so = function(zt, tn) {
    return zt / tn;
  }, io = function(zt, tn) {
    return no(so(zt, tn));
  }, dl = function(zt, tn) {
    return Qs(Zs(zt), tn);
  }, vl = function(zt, tn, Wt) {
    return Zs(Wt ? zt : zt - tn);
  };
  var lo = {
    ONE_SECOND_IN_TS: Hs,
    secondsToVideoTs: no,
    secondsToAudioTs: Qs,
    videoTsToSeconds: Zs,
    audioTsToSeconds: so,
    audioTsToVideoTs: io,
    videoTsToAudioTs: dl,
    metadataTsToSeconds: vl
  }, yl = Ms, bl = lo, Al = function(zt) {
    var tn, Wt, rn = 0;
    for (tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], rn += Wt.data.byteLength;
    return rn;
  }, Xl = function(zt, tn, Wt, rn) {
    var sn, dn = 0, _n = 0, wn = 0, Dn = 0, Fn, yi, Wi;
    if (tn.length && (sn = bl.audioTsToVideoTs(zt.baseMediaDecodeTime, zt.samplerate), dn = Math.ceil(bl.ONE_SECOND_IN_TS / (zt.samplerate / 1024)), Wt && rn && (_n = sn - Math.max(Wt, rn), wn = Math.floor(_n / dn), Dn = wn * dn), !(wn < 1 || Dn > bl.ONE_SECOND_IN_TS / 2))) {
      for (Fn = yl()[zt.samplerate], Fn || (Fn = tn[0].data), yi = 0; yi < wn; yi++)
        Wi = tn[0], tn.splice(0, 0, {
          data: Fn,
          dts: Wi.dts - dn,
          pts: Wi.pts - dn
        });
      return zt.baseMediaDecodeTime -= Math.floor(bl.videoTsToAudioTs(Dn, zt.samplerate)), Dn;
    }
  }, $l = function(zt, tn, Wt) {
    return tn.minSegmentDts >= Wt ? zt : (tn.minSegmentDts = 1 / 0, zt.filter(function(rn) {
      return rn.dts >= Wt ? (tn.minSegmentDts = Math.min(tn.minSegmentDts, rn.dts), tn.minSegmentPts = tn.minSegmentDts, !0) : !1;
    }));
  }, Bl = function(zt) {
    var tn, Wt, rn = [];
    for (tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], rn.push({
        size: Wt.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return rn;
  }, Fl = function(zt) {
    var tn, Wt, rn = 0, sn = new Uint8Array(Al(zt));
    for (tn = 0; tn < zt.length; tn++)
      Wt = zt[tn], sn.set(Wt.data, rn), rn += Wt.data.byteLength;
    return sn;
  }, kl = {
    prefixWithSilence: Xl,
    trimAdtsFramesByEarliestDts: $l,
    generateSampleTable: Bl,
    concatenateFrameData: Fl
  }, ql = lo.ONE_SECOND_IN_TS, _l = function(zt, tn) {
    typeof tn.pts == "number" && (zt.timelineStartInfo.pts === void 0 && (zt.timelineStartInfo.pts = tn.pts), zt.minSegmentPts === void 0 ? zt.minSegmentPts = tn.pts : zt.minSegmentPts = Math.min(zt.minSegmentPts, tn.pts), zt.maxSegmentPts === void 0 ? zt.maxSegmentPts = tn.pts : zt.maxSegmentPts = Math.max(zt.maxSegmentPts, tn.pts)), typeof tn.dts == "number" && (zt.timelineStartInfo.dts === void 0 && (zt.timelineStartInfo.dts = tn.dts), zt.minSegmentDts === void 0 ? zt.minSegmentDts = tn.dts : zt.minSegmentDts = Math.min(zt.minSegmentDts, tn.dts), zt.maxSegmentDts === void 0 ? zt.maxSegmentDts = tn.dts : zt.maxSegmentDts = Math.max(zt.maxSegmentDts, tn.dts));
  }, Ol = function(zt) {
    delete zt.minSegmentDts, delete zt.maxSegmentDts, delete zt.minSegmentPts, delete zt.maxSegmentPts;
  }, Ll = function(zt, tn) {
    var Wt, rn, sn = zt.minSegmentDts;
    return tn || (sn -= zt.timelineStartInfo.dts), Wt = zt.timelineStartInfo.baseMediaDecodeTime, Wt += sn, Wt = Math.max(0, Wt), zt.type === "audio" && (rn = zt.samplerate / ql, Wt *= rn, Wt = Math.floor(Wt)), Wt;
  }, Ql = {
    clearDtsInfo: Ol,
    calculateTrackBaseMediaDecodeTime: Ll,
    collectDtsInfo: _l
  }, wl = 4, to = 128, zs = function(zt) {
    for (var tn = 0, Wt = {
      payloadType: -1,
      payloadSize: 0
    }, rn = 0, sn = 0; tn < zt.byteLength && zt[tn] !== to; ) {
      for (; zt[tn] === 255; )
        rn += 255, tn++;
      for (rn += zt[tn++]; zt[tn] === 255; )
        sn += 255, tn++;
      if (sn += zt[tn++], !Wt.payload && rn === wl) {
        var dn = String.fromCharCode(zt[tn + 3], zt[tn + 4], zt[tn + 5], zt[tn + 6]);
        if (dn === "GA94") {
          Wt.payloadType = rn, Wt.payloadSize = sn, Wt.payload = zt.subarray(tn, tn + sn);
          break;
        } else
          Wt.payload = void 0;
      }
      tn += sn, rn = 0, sn = 0;
    }
    return Wt;
  }, Gs = function(zt) {
    return zt.payload[0] !== 181 || (zt.payload[1] << 8 | zt.payload[2]) !== 49 || String.fromCharCode(zt.payload[3], zt.payload[4], zt.payload[5], zt.payload[6]) !== "GA94" || zt.payload[7] !== 3 ? null : zt.payload.subarray(8, zt.payload.length - 1);
  }, Pl = function(zt, tn) {
    var Wt = [], rn, sn, dn, _n;
    if (!(tn[0] & 64))
      return Wt;
    for (sn = tn[0] & 31, rn = 0; rn < sn; rn++)
      dn = rn * 3, _n = {
        type: tn[dn + 2] & 3,
        pts: zt
      }, tn[dn + 2] & 4 && (_n.ccData = tn[dn + 3] << 8 | tn[dn + 4], Wt.push(_n));
    return Wt;
  }, Ml = function(zt) {
    for (var tn = zt.byteLength, Wt = [], rn = 1, sn, dn; rn < tn - 2; )
      zt[rn] === 0 && zt[rn + 1] === 0 && zt[rn + 2] === 3 ? (Wt.push(rn + 2), rn += 2) : rn++;
    if (Wt.length === 0)
      return zt;
    sn = tn - Wt.length, dn = new Uint8Array(sn);
    var _n = 0;
    for (rn = 0; rn < sn; _n++, rn++)
      _n === Wt[0] && (_n++, Wt.shift()), dn[rn] = zt[_n];
    return dn;
  }, Ws = {
    parseSei: zs,
    parseUserData: Gs,
    parseCaptionPackets: Pl,
    discardEmulationPreventionBytes: Ml,
    USER_DATA_REGISTERED_ITU_T_T35: wl
  }, Ks = me, Js = Ws, qs = function(zt) {
    zt = zt || {}, qs.prototype.init.call(this), this.parse708captions_ = typeof zt.parse708captions == "boolean" ? zt.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new Bs(0, 0),
      // eslint-disable-line no-use-before-define
      new Bs(0, 1),
      // eslint-disable-line no-use-before-define
      new Bs(1, 0),
      // eslint-disable-line no-use-before-define
      new Bs(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new Va({
      captionServices: zt.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(tn) {
      tn.on("data", this.trigger.bind(this, "data")), tn.on("partialdone", this.trigger.bind(this, "partialdone")), tn.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  qs.prototype = new Ks(), qs.prototype.push = function(zt) {
    var tn, Wt, rn;
    if (zt.nalUnitType === "sei_rbsp" && (tn = Js.parseSei(zt.escapedRBSP), !!tn.payload && tn.payloadType === Js.USER_DATA_REGISTERED_ITU_T_T35 && (Wt = Js.parseUserData(tn), !!Wt))) {
      if (zt.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (zt.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      rn = Js.parseCaptionPackets(zt.pts, Wt), this.captionPackets_ = this.captionPackets_.concat(rn), this.latestDts_ !== zt.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = zt.dts;
    }
  }, qs.prototype.flushCCStreams = function(zt) {
    this.ccStreams_.forEach(function(tn) {
      return zt === "flush" ? tn.flush() : tn.partialFlush();
    }, this);
  }, qs.prototype.flushStream = function(zt) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(zt);
      return;
    }
    this.captionPackets_.forEach(function(tn, Wt) {
      tn.presortIndex = Wt;
    }), this.captionPackets_.sort(function(tn, Wt) {
      return tn.pts === Wt.pts ? tn.presortIndex - Wt.presortIndex : tn.pts - Wt.pts;
    }), this.captionPackets_.forEach(function(tn) {
      tn.type < 2 ? this.dispatchCea608Packet(tn) : this.dispatchCea708Packet(tn);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(zt);
  }, qs.prototype.flush = function() {
    return this.flushStream("flush");
  }, qs.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, qs.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(zt) {
      zt.reset();
    });
  }, qs.prototype.dispatchCea608Packet = function(zt) {
    this.setsTextOrXDSActive(zt) ? this.activeCea608Channel_[zt.type] = null : this.setsChannel1Active(zt) ? this.activeCea608Channel_[zt.type] = 0 : this.setsChannel2Active(zt) && (this.activeCea608Channel_[zt.type] = 1), this.activeCea608Channel_[zt.type] !== null && this.ccStreams_[(zt.type << 1) + this.activeCea608Channel_[zt.type]].push(zt);
  }, qs.prototype.setsChannel1Active = function(zt) {
    return (zt.ccData & 30720) === 4096;
  }, qs.prototype.setsChannel2Active = function(zt) {
    return (zt.ccData & 30720) === 6144;
  }, qs.prototype.setsTextOrXDSActive = function(zt) {
    return (zt.ccData & 28928) === 256 || (zt.ccData & 30974) === 4138 || (zt.ccData & 30974) === 6186;
  }, qs.prototype.dispatchCea708Packet = function(zt) {
    this.parse708captions_ && this.cc708Stream_.push(zt);
  };
  var ho = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, mn = function(zt) {
    var tn = ho[zt] || zt;
    return zt & 4096 && zt === tn ? "" : String.fromCharCode(tn);
  }, ai = function(zt) {
    return 32 <= zt && zt <= 127 || 160 <= zt && zt <= 255;
  }, $i = function(zt) {
    this.windowNum = zt, this.reset();
  };
  $i.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, $i.prototype.getText = function() {
    return this.rows.join(`
`);
  }, $i.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, $i.prototype.newLine = function(zt) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(zt), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, $i.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, $i.prototype.addText = function(zt) {
    this.rows[this.rowIdx] += zt;
  }, $i.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var zt = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = zt.substr(0, zt.length - 1);
    }
  };
  var Ha = function(zt, tn, Wt) {
    this.serviceNum = zt, this.text = "", this.currentWindow = new $i(-1), this.windows = [], this.stream = Wt, typeof tn == "string" && this.createTextDecoder(tn);
  };
  Ha.prototype.init = function(zt, tn) {
    this.startPts = zt;
    for (var Wt = 0; Wt < 8; Wt++)
      this.windows[Wt] = new $i(Wt), typeof tn == "function" && (this.windows[Wt].beforeRowOverflow = tn);
  }, Ha.prototype.setCurrentWindow = function(zt) {
    this.currentWindow = this.windows[zt];
  }, Ha.prototype.createTextDecoder = function(zt) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(zt);
      } catch (tn) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + zt + " encoding. " + tn
        });
      }
  };
  var Va = function(zt) {
    zt = zt || {}, Va.prototype.init.call(this);
    var tn = this, Wt = zt.captionServices || {}, rn = {}, sn;
    Object.keys(Wt).forEach((dn) => {
      sn = Wt[dn], /^SERVICE/.test(dn) && (rn[dn] = sn.encoding);
    }), this.serviceEncodings = rn, this.current708Packet = null, this.services = {}, this.push = function(dn) {
      dn.type === 3 ? (tn.new708Packet(), tn.add708Bytes(dn)) : (tn.current708Packet === null && tn.new708Packet(), tn.add708Bytes(dn));
    };
  };
  Va.prototype = new Ks(), Va.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, Va.prototype.add708Bytes = function(zt) {
    var tn = zt.ccData, Wt = tn >>> 8, rn = tn & 255;
    this.current708Packet.ptsVals.push(zt.pts), this.current708Packet.data.push(Wt), this.current708Packet.data.push(rn);
  }, Va.prototype.push708Packet = function() {
    var zt = this.current708Packet, tn = zt.data, Wt = null, rn = null, sn = 0, dn = tn[sn++];
    for (zt.seq = dn >> 6, zt.sizeCode = dn & 63; sn < tn.length; sn++)
      dn = tn[sn++], Wt = dn >> 5, rn = dn & 31, Wt === 7 && rn > 0 && (dn = tn[sn++], Wt = dn), this.pushServiceBlock(Wt, sn, rn), rn > 0 && (sn += rn - 1);
  }, Va.prototype.pushServiceBlock = function(zt, tn, Wt) {
    var rn, sn = tn, dn = this.current708Packet.data, _n = this.services[zt];
    for (_n || (_n = this.initService(zt, sn)); sn < tn + Wt && sn < dn.length; sn++)
      rn = dn[sn], ai(rn) ? sn = this.handleText(sn, _n) : rn === 24 ? sn = this.multiByteCharacter(sn, _n) : rn === 16 ? sn = this.extendedCommands(sn, _n) : 128 <= rn && rn <= 135 ? sn = this.setCurrentWindow(sn, _n) : 152 <= rn && rn <= 159 ? sn = this.defineWindow(sn, _n) : rn === 136 ? sn = this.clearWindows(sn, _n) : rn === 140 ? sn = this.deleteWindows(sn, _n) : rn === 137 ? sn = this.displayWindows(sn, _n) : rn === 138 ? sn = this.hideWindows(sn, _n) : rn === 139 ? sn = this.toggleWindows(sn, _n) : rn === 151 ? sn = this.setWindowAttributes(sn, _n) : rn === 144 ? sn = this.setPenAttributes(sn, _n) : rn === 145 ? sn = this.setPenColor(sn, _n) : rn === 146 ? sn = this.setPenLocation(sn, _n) : rn === 143 ? _n = this.reset(sn, _n) : rn === 8 ? _n.currentWindow.backspace() : rn === 12 ? _n.currentWindow.clearText() : rn === 13 ? _n.currentWindow.pendingNewLine = !0 : rn === 14 ? _n.currentWindow.clearText() : rn === 141 && sn++;
  }, Va.prototype.extendedCommands = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt];
    return ai(rn) && (zt = this.handleText(zt, tn, {
      isExtended: !0
    })), zt;
  }, Va.prototype.getPts = function(zt) {
    return this.current708Packet.ptsVals[Math.floor(zt / 2)];
  }, Va.prototype.initService = function(zt, tn) {
    var rn = "SERVICE" + zt, Wt = this, rn, sn;
    return rn in this.serviceEncodings && (sn = this.serviceEncodings[rn]), this.services[zt] = new Ha(zt, sn, Wt), this.services[zt].init(this.getPts(tn), function(dn) {
      Wt.flushDisplayed(dn, Wt.services[zt]);
    }), this.services[zt];
  }, Va.prototype.handleText = function(zt, tn, Wt) {
    var rn = Wt && Wt.isExtended, sn = Wt && Wt.isMultiByte, dn = this.current708Packet.data, _n = rn ? 4096 : 0, wn = dn[zt], Dn = dn[zt + 1], Fn = tn.currentWindow, yi, Wi;
    function Vs($a) {
      return $a.map((fo) => ("0" + (fo & 255).toString(16)).slice(-2)).join("");
    }
    if (sn ? (Wi = [wn, Dn], zt++) : Wi = [wn], tn.textDecoder_ && !rn)
      yi = tn.textDecoder_.decode(new Uint8Array(Wi));
    else if (sn) {
      const $a = Vs(Wi);
      yi = String.fromCharCode(parseInt($a, 16));
    } else
      yi = mn(_n | wn);
    return Fn.pendingNewLine && !Fn.isEmpty() && Fn.newLine(this.getPts(zt)), Fn.pendingNewLine = !1, Fn.addText(yi), zt;
  }, Va.prototype.multiByteCharacter = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt + 1], sn = Wt[zt + 2];
    return ai(rn) && ai(sn) && (zt = this.handleText(++zt, tn, {
      isMultiByte: !0
    })), zt;
  }, Va.prototype.setCurrentWindow = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = rn & 7;
    return tn.setCurrentWindow(sn), zt;
  }, Va.prototype.defineWindow = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = rn & 7;
    tn.setCurrentWindow(sn);
    var dn = tn.currentWindow;
    return rn = Wt[++zt], dn.visible = (rn & 32) >> 5, dn.rowLock = (rn & 16) >> 4, dn.columnLock = (rn & 8) >> 3, dn.priority = rn & 7, rn = Wt[++zt], dn.relativePositioning = (rn & 128) >> 7, dn.anchorVertical = rn & 127, rn = Wt[++zt], dn.anchorHorizontal = rn, rn = Wt[++zt], dn.anchorPoint = (rn & 240) >> 4, dn.rowCount = rn & 15, rn = Wt[++zt], dn.columnCount = rn & 63, rn = Wt[++zt], dn.windowStyle = (rn & 56) >> 3, dn.penStyle = rn & 7, dn.virtualRowCount = dn.rowCount + 1, zt;
  }, Va.prototype.setWindowAttributes = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = tn.currentWindow.winAttr;
    return rn = Wt[++zt], sn.fillOpacity = (rn & 192) >> 6, sn.fillRed = (rn & 48) >> 4, sn.fillGreen = (rn & 12) >> 2, sn.fillBlue = rn & 3, rn = Wt[++zt], sn.borderType = (rn & 192) >> 6, sn.borderRed = (rn & 48) >> 4, sn.borderGreen = (rn & 12) >> 2, sn.borderBlue = rn & 3, rn = Wt[++zt], sn.borderType += (rn & 128) >> 5, sn.wordWrap = (rn & 64) >> 6, sn.printDirection = (rn & 48) >> 4, sn.scrollDirection = (rn & 12) >> 2, sn.justify = rn & 3, rn = Wt[++zt], sn.effectSpeed = (rn & 240) >> 4, sn.effectDirection = (rn & 12) >> 2, sn.displayEffect = rn & 3, zt;
  }, Va.prototype.flushDisplayed = function(zt, tn) {
    for (var Wt = [], rn = 0; rn < 8; rn++)
      tn.windows[rn].visible && !tn.windows[rn].isEmpty() && Wt.push(tn.windows[rn].getText());
    tn.endPts = zt, tn.text = Wt.join(`

`), this.pushCaption(tn), tn.startPts = zt;
  }, Va.prototype.pushCaption = function(zt) {
    zt.text !== "" && (this.trigger("data", {
      startPts: zt.startPts,
      endPts: zt.endPts,
      text: zt.text,
      stream: "cc708_" + zt.serviceNum
    }), zt.text = "", zt.startPts = zt.endPts);
  }, Va.prototype.displayWindows = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt], sn = this.getPts(zt);
    this.flushDisplayed(sn, tn);
    for (var dn = 0; dn < 8; dn++)
      rn & 1 << dn && (tn.windows[dn].visible = 1);
    return zt;
  }, Va.prototype.hideWindows = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt], sn = this.getPts(zt);
    this.flushDisplayed(sn, tn);
    for (var dn = 0; dn < 8; dn++)
      rn & 1 << dn && (tn.windows[dn].visible = 0);
    return zt;
  }, Va.prototype.toggleWindows = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt], sn = this.getPts(zt);
    this.flushDisplayed(sn, tn);
    for (var dn = 0; dn < 8; dn++)
      rn & 1 << dn && (tn.windows[dn].visible ^= 1);
    return zt;
  }, Va.prototype.clearWindows = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt], sn = this.getPts(zt);
    this.flushDisplayed(sn, tn);
    for (var dn = 0; dn < 8; dn++)
      rn & 1 << dn && tn.windows[dn].clearText();
    return zt;
  }, Va.prototype.deleteWindows = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[++zt], sn = this.getPts(zt);
    this.flushDisplayed(sn, tn);
    for (var dn = 0; dn < 8; dn++)
      rn & 1 << dn && tn.windows[dn].reset();
    return zt;
  }, Va.prototype.setPenAttributes = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = tn.currentWindow.penAttr;
    return rn = Wt[++zt], sn.textTag = (rn & 240) >> 4, sn.offset = (rn & 12) >> 2, sn.penSize = rn & 3, rn = Wt[++zt], sn.italics = (rn & 128) >> 7, sn.underline = (rn & 64) >> 6, sn.edgeType = (rn & 56) >> 3, sn.fontStyle = rn & 7, zt;
  }, Va.prototype.setPenColor = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = tn.currentWindow.penColor;
    return rn = Wt[++zt], sn.fgOpacity = (rn & 192) >> 6, sn.fgRed = (rn & 48) >> 4, sn.fgGreen = (rn & 12) >> 2, sn.fgBlue = rn & 3, rn = Wt[++zt], sn.bgOpacity = (rn & 192) >> 6, sn.bgRed = (rn & 48) >> 4, sn.bgGreen = (rn & 12) >> 2, sn.bgBlue = rn & 3, rn = Wt[++zt], sn.edgeRed = (rn & 48) >> 4, sn.edgeGreen = (rn & 12) >> 2, sn.edgeBlue = rn & 3, zt;
  }, Va.prototype.setPenLocation = function(zt, tn) {
    var Wt = this.current708Packet.data, rn = Wt[zt], sn = tn.currentWindow.penLoc;
    return tn.currentWindow.pendingNewLine = !0, rn = Wt[++zt], sn.row = rn & 15, rn = Wt[++zt], sn.column = rn & 63, zt;
  }, Va.prototype.reset = function(zt, tn) {
    var Wt = this.getPts(zt);
    return this.flushDisplayed(Wt, tn), this.initService(tn.serviceNum, zt);
  };
  var Us = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, $s = function(zt) {
    return zt === null ? "" : (zt = Us[zt] || zt, String.fromCharCode(zt));
  }, Za = 14, ml = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], Ys = function() {
    for (var zt = [], tn = Za + 1; tn--; )
      zt.push({
        text: "",
        indent: 0,
        offset: 0
      });
    return zt;
  }, Bs = function(zt, tn) {
    Bs.prototype.init.call(this), this.field_ = zt || 0, this.dataChannel_ = tn || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(Wt) {
      var rn, sn, dn, _n, wn;
      if (rn = Wt.ccData & 32639, rn === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((rn & 61440) === 4096 ? this.lastControlCode_ = rn : rn !== this.PADDING_ && (this.lastControlCode_ = null), dn = rn >>> 8, _n = rn & 255, rn !== this.PADDING_)
        if (rn === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (rn === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(Wt.pts), this.flushDisplayed(Wt.pts), sn = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = sn, this.startPts_ = Wt.pts;
        else if (rn === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(Wt.pts);
        else if (rn === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(Wt.pts);
        else if (rn === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(Wt.pts);
        else if (rn === this.CARRIAGE_RETURN_)
          this.clearFormatting(Wt.pts), this.flushDisplayed(Wt.pts), this.shiftRowsUp_(), this.startPts_ = Wt.pts;
        else if (rn === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
        else if (rn === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(Wt.pts), this.displayed_ = Ys();
        else if (rn === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = Ys();
        else if (rn === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(Wt.pts), this.displayed_ = Ys()), this.mode_ = "paintOn", this.startPts_ = Wt.pts;
        else if (this.isSpecialCharacter(dn, _n))
          dn = (dn & 3) << 8, wn = $s(dn | _n), this[this.mode_](Wt.pts, wn), this.column_++;
        else if (this.isExtCharacter(dn, _n))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), dn = (dn & 3) << 8, wn = $s(dn | _n), this[this.mode_](Wt.pts, wn), this.column_++;
        else if (this.isMidRowCode(dn, _n))
          this.clearFormatting(Wt.pts), this[this.mode_](Wt.pts, " "), this.column_++, (_n & 14) === 14 && this.addFormatting(Wt.pts, ["i"]), (_n & 1) === 1 && this.addFormatting(Wt.pts, ["u"]);
        else if (this.isOffsetControlCode(dn, _n)) {
          const Fn = _n & 3;
          this.nonDisplayed_[this.row_].offset = Fn, this.column_ += Fn;
        } else if (this.isPAC(dn, _n)) {
          var Dn = ml.indexOf(rn & 7968);
          if (this.mode_ === "rollUp" && (Dn - this.rollUpRows_ + 1 < 0 && (Dn = this.rollUpRows_ - 1), this.setRollUp(Wt.pts, Dn)), Dn !== this.row_ && Dn >= 0 && Dn <= 14 && (this.clearFormatting(Wt.pts), this.row_ = Dn), _n & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(Wt.pts, ["u"]), (rn & 16) === 16) {
            const Fn = (rn & 14) >> 1;
            this.column_ = Fn * 4, this.nonDisplayed_[this.row_].indent += Fn;
          }
          this.isColorPAC(_n) && (_n & 14) === 14 && this.addFormatting(Wt.pts, ["i"]);
        } else this.isNormalChar(dn) && (_n === 0 && (_n = null), wn = $s(dn), wn += $s(_n), this[this.mode_](Wt.pts, wn), this.column_ += wn.length);
    };
  };
  Bs.prototype = new Ks(), Bs.prototype.flushDisplayed = function(zt) {
    const tn = (rn) => {
      this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + rn + "."
      });
    }, Wt = [];
    this.displayed_.forEach((rn, sn) => {
      if (rn && rn.text && rn.text.length) {
        try {
          rn.text = rn.text.trim();
        } catch {
          tn(sn);
        }
        rn.text.length && Wt.push({
          // The text to be displayed in the caption from this specific row, with whitespace removed.
          text: rn.text,
          // Value between 1 and 15 representing the PAC row used to calculate line height.
          line: sn + 1,
          // A number representing the indent position by percentage (CEA-608 PAC indent code).
          // The value will be a number between 10 and 80. Offset is used to add an aditional
          // value to the position if necessary.
          position: 10 + Math.min(70, rn.indent * 10) + rn.offset * 2.5
        });
      } else rn == null && tn(sn);
    }), Wt.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: zt,
      content: Wt,
      stream: this.name_
    });
  }, Bs.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Ys(), this.nonDisplayed_ = Ys(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Za, this.rollUpRows_ = 2, this.formatting_ = [];
  }, Bs.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, Bs.prototype.isSpecialCharacter = function(zt, tn) {
    return zt === this.EXT_ && tn >= 48 && tn <= 63;
  }, Bs.prototype.isExtCharacter = function(zt, tn) {
    return (zt === this.EXT_ + 1 || zt === this.EXT_ + 2) && tn >= 32 && tn <= 63;
  }, Bs.prototype.isMidRowCode = function(zt, tn) {
    return zt === this.EXT_ && tn >= 32 && tn <= 47;
  }, Bs.prototype.isOffsetControlCode = function(zt, tn) {
    return zt === this.OFFSET_ && tn >= 33 && tn <= 35;
  }, Bs.prototype.isPAC = function(zt, tn) {
    return zt >= this.BASE_ && zt < this.BASE_ + 8 && tn >= 64 && tn <= 127;
  }, Bs.prototype.isColorPAC = function(zt) {
    return zt >= 64 && zt <= 79 || zt >= 96 && zt <= 127;
  }, Bs.prototype.isNormalChar = function(zt) {
    return zt >= 32 && zt <= 127;
  }, Bs.prototype.setRollUp = function(zt, tn) {
    if (this.mode_ !== "rollUp" && (this.row_ = Za, this.mode_ = "rollUp", this.flushDisplayed(zt), this.nonDisplayed_ = Ys(), this.displayed_ = Ys()), tn !== void 0 && tn !== this.row_)
      for (var Wt = 0; Wt < this.rollUpRows_; Wt++)
        this.displayed_[tn - Wt] = this.displayed_[this.row_ - Wt], this.displayed_[this.row_ - Wt] = {
          text: "",
          indent: 0,
          offset: 0
        };
    tn === void 0 && (tn = this.row_), this.topRow_ = tn - this.rollUpRows_ + 1;
  }, Bs.prototype.addFormatting = function(zt, tn) {
    this.formatting_ = this.formatting_.concat(tn);
    var Wt = tn.reduce(function(rn, sn) {
      return rn + "<" + sn + ">";
    }, "");
    this[this.mode_](zt, Wt);
  }, Bs.prototype.clearFormatting = function(zt) {
    if (this.formatting_.length) {
      var tn = this.formatting_.reverse().reduce(function(Wt, rn) {
        return Wt + "</" + rn + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](zt, tn);
    }
  }, Bs.prototype.popOn = function(zt, tn) {
    var Wt = this.nonDisplayed_[this.row_].text;
    Wt += tn, this.nonDisplayed_[this.row_].text = Wt;
  }, Bs.prototype.rollUp = function(zt, tn) {
    var Wt = this.displayed_[this.row_].text;
    Wt += tn, this.displayed_[this.row_].text = Wt;
  }, Bs.prototype.shiftRowsUp_ = function() {
    var zt;
    for (zt = 0; zt < this.topRow_; zt++)
      this.displayed_[zt] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (zt = this.row_ + 1; zt < Za + 1; zt++)
      this.displayed_[zt] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (zt = this.topRow_; zt < this.row_; zt++)
      this.displayed_[zt] = this.displayed_[zt + 1];
    this.displayed_[this.row_] = {
      text: "",
      indent: 0,
      offset: 0
    };
  }, Bs.prototype.paintOn = function(zt, tn) {
    var Wt = this.displayed_[this.row_].text;
    Wt += tn, this.displayed_[this.row_].text = Wt;
  };
  var Wa = {
    CaptionStream: qs,
    Cea608Stream: Bs,
    Cea708Stream: Va
  }, js = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, Fs = me, Xi = 8589934592, ao = 4294967296, Sl = "shared", xl = function(zt, tn) {
    var Wt = 1;
    for (zt > tn && (Wt = -1); Math.abs(tn - zt) > ao; )
      zt += Wt * Xi;
    return zt;
  }, fm = function(zt) {
    var tn, Wt;
    fm.prototype.init.call(this), this.type_ = zt || Sl, this.push = function(rn) {
      if (rn.type === "metadata") {
        this.trigger("data", rn);
        return;
      }
      this.type_ !== Sl && rn.type !== this.type_ || (Wt === void 0 && (Wt = rn.dts), rn.dts = xl(rn.dts, Wt), rn.pts = xl(rn.pts, Wt), tn = rn.dts, this.trigger("data", rn));
    }, this.flush = function() {
      Wt = tn, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      Wt = void 0, tn = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  fm.prototype = new Fs();
  var Jp = {
    TimestampRolloverStream: fm,
    handleRollover: xl
  }, um = (zt, tn, Wt) => {
    if (!zt)
      return -1;
    for (var rn = Wt; rn < zt.length; rn++)
      if (zt[rn] === tn)
        return rn;
    return -1;
  }, sm = {
    typedArrayIndexOf: um
  }, em = sm.typedArrayIndexOf, _m = {
    // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
    Utf8: 3
    // UTF-8 encoded Unicode, terminated with \0
  }, wm = function(zt, tn, Wt) {
    var rn, sn = "";
    for (rn = tn; rn < Wt; rn++)
      sn += "%" + ("00" + zt[rn].toString(16)).slice(-2);
    return sn;
  }, tm = function(zt, tn, Wt) {
    return decodeURIComponent(wm(zt, tn, Wt));
  }, cm = function(zt, tn, Wt) {
    return unescape(wm(zt, tn, Wt));
  }, Lm = function(zt) {
    return zt[0] << 21 | zt[1] << 14 | zt[2] << 7 | zt[3];
  }, Om = {
    APIC: function(zt) {
      var tn = 1, Wt, rn, sn = "-->";
      zt.data[0] === _m.Utf8 && (Wt = em(zt.data, 0, tn), !(Wt < 0) && (zt.mimeType = cm(zt.data, tn, Wt), tn = Wt + 1, zt.pictureType = zt.data[tn], tn++, rn = em(zt.data, 0, tn), !(rn < 0) && (zt.description = tm(zt.data, tn, rn), tn = rn + 1, zt.mimeType === sn ? zt.url = cm(zt.data, tn, zt.data.length) : zt.pictureData = zt.data.subarray(tn, zt.data.length))));
    },
    "T*": function(zt) {
      zt.data[0] === _m.Utf8 && (zt.value = tm(zt.data, 1, zt.data.length).replace(/\0*$/, ""), zt.values = zt.value.split("\0"));
    },
    TXXX: function(zt) {
      var tn;
      zt.data[0] === _m.Utf8 && (tn = em(zt.data, 0, 1), tn !== -1 && (zt.description = tm(zt.data, 1, tn), zt.value = tm(zt.data, tn + 1, zt.data.length).replace(/\0*$/, ""), zt.data = zt.value));
    },
    "W*": function(zt) {
      zt.url = cm(zt.data, 0, zt.data.length).replace(/\0.*$/, "");
    },
    WXXX: function(zt) {
      var tn;
      zt.data[0] === _m.Utf8 && (tn = em(zt.data, 0, 1), tn !== -1 && (zt.description = tm(zt.data, 1, tn), zt.url = cm(zt.data, tn + 1, zt.data.length).replace(/\0.*$/, "")));
    },
    PRIV: function(zt) {
      var tn;
      for (tn = 0; tn < zt.data.length; tn++)
        if (zt.data[tn] === 0) {
          zt.owner = cm(zt.data, 0, tn);
          break;
        }
      zt.privateData = zt.data.subarray(tn + 1), zt.data = zt.privateData;
    }
  }, Vm = function(zt) {
    var tn, Wt, rn = 10, sn = 0, dn = [];
    if (!(zt.length < 10 || zt[0] !== 73 || zt[1] !== 68 || zt[2] !== 51)) {
      sn = Lm(zt.subarray(6, 10)), sn += 10;
      var _n = zt[5] & 64;
      _n && (rn += 4, rn += Lm(zt.subarray(10, 14)), sn -= Lm(zt.subarray(16, 20)));
      do {
        if (tn = Lm(zt.subarray(rn + 4, rn + 8)), tn < 1)
          break;
        Wt = String.fromCharCode(zt[rn], zt[rn + 1], zt[rn + 2], zt[rn + 3]);
        var wn = {
          id: Wt,
          data: zt.subarray(rn + 10, rn + tn + 10)
        };
        wn.key = wn.id, Om[wn.id] ? Om[wn.id](wn) : wn.id[0] === "T" ? Om["T*"](wn) : wn.id[0] === "W" && Om["W*"](wn), dn.push(wn), rn += 10, rn += tn;
      } while (rn < sn);
      return dn;
    }
  }, ug = {
    parseId3Frames: Vm,
    parseSyncSafeInteger: Lm,
    frameParsers: Om
  }, qm = me, Tl = js, uo = ug, om;
  om = function(zt) {
    var tn = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: zt && zt.descriptor
    }, Wt = 0, rn = [], sn = 0, dn;
    if (om.prototype.init.call(this), this.dispatchType = Tl.METADATA_STREAM_TYPE.toString(16), tn.descriptor)
      for (dn = 0; dn < tn.descriptor.length; dn++)
        this.dispatchType += ("00" + tn.descriptor[dn].toString(16)).slice(-2);
    this.push = function(_n) {
      var wn, Dn, Fn, yi, Wi, Vs;
      if (_n.type === "timed-metadata") {
        if (_n.dataAlignmentIndicator && (sn = 0, rn.length = 0), rn.length === 0 && (_n.data.length < 10 || _n.data[0] !== 73 || _n.data[1] !== 68 || _n.data[2] !== 51)) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (rn.push(_n), sn += _n.data.byteLength, rn.length === 1 && (Wt = uo.parseSyncSafeInteger(_n.data.subarray(6, 10)), Wt += 10), !(sn < Wt)) {
          for (wn = {
            data: new Uint8Array(Wt),
            frames: [],
            pts: rn[0].pts,
            dts: rn[0].dts
          }, Wi = 0; Wi < Wt; )
            wn.data.set(rn[0].data.subarray(0, Wt - Wi), Wi), Wi += rn[0].data.byteLength, sn -= rn[0].data.byteLength, rn.shift();
          Dn = 10, wn.data[5] & 64 && (Dn += 4, Dn += uo.parseSyncSafeInteger(wn.data.subarray(10, 14)), Wt -= uo.parseSyncSafeInteger(wn.data.subarray(16, 20)));
          do {
            if (Fn = uo.parseSyncSafeInteger(wn.data.subarray(Dn + 4, Dn + 8)), Fn < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
              });
              break;
            }
            if (Vs = String.fromCharCode(wn.data[Dn], wn.data[Dn + 1], wn.data[Dn + 2], wn.data[Dn + 3]), yi = {
              id: Vs,
              data: wn.data.subarray(Dn + 10, Dn + Fn + 10)
            }, yi.key = yi.id, uo.frameParsers[yi.id] ? uo.frameParsers[yi.id](yi) : yi.id[0] === "T" ? uo.frameParsers["T*"](yi) : yi.id[0] === "W" && uo.frameParsers["W*"](yi), yi.owner === "com.apple.streaming.transportStreamTimestamp") {
              var $a = yi.data, fo = ($a[3] & 1) << 30 | $a[4] << 22 | $a[5] << 14 | $a[6] << 6 | $a[7] >>> 2;
              fo *= 4, fo += $a[7] & 3, yi.timeStamp = fo, wn.pts === void 0 && wn.dts === void 0 && (wn.pts = yi.timeStamp, wn.dts = yi.timeStamp), this.trigger("timestamp", yi);
            }
            wn.frames.push(yi), Dn += 10, Dn += Fn;
          } while (Dn < Wt);
          this.trigger("data", wn);
        }
      }
    };
  }, om.prototype = new qm();
  var pm = om, zl = me, rm = Wa, Zp = js, Am = Jp.TimestampRolloverStream, Sm, mm, Rm, $m = 188, xm = 71;
  Sm = function() {
    var zt = new Uint8Array($m), tn = 0;
    Sm.prototype.init.call(this), this.push = function(Wt) {
      var rn = 0, sn = $m, dn;
      for (tn ? (dn = new Uint8Array(Wt.byteLength + tn), dn.set(zt.subarray(0, tn)), dn.set(Wt, tn), tn = 0) : dn = Wt; sn < dn.byteLength; ) {
        if (dn[rn] === xm && dn[sn] === xm) {
          this.trigger("data", dn.subarray(rn, sn)), rn += $m, sn += $m;
          continue;
        }
        rn++, sn++;
      }
      rn < dn.byteLength && (zt.set(dn.subarray(rn), 0), tn = dn.byteLength - rn);
    }, this.flush = function() {
      tn === $m && zt[0] === xm && (this.trigger("data", zt), tn = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      tn = 0, this.trigger("reset");
    };
  }, Sm.prototype = new zl(), mm = function() {
    var zt, tn, Wt, rn;
    mm.prototype.init.call(this), rn = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, zt = function(sn, dn) {
      var _n = 0;
      dn.payloadUnitStartIndicator && (_n += sn[_n] + 1), dn.type === "pat" ? tn(sn.subarray(_n), dn) : Wt(sn.subarray(_n), dn);
    }, tn = function(sn, dn) {
      dn.section_number = sn[7], dn.last_section_number = sn[8], rn.pmtPid = (sn[10] & 31) << 8 | sn[11], dn.pmtPid = rn.pmtPid;
    }, Wt = function(sn, dn) {
      var _n, wn, Dn, Fn;
      if (sn[5] & 1) {
        for (rn.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, _n = (sn[1] & 15) << 8 | sn[2], wn = 3 + _n - 4, Dn = (sn[10] & 15) << 8 | sn[11], Fn = 12 + Dn; Fn < wn; ) {
          var yi = sn[Fn], Wi = (sn[Fn + 1] & 31) << 8 | sn[Fn + 2];
          yi === Zp.H264_STREAM_TYPE && rn.programMapTable.video === null ? rn.programMapTable.video = Wi : yi === Zp.ADTS_STREAM_TYPE && rn.programMapTable.audio === null ? rn.programMapTable.audio = Wi : yi === Zp.METADATA_STREAM_TYPE && (rn.programMapTable["timed-metadata"][Wi] = yi), Fn += ((sn[Fn + 3] & 15) << 8 | sn[Fn + 4]) + 5;
        }
        dn.programMapTable = rn.programMapTable;
      }
    }, this.push = function(sn) {
      var dn = {}, _n = 4;
      if (dn.payloadUnitStartIndicator = !!(sn[1] & 64), dn.pid = sn[1] & 31, dn.pid <<= 8, dn.pid |= sn[2], (sn[3] & 48) >>> 4 > 1 && (_n += sn[_n] + 1), dn.pid === 0)
        dn.type = "pat", zt(sn.subarray(_n), dn), this.trigger("data", dn);
      else if (dn.pid === this.pmtPid)
        for (dn.type = "pmt", zt(sn.subarray(_n), dn), this.trigger("data", dn); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([sn, _n, dn]) : this.processPes_(sn, _n, dn);
    }, this.processPes_ = function(sn, dn, _n) {
      _n.pid === this.programMapTable.video ? _n.streamType = Zp.H264_STREAM_TYPE : _n.pid === this.programMapTable.audio ? _n.streamType = Zp.ADTS_STREAM_TYPE : _n.streamType = this.programMapTable["timed-metadata"][_n.pid], _n.type = "pes", _n.data = sn.subarray(dn), this.trigger("data", _n);
    };
  }, mm.prototype = new zl(), mm.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, Rm = function() {
    var zt = this, tn = !1, Wt = {
      data: [],
      size: 0
    }, rn = {
      data: [],
      size: 0
    }, sn = {
      data: [],
      size: 0
    }, dn, _n = function(Dn, Fn) {
      var yi;
      const Wi = Dn[0] << 16 | Dn[1] << 8 | Dn[2];
      Fn.data = new Uint8Array(), Wi === 1 && (Fn.packetLength = 6 + (Dn[4] << 8 | Dn[5]), Fn.dataAlignmentIndicator = (Dn[6] & 4) !== 0, yi = Dn[7], yi & 192 && (Fn.pts = (Dn[9] & 14) << 27 | (Dn[10] & 255) << 20 | (Dn[11] & 254) << 12 | (Dn[12] & 255) << 5 | (Dn[13] & 254) >>> 3, Fn.pts *= 4, Fn.pts += (Dn[13] & 6) >>> 1, Fn.dts = Fn.pts, yi & 64 && (Fn.dts = (Dn[14] & 14) << 27 | (Dn[15] & 255) << 20 | (Dn[16] & 254) << 12 | (Dn[17] & 255) << 5 | (Dn[18] & 254) >>> 3, Fn.dts *= 4, Fn.dts += (Dn[18] & 6) >>> 1)), Fn.data = Dn.subarray(9 + Dn[8]));
    }, wn = function(Dn, Fn, yi) {
      var Wi = new Uint8Array(Dn.size), Vs = {
        type: Fn
      }, $a = 0, fo = 0, El = !1, Qp;
      if (!(!Dn.data.length || Dn.size < 9)) {
        for (Vs.trackId = Dn.data[0].pid, $a = 0; $a < Dn.data.length; $a++)
          Qp = Dn.data[$a], Wi.set(Qp.data, fo), fo += Qp.data.byteLength;
        _n(Wi, Vs), El = Fn === "video" || Vs.packetLength <= Dn.size, (yi || El) && (Dn.size = 0, Dn.data.length = 0), El && zt.trigger("data", Vs);
      }
    };
    Rm.prototype.init.call(this), this.push = function(Dn) {
      ({
        pat: function() {
        },
        pes: function() {
          var Fn, yi;
          switch (Dn.streamType) {
            case Zp.H264_STREAM_TYPE:
              Fn = Wt, yi = "video";
              break;
            case Zp.ADTS_STREAM_TYPE:
              Fn = rn, yi = "audio";
              break;
            case Zp.METADATA_STREAM_TYPE:
              Fn = sn, yi = "timed-metadata";
              break;
            default:
              return;
          }
          Dn.payloadUnitStartIndicator && wn(Fn, yi, !0), Fn.data.push(Dn), Fn.size += Dn.data.byteLength;
        },
        pmt: function() {
          var Fn = {
            type: "metadata",
            tracks: []
          };
          dn = Dn.programMapTable, dn.video !== null && Fn.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +dn.video,
            codec: "avc",
            type: "video"
          }), dn.audio !== null && Fn.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +dn.audio,
            codec: "adts",
            type: "audio"
          }), tn = !0, zt.trigger("data", Fn);
        }
      })[Dn.type]();
    }, this.reset = function() {
      Wt.size = 0, Wt.data.length = 0, rn.size = 0, rn.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      wn(Wt, "video"), wn(rn, "audio"), wn(sn, "timed-metadata");
    }, this.flush = function() {
      if (!tn && dn) {
        var Dn = {
          type: "metadata",
          tracks: []
        };
        dn.video !== null && Dn.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +dn.video,
          codec: "avc",
          type: "video"
        }), dn.audio !== null && Dn.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +dn.audio,
          codec: "adts",
          type: "audio"
        }), zt.trigger("data", Dn);
      }
      tn = !1, this.flushStreams_(), this.trigger("done");
    };
  }, Rm.prototype = new zl();
  var Ig = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: $m,
    TransportPacketStream: Sm,
    TransportParseStream: mm,
    ElementaryStream: Rm,
    TimestampRolloverStream: Am,
    CaptionStream: rm.CaptionStream,
    Cea608Stream: rm.Cea608Stream,
    Cea708Stream: rm.Cea708Stream,
    MetadataStream: pm
  };
  for (var km in Zp)
    Zp.hasOwnProperty(km) && (Ig[km] = Zp[km]);
  var Og = Ig, yg = me, cg = lo.ONE_SECOND_IN_TS, zm, Eg = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  zm = function(zt) {
    var tn, Wt = 0;
    zm.prototype.init.call(this), this.skipWarn_ = function(rn, sn) {
      this.trigger("log", {
        level: "warn",
        message: `adts skiping bytes ${rn} to ${sn} in frame ${Wt} outside syncword`
      });
    }, this.push = function(rn) {
      var sn = 0, dn, _n, wn, Dn, Fn;
      if (zt || (Wt = 0), rn.type === "audio") {
        tn && tn.length ? (wn = tn, tn = new Uint8Array(wn.byteLength + rn.data.byteLength), tn.set(wn), tn.set(rn.data, wn.byteLength)) : tn = rn.data;
        for (var yi; sn + 7 < tn.length; ) {
          if (tn[sn] !== 255 || (tn[sn + 1] & 246) !== 240) {
            typeof yi != "number" && (yi = sn), sn++;
            continue;
          }
          if (typeof yi == "number" && (this.skipWarn_(yi, sn), yi = null), _n = (~tn[sn + 1] & 1) * 2, dn = (tn[sn + 3] & 3) << 11 | tn[sn + 4] << 3 | (tn[sn + 5] & 224) >> 5, Dn = ((tn[sn + 6] & 3) + 1) * 1024, Fn = Dn * cg / Eg[(tn[sn + 2] & 60) >>> 2], tn.byteLength - sn < dn)
            break;
          this.trigger("data", {
            pts: rn.pts + Wt * Fn,
            dts: rn.dts + Wt * Fn,
            sampleCount: Dn,
            audioobjecttype: (tn[sn + 2] >>> 6 & 3) + 1,
            channelcount: (tn[sn + 2] & 1) << 2 | (tn[sn + 3] & 192) >>> 6,
            samplerate: Eg[(tn[sn + 2] & 60) >>> 2],
            samplingfrequencyindex: (tn[sn + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: tn.subarray(sn + 7 + _n, sn + dn)
          }), Wt++, sn += dn;
        }
        typeof yi == "number" && (this.skipWarn_(yi, sn), yi = null), tn = tn.subarray(sn);
      }
    }, this.flush = function() {
      Wt = 0, this.trigger("done");
    }, this.reset = function() {
      tn = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      tn = void 0, this.trigger("endedtimeline");
    };
  }, zm.prototype = new yg();
  var Mg = zm, h1;
  h1 = function(zt) {
    var tn = zt.byteLength, Wt = 0, rn = 0;
    this.length = function() {
      return 8 * tn;
    }, this.bitsAvailable = function() {
      return 8 * tn + rn;
    }, this.loadWord = function() {
      var sn = zt.byteLength - tn, dn = new Uint8Array(4), _n = Math.min(4, tn);
      if (_n === 0)
        throw new Error("no bytes available");
      dn.set(zt.subarray(sn, sn + _n)), Wt = new DataView(dn.buffer).getUint32(0), rn = _n * 8, tn -= _n;
    }, this.skipBits = function(sn) {
      var dn;
      rn > sn ? (Wt <<= sn, rn -= sn) : (sn -= rn, dn = Math.floor(sn / 8), sn -= dn * 8, tn -= dn, this.loadWord(), Wt <<= sn, rn -= sn);
    }, this.readBits = function(sn) {
      var dn = Math.min(rn, sn), _n = Wt >>> 32 - dn;
      return rn -= dn, rn > 0 ? Wt <<= dn : tn > 0 && this.loadWord(), dn = sn - dn, dn > 0 ? _n << dn | this.readBits(dn) : _n;
    }, this.skipLeadingZeros = function() {
      var sn;
      for (sn = 0; sn < rn; ++sn)
        if ((Wt & 2147483648 >>> sn) !== 0)
          return Wt <<= sn, rn -= sn, sn;
      return this.loadWord(), sn + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var sn = this.skipLeadingZeros();
      return this.readBits(sn + 1) - 1;
    }, this.readExpGolomb = function() {
      var sn = this.readUnsignedExpGolomb();
      return 1 & sn ? 1 + sn >>> 1 : -1 * (sn >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var L1 = h1, p1 = me, ro = L1, co, Wl, hm;
  Wl = function() {
    var zt = 0, tn, Wt;
    Wl.prototype.init.call(this), this.push = function(rn) {
      var sn;
      Wt ? (sn = new Uint8Array(Wt.byteLength + rn.data.byteLength), sn.set(Wt), sn.set(rn.data, Wt.byteLength), Wt = sn) : Wt = rn.data;
      for (var dn = Wt.byteLength; zt < dn - 3; zt++)
        if (Wt[zt + 2] === 1) {
          tn = zt + 5;
          break;
        }
      for (; tn < dn; )
        switch (Wt[tn]) {
          case 0:
            if (Wt[tn - 1] !== 0) {
              tn += 2;
              break;
            } else if (Wt[tn - 2] !== 0) {
              tn++;
              break;
            }
            zt + 3 !== tn - 2 && this.trigger("data", Wt.subarray(zt + 3, tn - 2));
            do
              tn++;
            while (Wt[tn] !== 1 && tn < dn);
            zt = tn - 2, tn += 3;
            break;
          case 1:
            if (Wt[tn - 1] !== 0 || Wt[tn - 2] !== 0) {
              tn += 3;
              break;
            }
            this.trigger("data", Wt.subarray(zt + 3, tn - 2)), zt = tn - 2, tn += 3;
            break;
          default:
            tn += 3;
            break;
        }
      Wt = Wt.subarray(zt), tn -= zt, zt = 0;
    }, this.reset = function() {
      Wt = null, zt = 0, this.trigger("reset");
    }, this.flush = function() {
      Wt && Wt.byteLength > 3 && this.trigger("data", Wt.subarray(zt + 3)), Wt = null, zt = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, Wl.prototype = new p1(), hm = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, co = function() {
    var zt = new Wl(), tn, Wt, rn, sn, dn, _n, wn;
    co.prototype.init.call(this), tn = this, this.push = function(Dn) {
      Dn.type === "video" && (Wt = Dn.trackId, rn = Dn.pts, sn = Dn.dts, zt.push(Dn));
    }, zt.on("data", function(Dn) {
      var Fn = {
        trackId: Wt,
        pts: rn,
        dts: sn,
        data: Dn,
        nalUnitTypeCode: Dn[0] & 31
      };
      switch (Fn.nalUnitTypeCode) {
        case 5:
          Fn.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          Fn.nalUnitType = "sei_rbsp", Fn.escapedRBSP = dn(Dn.subarray(1));
          break;
        case 7:
          Fn.nalUnitType = "seq_parameter_set_rbsp", Fn.escapedRBSP = dn(Dn.subarray(1)), Fn.config = _n(Fn.escapedRBSP);
          break;
        case 8:
          Fn.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          Fn.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      tn.trigger("data", Fn);
    }), zt.on("done", function() {
      tn.trigger("done");
    }), zt.on("partialdone", function() {
      tn.trigger("partialdone");
    }), zt.on("reset", function() {
      tn.trigger("reset");
    }), zt.on("endedtimeline", function() {
      tn.trigger("endedtimeline");
    }), this.flush = function() {
      zt.flush();
    }, this.partialFlush = function() {
      zt.partialFlush();
    }, this.reset = function() {
      zt.reset();
    }, this.endTimeline = function() {
      zt.endTimeline();
    }, wn = function(Dn, Fn) {
      var yi = 8, Wi = 8, Vs, $a;
      for (Vs = 0; Vs < Dn; Vs++)
        Wi !== 0 && ($a = Fn.readExpGolomb(), Wi = (yi + $a + 256) % 256), yi = Wi === 0 ? yi : Wi;
    }, dn = function(Dn) {
      for (var Fn = Dn.byteLength, yi = [], Wi = 1, Vs, $a; Wi < Fn - 2; )
        Dn[Wi] === 0 && Dn[Wi + 1] === 0 && Dn[Wi + 2] === 3 ? (yi.push(Wi + 2), Wi += 2) : Wi++;
      if (yi.length === 0)
        return Dn;
      Vs = Fn - yi.length, $a = new Uint8Array(Vs);
      var fo = 0;
      for (Wi = 0; Wi < Vs; fo++, Wi++)
        fo === yi[0] && (fo++, yi.shift()), $a[Wi] = Dn[fo];
      return $a;
    }, _n = function(Dn) {
      var Fn = 0, yi = 0, Wi = 0, Vs = 0, $a, fo, El, Qp, jm, hg, Z1, yS, bS, Bm, Q1, am = [1, 1], vx, a1;
      if ($a = new ro(Dn), fo = $a.readUnsignedByte(), Qp = $a.readUnsignedByte(), El = $a.readUnsignedByte(), $a.skipUnsignedExpGolomb(), hm[fo] && (jm = $a.readUnsignedExpGolomb(), jm === 3 && $a.skipBits(1), $a.skipUnsignedExpGolomb(), $a.skipUnsignedExpGolomb(), $a.skipBits(1), $a.readBoolean()))
        for (Q1 = jm !== 3 ? 8 : 12, a1 = 0; a1 < Q1; a1++)
          $a.readBoolean() && (a1 < 6 ? wn(16, $a) : wn(64, $a));
      if ($a.skipUnsignedExpGolomb(), hg = $a.readUnsignedExpGolomb(), hg === 0)
        $a.readUnsignedExpGolomb();
      else if (hg === 1)
        for ($a.skipBits(1), $a.skipExpGolomb(), $a.skipExpGolomb(), Z1 = $a.readUnsignedExpGolomb(), a1 = 0; a1 < Z1; a1++)
          $a.skipExpGolomb();
      if ($a.skipUnsignedExpGolomb(), $a.skipBits(1), yS = $a.readUnsignedExpGolomb(), bS = $a.readUnsignedExpGolomb(), Bm = $a.readBits(1), Bm === 0 && $a.skipBits(1), $a.skipBits(1), $a.readBoolean() && (Fn = $a.readUnsignedExpGolomb(), yi = $a.readUnsignedExpGolomb(), Wi = $a.readUnsignedExpGolomb(), Vs = $a.readUnsignedExpGolomb()), $a.readBoolean() && $a.readBoolean()) {
        switch (vx = $a.readUnsignedByte(), vx) {
          case 1:
            am = [1, 1];
            break;
          case 2:
            am = [12, 11];
            break;
          case 3:
            am = [10, 11];
            break;
          case 4:
            am = [16, 11];
            break;
          case 5:
            am = [40, 33];
            break;
          case 6:
            am = [24, 11];
            break;
          case 7:
            am = [20, 11];
            break;
          case 8:
            am = [32, 11];
            break;
          case 9:
            am = [80, 33];
            break;
          case 10:
            am = [18, 11];
            break;
          case 11:
            am = [15, 11];
            break;
          case 12:
            am = [64, 33];
            break;
          case 13:
            am = [160, 99];
            break;
          case 14:
            am = [4, 3];
            break;
          case 15:
            am = [3, 2];
            break;
          case 16:
            am = [2, 1];
            break;
          case 255: {
            am = [$a.readUnsignedByte() << 8 | $a.readUnsignedByte(), $a.readUnsignedByte() << 8 | $a.readUnsignedByte()];
            break;
          }
        }
        am && am[0] / am[1];
      }
      return {
        profileIdc: fo,
        levelIdc: El,
        profileCompatibility: Qp,
        width: (yS + 1) * 16 - Fn * 2 - yi * 2,
        height: (2 - Bm) * (bS + 1) * 16 - Wi * 2 - Vs * 2,
        // sar is sample aspect ratio
        sarRatio: am
      };
    };
  }, co.prototype = new p1();
  var lm = {
    H264Stream: co
  }, m1 = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], g1 = function(zt, tn) {
    var Wt = zt[tn + 6] << 21 | zt[tn + 7] << 14 | zt[tn + 8] << 7 | zt[tn + 9], rn = zt[tn + 5], sn = (rn & 16) >> 4;
    return Wt = Wt >= 0 ? Wt : 0, sn ? Wt + 20 : Wt + 10;
  }, Gl = function(zt, tn) {
    return zt.length - tn < 10 || zt[tn] !== 73 || zt[tn + 1] !== 68 || zt[tn + 2] !== 51 ? tn : (tn += g1(zt, tn), Gl(zt, tn));
  }, Vl = function(zt) {
    var tn = Gl(zt, 0);
    return zt.length >= tn + 2 && (zt[tn] & 255) === 255 && (zt[tn + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (zt[tn + 1] & 22) === 16;
  }, WS = function(zt) {
    return zt[0] << 21 | zt[1] << 14 | zt[2] << 7 | zt[3];
  }, Vx = function(zt, tn, Wt) {
    var rn, sn = "";
    for (rn = tn; rn < Wt; rn++)
      sn += "%" + ("00" + zt[rn].toString(16)).slice(-2);
    return sn;
  }, Hx = function(zt, tn, Wt) {
    return unescape(Vx(zt, tn, Wt));
  }, qx = function(zt, tn) {
    var Wt = (zt[tn + 5] & 224) >> 5, rn = zt[tn + 4] << 3, sn = zt[tn + 3] & 6144;
    return sn | rn | Wt;
  }, zx = function(zt, tn) {
    return zt[tn] === 73 && zt[tn + 1] === 68 && zt[tn + 2] === 51 ? "timed-metadata" : zt[tn] & !0 && (zt[tn + 1] & 240) === 240 ? "audio" : null;
  }, Wx = function(zt) {
    for (var tn = 0; tn + 5 < zt.length; ) {
      if (zt[tn] !== 255 || (zt[tn + 1] & 246) !== 240) {
        tn++;
        continue;
      }
      return m1[(zt[tn + 2] & 60) >>> 2];
    }
    return null;
  }, GS = function(zt) {
    var tn, Wt, rn, sn;
    tn = 10, zt[5] & 64 && (tn += 4, tn += WS(zt.subarray(10, 14)));
    do {
      if (Wt = WS(zt.subarray(tn + 4, tn + 8)), Wt < 1)
        return null;
      if (sn = String.fromCharCode(zt[tn], zt[tn + 1], zt[tn + 2], zt[tn + 3]), sn === "PRIV") {
        rn = zt.subarray(tn + 10, tn + Wt + 10);
        for (var dn = 0; dn < rn.byteLength; dn++)
          if (rn[dn] === 0) {
            var _n = Hx(rn, 0, dn);
            if (_n === "com.apple.streaming.transportStreamTimestamp") {
              var wn = rn.subarray(dn + 1), Dn = (wn[3] & 1) << 30 | wn[4] << 22 | wn[5] << 14 | wn[6] << 6 | wn[7] >>> 2;
              return Dn *= 4, Dn += wn[7] & 3, Dn;
            }
            break;
          }
      }
      tn += 10, tn += Wt;
    } while (tn < zt.byteLength);
    return null;
  }, wS = {
    isLikelyAacData: Vl,
    parseId3TagSize: g1,
    parseAdtsSize: qx,
    parseType: zx,
    parseSampleRate: Wx,
    parseAacTimestamp: GS
  }, Dm = me, iS = wS, dg;
  dg = function() {
    var zt = new Uint8Array(), tn = 0;
    dg.prototype.init.call(this), this.setTimestamp = function(Wt) {
      tn = Wt;
    }, this.push = function(Wt) {
      var rn = 0, sn = 0, dn, _n, wn, Dn;
      for (zt.length ? (Dn = zt.length, zt = new Uint8Array(Wt.byteLength + Dn), zt.set(zt.subarray(0, Dn)), zt.set(Wt, Dn)) : zt = Wt; zt.length - sn >= 3; ) {
        if (zt[sn] === 73 && zt[sn + 1] === 68 && zt[sn + 2] === 51) {
          if (zt.length - sn < 10 || (rn = iS.parseId3TagSize(zt, sn), sn + rn > zt.length))
            break;
          _n = {
            type: "timed-metadata",
            data: zt.subarray(sn, sn + rn)
          }, this.trigger("data", _n), sn += rn;
          continue;
        } else if ((zt[sn] & 255) === 255 && (zt[sn + 1] & 240) === 240) {
          if (zt.length - sn < 7 || (rn = iS.parseAdtsSize(zt, sn), sn + rn > zt.length))
            break;
          wn = {
            type: "audio",
            data: zt.subarray(sn, sn + rn),
            pts: tn,
            dts: tn
          }, this.trigger("data", wn), sn += rn;
          continue;
        }
        sn++;
      }
      dn = zt.length - sn, dn > 0 ? zt = zt.subarray(sn) : zt = new Uint8Array();
    }, this.reset = function() {
      zt = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      zt = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, dg.prototype = new Dm();
  var YS = dg, AS = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], Xm = AS, KS = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], XS = KS, N1 = me, y1 = xi, b1 = Ga, F1 = kl, dm = Ql, bg = Og, Nm = lo, ZS = Mg, QS = lm.H264Stream, Cg = YS, aS = wS.isLikelyAacData, $S = lo.ONE_SECOND_IN_TS, im = Xm, _g = XS, _1, j1, S1, Lg, Gx = function(zt, tn) {
    tn.stream = zt, this.trigger("log", tn);
  }, JS = function(zt, tn) {
    for (var Wt = Object.keys(tn), rn = 0; rn < Wt.length; rn++) {
      var sn = Wt[rn];
      sn === "headOfPipeline" || !tn[sn].on || tn[sn].on("log", Gx.bind(zt, sn));
    }
  }, PS = function(zt, tn) {
    var Wt;
    if (zt.length !== tn.length)
      return !1;
    for (Wt = 0; Wt < zt.length; Wt++)
      if (zt[Wt] !== tn[Wt])
        return !1;
    return !0;
  }, B1 = function(zt, tn, Wt, rn, sn, dn) {
    var _n = Wt - tn, wn = rn - tn, Dn = sn - Wt;
    return {
      start: {
        dts: zt,
        pts: zt + _n
      },
      end: {
        dts: zt + wn,
        pts: zt + Dn
      },
      prependedContentDuration: dn,
      baseMediaDecodeTime: zt
    };
  };
  j1 = function(zt, tn) {
    var Wt = [], rn, sn = 0, dn = 0, _n = 1 / 0;
    tn = tn || {}, rn = tn.firstSequenceNumber || 0, j1.prototype.init.call(this), this.push = function(wn) {
      dm.collectDtsInfo(zt, wn), zt && im.forEach(function(Dn) {
        zt[Dn] = wn[Dn];
      }), Wt.push(wn);
    }, this.setEarliestDts = function(wn) {
      sn = wn;
    }, this.setVideoBaseMediaDecodeTime = function(wn) {
      _n = wn;
    }, this.setAudioAppendStart = function(wn) {
      dn = wn;
    }, this.flush = function() {
      var wn, Dn, Fn, yi, Wi, Vs, $a;
      if (Wt.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      wn = F1.trimAdtsFramesByEarliestDts(Wt, zt, sn), zt.baseMediaDecodeTime = dm.calculateTrackBaseMediaDecodeTime(zt, tn.keepOriginalTimestamps), $a = F1.prefixWithSilence(zt, wn, dn, _n), zt.samples = F1.generateSampleTable(wn), Fn = y1.mdat(F1.concatenateFrameData(wn)), Wt = [], Dn = y1.moof(rn, [zt]), yi = new Uint8Array(Dn.byteLength + Fn.byteLength), rn++, yi.set(Dn), yi.set(Fn, Dn.byteLength), dm.clearDtsInfo(zt), Wi = Math.ceil($S * 1024 / zt.samplerate), wn.length && (Vs = wn.length * Wi, this.trigger("segmentTimingInfo", B1(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        Nm.audioTsToVideoTs(zt.baseMediaDecodeTime, zt.samplerate),
        // frame times are already in video clock, as is segment duration
        wn[0].dts,
        wn[0].pts,
        wn[0].dts + Vs,
        wn[0].pts + Vs,
        $a || 0
      )), this.trigger("timingInfo", {
        start: wn[0].pts,
        end: wn[0].pts + Vs
      })), this.trigger("data", {
        track: zt,
        boxes: yi
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      dm.clearDtsInfo(zt), Wt = [], this.trigger("reset");
    };
  }, j1.prototype = new N1(), _1 = function(zt, tn) {
    var Wt, rn = [], sn = [], dn, _n;
    tn = tn || {}, Wt = tn.firstSequenceNumber || 0, _1.prototype.init.call(this), delete zt.minPTS, this.gopCache_ = [], this.push = function(wn) {
      dm.collectDtsInfo(zt, wn), wn.nalUnitType === "seq_parameter_set_rbsp" && !dn && (dn = wn.config, zt.sps = [wn.data], _g.forEach(function(Dn) {
        zt[Dn] = dn[Dn];
      }, this)), wn.nalUnitType === "pic_parameter_set_rbsp" && !_n && (_n = wn.data, zt.pps = [wn.data]), rn.push(wn);
    }, this.flush = function() {
      for (var wn, Dn, Fn, yi, Wi, Vs, $a = 0, fo, El; rn.length && rn[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        rn.shift();
      if (rn.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (wn = b1.groupNalsIntoFrames(rn), Fn = b1.groupFramesIntoGops(wn), Fn[0][0].keyFrame || (Dn = this.getGopForFusion_(rn[0], zt), Dn ? ($a = Dn.duration, Fn.unshift(Dn), Fn.byteLength += Dn.byteLength, Fn.nalCount += Dn.nalCount, Fn.pts = Dn.pts, Fn.dts = Dn.dts, Fn.duration += Dn.duration) : Fn = b1.extendFirstKeyFrame(Fn)), sn.length) {
        var Qp;
        if (tn.alignGopsAtEnd ? Qp = this.alignGopsAtEnd_(Fn) : Qp = this.alignGopsAtStart_(Fn), !Qp) {
          this.gopCache_.unshift({
            gop: Fn.pop(),
            pps: zt.pps,
            sps: zt.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), rn = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        dm.clearDtsInfo(zt), Fn = Qp;
      }
      dm.collectDtsInfo(zt, Fn), zt.samples = b1.generateSampleTable(Fn), Wi = y1.mdat(b1.concatenateNalData(Fn)), zt.baseMediaDecodeTime = dm.calculateTrackBaseMediaDecodeTime(zt, tn.keepOriginalTimestamps), this.trigger("processedGopsInfo", Fn.map(function(jm) {
        return {
          pts: jm.pts,
          dts: jm.dts,
          byteLength: jm.byteLength
        };
      })), fo = Fn[0], El = Fn[Fn.length - 1], this.trigger("segmentTimingInfo", B1(zt.baseMediaDecodeTime, fo.dts, fo.pts, El.dts + El.duration, El.pts + El.duration, $a)), this.trigger("timingInfo", {
        start: Fn[0].pts,
        end: Fn[Fn.length - 1].pts + Fn[Fn.length - 1].duration
      }), this.gopCache_.unshift({
        gop: Fn.pop(),
        pps: zt.pps,
        sps: zt.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), rn = [], this.trigger("baseMediaDecodeTime", zt.baseMediaDecodeTime), this.trigger("timelineStartInfo", zt.timelineStartInfo), yi = y1.moof(Wt, [zt]), Vs = new Uint8Array(yi.byteLength + Wi.byteLength), Wt++, Vs.set(yi), Vs.set(Wi, yi.byteLength), this.trigger("data", {
        track: zt,
        boxes: Vs
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), rn = [], this.gopCache_.length = 0, sn.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      dm.clearDtsInfo(zt), dn = void 0, _n = void 0;
    }, this.getGopForFusion_ = function(wn) {
      var Dn = 45e3, Fn = 1 / 0, yi, Wi, Vs, $a, fo;
      for (fo = 0; fo < this.gopCache_.length; fo++)
        $a = this.gopCache_[fo], Vs = $a.gop, !(!(zt.pps && PS(zt.pps[0], $a.pps[0])) || !(zt.sps && PS(zt.sps[0], $a.sps[0]))) && (Vs.dts < zt.timelineStartInfo.dts || (yi = wn.dts - Vs.dts - Vs.duration, yi >= -1e4 && yi <= Dn && (!Wi || Fn > yi) && (Wi = $a, Fn = yi)));
      return Wi ? Wi.gop : null;
    }, this.alignGopsAtStart_ = function(wn) {
      var Dn, Fn, yi, Wi, Vs, $a, fo, El;
      for (Vs = wn.byteLength, $a = wn.nalCount, fo = wn.duration, Dn = Fn = 0; Dn < sn.length && Fn < wn.length && (yi = sn[Dn], Wi = wn[Fn], yi.pts !== Wi.pts); ) {
        if (Wi.pts > yi.pts) {
          Dn++;
          continue;
        }
        Fn++, Vs -= Wi.byteLength, $a -= Wi.nalCount, fo -= Wi.duration;
      }
      return Fn === 0 ? wn : Fn === wn.length ? null : (El = wn.slice(Fn), El.byteLength = Vs, El.duration = fo, El.nalCount = $a, El.pts = El[0].pts, El.dts = El[0].dts, El);
    }, this.alignGopsAtEnd_ = function(wn) {
      var Dn, Fn, yi, Wi, Vs, $a;
      for (Dn = sn.length - 1, Fn = wn.length - 1, Vs = null, $a = !1; Dn >= 0 && Fn >= 0; ) {
        if (yi = sn[Dn], Wi = wn[Fn], yi.pts === Wi.pts) {
          $a = !0;
          break;
        }
        if (yi.pts > Wi.pts) {
          Dn--;
          continue;
        }
        Dn === sn.length - 1 && (Vs = Fn), Fn--;
      }
      if (!$a && Vs === null)
        return null;
      var fo;
      if ($a ? fo = Fn : fo = Vs, fo === 0)
        return wn;
      var El = wn.slice(fo), Qp = El.reduce(function(jm, hg) {
        return jm.byteLength += hg.byteLength, jm.duration += hg.duration, jm.nalCount += hg.nalCount, jm;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return El.byteLength = Qp.byteLength, El.duration = Qp.duration, El.nalCount = Qp.nalCount, El.pts = El[0].pts, El.dts = El[0].dts, El;
    }, this.alignGopsWith = function(wn) {
      sn = wn;
    };
  }, _1.prototype = new N1(), Lg = function(zt, tn) {
    this.numberOfTracks = 0, this.metadataStream = tn, zt = zt || {}, typeof zt.remux < "u" ? this.remuxTracks = !!zt.remux : this.remuxTracks = !0, typeof zt.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = zt.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, Lg.prototype.init.call(this), this.push = function(Wt) {
      if (Wt.content || Wt.text)
        return this.pendingCaptions.push(Wt);
      if (Wt.frames)
        return this.pendingMetadata.push(Wt);
      this.pendingTracks.push(Wt.track), this.pendingBytes += Wt.boxes.byteLength, Wt.track.type === "video" && (this.videoTrack = Wt.track, this.pendingBoxes.push(Wt.boxes)), Wt.track.type === "audio" && (this.audioTrack = Wt.track, this.pendingBoxes.unshift(Wt.boxes));
    };
  }, Lg.prototype = new N1(), Lg.prototype.flush = function(zt) {
    var tn = 0, Wt = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, rn, sn, dn, _n = 0, wn;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (zt !== "VideoSegmentStream" && zt !== "AudioSegmentStream" || this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (_n = this.videoTrack.timelineStartInfo.pts, _g.forEach(function(Dn) {
      Wt.info[Dn] = this.videoTrack[Dn];
    }, this)) : this.audioTrack && (_n = this.audioTrack.timelineStartInfo.pts, im.forEach(function(Dn) {
      Wt.info[Dn] = this.audioTrack[Dn];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? Wt.type = this.pendingTracks[0].type : Wt.type = "combined", this.emittedTracks += this.pendingTracks.length, dn = y1.initSegment(this.pendingTracks), Wt.initSegment = new Uint8Array(dn.byteLength), Wt.initSegment.set(dn), Wt.data = new Uint8Array(this.pendingBytes), wn = 0; wn < this.pendingBoxes.length; wn++)
        Wt.data.set(this.pendingBoxes[wn], tn), tn += this.pendingBoxes[wn].byteLength;
      for (wn = 0; wn < this.pendingCaptions.length; wn++)
        rn = this.pendingCaptions[wn], rn.startTime = Nm.metadataTsToSeconds(rn.startPts, _n, this.keepOriginalTimestamps), rn.endTime = Nm.metadataTsToSeconds(rn.endPts, _n, this.keepOriginalTimestamps), Wt.captionStreams[rn.stream] = !0, Wt.captions.push(rn);
      for (wn = 0; wn < this.pendingMetadata.length; wn++)
        sn = this.pendingMetadata[wn], sn.cueTime = Nm.metadataTsToSeconds(sn.pts, _n, this.keepOriginalTimestamps), Wt.metadata.push(sn);
      for (Wt.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", Wt), wn = 0; wn < Wt.captions.length; wn++)
        rn = Wt.captions[wn], this.trigger("caption", rn);
      for (wn = 0; wn < Wt.metadata.length; wn++)
        sn = Wt.metadata[wn], this.trigger("id3Frame", sn);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, Lg.prototype.setRemux = function(zt) {
    this.remuxTracks = zt;
  }, S1 = function(zt) {
    var tn = this, Wt = !0, rn, sn;
    S1.prototype.init.call(this), zt = zt || {}, this.baseMediaDecodeTime = zt.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var dn = {};
      this.transmuxPipeline_ = dn, dn.type = "aac", dn.metadataStream = new bg.MetadataStream(), dn.aacStream = new Cg(), dn.audioTimestampRolloverStream = new bg.TimestampRolloverStream("audio"), dn.timedMetadataTimestampRolloverStream = new bg.TimestampRolloverStream("timed-metadata"), dn.adtsStream = new ZS(), dn.coalesceStream = new Lg(zt, dn.metadataStream), dn.headOfPipeline = dn.aacStream, dn.aacStream.pipe(dn.audioTimestampRolloverStream).pipe(dn.adtsStream), dn.aacStream.pipe(dn.timedMetadataTimestampRolloverStream).pipe(dn.metadataStream).pipe(dn.coalesceStream), dn.metadataStream.on("timestamp", function(_n) {
        dn.aacStream.setTimestamp(_n.timeStamp);
      }), dn.aacStream.on("data", function(_n) {
        _n.type !== "timed-metadata" && _n.type !== "audio" || dn.audioSegmentStream || (sn = sn || {
          timelineStartInfo: {
            baseMediaDecodeTime: tn.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, dn.coalesceStream.numberOfTracks++, dn.audioSegmentStream = new j1(sn, zt), dn.audioSegmentStream.on("log", tn.getLogTrigger_("audioSegmentStream")), dn.audioSegmentStream.on("timingInfo", tn.trigger.bind(tn, "audioTimingInfo")), dn.adtsStream.pipe(dn.audioSegmentStream).pipe(dn.coalesceStream), tn.trigger("trackinfo", {
          hasAudio: !!sn,
          hasVideo: !!rn
        }));
      }), dn.coalesceStream.on("data", this.trigger.bind(this, "data")), dn.coalesceStream.on("done", this.trigger.bind(this, "done")), JS(this, dn);
    }, this.setupTsPipeline = function() {
      var dn = {};
      this.transmuxPipeline_ = dn, dn.type = "ts", dn.metadataStream = new bg.MetadataStream(), dn.packetStream = new bg.TransportPacketStream(), dn.parseStream = new bg.TransportParseStream(), dn.elementaryStream = new bg.ElementaryStream(), dn.timestampRolloverStream = new bg.TimestampRolloverStream(), dn.adtsStream = new ZS(), dn.h264Stream = new QS(), dn.captionStream = new bg.CaptionStream(zt), dn.coalesceStream = new Lg(zt, dn.metadataStream), dn.headOfPipeline = dn.packetStream, dn.packetStream.pipe(dn.parseStream).pipe(dn.elementaryStream).pipe(dn.timestampRolloverStream), dn.timestampRolloverStream.pipe(dn.h264Stream), dn.timestampRolloverStream.pipe(dn.adtsStream), dn.timestampRolloverStream.pipe(dn.metadataStream).pipe(dn.coalesceStream), dn.h264Stream.pipe(dn.captionStream).pipe(dn.coalesceStream), dn.elementaryStream.on("data", function(_n) {
        var wn;
        if (_n.type === "metadata") {
          for (wn = _n.tracks.length; wn--; )
            !rn && _n.tracks[wn].type === "video" ? (rn = _n.tracks[wn], rn.timelineStartInfo.baseMediaDecodeTime = tn.baseMediaDecodeTime) : !sn && _n.tracks[wn].type === "audio" && (sn = _n.tracks[wn], sn.timelineStartInfo.baseMediaDecodeTime = tn.baseMediaDecodeTime);
          rn && !dn.videoSegmentStream && (dn.coalesceStream.numberOfTracks++, dn.videoSegmentStream = new _1(rn, zt), dn.videoSegmentStream.on("log", tn.getLogTrigger_("videoSegmentStream")), dn.videoSegmentStream.on("timelineStartInfo", function(Dn) {
            sn && !zt.keepOriginalTimestamps && (sn.timelineStartInfo = Dn, dn.audioSegmentStream.setEarliestDts(Dn.dts - tn.baseMediaDecodeTime));
          }), dn.videoSegmentStream.on("processedGopsInfo", tn.trigger.bind(tn, "gopInfo")), dn.videoSegmentStream.on("segmentTimingInfo", tn.trigger.bind(tn, "videoSegmentTimingInfo")), dn.videoSegmentStream.on("baseMediaDecodeTime", function(Dn) {
            sn && dn.audioSegmentStream.setVideoBaseMediaDecodeTime(Dn);
          }), dn.videoSegmentStream.on("timingInfo", tn.trigger.bind(tn, "videoTimingInfo")), dn.h264Stream.pipe(dn.videoSegmentStream).pipe(dn.coalesceStream)), sn && !dn.audioSegmentStream && (dn.coalesceStream.numberOfTracks++, dn.audioSegmentStream = new j1(sn, zt), dn.audioSegmentStream.on("log", tn.getLogTrigger_("audioSegmentStream")), dn.audioSegmentStream.on("timingInfo", tn.trigger.bind(tn, "audioTimingInfo")), dn.audioSegmentStream.on("segmentTimingInfo", tn.trigger.bind(tn, "audioSegmentTimingInfo")), dn.adtsStream.pipe(dn.audioSegmentStream).pipe(dn.coalesceStream)), tn.trigger("trackinfo", {
            hasAudio: !!sn,
            hasVideo: !!rn
          });
        }
      }), dn.coalesceStream.on("data", this.trigger.bind(this, "data")), dn.coalesceStream.on("id3Frame", function(_n) {
        _n.dispatchType = dn.metadataStream.dispatchType, tn.trigger("id3Frame", _n);
      }), dn.coalesceStream.on("caption", this.trigger.bind(this, "caption")), dn.coalesceStream.on("done", this.trigger.bind(this, "done")), JS(this, dn);
    }, this.setBaseMediaDecodeTime = function(dn) {
      var _n = this.transmuxPipeline_;
      zt.keepOriginalTimestamps || (this.baseMediaDecodeTime = dn), sn && (sn.timelineStartInfo.dts = void 0, sn.timelineStartInfo.pts = void 0, dm.clearDtsInfo(sn), _n.audioTimestampRolloverStream && _n.audioTimestampRolloverStream.discontinuity()), rn && (_n.videoSegmentStream && (_n.videoSegmentStream.gopCache_ = []), rn.timelineStartInfo.dts = void 0, rn.timelineStartInfo.pts = void 0, dm.clearDtsInfo(rn), _n.captionStream.reset()), _n.timestampRolloverStream && _n.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(dn) {
      sn && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(dn);
    }, this.setRemux = function(dn) {
      var _n = this.transmuxPipeline_;
      zt.remux = dn, _n && _n.coalesceStream && _n.coalesceStream.setRemux(dn);
    }, this.alignGopsWith = function(dn) {
      rn && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(dn);
    }, this.getLogTrigger_ = function(dn) {
      var _n = this;
      return function(wn) {
        wn.stream = dn, _n.trigger("log", wn);
      };
    }, this.push = function(dn) {
      if (Wt) {
        var _n = aS(dn);
        _n && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !_n && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), Wt = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(dn);
    }, this.flush = function() {
      Wt = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, S1.prototype = new N1();
  var x1 = {
    Transmuxer: S1
  }, Yx = function(zt) {
    return zt >>> 0;
  }, ex = function(zt) {
    return ("00" + zt.toString(16)).slice(-2);
  }, U1 = {
    toUnsigned: Yx,
    toHexString: ex
  }, RS = function(zt) {
    var tn = "";
    return tn += String.fromCharCode(zt[0]), tn += String.fromCharCode(zt[1]), tn += String.fromCharCode(zt[2]), tn += String.fromCharCode(zt[3]), tn;
  }, sS = RS, tx = U1.toUnsigned, Kx = sS, oS = function(zt, tn) {
    var Wt = [], rn, sn, dn, _n, wn;
    if (!tn.length)
      return null;
    for (rn = 0; rn < zt.byteLength; )
      sn = tx(zt[rn] << 24 | zt[rn + 1] << 16 | zt[rn + 2] << 8 | zt[rn + 3]), dn = Kx(zt.subarray(rn + 4, rn + 8)), _n = sn > 1 ? rn + sn : zt.byteLength, dn === tn[0] && (tn.length === 1 ? Wt.push(zt.subarray(rn + 8, _n)) : (wn = oS(zt.subarray(rn + 8, _n), tn.slice(1)), wn.length && (Wt = Wt.concat(wn)))), rn = _n;
    return Wt;
  }, V1 = oS, Xx = U1.toUnsigned, rx = je.getUint64, Wm = function(zt) {
    var tn = {
      version: zt[0],
      flags: new Uint8Array(zt.subarray(1, 4))
    };
    return tn.version === 1 ? tn.baseMediaDecodeTime = rx(zt.subarray(4)) : tn.baseMediaDecodeTime = Xx(zt[4] << 24 | zt[5] << 16 | zt[6] << 8 | zt[7]), tn;
  }, H1 = Wm, q1 = function(zt) {
    var tn = new DataView(zt.buffer, zt.byteOffset, zt.byteLength), Wt = {
      version: zt[0],
      flags: new Uint8Array(zt.subarray(1, 4)),
      trackId: tn.getUint32(4)
    }, rn = Wt.flags[2] & 1, sn = Wt.flags[2] & 2, dn = Wt.flags[2] & 8, _n = Wt.flags[2] & 16, wn = Wt.flags[2] & 32, Dn = Wt.flags[0] & 65536, Fn = Wt.flags[0] & 131072, yi;
    return yi = 8, rn && (yi += 4, Wt.baseDataOffset = tn.getUint32(12), yi += 4), sn && (Wt.sampleDescriptionIndex = tn.getUint32(yi), yi += 4), dn && (Wt.defaultSampleDuration = tn.getUint32(yi), yi += 4), _n && (Wt.defaultSampleSize = tn.getUint32(yi), yi += 4), wn && (Wt.defaultSampleFlags = tn.getUint32(yi)), Dn && (Wt.durationIsEmpty = !0), !rn && Fn && (Wt.baseDataOffsetIsMoof = !0), Wt;
  }, kS = q1, nx = function(zt) {
    return {
      isLeading: (zt[0] & 12) >>> 2,
      dependsOn: zt[0] & 3,
      isDependedOn: (zt[1] & 192) >>> 6,
      hasRedundancy: (zt[1] & 48) >>> 4,
      paddingValue: (zt[1] & 14) >>> 1,
      isNonSyncSample: zt[1] & 1,
      degradationPriority: zt[2] << 8 | zt[3]
    };
  }, Zx = nx, ix = Zx, Qx = function(zt) {
    var tn = {
      version: zt[0],
      flags: new Uint8Array(zt.subarray(1, 4)),
      samples: []
    }, Wt = new DataView(zt.buffer, zt.byteOffset, zt.byteLength), rn = tn.flags[2] & 1, sn = tn.flags[2] & 4, dn = tn.flags[1] & 1, _n = tn.flags[1] & 2, wn = tn.flags[1] & 4, Dn = tn.flags[1] & 8, Fn = Wt.getUint32(4), yi = 8, Wi;
    for (rn && (tn.dataOffset = Wt.getInt32(yi), yi += 4), sn && Fn && (Wi = {
      flags: ix(zt.subarray(yi, yi + 4))
    }, yi += 4, dn && (Wi.duration = Wt.getUint32(yi), yi += 4), _n && (Wi.size = Wt.getUint32(yi), yi += 4), Dn && (tn.version === 1 ? Wi.compositionTimeOffset = Wt.getInt32(yi) : Wi.compositionTimeOffset = Wt.getUint32(yi), yi += 4), tn.samples.push(Wi), Fn--); Fn--; )
      Wi = {}, dn && (Wi.duration = Wt.getUint32(yi), yi += 4), _n && (Wi.size = Wt.getUint32(yi), yi += 4), wn && (Wi.flags = ix(zt.subarray(yi, yi + 4)), yi += 4), Dn && (tn.version === 1 ? Wi.compositionTimeOffset = Wt.getInt32(yi) : Wi.compositionTimeOffset = Wt.getUint32(yi), yi += 4), tn.samples.push(Wi);
    return tn;
  }, ax = Qx, sx = {
    tfdt: H1,
    trun: ax
  }, e1 = {
    parseTfdt: sx.tfdt,
    parseTrun: sx.trun
  }, Jx = function(zt) {
    for (var tn = 0, Wt = String.fromCharCode(zt[tn]), rn = ""; Wt !== "\0"; )
      rn += Wt, tn++, Wt = String.fromCharCode(zt[tn]);
    return rn += Wt, rn;
  }, eE = {
    uint8ToCString: Jx
  }, T1 = eE.uint8ToCString, ox = je.getUint64, wg = function(zt) {
    var tn = 4, Wt = zt[0], rn, sn, dn, _n, wn, Dn, Fn, yi;
    if (Wt === 0) {
      rn = T1(zt.subarray(tn)), tn += rn.length, sn = T1(zt.subarray(tn)), tn += sn.length;
      var Wi = new DataView(zt.buffer);
      dn = Wi.getUint32(tn), tn += 4, wn = Wi.getUint32(tn), tn += 4, Dn = Wi.getUint32(tn), tn += 4, Fn = Wi.getUint32(tn), tn += 4;
    } else if (Wt === 1) {
      var Wi = new DataView(zt.buffer);
      dn = Wi.getUint32(tn), tn += 4, _n = ox(zt.subarray(tn)), tn += 8, Dn = Wi.getUint32(tn), tn += 4, Fn = Wi.getUint32(tn), tn += 4, rn = T1(zt.subarray(tn)), tn += rn.length, sn = T1(zt.subarray(tn)), tn += sn.length;
    }
    yi = new Uint8Array(zt.subarray(tn, zt.byteLength));
    var Vs = {
      scheme_id_uri: rn,
      value: sn,
      // if timescale is undefined or 0 set to 1 
      timescale: dn || 1,
      presentation_time: _n,
      presentation_time_delta: wn,
      event_duration: Dn,
      id: Fn,
      message_data: yi
    };
    return tE(Wt, Vs) ? Vs : void 0;
  }, lS = function(zt, tn, Wt, rn) {
    return zt || zt === 0 ? zt / tn : rn + Wt / tn;
  }, tE = function(zt, tn) {
    var Wt = tn.scheme_id_uri !== "\0", rn = zt === 0 && lx(tn.presentation_time_delta) && Wt, sn = zt === 1 && lx(tn.presentation_time) && Wt;
    return !(zt > 1) && rn || sn;
  }, lx = function(zt) {
    return zt !== void 0 || zt !== null;
  }, rE = {
    parseEmsgBox: wg,
    scaleTime: lS
  }, fg;
  typeof window < "u" ? fg = window : typeof ce < "u" ? fg = ce : typeof self < "u" ? fg = self : fg = {};
  var Zm = fg, z1 = U1.toUnsigned, W1 = U1.toHexString, gm = V1, E1 = sS, DS = rE, nE = kS, C1 = ax, Si = H1, Gi = je.getUint64, qi, eo, gl, Ul, ym, Yl, uS, IS = Zm, Qm = ug.parseId3Frames;
  qi = function(zt) {
    var tn = {}, Wt = gm(zt, ["moov", "trak"]);
    return Wt.reduce(function(rn, sn) {
      var dn, _n, wn, Dn, Fn;
      return dn = gm(sn, ["tkhd"])[0], !dn || (_n = dn[0], wn = _n === 0 ? 12 : 20, Dn = z1(dn[wn] << 24 | dn[wn + 1] << 16 | dn[wn + 2] << 8 | dn[wn + 3]), Fn = gm(sn, ["mdia", "mdhd"])[0], !Fn) ? null : (_n = Fn[0], wn = _n === 0 ? 12 : 20, rn[Dn] = z1(Fn[wn] << 24 | Fn[wn + 1] << 16 | Fn[wn + 2] << 8 | Fn[wn + 3]), rn);
    }, tn);
  }, eo = function(zt, tn) {
    var Wt;
    Wt = gm(tn, ["moof", "traf"]);
    var rn = Wt.reduce(function(sn, dn) {
      var _n = gm(dn, ["tfhd"])[0], wn = z1(_n[4] << 24 | _n[5] << 16 | _n[6] << 8 | _n[7]), Dn = zt[wn] || 9e4, Fn = gm(dn, ["tfdt"])[0], yi = new DataView(Fn.buffer, Fn.byteOffset, Fn.byteLength), Wi;
      Fn[0] === 1 ? Wi = Gi(Fn.subarray(4, 12)) : Wi = yi.getUint32(4);
      let Vs;
      return typeof Wi == "bigint" ? Vs = Wi / IS.BigInt(Dn) : typeof Wi == "number" && !isNaN(Wi) && (Vs = Wi / Dn), Vs < Number.MAX_SAFE_INTEGER && (Vs = Number(Vs)), Vs < sn && (sn = Vs), sn;
    }, 1 / 0);
    return typeof rn == "bigint" || isFinite(rn) ? rn : 0;
  }, gl = function(zt, tn) {
    var Wt = gm(tn, ["moof", "traf"]), rn = 0, sn = 0, dn;
    if (Wt && Wt.length) {
      var _n = gm(Wt[0], ["tfhd"])[0], wn = gm(Wt[0], ["trun"])[0], Dn = gm(Wt[0], ["tfdt"])[0];
      if (_n) {
        var Fn = nE(_n);
        dn = Fn.trackId;
      }
      if (Dn) {
        var yi = Si(Dn);
        rn = yi.baseMediaDecodeTime;
      }
      if (wn) {
        var Wi = C1(wn);
        Wi.samples && Wi.samples.length && (sn = Wi.samples[0].compositionTimeOffset || 0);
      }
    }
    var Vs = zt[dn] || 9e4;
    typeof rn == "bigint" && (sn = IS.BigInt(sn), Vs = IS.BigInt(Vs));
    var $a = (rn + sn) / Vs;
    return typeof $a == "bigint" && $a < Number.MAX_SAFE_INTEGER && ($a = Number($a)), $a;
  }, Ul = function(zt) {
    var tn = gm(zt, ["moov", "trak"]), Wt = [];
    return tn.forEach(function(rn) {
      var sn = gm(rn, ["mdia", "hdlr"]), dn = gm(rn, ["tkhd"]);
      sn.forEach(function(_n, wn) {
        var Dn = E1(_n.subarray(8, 12)), Fn = dn[wn], yi, Wi, Vs;
        Dn === "vide" && (yi = new DataView(Fn.buffer, Fn.byteOffset, Fn.byteLength), Wi = yi.getUint8(0), Vs = Wi === 0 ? yi.getUint32(12) : yi.getUint32(20), Wt.push(Vs));
      });
    }), Wt;
  }, Yl = function(zt) {
    var tn = zt[0], Wt = tn === 0 ? 12 : 20;
    return z1(zt[Wt] << 24 | zt[Wt + 1] << 16 | zt[Wt + 2] << 8 | zt[Wt + 3]);
  }, ym = function(zt) {
    var tn = gm(zt, ["moov", "trak"]), Wt = [];
    return tn.forEach(function(rn) {
      var sn = {}, dn = gm(rn, ["tkhd"])[0], _n, wn;
      dn && (_n = new DataView(dn.buffer, dn.byteOffset, dn.byteLength), wn = _n.getUint8(0), sn.id = wn === 0 ? _n.getUint32(12) : _n.getUint32(20));
      var Dn = gm(rn, ["mdia", "hdlr"])[0];
      if (Dn) {
        var Fn = E1(Dn.subarray(8, 12));
        Fn === "vide" ? sn.type = "video" : Fn === "soun" ? sn.type = "audio" : sn.type = Fn;
      }
      var yi = gm(rn, ["mdia", "minf", "stbl", "stsd"])[0];
      if (yi) {
        var Wi = yi.subarray(8);
        sn.codec = E1(Wi.subarray(4, 8));
        var Vs = gm(Wi, [sn.codec])[0], $a, fo;
        Vs && (/^[asm]vc[1-9]$/i.test(sn.codec) ? ($a = Vs.subarray(78), fo = E1($a.subarray(4, 8)), fo === "avcC" && $a.length > 11 ? (sn.codec += ".", sn.codec += W1($a[9]), sn.codec += W1($a[10]), sn.codec += W1($a[11])) : sn.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(sn.codec) ? ($a = Vs.subarray(28), fo = E1($a.subarray(4, 8)), fo === "esds" && $a.length > 20 && $a[19] !== 0 ? (sn.codec += "." + W1($a[19]), sn.codec += "." + W1($a[20] >>> 2 & 63).replace(/^0/, "")) : sn.codec = "mp4a.40.2") : sn.codec = sn.codec.toLowerCase());
      }
      var El = gm(rn, ["mdia", "mdhd"])[0];
      El && (sn.timescale = Yl(El)), Wt.push(sn);
    }), Wt;
  }, uS = function(zt, tn = 0) {
    var Wt = gm(zt, ["emsg"]);
    return Wt.map((rn) => {
      var sn = DS.parseEmsgBox(new Uint8Array(rn)), dn = Qm(sn.message_data);
      return {
        cueTime: DS.scaleTime(sn.presentation_time, sn.timescale, sn.presentation_time_delta, tn),
        duration: DS.scaleTime(sn.event_duration, sn.timescale),
        frames: dn
      };
    });
  };
  var Ag = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: gm,
    parseType: E1,
    timescale: qi,
    startTime: eo,
    compositionStartTime: gl,
    videoTrackIds: Ul,
    tracks: ym,
    getTimescaleFromMediaHeader: Yl,
    getEmsgID3: uS
  };
  const {
    parseTrun: iE
  } = e1, {
    findBox: r1
  } = Ag;
  var G1 = Zm, cS = function(zt) {
    var tn = r1(zt, ["moof", "traf"]), Wt = r1(zt, ["mdat"]), rn = [];
    return Wt.forEach(function(sn, dn) {
      var _n = tn[dn];
      rn.push({
        mdat: sn,
        traf: _n
      });
    }), rn;
  }, Kl = function(zt, tn, Wt) {
    var rn = tn, sn = Wt.defaultSampleDuration || 0, dn = Wt.defaultSampleSize || 0, _n = Wt.trackId, wn = [];
    return zt.forEach(function(Dn) {
      var Fn = iE(Dn), yi = Fn.samples;
      yi.forEach(function(Wi) {
        Wi.duration === void 0 && (Wi.duration = sn), Wi.size === void 0 && (Wi.size = dn), Wi.trackId = _n, Wi.dts = rn, Wi.compositionTimeOffset === void 0 && (Wi.compositionTimeOffset = 0), typeof rn == "bigint" ? (Wi.pts = rn + G1.BigInt(Wi.compositionTimeOffset), rn += G1.BigInt(Wi.duration)) : (Wi.pts = rn + Wi.compositionTimeOffset, rn += Wi.duration);
      }), wn = wn.concat(yi);
    }), wn;
  }, ux = {
    getMdatTrafPairs: cS,
    parseSamples: Kl
  }, cx = Ws.discardEmulationPreventionBytes, dS = Wa.CaptionStream, OS = V1, aE = H1, sE = kS, {
    getMdatTrafPairs: fS,
    parseSamples: Pg
  } = ux, hS = function(zt, tn) {
    for (var Wt = zt, rn = 0; rn < tn.length; rn++) {
      var sn = tn[rn];
      if (Wt < sn.size)
        return sn;
      Wt -= sn.size;
    }
    return null;
  }, dx = function(zt, tn, Wt) {
    var rn = new DataView(zt.buffer, zt.byteOffset, zt.byteLength), sn = {
      logs: [],
      seiNals: []
    }, dn, _n, wn, Dn;
    for (_n = 0; _n + 4 < zt.length; _n += wn)
      if (wn = rn.getUint32(_n), _n += 4, !(wn <= 0))
        switch (zt[_n] & 31) {
          case 6:
            var Fn = zt.subarray(_n + 1, _n + 1 + wn), yi = hS(_n, tn);
            if (dn = {
              nalUnitType: "sei_rbsp",
              size: wn,
              data: Fn,
              escapedRBSP: cx(Fn),
              trackId: Wt
            }, yi)
              dn.pts = yi.pts, dn.dts = yi.dts, Dn = yi;
            else if (Dn)
              dn.pts = Dn.pts, dn.dts = Dn.dts;
            else {
              sn.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + _n + " for trackId " + Wt + ". See mux.js#223."
              });
              break;
            }
            sn.seiNals.push(dn);
            break;
        }
    return sn;
  }, pS = function(zt, tn) {
    var Wt = {}, rn = fS(zt);
    return rn.forEach(function(sn) {
      var dn = sn.mdat, _n = sn.traf, wn = OS(_n, ["tfhd"]), Dn = sE(wn[0]), Fn = Dn.trackId, yi = OS(_n, ["tfdt"]), Wi = yi.length > 0 ? aE(yi[0]).baseMediaDecodeTime : 0, Vs = OS(_n, ["trun"]), $a, fo;
      tn === Fn && Vs.length > 0 && ($a = Pg(Vs, Wi, Dn), fo = dx(dn, $a, Fn), Wt[Fn] || (Wt[Fn] = {
        seiNals: [],
        logs: []
      }), Wt[Fn].seiNals = Wt[Fn].seiNals.concat(fo.seiNals), Wt[Fn].logs = Wt[Fn].logs.concat(fo.logs));
    }), Wt;
  }, fx = function(zt, tn, Wt) {
    var rn;
    if (tn === null)
      return null;
    rn = pS(zt, tn);
    var sn = rn[tn] || {};
    return {
      seiNals: sn.seiNals,
      logs: sn.logs,
      timescale: Wt
    };
  }, hx = function() {
    var zt = !1, tn, Wt, rn, sn, dn, _n;
    this.isInitialized = function() {
      return zt;
    }, this.init = function(wn) {
      tn = new dS(), zt = !0, _n = wn ? wn.isPartial : !1, tn.on("data", function(Dn) {
        Dn.startTime = Dn.startPts / sn, Dn.endTime = Dn.endPts / sn, dn.captions.push(Dn), dn.captionStreams[Dn.stream] = !0;
      }), tn.on("log", function(Dn) {
        dn.logs.push(Dn);
      });
    }, this.isNewInit = function(wn, Dn) {
      return wn && wn.length === 0 || Dn && typeof Dn == "object" && Object.keys(Dn).length === 0 ? !1 : rn !== wn[0] || sn !== Dn[rn];
    }, this.parse = function(wn, Dn, Fn) {
      var yi;
      if (this.isInitialized()) {
        if (!Dn || !Fn)
          return null;
        if (this.isNewInit(Dn, Fn))
          rn = Dn[0], sn = Fn[rn];
        else if (rn === null || !sn)
          return Wt.push(wn), null;
      } else return null;
      for (; Wt.length > 0; ) {
        var Wi = Wt.shift();
        this.parse(Wi, Dn, Fn);
      }
      return yi = fx(wn, rn, sn), yi && yi.logs && (dn.logs = dn.logs.concat(yi.logs)), yi === null || !yi.seiNals ? dn.logs.length ? {
        logs: dn.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(yi.seiNals), this.flushStream(), dn);
    }, this.pushNals = function(wn) {
      if (!this.isInitialized() || !wn || wn.length === 0)
        return null;
      wn.forEach(function(Dn) {
        tn.push(Dn);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      _n ? tn.partialFlush() : tn.flush();
    }, this.clearParsedCaptions = function() {
      dn.captions = [], dn.captionStreams = {}, dn.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      tn.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      Wt = [], rn = null, sn = null, dn ? this.clearParsedCaptions() : dn = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, mS = hx;
  const {
    parseTfdt: px
  } = e1, Jm = V1, {
    getTimescaleFromMediaHeader: n1
  } = Ag, {
    parseSamples: gS,
    getMdatTrafPairs: oE
  } = ux;
  var mx = function() {
    let zt = 9e4;
    this.init = function(tn) {
      const Wt = Jm(tn, ["moov", "trak", "mdia", "mdhd"])[0];
      Wt && (zt = n1(Wt));
    }, this.parseSegment = function(tn) {
      const Wt = [], rn = oE(tn);
      let sn = 0;
      return rn.forEach(function(dn) {
        const _n = dn.mdat, wn = dn.traf, Dn = Jm(wn, ["tfdt"])[0], Fn = Jm(wn, ["tfhd"])[0], yi = Jm(wn, ["trun"]);
        if (Dn && (sn = px(Dn).baseMediaDecodeTime), yi.length && Fn) {
          const Wi = gS(yi, sn, Fn);
          let Vs = 0;
          Wi.forEach(function($a) {
            const fo = "utf-8", El = new TextDecoder(fo), Qp = _n.slice(Vs, Vs + $a.size);
            if (Jm(Qp, ["vtte"])[0]) {
              Vs += $a.size;
              return;
            }
            Jm(Qp, ["vttc"]).forEach(function(jm) {
              const hg = Jm(jm, ["payl"])[0], Z1 = Jm(jm, ["sttg"])[0], yS = $a.pts / zt, bS = ($a.pts + $a.duration) / zt;
              let Bm, Q1;
              if (hg)
                try {
                  Bm = El.decode(hg);
                } catch (am) {
                  console.error(am);
                }
              if (Z1)
                try {
                  Q1 = El.decode(Z1);
                } catch (am) {
                  console.error(am);
                }
              $a.duration && Bm && Wt.push({
                cueText: Bm,
                start: yS,
                end: bS,
                settings: Q1
              });
            }), Vs += $a.size;
          });
        }
      }), Wt;
    };
  }, MS = js, Y1 = function(zt) {
    var tn = zt[1] & 31;
    return tn <<= 8, tn |= zt[2], tn;
  }, i1 = function(zt) {
    return !!(zt[1] & 64);
  }, w1 = function(zt) {
    var tn = 0;
    return (zt[3] & 48) >>> 4 > 1 && (tn += zt[4] + 1), tn;
  }, lE = function(zt, tn) {
    var Wt = Y1(zt);
    return Wt === 0 ? "pat" : Wt === tn ? "pmt" : tn ? "pes" : null;
  }, gx = function(zt) {
    var tn = i1(zt), Wt = 4 + w1(zt);
    return tn && (Wt += zt[Wt] + 1), (zt[Wt + 10] & 31) << 8 | zt[Wt + 11];
  }, uE = function(zt) {
    var tn = {}, Wt = i1(zt), rn = 4 + w1(zt);
    if (Wt && (rn += zt[rn] + 1), !!(zt[rn + 5] & 1)) {
      var sn, dn, _n;
      sn = (zt[rn + 1] & 15) << 8 | zt[rn + 2], dn = 3 + sn - 4, _n = (zt[rn + 10] & 15) << 8 | zt[rn + 11];
      for (var wn = 12 + _n; wn < dn; ) {
        var Dn = rn + wn;
        tn[(zt[Dn + 1] & 31) << 8 | zt[Dn + 2]] = zt[Dn], wn += ((zt[Dn + 3] & 15) << 8 | zt[Dn + 4]) + 5;
      }
      return tn;
    }
  }, cE = function(zt, tn) {
    var Wt = Y1(zt), rn = tn[Wt];
    switch (rn) {
      case MS.H264_STREAM_TYPE:
        return "video";
      case MS.ADTS_STREAM_TYPE:
        return "audio";
      case MS.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, Tm = function(zt) {
    var tn = i1(zt);
    if (!tn)
      return null;
    var Wt = 4 + w1(zt);
    if (Wt >= zt.byteLength)
      return null;
    var rn = null, sn;
    return sn = zt[Wt + 7], sn & 192 && (rn = {}, rn.pts = (zt[Wt + 9] & 14) << 27 | (zt[Wt + 10] & 255) << 20 | (zt[Wt + 11] & 254) << 12 | (zt[Wt + 12] & 255) << 5 | (zt[Wt + 13] & 254) >>> 3, rn.pts *= 4, rn.pts += (zt[Wt + 13] & 6) >>> 1, rn.dts = rn.pts, sn & 64 && (rn.dts = (zt[Wt + 14] & 14) << 27 | (zt[Wt + 15] & 255) << 20 | (zt[Wt + 16] & 254) << 12 | (zt[Wt + 17] & 255) << 5 | (zt[Wt + 18] & 254) >>> 3, rn.dts *= 4, rn.dts += (zt[Wt + 18] & 6) >>> 1)), rn;
  }, Pm = function(zt) {
    switch (zt) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, dE = function(zt) {
    for (var tn = 4 + w1(zt), Wt = zt.subarray(tn), rn = 0, sn = 0, dn = !1, _n; sn < Wt.byteLength - 3; sn++)
      if (Wt[sn + 2] === 1) {
        rn = sn + 5;
        break;
      }
    for (; rn < Wt.byteLength; )
      switch (Wt[rn]) {
        case 0:
          if (Wt[rn - 1] !== 0) {
            rn += 2;
            break;
          } else if (Wt[rn - 2] !== 0) {
            rn++;
            break;
          }
          sn + 3 !== rn - 2 && (_n = Pm(Wt[sn + 3] & 31), _n === "slice_layer_without_partitioning_rbsp_idr" && (dn = !0));
          do
            rn++;
          while (Wt[rn] !== 1 && rn < Wt.length);
          sn = rn - 2, rn += 3;
          break;
        case 1:
          if (Wt[rn - 1] !== 0 || Wt[rn - 2] !== 0) {
            rn += 3;
            break;
          }
          _n = Pm(Wt[sn + 3] & 31), _n === "slice_layer_without_partitioning_rbsp_idr" && (dn = !0), sn = rn - 2, rn += 3;
          break;
        default:
          rn += 3;
          break;
      }
    return Wt = Wt.subarray(sn), rn -= sn, sn = 0, Wt && Wt.byteLength > 3 && (_n = Pm(Wt[sn + 3] & 31), _n === "slice_layer_without_partitioning_rbsp_idr" && (dn = !0)), dn;
  }, fE = {
    parseType: lE,
    parsePat: gx,
    parsePmt: uE,
    parsePayloadUnitStartIndicator: i1,
    parsePesType: cE,
    parsePesTime: Tm,
    videoPacketContainsKeyFrame: dE
  }, LS = js, A1 = Jp.handleRollover, Hl = {};
  Hl.ts = fE, Hl.aac = wS;
  var ig = lo.ONE_SECOND_IN_TS, Im = 188, Fm = 71, K1 = function(zt, tn) {
    for (var Wt = 0, rn = Im, sn, dn; rn < zt.byteLength; ) {
      if (zt[Wt] === Fm && zt[rn] === Fm) {
        switch (sn = zt.subarray(Wt, rn), dn = Hl.ts.parseType(sn, tn.pid), dn) {
          case "pat":
            tn.pid = Hl.ts.parsePat(sn);
            break;
          case "pmt":
            var _n = Hl.ts.parsePmt(sn);
            tn.table = tn.table || {}, Object.keys(_n).forEach(function(wn) {
              tn.table[wn] = _n[wn];
            });
            break;
        }
        Wt += Im, rn += Im;
        continue;
      }
      Wt++, rn++;
    }
  }, $1 = function(zt, tn, Wt) {
    for (var rn = 0, sn = Im, dn, _n, wn, Dn, Fn, yi = !1; sn <= zt.byteLength; ) {
      if (zt[rn] === Fm && (zt[sn] === Fm || sn === zt.byteLength)) {
        switch (dn = zt.subarray(rn, sn), _n = Hl.ts.parseType(dn, tn.pid), _n) {
          case "pes":
            wn = Hl.ts.parsePesType(dn, tn.table), Dn = Hl.ts.parsePayloadUnitStartIndicator(dn), wn === "audio" && Dn && (Fn = Hl.ts.parsePesTime(dn), Fn && (Fn.type = "audio", Wt.audio.push(Fn), yi = !0));
            break;
        }
        if (yi)
          break;
        rn += Im, sn += Im;
        continue;
      }
      rn++, sn++;
    }
    for (sn = zt.byteLength, rn = sn - Im, yi = !1; rn >= 0; ) {
      if (zt[rn] === Fm && (zt[sn] === Fm || sn === zt.byteLength)) {
        switch (dn = zt.subarray(rn, sn), _n = Hl.ts.parseType(dn, tn.pid), _n) {
          case "pes":
            wn = Hl.ts.parsePesType(dn, tn.table), Dn = Hl.ts.parsePayloadUnitStartIndicator(dn), wn === "audio" && Dn && (Fn = Hl.ts.parsePesTime(dn), Fn && (Fn.type = "audio", Wt.audio.push(Fn), yi = !0));
            break;
        }
        if (yi)
          break;
        rn -= Im, sn -= Im;
        continue;
      }
      rn--, sn--;
    }
  }, vS = function(zt, tn, Wt) {
    for (var rn = 0, sn = Im, dn, _n, wn, Dn, Fn, yi, Wi, Vs, $a = !1, fo = {
      data: [],
      size: 0
    }; sn < zt.byteLength; ) {
      if (zt[rn] === Fm && zt[sn] === Fm) {
        switch (dn = zt.subarray(rn, sn), _n = Hl.ts.parseType(dn, tn.pid), _n) {
          case "pes":
            if (wn = Hl.ts.parsePesType(dn, tn.table), Dn = Hl.ts.parsePayloadUnitStartIndicator(dn), wn === "video" && (Dn && !$a && (Fn = Hl.ts.parsePesTime(dn), Fn && (Fn.type = "video", Wt.video.push(Fn), $a = !0)), !Wt.firstKeyFrame)) {
              if (Dn && fo.size !== 0) {
                for (yi = new Uint8Array(fo.size), Wi = 0; fo.data.length; )
                  Vs = fo.data.shift(), yi.set(Vs, Wi), Wi += Vs.byteLength;
                if (Hl.ts.videoPacketContainsKeyFrame(yi)) {
                  var El = Hl.ts.parsePesTime(yi);
                  El ? (Wt.firstKeyFrame = El, Wt.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                fo.size = 0;
              }
              fo.data.push(dn), fo.size += dn.byteLength;
            }
            break;
        }
        if ($a && Wt.firstKeyFrame)
          break;
        rn += Im, sn += Im;
        continue;
      }
      rn++, sn++;
    }
    for (sn = zt.byteLength, rn = sn - Im, $a = !1; rn >= 0; ) {
      if (zt[rn] === Fm && zt[sn] === Fm) {
        switch (dn = zt.subarray(rn, sn), _n = Hl.ts.parseType(dn, tn.pid), _n) {
          case "pes":
            wn = Hl.ts.parsePesType(dn, tn.table), Dn = Hl.ts.parsePayloadUnitStartIndicator(dn), wn === "video" && Dn && (Fn = Hl.ts.parsePesTime(dn), Fn && (Fn.type = "video", Wt.video.push(Fn), $a = !0));
            break;
        }
        if ($a)
          break;
        rn -= Im, sn -= Im;
        continue;
      }
      rn--, sn--;
    }
  }, P1 = function(zt, tn) {
    if (zt.audio && zt.audio.length) {
      var Wt = tn;
      (typeof Wt > "u" || isNaN(Wt)) && (Wt = zt.audio[0].dts), zt.audio.forEach(function(dn) {
        dn.dts = A1(dn.dts, Wt), dn.pts = A1(dn.pts, Wt), dn.dtsTime = dn.dts / ig, dn.ptsTime = dn.pts / ig;
      });
    }
    if (zt.video && zt.video.length) {
      var rn = tn;
      if ((typeof rn > "u" || isNaN(rn)) && (rn = zt.video[0].dts), zt.video.forEach(function(dn) {
        dn.dts = A1(dn.dts, rn), dn.pts = A1(dn.pts, rn), dn.dtsTime = dn.dts / ig, dn.ptsTime = dn.pts / ig;
      }), zt.firstKeyFrame) {
        var sn = zt.firstKeyFrame;
        sn.dts = A1(sn.dts, rn), sn.pts = A1(sn.pts, rn), sn.dtsTime = sn.dts / ig, sn.ptsTime = sn.pts / ig;
      }
    }
  }, hE = function(zt) {
    for (var tn = !1, Wt = 0, rn = null, sn = null, dn = 0, _n = 0, wn; zt.length - _n >= 3; ) {
      var Dn = Hl.aac.parseType(zt, _n);
      switch (Dn) {
        case "timed-metadata":
          if (zt.length - _n < 10) {
            tn = !0;
            break;
          }
          if (dn = Hl.aac.parseId3TagSize(zt, _n), dn > zt.length) {
            tn = !0;
            break;
          }
          sn === null && (wn = zt.subarray(_n, _n + dn), sn = Hl.aac.parseAacTimestamp(wn)), _n += dn;
          break;
        case "audio":
          if (zt.length - _n < 7) {
            tn = !0;
            break;
          }
          if (dn = Hl.aac.parseAdtsSize(zt, _n), dn > zt.length) {
            tn = !0;
            break;
          }
          rn === null && (wn = zt.subarray(_n, _n + dn), rn = Hl.aac.parseSampleRate(wn)), Wt++, _n += dn;
          break;
        default:
          _n++;
          break;
      }
      if (tn)
        return null;
    }
    if (rn === null || sn === null)
      return null;
    var Fn = ig / rn, yi = {
      audio: [{
        type: "audio",
        dts: sn,
        pts: sn
      }, {
        type: "audio",
        dts: sn + Wt * 1024 * Fn,
        pts: sn + Wt * 1024 * Fn
      }]
    };
    return yi;
  }, pE = function(zt) {
    var tn = {
      pid: null,
      table: null
    }, Wt = {};
    K1(zt, tn);
    for (var rn in tn.table)
      if (tn.table.hasOwnProperty(rn)) {
        var sn = tn.table[rn];
        switch (sn) {
          case LS.H264_STREAM_TYPE:
            Wt.video = [], vS(zt, tn, Wt), Wt.video.length === 0 && delete Wt.video;
            break;
          case LS.ADTS_STREAM_TYPE:
            Wt.audio = [], $1(zt, tn, Wt), Wt.audio.length === 0 && delete Wt.audio;
            break;
        }
      }
    return Wt;
  }, mE = function(zt, tn) {
    var Wt = Hl.aac.isLikelyAacData(zt), rn;
    return Wt ? rn = hE(zt) : rn = pE(zt), !rn || !rn.audio && !rn.video ? null : (P1(rn, tn), rn);
  }, gE = {
    inspect: mE,
    parseAudioPes_: $1
  };
  const vE = function(zt, tn) {
    tn.on("data", function(Wt) {
      const rn = Wt.initSegment;
      Wt.initSegment = {
        data: rn.buffer,
        byteOffset: rn.byteOffset,
        byteLength: rn.byteLength
      };
      const sn = Wt.data;
      Wt.data = sn.buffer, zt.postMessage({
        action: "data",
        segment: Wt,
        byteOffset: sn.byteOffset,
        byteLength: sn.byteLength
      }, [Wt.data]);
    }), tn.on("done", function(Wt) {
      zt.postMessage({
        action: "done"
      });
    }), tn.on("gopInfo", function(Wt) {
      zt.postMessage({
        action: "gopInfo",
        gopInfo: Wt
      });
    }), tn.on("videoSegmentTimingInfo", function(Wt) {
      const rn = {
        start: {
          decode: lo.videoTsToSeconds(Wt.start.dts),
          presentation: lo.videoTsToSeconds(Wt.start.pts)
        },
        end: {
          decode: lo.videoTsToSeconds(Wt.end.dts),
          presentation: lo.videoTsToSeconds(Wt.end.pts)
        },
        baseMediaDecodeTime: lo.videoTsToSeconds(Wt.baseMediaDecodeTime)
      };
      Wt.prependedContentDuration && (rn.prependedContentDuration = lo.videoTsToSeconds(Wt.prependedContentDuration)), zt.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: rn
      });
    }), tn.on("audioSegmentTimingInfo", function(Wt) {
      const rn = {
        start: {
          decode: lo.videoTsToSeconds(Wt.start.dts),
          presentation: lo.videoTsToSeconds(Wt.start.pts)
        },
        end: {
          decode: lo.videoTsToSeconds(Wt.end.dts),
          presentation: lo.videoTsToSeconds(Wt.end.pts)
        },
        baseMediaDecodeTime: lo.videoTsToSeconds(Wt.baseMediaDecodeTime)
      };
      Wt.prependedContentDuration && (rn.prependedContentDuration = lo.videoTsToSeconds(Wt.prependedContentDuration)), zt.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: rn
      });
    }), tn.on("id3Frame", function(Wt) {
      zt.postMessage({
        action: "id3Frame",
        id3Frame: Wt
      });
    }), tn.on("caption", function(Wt) {
      zt.postMessage({
        action: "caption",
        caption: Wt
      });
    }), tn.on("trackinfo", function(Wt) {
      zt.postMessage({
        action: "trackinfo",
        trackInfo: Wt
      });
    }), tn.on("audioTimingInfo", function(Wt) {
      zt.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: lo.videoTsToSeconds(Wt.start),
          end: lo.videoTsToSeconds(Wt.end)
        }
      });
    }), tn.on("videoTimingInfo", function(Wt) {
      zt.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: lo.videoTsToSeconds(Wt.start),
          end: lo.videoTsToSeconds(Wt.end)
        }
      });
    }), tn.on("log", function(Wt) {
      zt.postMessage({
        action: "log",
        log: Wt
      });
    });
  };
  class X1 {
    constructor(tn, Wt) {
      this.options = Wt || {}, this.self = tn, this.init();
    }
    /**
     * initialize our web worker and wire all the events.
     */
    init() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new x1.Transmuxer(this.options), vE(this.self, this.transmuxer);
    }
    pushMp4Captions(tn) {
      this.captionParser || (this.captionParser = new mS(), this.captionParser.init());
      const Wt = new Uint8Array(tn.data, tn.byteOffset, tn.byteLength), rn = this.captionParser.parse(Wt, tn.trackIds, tn.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: rn && rn.captions || [],
        logs: rn && rn.logs || [],
        data: Wt.buffer
      }, [Wt.buffer]);
    }
    /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */
    initMp4WebVttParser(tn) {
      this.webVttParser || (this.webVttParser = new mx());
      const Wt = new Uint8Array(tn.data, tn.byteOffset, tn.byteLength);
      this.webVttParser.init(Wt);
    }
    /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */
    getMp4WebVttText(tn) {
      this.webVttParser || (this.webVttParser = new mx());
      const Wt = new Uint8Array(tn.data, tn.byteOffset, tn.byteLength), rn = this.webVttParser.parseSegment(Wt);
      this.self.postMessage({
        action: "getMp4WebVttText",
        mp4VttCues: rn || [],
        data: Wt.buffer
      }, [Wt.buffer]);
    }
    probeMp4StartTime({
      timescales: tn,
      data: Wt
    }) {
      const rn = Ag.startTime(tn, Wt);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: rn,
        data: Wt
      }, [Wt.buffer]);
    }
    probeMp4Tracks({
      data: tn
    }) {
      const Wt = Ag.tracks(tn);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: Wt,
        data: tn
      }, [tn.buffer]);
    }
    /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */
    probeEmsgID3({
      data: tn,
      offset: Wt
    }) {
      const rn = Ag.getEmsgID3(tn, Wt);
      this.self.postMessage({
        action: "probeEmsgID3",
        id3Frames: rn,
        emsgData: tn
      }, [tn.buffer]);
    }
    /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */
    probeTs({
      data: tn,
      baseStartTime: Wt
    }) {
      const rn = typeof Wt == "number" && !isNaN(Wt) ? Wt * lo.ONE_SECOND_IN_TS : void 0, sn = gE.inspect(tn, rn);
      let dn = null;
      sn && (dn = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: sn.video && sn.video.length === 2 || !1,
        hasAudio: sn.audio && sn.audio.length === 2 || !1
      }, dn.hasVideo && (dn.videoStart = sn.video[0].ptsTime), dn.hasAudio && (dn.audioStart = sn.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: dn,
        data: tn
      }, [tn.buffer]);
    }
    clearAllMp4Captions() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }
    clearParsedMp4Captions() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }
    /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */
    push(tn) {
      const Wt = new Uint8Array(tn.data, tn.byteOffset, tn.byteLength);
      this.transmuxer.push(Wt);
    }
    /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */
    reset() {
      this.transmuxer.reset();
    }
    /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */
    setTimestampOffset(tn) {
      const Wt = tn.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(lo.secondsToVideoTs(Wt)));
    }
    setAudioAppendStart(tn) {
      this.transmuxer.setAudioAppendStart(Math.ceil(lo.secondsToVideoTs(tn.appendStart)));
    }
    setRemux(tn) {
      this.transmuxer.setRemux(tn.remux);
    }
    /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */
    flush(tn) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }
    endTimeline() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }
    alignGopsWith(tn) {
      this.transmuxer.alignGopsWith(tn.gopsToAlignWith.slice());
    }
  }
  self.onmessage = function(zt) {
    if (zt.data.action === "init" && zt.data.options) {
      this.messageHandlers = new X1(self, zt.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new X1(self)), zt.data && zt.data.action && zt.data.action !== "init" && this.messageHandlers[zt.data.action] && this.messageHandlers[zt.data.action](zt.data);
  };
}));
var hb = bp(db);
const fb = (ce, ie, me) => {
  const {
    type: we,
    initSegment: Re,
    captions: je,
    captionStreams: Ue,
    metadata: qe,
    videoFrameDtsTime: Ge,
    videoFramePtsTime: Xe
  } = ce.data.segment;
  ie.buffer.push({
    captions: je,
    captionStreams: Ue,
    metadata: qe
  });
  const ot = ce.data.segment.boxes || {
    data: ce.data.segment.data
  }, vt = {
    type: we,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(ot.data, ot.data.byteOffset, ot.data.byteLength),
    initSegment: new Uint8Array(Re.data, Re.byteOffset, Re.byteLength)
  };
  typeof Ge < "u" && (vt.videoFrameDtsTime = Ge), typeof Xe < "u" && (vt.videoFramePtsTime = Xe), me(vt);
}, pb = ({
  transmuxedData: ce,
  callback: ie
}) => {
  ce.buffer = [], ie(ce);
}, mb = (ce, ie) => {
  ie.gopInfo = ce.data.gopInfo;
}, Ep = (ce) => {
  const {
    transmuxer: ie,
    bytes: me,
    audioAppendStart: we,
    gopsToAlignWith: Re,
    remux: je,
    onData: Ue,
    onTrackInfo: qe,
    onAudioTimingInfo: Ge,
    onVideoTimingInfo: Xe,
    onVideoSegmentTimingInfo: ot,
    onAudioSegmentTimingInfo: vt,
    onId3: bt,
    onCaptions: Tt,
    onDone: wt,
    onEndedTimeline: St,
    onTransmuxerLog: It,
    isEndOfTimeline: Pt,
    segment: kt,
    triggerSegmentEventFn: Ot
  } = ce, Jr = {
    buffer: []
  };
  let en = Pt;
  const nn = (fn) => {
    ie.currentTransmux === ce && (fn.data.action === "data" && fb(fn, Jr, Ue), fn.data.action === "trackinfo" && qe(fn.data.trackInfo), fn.data.action === "gopInfo" && mb(fn, Jr), fn.data.action === "audioTimingInfo" && Ge(fn.data.audioTimingInfo), fn.data.action === "videoTimingInfo" && Xe(fn.data.videoTimingInfo), fn.data.action === "videoSegmentTimingInfo" && ot(fn.data.videoSegmentTimingInfo), fn.data.action === "audioSegmentTimingInfo" && vt(fn.data.audioSegmentTimingInfo), fn.data.action === "id3Frame" && bt([fn.data.id3Frame], fn.data.id3Frame.dispatchType), fn.data.action === "caption" && Tt(fn.data.caption), fn.data.action === "endedtimeline" && (en = !1, St()), fn.data.action === "log" && It(fn.data.log), fn.data.type === "transmuxed" && (en || (ie.onmessage = null, pb({
      transmuxedData: Jr,
      callback: wt
    }), Cp(ie))));
  }, ln = () => {
    const fn = {
      message: "Received an error message from the transmuxer worker",
      metadata: {
        errorType: L.Error.StreamingFailedToTransmuxSegment,
        segmentInfo: Ai({
          segment: kt
        })
      }
    };
    wt(null, fn);
  };
  if (ie.onmessage = nn, ie.onerror = ln, we && ie.postMessage({
    action: "setAudioAppendStart",
    appendStart: we
  }), Array.isArray(Re) && ie.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: Re
  }), typeof je < "u" && ie.postMessage({
    action: "setRemux",
    remux: je
  }), me.byteLength) {
    const fn = me instanceof ArrayBuffer ? me : me.buffer, vn = me instanceof ArrayBuffer ? 0 : me.byteOffset;
    Ot({
      type: "segmenttransmuxingstart",
      segment: kt
    }), ie.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: fn,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: vn,
      byteLength: me.byteLength
    }, [fn]);
  }
  Pt && ie.postMessage({
    action: "endTimeline"
  }), ie.postMessage({
    action: "flush"
  });
}, Cp = (ce) => {
  ce.currentTransmux = null, ce.transmuxQueue.length && (ce.currentTransmux = ce.transmuxQueue.shift(), typeof ce.currentTransmux == "function" ? ce.currentTransmux() : Ep(ce.currentTransmux));
}, fd = (ce, ie) => {
  ce.postMessage({
    action: ie
  }), Cp(ce);
}, Ap = (ce, ie) => {
  if (!ie.currentTransmux) {
    ie.currentTransmux = ce, fd(ie, ce);
    return;
  }
  ie.transmuxQueue.push(fd.bind(null, ie, ce));
}, gb = (ce) => {
  Ap("reset", ce);
}, _b = (ce) => {
  Ap("endTimeline", ce);
}, Dp = (ce) => {
  if (!ce.transmuxer.currentTransmux) {
    ce.transmuxer.currentTransmux = ce, Ep(ce);
    return;
  }
  ce.transmuxer.transmuxQueue.push(ce);
}, yb = (ce) => {
  const ie = new hb();
  ie.currentTransmux = null, ie.transmuxQueue = [];
  const me = ie.terminate;
  return ie.terminate = () => (ie.currentTransmux = null, ie.transmuxQueue.length = 0, me.call(ie)), ie.postMessage({
    action: "init",
    options: ce
  }), ie;
};
var Ro = {
  reset: gb,
  endTimeline: _b,
  transmux: Dp,
  createTransmuxer: yb
};
const ds = function(ce) {
  const ie = ce.transmuxer, me = ce.endAction || ce.action, we = ce.callback, Re = Oe$1({}, ce, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), je = (Ue) => {
    Ue.data.action === me && (ie.removeEventListener("message", je), Ue.data.data && (Ue.data.data = new Uint8Array(Ue.data.data, ce.byteOffset || 0, ce.byteLength || Ue.data.data.byteLength), ce.data && (ce.data = Ue.data.data)), we(Ue.data));
  };
  if (ie.addEventListener("message", je), ce.data) {
    const Ue = ce.data instanceof ArrayBuffer;
    Re.byteOffset = Ue ? 0 : ce.data.byteOffset, Re.byteLength = ce.data.byteLength;
    const qe = [Ue ? ce.data : ce.data.buffer];
    ie.postMessage(Re, qe);
  } else
    ie.postMessage(Re);
}, Ut = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, wp = "wvtt", uu = (ce) => {
  ce.forEach((ie) => {
    ie.abort();
  });
}, Tb = (ce) => ({
  bandwidth: ce.bandwidth,
  bytesReceived: ce.bytesReceived || 0,
  roundTripTime: ce.roundTripTime || 0
}), vb = (ce) => {
  const ie = ce.target, me = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: Date.now() - ie.requestTime || 0
  };
  return me.bytesReceived = ce.loaded, me.bandwidth = Math.floor(me.bytesReceived / me.roundTripTime * 8 * 1e3), me;
}, ll = (ce, ie) => {
  const {
    requestType: me
  } = ie, we = Li({
    requestType: me,
    request: ie,
    error: ce
  });
  return ie.timedout ? {
    status: ie.status,
    message: "HLS request timed-out at URL: " + ie.uri,
    code: Ut.TIMEOUT,
    xhr: ie,
    metadata: we
  } : ie.aborted ? {
    status: ie.status,
    message: "HLS request aborted at URL: " + ie.uri,
    code: Ut.ABORTED,
    xhr: ie,
    metadata: we
  } : ce ? {
    status: ie.status,
    message: "HLS request errored at URL: " + ie.uri,
    code: Ut.FAILURE,
    xhr: ie,
    metadata: we
  } : ie.responseType === "arraybuffer" && ie.response.byteLength === 0 ? {
    status: ie.status,
    message: "Empty HLS response at URL: " + ie.uri,
    code: Ut.FAILURE,
    xhr: ie,
    metadata: we
  } : null;
}, pd = (ce, ie, me, we) => (Re, je) => {
  const Ue = je.response, qe = ll(Re, je);
  if (qe)
    return me(qe, ce);
  if (Ue.byteLength !== 16)
    return me({
      status: je.status,
      message: "Invalid HLS key at URL: " + je.uri,
      code: Ut.FAILURE,
      xhr: je
    }, ce);
  const Ge = new DataView(Ue), Xe = new Uint32Array([Ge.getUint32(0), Ge.getUint32(4), Ge.getUint32(8), Ge.getUint32(12)]);
  for (let vt = 0; vt < ie.length; vt++)
    ie[vt].bytes = Xe;
  const ot = {
    uri: je.uri
  };
  return we({
    type: "segmentkeyloadcomplete",
    segment: ce,
    keyInfo: ot
  }), me(null, ce);
}, bb = (ce, ie) => {
  ie === wp && ce.transmuxer.postMessage({
    action: "initMp4WebVttParser",
    data: ce.map.bytes
  });
}, xb = (ce, ie, me) => {
  ie === wp && ds({
    action: "getMp4WebVttText",
    data: ce.bytes,
    transmuxer: ce.transmuxer,
    callback: ({
      data: we,
      mp4VttCues: Re
    }) => {
      ce.bytes = we, me(null, ce, {
        mp4VttCues: Re
      });
    }
  });
}, kp = (ce, ie) => {
  const me = Ou(ce.map.bytes);
  if (me !== "mp4") {
    const we = ce.map.resolvedUri || ce.map.uri, Re = me || "unknown";
    return ie({
      internal: !0,
      message: `Found unsupported ${Re} container for initialization segment at URL: ${we}`,
      code: Ut.FAILURE,
      metadata: {
        mediaType: Re
      }
    });
  }
  ds({
    action: "probeMp4Tracks",
    data: ce.map.bytes,
    transmuxer: ce.transmuxer,
    callback: ({
      tracks: we,
      data: Re
    }) => (ce.map.bytes = Re, we.forEach(function(je) {
      ce.map.tracks = ce.map.tracks || {}, !ce.map.tracks[je.type] && (ce.map.tracks[je.type] = je, typeof je.id == "number" && je.timescale && (ce.map.timescales = ce.map.timescales || {}, ce.map.timescales[je.id] = je.timescale), je.type === "text" && bb(ce, je.codec));
    }), ie(null))
  });
}, Sb = ({
  segment: ce,
  finishProcessingFn: ie,
  triggerSegmentEventFn: me
}) => (we, Re) => {
  const je = ll(we, Re);
  if (je)
    return ie(je, ce);
  const Ue = new Uint8Array(Re.response);
  if (me({
    type: "segmentloaded",
    segment: ce
  }), ce.map.key)
    return ce.map.encryptedBytes = Ue, ie(null, ce);
  ce.map.bytes = Ue, kp(ce, function(qe) {
    if (qe)
      return qe.xhr = Re, qe.status = Re.status, ie(qe, ce);
    ie(null, ce);
  });
}, Eb = ({
  segment: ce,
  finishProcessingFn: ie,
  responseType: me,
  triggerSegmentEventFn: we
}) => (Re, je) => {
  const Ue = ll(Re, je);
  if (Ue)
    return ie(Ue, ce);
  we({
    type: "segmentloaded",
    segment: ce
  });
  const qe = (
    // although responseText "should" exist, this guard serves to prevent an error being
    // thrown for two primary cases:
    // 1. the mime type override stops working, or is not implemented for a specific
    //    browser
    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
    me === "arraybuffer" || !je.responseText ? je.response : lb(je.responseText.substring(ce.lastReachedChar || 0))
  );
  return ce.stats = Tb(je), ce.key ? ce.encryptedBytes = new Uint8Array(qe) : ce.bytes = new Uint8Array(qe), ie(null, ce);
}, Cb = ({
  segment: ce,
  bytes: ie,
  trackInfoFn: me,
  timingInfoFn: we,
  videoSegmentTimingInfoFn: Re,
  audioSegmentTimingInfoFn: je,
  id3Fn: Ue,
  captionsFn: qe,
  isEndOfTimeline: Ge,
  endedTimelineFn: Xe,
  dataFn: ot,
  doneFn: vt,
  onTransmuxerLog: bt,
  triggerSegmentEventFn: Tt
}) => {
  const wt = ce.map && ce.map.tracks || {}, St = !!(wt.audio && wt.video);
  let It = we.bind(null, ce, "audio", "start");
  const Pt = we.bind(null, ce, "audio", "end");
  let kt = we.bind(null, ce, "video", "start");
  const Ot = we.bind(null, ce, "video", "end"), Jr = () => Dp({
    bytes: ie,
    transmuxer: ce.transmuxer,
    audioAppendStart: ce.audioAppendStart,
    gopsToAlignWith: ce.gopsToAlignWith,
    remux: St,
    onData: (en) => {
      en.type = en.type === "combined" ? "video" : en.type, ot(ce, en);
    },
    onTrackInfo: (en) => {
      me && (St && (en.isMuxed = !0), me(ce, en));
    },
    onAudioTimingInfo: (en) => {
      It && typeof en.start < "u" && (It(en.start), It = null), Pt && typeof en.end < "u" && Pt(en.end);
    },
    onVideoTimingInfo: (en) => {
      kt && typeof en.start < "u" && (kt(en.start), kt = null), Ot && typeof en.end < "u" && Ot(en.end);
    },
    onVideoSegmentTimingInfo: (en) => {
      const nn = {
        pts: {
          start: en.start.presentation,
          end: en.end.presentation
        },
        dts: {
          start: en.start.decode,
          end: en.end.decode
        }
      };
      Tt({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: ce,
        timingInfo: nn
      }), Re(en);
    },
    onAudioSegmentTimingInfo: (en) => {
      const nn = {
        pts: {
          start: en.start.pts,
          end: en.end.pts
        },
        dts: {
          start: en.start.dts,
          end: en.end.dts
        }
      };
      Tt({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: ce,
        timingInfo: nn
      }), je(en);
    },
    onId3: (en, nn) => {
      Ue(ce, en, nn);
    },
    onCaptions: (en) => {
      qe(ce, [en]);
    },
    isEndOfTimeline: Ge,
    onEndedTimeline: () => {
      Xe();
    },
    onTransmuxerLog: bt,
    onDone: (en, nn) => {
      vt && (en.type = en.type === "combined" ? "video" : en.type, Tt({
        type: "segmenttransmuxingcomplete",
        segment: ce
      }), vt(nn, ce, en));
    },
    segment: ce,
    triggerSegmentEventFn: Tt
  });
  ds({
    action: "probeTs",
    transmuxer: ce.transmuxer,
    data: ie,
    baseStartTime: ce.baseStartTime,
    callback: (en) => {
      ce.bytes = ie = en.data;
      const nn = en.result;
      nn && (me(ce, {
        hasAudio: nn.hasAudio,
        hasVideo: nn.hasVideo,
        isMuxed: St
      }), me = null), Jr();
    }
  });
}, Ip = ({
  segment: ce,
  bytes: ie,
  trackInfoFn: me,
  timingInfoFn: we,
  videoSegmentTimingInfoFn: Re,
  audioSegmentTimingInfoFn: je,
  id3Fn: Ue,
  captionsFn: qe,
  isEndOfTimeline: Ge,
  endedTimelineFn: Xe,
  dataFn: ot,
  doneFn: vt,
  onTransmuxerLog: bt,
  triggerSegmentEventFn: Tt
}) => {
  let wt = new Uint8Array(ie);
  if (Gy(wt)) {
    ce.isFmp4 = !0;
    const {
      tracks: St
    } = ce.map;
    if (St.text && (!St.audio || !St.video)) {
      ot(ce, {
        data: wt,
        type: "text"
      }), xb(ce, St.text.codec, vt);
      return;
    }
    const It = {
      isFmp4: !0,
      hasVideo: !!St.video,
      hasAudio: !!St.audio
    };
    St.audio && St.audio.codec && St.audio.codec !== "enca" && (It.audioCodec = St.audio.codec), St.video && St.video.codec && St.video.codec !== "encv" && (It.videoCodec = St.video.codec), St.video && St.audio && (It.isMuxed = !0), me(ce, It);
    const Pt = (kt, Ot) => {
      ot(ce, {
        data: wt,
        type: It.hasAudio && !It.isMuxed ? "audio" : "video"
      }), Ot && Ot.length && Ue(ce, Ot), kt && kt.length && qe(ce, kt), vt(null, ce, {});
    };
    ds({
      action: "probeMp4StartTime",
      timescales: ce.map.timescales,
      data: wt,
      transmuxer: ce.transmuxer,
      callback: ({
        data: kt,
        startTime: Ot
      }) => {
        ie = kt.buffer, ce.bytes = wt = kt, It.hasAudio && !It.isMuxed && we(ce, "audio", "start", Ot), It.hasVideo && we(ce, "video", "start", Ot), ds({
          action: "probeEmsgID3",
          data: wt,
          transmuxer: ce.transmuxer,
          offset: Ot,
          callback: ({
            emsgData: Jr,
            id3Frames: en
          }) => {
            if (ie = Jr.buffer, ce.bytes = wt = Jr, !St.video || !Jr.byteLength || !ce.transmuxer) {
              Pt(void 0, en);
              return;
            }
            ds({
              action: "pushMp4Captions",
              endAction: "mp4Captions",
              transmuxer: ce.transmuxer,
              data: wt,
              timescales: ce.map.timescales,
              trackIds: [St.video.id],
              callback: (nn) => {
                ie = nn.data.buffer, ce.bytes = wt = nn.data, nn.logs.forEach(function(ln) {
                  bt(fe$1(ln, {
                    stream: "mp4CaptionParser"
                  }));
                }), Pt(nn.captions, en);
              }
            });
          }
        });
      }
    });
    return;
  }
  if (!ce.transmuxer) {
    vt(null, ce, {});
    return;
  }
  if (typeof ce.container > "u" && (ce.container = Ou(wt)), ce.container !== "ts" && ce.container !== "aac") {
    me(ce, {
      hasAudio: !1,
      hasVideo: !1
    }), vt(null, ce, {});
    return;
  }
  Cb({
    segment: ce,
    bytes: ie,
    trackInfoFn: me,
    timingInfoFn: we,
    videoSegmentTimingInfoFn: Re,
    audioSegmentTimingInfoFn: je,
    id3Fn: Ue,
    captionsFn: qe,
    isEndOfTimeline: Ge,
    endedTimelineFn: Xe,
    dataFn: ot,
    doneFn: vt,
    onTransmuxerLog: bt,
    triggerSegmentEventFn: Tt
  });
}, Pp = function({
  id: ce,
  key: ie,
  encryptedBytes: me,
  decryptionWorker: we,
  segment: Re,
  doneFn: je
}, Ue) {
  const qe = (Xe) => {
    if (Xe.data.source === ce) {
      we.removeEventListener("message", qe);
      const ot = Xe.data.decrypted;
      Ue(new Uint8Array(ot.bytes, ot.byteOffset, ot.byteLength));
    }
  };
  we.onerror = () => {
    const Xe = "An error occurred in the decryption worker", ot = Ai({
      segment: Re
    }), vt = {
      message: Xe,
      metadata: {
        error: new Error(Xe),
        errorType: L.Error.StreamingFailedToDecryptSegment,
        segmentInfo: ot,
        keyInfo: {
          uri: Re.key.resolvedUri || Re.map.key.resolvedUri
        }
      }
    };
    je(vt, Re);
  }, we.addEventListener("message", qe);
  let Ge;
  ie.bytes.slice ? Ge = ie.bytes.slice() : Ge = new Uint32Array(Array.prototype.slice.call(ie.bytes)), we.postMessage(mp({
    source: ce,
    encrypted: me,
    key: Ge,
    iv: ie.iv
  }), [me.buffer, Ge.buffer]);
}, Ab = ({
  decryptionWorker: ce,
  segment: ie,
  trackInfoFn: me,
  timingInfoFn: we,
  videoSegmentTimingInfoFn: Re,
  audioSegmentTimingInfoFn: je,
  id3Fn: Ue,
  captionsFn: qe,
  isEndOfTimeline: Ge,
  endedTimelineFn: Xe,
  dataFn: ot,
  doneFn: vt,
  onTransmuxerLog: bt,
  triggerSegmentEventFn: Tt
}) => {
  Tt({
    type: "segmentdecryptionstart"
  }), Pp({
    id: ie.requestId,
    key: ie.key,
    encryptedBytes: ie.encryptedBytes,
    decryptionWorker: ce,
    segment: ie,
    doneFn: vt
  }, (wt) => {
    ie.bytes = wt, Tt({
      type: "segmentdecryptioncomplete",
      segment: ie
    }), Ip({
      segment: ie,
      bytes: ie.bytes,
      trackInfoFn: me,
      timingInfoFn: we,
      videoSegmentTimingInfoFn: Re,
      audioSegmentTimingInfoFn: je,
      id3Fn: Ue,
      captionsFn: qe,
      isEndOfTimeline: Ge,
      endedTimelineFn: Xe,
      dataFn: ot,
      doneFn: vt,
      onTransmuxerLog: bt,
      triggerSegmentEventFn: Tt
    });
  });
}, Db = ({
  activeXhrs: ce,
  decryptionWorker: ie,
  trackInfoFn: me,
  timingInfoFn: we,
  videoSegmentTimingInfoFn: Re,
  audioSegmentTimingInfoFn: je,
  id3Fn: Ue,
  captionsFn: qe,
  isEndOfTimeline: Ge,
  endedTimelineFn: Xe,
  dataFn: ot,
  doneFn: vt,
  onTransmuxerLog: bt,
  triggerSegmentEventFn: Tt
}) => {
  let wt = 0, St = !1;
  return (It, Pt) => {
    if (!St) {
      if (It)
        return St = !0, uu(ce), vt(It, Pt);
      if (wt += 1, wt === ce.length) {
        const kt = function() {
          if (Pt.encryptedBytes)
            return Ab({
              decryptionWorker: ie,
              segment: Pt,
              trackInfoFn: me,
              timingInfoFn: we,
              videoSegmentTimingInfoFn: Re,
              audioSegmentTimingInfoFn: je,
              id3Fn: Ue,
              captionsFn: qe,
              isEndOfTimeline: Ge,
              endedTimelineFn: Xe,
              dataFn: ot,
              doneFn: vt,
              onTransmuxerLog: bt,
              triggerSegmentEventFn: Tt
            });
          Ip({
            segment: Pt,
            bytes: Pt.bytes,
            trackInfoFn: me,
            timingInfoFn: we,
            videoSegmentTimingInfoFn: Re,
            audioSegmentTimingInfoFn: je,
            id3Fn: Ue,
            captionsFn: qe,
            isEndOfTimeline: Ge,
            endedTimelineFn: Xe,
            dataFn: ot,
            doneFn: vt,
            onTransmuxerLog: bt,
            triggerSegmentEventFn: Tt
          });
        };
        if (Pt.endOfAllRequests = Date.now(), Pt.map && Pt.map.encryptedBytes && !Pt.map.bytes)
          return Tt({
            type: "segmentdecryptionstart",
            segment: Pt
          }), Pp({
            decryptionWorker: ie,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: Pt.requestId + "-init",
            encryptedBytes: Pt.map.encryptedBytes,
            key: Pt.map.key,
            segment: Pt,
            doneFn: vt
          }, (Ot) => {
            Pt.map.bytes = Ot, Tt({
              type: "segmentdecryptioncomplete",
              segment: Pt
            }), kp(Pt, (Jr) => {
              if (Jr)
                return uu(ce), vt(Jr, Pt);
              kt();
            });
          });
        kt();
      }
    }
  };
}, wb = ({
  loadendState: ce,
  abortFn: ie
}) => (me) => {
  me.target.aborted && ie && !ce.calledAbortFn && (ie(), ce.calledAbortFn = !0);
}, kb = ({
  segment: ce,
  progressFn: ie,
  trackInfoFn: me,
  timingInfoFn: we,
  videoSegmentTimingInfoFn: Re,
  audioSegmentTimingInfoFn: je,
  id3Fn: Ue,
  captionsFn: qe,
  isEndOfTimeline: Ge,
  endedTimelineFn: Xe,
  dataFn: ot
}) => (vt) => {
  if (!vt.target.aborted)
    return ce.stats = fe$1(ce.stats, vb(vt)), !ce.stats.firstBytesReceivedAt && ce.stats.bytesReceived && (ce.stats.firstBytesReceivedAt = Date.now()), ie(vt, ce);
}, Ib = ({
  xhr: ce,
  xhrOptions: ie,
  decryptionWorker: me,
  segment: we,
  abortFn: Re,
  progressFn: je,
  trackInfoFn: Ue,
  timingInfoFn: qe,
  videoSegmentTimingInfoFn: Ge,
  audioSegmentTimingInfoFn: Xe,
  id3Fn: ot,
  captionsFn: vt,
  isEndOfTimeline: bt,
  endedTimelineFn: Tt,
  dataFn: wt,
  doneFn: St,
  onTransmuxerLog: It,
  triggerSegmentEventFn: Pt
}) => {
  const kt = [], Ot = Db({
    activeXhrs: kt,
    decryptionWorker: me,
    trackInfoFn: Ue,
    timingInfoFn: qe,
    videoSegmentTimingInfoFn: Ge,
    audioSegmentTimingInfoFn: Xe,
    id3Fn: ot,
    captionsFn: vt,
    isEndOfTimeline: bt,
    endedTimelineFn: Tt,
    dataFn: wt,
    doneFn: St,
    onTransmuxerLog: It,
    triggerSegmentEventFn: Pt
  });
  if (we.key && !we.key.bytes) {
    const fn = [we.key];
    we.map && !we.map.bytes && we.map.key && we.map.key.resolvedUri === we.key.resolvedUri && fn.push(we.map.key);
    const vn = fe$1(ie, {
      uri: we.key.resolvedUri,
      responseType: "arraybuffer",
      requestType: "segment-key"
    }), Tn = pd(we, fn, Ot, Pt), xn = {
      uri: we.key.resolvedUri
    };
    Pt({
      type: "segmentkeyloadstart",
      segment: we,
      keyInfo: xn
    });
    const bn = ce(vn, Tn);
    kt.push(bn);
  }
  if (we.map && !we.map.bytes) {
    if (we.map.key && (!we.key || we.key.resolvedUri !== we.map.key.resolvedUri)) {
      const xn = fe$1(ie, {
        uri: we.map.key.resolvedUri,
        responseType: "arraybuffer",
        requestType: "segment-key"
      }), bn = pd(we, [we.map.key], Ot, Pt), Sn = {
        uri: we.map.key.resolvedUri
      };
      Pt({
        type: "segmentkeyloadstart",
        segment: we,
        keyInfo: Sn
      });
      const Cn = ce(xn, bn);
      kt.push(Cn);
    }
    const fn = fe$1(ie, {
      uri: we.map.resolvedUri,
      responseType: "arraybuffer",
      headers: au(we.map),
      requestType: "segment-media-initialization"
    }), vn = Sb({
      segment: we,
      finishProcessingFn: Ot,
      triggerSegmentEventFn: Pt
    });
    Pt({
      type: "segmentloadstart",
      segment: we
    });
    const Tn = ce(fn, vn);
    kt.push(Tn);
  }
  const Jr = fe$1(ie, {
    uri: we.part && we.part.resolvedUri || we.resolvedUri,
    responseType: "arraybuffer",
    headers: au(we),
    requestType: "segment"
  }), en = Eb({
    segment: we,
    finishProcessingFn: Ot,
    responseType: Jr.responseType,
    triggerSegmentEventFn: Pt
  });
  Pt({
    type: "segmentloadstart",
    segment: we
  });
  const nn = ce(Jr, en);
  nn.addEventListener("progress", kb({
    segment: we,
    progressFn: je,
    trackInfoFn: Ue,
    timingInfoFn: qe,
    videoSegmentTimingInfoFn: Ge,
    audioSegmentTimingInfoFn: Xe,
    id3Fn: ot,
    captionsFn: vt,
    isEndOfTimeline: bt,
    endedTimelineFn: Tt,
    dataFn: wt
  })), kt.push(nn);
  const ln = {};
  return kt.forEach((fn) => {
    fn.addEventListener("loadend", wb({
      loadendState: ln,
      abortFn: Re
    }));
  }), () => uu(kt);
}, Nn = yt("PlaylistSelector"), md = function(ce) {
  if (!ce || !ce.playlist)
    return;
  const ie = ce.playlist;
  return JSON.stringify({
    id: ie.id,
    bandwidth: ce.bandwidth,
    width: ce.width,
    height: ce.height,
    codecs: ie.attributes && ie.attributes.CODECS || ""
  });
}, hs = function(ce, ie) {
  if (!ce)
    return "";
  const me = S.getComputedStyle(ce);
  return me ? me[ie] : "";
}, fs = function(ce, ie) {
  const me = ce.slice();
  ce.sort(function(we, Re) {
    const je = ie(we, Re);
    return je === 0 ? me.indexOf(we) - me.indexOf(Re) : je;
  });
}, cl = function(ce, ie) {
  let me, we;
  return ce.attributes.BANDWIDTH && (me = ce.attributes.BANDWIDTH), me = me || S.Number.MAX_VALUE, ie.attributes.BANDWIDTH && (we = ie.attributes.BANDWIDTH), we = we || S.Number.MAX_VALUE, me - we;
}, Pb = function(ce, ie) {
  let me, we;
  return ce.attributes.RESOLUTION && ce.attributes.RESOLUTION.width && (me = ce.attributes.RESOLUTION.width), me = me || S.Number.MAX_VALUE, ie.attributes.RESOLUTION && ie.attributes.RESOLUTION.width && (we = ie.attributes.RESOLUTION.width), we = we || S.Number.MAX_VALUE, me === we && ce.attributes.BANDWIDTH && ie.attributes.BANDWIDTH ? ce.attributes.BANDWIDTH - ie.attributes.BANDWIDTH : me - we;
};
let Op = function(ce) {
  const {
    main: ie,
    bandwidth: me,
    playerWidth: we,
    playerHeight: Re,
    playerObjectFit: je,
    limitRenditionByPlayerDimensions: Ue,
    playlistController: qe
  } = ce;
  if (!ie)
    return;
  const Ge = {
    bandwidth: me,
    width: we,
    height: Re,
    limitRenditionByPlayerDimensions: Ue
  };
  let Xe = ie.playlists;
  st.isAudioOnly(ie) && (Xe = qe.getAudioTrackPlaylists_(), Ge.audioOnly = !0);
  let ot = Xe.map((ln) => {
    let fn;
    const vn = ln.attributes && ln.attributes.RESOLUTION && ln.attributes.RESOLUTION.width, Tn = ln.attributes && ln.attributes.RESOLUTION && ln.attributes.RESOLUTION.height;
    return fn = ln.attributes && ln.attributes.BANDWIDTH, fn = fn || S.Number.MAX_VALUE, {
      bandwidth: fn,
      width: vn,
      height: Tn,
      playlist: ln
    };
  });
  fs(ot, (ln, fn) => ln.bandwidth - fn.bandwidth), ot = ot.filter((ln) => !st.isIncompatible(ln.playlist));
  let vt = ot.filter((ln) => st.isEnabled(ln.playlist));
  vt.length || (vt = ot.filter((ln) => !st.isDisabled(ln.playlist)));
  const bt = vt.filter((ln) => ln.bandwidth * Me.BANDWIDTH_VARIANCE < me);
  let Tt = bt[bt.length - 1];
  const wt = bt.filter((ln) => ln.bandwidth === Tt.bandwidth)[0];
  if (Ue === !1) {
    const ln = wt || vt[0] || ot[0];
    if (ln && ln.playlist) {
      let fn = "sortedPlaylistReps";
      return wt && (fn = "bandwidthBestRep"), vt[0] && (fn = "enabledPlaylistReps"), Nn(`choosing ${md(ln)} using ${fn} with options`, Ge), ln.playlist;
    }
    return Nn("could not choose a playlist with options", Ge), null;
  }
  const St = bt.filter((ln) => ln.width && ln.height);
  fs(St, (ln, fn) => ln.width - fn.width);
  const It = St.filter((ln) => ln.width === we && ln.height === Re);
  Tt = It[It.length - 1];
  const Pt = It.filter((ln) => ln.bandwidth === Tt.bandwidth)[0];
  let kt, Ot, Jr;
  Pt || (kt = St.filter((ln) => je === "cover" ? ln.width > we && ln.height > Re : ln.width > we || ln.height > Re), Ot = kt.filter((ln) => ln.width === kt[0].width && ln.height === kt[0].height), Tt = Ot[Ot.length - 1], Jr = Ot.filter((ln) => ln.bandwidth === Tt.bandwidth)[0]);
  let en;
  if (qe.leastPixelDiffSelector) {
    const ln = St.map((fn) => (fn.pixelDiff = Math.abs(fn.width - we) + Math.abs(fn.height - Re), fn));
    fs(ln, (fn, vn) => fn.pixelDiff === vn.pixelDiff ? vn.bandwidth - fn.bandwidth : fn.pixelDiff - vn.pixelDiff), en = ln[0];
  }
  const nn = en || Jr || Pt || wt || vt[0] || ot[0];
  if (nn && nn.playlist) {
    let ln = "sortedPlaylistReps";
    return en ? ln = "leastPixelDiffRep" : Jr ? ln = "resolutionPlusOneRep" : Pt ? ln = "resolutionBestRep" : wt ? ln = "bandwidthBestRep" : vt[0] && (ln = "enabledPlaylistReps"), Nn(`choosing ${md(nn)} using ${ln} with options`, Ge), nn.playlist;
  }
  return Nn("could not choose a playlist with options", Ge), null;
};
const gd = function() {
  let ce = this.useDevicePixelRatio && S.devicePixelRatio || 1;
  return isNaN(this.customPixelRatio) || (ce = this.customPixelRatio), Op({
    main: this.playlists.main,
    bandwidth: this.systemBandwidth,
    playerWidth: parseInt(hs(this.tech_.el(), "width"), 10) * ce,
    playerHeight: parseInt(hs(this.tech_.el(), "height"), 10) * ce,
    playerObjectFit: this.usePlayerObjectFit ? hs(this.tech_.el(), "objectFit") : "",
    limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
    playlistController: this.playlistController_
  });
}, Ob = function(ce) {
  let ie = -1, me = -1;
  if (ce < 0 || ce > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    let we = this.useDevicePixelRatio && S.devicePixelRatio || 1;
    return isNaN(this.customPixelRatio) || (we = this.customPixelRatio), ie < 0 && (ie = this.systemBandwidth, me = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== me && (ie = ce * this.systemBandwidth + (1 - ce) * ie, me = this.systemBandwidth), Op({
      main: this.playlists.main,
      bandwidth: ie,
      playerWidth: parseInt(hs(this.tech_.el(), "width"), 10) * we,
      playerHeight: parseInt(hs(this.tech_.el(), "height"), 10) * we,
      playerObjectFit: this.usePlayerObjectFit ? hs(this.tech_.el(), "objectFit") : "",
      limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
      playlistController: this.playlistController_
    });
  };
}, Lb = function(ce) {
  const {
    main: ie,
    currentTime: me,
    bandwidth: we,
    duration: Re,
    segmentDuration: je,
    timeUntilRebuffer: Ue,
    currentTimeline: qe,
    syncController: Ge
  } = ce, Xe = ie.playlists.filter((Tt) => !st.isIncompatible(Tt));
  let ot = Xe.filter(st.isEnabled);
  ot.length || (ot = Xe.filter((Tt) => !st.isDisabled(Tt)));
  const vt = ot.filter(st.hasAttribute.bind(null, "BANDWIDTH")).map((Tt) => {
    const wt = Ge.getSyncPoint(Tt, Re, qe, me) ? 1 : 2, St = st.estimateSegmentRequestTime(je, we, Tt) * wt - Ue;
    return {
      playlist: Tt,
      rebufferingImpact: St
    };
  }), bt = vt.filter((Tt) => Tt.rebufferingImpact <= 0);
  return fs(bt, (Tt, wt) => cl(wt.playlist, Tt.playlist)), bt.length ? bt[0] : (fs(vt, (Tt, wt) => Tt.rebufferingImpact - wt.rebufferingImpact), vt[0] || null);
}, Rb = function() {
  const ce = this.playlists.main.playlists.filter(st.isEnabled);
  return fs(ce, (ie, me) => cl(ie, me)), ce.filter((ie) => !!Or(this.playlists.main, ie).video)[0] || null;
}, Mb = (ce) => {
  let ie = 0, me;
  return ce.bytes && (me = new Uint8Array(ce.bytes), ce.segments.forEach((we) => {
    me.set(we, ie), ie += we.byteLength;
  })), me;
};
function Lp(ce) {
  try {
    return new URL(ce).pathname.split("/").slice(-2).join("/");
  } catch {
    return "";
  }
}
const Nb = function(ce, ie, me) {
  if (!ce[me]) {
    ie.trigger({
      type: "usage",
      name: "vhs-608"
    });
    let we = me;
    /^cc708_/.test(me) && (we = "SERVICE" + me.split("_")[1]);
    const Re = ie.textTracks().getTrackById(we);
    if (Re)
      ce[me] = Re;
    else {
      const je = ie.options_.vhs && ie.options_.vhs.captionServices || {};
      let Ue = me, qe = me, Ge = !1;
      const Xe = je[we];
      Xe && (Ue = Xe.label, qe = Xe.language, Ge = Xe.default), ce[me] = ie.addRemoteTextTrack({
        kind: "captions",
        id: we,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: Ge,
        label: Ue,
        language: qe
      }, !1).track;
    }
  }
}, Bb = function({
  inbandTextTracks: ce,
  captionArray: ie,
  timestampOffset: me
}) {
  if (!ie)
    return;
  const we = S.WebKitDataCue || S.VTTCue;
  ie.forEach((Re) => {
    const je = Re.stream;
    Re.content ? Re.content.forEach((Ue) => {
      const qe = new we(Re.startTime + me, Re.endTime + me, Ue.text);
      qe.line = Ue.line, qe.align = "left", qe.position = Ue.position, qe.positionAlign = "line-left", ce[je].addCue(qe);
    }) : ce[je].addCue(new we(Re.startTime + me, Re.endTime + me, Re.text));
  });
}, Fb = function(ce) {
  Object.defineProperties(ce.frame, {
    id: {
      get() {
        return L.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), ce.value.key;
      }
    },
    value: {
      get() {
        return L.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), ce.value.data;
      }
    },
    privateData: {
      get() {
        return L.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), ce.value.data;
      }
    }
  });
}, Ub = ({
  inbandTextTracks: ce,
  metadataArray: ie,
  timestampOffset: me,
  videoDuration: we
}) => {
  if (!ie)
    return;
  const Re = S.WebKitDataCue || S.VTTCue, je = ce.metadataTrack_;
  if (!je || (ie.forEach((ot) => {
    const vt = ot.cueTime + me;
    typeof vt != "number" || S.isNaN(vt) || vt < 0 || !(vt < 1 / 0) || !ot.frames || !ot.frames.length || ot.frames.forEach((bt) => {
      const Tt = new Re(vt, vt, bt.value || bt.url || bt.data || "");
      Tt.frame = bt, Tt.value = bt, Fb(Tt), je.addCue(Tt);
    });
  }), !je.cues || !je.cues.length))
    return;
  const Ue = je.cues, qe = [];
  for (let ot = 0; ot < Ue.length; ot++)
    Ue[ot] && qe.push(Ue[ot]);
  const Ge = qe.reduce((ot, vt) => {
    const bt = ot[vt.startTime] || [];
    return bt.push(vt), ot[vt.startTime] = bt, ot;
  }, {}), Xe = Object.keys(Ge).sort((ot, vt) => Number(ot) - Number(vt));
  Xe.forEach((ot, vt) => {
    const bt = Ge[ot], Tt = isFinite(we) ? we : ot, wt = Number(Xe[vt + 1]) || Tt;
    bt.forEach((St) => {
      St.endTime = wt;
    });
  });
}, $b = {
  id: "ID",
  class: "CLASS",
  startDate: "START-DATE",
  duration: "DURATION",
  endDate: "END-DATE",
  endOnNext: "END-ON-NEXT",
  plannedDuration: "PLANNED-DURATION",
  scte35Out: "SCTE35-OUT",
  scte35In: "SCTE35-IN"
}, jb = /* @__PURE__ */ new Set(["id", "class", "startDate", "duration", "endDate", "endOnNext", "startTime", "endTime", "processDateRange"]), qb = ({
  inbandTextTracks: ce,
  dateRanges: ie
}) => {
  const me = ce.metadataTrack_;
  if (!me)
    return;
  const we = S.WebKitDataCue || S.VTTCue;
  ie.forEach((Re) => {
    for (const je of Object.keys(Re)) {
      if (jb.has(je))
        continue;
      const Ue = new we(Re.startTime, Re.endTime, "");
      Ue.id = Re.id, Ue.type = "com.apple.quicktime.HLS", Ue.value = {
        key: $b[je],
        data: Re[je]
      }, (je === "scte35Out" || je === "scte35In") && (Ue.value.data = new Uint8Array(Ue.value.data.match(/[\da-f]{2}/gi)).buffer), me.addCue(Ue);
    }
    Re.processDateRange();
  });
}, _d = (ce, ie, me) => {
  ce.metadataTrack_ || (ce.metadataTrack_ = me.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, L.browser.IS_ANY_SAFARI || (ce.metadataTrack_.inBandMetadataTrackDispatchType = ie));
}, Cr = function(ce, ie, me) {
  let we, Re;
  if (me && me.cues)
    for (we = me.cues.length; we--; )
      Re = me.cues[we], Re.startTime >= ce && Re.endTime <= ie && me.removeCue(Re);
}, Vb = function(ce) {
  const ie = ce.cues;
  if (!ie)
    return;
  const me = {};
  for (let we = ie.length - 1; we >= 0; we--) {
    const Re = ie[we], je = `${Re.startTime}-${Re.endTime}-${Re.text}`;
    me[je] ? ce.removeCue(Re) : me[je] = Re;
  }
}, Hb = (ce, ie, me) => {
  if (typeof ie > "u" || ie === null || !ce.length)
    return [];
  const we = Math.ceil((ie - me + 3) * Di.ONE_SECOND_IN_TS);
  let Re;
  for (Re = 0; Re < ce.length && !(ce[Re].pts > we); Re++)
    ;
  return ce.slice(Re);
}, zb = (ce, ie, me) => {
  if (!ie.length)
    return ce;
  if (me)
    return ie.slice();
  const we = ie[0].pts;
  let Re = 0;
  for (Re; Re < ce.length && !(ce[Re].pts >= we); Re++)
    ;
  return ce.slice(0, Re).concat(ie);
}, Wb = (ce, ie, me, we) => {
  const Re = Math.ceil((ie - we) * Di.ONE_SECOND_IN_TS), je = Math.ceil((me - we) * Di.ONE_SECOND_IN_TS), Ue = ce.slice();
  let qe = ce.length;
  for (; qe-- && !(ce[qe].pts <= je); )
    ;
  if (qe === -1)
    return Ue;
  let Ge = qe + 1;
  for (; Ge-- && !(ce[Ge].pts <= Re); )
    ;
  return Ge = Math.max(Ge, 0), Ue.splice(Ge, qe - Ge + 1), Ue;
}, Gb = function(ce, ie) {
  if (!ce && !ie || !ce && ie || ce && !ie)
    return !1;
  if (ce === ie)
    return !0;
  const me = Object.keys(ce).sort(), we = Object.keys(ie).sort();
  if (me.length !== we.length)
    return !1;
  for (let Re = 0; Re < me.length; Re++) {
    const je = me[Re];
    if (je !== we[Re] || ce[je] !== ie[je])
      return !1;
  }
  return !0;
}, Xb = function(ce, ie, me) {
  ie = ie || [];
  const we = [];
  let Re = 0;
  for (let je = 0; je < ie.length; je++) {
    const Ue = ie[je];
    if (ce === Ue.timeline && (we.push(je), Re += Ue.duration, Re > me))
      return je;
  }
  return we.length === 0 ? 0 : we[we.length - 1];
}, Tr = 1, Kb = 500, yd = (ce) => typeof ce == "number" && isFinite(ce), Bn = 1 / 60, Yb = (ce, ie, me) => ce !== "main" || !ie || !me ? null : !me.hasAudio && !me.hasVideo ? "Neither audio nor video found in segment." : ie.hasVideo && !me.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !ie.hasVideo && me.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, Qb = (ce, ie, me) => {
  let we = ie - Me.BACK_BUFFER_LENGTH;
  ce.length && (we = Math.max(we, ce.start(0)));
  const Re = ie - me;
  return Math.min(Re, we);
}, ts = (ce) => {
  const {
    startOfSegment: ie,
    duration: me,
    segment: we,
    part: Re,
    playlist: {
      mediaSequence: je,
      id: Ue,
      segments: qe = []
    },
    mediaIndex: Ge,
    partIndex: Xe,
    timeline: ot
  } = ce, vt = qe.length - 1;
  let bt = "mediaIndex/partIndex increment";
  ce.getMediaInfoForTime ? bt = `getMediaInfoForTime (${ce.getMediaInfoForTime})` : ce.isSyncRequest && (bt = "getSyncSegmentCandidate (isSyncRequest)"), ce.independent && (bt += ` with independent ${ce.independent}`);
  const Tt = typeof Xe == "number", wt = ce.segment.uri ? "segment" : "pre-segment", St = Tt ? Qf({
    preloadSegment: we
  }) - 1 : 0;
  return `${wt} [${je + Ge}/${je + vt}]` + (Tt ? ` part [${Xe}/${St}]` : "") + ` segment start/end [${we.start} => ${we.end}]` + (Tt ? ` part start/end [${Re.start} => ${Re.end}]` : "") + ` startOfSegment [${ie}] duration [${me}] timeline [${ot}] selected by [${bt}] playlist [${Ue}]`;
}, Td = (ce) => `${ce}TimingInfo`, Jb = ({
  segmentTimeline: ce,
  currentTimeline: ie,
  startOfSegment: me,
  buffered: we,
  overrideCheck: Re
}) => !Re && ce === ie ? null : ce < ie ? me : we.length ? we.end(we.length - 1) : me, lu = ({
  timelineChangeController: ce,
  currentTimeline: ie,
  segmentTimeline: me,
  loaderType: we,
  audioDisabled: Re
}) => {
  if (ie === me)
    return !1;
  if (we === "audio") {
    const je = ce.lastTimelineChange({
      type: "main"
    });
    return !je || je.to !== me;
  }
  if (we === "main" && Re) {
    const je = ce.pendingTimelineChange({
      type: "audio"
    });
    return !(je && je.to === me);
  }
  return !1;
}, Zb = (ce) => {
  if (!ce)
    return !1;
  const ie = ce.pendingTimelineChange({
    type: "audio"
  }), me = ce.pendingTimelineChange({
    type: "main"
  }), we = ie && me, Re = we && ie.to !== me.to;
  return !!(we && ie.from !== -1 && me.from !== -1 && Re);
}, e2 = (ce) => {
  const ie = ce.timelineChangeController_.pendingTimelineChange({
    type: "audio"
  }), me = ce.timelineChangeController_.pendingTimelineChange({
    type: "main"
  });
  return ie && me && ie.to < me.to;
}, ci = (ce) => {
  const ie = ce.pendingSegment_;
  if (ie && lu({
    timelineChangeController: ce.timelineChangeController_,
    currentTimeline: ce.currentTimeline_,
    segmentTimeline: ie.timeline,
    loaderType: ce.loaderType_,
    audioDisabled: ce.audioDisabled_
  }) && Zb(ce.timelineChangeController_)) {
    if (e2(ce)) {
      ce.timelineChangeController_.trigger("audioTimelineBehind");
      return;
    }
    ce.timelineChangeController_.trigger("fixBadTimelineChange");
  }
}, t2 = (ce) => {
  let ie = 0;
  return ["video", "audio"].forEach(function(me) {
    const we = ce[`${me}TimingInfo`];
    if (!we)
      return;
    const {
      start: Re,
      end: je
    } = we;
    let Ue;
    typeof Re == "bigint" || typeof je == "bigint" ? Ue = S.BigInt(je) - S.BigInt(Re) : typeof Re == "number" && typeof je == "number" && (Ue = je - Re), typeof Ue < "u" && Ue > ie && (ie = Ue);
  }), typeof ie == "bigint" && ie < Number.MAX_SAFE_INTEGER && (ie = Number(ie)), ie;
}, vd = ({
  segmentDuration: ce,
  maxDuration: ie
}) => ce ? Math.round(ce) > ie + Bt : !1, i2 = (ce, ie) => {
  if (ie !== "hls")
    return null;
  const me = t2({
    audioTimingInfo: ce.audioTimingInfo,
    videoTimingInfo: ce.videoTimingInfo
  });
  if (!me)
    return null;
  const we = ce.playlist.targetDuration, Re = vd({
    segmentDuration: me,
    maxDuration: we * 2
  }), je = vd({
    segmentDuration: me,
    maxDuration: we
  }), Ue = `Segment with index ${ce.mediaIndex} from playlist ${ce.playlist.id} has a duration of ${me} when the reported duration is ${ce.duration} and the target duration is ${we}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
  return Re || je ? {
    severity: Re ? "warn" : "info",
    message: Ue
  } : null;
}, Ai = ({
  type: ce,
  segment: ie
}) => {
  if (!ie)
    return;
  const me = !!(ie.key || ie.map && ie.map.ke), we = !!(ie.map && !ie.map.bytes), Re = ie.startOfSegment === void 0 ? ie.start : ie.startOfSegment;
  return {
    type: ce || ie.type,
    uri: ie.resolvedUri || ie.uri,
    start: Re,
    duration: ie.duration,
    isEncrypted: me,
    isMediaInitialization: we
  };
};
class cu extends L.EventTarget {
  constructor(ie, me = {}) {
    if (super(), !ie)
      throw new TypeError("Initialization settings are required");
    if (typeof ie.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!ie.mediaSource)
      throw new TypeError("No MediaSource specified");
    this.bandwidth = ie.bandwidth, this.throughput = {
      rate: 0,
      count: 0
    }, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = ie.hasPlayed, this.currentTime_ = ie.currentTime, this.seekable_ = ie.seekable, this.seeking_ = ie.seeking, this.duration_ = ie.duration, this.mediaSource_ = ie.mediaSource, this.vhs_ = ie.vhs, this.loaderType_ = ie.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = ie.segmentMetadataTrack, this.goalBufferLength_ = ie.goalBufferLength, this.sourceType_ = ie.sourceType, this.sourceUpdater_ = ie.sourceUpdater, this.inbandTextTracks_ = ie.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = ie.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = ie.parse708captions, this.useDtsForTimestampOffset_ = ie.useDtsForTimestampOffset, this.captionServices_ = ie.captionServices, this.exactManifestTimings = ie.exactManifestTimings, this.addMetadataToTextTrack = ie.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
      id3: [],
      caption: []
    }, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = ie.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = ie.decrypter, this.syncController_ = ie.syncController, this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
      this.isEndOfStream_() || (this.ended_ = !1);
    }), this.fetchAtBuffer_ = !1, this.logger_ = yt(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
      get() {
        return this.state_;
      },
      set(we) {
        we !== this.state_ && (this.logger_(`${this.state_} -> ${we}`), this.state_ = we, this.trigger("statechange"));
      }
    }), this.sourceUpdater_.on("ready", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ci(this);
    }), this.sourceUpdater_.on("codecschange", (we) => {
      this.trigger(Oe$1({
        type: "codecschange"
      }, we));
    }), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ci(this);
    }), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (we) => {
      this.trigger(Oe$1({
        type: "timelinechange"
      }, we)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : ci(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ci(this);
    });
  }
  /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */
  get mediaSequenceSync_() {
    return this.syncController_.getMediaSequenceSync(this.loaderType_);
  }
  createTransmuxer_() {
    return Ro.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }
  /**
   * reset all of our media stats
   *
   * @private
   */
  resetStats_() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }
  /**
   * dispose of the SegmentLoader and reset to the default state
   */
  dispose() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }
  setAudio(ie) {
    this.audioDisabled_ = !ie, ie ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }
  /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */
  abort() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null), this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }
  /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */
  abort_() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, S.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }
  checkForAbort_(ie) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== ie;
  }
  /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */
  error(ie) {
    return typeof ie < "u" && (this.logger_("error occurred:", ie), this.error_ = ie), this.pendingSegment_ = null, this.error_;
  }
  endOfStream() {
    this.ended_ = !0, this.transmuxer_ && Ro.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    const ie = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !ie)
      return Be();
    if (this.loaderType_ === "main") {
      const {
        hasAudio: me,
        hasVideo: we,
        isMuxed: Re
      } = ie;
      if (we && me && !this.audioDisabled_ && !Re)
        return this.sourceUpdater_.buffered();
      if (we)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(ie, me = !1) {
    if (!ie)
      return null;
    const we = ha(ie);
    let Re = this.initSegments_[we];
    return me && !Re && ie.bytes && (this.initSegments_[we] = Re = {
      resolvedUri: ie.resolvedUri,
      byterange: ie.byterange,
      bytes: ie.bytes,
      tracks: ie.tracks,
      timescales: ie.timescales
    }), Re || ie;
  }
  /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */
  segmentKey(ie, me = !1) {
    if (!ie)
      return null;
    const we = gp(ie);
    let Re = this.keyCache_[we];
    this.cacheEncryptionKeys_ && me && !Re && ie.bytes && (this.keyCache_[we] = Re = {
      resolvedUri: ie.resolvedUri,
      bytes: ie.bytes
    });
    const je = {
      resolvedUri: (Re || ie).resolvedUri
    };
    return Re && (je.bytes = Re.bytes), je;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  }
  /**
   * load a playlist and start to fill the buffer
   */
  load() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */
  playlist(ie, me = {}) {
    if (!ie || this.playlist_ && this.playlist_.endList && ie.endList && this.playlist_.uri === ie.uri)
      return;
    const we = this.playlist_, Re = this.pendingSegment_;
    this.playlist_ = ie, this.xhrOptions_ = me, this.state === "INIT" && (ie.syncInfo = {
      mediaSequence: ie.mediaSequence,
      time: 0
    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(ie));
    let je = null;
    if (we && (we.id ? je = we.id : we.uri && (je = we.uri)), this.logger_(`playlist update [${je} => ${ie.id || ie.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(ie, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${Oo(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
      return this.init_();
    if (!we || we.uri !== ie.uri) {
      this.mediaIndex !== null && (!ie.endList && typeof ie.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
      return;
    }
    const Ue = ie.mediaSequence - we.mediaSequence;
    if (this.logger_(`live window shift [${Ue}]`), this.mediaIndex !== null)
      if (this.mediaIndex -= Ue, this.mediaIndex < 0)
        this.mediaIndex = null, this.partIndex = null;
      else {
        const qe = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!qe.parts || !qe.parts.length || !qe.parts[this.partIndex])) {
          const Ge = this.mediaIndex;
          this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = Ge;
        }
      }
    Re && (Re.mediaIndex -= Ue, Re.mediaIndex < 0 ? (Re.mediaIndex = null, Re.partIndex = null) : (Re.mediaIndex >= 0 && (Re.segment = ie.segments[Re.mediaIndex]), Re.partIndex >= 0 && Re.segment.parts && (Re.part = Re.segment.parts[Re.partIndex]))), this.syncController_.saveExpiredSegmentInfo(we, ie);
  }
  /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */
  pause() {
    this.checkBufferTimeout_ && (S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }
  /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */
  paused() {
    return this.checkBufferTimeout_ === null;
  }
  /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */
  resetEverything(ie) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, ie), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }
  /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */
  resetLoader() {
    this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
  }
  /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */
  resyncLoader() {
    this.transmuxer_ && Ro.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
    const ie = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
    this.sourceType_ === "hls" && !ie && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */
  remove(ie, me, we = () => {
  }, Re = !1) {
    if (me === 1 / 0 && (me = this.duration_()), me <= ie) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    let je = 1;
    const Ue = () => {
      je--, je === 0 && we();
    };
    (Re || !this.audioDisabled_) && (je++, this.sourceUpdater_.removeAudio(ie, me, Ue)), (Re || this.loaderType_ === "main") && (this.gopBuffer_ = Wb(this.gopBuffer_, ie, me, this.timeMapping_), je++, this.sourceUpdater_.removeVideo(ie, me, Ue));
    for (const qe in this.inbandTextTracks_)
      Cr(ie, me, this.inbandTextTracks_[qe]);
    Cr(ie, me, this.segmentMetadataTrack_), Ue();
  }
  /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */
  monitorBuffer_() {
    this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = S.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }
  /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */
  monitorBufferTick_() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = S.setTimeout(this.monitorBufferTick_.bind(this), Kb);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    if (this.sourceUpdater_.updating())
      return;
    const ie = this.chooseNextRequest_();
    if (!ie)
      return;
    const me = {
      segmentInfo: Ai({
        type: this.loaderType_,
        segment: ie
      })
    };
    this.trigger({
      type: "segmentselected",
      metadata: me
    }), typeof ie.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: ie.timeline
    })), this.loadSegment_(ie);
  }
  /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */
  isEndOfStream_(ie = this.mediaIndex, me = this.playlist_, we = this.partIndex) {
    if (!me || !this.mediaSource_)
      return !1;
    const Re = typeof ie == "number" && me.segments[ie], je = ie + 1 === me.segments.length, Ue = !Re || !Re.parts || we + 1 === Re.parts.length;
    return me.endList && this.mediaSource_.readyState === "open" && je && Ue;
  }
  /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */
  chooseNextRequest_() {
    const ie = this.buffered_(), me = Oo(ie) || 0, we = nl(ie, this.currentTime_()), Re = !this.hasPlayed_() && we >= 1, je = we >= this.goalBufferLength_(), Ue = this.playlist_.segments;
    if (!Ue.length || Re || je)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
    const qe = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (qe.isSyncRequest)
      qe.mediaIndex = Xb(this.currentTimeline_, Ue, me), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${qe.mediaIndex}`);
    else if (this.mediaIndex !== null) {
      const bt = Ue[this.mediaIndex], Tt = typeof this.partIndex == "number" ? this.partIndex : -1;
      qe.startOfSegment = bt.end ? bt.end : me, bt.parts && bt.parts[Tt + 1] ? (qe.mediaIndex = this.mediaIndex, qe.partIndex = Tt + 1) : qe.mediaIndex = this.mediaIndex + 1;
    } else {
      let bt, Tt, wt;
      const St = this.fetchAtBuffer_ ? me : this.currentTime_();
      if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${St}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${me}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
        const It = this.getSyncInfoFromMediaSequenceSync_(St);
        if (!It) {
          const Pt = "No sync info found while using media sequence sync";
          return this.error({
            message: Pt,
            metadata: {
              errorType: L.Error.StreamingFailedToSelectNextSegment,
              error: new Error(Pt)
            }
          }), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
        }
        this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${It.start} --> ${It.end})`), bt = It.segmentIndex, Tt = It.partIndex, wt = It.start;
      } else {
        this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
        const It = st.getMediaInfoForTime({
          exactManifestTimings: this.exactManifestTimings,
          playlist: this.playlist_,
          currentTime: St,
          startingPartIndex: this.syncPoint_.partIndex,
          startingSegmentIndex: this.syncPoint_.segmentIndex,
          startTime: this.syncPoint_.time
        });
        bt = It.segmentIndex, Tt = It.partIndex, wt = It.startTime;
      }
      qe.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${St}` : `currentTime ${St}`, qe.mediaIndex = bt, qe.startOfSegment = wt, qe.partIndex = Tt, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${qe.mediaIndex} `);
    }
    const Ge = Ue[qe.mediaIndex];
    let Xe = Ge && typeof qe.partIndex == "number" && Ge.parts && Ge.parts[qe.partIndex];
    if (!Ge || typeof qe.partIndex == "number" && !Xe)
      return null;
    typeof qe.partIndex != "number" && Ge.parts && (qe.partIndex = 0, Xe = Ge.parts[0]);
    const ot = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
    if (!we && Xe && !ot && !Xe.independent)
      if (qe.partIndex === 0) {
        const bt = Ue[qe.mediaIndex - 1], Tt = bt.parts && bt.parts.length && bt.parts[bt.parts.length - 1];
        Tt && Tt.independent && (qe.mediaIndex -= 1, qe.partIndex = bt.parts.length - 1, qe.independent = "previous segment");
      } else Ge.parts[qe.partIndex - 1].independent && (qe.partIndex -= 1, qe.independent = "previous part");
    const vt = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return qe.mediaIndex >= Ue.length - 1 && vt && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, qe.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(qe));
  }
  getSyncInfoFromMediaSequenceSync_(ie) {
    if (!this.mediaSequenceSync_)
      return null;
    const me = Math.max(ie, this.mediaSequenceSync_.start);
    ie !== me && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${ie} to ${me}`);
    const we = this.mediaSequenceSync_.getSyncInfoForTime(me);
    if (!we)
      return null;
    if (!we.isAppended)
      return we;
    const Re = this.mediaSequenceSync_.getSyncInfoForTime(we.end);
    return Re ? (Re.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), Re) : null;
  }
  generateSegmentInfo_(ie) {
    const {
      independent: me,
      playlist: we,
      mediaIndex: Re,
      startOfSegment: je,
      isSyncRequest: Ue,
      partIndex: qe,
      forceTimestampOffset: Ge,
      getMediaInfoForTime: Xe
    } = ie, ot = we.segments[Re], vt = typeof qe == "number" && ot.parts[qe], bt = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: vt && vt.resolvedUri || ot.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: Re,
      partIndex: vt ? qe : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: Ue,
      startOfSegment: je,
      // the segment's playlist
      playlist: we,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: ot.timeline,
      // The expected duration of the segment in seconds
      duration: vt && vt.duration || ot.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: ot,
      part: vt,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: Xe,
      independent: me
    }, Tt = typeof Ge < "u" ? Ge : this.isPendingTimestampOffset_;
    bt.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: ot.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: je,
      buffered: this.buffered_(),
      overrideCheck: Tt
    });
    const wt = Oo(this.sourceUpdater_.audioBuffered());
    return typeof wt == "number" && (bt.audioAppendStart = wt - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (bt.gopsToAlignWith = Hb(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), bt;
  }
  // get the timestampoffset for a segment,
  // added so that vtt segment loader can override and prevent
  // adding timestamp offsets.
  timestampOffsetForSegment_(ie) {
    return Jb(ie);
  }
  /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */
  earlyAbortWhenNeeded_(ie) {
    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH || Date.now() - (ie.firstBytesReceivedAt || Date.now()) < 1e3)
      return;
    const me = this.currentTime_(), we = ie.bandwidth, Re = this.pendingSegment_.duration, je = st.estimateSegmentRequestTime(Re, we, this.playlist_, ie.bytesReceived), Ue = vv(this.buffered_(), me, this.vhs_.tech_.playbackRate()) - 1;
    if (je <= Ue)
      return;
    const qe = Lb({
      main: this.vhs_.playlists.main,
      currentTime: me,
      bandwidth: we,
      duration: this.duration_(),
      segmentDuration: Re,
      timeUntilRebuffer: Ue,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!qe)
      return;
    const Ge = je - Ue - qe.rebufferingImpact;
    let Xe = 0.5;
    Ue <= Bt && (Xe = 1), !(!qe.playlist || qe.playlist.uri === this.playlist_.uri || Ge < Xe) && (this.bandwidth = qe.playlist.attributes.BANDWIDTH * Me.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
  }
  handleAbort_(ie) {
    this.logger_(`Aborting ${ts(ie)}`), this.mediaRequestsAborted += 1;
  }
  /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */
  handleProgress_(ie, me) {
    this.earlyAbortWhenNeeded_(me.stats), !this.checkForAbort_(me.requestId) && this.trigger("progress");
  }
  handleTrackInfo_(ie, me) {
    const {
      hasAudio: we,
      hasVideo: Re
    } = me, je = {
      segmentInfo: Ai({
        type: this.loaderType_,
        segment: ie
      }),
      trackInfo: {
        hasAudio: we,
        hasVideo: Re
      }
    };
    this.trigger({
      type: "segmenttransmuxingtrackinfoavailable",
      metadata: je
    }), this.earlyAbortWhenNeeded_(ie.stats), !this.checkForAbort_(ie.requestId) && (this.checkForIllegalMediaSwitch(me) || (me = me || {}, Gb(this.currentMediaInfo_, me) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = me, this.currentMediaInfo_ = me, this.logger_("trackinfo update", me), this.trigger("trackinfo")), !this.checkForAbort_(ie.requestId) && (this.pendingSegment_.trackInfo = me, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ci(this))));
  }
  handleTimingInfo_(ie, me, we, Re) {
    if (this.earlyAbortWhenNeeded_(ie.stats), this.checkForAbort_(ie.requestId))
      return;
    const je = this.pendingSegment_, Ue = Td(me);
    je[Ue] = je[Ue] || {}, je[Ue][we] = Re, this.logger_(`timinginfo: ${me} - ${we} - ${Re}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : ci(this);
  }
  handleCaptions_(ie, me) {
    if (this.earlyAbortWhenNeeded_(ie.stats), this.checkForAbort_(ie.requestId))
      return;
    if (me.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, ie, me));
      return;
    }
    const we = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), Re = {};
    me.forEach((je) => {
      Re[je.stream] = Re[je.stream] || {
        // Infinity, as any other value will be less than this
        startTime: 1 / 0,
        captions: [],
        // 0 as an other value will be more than this
        endTime: 0
      };
      const Ue = Re[je.stream];
      Ue.startTime = Math.min(Ue.startTime, je.startTime + we), Ue.endTime = Math.max(Ue.endTime, je.endTime + we), Ue.captions.push(je);
    }), Object.keys(Re).forEach((je) => {
      const {
        startTime: Ue,
        endTime: qe,
        captions: Ge
      } = Re[je], Xe = this.inbandTextTracks_;
      this.logger_(`adding cues from ${Ue} -> ${qe} for ${je}`), Nb(Xe, this.vhs_.tech_, je), Cr(Ue, qe, Xe[je]), Bb({
        captionArray: Ge,
        inbandTextTracks: Xe,
        timestampOffset: we
      });
    }), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  handleId3_(ie, me, we) {
    if (this.earlyAbortWhenNeeded_(ie.stats), !this.checkForAbort_(ie.requestId)) {
      if (!this.pendingSegment_.hasAppendedData_) {
        this.metadataQueue_.id3.push(this.handleId3_.bind(this, ie, me, we));
        return;
      }
      this.addMetadataToTextTrack(we, me, this.duration_());
    }
  }
  processMetadataQueue_() {
    this.metadataQueue_.id3.forEach((ie) => ie()), this.metadataQueue_.caption.forEach((ie) => ie()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }
  processCallQueue_() {
    const ie = this.callQueue_;
    this.callQueue_ = [], ie.forEach((me) => me());
  }
  processLoadQueue_() {
    const ie = this.loadQueue_;
    this.loadQueue_ = [], ie.forEach((me) => me());
  }
  /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */
  hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio")
      return !0;
    const ie = this.pendingSegment_;
    return ie ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !lu({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: ie.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }
  getCurrentMediaInfo_(ie = this.pendingSegment_) {
    return ie && ie.trackInfo || this.currentMediaInfo_;
  }
  getMediaInfo_(ie = this.pendingSegment_) {
    return this.getCurrentMediaInfo_(ie) || this.startingMediaInfo_;
  }
  getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }
  hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    const ie = this.pendingSegment_, me = this.getCurrentMediaInfo_();
    if (!ie || !me)
      return !1;
    const {
      hasAudio: we,
      hasVideo: Re,
      isMuxed: je
    } = me;
    return !(Re && !ie.videoTimingInfo || we && !this.audioDisabled_ && !je && !ie.audioTimingInfo || lu({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: ie.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }
  handleData_(ie, me) {
    if (this.earlyAbortWhenNeeded_(ie.stats), this.checkForAbort_(ie.requestId))
      return;
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      ci(this), this.callQueue_.push(this.handleData_.bind(this, ie, me));
      return;
    }
    const we = this.pendingSegment_;
    if (this.setTimeMapping_(we.timeline), this.updateMediaSecondsLoaded_(we.part || we.segment), this.mediaSource_.readyState !== "closed") {
      if (ie.map && (ie.map = this.initSegmentForMap(ie.map, !0), we.segment.map = ie.map), ie.key && this.segmentKey(ie.key, !0), we.isFmp4 = ie.isFmp4, we.timingInfo = we.timingInfo || {}, we.isFmp4)
        this.trigger("fmp4"), we.timingInfo.start = we[Td(me.type)].start;
      else {
        const Re = this.getCurrentMediaInfo_(), je = this.loaderType_ === "main" && Re && Re.hasVideo;
        let Ue;
        je && (Ue = we.videoTimingInfo.start), we.timingInfo.start = this.trueSegmentStart_({
          currentStart: we.timingInfo.start,
          playlist: we.playlist,
          mediaIndex: we.mediaIndex,
          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
          useVideoTimingInfo: je,
          firstVideoFrameTimeForData: Ue,
          videoTimingInfo: we.videoTimingInfo,
          audioTimingInfo: we.audioTimingInfo
        });
      }
      if (this.updateAppendInitSegmentStatus(we, me.type), this.updateSourceBufferTimestampOffset_(we), we.isSyncRequest) {
        this.updateTimingInfoEnd_(we), this.syncController_.saveSegmentTimingInfo({
          segmentInfo: we,
          shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const Re = this.chooseNextRequest_();
        if (Re.mediaIndex !== we.mediaIndex || Re.partIndex !== we.partIndex) {
          this.logger_("sync segment was incorrect, not appending");
          return;
        }
        this.logger_("sync segment was correct, appending");
      }
      we.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(we, me);
    }
  }
  updateAppendInitSegmentStatus(ie, me) {
    this.loaderType_ === "main" && typeof ie.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !ie.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[me] !== ie.playlist && (this.appendInitSegment_[me] = !0);
  }
  getInitSegmentAndUpdateState_({
    type: ie,
    initSegment: me,
    map: we,
    playlist: Re
  }) {
    if (we) {
      const je = ha(we);
      if (this.activeInitSegmentId_ === je)
        return null;
      me = this.initSegmentForMap(we, !0).bytes, this.activeInitSegmentId_ = je;
    }
    return me && this.appendInitSegment_[ie] ? (this.playlistOfLastInitSegment_[ie] = Re, this.appendInitSegment_[ie] = !1, this.activeInitSegmentId_ = null, me) : null;
  }
  handleQuotaExceededError_({
    segmentInfo: ie,
    type: me,
    bytes: we
  }, Re) {
    const je = this.sourceUpdater_.audioBuffered(), Ue = this.sourceUpdater_.videoBuffered();
    je.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + wi(je).join(", ")), Ue.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + wi(Ue).join(", "));
    const qe = je.length ? je.start(0) : 0, Ge = je.length ? je.end(je.length - 1) : 0, Xe = Ue.length ? Ue.start(0) : 0, ot = Ue.length ? Ue.end(Ue.length - 1) : 0;
    if (Ge - qe <= Tr && ot - Xe <= Tr) {
      this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${we.byteLength}, audio buffer: ${wi(je).join(", ")}, video buffer: ${wi(Ue).join(", ")}, `), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: ie,
      type: me,
      bytes: we
    }));
    const vt = this.currentTime_() - Tr;
    this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${vt}`), this.remove(0, vt, () => {
      this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${Tr}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = S.setTimeout(() => {
        this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
      }, Tr * 1e3);
    }, !0);
  }
  handleAppendError_({
    segmentInfo: ie,
    type: me,
    bytes: we
  }, Re) {
    if (Re) {
      if (Re.code === up) {
        this.handleQuotaExceededError_({
          segmentInfo: ie,
          type: me,
          bytes: we
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", Re), this.error({
        message: `${me} append of ${we.length}b failed for segment #${ie.mediaIndex} in playlist ${ie.playlist.id}`,
        metadata: {
          errorType: L.Error.StreamingFailedToAppendSegment
        }
      }), this.trigger("appenderror");
    }
  }
  appendToSourceBuffer_({
    segmentInfo: ie,
    type: me,
    initSegment: we,
    data: Re,
    bytes: je
  }) {
    if (!je) {
      const qe = [Re];
      let Ge = Re.byteLength;
      we && (qe.unshift(we), Ge += we.byteLength), je = Mb({
        bytes: Ge,
        segments: qe
      });
    }
    const Ue = {
      segmentInfo: Ai({
        type: this.loaderType_,
        segment: ie
      })
    };
    this.trigger({
      type: "segmentappendstart",
      metadata: Ue
    }), this.sourceUpdater_.appendBuffer({
      segmentInfo: ie,
      type: me,
      bytes: je
    }, this.handleAppendError_.bind(this, {
      segmentInfo: ie,
      type: me,
      bytes: je
    }));
  }
  handleSegmentTimingInfo_(ie, me, we) {
    if (!this.pendingSegment_ || me !== this.pendingSegment_.requestId)
      return;
    const Re = this.pendingSegment_.segment, je = `${ie}TimingInfo`;
    Re[je] || (Re[je] = {}), Re[je].transmuxerPrependedSeconds = we.prependedContentDuration || 0, Re[je].transmuxedPresentationStart = we.start.presentation, Re[je].transmuxedDecodeStart = we.start.decode, Re[je].transmuxedPresentationEnd = we.end.presentation, Re[je].transmuxedDecodeEnd = we.end.decode, Re[je].baseMediaDecodeTime = we.baseMediaDecodeTime;
  }
  appendData_(ie, me) {
    const {
      type: we,
      data: Re
    } = me;
    if (!Re || !Re.byteLength || we === "audio" && this.audioDisabled_)
      return;
    const je = this.getInitSegmentAndUpdateState_({
      type: we,
      initSegment: me.initSegment,
      playlist: ie.playlist,
      map: ie.isFmp4 ? ie.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo: ie,
      type: we,
      initSegment: je,
      data: Re
    });
  }
  /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */
  loadSegment_(ie) {
    if (this.state = "WAITING", this.pendingSegment_ = ie, this.trimBackBuffer_(ie), typeof ie.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      ci(this), this.loadQueue_.push(() => {
        const me = Oe$1({}, ie, {
          forceTimestampOffset: !0
        });
        Oe$1(ie, this.generateSegmentInfo_(me)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(ie);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(ie);
  }
  updateTransmuxerAndRequestSegment_(ie) {
    this.shouldUpdateTransmuxerTimestampOffset_(ie.timestampOffset) && (this.gopBuffer_.length = 0, ie.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: ie.timestampOffset
    }));
    const me = this.createSimplifiedSegmentObj_(ie), we = this.isEndOfStream_(ie.mediaIndex, ie.playlist, ie.partIndex), Re = this.mediaIndex !== null, je = ie.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    ie.timeline > 0, Ue = we || Re && je;
    this.logger_(`Requesting
${Lp(ie.uri)}
${ts(ie)}`), me.map && !me.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), ie.abortRequests = Ib({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: me,
      abortFn: this.handleAbort_.bind(this, ie),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", ie.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", ie.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: Ue,
      endedTimelineFn: () => {
        this.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: ({
        message: qe,
        level: Ge,
        stream: Xe
      }) => {
        this.logger_(`${ts(ie)} logged from transmuxer stream ${Xe} as a ${Ge}: ${qe}`);
      },
      triggerSegmentEventFn: ({
        type: qe,
        segment: Ge,
        keyInfo: Xe,
        trackInfo: ot,
        timingInfo: vt
      }) => {
        const bt = {
          segmentInfo: Ai({
            segment: Ge
          })
        };
        Xe && (bt.keyInfo = Xe), ot && (bt.trackInfo = ot), vt && (bt.timingInfo = vt), this.trigger({
          type: qe,
          metadata: bt
        });
      }
    });
  }
  /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */
  trimBackBuffer_(ie) {
    const me = Qb(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    me > 0 && this.remove(0, me);
  }
  /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */
  createSimplifiedSegmentObj_(ie) {
    const me = ie.segment, we = ie.part, Re = ie.segment.key || ie.segment.map && ie.segment.map.key, je = ie.segment.map && !ie.segment.map.bytes, Ue = {
      resolvedUri: we ? we.resolvedUri : me.resolvedUri,
      byterange: we ? we.byterange : me.byterange,
      requestId: ie.requestId,
      transmuxer: ie.transmuxer,
      audioAppendStart: ie.audioAppendStart,
      gopsToAlignWith: ie.gopsToAlignWith,
      part: ie.part,
      type: this.loaderType_,
      start: ie.startOfSegment,
      duration: ie.duration,
      isEncrypted: Re,
      isMediaInitialization: je
    }, qe = ie.playlist.segments[ie.mediaIndex - 1];
    if (qe && qe.timeline === me.timeline && (qe.videoTimingInfo ? Ue.baseStartTime = qe.videoTimingInfo.transmuxedDecodeEnd : qe.audioTimingInfo && (Ue.baseStartTime = qe.audioTimingInfo.transmuxedDecodeEnd)), me.key) {
      const Ge = me.key.iv || new Uint32Array([0, 0, 0, ie.mediaIndex + ie.playlist.mediaSequence]);
      Ue.key = this.segmentKey(me.key), Ue.key.iv = Ge;
    }
    return me.map && (Ue.map = this.initSegmentForMap(me.map)), Ue;
  }
  saveTransferStats_(ie) {
    this.mediaRequests += 1, ie && (this.mediaBytesTransferred += ie.bytesReceived, this.mediaTransferDuration += ie.roundTripTime);
  }
  saveBandwidthRelatedStats_(ie, me) {
    if (this.pendingSegment_.byteLength = me.bytesReceived, ie < Bn) {
      this.logger_(`Ignoring segment's bandwidth because its duration of ${ie} is less than the min to record ${Bn}`);
      return;
    }
    const we = {
      bandwidthInfo: {
        from: this.bandwidth,
        to: me.bandwidth
      }
    };
    this.trigger({
      type: "bandwidthupdated",
      metadata: we
    }), this.bandwidth = me.bandwidth, this.roundTrip = me.roundTripTime;
  }
  handleTimeout_() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }
  /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */
  segmentRequestFinished_(ie, me, we) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, ie, me, we));
      return;
    }
    if (this.saveTransferStats_(me.stats), !this.pendingSegment_ || me.requestId !== this.pendingSegment_.requestId)
      return;
    if (ie) {
      if (this.pendingSegment_ = null, this.state = "READY", ie.code === Ut.ABORTED)
        return;
      if (this.pause(), ie.code === Ut.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1, this.error(ie), this.trigger("error");
      return;
    }
    const Re = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(Re.duration, me.stats), Re.endOfAllRequests = me.endOfAllRequests, we.gopInfo && (this.gopBuffer_ = zb(this.gopBuffer_, we.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(Re);
  }
  setTimeMapping_(ie) {
    const me = this.syncController_.mappingForTimeline(ie);
    me !== null && (this.timeMapping_ = me);
  }
  updateMediaSecondsLoaded_(ie) {
    typeof ie.start == "number" && typeof ie.end == "number" ? this.mediaSecondsLoaded += ie.end - ie.start : this.mediaSecondsLoaded += ie.duration;
  }
  shouldUpdateTransmuxerTimestampOffset_(ie) {
    return ie === null ? !1 : this.loaderType_ === "main" && ie !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && ie !== this.sourceUpdater_.audioTimestampOffset();
  }
  trueSegmentStart_({
    currentStart: ie,
    playlist: me,
    mediaIndex: we,
    firstVideoFrameTimeForData: Re,
    currentVideoTimestampOffset: je,
    useVideoTimingInfo: Ue,
    videoTimingInfo: qe,
    audioTimingInfo: Ge
  }) {
    if (typeof ie < "u")
      return ie;
    if (!Ue)
      return Ge.start;
    const Xe = me.segments[we - 1];
    return we === 0 || !Xe || typeof Xe.start > "u" || Xe.end !== Re + je ? Re : qe.start;
  }
  waitForAppendsToComplete_(ie) {
    const me = this.getCurrentMediaInfo_(ie);
    if (!me) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        playlistExclusionDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    const {
      hasAudio: we,
      hasVideo: Re,
      isMuxed: je
    } = me, Ue = this.loaderType_ === "main" && Re, qe = !this.audioDisabled_ && we && !je;
    if (ie.waitingOnAppends = 0, !ie.hasAppendedData_) {
      !ie.timingInfo && typeof ie.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), ie.timingInfo = {
        start: 0
      }, ie.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(ie), this.processMetadataQueue_()), this.checkAppendsDone_(ie);
      return;
    }
    Ue && ie.waitingOnAppends++, qe && ie.waitingOnAppends++, Ue && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, ie)), qe && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, ie));
  }
  checkAppendsDone_(ie) {
    this.checkForAbort_(ie.requestId) || (ie.waitingOnAppends--, ie.waitingOnAppends === 0 && this.handleAppendsDone_());
  }
  checkForIllegalMediaSwitch(ie) {
    const me = Yb(this.loaderType_, this.getCurrentMediaInfo_(), ie);
    return me ? (this.error({
      message: me,
      playlistExclusionDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }
  updateSourceBufferTimestampOffset_(ie) {
    if (ie.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof ie.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    ie.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")
      return;
    let me = !1;
    ie.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: ie.segment.videoTimingInfo,
      audioTimingInfo: ie.segment.audioTimingInfo,
      timingInfo: ie.timingInfo
    }), ie.changedTimestampOffset = !0, ie.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(ie.timestampOffset), me = !0), ie.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(ie.timestampOffset), me = !0), me && this.trigger("timestampoffset");
  }
  getSegmentStartTimeForTimestampOffsetCalculation_({
    videoTimingInfo: ie,
    audioTimingInfo: me,
    timingInfo: we
  }) {
    return this.useDtsForTimestampOffset_ ? ie && typeof ie.transmuxedDecodeStart == "number" ? ie.transmuxedDecodeStart : me && typeof me.transmuxedDecodeStart == "number" ? me.transmuxedDecodeStart : we.start : we.start;
  }
  updateTimingInfoEnd_(ie) {
    ie.timingInfo = ie.timingInfo || {};
    const me = this.getMediaInfo_(), we = this.loaderType_ === "main" && me && me.hasVideo && ie.videoTimingInfo ? ie.videoTimingInfo : ie.audioTimingInfo;
    we && (ie.timingInfo.end = typeof we.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      we.end
    ) : we.start + ie.duration);
  }
  /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */
  handleAppendsDone_() {
    if (this.pendingSegment_) {
      const qe = {
        segmentInfo: Ai({
          type: this.loaderType_,
          segment: this.pendingSegment_
        })
      };
      this.trigger({
        type: "appendsdone",
        metadata: qe
      });
    }
    if (!this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    const ie = this.pendingSegment_;
    ie.part && ie.part.syncInfo ? ie.part.syncInfo.markAppended() : ie.segment.syncInfo && ie.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(ie), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: ie,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    const me = i2(ie, this.sourceType_);
    if (me && (me.severity === "warn" ? L.log.warn(me.message) : this.logger_(me.message)), this.recordThroughput_(ie), this.pendingSegment_ = null, this.state = "READY", ie.isSyncRequest && (this.trigger("syncinfoupdate"), !ie.hasAppendedData_)) {
      this.logger_(`Throwing away un-appended sync request ${ts(ie)}`);
      return;
    }
    this.logger_(`Appended ${ts(ie)}`), this.addSegmentMetadataCue_(ie), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== ie.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: ie.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: ie.timeline
    })), this.currentTimeline_ = ie.timeline, this.trigger("syncinfoupdate");
    const we = ie.segment, Re = ie.part, je = we.end && this.currentTime_() - we.end > ie.playlist.targetDuration * 3, Ue = Re && Re.end && this.currentTime_() - Re.end > ie.playlist.partTargetDuration * 3;
    if (je || Ue) {
      this.logger_(`bad ${je ? "segment" : "part"} ${ts(ie)}`), this.resetEverything();
      return;
    }
    this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = ie.mediaIndex, this.partIndex = ie.partIndex, this.isEndOfStream_(ie.mediaIndex, ie.playlist, ie.partIndex) && this.endOfStream(), this.trigger("appended"), ie.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }
  /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */
  recordThroughput_(ie) {
    if (ie.duration < Bn) {
      this.logger_(`Ignoring segment's throughput because its duration of ${ie.duration} is less than the min to record ${Bn}`);
      return;
    }
    const me = this.throughput.rate, we = Date.now() - ie.endOfAllRequests + 1, Re = Math.floor(ie.byteLength / we * 8 * 1e3);
    this.throughput.rate += (Re - me) / ++this.throughput.count;
  }
  /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */
  addSegmentMetadataCue_(ie) {
    if (!this.segmentMetadataTrack_)
      return;
    const me = ie.segment, we = me.start, Re = me.end;
    if (!yd(we) || !yd(Re))
      return;
    Cr(we, Re, this.segmentMetadataTrack_);
    const je = S.WebKitDataCue || S.VTTCue, Ue = {
      custom: me.custom,
      dateTimeObject: me.dateTimeObject,
      dateTimeString: me.dateTimeString,
      programDateTime: me.programDateTime,
      bandwidth: ie.playlist.attributes.BANDWIDTH,
      resolution: ie.playlist.attributes.RESOLUTION,
      codecs: ie.playlist.attributes.CODECS,
      byteLength: ie.byteLength,
      uri: ie.uri,
      timeline: ie.timeline,
      playlist: ie.playlist.id,
      start: we,
      end: Re
    }, qe = JSON.stringify(Ue), Ge = new je(we, Re, qe);
    Ge.value = Ue, this.segmentMetadataTrack_.addCue(Ge);
  }
}
function Xt() {
}
const Rp = function(ce) {
  return typeof ce != "string" ? ce : ce.replace(/./, (ie) => ie.toUpperCase());
}, s2 = ["video", "audio"], du = (ce, ie) => {
  const me = ie[`${ce}Buffer`];
  return me && me.updating || ie.queuePending[ce];
}, r2 = (ce, ie) => {
  for (let me = 0; me < ie.length; me++) {
    const we = ie[me];
    if (we.type === "mediaSource")
      return null;
    if (we.type === ce)
      return me;
  }
  return null;
}, ps = (ce, ie) => {
  if (ie.queue.length === 0)
    return;
  let me = 0, we = ie.queue[me];
  if (we.type === "mediaSource") {
    !ie.updating() && ie.mediaSource.readyState !== "closed" && (ie.queue.shift(), we.action(ie), we.doneFn && we.doneFn(), ps("audio", ie), ps("video", ie));
    return;
  }
  if (ce !== "mediaSource" && !(!ie.ready() || ie.mediaSource.readyState === "closed" || du(ce, ie))) {
    if (we.type !== ce) {
      if (me = r2(ce, ie.queue), me === null)
        return;
      we = ie.queue[me];
    }
    if (ie.queue.splice(me, 1), ie.queuePending[ce] = we, we.action(ce, ie), !we.doneFn) {
      ie.queuePending[ce] = null, ps(ce, ie);
      return;
    }
  }
}, Mp = (ce, ie) => {
  const me = ie[`${ce}Buffer`], we = Rp(ce);
  me && (me.removeEventListener("updateend", ie[`on${we}UpdateEnd_`]), me.removeEventListener("error", ie[`on${we}Error_`]), ie.codecs[ce] = null, ie[`${ce}Buffer`] = null);
}, Mt = (ce, ie) => ce && ie && Array.prototype.indexOf.call(ce.sourceBuffers, ie) !== -1, ut = {
  appendBuffer: (ce, ie, me) => (we, Re) => {
    const je = Re[`${we}Buffer`];
    if (Mt(Re.mediaSource, je)) {
      Re.logger_(`Appending segment ${ie.mediaIndex}'s ${ce.length} bytes to ${we}Buffer`);
      try {
        je.appendBuffer(ce);
      } catch (Ue) {
        Re.logger_(`Error with code ${Ue.code} ` + (Ue.code === up ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${ie.mediaIndex} to ${we}Buffer`), Re.queuePending[we] = null, me(Ue);
      }
    }
  },
  remove: (ce, ie) => (me, we) => {
    const Re = we[`${me}Buffer`];
    if (Mt(we.mediaSource, Re)) {
      we.logger_(`Removing ${ce} to ${ie} from ${me}Buffer`);
      try {
        Re.remove(ce, ie);
      } catch {
        we.logger_(`Remove ${ce} to ${ie} from ${me}Buffer failed`);
      }
    }
  },
  timestampOffset: (ce) => (ie, me) => {
    const we = me[`${ie}Buffer`];
    Mt(me.mediaSource, we) && (me.logger_(`Setting ${ie}timestampOffset to ${ce}`), we.timestampOffset = ce);
  },
  callback: (ce) => (ie, me) => {
    ce();
  },
  endOfStream: (ce) => (ie) => {
    if (ie.mediaSource.readyState === "open") {
      ie.logger_(`Calling mediaSource endOfStream(${ce || ""})`);
      try {
        ie.mediaSource.endOfStream(ce);
      } catch (me) {
        L.log.warn("Failed to call media source endOfStream", me);
      }
    }
  },
  duration: (ce) => (ie) => {
    ie.logger_(`Setting mediaSource duration to ${ce}`);
    try {
      ie.mediaSource.duration = ce;
    } catch (me) {
      L.log.warn("Failed to set media source duration", me);
    }
  },
  abort: () => (ce, ie) => {
    if (ie.mediaSource.readyState !== "open")
      return;
    const me = ie[`${ce}Buffer`];
    if (Mt(ie.mediaSource, me)) {
      ie.logger_(`calling abort on ${ce}Buffer`);
      try {
        me.abort();
      } catch (we) {
        L.log.warn(`Failed to abort on ${ce}Buffer`, we);
      }
    }
  },
  addSourceBuffer: (ce, ie) => (me) => {
    const we = Rp(ce), Re = ms(ie);
    me.logger_(`Adding ${ce}Buffer with codec ${ie} to mediaSource`);
    const je = me.mediaSource.addSourceBuffer(Re);
    je.addEventListener("updateend", me[`on${we}UpdateEnd_`]), je.addEventListener("error", me[`on${we}Error_`]), me.codecs[ce] = ie, me[`${ce}Buffer`] = je;
  },
  removeSourceBuffer: (ce) => (ie) => {
    const me = ie[`${ce}Buffer`];
    if (Mp(ce, ie), !!Mt(ie.mediaSource, me)) {
      ie.logger_(`Removing ${ce}Buffer with codec ${ie.codecs[ce]} from mediaSource`);
      try {
        ie.mediaSource.removeSourceBuffer(me);
      } catch (we) {
        L.log.warn(`Failed to removeSourceBuffer ${ce}Buffer`, we);
      }
    }
  },
  changeType: (ce) => (ie, me) => {
    const we = me[`${ie}Buffer`], Re = ms(ce);
    if (!Mt(me.mediaSource, we))
      return;
    const je = ce.substring(0, ce.indexOf(".")), Ue = me.codecs[ie];
    if (Ue.substring(0, Ue.indexOf(".")) === je)
      return;
    const qe = {
      codecsChangeInfo: {
        from: Ue,
        to: ce
      }
    };
    me.trigger({
      type: "codecschange",
      metadata: qe
    }), me.logger_(`changing ${ie}Buffer codec from ${Ue} to ${ce}`);
    try {
      we.changeType(Re), me.codecs[ie] = ce;
    } catch (Ge) {
      qe.errorType = L.Error.StreamingCodecsChangeError, qe.error = Ge, Ge.metadata = qe, me.error_ = Ge, me.trigger("error"), L.log.warn(`Failed to changeType on ${ie}Buffer`, Ge);
    }
  }
}, lt = ({
  type: ce,
  sourceUpdater: ie,
  action: me,
  doneFn: we,
  name: Re
}) => {
  ie.queue.push({
    type: ce,
    action: me,
    doneFn: we,
    name: Re
  }), ps(ce, ie);
}, bd = (ce, ie) => (me) => {
  const we = ie[`${ce}Buffered`](), Re = _v(we);
  if (ie.logger_(`received "updateend" event for ${ce} Source Buffer: `, Re), ie.queuePending[ce]) {
    const je = ie.queuePending[ce].doneFn;
    ie.queuePending[ce] = null, je && je(ie[`${ce}Error_`]);
  }
  ps(ce, ie);
};
class Np extends L.EventTarget {
  constructor(ie) {
    super(), this.mediaSource = ie, this.sourceopenListener_ = () => ps("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = yt("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
      audio: null,
      video: null
    }, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = bd("video", this), this.onAudioUpdateEnd_ = bd("audio", this), this.onVideoError_ = (me) => {
      this.videoError_ = me;
    }, this.onAudioError_ = (me) => {
      this.audioError_ = me;
    }, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
  }
  initializedEme() {
    this.initializedEme_ = !0, this.triggerReady();
  }
  hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  }
  hasInitializedAnyEme() {
    return this.initializedEme_;
  }
  ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }
  createSourceBuffers(ie) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(ie), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }
  triggerReady() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }
  /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */
  addSourceBuffer(ie, me) {
    lt({
      type: "mediaSource",
      sourceUpdater: this,
      action: ut.addSourceBuffer(ie, me),
      name: "addSourceBuffer"
    });
  }
  /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */
  abort(ie) {
    lt({
      type: ie,
      sourceUpdater: this,
      action: ut.abort(ie),
      name: "abort"
    });
  }
  /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */
  removeSourceBuffer(ie) {
    if (!this.canRemoveSourceBuffer()) {
      L.log.error("removeSourceBuffer is not supported!");
      return;
    }
    lt({
      type: "mediaSource",
      sourceUpdater: this,
      action: ut.removeSourceBuffer(ie),
      name: "removeSourceBuffer"
    });
  }
  /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */
  canRemoveSourceBuffer() {
    return !L.browser.IS_FIREFOX && S.MediaSource && S.MediaSource.prototype && typeof S.MediaSource.prototype.removeSourceBuffer == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  static canChangeType() {
    return S.SourceBuffer && S.SourceBuffer.prototype && typeof S.SourceBuffer.prototype.changeType == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  canChangeType() {
    return this.constructor.canChangeType();
  }
  /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */
  changeType(ie, me) {
    if (!this.canChangeType()) {
      L.log.error("changeType is not supported!");
      return;
    }
    lt({
      type: ie,
      sourceUpdater: this,
      action: ut.changeType(me),
      name: "changeType"
    });
  }
  /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */
  addOrChangeSourceBuffers(ie) {
    if (!ie || typeof ie != "object" || Object.keys(ie).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(ie).forEach((me) => {
      const we = ie[me];
      if (!this.hasCreatedSourceBuffers())
        return this.addSourceBuffer(me, we);
      this.canChangeType() && this.changeType(me, we);
    });
  }
  /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */
  appendBuffer(ie, me) {
    const {
      segmentInfo: we,
      type: Re,
      bytes: je
    } = ie;
    if (this.processedAppend_ = !0, Re === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([ie, me]), this.logger_(`delayed audio append of ${je.length} until video append`);
      return;
    }
    const Ue = me;
    if (lt({
      type: Re,
      sourceUpdater: this,
      action: ut.appendBuffer(je, we || {
        mediaIndex: -1
      }, Ue),
      doneFn: me,
      name: "appendBuffer"
    }), Re === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      const qe = this.delayedAudioAppendQueue_.slice();
      this.logger_(`queuing delayed audio ${qe.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, qe.forEach((Ge) => {
        this.appendBuffer.apply(this, Ge);
      });
    }
  }
  /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */
  audioBuffered() {
    return Mt(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : Be();
  }
  /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */
  videoBuffered() {
    return Mt(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : Be();
  }
  /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */
  buffered() {
    const ie = Mt(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, me = Mt(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return me && !ie ? this.audioBuffered() : ie && !me ? this.videoBuffered() : Tv(this.audioBuffered(), this.videoBuffered());
  }
  /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */
  setDuration(ie, me = Xt) {
    lt({
      type: "mediaSource",
      sourceUpdater: this,
      action: ut.duration(ie),
      name: "duration",
      doneFn: me
    });
  }
  /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */
  endOfStream(ie = null, me = Xt) {
    typeof ie != "string" && (ie = void 0), lt({
      type: "mediaSource",
      sourceUpdater: this,
      action: ut.endOfStream(ie),
      name: "endOfStream",
      doneFn: me
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeAudio(ie, me, we = Xt) {
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      we();
      return;
    }
    lt({
      type: "audio",
      sourceUpdater: this,
      action: ut.remove(ie, me),
      doneFn: we,
      name: "remove"
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeVideo(ie, me, we = Xt) {
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      we();
      return;
    }
    lt({
      type: "video",
      sourceUpdater: this,
      action: ut.remove(ie, me),
      doneFn: we,
      name: "remove"
    });
  }
  /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */
  updating() {
    return !!(du("audio", this) || du("video", this));
  }
  /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  audioTimestampOffset(ie) {
    return typeof ie < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== ie && (lt({
      type: "audio",
      sourceUpdater: this,
      action: ut.timestampOffset(ie),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = ie), this.audioTimestampOffset_;
  }
  /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  videoTimestampOffset(ie) {
    return typeof ie < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset_ !== ie && (lt({
      type: "video",
      sourceUpdater: this,
      action: ut.timestampOffset(ie),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = ie), this.videoTimestampOffset_;
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  audioQueueCallback(ie) {
    this.audioBuffer && lt({
      type: "audio",
      sourceUpdater: this,
      action: ut.callback(ie),
      name: "callback"
    });
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  videoQueueCallback(ie) {
    this.videoBuffer && lt({
      type: "video",
      sourceUpdater: this,
      action: ut.callback(ie),
      name: "callback"
    });
  }
  /**
   * dispose of the source updater and the underlying sourceBuffer
   */
  dispose() {
    this.trigger("dispose"), s2.forEach((ie) => {
      this.abort(ie), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(ie) : this[`${ie}QueueCallback`](() => Mp(ie, this));
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }
}
const xd = (ce) => decodeURIComponent(escape(String.fromCharCode.apply(null, ce))), n2 = (ce) => {
  const ie = new Uint8Array(ce);
  return Array.from(ie).map((me) => me.toString(16).padStart(2, "0")).join("");
}, Sd = new Uint8Array(`

`.split("").map((ce) => ce.charCodeAt(0)));
class a2 extends Error {
  constructor() {
    super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
  }
}
class o2 extends cu {
  constructor(ie, me = {}) {
    super(ie, me), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = ie.featuresNativeTextTracks, this.loadVttJs = ie.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return Be();
    const ie = this.subtitlesTrack_.cues, me = ie[0].startTime, we = ie[ie.length - 1].startTime;
    return Be([[me, we]]);
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(ie, me = !1) {
    if (!ie)
      return null;
    const we = ha(ie);
    let Re = this.initSegments_[we];
    if (me && !Re && ie.bytes) {
      const je = Sd.byteLength + ie.bytes.byteLength, Ue = new Uint8Array(je);
      Ue.set(ie.bytes), Ue.set(Sd, ie.bytes.byteLength), this.initSegments_[we] = Re = {
        resolvedUri: ie.resolvedUri,
        byterange: ie.byterange,
        bytes: Ue
      };
    }
    return Re || ie;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */
  track(ie) {
    return typeof ie > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = ie, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */
  remove(ie, me) {
    Cr(ie, me, this.subtitlesTrack_);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    const ie = this.chooseNextRequest_();
    if (ie) {
      if (this.syncController_.timestampOffsetForTimeline(ie.timeline) === null) {
        const me = () => {
          this.state = "READY", this.paused() || this.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", me), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(ie);
    }
  }
  // never set a timestamp offset for vtt segments.
  timestampOffsetForSegment_() {
    return null;
  }
  chooseNextRequest_() {
    return this.skipEmptySegments_(super.chooseNextRequest_());
  }
  /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */
  skipEmptySegments_(ie) {
    for (; ie && ie.segment.empty; ) {
      if (ie.mediaIndex + 1 >= ie.playlist.segments.length) {
        ie = null;
        break;
      }
      ie = this.generateSegmentInfo_({
        playlist: ie.playlist,
        mediaIndex: ie.mediaIndex + 1,
        startOfSegment: ie.startOfSegment + ie.duration,
        isSyncRequest: ie.isSyncRequest
      });
    }
    return ie;
  }
  stopForError(ie) {
    this.error(ie), this.state = "READY", this.pause(), this.trigger("error");
  }
  /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */
  segmentRequestFinished_(ie, me, we) {
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(me.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (ie) {
      ie.code === Ut.TIMEOUT && this.handleTimeout_(), ie.code === Ut.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(ie);
      return;
    }
    const Re = this.pendingSegment_, je = we.mp4VttCues && we.mp4VttCues.length;
    je && (Re.mp4VttCues = we.mp4VttCues), this.saveBandwidthRelatedStats_(Re.duration, me.stats), me.key && this.segmentKey(me.key, !0), this.state = "APPENDING", this.trigger("appending");
    const Ue = Re.segment;
    if (Ue.map && (Ue.map.bytes = me.map.bytes), Re.bytes = me.bytes, typeof S.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(ie, me, we), () => this.stopForError({
        message: "Error loading vtt.js"
      }));
      return;
    }
    Ue.requested = !0;
    try {
      this.parseVTTCues_(Re);
    } catch (qe) {
      this.stopForError({
        message: qe.message,
        metadata: {
          errorType: L.Error.StreamingVttParserError,
          error: qe
        }
      });
      return;
    }
    if (je || this.updateTimeMapping_(Re, this.syncController_.timelines[Re.timeline], this.playlist_), Re.cues.length ? Re.timingInfo = {
      start: Re.cues[0].startTime,
      end: Re.cues[Re.cues.length - 1].endTime
    } : Re.timingInfo = {
      start: Re.startOfSegment,
      end: Re.startOfSegment + Re.duration
    }, Re.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    Re.byteLength = Re.bytes.byteLength, this.mediaSecondsLoaded += Ue.duration, Re.cues.forEach((qe) => {
      this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new S.VTTCue(qe.startTime, qe.endTime, qe.text) : qe);
    }), Vb(this.subtitlesTrack_), this.handleAppendsDone_();
  }
  handleData_(ie, me) {
    const we = ie && ie.type === "vtt", Re = me && me.type === "text";
    we && Re && super.handleData_(ie, me);
  }
  updateTimingInfoEnd_() {
  }
  /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */
  parseMp4VttCues_(ie) {
    const me = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    ie.mp4VttCues.forEach((we) => {
      const Re = we.start + me, je = we.end + me, Ue = new S.VTTCue(Re, je, we.cueText);
      we.settings && we.settings.split(" ").forEach((qe) => {
        const Ge = qe.split(":"), Xe = Ge[0], ot = Ge[1];
        Ue[Xe] = isNaN(ot) ? ot : Number(ot);
      }), ie.cues.push(Ue);
    });
  }
  /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */
  parseVTTCues_(ie) {
    let me, we = !1;
    if (typeof S.WebVTT != "function")
      throw new a2();
    if (ie.cues = [], ie.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, ie.mp4VttCues) {
      this.parseMp4VttCues_(ie);
      return;
    }
    typeof S.TextDecoder == "function" ? me = new S.TextDecoder("utf8") : (me = S.WebVTT.StringDecoder(), we = !0);
    const Re = new S.WebVTT.Parser(S, S.vttjs, me);
    if (Re.oncue = ie.cues.push.bind(ie.cues), Re.ontimestampmap = (Ue) => {
      ie.timestampmap = Ue;
    }, Re.onparsingerror = (Ue) => {
      L.log.warn("Error encountered when parsing cues: " + Ue.message);
    }, ie.segment.map) {
      let Ue = ie.segment.map.bytes;
      we && (Ue = xd(Ue)), Re.parse(Ue);
    }
    let je = ie.bytes;
    we && (je = xd(je)), Re.parse(je), Re.flush();
  }
  /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */
  updateTimeMapping_(ie, me, we) {
    const Re = ie.segment;
    if (!me)
      return;
    if (!ie.cues.length) {
      Re.empty = !0;
      return;
    }
    const {
      MPEGTS: je,
      LOCAL: Ue
    } = ie.timestampmap, qe = je / Di.ONE_SECOND_IN_TS - Ue + me.mapping;
    if (ie.cues.forEach((Ge) => {
      const Xe = Ge.endTime - Ge.startTime, ot = this.handleRollover_(Ge.startTime + qe, me.time);
      Ge.startTime = Math.max(ot, 0), Ge.endTime = Math.max(ot + Xe, 0);
    }), !we.syncInfo) {
      const Ge = ie.cues[0].startTime, Xe = ie.cues[ie.cues.length - 1].startTime;
      we.syncInfo = {
        mediaSequence: we.mediaSequence + ie.mediaIndex,
        time: Math.min(Ge, Xe - Re.duration)
      };
    }
  }
  /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */
  handleRollover_(ie, me) {
    if (me === null)
      return ie;
    let we = ie * Di.ONE_SECOND_IN_TS;
    const Re = me * Di.ONE_SECOND_IN_TS;
    let je;
    for (Re < we ? je = -8589934592 : je = 8589934592; Math.abs(we - Re) > 4294967296; )
      we += je;
    return we / Di.ONE_SECOND_IN_TS;
  }
}
const u2 = function(ce, ie) {
  const me = ce.cues;
  for (let we = 0; we < me.length; we++) {
    const Re = me[we];
    if (ie >= Re.adStartTime && ie <= Re.adEndTime)
      return Re;
  }
  return null;
}, l2 = function(ce, ie, me = 0) {
  if (!ce.segments)
    return;
  let we = me, Re;
  for (let je = 0; je < ce.segments.length; je++) {
    const Ue = ce.segments[je];
    if (Re || (Re = u2(ie, we + Ue.duration / 2)), Re) {
      if ("cueIn" in Ue) {
        Re.endTime = we, Re.adEndTime = we, we += Ue.duration, Re = null;
        continue;
      }
      if (we < Re.endTime) {
        we += Ue.duration;
        continue;
      }
      Re.endTime += Ue.duration;
    } else if ("cueOut" in Ue && (Re = new S.VTTCue(we, we + Ue.duration, Ue.cueOut), Re.adStartTime = we, Re.adEndTime = we + parseFloat(Ue.cueOut), ie.addCue(Re)), "cueOutCont" in Ue) {
      const [qe, Ge] = Ue.cueOutCont.split("/").map(parseFloat);
      Re = new S.VTTCue(we, we + Ue.duration, ""), Re.adStartTime = we - qe, Re.adEndTime = Re.adStartTime + Ge, ie.addCue(Re);
    }
    we += Ue.duration;
  }
};
class Ed {
  /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */
  constructor({
    start: ie,
    end: me,
    segmentIndex: we,
    partIndex: Re = null,
    appended: je = !1
  }) {
    this.start_ = ie, this.end_ = me, this.segmentIndex_ = we, this.partIndex_ = Re, this.appended_ = je;
  }
  isInRange(ie) {
    return ie >= this.start && ie < this.end;
  }
  markAppended() {
    this.appended_ = !0;
  }
  resetAppendedStatus() {
    this.appended_ = !1;
  }
  get isAppended() {
    return this.appended_;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get segmentIndex() {
    return this.segmentIndex_;
  }
  get partIndex() {
    return this.partIndex_;
  }
}
class c2 {
  /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */
  constructor(ie, me = []) {
    this.segmentSyncInfo_ = ie, this.partsSyncInfo_ = me;
  }
  get segmentSyncInfo() {
    return this.segmentSyncInfo_;
  }
  get partsSyncInfo() {
    return this.partsSyncInfo_;
  }
  get hasPartsSyncInfo() {
    return this.partsSyncInfo_.length > 0;
  }
  resetAppendStatus() {
    this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((ie) => ie.resetAppendedStatus());
  }
}
class Bp {
  constructor() {
    this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -1 / 0, this.end_ = 1 / 0;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get diagnostics() {
    return this.diagnostics_;
  }
  get isReliable() {
    return this.isReliable_;
  }
  resetAppendedStatus() {
    this.storage_.forEach((ie) => ie.resetAppendStatus());
  }
  /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */
  update(ie, me) {
    const {
      mediaSequence: we,
      segments: Re
    } = ie;
    if (this.isReliable_ = this.isReliablePlaylist_(we, Re), !!this.isReliable_)
      return this.updateStorage_(Re, we, this.calculateBaseTime_(we, Re, me));
  }
  /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */
  getSyncInfoForTime(ie) {
    for (const {
      segmentSyncInfo: me,
      partsSyncInfo: we
    } of this.storage_.values())
      if (we.length) {
        for (const Re of we)
          if (Re.isInRange(ie))
            return Re;
      } else if (me.isInRange(ie))
        return me;
    return null;
  }
  getSyncInfoForMediaSequence(ie) {
    return this.storage_.get(ie);
  }
  updateStorage_(ie, me, we) {
    const Re = /* @__PURE__ */ new Map();
    let je = `
`, Ue = we, qe = me;
    this.start_ = Ue, ie.forEach((Ge, Xe) => {
      const ot = this.storage_.get(qe), vt = Ue, bt = vt + Ge.duration, Tt = !!(ot && ot.segmentSyncInfo && ot.segmentSyncInfo.isAppended), wt = new Ed({
        start: vt,
        end: bt,
        appended: Tt,
        segmentIndex: Xe
      });
      Ge.syncInfo = wt;
      let St = Ue;
      const It = (Ge.parts || []).map((Pt, kt) => {
        const Ot = St, Jr = St + Pt.duration, en = !!(ot && ot.partsSyncInfo && ot.partsSyncInfo[kt] && ot.partsSyncInfo[kt].isAppended), nn = new Ed({
          start: Ot,
          end: Jr,
          appended: en,
          segmentIndex: Xe,
          partIndex: kt
        });
        return St = Jr, je += `Media Sequence: ${qe}.${kt} | Range: ${Ot} --> ${Jr} | Appended: ${en}
`, Pt.syncInfo = nn, nn;
      });
      Re.set(qe, new c2(wt, It)), je += `${Lp(Ge.resolvedUri)} | Media Sequence: ${qe} | Range: ${vt} --> ${bt} | Appended: ${Tt}
`, qe++, Ue = bt;
    }), this.end_ = Ue, this.storage_ = Re, this.diagnostics_ = je;
  }
  calculateBaseTime_(ie, me, we) {
    if (!this.storage_.size)
      return 0;
    if (this.storage_.has(ie))
      return this.storage_.get(ie).segmentSyncInfo.start;
    const Re = Math.min(...this.storage_.keys());
    if (ie < Re) {
      const je = Re - ie;
      let Ue = this.storage_.get(Re).segmentSyncInfo.start;
      for (let qe = 0; qe < je; qe++) {
        const Ge = me[qe];
        Ue -= Ge.duration;
      }
      return Ue;
    }
    return we;
  }
  isReliablePlaylist_(ie, me) {
    return ie != null && Array.isArray(me) && me.length;
  }
}
class Cd extends Bp {
  constructor(ie) {
    super(), this.parent_ = ie;
  }
  calculateBaseTime_(ie, me, we) {
    if (!this.storage_.size) {
      const Re = this.parent_.getSyncInfoForMediaSequence(ie);
      return Re ? Re.segmentSyncInfo.start : 0;
    }
    return super.calculateBaseTime_(ie, me, we);
  }
}
const d2 = 86400, Mo = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: (ce, ie, me, we, Re) => me !== 1 / 0 ? {
      time: 0,
      segmentIndex: 0,
      partIndex: null
    } : null
  },
  {
    name: "MediaSequence",
    /**
     * run media sequence strategy
     *
     * @param {SyncController} syncController
     * @param {Object} playlist
     * @param {number} duration
     * @param {number} currentTimeline
     * @param {number} currentTime
     * @param {string} type
     */
    run: (ce, ie, me, we, Re, je) => {
      const Ue = ce.getMediaSequenceSync(je);
      if (!Ue || !Ue.isReliable)
        return null;
      const qe = Ue.getSyncInfoForTime(Re);
      return qe ? {
        time: qe.start,
        partIndex: qe.partIndex,
        segmentIndex: qe.segmentIndex
      } : null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: (ce, ie, me, we, Re) => {
      if (!Object.keys(ce.timelineToDatetimeMappings).length)
        return null;
      let je = null, Ue = null;
      const qe = tu(ie);
      Re = Re || 0;
      for (let Ge = 0; Ge < qe.length; Ge++) {
        const Xe = ie.endList || Re === 0 ? Ge : qe.length - (Ge + 1), ot = qe[Xe], vt = ot.segment, bt = ce.timelineToDatetimeMappings[vt.timeline];
        if (!bt || !vt.dateTimeObject)
          continue;
        let Tt = vt.dateTimeObject.getTime() / 1e3 + bt;
        if (vt.parts && typeof ot.partIndex == "number")
          for (let St = 0; St < ot.partIndex; St++)
            Tt += vt.parts[St].duration;
        const wt = Math.abs(Re - Tt);
        if (Ue !== null && (wt === 0 || Ue < wt))
          break;
        Ue = wt, je = {
          time: Tt,
          segmentIndex: ot.segmentIndex,
          partIndex: ot.partIndex
        };
      }
      return je;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: (ce, ie, me, we, Re) => {
      let je = null, Ue = null;
      Re = Re || 0;
      const qe = tu(ie);
      for (let Ge = 0; Ge < qe.length; Ge++) {
        const Xe = ie.endList || Re === 0 ? Ge : qe.length - (Ge + 1), ot = qe[Xe], vt = ot.segment, bt = ot.part && ot.part.start || vt && vt.start;
        if (vt.timeline === we && typeof bt < "u") {
          const Tt = Math.abs(Re - bt);
          if (Ue !== null && Ue < Tt)
            break;
          (!je || Ue === null || Ue >= Tt) && (Ue = Tt, je = {
            time: bt,
            segmentIndex: ot.segmentIndex,
            partIndex: ot.partIndex
          });
        }
      }
      return je;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: (ce, ie, me, we, Re) => {
      let je = null;
      if (Re = Re || 0, ie.discontinuityStarts && ie.discontinuityStarts.length) {
        let Ue = null;
        for (let qe = 0; qe < ie.discontinuityStarts.length; qe++) {
          const Ge = ie.discontinuityStarts[qe], Xe = ie.discontinuitySequence + qe + 1, ot = ce.discontinuities[Xe];
          if (ot) {
            const vt = Math.abs(Re - ot.time);
            if (Ue !== null && Ue < vt)
              break;
            (!je || Ue === null || Ue >= vt) && (Ue = vt, je = {
              time: ot.time,
              segmentIndex: Ge,
              partIndex: null
            });
          }
        }
      }
      return je;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: (ce, ie, me, we, Re) => ie.syncInfo ? {
      time: ie.syncInfo.time,
      segmentIndex: ie.syncInfo.mediaSequence - ie.mediaSequence,
      partIndex: null
    } : null
  }
];
class h2 extends L.EventTarget {
  constructor(ie = {}) {
    super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
    const me = new Bp(), we = new Cd(me), Re = new Cd(me);
    this.mediaSequenceStorage_ = {
      main: me,
      audio: we,
      vtt: Re
    }, this.logger_ = yt("SyncController");
  }
  /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */
  getMediaSequenceSync(ie) {
    return this.mediaSequenceStorage_[ie] || null;
  }
  /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */
  getSyncPoint(ie, me, we, Re, je) {
    if (me !== 1 / 0)
      return Mo.find(({
        name: qe
      }) => qe === "VOD").run(this, ie, me);
    const Ue = this.runStrategies_(ie, me, we, Re, je);
    if (!Ue.length)
      return null;
    for (const qe of Ue) {
      const {
        syncPoint: Ge,
        strategy: Xe
      } = qe, {
        segmentIndex: ot,
        time: vt
      } = Ge;
      if (ot < 0)
        continue;
      const bt = ie.segments[ot], Tt = vt, wt = Tt + bt.duration;
      if (this.logger_(`Strategy: ${Xe}. Current time: ${Re}. selected segment: ${ot}. Time: [${Tt} -> ${wt}]}`), Re >= Tt && Re < wt)
        return this.logger_("Found sync point with exact match: ", Ge), Ge;
    }
    return this.selectSyncPoint_(Ue, {
      key: "time",
      value: Re
    });
  }
  /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */
  getExpiredTime(ie, me) {
    if (!ie || !ie.segments)
      return null;
    const we = this.runStrategies_(ie, me, ie.discontinuitySequence, 0);
    if (!we.length)
      return null;
    const Re = this.selectSyncPoint_(we, {
      key: "segmentIndex",
      value: 0
    });
    return Re.segmentIndex > 0 && (Re.time *= -1), Math.abs(Re.time + Pr({
      defaultDuration: ie.targetDuration,
      durationList: ie.segments,
      startIndex: Re.segmentIndex,
      endIndex: 0
    }));
  }
  /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */
  runStrategies_(ie, me, we, Re, je) {
    const Ue = [];
    for (let qe = 0; qe < Mo.length; qe++) {
      const Ge = Mo[qe], Xe = Ge.run(this, ie, me, we, Re, je);
      Xe && (Xe.strategy = Ge.name, Ue.push({
        strategy: Ge.name,
        syncPoint: Xe
      }));
    }
    return Ue;
  }
  /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */
  selectSyncPoint_(ie, me) {
    let we = ie[0].syncPoint, Re = Math.abs(ie[0].syncPoint[me.key] - me.value), je = ie[0].strategy;
    for (let Ue = 1; Ue < ie.length; Ue++) {
      const qe = Math.abs(ie[Ue].syncPoint[me.key] - me.value);
      qe < Re && (Re = qe, we = ie[Ue].syncPoint, je = ie[Ue].strategy);
    }
    return this.logger_(`syncPoint for [${me.key}: ${me.value}] chosen with strategy [${je}]: [time:${we.time}, segmentIndex:${we.segmentIndex}` + (typeof we.partIndex == "number" ? `,partIndex:${we.partIndex}` : "") + "]"), we;
  }
  /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */
  saveExpiredSegmentInfo(ie, me) {
    const we = me.mediaSequence - ie.mediaSequence;
    if (we > d2) {
      L.log.warn(`Not saving expired segment info. Media sequence gap ${we} is too large.`);
      return;
    }
    for (let Re = we - 1; Re >= 0; Re--) {
      const je = ie.segments[Re];
      if (je && typeof je.start < "u") {
        me.syncInfo = {
          mediaSequence: ie.mediaSequence + Re,
          time: je.start
        }, this.logger_(`playlist refresh sync: [time:${me.syncInfo.time}, mediaSequence: ${me.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
        break;
      }
    }
  }
  /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */
  setDateTimeMappingForStart(ie) {
    if (this.timelineToDatetimeMappings = {}, ie.segments && ie.segments.length && ie.segments[0].dateTimeObject) {
      const me = ie.segments[0], we = me.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[me.timeline] = -we;
    }
  }
  /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */
  saveSegmentTimingInfo({
    segmentInfo: ie,
    shouldSaveTimelineMapping: me
  }) {
    const we = this.calculateSegmentTimeMapping_(ie, ie.timingInfo, me), Re = ie.segment;
    we && (this.saveDiscontinuitySyncInfo_(ie), ie.playlist.syncInfo || (ie.playlist.syncInfo = {
      mediaSequence: ie.playlist.mediaSequence + ie.mediaIndex,
      time: Re.start
    }));
    const je = Re.dateTimeObject;
    Re.discontinuity && me && je && (this.timelineToDatetimeMappings[Re.timeline] = -(je.getTime() / 1e3));
  }
  timestampOffsetForTimeline(ie) {
    return typeof this.timelines[ie] > "u" ? null : this.timelines[ie].time;
  }
  mappingForTimeline(ie) {
    return typeof this.timelines[ie] > "u" ? null : this.timelines[ie].mapping;
  }
  /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */
  calculateSegmentTimeMapping_(ie, me, we) {
    const Re = ie.segment, je = ie.part;
    let Ue = this.timelines[ie.timeline], qe, Ge;
    if (typeof ie.timestampOffset == "number")
      Ue = {
        time: ie.startOfSegment,
        mapping: ie.startOfSegment - me.start
      }, we && (this.timelines[ie.timeline] = Ue, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${ie.timeline}: [time: ${Ue.time}] [mapping: ${Ue.mapping}]`)), qe = ie.startOfSegment, Ge = me.end + Ue.mapping;
    else if (Ue)
      qe = me.start + Ue.mapping, Ge = me.end + Ue.mapping;
    else
      return !1;
    return je && (je.start = qe, je.end = Ge), (!Re.start || qe < Re.start) && (Re.start = qe), Re.end = Ge, !0;
  }
  /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */
  saveDiscontinuitySyncInfo_(ie) {
    const me = ie.playlist, we = ie.segment;
    if (we.discontinuity)
      this.discontinuities[we.timeline] = {
        time: we.start,
        accuracy: 0
      };
    else if (me.discontinuityStarts && me.discontinuityStarts.length)
      for (let Re = 0; Re < me.discontinuityStarts.length; Re++) {
        const je = me.discontinuityStarts[Re], Ue = me.discontinuitySequence + Re + 1, qe = je - ie.mediaIndex, Ge = Math.abs(qe);
        if (!this.discontinuities[Ue] || this.discontinuities[Ue].accuracy > Ge) {
          let Xe;
          qe < 0 ? Xe = we.start - Pr({
            defaultDuration: me.targetDuration,
            durationList: me.segments,
            startIndex: ie.mediaIndex,
            endIndex: je
          }) : Xe = we.end + Pr({
            defaultDuration: me.targetDuration,
            durationList: me.segments,
            startIndex: ie.mediaIndex + 1,
            endIndex: je
          }), this.discontinuities[Ue] = {
            time: Xe,
            accuracy: Ge
          };
        }
      }
  }
  dispose() {
    this.trigger("dispose"), this.off();
  }
}
class f2 extends L.EventTarget {
  constructor() {
    super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
  }
  clearPendingTimelineChange(ie) {
    this.pendingTimelineChanges_[ie] = null, this.trigger("pendingtimelinechange");
  }
  pendingTimelineChange({
    type: ie,
    from: me,
    to: we
  }) {
    return typeof me == "number" && typeof we == "number" && (this.pendingTimelineChanges_[ie] = {
      type: ie,
      from: me,
      to: we
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[ie];
  }
  lastTimelineChange({
    type: ie,
    from: me,
    to: we
  }) {
    if (typeof me == "number" && typeof we == "number") {
      this.lastTimelineChanges_[ie] = {
        type: ie,
        from: me,
        to: we
      }, delete this.pendingTimelineChanges_[ie];
      const Re = {
        timelineChangeInfo: {
          from: me,
          to: we
        }
      };
      this.trigger({
        type: "timelinechange",
        metadata: Re
      });
    }
    return this.lastTimelineChanges_[ie];
  }
  dispose() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }
}
const p2 = xp(Sp(function() {
  var ce = /* @__PURE__ */ function() {
    function St() {
      this.listeners = {};
    }
    var It = St.prototype;
    return It.on = function(Pt, kt) {
      this.listeners[Pt] || (this.listeners[Pt] = []), this.listeners[Pt].push(kt);
    }, It.off = function(Pt, kt) {
      if (!this.listeners[Pt])
        return !1;
      var Ot = this.listeners[Pt].indexOf(kt);
      return this.listeners[Pt] = this.listeners[Pt].slice(0), this.listeners[Pt].splice(Ot, 1), Ot > -1;
    }, It.trigger = function(Pt) {
      var kt = this.listeners[Pt];
      if (kt)
        if (arguments.length === 2)
          for (var Ot = kt.length, Jr = 0; Jr < Ot; ++Jr)
            kt[Jr].call(this, arguments[1]);
        else
          for (var en = Array.prototype.slice.call(arguments, 1), nn = kt.length, ln = 0; ln < nn; ++ln)
            kt[ln].apply(this, en);
    }, It.dispose = function() {
      this.listeners = {};
    }, It.pipe = function(Pt) {
      this.on("data", function(kt) {
        Pt.push(kt);
      });
    }, St;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function ie(St) {
    return St.subarray(0, St.byteLength - St[St.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */
  const me = function() {
    const St = [[[], [], [], [], []], [[], [], [], [], []]], It = St[0], Pt = St[1], kt = It[4], Ot = Pt[4];
    let Jr, en, nn;
    const ln = [], fn = [];
    let vn, Tn, xn, bn, Sn, Cn;
    for (Jr = 0; Jr < 256; Jr++)
      fn[(ln[Jr] = Jr << 1 ^ (Jr >> 7) * 283) ^ Jr] = Jr;
    for (en = nn = 0; !kt[en]; en ^= vn || 1, nn = fn[nn] || 1)
      for (bn = nn ^ nn << 1 ^ nn << 2 ^ nn << 3 ^ nn << 4, bn = bn >> 8 ^ bn & 255 ^ 99, kt[en] = bn, Ot[bn] = en, xn = ln[Tn = ln[vn = ln[en]]], Cn = xn * 16843009 ^ Tn * 65537 ^ vn * 257 ^ en * 16843008, Sn = ln[bn] * 257 ^ bn * 16843008, Jr = 0; Jr < 4; Jr++)
        It[Jr][en] = Sn = Sn << 24 ^ Sn >>> 8, Pt[Jr][bn] = Cn = Cn << 24 ^ Cn >>> 8;
    for (Jr = 0; Jr < 5; Jr++)
      It[Jr] = It[Jr].slice(0), Pt[Jr] = Pt[Jr].slice(0);
    return St;
  };
  let we = null;
  class Re {
    constructor(It) {
      we || (we = me()), this._tables = [[we[0][0].slice(), we[0][1].slice(), we[0][2].slice(), we[0][3].slice(), we[0][4].slice()], [we[1][0].slice(), we[1][1].slice(), we[1][2].slice(), we[1][3].slice(), we[1][4].slice()]];
      let Pt, kt, Ot;
      const Jr = this._tables[0][4], en = this._tables[1], nn = It.length;
      let ln = 1;
      if (nn !== 4 && nn !== 6 && nn !== 8)
        throw new Error("Invalid aes key size");
      const fn = It.slice(0), vn = [];
      for (this._key = [fn, vn], Pt = nn; Pt < 4 * nn + 28; Pt++)
        Ot = fn[Pt - 1], (Pt % nn === 0 || nn === 8 && Pt % nn === 4) && (Ot = Jr[Ot >>> 24] << 24 ^ Jr[Ot >> 16 & 255] << 16 ^ Jr[Ot >> 8 & 255] << 8 ^ Jr[Ot & 255], Pt % nn === 0 && (Ot = Ot << 8 ^ Ot >>> 24 ^ ln << 24, ln = ln << 1 ^ (ln >> 7) * 283)), fn[Pt] = fn[Pt - nn] ^ Ot;
      for (kt = 0; Pt; kt++, Pt--)
        Ot = fn[kt & 3 ? Pt : Pt - 4], Pt <= 4 || kt < 4 ? vn[kt] = Ot : vn[kt] = en[0][Jr[Ot >>> 24]] ^ en[1][Jr[Ot >> 16 & 255]] ^ en[2][Jr[Ot >> 8 & 255]] ^ en[3][Jr[Ot & 255]];
    }
    /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */
    decrypt(It, Pt, kt, Ot, Jr, en) {
      const nn = this._key[1];
      let ln = It ^ nn[0], fn = Ot ^ nn[1], vn = kt ^ nn[2], Tn = Pt ^ nn[3], xn, bn, Sn;
      const Cn = nn.length / 4 - 2;
      let kn, cn = 4;
      const gn = this._tables[1], an = gn[0], un = gn[1], pn = gn[2], hn = gn[3], An = gn[4];
      for (kn = 0; kn < Cn; kn++)
        xn = an[ln >>> 24] ^ un[fn >> 16 & 255] ^ pn[vn >> 8 & 255] ^ hn[Tn & 255] ^ nn[cn], bn = an[fn >>> 24] ^ un[vn >> 16 & 255] ^ pn[Tn >> 8 & 255] ^ hn[ln & 255] ^ nn[cn + 1], Sn = an[vn >>> 24] ^ un[Tn >> 16 & 255] ^ pn[ln >> 8 & 255] ^ hn[fn & 255] ^ nn[cn + 2], Tn = an[Tn >>> 24] ^ un[ln >> 16 & 255] ^ pn[fn >> 8 & 255] ^ hn[vn & 255] ^ nn[cn + 3], cn += 4, ln = xn, fn = bn, vn = Sn;
      for (kn = 0; kn < 4; kn++)
        Jr[(3 & -kn) + en] = An[ln >>> 24] << 24 ^ An[fn >> 16 & 255] << 16 ^ An[vn >> 8 & 255] << 8 ^ An[Tn & 255] ^ nn[cn++], xn = ln, ln = fn, fn = vn, vn = Tn, Tn = xn;
    }
  }
  class je extends ce {
    constructor() {
      super(ce), this.jobs = [], this.delay = 1, this.timeout_ = null;
    }
    /**
     * process an async job
     *
     * @private
     */
    processJob_() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }
    /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */
    push(It) {
      this.jobs.push(It), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }
  }
  const Ue = function(St) {
    return St << 24 | (St & 65280) << 8 | (St & 16711680) >> 8 | St >>> 24;
  }, qe = function(St, It, Pt) {
    const kt = new Int32Array(St.buffer, St.byteOffset, St.byteLength >> 2), Ot = new Re(Array.prototype.slice.call(It)), Jr = new Uint8Array(St.byteLength), en = new Int32Array(Jr.buffer);
    let nn, ln, fn, vn, Tn, xn, bn, Sn, Cn;
    for (nn = Pt[0], ln = Pt[1], fn = Pt[2], vn = Pt[3], Cn = 0; Cn < kt.length; Cn += 4)
      Tn = Ue(kt[Cn]), xn = Ue(kt[Cn + 1]), bn = Ue(kt[Cn + 2]), Sn = Ue(kt[Cn + 3]), Ot.decrypt(Tn, xn, bn, Sn, en, Cn), en[Cn] = Ue(en[Cn] ^ nn), en[Cn + 1] = Ue(en[Cn + 1] ^ ln), en[Cn + 2] = Ue(en[Cn + 2] ^ fn), en[Cn + 3] = Ue(en[Cn + 3] ^ vn), nn = Tn, ln = xn, fn = bn, vn = Sn;
    return Jr;
  };
  class Ge {
    constructor(It, Pt, kt, Ot) {
      const Jr = Ge.STEP, en = new Int32Array(It.buffer), nn = new Uint8Array(It.byteLength);
      let ln = 0;
      for (this.asyncStream_ = new je(), this.asyncStream_.push(this.decryptChunk_(en.subarray(ln, ln + Jr), Pt, kt, nn)), ln = Jr; ln < en.length; ln += Jr)
        kt = new Uint32Array([Ue(en[ln - 4]), Ue(en[ln - 3]), Ue(en[ln - 2]), Ue(en[ln - 1])]), this.asyncStream_.push(this.decryptChunk_(en.subarray(ln, ln + Jr), Pt, kt, nn));
      this.asyncStream_.push(function() {
        Ot(null, ie(nn));
      });
    }
    /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */
    static get STEP() {
      return 32e3;
    }
    /**
     * @private
     */
    decryptChunk_(It, Pt, kt, Ot) {
      return function() {
        const Jr = qe(It, Pt, kt);
        Ot.set(Jr, It.byteOffset);
      };
    }
  }
  var Xe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ot;
  typeof window < "u" ? ot = window : typeof Xe < "u" ? ot = Xe : typeof self < "u" ? ot = self : ot = {};
  var vt = ot, bt = function(St) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(St) : St && St.buffer instanceof ArrayBuffer;
  }, Tt = vt.BigInt || Number;
  Tt("0x1"), Tt("0x100"), Tt("0x10000"), Tt("0x1000000"), Tt("0x100000000"), Tt("0x10000000000"), Tt("0x1000000000000"), Tt("0x100000000000000"), Tt("0x10000000000000000"), function() {
    var St = new Uint16Array([65484]), It = new Uint8Array(St.buffer, St.byteOffset, St.byteLength);
    return It[0] === 255 ? "big" : It[0] === 204 ? "little" : "unknown";
  }();
  const wt = function(St) {
    const It = {};
    return Object.keys(St).forEach((Pt) => {
      const kt = St[Pt];
      bt(kt) ? It[Pt] = {
        bytes: kt.buffer,
        byteOffset: kt.byteOffset,
        byteLength: kt.byteLength
      } : It[Pt] = kt;
    }), It;
  };
  self.onmessage = function(St) {
    const It = St.data, Pt = new Uint8Array(It.encrypted.bytes, It.encrypted.byteOffset, It.encrypted.byteLength), kt = new Uint32Array(It.key.bytes, It.key.byteOffset, It.key.byteLength / 4), Ot = new Uint32Array(It.iv.bytes, It.iv.byteOffset, It.iv.byteLength / 4);
    new Ge(Pt, kt, Ot, function(Jr, en) {
      self.postMessage(wt({
        source: It.source,
        decrypted: en
      }), [en.buffer]);
    });
  };
}));
var m2 = bp(p2);
const g2 = (ce) => {
  let ie = ce.default ? "main" : "alternative";
  return ce.characteristics && ce.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (ie = "main-desc"), ie;
}, Fp = (ce, ie) => {
  ce.abort(), ce.pause(), ie && ie.activePlaylistLoader && (ie.activePlaylistLoader.pause(), ie.activePlaylistLoader = null);
}, hu = (ce, ie) => {
  ie.activePlaylistLoader = ce, ce.load();
}, _2 = (ce, ie) => () => {
  const {
    segmentLoaders: {
      [ce]: me,
      main: we
    },
    mediaTypes: {
      [ce]: Re
    }
  } = ie, je = Re.activeTrack(), Ue = Re.getActiveGroup(), qe = Re.activePlaylistLoader, Ge = Re.lastGroup_;
  if (!(Ue && Ge && Ue.id === Ge.id) && (Re.lastGroup_ = Ue, Re.lastTrack_ = je, Fp(me, Re), !(!Ue || Ue.isMainPlaylist))) {
    if (!Ue.playlistLoader) {
      qe && we.resetEverything();
      return;
    }
    me.resyncLoader(), hu(Ue.playlistLoader, Re);
  }
}, y2 = (ce, ie) => () => {
  const {
    segmentLoaders: {
      [ce]: me
    },
    mediaTypes: {
      [ce]: we
    }
  } = ie;
  we.lastGroup_ = null, me.abort(), me.pause();
}, T2 = (ce, ie) => () => {
  const {
    mainPlaylistLoader: me,
    segmentLoaders: {
      [ce]: we,
      main: Re
    },
    mediaTypes: {
      [ce]: je
    }
  } = ie, Ue = je.activeTrack(), qe = je.getActiveGroup(), Ge = je.activePlaylistLoader, Xe = je.lastTrack_;
  if (!(Xe && Ue && Xe.id === Ue.id) && (je.lastGroup_ = qe, je.lastTrack_ = Ue, Fp(we, je), !!qe)) {
    if (qe.isMainPlaylist) {
      if (!Ue || !Xe || Ue.id === Xe.id)
        return;
      const ot = ie.vhs.playlistController_, vt = ot.selectPlaylist();
      if (ot.media() === vt)
        return;
      je.logger_(`track change. Switching main audio from ${Xe.id} to ${Ue.id}`), me.pause(), Re.resetEverything(), ot.fastQualityChange_(vt);
      return;
    }
    if (ce === "AUDIO") {
      if (!qe.playlistLoader) {
        Re.setAudio(!0), Re.resetEverything();
        return;
      }
      we.setAudio(!0), Re.setAudio(!1);
    }
    if (Ge === qe.playlistLoader) {
      hu(qe.playlistLoader, je);
      return;
    }
    we.track && we.track(Ue), we.resetEverything(), hu(qe.playlistLoader, je);
  }
}, fa = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: (ce, ie) => () => {
    const {
      mediaTypes: {
        [ce]: me
      },
      excludePlaylist: we
    } = ie, Re = me.activeTrack(), je = me.activeGroup(), Ue = (je.filter((Ge) => Ge.default)[0] || je[0]).id, qe = me.tracks[Ue];
    if (Re === qe) {
      we({
        error: {
          message: "Problem encountered loading the default audio track."
        }
      });
      return;
    }
    L.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
    for (const Ge in me.tracks)
      me.tracks[Ge].enabled = me.tracks[Ge] === qe;
    me.onTrackChanged();
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: (ce, ie) => () => {
    const {
      mediaTypes: {
        [ce]: me
      }
    } = ie;
    L.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
    const we = me.activeTrack();
    we && (we.mode = "disabled"), me.onTrackChanged();
  }
}, Ad = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: (ce, ie, me) => {
    if (!ie)
      return;
    const {
      tech: we,
      requestOptions: Re,
      segmentLoaders: {
        [ce]: je
      }
    } = me;
    ie.on("loadedmetadata", () => {
      const Ue = ie.media();
      je.playlist(Ue, Re), (!we.paused() || Ue.endList && we.preload() !== "none") && je.load();
    }), ie.on("loadedplaylist", () => {
      je.playlist(ie.media(), Re), we.paused() || je.load();
    }), ie.on("error", fa[ce](ce, me));
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: (ce, ie, me) => {
    const {
      tech: we,
      requestOptions: Re,
      segmentLoaders: {
        [ce]: je
      },
      mediaTypes: {
        [ce]: Ue
      }
    } = me;
    ie.on("loadedmetadata", () => {
      const qe = ie.media();
      je.playlist(qe, Re), je.track(Ue.activeTrack()), (!we.paused() || qe.endList && we.preload() !== "none") && je.load();
    }), ie.on("loadedplaylist", () => {
      je.playlist(ie.media(), Re), we.paused() || je.load();
    }), ie.on("error", fa[ce](ce, me));
  }
}, v2 = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: (ce, ie) => {
    const {
      vhs: me,
      sourceType: we,
      segmentLoaders: {
        [ce]: Re
      },
      requestOptions: je,
      main: {
        mediaGroups: Ue
      },
      mediaTypes: {
        [ce]: {
          groups: qe,
          tracks: Ge,
          logger_: Xe
        }
      },
      mainPlaylistLoader: ot
    } = ie, vt = Qr(ot.main);
    (!Ue[ce] || Object.keys(Ue[ce]).length === 0) && (Ue[ce] = {
      main: {
        default: {
          default: !0
        }
      }
    }, vt && (Ue[ce].main.default.playlists = ot.main.playlists));
    for (const bt in Ue[ce]) {
      qe[bt] || (qe[bt] = []);
      for (const Tt in Ue[ce][bt]) {
        let wt = Ue[ce][bt][Tt], St;
        if (vt ? (Xe(`AUDIO group '${bt}' label '${Tt}' is a main playlist`), wt.isMainPlaylist = !0, St = null) : we === "vhs-json" && wt.playlists ? St = new ns(wt.playlists[0], me, je) : wt.resolvedUri ? St = new ns(wt.resolvedUri, me, je) : wt.playlists && we === "dash" ? St = new ou(wt.playlists[0], me, je, ot) : St = null, wt = fe$1({
          id: Tt,
          playlistLoader: St
        }, wt), Ad[ce](ce, wt.playlistLoader, ie), qe[bt].push(wt), typeof Ge[Tt] > "u") {
          const It = new L.AudioTrack({
            id: Tt,
            kind: g2(wt),
            enabled: !1,
            language: wt.language,
            default: wt.default,
            label: Tt
          });
          Ge[Tt] = It;
        }
      }
    }
    Re.on("error", fa[ce](ce, ie));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: (ce, ie) => {
    const {
      tech: me,
      vhs: we,
      sourceType: Re,
      segmentLoaders: {
        [ce]: je
      },
      requestOptions: Ue,
      main: {
        mediaGroups: qe
      },
      mediaTypes: {
        [ce]: {
          groups: Ge,
          tracks: Xe
        }
      },
      mainPlaylistLoader: ot
    } = ie;
    for (const vt in qe[ce]) {
      Ge[vt] || (Ge[vt] = []);
      for (const bt in qe[ce][vt]) {
        if (!we.options_.useForcedSubtitles && qe[ce][vt][bt].forced)
          continue;
        let Tt = qe[ce][vt][bt], wt;
        if (Re === "hls")
          wt = new ns(Tt.resolvedUri, we, Ue);
        else if (Re === "dash") {
          if (!Tt.playlists.filter((St) => St.excludeUntil !== 1 / 0).length)
            return;
          wt = new ou(Tt.playlists[0], we, Ue, ot);
        } else Re === "vhs-json" && (wt = new ns(
          // if the vhs-json object included the media playlist, use the media playlist
          // as provided, otherwise use the resolved URI to load the playlist
          Tt.playlists ? Tt.playlists[0] : Tt.resolvedUri,
          we,
          Ue
        ));
        if (Tt = fe$1({
          id: bt,
          playlistLoader: wt
        }, Tt), Ad[ce](ce, Tt.playlistLoader, ie), Ge[vt].push(Tt), typeof Xe[bt] > "u") {
          const St = me.addRemoteTextTrack({
            id: bt,
            kind: "subtitles",
            default: Tt.default && Tt.autoselect,
            language: Tt.language,
            label: bt
          }, !1).track;
          Xe[bt] = St;
        }
      }
    }
    je.on("error", fa[ce](ce, ie));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": (ce, ie) => {
    const {
      tech: me,
      main: {
        mediaGroups: we
      },
      mediaTypes: {
        [ce]: {
          groups: Re,
          tracks: je
        }
      }
    } = ie;
    for (const Ue in we[ce]) {
      Re[Ue] || (Re[Ue] = []);
      for (const qe in we[ce][Ue]) {
        const Ge = we[ce][Ue][qe];
        if (!/^(?:CC|SERVICE)/.test(Ge.instreamId))
          continue;
        const Xe = me.options_.vhs && me.options_.vhs.captionServices || {};
        let ot = {
          label: qe,
          language: Ge.language,
          instreamId: Ge.instreamId,
          default: Ge.default && Ge.autoselect
        };
        if (Xe[ot.instreamId] && (ot = fe$1(ot, Xe[ot.instreamId])), ot.default === void 0 && delete ot.default, Re[Ue].push(fe$1({
          id: qe
        }, Ge)), typeof je[qe] > "u") {
          const vt = me.addRemoteTextTrack({
            id: ot.instreamId,
            kind: "captions",
            default: ot.default,
            language: ot.language,
            label: ot.label
          }, !1).track;
          je[qe] = vt;
        }
      }
    }
  }
}, Up = (ce, ie) => {
  for (let me = 0; me < ce.length; me++)
    if (ul(ie, ce[me]) || ce[me].playlists && Up(ce[me].playlists, ie))
      return !0;
  return !1;
}, b2 = (ce, ie) => (me) => {
  const {
    mainPlaylistLoader: we,
    mediaTypes: {
      [ce]: {
        groups: Re
      }
    }
  } = ie, je = we.media();
  if (!je)
    return null;
  let Ue = null;
  je.attributes[ce] && (Ue = Re[je.attributes[ce]]);
  const qe = Object.keys(Re);
  if (!Ue)
    if (ce === "AUDIO" && qe.length > 1 && Qr(ie.main))
      for (let Ge = 0; Ge < qe.length; Ge++) {
        const Xe = Re[qe[Ge]];
        if (Up(Xe, je)) {
          Ue = Xe;
          break;
        }
      }
    else Re.main ? Ue = Re.main : qe.length === 1 && (Ue = Re[qe[0]]);
  return typeof me > "u" ? Ue : me === null || !Ue ? null : Ue.filter((Ge) => Ge.id === me.id)[0] || null;
}, x2 = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: (ce, ie) => () => {
    const {
      mediaTypes: {
        [ce]: {
          tracks: me
        }
      }
    } = ie;
    for (const we in me)
      if (me[we].enabled)
        return me[we];
    return null;
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: (ce, ie) => () => {
    const {
      mediaTypes: {
        [ce]: {
          tracks: me
        }
      }
    } = ie;
    for (const we in me)
      if (me[we].mode === "showing" || me[we].mode === "hidden")
        return me[we];
    return null;
  }
}, S2 = (ce, {
  mediaTypes: ie
}) => () => {
  const me = ie[ce].activeTrack();
  return me ? ie[ce].activeGroup(me) : null;
}, E2 = (ce) => {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((Xe) => {
    v2[Xe](Xe, ce);
  });
  const {
    mediaTypes: ie,
    mainPlaylistLoader: me,
    tech: we,
    vhs: Re,
    segmentLoaders: {
      ["AUDIO"]: je,
      main: Ue
    }
  } = ce;
  ["AUDIO", "SUBTITLES"].forEach((Xe) => {
    ie[Xe].activeGroup = b2(Xe, ce), ie[Xe].activeTrack = x2[Xe](Xe, ce), ie[Xe].onGroupChanged = _2(Xe, ce), ie[Xe].onGroupChanging = y2(Xe, ce), ie[Xe].onTrackChanged = T2(Xe, ce), ie[Xe].getActiveGroup = S2(Xe, ce);
  });
  const qe = ie.AUDIO.activeGroup();
  if (qe) {
    const Xe = (qe.filter((ot) => ot.default)[0] || qe[0]).id;
    ie.AUDIO.tracks[Xe].enabled = !0, ie.AUDIO.onGroupChanged(), ie.AUDIO.onTrackChanged(), ie.AUDIO.getActiveGroup().playlistLoader ? (Ue.setAudio(!1), je.setAudio(!0)) : Ue.setAudio(!0);
  }
  me.on("mediachange", () => {
    ["AUDIO", "SUBTITLES"].forEach((Xe) => ie[Xe].onGroupChanged());
  }), me.on("mediachanging", () => {
    ["AUDIO", "SUBTITLES"].forEach((Xe) => ie[Xe].onGroupChanging());
  });
  const Ge = () => {
    ie.AUDIO.onTrackChanged(), we.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
  };
  we.audioTracks().addEventListener("change", Ge), we.remoteTextTracks().addEventListener("change", ie.SUBTITLES.onTrackChanged), Re.on("dispose", () => {
    we.audioTracks().removeEventListener("change", Ge), we.remoteTextTracks().removeEventListener("change", ie.SUBTITLES.onTrackChanged);
  }), we.clearTracks("audio");
  for (const Xe in ie.AUDIO.tracks)
    we.audioTracks().addTrack(ie.AUDIO.tracks[Xe]);
}, C2 = () => {
  const ce = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((ie) => {
    ce[ie] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Xt,
      activeTrack: Xt,
      getActiveGroup: Xt,
      onGroupChanged: Xt,
      onTrackChanged: Xt,
      lastTrack_: null,
      logger_: yt(`MediaGroups[${ie}]`)
    };
  }), ce;
};
class Dd {
  constructor() {
    this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
  }
  set version(ie) {
    ie === 1 && (this.version_ = ie);
  }
  set ttl(ie) {
    this.ttl_ = ie || 300;
  }
  set reloadUri(ie) {
    ie && (this.reloadUri_ = it(this.reloadUri_, ie));
  }
  set priority(ie) {
    ie && ie.length && (this.priority_ = ie);
  }
  set pathwayClones(ie) {
    ie && ie.length && (this.pathwayClones_ = new Map(ie.map((me) => [me.ID, me])));
  }
  get version() {
    return this.version_;
  }
  get ttl() {
    return this.ttl_;
  }
  get reloadUri() {
    return this.reloadUri_;
  }
  get priority() {
    return this.priority_;
  }
  get pathwayClones() {
    return this.pathwayClones_;
  }
}
class A2 extends L.EventTarget {
  constructor(ie, me) {
    super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Dd(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = yt("Content Steering"), this.xhr_ = ie, this.getBandwidth_ = me;
  }
  /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */
  assignTagProperties(ie, me) {
    this.manifestType_ = me.serverUri ? "HLS" : "DASH";
    const we = me.serverUri || me.serverURL;
    if (!we) {
      this.logger_(`steering manifest URL is ${we}, cannot request steering manifest.`), this.trigger("error");
      return;
    }
    if (we.startsWith("data:")) {
      this.decodeDataUriManifest_(we.substring(we.indexOf(",") + 1));
      return;
    }
    this.steeringManifest.reloadUri = it(ie, we), this.defaultPathway = me.pathwayId || me.defaultServiceLocation, this.queryBeforeStart = me.queryBeforeStart, this.proxyServerUrl_ = me.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
  }
  /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */
  requestSteeringManifest(ie) {
    const me = this.steeringManifest.reloadUri;
    if (!me)
      return;
    const we = ie ? me : this.getRequestURI(me);
    if (!we) {
      this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
      return;
    }
    const Re = {
      contentSteeringInfo: {
        uri: we
      }
    };
    this.trigger({
      type: "contentsteeringloadstart",
      metadata: Re
    }), this.request_ = this.xhr_({
      uri: we,
      requestType: "content-steering-manifest"
    }, (je, Ue) => {
      if (je) {
        if (Ue.status === 410) {
          this.logger_(`manifest request 410 ${je}.`), this.logger_(`There will be no more content steering requests to ${we} this session.`), this.excludedSteeringManifestURLs.add(we);
          return;
        }
        if (Ue.status === 429) {
          const Xe = Ue.responseHeaders["retry-after"];
          this.logger_(`manifest request 429 ${je}.`), this.logger_(`content steering will retry in ${Xe} seconds.`), this.startTTLTimeout_(parseInt(Xe, 10));
          return;
        }
        this.logger_(`manifest failed to load ${je}.`), this.startTTLTimeout_();
        return;
      }
      this.trigger({
        type: "contentsteeringloadcomplete",
        metadata: Re
      });
      let qe;
      try {
        qe = JSON.parse(this.request_.responseText);
      } catch (Xe) {
        const ot = {
          errorType: L.Error.StreamingContentSteeringParserError,
          error: Xe
        };
        this.trigger({
          type: "error",
          metadata: ot
        });
      }
      this.assignSteeringProperties_(qe);
      const Ge = {
        contentSteeringInfo: Re.contentSteeringInfo,
        contentSteeringManifest: {
          version: this.steeringManifest.version,
          reloadUri: this.steeringManifest.reloadUri,
          priority: this.steeringManifest.priority
        }
      };
      this.trigger({
        type: "contentsteeringparsed",
        metadata: Ge
      }), this.startTTLTimeout_();
    });
  }
  /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */
  setProxyServerUrl_(ie) {
    const me = new S.URL(ie), we = new S.URL(this.proxyServerUrl_);
    return we.searchParams.set("url", encodeURI(me.toString())), this.setSteeringParams_(we.toString());
  }
  /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */
  decodeDataUriManifest_(ie) {
    const me = JSON.parse(S.atob(ie));
    this.assignSteeringProperties_(me);
  }
  /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */
  setSteeringParams_(ie) {
    const me = new S.URL(ie), we = this.getPathway(), Re = this.getBandwidth_();
    if (we) {
      const je = `_${this.manifestType_}_pathway`;
      me.searchParams.set(je, we);
    }
    if (Re) {
      const je = `_${this.manifestType_}_throughput`;
      me.searchParams.set(je, Re);
    }
    return me.toString();
  }
  /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */
  assignSteeringProperties_(ie) {
    if (this.steeringManifest.version = ie.VERSION, !this.steeringManifest.version) {
      this.logger_(`manifest version is ${ie.VERSION}, which is not supported.`), this.trigger("error");
      return;
    }
    this.steeringManifest.ttl = ie.TTL, this.steeringManifest.reloadUri = ie["RELOAD-URI"], this.steeringManifest.priority = ie["PATHWAY-PRIORITY"] || ie["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = ie["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
    const me = ((we) => {
      for (const Re of we)
        if (this.availablePathways_.has(Re))
          return Re;
      return [...this.availablePathways_][0];
    })(this.steeringManifest.priority);
    this.currentPathway !== me && (this.currentPathway = me, this.trigger("content-steering"));
  }
  /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */
  getPathway() {
    return this.currentPathway || this.defaultPathway;
  }
  /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */
  getRequestURI(ie) {
    if (!ie)
      return null;
    const me = (Re) => this.excludedSteeringManifestURLs.has(Re);
    if (this.proxyServerUrl_) {
      const Re = this.setProxyServerUrl_(ie);
      if (!me(Re))
        return Re;
    }
    const we = this.setSteeringParams_(ie);
    return me(we) ? null : we;
  }
  /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */
  startTTLTimeout_(ie = this.steeringManifest.ttl) {
    const me = ie * 1e3;
    this.ttlTimeout_ = S.setTimeout(() => {
      this.requestSteeringManifest();
    }, me);
  }
  /**
   * Clear the TTL timeout if necessary.
   */
  clearTTLTimeout_() {
    S.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
  }
  /**
   * aborts any current steering xhr and sets the current request object to null
   */
  abort() {
    this.request_ && this.request_.abort(), this.request_ = null;
  }
  /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */
  dispose() {
    this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Dd();
  }
  /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */
  addAvailablePathway(ie) {
    ie && this.availablePathways_.add(ie);
  }
  /**
   * Clears all pathways from the available pathways set
   */
  clearAvailablePathways() {
    this.availablePathways_.clear();
  }
  /**
   * Removes a pathway from the available pathways set.
   */
  excludePathway(ie) {
    return this.availablePathways_.delete(ie);
  }
  /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */
  didDASHTagChange(ie, me) {
    return !me && this.steeringManifest.reloadUri || me && (it(ie, me.serverURL) !== this.steeringManifest.reloadUri || me.defaultServiceLocation !== this.defaultPathway || me.queryBeforeStart !== this.queryBeforeStart || me.proxyServerURL !== this.proxyServerUrl_);
  }
  getAvailablePathways() {
    return this.availablePathways_;
  }
}
const D2 = (ce, ie) => {
  let me = null;
  return (...we) => {
    clearTimeout(me), me = setTimeout(() => {
      ce.apply(null, we);
    }, ie);
  };
}, w2 = 10;
let di;
const k2 = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], I2 = function(ce) {
  return this.audioSegmentLoader_[ce] + this.mainSegmentLoader_[ce];
}, P2 = function({
  currentPlaylist: ce,
  buffered: ie,
  currentTime: me,
  nextPlaylist: we,
  bufferLowWaterLine: Re,
  bufferHighWaterLine: je,
  duration: Ue,
  bufferBasedABR: qe,
  log: Ge
}) {
  if (!we)
    return L.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  const Xe = `allowing switch ${ce && ce.id || "null"} -> ${we.id}`;
  if (!ce)
    return Ge(`${Xe} as current playlist is not set`), !0;
  if (we.id === ce.id)
    return !1;
  const ot = !!rs(ie, me).length;
  if (!ce.endList)
    return !ot && typeof ce.partTargetDuration == "number" ? (Ge(`not ${Xe} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (Ge(`${Xe} as current playlist is live`), !0);
  const vt = nl(ie, me), bt = qe ? Me.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Me.MAX_BUFFER_LOW_WATER_LINE;
  if (Ue < bt)
    return Ge(`${Xe} as duration < max low water line (${Ue} < ${bt})`), !0;
  const Tt = we.attributes.BANDWIDTH, wt = ce.attributes.BANDWIDTH;
  if (Tt < wt && (!qe || vt < je)) {
    let St = `${Xe} as next bandwidth < current bandwidth (${Tt} < ${wt})`;
    return qe && (St += ` and forwardBuffer < bufferHighWaterLine (${vt} < ${je})`), Ge(St), !0;
  }
  if ((!qe || Tt > wt) && vt >= Re) {
    let St = `${Xe} as forwardBuffer >= bufferLowWaterLine (${vt} >= ${Re})`;
    return qe && (St += ` and next bandwidth > current bandwidth (${Tt} > ${wt})`), Ge(St), !0;
  }
  return Ge(`not ${Xe} as no switching criteria met`), !1;
};
class O2 extends L.EventTarget {
  constructor(ie) {
    super(), this.fastQualityChange_ = D2(this.fastQualityChange_.bind(this), 100);
    const {
      src: me,
      withCredentials: we,
      tech: Re,
      bandwidth: je,
      externVhs: Ue,
      useCueTags: qe,
      playlistExclusionDuration: Ge,
      enableLowInitialPlaylist: Xe,
      sourceType: ot,
      cacheEncryptionKeys: vt,
      bufferBasedABR: bt,
      leastPixelDiffSelector: Tt,
      captionServices: wt,
      experimentalUseMMS: St
    } = ie;
    if (!me)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    let {
      maxPlaylistRetries: It
    } = ie;
    (It === null || typeof It > "u") && (It = 1 / 0), di = Ue, this.bufferBasedABR = !!bt, this.leastPixelDiffSelector = !!Tt, this.withCredentials = we, this.tech_ = Re, this.vhs_ = Re.vhs, this.player_ = ie.player_, this.sourceType_ = ot, this.useCueTags_ = qe, this.playlistExclusionDuration = Ge, this.maxPlaylistRetries = It, this.enableLowInitialPlaylist = Xe, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
      withCredentials: we,
      maxPlaylistRetries: It,
      timeout: null
    }, this.on("error", this.pauseLoading), this.mediaTypes_ = C2(), St && S.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new S.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, L.log("Using ManagedMediaSource")) : S.MediaSource && (this.mediaSource = new S.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = Be(), this.hasPlayed_ = !1, this.syncController_ = new h2(ie), this.segmentMetadataTrack_ = Re.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, this.segmentMetadataTrack_.mode = "hidden", this.decrypter_ = new m2(), this.sourceUpdater_ = new Np(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new f2(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
    const Pt = {
      vhs: this.vhs_,
      parse708captions: ie.parse708captions,
      useDtsForTimestampOffset: ie.useDtsForTimestampOffset,
      captionServices: wt,
      mediaSource: this.mediaSource,
      currentTime: this.tech_.currentTime.bind(this.tech_),
      seekable: () => this.seekable(),
      seeking: () => this.tech_.seeking(),
      duration: () => this.duration(),
      hasPlayed: () => this.hasPlayed_,
      goalBufferLength: () => this.goalBufferLength(),
      bandwidth: je,
      syncController: this.syncController_,
      decrypter: this.decrypter_,
      sourceType: this.sourceType_,
      inbandTextTracks: this.inbandTextTracks_,
      cacheEncryptionKeys: vt,
      sourceUpdater: this.sourceUpdater_,
      timelineChangeController: this.timelineChangeController_,
      exactManifestTimings: ie.exactManifestTimings,
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    };
    this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new ou(me, this.vhs_, fe$1(this.requestOptions_, {
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    })) : new ns(me, this.vhs_, fe$1(this.requestOptions_, {
      addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
    })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new cu(fe$1(Pt, {
      segmentMetadataTrack: this.segmentMetadataTrack_,
      loaderType: "main"
    }), ie), this.audioSegmentLoader_ = new cu(fe$1(Pt, {
      loaderType: "audio"
    }), ie), this.subtitleSegmentLoader_ = new o2(fe$1(Pt, {
      loaderType: "vtt",
      featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
      loadVttJs: () => new Promise((Jr, en) => {
        function nn() {
          Re.off("vttjserror", ln), Jr();
        }
        function ln() {
          Re.off("vttjsloaded", nn), en();
        }
        Re.one("vttjsloaded", nn), Re.one("vttjserror", ln), Re.addWebVttScript_();
      })
    }), ie);
    const kt = () => this.mainSegmentLoader_.bandwidth;
    this.contentSteeringController_ = new A2(this.vhs_.xhr, kt), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), k2.forEach((Jr) => {
      this[Jr + "_"] = I2.bind(this, Jr);
    }), this.logger_ = yt("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
      this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
    }, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
    const Ot = this.tech_.preload() === "none" ? "play" : "loadstart";
    this.tech_.one(Ot, () => {
      const Jr = Date.now();
      this.tech_.one("loadeddata", () => {
        this.timeToLoadedData__ = Date.now() - Jr, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
      });
    });
  }
  mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  }
  audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  }
  appendsToLoadedData_() {
    const ie = this.mainAppendsToLoadedData_(), me = this.audioAppendsToLoadedData_();
    return ie === -1 || me === -1 ? -1 : ie + me;
  }
  timeToLoadedData_() {
    return this.timeToLoadedData__;
  }
  /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */
  checkABR_(ie = "abr") {
    const me = this.selectPlaylist();
    me && this.shouldSwitchToMedia_(me) && this.switchMedia_(me, ie);
  }
  switchMedia_(ie, me, we) {
    const Re = this.media(), je = Re && (Re.id || Re.uri), Ue = ie && (ie.id || ie.uri);
    if (je && je !== Ue) {
      this.logger_(`switch media ${je} -> ${Ue} from ${me}`);
      const qe = {
        renditionInfo: {
          id: Ue,
          bandwidth: ie.attributes.BANDWIDTH,
          resolution: ie.attributes.RESOLUTION,
          codecs: ie.attributes.CODECS
        },
        cause: me
      };
      this.trigger({
        type: "renditionselected",
        metadata: qe
      }), this.tech_.trigger({
        type: "usage",
        name: `vhs-rendition-change-${me}`
      });
    }
    this.mainPlaylistLoader_.media(ie, we);
  }
  /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */
  switchMediaForDASHContentSteering_() {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((ie) => {
      const me = this.mediaTypes_[ie], we = me ? me.activeGroup() : null, Re = this.contentSteeringController_.getPathway();
      if (we && Re) {
        const je = (we.length ? we[0].playlists : we.playlists).filter((Ue) => Ue.attributes.serviceLocation === Re);
        je.length && this.mediaTypes_[ie].activePlaylistLoader.media(je[0]);
      }
    });
  }
  /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */
  startABRTimer_() {
    this.stopABRTimer_(), this.abrTimer_ = S.setInterval(() => this.checkABR_(), 250);
  }
  /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */
  stopABRTimer_() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (S.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }
  /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */
  getAudioTrackPlaylists_() {
    const ie = this.main(), me = ie && ie.playlists || [];
    if (!ie || !ie.mediaGroups || !ie.mediaGroups.AUDIO)
      return me;
    const we = ie.mediaGroups.AUDIO, Re = Object.keys(we);
    let je;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      je = this.mediaTypes_.AUDIO.activeTrack();
    else {
      const qe = we.main || Re.length && we[Re[0]];
      for (const Ge in qe)
        if (qe[Ge].default) {
          je = {
            label: Ge
          };
          break;
        }
    }
    if (!je)
      return me;
    const Ue = [];
    for (const qe in we)
      if (we[qe][je.label]) {
        const Ge = we[qe][je.label];
        if (Ge.playlists && Ge.playlists.length)
          Ue.push.apply(Ue, Ge.playlists);
        else if (Ge.uri)
          Ue.push(Ge);
        else if (ie.playlists.length)
          for (let Xe = 0; Xe < ie.playlists.length; Xe++) {
            const ot = ie.playlists[Xe];
            ot.attributes && ot.attributes.AUDIO && ot.attributes.AUDIO === qe && Ue.push(ot);
          }
      }
    return Ue.length ? Ue : me;
  }
  /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */
  setupMainPlaylistLoaderListeners_() {
    this.mainPlaylistLoader_.on("loadedmetadata", () => {
      const ie = this.mainPlaylistLoader_.media(), me = ie.targetDuration * 1.5 * 1e3;
      iu(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = me, ie.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(ie, this.requestOptions_), this.mainSegmentLoader_.load()), E2({
        sourceType: this.sourceType_,
        segmentLoaders: {
          AUDIO: this.audioSegmentLoader_,
          SUBTITLES: this.subtitleSegmentLoader_,
          main: this.mainSegmentLoader_
        },
        tech: this.tech_,
        requestOptions: this.requestOptions_,
        mainPlaylistLoader: this.mainPlaylistLoader_,
        vhs: this.vhs_,
        main: this.main(),
        mediaTypes: this.mediaTypes_,
        excludePlaylist: this.excludePlaylist.bind(this)
      }), this.triggerPresenceUsage_(this.main(), ie), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
        this.trigger("selectedinitialmedia");
      });
    }), this.mainPlaylistLoader_.on("loadedplaylist", () => {
      this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
      let ie = this.mainPlaylistLoader_.media();
      if (!ie) {
        this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
        let me;
        if (this.enableLowInitialPlaylist && (me = this.selectInitialPlaylist()), me || (me = this.selectPlaylist()), !me || !this.shouldSwitchToMedia_(me) || (this.initialMedia_ = me, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments)))
          return;
        ie = this.initialMedia_;
      }
      this.handleUpdatedMediaPlaylist(ie);
    }), this.mainPlaylistLoader_.on("error", () => {
      const ie = this.mainPlaylistLoader_.error;
      this.excludePlaylist({
        playlistToExclude: ie.playlist,
        error: ie
      });
    }), this.mainPlaylistLoader_.on("mediachanging", () => {
      this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
    }), this.mainPlaylistLoader_.on("mediachange", () => {
      const ie = this.mainPlaylistLoader_.media(), me = ie.targetDuration * 1.5 * 1e3;
      iu(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = me, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(ie, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.mainPlaylistLoader_.on("playlistunchanged", () => {
      const ie = this.mainPlaylistLoader_.media();
      ie.lastExcludeReason_ !== "playlist-unchanged" && this.stuckAtPlaylistEnd_(ie) && (this.excludePlaylist({
        error: {
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }
      }), this.tech_.trigger("playliststuck"));
    }), this.mainPlaylistLoader_.on("renditiondisabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
    }), this.mainPlaylistLoader_.on("renditionenabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
    }), ["manifestrequeststart", "manifestrequestcomplete", "manifestparsestart", "manifestparsecomplete", "playlistrequeststart", "playlistrequestcomplete", "playlistparsestart", "playlistparsecomplete", "renditiondisabled", "renditionenabled"].forEach((ie) => {
      this.mainPlaylistLoader_.on(ie, (me) => {
        this.player_.trigger(Oe$1({}, me));
      });
    });
  }
  /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */
  handleUpdatedMediaPlaylist(ie) {
    this.useCueTags_ && this.updateAdCues_(ie), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(ie, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!ie.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }
  /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */
  triggerPresenceUsage_(ie, me) {
    const we = ie.mediaGroups || {};
    let Re = !0;
    const je = Object.keys(we.AUDIO);
    for (const Ue in we.AUDIO)
      for (const qe in we.AUDIO[Ue])
        we.AUDIO[Ue][qe].uri || (Re = !1);
    Re && this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), Object.keys(we.SUBTITLES).length && this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), di.Playlist.isAes(me) && this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), je.length && Object.keys(we.AUDIO[je[0]]).length > 1 && this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.useCueTags_ && this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    });
  }
  shouldSwitchToMedia_(ie) {
    const me = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, we = this.tech_.currentTime(), Re = this.bufferLowWaterLine(), je = this.bufferHighWaterLine(), Ue = this.tech_.buffered();
    return P2({
      buffered: Ue,
      currentTime: we,
      currentPlaylist: me,
      nextPlaylist: ie,
      bufferLowWaterLine: Re,
      bufferHighWaterLine: je,
      duration: this.duration(),
      bufferBasedABR: this.bufferBasedABR,
      log: this.logger_
    });
  }
  /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */
  setupSegmentLoaderListeners_() {
    this.mainSegmentLoader_.on("bandwidthupdate", () => {
      this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", () => {
      this.bufferBasedABR && this.mainSegmentLoader_.load();
    }), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
      this.trigger("progress");
    }), this.mainSegmentLoader_.on("error", () => {
      const me = this.mainSegmentLoader_.error();
      this.excludePlaylist({
        playlistToExclude: me.playlist,
        error: me
      });
    }), this.mainSegmentLoader_.on("appenderror", () => {
      this.error = this.mainSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", () => {
      this.error = this.audioSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("ended", () => {
      this.logger_("main segment loader ended"), this.onEndOfStream();
    }), this.timelineChangeController_.on("audioTimelineBehind", () => {
      const me = this.audioSegmentLoader_.pendingSegment_;
      if (!me || !me.segment || !me.segment.syncInfo)
        return;
      const we = me.segment.syncInfo.end + 0.01;
      this.tech_.setCurrentTime(we);
    }), this.timelineChangeController_.on("fixBadTimelineChange", () => {
      this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
    }), this.mainSegmentLoader_.on("earlyabort", (me) => {
      this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
        error: {
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        },
        playlistExclusionDuration: w2
      }));
    });
    const ie = () => {
      if (!this.sourceUpdater_.hasCreatedSourceBuffers())
        return this.tryToCreateSourceBuffers_();
      const me = this.getCodecsOrExclude_();
      me && this.sourceUpdater_.addOrChangeSourceBuffers(me);
    };
    this.mainSegmentLoader_.on("trackinfo", ie), this.audioSegmentLoader_.on("trackinfo", ie), this.mainSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", () => {
      this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
    }), ["segmentselected", "segmentloadstart", "segmentloaded", "segmentkeyloadstart", "segmentkeyloadcomplete", "segmentdecryptionstart", "segmentdecryptioncomplete", "segmenttransmuxingstart", "segmenttransmuxingcomplete", "segmenttransmuxingtrackinfoavailable", "segmenttransmuxingtiminginfoavailable", "segmentappendstart", "appendsdone", "bandwidthupdated", "timelinechange", "codecschange"].forEach((me) => {
      this.mainSegmentLoader_.on(me, (we) => {
        this.player_.trigger(Oe$1({}, we));
      }), this.audioSegmentLoader_.on(me, (we) => {
        this.player_.trigger(Oe$1({}, we));
      }), this.subtitleSegmentLoader_.on(me, (we) => {
        this.player_.trigger(Oe$1({}, we));
      });
    });
  }
  mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }
  /**
   * Call load on our SegmentLoaders
   */
  load() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }
  /**
   * Call pause on our SegmentLoaders
   */
  pause() {
    this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
  }
  /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */
  fastQualityChange_(ie = this.selectPlaylist()) {
    if (ie && ie === this.mainPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(ie, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
  }
  runFastQualitySwitch_() {
    this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * Begin playback.
   */
  play() {
    if (this.setupFirstPlay())
      return;
    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
    const ie = this.tech_.seekable();
    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < ie.start(0))
      return this.tech_.setCurrentTime(ie.end(ie.length - 1));
  }
  /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */
  setupFirstPlay() {
    const ie = this.mainPlaylistLoader_.media();
    if (!ie || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!ie.endList || ie.start) {
      const me = this.seekable();
      if (!me.length)
        return !1;
      const we = me.end(0);
      let Re = we;
      if (ie.start) {
        const je = ie.start.timeOffset;
        je < 0 ? Re = Math.max(we + je, me.start(0)) : Re = Math.min(we, je);
      }
      this.trigger("firstplay"), this.tech_.setCurrentTime(Re);
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }
  /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */
  handleSourceOpen_() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      const ie = this.tech_.play();
      typeof ie < "u" && typeof ie.then == "function" && ie.then(null, (me) => {
      });
    }
    this.trigger("sourceopen");
  }
  /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */
  handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_)
      return;
    const ie = this.inbandTextTracks_.metadataTrack_.cues;
    if (!ie || !ie.length)
      return;
    const me = this.duration();
    ie[ie.length - 1].endTime = isNaN(me) || Math.abs(me) === 1 / 0 ? Number.MAX_VALUE : me;
  }
  /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */
  handleDurationChange_() {
    this.tech_.trigger("durationchange");
  }
  /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */
  onEndOfStream() {
    let ie = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      const me = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !me || me.hasVideo ? ie = ie && this.audioSegmentLoader_.ended_ : ie = this.audioSegmentLoader_.ended_;
    }
    ie && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }
  /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */
  stuckAtPlaylistEnd_(ie) {
    if (!this.seekable().length)
      return !1;
    const me = this.syncController_.getExpiredTime(ie, this.duration());
    if (me === null)
      return !1;
    const we = di.Playlist.playlistEnd(ie, me), Re = this.tech_.currentTime(), je = this.tech_.buffered();
    if (!je.length)
      return we - Re <= Ft;
    const Ue = je.end(je.length - 1);
    return Ue - Re <= Ft && we - Ue <= Ft;
  }
  /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */
  excludePlaylist({
    playlistToExclude: ie = this.mainPlaylistLoader_.media(),
    error: me = {},
    playlistExclusionDuration: we
  }) {
    if (ie = ie || this.mainPlaylistLoader_.media(), we = we || me.playlistExclusionDuration || this.playlistExclusionDuration, !ie) {
      this.error = me, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    ie.playlistErrors_++;
    const Re = this.mainPlaylistLoader_.main.playlists, je = Re.filter(Ua), Ue = je.length === 1 && je[0] === ie;
    if (Re.length === 1 && we !== 1 / 0)
      return L.log.warn(`Problem encountered with playlist ${ie.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(Ue);
    if (Ue) {
      if (this.main().contentSteering) {
        const wt = this.pathwayAttribute_(ie), St = this.contentSteeringController_.steeringManifest.ttl * 1e3;
        this.contentSteeringController_.excludePathway(wt), this.excludeThenChangePathway_(), setTimeout(() => {
          this.contentSteeringController_.addAvailablePathway(wt);
        }, St);
        return;
      }
      let Tt = !1;
      Re.forEach((wt) => {
        if (wt === ie)
          return;
        const St = wt.excludeUntil;
        typeof St < "u" && St !== 1 / 0 && (Tt = !0, delete wt.excludeUntil);
      }), Tt && (L.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    let qe;
    ie.playlistErrors_ > this.maxPlaylistRetries ? qe = 1 / 0 : qe = Date.now() + we * 1e3, ie.excludeUntil = qe, me.reason && (ie.lastExcludeReason_ = me.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-excluded"
    });
    const Ge = this.selectPlaylist();
    if (!Ge) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    const Xe = me.internal ? this.logger_ : L.log.warn, ot = me.message ? " " + me.message : "";
    Xe(`${me.internal ? "Internal problem" : "Problem"} encountered with playlist ${ie.id}.${ot} Switching to playlist ${Ge.id}.`), Ge.attributes.AUDIO !== ie.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), Ge.attributes.SUBTITLES !== ie.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    const vt = Ge.targetDuration / 2 * 1e3 || 5 * 1e3, bt = typeof Ge.lastRequest == "number" && Date.now() - Ge.lastRequest <= vt;
    return this.switchMedia_(Ge, "exclude", Ue || bt);
  }
  /**
   * Pause all segment/playlist loaders
   */
  pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }
  /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */
  delegateLoaders_(ie, me) {
    const we = [], Re = ie === "all";
    (Re || ie === "main") && we.push(this.mainPlaylistLoader_);
    const je = [];
    (Re || ie === "audio") && je.push("AUDIO"), (Re || ie === "subtitle") && (je.push("CLOSED-CAPTIONS"), je.push("SUBTITLES")), je.forEach((Ue) => {
      const qe = this.mediaTypes_[Ue] && this.mediaTypes_[Ue].activePlaylistLoader;
      qe && we.push(qe);
    }), ["main", "audio", "subtitle"].forEach((Ue) => {
      const qe = this[`${Ue}SegmentLoader_`];
      qe && (ie === Ue || ie === "all") && we.push(qe);
    }), we.forEach((Ue) => me.forEach((qe) => {
      typeof Ue[qe] == "function" && Ue[qe]();
    }));
  }
  /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */
  setCurrentTime(ie) {
    const me = rs(this.tech_.buffered(), ie);
    if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments)
      return 0;
    if (me && me.length)
      return ie;
    this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */
  duration() {
    if (!this.mainPlaylistLoader_)
      return 0;
    const ie = this.mainPlaylistLoader_.media();
    return ie ? ie.endList ? this.mediaSource ? this.mediaSource.duration : di.Playlist.duration(ie) : 1 / 0 : 0;
  }
  /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */
  seekable() {
    return this.seekable_;
  }
  getSeekableRange_(ie, me) {
    const we = ie.media();
    if (!we)
      return null;
    const Re = this.syncController_.getMediaSequenceSync(me);
    if (Re && Re.isReliable) {
      const qe = Re.start, Ge = Re.end;
      if (!isFinite(qe) || !isFinite(Ge))
        return null;
      const Xe = di.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, we), ot = Math.max(qe, Ge - Xe);
      return Be([[qe, ot]]);
    }
    const je = this.syncController_.getExpiredTime(we, this.duration());
    if (je === null)
      return null;
    const Ue = di.Playlist.seekable(we, je, di.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, we));
    return Ue.length ? Ue : null;
  }
  computeFinalSeekable_(ie, me) {
    if (!me)
      return ie;
    const we = ie.start(0), Re = ie.end(0), je = me.start(0), Ue = me.end(0);
    return je > Re || we > Ue ? ie : Be([[Math.max(we, je), Math.min(Re, Ue)]]);
  }
  onSyncInfoUpdate_() {
    if (!this.mainPlaylistLoader_)
      return;
    const ie = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
    if (!ie)
      return;
    let me;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader && (me = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !me))
      return;
    const we = this.seekable_;
    if (this.seekable_ = this.computeFinalSeekable_(ie, me), !this.seekable_ || we && we.length && this.seekable_.length && we.start(0) === this.seekable_.start(0) && we.end(0) === this.seekable_.end(0))
      return;
    this.logger_(`seekable updated [${Kf(this.seekable_)}]`);
    const Re = {
      seekableRanges: this.seekable_
    };
    this.trigger({
      type: "seekablerangeschanged",
      metadata: Re
    }), this.tech_.trigger("seekablechanged");
  }
  /**
   * Update the player duration
   */
  updateDuration(ie) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, ie), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (ie) {
      const Re = this.seekable();
      if (!Re.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < Re.end(Re.length - 1)) && this.sourceUpdater_.setDuration(Re.end(Re.length - 1));
      return;
    }
    const me = this.tech_.buffered();
    let we = di.Playlist.duration(this.mainPlaylistLoader_.media());
    me.length > 0 && (we = Math.max(we, me.end(me.length - 1))), this.mediaSource.duration !== we && this.sourceUpdater_.setDuration(we);
  }
  /**
   * dispose of the PlaylistController and everything
   * that it controls
   */
  dispose() {
    this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((ie) => {
      const me = this.mediaTypes_[ie].groups;
      for (const we in me)
        me[we].forEach((Re) => {
          Re.playlistLoader && Re.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }
  /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */
  main() {
    return this.mainPlaylistLoader_.main;
  }
  /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */
  media() {
    return this.mainPlaylistLoader_.media() || this.initialMedia_;
  }
  areMediaTypesKnown_() {
    const ie = !!this.mediaTypes_.AUDIO.activePlaylistLoader, me = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), we = ie ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!me || !we);
  }
  // find from and to for codec switch event
  getCodecsOrExclude_() {
    const ie = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, me = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    ie.video = ie.main;
    const we = Or(this.main(), me), Re = {}, je = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (ie.main.hasVideo && (Re.video = we.video || ie.main.videoCodec || Y0), ie.main.isMuxed && (Re.video += `,${we.audio || ie.main.audioCodec || cc}`), (ie.main.hasAudio && !ie.main.isMuxed || ie.audio.hasAudio || je) && (Re.audio = we.audio || ie.main.audioCodec || ie.audio.audioCodec || cc, ie.audio.isFmp4 = ie.main.hasAudio && !ie.main.isMuxed ? ie.main.isFmp4 : ie.audio.isFmp4), !Re.audio && !Re.video) {
      this.excludePlaylist({
        playlistToExclude: me,
        error: {
          message: "Could not determine codecs for playlist."
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    const Ue = (Xe, ot) => Xe ? Dr(ot, this.usingManagedMediaSource_) : yo(ot), qe = {};
    let Ge;
    if (["video", "audio"].forEach(function(Xe) {
      if (Re.hasOwnProperty(Xe) && !Ue(ie[Xe].isFmp4, Re[Xe])) {
        const ot = ie[Xe].isFmp4 ? "browser" : "muxer";
        qe[ot] = qe[ot] || [], qe[ot].push(Re[Xe]), Xe === "audio" && (Ge = ot);
      }
    }), je && Ge && me.attributes.AUDIO) {
      const Xe = me.attributes.AUDIO;
      this.main().playlists.forEach((ot) => {
        (ot.attributes && ot.attributes.AUDIO) === Xe && ot !== me && (ot.excludeUntil = 1 / 0);
      }), this.logger_(`excluding audio group ${Xe} as ${Ge} does not support codec(s): "${Re.audio}"`);
    }
    if (Object.keys(qe).length) {
      const Xe = Object.keys(qe).reduce((ot, vt) => (ot && (ot += ", "), ot += `${vt} does not support codec(s): "${qe[vt].join(",")}"`, ot), "") + ".";
      this.excludePlaylist({
        playlistToExclude: me,
        error: {
          internal: !0,
          message: Xe
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      const Xe = [];
      if (["video", "audio"].forEach((ot) => {
        const vt = (Rt(this.sourceUpdater_.codecs[ot] || "")[0] || {}).type, bt = (Rt(Re[ot] || "")[0] || {}).type;
        vt && bt && vt.toLowerCase() !== bt.toLowerCase() && Xe.push(`"${this.sourceUpdater_.codecs[ot]}" -> "${Re[ot]}"`);
      }), Xe.length) {
        this.excludePlaylist({
          playlistToExclude: me,
          error: {
            message: `Codec switching not supported: ${Xe.join(", ")}.`,
            internal: !0
          },
          playlistExclusionDuration: 1 / 0
        });
        return;
      }
    }
    return Re;
  }
  /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */
  tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_())
      return;
    const ie = this.getCodecsOrExclude_();
    if (!ie)
      return;
    this.sourceUpdater_.createSourceBuffers(ie);
    const me = [ie.video, ie.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(me);
  }
  /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */
  excludeUnsupportedVariants_() {
    const ie = this.main().playlists, me = [];
    Object.keys(ie).forEach((we) => {
      const Re = ie[we];
      if (me.indexOf(Re.id) !== -1)
        return;
      me.push(Re.id);
      const je = Or(this.main, Re), Ue = [];
      je.audio && !yo(je.audio) && !Dr(je.audio, this.usingManagedMediaSource_) && Ue.push(`audio codec ${je.audio}`), je.video && !yo(je.video) && !Dr(je.video, this.usingManagedMediaSource_) && Ue.push(`video codec ${je.video}`), je.text && je.text === "stpp.ttml.im1t" && Ue.push(`text codec ${je.text}`), Ue.length && (Re.excludeUntil = 1 / 0, this.logger_(`excluding ${Re.id} for unsupported: ${Ue.join(", ")}`));
    });
  }
  /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */
  excludeIncompatibleVariants_(ie) {
    const me = [], we = this.main().playlists, Re = $r(Rt(ie)), je = ld(Re), Ue = Re.video && Rt(Re.video)[0] || null, qe = Re.audio && Rt(Re.audio)[0] || null;
    Object.keys(we).forEach((Ge) => {
      const Xe = we[Ge];
      if (me.indexOf(Xe.id) !== -1 || Xe.excludeUntil === 1 / 0)
        return;
      me.push(Xe.id);
      const ot = [], vt = Or(this.mainPlaylistLoader_.main, Xe), bt = ld(vt);
      if (!(!vt.audio && !vt.video)) {
        if (bt !== je && ot.push(`codec count "${bt}" !== "${je}"`), !this.sourceUpdater_.canChangeType()) {
          const Tt = vt.video && Rt(vt.video)[0] || null, wt = vt.audio && Rt(vt.audio)[0] || null;
          Tt && Ue && Tt.type.toLowerCase() !== Ue.type.toLowerCase() && ot.push(`video codec "${Tt.type}" !== "${Ue.type}"`), wt && qe && wt.type.toLowerCase() !== qe.type.toLowerCase() && ot.push(`audio codec "${wt.type}" !== "${qe.type}"`);
        }
        ot.length && (Xe.excludeUntil = 1 / 0, this.logger_(`excluding ${Xe.id}: ${ot.join(" && ")}`));
      }
    });
  }
  updateAdCues_(ie) {
    let me = 0;
    const we = this.seekable();
    we.length && (me = we.start(0)), l2(ie, this.cueTagsTrack_, me);
  }
  /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */
  goalBufferLength() {
    const ie = this.tech_.currentTime(), me = Me.GOAL_BUFFER_LENGTH, we = Me.GOAL_BUFFER_LENGTH_RATE, Re = Math.max(me, Me.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(me + ie * we, Re);
  }
  /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */
  bufferLowWaterLine() {
    const ie = this.tech_.currentTime(), me = Me.BUFFER_LOW_WATER_LINE, we = Me.BUFFER_LOW_WATER_LINE_RATE, Re = Math.max(me, Me.MAX_BUFFER_LOW_WATER_LINE), je = Math.max(me, Me.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(me + ie * we, this.bufferBasedABR ? je : Re);
  }
  bufferHighWaterLine() {
    return Me.BUFFER_HIGH_WATER_LINE;
  }
  addDateRangesToTextTrack_(ie) {
    _d(this.inbandTextTracks_, "com.apple.streaming", this.tech_), qb({
      inbandTextTracks: this.inbandTextTracks_,
      dateRanges: ie
    });
  }
  addMetadataToTextTrack(ie, me, we) {
    const Re = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
    _d(this.inbandTextTracks_, ie, this.tech_), Ub({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: me,
      timestampOffset: Re,
      videoDuration: we
    });
  }
  /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */
  pathwayAttribute_(ie) {
    return ie.attributes["PATHWAY-ID"] || ie.attributes.serviceLocation;
  }
  /**
   * Initialize available pathways and apply the tag properties.
   */
  initContentSteeringController_() {
    const ie = this.main();
    if (ie.contentSteering) {
      for (const me of ie.playlists)
        this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(me));
      if (this.contentSteeringController_.assignTagProperties(ie.uri, ie.contentSteering), this.contentSteeringController_.queryBeforeStart) {
        this.contentSteeringController_.requestSteeringManifest(!0);
        return;
      }
      this.tech_.one("canplay", () => {
        this.contentSteeringController_.requestSteeringManifest();
      });
    }
  }
  /**
   * Reset the content steering controller and re-init.
   */
  resetContentSteeringController_() {
    this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
  }
  /**
   * Attaches the listeners for content steering.
   */
  attachContentSteeringListeners_() {
    this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), ["contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"].forEach((ie) => {
      this.contentSteeringController_.on(ie, (me) => {
        this.trigger(Oe$1({}, me));
      });
    }), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
      const ie = this.main();
      (this.contentSteeringController_.didDASHTagChange(ie.uri, ie.contentSteering) || (() => {
        const me = this.contentSteeringController_.getAvailablePathways(), we = [];
        for (const Re of ie.playlists) {
          const je = Re.attributes.serviceLocation;
          if (je && (we.push(je), !me.has(je)))
            return !0;
        }
        return !!(!we.length && me.size);
      })()) && this.resetContentSteeringController_();
    });
  }
  /**
   * Simple exclude and change playlist logic for content steering.
   */
  excludeThenChangePathway_() {
    const ie = this.contentSteeringController_.getPathway();
    if (!ie)
      return;
    this.handlePathwayClones_();
    const me = this.main().playlists, we = /* @__PURE__ */ new Set();
    let Re = !1;
    Object.keys(me).forEach((je) => {
      const Ue = me[je], qe = this.pathwayAttribute_(Ue), Ge = qe && ie !== qe;
      Ue.excludeUntil === 1 / 0 && Ue.lastExcludeReason_ === "content-steering" && !Ge && (delete Ue.excludeUntil, delete Ue.lastExcludeReason_, Re = !0);
      const Xe = !Ue.excludeUntil && Ue.excludeUntil !== 1 / 0;
      !we.has(Ue.id) && Ge && Xe && (we.add(Ue.id), Ue.excludeUntil = 1 / 0, Ue.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${Ue.id} for ${Ue.lastExcludeReason_}`));
    }), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((je) => {
      const Ue = this.mediaTypes_[je];
      if (Ue.activePlaylistLoader) {
        const qe = Ue.activePlaylistLoader.media_;
        qe && qe.attributes.serviceLocation !== ie && (Re = !0);
      }
    }), Re && this.changeSegmentPathway_();
  }
  /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */
  handlePathwayClones_() {
    const ie = this.main().playlists, me = this.contentSteeringController_.currentPathwayClones, we = this.contentSteeringController_.nextPathwayClones;
    if (me && me.size || we && we.size) {
      for (const [Re, je] of me.entries())
        we.get(Re) || (this.mainPlaylistLoader_.updateOrDeleteClone(je), this.contentSteeringController_.excludePathway(Re));
      for (const [Re, je] of we.entries()) {
        const Ue = me.get(Re);
        if (!Ue) {
          ie.filter((qe) => qe.attributes["PATHWAY-ID"] === je["BASE-ID"]).forEach((qe) => {
            this.mainPlaylistLoader_.addClonePathway(je, qe);
          }), this.contentSteeringController_.addAvailablePathway(Re);
          continue;
        }
        this.equalPathwayClones_(Ue, je) || (this.mainPlaylistLoader_.updateOrDeleteClone(je, !0), this.contentSteeringController_.addAvailablePathway(Re));
      }
      this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...we])));
    }
  }
  /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */
  equalPathwayClones_(ie, me) {
    if (ie["BASE-ID"] !== me["BASE-ID"] || ie.ID !== me.ID || ie["URI-REPLACEMENT"].HOST !== me["URI-REPLACEMENT"].HOST)
      return !1;
    const we = ie["URI-REPLACEMENT"].PARAMS, Re = me["URI-REPLACEMENT"].PARAMS;
    for (const je in we)
      if (we[je] !== Re[je])
        return !1;
    for (const je in Re)
      if (we[je] !== Re[je])
        return !1;
    return !0;
  }
  /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */
  changeSegmentPathway_() {
    const ie = this.selectPlaylist();
    this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(ie, "content-steering");
  }
  /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */
  excludeNonUsablePlaylistsByKeyId_() {
    if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main)
      return;
    let ie = 0;
    const me = "non-usable";
    this.mainPlaylistLoader_.main.playlists.forEach((we) => {
      const Re = this.mainPlaylistLoader_.getKeyIdSet(we);
      !Re || !Re.size || Re.forEach((je) => {
        const Ue = "usable", qe = this.keyStatusMap_.has(je) && this.keyStatusMap_.get(je) === Ue, Ge = we.lastExcludeReason_ === me && we.excludeUntil === 1 / 0;
        qe ? qe && Ge && (delete we.excludeUntil, delete we.lastExcludeReason_, this.logger_(`enabling playlist ${we.id} because key ID ${je} is ${Ue}`)) : (we.excludeUntil !== 1 / 0 && we.lastExcludeReason_ !== me && (we.excludeUntil = 1 / 0, we.lastExcludeReason_ = me, this.logger_(`excluding playlist ${we.id} because the key ID ${je} doesn't exist in the keyStatusMap or is not ${Ue}`)), ie++);
      });
    }), ie >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((we) => {
      const Re = we && we.attributes && we.attributes.RESOLUTION && we.attributes.RESOLUTION.height < 720, je = we.excludeUntil === 1 / 0 && we.lastExcludeReason_ === me;
      Re && je && (delete we.excludeUntil, L.log.warn(`enabling non-HD playlist ${we.id} because all playlists were excluded due to ${me} key IDs`));
    });
  }
  /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */
  addKeyStatus_(ie, me) {
    const we = (typeof ie == "string" ? ie : n2(ie)).slice(0, 32).toLowerCase();
    this.logger_(`KeyStatus '${me}' with key ID ${we} added to the keyStatusMap`), this.keyStatusMap_.set(we, me);
  }
  /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */
  updatePlaylistByKeyStatus(ie, me) {
    this.addKeyStatus_(ie, me), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
  }
  excludeNonUsableThenChangePlaylist_() {
    this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
  }
}
const L2 = (ce, ie, me) => (we) => {
  const Re = ce.main.playlists[ie], je = ol(Re), Ue = Ua(Re);
  if (typeof we > "u")
    return Ue;
  we ? delete Re.disabled : Re.disabled = !0;
  const qe = {
    renditionInfo: {
      id: ie,
      bandwidth: Re.attributes.BANDWIDTH,
      resolution: Re.attributes.RESOLUTION,
      codecs: Re.attributes.CODECS
    },
    cause: "fast-quality"
  };
  return we !== Ue && !je && (we ? (me(Re), ce.trigger({
    type: "renditionenabled",
    metadata: qe
  })) : ce.trigger({
    type: "renditiondisabled",
    metadata: qe
  })), we;
};
class R2 {
  constructor(ie, me, we) {
    const {
      playlistController_: Re
    } = ie, je = Re.fastQualityChange_.bind(Re);
    if (me.attributes) {
      const Ue = me.attributes.RESOLUTION;
      this.width = Ue && Ue.width, this.height = Ue && Ue.height, this.bandwidth = me.attributes.BANDWIDTH, this.frameRate = me.attributes["FRAME-RATE"];
    }
    this.codecs = Or(Re.main(), me), this.playlist = me, this.id = we, this.enabled = L2(ie.playlists, me.id, je);
  }
}
const M2 = function(ce) {
  ce.representations = () => {
    const ie = ce.playlistController_.main(), me = Qr(ie) ? ce.playlistController_.getAudioTrackPlaylists_() : ie.playlists;
    return me ? me.filter((we) => !ol(we)).map((we, Re) => new R2(ce, we, we.id)) : [];
  };
}, wd = ["seeking", "seeked", "pause", "playing", "error"];
class N2 extends L.EventTarget {
  /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */
  constructor(ie) {
    super(), this.playlistController_ = ie.playlistController, this.tech_ = ie.tech, this.seekable = ie.seekable, this.allowSeeksWithinUnsafeLiveWindow = ie.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = ie.liveRangeSafeTimeDelta, this.media = ie.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = yt("PlaybackWatcher"), this.logger_("initialize");
    const me = () => this.monitorCurrentTime_(), we = () => this.monitorCurrentTime_(), Re = () => this.techWaiting_(), je = () => this.resetTimeUpdate_(), Ue = this.playlistController_, qe = ["main", "subtitle", "audio"], Ge = {};
    qe.forEach((ot) => {
      Ge[ot] = {
        reset: () => this.resetSegmentDownloads_(ot),
        updateend: () => this.checkSegmentDownloads_(ot)
      }, Ue[`${ot}SegmentLoader_`].on("appendsdone", Ge[ot].updateend), Ue[`${ot}SegmentLoader_`].on("playlistupdate", Ge[ot].reset), this.tech_.on(["seeked", "seeking"], Ge[ot].reset);
    });
    const Xe = (ot) => {
      ["main", "audio"].forEach((vt) => {
        Ue[`${vt}SegmentLoader_`][ot]("appended", this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = () => {
      this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), Xe("off"));
    }, this.clearSeekingAppendCheck_ = () => Xe("off"), this.watchForBadSeeking_ = () => {
      this.clearSeekingAppendCheck_(), Xe("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", Re), this.tech_.on(wd, je), this.tech_.on("canplay", we), this.tech_.one("play", me), this.dispose = () => {
      this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", Re), this.tech_.off(wd, je), this.tech_.off("canplay", we), this.tech_.off("play", me), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), qe.forEach((ot) => {
        Ue[`${ot}SegmentLoader_`].off("appendsdone", Ge[ot].updateend), Ue[`${ot}SegmentLoader_`].off("playlistupdate", Ge[ot].reset), this.tech_.off(["seeked", "seeking"], Ge[ot].reset);
      }), this.checkCurrentTimeTimeout_ && S.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
    };
  }
  /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */
  monitorCurrentTime_() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && S.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = S.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }
  /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */
  resetSegmentDownloads_(ie) {
    const me = this.playlistController_[`${ie}SegmentLoader_`];
    this[`${ie}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${ie} loader`), this[`${ie}StalledDownloads_`] = 0, this[`${ie}Buffered_`] = me.buffered_();
  }
  /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */
  checkSegmentDownloads_(ie) {
    const me = this.playlistController_, we = me[`${ie}SegmentLoader_`], Re = we.buffered_(), je = bv(this[`${ie}Buffered_`], Re);
    if (this[`${ie}Buffered_`] = Re, je) {
      const Ue = {
        bufferedRanges: Re
      };
      me.trigger({
        type: "bufferedrangeschanged",
        metadata: Ue
      }), this.resetSegmentDownloads_(ie);
      return;
    }
    this[`${ie}StalledDownloads_`]++, this.logger_(`found #${this[`${ie}StalledDownloads_`]} ${ie} appends that did not increase buffer (possible stalled download)`, {
      playlistId: we.playlist_ && we.playlist_.id,
      buffered: wi(Re)
    }), !(this[`${ie}StalledDownloads_`] < 10) && (this.logger_(`${ie} loader stalled download exclusion`), this.resetSegmentDownloads_(ie), this.tech_.trigger({
      type: "usage",
      name: `vhs-${ie}-download-exclusion`
    }), ie !== "subtitle" && me.excludePlaylist({
      error: {
        message: `Excessive ${ie} segment downloading detected.`
      },
      playlistExclusionDuration: 1 / 0
    }));
  }
  /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */
  checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking())
      return;
    const ie = this.tech_.currentTime(), me = this.tech_.buffered();
    if (this.lastRecordedTime === ie && (!me.length || ie + Ft >= me.end(me.length - 1)))
      return this.techWaiting_();
    if (this.consecutiveUpdates >= 5 && ie === this.lastRecordedTime)
      this.consecutiveUpdates++, this.waiting_();
    else if (ie === this.lastRecordedTime)
      this.consecutiveUpdates++;
    else {
      this.playedRanges_.push(Be([this.lastRecordedTime, ie]));
      const we = {
        playedRanges: this.playedRanges_
      };
      this.playlistController_.trigger({
        type: "playedrangeschanged",
        metadata: we
      }), this.consecutiveUpdates = 0, this.lastRecordedTime = ie;
    }
  }
  /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */
  resetTimeUpdate_() {
    this.consecutiveUpdates = 0;
  }
  /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */
  fixesBadSeeks_() {
    if (!this.tech_.seeking())
      return !1;
    const ie = this.seekable(), me = this.tech_.currentTime(), we = this.afterSeekableWindow_(ie, me, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    let Re;
    if (we && (Re = ie.end(ie.length - 1)), this.beforeSeekableWindow_(ie, me)) {
      const Tt = ie.start(0);
      Re = Tt + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (Tt === ie.end(0) ? 0 : Ft);
    }
    if (typeof Re < "u")
      return this.logger_(`Trying to seek outside of seekable at time ${me} with seekable range ${Kf(ie)}. Seeking to ${Re}.`), this.tech_.setCurrentTime(Re), !0;
    const je = this.playlistController_.sourceUpdater_, Ue = this.tech_.buffered(), qe = je.audioBuffer ? je.audioBuffered() : null, Ge = je.videoBuffer ? je.videoBuffered() : null, Xe = this.media(), ot = Xe.partTargetDuration ? Xe.partTargetDuration : (Xe.targetDuration - Bt) * 2, vt = [qe, Ge];
    for (let Tt = 0; Tt < vt.length; Tt++)
      if (vt[Tt] && nl(vt[Tt], me) < ot)
        return !1;
    const bt = Mn(Ue, me);
    return bt.length === 0 ? !1 : (Re = bt.start(0) + Ft, this.logger_(`Buffered region starts (${bt.start(0)})  just beyond seek point (${me}). Seeking to ${Re}.`), this.tech_.setCurrentTime(Re), !0);
  }
  /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */
  waiting_() {
    if (this.techWaiting_())
      return;
    const ie = this.tech_.currentTime(), me = this.tech_.buffered(), we = rs(me, ie);
    if (we.length && ie + 3 <= we.end(0)) {
      this.resetTimeUpdate_(), this.tech_.setCurrentTime(ie), this.logger_(`Stopped at ${ie} while inside a buffered region [${we.start(0)} -> ${we.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      return;
    }
  }
  /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */
  techWaiting_() {
    const ie = this.seekable(), me = this.tech_.currentTime();
    if (this.tech_.seeking())
      return !0;
    if (this.beforeSeekableWindow_(ie, me)) {
      const Ue = ie.end(ie.length - 1);
      return this.logger_(`Fell out of live window at time ${me}. Seeking to live point (seekable end) ${Ue}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(Ue), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), !0;
    }
    const we = this.tech_.vhs.playlistController_.sourceUpdater_, Re = this.tech_.buffered();
    if (this.videoUnderflow_({
      audioBuffered: we.audioBuffered(),
      videoBuffered: we.videoBuffered(),
      currentTime: me
    }))
      return this.resetTimeUpdate_(), this.tech_.setCurrentTime(me), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), !0;
    const je = Mn(Re, me);
    return je.length > 0 ? (this.logger_(`Stopped at ${me} and seeking to ${je.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(me), !0) : !1;
  }
  afterSeekableWindow_(ie, me, we, Re = !1) {
    if (!ie.length)
      return !1;
    let je = ie.end(ie.length - 1) + Ft;
    const Ue = !we.endList, qe = typeof we.partTargetDuration == "number";
    return Ue && (qe || Re) && (je = ie.end(ie.length - 1) + we.targetDuration * 3), me > je;
  }
  beforeSeekableWindow_(ie, me) {
    return !!(ie.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    ie.start(0) > 0 && me < ie.start(0) - this.liveRangeSafeTimeDelta);
  }
  videoUnderflow_({
    videoBuffered: ie,
    audioBuffered: me,
    currentTime: we
  }) {
    if (!ie)
      return;
    let Re;
    if (ie.length && me.length) {
      const je = rs(ie, we - 3), Ue = rs(ie, we), qe = rs(me, we);
      qe.length && !Ue.length && je.length && (Re = {
        start: je.end(0),
        end: qe.end(0)
      });
    } else
      Mn(ie, we).length || (Re = this.gapFromVideoUnderflow_(ie, we));
    return Re ? (this.logger_(`Encountered a gap in video from ${Re.start} to ${Re.end}. Seeking to current time ${we}`), !0) : !1;
  }
  /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */
  skipTheGap_(ie) {
    const me = this.tech_.buffered(), we = this.tech_.currentTime(), Re = Mn(me, we);
    if (this.resetTimeUpdate_(), Re.length === 0 || we !== ie)
      return;
    this.logger_("skipTheGap_:", "currentTime:", we, "scheduled currentTime:", ie, "nextRange start:", Re.start(0)), this.tech_.setCurrentTime(Re.start(0) + Bt);
    const je = {
      gapInfo: {
        from: we,
        to: Re.start(0)
      }
    };
    this.playlistController_.trigger({
      type: "gapjumped",
      metadata: je
    }), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
  }
  gapFromVideoUnderflow_(ie, me) {
    const we = yv(ie);
    for (let Re = 0; Re < we.length; Re++) {
      const je = we.start(Re), Ue = we.end(Re);
      if (me - je < 4 && me - je > 2)
        return {
          start: je,
          end: Ue
        };
    }
    return null;
  }
}
const B2 = {
  errorInterval: 30,
  getSource(ce) {
    const ie = this.tech({
      IWillNotUseThisInPlugins: !0
    }).currentSource_ || this.currentSource();
    return ce(ie);
  }
}, $p = function(ce, ie) {
  let me = 0, we = 0;
  const Re = fe$1(B2, ie);
  ce.ready(() => {
    ce.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
  });
  const je = function() {
    we && ce.currentTime(we);
  }, Ue = function(ot) {
    ot != null && (we = ce.duration() !== 1 / 0 && ce.currentTime() || 0, ce.one("loadedmetadata", je), ce.src(ot), ce.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), ce.play());
  }, qe = function() {
    if (Date.now() - me < Re.errorInterval * 1e3) {
      ce.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      return;
    }
    if (!Re.getSource || typeof Re.getSource != "function") {
      L.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return me = Date.now(), Re.getSource.call(ce, Ue);
  }, Ge = function() {
    ce.off("loadedmetadata", je), ce.off("error", qe), ce.off("dispose", Ge);
  }, Xe = function(ot) {
    Ge(), $p(ce, ot);
  };
  ce.on("error", qe), ce.on("dispose", Ge), ce.reloadSourceOnError = Xe;
}, F2 = function(ce) {
  $p(this, ce);
};
var jp = "3.17.0", U2 = "7.1.0", $2 = "1.3.1", j2 = "7.2.0", q2 = "4.0.2";
const Ce = {
  PlaylistLoader: ns,
  Playlist: st,
  utils: Gv,
  STANDARD_PLAYLIST_SELECTOR: gd,
  INITIAL_PLAYLIST_SELECTOR: Rb,
  lastBandwidthSelector: gd,
  movingAverageBandwidthSelector: Ob,
  comparePlaylistBandwidth: cl,
  comparePlaylistResolution: Pb,
  xhr: pp()
};
Object.keys(Me).forEach((ce) => {
  Object.defineProperty(Ce, ce, {
    get() {
      return L.log.warn(`using Vhs.${ce} is UNSAFE be sure you know what you are doing`), Me[ce];
    },
    set(ie) {
      if (L.log.warn(`using Vhs.${ce} is UNSAFE be sure you know what you are doing`), typeof ie != "number" || ie < 0) {
        L.log.warn(`value of Vhs.${ce} must be greater than or equal to 0`);
        return;
      }
      Me[ce] = ie;
    }
  });
});
const qp = "videojs-vhs", Vp = function(ce, ie) {
  const me = ie.media();
  let we = -1;
  for (let Re = 0; Re < ce.length; Re++)
    if (ce[Re].id === me.id) {
      we = Re;
      break;
    }
  ce.selectedIndex_ = we, ce.trigger({
    selectedIndex: we,
    type: "change"
  });
}, V2 = function(ce, ie) {
  ie.representations().forEach((me) => {
    ce.addQualityLevel(me);
  }), Vp(ce, ie.playlists);
};
Ce.canPlaySource = function() {
  return L.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const H2 = (ce, ie, me) => {
  if (!ce)
    return ce;
  let we = {};
  ie && ie.attributes && ie.attributes.CODECS && (we = $r(Rt(ie.attributes.CODECS))), me && me.attributes && me.attributes.CODECS && (we.audio = me.attributes.CODECS);
  const Re = ms(we.video), je = ms(we.audio), Ue = {};
  for (const qe in ce)
    Ue[qe] = {}, je && (Ue[qe].audioContentType = je), Re && (Ue[qe].videoContentType = Re), ie.contentProtection && ie.contentProtection[qe] && ie.contentProtection[qe].pssh && (Ue[qe].pssh = ie.contentProtection[qe].pssh), typeof ce[qe] == "string" && (Ue[qe].url = ce[qe]);
  return fe$1(ce, Ue);
}, z2 = (ce, ie) => ce.reduce((me, we) => {
  if (!we.contentProtection)
    return me;
  const Re = ie.reduce((je, Ue) => {
    const qe = we.contentProtection[Ue];
    return qe && qe.pssh && (je[Ue] = {
      pssh: qe.pssh
    }), je;
  }, {});
  return Object.keys(Re).length && me.push(Re), me;
}, []), W2 = ({
  player: ce,
  sourceKeySystems: ie,
  audioMedia: me,
  mainPlaylists: we
}) => {
  if (!ce.eme.initializeMediaKeys)
    return Promise.resolve();
  const Re = me ? we.concat([me]) : we, je = z2(Re, Object.keys(ie)), Ue = [], qe = [];
  return je.forEach((Ge) => {
    qe.push(new Promise((Xe, ot) => {
      ce.tech_.one("keysessioncreated", Xe);
    })), Ue.push(new Promise((Xe, ot) => {
      ce.eme.initializeMediaKeys({
        keySystems: Ge
      }, (vt) => {
        if (vt) {
          ot(vt);
          return;
        }
        Xe();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(Ue),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(qe)
  ]);
}, G2 = ({
  player: ce,
  sourceKeySystems: ie,
  media: me,
  audioMedia: we
}) => {
  const Re = H2(ie, me, we);
  return Re ? (ce.currentSource().keySystems = Re, Re && !ce.eme ? (L.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, Hp = () => {
  if (!S.localStorage)
    return null;
  const ce = S.localStorage.getItem(qp);
  if (!ce)
    return null;
  try {
    return JSON.parse(ce);
  } catch {
    return null;
  }
}, X2 = (ce) => {
  if (!S.localStorage)
    return !1;
  let ie = Hp();
  ie = ie ? fe$1(ie, ce) : ce;
  try {
    S.localStorage.setItem(qp, JSON.stringify(ie));
  } catch {
    return !1;
  }
  return ie;
}, K2 = (ce) => ce.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(ce.substring(ce.indexOf(",") + 1)) : ce, zp = (ce, ie) => {
  ce._requestCallbackSet || (ce._requestCallbackSet = /* @__PURE__ */ new Set()), ce._requestCallbackSet.add(ie);
}, Wp = (ce, ie) => {
  ce._responseCallbackSet || (ce._responseCallbackSet = /* @__PURE__ */ new Set()), ce._responseCallbackSet.add(ie);
}, Gp = (ce, ie) => {
  ce._requestCallbackSet && (ce._requestCallbackSet.delete(ie), ce._requestCallbackSet.size || delete ce._requestCallbackSet);
}, Xp = (ce, ie) => {
  ce._responseCallbackSet && (ce._responseCallbackSet.delete(ie), ce._responseCallbackSet.size || delete ce._responseCallbackSet);
};
Ce.supportsNativeHls = function() {
  if (!V$1 || !V$1.createElement)
    return !1;
  const ce = V$1.createElement("video");
  return L.getTech("Html5").isSupported() ? [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ].some(function(ie) {
    return /maybe|probably/i.test(ce.canPlayType(ie));
  }) : !1;
}();
Ce.supportsNativeDash = function() {
  return !V$1 || !V$1.createElement || !L.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(V$1.createElement("video").canPlayType("application/dash+xml"));
}();
Ce.supportsTypeNatively = (ce) => ce === "hls" ? Ce.supportsNativeHls : ce === "dash" ? Ce.supportsNativeDash : !1;
Ce.isSupported = function() {
  return L.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
Ce.xhr.onRequest = function(ce) {
  zp(Ce.xhr, ce);
};
Ce.xhr.onResponse = function(ce) {
  Wp(Ce.xhr, ce);
};
Ce.xhr.offRequest = function(ce) {
  Gp(Ce.xhr, ce);
};
Ce.xhr.offResponse = function(ce) {
  Xp(Ce.xhr, ce);
};
const Y2 = L.getComponent("Component");
class Kp extends Y2 {
  constructor(ie, me, we) {
    if (super(me, we.vhs), typeof we.initialBandwidth == "number" && (this.options_.bandwidth = we.initialBandwidth), this.logger_ = yt("VhsHandler"), me.options_ && me.options_.playerId) {
      const Re = L.getPlayer(me.options_.playerId);
      this.player_ = Re;
    }
    if (this.tech_ = me, this.source_ = ie, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && me.overrideNativeAudioTracks && me.overrideNativeVideoTracks)
      me.overrideNativeAudioTracks(!0), me.overrideNativeVideoTracks(!0);
    else if (this.options_.overrideNative && (me.featuresNativeVideoTracks || me.featuresNativeAudioTracks))
      throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
    this.on(V$1, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], (Re) => {
      const je = V$1.fullscreenElement || V$1.webkitFullscreenElement || V$1.mozFullScreenElement || V$1.msFullscreenElement;
      je && je.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
    }), this.on(this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), this.on(this.tech_, "error", function() {
      this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
    }), this.on(this.tech_, "play", this.play);
  }
  /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */
  setOptions_(ie = {}) {
    if (this.options_ = fe$1(this.options_, ie), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = typeof this.options_.useNetworkInformationApi < "u" ? this.options_.useNetworkInformationApi : !0, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      const we = Hp();
      we && we.bandwidth && (this.options_.bandwidth = we.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      })), we && we.throughput && (this.options_.throughput = we.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Me.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Me.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "usePlayerObjectFit", "customPixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "customTagParsers", "customTagMappers", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "bufferBasedABR", "liveRangeSafeTimeDelta", "llhls", "useForcedSubtitles", "useNetworkInformationApi", "useDtsForTimestampOffset", "exactManifestTimings", "leastPixelDiffSelector"].forEach((we) => {
      typeof this.source_[we] < "u" && (this.options_[we] = this.source_[we]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio, this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
    const me = this.options_.customPixelRatio;
    typeof me == "number" && me >= 0 && (this.customPixelRatio = me);
  }
  // alias for public method to set options
  setOptions(ie = {}) {
    this.setOptions_(ie);
  }
  /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */
  src(ie, me) {
    if (!ie)
      return;
    this.setOptions_(), this.options_.src = K2(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = Ce, this.options_.sourceType = jd(me), this.options_.seekTo = (je) => {
      this.tech_.setCurrentTime(je);
    }, this.options_.player_ = this.player_, this.playlistController_ = new O2(this.options_);
    const we = fe$1({
      liveRangeSafeTimeDelta: Ft
    }, this.options_, {
      seekable: () => this.seekable(),
      media: () => this.playlistController_.media(),
      playlistController: this.playlistController_
    });
    this.playbackWatcher_ = new N2(we), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
      const je = L.players[this.tech_.options_.playerId];
      let Ue = this.playlistController_.error;
      typeof Ue == "object" && !Ue.code ? Ue.code = 3 : typeof Ue == "string" && (Ue = {
        message: Ue,
        code: 3
      }), je.error(Ue);
    });
    const Re = this.options_.bufferBasedABR ? Ce.movingAverageBandwidthSelector(0.55) : Ce.STANDARD_PLAYLIST_SELECTOR;
    this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : Re.bind(this), this.playlistController_.selectInitialPlaylist = Ce.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
      selectPlaylist: {
        get() {
          return this.playlistController_.selectPlaylist;
        },
        set(je) {
          this.playlistController_.selectPlaylist = je.bind(this);
        }
      },
      throughput: {
        get() {
          return this.playlistController_.mainSegmentLoader_.throughput.rate;
        },
        set(je) {
          this.playlistController_.mainSegmentLoader_.throughput.rate = je, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get() {
          let je = this.playlistController_.mainSegmentLoader_.bandwidth;
          const Ue = S.navigator.connection || S.navigator.mozConnection || S.navigator.webkitConnection, qe = 1e7;
          if (this.options_.useNetworkInformationApi && Ue) {
            const Ge = Ue.downlink * 1e3 * 1e3;
            Ge >= qe && je >= qe ? je = Math.max(je, Ge) : je = Ge;
          }
          return je;
        },
        set(je) {
          this.playlistController_.mainSegmentLoader_.bandwidth = je, this.playlistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */
      systemBandwidth: {
        get() {
          const je = 1 / (this.bandwidth || 1);
          let Ue;
          return this.throughput > 0 ? Ue = 1 / this.throughput : Ue = 0, Math.floor(1 / (je + Ue));
        },
        set() {
          L.log.error('The "systemBandwidth" property is read-only');
        }
      }
    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
      bandwidth: {
        get: () => this.bandwidth || 0,
        enumerable: !0
      },
      mediaRequests: {
        get: () => this.playlistController_.mediaRequests_() || 0,
        enumerable: !0
      },
      mediaRequestsAborted: {
        get: () => this.playlistController_.mediaRequestsAborted_() || 0,
        enumerable: !0
      },
      mediaRequestsTimedout: {
        get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
        enumerable: !0
      },
      mediaRequestsErrored: {
        get: () => this.playlistController_.mediaRequestsErrored_() || 0,
        enumerable: !0
      },
      mediaTransferDuration: {
        get: () => this.playlistController_.mediaTransferDuration_() || 0,
        enumerable: !0
      },
      mediaBytesTransferred: {
        get: () => this.playlistController_.mediaBytesTransferred_() || 0,
        enumerable: !0
      },
      mediaSecondsLoaded: {
        get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
        enumerable: !0
      },
      mediaAppends: {
        get: () => this.playlistController_.mediaAppends_() || 0,
        enumerable: !0
      },
      mainAppendsToLoadedData: {
        get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      audioAppendsToLoadedData: {
        get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      appendsToLoadedData: {
        get: () => this.playlistController_.appendsToLoadedData_() || 0,
        enumerable: !0
      },
      timeToLoadedData: {
        get: () => this.playlistController_.timeToLoadedData_() || 0,
        enumerable: !0
      },
      buffered: {
        get: () => wi(this.tech_.buffered()),
        enumerable: !0
      },
      currentTime: {
        get: () => this.tech_.currentTime(),
        enumerable: !0
      },
      currentSource: {
        get: () => this.tech_.currentSource_,
        enumerable: !0
      },
      currentTech: {
        get: () => this.tech_.name_,
        enumerable: !0
      },
      duration: {
        get: () => this.tech_.duration(),
        enumerable: !0
      },
      main: {
        get: () => this.playlists.main,
        enumerable: !0
      },
      playerDimensions: {
        get: () => this.tech_.currentDimensions(),
        enumerable: !0
      },
      seekable: {
        get: () => wi(this.tech_.seekable()),
        enumerable: !0
      },
      timestamp: {
        get: () => Date.now(),
        enumerable: !0
      },
      videoPlaybackQuality: {
        get: () => this.tech_.getVideoPlaybackQuality(),
        enumerable: !0
      }
    }), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
      this.options_.useBandwidthFromLocalStorage && X2({
        bandwidth: this.bandwidth,
        throughput: Math.round(this.throughput)
      });
    }), this.playlistController_.on("selectedinitialmedia", () => {
      M2(this);
    }), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
      this.setupEme_();
    }), this.on(this.playlistController_, "progress", function() {
      this.tech_.trigger("progress");
    }), this.on(this.playlistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = !0;
    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = S.URL.createObjectURL(this.playlistController_.mediaSource), (L.browser.IS_ANY_SAFARI || L.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
  }
  createKeySessions_() {
    const ie = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), W2({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: ie && ie.media(),
      mainPlaylists: this.playlists.main.playlists
    }).then(() => {
      this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
    }).catch((me) => {
      this.logger_("error while creating EME key session", me), this.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }
  handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }
  /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */
  setupEme_() {
    const ie = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, me = G2({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: ie && ie.media()
    });
    if (this.player_.tech_.on("keystatuschange", (we) => {
      this.playlistController_.updatePlaylistByKeyStatus(we.keyId, we.status);
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !me) {
      this.playlistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }
  /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */
  setupQualityLevels_() {
    const ie = L.players[this.tech_.options_.playerId];
    !ie || !ie.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = ie.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
      V2(this.qualityLevels_, this);
    }), this.playlists.on("mediachange", () => {
      Vp(this.qualityLevels_, this.playlists);
    }));
  }
  /**
   * return the version
   */
  static version() {
    return {
      "@videojs/http-streaming": jp,
      "mux.js": U2,
      "mpd-parser": $2,
      "m3u8-parser": j2,
      "aes-decrypter": q2
    };
  }
  /**
   * return the version
   */
  version() {
    return this.constructor.version();
  }
  canChangeType() {
    return Np.canChangeType();
  }
  /**
   * Begin playing the video.
   */
  play() {
    this.playlistController_.play();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  setCurrentTime(ie) {
    this.playlistController_.setCurrentTime(ie);
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  duration() {
    return this.playlistController_.duration();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  seekable() {
    return this.playlistController_.seekable();
  }
  /**
   * Abort all outstanding work and cleanup.
   */
  dispose() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && S.URL.revokeObjectURL && (S.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
  }
  convertToProgramTime(ie, me) {
    return eb({
      playlist: this.playlistController_.media(),
      time: ie,
      callback: me
    });
  }
  // the player must be playing before calling this
  seekToProgramTime(ie, me, we = !0, Re = 2) {
    return Tp({
      programTime: ie,
      playlist: this.playlistController_.media(),
      retryCount: Re,
      pauseAfterSeek: we,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: me
    });
  }
  /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */
  setupXhrHooks_() {
    this.xhr.onRequest = (ie) => {
      zp(this.xhr, ie);
    }, this.xhr.onResponse = (ie) => {
      Wp(this.xhr, ie);
    }, this.xhr.offRequest = (ie) => {
      Gp(this.xhr, ie);
    }, this.xhr.offResponse = (ie) => {
      Xp(this.xhr, ie);
    }, this.player_.trigger("xhr-hooks-ready");
  }
  attachStreamingEventListeners_() {
    const ie = ["seekablerangeschanged", "bufferedrangeschanged", "contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"], me = ["gapjumped", "playedrangeschanged"];
    ie.forEach((we) => {
      this.playlistController_.on(we, (Re) => {
        this.player_.trigger(Oe$1({}, Re));
      });
    }), me.forEach((we) => {
      this.playbackWatcher_.on(we, (Re) => {
        this.player_.trigger(Oe$1({}, Re));
      });
    });
  }
}
const pa = {
  name: "videojs-http-streaming",
  VERSION: jp,
  canHandleSource(ce, ie = {}) {
    const me = fe$1(L.options, ie);
    return !me.vhs.experimentalUseMMS && !Dr("avc1.4d400d,mp4a.40.2", !1) ? !1 : pa.canPlayType(ce.type, me);
  },
  handleSource(ce, ie, me = {}) {
    const we = fe$1(L.options, me);
    return ie.vhs = new Kp(ce, ie, we), ie.vhs.xhr = pp(), ie.vhs.setupXhrHooks_(), ie.vhs.src(ce.src, ce.type), ie.vhs;
  },
  canPlayType(ce, ie) {
    const me = jd(ce);
    if (!me)
      return "";
    const we = pa.getOverrideNative(ie);
    return !Ce.supportsTypeNatively(me) || we ? "maybe" : "";
  },
  getOverrideNative(ce = {}) {
    const {
      vhs: ie = {}
    } = ce, me = !(L.browser.IS_ANY_SAFARI || L.browser.IS_IOS), {
      overrideNative: we = me
    } = ie;
    return we;
  }
}, Q2 = () => Dr("avc1.4d400d,mp4a.40.2", !0);
Q2() && L.getTech("Html5").registerSourceHandler(pa, 0);
L.VhsHandler = Kp;
L.VhsSourceHandler = pa;
L.Vhs = Ce;
L.use || L.registerComponent("Vhs", Ce);
L.options.vhs = L.options.vhs || {};
(!L.getPlugin || !L.getPlugin("reloadSourceOnError")) && L.registerPlugin("reloadSourceOnError", F2);
const J2 = ({
  src: ce,
  autoplay: ie,
  seekBarLocked: me,
  hideControls: we,
  loop: Re,
  mute: je,
  onReady: Ue,
  onEnded: qe
}) => {
  const Ge = React__default.useRef(null), Xe = React__default.useRef(null), ot = $g(ce);
  return useEffect(() => {
    var vt, bt, Tt, wt;
    if (Xe.current) {
      const St = Xe.current;
      me ? (Tt = St.controlBar) == null || Tt.progressControl.disable() : (wt = St.controlBar) == null || wt.progressControl.enable(), St.autoplay(ie), St.controls(!we), St.muted(je), St.loop(Re), ot && ot !== ce && St.src({ src: ce });
      return;
    } else {
      const St = document.createElement("video-js");
      St.classList.add("vjs-big-play-centered"), (vt = Ge.current) == null || vt.appendChild(St);
      const It = {
        controls: !we,
        loop: Re,
        muted: je,
        playsinline: !0,
        fluid: !0,
        sources: [
          {
            src: ce
          }
        ],
        playbackRates: [0.75, 1, 1.25, 1.5, 2],
        disablePictureInPicture: !0
      }, Pt = Xe.current = L(St, It, () => {
        Ue == null || Ue(Pt), we && !ie && (console.log(Pt), Pt.controls(!0), Pt.on("play", kt));
      }), kt = () => {
        Pt.controls(!1);
      };
      return ie && Pt.on("canplay", function() {
        var Ot;
        (Ot = Pt.play()) == null || Ot.catch(() => {
          we && (Pt.controls(!0), Pt.on("play", kt));
        });
      }), me && ((bt = Pt.controlBar.progressControl) == null || bt.disable()), () => {
        Pt.off("play", kt);
      };
    }
  }, [ce, ie, me, we, Re, je, ot, Ue]), useEffect(() => {
    const vt = Xe.current;
    if (vt && qe)
      if (Re) {
        const bt = () => {
          (vt.currentTime() ?? 0) >= (vt.duration() ?? 0) - 0.5 && qe();
        };
        return vt.on("timeupdate", bt), () => {
          vt.off("timeupdate", bt);
        };
      } else
        return vt.on("ended", qe), () => {
          vt.off("ended", qe);
        };
  }, [Re, qe]), useEffect(() => {
    const vt = Xe.current;
    return () => {
      vt && !vt.isDisposed() && (vt.dispose(), Xe.current = null);
    };
  }, []), useMemo$1(() => ({ videoRef: Ge }), [Ge]);
}, t1 = (ce) => {
  const { videoRef: ie } = J2(ce);
  return /* @__PURE__ */ Ug.jsx(
    "div",
    {
      className: ce.constricted ? "constricted" : "",
      "data-vjs-player": !0,
      onContextMenu: (me) => {
        me.preventDefault();
      },
      ref: ie
    }
  );
}, SizeToClassname = {
  xs: "text--xs",
  s: "text--s",
  m: "text--m",
  base: "text--base",
  l: "text--l",
  xl: "text--xl",
  xxl: "text--xxl"
}, getColorClassName = (ce, ie = !1) => ({
  inherit: "text-inherit",
  white: `text-white ${ie && "light:text-black"}`,
  black: `text-black ${ie && "light:text-white"}`,
  "grey-300": `text-grey-300 ${ie && "light:text-grey-700"}`,
  "grey-350": `text-grey-350 ${ie && "light:text-grey-650"}`,
  "grey-400": `text-grey-400 ${ie && "light:text-grey-600"}`,
  "grey-500": `text-grey-500 ${ie && "light:text-grey-500"}`,
  "grey-600": `text-grey-600 ${ie && "light:text-grey-400"}`,
  "grey-900": `text-grey-900 ${ie && "light:text-grey-100"}`,
  accent: "text-accent",
  "yellow-600": "text-yellow-600",
  "blue-500": "text-blue-500",
  "red-500": "text-red-500"
})[ce], WeightToClassname = {
  semibold: "font-semibold",
  regular: "font-normal",
  bold: "font-bold"
}, Text = ({
  size: ce = "m",
  color: ie = "inherit",
  weight: me = "regular",
  center: we,
  className: Re,
  invertInLightTheme: je,
  children: Ue,
  block: qe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "span",
  {
    className: classNames(
      "text",
      SizeToClassname[ce],
      getColorClassName(ie, je),
      WeightToClassname[me],
      {
        "text--center": we,
        block: qe,
        "inline-block": !qe
      },
      Re
    ),
    children: Ue
  }
);
function isEqual$1(ce, ie) {
  var me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, we = /* @__PURE__ */ new Set();
  function Re(je, Ue) {
    var qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, Ge = we.has(je);
    if (warningOnce(!Ge, "Warning: There may be circular references"), Ge)
      return !1;
    if (je === Ue)
      return !0;
    if (me && qe > 1)
      return !1;
    we.add(je);
    var Xe = qe + 1;
    if (Array.isArray(je)) {
      if (!Array.isArray(Ue) || je.length !== Ue.length)
        return !1;
      for (var ot = 0; ot < je.length; ot++)
        if (!Re(je[ot], Ue[ot], Xe))
          return !1;
      return !0;
    }
    if (je && Ue && _typeof$b(je) === "object" && _typeof$b(Ue) === "object") {
      var vt = Object.keys(je);
      return vt.length !== Object.keys(Ue).length ? !1 : vt.every(function(bt) {
        return Re(je[bt], Ue[bt], Xe);
      });
    }
    return !1;
  }
  return Re(ce, ie);
}
function getOffset$2(ce, ie, me) {
  return (ce - ie) / (me - ie);
}
function getDirectionStyle(ce, ie, me, we) {
  var Re = getOffset$2(ie, me, we), je = {};
  switch (ce) {
    case "rtl":
      je.right = "".concat(Re * 100, "%"), je.transform = "translateX(50%)";
      break;
    case "btt":
      je.bottom = "".concat(Re * 100, "%"), je.transform = "translateY(50%)";
      break;
    case "ttb":
      je.top = "".concat(Re * 100, "%"), je.transform = "translateY(-50%)";
      break;
    default:
      je.left = "".concat(Re * 100, "%"), je.transform = "translateX(-50%)";
      break;
  }
  return je;
}
function getIndex(ce, ie) {
  return Array.isArray(ce) ? ce[ie] : ce;
}
var KeyCode = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, SliderContext = /* @__PURE__ */ React.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), UnstableContext = /* @__PURE__ */ React.createContext({}), _excluded$e = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], Handle = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.prefixCls, we = ce.value, Re = ce.valueIndex, je = ce.onStartMove, Ue = ce.onDelete, qe = ce.style, Ge = ce.render, Xe = ce.dragging, ot = ce.draggingDelete, vt = ce.onOffsetChange, bt = ce.onChangeComplete, Tt = ce.onFocus, wt = ce.onMouseEnter, St = _objectWithoutProperties$6(ce, _excluded$e), It = React.useContext(SliderContext), Pt = It.min, kt = It.max, Ot = It.direction, Jr = It.disabled, en = It.keyboard, nn = It.range, ln = It.tabIndex, fn = It.ariaLabelForHandle, vn = It.ariaLabelledByForHandle, Tn = It.ariaRequired, xn = It.ariaValueTextFormatterForHandle, bn = It.styles, Sn = It.classNames, Cn = "".concat(me, "-handle"), kn = function(si) {
    Jr || je(si, Re);
  }, cn = function(si) {
    Tt == null || Tt(si, Re);
  }, gn = function(si) {
    wt(si, Re);
  }, an = function(si) {
    if (!Jr && en) {
      var bi = null;
      switch (si.which || si.keyCode) {
        case KeyCode.LEFT:
          bi = Ot === "ltr" || Ot === "btt" ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          bi = Ot === "ltr" || Ot === "btt" ? 1 : -1;
          break;
        // Up is plus
        case KeyCode.UP:
          bi = Ot !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case KeyCode.DOWN:
          bi = Ot !== "ttb" ? -1 : 1;
          break;
        case KeyCode.HOME:
          bi = "min";
          break;
        case KeyCode.END:
          bi = "max";
          break;
        case KeyCode.PAGE_UP:
          bi = 2;
          break;
        case KeyCode.PAGE_DOWN:
          bi = -2;
          break;
        case KeyCode.BACKSPACE:
        case KeyCode.DELETE:
          Ue(Re);
          break;
      }
      bi !== null && (si.preventDefault(), vt(bi, Re));
    }
  }, un = function(si) {
    switch (si.which || si.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        bt == null || bt();
        break;
    }
  }, pn = getDirectionStyle(Ot, we, Pt, kt), hn = {};
  if (Re !== null) {
    var An;
    hn = {
      tabIndex: Jr ? null : getIndex(ln, Re),
      role: "slider",
      "aria-valuemin": Pt,
      "aria-valuemax": kt,
      "aria-valuenow": we,
      "aria-disabled": Jr,
      "aria-label": getIndex(fn, Re),
      "aria-labelledby": getIndex(vn, Re),
      "aria-required": getIndex(Tn, Re),
      "aria-valuetext": (An = getIndex(xn, Re)) === null || An === void 0 ? void 0 : An(we),
      "aria-orientation": Ot === "ltr" || Ot === "rtl" ? "horizontal" : "vertical",
      onMouseDown: kn,
      onTouchStart: kn,
      onFocus: cn,
      onMouseEnter: gn,
      onKeyDown: an,
      onKeyUp: un
    };
  }
  var In = /* @__PURE__ */ React.createElement("div", _extends$j({
    ref: ie,
    className: classNames(Cn, _defineProperty$s(_defineProperty$s(_defineProperty$s({}, "".concat(Cn, "-").concat(Re + 1), Re !== null && nn), "".concat(Cn, "-dragging"), Xe), "".concat(Cn, "-dragging-delete"), ot), Sn.handle),
    style: _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, pn), qe), bn.handle)
  }, hn, St));
  return Ge && (In = Ge(In, {
    index: Re,
    prefixCls: me,
    value: we,
    dragging: Xe,
    draggingDelete: ot
  })), In;
});
process.env.NODE_ENV !== "production" && (Handle.displayName = "Handle");
var _excluded$d = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], Handles = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.prefixCls, we = ce.style, Re = ce.onStartMove, je = ce.onOffsetChange, Ue = ce.values, qe = ce.handleRender, Ge = ce.activeHandleRender, Xe = ce.draggingIndex, ot = ce.draggingDelete, vt = ce.onFocus, bt = _objectWithoutProperties$6(ce, _excluded$d), Tt = React.useRef({}), wt = React.useState(!1), St = _slicedToArray$8(wt, 2), It = St[0], Pt = St[1], kt = React.useState(-1), Ot = _slicedToArray$8(kt, 2), Jr = Ot[0], en = Ot[1], nn = function(xn) {
    en(xn), Pt(!0);
  }, ln = function(xn, bn) {
    nn(bn), vt == null || vt(xn);
  }, fn = function(xn, bn) {
    nn(bn);
  };
  React.useImperativeHandle(ie, function() {
    return {
      focus: function(xn) {
        var bn;
        (bn = Tt.current[xn]) === null || bn === void 0 || bn.focus();
      },
      hideHelp: function() {
        flushSync(function() {
          Pt(!1);
        });
      }
    };
  });
  var vn = _objectSpread2$2({
    prefixCls: me,
    onStartMove: Re,
    onOffsetChange: je,
    render: qe,
    onFocus: ln,
    onMouseEnter: fn
  }, bt);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Ue.map(function(Tn, xn) {
    var bn = Xe === xn;
    return /* @__PURE__ */ React.createElement(Handle, _extends$j({
      ref: function(Cn) {
        Cn ? Tt.current[xn] = Cn : delete Tt.current[xn];
      },
      dragging: bn,
      draggingDelete: bn && ot,
      style: getIndex(we, xn),
      key: xn,
      value: Tn,
      valueIndex: xn
    }, vn));
  }), Ge && It && /* @__PURE__ */ React.createElement(Handle, _extends$j({
    key: "a11y"
  }, vn, {
    value: Ue[Jr],
    valueIndex: null,
    dragging: Xe !== -1,
    draggingDelete: ot,
    render: Ge,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (Handles.displayName = "Handles");
var Mark = function(ie) {
  var me = ie.prefixCls, we = ie.style, Re = ie.children, je = ie.value, Ue = ie.onClick, qe = React.useContext(SliderContext), Ge = qe.min, Xe = qe.max, ot = qe.direction, vt = qe.includedStart, bt = qe.includedEnd, Tt = qe.included, wt = "".concat(me, "-text"), St = getDirectionStyle(ot, je, Ge, Xe);
  return /* @__PURE__ */ React.createElement("span", {
    className: classNames(wt, _defineProperty$s({}, "".concat(wt, "-active"), Tt && vt <= je && je <= bt)),
    style: _objectSpread2$2(_objectSpread2$2({}, St), we),
    onMouseDown: function(Pt) {
      Pt.stopPropagation();
    },
    onClick: function() {
      Ue(je);
    }
  }, Re);
}, Marks = function(ie) {
  var me = ie.prefixCls, we = ie.marks, Re = ie.onClick, je = "".concat(me, "-mark");
  return we.length ? /* @__PURE__ */ React.createElement("div", {
    className: je
  }, we.map(function(Ue) {
    var qe = Ue.value, Ge = Ue.style, Xe = Ue.label;
    return /* @__PURE__ */ React.createElement(Mark, {
      key: qe,
      prefixCls: je,
      style: Ge,
      value: qe,
      onClick: Re
    }, Xe);
  })) : null;
}, Dot = function(ie) {
  var me = ie.prefixCls, we = ie.value, Re = ie.style, je = ie.activeStyle, Ue = React.useContext(SliderContext), qe = Ue.min, Ge = Ue.max, Xe = Ue.direction, ot = Ue.included, vt = Ue.includedStart, bt = Ue.includedEnd, Tt = "".concat(me, "-dot"), wt = ot && vt <= we && we <= bt, St = _objectSpread2$2(_objectSpread2$2({}, getDirectionStyle(Xe, we, qe, Ge)), typeof Re == "function" ? Re(we) : Re);
  return wt && (St = _objectSpread2$2(_objectSpread2$2({}, St), typeof je == "function" ? je(we) : je)), /* @__PURE__ */ React.createElement("span", {
    className: classNames(Tt, _defineProperty$s({}, "".concat(Tt, "-active"), wt)),
    style: St
  });
}, Steps = function(ie) {
  var me = ie.prefixCls, we = ie.marks, Re = ie.dots, je = ie.style, Ue = ie.activeStyle, qe = React.useContext(SliderContext), Ge = qe.min, Xe = qe.max, ot = qe.step, vt = React.useMemo(function() {
    var bt = /* @__PURE__ */ new Set();
    if (we.forEach(function(wt) {
      bt.add(wt.value);
    }), Re && ot !== null)
      for (var Tt = Ge; Tt <= Xe; )
        bt.add(Tt), Tt += ot;
    return Array.from(bt);
  }, [Ge, Xe, ot, Re, we]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(me, "-step")
  }, vt.map(function(bt) {
    return /* @__PURE__ */ React.createElement(Dot, {
      prefixCls: me,
      key: bt,
      value: bt,
      style: je,
      activeStyle: Ue
    });
  }));
}, Track = function(ie) {
  var me = ie.prefixCls, we = ie.style, Re = ie.start, je = ie.end, Ue = ie.index, qe = ie.onStartMove, Ge = ie.replaceCls, Xe = React.useContext(SliderContext), ot = Xe.direction, vt = Xe.min, bt = Xe.max, Tt = Xe.disabled, wt = Xe.range, St = Xe.classNames, It = "".concat(me, "-track"), Pt = getOffset$2(Re, vt, bt), kt = getOffset$2(je, vt, bt), Ot = function(ln) {
    !Tt && qe && qe(ln, -1);
  }, Jr = {};
  switch (ot) {
    case "rtl":
      Jr.right = "".concat(Pt * 100, "%"), Jr.width = "".concat(kt * 100 - Pt * 100, "%");
      break;
    case "btt":
      Jr.bottom = "".concat(Pt * 100, "%"), Jr.height = "".concat(kt * 100 - Pt * 100, "%");
      break;
    case "ttb":
      Jr.top = "".concat(Pt * 100, "%"), Jr.height = "".concat(kt * 100 - Pt * 100, "%");
      break;
    default:
      Jr.left = "".concat(Pt * 100, "%"), Jr.width = "".concat(kt * 100 - Pt * 100, "%");
  }
  var en = Ge || classNames(It, _defineProperty$s(_defineProperty$s({}, "".concat(It, "-").concat(Ue + 1), Ue !== null && wt), "".concat(me, "-track-draggable"), qe), St.track);
  return /* @__PURE__ */ React.createElement("div", {
    className: en,
    style: _objectSpread2$2(_objectSpread2$2({}, Jr), we),
    onMouseDown: Ot,
    onTouchStart: Ot
  });
}, Tracks = function(ie) {
  var me = ie.prefixCls, we = ie.style, Re = ie.values, je = ie.startPoint, Ue = ie.onStartMove, qe = React.useContext(SliderContext), Ge = qe.included, Xe = qe.range, ot = qe.min, vt = qe.styles, bt = qe.classNames, Tt = React.useMemo(function() {
    if (!Xe) {
      if (Re.length === 0)
        return [];
      var St = je ?? ot, It = Re[0];
      return [{
        start: Math.min(St, It),
        end: Math.max(St, It)
      }];
    }
    for (var Pt = [], kt = 0; kt < Re.length - 1; kt += 1)
      Pt.push({
        start: Re[kt],
        end: Re[kt + 1]
      });
    return Pt;
  }, [Re, Xe, je, ot]);
  if (!Ge)
    return null;
  var wt = Tt != null && Tt.length && (bt.tracks || vt.tracks) ? /* @__PURE__ */ React.createElement(Track, {
    index: null,
    prefixCls: me,
    start: Tt[0].start,
    end: Tt[Tt.length - 1].end,
    replaceCls: classNames(bt.tracks, "".concat(me, "-tracks")),
    style: vt.tracks
  }) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, wt, Tt.map(function(St, It) {
    var Pt = St.start, kt = St.end;
    return /* @__PURE__ */ React.createElement(Track, {
      index: It,
      prefixCls: me,
      style: _objectSpread2$2(_objectSpread2$2({}, getIndex(we, It)), vt.track),
      start: Pt,
      end: kt,
      key: It,
      onStartMove: Ue
    });
  }));
}, REMOVE_DIST = 130;
function getPosition(ce) {
  var ie = "targetTouches" in ce ? ce.targetTouches[0] : ce;
  return {
    pageX: ie.pageX,
    pageY: ie.pageY
  };
}
function useDrag$1(ce, ie, me, we, Re, je, Ue, qe, Ge, Xe, ot) {
  var vt = React.useState(null), bt = _slicedToArray$8(vt, 2), Tt = bt[0], wt = bt[1], St = React.useState(-1), It = _slicedToArray$8(St, 2), Pt = It[0], kt = It[1], Ot = React.useState(!1), Jr = _slicedToArray$8(Ot, 2), en = Jr[0], nn = Jr[1], ln = React.useState(me), fn = _slicedToArray$8(ln, 2), vn = fn[0], Tn = fn[1], xn = React.useState(me), bn = _slicedToArray$8(xn, 2), Sn = bn[0], Cn = bn[1], kn = React.useRef(null), cn = React.useRef(null), gn = React.useRef(null), an = React.useContext(UnstableContext), un = an.onDragStart, pn = an.onDragChange;
  useLayoutEffect$1(function() {
    Pt === -1 && Tn(me);
  }, [me, Pt]), React.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", kn.current), document.removeEventListener("mouseup", cn.current), gn.current && (gn.current.removeEventListener("touchmove", kn.current), gn.current.removeEventListener("touchend", cn.current));
    };
  }, []);
  var hn = function(bi, xi, ji) {
    xi !== void 0 && wt(xi), Tn(bi);
    var zi = bi;
    ji && (zi = bi.filter(function(Vi, Hi) {
      return Hi !== Pt;
    })), Ue(zi), pn && pn({
      rawValues: bi,
      deleteIndex: ji ? Pt : -1,
      draggingIndex: Pt,
      draggingValue: xi
    });
  }, An = useEvent(function(si, bi, xi) {
    if (si === -1) {
      var ji = Sn[0], zi = Sn[Sn.length - 1], Vi = we - ji, Hi = Re - zi, ii = bi * (Re - we);
      ii = Math.max(ii, Vi), ii = Math.min(ii, Hi);
      var Fi = je(ji + ii);
      ii = Fi - ji;
      var ni = Sn.map(function(Xa) {
        return Xa + ii;
      });
      hn(ni);
    } else {
      var Ui = (Re - we) * bi, ja = _toConsumableArray$1(vn);
      ja[si] = Sn[si];
      var Ga = Ge(ja, Ui, si, "dist");
      hn(Ga.values, Ga.value, xi);
    }
  }), In = function(bi, xi, ji) {
    bi.stopPropagation();
    var zi = ji || me, Vi = zi[xi];
    kt(xi), wt(Vi), Cn(zi), Tn(zi), nn(!1);
    var Hi = getPosition(bi), ii = Hi.pageX, Fi = Hi.pageY, ni = !1;
    un && un({
      rawValues: zi,
      draggingIndex: xi,
      draggingValue: Vi
    });
    var Ui = function(Xa) {
      Xa.preventDefault();
      var Ns = getPosition(Xa), Ya = Ns.pageX, Qa = Ns.pageY, Ja = Ya - ii, Ms = Qa - Fi, Hs = ce.current.getBoundingClientRect(), no = Hs.width, Qs = Hs.height, Zs, so;
      switch (ie) {
        case "btt":
          Zs = -Ms / Qs, so = Ja;
          break;
        case "ttb":
          Zs = Ms / Qs, so = Ja;
          break;
        case "rtl":
          Zs = -Ja / no, so = Ms;
          break;
        default:
          Zs = Ja / no, so = Ms;
      }
      ni = Xe ? Math.abs(so) > REMOVE_DIST && ot < vn.length : !1, nn(ni), An(xi, Zs, ni);
    }, ja = function Ga(Xa) {
      Xa.preventDefault(), document.removeEventListener("mouseup", Ga), document.removeEventListener("mousemove", Ui), gn.current && (gn.current.removeEventListener("touchmove", kn.current), gn.current.removeEventListener("touchend", cn.current)), kn.current = null, cn.current = null, gn.current = null, qe(ni), kt(-1), nn(!1);
    };
    document.addEventListener("mouseup", ja), document.addEventListener("mousemove", Ui), bi.currentTarget.addEventListener("touchend", ja), bi.currentTarget.addEventListener("touchmove", Ui), kn.current = Ui, cn.current = ja, gn.current = bi.currentTarget;
  }, qn = React.useMemo(function() {
    var si = _toConsumableArray$1(me).sort(function(Vi, Hi) {
      return Vi - Hi;
    }), bi = _toConsumableArray$1(vn).sort(function(Vi, Hi) {
      return Vi - Hi;
    }), xi = {};
    bi.forEach(function(Vi) {
      xi[Vi] = (xi[Vi] || 0) + 1;
    }), si.forEach(function(Vi) {
      xi[Vi] = (xi[Vi] || 0) - 1;
    });
    var ji = Xe ? 1 : 0, zi = Object.values(xi).reduce(function(Vi, Hi) {
      return Vi + Math.abs(Hi);
    }, 0);
    return zi <= ji ? vn : me;
  }, [me, vn, Xe]);
  return [Pt, Tt, en, qn, In];
}
function useOffset(ce, ie, me, we, Re, je) {
  var Ue = React.useCallback(function(Tt) {
    return Math.max(ce, Math.min(ie, Tt));
  }, [ce, ie]), qe = React.useCallback(function(Tt) {
    if (me !== null) {
      var wt = ce + Math.round((Ue(Tt) - ce) / me) * me, St = function(Ot) {
        return (String(Ot).split(".")[1] || "").length;
      }, It = Math.max(St(me), St(ie), St(ce)), Pt = Number(wt.toFixed(It));
      return ce <= Pt && Pt <= ie ? Pt : null;
    }
    return null;
  }, [me, ce, ie, Ue]), Ge = React.useCallback(function(Tt) {
    var wt = Ue(Tt), St = we.map(function(kt) {
      return kt.value;
    });
    me !== null && St.push(qe(Tt)), St.push(ce, ie);
    var It = St[0], Pt = ie - ce;
    return St.forEach(function(kt) {
      var Ot = Math.abs(wt - kt);
      Ot <= Pt && (It = kt, Pt = Ot);
    }), It;
  }, [ce, ie, we, me, Ue, qe]), Xe = function Tt(wt, St, It) {
    var Pt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof St == "number") {
      var kt, Ot = wt[It], Jr = Ot + St, en = [];
      we.forEach(function(Tn) {
        en.push(Tn.value);
      }), en.push(ce, ie), en.push(qe(Ot));
      var nn = St > 0 ? 1 : -1;
      Pt === "unit" ? en.push(qe(Ot + nn * me)) : en.push(qe(Jr)), en = en.filter(function(Tn) {
        return Tn !== null;
      }).filter(function(Tn) {
        return St < 0 ? Tn <= Ot : Tn >= Ot;
      }), Pt === "unit" && (en = en.filter(function(Tn) {
        return Tn !== Ot;
      }));
      var ln = Pt === "unit" ? Ot : Jr;
      kt = en[0];
      var fn = Math.abs(kt - ln);
      if (en.forEach(function(Tn) {
        var xn = Math.abs(Tn - ln);
        xn < fn && (kt = Tn, fn = xn);
      }), kt === void 0)
        return St < 0 ? ce : ie;
      if (Pt === "dist")
        return kt;
      if (Math.abs(St) > 1) {
        var vn = _toConsumableArray$1(wt);
        return vn[It] = kt, Tt(vn, St - nn, It, Pt);
      }
      return kt;
    } else {
      if (St === "min")
        return ce;
      if (St === "max")
        return ie;
    }
  }, ot = function(wt, St, It) {
    var Pt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", kt = wt[It], Ot = Xe(wt, St, It, Pt);
    return {
      value: Ot,
      changed: Ot !== kt
    };
  }, vt = function(wt) {
    return je === null && wt === 0 || typeof je == "number" && wt < je;
  }, bt = function(wt, St, It) {
    var Pt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", kt = wt.map(Ge), Ot = kt[It], Jr = Xe(kt, St, It, Pt);
    if (kt[It] = Jr, Re === !1) {
      var en = je || 0;
      It > 0 && kt[It - 1] !== Ot && (kt[It] = Math.max(kt[It], kt[It - 1] + en)), It < kt.length - 1 && kt[It + 1] !== Ot && (kt[It] = Math.min(kt[It], kt[It + 1] - en));
    } else if (typeof je == "number" || je === null) {
      for (var nn = It + 1; nn < kt.length; nn += 1)
        for (var ln = !0; vt(kt[nn] - kt[nn - 1]) && ln; ) {
          var fn = ot(kt, 1, nn);
          kt[nn] = fn.value, ln = fn.changed;
        }
      for (var vn = It; vn > 0; vn -= 1)
        for (var Tn = !0; vt(kt[vn] - kt[vn - 1]) && Tn; ) {
          var xn = ot(kt, -1, vn - 1);
          kt[vn - 1] = xn.value, Tn = xn.changed;
        }
      for (var bn = kt.length - 1; bn > 0; bn -= 1)
        for (var Sn = !0; vt(kt[bn] - kt[bn - 1]) && Sn; ) {
          var Cn = ot(kt, -1, bn - 1);
          kt[bn - 1] = Cn.value, Sn = Cn.changed;
        }
      for (var kn = 0; kn < kt.length - 1; kn += 1)
        for (var cn = !0; vt(kt[kn + 1] - kt[kn]) && cn; ) {
          var gn = ot(kt, 1, kn + 1);
          kt[kn + 1] = gn.value, cn = gn.changed;
        }
    }
    return {
      value: kt[It],
      values: kt
    };
  };
  return [Ge, bt];
}
function useRange(ce) {
  return useMemo$1(function() {
    if (ce === !0 || !ce)
      return [!!ce, !1, !1, 0];
    var ie = ce.editable, me = ce.draggableTrack, we = ce.minCount, Re = ce.maxCount;
    return process.env.NODE_ENV !== "production" && warning$1(!ie || !me, "`editable` can not work with `draggableTrack`."), [!0, ie, !ie && me, we || 0, Re];
  }, [ce]);
}
var Slider$1 = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.prefixCls, we = me === void 0 ? "rc-slider" : me, Re = ce.className, je = ce.style, Ue = ce.classNames, qe = ce.styles, Ge = ce.id, Xe = ce.disabled, ot = Xe === void 0 ? !1 : Xe, vt = ce.keyboard, bt = vt === void 0 ? !0 : vt, Tt = ce.autoFocus, wt = ce.onFocus, St = ce.onBlur, It = ce.min, Pt = It === void 0 ? 0 : It, kt = ce.max, Ot = kt === void 0 ? 100 : kt, Jr = ce.step, en = Jr === void 0 ? 1 : Jr, nn = ce.value, ln = ce.defaultValue, fn = ce.range, vn = ce.count, Tn = ce.onChange, xn = ce.onBeforeChange, bn = ce.onAfterChange, Sn = ce.onChangeComplete, Cn = ce.allowCross, kn = Cn === void 0 ? !0 : Cn, cn = ce.pushable, gn = cn === void 0 ? !1 : cn, an = ce.reverse, un = ce.vertical, pn = ce.included, hn = pn === void 0 ? !0 : pn, An = ce.startPoint, In = ce.trackStyle, qn = ce.handleStyle, si = ce.railStyle, bi = ce.dotStyle, xi = ce.activeDotStyle, ji = ce.marks, zi = ce.dots, Vi = ce.handleRender, Hi = ce.activeHandleRender, ii = ce.track, Fi = ce.tabIndex, ni = Fi === void 0 ? 0 : Fi, Ui = ce.ariaLabelForHandle, ja = ce.ariaLabelledByForHandle, Ga = ce.ariaRequired, Xa = ce.ariaValueTextFormatterForHandle, Ns = React.useRef(null), Ya = React.useRef(null), Qa = React.useMemo(function() {
    return un ? an ? "ttb" : "btt" : an ? "rtl" : "ltr";
  }, [an, un]), Ja = useRange(fn), Ms = _slicedToArray$8(Ja, 5), Hs = Ms[0], no = Ms[1], Qs = Ms[2], Zs = Ms[3], so = Ms[4], io = React.useMemo(function() {
    return isFinite(Pt) ? Pt : 0;
  }, [Pt]), dl = React.useMemo(function() {
    return isFinite(Ot) ? Ot : 100;
  }, [Ot]), vl = React.useMemo(function() {
    return en !== null && en <= 0 ? 1 : en;
  }, [en]), lo = React.useMemo(function() {
    return typeof gn == "boolean" ? gn ? vl : !1 : gn >= 0 ? gn : !1;
  }, [gn, vl]), yl = React.useMemo(function() {
    return Object.keys(ji || {}).map(function(Fs) {
      var Xi = ji[Fs], ao = {
        value: Number(Fs)
      };
      return Xi && _typeof$b(Xi) === "object" && !/* @__PURE__ */ React.isValidElement(Xi) && ("label" in Xi || "style" in Xi) ? (ao.style = Xi.style, ao.label = Xi.label) : ao.label = Xi, ao;
    }).filter(function(Fs) {
      var Xi = Fs.label;
      return Xi || typeof Xi == "number";
    }).sort(function(Fs, Xi) {
      return Fs.value - Xi.value;
    });
  }, [ji]), bl = useOffset(io, dl, vl, yl, kn, lo), Al = _slicedToArray$8(bl, 2), Xl = Al[0], $l = Al[1], Bl = useMergedState(ln, {
    value: nn
  }), Fl = _slicedToArray$8(Bl, 2), kl = Fl[0], ql = Fl[1], _l = React.useMemo(function() {
    var Fs = kl == null ? [] : Array.isArray(kl) ? kl : [kl], Xi = _slicedToArray$8(Fs, 1), ao = Xi[0], Sl = ao === void 0 ? io : ao, xl = kl === null ? [] : [Sl];
    if (Hs) {
      if (xl = _toConsumableArray$1(Fs), vn || kl === void 0) {
        var fm = vn >= 0 ? vn + 1 : 2;
        for (xl = xl.slice(0, fm); xl.length < fm; ) {
          var Jp;
          xl.push((Jp = xl[xl.length - 1]) !== null && Jp !== void 0 ? Jp : io);
        }
      }
      xl.sort(function(um, sm) {
        return um - sm;
      });
    }
    return xl.forEach(function(um, sm) {
      xl[sm] = Xl(um);
    }), xl;
  }, [kl, Hs, io, vn, Xl]), Ol = function(Xi) {
    return Hs ? Xi : Xi[0];
  }, Ll = useEvent(function(Fs) {
    var Xi = _toConsumableArray$1(Fs).sort(function(ao, Sl) {
      return ao - Sl;
    });
    Tn && !isEqual$1(Xi, _l, !0) && Tn(Ol(Xi)), ql(Xi);
  }), Ql = useEvent(function(Fs) {
    Fs && Ns.current.hideHelp();
    var Xi = Ol(_l);
    bn == null || bn(Xi), warningOnce(!bn, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), Sn == null || Sn(Xi);
  }), wl = function(Xi) {
    if (!(ot || !no || _l.length <= Zs)) {
      var ao = _toConsumableArray$1(_l);
      ao.splice(Xi, 1), xn == null || xn(Ol(ao)), Ll(ao);
      var Sl = Math.max(0, Xi - 1);
      Ns.current.hideHelp(), Ns.current.focus(Sl);
    }
  }, to = useDrag$1(Ya, Qa, _l, io, dl, Xl, Ll, Ql, $l, no, Zs), zs = _slicedToArray$8(to, 5), Gs = zs[0], Pl = zs[1], Ml = zs[2], Ws = zs[3], Ks = zs[4], Js = function(Xi, ao) {
    if (!ot) {
      var Sl = _toConsumableArray$1(_l), xl = 0, fm = 0, Jp = dl - io;
      _l.forEach(function(wm, tm) {
        var cm = Math.abs(Xi - wm);
        cm <= Jp && (Jp = cm, xl = tm), wm < Xi && (fm = tm);
      });
      var um = xl;
      no && Jp !== 0 && (!so || _l.length < so) ? (Sl.splice(fm + 1, 0, Xi), um = fm + 1) : Sl[xl] = Xi, Hs && !_l.length && vn === void 0 && Sl.push(Xi);
      var sm = Ol(Sl);
      if (xn == null || xn(sm), Ll(Sl), ao) {
        var em, _m;
        (em = document.activeElement) === null || em === void 0 || (_m = em.blur) === null || _m === void 0 || _m.call(em), Ns.current.focus(um), Ks(ao, um, Sl);
      } else
        bn == null || bn(sm), warningOnce(!bn, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), Sn == null || Sn(sm);
    }
  }, qs = function(Xi) {
    Xi.preventDefault();
    var ao = Ya.current.getBoundingClientRect(), Sl = ao.width, xl = ao.height, fm = ao.left, Jp = ao.top, um = ao.bottom, sm = ao.right, em = Xi.clientX, _m = Xi.clientY, wm;
    switch (Qa) {
      case "btt":
        wm = (um - _m) / xl;
        break;
      case "ttb":
        wm = (_m - Jp) / xl;
        break;
      case "rtl":
        wm = (sm - em) / Sl;
        break;
      default:
        wm = (em - fm) / Sl;
    }
    var tm = io + wm * (dl - io);
    Js(Xl(tm), Xi);
  }, ho = React.useState(null), mn = _slicedToArray$8(ho, 2), ai = mn[0], $i = mn[1], Ha = function(Xi, ao) {
    if (!ot) {
      var Sl = $l(_l, Xi, ao);
      xn == null || xn(Ol(_l)), Ll(Sl.values), $i(Sl.value);
    }
  };
  React.useEffect(function() {
    if (ai !== null) {
      var Fs = _l.indexOf(ai);
      Fs >= 0 && Ns.current.focus(Fs);
    }
    $i(null);
  }, [ai]);
  var Va = React.useMemo(function() {
    return Qs && vl === null ? (process.env.NODE_ENV !== "production" && warningOnce(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : Qs;
  }, [Qs, vl]), Us = useEvent(function(Fs, Xi) {
    Ks(Fs, Xi), xn == null || xn(Ol(_l));
  }), $s = Gs !== -1;
  React.useEffect(function() {
    if (!$s) {
      var Fs = _l.lastIndexOf(Pl);
      Ns.current.focus(Fs);
    }
  }, [$s]);
  var Za = React.useMemo(function() {
    return _toConsumableArray$1(Ws).sort(function(Fs, Xi) {
      return Fs - Xi;
    });
  }, [Ws]), ml = React.useMemo(function() {
    return Hs ? [Za[0], Za[Za.length - 1]] : [io, Za[0]];
  }, [Za, Hs, io]), Ys = _slicedToArray$8(ml, 2), Bs = Ys[0], Wa = Ys[1];
  React.useImperativeHandle(ie, function() {
    return {
      focus: function() {
        Ns.current.focus(0);
      },
      blur: function() {
        var Xi, ao = document, Sl = ao.activeElement;
        (Xi = Ya.current) !== null && Xi !== void 0 && Xi.contains(Sl) && (Sl == null || Sl.blur());
      }
    };
  }), React.useEffect(function() {
    Tt && Ns.current.focus(0);
  }, []);
  var js = React.useMemo(function() {
    return {
      min: io,
      max: dl,
      direction: Qa,
      disabled: ot,
      keyboard: bt,
      step: vl,
      included: hn,
      includedStart: Bs,
      includedEnd: Wa,
      range: Hs,
      tabIndex: ni,
      ariaLabelForHandle: Ui,
      ariaLabelledByForHandle: ja,
      ariaRequired: Ga,
      ariaValueTextFormatterForHandle: Xa,
      styles: qe || {},
      classNames: Ue || {}
    };
  }, [io, dl, Qa, ot, bt, vl, hn, Bs, Wa, Hs, ni, Ui, ja, Ga, Xa, qe, Ue]);
  return /* @__PURE__ */ React.createElement(SliderContext.Provider, {
    value: js
  }, /* @__PURE__ */ React.createElement("div", {
    ref: Ya,
    className: classNames(we, Re, _defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s({}, "".concat(we, "-disabled"), ot), "".concat(we, "-vertical"), un), "".concat(we, "-horizontal"), !un), "".concat(we, "-with-marks"), yl.length)),
    style: je,
    onMouseDown: qs,
    id: Ge
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames("".concat(we, "-rail"), Ue == null ? void 0 : Ue.rail),
    style: _objectSpread2$2(_objectSpread2$2({}, si), qe == null ? void 0 : qe.rail)
  }), ii !== !1 && /* @__PURE__ */ React.createElement(Tracks, {
    prefixCls: we,
    style: In,
    values: _l,
    startPoint: An,
    onStartMove: Va ? Us : void 0
  }), /* @__PURE__ */ React.createElement(Steps, {
    prefixCls: we,
    marks: yl,
    dots: zi,
    style: bi,
    activeStyle: xi
  }), /* @__PURE__ */ React.createElement(Handles, {
    ref: Ns,
    prefixCls: we,
    style: qn,
    values: Ws,
    draggingIndex: Gs,
    draggingDelete: Ml,
    onStartMove: Us,
    onOffsetChange: Ha,
    onFocus: wt,
    onBlur: St,
    handleRender: Vi,
    activeHandleRender: Hi,
    onChangeComplete: Ql,
    onDelete: no ? wl : void 0
  }), /* @__PURE__ */ React.createElement(Marks, {
    prefixCls: we,
    marks: yl,
    onClick: Js
  })));
});
process.env.NODE_ENV !== "production" && (Slider$1.displayName = "Slider");
var raf$1 = {};
Object.defineProperty(raf$1, "__esModule", {
  value: !0
});
var default_1 = raf$1.default = void 0, raf = function(ie) {
  return +setTimeout(ie, 16);
}, caf = function(ie) {
  return clearTimeout(ie);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(ie) {
  return window.requestAnimationFrame(ie);
}, caf = function(ie) {
  return window.cancelAnimationFrame(ie);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(ce) {
  rafIds.delete(ce);
}
var wrapperRaf = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var we = rafUUID;
  function Re(je) {
    if (je === 0)
      cleanup(we), ie();
    else {
      var Ue = raf(function() {
        Re(je - 1);
      });
      rafIds.set(we, Ue);
    }
  }
  return Re(me), we;
};
wrapperRaf.cancel = function(ce) {
  var ie = rafIds.get(ce);
  return cleanup(ce), caf(ie);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
default_1 = raf$1.default = wrapperRaf;
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(ce, ie) {
  (function() {
    var me, we = "4.17.21", Re = 200, je = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", Ue = "Expected a function", qe = "Invalid `variable` option passed into `_.template`", Ge = "__lodash_hash_undefined__", Xe = 500, ot = "__lodash_placeholder__", vt = 1, bt = 2, Tt = 4, wt = 1, St = 2, It = 1, Pt = 2, kt = 4, Ot = 8, Jr = 16, en = 32, nn = 64, ln = 128, fn = 256, vn = 512, Tn = 30, xn = "...", bn = 800, Sn = 16, Cn = 1, kn = 2, cn = 3, gn = 1 / 0, an = 9007199254740991, un = 17976931348623157e292, pn = NaN, hn = 4294967295, An = hn - 1, In = hn >>> 1, qn = [
      ["ary", ln],
      ["bind", It],
      ["bindKey", Pt],
      ["curry", Ot],
      ["curryRight", Jr],
      ["flip", vn],
      ["partial", en],
      ["partialRight", nn],
      ["rearg", fn]
    ], si = "[object Arguments]", bi = "[object Array]", xi = "[object AsyncFunction]", ji = "[object Boolean]", zi = "[object Date]", Vi = "[object DOMException]", Hi = "[object Error]", ii = "[object Function]", Fi = "[object GeneratorFunction]", ni = "[object Map]", Ui = "[object Number]", ja = "[object Null]", Ga = "[object Object]", Xa = "[object Promise]", Ns = "[object Proxy]", Ya = "[object RegExp]", Qa = "[object Set]", Ja = "[object String]", Ms = "[object Symbol]", Hs = "[object Undefined]", no = "[object WeakMap]", Qs = "[object WeakSet]", Zs = "[object ArrayBuffer]", so = "[object DataView]", io = "[object Float32Array]", dl = "[object Float64Array]", vl = "[object Int8Array]", lo = "[object Int16Array]", yl = "[object Int32Array]", bl = "[object Uint8Array]", Al = "[object Uint8ClampedArray]", Xl = "[object Uint16Array]", $l = "[object Uint32Array]", Bl = /\b__p \+= '';/g, Fl = /\b(__p \+=) '' \+/g, kl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ql = /&(?:amp|lt|gt|quot|#39);/g, _l = /[&<>"']/g, Ol = RegExp(ql.source), Ll = RegExp(_l.source), Ql = /<%-([\s\S]+?)%>/g, wl = /<%([\s\S]+?)%>/g, to = /<%=([\s\S]+?)%>/g, zs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Gs = /^\w*$/, Pl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ml = /[\\^$.*+?()[\]{}|]/g, Ws = RegExp(Ml.source), Ks = /^\s+/, Js = /\s/, qs = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ho = /\{\n\/\* \[wrapped with (.+)\] \*/, mn = /,? & /, ai = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, $i = /[()=,{}\[\]\/\s]/, Ha = /\\(\\)?/g, Va = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Us = /\w*$/, $s = /^[-+]0x[0-9a-f]+$/i, Za = /^0b[01]+$/i, ml = /^\[object .+?Constructor\]$/, Ys = /^0o[0-7]+$/i, Bs = /^(?:0|[1-9]\d*)$/, Wa = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, js = /($^)/, Fs = /['\n\r\u2028\u2029\\]/g, Xi = "\\ud800-\\udfff", ao = "\\u0300-\\u036f", Sl = "\\ufe20-\\ufe2f", xl = "\\u20d0-\\u20ff", fm = ao + Sl + xl, Jp = "\\u2700-\\u27bf", um = "a-z\\xdf-\\xf6\\xf8-\\xff", sm = "\\xac\\xb1\\xd7\\xf7", em = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", _m = "\\u2000-\\u206f", wm = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", tm = "A-Z\\xc0-\\xd6\\xd8-\\xde", cm = "\\ufe0e\\ufe0f", Lm = sm + em + _m + wm, Om = "['’]", Vm = "[" + Xi + "]", ug = "[" + Lm + "]", qm = "[" + fm + "]", Tl = "\\d+", uo = "[" + Jp + "]", om = "[" + um + "]", pm = "[^" + Xi + Lm + Tl + Jp + um + tm + "]", zl = "\\ud83c[\\udffb-\\udfff]", rm = "(?:" + qm + "|" + zl + ")", Zp = "[^" + Xi + "]", Am = "(?:\\ud83c[\\udde6-\\uddff]){2}", Sm = "[\\ud800-\\udbff][\\udc00-\\udfff]", mm = "[" + tm + "]", Rm = "\\u200d", $m = "(?:" + om + "|" + pm + ")", xm = "(?:" + mm + "|" + pm + ")", Ig = "(?:" + Om + "(?:d|ll|m|re|s|t|ve))?", km = "(?:" + Om + "(?:D|LL|M|RE|S|T|VE))?", Og = rm + "?", yg = "[" + cm + "]?", cg = "(?:" + Rm + "(?:" + [Zp, Am, Sm].join("|") + ")" + yg + Og + ")*", zm = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Eg = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Mg = yg + Og + cg, h1 = "(?:" + [uo, Am, Sm].join("|") + ")" + Mg, L1 = "(?:" + [Zp + qm + "?", qm, Am, Sm, Vm].join("|") + ")", p1 = RegExp(Om, "g"), ro = RegExp(qm, "g"), co = RegExp(zl + "(?=" + zl + ")|" + L1 + Mg, "g"), Wl = RegExp([
      mm + "?" + om + "+" + Ig + "(?=" + [ug, mm, "$"].join("|") + ")",
      xm + "+" + km + "(?=" + [ug, mm + $m, "$"].join("|") + ")",
      mm + "?" + $m + "+" + Ig,
      mm + "+" + km,
      Eg,
      zm,
      Tl,
      h1
    ].join("|"), "g"), hm = RegExp("[" + Rm + Xi + fm + cm + "]"), lm = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, m1 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], g1 = -1, Gl = {};
    Gl[io] = Gl[dl] = Gl[vl] = Gl[lo] = Gl[yl] = Gl[bl] = Gl[Al] = Gl[Xl] = Gl[$l] = !0, Gl[si] = Gl[bi] = Gl[Zs] = Gl[ji] = Gl[so] = Gl[zi] = Gl[Hi] = Gl[ii] = Gl[ni] = Gl[Ui] = Gl[Ga] = Gl[Ya] = Gl[Qa] = Gl[Ja] = Gl[no] = !1;
    var Vl = {};
    Vl[si] = Vl[bi] = Vl[Zs] = Vl[so] = Vl[ji] = Vl[zi] = Vl[io] = Vl[dl] = Vl[vl] = Vl[lo] = Vl[yl] = Vl[ni] = Vl[Ui] = Vl[Ga] = Vl[Ya] = Vl[Qa] = Vl[Ja] = Vl[Ms] = Vl[bl] = Vl[Al] = Vl[Xl] = Vl[$l] = !0, Vl[Hi] = Vl[ii] = Vl[no] = !1;
    var WS = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Vx = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Hx = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, qx = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, zx = parseFloat, Wx = parseInt, GS = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, wS = typeof self == "object" && self && self.Object === Object && self, Dm = GS || wS || Function("return this")(), iS = ie && !ie.nodeType && ie, dg = iS && !0 && ce && !ce.nodeType && ce, YS = dg && dg.exports === iS, AS = YS && GS.process, Xm = function() {
      try {
        var Si = dg && dg.require && dg.require("util").types;
        return Si || AS && AS.binding && AS.binding("util");
      } catch {
      }
    }(), KS = Xm && Xm.isArrayBuffer, XS = Xm && Xm.isDate, N1 = Xm && Xm.isMap, y1 = Xm && Xm.isRegExp, b1 = Xm && Xm.isSet, F1 = Xm && Xm.isTypedArray;
    function dm(Si, Gi, qi) {
      switch (qi.length) {
        case 0:
          return Si.call(Gi);
        case 1:
          return Si.call(Gi, qi[0]);
        case 2:
          return Si.call(Gi, qi[0], qi[1]);
        case 3:
          return Si.call(Gi, qi[0], qi[1], qi[2]);
      }
      return Si.apply(Gi, qi);
    }
    function bg(Si, Gi, qi, eo) {
      for (var gl = -1, Ul = Si == null ? 0 : Si.length; ++gl < Ul; ) {
        var ym = Si[gl];
        Gi(eo, ym, qi(ym), Si);
      }
      return eo;
    }
    function Nm(Si, Gi) {
      for (var qi = -1, eo = Si == null ? 0 : Si.length; ++qi < eo && Gi(Si[qi], qi, Si) !== !1; )
        ;
      return Si;
    }
    function ZS(Si, Gi) {
      for (var qi = Si == null ? 0 : Si.length; qi-- && Gi(Si[qi], qi, Si) !== !1; )
        ;
      return Si;
    }
    function QS(Si, Gi) {
      for (var qi = -1, eo = Si == null ? 0 : Si.length; ++qi < eo; )
        if (!Gi(Si[qi], qi, Si))
          return !1;
      return !0;
    }
    function Cg(Si, Gi) {
      for (var qi = -1, eo = Si == null ? 0 : Si.length, gl = 0, Ul = []; ++qi < eo; ) {
        var ym = Si[qi];
        Gi(ym, qi, Si) && (Ul[gl++] = ym);
      }
      return Ul;
    }
    function aS(Si, Gi) {
      var qi = Si == null ? 0 : Si.length;
      return !!qi && x1(Si, Gi, 0) > -1;
    }
    function $S(Si, Gi, qi) {
      for (var eo = -1, gl = Si == null ? 0 : Si.length; ++eo < gl; )
        if (qi(Gi, Si[eo]))
          return !0;
      return !1;
    }
    function im(Si, Gi) {
      for (var qi = -1, eo = Si == null ? 0 : Si.length, gl = Array(eo); ++qi < eo; )
        gl[qi] = Gi(Si[qi], qi, Si);
      return gl;
    }
    function _g(Si, Gi) {
      for (var qi = -1, eo = Gi.length, gl = Si.length; ++qi < eo; )
        Si[gl + qi] = Gi[qi];
      return Si;
    }
    function _1(Si, Gi, qi, eo) {
      var gl = -1, Ul = Si == null ? 0 : Si.length;
      for (eo && Ul && (qi = Si[++gl]); ++gl < Ul; )
        qi = Gi(qi, Si[gl], gl, Si);
      return qi;
    }
    function j1(Si, Gi, qi, eo) {
      var gl = Si == null ? 0 : Si.length;
      for (eo && gl && (qi = Si[--gl]); gl--; )
        qi = Gi(qi, Si[gl], gl, Si);
      return qi;
    }
    function S1(Si, Gi) {
      for (var qi = -1, eo = Si == null ? 0 : Si.length; ++qi < eo; )
        if (Gi(Si[qi], qi, Si))
          return !0;
      return !1;
    }
    var Lg = RS("length");
    function Gx(Si) {
      return Si.split("");
    }
    function JS(Si) {
      return Si.match(ai) || [];
    }
    function PS(Si, Gi, qi) {
      var eo;
      return qi(Si, function(gl, Ul, ym) {
        if (Gi(gl, Ul, ym))
          return eo = Ul, !1;
      }), eo;
    }
    function B1(Si, Gi, qi, eo) {
      for (var gl = Si.length, Ul = qi + (eo ? 1 : -1); eo ? Ul-- : ++Ul < gl; )
        if (Gi(Si[Ul], Ul, Si))
          return Ul;
      return -1;
    }
    function x1(Si, Gi, qi) {
      return Gi === Gi ? lx(Si, Gi, qi) : B1(Si, ex, qi);
    }
    function Yx(Si, Gi, qi, eo) {
      for (var gl = qi - 1, Ul = Si.length; ++gl < Ul; )
        if (eo(Si[gl], Gi))
          return gl;
      return -1;
    }
    function ex(Si) {
      return Si !== Si;
    }
    function U1(Si, Gi) {
      var qi = Si == null ? 0 : Si.length;
      return qi ? oS(Si, Gi) / qi : pn;
    }
    function RS(Si) {
      return function(Gi) {
        return Gi == null ? me : Gi[Si];
      };
    }
    function sS(Si) {
      return function(Gi) {
        return Si == null ? me : Si[Gi];
      };
    }
    function tx(Si, Gi, qi, eo, gl) {
      return gl(Si, function(Ul, ym, Yl) {
        qi = eo ? (eo = !1, Ul) : Gi(qi, Ul, ym, Yl);
      }), qi;
    }
    function Kx(Si, Gi) {
      var qi = Si.length;
      for (Si.sort(Gi); qi--; )
        Si[qi] = Si[qi].value;
      return Si;
    }
    function oS(Si, Gi) {
      for (var qi, eo = -1, gl = Si.length; ++eo < gl; ) {
        var Ul = Gi(Si[eo]);
        Ul !== me && (qi = qi === me ? Ul : qi + Ul);
      }
      return qi;
    }
    function V1(Si, Gi) {
      for (var qi = -1, eo = Array(Si); ++qi < Si; )
        eo[qi] = Gi(qi);
      return eo;
    }
    function Xx(Si, Gi) {
      return im(Gi, function(qi) {
        return [qi, Si[qi]];
      });
    }
    function rx(Si) {
      return Si && Si.slice(0, z1(Si) + 1).replace(Ks, "");
    }
    function Wm(Si) {
      return function(Gi) {
        return Si(Gi);
      };
    }
    function H1(Si, Gi) {
      return im(Gi, function(qi) {
        return Si[qi];
      });
    }
    function q1(Si, Gi) {
      return Si.has(Gi);
    }
    function kS(Si, Gi) {
      for (var qi = -1, eo = Si.length; ++qi < eo && x1(Gi, Si[qi], 0) > -1; )
        ;
      return qi;
    }
    function nx(Si, Gi) {
      for (var qi = Si.length; qi-- && x1(Gi, Si[qi], 0) > -1; )
        ;
      return qi;
    }
    function Zx(Si, Gi) {
      for (var qi = Si.length, eo = 0; qi--; )
        Si[qi] === Gi && ++eo;
      return eo;
    }
    var ix = sS(WS), Qx = sS(Vx);
    function ax(Si) {
      return "\\" + qx[Si];
    }
    function sx(Si, Gi) {
      return Si == null ? me : Si[Gi];
    }
    function e1(Si) {
      return hm.test(Si);
    }
    function Jx(Si) {
      return lm.test(Si);
    }
    function eE(Si) {
      for (var Gi, qi = []; !(Gi = Si.next()).done; )
        qi.push(Gi.value);
      return qi;
    }
    function T1(Si) {
      var Gi = -1, qi = Array(Si.size);
      return Si.forEach(function(eo, gl) {
        qi[++Gi] = [gl, eo];
      }), qi;
    }
    function ox(Si, Gi) {
      return function(qi) {
        return Si(Gi(qi));
      };
    }
    function wg(Si, Gi) {
      for (var qi = -1, eo = Si.length, gl = 0, Ul = []; ++qi < eo; ) {
        var ym = Si[qi];
        (ym === Gi || ym === ot) && (Si[qi] = ot, Ul[gl++] = qi);
      }
      return Ul;
    }
    function lS(Si) {
      var Gi = -1, qi = Array(Si.size);
      return Si.forEach(function(eo) {
        qi[++Gi] = eo;
      }), qi;
    }
    function tE(Si) {
      var Gi = -1, qi = Array(Si.size);
      return Si.forEach(function(eo) {
        qi[++Gi] = [eo, eo];
      }), qi;
    }
    function lx(Si, Gi, qi) {
      for (var eo = qi - 1, gl = Si.length; ++eo < gl; )
        if (Si[eo] === Gi)
          return eo;
      return -1;
    }
    function rE(Si, Gi, qi) {
      for (var eo = qi + 1; eo--; )
        if (Si[eo] === Gi)
          return eo;
      return eo;
    }
    function fg(Si) {
      return e1(Si) ? gm(Si) : Lg(Si);
    }
    function Zm(Si) {
      return e1(Si) ? E1(Si) : Gx(Si);
    }
    function z1(Si) {
      for (var Gi = Si.length; Gi-- && Js.test(Si.charAt(Gi)); )
        ;
      return Gi;
    }
    var W1 = sS(Hx);
    function gm(Si) {
      for (var Gi = co.lastIndex = 0; co.test(Si); )
        ++Gi;
      return Gi;
    }
    function E1(Si) {
      return Si.match(co) || [];
    }
    function DS(Si) {
      return Si.match(Wl) || [];
    }
    var nE = function Si(Gi) {
      Gi = Gi == null ? Dm : C1.defaults(Dm.Object(), Gi, C1.pick(Dm, m1));
      var qi = Gi.Array, eo = Gi.Date, gl = Gi.Error, Ul = Gi.Function, ym = Gi.Math, Yl = Gi.Object, uS = Gi.RegExp, IS = Gi.String, Qm = Gi.TypeError, Ag = qi.prototype, iE = Ul.prototype, r1 = Yl.prototype, G1 = Gi["__core-js_shared__"], cS = iE.toString, Kl = r1.hasOwnProperty, ux = 0, cx = function() {
        var ft = /[^.]+$/.exec(G1 && G1.keys && G1.keys.IE_PROTO || "");
        return ft ? "Symbol(src)_1." + ft : "";
      }(), dS = r1.toString, OS = cS.call(Yl), aE = Dm._, sE = uS(
        "^" + cS.call(Kl).replace(Ml, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), fS = YS ? Gi.Buffer : me, Pg = Gi.Symbol, hS = Gi.Uint8Array, dx = fS ? fS.allocUnsafe : me, pS = ox(Yl.getPrototypeOf, Yl), fx = Yl.create, hx = r1.propertyIsEnumerable, mS = Ag.splice, px = Pg ? Pg.isConcatSpreadable : me, Jm = Pg ? Pg.iterator : me, n1 = Pg ? Pg.toStringTag : me, gS = function() {
        try {
          var ft = tS(Yl, "defineProperty");
          return ft({}, "", {}), ft;
        } catch {
        }
      }(), oE = Gi.clearTimeout !== Dm.clearTimeout && Gi.clearTimeout, mx = eo && eo.now !== Dm.Date.now && eo.now, MS = Gi.setTimeout !== Dm.setTimeout && Gi.setTimeout, Y1 = ym.ceil, i1 = ym.floor, w1 = Yl.getOwnPropertySymbols, lE = fS ? fS.isBuffer : me, gx = Gi.isFinite, uE = Ag.join, cE = ox(Yl.keys, Yl), Tm = ym.max, Pm = ym.min, dE = eo.now, fE = Gi.parseInt, LS = ym.random, A1 = Ag.reverse, Hl = tS(Gi, "DataView"), ig = tS(Gi, "Map"), Im = tS(Gi, "Promise"), Fm = tS(Gi, "Set"), K1 = tS(Gi, "WeakMap"), $1 = tS(Yl, "create"), vS = K1 && new K1(), P1 = {}, hE = rS(Hl), pE = rS(ig), mE = rS(Im), gE = rS(Fm), vE = rS(K1), X1 = Pg ? Pg.prototype : me, zt = X1 ? X1.valueOf : me, tn = X1 ? X1.toString : me;
      function Wt(ft) {
        if (bm(ft) && !Cl(ft) && !(ft instanceof _n)) {
          if (ft instanceof dn)
            return ft;
          if (Kl.call(ft, "__wrapped__"))
            return lw(ft);
        }
        return new dn(ft);
      }
      var rn = /* @__PURE__ */ function() {
        function ft() {
        }
        return function(xt) {
          if (!vm(xt))
            return {};
          if (fx)
            return fx(xt);
          ft.prototype = xt;
          var Zr = new ft();
          return ft.prototype = me, Zr;
        };
      }();
      function sn() {
      }
      function dn(ft, xt) {
        this.__wrapped__ = ft, this.__actions__ = [], this.__chain__ = !!xt, this.__index__ = 0, this.__values__ = me;
      }
      Wt.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ql,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: wl,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: to,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Wt
        }
      }, Wt.prototype = sn.prototype, Wt.prototype.constructor = Wt, dn.prototype = rn(sn.prototype), dn.prototype.constructor = dn;
      function _n(ft) {
        this.__wrapped__ = ft, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = hn, this.__views__ = [];
      }
      function wn() {
        var ft = new _n(this.__wrapped__);
        return ft.__actions__ = eg(this.__actions__), ft.__dir__ = this.__dir__, ft.__filtered__ = this.__filtered__, ft.__iteratees__ = eg(this.__iteratees__), ft.__takeCount__ = this.__takeCount__, ft.__views__ = eg(this.__views__), ft;
      }
      function Dn() {
        if (this.__filtered__) {
          var ft = new _n(this);
          ft.__dir__ = -1, ft.__filtered__ = !0;
        } else
          ft = this.clone(), ft.__dir__ *= -1;
        return ft;
      }
      function Fn() {
        var ft = this.__wrapped__.value(), xt = this.__dir__, Zr = Cl(ft), on = xt < 0, yn = Zr ? ft.length : 0, En = BA(0, yn, this.__views__), ri = En.start, vi = En.end, Ti = vi - ri, qa = on ? vi : ri - 1, za = this.__iteratees__, Ka = za.length, Xs = 0, oo = Pm(Ti, this.__takeCount__);
        if (!Zr || !on && yn == Ti && oo == Ti)
          return kC(ft, this.__actions__);
        var hl = [];
        e:
          for (; Ti-- && Xs < oo; ) {
            qa += xt;
            for (var Dl = -1, pl = ft[qa]; ++Dl < Ka; ) {
              var Nl = za[Dl], jl = Nl.iteratee, og = Nl.type, Km = jl(pl);
              if (og == kn)
                pl = Km;
              else if (!Km) {
                if (og == Cn)
                  continue e;
                break e;
              }
            }
            hl[Xs++] = pl;
          }
        return hl;
      }
      _n.prototype = rn(sn.prototype), _n.prototype.constructor = _n;
      function yi(ft) {
        var xt = -1, Zr = ft == null ? 0 : ft.length;
        for (this.clear(); ++xt < Zr; ) {
          var on = ft[xt];
          this.set(on[0], on[1]);
        }
      }
      function Wi() {
        this.__data__ = $1 ? $1(null) : {}, this.size = 0;
      }
      function Vs(ft) {
        var xt = this.has(ft) && delete this.__data__[ft];
        return this.size -= xt ? 1 : 0, xt;
      }
      function $a(ft) {
        var xt = this.__data__;
        if ($1) {
          var Zr = xt[ft];
          return Zr === Ge ? me : Zr;
        }
        return Kl.call(xt, ft) ? xt[ft] : me;
      }
      function fo(ft) {
        var xt = this.__data__;
        return $1 ? xt[ft] !== me : Kl.call(xt, ft);
      }
      function El(ft, xt) {
        var Zr = this.__data__;
        return this.size += this.has(ft) ? 0 : 1, Zr[ft] = $1 && xt === me ? Ge : xt, this;
      }
      yi.prototype.clear = Wi, yi.prototype.delete = Vs, yi.prototype.get = $a, yi.prototype.has = fo, yi.prototype.set = El;
      function Qp(ft) {
        var xt = -1, Zr = ft == null ? 0 : ft.length;
        for (this.clear(); ++xt < Zr; ) {
          var on = ft[xt];
          this.set(on[0], on[1]);
        }
      }
      function jm() {
        this.__data__ = [], this.size = 0;
      }
      function hg(ft) {
        var xt = this.__data__, Zr = yx(xt, ft);
        if (Zr < 0)
          return !1;
        var on = xt.length - 1;
        return Zr == on ? xt.pop() : mS.call(xt, Zr, 1), --this.size, !0;
      }
      function Z1(ft) {
        var xt = this.__data__, Zr = yx(xt, ft);
        return Zr < 0 ? me : xt[Zr][1];
      }
      function yS(ft) {
        return yx(this.__data__, ft) > -1;
      }
      function bS(ft, xt) {
        var Zr = this.__data__, on = yx(Zr, ft);
        return on < 0 ? (++this.size, Zr.push([ft, xt])) : Zr[on][1] = xt, this;
      }
      Qp.prototype.clear = jm, Qp.prototype.delete = hg, Qp.prototype.get = Z1, Qp.prototype.has = yS, Qp.prototype.set = bS;
      function Bm(ft) {
        var xt = -1, Zr = ft == null ? 0 : ft.length;
        for (this.clear(); ++xt < Zr; ) {
          var on = ft[xt];
          this.set(on[0], on[1]);
        }
      }
      function Q1() {
        this.size = 0, this.__data__ = {
          hash: new yi(),
          map: new (ig || Qp)(),
          string: new yi()
        };
      }
      function am(ft) {
        var xt = kx(this, ft).delete(ft);
        return this.size -= xt ? 1 : 0, xt;
      }
      function vx(ft) {
        return kx(this, ft).get(ft);
      }
      function a1(ft) {
        return kx(this, ft).has(ft);
      }
      function Hw(ft, xt) {
        var Zr = kx(this, ft), on = Zr.size;
        return Zr.set(ft, xt), this.size += Zr.size == on ? 0 : 1, this;
      }
      Bm.prototype.clear = Q1, Bm.prototype.delete = am, Bm.prototype.get = vx, Bm.prototype.has = a1, Bm.prototype.set = Hw;
      function J1(ft) {
        var xt = -1, Zr = ft == null ? 0 : ft.length;
        for (this.__data__ = new Bm(); ++xt < Zr; )
          this.add(ft[xt]);
      }
      function qw(ft) {
        return this.__data__.set(ft, Ge), this;
      }
      function zw(ft) {
        return this.__data__.has(ft);
      }
      J1.prototype.add = J1.prototype.push = qw, J1.prototype.has = zw;
      function Sg(ft) {
        var xt = this.__data__ = new Qp(ft);
        this.size = xt.size;
      }
      function Ww() {
        this.__data__ = new Qp(), this.size = 0;
      }
      function Gw(ft) {
        var xt = this.__data__, Zr = xt.delete(ft);
        return this.size = xt.size, Zr;
      }
      function Yw(ft) {
        return this.__data__.get(ft);
      }
      function Kw(ft) {
        return this.__data__.has(ft);
      }
      function Xw(ft, xt) {
        var Zr = this.__data__;
        if (Zr instanceof Qp) {
          var on = Zr.__data__;
          if (!ig || on.length < Re - 1)
            return on.push([ft, xt]), this.size = ++Zr.size, this;
          Zr = this.__data__ = new Bm(on);
        }
        return Zr.set(ft, xt), this.size = Zr.size, this;
      }
      Sg.prototype.clear = Ww, Sg.prototype.delete = Gw, Sg.prototype.get = Yw, Sg.prototype.has = Kw, Sg.prototype.set = Xw;
      function lC(ft, xt) {
        var Zr = Cl(ft), on = !Zr && nS(ft), yn = !Zr && !on && O1(ft), En = !Zr && !on && !yn && TS(ft), ri = Zr || on || yn || En, vi = ri ? V1(ft.length, IS) : [], Ti = vi.length;
        for (var qa in ft)
          (xt || Kl.call(ft, qa)) && !(ri && // Safari 9 has enumerable `arguments.length` in strict mode.
          (qa == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          yn && (qa == "offset" || qa == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          En && (qa == "buffer" || qa == "byteLength" || qa == "byteOffset") || // Skip index properties.
          u1(qa, Ti))) && vi.push(qa);
        return vi;
      }
      function uC(ft) {
        var xt = ft.length;
        return xt ? ft[$E(0, xt - 1)] : me;
      }
      function Zw(ft, xt) {
        return Dx(eg(ft), Z2(xt, 0, ft.length));
      }
      function Qw(ft) {
        return Dx(eg(ft));
      }
      function yE(ft, xt, Zr) {
        (Zr !== me && !xg(ft[xt], Zr) || Zr === me && !(xt in ft)) && s1(ft, xt, Zr);
      }
      function NS(ft, xt, Zr) {
        var on = ft[xt];
        (!(Kl.call(ft, xt) && xg(on, Zr)) || Zr === me && !(xt in ft)) && s1(ft, xt, Zr);
      }
      function yx(ft, xt) {
        for (var Zr = ft.length; Zr--; )
          if (xg(ft[Zr][0], xt))
            return Zr;
        return -1;
      }
      function Jw(ft, xt, Zr, on) {
        return R1(ft, function(yn, En, ri) {
          xt(on, yn, Zr(yn), ri);
        }), on;
      }
      function cC(ft, xt) {
        return ft && kg(xt, Mm(xt), ft);
      }
      function eA(ft, xt) {
        return ft && kg(xt, rg(xt), ft);
      }
      function s1(ft, xt, Zr) {
        xt == "__proto__" && gS ? gS(ft, xt, {
          configurable: !0,
          enumerable: !0,
          value: Zr,
          writable: !0
        }) : ft[xt] = Zr;
      }
      function bE(ft, xt) {
        for (var Zr = -1, on = xt.length, yn = qi(on), En = ft == null; ++Zr < on; )
          yn[Zr] = En ? me : JE(ft, xt[Zr]);
        return yn;
      }
      function Z2(ft, xt, Zr) {
        return ft === ft && (Zr !== me && (ft = ft <= Zr ? ft : Zr), xt !== me && (ft = ft >= xt ? ft : xt)), ft;
      }
      function pg(ft, xt, Zr, on, yn, En) {
        var ri, vi = xt & vt, Ti = xt & bt, qa = xt & Tt;
        if (Zr && (ri = yn ? Zr(ft, on, yn, En) : Zr(ft)), ri !== me)
          return ri;
        if (!vm(ft))
          return ft;
        var za = Cl(ft);
        if (za) {
          if (ri = VA(ft), !vi)
            return eg(ft, ri);
        } else {
          var Ka = Hm(ft), Xs = Ka == ii || Ka == Fi;
          if (O1(ft))
            return OC(ft, vi);
          if (Ka == Ga || Ka == si || Xs && !yn) {
            if (ri = Ti || Xs ? {} : JC(ft), !vi)
              return Ti ? kA(ft, eA(ri, ft)) : RA(ft, cC(ri, ft));
          } else {
            if (!Vl[Ka])
              return yn ? ft : {};
            ri = HA(ft, Ka, vi);
          }
        }
        En || (En = new Sg());
        var oo = En.get(ft);
        if (oo)
          return oo;
        En.set(ft, ri), $w(ft) ? ft.forEach(function(pl) {
          ri.add(pg(pl, xt, Zr, pl, ft, En));
        }) : ww(ft) && ft.forEach(function(pl, Nl) {
          ri.set(Nl, pg(pl, xt, Zr, Nl, ft, En));
        });
        var hl = qa ? Ti ? jE : FE : Ti ? rg : Mm, Dl = za ? me : hl(ft);
        return Nm(Dl || ft, function(pl, Nl) {
          Dl && (Nl = pl, pl = ft[Nl]), NS(ri, Nl, pg(pl, xt, Zr, Nl, ft, En));
        }), ri;
      }
      function tA(ft) {
        var xt = Mm(ft);
        return function(Zr) {
          return dC(Zr, ft, xt);
        };
      }
      function dC(ft, xt, Zr) {
        var on = Zr.length;
        if (ft == null)
          return !on;
        for (ft = Yl(ft); on--; ) {
          var yn = Zr[on], En = xt[yn], ri = ft[yn];
          if (ri === me && !(yn in ft) || !En(ri))
            return !1;
        }
        return !0;
      }
      function fC(ft, xt, Zr) {
        if (typeof ft != "function")
          throw new Qm(Ue);
        return qS(function() {
          ft.apply(me, Zr);
        }, xt);
      }
      function FS(ft, xt, Zr, on) {
        var yn = -1, En = aS, ri = !0, vi = ft.length, Ti = [], qa = xt.length;
        if (!vi)
          return Ti;
        Zr && (xt = im(xt, Wm(Zr))), on ? (En = $S, ri = !1) : xt.length >= Re && (En = q1, ri = !1, xt = new J1(xt));
        e:
          for (; ++yn < vi; ) {
            var za = ft[yn], Ka = Zr == null ? za : Zr(za);
            if (za = on || za !== 0 ? za : 0, ri && Ka === Ka) {
              for (var Xs = qa; Xs--; )
                if (xt[Xs] === Ka)
                  continue e;
              Ti.push(za);
            } else En(xt, Ka, on) || Ti.push(za);
          }
        return Ti;
      }
      var R1 = jC(Rg), hC = jC(SE, !0);
      function rA(ft, xt) {
        var Zr = !0;
        return R1(ft, function(on, yn, En) {
          return Zr = !!xt(on, yn, En), Zr;
        }), Zr;
      }
      function bx(ft, xt, Zr) {
        for (var on = -1, yn = ft.length; ++on < yn; ) {
          var En = ft[on], ri = xt(En);
          if (ri != null && (vi === me ? ri === ri && !sg(ri) : Zr(ri, vi)))
            var vi = ri, Ti = En;
        }
        return Ti;
      }
      function nA(ft, xt, Zr, on) {
        var yn = ft.length;
        for (Zr = Rl(Zr), Zr < 0 && (Zr = -Zr > yn ? 0 : yn + Zr), on = on === me || on > yn ? yn : Rl(on), on < 0 && (on += yn), on = Zr > on ? 0 : Rw(on); Zr < on; )
          ft[Zr++] = xt;
        return ft;
      }
      function pC(ft, xt) {
        var Zr = [];
        return R1(ft, function(on, yn, En) {
          xt(on, yn, En) && Zr.push(on);
        }), Zr;
      }
      function Um(ft, xt, Zr, on, yn) {
        var En = -1, ri = ft.length;
        for (Zr || (Zr = zA), yn || (yn = []); ++En < ri; ) {
          var vi = ft[En];
          xt > 0 && Zr(vi) ? xt > 1 ? Um(vi, xt - 1, Zr, on, yn) : _g(yn, vi) : on || (yn[yn.length] = vi);
        }
        return yn;
      }
      var _E = BC(), mC = BC(!0);
      function Rg(ft, xt) {
        return ft && _E(ft, xt, Mm);
      }
      function SE(ft, xt) {
        return ft && mC(ft, xt, Mm);
      }
      function Sx(ft, xt) {
        return Cg(xt, function(Zr) {
          return c1(ft[Zr]);
        });
      }
      function eS(ft, xt) {
        xt = D1(xt, ft);
        for (var Zr = 0, on = xt.length; ft != null && Zr < on; )
          ft = ft[Dg(xt[Zr++])];
        return Zr && Zr == on ? ft : me;
      }
      function gC(ft, xt, Zr) {
        var on = xt(ft);
        return Cl(ft) ? on : _g(on, Zr(ft));
      }
      function Gm(ft) {
        return ft == null ? ft === me ? Hs : ja : n1 && n1 in Yl(ft) ? jA(ft) : QA(ft);
      }
      function xE(ft, xt) {
        return ft > xt;
      }
      function iA(ft, xt) {
        return ft != null && Kl.call(ft, xt);
      }
      function aA(ft, xt) {
        return ft != null && xt in Yl(ft);
      }
      function sA(ft, xt, Zr) {
        return ft >= Pm(xt, Zr) && ft < Tm(xt, Zr);
      }
      function TE(ft, xt, Zr) {
        for (var on = Zr ? $S : aS, yn = ft[0].length, En = ft.length, ri = En, vi = qi(En), Ti = 1 / 0, qa = []; ri--; ) {
          var za = ft[ri];
          ri && xt && (za = im(za, Wm(xt))), Ti = Pm(za.length, Ti), vi[ri] = !Zr && (xt || yn >= 120 && za.length >= 120) ? new J1(ri && za) : me;
        }
        za = ft[0];
        var Ka = -1, Xs = vi[0];
        e:
          for (; ++Ka < yn && qa.length < Ti; ) {
            var oo = za[Ka], hl = xt ? xt(oo) : oo;
            if (oo = Zr || oo !== 0 ? oo : 0, !(Xs ? q1(Xs, hl) : on(qa, hl, Zr))) {
              for (ri = En; --ri; ) {
                var Dl = vi[ri];
                if (!(Dl ? q1(Dl, hl) : on(ft[ri], hl, Zr)))
                  continue e;
              }
              Xs && Xs.push(hl), qa.push(oo);
            }
          }
        return qa;
      }
      function oA(ft, xt, Zr, on) {
        return Rg(ft, function(yn, En, ri) {
          xt(on, Zr(yn), En, ri);
        }), on;
      }
      function jS(ft, xt, Zr) {
        xt = D1(xt, ft), ft = nw(ft, xt);
        var on = ft == null ? ft : ft[Dg(gg(xt))];
        return on == null ? me : dm(on, ft, Zr);
      }
      function vC(ft) {
        return bm(ft) && Gm(ft) == si;
      }
      function lA(ft) {
        return bm(ft) && Gm(ft) == Zs;
      }
      function uA(ft) {
        return bm(ft) && Gm(ft) == zi;
      }
      function BS(ft, xt, Zr, on, yn) {
        return ft === xt ? !0 : ft == null || xt == null || !bm(ft) && !bm(xt) ? ft !== ft && xt !== xt : cA(ft, xt, Zr, on, BS, yn);
      }
      function cA(ft, xt, Zr, on, yn, En) {
        var ri = Cl(ft), vi = Cl(xt), Ti = ri ? bi : Hm(ft), qa = vi ? bi : Hm(xt);
        Ti = Ti == si ? Ga : Ti, qa = qa == si ? Ga : qa;
        var za = Ti == Ga, Ka = qa == Ga, Xs = Ti == qa;
        if (Xs && O1(ft)) {
          if (!O1(xt))
            return !1;
          ri = !0, za = !1;
        }
        if (Xs && !za)
          return En || (En = new Sg()), ri || TS(ft) ? XC(ft, xt, Zr, on, yn, En) : NA(ft, xt, Ti, Zr, on, yn, En);
        if (!(Zr & wt)) {
          var oo = za && Kl.call(ft, "__wrapped__"), hl = Ka && Kl.call(xt, "__wrapped__");
          if (oo || hl) {
            var Dl = oo ? ft.value() : ft, pl = hl ? xt.value() : xt;
            return En || (En = new Sg()), yn(Dl, pl, Zr, on, En);
          }
        }
        return Xs ? (En || (En = new Sg()), FA(ft, xt, Zr, on, yn, En)) : !1;
      }
      function dA(ft) {
        return bm(ft) && Hm(ft) == ni;
      }
      function EE(ft, xt, Zr, on) {
        var yn = Zr.length, En = yn, ri = !on;
        if (ft == null)
          return !En;
        for (ft = Yl(ft); yn--; ) {
          var vi = Zr[yn];
          if (ri && vi[2] ? vi[1] !== ft[vi[0]] : !(vi[0] in ft))
            return !1;
        }
        for (; ++yn < En; ) {
          vi = Zr[yn];
          var Ti = vi[0], qa = ft[Ti], za = vi[1];
          if (ri && vi[2]) {
            if (qa === me && !(Ti in ft))
              return !1;
          } else {
            var Ka = new Sg();
            if (on)
              var Xs = on(qa, za, Ti, ft, xt, Ka);
            if (!(Xs === me ? BS(za, qa, wt | St, on, Ka) : Xs))
              return !1;
          }
        }
        return !0;
      }
      function yC(ft) {
        if (!vm(ft) || GA(ft))
          return !1;
        var xt = c1(ft) ? sE : ml;
        return xt.test(rS(ft));
      }
      function fA(ft) {
        return bm(ft) && Gm(ft) == Ya;
      }
      function hA(ft) {
        return bm(ft) && Hm(ft) == Qa;
      }
      function pA(ft) {
        return bm(ft) && Fx(ft.length) && !!Gl[Gm(ft)];
      }
      function bC(ft) {
        return typeof ft == "function" ? ft : ft == null ? ng : typeof ft == "object" ? Cl(ft) ? xC(ft[0], ft[1]) : SC(ft) : Uw(ft);
      }
      function CE(ft) {
        if (!HS(ft))
          return cE(ft);
        var xt = [];
        for (var Zr in Yl(ft))
          Kl.call(ft, Zr) && Zr != "constructor" && xt.push(Zr);
        return xt;
      }
      function mA(ft) {
        if (!vm(ft))
          return ZA(ft);
        var xt = HS(ft), Zr = [];
        for (var on in ft)
          on == "constructor" && (xt || !Kl.call(ft, on)) || Zr.push(on);
        return Zr;
      }
      function wE(ft, xt) {
        return ft < xt;
      }
      function _C(ft, xt) {
        var Zr = -1, on = tg(ft) ? qi(ft.length) : [];
        return R1(ft, function(yn, En, ri) {
          on[++Zr] = xt(yn, En, ri);
        }), on;
      }
      function SC(ft) {
        var xt = UE(ft);
        return xt.length == 1 && xt[0][2] ? tw(xt[0][0], xt[0][1]) : function(Zr) {
          return Zr === ft || EE(Zr, ft, xt);
        };
      }
      function xC(ft, xt) {
        return HE(ft) && ew(xt) ? tw(Dg(ft), xt) : function(Zr) {
          var on = JE(Zr, ft);
          return on === me && on === xt ? eC(Zr, ft) : BS(xt, on, wt | St);
        };
      }
      function xx(ft, xt, Zr, on, yn) {
        ft !== xt && _E(xt, function(En, ri) {
          if (yn || (yn = new Sg()), vm(En))
            gA(ft, xt, ri, Zr, xx, on, yn);
          else {
            var vi = on ? on(zE(ft, ri), En, ri + "", ft, xt, yn) : me;
            vi === me && (vi = En), yE(ft, ri, vi);
          }
        }, rg);
      }
      function gA(ft, xt, Zr, on, yn, En, ri) {
        var vi = zE(ft, Zr), Ti = zE(xt, Zr), qa = ri.get(Ti);
        if (qa) {
          yE(ft, Zr, qa);
          return;
        }
        var za = En ? En(vi, Ti, Zr + "", ft, xt, ri) : me, Ka = za === me;
        if (Ka) {
          var Xs = Cl(Ti), oo = !Xs && O1(Ti), hl = !Xs && !oo && TS(Ti);
          za = Ti, Xs || oo || hl ? Cl(vi) ? za = vi : Em(vi) ? za = eg(vi) : oo ? (Ka = !1, za = OC(Ti, !0)) : hl ? (Ka = !1, za = MC(Ti, !0)) : za = [] : zS(Ti) || nS(Ti) ? (za = vi, nS(vi) ? za = kw(vi) : (!vm(vi) || c1(vi)) && (za = JC(Ti))) : Ka = !1;
        }
        Ka && (ri.set(Ti, za), yn(za, Ti, on, En, ri), ri.delete(Ti)), yE(ft, Zr, za);
      }
      function TC(ft, xt) {
        var Zr = ft.length;
        if (Zr)
          return xt += xt < 0 ? Zr : 0, u1(xt, Zr) ? ft[xt] : me;
      }
      function EC(ft, xt, Zr) {
        xt.length ? xt = im(xt, function(En) {
          return Cl(En) ? function(ri) {
            return eS(ri, En.length === 1 ? En[0] : En);
          } : En;
        }) : xt = [ng];
        var on = -1;
        xt = im(xt, Wm(fl()));
        var yn = _C(ft, function(En, ri, vi) {
          var Ti = im(xt, function(qa) {
            return qa(En);
          });
          return { criteria: Ti, index: ++on, value: En };
        });
        return Kx(yn, function(En, ri) {
          return PA(En, ri, Zr);
        });
      }
      function vA(ft, xt) {
        return CC(ft, xt, function(Zr, on) {
          return eC(ft, on);
        });
      }
      function CC(ft, xt, Zr) {
        for (var on = -1, yn = xt.length, En = {}; ++on < yn; ) {
          var ri = xt[on], vi = eS(ft, ri);
          Zr(vi, ri) && US(En, D1(ri, ft), vi);
        }
        return En;
      }
      function yA(ft) {
        return function(xt) {
          return eS(xt, ft);
        };
      }
      function AE(ft, xt, Zr, on) {
        var yn = on ? Yx : x1, En = -1, ri = xt.length, vi = ft;
        for (ft === xt && (xt = eg(xt)), Zr && (vi = im(ft, Wm(Zr))); ++En < ri; )
          for (var Ti = 0, qa = xt[En], za = Zr ? Zr(qa) : qa; (Ti = yn(vi, za, Ti, on)) > -1; )
            vi !== ft && mS.call(vi, Ti, 1), mS.call(ft, Ti, 1);
        return ft;
      }
      function wC(ft, xt) {
        for (var Zr = ft ? xt.length : 0, on = Zr - 1; Zr--; ) {
          var yn = xt[Zr];
          if (Zr == on || yn !== En) {
            var En = yn;
            u1(yn) ? mS.call(ft, yn, 1) : kE(ft, yn);
          }
        }
        return ft;
      }
      function $E(ft, xt) {
        return ft + i1(LS() * (xt - ft + 1));
      }
      function bA(ft, xt, Zr, on) {
        for (var yn = -1, En = Tm(Y1((xt - ft) / (Zr || 1)), 0), ri = qi(En); En--; )
          ri[on ? En : ++yn] = ft, ft += Zr;
        return ri;
      }
      function PE(ft, xt) {
        var Zr = "";
        if (!ft || xt < 1 || xt > an)
          return Zr;
        do
          xt % 2 && (Zr += ft), xt = i1(xt / 2), xt && (ft += ft);
        while (xt);
        return Zr;
      }
      function Il(ft, xt) {
        return WE(rw(ft, xt, ng), ft + "");
      }
      function _A(ft) {
        return uC(ES(ft));
      }
      function SA(ft, xt) {
        var Zr = ES(ft);
        return Dx(Zr, Z2(xt, 0, Zr.length));
      }
      function US(ft, xt, Zr, on) {
        if (!vm(ft))
          return ft;
        xt = D1(xt, ft);
        for (var yn = -1, En = xt.length, ri = En - 1, vi = ft; vi != null && ++yn < En; ) {
          var Ti = Dg(xt[yn]), qa = Zr;
          if (Ti === "__proto__" || Ti === "constructor" || Ti === "prototype")
            return ft;
          if (yn != ri) {
            var za = vi[Ti];
            qa = on ? on(za, Ti, vi) : me, qa === me && (qa = vm(za) ? za : u1(xt[yn + 1]) ? [] : {});
          }
          NS(vi, Ti, qa), vi = vi[Ti];
        }
        return ft;
      }
      var AC = vS ? function(ft, xt) {
        return vS.set(ft, xt), ft;
      } : ng, xA = gS ? function(ft, xt) {
        return gS(ft, "toString", {
          configurable: !0,
          enumerable: !1,
          value: rC(xt),
          writable: !0
        });
      } : ng;
      function TA(ft) {
        return Dx(ES(ft));
      }
      function mg(ft, xt, Zr) {
        var on = -1, yn = ft.length;
        xt < 0 && (xt = -xt > yn ? 0 : yn + xt), Zr = Zr > yn ? yn : Zr, Zr < 0 && (Zr += yn), yn = xt > Zr ? 0 : Zr - xt >>> 0, xt >>>= 0;
        for (var En = qi(yn); ++on < yn; )
          En[on] = ft[on + xt];
        return En;
      }
      function EA(ft, xt) {
        var Zr;
        return R1(ft, function(on, yn, En) {
          return Zr = xt(on, yn, En), !Zr;
        }), !!Zr;
      }
      function Tx(ft, xt, Zr) {
        var on = 0, yn = ft == null ? on : ft.length;
        if (typeof xt == "number" && xt === xt && yn <= In) {
          for (; on < yn; ) {
            var En = on + yn >>> 1, ri = ft[En];
            ri !== null && !sg(ri) && (Zr ? ri <= xt : ri < xt) ? on = En + 1 : yn = En;
          }
          return yn;
        }
        return RE(ft, xt, ng, Zr);
      }
      function RE(ft, xt, Zr, on) {
        var yn = 0, En = ft == null ? 0 : ft.length;
        if (En === 0)
          return 0;
        xt = Zr(xt);
        for (var ri = xt !== xt, vi = xt === null, Ti = sg(xt), qa = xt === me; yn < En; ) {
          var za = i1((yn + En) / 2), Ka = Zr(ft[za]), Xs = Ka !== me, oo = Ka === null, hl = Ka === Ka, Dl = sg(Ka);
          if (ri)
            var pl = on || hl;
          else qa ? pl = hl && (on || Xs) : vi ? pl = hl && Xs && (on || !oo) : Ti ? pl = hl && Xs && !oo && (on || !Dl) : oo || Dl ? pl = !1 : pl = on ? Ka <= xt : Ka < xt;
          pl ? yn = za + 1 : En = za;
        }
        return Pm(En, An);
      }
      function $C(ft, xt) {
        for (var Zr = -1, on = ft.length, yn = 0, En = []; ++Zr < on; ) {
          var ri = ft[Zr], vi = xt ? xt(ri) : ri;
          if (!Zr || !xg(vi, Ti)) {
            var Ti = vi;
            En[yn++] = ri === 0 ? 0 : ri;
          }
        }
        return En;
      }
      function PC(ft) {
        return typeof ft == "number" ? ft : sg(ft) ? pn : +ft;
      }
      function ag(ft) {
        if (typeof ft == "string")
          return ft;
        if (Cl(ft))
          return im(ft, ag) + "";
        if (sg(ft))
          return tn ? tn.call(ft) : "";
        var xt = ft + "";
        return xt == "0" && 1 / ft == -1 / 0 ? "-0" : xt;
      }
      function k1(ft, xt, Zr) {
        var on = -1, yn = aS, En = ft.length, ri = !0, vi = [], Ti = vi;
        if (Zr)
          ri = !1, yn = $S;
        else if (En >= Re) {
          var qa = xt ? null : MA(ft);
          if (qa)
            return lS(qa);
          ri = !1, yn = q1, Ti = new J1();
        } else
          Ti = xt ? [] : vi;
        e:
          for (; ++on < En; ) {
            var za = ft[on], Ka = xt ? xt(za) : za;
            if (za = Zr || za !== 0 ? za : 0, ri && Ka === Ka) {
              for (var Xs = Ti.length; Xs--; )
                if (Ti[Xs] === Ka)
                  continue e;
              xt && Ti.push(Ka), vi.push(za);
            } else yn(Ti, Ka, Zr) || (Ti !== vi && Ti.push(Ka), vi.push(za));
          }
        return vi;
      }
      function kE(ft, xt) {
        return xt = D1(xt, ft), ft = nw(ft, xt), ft == null || delete ft[Dg(gg(xt))];
      }
      function RC(ft, xt, Zr, on) {
        return US(ft, xt, Zr(eS(ft, xt)), on);
      }
      function Ex(ft, xt, Zr, on) {
        for (var yn = ft.length, En = on ? yn : -1; (on ? En-- : ++En < yn) && xt(ft[En], En, ft); )
          ;
        return Zr ? mg(ft, on ? 0 : En, on ? En + 1 : yn) : mg(ft, on ? En + 1 : 0, on ? yn : En);
      }
      function kC(ft, xt) {
        var Zr = ft;
        return Zr instanceof _n && (Zr = Zr.value()), _1(xt, function(on, yn) {
          return yn.func.apply(yn.thisArg, _g([on], yn.args));
        }, Zr);
      }
      function DE(ft, xt, Zr) {
        var on = ft.length;
        if (on < 2)
          return on ? k1(ft[0]) : [];
        for (var yn = -1, En = qi(on); ++yn < on; )
          for (var ri = ft[yn], vi = -1; ++vi < on; )
            vi != yn && (En[yn] = FS(En[yn] || ri, ft[vi], xt, Zr));
        return k1(Um(En, 1), xt, Zr);
      }
      function DC(ft, xt, Zr) {
        for (var on = -1, yn = ft.length, En = xt.length, ri = {}; ++on < yn; ) {
          var vi = on < En ? xt[on] : me;
          Zr(ri, ft[on], vi);
        }
        return ri;
      }
      function IE(ft) {
        return Em(ft) ? ft : [];
      }
      function OE(ft) {
        return typeof ft == "function" ? ft : ng;
      }
      function D1(ft, xt) {
        return Cl(ft) ? ft : HE(ft, xt) ? [ft] : ow(Yp(ft));
      }
      var CA = Il;
      function I1(ft, xt, Zr) {
        var on = ft.length;
        return Zr = Zr === me ? on : Zr, !xt && Zr >= on ? ft : mg(ft, xt, Zr);
      }
      var IC = oE || function(ft) {
        return Dm.clearTimeout(ft);
      };
      function OC(ft, xt) {
        if (xt)
          return ft.slice();
        var Zr = ft.length, on = dx ? dx(Zr) : new ft.constructor(Zr);
        return ft.copy(on), on;
      }
      function ME(ft) {
        var xt = new ft.constructor(ft.byteLength);
        return new hS(xt).set(new hS(ft)), xt;
      }
      function wA(ft, xt) {
        var Zr = xt ? ME(ft.buffer) : ft.buffer;
        return new ft.constructor(Zr, ft.byteOffset, ft.byteLength);
      }
      function AA(ft) {
        var xt = new ft.constructor(ft.source, Us.exec(ft));
        return xt.lastIndex = ft.lastIndex, xt;
      }
      function $A(ft) {
        return zt ? Yl(zt.call(ft)) : {};
      }
      function MC(ft, xt) {
        var Zr = xt ? ME(ft.buffer) : ft.buffer;
        return new ft.constructor(Zr, ft.byteOffset, ft.length);
      }
      function LC(ft, xt) {
        if (ft !== xt) {
          var Zr = ft !== me, on = ft === null, yn = ft === ft, En = sg(ft), ri = xt !== me, vi = xt === null, Ti = xt === xt, qa = sg(xt);
          if (!vi && !qa && !En && ft > xt || En && ri && Ti && !vi && !qa || on && ri && Ti || !Zr && Ti || !yn)
            return 1;
          if (!on && !En && !qa && ft < xt || qa && Zr && yn && !on && !En || vi && Zr && yn || !ri && yn || !Ti)
            return -1;
        }
        return 0;
      }
      function PA(ft, xt, Zr) {
        for (var on = -1, yn = ft.criteria, En = xt.criteria, ri = yn.length, vi = Zr.length; ++on < ri; ) {
          var Ti = LC(yn[on], En[on]);
          if (Ti) {
            if (on >= vi)
              return Ti;
            var qa = Zr[on];
            return Ti * (qa == "desc" ? -1 : 1);
          }
        }
        return ft.index - xt.index;
      }
      function NC(ft, xt, Zr, on) {
        for (var yn = -1, En = ft.length, ri = Zr.length, vi = -1, Ti = xt.length, qa = Tm(En - ri, 0), za = qi(Ti + qa), Ka = !on; ++vi < Ti; )
          za[vi] = xt[vi];
        for (; ++yn < ri; )
          (Ka || yn < En) && (za[Zr[yn]] = ft[yn]);
        for (; qa--; )
          za[vi++] = ft[yn++];
        return za;
      }
      function FC(ft, xt, Zr, on) {
        for (var yn = -1, En = ft.length, ri = -1, vi = Zr.length, Ti = -1, qa = xt.length, za = Tm(En - vi, 0), Ka = qi(za + qa), Xs = !on; ++yn < za; )
          Ka[yn] = ft[yn];
        for (var oo = yn; ++Ti < qa; )
          Ka[oo + Ti] = xt[Ti];
        for (; ++ri < vi; )
          (Xs || yn < En) && (Ka[oo + Zr[ri]] = ft[yn++]);
        return Ka;
      }
      function eg(ft, xt) {
        var Zr = -1, on = ft.length;
        for (xt || (xt = qi(on)); ++Zr < on; )
          xt[Zr] = ft[Zr];
        return xt;
      }
      function kg(ft, xt, Zr, on) {
        var yn = !Zr;
        Zr || (Zr = {});
        for (var En = -1, ri = xt.length; ++En < ri; ) {
          var vi = xt[En], Ti = on ? on(Zr[vi], ft[vi], vi, Zr, ft) : me;
          Ti === me && (Ti = ft[vi]), yn ? s1(Zr, vi, Ti) : NS(Zr, vi, Ti);
        }
        return Zr;
      }
      function RA(ft, xt) {
        return kg(ft, VE(ft), xt);
      }
      function kA(ft, xt) {
        return kg(ft, ZC(ft), xt);
      }
      function Cx(ft, xt) {
        return function(Zr, on) {
          var yn = Cl(Zr) ? bg : Jw, En = xt ? xt() : {};
          return yn(Zr, ft, fl(on, 2), En);
        };
      }
      function _S(ft) {
        return Il(function(xt, Zr) {
          var on = -1, yn = Zr.length, En = yn > 1 ? Zr[yn - 1] : me, ri = yn > 2 ? Zr[2] : me;
          for (En = ft.length > 3 && typeof En == "function" ? (yn--, En) : me, ri && Ym(Zr[0], Zr[1], ri) && (En = yn < 3 ? me : En, yn = 1), xt = Yl(xt); ++on < yn; ) {
            var vi = Zr[on];
            vi && ft(xt, vi, on, En);
          }
          return xt;
        });
      }
      function jC(ft, xt) {
        return function(Zr, on) {
          if (Zr == null)
            return Zr;
          if (!tg(Zr))
            return ft(Zr, on);
          for (var yn = Zr.length, En = xt ? yn : -1, ri = Yl(Zr); (xt ? En-- : ++En < yn) && on(ri[En], En, ri) !== !1; )
            ;
          return Zr;
        };
      }
      function BC(ft) {
        return function(xt, Zr, on) {
          for (var yn = -1, En = Yl(xt), ri = on(xt), vi = ri.length; vi--; ) {
            var Ti = ri[ft ? vi : ++yn];
            if (Zr(En[Ti], Ti, En) === !1)
              break;
          }
          return xt;
        };
      }
      function DA(ft, xt, Zr) {
        var on = xt & It, yn = VS(ft);
        function En() {
          var ri = this && this !== Dm && this instanceof En ? yn : ft;
          return ri.apply(on ? Zr : this, arguments);
        }
        return En;
      }
      function UC(ft) {
        return function(xt) {
          xt = Yp(xt);
          var Zr = e1(xt) ? Zm(xt) : me, on = Zr ? Zr[0] : xt.charAt(0), yn = Zr ? I1(Zr, 1).join("") : xt.slice(1);
          return on[ft]() + yn;
        };
      }
      function SS(ft) {
        return function(xt) {
          return _1(jw(Fw(xt).replace(p1, "")), ft, "");
        };
      }
      function VS(ft) {
        return function() {
          var xt = arguments;
          switch (xt.length) {
            case 0:
              return new ft();
            case 1:
              return new ft(xt[0]);
            case 2:
              return new ft(xt[0], xt[1]);
            case 3:
              return new ft(xt[0], xt[1], xt[2]);
            case 4:
              return new ft(xt[0], xt[1], xt[2], xt[3]);
            case 5:
              return new ft(xt[0], xt[1], xt[2], xt[3], xt[4]);
            case 6:
              return new ft(xt[0], xt[1], xt[2], xt[3], xt[4], xt[5]);
            case 7:
              return new ft(xt[0], xt[1], xt[2], xt[3], xt[4], xt[5], xt[6]);
          }
          var Zr = rn(ft.prototype), on = ft.apply(Zr, xt);
          return vm(on) ? on : Zr;
        };
      }
      function IA(ft, xt, Zr) {
        var on = VS(ft);
        function yn() {
          for (var En = arguments.length, ri = qi(En), vi = En, Ti = xS(yn); vi--; )
            ri[vi] = arguments[vi];
          var qa = En < 3 && ri[0] !== Ti && ri[En - 1] !== Ti ? [] : wg(ri, Ti);
          if (En -= qa.length, En < Zr)
            return WC(
              ft,
              xt,
              wx,
              yn.placeholder,
              me,
              ri,
              qa,
              me,
              me,
              Zr - En
            );
          var za = this && this !== Dm && this instanceof yn ? on : ft;
          return dm(za, this, ri);
        }
        return yn;
      }
      function VC(ft) {
        return function(xt, Zr, on) {
          var yn = Yl(xt);
          if (!tg(xt)) {
            var En = fl(Zr, 3);
            xt = Mm(xt), Zr = function(vi) {
              return En(yn[vi], vi, yn);
            };
          }
          var ri = ft(xt, Zr, on);
          return ri > -1 ? yn[En ? xt[ri] : ri] : me;
        };
      }
      function HC(ft) {
        return l1(function(xt) {
          var Zr = xt.length, on = Zr, yn = dn.prototype.thru;
          for (ft && xt.reverse(); on--; ) {
            var En = xt[on];
            if (typeof En != "function")
              throw new Qm(Ue);
            if (yn && !ri && Rx(En) == "wrapper")
              var ri = new dn([], !0);
          }
          for (on = ri ? on : Zr; ++on < Zr; ) {
            En = xt[on];
            var vi = Rx(En), Ti = vi == "wrapper" ? BE(En) : me;
            Ti && qE(Ti[0]) && Ti[1] == (ln | Ot | en | fn) && !Ti[4].length && Ti[9] == 1 ? ri = ri[Rx(Ti[0])].apply(ri, Ti[3]) : ri = En.length == 1 && qE(En) ? ri[vi]() : ri.thru(En);
          }
          return function() {
            var qa = arguments, za = qa[0];
            if (ri && qa.length == 1 && Cl(za))
              return ri.plant(za).value();
            for (var Ka = 0, Xs = Zr ? xt[Ka].apply(this, qa) : za; ++Ka < Zr; )
              Xs = xt[Ka].call(this, Xs);
            return Xs;
          };
        });
      }
      function wx(ft, xt, Zr, on, yn, En, ri, vi, Ti, qa) {
        var za = xt & ln, Ka = xt & It, Xs = xt & Pt, oo = xt & (Ot | Jr), hl = xt & vn, Dl = Xs ? me : VS(ft);
        function pl() {
          for (var Nl = arguments.length, jl = qi(Nl), og = Nl; og--; )
            jl[og] = arguments[og];
          if (oo)
            var Km = xS(pl), lg = Zx(jl, Km);
          if (on && (jl = NC(jl, on, yn, oo)), En && (jl = FC(jl, En, ri, oo)), Nl -= lg, oo && Nl < qa) {
            var Cm = wg(jl, Km);
            return WC(
              ft,
              xt,
              wx,
              pl.placeholder,
              Zr,
              jl,
              Cm,
              vi,
              Ti,
              qa - Nl
            );
          }
          var Tg = Ka ? Zr : this, f1 = Xs ? Tg[ft] : ft;
          return Nl = jl.length, vi ? jl = JA(jl, vi) : hl && Nl > 1 && jl.reverse(), za && Ti < Nl && (jl.length = Ti), this && this !== Dm && this instanceof pl && (f1 = Dl || VS(f1)), f1.apply(Tg, jl);
        }
        return pl;
      }
      function qC(ft, xt) {
        return function(Zr, on) {
          return oA(Zr, ft, xt(on), {});
        };
      }
      function Ax(ft, xt) {
        return function(Zr, on) {
          var yn;
          if (Zr === me && on === me)
            return xt;
          if (Zr !== me && (yn = Zr), on !== me) {
            if (yn === me)
              return on;
            typeof Zr == "string" || typeof on == "string" ? (Zr = ag(Zr), on = ag(on)) : (Zr = PC(Zr), on = PC(on)), yn = ft(Zr, on);
          }
          return yn;
        };
      }
      function LE(ft) {
        return l1(function(xt) {
          return xt = im(xt, Wm(fl())), Il(function(Zr) {
            var on = this;
            return ft(xt, function(yn) {
              return dm(yn, on, Zr);
            });
          });
        });
      }
      function $x(ft, xt) {
        xt = xt === me ? " " : ag(xt);
        var Zr = xt.length;
        if (Zr < 2)
          return Zr ? PE(xt, ft) : xt;
        var on = PE(xt, Y1(ft / fg(xt)));
        return e1(xt) ? I1(Zm(on), 0, ft).join("") : on.slice(0, ft);
      }
      function OA(ft, xt, Zr, on) {
        var yn = xt & It, En = VS(ft);
        function ri() {
          for (var vi = -1, Ti = arguments.length, qa = -1, za = on.length, Ka = qi(za + Ti), Xs = this && this !== Dm && this instanceof ri ? En : ft; ++qa < za; )
            Ka[qa] = on[qa];
          for (; Ti--; )
            Ka[qa++] = arguments[++vi];
          return dm(Xs, yn ? Zr : this, Ka);
        }
        return ri;
      }
      function zC(ft) {
        return function(xt, Zr, on) {
          return on && typeof on != "number" && Ym(xt, Zr, on) && (Zr = on = me), xt = d1(xt), Zr === me ? (Zr = xt, xt = 0) : Zr = d1(Zr), on = on === me ? xt < Zr ? 1 : -1 : d1(on), bA(xt, Zr, on, ft);
        };
      }
      function Px(ft) {
        return function(xt, Zr) {
          return typeof xt == "string" && typeof Zr == "string" || (xt = vg(xt), Zr = vg(Zr)), ft(xt, Zr);
        };
      }
      function WC(ft, xt, Zr, on, yn, En, ri, vi, Ti, qa) {
        var za = xt & Ot, Ka = za ? ri : me, Xs = za ? me : ri, oo = za ? En : me, hl = za ? me : En;
        xt |= za ? en : nn, xt &= ~(za ? nn : en), xt & kt || (xt &= -4);
        var Dl = [
          ft,
          xt,
          yn,
          oo,
          Ka,
          hl,
          Xs,
          vi,
          Ti,
          qa
        ], pl = Zr.apply(me, Dl);
        return qE(ft) && iw(pl, Dl), pl.placeholder = on, aw(pl, ft, xt);
      }
      function NE(ft) {
        var xt = ym[ft];
        return function(Zr, on) {
          if (Zr = vg(Zr), on = on == null ? 0 : Pm(Rl(on), 292), on && gx(Zr)) {
            var yn = (Yp(Zr) + "e").split("e"), En = xt(yn[0] + "e" + (+yn[1] + on));
            return yn = (Yp(En) + "e").split("e"), +(yn[0] + "e" + (+yn[1] - on));
          }
          return xt(Zr);
        };
      }
      var MA = Fm && 1 / lS(new Fm([, -0]))[1] == gn ? function(ft) {
        return new Fm(ft);
      } : aC;
      function GC(ft) {
        return function(xt) {
          var Zr = Hm(xt);
          return Zr == ni ? T1(xt) : Zr == Qa ? tE(xt) : Xx(xt, ft(xt));
        };
      }
      function o1(ft, xt, Zr, on, yn, En, ri, vi) {
        var Ti = xt & Pt;
        if (!Ti && typeof ft != "function")
          throw new Qm(Ue);
        var qa = on ? on.length : 0;
        if (qa || (xt &= -97, on = yn = me), ri = ri === me ? ri : Tm(Rl(ri), 0), vi = vi === me ? vi : Rl(vi), qa -= yn ? yn.length : 0, xt & nn) {
          var za = on, Ka = yn;
          on = yn = me;
        }
        var Xs = Ti ? me : BE(ft), oo = [
          ft,
          xt,
          Zr,
          on,
          yn,
          za,
          Ka,
          En,
          ri,
          vi
        ];
        if (Xs && XA(oo, Xs), ft = oo[0], xt = oo[1], Zr = oo[2], on = oo[3], yn = oo[4], vi = oo[9] = oo[9] === me ? Ti ? 0 : ft.length : Tm(oo[9] - qa, 0), !vi && xt & (Ot | Jr) && (xt &= -25), !xt || xt == It)
          var hl = DA(ft, xt, Zr);
        else xt == Ot || xt == Jr ? hl = IA(ft, xt, vi) : (xt == en || xt == (It | en)) && !yn.length ? hl = OA(ft, xt, Zr, on) : hl = wx.apply(me, oo);
        var Dl = Xs ? AC : iw;
        return aw(Dl(hl, oo), ft, xt);
      }
      function YC(ft, xt, Zr, on) {
        return ft === me || xg(ft, r1[Zr]) && !Kl.call(on, Zr) ? xt : ft;
      }
      function KC(ft, xt, Zr, on, yn, En) {
        return vm(ft) && vm(xt) && (En.set(xt, ft), xx(ft, xt, me, KC, En), En.delete(xt)), ft;
      }
      function LA(ft) {
        return zS(ft) ? me : ft;
      }
      function XC(ft, xt, Zr, on, yn, En) {
        var ri = Zr & wt, vi = ft.length, Ti = xt.length;
        if (vi != Ti && !(ri && Ti > vi))
          return !1;
        var qa = En.get(ft), za = En.get(xt);
        if (qa && za)
          return qa == xt && za == ft;
        var Ka = -1, Xs = !0, oo = Zr & St ? new J1() : me;
        for (En.set(ft, xt), En.set(xt, ft); ++Ka < vi; ) {
          var hl = ft[Ka], Dl = xt[Ka];
          if (on)
            var pl = ri ? on(Dl, hl, Ka, xt, ft, En) : on(hl, Dl, Ka, ft, xt, En);
          if (pl !== me) {
            if (pl)
              continue;
            Xs = !1;
            break;
          }
          if (oo) {
            if (!S1(xt, function(Nl, jl) {
              if (!q1(oo, jl) && (hl === Nl || yn(hl, Nl, Zr, on, En)))
                return oo.push(jl);
            })) {
              Xs = !1;
              break;
            }
          } else if (!(hl === Dl || yn(hl, Dl, Zr, on, En))) {
            Xs = !1;
            break;
          }
        }
        return En.delete(ft), En.delete(xt), Xs;
      }
      function NA(ft, xt, Zr, on, yn, En, ri) {
        switch (Zr) {
          case so:
            if (ft.byteLength != xt.byteLength || ft.byteOffset != xt.byteOffset)
              return !1;
            ft = ft.buffer, xt = xt.buffer;
          case Zs:
            return !(ft.byteLength != xt.byteLength || !En(new hS(ft), new hS(xt)));
          case ji:
          case zi:
          case Ui:
            return xg(+ft, +xt);
          case Hi:
            return ft.name == xt.name && ft.message == xt.message;
          case Ya:
          case Ja:
            return ft == xt + "";
          case ni:
            var vi = T1;
          case Qa:
            var Ti = on & wt;
            if (vi || (vi = lS), ft.size != xt.size && !Ti)
              return !1;
            var qa = ri.get(ft);
            if (qa)
              return qa == xt;
            on |= St, ri.set(ft, xt);
            var za = XC(vi(ft), vi(xt), on, yn, En, ri);
            return ri.delete(ft), za;
          case Ms:
            if (zt)
              return zt.call(ft) == zt.call(xt);
        }
        return !1;
      }
      function FA(ft, xt, Zr, on, yn, En) {
        var ri = Zr & wt, vi = FE(ft), Ti = vi.length, qa = FE(xt), za = qa.length;
        if (Ti != za && !ri)
          return !1;
        for (var Ka = Ti; Ka--; ) {
          var Xs = vi[Ka];
          if (!(ri ? Xs in xt : Kl.call(xt, Xs)))
            return !1;
        }
        var oo = En.get(ft), hl = En.get(xt);
        if (oo && hl)
          return oo == xt && hl == ft;
        var Dl = !0;
        En.set(ft, xt), En.set(xt, ft);
        for (var pl = ri; ++Ka < Ti; ) {
          Xs = vi[Ka];
          var Nl = ft[Xs], jl = xt[Xs];
          if (on)
            var og = ri ? on(jl, Nl, Xs, xt, ft, En) : on(Nl, jl, Xs, ft, xt, En);
          if (!(og === me ? Nl === jl || yn(Nl, jl, Zr, on, En) : og)) {
            Dl = !1;
            break;
          }
          pl || (pl = Xs == "constructor");
        }
        if (Dl && !pl) {
          var Km = ft.constructor, lg = xt.constructor;
          Km != lg && "constructor" in ft && "constructor" in xt && !(typeof Km == "function" && Km instanceof Km && typeof lg == "function" && lg instanceof lg) && (Dl = !1);
        }
        return En.delete(ft), En.delete(xt), Dl;
      }
      function l1(ft) {
        return WE(rw(ft, me, dw), ft + "");
      }
      function FE(ft) {
        return gC(ft, Mm, VE);
      }
      function jE(ft) {
        return gC(ft, rg, ZC);
      }
      var BE = vS ? function(ft) {
        return vS.get(ft);
      } : aC;
      function Rx(ft) {
        for (var xt = ft.name + "", Zr = P1[xt], on = Kl.call(P1, xt) ? Zr.length : 0; on--; ) {
          var yn = Zr[on], En = yn.func;
          if (En == null || En == ft)
            return yn.name;
        }
        return xt;
      }
      function xS(ft) {
        var xt = Kl.call(Wt, "placeholder") ? Wt : ft;
        return xt.placeholder;
      }
      function fl() {
        var ft = Wt.iteratee || nC;
        return ft = ft === nC ? bC : ft, arguments.length ? ft(arguments[0], arguments[1]) : ft;
      }
      function kx(ft, xt) {
        var Zr = ft.__data__;
        return WA(xt) ? Zr[typeof xt == "string" ? "string" : "hash"] : Zr.map;
      }
      function UE(ft) {
        for (var xt = Mm(ft), Zr = xt.length; Zr--; ) {
          var on = xt[Zr], yn = ft[on];
          xt[Zr] = [on, yn, ew(yn)];
        }
        return xt;
      }
      function tS(ft, xt) {
        var Zr = sx(ft, xt);
        return yC(Zr) ? Zr : me;
      }
      function jA(ft) {
        var xt = Kl.call(ft, n1), Zr = ft[n1];
        try {
          ft[n1] = me;
          var on = !0;
        } catch {
        }
        var yn = dS.call(ft);
        return on && (xt ? ft[n1] = Zr : delete ft[n1]), yn;
      }
      var VE = w1 ? function(ft) {
        return ft == null ? [] : (ft = Yl(ft), Cg(w1(ft), function(xt) {
          return hx.call(ft, xt);
        }));
      } : sC, ZC = w1 ? function(ft) {
        for (var xt = []; ft; )
          _g(xt, VE(ft)), ft = pS(ft);
        return xt;
      } : sC, Hm = Gm;
      (Hl && Hm(new Hl(new ArrayBuffer(1))) != so || ig && Hm(new ig()) != ni || Im && Hm(Im.resolve()) != Xa || Fm && Hm(new Fm()) != Qa || K1 && Hm(new K1()) != no) && (Hm = function(ft) {
        var xt = Gm(ft), Zr = xt == Ga ? ft.constructor : me, on = Zr ? rS(Zr) : "";
        if (on)
          switch (on) {
            case hE:
              return so;
            case pE:
              return ni;
            case mE:
              return Xa;
            case gE:
              return Qa;
            case vE:
              return no;
          }
        return xt;
      });
      function BA(ft, xt, Zr) {
        for (var on = -1, yn = Zr.length; ++on < yn; ) {
          var En = Zr[on], ri = En.size;
          switch (En.type) {
            case "drop":
              ft += ri;
              break;
            case "dropRight":
              xt -= ri;
              break;
            case "take":
              xt = Pm(xt, ft + ri);
              break;
            case "takeRight":
              ft = Tm(ft, xt - ri);
              break;
          }
        }
        return { start: ft, end: xt };
      }
      function UA(ft) {
        var xt = ft.match(ho);
        return xt ? xt[1].split(mn) : [];
      }
      function QC(ft, xt, Zr) {
        xt = D1(xt, ft);
        for (var on = -1, yn = xt.length, En = !1; ++on < yn; ) {
          var ri = Dg(xt[on]);
          if (!(En = ft != null && Zr(ft, ri)))
            break;
          ft = ft[ri];
        }
        return En || ++on != yn ? En : (yn = ft == null ? 0 : ft.length, !!yn && Fx(yn) && u1(ri, yn) && (Cl(ft) || nS(ft)));
      }
      function VA(ft) {
        var xt = ft.length, Zr = new ft.constructor(xt);
        return xt && typeof ft[0] == "string" && Kl.call(ft, "index") && (Zr.index = ft.index, Zr.input = ft.input), Zr;
      }
      function JC(ft) {
        return typeof ft.constructor == "function" && !HS(ft) ? rn(pS(ft)) : {};
      }
      function HA(ft, xt, Zr) {
        var on = ft.constructor;
        switch (xt) {
          case Zs:
            return ME(ft);
          case ji:
          case zi:
            return new on(+ft);
          case so:
            return wA(ft, Zr);
          case io:
          case dl:
          case vl:
          case lo:
          case yl:
          case bl:
          case Al:
          case Xl:
          case $l:
            return MC(ft, Zr);
          case ni:
            return new on();
          case Ui:
          case Ja:
            return new on(ft);
          case Ya:
            return AA(ft);
          case Qa:
            return new on();
          case Ms:
            return $A(ft);
        }
      }
      function qA(ft, xt) {
        var Zr = xt.length;
        if (!Zr)
          return ft;
        var on = Zr - 1;
        return xt[on] = (Zr > 1 ? "& " : "") + xt[on], xt = xt.join(Zr > 2 ? ", " : " "), ft.replace(qs, `{
/* [wrapped with ` + xt + `] */
`);
      }
      function zA(ft) {
        return Cl(ft) || nS(ft) || !!(px && ft && ft[px]);
      }
      function u1(ft, xt) {
        var Zr = typeof ft;
        return xt = xt ?? an, !!xt && (Zr == "number" || Zr != "symbol" && Bs.test(ft)) && ft > -1 && ft % 1 == 0 && ft < xt;
      }
      function Ym(ft, xt, Zr) {
        if (!vm(Zr))
          return !1;
        var on = typeof xt;
        return (on == "number" ? tg(Zr) && u1(xt, Zr.length) : on == "string" && xt in Zr) ? xg(Zr[xt], ft) : !1;
      }
      function HE(ft, xt) {
        if (Cl(ft))
          return !1;
        var Zr = typeof ft;
        return Zr == "number" || Zr == "symbol" || Zr == "boolean" || ft == null || sg(ft) ? !0 : Gs.test(ft) || !zs.test(ft) || xt != null && ft in Yl(xt);
      }
      function WA(ft) {
        var xt = typeof ft;
        return xt == "string" || xt == "number" || xt == "symbol" || xt == "boolean" ? ft !== "__proto__" : ft === null;
      }
      function qE(ft) {
        var xt = Rx(ft), Zr = Wt[xt];
        if (typeof Zr != "function" || !(xt in _n.prototype))
          return !1;
        if (ft === Zr)
          return !0;
        var on = BE(Zr);
        return !!on && ft === on[0];
      }
      function GA(ft) {
        return !!cx && cx in ft;
      }
      var YA = G1 ? c1 : oC;
      function HS(ft) {
        var xt = ft && ft.constructor, Zr = typeof xt == "function" && xt.prototype || r1;
        return ft === Zr;
      }
      function ew(ft) {
        return ft === ft && !vm(ft);
      }
      function tw(ft, xt) {
        return function(Zr) {
          return Zr == null ? !1 : Zr[ft] === xt && (xt !== me || ft in Yl(Zr));
        };
      }
      function KA(ft) {
        var xt = Lx(ft, function(on) {
          return Zr.size === Xe && Zr.clear(), on;
        }), Zr = xt.cache;
        return xt;
      }
      function XA(ft, xt) {
        var Zr = ft[1], on = xt[1], yn = Zr | on, En = yn < (It | Pt | ln), ri = on == ln && Zr == Ot || on == ln && Zr == fn && ft[7].length <= xt[8] || on == (ln | fn) && xt[7].length <= xt[8] && Zr == Ot;
        if (!(En || ri))
          return ft;
        on & It && (ft[2] = xt[2], yn |= Zr & It ? 0 : kt);
        var vi = xt[3];
        if (vi) {
          var Ti = ft[3];
          ft[3] = Ti ? NC(Ti, vi, xt[4]) : vi, ft[4] = Ti ? wg(ft[3], ot) : xt[4];
        }
        return vi = xt[5], vi && (Ti = ft[5], ft[5] = Ti ? FC(Ti, vi, xt[6]) : vi, ft[6] = Ti ? wg(ft[5], ot) : xt[6]), vi = xt[7], vi && (ft[7] = vi), on & ln && (ft[8] = ft[8] == null ? xt[8] : Pm(ft[8], xt[8])), ft[9] == null && (ft[9] = xt[9]), ft[0] = xt[0], ft[1] = yn, ft;
      }
      function ZA(ft) {
        var xt = [];
        if (ft != null)
          for (var Zr in Yl(ft))
            xt.push(Zr);
        return xt;
      }
      function QA(ft) {
        return dS.call(ft);
      }
      function rw(ft, xt, Zr) {
        return xt = Tm(xt === me ? ft.length - 1 : xt, 0), function() {
          for (var on = arguments, yn = -1, En = Tm(on.length - xt, 0), ri = qi(En); ++yn < En; )
            ri[yn] = on[xt + yn];
          yn = -1;
          for (var vi = qi(xt + 1); ++yn < xt; )
            vi[yn] = on[yn];
          return vi[xt] = Zr(ri), dm(ft, this, vi);
        };
      }
      function nw(ft, xt) {
        return xt.length < 2 ? ft : eS(ft, mg(xt, 0, -1));
      }
      function JA(ft, xt) {
        for (var Zr = ft.length, on = Pm(xt.length, Zr), yn = eg(ft); on--; ) {
          var En = xt[on];
          ft[on] = u1(En, Zr) ? yn[En] : me;
        }
        return ft;
      }
      function zE(ft, xt) {
        if (!(xt === "constructor" && typeof ft[xt] == "function") && xt != "__proto__")
          return ft[xt];
      }
      var iw = sw(AC), qS = MS || function(ft, xt) {
        return Dm.setTimeout(ft, xt);
      }, WE = sw(xA);
      function aw(ft, xt, Zr) {
        var on = xt + "";
        return WE(ft, qA(on, e$(UA(on), Zr)));
      }
      function sw(ft) {
        var xt = 0, Zr = 0;
        return function() {
          var on = dE(), yn = Sn - (on - Zr);
          if (Zr = on, yn > 0) {
            if (++xt >= bn)
              return arguments[0];
          } else
            xt = 0;
          return ft.apply(me, arguments);
        };
      }
      function Dx(ft, xt) {
        var Zr = -1, on = ft.length, yn = on - 1;
        for (xt = xt === me ? on : xt; ++Zr < xt; ) {
          var En = $E(Zr, yn), ri = ft[En];
          ft[En] = ft[Zr], ft[Zr] = ri;
        }
        return ft.length = xt, ft;
      }
      var ow = KA(function(ft) {
        var xt = [];
        return ft.charCodeAt(0) === 46 && xt.push(""), ft.replace(Pl, function(Zr, on, yn, En) {
          xt.push(yn ? En.replace(Ha, "$1") : on || Zr);
        }), xt;
      });
      function Dg(ft) {
        if (typeof ft == "string" || sg(ft))
          return ft;
        var xt = ft + "";
        return xt == "0" && 1 / ft == -1 / 0 ? "-0" : xt;
      }
      function rS(ft) {
        if (ft != null) {
          try {
            return cS.call(ft);
          } catch {
          }
          try {
            return ft + "";
          } catch {
          }
        }
        return "";
      }
      function e$(ft, xt) {
        return Nm(qn, function(Zr) {
          var on = "_." + Zr[0];
          xt & Zr[1] && !aS(ft, on) && ft.push(on);
        }), ft.sort();
      }
      function lw(ft) {
        if (ft instanceof _n)
          return ft.clone();
        var xt = new dn(ft.__wrapped__, ft.__chain__);
        return xt.__actions__ = eg(ft.__actions__), xt.__index__ = ft.__index__, xt.__values__ = ft.__values__, xt;
      }
      function t$(ft, xt, Zr) {
        (Zr ? Ym(ft, xt, Zr) : xt === me) ? xt = 1 : xt = Tm(Rl(xt), 0);
        var on = ft == null ? 0 : ft.length;
        if (!on || xt < 1)
          return [];
        for (var yn = 0, En = 0, ri = qi(Y1(on / xt)); yn < on; )
          ri[En++] = mg(ft, yn, yn += xt);
        return ri;
      }
      function r$(ft) {
        for (var xt = -1, Zr = ft == null ? 0 : ft.length, on = 0, yn = []; ++xt < Zr; ) {
          var En = ft[xt];
          En && (yn[on++] = En);
        }
        return yn;
      }
      function n$() {
        var ft = arguments.length;
        if (!ft)
          return [];
        for (var xt = qi(ft - 1), Zr = arguments[0], on = ft; on--; )
          xt[on - 1] = arguments[on];
        return _g(Cl(Zr) ? eg(Zr) : [Zr], Um(xt, 1));
      }
      var i$ = Il(function(ft, xt) {
        return Em(ft) ? FS(ft, Um(xt, 1, Em, !0)) : [];
      }), a$ = Il(function(ft, xt) {
        var Zr = gg(xt);
        return Em(Zr) && (Zr = me), Em(ft) ? FS(ft, Um(xt, 1, Em, !0), fl(Zr, 2)) : [];
      }), s$ = Il(function(ft, xt) {
        var Zr = gg(xt);
        return Em(Zr) && (Zr = me), Em(ft) ? FS(ft, Um(xt, 1, Em, !0), me, Zr) : [];
      });
      function o$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        return on ? (xt = Zr || xt === me ? 1 : Rl(xt), mg(ft, xt < 0 ? 0 : xt, on)) : [];
      }
      function l$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        return on ? (xt = Zr || xt === me ? 1 : Rl(xt), xt = on - xt, mg(ft, 0, xt < 0 ? 0 : xt)) : [];
      }
      function u$(ft, xt) {
        return ft && ft.length ? Ex(ft, fl(xt, 3), !0, !0) : [];
      }
      function c$(ft, xt) {
        return ft && ft.length ? Ex(ft, fl(xt, 3), !0) : [];
      }
      function d$(ft, xt, Zr, on) {
        var yn = ft == null ? 0 : ft.length;
        return yn ? (Zr && typeof Zr != "number" && Ym(ft, xt, Zr) && (Zr = 0, on = yn), nA(ft, xt, Zr, on)) : [];
      }
      function uw(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        if (!on)
          return -1;
        var yn = Zr == null ? 0 : Rl(Zr);
        return yn < 0 && (yn = Tm(on + yn, 0)), B1(ft, fl(xt, 3), yn);
      }
      function cw(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        if (!on)
          return -1;
        var yn = on - 1;
        return Zr !== me && (yn = Rl(Zr), yn = Zr < 0 ? Tm(on + yn, 0) : Pm(yn, on - 1)), B1(ft, fl(xt, 3), yn, !0);
      }
      function dw(ft) {
        var xt = ft == null ? 0 : ft.length;
        return xt ? Um(ft, 1) : [];
      }
      function f$(ft) {
        var xt = ft == null ? 0 : ft.length;
        return xt ? Um(ft, gn) : [];
      }
      function h$(ft, xt) {
        var Zr = ft == null ? 0 : ft.length;
        return Zr ? (xt = xt === me ? 1 : Rl(xt), Um(ft, xt)) : [];
      }
      function p$(ft) {
        for (var xt = -1, Zr = ft == null ? 0 : ft.length, on = {}; ++xt < Zr; ) {
          var yn = ft[xt];
          on[yn[0]] = yn[1];
        }
        return on;
      }
      function fw(ft) {
        return ft && ft.length ? ft[0] : me;
      }
      function m$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        if (!on)
          return -1;
        var yn = Zr == null ? 0 : Rl(Zr);
        return yn < 0 && (yn = Tm(on + yn, 0)), x1(ft, xt, yn);
      }
      function g$(ft) {
        var xt = ft == null ? 0 : ft.length;
        return xt ? mg(ft, 0, -1) : [];
      }
      var v$ = Il(function(ft) {
        var xt = im(ft, IE);
        return xt.length && xt[0] === ft[0] ? TE(xt) : [];
      }), y$ = Il(function(ft) {
        var xt = gg(ft), Zr = im(ft, IE);
        return xt === gg(Zr) ? xt = me : Zr.pop(), Zr.length && Zr[0] === ft[0] ? TE(Zr, fl(xt, 2)) : [];
      }), b$ = Il(function(ft) {
        var xt = gg(ft), Zr = im(ft, IE);
        return xt = typeof xt == "function" ? xt : me, xt && Zr.pop(), Zr.length && Zr[0] === ft[0] ? TE(Zr, me, xt) : [];
      });
      function _$(ft, xt) {
        return ft == null ? "" : uE.call(ft, xt);
      }
      function gg(ft) {
        var xt = ft == null ? 0 : ft.length;
        return xt ? ft[xt - 1] : me;
      }
      function S$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        if (!on)
          return -1;
        var yn = on;
        return Zr !== me && (yn = Rl(Zr), yn = yn < 0 ? Tm(on + yn, 0) : Pm(yn, on - 1)), xt === xt ? rE(ft, xt, yn) : B1(ft, ex, yn, !0);
      }
      function x$(ft, xt) {
        return ft && ft.length ? TC(ft, Rl(xt)) : me;
      }
      var T$ = Il(hw);
      function hw(ft, xt) {
        return ft && ft.length && xt && xt.length ? AE(ft, xt) : ft;
      }
      function E$(ft, xt, Zr) {
        return ft && ft.length && xt && xt.length ? AE(ft, xt, fl(Zr, 2)) : ft;
      }
      function C$(ft, xt, Zr) {
        return ft && ft.length && xt && xt.length ? AE(ft, xt, me, Zr) : ft;
      }
      var w$ = l1(function(ft, xt) {
        var Zr = ft == null ? 0 : ft.length, on = bE(ft, xt);
        return wC(ft, im(xt, function(yn) {
          return u1(yn, Zr) ? +yn : yn;
        }).sort(LC)), on;
      });
      function A$(ft, xt) {
        var Zr = [];
        if (!(ft && ft.length))
          return Zr;
        var on = -1, yn = [], En = ft.length;
        for (xt = fl(xt, 3); ++on < En; ) {
          var ri = ft[on];
          xt(ri, on, ft) && (Zr.push(ri), yn.push(on));
        }
        return wC(ft, yn), Zr;
      }
      function GE(ft) {
        return ft == null ? ft : A1.call(ft);
      }
      function $$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        return on ? (Zr && typeof Zr != "number" && Ym(ft, xt, Zr) ? (xt = 0, Zr = on) : (xt = xt == null ? 0 : Rl(xt), Zr = Zr === me ? on : Rl(Zr)), mg(ft, xt, Zr)) : [];
      }
      function P$(ft, xt) {
        return Tx(ft, xt);
      }
      function R$(ft, xt, Zr) {
        return RE(ft, xt, fl(Zr, 2));
      }
      function k$(ft, xt) {
        var Zr = ft == null ? 0 : ft.length;
        if (Zr) {
          var on = Tx(ft, xt);
          if (on < Zr && xg(ft[on], xt))
            return on;
        }
        return -1;
      }
      function D$(ft, xt) {
        return Tx(ft, xt, !0);
      }
      function I$(ft, xt, Zr) {
        return RE(ft, xt, fl(Zr, 2), !0);
      }
      function O$(ft, xt) {
        var Zr = ft == null ? 0 : ft.length;
        if (Zr) {
          var on = Tx(ft, xt, !0) - 1;
          if (xg(ft[on], xt))
            return on;
        }
        return -1;
      }
      function M$(ft) {
        return ft && ft.length ? $C(ft) : [];
      }
      function L$(ft, xt) {
        return ft && ft.length ? $C(ft, fl(xt, 2)) : [];
      }
      function N$(ft) {
        var xt = ft == null ? 0 : ft.length;
        return xt ? mg(ft, 1, xt) : [];
      }
      function F$(ft, xt, Zr) {
        return ft && ft.length ? (xt = Zr || xt === me ? 1 : Rl(xt), mg(ft, 0, xt < 0 ? 0 : xt)) : [];
      }
      function j$(ft, xt, Zr) {
        var on = ft == null ? 0 : ft.length;
        return on ? (xt = Zr || xt === me ? 1 : Rl(xt), xt = on - xt, mg(ft, xt < 0 ? 0 : xt, on)) : [];
      }
      function B$(ft, xt) {
        return ft && ft.length ? Ex(ft, fl(xt, 3), !1, !0) : [];
      }
      function U$(ft, xt) {
        return ft && ft.length ? Ex(ft, fl(xt, 3)) : [];
      }
      var V$ = Il(function(ft) {
        return k1(Um(ft, 1, Em, !0));
      }), H$ = Il(function(ft) {
        var xt = gg(ft);
        return Em(xt) && (xt = me), k1(Um(ft, 1, Em, !0), fl(xt, 2));
      }), q$ = Il(function(ft) {
        var xt = gg(ft);
        return xt = typeof xt == "function" ? xt : me, k1(Um(ft, 1, Em, !0), me, xt);
      });
      function z$(ft) {
        return ft && ft.length ? k1(ft) : [];
      }
      function W$(ft, xt) {
        return ft && ft.length ? k1(ft, fl(xt, 2)) : [];
      }
      function G$(ft, xt) {
        return xt = typeof xt == "function" ? xt : me, ft && ft.length ? k1(ft, me, xt) : [];
      }
      function YE(ft) {
        if (!(ft && ft.length))
          return [];
        var xt = 0;
        return ft = Cg(ft, function(Zr) {
          if (Em(Zr))
            return xt = Tm(Zr.length, xt), !0;
        }), V1(xt, function(Zr) {
          return im(ft, RS(Zr));
        });
      }
      function pw(ft, xt) {
        if (!(ft && ft.length))
          return [];
        var Zr = YE(ft);
        return xt == null ? Zr : im(Zr, function(on) {
          return dm(xt, me, on);
        });
      }
      var Y$ = Il(function(ft, xt) {
        return Em(ft) ? FS(ft, xt) : [];
      }), K$ = Il(function(ft) {
        return DE(Cg(ft, Em));
      }), X$ = Il(function(ft) {
        var xt = gg(ft);
        return Em(xt) && (xt = me), DE(Cg(ft, Em), fl(xt, 2));
      }), Z$ = Il(function(ft) {
        var xt = gg(ft);
        return xt = typeof xt == "function" ? xt : me, DE(Cg(ft, Em), me, xt);
      }), Q$ = Il(YE);
      function J$(ft, xt) {
        return DC(ft || [], xt || [], NS);
      }
      function eP(ft, xt) {
        return DC(ft || [], xt || [], US);
      }
      var tP = Il(function(ft) {
        var xt = ft.length, Zr = xt > 1 ? ft[xt - 1] : me;
        return Zr = typeof Zr == "function" ? (ft.pop(), Zr) : me, pw(ft, Zr);
      });
      function mw(ft) {
        var xt = Wt(ft);
        return xt.__chain__ = !0, xt;
      }
      function rP(ft, xt) {
        return xt(ft), ft;
      }
      function Ix(ft, xt) {
        return xt(ft);
      }
      var nP = l1(function(ft) {
        var xt = ft.length, Zr = xt ? ft[0] : 0, on = this.__wrapped__, yn = function(En) {
          return bE(En, ft);
        };
        return xt > 1 || this.__actions__.length || !(on instanceof _n) || !u1(Zr) ? this.thru(yn) : (on = on.slice(Zr, +Zr + (xt ? 1 : 0)), on.__actions__.push({
          func: Ix,
          args: [yn],
          thisArg: me
        }), new dn(on, this.__chain__).thru(function(En) {
          return xt && !En.length && En.push(me), En;
        }));
      });
      function iP() {
        return mw(this);
      }
      function aP() {
        return new dn(this.value(), this.__chain__);
      }
      function sP() {
        this.__values__ === me && (this.__values__ = Pw(this.value()));
        var ft = this.__index__ >= this.__values__.length, xt = ft ? me : this.__values__[this.__index__++];
        return { done: ft, value: xt };
      }
      function oP() {
        return this;
      }
      function lP(ft) {
        for (var xt, Zr = this; Zr instanceof sn; ) {
          var on = lw(Zr);
          on.__index__ = 0, on.__values__ = me, xt ? yn.__wrapped__ = on : xt = on;
          var yn = on;
          Zr = Zr.__wrapped__;
        }
        return yn.__wrapped__ = ft, xt;
      }
      function uP() {
        var ft = this.__wrapped__;
        if (ft instanceof _n) {
          var xt = ft;
          return this.__actions__.length && (xt = new _n(this)), xt = xt.reverse(), xt.__actions__.push({
            func: Ix,
            args: [GE],
            thisArg: me
          }), new dn(xt, this.__chain__);
        }
        return this.thru(GE);
      }
      function cP() {
        return kC(this.__wrapped__, this.__actions__);
      }
      var dP = Cx(function(ft, xt, Zr) {
        Kl.call(ft, Zr) ? ++ft[Zr] : s1(ft, Zr, 1);
      });
      function fP(ft, xt, Zr) {
        var on = Cl(ft) ? QS : rA;
        return Zr && Ym(ft, xt, Zr) && (xt = me), on(ft, fl(xt, 3));
      }
      function hP(ft, xt) {
        var Zr = Cl(ft) ? Cg : pC;
        return Zr(ft, fl(xt, 3));
      }
      var pP = VC(uw), mP = VC(cw);
      function gP(ft, xt) {
        return Um(Ox(ft, xt), 1);
      }
      function vP(ft, xt) {
        return Um(Ox(ft, xt), gn);
      }
      function yP(ft, xt, Zr) {
        return Zr = Zr === me ? 1 : Rl(Zr), Um(Ox(ft, xt), Zr);
      }
      function gw(ft, xt) {
        var Zr = Cl(ft) ? Nm : R1;
        return Zr(ft, fl(xt, 3));
      }
      function vw(ft, xt) {
        var Zr = Cl(ft) ? ZS : hC;
        return Zr(ft, fl(xt, 3));
      }
      var bP = Cx(function(ft, xt, Zr) {
        Kl.call(ft, Zr) ? ft[Zr].push(xt) : s1(ft, Zr, [xt]);
      });
      function _P(ft, xt, Zr, on) {
        ft = tg(ft) ? ft : ES(ft), Zr = Zr && !on ? Rl(Zr) : 0;
        var yn = ft.length;
        return Zr < 0 && (Zr = Tm(yn + Zr, 0)), jx(ft) ? Zr <= yn && ft.indexOf(xt, Zr) > -1 : !!yn && x1(ft, xt, Zr) > -1;
      }
      var SP = Il(function(ft, xt, Zr) {
        var on = -1, yn = typeof xt == "function", En = tg(ft) ? qi(ft.length) : [];
        return R1(ft, function(ri) {
          En[++on] = yn ? dm(xt, ri, Zr) : jS(ri, xt, Zr);
        }), En;
      }), xP = Cx(function(ft, xt, Zr) {
        s1(ft, Zr, xt);
      });
      function Ox(ft, xt) {
        var Zr = Cl(ft) ? im : _C;
        return Zr(ft, fl(xt, 3));
      }
      function TP(ft, xt, Zr, on) {
        return ft == null ? [] : (Cl(xt) || (xt = xt == null ? [] : [xt]), Zr = on ? me : Zr, Cl(Zr) || (Zr = Zr == null ? [] : [Zr]), EC(ft, xt, Zr));
      }
      var EP = Cx(function(ft, xt, Zr) {
        ft[Zr ? 0 : 1].push(xt);
      }, function() {
        return [[], []];
      });
      function CP(ft, xt, Zr) {
        var on = Cl(ft) ? _1 : tx, yn = arguments.length < 3;
        return on(ft, fl(xt, 4), Zr, yn, R1);
      }
      function wP(ft, xt, Zr) {
        var on = Cl(ft) ? j1 : tx, yn = arguments.length < 3;
        return on(ft, fl(xt, 4), Zr, yn, hC);
      }
      function AP(ft, xt) {
        var Zr = Cl(ft) ? Cg : pC;
        return Zr(ft, Nx(fl(xt, 3)));
      }
      function $P(ft) {
        var xt = Cl(ft) ? uC : _A;
        return xt(ft);
      }
      function PP(ft, xt, Zr) {
        (Zr ? Ym(ft, xt, Zr) : xt === me) ? xt = 1 : xt = Rl(xt);
        var on = Cl(ft) ? Zw : SA;
        return on(ft, xt);
      }
      function RP(ft) {
        var xt = Cl(ft) ? Qw : TA;
        return xt(ft);
      }
      function kP(ft) {
        if (ft == null)
          return 0;
        if (tg(ft))
          return jx(ft) ? fg(ft) : ft.length;
        var xt = Hm(ft);
        return xt == ni || xt == Qa ? ft.size : CE(ft).length;
      }
      function DP(ft, xt, Zr) {
        var on = Cl(ft) ? S1 : EA;
        return Zr && Ym(ft, xt, Zr) && (xt = me), on(ft, fl(xt, 3));
      }
      var IP = Il(function(ft, xt) {
        if (ft == null)
          return [];
        var Zr = xt.length;
        return Zr > 1 && Ym(ft, xt[0], xt[1]) ? xt = [] : Zr > 2 && Ym(xt[0], xt[1], xt[2]) && (xt = [xt[0]]), EC(ft, Um(xt, 1), []);
      }), Mx = mx || function() {
        return Dm.Date.now();
      };
      function OP(ft, xt) {
        if (typeof xt != "function")
          throw new Qm(Ue);
        return ft = Rl(ft), function() {
          if (--ft < 1)
            return xt.apply(this, arguments);
        };
      }
      function yw(ft, xt, Zr) {
        return xt = Zr ? me : xt, xt = ft && xt == null ? ft.length : xt, o1(ft, ln, me, me, me, me, xt);
      }
      function bw(ft, xt) {
        var Zr;
        if (typeof xt != "function")
          throw new Qm(Ue);
        return ft = Rl(ft), function() {
          return --ft > 0 && (Zr = xt.apply(this, arguments)), ft <= 1 && (xt = me), Zr;
        };
      }
      var KE = Il(function(ft, xt, Zr) {
        var on = It;
        if (Zr.length) {
          var yn = wg(Zr, xS(KE));
          on |= en;
        }
        return o1(ft, on, xt, Zr, yn);
      }), _w = Il(function(ft, xt, Zr) {
        var on = It | Pt;
        if (Zr.length) {
          var yn = wg(Zr, xS(_w));
          on |= en;
        }
        return o1(xt, on, ft, Zr, yn);
      });
      function Sw(ft, xt, Zr) {
        xt = Zr ? me : xt;
        var on = o1(ft, Ot, me, me, me, me, me, xt);
        return on.placeholder = Sw.placeholder, on;
      }
      function xw(ft, xt, Zr) {
        xt = Zr ? me : xt;
        var on = o1(ft, Jr, me, me, me, me, me, xt);
        return on.placeholder = xw.placeholder, on;
      }
      function Tw(ft, xt, Zr) {
        var on, yn, En, ri, vi, Ti, qa = 0, za = !1, Ka = !1, Xs = !0;
        if (typeof ft != "function")
          throw new Qm(Ue);
        xt = vg(xt) || 0, vm(Zr) && (za = !!Zr.leading, Ka = "maxWait" in Zr, En = Ka ? Tm(vg(Zr.maxWait) || 0, xt) : En, Xs = "trailing" in Zr ? !!Zr.trailing : Xs);
        function oo(Cm) {
          var Tg = on, f1 = yn;
          return on = yn = me, qa = Cm, ri = ft.apply(f1, Tg), ri;
        }
        function hl(Cm) {
          return qa = Cm, vi = qS(Nl, xt), za ? oo(Cm) : ri;
        }
        function Dl(Cm) {
          var Tg = Cm - Ti, f1 = Cm - qa, Vw = xt - Tg;
          return Ka ? Pm(Vw, En - f1) : Vw;
        }
        function pl(Cm) {
          var Tg = Cm - Ti, f1 = Cm - qa;
          return Ti === me || Tg >= xt || Tg < 0 || Ka && f1 >= En;
        }
        function Nl() {
          var Cm = Mx();
          if (pl(Cm))
            return jl(Cm);
          vi = qS(Nl, Dl(Cm));
        }
        function jl(Cm) {
          return vi = me, Xs && on ? oo(Cm) : (on = yn = me, ri);
        }
        function og() {
          vi !== me && IC(vi), qa = 0, on = Ti = yn = vi = me;
        }
        function Km() {
          return vi === me ? ri : jl(Mx());
        }
        function lg() {
          var Cm = Mx(), Tg = pl(Cm);
          if (on = arguments, yn = this, Ti = Cm, Tg) {
            if (vi === me)
              return hl(Ti);
            if (Ka)
              return IC(vi), vi = qS(Nl, xt), oo(Ti);
          }
          return vi === me && (vi = qS(Nl, xt)), ri;
        }
        return lg.cancel = og, lg.flush = Km, lg;
      }
      var MP = Il(function(ft, xt) {
        return fC(ft, 1, xt);
      }), LP = Il(function(ft, xt, Zr) {
        return fC(ft, vg(xt) || 0, Zr);
      });
      function NP(ft) {
        return o1(ft, vn);
      }
      function Lx(ft, xt) {
        if (typeof ft != "function" || xt != null && typeof xt != "function")
          throw new Qm(Ue);
        var Zr = function() {
          var on = arguments, yn = xt ? xt.apply(this, on) : on[0], En = Zr.cache;
          if (En.has(yn))
            return En.get(yn);
          var ri = ft.apply(this, on);
          return Zr.cache = En.set(yn, ri) || En, ri;
        };
        return Zr.cache = new (Lx.Cache || Bm)(), Zr;
      }
      Lx.Cache = Bm;
      function Nx(ft) {
        if (typeof ft != "function")
          throw new Qm(Ue);
        return function() {
          var xt = arguments;
          switch (xt.length) {
            case 0:
              return !ft.call(this);
            case 1:
              return !ft.call(this, xt[0]);
            case 2:
              return !ft.call(this, xt[0], xt[1]);
            case 3:
              return !ft.call(this, xt[0], xt[1], xt[2]);
          }
          return !ft.apply(this, xt);
        };
      }
      function FP(ft) {
        return bw(2, ft);
      }
      var jP = CA(function(ft, xt) {
        xt = xt.length == 1 && Cl(xt[0]) ? im(xt[0], Wm(fl())) : im(Um(xt, 1), Wm(fl()));
        var Zr = xt.length;
        return Il(function(on) {
          for (var yn = -1, En = Pm(on.length, Zr); ++yn < En; )
            on[yn] = xt[yn].call(this, on[yn]);
          return dm(ft, this, on);
        });
      }), XE = Il(function(ft, xt) {
        var Zr = wg(xt, xS(XE));
        return o1(ft, en, me, xt, Zr);
      }), Ew = Il(function(ft, xt) {
        var Zr = wg(xt, xS(Ew));
        return o1(ft, nn, me, xt, Zr);
      }), BP = l1(function(ft, xt) {
        return o1(ft, fn, me, me, me, xt);
      });
      function UP(ft, xt) {
        if (typeof ft != "function")
          throw new Qm(Ue);
        return xt = xt === me ? xt : Rl(xt), Il(ft, xt);
      }
      function VP(ft, xt) {
        if (typeof ft != "function")
          throw new Qm(Ue);
        return xt = xt == null ? 0 : Tm(Rl(xt), 0), Il(function(Zr) {
          var on = Zr[xt], yn = I1(Zr, 0, xt);
          return on && _g(yn, on), dm(ft, this, yn);
        });
      }
      function HP(ft, xt, Zr) {
        var on = !0, yn = !0;
        if (typeof ft != "function")
          throw new Qm(Ue);
        return vm(Zr) && (on = "leading" in Zr ? !!Zr.leading : on, yn = "trailing" in Zr ? !!Zr.trailing : yn), Tw(ft, xt, {
          leading: on,
          maxWait: xt,
          trailing: yn
        });
      }
      function qP(ft) {
        return yw(ft, 1);
      }
      function zP(ft, xt) {
        return XE(OE(xt), ft);
      }
      function WP() {
        if (!arguments.length)
          return [];
        var ft = arguments[0];
        return Cl(ft) ? ft : [ft];
      }
      function GP(ft) {
        return pg(ft, Tt);
      }
      function YP(ft, xt) {
        return xt = typeof xt == "function" ? xt : me, pg(ft, Tt, xt);
      }
      function KP(ft) {
        return pg(ft, vt | Tt);
      }
      function XP(ft, xt) {
        return xt = typeof xt == "function" ? xt : me, pg(ft, vt | Tt, xt);
      }
      function ZP(ft, xt) {
        return xt == null || dC(ft, xt, Mm(xt));
      }
      function xg(ft, xt) {
        return ft === xt || ft !== ft && xt !== xt;
      }
      var QP = Px(xE), JP = Px(function(ft, xt) {
        return ft >= xt;
      }), nS = vC(/* @__PURE__ */ function() {
        return arguments;
      }()) ? vC : function(ft) {
        return bm(ft) && Kl.call(ft, "callee") && !hx.call(ft, "callee");
      }, Cl = qi.isArray, eR = KS ? Wm(KS) : lA;
      function tg(ft) {
        return ft != null && Fx(ft.length) && !c1(ft);
      }
      function Em(ft) {
        return bm(ft) && tg(ft);
      }
      function tR(ft) {
        return ft === !0 || ft === !1 || bm(ft) && Gm(ft) == ji;
      }
      var O1 = lE || oC, rR = XS ? Wm(XS) : uA;
      function nR(ft) {
        return bm(ft) && ft.nodeType === 1 && !zS(ft);
      }
      function iR(ft) {
        if (ft == null)
          return !0;
        if (tg(ft) && (Cl(ft) || typeof ft == "string" || typeof ft.splice == "function" || O1(ft) || TS(ft) || nS(ft)))
          return !ft.length;
        var xt = Hm(ft);
        if (xt == ni || xt == Qa)
          return !ft.size;
        if (HS(ft))
          return !CE(ft).length;
        for (var Zr in ft)
          if (Kl.call(ft, Zr))
            return !1;
        return !0;
      }
      function aR(ft, xt) {
        return BS(ft, xt);
      }
      function sR(ft, xt, Zr) {
        Zr = typeof Zr == "function" ? Zr : me;
        var on = Zr ? Zr(ft, xt) : me;
        return on === me ? BS(ft, xt, me, Zr) : !!on;
      }
      function ZE(ft) {
        if (!bm(ft))
          return !1;
        var xt = Gm(ft);
        return xt == Hi || xt == Vi || typeof ft.message == "string" && typeof ft.name == "string" && !zS(ft);
      }
      function oR(ft) {
        return typeof ft == "number" && gx(ft);
      }
      function c1(ft) {
        if (!vm(ft))
          return !1;
        var xt = Gm(ft);
        return xt == ii || xt == Fi || xt == xi || xt == Ns;
      }
      function Cw(ft) {
        return typeof ft == "number" && ft == Rl(ft);
      }
      function Fx(ft) {
        return typeof ft == "number" && ft > -1 && ft % 1 == 0 && ft <= an;
      }
      function vm(ft) {
        var xt = typeof ft;
        return ft != null && (xt == "object" || xt == "function");
      }
      function bm(ft) {
        return ft != null && typeof ft == "object";
      }
      var ww = N1 ? Wm(N1) : dA;
      function lR(ft, xt) {
        return ft === xt || EE(ft, xt, UE(xt));
      }
      function uR(ft, xt, Zr) {
        return Zr = typeof Zr == "function" ? Zr : me, EE(ft, xt, UE(xt), Zr);
      }
      function cR(ft) {
        return Aw(ft) && ft != +ft;
      }
      function dR(ft) {
        if (YA(ft))
          throw new gl(je);
        return yC(ft);
      }
      function fR(ft) {
        return ft === null;
      }
      function hR(ft) {
        return ft == null;
      }
      function Aw(ft) {
        return typeof ft == "number" || bm(ft) && Gm(ft) == Ui;
      }
      function zS(ft) {
        if (!bm(ft) || Gm(ft) != Ga)
          return !1;
        var xt = pS(ft);
        if (xt === null)
          return !0;
        var Zr = Kl.call(xt, "constructor") && xt.constructor;
        return typeof Zr == "function" && Zr instanceof Zr && cS.call(Zr) == OS;
      }
      var QE = y1 ? Wm(y1) : fA;
      function pR(ft) {
        return Cw(ft) && ft >= -9007199254740991 && ft <= an;
      }
      var $w = b1 ? Wm(b1) : hA;
      function jx(ft) {
        return typeof ft == "string" || !Cl(ft) && bm(ft) && Gm(ft) == Ja;
      }
      function sg(ft) {
        return typeof ft == "symbol" || bm(ft) && Gm(ft) == Ms;
      }
      var TS = F1 ? Wm(F1) : pA;
      function mR(ft) {
        return ft === me;
      }
      function gR(ft) {
        return bm(ft) && Hm(ft) == no;
      }
      function vR(ft) {
        return bm(ft) && Gm(ft) == Qs;
      }
      var yR = Px(wE), bR = Px(function(ft, xt) {
        return ft <= xt;
      });
      function Pw(ft) {
        if (!ft)
          return [];
        if (tg(ft))
          return jx(ft) ? Zm(ft) : eg(ft);
        if (Jm && ft[Jm])
          return eE(ft[Jm]());
        var xt = Hm(ft), Zr = xt == ni ? T1 : xt == Qa ? lS : ES;
        return Zr(ft);
      }
      function d1(ft) {
        if (!ft)
          return ft === 0 ? ft : 0;
        if (ft = vg(ft), ft === gn || ft === -1 / 0) {
          var xt = ft < 0 ? -1 : 1;
          return xt * un;
        }
        return ft === ft ? ft : 0;
      }
      function Rl(ft) {
        var xt = d1(ft), Zr = xt % 1;
        return xt === xt ? Zr ? xt - Zr : xt : 0;
      }
      function Rw(ft) {
        return ft ? Z2(Rl(ft), 0, hn) : 0;
      }
      function vg(ft) {
        if (typeof ft == "number")
          return ft;
        if (sg(ft))
          return pn;
        if (vm(ft)) {
          var xt = typeof ft.valueOf == "function" ? ft.valueOf() : ft;
          ft = vm(xt) ? xt + "" : xt;
        }
        if (typeof ft != "string")
          return ft === 0 ? ft : +ft;
        ft = rx(ft);
        var Zr = Za.test(ft);
        return Zr || Ys.test(ft) ? Wx(ft.slice(2), Zr ? 2 : 8) : $s.test(ft) ? pn : +ft;
      }
      function kw(ft) {
        return kg(ft, rg(ft));
      }
      function _R(ft) {
        return ft ? Z2(Rl(ft), -9007199254740991, an) : ft === 0 ? ft : 0;
      }
      function Yp(ft) {
        return ft == null ? "" : ag(ft);
      }
      var SR = _S(function(ft, xt) {
        if (HS(xt) || tg(xt)) {
          kg(xt, Mm(xt), ft);
          return;
        }
        for (var Zr in xt)
          Kl.call(xt, Zr) && NS(ft, Zr, xt[Zr]);
      }), Dw = _S(function(ft, xt) {
        kg(xt, rg(xt), ft);
      }), Bx = _S(function(ft, xt, Zr, on) {
        kg(xt, rg(xt), ft, on);
      }), xR = _S(function(ft, xt, Zr, on) {
        kg(xt, Mm(xt), ft, on);
      }), TR = l1(bE);
      function ER(ft, xt) {
        var Zr = rn(ft);
        return xt == null ? Zr : cC(Zr, xt);
      }
      var CR = Il(function(ft, xt) {
        ft = Yl(ft);
        var Zr = -1, on = xt.length, yn = on > 2 ? xt[2] : me;
        for (yn && Ym(xt[0], xt[1], yn) && (on = 1); ++Zr < on; )
          for (var En = xt[Zr], ri = rg(En), vi = -1, Ti = ri.length; ++vi < Ti; ) {
            var qa = ri[vi], za = ft[qa];
            (za === me || xg(za, r1[qa]) && !Kl.call(ft, qa)) && (ft[qa] = En[qa]);
          }
        return ft;
      }), wR = Il(function(ft) {
        return ft.push(me, KC), dm(Iw, me, ft);
      });
      function AR(ft, xt) {
        return PS(ft, fl(xt, 3), Rg);
      }
      function $R(ft, xt) {
        return PS(ft, fl(xt, 3), SE);
      }
      function PR(ft, xt) {
        return ft == null ? ft : _E(ft, fl(xt, 3), rg);
      }
      function RR(ft, xt) {
        return ft == null ? ft : mC(ft, fl(xt, 3), rg);
      }
      function kR(ft, xt) {
        return ft && Rg(ft, fl(xt, 3));
      }
      function DR(ft, xt) {
        return ft && SE(ft, fl(xt, 3));
      }
      function IR(ft) {
        return ft == null ? [] : Sx(ft, Mm(ft));
      }
      function OR(ft) {
        return ft == null ? [] : Sx(ft, rg(ft));
      }
      function JE(ft, xt, Zr) {
        var on = ft == null ? me : eS(ft, xt);
        return on === me ? Zr : on;
      }
      function MR(ft, xt) {
        return ft != null && QC(ft, xt, iA);
      }
      function eC(ft, xt) {
        return ft != null && QC(ft, xt, aA);
      }
      var LR = qC(function(ft, xt, Zr) {
        xt != null && typeof xt.toString != "function" && (xt = dS.call(xt)), ft[xt] = Zr;
      }, rC(ng)), NR = qC(function(ft, xt, Zr) {
        xt != null && typeof xt.toString != "function" && (xt = dS.call(xt)), Kl.call(ft, xt) ? ft[xt].push(Zr) : ft[xt] = [Zr];
      }, fl), FR = Il(jS);
      function Mm(ft) {
        return tg(ft) ? lC(ft) : CE(ft);
      }
      function rg(ft) {
        return tg(ft) ? lC(ft, !0) : mA(ft);
      }
      function jR(ft, xt) {
        var Zr = {};
        return xt = fl(xt, 3), Rg(ft, function(on, yn, En) {
          s1(Zr, xt(on, yn, En), on);
        }), Zr;
      }
      function BR(ft, xt) {
        var Zr = {};
        return xt = fl(xt, 3), Rg(ft, function(on, yn, En) {
          s1(Zr, yn, xt(on, yn, En));
        }), Zr;
      }
      var UR = _S(function(ft, xt, Zr) {
        xx(ft, xt, Zr);
      }), Iw = _S(function(ft, xt, Zr, on) {
        xx(ft, xt, Zr, on);
      }), VR = l1(function(ft, xt) {
        var Zr = {};
        if (ft == null)
          return Zr;
        var on = !1;
        xt = im(xt, function(En) {
          return En = D1(En, ft), on || (on = En.length > 1), En;
        }), kg(ft, jE(ft), Zr), on && (Zr = pg(Zr, vt | bt | Tt, LA));
        for (var yn = xt.length; yn--; )
          kE(Zr, xt[yn]);
        return Zr;
      });
      function HR(ft, xt) {
        return Ow(ft, Nx(fl(xt)));
      }
      var qR = l1(function(ft, xt) {
        return ft == null ? {} : vA(ft, xt);
      });
      function Ow(ft, xt) {
        if (ft == null)
          return {};
        var Zr = im(jE(ft), function(on) {
          return [on];
        });
        return xt = fl(xt), CC(ft, Zr, function(on, yn) {
          return xt(on, yn[0]);
        });
      }
      function zR(ft, xt, Zr) {
        xt = D1(xt, ft);
        var on = -1, yn = xt.length;
        for (yn || (yn = 1, ft = me); ++on < yn; ) {
          var En = ft == null ? me : ft[Dg(xt[on])];
          En === me && (on = yn, En = Zr), ft = c1(En) ? En.call(ft) : En;
        }
        return ft;
      }
      function WR(ft, xt, Zr) {
        return ft == null ? ft : US(ft, xt, Zr);
      }
      function GR(ft, xt, Zr, on) {
        return on = typeof on == "function" ? on : me, ft == null ? ft : US(ft, xt, Zr, on);
      }
      var Mw = GC(Mm), Lw = GC(rg);
      function YR(ft, xt, Zr) {
        var on = Cl(ft), yn = on || O1(ft) || TS(ft);
        if (xt = fl(xt, 4), Zr == null) {
          var En = ft && ft.constructor;
          yn ? Zr = on ? new En() : [] : vm(ft) ? Zr = c1(En) ? rn(pS(ft)) : {} : Zr = {};
        }
        return (yn ? Nm : Rg)(ft, function(ri, vi, Ti) {
          return xt(Zr, ri, vi, Ti);
        }), Zr;
      }
      function KR(ft, xt) {
        return ft == null ? !0 : kE(ft, xt);
      }
      function XR(ft, xt, Zr) {
        return ft == null ? ft : RC(ft, xt, OE(Zr));
      }
      function ZR(ft, xt, Zr, on) {
        return on = typeof on == "function" ? on : me, ft == null ? ft : RC(ft, xt, OE(Zr), on);
      }
      function ES(ft) {
        return ft == null ? [] : H1(ft, Mm(ft));
      }
      function QR(ft) {
        return ft == null ? [] : H1(ft, rg(ft));
      }
      function JR(ft, xt, Zr) {
        return Zr === me && (Zr = xt, xt = me), Zr !== me && (Zr = vg(Zr), Zr = Zr === Zr ? Zr : 0), xt !== me && (xt = vg(xt), xt = xt === xt ? xt : 0), Z2(vg(ft), xt, Zr);
      }
      function ek(ft, xt, Zr) {
        return xt = d1(xt), Zr === me ? (Zr = xt, xt = 0) : Zr = d1(Zr), ft = vg(ft), sA(ft, xt, Zr);
      }
      function tk(ft, xt, Zr) {
        if (Zr && typeof Zr != "boolean" && Ym(ft, xt, Zr) && (xt = Zr = me), Zr === me && (typeof xt == "boolean" ? (Zr = xt, xt = me) : typeof ft == "boolean" && (Zr = ft, ft = me)), ft === me && xt === me ? (ft = 0, xt = 1) : (ft = d1(ft), xt === me ? (xt = ft, ft = 0) : xt = d1(xt)), ft > xt) {
          var on = ft;
          ft = xt, xt = on;
        }
        if (Zr || ft % 1 || xt % 1) {
          var yn = LS();
          return Pm(ft + yn * (xt - ft + zx("1e-" + ((yn + "").length - 1))), xt);
        }
        return $E(ft, xt);
      }
      var rk = SS(function(ft, xt, Zr) {
        return xt = xt.toLowerCase(), ft + (Zr ? Nw(xt) : xt);
      });
      function Nw(ft) {
        return tC(Yp(ft).toLowerCase());
      }
      function Fw(ft) {
        return ft = Yp(ft), ft && ft.replace(Wa, ix).replace(ro, "");
      }
      function nk(ft, xt, Zr) {
        ft = Yp(ft), xt = ag(xt);
        var on = ft.length;
        Zr = Zr === me ? on : Z2(Rl(Zr), 0, on);
        var yn = Zr;
        return Zr -= xt.length, Zr >= 0 && ft.slice(Zr, yn) == xt;
      }
      function ik(ft) {
        return ft = Yp(ft), ft && Ll.test(ft) ? ft.replace(_l, Qx) : ft;
      }
      function ak(ft) {
        return ft = Yp(ft), ft && Ws.test(ft) ? ft.replace(Ml, "\\$&") : ft;
      }
      var sk = SS(function(ft, xt, Zr) {
        return ft + (Zr ? "-" : "") + xt.toLowerCase();
      }), ok = SS(function(ft, xt, Zr) {
        return ft + (Zr ? " " : "") + xt.toLowerCase();
      }), lk = UC("toLowerCase");
      function uk(ft, xt, Zr) {
        ft = Yp(ft), xt = Rl(xt);
        var on = xt ? fg(ft) : 0;
        if (!xt || on >= xt)
          return ft;
        var yn = (xt - on) / 2;
        return $x(i1(yn), Zr) + ft + $x(Y1(yn), Zr);
      }
      function ck(ft, xt, Zr) {
        ft = Yp(ft), xt = Rl(xt);
        var on = xt ? fg(ft) : 0;
        return xt && on < xt ? ft + $x(xt - on, Zr) : ft;
      }
      function dk(ft, xt, Zr) {
        ft = Yp(ft), xt = Rl(xt);
        var on = xt ? fg(ft) : 0;
        return xt && on < xt ? $x(xt - on, Zr) + ft : ft;
      }
      function fk(ft, xt, Zr) {
        return Zr || xt == null ? xt = 0 : xt && (xt = +xt), fE(Yp(ft).replace(Ks, ""), xt || 0);
      }
      function hk(ft, xt, Zr) {
        return (Zr ? Ym(ft, xt, Zr) : xt === me) ? xt = 1 : xt = Rl(xt), PE(Yp(ft), xt);
      }
      function pk() {
        var ft = arguments, xt = Yp(ft[0]);
        return ft.length < 3 ? xt : xt.replace(ft[1], ft[2]);
      }
      var mk = SS(function(ft, xt, Zr) {
        return ft + (Zr ? "_" : "") + xt.toLowerCase();
      });
      function gk(ft, xt, Zr) {
        return Zr && typeof Zr != "number" && Ym(ft, xt, Zr) && (xt = Zr = me), Zr = Zr === me ? hn : Zr >>> 0, Zr ? (ft = Yp(ft), ft && (typeof xt == "string" || xt != null && !QE(xt)) && (xt = ag(xt), !xt && e1(ft)) ? I1(Zm(ft), 0, Zr) : ft.split(xt, Zr)) : [];
      }
      var vk = SS(function(ft, xt, Zr) {
        return ft + (Zr ? " " : "") + tC(xt);
      });
      function yk(ft, xt, Zr) {
        return ft = Yp(ft), Zr = Zr == null ? 0 : Z2(Rl(Zr), 0, ft.length), xt = ag(xt), ft.slice(Zr, Zr + xt.length) == xt;
      }
      function bk(ft, xt, Zr) {
        var on = Wt.templateSettings;
        Zr && Ym(ft, xt, Zr) && (xt = me), ft = Yp(ft), xt = Bx({}, xt, on, YC);
        var yn = Bx({}, xt.imports, on.imports, YC), En = Mm(yn), ri = H1(yn, En), vi, Ti, qa = 0, za = xt.interpolate || js, Ka = "__p += '", Xs = uS(
          (xt.escape || js).source + "|" + za.source + "|" + (za === to ? Va : js).source + "|" + (xt.evaluate || js).source + "|$",
          "g"
        ), oo = "//# sourceURL=" + (Kl.call(xt, "sourceURL") ? (xt.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++g1 + "]") + `
`;
        ft.replace(Xs, function(pl, Nl, jl, og, Km, lg) {
          return jl || (jl = og), Ka += ft.slice(qa, lg).replace(Fs, ax), Nl && (vi = !0, Ka += `' +
__e(` + Nl + `) +
'`), Km && (Ti = !0, Ka += `';
` + Km + `;
__p += '`), jl && (Ka += `' +
((__t = (` + jl + `)) == null ? '' : __t) +
'`), qa = lg + pl.length, pl;
        }), Ka += `';
`;
        var hl = Kl.call(xt, "variable") && xt.variable;
        if (!hl)
          Ka = `with (obj) {
` + Ka + `
}
`;
        else if ($i.test(hl))
          throw new gl(qe);
        Ka = (Ti ? Ka.replace(Bl, "") : Ka).replace(Fl, "$1").replace(kl, "$1;"), Ka = "function(" + (hl || "obj") + `) {
` + (hl ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (vi ? ", __e = _.escape" : "") + (Ti ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ka + `return __p
}`;
        var Dl = Bw(function() {
          return Ul(En, oo + "return " + Ka).apply(me, ri);
        });
        if (Dl.source = Ka, ZE(Dl))
          throw Dl;
        return Dl;
      }
      function _k(ft) {
        return Yp(ft).toLowerCase();
      }
      function Sk(ft) {
        return Yp(ft).toUpperCase();
      }
      function xk(ft, xt, Zr) {
        if (ft = Yp(ft), ft && (Zr || xt === me))
          return rx(ft);
        if (!ft || !(xt = ag(xt)))
          return ft;
        var on = Zm(ft), yn = Zm(xt), En = kS(on, yn), ri = nx(on, yn) + 1;
        return I1(on, En, ri).join("");
      }
      function Tk(ft, xt, Zr) {
        if (ft = Yp(ft), ft && (Zr || xt === me))
          return ft.slice(0, z1(ft) + 1);
        if (!ft || !(xt = ag(xt)))
          return ft;
        var on = Zm(ft), yn = nx(on, Zm(xt)) + 1;
        return I1(on, 0, yn).join("");
      }
      function Ek(ft, xt, Zr) {
        if (ft = Yp(ft), ft && (Zr || xt === me))
          return ft.replace(Ks, "");
        if (!ft || !(xt = ag(xt)))
          return ft;
        var on = Zm(ft), yn = kS(on, Zm(xt));
        return I1(on, yn).join("");
      }
      function Ck(ft, xt) {
        var Zr = Tn, on = xn;
        if (vm(xt)) {
          var yn = "separator" in xt ? xt.separator : yn;
          Zr = "length" in xt ? Rl(xt.length) : Zr, on = "omission" in xt ? ag(xt.omission) : on;
        }
        ft = Yp(ft);
        var En = ft.length;
        if (e1(ft)) {
          var ri = Zm(ft);
          En = ri.length;
        }
        if (Zr >= En)
          return ft;
        var vi = Zr - fg(on);
        if (vi < 1)
          return on;
        var Ti = ri ? I1(ri, 0, vi).join("") : ft.slice(0, vi);
        if (yn === me)
          return Ti + on;
        if (ri && (vi += Ti.length - vi), QE(yn)) {
          if (ft.slice(vi).search(yn)) {
            var qa, za = Ti;
            for (yn.global || (yn = uS(yn.source, Yp(Us.exec(yn)) + "g")), yn.lastIndex = 0; qa = yn.exec(za); )
              var Ka = qa.index;
            Ti = Ti.slice(0, Ka === me ? vi : Ka);
          }
        } else if (ft.indexOf(ag(yn), vi) != vi) {
          var Xs = Ti.lastIndexOf(yn);
          Xs > -1 && (Ti = Ti.slice(0, Xs));
        }
        return Ti + on;
      }
      function wk(ft) {
        return ft = Yp(ft), ft && Ol.test(ft) ? ft.replace(ql, W1) : ft;
      }
      var Ak = SS(function(ft, xt, Zr) {
        return ft + (Zr ? " " : "") + xt.toUpperCase();
      }), tC = UC("toUpperCase");
      function jw(ft, xt, Zr) {
        return ft = Yp(ft), xt = Zr ? me : xt, xt === me ? Jx(ft) ? DS(ft) : JS(ft) : ft.match(xt) || [];
      }
      var Bw = Il(function(ft, xt) {
        try {
          return dm(ft, me, xt);
        } catch (Zr) {
          return ZE(Zr) ? Zr : new gl(Zr);
        }
      }), $k = l1(function(ft, xt) {
        return Nm(xt, function(Zr) {
          Zr = Dg(Zr), s1(ft, Zr, KE(ft[Zr], ft));
        }), ft;
      });
      function Pk(ft) {
        var xt = ft == null ? 0 : ft.length, Zr = fl();
        return ft = xt ? im(ft, function(on) {
          if (typeof on[1] != "function")
            throw new Qm(Ue);
          return [Zr(on[0]), on[1]];
        }) : [], Il(function(on) {
          for (var yn = -1; ++yn < xt; ) {
            var En = ft[yn];
            if (dm(En[0], this, on))
              return dm(En[1], this, on);
          }
        });
      }
      function Rk(ft) {
        return tA(pg(ft, vt));
      }
      function rC(ft) {
        return function() {
          return ft;
        };
      }
      function kk(ft, xt) {
        return ft == null || ft !== ft ? xt : ft;
      }
      var Dk = HC(), Ik = HC(!0);
      function ng(ft) {
        return ft;
      }
      function nC(ft) {
        return bC(typeof ft == "function" ? ft : pg(ft, vt));
      }
      function Ok(ft) {
        return SC(pg(ft, vt));
      }
      function Mk(ft, xt) {
        return xC(ft, pg(xt, vt));
      }
      var Lk = Il(function(ft, xt) {
        return function(Zr) {
          return jS(Zr, ft, xt);
        };
      }), Nk = Il(function(ft, xt) {
        return function(Zr) {
          return jS(ft, Zr, xt);
        };
      });
      function iC(ft, xt, Zr) {
        var on = Mm(xt), yn = Sx(xt, on);
        Zr == null && !(vm(xt) && (yn.length || !on.length)) && (Zr = xt, xt = ft, ft = this, yn = Sx(xt, Mm(xt)));
        var En = !(vm(Zr) && "chain" in Zr) || !!Zr.chain, ri = c1(ft);
        return Nm(yn, function(vi) {
          var Ti = xt[vi];
          ft[vi] = Ti, ri && (ft.prototype[vi] = function() {
            var qa = this.__chain__;
            if (En || qa) {
              var za = ft(this.__wrapped__), Ka = za.__actions__ = eg(this.__actions__);
              return Ka.push({ func: Ti, args: arguments, thisArg: ft }), za.__chain__ = qa, za;
            }
            return Ti.apply(ft, _g([this.value()], arguments));
          });
        }), ft;
      }
      function Fk() {
        return Dm._ === this && (Dm._ = aE), this;
      }
      function aC() {
      }
      function jk(ft) {
        return ft = Rl(ft), Il(function(xt) {
          return TC(xt, ft);
        });
      }
      var Bk = LE(im), Uk = LE(QS), Vk = LE(S1);
      function Uw(ft) {
        return HE(ft) ? RS(Dg(ft)) : yA(ft);
      }
      function Hk(ft) {
        return function(xt) {
          return ft == null ? me : eS(ft, xt);
        };
      }
      var qk = zC(), zk = zC(!0);
      function sC() {
        return [];
      }
      function oC() {
        return !1;
      }
      function Wk() {
        return {};
      }
      function Gk() {
        return "";
      }
      function Yk() {
        return !0;
      }
      function Kk(ft, xt) {
        if (ft = Rl(ft), ft < 1 || ft > an)
          return [];
        var Zr = hn, on = Pm(ft, hn);
        xt = fl(xt), ft -= hn;
        for (var yn = V1(on, xt); ++Zr < ft; )
          xt(Zr);
        return yn;
      }
      function Xk(ft) {
        return Cl(ft) ? im(ft, Dg) : sg(ft) ? [ft] : eg(ow(Yp(ft)));
      }
      function Zk(ft) {
        var xt = ++ux;
        return Yp(ft) + xt;
      }
      var Qk = Ax(function(ft, xt) {
        return ft + xt;
      }, 0), Jk = NE("ceil"), eD = Ax(function(ft, xt) {
        return ft / xt;
      }, 1), tD = NE("floor");
      function rD(ft) {
        return ft && ft.length ? bx(ft, ng, xE) : me;
      }
      function nD(ft, xt) {
        return ft && ft.length ? bx(ft, fl(xt, 2), xE) : me;
      }
      function iD(ft) {
        return U1(ft, ng);
      }
      function aD(ft, xt) {
        return U1(ft, fl(xt, 2));
      }
      function sD(ft) {
        return ft && ft.length ? bx(ft, ng, wE) : me;
      }
      function oD(ft, xt) {
        return ft && ft.length ? bx(ft, fl(xt, 2), wE) : me;
      }
      var lD = Ax(function(ft, xt) {
        return ft * xt;
      }, 1), uD = NE("round"), cD = Ax(function(ft, xt) {
        return ft - xt;
      }, 0);
      function dD(ft) {
        return ft && ft.length ? oS(ft, ng) : 0;
      }
      function fD(ft, xt) {
        return ft && ft.length ? oS(ft, fl(xt, 2)) : 0;
      }
      return Wt.after = OP, Wt.ary = yw, Wt.assign = SR, Wt.assignIn = Dw, Wt.assignInWith = Bx, Wt.assignWith = xR, Wt.at = TR, Wt.before = bw, Wt.bind = KE, Wt.bindAll = $k, Wt.bindKey = _w, Wt.castArray = WP, Wt.chain = mw, Wt.chunk = t$, Wt.compact = r$, Wt.concat = n$, Wt.cond = Pk, Wt.conforms = Rk, Wt.constant = rC, Wt.countBy = dP, Wt.create = ER, Wt.curry = Sw, Wt.curryRight = xw, Wt.debounce = Tw, Wt.defaults = CR, Wt.defaultsDeep = wR, Wt.defer = MP, Wt.delay = LP, Wt.difference = i$, Wt.differenceBy = a$, Wt.differenceWith = s$, Wt.drop = o$, Wt.dropRight = l$, Wt.dropRightWhile = u$, Wt.dropWhile = c$, Wt.fill = d$, Wt.filter = hP, Wt.flatMap = gP, Wt.flatMapDeep = vP, Wt.flatMapDepth = yP, Wt.flatten = dw, Wt.flattenDeep = f$, Wt.flattenDepth = h$, Wt.flip = NP, Wt.flow = Dk, Wt.flowRight = Ik, Wt.fromPairs = p$, Wt.functions = IR, Wt.functionsIn = OR, Wt.groupBy = bP, Wt.initial = g$, Wt.intersection = v$, Wt.intersectionBy = y$, Wt.intersectionWith = b$, Wt.invert = LR, Wt.invertBy = NR, Wt.invokeMap = SP, Wt.iteratee = nC, Wt.keyBy = xP, Wt.keys = Mm, Wt.keysIn = rg, Wt.map = Ox, Wt.mapKeys = jR, Wt.mapValues = BR, Wt.matches = Ok, Wt.matchesProperty = Mk, Wt.memoize = Lx, Wt.merge = UR, Wt.mergeWith = Iw, Wt.method = Lk, Wt.methodOf = Nk, Wt.mixin = iC, Wt.negate = Nx, Wt.nthArg = jk, Wt.omit = VR, Wt.omitBy = HR, Wt.once = FP, Wt.orderBy = TP, Wt.over = Bk, Wt.overArgs = jP, Wt.overEvery = Uk, Wt.overSome = Vk, Wt.partial = XE, Wt.partialRight = Ew, Wt.partition = EP, Wt.pick = qR, Wt.pickBy = Ow, Wt.property = Uw, Wt.propertyOf = Hk, Wt.pull = T$, Wt.pullAll = hw, Wt.pullAllBy = E$, Wt.pullAllWith = C$, Wt.pullAt = w$, Wt.range = qk, Wt.rangeRight = zk, Wt.rearg = BP, Wt.reject = AP, Wt.remove = A$, Wt.rest = UP, Wt.reverse = GE, Wt.sampleSize = PP, Wt.set = WR, Wt.setWith = GR, Wt.shuffle = RP, Wt.slice = $$, Wt.sortBy = IP, Wt.sortedUniq = M$, Wt.sortedUniqBy = L$, Wt.split = gk, Wt.spread = VP, Wt.tail = N$, Wt.take = F$, Wt.takeRight = j$, Wt.takeRightWhile = B$, Wt.takeWhile = U$, Wt.tap = rP, Wt.throttle = HP, Wt.thru = Ix, Wt.toArray = Pw, Wt.toPairs = Mw, Wt.toPairsIn = Lw, Wt.toPath = Xk, Wt.toPlainObject = kw, Wt.transform = YR, Wt.unary = qP, Wt.union = V$, Wt.unionBy = H$, Wt.unionWith = q$, Wt.uniq = z$, Wt.uniqBy = W$, Wt.uniqWith = G$, Wt.unset = KR, Wt.unzip = YE, Wt.unzipWith = pw, Wt.update = XR, Wt.updateWith = ZR, Wt.values = ES, Wt.valuesIn = QR, Wt.without = Y$, Wt.words = jw, Wt.wrap = zP, Wt.xor = K$, Wt.xorBy = X$, Wt.xorWith = Z$, Wt.zip = Q$, Wt.zipObject = J$, Wt.zipObjectDeep = eP, Wt.zipWith = tP, Wt.entries = Mw, Wt.entriesIn = Lw, Wt.extend = Dw, Wt.extendWith = Bx, iC(Wt, Wt), Wt.add = Qk, Wt.attempt = Bw, Wt.camelCase = rk, Wt.capitalize = Nw, Wt.ceil = Jk, Wt.clamp = JR, Wt.clone = GP, Wt.cloneDeep = KP, Wt.cloneDeepWith = XP, Wt.cloneWith = YP, Wt.conformsTo = ZP, Wt.deburr = Fw, Wt.defaultTo = kk, Wt.divide = eD, Wt.endsWith = nk, Wt.eq = xg, Wt.escape = ik, Wt.escapeRegExp = ak, Wt.every = fP, Wt.find = pP, Wt.findIndex = uw, Wt.findKey = AR, Wt.findLast = mP, Wt.findLastIndex = cw, Wt.findLastKey = $R, Wt.floor = tD, Wt.forEach = gw, Wt.forEachRight = vw, Wt.forIn = PR, Wt.forInRight = RR, Wt.forOwn = kR, Wt.forOwnRight = DR, Wt.get = JE, Wt.gt = QP, Wt.gte = JP, Wt.has = MR, Wt.hasIn = eC, Wt.head = fw, Wt.identity = ng, Wt.includes = _P, Wt.indexOf = m$, Wt.inRange = ek, Wt.invoke = FR, Wt.isArguments = nS, Wt.isArray = Cl, Wt.isArrayBuffer = eR, Wt.isArrayLike = tg, Wt.isArrayLikeObject = Em, Wt.isBoolean = tR, Wt.isBuffer = O1, Wt.isDate = rR, Wt.isElement = nR, Wt.isEmpty = iR, Wt.isEqual = aR, Wt.isEqualWith = sR, Wt.isError = ZE, Wt.isFinite = oR, Wt.isFunction = c1, Wt.isInteger = Cw, Wt.isLength = Fx, Wt.isMap = ww, Wt.isMatch = lR, Wt.isMatchWith = uR, Wt.isNaN = cR, Wt.isNative = dR, Wt.isNil = hR, Wt.isNull = fR, Wt.isNumber = Aw, Wt.isObject = vm, Wt.isObjectLike = bm, Wt.isPlainObject = zS, Wt.isRegExp = QE, Wt.isSafeInteger = pR, Wt.isSet = $w, Wt.isString = jx, Wt.isSymbol = sg, Wt.isTypedArray = TS, Wt.isUndefined = mR, Wt.isWeakMap = gR, Wt.isWeakSet = vR, Wt.join = _$, Wt.kebabCase = sk, Wt.last = gg, Wt.lastIndexOf = S$, Wt.lowerCase = ok, Wt.lowerFirst = lk, Wt.lt = yR, Wt.lte = bR, Wt.max = rD, Wt.maxBy = nD, Wt.mean = iD, Wt.meanBy = aD, Wt.min = sD, Wt.minBy = oD, Wt.stubArray = sC, Wt.stubFalse = oC, Wt.stubObject = Wk, Wt.stubString = Gk, Wt.stubTrue = Yk, Wt.multiply = lD, Wt.nth = x$, Wt.noConflict = Fk, Wt.noop = aC, Wt.now = Mx, Wt.pad = uk, Wt.padEnd = ck, Wt.padStart = dk, Wt.parseInt = fk, Wt.random = tk, Wt.reduce = CP, Wt.reduceRight = wP, Wt.repeat = hk, Wt.replace = pk, Wt.result = zR, Wt.round = uD, Wt.runInContext = Si, Wt.sample = $P, Wt.size = kP, Wt.snakeCase = mk, Wt.some = DP, Wt.sortedIndex = P$, Wt.sortedIndexBy = R$, Wt.sortedIndexOf = k$, Wt.sortedLastIndex = D$, Wt.sortedLastIndexBy = I$, Wt.sortedLastIndexOf = O$, Wt.startCase = vk, Wt.startsWith = yk, Wt.subtract = cD, Wt.sum = dD, Wt.sumBy = fD, Wt.template = bk, Wt.times = Kk, Wt.toFinite = d1, Wt.toInteger = Rl, Wt.toLength = Rw, Wt.toLower = _k, Wt.toNumber = vg, Wt.toSafeInteger = _R, Wt.toString = Yp, Wt.toUpper = Sk, Wt.trim = xk, Wt.trimEnd = Tk, Wt.trimStart = Ek, Wt.truncate = Ck, Wt.unescape = wk, Wt.uniqueId = Zk, Wt.upperCase = Ak, Wt.upperFirst = tC, Wt.each = gw, Wt.eachRight = vw, Wt.first = fw, iC(Wt, function() {
        var ft = {};
        return Rg(Wt, function(xt, Zr) {
          Kl.call(Wt.prototype, Zr) || (ft[Zr] = xt);
        }), ft;
      }(), { chain: !1 }), Wt.VERSION = we, Nm(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(ft) {
        Wt[ft].placeholder = Wt;
      }), Nm(["drop", "take"], function(ft, xt) {
        _n.prototype[ft] = function(Zr) {
          Zr = Zr === me ? 1 : Tm(Rl(Zr), 0);
          var on = this.__filtered__ && !xt ? new _n(this) : this.clone();
          return on.__filtered__ ? on.__takeCount__ = Pm(Zr, on.__takeCount__) : on.__views__.push({
            size: Pm(Zr, hn),
            type: ft + (on.__dir__ < 0 ? "Right" : "")
          }), on;
        }, _n.prototype[ft + "Right"] = function(Zr) {
          return this.reverse()[ft](Zr).reverse();
        };
      }), Nm(["filter", "map", "takeWhile"], function(ft, xt) {
        var Zr = xt + 1, on = Zr == Cn || Zr == cn;
        _n.prototype[ft] = function(yn) {
          var En = this.clone();
          return En.__iteratees__.push({
            iteratee: fl(yn, 3),
            type: Zr
          }), En.__filtered__ = En.__filtered__ || on, En;
        };
      }), Nm(["head", "last"], function(ft, xt) {
        var Zr = "take" + (xt ? "Right" : "");
        _n.prototype[ft] = function() {
          return this[Zr](1).value()[0];
        };
      }), Nm(["initial", "tail"], function(ft, xt) {
        var Zr = "drop" + (xt ? "" : "Right");
        _n.prototype[ft] = function() {
          return this.__filtered__ ? new _n(this) : this[Zr](1);
        };
      }), _n.prototype.compact = function() {
        return this.filter(ng);
      }, _n.prototype.find = function(ft) {
        return this.filter(ft).head();
      }, _n.prototype.findLast = function(ft) {
        return this.reverse().find(ft);
      }, _n.prototype.invokeMap = Il(function(ft, xt) {
        return typeof ft == "function" ? new _n(this) : this.map(function(Zr) {
          return jS(Zr, ft, xt);
        });
      }), _n.prototype.reject = function(ft) {
        return this.filter(Nx(fl(ft)));
      }, _n.prototype.slice = function(ft, xt) {
        ft = Rl(ft);
        var Zr = this;
        return Zr.__filtered__ && (ft > 0 || xt < 0) ? new _n(Zr) : (ft < 0 ? Zr = Zr.takeRight(-ft) : ft && (Zr = Zr.drop(ft)), xt !== me && (xt = Rl(xt), Zr = xt < 0 ? Zr.dropRight(-xt) : Zr.take(xt - ft)), Zr);
      }, _n.prototype.takeRightWhile = function(ft) {
        return this.reverse().takeWhile(ft).reverse();
      }, _n.prototype.toArray = function() {
        return this.take(hn);
      }, Rg(_n.prototype, function(ft, xt) {
        var Zr = /^(?:filter|find|map|reject)|While$/.test(xt), on = /^(?:head|last)$/.test(xt), yn = Wt[on ? "take" + (xt == "last" ? "Right" : "") : xt], En = on || /^find/.test(xt);
        yn && (Wt.prototype[xt] = function() {
          var ri = this.__wrapped__, vi = on ? [1] : arguments, Ti = ri instanceof _n, qa = vi[0], za = Ti || Cl(ri), Ka = function(Nl) {
            var jl = yn.apply(Wt, _g([Nl], vi));
            return on && Xs ? jl[0] : jl;
          };
          za && Zr && typeof qa == "function" && qa.length != 1 && (Ti = za = !1);
          var Xs = this.__chain__, oo = !!this.__actions__.length, hl = En && !Xs, Dl = Ti && !oo;
          if (!En && za) {
            ri = Dl ? ri : new _n(this);
            var pl = ft.apply(ri, vi);
            return pl.__actions__.push({ func: Ix, args: [Ka], thisArg: me }), new dn(pl, Xs);
          }
          return hl && Dl ? ft.apply(this, vi) : (pl = this.thru(Ka), hl ? on ? pl.value()[0] : pl.value() : pl);
        });
      }), Nm(["pop", "push", "shift", "sort", "splice", "unshift"], function(ft) {
        var xt = Ag[ft], Zr = /^(?:push|sort|unshift)$/.test(ft) ? "tap" : "thru", on = /^(?:pop|shift)$/.test(ft);
        Wt.prototype[ft] = function() {
          var yn = arguments;
          if (on && !this.__chain__) {
            var En = this.value();
            return xt.apply(Cl(En) ? En : [], yn);
          }
          return this[Zr](function(ri) {
            return xt.apply(Cl(ri) ? ri : [], yn);
          });
        };
      }), Rg(_n.prototype, function(ft, xt) {
        var Zr = Wt[xt];
        if (Zr) {
          var on = Zr.name + "";
          Kl.call(P1, on) || (P1[on] = []), P1[on].push({ name: xt, func: Zr });
        }
      }), P1[wx(me, Pt).name] = [{
        name: "wrapper",
        func: me
      }], _n.prototype.clone = wn, _n.prototype.reverse = Dn, _n.prototype.value = Fn, Wt.prototype.at = nP, Wt.prototype.chain = iP, Wt.prototype.commit = aP, Wt.prototype.next = sP, Wt.prototype.plant = lP, Wt.prototype.reverse = uP, Wt.prototype.toJSON = Wt.prototype.valueOf = Wt.prototype.value = cP, Wt.prototype.first = Wt.prototype.head, Jm && (Wt.prototype[Jm] = oP), Wt;
    }, C1 = nE();
    dg ? ((dg.exports = C1)._ = C1, iS._ = C1) : Dm._ = C1;
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const HandleTooltip = (ce) => {
  const { value: ie, children: me, visible: we, tipFormatter: Re = (ot) => `${Math.round(ot)}`, ...je } = ce, Ue = React__default.useRef(null), qe = React__default.useRef(null);
  function Ge() {
    qe.current && default_1.cancel(qe.current);
  }
  function Xe() {
    qe.current = default_1(() => {
      var ot;
      (ot = Ue.current) == null || ot.forceAlign();
    });
  }
  return React__default.useEffect(() => (we ? Xe() : Ge(), Ge), [ie, we]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tooltip$2,
    {
      prefixCls: "rc-slider-tooltip",
      placement: "top",
      overlay: Re(ie),
      styles: {
        body: {
          minHeight: "auto"
        }
      },
      ref: Ue,
      visible: we,
      ...je,
      children: me
    }
  );
}, NumericSlider = ({
  onChange: ce,
  value: ie,
  defaultValue: me,
  min: we,
  max: Re,
  step: je,
  visibleTooltip: Ue = !0,
  tipFormatter: qe,
  tipProps: Ge,
  range: Xe
}) => {
  const ot = lodashExports.debounce((Tt) => ce(Tt), 50), bt = {
    range: Xe,
    onChange: (Tt) => ot(Tt),
    min: we,
    max: Re,
    step: je,
    styles: {
      rail: { height: 2, backgroundColor: "#585858" },
      track: { height: 2, backgroundColor: "#D0D0D0" },
      handle: {
        height: 11,
        width: 11,
        border: 0,
        marginTop: -5,
        backgroundColor: "#FDC23B"
      }
    }
  };
  return ie !== void 0 ? bt.value = ie : bt.defaultValue = me, Ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slider$1,
    {
      ...bt,
      handleRender: (Tt, wt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        HandleTooltip,
        {
          value: wt.value,
          visible: wt.dragging,
          tipFormatter: qe,
          ...Ge,
          children: Tt
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Slider$1, { ...bt });
}, TrackElement = (ce) => {
  const ie = useRef(null);
  return useEffect(() => {
    const me = ie.current, we = ce.onCaptionsChanged;
    if (!me)
      return;
    const Re = () => {
      var Ue, qe;
      const je = (qe = (Ue = me.track.activeCues) == null ? void 0 : Ue[0]) == null ? void 0 : qe.text;
      if (!je) {
        we == null || we(null);
        return;
      }
      we == null || we(je);
    };
    return me.addEventListener("cuechange", Re), () => {
      we == null || we(null), me.removeEventListener("cuechange", Re);
    };
  }, [ce.onCaptionsChanged, ce.captionSrc]), ce.captionSrc ? /* @__PURE__ */ jsxRuntimeExports.jsx("track", { src: ce.captionSrc, ref: ie, default: !0, srcLang: "en", kind: "captions" }, ce.captionSrc) : null;
};
function rewindBackAudioTime(ce, ie) {
  const me = getCurrentTime(ce), we = Math.max(me - ie, 0);
  ce.currentTime = we;
}
function getCurrentTime(ce, ie) {
  return ce.currentTime > ce.duration ? (ie == null || ie(
    `Corrupted audio duration in ${ce.namespaceURI || ""}. Duration was ${ce.duration} and currentTime ${ce.currentTime}`
  ), ce.duration) : ce.currentTime;
}
const AudioElement = forwardRef((ce, ie) => {
  const me = useRef("stopped"), we = useRef(null);
  return useImperativeHandle(ie, () => {
    const Re = () => {
      const ot = we.current;
      ot && (me.current === "preparing to play" ? me.current = "preparing to play but requested stop" : ot.pause());
    }, je = (ot = !0, vt) => {
      const bt = we.current;
      if (!bt)
        return;
      const Tt = me.current === "preparing to play" || me.current === "preparing to play but requested stop";
      ot && !Tt && bt.load(), me.current = "preparing to play", bt.play().then(() => {
        me.current === "preparing to play but requested stop" && Re(), me.current = "playing";
      }).catch((wt) => {
        vt == null || vt(wt), me.current = "stopped";
      }), bt.playbackRate = ce.playbackRate ?? 1;
    };
    return {
      playFromStart: (ot) => je(!0, ot),
      pause: Re,
      rewindBack: (ot) => {
        const vt = we.current;
        vt && (rewindBackAudioTime(vt, ot), vt.currentTime === 0 ? je(!0) : (me.current === "stopped" || me.current === "ended") && je(!1));
      },
      toggle: () => {
        me.current === "playing" && Re(), me.current === "stopped" && je(!1), me.current === "ended" && je(!0);
      },
      changePlaybackRate: (ot) => {
        const vt = we.current;
        vt && (vt.playbackRate = ot);
      },
      forwardTo: (ot) => {
        const vt = we.current;
        vt && (vt.currentTime = ot);
      }
    };
  }, [me, we, ce.playbackRate]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "audio",
    {
      ref: we,
      src: ce.audioSrc,
      crossOrigin: "anonymous",
      muted: ce.isMuted,
      onLoadedMetadata: (Re) => {
        var je;
        ce.captionsSrc && (Re.currentTarget.textTracks[0].mode = "showing"), (je = ce.onLoadedMetadata) == null || je.call(ce, Re.currentTarget.duration);
      },
      onPlaying: ce.onPlaying,
      onPause: () => {
        var Re;
        me.current = "stopped", (Re = ce.onPause) == null || Re.call(ce);
      },
      onTimeUpdate: (Re) => {
        var Ue;
        const je = getCurrentTime(Re.currentTarget, ce.onLogError);
        (Ue = ce.onTimeUpdate) == null || Ue.call(ce, je);
      },
      onEnded: () => {
        var Re, je;
        me.current = "ended", (Re = ce.onCaptionsChanged) == null || Re.call(ce, null), (je = ce.onEnded) == null || je.call(ce);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrackElement, { captionSrc: ce.captionsSrc ?? null, onCaptionsChanged: ce.onCaptionsChanged })
    }
  );
}), AudioPlayer = ({ src: ce, captionsSrc: ie, onCaptionsChanged: me }) => {
  const we = useRef(null), [Re, je] = useState(!1), [Ue, qe] = useState(0), [Ge, Xe] = useState(0), ot = (St) => {
    qe(St);
  }, vt = (St) => {
    Xe(St);
  }, bt = () => {
    we.current && (Ue === 0 && !Re ? we.current.playFromStart((St) => {
      console.error("Error playing audio:", St);
    }) : we.current.toggle());
  }, Tt = (St) => {
    we.current && (we.current.forwardTo(St), qe(St));
  }, wt = (St) => {
    const It = Math.floor(St / 60), Pt = Math.floor(St % 60);
    return `${It}:${Pt < 10 ? "0" : ""}${Pt}`;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: ButtonVariant.TEXT, icon: Re ? faPause : faPlay, onClick: bt }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grow", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      NumericSlider,
      {
        value: Ue,
        onChange: Tt,
        min: 0,
        max: Ge,
        step: 0.01,
        visibleTooltip: !1
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { size: "xs", weight: "regular", children: [
      wt(Ue),
      " / ",
      wt(Ge)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AudioElement,
      {
        ref: we,
        audioSrc: ce,
        onTimeUpdate: ot,
        onLoadedMetadata: vt,
        onEnded: () => je(!1),
        onPlaying: () => je(!0),
        onPause: () => je(!1),
        captionsSrc: ie,
        onCaptionsChanged: me
      }
    )
  ] });
};
var roundNumber = function(ce, ie) {
  return Number(ce.toFixed(ie));
}, checkIsNumber = function(ce, ie) {
  return ie;
}, handleCallback = function(ce, ie, me) {
  me && typeof me == "function" && me(ce, ie);
}, easeOut = function(ce) {
  return -Math.cos(ce * Math.PI) / 2 + 0.5;
}, linear = function(ce) {
  return ce;
}, easeInQuad = function(ce) {
  return ce * ce;
}, easeOutQuad = function(ce) {
  return ce * (2 - ce);
}, easeInOutQuad = function(ce) {
  return ce < 0.5 ? 2 * ce * ce : -1 + (4 - 2 * ce) * ce;
}, easeInCubic = function(ce) {
  return ce * ce * ce;
}, easeOutCubic = function(ce) {
  return --ce * ce * ce + 1;
}, easeInOutCubic = function(ce) {
  return ce < 0.5 ? 4 * ce * ce * ce : (ce - 1) * (2 * ce - 2) * (2 * ce - 2) + 1;
}, easeInQuart = function(ce) {
  return ce * ce * ce * ce;
}, easeOutQuart = function(ce) {
  return 1 - --ce * ce * ce * ce;
}, easeInOutQuart = function(ce) {
  return ce < 0.5 ? 8 * ce * ce * ce * ce : 1 - 8 * --ce * ce * ce * ce;
}, easeInQuint = function(ce) {
  return ce * ce * ce * ce * ce;
}, easeOutQuint = function(ce) {
  return 1 + --ce * ce * ce * ce * ce;
}, easeInOutQuint = function(ce) {
  return ce < 0.5 ? 16 * ce * ce * ce * ce * ce : 1 + 16 * --ce * ce * ce * ce * ce;
}, animations = {
  easeOut,
  linear,
  easeInQuad,
  easeOutQuad,
  easeInOutQuad,
  easeInCubic,
  easeOutCubic,
  easeInOutCubic,
  easeInQuart,
  easeOutQuart,
  easeInOutQuart,
  easeInQuint,
  easeOutQuint,
  easeInOutQuint
}, handleCancelAnimationFrame = function(ce) {
  typeof ce == "number" && cancelAnimationFrame(ce);
}, handleCancelAnimation = function(ce) {
  ce.mounted && (handleCancelAnimationFrame(ce.animation), ce.animate = !1, ce.animation = null, ce.velocity = null);
};
function handleSetupAnimation(ce, ie, me, we) {
  if (ce.mounted) {
    var Re = (/* @__PURE__ */ new Date()).getTime(), je = 1;
    handleCancelAnimation(ce), ce.animation = function() {
      if (!ce.mounted)
        return handleCancelAnimationFrame(ce.animation);
      var Ue = (/* @__PURE__ */ new Date()).getTime() - Re, qe = Ue / me, Ge = animations[ie], Xe = Ge(qe);
      Ue >= me ? (we(je), ce.animation = null) : ce.animation && (we(Xe), requestAnimationFrame(ce.animation));
    }, requestAnimationFrame(ce.animation);
  }
}
function isValidTargetState(ce) {
  var ie = ce.scale, me = ce.positionX, we = ce.positionY;
  return !(Number.isNaN(ie) || Number.isNaN(me) || Number.isNaN(we));
}
function animate(ce, ie, me, we) {
  var Re = isValidTargetState(ie);
  if (!(!ce.mounted || !Re)) {
    var je = ce.setTransformState, Ue = ce.transformState, qe = Ue.scale, Ge = Ue.positionX, Xe = Ue.positionY, ot = ie.scale - qe, vt = ie.positionX - Ge, bt = ie.positionY - Xe;
    me === 0 ? je(ie.scale, ie.positionX, ie.positionY) : handleSetupAnimation(ce, we, me, function(Tt) {
      var wt = qe + ot * Tt, St = Ge + vt * Tt, It = Xe + bt * Tt;
      je(wt, St, It);
    });
  }
}
function getComponentsSizes(ce, ie, me) {
  var we = ce.offsetWidth, Re = ce.offsetHeight, je = ie.offsetWidth, Ue = ie.offsetHeight, qe = je * me, Ge = Ue * me, Xe = we - qe, ot = Re - Ge;
  return {
    wrapperWidth: we,
    wrapperHeight: Re,
    newContentWidth: qe,
    newDiffWidth: Xe,
    newContentHeight: Ge,
    newDiffHeight: ot
  };
}
var getBounds = function(ce, ie, me, we, Re, je, Ue) {
  var qe = ce > ie ? me * (Ue ? 1 : 0.5) : 0, Ge = we > Re ? je * (Ue ? 1 : 0.5) : 0, Xe = ce - ie - qe, ot = qe, vt = we - Re - Ge, bt = Ge;
  return { minPositionX: Xe, maxPositionX: ot, minPositionY: vt, maxPositionY: bt };
}, calculateBounds = function(ce, ie) {
  var me = ce.wrapperComponent, we = ce.contentComponent, Re = ce.setup.centerZoomedOut;
  if (!me || !we)
    throw new Error("Components are not mounted");
  var je = getComponentsSizes(me, we, ie), Ue = je.wrapperWidth, qe = je.wrapperHeight, Ge = je.newContentWidth, Xe = je.newDiffWidth, ot = je.newContentHeight, vt = je.newDiffHeight, bt = getBounds(Ue, Ge, Xe, qe, ot, vt, !!Re);
  return bt;
}, boundLimiter = function(ce, ie, me, we) {
  return we ? ce < ie ? roundNumber(ie, 2) : ce > me ? roundNumber(me, 2) : roundNumber(ce, 2) : roundNumber(ce, 2);
}, handleCalculateBounds = function(ce, ie) {
  var me = calculateBounds(ce, ie);
  return ce.bounds = me, me;
};
function getMouseBoundedPosition(ce, ie, me, we, Re, je, Ue) {
  var qe = me.minPositionX, Ge = me.minPositionY, Xe = me.maxPositionX, ot = me.maxPositionY, vt = 0, bt = 0;
  Ue && (vt = Re, bt = je);
  var Tt = boundLimiter(ce, qe - vt, Xe + vt, we), wt = boundLimiter(ie, Ge - bt, ot + bt, we);
  return { x: Tt, y: wt };
}
function handleCalculateZoomPositions(ce, ie, me, we, Re, je) {
  var Ue = ce.transformState, qe = Ue.scale, Ge = Ue.positionX, Xe = Ue.positionY, ot = we - qe;
  if (typeof ie != "number" || typeof me != "number")
    return console.error("Mouse X and Y position were not provided!"), { x: Ge, y: Xe };
  var vt = Ge - ie * ot, bt = Xe - me * ot, Tt = getMouseBoundedPosition(vt, bt, Re, je, 0, 0, null);
  return Tt;
}
function checkZoomBounds(ce, ie, me, we, Re) {
  var je = Re ? we : 0, Ue = ie - je;
  return !Number.isNaN(me) && ce >= me ? me : !Number.isNaN(ie) && ce <= Ue ? Ue : ce;
}
var isPanningStartAllowed = function(ce, ie) {
  var me = ce.setup.panning.excluded, we = ce.isInitialized, Re = ce.wrapperComponent, je = ie.target, Ue = "shadowRoot" in je && "composedPath" in ie, qe = Ue ? ie.composedPath().some(function(ot) {
    return ot instanceof Element ? Re == null ? void 0 : Re.contains(ot) : !1;
  }) : Re == null ? void 0 : Re.contains(je), Ge = we && je && qe;
  if (!Ge)
    return !1;
  var Xe = isExcludedNode(je, me);
  return !Xe;
}, isPanningAllowed = function(ce) {
  var ie = ce.isInitialized, me = ce.isPanning, we = ce.setup, Re = we.panning.disabled, je = ie && me && !Re;
  return !!je;
}, handlePanningSetup = function(ce, ie) {
  var me = ce.transformState, we = me.positionX, Re = me.positionY;
  ce.isPanning = !0;
  var je = ie.clientX, Ue = ie.clientY;
  ce.startCoords = { x: je - we, y: Ue - Re };
}, handleTouchPanningSetup = function(ce, ie) {
  var me = ie.touches, we = ce.transformState, Re = we.positionX, je = we.positionY;
  ce.isPanning = !0;
  var Ue = me.length === 1;
  if (Ue) {
    var qe = me[0].clientX, Ge = me[0].clientY;
    ce.startCoords = { x: qe - Re, y: Ge - je };
  }
};
function handlePanToBounds(ce) {
  var ie = ce.transformState, me = ie.positionX, we = ie.positionY, Re = ie.scale, je = ce.setup, Ue = je.disabled, qe = je.limitToBounds, Ge = je.centerZoomedOut, Xe = ce.wrapperComponent;
  if (!(Ue || !Xe || !ce.bounds)) {
    var ot = ce.bounds, vt = ot.maxPositionX, bt = ot.minPositionX, Tt = ot.maxPositionY, wt = ot.minPositionY, St = me > vt || me < bt, It = we > Tt || we < wt, Pt = me > vt ? Xe.offsetWidth : ce.setup.minPositionX || 0, kt = we > Tt ? Xe.offsetHeight : ce.setup.minPositionY || 0, Ot = handleCalculateZoomPositions(ce, Pt, kt, Re, ce.bounds, qe || Ge), Jr = Ot.x, en = Ot.y;
    return {
      scale: Re,
      positionX: St ? Jr : me,
      positionY: It ? en : we
    };
  }
}
function handleNewPosition(ce, ie, me, we, Re) {
  var je = ce.setup.limitToBounds, Ue = ce.wrapperComponent, qe = ce.bounds, Ge = ce.transformState, Xe = Ge.scale, ot = Ge.positionX, vt = Ge.positionY;
  if (!(Ue === null || qe === null || ie === ot && me === vt)) {
    var bt = getMouseBoundedPosition(ie, me, qe, je, we, Re, Ue), Tt = bt.x, wt = bt.y;
    ce.setTransformState(Xe, Tt, wt);
  }
}
var getPanningClientPosition = function(ce, ie, me) {
  var we = ce.startCoords, Re = ce.transformState, je = ce.setup.panning, Ue = je.lockAxisX, qe = je.lockAxisY, Ge = Re.positionX, Xe = Re.positionY;
  if (!we)
    return { x: Ge, y: Xe };
  var ot = ie - we.x, vt = me - we.y, bt = Ue ? Ge : ot, Tt = qe ? Xe : vt;
  return { x: bt, y: Tt };
}, getPaddingValue = function(ce, ie) {
  var me = ce.setup, we = ce.transformState, Re = we.scale, je = me.minScale, Ue = me.disablePadding;
  return ie > 0 && Re >= je && !Ue ? ie : 0;
}, isVelocityCalculationAllowed = function(ce) {
  var ie = ce.mounted, me = ce.setup, we = me.disabled, Re = me.velocityAnimation, je = ce.transformState.scale, Ue = Re.disabled, qe = !Ue || je > 1 || !we || ie;
  return !!qe;
}, isVelocityAllowed = function(ce) {
  var ie = ce.mounted, me = ce.velocity, we = ce.bounds, Re = ce.setup, je = Re.disabled, Ue = Re.velocityAnimation, qe = ce.transformState.scale, Ge = Ue.disabled, Xe = !Ge || qe > 1 || !je || ie;
  return !(!Xe || !me || !we);
};
function getVelocityMoveTime(ce, ie) {
  var me = ce.setup.velocityAnimation, we = me.equalToMove, Re = me.animationTime, je = me.sensitivity;
  return we ? Re * ie * je : Re;
}
function getVelocityPosition(ce, ie, me, we, Re, je, Ue, qe, Ge, Xe) {
  if (Re) {
    if (ie > Ue && me > Ue) {
      var ot = Ue + (ce - Ue) * Xe;
      return ot > Ge ? Ge : ot < Ue ? Ue : ot;
    }
    if (ie < je && me < je) {
      var ot = je + (ce - je) * Xe;
      return ot < qe ? qe : ot > je ? je : ot;
    }
  }
  return we ? ie : boundLimiter(ce, je, Ue, Re);
}
function getSizeMultiplier(ce, ie) {
  var me = 1;
  return ie ? Math.min(me, ce.offsetWidth / window.innerWidth) : me;
}
function handleCalculateVelocity(ce, ie) {
  var me = isVelocityCalculationAllowed(ce);
  if (me) {
    var we = ce.lastMousePosition, Re = ce.velocityTime, je = ce.setup, Ue = ce.wrapperComponent, qe = je.velocityAnimation.equalToMove, Ge = Date.now();
    if (we && Re && Ue) {
      var Xe = getSizeMultiplier(Ue, qe), ot = ie.x - we.x, vt = ie.y - we.y, bt = ot / Xe, Tt = vt / Xe, wt = Ge - Re, St = ot * ot + vt * vt, It = Math.sqrt(St) / wt;
      ce.velocity = { velocityX: bt, velocityY: Tt, total: It };
    }
    ce.lastMousePosition = ie, ce.velocityTime = Ge;
  }
}
function handleVelocityPanning(ce) {
  var ie = ce.velocity, me = ce.bounds, we = ce.setup, Re = ce.wrapperComponent, je = isVelocityAllowed(ce);
  if (!(!je || !ie || !me || !Re)) {
    var Ue = ie.velocityX, qe = ie.velocityY, Ge = ie.total, Xe = me.maxPositionX, ot = me.minPositionX, vt = me.maxPositionY, bt = me.minPositionY, Tt = we.limitToBounds, wt = we.alignmentAnimation, St = we.zoomAnimation, It = we.panning, Pt = It.lockAxisY, kt = It.lockAxisX, Ot = St.animationType, Jr = wt.sizeX, en = wt.sizeY, nn = wt.velocityAlignmentTime, ln = nn, fn = getVelocityMoveTime(ce, Ge), vn = Math.max(fn, ln), Tn = getPaddingValue(ce, Jr), xn = getPaddingValue(ce, en), bn = Tn * Re.offsetWidth / 100, Sn = xn * Re.offsetHeight / 100, Cn = Xe + bn, kn = ot - bn, cn = vt + Sn, gn = bt - Sn, an = ce.transformState, un = (/* @__PURE__ */ new Date()).getTime();
    handleSetupAnimation(ce, Ot, vn, function(pn) {
      var hn = ce.transformState, An = hn.scale, In = hn.positionX, qn = hn.positionY, si = (/* @__PURE__ */ new Date()).getTime() - un, bi = si / ln, xi = animations[wt.animationType], ji = 1 - xi(Math.min(1, bi)), zi = 1 - pn, Vi = In + Ue * zi, Hi = qn + qe * zi, ii = getVelocityPosition(Vi, an.positionX, In, kt, Tt, ot, Xe, kn, Cn, ji), Fi = getVelocityPosition(Hi, an.positionY, qn, Pt, Tt, bt, vt, gn, cn, ji);
      (In !== Vi || qn !== Hi) && ce.setTransformState(An, ii, Fi);
    });
  }
}
function handlePanningStart(ce, ie) {
  var me = ce.transformState.scale;
  handleCancelAnimation(ce), handleCalculateBounds(ce, me), window.TouchEvent !== void 0 && ie instanceof TouchEvent ? handleTouchPanningSetup(ce, ie) : handlePanningSetup(ce, ie);
}
function handleAlignToBounds(ce, ie) {
  var me = ce.transformState.scale, we = ce.setup, Re = we.minScale, je = we.alignmentAnimation, Ue = je.disabled, qe = je.sizeX, Ge = je.sizeY, Xe = je.animationTime, ot = je.animationType, vt = Ue || me < Re || !qe && !Ge;
  if (!vt) {
    var bt = handlePanToBounds(ce);
    bt && animate(ce, bt, ie ?? Xe, ot);
  }
}
function handlePanning(ce, ie, me) {
  var we = ce.startCoords, Re = ce.setup, je = Re.alignmentAnimation, Ue = je.sizeX, qe = je.sizeY;
  if (we) {
    var Ge = getPanningClientPosition(ce, ie, me), Xe = Ge.x, ot = Ge.y, vt = getPaddingValue(ce, Ue), bt = getPaddingValue(ce, qe);
    handleCalculateVelocity(ce, { x: Xe, y: ot }), handleNewPosition(ce, Xe, ot, vt, bt);
  }
}
function handlePanningEnd(ce) {
  if (ce.isPanning) {
    var ie = ce.setup.panning.velocityDisabled, me = ce.velocity, we = ce.wrapperComponent, Re = ce.contentComponent;
    ce.isPanning = !1, ce.animate = !1, ce.animation = null;
    var je = we == null ? void 0 : we.getBoundingClientRect(), Ue = Re == null ? void 0 : Re.getBoundingClientRect(), qe = (je == null ? void 0 : je.width) || 0, Ge = (je == null ? void 0 : je.height) || 0, Xe = (Ue == null ? void 0 : Ue.width) || 0, ot = (Ue == null ? void 0 : Ue.height) || 0, vt = qe < Xe || Ge < ot, bt = !ie && me && (me == null ? void 0 : me.total) > 0.1 && vt;
    bt ? handleVelocityPanning(ce) : handleAlignToBounds(ce);
  }
}
function handleZoomToPoint(ce, ie, me, we) {
  var Re = ce.setup, je = Re.minScale, Ue = Re.maxScale, qe = Re.limitToBounds, Ge = checkZoomBounds(roundNumber(ie, 2), je, Ue, 0, !1), Xe = handleCalculateBounds(ce, Ge), ot = handleCalculateZoomPositions(ce, me, we, Ge, Xe, qe), vt = ot.x, bt = ot.y;
  return { scale: Ge, positionX: vt, positionY: bt };
}
function handleAlignToScaleBounds(ce, ie, me) {
  var we = ce.transformState.scale, Re = ce.wrapperComponent, je = ce.setup, Ue = je.minScale, qe = je.limitToBounds, Ge = je.zoomAnimation, Xe = Ge.disabled, ot = Ge.animationTime, vt = Ge.animationType, bt = Xe || we >= Ue;
  if ((we >= 1 || qe) && handleAlignToBounds(ce), !(bt || !Re || !ce.mounted)) {
    var Tt = ie || Re.offsetWidth / 2, wt = me || Re.offsetHeight / 2, St = handleZoomToPoint(ce, Ue, Tt, wt);
    St && animate(ce, St, ot, vt);
  }
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(ie) {
    for (var me, we = 1, Re = arguments.length; we < Re; we++) {
      me = arguments[we];
      for (var je in me) Object.prototype.hasOwnProperty.call(me, je) && (ie[je] = me[je]);
    }
    return ie;
  }, __assign$2.apply(this, arguments);
};
function __spreadArray(ce, ie, me) {
  for (var we = 0, Re = ie.length, je; we < Re; we++)
    (je || !(we in ie)) && (je || (je = Array.prototype.slice.call(ie, 0, we)), je[we] = ie[we]);
  return ce.concat(je || Array.prototype.slice.call(ie));
}
typeof SuppressedError == "function" && SuppressedError;
var initialState$3 = {
  scale: 1,
  positionX: 0,
  positionY: 0
}, initialSetup = {
  disabled: !1,
  minPositionX: null,
  maxPositionX: null,
  minPositionY: null,
  maxPositionY: null,
  minScale: 1,
  maxScale: 8,
  limitToBounds: !0,
  centerZoomedOut: !1,
  centerOnInit: !1,
  disablePadding: !1,
  smooth: !0,
  wheel: {
    step: 0.2,
    disabled: !1,
    smoothStep: 1e-3,
    wheelDisabled: !1,
    touchPadDisabled: !1,
    activationKeys: [],
    excluded: []
  },
  panning: {
    disabled: !1,
    velocityDisabled: !1,
    lockAxisX: !1,
    lockAxisY: !1,
    allowLeftClickPan: !0,
    allowMiddleClickPan: !0,
    allowRightClickPan: !0,
    wheelPanning: !1,
    activationKeys: [],
    excluded: []
  },
  pinch: {
    step: 5,
    disabled: !1,
    excluded: []
  },
  doubleClick: {
    disabled: !1,
    step: 0.7,
    mode: "zoomIn",
    animationType: "easeOut",
    animationTime: 200,
    excluded: []
  },
  zoomAnimation: {
    disabled: !1,
    size: 0.4,
    animationTime: 200,
    animationType: "easeOut"
  },
  alignmentAnimation: {
    disabled: !1,
    sizeX: 100,
    sizeY: 100,
    animationTime: 200,
    velocityAlignmentTime: 400,
    animationType: "easeOut"
  },
  velocityAnimation: {
    disabled: !1,
    sensitivity: 1,
    animationTime: 400,
    animationType: "easeOut",
    equalToMove: !0
  }
}, baseClasses = {
  wrapperClass: "react-transform-wrapper",
  contentClass: "react-transform-component"
}, createState = function(ce) {
  var ie, me, we, Re;
  return {
    previousScale: (ie = ce.initialScale) !== null && ie !== void 0 ? ie : initialState$3.scale,
    scale: (me = ce.initialScale) !== null && me !== void 0 ? me : initialState$3.scale,
    positionX: (we = ce.initialPositionX) !== null && we !== void 0 ? we : initialState$3.positionX,
    positionY: (Re = ce.initialPositionY) !== null && Re !== void 0 ? Re : initialState$3.positionY
  };
}, createSetup = function(ce) {
  var ie = __assign$2({}, initialSetup);
  return Object.keys(ce).forEach(function(me) {
    var we = typeof ce[me] < "u", Re = typeof initialSetup[me] < "u";
    if (Re && we) {
      var je = Object.prototype.toString.call(initialSetup[me]), Ue = je === "[object Object]", qe = je === "[object Array]";
      Ue ? ie[me] = __assign$2(__assign$2({}, initialSetup[me]), ce[me]) : qe ? ie[me] = __spreadArray(__spreadArray([], initialSetup[me], !0), ce[me]) : ie[me] = ce[me];
    }
  }), ie;
}, handleCalculateButtonZoom = function(ce, ie, me) {
  var we = ce.transformState.scale, Re = ce.wrapperComponent, je = ce.setup, Ue = je.maxScale, qe = je.minScale, Ge = je.zoomAnimation, Xe = je.smooth, ot = Ge.size;
  if (!Re)
    throw new Error("Wrapper is not mounted");
  var vt = Xe ? we * Math.exp(ie * me) : we + ie * me, bt = checkZoomBounds(roundNumber(vt, 3), qe, Ue, ot, !1);
  return bt;
};
function handleZoomToViewCenter(ce, ie, me, we, Re) {
  var je = ce.wrapperComponent, Ue = ce.transformState, qe = Ue.scale, Ge = Ue.positionX, Xe = Ue.positionY;
  if (!je)
    return console.error("No WrapperComponent found");
  var ot = je.offsetWidth, vt = je.offsetHeight, bt = (ot / 2 - Ge) / qe, Tt = (vt / 2 - Xe) / qe, wt = handleCalculateButtonZoom(ce, ie, me), St = handleZoomToPoint(ce, wt, bt, Tt);
  if (!St)
    return console.error("Error during zoom event. New transformation state was not calculated.");
  animate(ce, St, we, Re);
}
function resetTransformations(ce, ie, me, we) {
  var Re = ce.setup, je = ce.wrapperComponent, Ue = Re.limitToBounds, qe = createState(ce.props), Ge = ce.transformState, Xe = Ge.scale, ot = Ge.positionX, vt = Ge.positionY;
  if (je) {
    var bt = calculateBounds(ce, qe.scale), Tt = getMouseBoundedPosition(qe.positionX, qe.positionY, bt, Ue, 0, 0, je), wt = {
      scale: qe.scale,
      positionX: Tt.x,
      positionY: Tt.y
    };
    Xe === qe.scale && ot === qe.positionX && vt === qe.positionY || (we == null || we(), animate(ce, wt, ie, me));
  }
}
function getOffset$1(ce, ie, me, we) {
  var Re = ce.getBoundingClientRect(), je = ie.getBoundingClientRect(), Ue = me.getBoundingClientRect(), qe = je.x * we.scale, Ge = je.y * we.scale;
  return {
    x: (Re.x - Ue.x + qe) / we.scale,
    y: (Re.y - Ue.y + Ge) / we.scale
  };
}
function calculateZoomToNode(ce, ie, me) {
  var we = ce.wrapperComponent, Re = ce.contentComponent, je = ce.transformState, Ue = ce.setup, qe = Ue.limitToBounds, Ge = Ue.minScale, Xe = Ue.maxScale;
  if (!we || !Re)
    return je;
  var ot = we.getBoundingClientRect(), vt = ie.getBoundingClientRect(), bt = getOffset$1(ie, we, Re, je), Tt = bt.x, wt = bt.y, St = vt.width / je.scale, It = vt.height / je.scale, Pt = we.offsetWidth / St, kt = we.offsetHeight / It, Ot = checkZoomBounds(me || Math.min(Pt, kt), Ge, Xe, 0, !1), Jr = (ot.width - St * Ot) / 2, en = (ot.height - It * Ot) / 2, nn = (ot.left - Tt) * Ot + Jr, ln = (ot.top - wt) * Ot + en, fn = calculateBounds(ce, Ot), vn = getMouseBoundedPosition(nn, ln, fn, qe, 0, 0, we), Tn = vn.x, xn = vn.y;
  return { positionX: Tn, positionY: xn, scale: Ot };
}
var zoomIn = function(ce) {
  return function(ie, me, we) {
    ie === void 0 && (ie = 0.5), me === void 0 && (me = 300), we === void 0 && (we = "easeOut"), handleZoomToViewCenter(ce, 1, ie, me, we);
  };
}, zoomOut = function(ce) {
  return function(ie, me, we) {
    ie === void 0 && (ie = 0.5), me === void 0 && (me = 300), we === void 0 && (we = "easeOut"), handleZoomToViewCenter(ce, -1, ie, me, we);
  };
}, setTransform$2 = function(ce) {
  return function(ie, me, we, Re, je) {
    Re === void 0 && (Re = 300), je === void 0 && (je = "easeOut");
    var Ue = ce.transformState, qe = Ue.positionX, Ge = Ue.positionY, Xe = Ue.scale, ot = ce.wrapperComponent, vt = ce.contentComponent, bt = ce.setup.disabled;
    if (!(bt || !ot || !vt)) {
      var Tt = {
        positionX: Number.isNaN(ie) ? qe : ie,
        positionY: Number.isNaN(me) ? Ge : me,
        scale: Number.isNaN(we) ? Xe : we
      };
      animate(ce, Tt, Re, je);
    }
  };
}, resetTransform = function(ce) {
  return function(ie, me) {
    ie === void 0 && (ie = 200), me === void 0 && (me = "easeOut"), resetTransformations(ce, ie, me);
  };
}, centerView = function(ce) {
  return function(ie, me, we) {
    me === void 0 && (me = 200), we === void 0 && (we = "easeOut");
    var Re = ce.transformState, je = ce.wrapperComponent, Ue = ce.contentComponent;
    if (je && Ue) {
      var qe = getCenterPosition(ie || Re.scale, je, Ue);
      animate(ce, qe, me, we);
    }
  };
}, zoomToElement = function(ce) {
  return function(ie, me, we, Re) {
    we === void 0 && (we = 600), Re === void 0 && (Re = "easeOut"), handleCancelAnimation(ce);
    var je = ce.wrapperComponent, Ue = typeof ie == "string" ? document.getElementById(ie) : ie;
    if (je && Ue && je.contains(Ue)) {
      var qe = calculateZoomToNode(ce, Ue, me);
      animate(ce, qe, we, Re);
    }
  };
}, getControls = function(ce) {
  return {
    instance: ce,
    zoomIn: zoomIn(ce),
    zoomOut: zoomOut(ce),
    setTransform: setTransform$2(ce),
    resetTransform: resetTransform(ce),
    centerView: centerView(ce),
    zoomToElement: zoomToElement(ce)
  };
}, getState = function(ce) {
  return {
    instance: ce,
    state: ce.transformState
  };
}, getContext = function(ce) {
  var ie = {};
  return Object.assign(ie, getState(ce)), Object.assign(ie, getControls(ce)), ie;
}, passiveSupported = !1;
function makePassiveEventOption() {
  try {
    var ce = {
      get passive() {
        return passiveSupported = !0, !1;
      }
    };
    return ce;
  } catch {
    return passiveSupported = !1, passiveSupported;
  }
}
var matchPrefix = ".".concat(baseClasses.wrapperClass), isExcludedNode = function(ce, ie) {
  return ie.some(function(me) {
    return ce.matches("".concat(matchPrefix, " ").concat(me, ", ").concat(matchPrefix, " .").concat(me, ", ").concat(matchPrefix, " ").concat(me, " *, ").concat(matchPrefix, " .").concat(me, " *"));
  });
}, cancelTimeout$1 = function(ce) {
  ce && clearTimeout(ce);
}, getTransformStyles = function(ce, ie, me) {
  return "translate(".concat(ce, "px, ").concat(ie, "px) scale(").concat(me, ")");
}, getCenterPosition = function(ce, ie, me) {
  var we = me.offsetWidth * ce, Re = me.offsetHeight * ce, je = (ie.offsetWidth - we) / 2, Ue = (ie.offsetHeight - Re) / 2;
  return {
    scale: ce,
    positionX: je,
    positionY: Ue
  };
};
function mergeRefs(ce) {
  return function(ie) {
    ce.forEach(function(me) {
      typeof me == "function" ? me(ie) : me != null && (me.current = ie);
    });
  };
}
var isWheelAllowed = function(ce, ie) {
  var me = ce.setup.wheel, we = me.disabled, Re = me.wheelDisabled, je = me.touchPadDisabled, Ue = me.excluded, qe = ce.isInitialized, Ge = ce.isPanning, Xe = ie.target, ot = qe && !Ge && !we && Xe;
  if (!ot || Re && !ie.ctrlKey || je && ie.ctrlKey)
    return !1;
  var vt = isExcludedNode(Xe, Ue);
  return !vt;
}, getDeltaY = function(ce) {
  return ce ? ce.deltaY < 0 ? 1 : -1 : 0;
};
function getDelta(ce, ie) {
  var me = getDeltaY(ce), we = checkIsNumber(ie, me);
  return we;
}
function getMousePosition(ce, ie, me) {
  var we = ie.getBoundingClientRect(), Re = 0, je = 0;
  if ("clientX" in ce)
    Re = (ce.clientX - we.left) / me, je = (ce.clientY - we.top) / me;
  else {
    var Ue = ce.touches[0];
    Re = (Ue.clientX - we.left) / me, je = (Ue.clientY - we.top) / me;
  }
  return (Number.isNaN(Re) || Number.isNaN(je)) && console.error("No mouse or touch offset found"), {
    x: Re,
    y: je
  };
}
var handleCalculateWheelZoom = function(ce, ie, me, we, Re) {
  var je = ce.transformState.scale, Ue = ce.wrapperComponent, qe = ce.setup, Ge = qe.maxScale, Xe = qe.minScale, ot = qe.zoomAnimation, vt = qe.disablePadding, bt = ot.size, Tt = ot.disabled;
  if (!Ue)
    throw new Error("Wrapper is not mounted");
  var wt = je + ie * me, St = we ? !1 : !Tt, It = checkZoomBounds(roundNumber(wt, 3), Xe, Ge, bt, St && !vt);
  return It;
}, handleWheelZoomStop = function(ce, ie) {
  var me = ce.previousWheelEvent, we = ce.transformState.scale, Re = ce.setup, je = Re.maxScale, Ue = Re.minScale;
  return me ? we < je || we > Ue || Math.sign(me.deltaY) !== Math.sign(ie.deltaY) || me.deltaY > 0 && me.deltaY < ie.deltaY || me.deltaY < 0 && me.deltaY > ie.deltaY || Math.sign(me.deltaY) !== Math.sign(ie.deltaY) : !1;
}, isPinchStartAllowed = function(ce, ie) {
  var me = ce.setup.pinch, we = me.disabled, Re = me.excluded, je = ce.isInitialized, Ue = ie.target, qe = je && !we && Ue;
  if (!qe)
    return !1;
  var Ge = isExcludedNode(Ue, Re);
  return !Ge;
}, isPinchAllowed = function(ce) {
  var ie = ce.setup.pinch.disabled, me = ce.isInitialized, we = ce.pinchStartDistance, Re = me && !ie && we;
  return !!Re;
}, calculateTouchMidPoint = function(ce, ie, me) {
  var we = me.getBoundingClientRect(), Re = ce.touches, je = roundNumber(Re[0].clientX - we.left, 5), Ue = roundNumber(Re[0].clientY - we.top, 5), qe = roundNumber(Re[1].clientX - we.left, 5), Ge = roundNumber(Re[1].clientY - we.top, 5);
  return {
    x: (je + qe) / 2 / ie,
    y: (Ue + Ge) / 2 / ie
  };
}, getTouchDistance = function(ce) {
  return Math.sqrt(Math.pow(ce.touches[0].pageX - ce.touches[1].pageX, 2) + Math.pow(ce.touches[0].pageY - ce.touches[1].pageY, 2));
}, calculatePinchZoom = function(ce, ie) {
  var me = ce.pinchStartScale, we = ce.pinchStartDistance, Re = ce.setup, je = Re.maxScale, Ue = Re.minScale, qe = Re.zoomAnimation, Ge = Re.disablePadding, Xe = qe.size, ot = qe.disabled;
  if (!me || we === null || !ie)
    throw new Error("Pinch touches distance was not provided");
  if (ie < 0)
    return ce.transformState.scale;
  var vt = ie / we, bt = vt * me;
  return checkZoomBounds(roundNumber(bt, 2), Ue, je, Xe, !ot && !Ge);
}, wheelStopEventTime = 160, wheelAnimationTime = 100, handleWheelStart = function(ce, ie) {
  var me = ce.props, we = me.onWheelStart, Re = me.onZoomStart;
  ce.wheelStopEventTimer || (handleCancelAnimation(ce), handleCallback(getContext(ce), ie, we), handleCallback(getContext(ce), ie, Re));
}, handleWheelZoom = function(ce, ie) {
  var me = ce.props, we = me.onWheel, Re = me.onZoom, je = ce.contentComponent, Ue = ce.setup, qe = ce.transformState, Ge = qe.scale, Xe = Ue.limitToBounds, ot = Ue.centerZoomedOut, vt = Ue.zoomAnimation, bt = Ue.wheel, Tt = Ue.disablePadding, wt = Ue.smooth, St = vt.size, It = vt.disabled, Pt = bt.step, kt = bt.smoothStep;
  if (!je)
    throw new Error("Component not mounted");
  ie.preventDefault(), ie.stopPropagation();
  var Ot = getDelta(ie, null), Jr = wt ? kt * Math.abs(ie.deltaY) : Pt, en = handleCalculateWheelZoom(ce, Ot, Jr, !ie.ctrlKey);
  if (Ge !== en) {
    var nn = handleCalculateBounds(ce, en), ln = getMousePosition(ie, je, Ge), fn = It || St === 0 || ot || Tt, vn = Xe && fn, Tn = handleCalculateZoomPositions(ce, ln.x, ln.y, en, nn, vn), xn = Tn.x, bn = Tn.y;
    ce.previousWheelEvent = ie, ce.setTransformState(en, xn, bn), handleCallback(getContext(ce), ie, we), handleCallback(getContext(ce), ie, Re);
  }
}, handleWheelStop = function(ce, ie) {
  var me = ce.props, we = me.onWheelStop, Re = me.onZoomStop;
  cancelTimeout$1(ce.wheelAnimationTimer), ce.wheelAnimationTimer = setTimeout(function() {
    ce.mounted && (handleAlignToScaleBounds(ce, ie.x, ie.y), ce.wheelAnimationTimer = null);
  }, wheelAnimationTime);
  var je = handleWheelZoomStop(ce, ie);
  je && (cancelTimeout$1(ce.wheelStopEventTimer), ce.wheelStopEventTimer = setTimeout(function() {
    ce.mounted && (ce.wheelStopEventTimer = null, handleCallback(getContext(ce), ie, we), handleCallback(getContext(ce), ie, Re));
  }, wheelStopEventTime));
}, getTouchCenter = function(ce) {
  for (var ie = 0, me = 0, we = 0; we < 2; we += 1)
    ie += ce.touches[we].clientX, me += ce.touches[we].clientY;
  var Re = ie / 2, je = me / 2;
  return { x: Re, y: je };
}, handlePinchStart = function(ce, ie) {
  var me = getTouchDistance(ie);
  ce.pinchStartDistance = me, ce.lastDistance = me, ce.pinchStartScale = ce.transformState.scale, ce.isPanning = !1;
  var we = getTouchCenter(ie);
  ce.pinchLastCenterX = we.x, ce.pinchLastCenterY = we.y, handleCancelAnimation(ce);
}, handlePinchZoom = function(ce, ie) {
  var me = ce.contentComponent, we = ce.pinchStartDistance, Re = ce.wrapperComponent, je = ce.transformState.scale, Ue = ce.setup, qe = Ue.limitToBounds, Ge = Ue.centerZoomedOut, Xe = Ue.zoomAnimation, ot = Ue.alignmentAnimation, vt = Xe.disabled, bt = Xe.size;
  if (!(we === null || !me)) {
    var Tt = calculateTouchMidPoint(ie, je, me);
    if (!(!Number.isFinite(Tt.x) || !Number.isFinite(Tt.y))) {
      var wt = getTouchDistance(ie), St = calculatePinchZoom(ce, wt), It = getTouchCenter(ie), Pt = It.x - (ce.pinchLastCenterX || 0), kt = It.y - (ce.pinchLastCenterY || 0);
      if (!(St === je && Pt === 0 && kt === 0)) {
        ce.pinchLastCenterX = It.x, ce.pinchLastCenterY = It.y;
        var Ot = handleCalculateBounds(ce, St), Jr = vt || bt === 0 || Ge, en = qe && Jr, nn = handleCalculateZoomPositions(ce, Tt.x, Tt.y, St, Ot, en), ln = nn.x, fn = nn.y;
        ce.pinchMidpoint = Tt, ce.lastDistance = wt;
        var vn = ot.sizeX, Tn = ot.sizeY, xn = getPaddingValue(ce, vn), bn = getPaddingValue(ce, Tn), Sn = ln + Pt, Cn = fn + kt, kn = getMouseBoundedPosition(Sn, Cn, Ot, qe, xn, bn, Re), cn = kn.x, gn = kn.y;
        ce.setTransformState(St, cn, gn);
      }
    }
  }
}, handlePinchStop = function(ce) {
  var ie = ce.pinchMidpoint;
  ce.velocity = null, ce.lastDistance = null, ce.pinchMidpoint = null, ce.pinchStartScale = null, ce.pinchStartDistance = null, handleAlignToScaleBounds(ce, ie == null ? void 0 : ie.x, ie == null ? void 0 : ie.y);
}, handleDoubleClickStop = function(ce, ie) {
  var me = ce.props.onZoomStop, we = ce.setup.doubleClick.animationTime;
  cancelTimeout$1(ce.doubleClickStopEventTimer), ce.doubleClickStopEventTimer = setTimeout(function() {
    ce.doubleClickStopEventTimer = null, handleCallback(getContext(ce), ie, me);
  }, we);
}, handleDoubleClickResetMode = function(ce, ie) {
  var me = ce.props, we = me.onZoomStart, Re = me.onZoom, je = ce.setup.doubleClick, Ue = je.animationTime, qe = je.animationType;
  handleCallback(getContext(ce), ie, we), resetTransformations(ce, Ue, qe, function() {
    return handleCallback(getContext(ce), ie, Re);
  }), handleDoubleClickStop(ce, ie);
};
function getDoubleClickScale(ce, ie) {
  return ce === "toggle" ? ie === 1 ? 1 : -1 : ce === "zoomOut" ? -1 : 1;
}
function handleDoubleClick(ce, ie) {
  var me = ce.setup, we = ce.doubleClickStopEventTimer, Re = ce.transformState, je = ce.contentComponent, Ue = Re.scale, qe = ce.props, Ge = qe.onZoomStart, Xe = qe.onZoom, ot = me.doubleClick, vt = ot.disabled, bt = ot.mode, Tt = ot.step, wt = ot.animationTime, St = ot.animationType;
  if (!vt && !we) {
    if (bt === "reset")
      return handleDoubleClickResetMode(ce, ie);
    if (!je)
      return console.error("No ContentComponent found");
    var It = getDoubleClickScale(bt, ce.transformState.scale), Pt = handleCalculateButtonZoom(ce, It, Tt);
    if (Ue !== Pt) {
      handleCallback(getContext(ce), ie, Ge);
      var kt = getMousePosition(ie, je, Ue), Ot = handleZoomToPoint(ce, Pt, kt.x, kt.y);
      if (!Ot)
        return console.error("Error during zoom event. New transformation state was not calculated.");
      handleCallback(getContext(ce), ie, Xe), animate(ce, Ot, wt, St), handleDoubleClickStop(ce, ie);
    }
  }
}
var isDoubleClickAllowed = function(ce, ie) {
  var me = ce.isInitialized, we = ce.setup, Re = ce.wrapperComponent, je = we.doubleClick, Ue = je.disabled, qe = je.excluded, Ge = ie.target, Xe = Re == null ? void 0 : Re.contains(Ge), ot = me && Ge && Xe && !Ue;
  if (!ot)
    return !1;
  var vt = isExcludedNode(Ge, qe);
  return !vt;
}, ZoomPanPinch = (
  /** @class */
  /* @__PURE__ */ function() {
    function ce(ie) {
      var me = this;
      this.mounted = !0, this.pinchLastCenterX = null, this.pinchLastCenterY = null, this.onChangeCallbacks = /* @__PURE__ */ new Set(), this.onInitCallbacks = /* @__PURE__ */ new Set(), this.wrapperComponent = null, this.contentComponent = null, this.isInitialized = !1, this.bounds = null, this.previousWheelEvent = null, this.wheelStopEventTimer = null, this.wheelAnimationTimer = null, this.isPanning = !1, this.isWheelPanning = !1, this.startCoords = null, this.lastTouch = null, this.distance = null, this.lastDistance = null, this.pinchStartDistance = null, this.pinchStartScale = null, this.pinchMidpoint = null, this.doubleClickStopEventTimer = null, this.velocity = null, this.velocityTime = null, this.lastMousePosition = null, this.animate = !1, this.animation = null, this.maxBounds = null, this.pressedKeys = {}, this.mount = function() {
        me.initializeWindowEvents();
      }, this.unmount = function() {
        me.cleanupWindowEvents();
      }, this.update = function(we) {
        me.props = we, handleCalculateBounds(me, me.transformState.scale), me.setup = createSetup(we);
      }, this.initializeWindowEvents = function() {
        var we, Re, je = makePassiveEventOption(), Ue = (we = me.wrapperComponent) === null || we === void 0 ? void 0 : we.ownerDocument, qe = Ue == null ? void 0 : Ue.defaultView;
        (Re = me.wrapperComponent) === null || Re === void 0 || Re.addEventListener("wheel", me.onWheelPanning, je), qe == null || qe.addEventListener("mousedown", me.onPanningStart, je), qe == null || qe.addEventListener("mousemove", me.onPanning, je), qe == null || qe.addEventListener("mouseup", me.onPanningStop, je), Ue == null || Ue.addEventListener("mouseleave", me.clearPanning, je), qe == null || qe.addEventListener("keyup", me.setKeyUnPressed, je), qe == null || qe.addEventListener("keydown", me.setKeyPressed, je);
      }, this.cleanupWindowEvents = function() {
        var we, Re, je = makePassiveEventOption(), Ue = (we = me.wrapperComponent) === null || we === void 0 ? void 0 : we.ownerDocument, qe = Ue == null ? void 0 : Ue.defaultView;
        qe == null || qe.removeEventListener("mousedown", me.onPanningStart, je), qe == null || qe.removeEventListener("mousemove", me.onPanning, je), qe == null || qe.removeEventListener("mouseup", me.onPanningStop, je), Ue == null || Ue.removeEventListener("mouseleave", me.clearPanning, je), qe == null || qe.removeEventListener("keyup", me.setKeyUnPressed, je), qe == null || qe.removeEventListener("keydown", me.setKeyPressed, je), document.removeEventListener("mouseleave", me.clearPanning, je), handleCancelAnimation(me), (Re = me.observer) === null || Re === void 0 || Re.disconnect();
      }, this.handleInitializeWrapperEvents = function(we) {
        var Re = makePassiveEventOption();
        we.addEventListener("wheel", me.onWheelZoom, Re), we.addEventListener("dblclick", me.onDoubleClick, Re), we.addEventListener("touchstart", me.onTouchPanningStart, Re), we.addEventListener("touchmove", me.onTouchPanning, Re), we.addEventListener("touchend", me.onTouchPanningStop, Re);
      }, this.handleInitialize = function(we, Re) {
        var je = !1, Ue = me.setup.centerOnInit, qe = function(Ge, Xe) {
          for (var ot = 0, vt = Ge; ot < vt.length; ot++) {
            var bt = vt[ot];
            if (bt.target === Xe)
              return !0;
          }
          return !1;
        };
        me.applyTransformation(), me.onInitCallbacks.forEach(function(Ge) {
          Ge(getContext(me));
        }), me.observer = new ResizeObserver(function(Ge) {
          if (qe(Ge, we) || qe(Ge, Re))
            if (Ue && !je) {
              var Xe = Re.offsetWidth, ot = Re.offsetHeight;
              (Xe > 0 || ot > 0) && (je = !0, me.setCenter());
            } else
              handleCancelAnimation(me), handleCalculateBounds(me, me.transformState.scale), handleAlignToBounds(me, 0);
        }), me.observer.observe(we), me.observer.observe(Re);
      }, this.onWheelZoom = function(we) {
        var Re = me.setup.disabled;
        if (!Re) {
          var je = isWheelAllowed(me, we);
          if (je) {
            var Ue = me.isPressingKeys(me.setup.wheel.activationKeys);
            Ue && (handleWheelStart(me, we), handleWheelZoom(me, we), handleWheelStop(me, we));
          }
        }
      }, this.onWheelPanning = function(we) {
        var Re = me.setup, je = Re.disabled, Ue = Re.wheel, qe = Re.panning;
        if (!(!me.wrapperComponent || !me.contentComponent || je || !Ue.wheelDisabled || qe.disabled || !qe.wheelPanning || we.ctrlKey)) {
          we.preventDefault(), we.stopPropagation();
          var Ge = me.transformState, Xe = Ge.positionX, ot = Ge.positionY, vt = Xe - we.deltaX, bt = ot - we.deltaY, Tt = qe.lockAxisX ? Xe : vt, wt = qe.lockAxisY ? ot : bt, St = me.setup.alignmentAnimation, It = St.sizeX, Pt = St.sizeY, kt = getPaddingValue(me, It), Ot = getPaddingValue(me, Pt);
          Tt === Xe && wt === ot || handleNewPosition(me, Tt, wt, kt, Ot);
        }
      }, this.onPanningStart = function(we) {
        var Re = me.setup.disabled, je = me.props.onPanningStart;
        if (!Re) {
          var Ue = isPanningStartAllowed(me, we);
          if (Ue) {
            var qe = me.isPressingKeys(me.setup.panning.activationKeys);
            qe && (we.button === 0 && !me.setup.panning.allowLeftClickPan || we.button === 1 && !me.setup.panning.allowMiddleClickPan || we.button === 2 && !me.setup.panning.allowRightClickPan || (we.preventDefault(), we.stopPropagation(), handleCancelAnimation(me), handlePanningStart(me, we), handleCallback(getContext(me), we, je)));
          }
        }
      }, this.onPanning = function(we) {
        var Re = me.setup.disabled, je = me.props.onPanning;
        if (!Re) {
          var Ue = isPanningAllowed(me);
          if (Ue) {
            var qe = me.isPressingKeys(me.setup.panning.activationKeys);
            qe && (we.preventDefault(), we.stopPropagation(), handlePanning(me, we.clientX, we.clientY), handleCallback(getContext(me), we, je));
          }
        }
      }, this.onPanningStop = function(we) {
        var Re = me.props.onPanningStop;
        me.isPanning && (handlePanningEnd(me), handleCallback(getContext(me), we, Re));
      }, this.onPinchStart = function(we) {
        var Re = me.setup.disabled, je = me.props, Ue = je.onPinchingStart, qe = je.onZoomStart;
        if (!Re) {
          var Ge = isPinchStartAllowed(me, we);
          Ge && (handlePinchStart(me, we), handleCancelAnimation(me), handleCallback(getContext(me), we, Ue), handleCallback(getContext(me), we, qe));
        }
      }, this.onPinch = function(we) {
        var Re = me.setup.disabled, je = me.props, Ue = je.onPinching, qe = je.onZoom;
        if (!Re) {
          var Ge = isPinchAllowed(me);
          Ge && (we.preventDefault(), we.stopPropagation(), handlePinchZoom(me, we), handleCallback(getContext(me), we, Ue), handleCallback(getContext(me), we, qe));
        }
      }, this.onPinchStop = function(we) {
        var Re = me.props, je = Re.onPinchingStop, Ue = Re.onZoomStop;
        me.pinchStartScale && (handlePinchStop(me), handleCallback(getContext(me), we, je), handleCallback(getContext(me), we, Ue));
      }, this.onTouchPanningStart = function(we) {
        var Re = me.setup.disabled, je = me.props.onPanningStart;
        if (!Re) {
          var Ue = isPanningStartAllowed(me, we);
          if (Ue) {
            var qe = me.lastTouch && +/* @__PURE__ */ new Date() - me.lastTouch < 200 && we.touches.length === 1;
            if (!qe) {
              me.lastTouch = +/* @__PURE__ */ new Date(), handleCancelAnimation(me);
              var Ge = we.touches, Xe = Ge.length === 1, ot = Ge.length === 2;
              Xe && (handleCancelAnimation(me), handlePanningStart(me, we), handleCallback(getContext(me), we, je)), ot && me.onPinchStart(we);
            }
          }
        }
      }, this.onTouchPanning = function(we) {
        var Re = me.setup.disabled, je = me.props.onPanning;
        if (me.isPanning && we.touches.length === 1) {
          if (Re)
            return;
          var Ue = isPanningAllowed(me);
          if (!Ue)
            return;
          we.preventDefault(), we.stopPropagation();
          var qe = we.touches[0];
          handlePanning(me, qe.clientX, qe.clientY), handleCallback(getContext(me), we, je);
        } else we.touches.length > 1 && me.onPinch(we);
      }, this.onTouchPanningStop = function(we) {
        me.onPanningStop(we), me.onPinchStop(we);
      }, this.onDoubleClick = function(we) {
        var Re = me.setup.disabled;
        if (!Re) {
          var je = isDoubleClickAllowed(me, we);
          je && handleDoubleClick(me, we);
        }
      }, this.clearPanning = function(we) {
        me.isPanning && me.onPanningStop(we);
      }, this.setKeyPressed = function(we) {
        me.pressedKeys[we.key] = !0;
      }, this.setKeyUnPressed = function(we) {
        me.pressedKeys[we.key] = !1;
      }, this.isPressingKeys = function(we) {
        return we.length ? !!we.find(function(Re) {
          return me.pressedKeys[Re];
        }) : !0;
      }, this.setTransformState = function(we, Re, je) {
        var Ue = me.props.onTransformed;
        if (!Number.isNaN(we) && !Number.isNaN(Re) && !Number.isNaN(je)) {
          we !== me.transformState.scale && (me.transformState.previousScale = me.transformState.scale, me.transformState.scale = we), me.transformState.positionX = Re, me.transformState.positionY = je, me.applyTransformation();
          var qe = getContext(me);
          me.onChangeCallbacks.forEach(function(Ge) {
            return Ge(qe);
          }), handleCallback(qe, { scale: we, positionX: Re, positionY: je }, Ue);
        } else
          console.error("Detected NaN set state values");
      }, this.setCenter = function() {
        if (me.wrapperComponent && me.contentComponent) {
          var we = getCenterPosition(me.transformState.scale, me.wrapperComponent, me.contentComponent);
          me.setTransformState(we.scale, we.positionX, we.positionY);
        }
      }, this.handleTransformStyles = function(we, Re, je) {
        return me.props.customTransform ? me.props.customTransform(we, Re, je) : getTransformStyles(we, Re, je);
      }, this.applyTransformation = function() {
        if (!(!me.mounted || !me.contentComponent)) {
          var we = me.transformState, Re = we.scale, je = we.positionX, Ue = we.positionY, qe = me.handleTransformStyles(je, Ue, Re);
          me.contentComponent.style.transform = qe;
        }
      }, this.getContext = function() {
        return getContext(me);
      }, this.onChange = function(we) {
        return me.onChangeCallbacks.has(we) || me.onChangeCallbacks.add(we), function() {
          me.onChangeCallbacks.delete(we);
        };
      }, this.onInit = function(we) {
        return me.onInitCallbacks.has(we) || me.onInitCallbacks.add(we), function() {
          me.onInitCallbacks.delete(we);
        };
      }, this.init = function(we, Re) {
        me.cleanupWindowEvents(), me.wrapperComponent = we, me.contentComponent = Re, handleCalculateBounds(me, me.transformState.scale), me.handleInitializeWrapperEvents(we), me.handleInitialize(we, Re), me.initializeWindowEvents(), me.isInitialized = !0;
        var je = getContext(me);
        handleCallback(je, void 0, me.props.onInit);
      }, this.props = ie, this.setup = createSetup(this.props), this.transformState = createState(this.props);
    }
    return ce;
  }()
), Context = React__default.createContext(null), getContent = function(ce, ie) {
  return typeof ce == "function" ? ce(ie) : ce;
}, TransformWrapper = React__default.forwardRef(function(ce, ie) {
  var me = useRef(new ZoomPanPinch(ce)).current, we = getContent(ce.children, getControls(me));
  return useImperativeHandle(ie, function() {
    return getControls(me);
  }, [me]), useEffect(function() {
    me.update(ce);
  }, [me, ce]), React__default.createElement(Context.Provider, { value: me }, we);
});
React__default.forwardRef(function(ce, ie) {
  var me = useRef(null), we = useContext(Context);
  return useEffect(function() {
    return we.onChange(function(Re) {
      if (me.current) {
        var je = 0, Ue = 0;
        me.current.style.transform = we.handleTransformStyles(je, Ue, 1 / Re.instance.transformState.scale);
      }
    });
  }, [we]), React__default.createElement("div", __assign$2({}, ce, { ref: mergeRefs([me, ie]) }));
});
function styleInject(ce, ie) {
  ie === void 0 && (ie = {});
  var me = ie.insertAt;
  if (!(typeof document > "u")) {
    var we = document.head || document.getElementsByTagName("head")[0], Re = document.createElement("style");
    Re.type = "text/css", me === "top" && we.firstChild ? we.insertBefore(Re, we.firstChild) : we.appendChild(Re), Re.styleSheet ? Re.styleSheet.cssText = ce : Re.appendChild(document.createTextNode(ce));
  }
}
var css_248z = `.transform-component-module_wrapper__SPB86 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
  transform: translate3d(0, 0, 0);
}
.transform-component-module_content__FBWxo {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}
.transform-component-module_content__FBWxo img {
  pointer-events: none;
}
`, styles = { wrapper: "transform-component-module_wrapper__SPB86", content: "transform-component-module_content__FBWxo" };
styleInject(css_248z);
var TransformComponent = function(ce) {
  var ie = ce.children, me = ce.wrapperClass, we = me === void 0 ? "" : me, Re = ce.contentClass, je = Re === void 0 ? "" : Re, Ue = ce.wrapperStyle, qe = ce.contentStyle, Ge = ce.wrapperProps, Xe = Ge === void 0 ? {} : Ge, ot = ce.contentProps, vt = ot === void 0 ? {} : ot, bt = useContext(Context), Tt = bt.init, wt = bt.cleanupWindowEvents, St = useRef(null), It = useRef(null);
  return useEffect(function() {
    var Pt = St.current, kt = It.current;
    return Pt !== null && kt !== null && Tt && (Tt == null || Tt(Pt, kt)), function() {
      wt == null || wt();
    };
  }, []), React__default.createElement(
    "div",
    __assign$2({}, Xe, { ref: St, className: "".concat(baseClasses.wrapperClass, " ").concat(styles.wrapper, " ").concat(we), style: Ue }),
    React__default.createElement("div", __assign$2({}, vt, { ref: It, className: "".concat(baseClasses.contentClass, " ").concat(styles.content, " ").concat(je), style: qe }), ie)
  );
}, faLineHeight = {
  prefix: "far",
  iconName: "line-height",
  icon: [576, 512, [], "f871", "M113.8 39.9c-4.6-5.1-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-72 80c-8.9 9.9-8.1 25 1.8 33.9s25 8.1 33.9-1.8L72 118.5V393.5L41.8 359.9c-8.9-9.9-24-10.7-33.9-1.8s-10.7 24-1.8 33.9l72 80c4.6 5.1 11 7.9 17.8 7.9s13.3-2.9 17.8-7.9l72-80c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L120 393.5V118.5l30.2 33.5c8.9 9.9 24 10.7 33.9 1.8s10.7-24 1.8-33.9l-72-80zM248 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zM224 416c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24z"]
}, faTextSize = {
  prefix: "far",
  iconName: "text-size",
  icon: [640, 512, [], "f894", "M48 128V80H168l0 352H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H216l0-352H336v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296V272h96l0 160H424c-13.3 0-24 10.7-24 24s10.7 24 24 24H536c13.3 0 24-10.7 24-24s-10.7-24-24-24H504l0-160h88v24c0 13.3 10.7 24 24 24s24-10.7 24-24V264c0-22.1-17.9-40-40-40H352c-22.1 0-40 17.9-40 40v32c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
}, faCircleExclamation = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, faExclamationCircle = faCircleExclamation, faArrowDownToLine = {
  prefix: "far",
  iconName: "arrow-down-to-line",
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 267.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 175.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z"]
}, faCircleCheck = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, faCheckCircle = faCircleCheck, faCircle = {
  prefix: "far",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
}, faVolumeHigh = {
  prefix: "far",
  iconName: "volume-high",
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256s-41.5-170.8-106.4-223.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM159.9 201.9L272 102.3V409.7L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.9 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32z"]
}, faVolumeUp = faVolumeHigh, faArrowsToLine = {
  prefix: "far",
  iconName: "arrows-to-line",
  icon: [448, 512, [], "e0a7", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V488c0 13.3 10.7 24 24 24s24-10.7 24-24V401.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"]
}, faCircleInfo = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, faInfoCircle = faCircleInfo, faMinus = {
  prefix: "far",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
}, faClosedCaptioning = {
  prefix: "far",
  iconName: "closed-captioning",
  icon: [576, 512, [], "f20a", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]
}, faHouse = {
  prefix: "far",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM288 55.5L112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V464h48c17.7 0 32-14.3 32-32V204.8L288 55.5zM240 464h96V320H240V464z"]
}, faHome = faHouse, faArrowsFromLine = {
  prefix: "far",
  iconName: "arrows-from-line",
  icon: [448, 512, [], "e0a4", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V168c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V344zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
}, faMagnifyingGlass = {
  prefix: "far",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
}, faChevronDown = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
}, faVolumeXmark = {
  prefix: "far",
  iconName: "volume-xmark",
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M159.9 201.9L272 102.3V409.7L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM425 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55z"]
}, faVolumeMute = faVolumeXmark, faPlus = {
  prefix: "far",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"]
}, faXmark$1 = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, faClose = faXmark$1, faTriangleExclamation = {
  prefix: "far",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
}, faXmark = {
  prefix: "fal",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
}, faTimes = faXmark, faArrowsUpDown = {
  prefix: "fal",
  iconName: "arrows-up-down",
  icon: [320, 512, ["arrows-v"], "f07d", "M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6 .9L144 52.5V457.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"]
}, faArrowsV = faArrowsUpDown;
const ImageWithZoom = ({ children: ce, portalRef: ie }) => {
  const [me, we] = React__default.useState(null), Re = (Xe) => {
    if (Xe.target.nodeName === "IMG") {
      const ot = Xe.target;
      we(ot.src);
    }
  }, je = () => {
    we(null);
  }, Ue = React__default.Children.only(ce), { onClick: qe, className: Ge } = Ue.props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    me && ReactDOM.createPortal(
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "modal-image-preview", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TransformWrapper, { centerOnInit: !0, centerZoomedOut: !0, minScale: 0.5, children: ({ zoomIn: Xe, zoomOut: ot }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-image-preview__overlay", onClick: je }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TransformComponent, { wrapperClass: "modal-image-preview__wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "modal-image-preview__image", src: me, alt: me }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "modal-image-preview__control", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-image-preview__control__button", onClick: () => Xe(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faPlus, fixedWidth: !0 }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-image-preview__control__button", onClick: () => ot(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faMinus, fixedWidth: !0 }) })
          ] })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-image-preview__image-close", onClick: je, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faTimes, fixedWidth: !0 }) })
      ] }),
      ie != null && ie.current ? ie.current : document.body
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", {}),
    React__default.cloneElement(ce, {
      onClick: (Xe) => {
        Re(Xe), qe == null || qe(Xe);
      },
      className: `cursor-zoom-in ${Ge || ""}`
    })
  ] });
}, ImageLoader = ({ width: ce, height: ie, style: me, className: we }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: `0 0 ${ce} ${ie}`, className: classNames("image-loader inline-block", we), style: me, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Loading..." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: ce, height: ie, fill: "url(#linear-gradient)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "linear-gradient", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0%", stopColor: "#000000", stopOpacity: "0.4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("animate", { attributeName: "offset", values: "-2; -2; 1", keyTimes: "0; 0.25; 1", dur: "2s", repeatCount: "indefinite" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "50%", stopColor: "#252525", stopOpacity: "0.4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("animate", { attributeName: "offset", values: "-1; -1; 2", keyTimes: "0; 0.25; 1", dur: "2s", repeatCount: "indefinite" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "100%", stopColor: "#000000", stopOpacity: "0.4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("animate", { attributeName: "offset", values: "0; 0; 3", keyTimes: "0; 0.25; 1", dur: "2s", repeatCount: "indefinite" }) })
  ] }) })
] }), ImageHeightToClassname = {
  extraSmall: "max-h-45",
  small: "max-h-80",
  medium: "max-h-140",
  large: "max-h-225",
  full: "max-h-full"
}, ImageSized = (ce) => {
  const { maxImageHeight: ie, ...me } = ce;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      ...me,
      className: classNames(
        "w-auto h-auto! max-w-full inline-block object-contain",
        me.className,
        ImageHeightToClassname[ie]
      )
    }
  );
}, SmartImage = ({
  src: ce,
  alt: ie,
  maxImageHeight: me = "full",
  loaderStyle: we,
  portalRef: Re,
  enableZoom: je = !0,
  style: Ue,
  className: qe,
  loaderHeight: Ge,
  loaderWidth: Xe
}) => {
  const [ot, vt] = useState(!0), bt = () => {
    vt(!1);
  }, Tt = ot && Ge && Xe, wt = /* @__PURE__ */ jsxRuntimeExports.jsx(
    ImageSized,
    {
      src: ce,
      alt: ie,
      maxImageHeight: me,
      onLoad: bt,
      className: classNames(qe, { "hidden!": Tt }),
      style: Ue
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    Tt && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ImageLoader,
      {
        width: Xe,
        height: Ge,
        style: { ...we },
        className: ImageHeightToClassname[me]
      }
    ),
    je ? /* @__PURE__ */ jsxRuntimeExports.jsx(ImageWithZoom, { portalRef: Re, children: wt }) : wt
  ] });
}, DisplayAsset = (ce) => {
  const ie = useRef(null);
  return ce.type === "video" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(t1, { src: ce.src }) }) : ce.type === "audio" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AudioPlayer, { src: ce.src }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-center", ref: ie, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    SmartImage,
    {
      src: ce.src,
      alt: ce.altTitle,
      maxImageHeight: ce.maxImageHeight ?? "full",
      loaderWidth: ce.loaderWidth,
      loaderHeight: ce.loaderHeight,
      portalRef: ce.imageZoomInnerPortal ? ie : void 0,
      enableZoom: !0
    }
  ) });
}, Divider = ({ type: ce = "dark" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames("w-full h-px shrink-0", {
      "dark:bg-grey-350 light:bg-grey-650": ce === "light",
      "dark:bg-grey-650 light:bg-grey-350 ": ce === "dark"
    })
  }
);
var DockItemStatus = /* @__PURE__ */ ((ce) => (ce.Default = "default", ce.Active = "active", ce.Success = "success", ce.Failed = "failed", ce.InProgress = "in-progress", ce))(DockItemStatus || {});
const BackgroundAndStatusToClassnames = {
  solid: {
    default: "text-text-muted hover:text-text bg-background hover:bg-surface border-stroke",
    active: "text-accent hover:text-accent bg-surface-elevated border-stroke",
    success: "text-green-400 hover:text-green-400 bg-background hover:bg-surface-elevated border-stroke",
    failed: "text-red-500 hover:text-red-500 bg-background hover:bg-surface-elevated border-stroke",
    "in-progress": "text-grey-350 hover:text-grey-350 bg-background hover:bg-surface-elevated border-stroke"
  },
  transparent: {
    default: "text-grey-400 hover:text-grey-200 bg-transparent hover:bg-transparent b-transparent",
    active: "text-accent hover:text-accent bg-transparent hover:bg-transparent b-transparent",
    success: "text-green-400 hover:text-green-400 bg-transparent hover:bg-transparent b-transparent",
    failed: "text-red-500 hover:text-red-500 bg-transparent hover:bg-transparent b-transparent",
    "in-progress": "text-grey-350 hover:text-grey-350 bg-transparent hover:bg-transparent b-transparent"
  }
}, DockItem = ({
  background: ce = "solid",
  status: ie = "default",
  ...me
}) => {
  const we = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      onClick: me.disabled ? void 0 : me.onClick,
      className: classNames(
        "flex flex-col justify-center items-center w-10 h-10 border-b-1 border-solid first:border-t-1 transition-all",
        !me.disabled && BackgroundAndStatusToClassnames[ce][ie],
        me.onClick === void 0 || me.disabled ? "cursor-default" : "cursor-pointer",
        {
          "bg-background text-text-muted border-stroke": me.disabled
        }
      ),
      children: me.children
    }
  );
  return me.tooltip ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { bodyText: me.tooltip, hideArrow: !0, dontWrapWithSpan: !0, mouseEnterDelay: 0.6, children: we() }) : we();
}, DockNavItem = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  DockItem,
  {
    status: ce.active ? DockItemStatus.Active : void 0,
    background: ce.background,
    onClick: ce.onClick,
    disabled: ce.disabled,
    tooltip: ce.tooltip,
    children: ce.children
  }
), DockItems = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col", children: ce.children }), DockStatusItem = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  DockItem,
  {
    onClick: ce.onClick,
    status: ce.status,
    background: ce.background,
    disabled: ce.disabled,
    tooltip: ce.tooltip,
    children: ce.children
  }
), Dock = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col w-fit justify-between bg-background h-100dvh border-r-1 border-solid border-stroke", children: ce.children });
Dock.Items = DockItems;
Dock.Item = DockItem;
Dock.NavItem = DockNavItem;
Dock.StatusItem = DockStatusItem;
const InactiveColorToClassname = {
  dark: "dropdown-toggle--dark",
  transparent: ""
}, DropdownToggle = ({
  disabled: ce,
  toggledOn: ie,
  onClick: me,
  inactiveColor: we = "transparent",
  transparentBackground: Re
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    onClick: ce ? void 0 : (je) => {
      je.stopPropagation(), me();
    },
    className: classNames(
      "dropdown-toggle",
      InactiveColorToClassname[we],
      { "dropdown-toggle--active": ie },
      { "dropdown-toggle--disabled": ce },
      { "dropdown-toggle--transparent": Re }
    ),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faEllipsisH, fixedWidth: !0 })
  }
) }), ExternalLinkWrapper = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { target: "_blank", rel: "noreferrer noopener", href: ce.href, className: "external-link-wrapper", children: ce.children }), FluidGrid = ({ gridItemWidth: ce, gridRowGap: ie, gridColumnGap: me, children: we }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: "grid w-full",
    style: {
      gridTemplateColumns: `repeat(auto-fit, ${ce}px)`,
      gridRowGap: ie,
      gridColumnGap: me
    },
    children: we.map((Re, je) => /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: Re }, je))
  }
), Grid = ({ columns: ce, children: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-[20px] w-full", style: { gridTemplateColumns: `repeat(${ce}, 1fr)` }, children: ie.map((me, we) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-5", children: me }, we)) }), IconButton = ({ icon: ce, onClick: ie, disabled: me = !1 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    className: classNames("p-2 focus:outline-none hover:opacity-80 transition-opacity-150", {
      "opacity-70 cursor-not-allowed": me,
      "cursor-pointer": !!ie && !me
    }),
    onClick: ie,
    disabled: me,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ce, fixedWidth: !0 })
  }
), LoaderThreeDots = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loader-three-dots" }), MaxWidthToClassName = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg"
}, Modal = ({ children: ce, maxWidth: ie = "lg" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames(
      "w-full rounded-lg bg-background border-stroke border px-8 pt-6 pb-8 flex flex-col gap-5",
      MaxWidthToClassName[ie]
    ),
    children: ce
  }
);
var RoundButtonColor = /* @__PURE__ */ ((ce) => (ce.Default = "Default", ce.Green = "Green", ce.Yellow = "Yellow", ce.YellowIcon = "YellowIcon", ce))(RoundButtonColor || {});
const RoundButton = ({
  content: ce,
  label: ie,
  onClick: me,
  disabled: we,
  big: Re,
  showLabel: je,
  color: Ue = "Default",
  className: qe,
  elementId: Ge,
  displayAutoProgressIndicator: Xe,
  hasBorder: ot
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "button",
  {
    "data-elementid": Ge,
    disabled: we,
    className: classNames(
      "round-button",
      {
        "round-button--green": Ue === "Green",
        "round-button--yellow": Ue === "Yellow",
        "round-button--yellow-icon": Ue === "YellowIcon",
        "round-button--big": Re
      },
      qe
    ),
    onClick: me,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: classNames("relative", {
            "round-button__push-animation-wrapper--animate": Xe
          }),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: classNames(
                  "relative flex w-44px h-44px shrink-0 border-rd-full justify-center items-center bg-background transition-all duration-0.25s ease-out  font-normal",
                  "hover:opacity-80 hover:dark:shadow-md hover:light:shadow-xs",
                  "active:opacity-100 active:dark:shadow-none active:light:shadow-none active:translate-y-2px",
                  {
                    "bg-background text-text border border-stroke": Ue === "Default",
                    "bg-green-500 text-white": Ue === "Green",
                    "bg-yellow-500 text-white": Ue === "Yellow",
                    "bg-background text-yellow-500 border border-stroke": Ue === "YellowIcon",
                    "m-0 w-64px h-64px text-6": Re,
                    "mt-10px mb-10px ml-6px mr-6px text-5": !Re,
                    "border-1 border-grey-650": ot,
                    "opacity-50": we,
                    "round-button__button--with-auto-progress-indicator": Xe
                  }
                ),
                children: ce.type === "icon" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  FontAwesomeIcon,
                  {
                    icon: ce.icon,
                    fill: "black",
                    className: "w-full",
                    size: ce.smallIcon ? "xs" : void 0
                  }
                ) : ce.children
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: classNames("absolute bg-background rounded-full z--1", {
                  "h-64px w-64px inset-0": Re,
                  "h-44px w-44px top-10px left-6px": !Re
                })
              }
            ),
            Xe && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "round-button__auto-progress-indicator", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "round-button__auto-progress-indicator-bar round-button__auto-progress-indicator-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "round-button__auto-progress-indicator-progress" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "round-button__auto-progress-indicator-bar round-button__auto-progress-indicator-right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "round-button__auto-progress-indicator-progress" }) })
            ] })
          ]
        }
      ),
      je && ie && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "round-button__label", children: ie })
    ]
  }
), NavigationButton = ({
  label: ce,
  icon: ie,
  onClick: me,
  disabled: we,
  finish: Re,
  big: je,
  smallIcon: Ue,
  showLabel: qe,
  elementId: Ge,
  displayAutoProgressIndicator: Xe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RoundButton,
  {
    content: { type: "icon", icon: ie, smallIcon: Ue },
    label: ce,
    onClick: me,
    disabled: we,
    color: Re ? RoundButtonColor.Green : RoundButtonColor.Default,
    big: je,
    showLabel: qe,
    elementId: Ge,
    displayAutoProgressIndicator: Xe
  }
), ButtonWrapper = ({ children: ce, justifyEnd: ie, hasLabels: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames("navigation-bar__buttons-wrapper", {
      "navigation-bar__buttons-wrapper--justify-end": ie,
      "navigation-bar__buttons-wrapper--has-labels": me
    }),
    children: ce
  }
), NavigationBarTypeToClassname = {
  StudentFull: "fixed w-full pl-90px pr-48px",
  ManagerFull: "fixed w-full-minus-dock left-dock pl-90px pr-48px",
  StudentSmall: "absolute w-full px-20px",
  ManagerSmall: "absolute w-full px-20px"
}, NavigationBarInternal$2 = forwardRef(
  ({ className: ce, type: ie, children: me }, we) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: we,
      className: classNames(
        "bottom-0 right-0 left-0 h-navigation-bar bg-background grid auto-cols-[1fr] grid-flow-col grid-rows-[100%] z-598 border-t-1 border-stroke border-solid",
        NavigationBarTypeToClassname[ie],
        ce
      ),
      children: me
    }
  )
), NavigationBar = {
  ...NavigationBarInternal$2,
  ButtonBox: ButtonWrapper,
  Button: NavigationButton
}, OptionsMenuDivider = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "options-menu-item-divider" }), NotImplementedException = (ce) => new Error(`Not implemented exception: ${ce}`), OptionsMenuContext = React__default.createContext({
  closeOptionsMenu: () => NotImplementedException("")
}), useOptionsMenuContext = () => React__default.useContext(OptionsMenuContext);
var OptionsMenuItemFontColor = /* @__PURE__ */ ((ce) => (ce.Default = "Default", ce.Danger = "Danger", ce.Faded = "Faded", ce.Action = "Action", ce))(OptionsMenuItemFontColor || {});
const OptionsMenuItem = ({
  children: ce,
  selected: ie,
  smallSpacing: me,
  largeFontSize: we,
  fontColor: Re = "Default",
  closeMenuOnClick: je,
  onClick: Ue
}) => {
  const { closeOptionsMenu: qe } = useOptionsMenuContext(), Ge = Ue === void 0, Xe = () => {
    Ue && Ue(), je && qe();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(
        "options-menu-item",
        { "options-menu-item--selected": ie },
        { "options-menu-item--not-selectable": Ge },
        { "options-menu-item--small-spacing": me }
      ),
      onClick: (ot) => {
        ot.preventDefault(), ot.stopPropagation(), Xe();
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: classNames(
            "options-menu-item__text",
            { "options-menu-item__text--large": we },
            {
              "options-menu-item__text--danger": Re === "Danger"
              /* Danger */
            },
            {
              "options-menu-item__text--faded": Re === "Faded"
              /* Faded */
            },
            {
              "options-menu-item__text--action": Re === "Action"
              /* Action */
            }
          ),
          children: ce
        }
      )
    }
  );
}, Panel = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames(
      "flex w-64 flex-col bg-background gap-3 border-x border-stroke border-solid overflow-auto",
      {
        "h-full p-b-6": ce.height === "full",
        "h-fit": ce.height === "fit"
      }
    ),
    children: ce.children
  }
), Popover$1 = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-64 flex-col gap-4 p-0 pb-6 bg-background rounded border border-stroke border-solid", children: ce.children }), Row = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-row w-full min-h-8 shrink-0 gap-2 px-4 items-center text-xs text-grey-350", children: ce.children }), SettingsMenuItem = ({ title: ce, description: ie, ActionComponent: me }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col justify-between sm:flex-row items-center gap-2", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pb-5 sm:pb-0 flex-col gap-1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { block: !0, size: "s", weight: "semibold", children: ce }),
    ie && /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { block: !0, size: "s", color: "grey-500", invertInLightTheme: !0, children: ie })
  ] }),
  me
] }), SettingsTable = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounded-lg border-stroke border", children: ce == null ? void 0 : ce.map((ie, me) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-4 border-b border-stroke  last:border-b-0", children: ie }, me)) }), Slide = (ce) => {
  const { children: ie, className: me } = ce;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("text-text bg-surface border-rd-2 p-8", me), ...ce, children: ie });
}, StudentButton = ({ children: ce, disabled: ie, onClick: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    disabled: ie,
    onClick: ie ? void 0 : () => me(),
    className: classNames(
      "rounded-10 pt-3.5 px-9 py-3.5 text-center text-s font-semibold uppercase transition-all whitespace-nowrap",
      "bg-white text-black hover:bg-grey-300 active:bg-grey-400 active:translate-y-0.2 disabled:opacity-30 disabled:hover:bg-white disabled:active:translate-y-none",
      "light:border light:border-stroke"
    ),
    children: ce
  }
), TabSelectorItem = ({ content: ce, active: ie, onClick: me }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: classNames(
      "flex flex-1 gap-2 w-full items-center px-3 py-2 text-xs transition-all text-text cursor-pointer rounded-1 transition-333 whitespace-nowrap border-solid border-1",
      ie ? "bg-background border-stroke" : "border-transparent",
      "group-[.flex-col]:justify-start",
      // Adjust layout based on parent group
      "group-[.flex-row]:justify-center"
      // Default layout
    ),
    onClick: me,
    children: [
      ce.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ce.icon, fixedWidth: !0 }),
      ce.label && ce.label
    ]
  }
), TextArea = ({
  value: ce,
  disabled: ie,
  placeholder: me,
  autoFocus: we,
  fullWidth: Re,
  className: je,
  onChange: Ue,
  onBlur: qe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "textarea",
  {
    value: ce,
    onChange: (Ge) => {
      ie || Ue(Ge.currentTarget.value);
    },
    placeholder: me,
    disabled: ie,
    autoFocus: we,
    onBlur: qe,
    className: classNames(
      "bg-surface rounded-1 border-solid border-stroke border gap-2.5 h-full min-h-32 overflow-auto text-text p-2.5 text-xs outline-none placeholder:text-grey-500",
      "hover:border-grey-600",
      "focus:bg-surface-elevated focus:border-accent focus:hover:bg-surface-elevated active:hover:bg-surface-elevated",
      "disabled:text-grey-600 disabled:pointer-events-none",
      "resize-none",
      { "w-full": Re },
      je
    )
  }
), TextInput = ({
  value: ce,
  icon: ie,
  disabled: me,
  placeholder: we,
  autoFocus: Re,
  fullWidth: je,
  maxLength: Ue,
  onChange: qe,
  onBlur: Ge
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames("relative flex flex-row items-center", { "w-full": je }), children: [
  ie && /* @__PURE__ */ jsxRuntimeExports.jsx(
    FontAwesomeIcon,
    {
      icon: ie,
      fixedWidth: !0,
      className: classNames("text-text text-xs absolute left-2 z-2 pointer-events-none", {
        "text-text-muted": me
      })
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      type: "text",
      value: ce,
      onChange: (Xe) => {
        me || qe(Xe.currentTarget.value);
      },
      placeholder: we,
      disabled: me,
      autoFocus: Re,
      maxLength: Ue,
      onBlur: Ge,
      className: classNames(
        "bg-surface rounded-2 border-solid border-stroke border flex flex-row gap-2.5 items-start justify-start shrink-0 w-full relative text-text p-2.5 text-xs outline-none placeholder:text-grey-500",
        "hover:border-grey-500",
        "focus:bg-surface-elevated focus:border-accent focus:hover:bg-surface-elevated active:hover:bg-surface-elevated",
        "disabled:text-text-muted disabled:pointer-events-none",
        { "pl-8": !!ie }
      )
    }
  )
] });
var component = {}, check = {};
Object.defineProperty(check, "__esModule", {
  value: !0
});
var _react$7 = React__default, _react2$2 = _interopRequireDefault$7(_react$7);
function _interopRequireDefault$7(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
check.default = function() {
  return _react2$2.default.createElement(
    "svg",
    { width: "14", height: "11", viewBox: "0 0 14 11" },
    _react2$2.default.createElement("path", { d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0", fill: "#fff", fillRule: "evenodd" })
  );
};
var x$1 = {};
Object.defineProperty(x$1, "__esModule", {
  value: !0
});
var _react$6 = React__default, _react2$1 = _interopRequireDefault$6(_react$6);
function _interopRequireDefault$6(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
x$1.default = function() {
  return _react2$1.default.createElement(
    "svg",
    { width: "10", height: "10", viewBox: "0 0 10 10" },
    _react2$1.default.createElement("path", { d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12", fill: "#fff", fillRule: "evenodd" })
  );
};
var util$1 = {};
Object.defineProperty(util$1, "__esModule", {
  value: !0
});
util$1.pointerCoord = pointerCoord;
function pointerCoord(ce) {
  if (ce) {
    var ie = ce.changedTouches;
    if (ie && ie.length > 0) {
      var me = ie[0];
      return { x: me.clientX, y: me.clientY };
    }
    var we = ce.pageX;
    if (we !== void 0)
      return { x: we, y: ce.pageY };
  }
  return { x: 0, y: 0 };
}
Object.defineProperty(component, "__esModule", {
  value: !0
});
var _extends$3 = Object.assign || function(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie];
    for (var we in me)
      Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
  }
  return ce;
}, _createClass$i = /* @__PURE__ */ function() {
  function ce(ie, me) {
    for (var we = 0; we < me.length; we++) {
      var Re = me[we];
      Re.enumerable = Re.enumerable || !1, Re.configurable = !0, "value" in Re && (Re.writable = !0), Object.defineProperty(ie, Re.key, Re);
    }
  }
  return function(ie, me, we) {
    return me && ce(ie.prototype, me), we && ce(ie, we), ie;
  };
}(), _react$5 = React__default, _react2 = _interopRequireDefault$5(_react$5), _classnames$4 = classnamesExports, _classnames2 = _interopRequireDefault$5(_classnames$4), _propTypes = propTypesExports, _propTypes2 = _interopRequireDefault$5(_propTypes), _check = check, _check2 = _interopRequireDefault$5(_check), _x = x$1, _x2 = _interopRequireDefault$5(_x), _util = util$1;
function _interopRequireDefault$5(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _objectWithoutProperties$3(ce, ie) {
  var me = {};
  for (var we in ce)
    ie.indexOf(we) >= 0 || Object.prototype.hasOwnProperty.call(ce, we) && (me[we] = ce[we]);
  return me;
}
function _classCallCheck$i(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$4(ce, ie) {
  if (!ce)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ie && (typeof ie == "object" || typeof ie == "function") ? ie : ce;
}
function _inherits$4(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof ie);
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, enumerable: !1, writable: !0, configurable: !0 } }), ie && (Object.setPrototypeOf ? Object.setPrototypeOf(ce, ie) : ce.__proto__ = ie);
}
var Toggle$1 = function(ce) {
  _inherits$4(ie, ce);
  function ie(me) {
    _classCallCheck$i(this, ie);
    var we = _possibleConstructorReturn$4(this, (ie.__proto__ || Object.getPrototypeOf(ie)).call(this, me));
    return we.handleClick = we.handleClick.bind(we), we.handleTouchStart = we.handleTouchStart.bind(we), we.handleTouchMove = we.handleTouchMove.bind(we), we.handleTouchEnd = we.handleTouchEnd.bind(we), we.handleFocus = we.handleFocus.bind(we), we.handleBlur = we.handleBlur.bind(we), we.previouslyChecked = !!(me.checked || me.defaultChecked), we.state = {
      checked: !!(me.checked || me.defaultChecked),
      hasFocus: !1
    }, we;
  }
  return _createClass$i(ie, [{
    key: "componentDidUpdate",
    value: function(we) {
      we.checked !== this.props.checked && this.setState({ checked: !!this.props.checked });
    }
  }, {
    key: "handleClick",
    value: function(we) {
      if (!this.props.disabled) {
        var Re = this.input;
        if (we.target !== Re && !this.moved) {
          this.previouslyChecked = Re.checked, we.preventDefault(), Re.focus(), Re.click();
          return;
        }
        var je = this.props.hasOwnProperty("checked") ? this.props.checked : Re.checked;
        this.setState({ checked: je });
      }
    }
  }, {
    key: "handleTouchStart",
    value: function(we) {
      this.props.disabled || (this.startX = (0, _util.pointerCoord)(we).x, this.activated = !0);
    }
  }, {
    key: "handleTouchMove",
    value: function(we) {
      if (this.activated && (this.moved = !0, this.startX)) {
        var Re = (0, _util.pointerCoord)(we).x;
        this.state.checked && Re + 15 < this.startX ? (this.setState({ checked: !1 }), this.startX = Re, this.activated = !0) : Re - 15 > this.startX && (this.setState({ checked: !0 }), this.startX = Re, this.activated = Re < this.startX + 5);
      }
    }
  }, {
    key: "handleTouchEnd",
    value: function(we) {
      if (this.moved) {
        var Re = this.input;
        if (we.preventDefault(), this.startX) {
          var je = (0, _util.pointerCoord)(we).x;
          this.previouslyChecked === !0 && this.startX + 4 > je ? this.previouslyChecked !== this.state.checked && (this.setState({ checked: !1 }), this.previouslyChecked = this.state.checked, Re.click()) : this.startX - 4 < je && this.previouslyChecked !== this.state.checked && (this.setState({ checked: !0 }), this.previouslyChecked = this.state.checked, Re.click()), this.activated = !1, this.startX = null, this.moved = !1;
        }
      }
    }
  }, {
    key: "handleFocus",
    value: function(we) {
      var Re = this.props.onFocus;
      Re && Re(we), this.setState({ hasFocus: !0 });
    }
  }, {
    key: "handleBlur",
    value: function(we) {
      var Re = this.props.onBlur;
      Re && Re(we), this.setState({ hasFocus: !1 });
    }
  }, {
    key: "getIcon",
    value: function(we) {
      var Re = this.props.icons;
      return Re ? Re[we] === void 0 ? ie.defaultProps.icons[we] : Re[we] : null;
    }
  }, {
    key: "render",
    value: function() {
      var we = this, Re = this.props, je = Re.className;
      Re.icons;
      var Ue = _objectWithoutProperties$3(Re, ["className", "icons"]), qe = (0, _classnames2.default)("react-toggle", {
        "react-toggle--checked": this.state.checked,
        "react-toggle--focus": this.state.hasFocus,
        "react-toggle--disabled": this.props.disabled
      }, je);
      return _react2.default.createElement(
        "div",
        {
          className: qe,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd
        },
        _react2.default.createElement(
          "div",
          { className: "react-toggle-track" },
          _react2.default.createElement(
            "div",
            { className: "react-toggle-track-check" },
            this.getIcon("checked")
          ),
          _react2.default.createElement(
            "div",
            { className: "react-toggle-track-x" },
            this.getIcon("unchecked")
          )
        ),
        _react2.default.createElement("div", { className: "react-toggle-thumb" }),
        _react2.default.createElement("input", _extends$3({}, Ue, {
          ref: function(Xe) {
            we.input = Xe;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: "react-toggle-screenreader-only",
          type: "checkbox"
        }))
      );
    }
  }]), ie;
}(_react$5.PureComponent), _default = component.default = Toggle$1;
Toggle$1.displayName = "Toggle";
Toggle$1.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};
Toggle$1.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  "aria-labelledby": _propTypes2.default.string,
  "aria-label": _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};
const Toggle = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(_default, { ...ce });
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var ce = React__default;
  function ie(vt, bt) {
    return vt === bt && (vt !== 0 || 1 / vt === 1 / bt) || vt !== vt && bt !== bt;
  }
  var me = typeof Object.is == "function" ? Object.is : ie, we = ce.useState, Re = ce.useEffect, je = ce.useLayoutEffect, Ue = ce.useDebugValue;
  function qe(vt, bt) {
    var Tt = bt(), wt = we({ inst: { value: Tt, getSnapshot: bt } }), St = wt[0].inst, It = wt[1];
    return je(
      function() {
        St.value = Tt, St.getSnapshot = bt, Ge(St) && It({ inst: St });
      },
      [vt, Tt, bt]
    ), Re(
      function() {
        return Ge(St) && It({ inst: St }), vt(function() {
          Ge(St) && It({ inst: St });
        });
      },
      [vt]
    ), Ue(Tt), Tt;
  }
  function Ge(vt) {
    var bt = vt.getSnapshot;
    vt = vt.value;
    try {
      var Tt = bt();
      return !me(vt, Tt);
    } catch {
      return !0;
    }
  }
  function Xe(vt, bt) {
    return bt();
  }
  var ot = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Xe : qe;
  return useSyncExternalStoreShim_production.useSyncExternalStore = ce.useSyncExternalStore !== void 0 ? ce.useSyncExternalStore : ot, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && function() {
    function ce(Tt, wt) {
      return Tt === wt && (Tt !== 0 || 1 / Tt === 1 / wt) || Tt !== Tt && wt !== wt;
    }
    function ie(Tt, wt) {
      ot || Re.startTransition === void 0 || (ot = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var St = wt();
      if (!vt) {
        var It = wt();
        je(St, It) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), vt = !0);
      }
      It = Ue({
        inst: { value: St, getSnapshot: wt }
      });
      var Pt = It[0].inst, kt = It[1];
      return Ge(
        function() {
          Pt.value = St, Pt.getSnapshot = wt, me(Pt) && kt({ inst: Pt });
        },
        [Tt, St, wt]
      ), qe(
        function() {
          return me(Pt) && kt({ inst: Pt }), Tt(function() {
            me(Pt) && kt({ inst: Pt });
          });
        },
        [Tt]
      ), Xe(St), St;
    }
    function me(Tt) {
      var wt = Tt.getSnapshot;
      Tt = Tt.value;
      try {
        var St = wt();
        return !je(Tt, St);
      } catch {
        return !0;
      }
    }
    function we(Tt, wt) {
      return wt();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Re = React__default, je = typeof Object.is == "function" ? Object.is : ce, Ue = Re.useState, qe = Re.useEffect, Ge = Re.useLayoutEffect, Xe = Re.useDebugValue, ot = !1, vt = !1, bt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? we : ie;
    useSyncExternalStoreShim_development.useSyncExternalStore = Re.useSyncExternalStore !== void 0 ? Re.useSyncExternalStore : bt, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), useSyncExternalStoreShim_development;
}
process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development();
var shimExports = shim.exports;
function memoize(ce) {
  var ie = null, me = function() {
    return ie == null && (ie = ce()), ie;
  };
  return me;
}
function without$1(ce, ie) {
  return ce.filter(function(me) {
    return me !== ie;
  });
}
function union(ce, ie) {
  var me = /* @__PURE__ */ new Set(), we = function(Ue) {
    return me.add(Ue);
  };
  ce.forEach(we), ie.forEach(we);
  var Re = [];
  return me.forEach(function(je) {
    return Re.push(je);
  }), Re;
}
function _classCallCheck$h(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$h(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$h(ce, ie, me) {
  return ie && _defineProperties$h(ce.prototype, ie), ce;
}
function _defineProperty$p(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var EnterLeaveCounter = /* @__PURE__ */ function() {
  function ce(ie) {
    _classCallCheck$h(this, ce), _defineProperty$p(this, "entered", []), _defineProperty$p(this, "isNodeInDocument", void 0), this.isNodeInDocument = ie;
  }
  return _createClass$h(ce, [{
    key: "enter",
    value: function(me) {
      var we = this, Re = this.entered.length, je = function(qe) {
        return we.isNodeInDocument(qe) && (!qe.contains || qe.contains(me));
      };
      return this.entered = union(this.entered.filter(je), [me]), Re === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function(me) {
      var we = this.entered.length;
      return this.entered = without$1(this.entered.filter(this.isNodeInDocument), me), we > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function() {
      this.entered = [];
    }
  }]), ce;
}(), isFirefox = memoize(function() {
  return /firefox/i.test(navigator.userAgent);
}), isSafari = memoize(function() {
  return !!window.safari;
});
function _classCallCheck$g(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$g(ce, ie, me) {
  return ie && _defineProperties$g(ce.prototype, ie), ce;
}
function _defineProperty$o(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var MonotonicInterpolant = /* @__PURE__ */ function() {
  function ce(ie, me) {
    _classCallCheck$g(this, ce), _defineProperty$o(this, "xs", void 0), _defineProperty$o(this, "ys", void 0), _defineProperty$o(this, "c1s", void 0), _defineProperty$o(this, "c2s", void 0), _defineProperty$o(this, "c3s", void 0);
    for (var we = ie.length, Re = [], je = 0; je < we; je++)
      Re.push(je);
    Re.sort(function(fn, vn) {
      return ie[fn] < ie[vn] ? -1 : 1;
    });
    for (var Ue = [], qe = [], Ge, Xe, ot = 0; ot < we - 1; ot++)
      Ge = ie[ot + 1] - ie[ot], Xe = me[ot + 1] - me[ot], Ue.push(Ge), qe.push(Xe / Ge);
    for (var vt = [qe[0]], bt = 0; bt < Ue.length - 1; bt++) {
      var Tt = qe[bt], wt = qe[bt + 1];
      if (Tt * wt <= 0)
        vt.push(0);
      else {
        Ge = Ue[bt];
        var St = Ue[bt + 1], It = Ge + St;
        vt.push(3 * It / ((It + St) / Tt + (It + Ge) / wt));
      }
    }
    vt.push(qe[qe.length - 1]);
    for (var Pt = [], kt = [], Ot, Jr = 0; Jr < vt.length - 1; Jr++) {
      Ot = qe[Jr];
      var en = vt[Jr], nn = 1 / Ue[Jr], ln = en + vt[Jr + 1] - Ot - Ot;
      Pt.push((Ot - en - ln) * nn), kt.push(ln * nn * nn);
    }
    this.xs = ie, this.ys = me, this.c1s = vt, this.c2s = Pt, this.c3s = kt;
  }
  return _createClass$g(ce, [{
    key: "interpolate",
    value: function(me) {
      var we = this.xs, Re = this.ys, je = this.c1s, Ue = this.c2s, qe = this.c3s, Ge = we.length - 1;
      if (me === we[Ge])
        return Re[Ge];
      for (var Xe = 0, ot = qe.length - 1, vt; Xe <= ot; ) {
        vt = Math.floor(0.5 * (Xe + ot));
        var bt = we[vt];
        if (bt < me)
          Xe = vt + 1;
        else if (bt > me)
          ot = vt - 1;
        else
          return Re[vt];
      }
      Ge = Math.max(0, ot);
      var Tt = me - we[Ge], wt = Tt * Tt;
      return Re[Ge] + je[Ge] * Tt + Ue[Ge] * wt + qe[Ge] * Tt * wt;
    }
  }]), ce;
}(), ELEMENT_NODE = 1;
function getNodeClientOffset(ce) {
  var ie = ce.nodeType === ELEMENT_NODE ? ce : ce.parentElement;
  if (!ie)
    return null;
  var me = ie.getBoundingClientRect(), we = me.top, Re = me.left;
  return {
    x: Re,
    y: we
  };
}
function getEventClientOffset(ce) {
  return {
    x: ce.clientX,
    y: ce.clientY
  };
}
function isImageNode(ce) {
  var ie;
  return ce.nodeName === "IMG" && (isFirefox() || !((ie = document.documentElement) !== null && ie !== void 0 && ie.contains(ce)));
}
function getDragPreviewSize(ce, ie, me, we) {
  var Re = ce ? ie.width : me, je = ce ? ie.height : we;
  return isSafari() && ce && (je /= window.devicePixelRatio, Re /= window.devicePixelRatio), {
    dragPreviewWidth: Re,
    dragPreviewHeight: je
  };
}
function getDragPreviewOffset(ce, ie, me, we, Re) {
  var je = isImageNode(ie), Ue = je ? ce : ie, qe = getNodeClientOffset(Ue), Ge = {
    x: me.x - qe.x,
    y: me.y - qe.y
  }, Xe = ce.offsetWidth, ot = ce.offsetHeight, vt = we.anchorX, bt = we.anchorY, Tt = getDragPreviewSize(je, ie, Xe, ot), wt = Tt.dragPreviewWidth, St = Tt.dragPreviewHeight, It = function() {
    var ln = new MonotonicInterpolant([0, 0.5, 1], [
      // Dock to the top
      Ge.y,
      // Align at the center
      Ge.y / ot * St,
      // Dock to the bottom
      Ge.y + St - ot
    ]), fn = ln.interpolate(bt);
    return isSafari() && je && (fn += (window.devicePixelRatio - 1) * St), fn;
  }, Pt = function() {
    var ln = new MonotonicInterpolant([0, 0.5, 1], [
      // Dock to the left
      Ge.x,
      // Align at the center
      Ge.x / Xe * wt,
      // Dock to the right
      Ge.x + wt - Xe
    ]);
    return ln.interpolate(vt);
  }, kt = Re.offsetX, Ot = Re.offsetY, Jr = kt === 0 || kt, en = Ot === 0 || Ot;
  return {
    x: Jr ? kt : Pt(),
    y: en ? Ot : It()
  };
}
var FILE = "__NATIVE_FILE__", URL$1 = "__NATIVE_URL__", TEXT = "__NATIVE_TEXT__", HTML = "__NATIVE_HTML__";
const NativeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE,
  HTML,
  TEXT,
  URL: URL$1
}, Symbol.toStringTag, { value: "Module" }));
function getDataFromDataTransfer(ce, ie, me) {
  var we = ie.reduce(function(Re, je) {
    return Re || ce.getData(je);
  }, "");
  return we ?? me;
}
var _nativeTypesConfig;
function _defineProperty$n(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty$n(_nativeTypesConfig, FILE, {
  exposeProperties: {
    files: function(ie) {
      return Array.prototype.slice.call(ie.files);
    },
    items: function(ie) {
      return ie.items;
    },
    dataTransfer: function(ie) {
      return ie;
    }
  },
  matchesTypes: ["Files"]
}), _defineProperty$n(_nativeTypesConfig, HTML, {
  exposeProperties: {
    html: function(ie, me) {
      return getDataFromDataTransfer(ie, me, "");
    },
    dataTransfer: function(ie) {
      return ie;
    }
  },
  matchesTypes: ["Html", "text/html"]
}), _defineProperty$n(_nativeTypesConfig, URL$1, {
  exposeProperties: {
    urls: function(ie, me) {
      return getDataFromDataTransfer(ie, me, "").split(`
`);
    },
    dataTransfer: function(ie) {
      return ie;
    }
  },
  matchesTypes: ["Url", "text/uri-list"]
}), _defineProperty$n(_nativeTypesConfig, TEXT, {
  exposeProperties: {
    text: function(ie, me) {
      return getDataFromDataTransfer(ie, me, "");
    },
    dataTransfer: function(ie) {
      return ie;
    }
  },
  matchesTypes: ["Text", "text/plain"]
}), _nativeTypesConfig);
function _classCallCheck$f(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$f(ce, ie, me) {
  return ie && _defineProperties$f(ce.prototype, ie), ce;
}
function _defineProperty$m(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var NativeDragSource = /* @__PURE__ */ function() {
  function ce(ie) {
    _classCallCheck$f(this, ce), _defineProperty$m(this, "item", void 0), _defineProperty$m(this, "config", void 0), this.config = ie, this.item = {}, this.initializeExposedProperties();
  }
  return _createClass$f(ce, [{
    key: "initializeExposedProperties",
    value: function() {
      var me = this;
      Object.keys(this.config.exposeProperties).forEach(function(we) {
        Object.defineProperty(me.item, we, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return console.warn(`Browser doesn't allow reading "`.concat(we, '" until the drop event.')), null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function(me) {
      var we = this;
      if (me) {
        var Re = {};
        Object.keys(this.config.exposeProperties).forEach(function(je) {
          Re[je] = {
            value: we.config.exposeProperties[je](me, we.config.matchesTypes),
            configurable: !0,
            enumerable: !0
          };
        }), Object.defineProperties(this.item, Re);
      }
    }
  }, {
    key: "canDrag",
    value: function() {
      return !0;
    }
  }, {
    key: "beginDrag",
    value: function() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function(me, we) {
      return we === me.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function() {
    }
  }]), ce;
}();
function createNativeDragSource(ce, ie) {
  var me = new NativeDragSource(nativeTypesConfig[ce]);
  return me.loadDataTransfer(ie), me;
}
function matchNativeItemType(ce) {
  if (!ce)
    return null;
  var ie = Array.prototype.slice.call(ce.types || []);
  return Object.keys(nativeTypesConfig).filter(function(me) {
    var we = nativeTypesConfig[me].matchesTypes;
    return we.some(function(Re) {
      return ie.indexOf(Re) > -1;
    });
  })[0] || null;
}
function _classCallCheck$e(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$e(ce, ie, me) {
  return ie && _defineProperties$e(ce.prototype, ie), ce;
}
function _defineProperty$l(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var OptionsReader = /* @__PURE__ */ function() {
  function ce(ie, me) {
    _classCallCheck$e(this, ce), _defineProperty$l(this, "ownerDocument", null), _defineProperty$l(this, "globalContext", void 0), _defineProperty$l(this, "optionsArgs", void 0), this.globalContext = ie, this.optionsArgs = me;
  }
  return _createClass$e(ce, [{
    key: "window",
    get: function() {
      if (this.globalContext)
        return this.globalContext;
      if (typeof window < "u")
        return window;
    }
  }, {
    key: "document",
    get: function() {
      var me;
      return (me = this.globalContext) !== null && me !== void 0 && me.document ? this.globalContext.document : this.window ? this.window.document : void 0;
    }
  }, {
    key: "rootElement",
    get: function() {
      var me;
      return ((me = this.optionsArgs) === null || me === void 0 ? void 0 : me.rootElement) || this.window;
    }
  }]), ce;
}();
function ownKeys$b(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$9(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$b(Object(me), !0).forEach(function(we) {
      _defineProperty$k(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$b(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _classCallCheck$d(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$d(ce, ie, me) {
  return ie && _defineProperties$d(ce.prototype, ie), ce;
}
function _defineProperty$k(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var HTML5BackendImpl = /* @__PURE__ */ function() {
  function ce(ie, me, we) {
    var Re = this;
    _classCallCheck$d(this, ce), _defineProperty$k(this, "options", void 0), _defineProperty$k(this, "actions", void 0), _defineProperty$k(this, "monitor", void 0), _defineProperty$k(this, "registry", void 0), _defineProperty$k(this, "enterLeaveCounter", void 0), _defineProperty$k(this, "sourcePreviewNodes", /* @__PURE__ */ new Map()), _defineProperty$k(this, "sourcePreviewNodeOptions", /* @__PURE__ */ new Map()), _defineProperty$k(this, "sourceNodes", /* @__PURE__ */ new Map()), _defineProperty$k(this, "sourceNodeOptions", /* @__PURE__ */ new Map()), _defineProperty$k(this, "dragStartSourceIds", null), _defineProperty$k(this, "dropTargetIds", []), _defineProperty$k(this, "dragEnterTargetIds", []), _defineProperty$k(this, "currentNativeSource", null), _defineProperty$k(this, "currentNativeHandle", null), _defineProperty$k(this, "currentDragSourceNode", null), _defineProperty$k(this, "altKeyPressed", !1), _defineProperty$k(this, "mouseMoveTimeoutTimer", null), _defineProperty$k(this, "asyncEndDragFrameId", null), _defineProperty$k(this, "dragOverTargetIds", null), _defineProperty$k(this, "lastClientOffset", null), _defineProperty$k(this, "hoverRafId", null), _defineProperty$k(this, "getSourceClientOffset", function(je) {
      var Ue = Re.sourceNodes.get(je);
      return Ue && getNodeClientOffset(Ue) || null;
    }), _defineProperty$k(this, "endDragNativeItem", function() {
      Re.isDraggingNativeItem() && (Re.actions.endDrag(), Re.currentNativeHandle && Re.registry.removeSource(Re.currentNativeHandle), Re.currentNativeHandle = null, Re.currentNativeSource = null);
    }), _defineProperty$k(this, "isNodeInDocument", function(je) {
      return !!(je && Re.document && Re.document.body && Re.document.body.contains(je));
    }), _defineProperty$k(this, "endDragIfSourceWasRemovedFromDOM", function() {
      var je = Re.currentDragSourceNode;
      je == null || Re.isNodeInDocument(je) || Re.clearCurrentDragSourceNode() && Re.monitor.isDragging() && Re.actions.endDrag();
    }), _defineProperty$k(this, "handleTopDragStartCapture", function() {
      Re.clearCurrentDragSourceNode(), Re.dragStartSourceIds = [];
    }), _defineProperty$k(this, "handleTopDragStart", function(je) {
      if (!je.defaultPrevented) {
        var Ue = Re.dragStartSourceIds;
        Re.dragStartSourceIds = null;
        var qe = getEventClientOffset(je);
        Re.monitor.isDragging() && Re.actions.endDrag(), Re.actions.beginDrag(Ue || [], {
          publishSource: !1,
          getSourceClientOffset: Re.getSourceClientOffset,
          clientOffset: qe
        });
        var Ge = je.dataTransfer, Xe = matchNativeItemType(Ge);
        if (Re.monitor.isDragging()) {
          if (Ge && typeof Ge.setDragImage == "function") {
            var ot = Re.monitor.getSourceId(), vt = Re.sourceNodes.get(ot), bt = Re.sourcePreviewNodes.get(ot) || vt;
            if (bt) {
              var Tt = Re.getCurrentSourcePreviewNodeOptions(), wt = Tt.anchorX, St = Tt.anchorY, It = Tt.offsetX, Pt = Tt.offsetY, kt = {
                anchorX: wt,
                anchorY: St
              }, Ot = {
                offsetX: It,
                offsetY: Pt
              }, Jr = getDragPreviewOffset(vt, bt, qe, kt, Ot);
              Ge.setDragImage(bt, Jr.x, Jr.y);
            }
          }
          try {
            Ge == null || Ge.setData("application/json", {});
          } catch {
          }
          Re.setCurrentDragSourceNode(je.target);
          var en = Re.getCurrentSourcePreviewNodeOptions(), nn = en.captureDraggingState;
          nn ? Re.actions.publishDragSource() : setTimeout(function() {
            return Re.actions.publishDragSource();
          }, 0);
        } else if (Xe)
          Re.beginDragNativeItem(Xe);
        else {
          if (Ge && !Ge.types && (je.target && !je.target.hasAttribute || !je.target.hasAttribute("draggable")))
            return;
          je.preventDefault();
        }
      }
    }), _defineProperty$k(this, "handleTopDragEndCapture", function() {
      Re.clearCurrentDragSourceNode() && Re.monitor.isDragging() && Re.actions.endDrag();
    }), _defineProperty$k(this, "handleTopDragEnterCapture", function(je) {
      Re.dragEnterTargetIds = [];
      var Ue = Re.enterLeaveCounter.enter(je.target);
      if (!(!Ue || Re.monitor.isDragging())) {
        var qe = je.dataTransfer, Ge = matchNativeItemType(qe);
        Ge && Re.beginDragNativeItem(Ge, qe);
      }
    }), _defineProperty$k(this, "handleTopDragEnter", function(je) {
      var Ue = Re.dragEnterTargetIds;
      if (Re.dragEnterTargetIds = [], !!Re.monitor.isDragging()) {
        Re.altKeyPressed = je.altKey, Ue.length > 0 && Re.actions.hover(Ue, {
          clientOffset: getEventClientOffset(je)
        });
        var qe = Ue.some(function(Ge) {
          return Re.monitor.canDropOnTarget(Ge);
        });
        qe && (je.preventDefault(), je.dataTransfer && (je.dataTransfer.dropEffect = Re.getCurrentDropEffect()));
      }
    }), _defineProperty$k(this, "handleTopDragOverCapture", function() {
      Re.dragOverTargetIds = [];
    }), _defineProperty$k(this, "handleTopDragOver", function(je) {
      var Ue = Re.dragOverTargetIds;
      if (Re.dragOverTargetIds = [], !Re.monitor.isDragging()) {
        je.preventDefault(), je.dataTransfer && (je.dataTransfer.dropEffect = "none");
        return;
      }
      Re.altKeyPressed = je.altKey, Re.lastClientOffset = getEventClientOffset(je), Re.hoverRafId === null && typeof requestAnimationFrame < "u" && (Re.hoverRafId = requestAnimationFrame(function() {
        Re.monitor.isDragging() && Re.actions.hover(Ue || [], {
          clientOffset: Re.lastClientOffset
        }), Re.hoverRafId = null;
      }));
      var qe = (Ue || []).some(function(Ge) {
        return Re.monitor.canDropOnTarget(Ge);
      });
      qe ? (je.preventDefault(), je.dataTransfer && (je.dataTransfer.dropEffect = Re.getCurrentDropEffect())) : Re.isDraggingNativeItem() ? je.preventDefault() : (je.preventDefault(), je.dataTransfer && (je.dataTransfer.dropEffect = "none"));
    }), _defineProperty$k(this, "handleTopDragLeaveCapture", function(je) {
      Re.isDraggingNativeItem() && je.preventDefault();
      var Ue = Re.enterLeaveCounter.leave(je.target);
      Ue && Re.isDraggingNativeItem() && setTimeout(function() {
        return Re.endDragNativeItem();
      }, 0);
    }), _defineProperty$k(this, "handleTopDropCapture", function(je) {
      if (Re.dropTargetIds = [], Re.isDraggingNativeItem()) {
        var Ue;
        je.preventDefault(), (Ue = Re.currentNativeSource) === null || Ue === void 0 || Ue.loadDataTransfer(je.dataTransfer);
      } else matchNativeItemType(je.dataTransfer) && je.preventDefault();
      Re.enterLeaveCounter.reset();
    }), _defineProperty$k(this, "handleTopDrop", function(je) {
      var Ue = Re.dropTargetIds;
      Re.dropTargetIds = [], Re.actions.hover(Ue, {
        clientOffset: getEventClientOffset(je)
      }), Re.actions.drop({
        dropEffect: Re.getCurrentDropEffect()
      }), Re.isDraggingNativeItem() ? Re.endDragNativeItem() : Re.monitor.isDragging() && Re.actions.endDrag();
    }), _defineProperty$k(this, "handleSelectStart", function(je) {
      var Ue = je.target;
      typeof Ue.dragDrop == "function" && (Ue.tagName === "INPUT" || Ue.tagName === "SELECT" || Ue.tagName === "TEXTAREA" || Ue.isContentEditable || (je.preventDefault(), Ue.dragDrop()));
    }), this.options = new OptionsReader(me, we), this.actions = ie.getActions(), this.monitor = ie.getMonitor(), this.registry = ie.getRegistry(), this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
  return _createClass$d(ce, [{
    key: "profile",
    value: function() {
      var me, we;
      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodeOptions: this.sourceNodeOptions.size,
        sourceNodes: this.sourceNodes.size,
        dragStartSourceIds: ((me = this.dragStartSourceIds) === null || me === void 0 ? void 0 : me.length) || 0,
        dropTargetIds: this.dropTargetIds.length,
        dragEnterTargetIds: this.dragEnterTargetIds.length,
        dragOverTargetIds: ((we = this.dragOverTargetIds) === null || we === void 0 ? void 0 : we.length) || 0
      };
    }
    // public for test
  }, {
    key: "window",
    get: function() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function() {
      return this.options.document;
    }
    /**
     * Get the root element to use for event subscriptions
     */
  }, {
    key: "rootElement",
    get: function() {
      return this.options.rootElement;
    }
  }, {
    key: "setup",
    value: function() {
      var me = this.rootElement;
      if (me !== void 0) {
        if (me.__isReactDndBackendSetUp)
          throw new Error("Cannot have two HTML5 backends at the same time.");
        me.__isReactDndBackendSetUp = !0, this.addEventListeners(me);
      }
    }
  }, {
    key: "teardown",
    value: function() {
      var me = this.rootElement;
      if (me !== void 0 && (me.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
        var we;
        (we = this.window) === null || we === void 0 || we.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function(me, we, Re) {
      var je = this;
      return this.sourcePreviewNodeOptions.set(me, Re), this.sourcePreviewNodes.set(me, we), function() {
        je.sourcePreviewNodes.delete(me), je.sourcePreviewNodeOptions.delete(me);
      };
    }
  }, {
    key: "connectDragSource",
    value: function(me, we, Re) {
      var je = this;
      this.sourceNodes.set(me, we), this.sourceNodeOptions.set(me, Re);
      var Ue = function(Xe) {
        return je.handleDragStart(Xe, me);
      }, qe = function(Xe) {
        return je.handleSelectStart(Xe);
      };
      return we.setAttribute("draggable", "true"), we.addEventListener("dragstart", Ue), we.addEventListener("selectstart", qe), function() {
        je.sourceNodes.delete(me), je.sourceNodeOptions.delete(me), we.removeEventListener("dragstart", Ue), we.removeEventListener("selectstart", qe), we.setAttribute("draggable", "false");
      };
    }
  }, {
    key: "connectDropTarget",
    value: function(me, we) {
      var Re = this, je = function(Xe) {
        return Re.handleDragEnter(Xe, me);
      }, Ue = function(Xe) {
        return Re.handleDragOver(Xe, me);
      }, qe = function(Xe) {
        return Re.handleDrop(Xe, me);
      };
      return we.addEventListener("dragenter", je), we.addEventListener("dragover", Ue), we.addEventListener("drop", qe), function() {
        we.removeEventListener("dragenter", je), we.removeEventListener("dragover", Ue), we.removeEventListener("drop", qe);
      };
    }
  }, {
    key: "addEventListeners",
    value: function(me) {
      me.addEventListener && (me.addEventListener("dragstart", this.handleTopDragStart), me.addEventListener("dragstart", this.handleTopDragStartCapture, !0), me.addEventListener("dragend", this.handleTopDragEndCapture, !0), me.addEventListener("dragenter", this.handleTopDragEnter), me.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), me.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), me.addEventListener("dragover", this.handleTopDragOver), me.addEventListener("dragover", this.handleTopDragOverCapture, !0), me.addEventListener("drop", this.handleTopDrop), me.addEventListener("drop", this.handleTopDropCapture, !0));
    }
  }, {
    key: "removeEventListeners",
    value: function(me) {
      me.removeEventListener && (me.removeEventListener("dragstart", this.handleTopDragStart), me.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), me.removeEventListener("dragend", this.handleTopDragEndCapture, !0), me.removeEventListener("dragenter", this.handleTopDragEnter), me.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), me.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), me.removeEventListener("dragover", this.handleTopDragOver), me.removeEventListener("dragover", this.handleTopDragOverCapture, !0), me.removeEventListener("drop", this.handleTopDrop), me.removeEventListener("drop", this.handleTopDropCapture, !0));
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function() {
      var me = this.monitor.getSourceId(), we = this.sourceNodeOptions.get(me);
      return _objectSpread$9({
        dropEffect: this.altKeyPressed ? "copy" : "move"
      }, we || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function() {
      return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function() {
      var me = this.monitor.getSourceId(), we = this.sourcePreviewNodeOptions.get(me);
      return _objectSpread$9({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: !1
      }, we || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function() {
      var me = this.monitor.getItemType();
      return Object.keys(NativeTypes).some(function(we) {
        return NativeTypes[we] === me;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function(me, we) {
      this.clearCurrentDragSourceNode(), this.currentNativeSource = createNativeDragSource(me, we), this.currentNativeHandle = this.registry.addSource(me, this.currentNativeSource), this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function(me) {
      var we = this;
      this.clearCurrentDragSourceNode(), this.currentDragSourceNode = me;
      var Re = 1e3;
      this.mouseMoveTimeoutTimer = setTimeout(function() {
        var je;
        return (je = we.rootElement) === null || je === void 0 ? void 0 : je.addEventListener("mousemove", we.endDragIfSourceWasRemovedFromDOM, !0);
      }, Re);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function() {
      if (this.currentDragSourceNode) {
        if (this.currentDragSourceNode = null, this.rootElement) {
          var me;
          (me = this.window) === null || me === void 0 || me.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
        }
        return this.mouseMoveTimeoutTimer = null, !0;
      }
      return !1;
    }
  }, {
    key: "handleDragStart",
    value: function(me, we) {
      me.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(we));
    }
  }, {
    key: "handleDragEnter",
    value: function(me, we) {
      this.dragEnterTargetIds.unshift(we);
    }
  }, {
    key: "handleDragOver",
    value: function(me, we) {
      this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(we);
    }
  }, {
    key: "handleDrop",
    value: function(me, we) {
      this.dropTargetIds.unshift(we);
    }
  }]), ce;
}(), emptyImage;
function getEmptyImage() {
  return emptyImage || (emptyImage = new Image(), emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), emptyImage;
}
var HTML5Backend = function(ie, me, we) {
  return new HTML5BackendImpl(ie, me, we);
}, DndContext = createContext({
  dragDropManager: void 0
}), HandlerRole;
(function(ce) {
  ce.SOURCE = "SOURCE", ce.TARGET = "TARGET";
})(HandlerRole || (HandlerRole = {}));
function invariant(ce, ie) {
  for (var me = arguments.length, we = new Array(me > 2 ? me - 2 : 0), Re = 2; Re < me; Re++)
    we[Re - 2] = arguments[Re];
  if (process.env.NODE_ENV !== "production" && ie === void 0)
    throw new Error("invariant requires an error message argument");
  if (!ce) {
    var je;
    if (ie === void 0)
      je = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var Ue = 0;
      je = new Error(ie.replace(/%s/g, function() {
        return we[Ue++];
      })), je.name = "Invariant Violation";
    }
    throw je.framesToPop = 1, je;
  }
}
var INIT_COORDS = "dnd-core/INIT_COORDS", BEGIN_DRAG = "dnd-core/BEGIN_DRAG", PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE", HOVER = "dnd-core/HOVER", DROP = "dnd-core/DROP", END_DRAG = "dnd-core/END_DRAG";
function setClientOffset(ce, ie) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: ie || null,
      clientOffset: ce || null
    }
  };
}
function _typeof$9(ce) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$9 = function(me) {
    return typeof me;
  } : _typeof$9 = function(me) {
    return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
  }, _typeof$9(ce);
}
function get(ce, ie, me) {
  return ie.split(".").reduce(function(we, Re) {
    return we && we[Re] ? we[Re] : me || null;
  }, ce);
}
function without(ce, ie) {
  return ce.filter(function(me) {
    return me !== ie;
  });
}
function isObject$1(ce) {
  return _typeof$9(ce) === "object";
}
function xor(ce, ie) {
  var me = /* @__PURE__ */ new Map(), we = function(Ue) {
    me.set(Ue, me.has(Ue) ? me.get(Ue) + 1 : 1);
  };
  ce.forEach(we), ie.forEach(we);
  var Re = [];
  return me.forEach(function(je, Ue) {
    je === 1 && Re.push(Ue);
  }), Re;
}
function intersection(ce, ie) {
  return ce.filter(function(me) {
    return ie.indexOf(me) > -1;
  });
}
var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(ce) {
  return function() {
    var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      publishSource: !0
    }, Re = we.publishSource, je = Re === void 0 ? !0 : Re, Ue = we.clientOffset, qe = we.getSourceClientOffset, Ge = ce.getMonitor(), Xe = ce.getRegistry();
    ce.dispatch(setClientOffset(Ue)), verifyInvariants$1(me, Ge, Xe);
    var ot = getDraggableSource(me, Ge);
    if (ot === null) {
      ce.dispatch(ResetCoordinatesAction);
      return;
    }
    var vt = null;
    if (Ue) {
      if (!qe)
        throw new Error("getSourceClientOffset must be defined");
      verifyGetSourceClientOffsetIsFunction(qe), vt = qe(ot);
    }
    ce.dispatch(setClientOffset(Ue, vt));
    var bt = Xe.getSource(ot), Tt = bt.beginDrag(Ge, ot);
    if (Tt != null) {
      verifyItemIsObject(Tt), Xe.pinSource(ot);
      var wt = Xe.getSourceType(ot);
      return {
        type: BEGIN_DRAG,
        payload: {
          itemType: wt,
          item: Tt,
          sourceId: ot,
          clientOffset: Ue || null,
          sourceClientOffset: vt || null,
          isSourcePublic: !!je
        }
      };
    }
  };
}
function verifyInvariants$1(ce, ie, me) {
  invariant(!ie.isDragging(), "Cannot call beginDrag while dragging."), ce.forEach(function(we) {
    invariant(me.getSource(we), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(ce) {
  invariant(typeof ce == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(ce) {
  invariant(isObject$1(ce), "Item must be an object.");
}
function getDraggableSource(ce, ie) {
  for (var me = null, we = ce.length - 1; we >= 0; we--)
    if (ie.canDragSource(ce[we])) {
      me = ce[we];
      break;
    }
  return me;
}
function createPublishDragSource(ce) {
  return function() {
    var me = ce.getMonitor();
    if (me.isDragging())
      return {
        type: PUBLISH_DRAG_SOURCE
      };
  };
}
function matchesType(ce, ie) {
  return ie === null ? ce === null : Array.isArray(ce) ? ce.some(function(me) {
    return me === ie;
  }) : ce === ie;
}
function createHover(ce) {
  return function(me) {
    var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Re = we.clientOffset;
    verifyTargetIdsIsArray(me);
    var je = me.slice(0), Ue = ce.getMonitor(), qe = ce.getRegistry();
    checkInvariants(je, Ue, qe);
    var Ge = Ue.getItemType();
    return removeNonMatchingTargetIds(je, qe, Ge), hoverAllTargets(je, Ue, qe), {
      type: HOVER,
      payload: {
        targetIds: je,
        clientOffset: Re || null
      }
    };
  };
}
function verifyTargetIdsIsArray(ce) {
  invariant(Array.isArray(ce), "Expected targetIds to be an array.");
}
function checkInvariants(ce, ie, me) {
  invariant(ie.isDragging(), "Cannot call hover while not dragging."), invariant(!ie.didDrop(), "Cannot call hover after drop.");
  for (var we = 0; we < ce.length; we++) {
    var Re = ce[we];
    invariant(ce.lastIndexOf(Re) === we, "Expected targetIds to be unique in the passed array.");
    var je = me.getTarget(Re);
    invariant(je, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(ce, ie, me) {
  for (var we = ce.length - 1; we >= 0; we--) {
    var Re = ce[we], je = ie.getTargetType(Re);
    matchesType(je, me) || ce.splice(we, 1);
  }
}
function hoverAllTargets(ce, ie, me) {
  ce.forEach(function(we) {
    var Re = me.getTarget(we);
    Re.hover(ie, we);
  });
}
function ownKeys$a(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$8(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$a(Object(me), !0).forEach(function(we) {
      _defineProperty$j(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$a(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$j(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function createDrop(ce) {
  return function() {
    var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, we = ce.getMonitor(), Re = ce.getRegistry();
    verifyInvariants(we);
    var je = getDroppableTargets(we);
    je.forEach(function(Ue, qe) {
      var Ge = determineDropResult(Ue, qe, Re, we), Xe = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$8(_objectSpread$8({}, me), Ge)
        }
      };
      ce.dispatch(Xe);
    });
  };
}
function verifyInvariants(ce) {
  invariant(ce.isDragging(), "Cannot call drop while not dragging."), invariant(!ce.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(ce, ie, me, we) {
  var Re = me.getTarget(ce), je = Re ? Re.drop(we, ce) : void 0;
  return verifyDropResultType(je), typeof je > "u" && (je = ie === 0 ? {} : we.getDropResult()), je;
}
function verifyDropResultType(ce) {
  invariant(typeof ce > "u" || isObject$1(ce), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(ce) {
  var ie = ce.getTargetIds().filter(ce.canDropOnTarget, ce);
  return ie.reverse(), ie;
}
function createEndDrag(ce) {
  return function() {
    var me = ce.getMonitor(), we = ce.getRegistry();
    verifyIsDragging(me);
    var Re = me.getSourceId();
    if (Re != null) {
      var je = we.getSource(Re, !0);
      je.endDrag(me, Re), we.unpinSource();
    }
    return {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(ce) {
  invariant(ce.isDragging(), "Cannot call endDrag while not dragging.");
}
function createDragDropActions(ce) {
  return {
    beginDrag: createBeginDrag(ce),
    publishDragSource: createPublishDragSource(ce),
    hover: createHover(ce),
    drop: createDrop(ce),
    endDrag: createEndDrag(ce)
  };
}
function _classCallCheck$c(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$c(ce, ie, me) {
  return ie && _defineProperties$c(ce.prototype, ie), ce;
}
function _defineProperty$i(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var DragDropManagerImpl = /* @__PURE__ */ function() {
  function ce(ie, me) {
    var we = this;
    _classCallCheck$c(this, ce), _defineProperty$i(this, "store", void 0), _defineProperty$i(this, "monitor", void 0), _defineProperty$i(this, "backend", void 0), _defineProperty$i(this, "isSetUp", !1), _defineProperty$i(this, "handleRefCountChange", function() {
      var Re = we.store.getState().refCount > 0;
      we.backend && (Re && !we.isSetUp ? (we.backend.setup(), we.isSetUp = !0) : !Re && we.isSetUp && (we.backend.teardown(), we.isSetUp = !1));
    }), this.store = ie, this.monitor = me, ie.subscribe(this.handleRefCountChange);
  }
  return _createClass$c(ce, [{
    key: "receiveBackend",
    value: function(me) {
      this.backend = me;
    }
  }, {
    key: "getMonitor",
    value: function() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function() {
      var me = this, we = this.store.dispatch;
      function Re(Ue) {
        return function() {
          for (var qe = arguments.length, Ge = new Array(qe), Xe = 0; Xe < qe; Xe++)
            Ge[Xe] = arguments[Xe];
          var ot = Ue.apply(me, Ge);
          typeof ot < "u" && we(ot);
        };
      }
      var je = createDragDropActions(this);
      return Object.keys(je).reduce(function(Ue, qe) {
        var Ge = je[qe];
        return Ue[qe] = Re(Ge), Ue;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function(me) {
      this.store.dispatch(me);
    }
  }]), ce;
}();
function formatProdErrorMessage(ce) {
  return "Minified Redux error #" + ce + "; visit https://redux.js.org/Errors?code=" + ce + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
function isPlainObject(ce) {
  if (typeof ce != "object" || ce === null) return !1;
  for (var ie = ce; Object.getPrototypeOf(ie) !== null; )
    ie = Object.getPrototypeOf(ie);
  return Object.getPrototypeOf(ce) === ie;
}
function miniKindOf(ce) {
  if (ce === void 0) return "undefined";
  if (ce === null) return "null";
  var ie = typeof ce;
  switch (ie) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return ie;
  }
  if (Array.isArray(ce)) return "array";
  if (isDate(ce)) return "date";
  if (isError(ce)) return "error";
  var me = ctorName(ce);
  switch (me) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return me;
  }
  return ie.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(ce) {
  return typeof ce.constructor == "function" ? ce.constructor.name : null;
}
function isError(ce) {
  return ce instanceof Error || typeof ce.message == "string" && ce.constructor && typeof ce.constructor.stackTraceLimit == "number";
}
function isDate(ce) {
  return ce instanceof Date ? !0 : typeof ce.toDateString == "function" && typeof ce.getDate == "function" && typeof ce.setDate == "function";
}
function kindOf(ce) {
  var ie = typeof ce;
  return process.env.NODE_ENV !== "production" && (ie = miniKindOf(ce)), ie;
}
function createStore(ce, ie, me) {
  var we;
  if (typeof ie == "function" && typeof me == "function" || typeof me == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof ie == "function" && typeof me > "u" && (me = ie, ie = void 0), typeof me < "u") {
    if (typeof me != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(me) + "'");
    return me(createStore)(ce, ie);
  }
  if (typeof ce != "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(ce) + "'");
  var Re = ce, je = ie, Ue = [], qe = Ue, Ge = !1;
  function Xe() {
    qe === Ue && (qe = Ue.slice());
  }
  function ot() {
    if (Ge)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return je;
  }
  function vt(St) {
    if (typeof St != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(St) + "'");
    if (Ge)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var It = !0;
    return Xe(), qe.push(St), function() {
      if (It) {
        if (Ge)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        It = !1, Xe();
        var kt = qe.indexOf(St);
        qe.splice(kt, 1), Ue = null;
      }
    };
  }
  function bt(St) {
    if (!isPlainObject(St))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(St) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof St.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (Ge)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      Ge = !0, je = Re(je, St);
    } finally {
      Ge = !1;
    }
    for (var It = Ue = qe, Pt = 0; Pt < It.length; Pt++) {
      var kt = It[Pt];
      kt();
    }
    return St;
  }
  function Tt(St) {
    if (typeof St != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(St));
    Re = St, bt({
      type: ActionTypes.REPLACE
    });
  }
  function wt() {
    var St, It = vt;
    return St = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(kt) {
        if (typeof kt != "object" || kt === null)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(kt) + "'");
        function Ot() {
          kt.next && kt.next(ot());
        }
        Ot();
        var Jr = It(Ot);
        return {
          unsubscribe: Jr
        };
      }
    }, St[$$observable] = function() {
      return this;
    }, St;
  }
  return bt({
    type: ActionTypes.INIT
  }), we = {
    dispatch: bt,
    subscribe: vt,
    getState: ot,
    replaceReducer: Tt
  }, we[$$observable] = wt, we;
}
function warning(ce) {
  typeof console < "u" && typeof console.error == "function" && console.error(ce);
  try {
    throw new Error(ce);
  } catch {
  }
}
function getUnexpectedStateShapeWarningMessage(ce, ie, me, we) {
  var Re = Object.keys(ie), je = me && me.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (Re.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject(ce))
    return "The " + je + ' has unexpected type of "' + kindOf(ce) + '". Expected argument to be an object with the following ' + ('keys: "' + Re.join('", "') + '"');
  var Ue = Object.keys(ce).filter(function(qe) {
    return !ie.hasOwnProperty(qe) && !we[qe];
  });
  if (Ue.forEach(function(qe) {
    we[qe] = !0;
  }), !(me && me.type === ActionTypes.REPLACE) && Ue.length > 0)
    return "Unexpected " + (Ue.length > 1 ? "keys" : "key") + " " + ('"' + Ue.join('", "') + '" found in ' + je + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + Re.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(ce) {
  Object.keys(ce).forEach(function(ie) {
    var me = ce[ie], we = me(void 0, {
      type: ActionTypes.INIT
    });
    if (typeof we > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : 'The slice reducer for key "' + ie + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof me(void 0, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : 'The slice reducer for key "' + ie + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + ActionTypes.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function combineReducers(ce) {
  for (var ie = Object.keys(ce), me = {}, we = 0; we < ie.length; we++) {
    var Re = ie[we];
    process.env.NODE_ENV !== "production" && typeof ce[Re] > "u" && warning('No reducer provided for key "' + Re + '"'), typeof ce[Re] == "function" && (me[Re] = ce[Re]);
  }
  var je = Object.keys(me), Ue;
  process.env.NODE_ENV !== "production" && (Ue = {});
  var qe;
  try {
    assertReducerShape(me);
  } catch (Ge) {
    qe = Ge;
  }
  return function(Xe, ot) {
    if (Xe === void 0 && (Xe = {}), qe)
      throw qe;
    if (process.env.NODE_ENV !== "production") {
      var vt = getUnexpectedStateShapeWarningMessage(Xe, me, ot, Ue);
      vt && warning(vt);
    }
    for (var bt = !1, Tt = {}, wt = 0; wt < je.length; wt++) {
      var St = je[wt], It = me[St], Pt = Xe[St], kt = It(Pt, ot);
      if (typeof kt > "u") {
        var Ot = ot && ot.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "When called with an action of type " + (Ot ? '"' + String(Ot) + '"' : "(unknown type)") + ', the slice reducer for key "' + St + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      Tt[St] = kt, bt = bt || kt !== Pt;
    }
    return bt = bt || je.length !== Object.keys(Xe).length, bt ? Tt : Xe;
  };
}
var strictEquality = function(ie, me) {
  return ie === me;
};
function areCoordsEqual(ce, ie) {
  return !ce && !ie ? !0 : !ce || !ie ? !1 : ce.x === ie.x && ce.y === ie.y;
}
function areArraysEqual(ce, ie) {
  var me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : strictEquality;
  if (ce.length !== ie.length)
    return !1;
  for (var we = 0; we < ce.length; ++we)
    if (!me(ce[we], ie[we]))
      return !1;
  return !0;
}
function ownKeys$9(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$7(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$9(Object(me), !0).forEach(function(we) {
      _defineProperty$h(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$9(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$h(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var initialState$2 = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce$5() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState$2, ie = arguments.length > 1 ? arguments[1] : void 0, me = ie.payload;
  switch (ie.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: me.sourceClientOffset,
        initialClientOffset: me.clientOffset,
        clientOffset: me.clientOffset
      };
    case HOVER:
      return areCoordsEqual(ce.clientOffset, me.clientOffset) ? ce : _objectSpread$7(_objectSpread$7({}, ce), {}, {
        clientOffset: me.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState$2;
    default:
      return ce;
  }
}
var ADD_SOURCE = "dnd-core/ADD_SOURCE", ADD_TARGET = "dnd-core/ADD_TARGET", REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE", REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(ce) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: ce
    }
  };
}
function addTarget(ce) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: ce
    }
  };
}
function removeSource(ce) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: ce
    }
  };
}
function removeTarget(ce) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: ce
    }
  };
}
function ownKeys$8(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$6(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$8(Object(me), !0).forEach(function(we) {
      _defineProperty$g(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$8(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$g(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function reduce$4() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState$1, ie = arguments.length > 1 ? arguments[1] : void 0, me = ie.payload;
  switch (ie.type) {
    case BEGIN_DRAG:
      return _objectSpread$6(_objectSpread$6({}, ce), {}, {
        itemType: me.itemType,
        item: me.item,
        sourceId: me.sourceId,
        isSourcePublic: me.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$6(_objectSpread$6({}, ce), {}, {
        isSourcePublic: !0
      });
    case HOVER:
      return _objectSpread$6(_objectSpread$6({}, ce), {}, {
        targetIds: me.targetIds
      });
    case REMOVE_TARGET:
      return ce.targetIds.indexOf(me.targetId) === -1 ? ce : _objectSpread$6(_objectSpread$6({}, ce), {}, {
        targetIds: without(ce.targetIds, me.targetId)
      });
    case DROP:
      return _objectSpread$6(_objectSpread$6({}, ce), {}, {
        dropResult: me.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread$6(_objectSpread$6({}, ce), {}, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return ce;
  }
}
function reduce$3() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ie = arguments.length > 1 ? arguments[1] : void 0;
  switch (ie.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return ce + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return ce - 1;
    default:
      return ce;
  }
}
var NONE = [], ALL = [];
NONE.__IS_NONE__ = !0;
ALL.__IS_ALL__ = !0;
function areDirty(ce, ie) {
  if (ce === NONE)
    return !1;
  if (ce === ALL || typeof ie > "u")
    return !0;
  var me = intersection(ie, ce);
  return me.length > 0;
}
function reduce$2() {
  var ce = arguments.length > 1 ? arguments[1] : void 0;
  switch (ce.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  var ie = ce.payload, me = ie.targetIds, we = me === void 0 ? [] : me, Re = ie.prevTargetIds, je = Re === void 0 ? [] : Re, Ue = xor(we, je), qe = Ue.length > 0 || !areArraysEqual(we, je);
  if (!qe)
    return NONE;
  var Ge = je[je.length - 1], Xe = we[we.length - 1];
  return Ge !== Xe && (Ge && Ue.push(Ge), Xe && Ue.push(Xe)), Ue;
}
function reduce$1() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  return ce + 1;
}
function ownKeys$7(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$5(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$7(Object(me), !0).forEach(function(we) {
      _defineProperty$f(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$7(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$f(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function reduce() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ie = arguments.length > 1 ? arguments[1] : void 0;
  return {
    dirtyHandlerIds: reduce$2(ce.dirtyHandlerIds, {
      type: ie.type,
      payload: _objectSpread$5(_objectSpread$5({}, ie.payload), {}, {
        prevTargetIds: get(ce, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce$5(ce.dragOffset, ie),
    refCount: reduce$3(ce.refCount, ie),
    dragOperation: reduce$4(ce.dragOperation, ie),
    stateId: reduce$1(ce.stateId)
  };
}
function add(ce, ie) {
  return {
    x: ce.x + ie.x,
    y: ce.y + ie.y
  };
}
function subtract(ce, ie) {
  return {
    x: ce.x - ie.x,
    y: ce.y - ie.y
  };
}
function getSourceClientOffset(ce) {
  var ie = ce.clientOffset, me = ce.initialClientOffset, we = ce.initialSourceClientOffset;
  return !ie || !me || !we ? null : subtract(add(ie, we), me);
}
function getDifferenceFromInitialOffset(ce) {
  var ie = ce.clientOffset, me = ce.initialClientOffset;
  return !ie || !me ? null : subtract(ie, me);
}
function _classCallCheck$b(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$b(ce, ie, me) {
  return ie && _defineProperties$b(ce.prototype, ie), ce;
}
function _defineProperty$e(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var DragDropMonitorImpl = /* @__PURE__ */ function() {
  function ce(ie, me) {
    _classCallCheck$b(this, ce), _defineProperty$e(this, "store", void 0), _defineProperty$e(this, "registry", void 0), this.store = ie, this.registry = me;
  }
  return _createClass$b(ce, [{
    key: "subscribeToStateChange",
    value: function(me) {
      var we = this, Re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        handlerIds: void 0
      }, je = Re.handlerIds;
      invariant(typeof me == "function", "listener must be a function."), invariant(typeof je > "u" || Array.isArray(je), "handlerIds, when specified, must be an array of strings.");
      var Ue = this.store.getState().stateId, qe = function() {
        var Xe = we.store.getState(), ot = Xe.stateId;
        try {
          var vt = ot === Ue || ot === Ue + 1 && !areDirty(Xe.dirtyHandlerIds, je);
          vt || me();
        } finally {
          Ue = ot;
        }
      };
      return this.store.subscribe(qe);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function(me) {
      var we = this;
      invariant(typeof me == "function", "listener must be a function.");
      var Re = this.store.getState().dragOffset, je = function() {
        var qe = we.store.getState().dragOffset;
        qe !== Re && (Re = qe, me());
      };
      return this.store.subscribe(je);
    }
  }, {
    key: "canDragSource",
    value: function(me) {
      if (!me)
        return !1;
      var we = this.registry.getSource(me);
      return invariant(we, "Expected to find a valid source. sourceId=".concat(me)), this.isDragging() ? !1 : we.canDrag(this, me);
    }
  }, {
    key: "canDropOnTarget",
    value: function(me) {
      if (!me)
        return !1;
      var we = this.registry.getTarget(me);
      if (invariant(we, "Expected to find a valid target. targetId=".concat(me)), !this.isDragging() || this.didDrop())
        return !1;
      var Re = this.registry.getTargetType(me), je = this.getItemType();
      return matchesType(Re, je) && we.canDrop(this, me);
    }
  }, {
    key: "isDragging",
    value: function() {
      return !!this.getItemType();
    }
  }, {
    key: "isDraggingSource",
    value: function(me) {
      if (!me)
        return !1;
      var we = this.registry.getSource(me, !0);
      if (invariant(we, "Expected to find a valid source. sourceId=".concat(me)), !this.isDragging() || !this.isSourcePublic())
        return !1;
      var Re = this.registry.getSourceType(me), je = this.getItemType();
      return Re !== je ? !1 : we.isDragging(this, me);
    }
  }, {
    key: "isOverTarget",
    value: function(me) {
      var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        shallow: !1
      };
      if (!me)
        return !1;
      var Re = we.shallow;
      if (!this.isDragging())
        return !1;
      var je = this.registry.getTargetType(me), Ue = this.getItemType();
      if (Ue && !matchesType(je, Ue))
        return !1;
      var qe = this.getTargetIds();
      if (!qe.length)
        return !1;
      var Ge = qe.indexOf(me);
      return Re ? Ge === qe.length - 1 : Ge > -1;
    }
  }, {
    key: "getItemType",
    value: function() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function() {
      return !!this.store.getState().dragOperation.isSourcePublic;
    }
  }, {
    key: "getInitialClientOffset",
    value: function() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function() {
      return getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function() {
      return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]), ce;
}(), nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
function _typeof$8(ce) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$8 = function(me) {
    return typeof me;
  } : _typeof$8 = function(me) {
    return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
  }, _typeof$8(ce);
}
function validateSourceContract(ce) {
  invariant(typeof ce.canDrag == "function", "Expected canDrag to be a function."), invariant(typeof ce.beginDrag == "function", "Expected beginDrag to be a function."), invariant(typeof ce.endDrag == "function", "Expected endDrag to be a function.");
}
function validateTargetContract(ce) {
  invariant(typeof ce.canDrop == "function", "Expected canDrop to be a function."), invariant(typeof ce.hover == "function", "Expected hover to be a function."), invariant(typeof ce.drop == "function", "Expected beginDrag to be a function.");
}
function validateType(ce, ie) {
  if (ie && Array.isArray(ce)) {
    ce.forEach(function(me) {
      return validateType(me, !1);
    });
    return;
  }
  invariant(typeof ce == "string" || _typeof$8(ce) === "symbol", ie ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
const scope = typeof global < "u" ? global : self, BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(ce) {
  return function() {
    const me = setTimeout(Re, 0), we = setInterval(Re, 50);
    function Re() {
      clearTimeout(me), clearInterval(we), ce();
    }
  };
}
function makeRequestCallFromMutationObserver(ce) {
  let ie = 1;
  const me = new BrowserMutationObserver(ce), we = document.createTextNode("");
  return me.observe(we, {
    characterData: !0
  }), function() {
    ie = -ie, we.data = ie;
  };
}
const makeRequestCall = typeof BrowserMutationObserver == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);
class AsapQueue {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(ie) {
    const { queue: me, requestFlush: we } = this;
    me.length || (we(), this.flushing = !0), me[me.length] = ie;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: ie } = this;
      for (; this.index < ie.length; ) {
        const me = this.index;
        if (this.index++, ie[me].call(), this.index > this.capacity) {
          for (let we = 0, Re = ie.length - this.index; we < Re; we++)
            ie[we] = ie[we + this.index];
          ie.length -= this.index, this.index = 0;
        }
      }
      ie.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (ie) => {
      this.pendingErrors.push(ie), this.requestErrorThrow();
    }, this.requestFlush = makeRequestCall(this.flush), this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class RawTask {
  call() {
    try {
      this.task && this.task();
    } catch (ie) {
      this.onError(ie);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(ie, me) {
    this.onError = ie, this.release = me, this.task = null;
  }
}
class TaskFactory {
  create(ie) {
    const me = this.freeTasks, we = me.length ? me.pop() : new RawTask(
      this.onError,
      (Re) => me[me.length] = Re
    );
    return we.task = ie, we;
  }
  constructor(ie) {
    this.onError = ie, this.freeTasks = [];
  }
}
const asapQueue = new AsapQueue(), taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(ce) {
  asapQueue.enqueueTask(taskFactory.create(ce));
}
function _classCallCheck$a(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$a(ce, ie, me) {
  return ie && _defineProperties$a(ce.prototype, ie), ce;
}
function _defineProperty$d(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _slicedToArray$7(ce, ie) {
  return _arrayWithHoles$7(ce) || _iterableToArrayLimit$7(ce, ie) || _unsupportedIterableToArray$8(ce, ie) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$8(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$8(ce, ie);
  }
}
function _arrayLikeToArray$8(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$7(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$7(ce) {
  if (Array.isArray(ce)) return ce;
}
function getNextHandlerId(ce) {
  var ie = getNextUniqueId().toString();
  switch (ce) {
    case HandlerRole.SOURCE:
      return "S".concat(ie);
    case HandlerRole.TARGET:
      return "T".concat(ie);
    default:
      throw new Error("Unknown Handler Role: ".concat(ce));
  }
}
function parseRoleFromHandlerId(ce) {
  switch (ce[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      invariant(!1, "Cannot parse handler ID: ".concat(ce));
  }
}
function mapContainsValue(ce, ie) {
  var me = ce.entries(), we = !1;
  do {
    var Re = me.next(), je = Re.done, Ue = _slicedToArray$7(Re.value, 2), qe = Ue[1];
    if (qe === ie)
      return !0;
    we = !!je;
  } while (!we);
  return !1;
}
var HandlerRegistryImpl = /* @__PURE__ */ function() {
  function ce(ie) {
    _classCallCheck$a(this, ce), _defineProperty$d(this, "types", /* @__PURE__ */ new Map()), _defineProperty$d(this, "dragSources", /* @__PURE__ */ new Map()), _defineProperty$d(this, "dropTargets", /* @__PURE__ */ new Map()), _defineProperty$d(this, "pinnedSourceId", null), _defineProperty$d(this, "pinnedSource", null), _defineProperty$d(this, "store", void 0), this.store = ie;
  }
  return _createClass$a(ce, [{
    key: "addSource",
    value: function(me, we) {
      validateType(me), validateSourceContract(we);
      var Re = this.addHandler(HandlerRole.SOURCE, me, we);
      return this.store.dispatch(addSource(Re)), Re;
    }
  }, {
    key: "addTarget",
    value: function(me, we) {
      validateType(me, !0), validateTargetContract(we);
      var Re = this.addHandler(HandlerRole.TARGET, me, we);
      return this.store.dispatch(addTarget(Re)), Re;
    }
  }, {
    key: "containsHandler",
    value: function(me) {
      return mapContainsValue(this.dragSources, me) || mapContainsValue(this.dropTargets, me);
    }
  }, {
    key: "getSource",
    value: function(me) {
      var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      invariant(this.isSourceId(me), "Expected a valid source ID.");
      var Re = we && me === this.pinnedSourceId, je = Re ? this.pinnedSource : this.dragSources.get(me);
      return je;
    }
  }, {
    key: "getTarget",
    value: function(me) {
      return invariant(this.isTargetId(me), "Expected a valid target ID."), this.dropTargets.get(me);
    }
  }, {
    key: "getSourceType",
    value: function(me) {
      return invariant(this.isSourceId(me), "Expected a valid source ID."), this.types.get(me);
    }
  }, {
    key: "getTargetType",
    value: function(me) {
      return invariant(this.isTargetId(me), "Expected a valid target ID."), this.types.get(me);
    }
  }, {
    key: "isSourceId",
    value: function(me) {
      var we = parseRoleFromHandlerId(me);
      return we === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function(me) {
      var we = parseRoleFromHandlerId(me);
      return we === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function(me) {
      var we = this;
      invariant(this.getSource(me), "Expected an existing source."), this.store.dispatch(removeSource(me)), asap(function() {
        we.dragSources.delete(me), we.types.delete(me);
      });
    }
  }, {
    key: "removeTarget",
    value: function(me) {
      invariant(this.getTarget(me), "Expected an existing target."), this.store.dispatch(removeTarget(me)), this.dropTargets.delete(me), this.types.delete(me);
    }
  }, {
    key: "pinSource",
    value: function(me) {
      var we = this.getSource(me);
      invariant(we, "Expected an existing source."), this.pinnedSourceId = me, this.pinnedSource = we;
    }
  }, {
    key: "unpinSource",
    value: function() {
      invariant(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function(me, we, Re) {
      var je = getNextHandlerId(me);
      return this.types.set(je, we), me === HandlerRole.SOURCE ? this.dragSources.set(je, Re) : me === HandlerRole.TARGET && this.dropTargets.set(je, Re), je;
    }
  }]), ce;
}();
function createDragDropManager(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, we = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, Re = makeStoreInstance(we), je = new DragDropMonitorImpl(Re, new HandlerRegistryImpl(Re)), Ue = new DragDropManagerImpl(Re, je), qe = ce(Ue, ie, me);
  return Ue.receiveBackend(qe), Ue;
}
function makeStoreInstance(ce) {
  var ie = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, ce && ie && ie({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
var _excluded$c = ["children"];
function _slicedToArray$6(ce, ie) {
  return _arrayWithHoles$6(ce) || _iterableToArrayLimit$6(ce, ie) || _unsupportedIterableToArray$7(ce, ie) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$7(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$7(ce, ie);
  }
}
function _arrayLikeToArray$7(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$6(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$6(ce) {
  if (Array.isArray(ce)) return ce;
}
function _objectWithoutProperties$2(ce, ie) {
  if (ce == null) return {};
  var me = _objectWithoutPropertiesLoose$2(ce, ie), we, Re;
  if (Object.getOwnPropertySymbols) {
    var je = Object.getOwnPropertySymbols(ce);
    for (Re = 0; Re < je.length; Re++)
      we = je[Re], !(ie.indexOf(we) >= 0) && Object.prototype.propertyIsEnumerable.call(ce, we) && (me[we] = ce[we]);
  }
  return me;
}
function _objectWithoutPropertiesLoose$2(ce, ie) {
  if (ce == null) return {};
  var me = {}, we = Object.keys(ce), Re, je;
  for (je = 0; je < we.length; je++)
    Re = we[je], !(ie.indexOf(Re) >= 0) && (me[Re] = ce[Re]);
  return me;
}
var refCount = 0, INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__"), DndProvider = memo(function(ie) {
  var me = ie.children, we = _objectWithoutProperties$2(ie, _excluded$c), Re = getDndContextValue(we), je = _slicedToArray$6(Re, 2), Ue = je[0], qe = je[1];
  return useEffect(function() {
    if (qe) {
      var Ge = getGlobalContext();
      return ++refCount, function() {
        --refCount === 0 && (Ge[INSTANCE_SYM] = null);
      };
    }
  }, []), jsxRuntimeExports.jsx(DndContext.Provider, Object.assign({
    value: Ue
  }, {
    children: me
  }), void 0);
});
function getDndContextValue(ce) {
  if ("manager" in ce) {
    var ie = {
      dragDropManager: ce.manager
    };
    return [ie, !1];
  }
  var me = createSingletonDndContext(ce.backend, ce.context, ce.options, ce.debugMode), we = !ce.context;
  return [me, we];
}
function createSingletonDndContext(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalContext(), me = arguments.length > 2 ? arguments[2] : void 0, we = arguments.length > 3 ? arguments[3] : void 0, Re = ie;
  return Re[INSTANCE_SYM] || (Re[INSTANCE_SYM] = {
    dragDropManager: createDragDropManager(ce, ie, me, we)
  }), Re[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global < "u" ? global : window;
}
function _classCallCheck$9(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$9(ce, ie, me) {
  return ie && _defineProperties$9(ce.prototype, ie), ce;
}
function _defineProperty$c(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var isCallingCanDrag = !1, isCallingIsDragging = !1, DragSourceMonitorImpl = /* @__PURE__ */ function() {
  function ce(ie) {
    _classCallCheck$9(this, ce), _defineProperty$c(this, "internalMonitor", void 0), _defineProperty$c(this, "sourceId", null), this.internalMonitor = ie.getMonitor();
  }
  return _createClass$9(ce, [{
    key: "receiveHandlerId",
    value: function(me) {
      this.sourceId = me;
    }
  }, {
    key: "getHandlerId",
    value: function() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function() {
      invariant(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
      try {
        return isCallingCanDrag = !0, this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = !1;
      }
    }
  }, {
    key: "isDragging",
    value: function() {
      if (!this.sourceId)
        return !1;
      invariant(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
      try {
        return isCallingIsDragging = !0, this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = !1;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function(me, we) {
      return this.internalMonitor.subscribeToStateChange(me, we);
    }
  }, {
    key: "isDraggingSource",
    value: function(me) {
      return this.internalMonitor.isDraggingSource(me);
    }
  }, {
    key: "isOverTarget",
    value: function(me, we) {
      return this.internalMonitor.isOverTarget(me, we);
    }
  }, {
    key: "getTargetIds",
    value: function() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function(me) {
      return this.internalMonitor.subscribeToOffsetChange(me);
    }
  }, {
    key: "canDragSource",
    value: function(me) {
      return this.internalMonitor.canDragSource(me);
    }
  }, {
    key: "canDropOnTarget",
    value: function(me) {
      return this.internalMonitor.canDropOnTarget(me);
    }
  }, {
    key: "getItemType",
    value: function() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]), ce;
}();
function _classCallCheck$8(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$8(ce, ie, me) {
  return ie && _defineProperties$8(ce.prototype, ie), ce;
}
function _defineProperty$b(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var isCallingCanDrop = !1, DropTargetMonitorImpl = /* @__PURE__ */ function() {
  function ce(ie) {
    _classCallCheck$8(this, ce), _defineProperty$b(this, "internalMonitor", void 0), _defineProperty$b(this, "targetId", null), this.internalMonitor = ie.getMonitor();
  }
  return _createClass$8(ce, [{
    key: "receiveHandlerId",
    value: function(me) {
      this.targetId = me;
    }
  }, {
    key: "getHandlerId",
    value: function() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function(me, we) {
      return this.internalMonitor.subscribeToStateChange(me, we);
    }
  }, {
    key: "canDrop",
    value: function() {
      if (!this.targetId)
        return !1;
      invariant(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
      try {
        return isCallingCanDrop = !0, this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = !1;
      }
    }
  }, {
    key: "isOver",
    value: function(me) {
      return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, me) : !1;
    }
  }, {
    key: "getItemType",
    value: function() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]), ce;
}();
function throwIfCompositeComponentElement(ce) {
  if (typeof ce.type != "string") {
    var ie = ce.type.displayName || ce.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + "You can either wrap ".concat(ie, " into a <div>, or turn it into a ") + "drag source or a drop target itself.");
  }
}
function wrapHookToRecognizeElement(ce) {
  return function() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!isValidElement(ie)) {
      var we = ie;
      return ce(we, me), we;
    }
    var Re = ie;
    throwIfCompositeComponentElement(Re);
    var je = me ? function(Ue) {
      return ce(Ue, me);
    } : ce;
    return cloneWithRef(Re, je);
  };
}
function wrapConnectorHooks(ce) {
  var ie = {};
  return Object.keys(ce).forEach(function(me) {
    var we = ce[me];
    if (me.endsWith("Ref"))
      ie[me] = ce[me];
    else {
      var Re = wrapHookToRecognizeElement(we);
      ie[me] = function() {
        return Re;
      };
    }
  }), ie;
}
function setRef(ce, ie) {
  typeof ce == "function" ? ce(ie) : ce.current = ie;
}
function cloneWithRef(ce, ie) {
  var me = ce.ref;
  return invariant(typeof me != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), me ? cloneElement(ce, {
    ref: function(Re) {
      setRef(me, Re), setRef(ie, Re);
    }
  }) : cloneElement(ce, {
    ref: ie
  });
}
function _typeof$7(ce) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$7 = function(me) {
    return typeof me;
  } : _typeof$7 = function(me) {
    return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
  }, _typeof$7(ce);
}
function isRef(ce) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    ce !== null && _typeof$7(ce) === "object" && Object.prototype.hasOwnProperty.call(ce, "current")
  );
}
function shallowEqual(ce, ie, me, we) {
  var Re = void 0;
  if (Re !== void 0)
    return !!Re;
  if (ce === ie)
    return !0;
  if (typeof ce != "object" || !ce || typeof ie != "object" || !ie)
    return !1;
  var je = Object.keys(ce), Ue = Object.keys(ie);
  if (je.length !== Ue.length)
    return !1;
  for (var qe = Object.prototype.hasOwnProperty.bind(ie), Ge = 0; Ge < je.length; Ge++) {
    var Xe = je[Ge];
    if (!qe(Xe))
      return !1;
    var ot = ce[Xe], vt = ie[Xe];
    if (Re = void 0, Re === !1 || Re === void 0 && ot !== vt)
      return !1;
  }
  return !0;
}
function _classCallCheck$7(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$7(ce, ie, me) {
  return ie && _defineProperties$7(ce.prototype, ie), ce;
}
function _defineProperty$a(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var SourceConnector = /* @__PURE__ */ function() {
  function ce(ie) {
    var me = this;
    _classCallCheck$7(this, ce), _defineProperty$a(this, "hooks", wrapConnectorHooks({
      dragSource: function(Re, je) {
        me.clearDragSource(), me.dragSourceOptions = je || null, isRef(Re) ? me.dragSourceRef = Re : me.dragSourceNode = Re, me.reconnectDragSource();
      },
      dragPreview: function(Re, je) {
        me.clearDragPreview(), me.dragPreviewOptions = je || null, isRef(Re) ? me.dragPreviewRef = Re : me.dragPreviewNode = Re, me.reconnectDragPreview();
      }
    })), _defineProperty$a(this, "handlerId", null), _defineProperty$a(this, "dragSourceRef", null), _defineProperty$a(this, "dragSourceNode", void 0), _defineProperty$a(this, "dragSourceOptionsInternal", null), _defineProperty$a(this, "dragSourceUnsubscribe", void 0), _defineProperty$a(this, "dragPreviewRef", null), _defineProperty$a(this, "dragPreviewNode", void 0), _defineProperty$a(this, "dragPreviewOptionsInternal", null), _defineProperty$a(this, "dragPreviewUnsubscribe", void 0), _defineProperty$a(this, "lastConnectedHandlerId", null), _defineProperty$a(this, "lastConnectedDragSource", null), _defineProperty$a(this, "lastConnectedDragSourceOptions", null), _defineProperty$a(this, "lastConnectedDragPreview", null), _defineProperty$a(this, "lastConnectedDragPreviewOptions", null), _defineProperty$a(this, "backend", void 0), this.backend = ie;
  }
  return _createClass$7(ce, [{
    key: "receiveHandlerId",
    value: function(me) {
      this.handlerId !== me && (this.handlerId = me, this.reconnect());
    }
  }, {
    key: "connectTarget",
    get: function() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function() {
      return this.dragSourceOptionsInternal;
    },
    set: function(me) {
      this.dragSourceOptionsInternal = me;
    }
  }, {
    key: "dragPreviewOptions",
    get: function() {
      return this.dragPreviewOptionsInternal;
    },
    set: function(me) {
      this.dragPreviewOptionsInternal = me;
    }
  }, {
    key: "reconnect",
    value: function() {
      this.reconnectDragSource(), this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function() {
      var me = this.dragSource, we = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
      if (we && this.disconnectDragSource(), !!this.handlerId) {
        if (!me) {
          this.lastConnectedDragSource = me;
          return;
        }
        we && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = me, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, me, this.dragSourceOptions));
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function() {
      var me = this.dragPreview, we = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
      if (we && this.disconnectDragPreview(), !!this.handlerId) {
        if (!me) {
          this.lastConnectedDragPreview = me;
          return;
        }
        we && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = me, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, me, this.dragPreviewOptions));
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function() {
      return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function() {
      return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function() {
      this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
    }
  }, {
    key: "disconnectDragPreview",
    value: function() {
      this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
    }
  }, {
    key: "dragSource",
    get: function() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }, {
    key: "clearDragSource",
    value: function() {
      this.dragSourceNode = null, this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function() {
      this.dragPreviewNode = null, this.dragPreviewRef = null;
    }
  }]), ce;
}();
function _classCallCheck$6(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$6(ce, ie, me) {
  return ie && _defineProperties$6(ce.prototype, ie), ce;
}
function _defineProperty$9(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var TargetConnector = /* @__PURE__ */ function() {
  function ce(ie) {
    var me = this;
    _classCallCheck$6(this, ce), _defineProperty$9(this, "hooks", wrapConnectorHooks({
      dropTarget: function(Re, je) {
        me.clearDropTarget(), me.dropTargetOptions = je, isRef(Re) ? me.dropTargetRef = Re : me.dropTargetNode = Re, me.reconnect();
      }
    })), _defineProperty$9(this, "handlerId", null), _defineProperty$9(this, "dropTargetRef", null), _defineProperty$9(this, "dropTargetNode", void 0), _defineProperty$9(this, "dropTargetOptionsInternal", null), _defineProperty$9(this, "unsubscribeDropTarget", void 0), _defineProperty$9(this, "lastConnectedHandlerId", null), _defineProperty$9(this, "lastConnectedDropTarget", null), _defineProperty$9(this, "lastConnectedDropTargetOptions", null), _defineProperty$9(this, "backend", void 0), this.backend = ie;
  }
  return _createClass$6(ce, [{
    key: "connectTarget",
    get: function() {
      return this.dropTarget;
    }
  }, {
    key: "reconnect",
    value: function() {
      var me = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
      me && this.disconnectDropTarget();
      var we = this.dropTarget;
      if (this.handlerId) {
        if (!we) {
          this.lastConnectedDropTarget = we;
          return;
        }
        me && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = we, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, we, this.dropTargetOptions));
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function(me) {
      me !== this.handlerId && (this.handlerId = me, this.reconnect());
    }
  }, {
    key: "dropTargetOptions",
    get: function() {
      return this.dropTargetOptionsInternal;
    },
    set: function(me) {
      this.dropTargetOptionsInternal = me;
    }
  }, {
    key: "didHandlerIdChange",
    value: function() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function() {
      return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function() {
      this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
    }
  }, {
    key: "dropTarget",
    get: function() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }, {
    key: "clearDropTarget",
    value: function() {
      this.dropTargetRef = null, this.dropTargetNode = null;
    }
  }]), ce;
}();
function registerTarget(ce, ie, me) {
  var we = me.getRegistry(), Re = we.addTarget(ce, ie);
  return [Re, function() {
    return we.removeTarget(Re);
  }];
}
function registerSource(ce, ie, me) {
  var we = me.getRegistry(), Re = we.addSource(ce, ie);
  return [Re, function() {
    return we.removeSource(Re);
  }];
}
var useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect$2 : useEffect;
function _typeof$6(ce) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(me) {
    return typeof me;
  } : _typeof$6 = function(me) {
    return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
  }, _typeof$6(ce);
}
function _classCallCheck$5(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$5(ce, ie, me) {
  return ie && _defineProperties$5(ce.prototype, ie), ce;
}
function _defineProperty$8(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var DragSourceImpl = /* @__PURE__ */ function() {
  function ce(ie, me, we) {
    _classCallCheck$5(this, ce), _defineProperty$8(this, "spec", void 0), _defineProperty$8(this, "monitor", void 0), _defineProperty$8(this, "connector", void 0), this.spec = ie, this.monitor = me, this.connector = we;
  }
  return _createClass$5(ce, [{
    key: "beginDrag",
    value: function() {
      var me, we = this.spec, Re = this.monitor, je = null;
      return _typeof$6(we.item) === "object" ? je = we.item : typeof we.item == "function" ? je = we.item(Re) : je = {}, (me = je) !== null && me !== void 0 ? me : null;
    }
  }, {
    key: "canDrag",
    value: function() {
      var me = this.spec, we = this.monitor;
      return typeof me.canDrag == "boolean" ? me.canDrag : typeof me.canDrag == "function" ? me.canDrag(we) : !0;
    }
  }, {
    key: "isDragging",
    value: function(me, we) {
      var Re = this.spec, je = this.monitor, Ue = Re.isDragging;
      return Ue ? Ue(je) : we === me.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function() {
      var me = this.spec, we = this.monitor, Re = this.connector, je = me.end;
      je && je(we.getItem(), we), Re.reconnect();
    }
  }]), ce;
}();
function useDragSource(ce, ie, me) {
  var we = useMemo$1(function() {
    return new DragSourceImpl(ce, ie, me);
  }, [ie, me]);
  return useEffect(function() {
    we.spec = ce;
  }, [ce]), we;
}
function useDragDropManager() {
  var ce = useContext(DndContext), ie = ce.dragDropManager;
  return invariant(ie != null, "Expected drag drop context"), ie;
}
function useDragType(ce) {
  return useMemo$1(function() {
    var ie = ce.type;
    return invariant(ie != null, "spec.type must be defined"), ie;
  }, [ce]);
}
function _slicedToArray$5(ce, ie) {
  return _arrayWithHoles$5(ce) || _iterableToArrayLimit$5(ce, ie) || _unsupportedIterableToArray$6(ce, ie) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$6(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$6(ce, ie);
  }
}
function _arrayLikeToArray$6(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$5(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$5(ce) {
  if (Array.isArray(ce)) return ce;
}
function useRegisteredDragSource(ce, ie, me) {
  var we = useDragDropManager(), Re = useDragSource(ce, ie, me), je = useDragType(ce);
  useIsomorphicLayoutEffect(function() {
    if (je != null) {
      var qe = registerSource(je, Re, we), Ge = _slicedToArray$5(qe, 2), Xe = Ge[0], ot = Ge[1];
      return ie.receiveHandlerId(Xe), me.receiveHandlerId(Xe), ot;
    }
  }, [we, ie, me, Re, je]);
}
function _toConsumableArray(ce) {
  return _arrayWithoutHoles(ce) || _iterableToArray(ce) || _unsupportedIterableToArray$5(ce) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$5(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$5(ce, ie);
  }
}
function _iterableToArray(ce) {
  if (typeof Symbol < "u" && ce[Symbol.iterator] != null || ce["@@iterator"] != null) return Array.from(ce);
}
function _arrayWithoutHoles(ce) {
  if (Array.isArray(ce)) return _arrayLikeToArray$5(ce);
}
function _arrayLikeToArray$5(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function useOptionalFactory(ce, ie) {
  var me = _toConsumableArray(ie || []);
  return ie == null && typeof ce != "function" && me.push(ce), useMemo$1(function() {
    return typeof ce == "function" ? ce() : ce;
  }, me);
}
function useDragSourceMonitor() {
  var ce = useDragDropManager();
  return useMemo$1(function() {
    return new DragSourceMonitorImpl(ce);
  }, [ce]);
}
function useDragSourceConnector(ce, ie) {
  var me = useDragDropManager(), we = useMemo$1(function() {
    return new SourceConnector(me.getBackend());
  }, [me]);
  return useIsomorphicLayoutEffect(function() {
    return we.dragSourceOptions = ce || null, we.reconnect(), function() {
      return we.disconnectDragSource();
    };
  }, [we, ce]), useIsomorphicLayoutEffect(function() {
    return we.dragPreviewOptions = ie || null, we.reconnect(), function() {
      return we.disconnectDragPreview();
    };
  }, [we, ie]), we;
}
var fastDeepEqual = function ce(ie, me) {
  if (ie === me) return !0;
  if (ie && me && typeof ie == "object" && typeof me == "object") {
    if (ie.constructor !== me.constructor) return !1;
    var we, Re, je;
    if (Array.isArray(ie)) {
      if (we = ie.length, we != me.length) return !1;
      for (Re = we; Re-- !== 0; )
        if (!ce(ie[Re], me[Re])) return !1;
      return !0;
    }
    if (ie.constructor === RegExp) return ie.source === me.source && ie.flags === me.flags;
    if (ie.valueOf !== Object.prototype.valueOf) return ie.valueOf() === me.valueOf();
    if (ie.toString !== Object.prototype.toString) return ie.toString() === me.toString();
    if (je = Object.keys(ie), we = je.length, we !== Object.keys(me).length) return !1;
    for (Re = we; Re-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(me, je[Re])) return !1;
    for (Re = we; Re-- !== 0; ) {
      var Ue = je[Re];
      if (!ce(ie[Ue], me[Ue])) return !1;
    }
    return !0;
  }
  return ie !== ie && me !== me;
};
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqual);
function _slicedToArray$4(ce, ie) {
  return _arrayWithHoles$4(ce) || _iterableToArrayLimit$4(ce, ie) || _unsupportedIterableToArray$4(ce, ie) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$4(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$4(ce, ie);
  }
}
function _arrayLikeToArray$4(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$4(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$4(ce) {
  if (Array.isArray(ce)) return ce;
}
function useCollector(ce, ie, me) {
  var we = useState(function() {
    return ie(ce);
  }), Re = _slicedToArray$4(we, 2), je = Re[0], Ue = Re[1], qe = useCallback(function() {
    var Ge = ie(ce);
    equal(je, Ge) || (Ue(Ge), me && me());
  }, [je, ce, me]);
  return useIsomorphicLayoutEffect(qe), [je, qe];
}
function _slicedToArray$3(ce, ie) {
  return _arrayWithHoles$3(ce) || _iterableToArrayLimit$3(ce, ie) || _unsupportedIterableToArray$3(ce, ie) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$3(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$3(ce, ie);
  }
}
function _arrayLikeToArray$3(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$3(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$3(ce) {
  if (Array.isArray(ce)) return ce;
}
function useMonitorOutput(ce, ie, me) {
  var we = useCollector(ce, ie, me), Re = _slicedToArray$3(we, 2), je = Re[0], Ue = Re[1];
  return useIsomorphicLayoutEffect(function() {
    var Ge = ce.getHandlerId();
    if (Ge != null)
      return ce.subscribeToStateChange(Ue, {
        handlerIds: [Ge]
      });
  }, [ce, Ue]), je;
}
function useCollectedProps(ce, ie, me) {
  return useMonitorOutput(ie, ce || function() {
    return {};
  }, function() {
    return me.reconnect();
  });
}
function useConnectDragSource(ce) {
  return useMemo$1(function() {
    return ce.hooks.dragSource();
  }, [ce]);
}
function useConnectDragPreview(ce) {
  return useMemo$1(function() {
    return ce.hooks.dragPreview();
  }, [ce]);
}
function useDrag(ce, ie) {
  var me = useOptionalFactory(ce, ie);
  invariant(!me.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  var we = useDragSourceMonitor(), Re = useDragSourceConnector(me.options, me.previewOptions);
  return useRegisteredDragSource(me, we, Re), [useCollectedProps(me.collect, we, Re), useConnectDragSource(Re), useConnectDragPreview(Re)];
}
function useAccept(ce) {
  var ie = ce.accept;
  return useMemo$1(function() {
    return invariant(ce.accept != null, "accept must be defined"), Array.isArray(ie) ? ie : [ie];
  }, [ie]);
}
function _classCallCheck$4(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, we.key, we);
  }
}
function _createClass$4(ce, ie, me) {
  return ie && _defineProperties$4(ce.prototype, ie), ce;
}
function _defineProperty$7(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
var DropTargetImpl = /* @__PURE__ */ function() {
  function ce(ie, me) {
    _classCallCheck$4(this, ce), _defineProperty$7(this, "spec", void 0), _defineProperty$7(this, "monitor", void 0), this.spec = ie, this.monitor = me;
  }
  return _createClass$4(ce, [{
    key: "canDrop",
    value: function() {
      var me = this.spec, we = this.monitor;
      return me.canDrop ? me.canDrop(we.getItem(), we) : !0;
    }
  }, {
    key: "hover",
    value: function() {
      var me = this.spec, we = this.monitor;
      me.hover && me.hover(we.getItem(), we);
    }
  }, {
    key: "drop",
    value: function() {
      var me = this.spec, we = this.monitor;
      if (me.drop)
        return me.drop(we.getItem(), we);
    }
  }]), ce;
}();
function useDropTarget(ce, ie) {
  var me = useMemo$1(function() {
    return new DropTargetImpl(ce, ie);
  }, [ie]);
  return useEffect(function() {
    me.spec = ce;
  }, [ce]), me;
}
function _slicedToArray$2(ce, ie) {
  return _arrayWithHoles$2(ce) || _iterableToArrayLimit$2(ce, ie) || _unsupportedIterableToArray$2(ce, ie) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$2(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$2(ce, ie);
  }
}
function _arrayLikeToArray$2(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$2(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$2(ce) {
  if (Array.isArray(ce)) return ce;
}
function useRegisteredDropTarget(ce, ie, me) {
  var we = useDragDropManager(), Re = useDropTarget(ce, ie), je = useAccept(ce);
  useIsomorphicLayoutEffect(function() {
    var qe = registerTarget(je, Re, we), Ge = _slicedToArray$2(qe, 2), Xe = Ge[0], ot = Ge[1];
    return ie.receiveHandlerId(Xe), me.receiveHandlerId(Xe), ot;
  }, [we, ie, Re, me, je.map(function(Ue) {
    return Ue.toString();
  }).join("|")]);
}
function useDropTargetMonitor() {
  var ce = useDragDropManager();
  return useMemo$1(function() {
    return new DropTargetMonitorImpl(ce);
  }, [ce]);
}
function useDropTargetConnector(ce) {
  var ie = useDragDropManager(), me = useMemo$1(function() {
    return new TargetConnector(ie.getBackend());
  }, [ie]);
  return useIsomorphicLayoutEffect(function() {
    return me.dropTargetOptions = ce || null, me.reconnect(), function() {
      return me.disconnectDropTarget();
    };
  }, [ce]), me;
}
function useConnectDropTarget(ce) {
  return useMemo$1(function() {
    return ce.hooks.dropTarget();
  }, [ce]);
}
function useDrop(ce, ie) {
  var me = useOptionalFactory(ce, ie), we = useDropTargetMonitor(), Re = useDropTargetConnector(me.options);
  return useRegisteredDropTarget(me, we, Re), [useCollectedProps(me.collect, we, Re), useConnectDropTarget(Re)];
}
function _slicedToArray$1(ce, ie) {
  return _arrayWithHoles$1(ce) || _iterableToArrayLimit$1(ce, ie) || _unsupportedIterableToArray$1(ce, ie) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray$1(ce, ie);
    var me = Object.prototype.toString.call(ce).slice(8, -1);
    if (me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set") return Array.from(ce);
    if (me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me)) return _arrayLikeToArray$1(ce, ie);
  }
}
function _arrayLikeToArray$1(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = new Array(ie); me < ie; me++)
    we[me] = ce[me];
  return we;
}
function _iterableToArrayLimit$1(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we = [], Re = !0, je = !1, Ue, qe;
    try {
      for (me = me.call(ce); !(Re = (Ue = me.next()).done) && (we.push(Ue.value), !(ie && we.length === ie)); Re = !0)
        ;
    } catch (Ge) {
      je = !0, qe = Ge;
    } finally {
      try {
        !Re && me.return != null && me.return();
      } finally {
        if (je) throw qe;
      }
    }
    return we;
  }
}
function _arrayWithHoles$1(ce) {
  if (Array.isArray(ce)) return ce;
}
function useDragLayer(ce) {
  var ie = useDragDropManager(), me = ie.getMonitor(), we = useCollector(me, ce), Re = _slicedToArray$1(we, 2), je = Re[0], Ue = Re[1];
  return useEffect(function() {
    return me.subscribeToOffsetChange(Ue);
  }), useEffect(function() {
    return me.subscribeToStateChange(Ue);
  }), je;
}
function _inheritsLoose(ce, ie) {
  ce.prototype = Object.create(ie.prototype), ce.prototype.constructor = ce, _setPrototypeOf$4(ce, ie);
}
var safeIsNaN = Number.isNaN || function(ie) {
  return typeof ie == "number" && ie !== ie;
};
function isEqual(ce, ie) {
  return !!(ce === ie || safeIsNaN(ce) && safeIsNaN(ie));
}
function areInputsEqual(ce, ie) {
  if (ce.length !== ie.length)
    return !1;
  for (var me = 0; me < ce.length; me++)
    if (!isEqual(ce[me], ie[me]))
      return !1;
  return !0;
}
function memoizeOne(ce, ie) {
  ie === void 0 && (ie = areInputsEqual);
  var me, we = [], Re, je = !1;
  function Ue() {
    for (var qe = [], Ge = 0; Ge < arguments.length; Ge++)
      qe[Ge] = arguments[Ge];
    return je && me === this && ie(qe, we) || (Re = ce.apply(this, qe), je = !0, me = this, we = qe), Re;
  }
  return Ue;
}
var hasNativePerformanceNow = typeof performance == "object" && typeof performance.now == "function", now$1 = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(ce) {
  cancelAnimationFrame(ce.id);
}
function requestTimeout(ce, ie) {
  var me = now$1();
  function we() {
    now$1() - me >= ie ? ce.call(null) : Re.id = requestAnimationFrame(we);
  }
  var Re = {
    id: requestAnimationFrame(we)
  };
  return Re;
}
var size = -1;
function getScrollbarSize(ce) {
  if (ce === void 0 && (ce = !1), size === -1 || ce) {
    var ie = document.createElement("div"), me = ie.style;
    me.width = "50px", me.height = "50px", me.overflow = "scroll", document.body.appendChild(ie), size = ie.offsetWidth - ie.clientWidth, document.body.removeChild(ie);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(ce) {
  if (ce === void 0 && (ce = !1), cachedRTLResult === null || ce) {
    var ie = document.createElement("div"), me = ie.style;
    me.width = "50px", me.height = "50px", me.overflow = "scroll", me.direction = "rtl";
    var we = document.createElement("div"), Re = we.style;
    return Re.width = "100px", Re.height = "100px", ie.appendChild(we), document.body.appendChild(ie), ie.scrollLeft > 0 ? cachedRTLResult = "positive-descending" : (ie.scrollLeft = 1, ie.scrollLeft === 0 ? cachedRTLResult = "negative" : cachedRTLResult = "positive-ascending"), document.body.removeChild(ie), cachedRTLResult;
  }
  return cachedRTLResult;
}
process.env.NODE_ENV;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150, defaultItemKey$1 = function(ie, me) {
  return ie;
}, devWarningsDirection = null, devWarningsTagName$1 = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (devWarningsDirection = /* @__PURE__ */ new WeakSet(), devWarningsTagName$1 = /* @__PURE__ */ new WeakSet());
function createListComponent(ce) {
  var ie, me = ce.getItemOffset, we = ce.getEstimatedTotalSize, Re = ce.getItemSize, je = ce.getOffsetForIndexAndAlignment, Ue = ce.getStartIndexForOffset, qe = ce.getStopIndexForStartIndex, Ge = ce.initInstanceProps, Xe = ce.shouldResetStyleCacheOnItemSizeChange, ot = ce.validateProps;
  return ie = /* @__PURE__ */ function(vt) {
    _inheritsLoose(bt, vt);
    function bt(wt) {
      var St;
      return St = vt.call(this, wt) || this, St._instanceProps = Ge(St.props, _assertThisInitialized$4(St)), St._outerRef = void 0, St._resetIsScrollingTimeoutId = null, St.state = {
        instance: _assertThisInitialized$4(St),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof St.props.initialScrollOffset == "number" ? St.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, St._callOnItemsRendered = void 0, St._callOnItemsRendered = memoizeOne(function(It, Pt, kt, Ot) {
        return St.props.onItemsRendered({
          overscanStartIndex: It,
          overscanStopIndex: Pt,
          visibleStartIndex: kt,
          visibleStopIndex: Ot
        });
      }), St._callOnScroll = void 0, St._callOnScroll = memoizeOne(function(It, Pt, kt) {
        return St.props.onScroll({
          scrollDirection: It,
          scrollOffset: Pt,
          scrollUpdateWasRequested: kt
        });
      }), St._getItemStyle = void 0, St._getItemStyle = function(It) {
        var Pt = St.props, kt = Pt.direction, Ot = Pt.itemSize, Jr = Pt.layout, en = St._getItemStyleCache(Xe && Ot, Xe && Jr, Xe && kt), nn;
        if (en.hasOwnProperty(It))
          nn = en[It];
        else {
          var ln = me(St.props, It, St._instanceProps), fn = Re(St.props, It, St._instanceProps), vn = kt === "horizontal" || Jr === "horizontal", Tn = kt === "rtl", xn = vn ? ln : 0;
          en[It] = nn = {
            position: "absolute",
            left: Tn ? void 0 : xn,
            right: Tn ? xn : void 0,
            top: vn ? 0 : ln,
            height: vn ? "100%" : fn,
            width: vn ? fn : "100%"
          };
        }
        return nn;
      }, St._getItemStyleCache = void 0, St._getItemStyleCache = memoizeOne(function(It, Pt, kt) {
        return {};
      }), St._onScrollHorizontal = function(It) {
        var Pt = It.currentTarget, kt = Pt.clientWidth, Ot = Pt.scrollLeft, Jr = Pt.scrollWidth;
        St.setState(function(en) {
          if (en.scrollOffset === Ot)
            return null;
          var nn = St.props.direction, ln = Ot;
          if (nn === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                ln = -Ot;
                break;
              case "positive-descending":
                ln = Jr - kt - Ot;
                break;
            }
          return ln = Math.max(0, Math.min(ln, Jr - kt)), {
            isScrolling: !0,
            scrollDirection: en.scrollOffset < ln ? "forward" : "backward",
            scrollOffset: ln,
            scrollUpdateWasRequested: !1
          };
        }, St._resetIsScrollingDebounced);
      }, St._onScrollVertical = function(It) {
        var Pt = It.currentTarget, kt = Pt.clientHeight, Ot = Pt.scrollHeight, Jr = Pt.scrollTop;
        St.setState(function(en) {
          if (en.scrollOffset === Jr)
            return null;
          var nn = Math.max(0, Math.min(Jr, Ot - kt));
          return {
            isScrolling: !0,
            scrollDirection: en.scrollOffset < nn ? "forward" : "backward",
            scrollOffset: nn,
            scrollUpdateWasRequested: !1
          };
        }, St._resetIsScrollingDebounced);
      }, St._outerRefSetter = function(It) {
        var Pt = St.props.outerRef;
        St._outerRef = It, typeof Pt == "function" ? Pt(It) : Pt != null && typeof Pt == "object" && Pt.hasOwnProperty("current") && (Pt.current = It);
      }, St._resetIsScrollingDebounced = function() {
        St._resetIsScrollingTimeoutId !== null && cancelTimeout(St._resetIsScrollingTimeoutId), St._resetIsScrollingTimeoutId = requestTimeout(St._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      }, St._resetIsScrolling = function() {
        St._resetIsScrollingTimeoutId = null, St.setState({
          isScrolling: !1
        }, function() {
          St._getItemStyleCache(-1, null);
        });
      }, St;
    }
    bt.getDerivedStateFromProps = function(St, It) {
      return validateSharedProps$1(St, It), ot(St), null;
    };
    var Tt = bt.prototype;
    return Tt.scrollTo = function(St) {
      St = Math.max(0, St), this.setState(function(It) {
        return It.scrollOffset === St ? null : {
          scrollDirection: It.scrollOffset < St ? "forward" : "backward",
          scrollOffset: St,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, Tt.scrollToItem = function(St, It) {
      It === void 0 && (It = "auto");
      var Pt = this.props, kt = Pt.itemCount, Ot = Pt.layout, Jr = this.state.scrollOffset;
      St = Math.max(0, Math.min(St, kt - 1));
      var en = 0;
      if (this._outerRef) {
        var nn = this._outerRef;
        Ot === "vertical" ? en = nn.scrollWidth > nn.clientWidth ? getScrollbarSize() : 0 : en = nn.scrollHeight > nn.clientHeight ? getScrollbarSize() : 0;
      }
      this.scrollTo(je(this.props, St, It, Jr, this._instanceProps, en));
    }, Tt.componentDidMount = function() {
      var St = this.props, It = St.direction, Pt = St.initialScrollOffset, kt = St.layout;
      if (typeof Pt == "number" && this._outerRef != null) {
        var Ot = this._outerRef;
        It === "horizontal" || kt === "horizontal" ? Ot.scrollLeft = Pt : Ot.scrollTop = Pt;
      }
      this._callPropsCallbacks();
    }, Tt.componentDidUpdate = function() {
      var St = this.props, It = St.direction, Pt = St.layout, kt = this.state, Ot = kt.scrollOffset, Jr = kt.scrollUpdateWasRequested;
      if (Jr && this._outerRef != null) {
        var en = this._outerRef;
        if (It === "horizontal" || Pt === "horizontal")
          if (It === "rtl")
            switch (getRTLOffsetType()) {
              case "negative":
                en.scrollLeft = -Ot;
                break;
              case "positive-ascending":
                en.scrollLeft = Ot;
                break;
              default:
                var nn = en.clientWidth, ln = en.scrollWidth;
                en.scrollLeft = ln - nn - Ot;
                break;
            }
          else
            en.scrollLeft = Ot;
        else
          en.scrollTop = Ot;
      }
      this._callPropsCallbacks();
    }, Tt.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && cancelTimeout(this._resetIsScrollingTimeoutId);
    }, Tt.render = function() {
      var St = this.props, It = St.children, Pt = St.className, kt = St.direction, Ot = St.height, Jr = St.innerRef, en = St.innerElementType, nn = St.innerTagName, ln = St.itemCount, fn = St.itemData, vn = St.itemKey, Tn = vn === void 0 ? defaultItemKey$1 : vn, xn = St.layout, bn = St.outerElementType, Sn = St.outerTagName, Cn = St.style, kn = St.useIsScrolling, cn = St.width, gn = this.state.isScrolling, an = kt === "horizontal" || xn === "horizontal", un = an ? this._onScrollHorizontal : this._onScrollVertical, pn = this._getRangeToRender(), hn = pn[0], An = pn[1], In = [];
      if (ln > 0)
        for (var qn = hn; qn <= An; qn++)
          In.push(createElement$1(It, {
            data: fn,
            key: Tn(qn, fn),
            index: qn,
            isScrolling: kn ? gn : void 0,
            style: this._getItemStyle(qn)
          }));
      var si = we(this.props, this._instanceProps);
      return createElement$1(bn || Sn || "div", {
        className: Pt,
        onScroll: un,
        ref: this._outerRefSetter,
        style: _extends$j({
          position: "relative",
          height: Ot,
          width: cn,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: kt
        }, Cn)
      }, createElement$1(en || nn || "div", {
        children: In,
        ref: Jr,
        style: {
          height: an ? "100%" : si,
          pointerEvents: gn ? "none" : void 0,
          width: an ? si : "100%"
        }
      }));
    }, Tt._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var St = this.props.itemCount;
        if (St > 0) {
          var It = this._getRangeToRender(), Pt = It[0], kt = It[1], Ot = It[2], Jr = It[3];
          this._callOnItemsRendered(Pt, kt, Ot, Jr);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var en = this.state, nn = en.scrollDirection, ln = en.scrollOffset, fn = en.scrollUpdateWasRequested;
        this._callOnScroll(nn, ln, fn);
      }
    }, Tt._getRangeToRender = function() {
      var St = this.props, It = St.itemCount, Pt = St.overscanCount, kt = this.state, Ot = kt.isScrolling, Jr = kt.scrollDirection, en = kt.scrollOffset;
      if (It === 0)
        return [0, 0, 0, 0];
      var nn = Ue(this.props, en, this._instanceProps), ln = qe(this.props, nn, en, this._instanceProps), fn = !Ot || Jr === "backward" ? Math.max(1, Pt) : 1, vn = !Ot || Jr === "forward" ? Math.max(1, Pt) : 1;
      return [Math.max(0, nn - fn), Math.max(0, Math.min(It - 1, ln + vn)), nn, ln];
    }, bt;
  }(PureComponent), ie.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, ie;
}
var validateSharedProps$1 = function(ie, me) {
  var we = ie.children, Re = ie.direction, je = ie.height, Ue = ie.layout, qe = ie.innerTagName, Ge = ie.outerTagName, Xe = ie.width, ot = me.instance;
  if (process.env.NODE_ENV !== "production") {
    (qe != null || Ge != null) && devWarningsTagName$1 && !devWarningsTagName$1.has(ot) && (devWarningsTagName$1.add(ot), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var vt = Re === "horizontal" || Ue === "horizontal";
    switch (Re) {
      case "horizontal":
      case "vertical":
        devWarningsDirection && !devWarningsDirection.has(ot) && (devWarningsDirection.add(ot), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + Re + '" was specified.'));
    }
    switch (Ue) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + Ue + '" was specified.'));
    }
    if (we == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (we === null ? "null" : typeof we) + '" was specified.'));
    if (vt && typeof Xe != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (Xe === null ? "null" : typeof Xe) + '" was specified.'));
    if (!vt && typeof je != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (je === null ? "null" : typeof je) + '" was specified.'));
  }
}, FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function(ie, me) {
    var we = ie.itemSize;
    return me * we;
  },
  getItemSize: function(ie, me) {
    var we = ie.itemSize;
    return we;
  },
  getEstimatedTotalSize: function(ie) {
    var me = ie.itemCount, we = ie.itemSize;
    return we * me;
  },
  getOffsetForIndexAndAlignment: function(ie, me, we, Re, je, Ue) {
    var qe = ie.direction, Ge = ie.height, Xe = ie.itemCount, ot = ie.itemSize, vt = ie.layout, bt = ie.width, Tt = qe === "horizontal" || vt === "horizontal", wt = Tt ? bt : Ge, St = Math.max(0, Xe * ot - wt), It = Math.min(St, me * ot), Pt = Math.max(0, me * ot - wt + ot + Ue);
    switch (we === "smart" && (Re >= Pt - wt && Re <= It + wt ? we = "auto" : we = "center"), we) {
      case "start":
        return It;
      case "end":
        return Pt;
      case "center": {
        var kt = Math.round(Pt + (It - Pt) / 2);
        return kt < Math.ceil(wt / 2) ? 0 : kt > St + Math.floor(wt / 2) ? St : kt;
      }
      case "auto":
      default:
        return Re >= Pt && Re <= It ? Re : Re < Pt ? Pt : It;
    }
  },
  getStartIndexForOffset: function(ie, me) {
    var we = ie.itemCount, Re = ie.itemSize;
    return Math.max(0, Math.min(we - 1, Math.floor(me / Re)));
  },
  getStopIndexForStartIndex: function(ie, me, we) {
    var Re = ie.direction, je = ie.height, Ue = ie.itemCount, qe = ie.itemSize, Ge = ie.layout, Xe = ie.width, ot = Re === "horizontal" || Ge === "horizontal", vt = me * qe, bt = ot ? Xe : je, Tt = Math.ceil((bt + we - vt) / qe);
    return Math.max(0, Math.min(
      Ue - 1,
      me + Tt - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(ie) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(ie) {
    var me = ie.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof me != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (me === null ? "null" : typeof me) + '" was specified.'));
  }
});
function $parcel$export(ce, ie, me, we) {
  Object.defineProperty(ce, ie, { get: me, set: we, enumerable: !0, configurable: !0 });
}
const $89e93131aae74bd9$export$feef243b04ff4151 = createContext(null);
function $89e93131aae74bd9$export$367b0f2231a90ba0() {
  const ce = useContext($89e93131aae74bd9$export$feef243b04ff4151);
  if (ce === null) throw new Error("No Tree Api Provided");
  return ce;
}
const $89e93131aae74bd9$export$f6d467aa8b3786af = createContext(null);
function $89e93131aae74bd9$export$fd23f19d5d8f3033() {
  const ce = useContext($89e93131aae74bd9$export$f6d467aa8b3786af);
  if (ce === null) throw new Error("Provide a NodesContext");
  return ce;
}
const $89e93131aae74bd9$export$2d5c5ceac203fc1e = createContext(null);
function $89e93131aae74bd9$export$4930f6bf413be70e() {
  const ce = useContext($89e93131aae74bd9$export$2d5c5ceac203fc1e);
  if (ce === null) throw new Error("Provide a DnDContext");
  return ce;
}
const $89e93131aae74bd9$export$d0c71bc5e3e2d897 = createContext(0);
function $89e93131aae74bd9$export$83a4f9dc3b36edb8() {
  useContext($89e93131aae74bd9$export$d0c71bc5e3e2d897);
}
var $bfece7c4aed4e9c4$exports = {};
$parcel$export($bfece7c4aed4e9c4$exports, "TreeApi", () => $bfece7c4aed4e9c4$export$e2da3477247342d1);
var $0e6083160f4b36ed$exports = {};
$parcel$export($0e6083160f4b36ed$exports, "bound", () => $0e6083160f4b36ed$export$adf7c0fe6059d774);
$parcel$export($0e6083160f4b36ed$exports, "isItem", () => $0e6083160f4b36ed$export$5318634f2ee07019);
$parcel$export($0e6083160f4b36ed$exports, "isClosed", () => $0e6083160f4b36ed$export$4210f5ea57fbae57);
$parcel$export($0e6083160f4b36ed$exports, "isDescendant", () => $0e6083160f4b36ed$export$8503f9d2928f9a64);
$parcel$export($0e6083160f4b36ed$exports, "indexOf", () => $0e6083160f4b36ed$export$305f7d4e9d4624f2);
$parcel$export($0e6083160f4b36ed$exports, "noop", () => $0e6083160f4b36ed$export$8793edee2d425525);
$parcel$export($0e6083160f4b36ed$exports, "dfs", () => $0e6083160f4b36ed$export$51b654aff22fc5a6);
$parcel$export($0e6083160f4b36ed$exports, "walk", () => $0e6083160f4b36ed$export$588732934346abbf);
$parcel$export($0e6083160f4b36ed$exports, "focusNextElement", () => $0e6083160f4b36ed$export$3b0237e8566c8d65);
$parcel$export($0e6083160f4b36ed$exports, "focusPrevElement", () => $0e6083160f4b36ed$export$33b47db07a82b2fb);
$parcel$export($0e6083160f4b36ed$exports, "access", () => $0e6083160f4b36ed$export$9bb0e144ba4929ca);
$parcel$export($0e6083160f4b36ed$exports, "identifyNull", () => $0e6083160f4b36ed$export$611823266272db76);
$parcel$export($0e6083160f4b36ed$exports, "identify", () => $0e6083160f4b36ed$export$65e5b62a4c490288);
$parcel$export($0e6083160f4b36ed$exports, "mergeRefs", () => $0e6083160f4b36ed$export$c9058316764c140e);
$parcel$export($0e6083160f4b36ed$exports, "safeRun", () => $0e6083160f4b36ed$export$c6d63370cef03886);
$parcel$export($0e6083160f4b36ed$exports, "waitFor", () => $0e6083160f4b36ed$export$9bbfceb27f687c1b);
$parcel$export($0e6083160f4b36ed$exports, "getInsertIndex", () => $0e6083160f4b36ed$export$e12bf2314d0bc2a9);
$parcel$export($0e6083160f4b36ed$exports, "getInsertParentId", () => $0e6083160f4b36ed$export$58fe32731f07ed56);
function $0e6083160f4b36ed$export$adf7c0fe6059d774(ce, ie, me) {
  return Math.max(Math.min(ce, me), ie);
}
function $0e6083160f4b36ed$export$5318634f2ee07019(ce) {
  return ce && ce.isLeaf;
}
function $0e6083160f4b36ed$export$4210f5ea57fbae57(ce) {
  return ce && ce.isInternal && !ce.isOpen;
}
const $0e6083160f4b36ed$export$8503f9d2928f9a64 = (ce, ie) => {
  let me = ce;
  for (; me; ) {
    if (me.id === ie.id) return !0;
    me = me.parent;
  }
  return !1;
}, $0e6083160f4b36ed$export$305f7d4e9d4624f2 = (ce) => {
  if (!ce.parent) throw Error("Node does not have a parent");
  return ce.parent.children.findIndex((ie) => ie.id === ce.id);
};
function $0e6083160f4b36ed$export$8793edee2d425525() {
}
function $0e6083160f4b36ed$export$51b654aff22fc5a6(ce, ie) {
  if (!ce) return null;
  if (ce.id === ie) return ce;
  if (ce.children) for (let me of ce.children) {
    const we = $0e6083160f4b36ed$export$51b654aff22fc5a6(me, ie);
    if (we) return we;
  }
  return null;
}
function $0e6083160f4b36ed$export$588732934346abbf(ce, ie) {
  if (ie(ce), ce.children) for (let me of ce.children) $0e6083160f4b36ed$export$588732934346abbf(me, ie);
}
function $0e6083160f4b36ed$export$3b0237e8566c8d65(ce) {
  const ie = $0e6083160f4b36ed$var$getFocusable(ce);
  let me;
  for (let we = 0; we < ie.length; ++we)
    if (ie[we] === ce) {
      me = $0e6083160f4b36ed$var$nextItem(ie, we);
      break;
    }
  me == null || me.focus();
}
function $0e6083160f4b36ed$export$33b47db07a82b2fb(ce) {
  const ie = $0e6083160f4b36ed$var$getFocusable(ce);
  let me;
  for (let we = 0; we < ie.length; ++we)
    if (ie[we] === ce) {
      me = $0e6083160f4b36ed$var$prevItem(ie, we);
      break;
    }
  me == null || me.focus();
}
function $0e6083160f4b36ed$var$nextItem(ce, ie) {
  return ie + 1 < ce.length ? ce[ie + 1] : ce[0];
}
function $0e6083160f4b36ed$var$prevItem(ce, ie) {
  return ie - 1 >= 0 ? ce[ie - 1] : ce[ce.length - 1];
}
function $0e6083160f4b36ed$var$getFocusable(ce) {
  return Array.from(document.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)')).filter((ie) => ie === ce || !ce.contains(ie));
}
function $0e6083160f4b36ed$export$9bb0e144ba4929ca(ce, ie) {
  return typeof ie == "boolean" ? ie : typeof ie == "string" ? ce[ie] : ie(ce);
}
function $0e6083160f4b36ed$export$611823266272db76(ce) {
  return ce === null ? null : $0e6083160f4b36ed$export$65e5b62a4c490288(ce);
}
function $0e6083160f4b36ed$export$65e5b62a4c490288(ce) {
  return typeof ce == "string" ? ce : ce.id;
}
function $0e6083160f4b36ed$export$c9058316764c140e(...ce) {
  return (ie) => {
    ce.forEach((me) => {
      typeof me == "function" ? me(ie) : me != null && (me.current = ie);
    });
  };
}
function $0e6083160f4b36ed$export$c6d63370cef03886(ce, ...ie) {
  if (ce) return ce(...ie);
}
function $0e6083160f4b36ed$export$9bbfceb27f687c1b(ce) {
  return new Promise((ie, me) => {
    let we = 0;
    function Re() {
      we += 1, we === 100 && me(), ce() ? ie() : setTimeout(Re, 10);
    }
    Re();
  });
}
function $0e6083160f4b36ed$export$e12bf2314d0bc2a9(ce) {
  var me;
  const ie = ce.focusedNode;
  return ie ? ie.isOpen ? 0 : ie.parent ? ie.childIndex + 1 : 0 : ((me = ce.root.children) == null ? void 0 : me.length) ?? 0;
}
function $0e6083160f4b36ed$export$58fe32731f07ed56(ce) {
  const ie = ce.focusedNode;
  return ie ? ie.isOpen ? ie.id : ie.parent && !ie.parent.isRoot ? ie.parent.id : null : null;
}
const $fb4c15d8425379bd$var$placeholderStyle = {
  display: "flex",
  alignItems: "center",
  zIndex: 1
}, $fb4c15d8425379bd$var$lineStyle = {
  flex: 1,
  height: "2px",
  background: "#4B91E2",
  borderRadius: "1px"
}, $fb4c15d8425379bd$var$circleStyle = {
  width: "4px",
  height: "4px",
  boxShadow: "0 0 0 3px #4B91E2",
  borderRadius: "50%"
}, $fb4c15d8425379bd$export$6cb3c16721363d11 = /* @__PURE__ */ React__default.memo(function({ top: ie, left: me, indent: we }) {
  const Re = {
    position: "absolute",
    pointerEvents: "none",
    top: ie - 2 + "px",
    left: me + "px",
    right: we + "px"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    style: {
      ...$fb4c15d8425379bd$var$placeholderStyle,
      ...Re
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        style: {
          ...$fb4c15d8425379bd$var$circleStyle
        }
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        style: {
          ...$fb4c15d8425379bd$var$lineStyle
        }
      })
    ]
  });
});
function $164e874d21fcd87e$export$f9c541e71856c524({ node: ce, attrs: ie, innerRef: me, children: we }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ...ie,
    ref: me,
    onFocus: (Re) => Re.stopPropagation(),
    onClick: ce.handleClick,
    children: we
  });
}
function $c4edd692d5290432$export$909e23cbfbbd3351(ce) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    ref: ce.dragHandle,
    style: ce.style,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        onClick: (ie) => {
          ie.stopPropagation(), ce.node.toggle();
        },
        children: ce.node.isLeaf ? "🌳" : ce.node.isOpen ? "🗁" : "🗀"
      }),
      " ",
      ce.node.isEditing ? /* @__PURE__ */ jsxRuntimeExports.jsx($c4edd692d5290432$var$Edit, {
        ...ce
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx($c4edd692d5290432$var$Show, {
        ...ce
      })
    ]
  });
}
function $c4edd692d5290432$var$Show(ce) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: ce.node.data.name
    })
  });
}
function $c4edd692d5290432$var$Edit({ node: ce }) {
  const ie = useRef();
  return useEffect(() => {
    var me, we;
    (me = ie.current) == null || me.focus(), (we = ie.current) == null || we.select();
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx("input", {
    ref: ie,
    // @ts-ignore
    defaultValue: ce.data.name,
    onBlur: () => ce.reset(),
    onKeyDown: (me) => {
      var we;
      me.key === "Escape" && ce.reset(), me.key === "Enter" && ce.submit(((we = ie.current) == null ? void 0 : we.value) || "");
    }
  });
}
function $21783d2b0251be67$export$e1a8e267487c59d1(ce) {
  return {
    type: "EDIT",
    id: ce
  };
}
function $21783d2b0251be67$export$1650419e431d3ba3(ce = {
  id: null
}, ie) {
  return ie.type === "EDIT" ? {
    ...ce,
    id: ie.id
  } : ce;
}
function $c27b8e9863235052$export$d7ddd398f22d79ef(ce) {
  return {
    type: "FOCUS",
    id: ce
  };
}
function $c27b8e9863235052$export$6b6c976e46a06288() {
  return {
    type: "TREE_BLUR"
  };
}
function $c27b8e9863235052$export$1650419e431d3ba3(ce = {
  id: null,
  treeFocused: !1
}, ie) {
  return ie.type === "FOCUS" ? {
    ...ce,
    id: ie.id,
    treeFocused: !0
  } : ie.type === "TREE_BLUR" ? {
    ...ce,
    treeFocused: !1
  } : ce;
}
var $096e74084443e9a3$exports = {};
$parcel$export($096e74084443e9a3$exports, "NodeApi", () => $096e74084443e9a3$export$d4b903da0f522dc8);
class $096e74084443e9a3$export$d4b903da0f522dc8 {
  constructor(ie) {
    M1(this, "handleClick", (ie) => {
      ie.metaKey && !this.tree.props.disableMultiSelection ? this.isSelected ? this.deselect() : this.selectMulti() : ie.shiftKey && !this.tree.props.disableMultiSelection ? this.selectContiguous() : (this.select(), this.activate());
    });
    this.tree = ie.tree, this.id = ie.id, this.data = ie.data, this.level = ie.level, this.children = ie.children, this.parent = ie.parent, this.isDraggable = ie.isDraggable, this.rowIndex = ie.rowIndex;
  }
  get isRoot() {
    return this.id === $81080a351c006222$export$ec71a3379b43ae5c;
  }
  get isLeaf() {
    return !Array.isArray(this.children);
  }
  get isInternal() {
    return !this.isLeaf;
  }
  get isOpen() {
    return this.isLeaf ? !1 : this.tree.isOpen(this.id);
  }
  get isClosed() {
    return this.isLeaf ? !1 : !this.tree.isOpen(this.id);
  }
  get isEditable() {
    return this.tree.isEditable(this.data);
  }
  get isEditing() {
    return this.tree.editingId === this.id;
  }
  get isSelected() {
    return this.tree.isSelected(this.id);
  }
  get isOnlySelection() {
    return this.isSelected && this.tree.hasOneSelection;
  }
  get isSelectedStart() {
    var ie;
    return this.isSelected && !((ie = this.prev) != null && ie.isSelected);
  }
  get isSelectedEnd() {
    var ie;
    return this.isSelected && !((ie = this.next) != null && ie.isSelected);
  }
  get isFocused() {
    return this.tree.isFocused(this.id);
  }
  get isDragging() {
    return this.tree.isDragging(this.id);
  }
  get willReceiveDrop() {
    return this.tree.willReceiveDrop(this.id);
  }
  get state() {
    return {
      isClosed: this.isClosed,
      isDragging: this.isDragging,
      isEditing: this.isEditing,
      isFocused: this.isFocused,
      isInternal: this.isInternal,
      isLeaf: this.isLeaf,
      isOpen: this.isOpen,
      isSelected: this.isSelected,
      isSelectedEnd: this.isSelectedEnd,
      isSelectedStart: this.isSelectedStart,
      willReceiveDrop: this.willReceiveDrop
    };
  }
  get childIndex() {
    return this.parent && this.parent.children ? this.parent.children.findIndex((ie) => ie.id === this.id) : -1;
  }
  get next() {
    return this.rowIndex === null ? null : this.tree.at(this.rowIndex + 1);
  }
  get prev() {
    return this.rowIndex === null ? null : this.tree.at(this.rowIndex - 1);
  }
  get nextSibling() {
    var me;
    const ie = this.childIndex;
    return ((me = this.parent) == null ? void 0 : me.children[ie + 1]) ?? null;
  }
  isAncestorOf(ie) {
    if (!ie) return !1;
    let me = ie;
    for (; me; ) {
      if (me.id === this.id) return !0;
      me = me.parent;
    }
    return !1;
  }
  select() {
    this.tree.select(this);
  }
  deselect() {
    this.tree.deselect(this);
  }
  selectMulti() {
    this.tree.selectMulti(this);
  }
  selectContiguous() {
    this.tree.selectContiguous(this);
  }
  activate() {
    this.tree.activate(this);
  }
  focus() {
    this.tree.focus(this);
  }
  toggle() {
    this.tree.toggle(this);
  }
  open() {
    this.tree.open(this);
  }
  openParents() {
    this.tree.openParents(this);
  }
  close() {
    this.tree.close(this);
  }
  submit(ie) {
    this.tree.submit(this, ie);
  }
  reset() {
    this.tree.reset();
  }
  clone() {
    return new $096e74084443e9a3$export$d4b903da0f522dc8({
      ...this
    });
  }
  edit() {
    return this.tree.edit(this);
  }
}
const $81080a351c006222$export$ec71a3379b43ae5c = "__REACT_ARBORIST_INTERNAL_ROOT__";
function $81080a351c006222$export$882461b6382ed46c(ce) {
  function ie(Re, je, Ue) {
    const qe = ce.accessId(Re), Ge = new $096e74084443e9a3$export$d4b903da0f522dc8({
      tree: ce,
      data: Re,
      level: je,
      parent: Ue,
      id: qe,
      children: null,
      isDraggable: ce.isDraggable(Re),
      rowIndex: null
    }), Xe = ce.accessChildren(Re);
    return Xe && (Ge.children = Xe.map((ot) => ie(ot, je + 1, Ge))), Ge;
  }
  const me = new $096e74084443e9a3$export$d4b903da0f522dc8({
    tree: ce,
    id: $81080a351c006222$export$ec71a3379b43ae5c,
    // @ts-ignore
    data: {
      id: $81080a351c006222$export$ec71a3379b43ae5c
    },
    level: -1,
    parent: null,
    children: null,
    isDraggable: !0,
    rowIndex: null
  }), we = ce.props.data ?? [];
  return me.children = we.map((Re) => ie(Re, 0, me)), me;
}
const $3c0bad2888bcd4bc$export$e324594224ef24da = {
  open(ce, ie) {
    return {
      type: "VISIBILITY_OPEN",
      id: ce,
      filtered: ie
    };
  },
  close(ce, ie) {
    return {
      type: "VISIBILITY_CLOSE",
      id: ce,
      filtered: ie
    };
  },
  toggle(ce, ie) {
    return {
      type: "VISIBILITY_TOGGLE",
      id: ce,
      filtered: ie
    };
  },
  clear(ce) {
    return {
      type: "VISIBILITY_CLEAR",
      filtered: ce
    };
  }
};
function $3c0bad2888bcd4bc$var$openMapReducer(ce = {}, ie) {
  if (ie.type === "VISIBILITY_OPEN") return {
    ...ce,
    [ie.id]: !0
  };
  if (ie.type === "VISIBILITY_CLOSE") return {
    ...ce,
    [ie.id]: !1
  };
  if (ie.type === "VISIBILITY_TOGGLE") {
    const me = ce[ie.id];
    return {
      ...ce,
      [ie.id]: !me
    };
  } else return ie.type === "VISIBILITY_CLEAR" ? {} : ce;
}
function $3c0bad2888bcd4bc$export$1650419e431d3ba3(ce = {
  filtered: {},
  unfiltered: {}
}, ie) {
  return ie.type.startsWith("VISIBILITY") ? ie.filtered ? {
    ...ce,
    filtered: $3c0bad2888bcd4bc$var$openMapReducer(ce.filtered, ie)
  } : {
    ...ce,
    unfiltered: $3c0bad2888bcd4bc$var$openMapReducer(ce.unfiltered, ie)
  } : ce;
}
const $6ad32e02250c922e$export$d4c72bab9d6cc13a = (ce) => ({
  nodes: {
    // Changes together
    open: {
      filtered: {},
      unfiltered: (ce == null ? void 0 : ce.initialOpenState) ?? {}
    },
    focus: {
      id: null,
      treeFocused: !1
    },
    edit: {
      id: null
    },
    drag: {
      id: null,
      selectedIds: [],
      destinationParentId: null,
      destinationIndex: null
    },
    selection: {
      ids: /* @__PURE__ */ new Set(),
      anchor: null,
      mostRecent: null
    }
  },
  dnd: {
    cursor: {
      type: "none"
    },
    dragId: null,
    dragIds: [],
    parentId: null,
    index: -1
  }
}), $37bc167debff36d2$export$e324594224ef24da = {
  clear: () => ({
    type: "SELECTION_CLEAR"
  }),
  only: (ce) => ({
    type: "SELECTION_ONLY",
    id: $0e6083160f4b36ed$export$65e5b62a4c490288(ce)
  }),
  add: (ce) => ({
    type: "SELECTION_ADD",
    ids: (Array.isArray(ce) ? ce : [
      ce
    ]).map($0e6083160f4b36ed$export$65e5b62a4c490288)
  }),
  remove: (ce) => ({
    type: "SELECTION_REMOVE",
    ids: (Array.isArray(ce) ? ce : [
      ce
    ]).map($0e6083160f4b36ed$export$65e5b62a4c490288)
  }),
  set: (ce) => ({
    type: "SELECTION_SET",
    ...ce
  }),
  mostRecent: (ce) => ({
    type: "SELECTION_MOST_RECENT",
    id: ce === null ? null : $0e6083160f4b36ed$export$65e5b62a4c490288(ce)
  }),
  anchor: (ce) => ({
    type: "SELECTION_ANCHOR",
    id: ce === null ? null : $0e6083160f4b36ed$export$65e5b62a4c490288(ce)
  })
};
function $37bc167debff36d2$export$1650419e431d3ba3(ce = $6ad32e02250c922e$export$d4c72bab9d6cc13a().nodes.selection, ie) {
  const me = ce.ids;
  switch (ie.type) {
    case "SELECTION_CLEAR":
      return {
        ...ce,
        ids: /* @__PURE__ */ new Set()
      };
    case "SELECTION_ONLY":
      return {
        ...ce,
        ids: /* @__PURE__ */ new Set([
          ie.id
        ])
      };
    case "SELECTION_ADD":
      return ie.ids.length === 0 ? ce : (ie.ids.forEach((we) => me.add(we)), {
        ...ce,
        ids: new Set(me)
      });
    case "SELECTION_REMOVE":
      return ie.ids.length === 0 ? ce : (ie.ids.forEach((we) => me.delete(we)), {
        ...ce,
        ids: new Set(me)
      });
    case "SELECTION_SET":
      return {
        ...ce,
        ids: ie.ids,
        mostRecent: ie.mostRecent,
        anchor: ie.anchor
      };
    case "SELECTION_MOST_RECENT":
      return {
        ...ce,
        mostRecent: ie.id
      };
    case "SELECTION_ANCHOR":
      return {
        ...ce,
        anchor: ie.id
      };
    default:
      return ce;
  }
}
const $59f144a8dd651e5e$export$e324594224ef24da = {
  cursor(ce) {
    return {
      type: "DND_CURSOR",
      cursor: ce
    };
  },
  dragStart(ce, ie) {
    return {
      type: "DND_DRAG_START",
      id: ce,
      dragIds: ie
    };
  },
  dragEnd() {
    return {
      type: "DND_DRAG_END"
    };
  },
  hovering(ce, ie) {
    return {
      type: "DND_HOVERING",
      parentId: ce,
      index: ie
    };
  }
};
function $59f144a8dd651e5e$export$1650419e431d3ba3(ce = $6ad32e02250c922e$export$d4c72bab9d6cc13a().dnd, ie) {
  switch (ie.type) {
    case "DND_CURSOR":
      return {
        ...ce,
        cursor: ie.cursor
      };
    case "DND_DRAG_START":
      return {
        ...ce,
        dragId: ie.id,
        dragIds: ie.dragIds
      };
    case "DND_DRAG_END":
      return $6ad32e02250c922e$export$d4c72bab9d6cc13a().dnd;
    case "DND_HOVERING":
      return {
        ...ce,
        parentId: ie.parentId,
        index: ie.index
      };
    default:
      return ce;
  }
}
const $77d34d95e44d2f58$var$layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
}, $77d34d95e44d2f58$var$getStyle = (ce) => {
  if (!ce) return {
    display: "none"
  };
  const { x: ie, y: me } = ce;
  return {
    transform: `translate(${ie}px, ${me}px)`
  };
}, $77d34d95e44d2f58$var$getCountStyle = (ce) => {
  if (!ce) return {
    display: "none"
  };
  const { x: ie, y: me } = ce;
  return {
    transform: `translate(${ie + 10}px, ${me + 10}px)`
  };
};
function $77d34d95e44d2f58$export$84e211ad8431a387({ offset: ce, mouse: ie, id: me, dragIds: we, isDragging: Re }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs($77d34d95e44d2f58$var$Overlay, {
    isDragging: Re,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($77d34d95e44d2f58$var$Position, {
        offset: ce,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx($77d34d95e44d2f58$var$PreviewNode, {
          id: me,
          dragIds: we
        })
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx($77d34d95e44d2f58$var$Count, {
        mouse: ie,
        count: we.length
      })
    ]
  });
}
const $77d34d95e44d2f58$var$Overlay = /* @__PURE__ */ memo(function(ie) {
  return ie.isDragging ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    style: $77d34d95e44d2f58$var$layerStyles,
    children: ie.children
  }) : null;
});
function $77d34d95e44d2f58$var$Position(ce) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: "row preview",
    style: $77d34d95e44d2f58$var$getStyle(ce.offset),
    children: ce.children
  });
}
function $77d34d95e44d2f58$var$Count(ce) {
  const { count: ie, mouse: me } = ce;
  return ie > 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: "selected-count",
    style: $77d34d95e44d2f58$var$getCountStyle(me),
    children: ie
  }) : null;
}
const $77d34d95e44d2f58$var$PreviewNode = /* @__PURE__ */ memo(function(ie) {
  const me = $89e93131aae74bd9$export$367b0f2231a90ba0(), we = me.get(ie.id);
  return we ? /* @__PURE__ */ jsxRuntimeExports.jsx(me.renderNode, {
    preview: !0,
    node: we,
    style: {
      paddingLeft: we.level * me.indent,
      opacity: 0.2,
      background: "transparent"
    },
    tree: me
  }) : null;
});
function $f608be224a71d6f5$export$b6a79797ad180576() {
  const ce = $89e93131aae74bd9$export$367b0f2231a90ba0(), me = $89e93131aae74bd9$export$4930f6bf413be70e().cursor;
  if (!me || me.type !== "line") return null;
  const we = ce.indent, Re = ce.rowHeight * me.index + (ce.props.padding ?? ce.props.paddingTop ?? 0), je = we * me.level, Ue = ce.renderCursor;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Ue, {
    top: Re,
    left: je,
    indent: we
  });
}
const $05f64c7ebcbad8b5$export$70c2b8898b86d3ad = /* @__PURE__ */ forwardRef(function(ie, me) {
  const { children: we, ...Re } = ie, je = $89e93131aae74bd9$export$367b0f2231a90ba0();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    // @ts-ignore
    ref: me,
    ...Re,
    onClick: (Ue) => {
      Ue.currentTarget === Ue.target && je.deselectAll();
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($05f64c7ebcbad8b5$var$DropContainer, {}),
      we
    ]
  });
}), $05f64c7ebcbad8b5$var$DropContainer = () => {
  const ce = $89e93131aae74bd9$export$367b0f2231a90ba0();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    style: {
      height: ce.visibleNodes.length * ce.rowHeight,
      width: "100%",
      position: "absolute",
      left: "0",
      right: "0"
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx($f608be224a71d6f5$export$b6a79797ad180576, {})
  });
}, $da9a6b47b6fff922$export$a9af0da3ae60cd00 = /* @__PURE__ */ forwardRef(function({ style: ie, ...me }, we) {
  const Re = $89e93131aae74bd9$export$367b0f2231a90ba0(), je = Re.props.padding ?? Re.props.paddingTop ?? 0, Ue = Re.props.padding ?? Re.props.paddingBottom ?? 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref: we,
    style: {
      ...ie,
      height: `${parseFloat(ie.height) + je + Ue}px`
    },
    ...me
  });
});
function $907e707a330ef23a$export$715c0d031ede7907(ce) {
  const ie = $89e93131aae74bd9$export$367b0f2231a90ba0(), me = ie.selectedIds, [we, Re, je] = useDrag(() => ({
    canDrag: () => ce.isDraggable,
    type: "NODE",
    item: () => {
      const Ue = ie.isSelected(ce.id) ? Array.from(me) : [
        ce.id
      ];
      return ie.dispatch($59f144a8dd651e5e$export$e324594224ef24da.dragStart(ce.id, Ue)), {
        id: ce.id
      };
    },
    end: () => {
      ie.hideCursor();
      let { parentId: Ue, index: qe, dragIds: Ge } = ie.state.dnd;
      ie.canDrop() && ($0e6083160f4b36ed$export$c6d63370cef03886(ie.props.onMove, {
        dragIds: Ge,
        parentId: Ue === $81080a351c006222$export$ec71a3379b43ae5c ? null : Ue,
        index: qe === null ? 0 : qe,
        dragNodes: ie.dragNodes,
        parentNode: ie.get(Ue)
      }), ie.open(Ue)), ie.dispatch($59f144a8dd651e5e$export$e324594224ef24da.dragEnd());
    }
  }), [
    me,
    ce
  ]);
  return useEffect(() => {
    je(getEmptyImage());
  }, [
    je
  ]), Re;
}
function $2db980bfed6822da$var$measureHover(ce, ie) {
  const me = ce.getBoundingClientRect(), we = ie.x - Math.round(me.x), Re = ie.y - Math.round(me.y), je = me.height, Ue = Re < je / 2, qe = !Ue, Ge = je / 4, Xe = Re > Ge && Re < je - Ge;
  return {
    x: we,
    inTopHalf: Ue,
    inBottomHalf: qe,
    inMiddle: Xe,
    atTop: !Xe && Ue,
    atBottom: !Xe && qe
  };
}
function $2db980bfed6822da$var$getNodesAroundCursor(ce, ie, me, we) {
  return ce ? ce.isInternal ? we.atTop ? [
    ie,
    ce
  ] : we.inMiddle ? [
    ce,
    ce
  ] : [
    ce,
    me
  ] : we.inTopHalf ? [
    ie,
    ce
  ] : [
    ce,
    me
  ] : [
    ie,
    null
  ];
}
function $2db980bfed6822da$var$getDropLevel(ce, ie, me, we) {
  const Re = Math.round(Math.max(0, ce.x - we) / we);
  let je, Ue;
  return ie ? me ? (Ue = ie.level, je = me.level) : (Ue = ie.level, je = 0) : (Ue = 0, je = 0), $0e6083160f4b36ed$export$adf7c0fe6059d774(Re, je, Ue);
}
function $2db980bfed6822da$var$dropAt(ce, ie) {
  return {
    parentId: ce || null,
    index: ie
  };
}
function $2db980bfed6822da$var$lineCursor(ce, ie) {
  return {
    type: "line",
    index: ce,
    level: ie
  };
}
function $2db980bfed6822da$var$highlightCursor(ce) {
  return {
    type: "highlight",
    id: ce
  };
}
function $2db980bfed6822da$var$walkUpFrom(ce, ie) {
  var je;
  let me = ce;
  for (; me.parent && me.level > ie; ) me = me.parent;
  const we = ((je = me.parent) == null ? void 0 : je.id) || null, Re = $0e6083160f4b36ed$export$305f7d4e9d4624f2(me) + 1;
  return {
    parentId: we,
    index: Re
  };
}
function $2db980bfed6822da$export$f502ca02ebb85a1c(ce) {
  var qe;
  const ie = $2db980bfed6822da$var$measureHover(ce.element, ce.offset), { node: me, nextNode: we, prevNode: Re } = ce, [je, Ue] = $2db980bfed6822da$var$getNodesAroundCursor(me, Re, we, ie);
  if (me && me.isInternal && ie.inMiddle) return {
    drop: $2db980bfed6822da$var$dropAt(me.id, null),
    cursor: $2db980bfed6822da$var$highlightCursor(me.id)
  };
  if (!je) return {
    drop: $2db980bfed6822da$var$dropAt((qe = Ue == null ? void 0 : Ue.parent) == null ? void 0 : qe.id, 0),
    cursor: $2db980bfed6822da$var$lineCursor(0, 0)
  };
  if ($0e6083160f4b36ed$export$5318634f2ee07019(je) || $0e6083160f4b36ed$export$4210f5ea57fbae57(je)) {
    const Ge = $2db980bfed6822da$var$getDropLevel(ie, je, Ue, ce.indent);
    return {
      drop: $2db980bfed6822da$var$walkUpFrom(je, Ge),
      cursor: $2db980bfed6822da$var$lineCursor(je.rowIndex + 1, Ge)
    };
  }
  return {
    drop: $2db980bfed6822da$var$dropAt(je == null ? void 0 : je.id, 0),
    cursor: $2db980bfed6822da$var$lineCursor(je.rowIndex + 1, je.level + 1)
  };
}
function $d38aa53467160173$export$57afafec4637d997(ce, ie) {
  const me = $89e93131aae74bd9$export$367b0f2231a90ba0(), [we, Re] = useDrop(() => ({
    accept: "NODE",
    canDrop: () => me.canDrop(),
    hover: (je, Ue) => {
      const qe = Ue.getClientOffset();
      if (!ce.current || !qe) return;
      const { cursor: Ge, drop: Xe } = $2db980bfed6822da$export$f502ca02ebb85a1c({
        element: ce.current,
        offset: qe,
        indent: me.indent,
        node: ie,
        prevNode: ie.prev,
        nextNode: ie.next
      });
      Xe && me.dispatch($59f144a8dd651e5e$export$e324594224ef24da.hovering(Xe.parentId, Xe.index)), Ue.canDrop() ? Ge && me.showCursor(Ge) : me.hideCursor();
    },
    drop: (je, Ue) => {
      if (!Ue.canDrop()) return null;
    }
  }), [
    ie,
    ce.current,
    me.props
  ]);
  return Re;
}
function $48ab254e4b4b72da$export$d75ab90b05ebbfaa(ce) {
  const ie = $89e93131aae74bd9$export$367b0f2231a90ba0(), me = ie.at(ce);
  if (!me) throw new Error(`Could not find node for index: ${ce}`);
  return useMemo$1(() => {
    const we = me.clone();
    return ie.visibleNodes[ce] = we, we;
  }, [
    ...Object.values(me.state),
    me
  ]);
}
const $8c3aed0a01f84486$export$a9754b3c8daa5172 = /* @__PURE__ */ React__default.memo(function({ index: ie, style: me }) {
  $89e93131aae74bd9$export$83a4f9dc3b36edb8(), $89e93131aae74bd9$export$fd23f19d5d8f3033();
  const we = $89e93131aae74bd9$export$367b0f2231a90ba0(), Re = $48ab254e4b4b72da$export$d75ab90b05ebbfaa(ie), je = useRef(null), Ue = $907e707a330ef23a$export$715c0d031ede7907(Re), qe = $d38aa53467160173$export$57afafec4637d997(je, Re), Ge = useCallback((St) => {
    je.current = St, qe(St);
  }, [
    qe
  ]), Xe = we.indent * Re.level, ot = useMemo$1(() => ({
    paddingLeft: Xe
  }), [
    Xe
  ]), vt = useMemo$1(() => ({
    ...me,
    top: parseFloat(me.top) + (we.props.padding ?? we.props.paddingTop ?? 0)
  }), [
    me,
    we.props.padding,
    we.props.paddingTop
  ]), bt = {
    role: "treeitem",
    "aria-level": Re.level,
    "aria-selected": Re.isSelected,
    style: vt,
    tabIndex: -1,
    className: we.props.rowClassName
  };
  useEffect(() => {
    var St;
    !Re.isEditing && Re.isFocused && ((St = je.current) == null || St.focus({
      preventScroll: !0
    }));
  }, [
    Re.isEditing,
    Re.isFocused,
    je.current
  ]);
  const Tt = we.renderNode, wt = we.renderRow;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(wt, {
    node: Re,
    innerRef: Ge,
    attrs: bt,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tt, {
      node: Re,
      tree: we,
      style: ot,
      dragHandle: Ue
    })
  });
});
let $065a164934293bf2$var$focusSearchTerm = "", $065a164934293bf2$var$timeoutId = null;
function $065a164934293bf2$export$ff4858a4110d9246() {
  $89e93131aae74bd9$export$83a4f9dc3b36edb8();
  const ce = $89e93131aae74bd9$export$367b0f2231a90ba0();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    style: {
      height: ce.height,
      width: ce.width,
      minHeight: 0,
      minWidth: 0
    },
    onContextMenu: ce.props.onContextMenu,
    onClick: ce.props.onClick,
    tabIndex: 0,
    onFocus: (ie) => {
      ie.currentTarget.contains(ie.relatedTarget) || ce.onFocus();
    },
    onBlur: (ie) => {
      ie.currentTarget.contains(ie.relatedTarget) || ce.onBlur();
    },
    onKeyDown: (ie) => {
      var we;
      if (ce.isEditing) return;
      if (ie.key === "Backspace") {
        if (!ce.props.onDelete) return;
        const Re = Array.from(ce.selectedIds);
        if (Re.length > 1) {
          let je = ce.mostRecentNode;
          for (; je && je.isSelected; ) je = je.nextSibling;
          je || (je = ce.lastNode), ce.focus(je, {
            scroll: !1
          }), ce.delete(Array.from(Re));
        } else {
          const je = ce.focusedNode;
          if (je) {
            const Ue = je.nextSibling, qe = je.parent;
            ce.focus(Ue || qe, {
              scroll: !1
            }), ce.delete(je);
          }
        }
        return;
      }
      if (ie.key === "Tab" && !ie.shiftKey) {
        ie.preventDefault(), $0e6083160f4b36ed$export$3b0237e8566c8d65(ie.currentTarget);
        return;
      }
      if (ie.key === "Tab" && ie.shiftKey) {
        ie.preventDefault(), $0e6083160f4b36ed$export$33b47db07a82b2fb(ie.currentTarget);
        return;
      }
      if (ie.key === "ArrowDown") {
        ie.preventDefault();
        const Re = ce.nextNode;
        if (ie.metaKey) {
          ce.select(ce.focusedNode), ce.activate(ce.focusedNode);
          return;
        } else if (!ie.shiftKey || ce.props.disableMultiSelection) {
          ce.focus(Re);
          return;
        } else {
          if (!Re) return;
          const je = ce.focusedNode;
          je ? je.isSelected ? ce.selectContiguous(Re) : ce.selectMulti(Re) : ce.focus(ce.firstNode);
          return;
        }
      }
      if (ie.key === "ArrowUp") {
        ie.preventDefault();
        const Re = ce.prevNode;
        if (!ie.shiftKey || ce.props.disableMultiSelection) {
          ce.focus(Re);
          return;
        } else {
          if (!Re) return;
          const je = ce.focusedNode;
          je ? je.isSelected ? ce.selectContiguous(Re) : ce.selectMulti(Re) : ce.focus(ce.lastNode);
          return;
        }
      }
      if (ie.key === "ArrowRight") {
        const Re = ce.focusedNode;
        if (!Re) return;
        Re.isInternal && Re.isOpen ? ce.focus(ce.nextNode) : Re.isInternal && ce.open(Re.id);
        return;
      }
      if (ie.key === "ArrowLeft") {
        const Re = ce.focusedNode;
        if (!Re || Re.isRoot) return;
        Re.isInternal && Re.isOpen ? ce.close(Re.id) : (we = Re.parent) != null && we.isRoot || ce.focus(Re.parent);
        return;
      }
      if (ie.key === "a" && ie.metaKey && !ce.props.disableMultiSelection) {
        ie.preventDefault(), ce.selectAll();
        return;
      }
      if (ie.key === "a" && !ie.metaKey && ce.props.onCreate) {
        ce.createLeaf();
        return;
      }
      if (ie.key === "A" && !ie.metaKey) {
        if (!ce.props.onCreate) return;
        ce.createInternal();
        return;
      }
      if (ie.key === "Home") {
        ie.preventDefault(), ce.focus(ce.firstNode);
        return;
      }
      if (ie.key === "End") {
        ie.preventDefault(), ce.focus(ce.lastNode);
        return;
      }
      if (ie.key === "Enter") {
        const Re = ce.focusedNode;
        if (!Re || !Re.isEditable || !ce.props.onRename) return;
        setTimeout(() => {
          Re && ce.edit(Re);
        });
        return;
      }
      if (ie.key === " ") {
        ie.preventDefault();
        const Re = ce.focusedNode;
        if (!Re) return;
        Re.isLeaf ? (Re.select(), Re.activate()) : Re.toggle();
        return;
      }
      if (ie.key === "*") {
        const Re = ce.focusedNode;
        if (!Re) return;
        ce.openSiblings(Re);
        return;
      }
      if (ie.key === "PageUp") {
        ie.preventDefault(), ce.pageUp();
        return;
      }
      ie.key === "PageDown" && (ie.preventDefault(), ce.pageDown()), clearTimeout($065a164934293bf2$var$timeoutId), $065a164934293bf2$var$focusSearchTerm += ie.key, $065a164934293bf2$var$timeoutId = setTimeout(() => {
        $065a164934293bf2$var$focusSearchTerm = "";
      }, 600);
      const me = ce.visibleNodes.find((Re) => {
        const je = Re.data.name;
        return typeof je == "string" ? je.toLowerCase().startsWith($065a164934293bf2$var$focusSearchTerm) : !1;
      });
      me && ce.focus(me.id);
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FixedSizeList, {
      className: ce.props.className,
      outerRef: ce.listEl,
      itemCount: ce.visibleNodes.length,
      height: ce.height,
      width: ce.width,
      itemSize: ce.rowHeight,
      overscanCount: ce.overscanCount,
      itemKey: (ie) => {
        var me;
        return ((me = ce.visibleNodes[ie]) == null ? void 0 : me.id) || ie;
      },
      outerElementType: $05f64c7ebcbad8b5$export$70c2b8898b86d3ad,
      innerElementType: $da9a6b47b6fff922$export$a9af0da3ae60cd00,
      onScroll: ce.props.onScroll,
      onItemsRendered: ce.onItemsRendered.bind(ce),
      ref: ce.list,
      children: $8c3aed0a01f84486$export$a9754b3c8daa5172
    })
  });
}
function $749bc746798c29ad$export$5897d8d7c7a3d871(ce) {
  return ce.isFiltered ? $749bc746798c29ad$var$flattenAndFilterTree(ce.root, ce.isMatch.bind(ce)) : $749bc746798c29ad$var$flattenTree(ce.root);
}
function $749bc746798c29ad$var$flattenTree(ce) {
  const ie = [];
  function me(we) {
    var Re;
    we.level >= 0 && ie.push(we), we.isOpen && ((Re = we.children) == null || Re.forEach(me));
  }
  return me(ce), ie.forEach($749bc746798c29ad$var$assignRowIndex), ie;
}
function $749bc746798c29ad$var$flattenAndFilterTree(ce, ie) {
  const me = {}, we = [];
  function Re(Ue) {
    if (!Ue.isRoot && ie(Ue)) {
      me[Ue.id] = !0;
      let Ge = Ue.parent;
      for (; Ge; )
        me[Ge.id] = !0, Ge = Ge.parent;
    }
    if (Ue.children) for (let Ge of Ue.children) Re(Ge);
  }
  function je(Ue) {
    var qe;
    Ue.level >= 0 && me[Ue.id] && we.push(Ue), Ue.isOpen && ((qe = Ue.children) == null || qe.forEach(je));
  }
  return Re(ce), je(ce), we.forEach($749bc746798c29ad$var$assignRowIndex), we;
}
function $749bc746798c29ad$var$assignRowIndex(ce, ie) {
  ce.rowIndex = ie;
}
const $659b2f68e1468ad0$export$c6d108d7c8095f19 = (ce) => ce.reduce((ie, me, we) => (ie[me.id] = we, ie), {}), { safeRun: $bfece7c4aed4e9c4$var$safeRun, identify: $bfece7c4aed4e9c4$var$identify, identifyNull: $bfece7c4aed4e9c4$var$identifyNull } = $0e6083160f4b36ed$exports;
class $bfece7c4aed4e9c4$export$e2da3477247342d1 {
  constructor(ie, me, we, Re) {
    this.store = ie, this.props = me, this.list = we, this.listEl = Re, this.visibleStartIndex = 0, this.visibleStopIndex = 0, this.root = $81080a351c006222$export$882461b6382ed46c(this), this.visibleNodes = $749bc746798c29ad$export$5897d8d7c7a3d871(this), this.idToIndex = $659b2f68e1468ad0$export$c6d108d7c8095f19(this.visibleNodes);
  }
  /* Changes here must also be made in constructor() */
  update(ie) {
    this.props = ie, this.root = $81080a351c006222$export$882461b6382ed46c(this), this.visibleNodes = $749bc746798c29ad$export$5897d8d7c7a3d871(this), this.idToIndex = $659b2f68e1468ad0$export$c6d108d7c8095f19(this.visibleNodes);
  }
  /* Store helpers */
  dispatch(ie) {
    return this.store.dispatch(ie);
  }
  get state() {
    return this.store.getState();
  }
  get openState() {
    return this.state.nodes.open.unfiltered;
  }
  /* Tree Props */
  get width() {
    return this.props.width ?? 300;
  }
  get height() {
    return this.props.height ?? 500;
  }
  get indent() {
    return this.props.indent ?? 24;
  }
  get rowHeight() {
    return this.props.rowHeight ?? 24;
  }
  get overscanCount() {
    return this.props.overscanCount ?? 1;
  }
  get searchTerm() {
    return (this.props.searchTerm || "").trim();
  }
  get matchFn() {
    const ie = this.props.searchMatch ?? ((me, we) => JSON.stringify(Object.values(me.data)).toLocaleLowerCase().includes(we.toLocaleLowerCase()));
    return (me) => ie(me, this.searchTerm);
  }
  accessChildren(ie) {
    const me = this.props.childrenAccessor || "children";
    return $0e6083160f4b36ed$exports.access(ie, me) ?? null;
  }
  accessId(ie) {
    const me = this.props.idAccessor || "id", we = $0e6083160f4b36ed$exports.access(ie, me);
    if (!we) throw new Error("Data must contain an 'id' property or props.idAccessor must return a string");
    return we;
  }
  /* Node Access */
  get firstNode() {
    return this.visibleNodes[0] ?? null;
  }
  get lastNode() {
    return this.visibleNodes[this.visibleNodes.length - 1] ?? null;
  }
  get focusedNode() {
    return this.get(this.state.nodes.focus.id) ?? null;
  }
  get mostRecentNode() {
    return this.get(this.state.nodes.selection.mostRecent) ?? null;
  }
  get nextNode() {
    const ie = this.indexOf(this.focusedNode);
    return ie === null ? null : this.at(ie + 1);
  }
  get prevNode() {
    const ie = this.indexOf(this.focusedNode);
    return ie === null ? null : this.at(ie - 1);
  }
  get(ie) {
    return ie && ie in this.idToIndex && this.visibleNodes[this.idToIndex[ie]] || null;
  }
  at(ie) {
    return this.visibleNodes[ie] || null;
  }
  nodesBetween(ie, me) {
    if (ie === null || me === null) return [];
    const we = this.indexOf(ie) ?? 0, Re = this.indexOf(me);
    if (Re === null) return [];
    const je = Math.min(we, Re), Ue = Math.max(we, Re);
    return this.visibleNodes.slice(je, Ue + 1);
  }
  indexOf(ie) {
    const me = $0e6083160f4b36ed$exports.identifyNull(ie);
    return me ? this.idToIndex[me] : null;
  }
  /* Data Operations */
  get editingId() {
    return this.state.nodes.edit.id;
  }
  createInternal() {
    return this.create({
      type: "internal"
    });
  }
  createLeaf() {
    return this.create({
      type: "leaf"
    });
  }
  async create(ie = {}) {
    const me = ie.parentId === void 0 ? $0e6083160f4b36ed$exports.getInsertParentId(this) : ie.parentId, we = ie.index ?? $0e6083160f4b36ed$exports.getInsertIndex(this), Re = ie.type ?? "leaf", je = await $bfece7c4aed4e9c4$var$safeRun(this.props.onCreate, {
      type: Re,
      parentId: me,
      index: we,
      parentNode: this.get(me)
    });
    je && (this.focus(je), setTimeout(() => {
      this.edit(je).then(() => {
        this.select(je), this.activate(je);
      });
    }));
  }
  async delete(ie) {
    if (!ie) return;
    const we = (Array.isArray(ie) ? ie : [
      ie
    ]).map($bfece7c4aed4e9c4$var$identify), Re = we.map((je) => this.get(je)).filter((je) => !!je);
    await $bfece7c4aed4e9c4$var$safeRun(this.props.onDelete, {
      nodes: Re,
      ids: we
    });
  }
  edit(ie) {
    const me = $bfece7c4aed4e9c4$var$identify(ie);
    return this.resolveEdit({
      cancelled: !0
    }), this.scrollTo(me), this.dispatch($21783d2b0251be67$export$e1a8e267487c59d1(me)), new Promise((we) => {
      $bfece7c4aed4e9c4$export$e2da3477247342d1.editPromise = we;
    });
  }
  async submit(ie, me) {
    if (!ie) return;
    const we = $bfece7c4aed4e9c4$var$identify(ie);
    await $bfece7c4aed4e9c4$var$safeRun(this.props.onRename, {
      id: we,
      name: me,
      node: this.get(we)
    }), this.dispatch($21783d2b0251be67$export$e1a8e267487c59d1(null)), this.resolveEdit({
      cancelled: !1,
      value: me
    }), setTimeout(() => this.onFocus());
  }
  reset() {
    this.dispatch($21783d2b0251be67$export$e1a8e267487c59d1(null)), this.resolveEdit({
      cancelled: !0
    }), setTimeout(() => this.onFocus());
  }
  activate(ie) {
    const me = this.get($bfece7c4aed4e9c4$var$identifyNull(ie));
    me && $bfece7c4aed4e9c4$var$safeRun(this.props.onActivate, me);
  }
  resolveEdit(ie) {
    const me = $bfece7c4aed4e9c4$export$e2da3477247342d1.editPromise;
    me && me(ie), $bfece7c4aed4e9c4$export$e2da3477247342d1.editPromise = null;
  }
  /* Focus and Selection */
  get selectedIds() {
    return this.state.nodes.selection.ids;
  }
  get selectedNodes() {
    let ie = [];
    for (let me of Array.from(this.selectedIds)) {
      const we = this.get(me);
      we && ie.push(we);
    }
    return ie;
  }
  focus(ie, me = {}) {
    ie && (this.props.selectionFollowsFocus ? this.select(ie) : (this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef($bfece7c4aed4e9c4$var$identify(ie))), me.scroll !== !1 && this.scrollTo(ie), this.focusedNode && $bfece7c4aed4e9c4$var$safeRun(this.props.onFocus, this.focusedNode)));
  }
  pageUp() {
    var je;
    const ie = this.visibleStartIndex, we = this.visibleStopIndex - ie;
    let Re = ((je = this.focusedNode) == null ? void 0 : je.rowIndex) ?? 0;
    Re > ie ? Re = ie : Re = Math.max(ie - we, 0), this.focus(this.at(Re));
  }
  pageDown() {
    var je;
    const ie = this.visibleStartIndex, me = this.visibleStopIndex, we = me - ie;
    let Re = ((je = this.focusedNode) == null ? void 0 : je.rowIndex) ?? 0;
    Re < me ? Re = me : Re = Math.min(Re + we, this.visibleNodes.length - 1), this.focus(this.at(Re));
  }
  select(ie, me = {}) {
    if (!ie) return;
    const we = me.focus !== !1, Re = $bfece7c4aed4e9c4$var$identify(ie);
    we && this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef(Re)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.only(Re)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.anchor(Re)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.mostRecent(Re)), this.scrollTo(Re, me.align), this.focusedNode && we && $bfece7c4aed4e9c4$var$safeRun(this.props.onFocus, this.focusedNode), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes);
  }
  deselect(ie) {
    if (!ie) return;
    const me = $bfece7c4aed4e9c4$var$identify(ie);
    this.dispatch($37bc167debff36d2$export$e324594224ef24da.remove(me));
  }
  selectMulti(ie) {
    const me = this.get($bfece7c4aed4e9c4$var$identifyNull(ie));
    me && (this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef(me.id)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.add(me.id)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.anchor(me.id)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.mostRecent(me.id)), this.scrollTo(me), this.focusedNode && $bfece7c4aed4e9c4$var$safeRun(this.props.onFocus, this.focusedNode), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes));
  }
  selectContiguous(ie) {
    if (!ie) return;
    const me = $bfece7c4aed4e9c4$var$identify(ie), { anchor: we, mostRecent: Re } = this.state.nodes.selection;
    this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef(me)), this.dispatch($37bc167debff36d2$export$e324594224ef24da.remove(this.nodesBetween(we, Re))), this.dispatch($37bc167debff36d2$export$e324594224ef24da.add(this.nodesBetween(we, $bfece7c4aed4e9c4$var$identifyNull(me)))), this.dispatch($37bc167debff36d2$export$e324594224ef24da.mostRecent(me)), this.scrollTo(me), this.focusedNode && $bfece7c4aed4e9c4$var$safeRun(this.props.onFocus, this.focusedNode), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes);
  }
  deselectAll() {
    this.setSelection({
      ids: [],
      anchor: null,
      mostRecent: null
    }), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes);
  }
  selectAll() {
    var ie;
    this.setSelection({
      ids: Object.keys(this.idToIndex),
      anchor: this.firstNode,
      mostRecent: this.lastNode
    }), this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef((ie = this.lastNode) == null ? void 0 : ie.id)), this.focusedNode && $bfece7c4aed4e9c4$var$safeRun(this.props.onFocus, this.focusedNode), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes);
  }
  setSelection(ie) {
    var je;
    const me = new Set((je = ie.ids) == null ? void 0 : je.map($bfece7c4aed4e9c4$var$identify)), we = $bfece7c4aed4e9c4$var$identifyNull(ie.anchor), Re = $bfece7c4aed4e9c4$var$identifyNull(ie.mostRecent);
    this.dispatch($37bc167debff36d2$export$e324594224ef24da.set({
      ids: me,
      anchor: we,
      mostRecent: Re
    })), $bfece7c4aed4e9c4$var$safeRun(this.props.onSelect, this.selectedNodes);
  }
  /* Drag and Drop */
  get cursorParentId() {
    const { cursor: ie } = this.state.dnd;
    switch (ie.type) {
      case "highlight":
        return ie.id;
      default:
        return null;
    }
  }
  get cursorOverFolder() {
    return this.state.dnd.cursor.type === "highlight";
  }
  get dragNodes() {
    return this.state.dnd.dragIds.map((ie) => this.get(ie)).filter((ie) => !!ie);
  }
  get dragNode() {
    return this.get(this.state.nodes.drag.id);
  }
  get dragDestinationParent() {
    return this.get(this.state.nodes.drag.destinationParentId);
  }
  get dragDestinationIndex() {
    return this.state.nodes.drag.destinationIndex;
  }
  canDrop() {
    if (this.isFiltered) return !1;
    const ie = this.get(this.state.dnd.parentId) ?? this.root, me = this.dragNodes, we = this.props.disableDrop;
    for (const Re of me)
      if (!Re || !ie || Re.isInternal && $0e6083160f4b36ed$exports.isDescendant(ie, Re)) return !1;
    return typeof we == "function" ? !we({
      parentNode: ie,
      dragNodes: this.dragNodes,
      index: this.state.dnd.index || 0
    }) : typeof we == "string" ? !ie.data[we] : typeof we == "boolean" ? !we : !0;
  }
  hideCursor() {
    this.dispatch($59f144a8dd651e5e$export$e324594224ef24da.cursor({
      type: "none"
    }));
  }
  showCursor(ie) {
    this.dispatch($59f144a8dd651e5e$export$e324594224ef24da.cursor(ie));
  }
  /* Visibility */
  open(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    me && (this.isOpen(me) || (this.dispatch($3c0bad2888bcd4bc$export$e324594224ef24da.open(me, this.isFiltered)), $bfece7c4aed4e9c4$var$safeRun(this.props.onToggle, me)));
  }
  close(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    me && this.isOpen(me) && (this.dispatch($3c0bad2888bcd4bc$export$e324594224ef24da.close(me, this.isFiltered)), $bfece7c4aed4e9c4$var$safeRun(this.props.onToggle, me));
  }
  toggle(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    if (me)
      return this.isOpen(me) ? this.close(me) : this.open(me);
  }
  openParents(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    if (!me) return;
    const we = $0e6083160f4b36ed$exports.dfs(this.root, me);
    let Re = we == null ? void 0 : we.parent;
    for (; Re; )
      this.open(Re.id), Re = Re.parent;
  }
  openSiblings(ie) {
    const me = ie.parent;
    if (!me) this.toggle(ie.id);
    else if (me.children) {
      const we = ie.isOpen;
      for (let Re of me.children) Re.isInternal && (we ? this.close(Re.id) : this.open(Re.id));
      this.scrollTo(this.focusedNode);
    }
  }
  openAll() {
    $0e6083160f4b36ed$exports.walk(this.root, (ie) => {
      ie.isInternal && ie.open();
    });
  }
  closeAll() {
    $0e6083160f4b36ed$exports.walk(this.root, (ie) => {
      ie.isInternal && ie.close();
    });
  }
  /* Scrolling */
  scrollTo(ie, me = "smart") {
    if (!ie) return;
    const we = $bfece7c4aed4e9c4$var$identify(ie);
    return this.openParents(we), $0e6083160f4b36ed$exports.waitFor(() => we in this.idToIndex).then(() => {
      var je;
      const Re = this.idToIndex[we];
      Re !== void 0 && ((je = this.list.current) == null || je.scrollToItem(Re, me));
    }).catch(() => {
    });
  }
  /* State Checks */
  get isEditing() {
    return this.state.nodes.edit.id !== null;
  }
  get isFiltered() {
    var ie;
    return !!((ie = this.props.searchTerm) != null && ie.trim());
  }
  get hasFocus() {
    return this.state.nodes.focus.treeFocused;
  }
  get hasNoSelection() {
    return this.state.nodes.selection.ids.size === 0;
  }
  get hasOneSelection() {
    return this.state.nodes.selection.ids.size === 1;
  }
  get hasMultipleSelections() {
    return this.state.nodes.selection.ids.size > 1;
  }
  isSelected(ie) {
    return ie ? this.state.nodes.selection.ids.has(ie) : !1;
  }
  isOpen(ie) {
    if (!ie) return !1;
    if (ie === $81080a351c006222$export$ec71a3379b43ae5c) return !0;
    const me = this.props.openByDefault ?? !0;
    return this.isFiltered ? this.state.nodes.open.filtered[ie] ?? !0 : this.state.nodes.open.unfiltered[ie] ?? me;
  }
  isEditable(ie) {
    const me = this.props.disableEdit || (() => !1);
    return !$0e6083160f4b36ed$exports.access(ie, me);
  }
  isDraggable(ie) {
    const me = this.props.disableDrag || (() => !1);
    return !$0e6083160f4b36ed$exports.access(ie, me);
  }
  isDragging(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    return me ? this.state.nodes.drag.id === me : !1;
  }
  isFocused(ie) {
    return this.hasFocus && this.state.nodes.focus.id === ie;
  }
  isMatch(ie) {
    return this.matchFn(ie);
  }
  willReceiveDrop(ie) {
    const me = $bfece7c4aed4e9c4$var$identifyNull(ie);
    if (!me) return !1;
    const { destinationParentId: we, destinationIndex: Re } = this.state.nodes.drag;
    return me === we && Re === null;
  }
  /* Tree Event Handlers */
  onFocus() {
    const ie = this.focusedNode || this.firstNode;
    ie && this.dispatch($c27b8e9863235052$export$d7ddd398f22d79ef(ie.id));
  }
  onBlur() {
    this.dispatch($c27b8e9863235052$export$6b6c976e46a06288());
  }
  onItemsRendered(ie) {
    this.visibleStartIndex = ie.visibleStartIndex, this.visibleStopIndex = ie.visibleStopIndex;
  }
  /* Get Renderers */
  get renderContainer() {
    return this.props.renderContainer || $065a164934293bf2$export$ff4858a4110d9246;
  }
  get renderRow() {
    return this.props.renderRow || $164e874d21fcd87e$export$f9c541e71856c524;
  }
  get renderNode() {
    return this.props.children || $c4edd692d5290432$export$909e23cbfbbd3351;
  }
  get renderDragPreview() {
    return this.props.renderDragPreview || $77d34d95e44d2f58$export$84e211ad8431a387;
  }
  get renderCursor() {
    return this.props.renderCursor || $fb4c15d8425379bd$export$6cb3c16721363d11;
  }
}
function $5c35ee13c124a8cc$export$1650419e431d3ba3(ce = $6ad32e02250c922e$export$d4c72bab9d6cc13a().nodes.drag, ie) {
  switch (ie.type) {
    case "DND_DRAG_START":
      return {
        ...ce,
        id: ie.id,
        selectedIds: ie.dragIds
      };
    case "DND_DRAG_END":
      return {
        ...ce,
        id: null,
        destinationParentId: null,
        destinationIndex: null,
        selectedIds: []
      };
    case "DND_HOVERING":
      return ie.parentId !== ce.destinationParentId || ie.index != ce.destinationIndex ? {
        ...ce,
        destinationParentId: ie.parentId,
        destinationIndex: ie.index
      } : ce;
    default:
      return ce;
  }
}
const $a18760514dcf279e$export$a8a69c316169e623 = combineReducers({
  nodes: combineReducers({
    focus: $c27b8e9863235052$export$1650419e431d3ba3,
    edit: $21783d2b0251be67$export$1650419e431d3ba3,
    open: $3c0bad2888bcd4bc$export$1650419e431d3ba3,
    selection: $37bc167debff36d2$export$1650419e431d3ba3,
    drag: $5c35ee13c124a8cc$export$1650419e431d3ba3
  }),
  dnd: $59f144a8dd651e5e$export$1650419e431d3ba3
}), $dac24389e46ba09d$var$SERVER_STATE = $6ad32e02250c922e$export$d4c72bab9d6cc13a();
function $dac24389e46ba09d$export$c49dab5eb1b4ce0c({ treeProps: ce, imperativeHandle: ie, children: me }) {
  const we = useRef(null), Re = useRef(null), je = useRef(createStore($a18760514dcf279e$export$a8a69c316169e623, $6ad32e02250c922e$export$d4c72bab9d6cc13a(ce))), Ue = shimExports.useSyncExternalStore(je.current.subscribe, je.current.getState, () => $dac24389e46ba09d$var$SERVER_STATE), qe = useMemo$1(() => new $bfece7c4aed4e9c4$export$e2da3477247342d1(je.current, ce, we, Re), []), Ge = useRef(0);
  return useMemo$1(() => {
    Ge.current += 1, qe.update(ce);
  }, [
    ...Object.values(ce),
    Ue.nodes.open
  ]), useImperativeHandle(ie, () => qe), useEffect(() => {
    qe.props.selection ? qe.select(qe.props.selection, {
      focus: !1
    }) : qe.deselectAll();
  }, [
    qe.props.selection
  ]), useEffect(() => {
    qe.props.searchTerm || je.current.dispatch($3c0bad2888bcd4bc$export$e324594224ef24da.clear(!0));
  }, [
    qe.props.searchTerm
  ]), /* @__PURE__ */ jsxRuntimeExports.jsx($89e93131aae74bd9$export$feef243b04ff4151.Provider, {
    value: qe,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx($89e93131aae74bd9$export$d0c71bc5e3e2d897.Provider, {
      value: Ge.current,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx($89e93131aae74bd9$export$f6d467aa8b3786af.Provider, {
        value: Ue.nodes,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx($89e93131aae74bd9$export$2d5c5ceac203fc1e.Provider, {
          value: Ue.dnd,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DndProvider, {
            backend: HTML5Backend,
            options: {
              rootElement: qe.props.dndRootElement || void 0
            },
            ...ce.dndManager && {
              manager: ce.dndManager
            },
            children: me
          })
        })
      })
    })
  });
}
function $e739455e59c6aed3$export$5a6c424b1725f44f() {
  const ce = $89e93131aae74bd9$export$367b0f2231a90ba0(), [, ie] = useDrop(() => ({
    accept: "NODE",
    canDrop: (me, we) => we.isOver({
      shallow: !0
    }) ? ce.canDrop() : !1,
    hover: (me, we) => {
      if (!we.isOver({
        shallow: !0
      })) return;
      const Re = we.getClientOffset();
      if (!ce.listEl.current || !Re) return;
      const { cursor: je, drop: Ue } = $2db980bfed6822da$export$f502ca02ebb85a1c({
        element: ce.listEl.current,
        offset: Re,
        indent: ce.indent,
        node: null,
        prevNode: ce.visibleNodes[ce.visibleNodes.length - 1],
        nextNode: null
      });
      Ue && ce.dispatch($59f144a8dd651e5e$export$e324594224ef24da.hovering(Ue.parentId, Ue.index)), we.canDrop() ? je && ce.showCursor(je) : ce.hideCursor();
    }
  }), [
    ce
  ]);
  ie(ce.listEl);
}
function $5d6a5680e6f62734$export$a6ee728c3c6ef11d(ce) {
  return $e739455e59c6aed3$export$5a6c424b1725f44f(), ce.children;
}
function $f13a06e5444f84b6$export$cdf2ef3f6364d85() {
  const ie = $89e93131aae74bd9$export$367b0f2231a90ba0().props.renderContainer || $065a164934293bf2$export$ff4858a4110d9246;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ie, {})
  });
}
function $8f8be4c9bb5ab52a$export$3e21b60650ec7e55() {
  const ce = $89e93131aae74bd9$export$367b0f2231a90ba0(), { offset: ie, mouse: me, item: we, isDragging: Re } = useDragLayer((Ue) => ({
    offset: Ue.getSourceClientOffset(),
    mouse: Ue.getClientOffset(),
    item: Ue.getItem(),
    isDragging: Ue.isDragging()
  })), je = ce.props.renderDragPreview || $77d34d95e44d2f58$export$84e211ad8431a387;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(je, {
    offset: ie,
    mouse: me,
    id: (we == null ? void 0 : we.id) || null,
    dragIds: (we == null ? void 0 : we.dragIds) || [],
    isDragging: Re
  });
}
var $0a3913338341addb$exports = {};
$parcel$export($0a3913338341addb$exports, "useSimpleTree", () => $0a3913338341addb$export$dcd27aa2043b2724);
var $65f74606ca594063$exports = {};
$parcel$export($65f74606ca594063$exports, "SimpleTree", () => $65f74606ca594063$export$e32206264f456dce);
class $65f74606ca594063$export$e32206264f456dce {
  constructor(ie) {
    this.root = $65f74606ca594063$var$createRoot(ie);
  }
  get data() {
    var ie;
    return ((ie = this.root.children) == null ? void 0 : ie.map((me) => me.data)) ?? [];
  }
  create(ie) {
    const me = ie.parentId ? this.find(ie.parentId) : this.root;
    if (!me) return null;
    me.addChild(ie.data, ie.index);
  }
  move(ie) {
    const me = this.find(ie.id), we = ie.parentId ? this.find(ie.parentId) : this.root;
    !me || !we || (we.addChild(me.data, ie.index), me.drop());
  }
  update(ie) {
    const me = this.find(ie.id);
    me && me.update(ie.changes);
  }
  drop(ie) {
    const me = this.find(ie.id);
    me && me.drop();
  }
  find(ie, me = this.root) {
    if (!me) return null;
    if (me.id === ie) return me;
    if (me.children) {
      for (let we of me.children) {
        const Re = this.find(ie, we);
        if (Re) return Re;
      }
      return null;
    }
    return null;
  }
}
function $65f74606ca594063$var$createRoot(ce) {
  const ie = new $65f74606ca594063$var$SimpleNode({
    id: "ROOT"
  }, null);
  return ie.children = ce.map((me) => $65f74606ca594063$var$createNode(me, ie)), ie;
}
function $65f74606ca594063$var$createNode(ce, ie) {
  const me = new $65f74606ca594063$var$SimpleNode(ce, ie);
  return ce.children && (me.children = ce.children.map((we) => $65f74606ca594063$var$createNode(we, me))), me;
}
class $65f74606ca594063$var$SimpleNode {
  constructor(ie, me) {
    this.data = ie, this.parent = me, this.id = ie.id;
  }
  hasParent() {
    return !!this.parent;
  }
  get childIndex() {
    return this.hasParent() ? this.parent.children.indexOf(this) : -1;
  }
  addChild(ie, me) {
    const we = $65f74606ca594063$var$createNode(ie, this);
    this.children = this.children ?? [], this.children.splice(me, 0, we), this.data.children = this.data.children ?? [], this.data.children.splice(me, 0, ie);
  }
  removeChild(ie) {
    var me, we;
    (me = this.children) == null || me.splice(ie, 1), (we = this.data.children) == null || we.splice(ie, 1);
  }
  update(ie) {
    if (this.hasParent()) {
      const me = this.childIndex;
      this.parent.addChild({
        ...this.data,
        ...ie
      }, me), this.drop();
    }
  }
  drop() {
    this.hasParent() && this.parent.removeChild(this.childIndex);
  }
}
let $0a3913338341addb$var$nextId = 0;
function $0a3913338341addb$export$dcd27aa2043b2724(ce) {
  const [ie, me] = useState(ce), we = useMemo$1(() => new $65f74606ca594063$export$e32206264f456dce(ie), [
    ie
  ]);
  return [
    ie,
    {
      onMove: (Xe) => {
        for (const ot of Xe.dragIds) we.move({
          id: ot,
          parentId: Xe.parentId,
          index: Xe.index
        });
        me(we.data);
      },
      onRename: ({ name: Xe, id: ot }) => {
        we.update({
          id: ot,
          changes: {
            name: Xe
          }
        }), me(we.data);
      },
      onCreate: ({ parentId: Xe, index: ot, type: vt }) => {
        const bt = {
          id: `simple-tree-id-${$0a3913338341addb$var$nextId++}`,
          name: ""
        };
        return vt === "internal" && (bt.children = []), we.create({
          parentId: Xe,
          index: ot,
          data: bt
        }), me(we.data), bt;
      },
      onDelete: (Xe) => {
        Xe.ids.forEach((ot) => we.drop({
          id: ot
        })), me(we.data);
      }
    }
  ];
}
function $c881d1adb735dfd0$export$d227906824a13416(ce) {
  if (ce.initialData && ce.data) throw new Error("React Arborist Tree => Provide either a data or initialData prop, but not both.");
  if (ce.initialData && (ce.onCreate || ce.onDelete || ce.onMove || ce.onRename)) throw new Error(`React Arborist Tree => You passed the initialData prop along with a data handler.
Use the data prop if you want to provide your own handlers.`);
  if (ce.initialData) {
    const [ie, me] = $0a3913338341addb$export$dcd27aa2043b2724(ce.initialData);
    return {
      ...ce,
      ...me,
      data: ie
    };
  } else return ce;
}
function $2ba43033bb8eb39d$var$TreeComponent(ce, ie) {
  const me = $c881d1adb735dfd0$export$d227906824a13416(ce);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs($dac24389e46ba09d$export$c49dab5eb1b4ce0c, {
    treeProps: me,
    imperativeHandle: ie,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($5d6a5680e6f62734$export$a6ee728c3c6ef11d, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx($f13a06e5444f84b6$export$cdf2ef3f6364d85, {})
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx($8f8be4c9bb5ab52a$export$3e21b60650ec7e55, {})
    ]
  });
}
const $2ba43033bb8eb39d$export$7fbedc92909ed28e = /* @__PURE__ */ forwardRef($2ba43033bb8eb39d$var$TreeComponent);
function useResolvedElement(ce, ie) {
  var me = useRef(null), we = useRef(null);
  we.current = ie;
  var Re = useRef(null);
  useEffect(function() {
    je();
  });
  var je = useCallback(function() {
    var Ue = Re.current, qe = we.current, Ge = Ue || (qe ? qe instanceof Element ? qe : qe.current : null);
    me.current && me.current.element === Ge && me.current.subscriber === ce || (me.current && me.current.cleanup && me.current.cleanup(), me.current = {
      element: Ge,
      subscriber: ce,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: Ge ? ce(Ge) : void 0
    });
  }, [ce]);
  return useEffect(function() {
    return function() {
      me.current && me.current.cleanup && (me.current.cleanup(), me.current = null);
    };
  }, []), useCallback(function(Ue) {
    Re.current = Ue, je();
  }, [je]);
}
function extractSize(ce, ie, me) {
  return ce[ie] ? ce[ie][0] ? ce[ie][0][me] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    ce[ie][me]
  ) : ie === "contentBoxSize" ? ce.contentRect[me === "inlineSize" ? "width" : "height"] : void 0;
}
function useResizeObserver(ce) {
  ce === void 0 && (ce = {});
  var ie = ce.onResize, me = useRef(void 0);
  me.current = ie;
  var we = ce.round || Math.round, Re = useRef(), je = useState({
    width: void 0,
    height: void 0
  }), Ue = je[0], qe = je[1], Ge = useRef(!1);
  useEffect(function() {
    return Ge.current = !1, function() {
      Ge.current = !0;
    };
  }, []);
  var Xe = useRef({
    width: void 0,
    height: void 0
  }), ot = useResolvedElement(useCallback(function(vt) {
    return (!Re.current || Re.current.box !== ce.box || Re.current.round !== we) && (Re.current = {
      box: ce.box,
      round: we,
      instance: new ResizeObserver(function(bt) {
        var Tt = bt[0], wt = ce.box === "border-box" ? "borderBoxSize" : ce.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", St = extractSize(Tt, wt, "inlineSize"), It = extractSize(Tt, wt, "blockSize"), Pt = St ? we(St) : void 0, kt = It ? we(It) : void 0;
        if (Xe.current.width !== Pt || Xe.current.height !== kt) {
          var Ot = {
            width: Pt,
            height: kt
          };
          Xe.current.width = Pt, Xe.current.height = kt, me.current ? me.current(Ot) : Ge.current || qe(Ot);
        }
      })
    }), Re.current.instance.observe(vt, {
      box: ce.box
    }), function() {
      Re.current && Re.current.instance.unobserve(vt);
    };
  }, [ce.box, we]), ce.ref);
  return useMemo$1(function() {
    return {
      ref: ot,
      width: Ue.width,
      height: Ue.height
    };
  }, [ot, Ue.width, Ue.height]);
}
const TreeRow = ({ innerRef: ce, attrs: ie, children: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...ie, ref: ce, children: me }), useSwitch = (ce = !1) => {
  const [ie, me] = useState(ce), we = useCallback(() => {
    me(!1);
  }, []), Re = useCallback(() => {
    me(!0);
  }, []), je = useCallback(() => {
    me((Ue) => !Ue);
  }, []);
  return {
    isOn: ie,
    turnOn: Re,
    turnOff: we,
    toggle: je
  };
};
var Popover = {}, PopoverPortal$1 = {};
Object.defineProperty(PopoverPortal$1, "__esModule", { value: !0 });
PopoverPortal$1.PopoverPortal = void 0;
var react_1$6 = React__default, react_dom_1 = ReactDOM__default, PopoverPortal = function(ce) {
  var ie = ce.container, me = ce.element, we = ce.scoutElement, Re = ce.children;
  return (0, react_1$6.useLayoutEffect)(function() {
    return ie.appendChild(me), ie.appendChild(we), function() {
      ie.removeChild(me), ie.removeChild(we);
    };
  }, [ie, me, we]), (0, react_dom_1.createPortal)(Re, me);
};
PopoverPortal$1.PopoverPortal = PopoverPortal;
var util = {};
(function(ce) {
  var ie = commonjsGlobal && commonjsGlobal.__assign || function() {
    return ie = Object.assign || function(Ge) {
      for (var Xe, ot = 1, vt = arguments.length; ot < vt; ot++) {
        Xe = arguments[ot];
        for (var bt in Xe) Object.prototype.hasOwnProperty.call(Xe, bt) && (Ge[bt] = Xe[bt]);
      }
      return Ge;
    }, ie.apply(this, arguments);
  };
  Object.defineProperty(ce, "__esModule", { value: !0 }), ce.getNudgedPopoverRect = ce.getNewPopoverRect = ce.popoverRectForPosition = ce.createContainer = ce.rectsAreEqual = ce.createRect = ce.EMPTY_RECT = void 0, ce.EMPTY_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
  };
  var me = function(Ge) {
    var Xe = Ge.top, ot = Ge.left, vt = Ge.width, bt = Ge.height;
    return {
      top: Xe,
      left: ot,
      width: vt,
      height: bt,
      right: ot + vt,
      bottom: Xe + bt
    };
  };
  ce.createRect = me;
  var we = function(Ge, Xe) {
    return Ge === Xe || (Ge == null ? void 0 : Ge.bottom) === (Xe == null ? void 0 : Xe.bottom) && (Ge == null ? void 0 : Ge.height) === (Xe == null ? void 0 : Xe.height) && (Ge == null ? void 0 : Ge.left) === (Xe == null ? void 0 : Xe.left) && (Ge == null ? void 0 : Ge.right) === (Xe == null ? void 0 : Xe.right) && (Ge == null ? void 0 : Ge.top) === (Xe == null ? void 0 : Xe.top) && (Ge == null ? void 0 : Ge.width) === (Xe == null ? void 0 : Xe.width);
  };
  ce.rectsAreEqual = we;
  var Re = function(Ge) {
    var Xe = Ge.containerStyle, ot = Ge.containerClassName, vt = window.document.createElement("div");
    return ot && (vt.className = ot), Object.assign(vt.style, Xe), vt;
  };
  ce.createContainer = Re;
  var je = function(Ge, Xe, ot, vt, bt) {
    var Tt = Xe.left + Xe.width / 2, wt = Xe.top + Xe.height / 2, St = ot.width, It = ot.height, Pt, kt;
    switch (Ge) {
      case "left":
        Pt = wt - It / 2, kt = Xe.left - vt - St, bt === "start" && (Pt = Xe.top), bt === "end" && (Pt = Xe.bottom - It);
        break;
      case "bottom":
        Pt = Xe.bottom + vt, kt = Tt - St / 2, bt === "start" && (kt = Xe.left), bt === "end" && (kt = Xe.right - St);
        break;
      case "right":
        Pt = wt - It / 2, kt = Xe.right + vt, bt === "start" && (Pt = Xe.top), bt === "end" && (Pt = Xe.bottom - It);
        break;
      default:
        Pt = Xe.top - It - vt, kt = Tt - St / 2, bt === "start" && (kt = Xe.left), bt === "end" && (kt = Xe.right - St);
        break;
    }
    return (0, ce.createRect)({ left: kt, top: Pt, width: St, height: It });
  };
  ce.popoverRectForPosition = je;
  var Ue = function(Ge, Xe) {
    var ot = Ge.position, vt = Ge.align, bt = Ge.childRect, Tt = Ge.popoverRect, wt = Ge.boundaryRect, St = Ge.padding, It = Ge.reposition, Pt = (0, ce.popoverRectForPosition)(ot, bt, Tt, St, vt), kt = It && (ot === "top" && Pt.top < wt.top + Xe || ot === "left" && Pt.left < wt.left + Xe || ot === "right" && Pt.right > wt.right - Xe || ot === "bottom" && Pt.bottom > wt.bottom - Xe);
    return {
      rect: Pt,
      boundaryViolation: kt
    };
  };
  ce.getNewPopoverRect = Ue;
  var qe = function(Ge, Xe, ot) {
    var vt = Xe.top + ot, bt = Xe.left + ot, Tt = Xe.right - ot, wt = Xe.bottom - ot, St = Ge.top < vt ? vt : Ge.top;
    St = St + Ge.height > wt ? wt - Ge.height : St;
    var It = Ge.left < bt ? bt : Ge.left;
    return It = It + Ge.width > Tt ? Tt - Ge.width : It, (0, ce.createRect)(ie(ie({}, Ge), { top: St, left: It }));
  };
  ce.getNudgedPopoverRect = qe;
})(util);
var usePopover$1 = {}, useElementRef$1 = {};
Object.defineProperty(useElementRef$1, "__esModule", { value: !0 });
useElementRef$1.useElementRef = void 0;
var react_1$5 = React__default, util_1$1 = util, useElementRef = function(ce) {
  var ie = ce.containerClassName, me = ce.containerStyle, we = (0, react_1$5.useRef)(), Re = (0, react_1$5.useState)(function() {
    return (0, util_1$1.createContainer)({ containerStyle: me, containerClassName: ie });
  })[0];
  return (0, react_1$5.useLayoutEffect)(function() {
    Re.className = ie;
  }, [ie, Re]), (0, react_1$5.useLayoutEffect)(function() {
    Object.assign(Re.style, me);
  }, [me, Re]), we.current = Re, we;
};
useElementRef$1.useElementRef = useElementRef;
Object.defineProperty(usePopover$1, "__esModule", { value: !0 });
usePopover$1.usePopover = void 0;
var react_1$4 = React__default, util_1 = util, useElementRef_1 = useElementRef$1, POPOVER_STYLE = {
  position: "fixed",
  overflow: "visible",
  top: "0px",
  left: "0px"
}, SCOUT_STYLE = {
  position: "fixed",
  top: "0px",
  left: "0px",
  width: "0px",
  height: "0px",
  visibility: "hidden"
}, usePopover = function(ce) {
  var ie = ce.isOpen, me = ce.childRef, we = ce.positions, Re = ce.containerClassName, je = ce.parentElement, Ue = ce.transform, qe = ce.transformMode, Ge = ce.align, Xe = ce.padding, ot = ce.reposition, vt = ce.boundaryInset, bt = ce.boundaryElement, Tt = ce.onPositionPopover, wt = (0, useElementRef_1.useElementRef)({
    containerClassName: "react-tiny-popover-scout",
    containerStyle: SCOUT_STYLE
  }), St = (0, useElementRef_1.useElementRef)({
    containerClassName: Re != null && Re.length > 0 && Re !== "react-tiny-popover-container" ? "react-tiny-popover-container ".concat(Re) : "react-tiny-popover-container",
    containerStyle: POPOVER_STYLE
  }), It = (0, react_1$4.useCallback)(function(Pt) {
    var kt, Ot, Jr = Pt === void 0 ? {} : Pt, en = Jr.positionIndex, nn = en === void 0 ? 0 : en, ln = Jr.parentRect, fn = ln === void 0 ? je.getBoundingClientRect() : ln, vn = Jr.childRect, Tn = vn === void 0 ? (kt = me == null ? void 0 : me.current) === null || kt === void 0 ? void 0 : kt.getBoundingClientRect() : vn, xn = Jr.scoutRect, bn = xn === void 0 ? (Ot = wt == null ? void 0 : wt.current) === null || Ot === void 0 ? void 0 : Ot.getBoundingClientRect() : xn, Sn = Jr.popoverRect, Cn = Sn === void 0 ? St.current.getBoundingClientRect() : Sn, kn = Jr.boundaryRect, cn = kn === void 0 ? bt === je ? fn : bt.getBoundingClientRect() : kn;
    if (!(!Tn || !fn || !ie)) {
      if (Ue && qe === "absolute") {
        var gn = typeof Ue == "function" ? Ue({
          childRect: Tn,
          popoverRect: Cn,
          parentRect: fn,
          boundaryRect: cn,
          padding: Xe,
          align: Ge,
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: vt,
          violations: util_1.EMPTY_RECT,
          hasViolations: !1
        }) : Ue, an = gn.top, un = gn.left, pn = Math.round(fn.left + un - bn.left), hn = Math.round(fn.top + an - bn.top);
        St.current.style.transform = "translate(".concat(pn, "px, ").concat(hn, "px)"), Tt({
          childRect: Tn,
          popoverRect: (0, util_1.createRect)({
            left: pn,
            top: hn,
            width: Cn.width,
            height: Cn.height
          }),
          parentRect: fn,
          boundaryRect: cn,
          padding: Xe,
          align: Ge,
          transform: { top: an, left: un },
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: vt,
          violations: util_1.EMPTY_RECT,
          hasViolations: !1
        });
        return;
      }
      var An = nn === we.length, In = An ? we[0] : we[nn], qn = (0, util_1.getNewPopoverRect)({
        childRect: Tn,
        popoverRect: Cn,
        boundaryRect: cn,
        position: In,
        align: Ge,
        padding: Xe,
        reposition: ot
      }, vt), si = qn.rect, bi = qn.boundaryViolation;
      if (bi && ot && !An) {
        It({
          positionIndex: nn + 1,
          childRect: Tn,
          popoverRect: Cn,
          parentRect: fn,
          boundaryRect: cn
        });
        return;
      }
      var xi = si.top, ji = si.left, zi = si.width, Vi = si.height, Hi = ot && !An, ii = (0, util_1.getNudgedPopoverRect)(si, cn, vt), Fi = ii.left, ni = ii.top, Ui = xi, ja = ji;
      Hi && (Ui = ni, ja = Fi), Ui = Math.round(Ui - bn.top), ja = Math.round(ja - bn.left), St.current.style.transform = "translate(".concat(ja, "px, ").concat(Ui, "px)");
      var Ga = {
        top: cn.top + vt - Ui,
        left: cn.left + vt - ja,
        right: ja + zi - cn.right + vt,
        bottom: Ui + Vi - cn.bottom + vt
      }, Xa = {
        childRect: Tn,
        popoverRect: (0, util_1.createRect)({ left: ja, top: Ui, width: zi, height: Vi }),
        parentRect: fn,
        boundaryRect: cn,
        position: In,
        align: Ge,
        padding: Xe,
        nudgedTop: ni - xi,
        nudgedLeft: Fi - ji,
        boundaryInset: vt,
        violations: {
          top: Ga.top <= 0 ? 0 : Ga.top,
          left: Ga.left <= 0 ? 0 : Ga.left,
          right: Ga.right <= 0 ? 0 : Ga.right,
          bottom: Ga.bottom <= 0 ? 0 : Ga.bottom
        },
        hasViolations: Ga.top > 0 || Ga.left > 0 || Ga.right > 0 || Ga.bottom > 0
      };
      if (Ue) {
        Tt(Xa);
        var Ns = typeof Ue == "function" ? Ue(Xa) : Ue, Ya = Ns.top, Qa = Ns.left;
        St.current.style.transform = "translate(".concat(Math.round(ja + (Qa ?? 0)), "px, ").concat(Math.round(Ui + (Ya ?? 0)), "px)"), Xa.nudgedLeft += Qa ?? 0, Xa.nudgedTop += Ya ?? 0, Xa.transform = { top: Ya, left: Qa };
      }
      Tt(Xa);
    }
  }, [
    je,
    me,
    wt,
    St,
    bt,
    ie,
    Ue,
    qe,
    we,
    Ge,
    Xe,
    ot,
    vt,
    Tt
  ]);
  return { positionPopover: It, popoverRef: St, scoutRef: wt };
};
usePopover$1.usePopover = usePopover;
var useMemoizedArray$1 = {};
Object.defineProperty(useMemoizedArray$1, "__esModule", { value: !0 });
useMemoizedArray$1.useMemoizedArray = void 0;
var react_1$3 = React__default, useMemoizedArray = function(ce) {
  var ie = (0, react_1$3.useRef)(ce), me = (0, react_1$3.useMemo)(function() {
    if (ie.current === ce)
      return ie.current;
    if (ie.current.length !== ce.length)
      return ie.current = ce, ce;
    for (var we = 0; we < ce.length; we += 1)
      if (ce[we] !== ie.current[we])
        return ie.current = ce, ce;
    return ie.current;
  }, [ce]);
  return me;
};
useMemoizedArray$1.useMemoizedArray = useMemoizedArray;
var useHandlePrevValues$1 = {};
Object.defineProperty(useHandlePrevValues$1, "__esModule", { value: !0 });
useHandlePrevValues$1.useHandlePrevValues = void 0;
var react_1$2 = React__default, useHandlePrevValues = function(ce) {
  var ie = (0, react_1$2.useRef)(ce.positions), me = (0, react_1$2.useRef)(ce.reposition), we = (0, react_1$2.useRef)(ce.transformMode), Re = (0, react_1$2.useRef)(ce.transform), je = (0, react_1$2.useRef)(ce.boundaryElement), Ue = (0, react_1$2.useRef)(ce.boundaryInset), qe = (0, react_1$2.useCallback)(function() {
    ie.current = ce.positions, me.current = ce.reposition, we.current = ce.transformMode, Re.current = ce.transform, je.current = ce.boundaryElement, Ue.current = ce.boundaryInset;
  }, [
    ce.boundaryElement,
    ce.boundaryInset,
    ce.positions,
    ce.reposition,
    ce.transform,
    ce.transformMode
  ]);
  return {
    prev: {
      positions: ie.current,
      reposition: me.current,
      transformMode: we.current,
      transform: Re.current,
      boundaryElement: je.current,
      boundaryInset: Ue.current
    },
    updatePrevValues: qe
  };
};
useHandlePrevValues$1.useHandlePrevValues = useHandlePrevValues;
var useArrowContainer$1 = {}, __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$1 = Object.assign || function(ce) {
    for (var ie, me = 1, we = arguments.length; me < we; me++) {
      ie = arguments[me];
      for (var Re in ie) Object.prototype.hasOwnProperty.call(ie, Re) && (ce[Re] = ie[Re]);
    }
    return ce;
  }, __assign$1.apply(this, arguments);
};
Object.defineProperty(useArrowContainer$1, "__esModule", { value: !0 });
useArrowContainer$1.useArrowContainer = void 0;
var react_1$1 = React__default, useArrowContainer = function(ce) {
  var ie = ce.childRect, me = ce.popoverRect, we = ce.position, Re = ce.arrowSize, je = ce.arrowColor, Ue = (0, react_1$1.useMemo)(function() {
    return {
      padding: Re
    };
  }, [Re]), qe = (0, react_1$1.useMemo)(function() {
    return __assign$1({ position: "absolute" }, function() {
      var Ge = Re * 2, Xe = ie.top - me.top + ie.height / 2 - Ge / 2, ot = ie.left - me.left + ie.width / 2 - Ge / 2, vt = Re, bt = me.width - Re, Tt = me.height - Re;
      switch (ot = ot < vt ? vt : ot, ot = ot + Ge > bt ? bt - Ge : ot, Xe = Xe < vt ? vt : Xe, Xe = Xe + Ge > Tt ? Tt - Ge : Xe, Xe = Number.isNaN(Xe) ? 0 : Xe, ot = Number.isNaN(ot) ? 0 : ot, we) {
        case "right":
          return {
            borderTop: "".concat(Re, "px solid transparent"),
            borderBottom: "".concat(Re, "px solid transparent"),
            borderRight: "".concat(Re, "px solid ").concat(je),
            left: 0,
            top: Xe
          };
        case "left":
          return {
            borderTop: "".concat(Re, "px solid transparent"),
            borderBottom: "".concat(Re, "px solid transparent"),
            borderLeft: "".concat(Re, "px solid ").concat(je),
            right: 0,
            top: Xe
          };
        case "bottom":
          return {
            borderLeft: "".concat(Re, "px solid transparent"),
            borderRight: "".concat(Re, "px solid transparent"),
            borderBottom: "".concat(Re, "px solid ").concat(je),
            top: 0,
            left: ot
          };
        case "top":
          return {
            borderLeft: "".concat(Re, "px solid transparent"),
            borderRight: "".concat(Re, "px solid transparent"),
            borderTop: "".concat(Re, "px solid ").concat(je),
            bottom: 0,
            left: ot
          };
        default:
          return {
            display: "hidden"
          };
      }
    }());
  }, [
    je,
    Re,
    ie.height,
    ie.left,
    ie.top,
    ie.width,
    me.height,
    me.left,
    me.top,
    me.width,
    we
  ]);
  return {
    arrowContainerStyle: Ue,
    arrowStyle: qe
  };
};
useArrowContainer$1.useArrowContainer = useArrowContainer;
var ArrowContainer$1 = {}, __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign = Object.assign || function(ce) {
    for (var ie, me = 1, we = arguments.length; me < we; me++) {
      ie = arguments[me];
      for (var Re in ie) Object.prototype.hasOwnProperty.call(ie, Re) && (ce[Re] = ie[Re]);
    }
    return ce;
  }, __assign.apply(this, arguments);
};
Object.defineProperty(ArrowContainer$1, "__esModule", { value: !0 });
ArrowContainer$1.ArrowContainer = void 0;
var jsx_runtime_1 = jsxRuntimeExports, react_1 = React__default, useArrowContainer_1 = useArrowContainer$1, ArrowContainer = function(ce) {
  var ie = ce.childRect, me = ce.popoverRect, we = ce.position, Re = ce.arrowColor, je = ce.arrowSize, Ue = ce.arrowClassName, qe = ce.arrowStyle, Ge = ce.className, Xe = ce.children, ot = ce.style, vt = (0, useArrowContainer_1.useArrowContainer)({
    childRect: ie,
    popoverRect: me,
    position: we,
    arrowColor: Re,
    arrowSize: je
  }), bt = vt.arrowContainerStyle, Tt = vt.arrowStyle, wt = (0, react_1.useMemo)(function() {
    return __assign(__assign({}, bt), ot);
  }, [bt, ot]), St = (0, react_1.useMemo)(function() {
    return __assign(__assign({}, Tt), qe);
  }, [Tt, qe]);
  return (0, jsx_runtime_1.jsxs)("div", { className: Ge, style: wt, children: [(0, jsx_runtime_1.jsx)("div", { style: St, className: Ue }), Xe] });
};
ArrowContainer$1.ArrowContainer = ArrowContainer;
(function(ce) {
  var ie = commonjsGlobal && commonjsGlobal.__assign || function() {
    return ie = Object.assign || function(Tt) {
      for (var wt, St = 1, It = arguments.length; St < It; St++) {
        wt = arguments[St];
        for (var Pt in wt) Object.prototype.hasOwnProperty.call(wt, Pt) && (Tt[Pt] = wt[Pt]);
      }
      return Tt;
    }, ie.apply(this, arguments);
  };
  Object.defineProperty(ce, "__esModule", { value: !0 }), ce.Popover = ce.usePopover = ce.ArrowContainer = ce.useArrowContainer = void 0;
  var me = jsxRuntimeExports, we = React__default, Re = PopoverPortal$1, je = util, Ue = usePopover$1;
  Object.defineProperty(ce, "usePopover", { enumerable: !0, get: function() {
    return Ue.usePopover;
  } });
  var qe = useMemoizedArray$1, Ge = useHandlePrevValues$1, Xe = useArrowContainer$1;
  Object.defineProperty(ce, "useArrowContainer", { enumerable: !0, get: function() {
    return Xe.useArrowContainer;
  } });
  var ot = ArrowContainer$1;
  Object.defineProperty(ce, "ArrowContainer", { enumerable: !0, get: function() {
    return ot.ArrowContainer;
  } });
  var vt = ["top", "left", "right", "bottom"], bt = (0, we.forwardRef)(function(Tt, wt) {
    var St = Tt.isOpen, It = Tt.children, Pt = Tt.content, kt = Tt.positions, Ot = kt === void 0 ? vt : kt, Jr = Tt.align, en = Jr === void 0 ? "center" : Jr, nn = Tt.padding, ln = nn === void 0 ? 0 : nn, fn = Tt.reposition, vn = fn === void 0 ? !0 : fn, Tn = Tt.parentElement, xn = Tn === void 0 ? window.document.body : Tn, bn = Tt.boundaryElement, Sn = bn === void 0 ? xn : bn, Cn = Tt.containerClassName, kn = Tt.containerStyle, cn = Tt.transform, gn = Tt.transformMode, an = gn === void 0 ? "absolute" : gn, un = Tt.boundaryInset, pn = un === void 0 ? 0 : un, hn = Tt.onClickOutside, An = Tt.clickOutsideCapture, In = An === void 0 ? !1 : An, qn = (0, qe.useMemoizedArray)(Array.isArray(Ot) ? Ot : [Ot]), si = (0, Ge.useHandlePrevValues)({
      positions: qn,
      reposition: vn,
      transformMode: an,
      transform: cn,
      boundaryElement: Sn,
      boundaryInset: pn
    }), bi = si.prev, xi = si.updatePrevValues, ji = (0, we.useRef)(), zi = (0, we.useState)({
      align: en,
      nudgedLeft: 0,
      nudgedTop: 0,
      position: qn[0],
      padding: ln,
      childRect: je.EMPTY_RECT,
      popoverRect: je.EMPTY_RECT,
      parentRect: je.EMPTY_RECT,
      boundaryRect: je.EMPTY_RECT,
      boundaryInset: pn,
      violations: je.EMPTY_RECT,
      hasViolations: !1
    }), Vi = zi[0], Hi = zi[1], ii = (0, we.useCallback)(function(Ja) {
      return Hi(Ja);
    }, []), Fi = (0, Ue.usePopover)({
      isOpen: St,
      childRef: ji,
      containerClassName: Cn,
      parentElement: xn,
      boundaryElement: Sn,
      transform: cn,
      transformMode: an,
      positions: qn,
      align: en,
      padding: ln,
      boundaryInset: pn,
      reposition: vn,
      onPositionPopover: ii
    }), ni = Fi.positionPopover, Ui = Fi.popoverRef, ja = Fi.scoutRef;
    (0, we.useLayoutEffect)(function() {
      var Ja = !0, Ms = function() {
        var Hs, no;
        if (St && Ja) {
          var Qs = (Hs = ji == null ? void 0 : ji.current) === null || Hs === void 0 ? void 0 : Hs.getBoundingClientRect(), Zs = (no = Ui == null ? void 0 : Ui.current) === null || no === void 0 ? void 0 : no.getBoundingClientRect();
          Qs != null && Zs != null && (!(0, je.rectsAreEqual)(Qs, Vi.childRect) || Zs.width !== Vi.popoverRect.width || Zs.height !== Vi.popoverRect.height || Vi.padding !== ln || Vi.align !== en || qn !== bi.positions || vn !== bi.reposition || an !== bi.transformMode || cn !== bi.transform || Sn !== bi.boundaryElement || pn !== bi.boundaryInset) && ni(), xi(), Ja && window.requestAnimationFrame(Ms);
        }
      };
      return Ms(), function() {
        Ja = !1;
      };
    }, [
      en,
      Sn,
      pn,
      St,
      ln,
      Ui,
      Vi.align,
      Vi.childRect,
      Vi.padding,
      Vi.popoverRect.height,
      Vi.popoverRect.width,
      ni,
      qn,
      bi.boundaryElement,
      bi.boundaryInset,
      bi.positions,
      bi.reposition,
      bi.transform,
      bi.transformMode,
      vn,
      cn,
      an,
      xi
    ]), (0, we.useEffect)(function() {
      var Ja = Ui.current;
      return Object.assign(Ja.style, kn), function() {
        Object.keys(kn ?? {}).forEach(function(Ms) {
          return delete Ja.style[Ms];
        });
      };
    }, [kn, St, Ui]);
    var Ga = (0, we.useCallback)(function(Ja) {
      var Ms, Hs;
      St && !(!((Ms = Ui.current) === null || Ms === void 0) && Ms.contains(Ja.target)) && !(!((Hs = ji.current) === null || Hs === void 0) && Hs.contains(Ja.target)) && (hn == null || hn(Ja));
    }, [St, hn, Ui]), Xa = (0, we.useCallback)(function() {
      ji.current && St && window.requestAnimationFrame(function() {
        return ni();
      });
    }, [ni, St]);
    (0, we.useEffect)(function() {
      var Ja = xn.ownerDocument.body;
      return Ja.addEventListener("click", Ga, In), Ja.addEventListener("contextmenu", Ga, In), window.addEventListener("resize", Xa), function() {
        Ja.removeEventListener("click", Ga, In), Ja.removeEventListener("contextmenu", Ga, In), window.removeEventListener("resize", Xa);
      };
    }, [In, Ga, Xa, xn]);
    var Ns = (0, we.useCallback)(function(Ja) {
      ji.current = Ja, wt != null && (typeof wt == "object" ? wt.current = Ja : typeof wt == "function" && wt(Ja));
    }, [wt]), Ya = function() {
      return (0, we.cloneElement)(It, { ref: Ns });
    }, Qa = function() {
      return St ? (0, me.jsx)(Re.PopoverPortal, { element: Ui.current, scoutElement: ja.current, container: xn, children: typeof Pt == "function" ? Pt(Vi) : Pt }) : null;
    };
    return (0, me.jsxs)(me.Fragment, { children: [Ya(), Qa()] });
  });
  ce.Popover = (0, we.forwardRef)(function(Tt, wt) {
    return typeof window > "u" ? Tt.children : (0, me.jsx)(bt, ie({}, Tt, { ref: wt }));
  });
})(Popover);
const PopoverHOC = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(Popover.Popover, { ...ce, padding: 10, reposition: !0, children: ce.children }), INDENT_STEP = 24, TreeNode = ({ node: ce, style: ie, dragHandle: me }) => {
  const we = ie, Re = Number.parseFloat(`${we.paddingLeft || 0}`);
  return ce.data.isAddNew ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddNewTreeNodeInternal,
    {
      style: ie,
      name: ce.data.name,
      indentSize: Re,
      onSelect: () => ce.select()
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    TreeNodeInternal,
    {
      style: ie,
      name: ce.data.name,
      isSelected: ce.isSelected,
      isOpen: ce.isOpen,
      leftIcon: ce.data.leftIcon,
      rightIcon: ce.data.rightIcon,
      moreIconDropdownComponent: ce.data.moreIconDropdownComponent,
      indentSize: Re,
      onSelect: () => ce.select(),
      dragHandle: me,
      onToggle: ce.isInternal ? () => ce.toggle() : void 0,
      selectDisabled: ce.data.selectDisabled
    }
  );
}, TreeNodeInternal = ({
  style: ce,
  name: ie,
  isSelected: me = !1,
  leftIcon: we,
  rightIcon: Re,
  isOpen: je = !1,
  indentSize: Ue = 0,
  selectDisabled: qe = !1,
  moreIconDropdownComponent: Ge,
  dragHandle: Xe,
  onSelect: ot,
  onToggle: vt
}) => {
  const bt = useSwitch(!1), Tt = me && !qe;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: Xe,
      style: ce,
      onClick: ot,
      className: classNames("relative group/treeNode hover:bg-surface rounded-2 cursor-pointer", {
        "bg-surface": Tt
      }),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute left-0 top-0 z--1 h-full flex items-start z-2", children: new Array(Ue / INDENT_STEP).fill(0).map((wt, St) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-[24px] h-full w-[1px] bg-grey-600" }, St)) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames("flex flex-1 flex-row items-center gap-2 pb-3.5 px-2  mx-2 pt-3.5 rounded-2"), children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: classNames({
                "text-grey-400 group-hover/treeNode:text-grey-100": !Tt,
                "text-accent": Tt
              }),
              onClick: vt !== void 0 ? (wt) => {
                wt.preventDefault(), wt.stopPropagation(), vt();
              } : void 0,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  fixedWidth: !0,
                  icon: we,
                  className: classNames("transition-all", { "rotate-90": je })
                }
              )
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: classNames("font-semibold text-overflow-ellipsis", {
                "text-grey-350 group-hover/treeNode:text-grey-200": !Tt,
                "text-accent": Tt && !qe
              }),
              children: ie
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-4 ml-auto", children: [
            Re && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("flex gap-4 text-grey-100", { "text-accent": Tt }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { fixedWidth: !0, icon: Re }) }),
            Ge !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: classNames("flex gap-4 text-grey-100", {
                  "bg-grey-700 opacity-100": bt.isOn,
                  "bg-grey-700 opacity-0 group-hover/treeNode:opacity-100": !bt.isOn
                }),
                onClick: (wt) => {
                  wt.preventDefault(), wt.stopPropagation(), bt.toggle();
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  PopoverHOC,
                  {
                    isOpen: bt.isOn,
                    align: "start",
                    positions: ["right", "bottom", "left"],
                    content: Ge(bt.turnOff),
                    onClickOutside: bt.turnOff,
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { fixedWidth: !0, icon: faEllipsis })
                  }
                )
              }
            )
          ] })
        ] })
      ]
    }
  );
}, AddNewTreeNodeInternal = ({ name: ce, style: ie, indentSize: me = 0, onSelect: we }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: ie, onClick: we, className: "relative group/treeNode hover:bg-surface rounded-2 cursor-pointer", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute left-0 top-0 z--1 h-full flex items-start z-2", children: new Array(me / INDENT_STEP).fill(0).map((Re, je) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-[24px] h-full w-[1px] bg-grey-600" }, je)) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames("flex flex-1 flex-row items-center gap-2 pb-3.5 px-2  mx-2 pt-3.5 rounded-2"), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-grey-400 group-hover/treeNode:text-grey-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { fixedWidth: !0, icon: faPlus$1, className: "text-accent" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "font-semibold text-overflow-ellipsis text-text group-hover/treeNode:text-grey-200", children: ce })
  ] })
] }), Tree = ({ data: ce, selectedId: ie, onMove: me, onNodeClick: we }) => {
  const { ref: Re, width: je, height: Ue } = useResizeObserver(), qe = (Ge) => {
    const Xe = Ge[0];
    Xe && (we == null || we(Xe));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Re, style: { height: "100%", minHeight: 0 }, className: "bg-background", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    $2ba43033bb8eb39d$export$7fbedc92909ed28e,
    {
      data: ce,
      openByDefault: !0,
      indent: 24,
      rowHeight: 51,
      height: Ue,
      width: je,
      onMove: me,
      onSelect: qe,
      renderRow: TreeRow,
      disableDrag: me === void 0,
      selection: ie,
      disableMultiSelection: !0,
      children: TreeNode
    }
  ) });
};
var UnderlineTextInputSize = /* @__PURE__ */ ((ce) => (ce.Default = "Default", ce.Big = "Big", ce.Medium = "Medium", ce.Small = "Small", ce))(UnderlineTextInputSize || {});
const UnderlineTextInput = ({
  value: ce,
  inputClassName: ie,
  placeholder: me,
  autoFocus: we,
  maxLength: Re,
  disabled: je,
  onDiscard: Ue,
  onChange: qe,
  errorMessage: Ge,
  stretched: Xe,
  onBlur: ot,
  onFocus: vt,
  textInputSize: bt = "Default"
  /* Default */
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: classNames("text-input", {
      "text-input--stretched": Xe
    }),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          type: "text",
          className: classNames(
            "text-input__input",
            {
              "text-input__input--error": !!Ge,
              "text-input__input--disabled": je,
              "text-input__input--type-big": bt === "Big",
              "text-input__input--type-medium": bt === "Medium",
              "text-input__input--type-small": bt === "Small"
              /* Small */
            },
            ie
          ),
          value: ce,
          onChange: (Tt) => qe(Tt.currentTarget.value),
          onBlur: ot,
          onFocus: vt,
          autoFocus: we !== void 0 ? we : me === ce,
          placeholder: me,
          maxLength: Re
        }
      ),
      Ue && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-input__controls-pane", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faTimes, className: "text-input__discard-button", onClick: Ue }) }),
      !!Ge && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-input__error", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-input__error-message", children: "Oops!" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-input__error-text", children: Ge })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faExclamationCircle$1, className: "text-input__error-icon", fixedWidth: !0 })
      ] })
    ]
  }
), UnderlineTextInputWithDefaultValue = ({
  value: ce,
  onChange: ie,
  errorMessage: me,
  disabled: we,
  textInputSize: Re,
  stretched: je,
  onDiscard: Ue,
  defaultValue: qe,
  autoFocus: Ge,
  maxLength: Xe,
  inputClassName: ot,
  placeholder: vt
}) => {
  const [bt, Tt] = useState(!0), St = bt && ce === qe ? "" : ce, It = (Pt) => {
    isStringEmptyOrWhiteSpace(Pt) ? (bt || Tt(!0), ie(qe)) : (Tt(!1), ie(Pt));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    UnderlineTextInput,
    {
      value: St,
      onChange: It,
      autoFocus: Ge,
      placeholder: vt ?? qe,
      maxLength: Xe,
      disabled: we,
      errorMessage: me,
      onDiscard: Ue,
      stretched: je,
      textInputSize: Re,
      inputClassName: ot
    }
  );
}, VideoPlayer = ({
  src: ce,
  autoplay: ie,
  seekBarLocked: me,
  hideControls: we,
  loop: Re,
  mute: je,
  onEnded: Ue
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  t1,
  {
    src: ce,
    autoplay: ie,
    seekBarLocked: me,
    hideControls: we,
    loop: Re,
    mute: je,
    onEnded: Ue
  }
);
class YouTubeAPIManager {
  constructor() {
    M1(this, "isScriptLoaded", !1);
    M1(this, "isAPIReady", !1);
    M1(this, "isLoading", !1);
    M1(this, "callbacks", /* @__PURE__ */ new Set());
    M1(this, "scriptLoadCallbacks", /* @__PURE__ */ new Set());
  }
  /**
   * Subscribe to API ready state
   * @param callback Function to call when API is ready
   * @returns Unsubscribe function
   */
  onAPIReady(ie) {
    return this.isAPIReady ? (ie(), () => {
    }) : (this.callbacks.add(ie), this.loadAPI(), () => {
      this.callbacks.delete(ie);
    });
  }
  /**
   * Subscribe to script load state (before API is ready)
   * @param callback Function to call when script is loaded
   * @returns Unsubscribe function
   */
  onScriptLoaded(ie) {
    return this.isScriptLoaded ? (ie(), () => {
    }) : (this.scriptLoadCallbacks.add(ie), this.loadAPI(), () => {
      this.scriptLoadCallbacks.delete(ie);
    });
  }
  /**
   * Check if API is ready
   */
  get ready() {
    return this.isAPIReady;
  }
  /**
   * Check if script is loaded
   */
  get scriptLoaded() {
    return this.isScriptLoaded;
  }
  /**
   * Load the YouTube IFrame API
   */
  loadAPI() {
    var we;
    if ((we = window.YT) != null && we.Player) {
      this.markAsReady();
      return;
    }
    if (this.isLoading)
      return;
    if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      this.isLoading = !0, this.setupGlobalCallback(), this.checkAPIReady();
      return;
    }
    this.isLoading = !0, this.setupGlobalCallback();
    const me = document.createElement("script");
    me.src = "https://www.youtube.com/iframe_api", me.async = !0, me.onload = () => {
      var Re;
      this.isScriptLoaded = !0, this.notifyScriptLoadCallbacks(), (Re = window.YT) != null && Re.Player && this.markAsReady();
    }, me.onerror = () => {
      this.isLoading = !1, console.error("Failed to load YouTube IFrame API");
    }, document.head.appendChild(me);
  }
  /**
   * Set up the global YouTube API ready callback
   */
  setupGlobalCallback() {
    const ie = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (ie && typeof ie == "function")
        try {
          ie();
        } catch (me) {
          console.warn("Error in existing YouTube API callback:", me);
        }
      this.markAsReady();
    };
  }
  /**
   * Check if API is ready (polling fallback)
   */
  checkAPIReady() {
    var we;
    if ((we = window.YT) != null && we.Player) {
      this.markAsReady();
      return;
    }
    const ie = setInterval(() => {
      var Re;
      (Re = window.YT) != null && Re.Player && (clearInterval(ie), clearTimeout(me), this.markAsReady());
    }, 100), me = setTimeout(() => {
      clearInterval(ie), console.warn("YouTube API failed to initialize within timeout"), this.isLoading = !1;
    }, 5e3);
  }
  /**
   * Mark API as ready and notify all callbacks
   */
  markAsReady() {
    this.isAPIReady || (this.isAPIReady = !0, this.isScriptLoaded = !0, this.isLoading = !1, this.notifyScriptLoadCallbacks(), this.notifyAPIReadyCallbacks());
  }
  /**
   * Notify all script load callbacks
   */
  notifyScriptLoadCallbacks() {
    this.scriptLoadCallbacks.forEach((ie) => {
      try {
        ie();
      } catch (me) {
        console.error("Error in YouTube API script load callback:", me);
      }
    }), this.scriptLoadCallbacks.clear();
  }
  /**
   * Notify all API ready callbacks
   */
  notifyAPIReadyCallbacks() {
    this.callbacks.forEach((ie) => {
      try {
        ie();
      } catch (me) {
        console.error("Error in YouTube API ready callback:", me);
      }
    }), this.callbacks.clear();
  }
}
const youTubeAPIManager = new YouTubeAPIManager(), getYouTubeErrorMessage = (ce) => {
  switch (ce) {
    case 2:
      return "Invalid video ID. Please check the video URL.";
    case 5:
      return "HTML5 player error. The video cannot be played in this browser.";
    case 100:
      return "Video not found. The video may have been removed or made private.";
    case 101:
      return "Video cannot be embedded. The video owner has restricted embedding.";
    case 150:
      return "Video cannot be embedded. The video owner has restricted embedding.";
    default:
      return `Video playback error (${ce}). Please try again later.`;
  }
}, YouTubeVideoPlayer = ({
  videoId: ce,
  onEnded: ie,
  className: me = "youtube-video-player"
}) => {
  const we = useRef(null), Re = useRef(null), je = useRef(null), Ue = useRef(!1), qe = useRef(null), [Ge, Xe] = useState(youTubeAPIManager.ready), [ot, vt] = useState(!1), [bt, Tt] = useState(null), wt = useCallback(() => {
    var Pt;
    if (!we.current || !((Pt = window.YT) != null && Pt.Player) || !Ge)
      return;
    if (je.current && (clearTimeout(je.current), je.current = null), Re.current) {
      try {
        Re.current.destroy();
      } catch (kt) {
        console.warn("Error destroying previous YouTube player:", kt);
      }
      Re.current = null;
    }
    const St = we.current;
    St.innerHTML = "";
    const It = document.createElement("div");
    It.id = `youtube-player-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`, St.appendChild(It), je.current = window.setTimeout(() => {
      if (!Ue.current && !qe.current) {
        console.log("YouTube player timeout - video failed to load");
        const kt = "Video cannot be embedded. The video owner has restricted embedding.";
        qe.current = kt, Tt(kt);
      }
    }, 1e4);
    try {
      Re.current = new window.YT.Player(It, {
        width: "100%",
        height: "100%",
        videoId: ce,
        playerVars: {
          autoplay: 0,
          controls: 1,
          enablejsapi: 1,
          rel: 0,
          playsinline: 1
        },
        events: {
          onStateChange: (kt) => {
            var Ot;
            (kt.data === 0 || (Ot = window.YT) != null && Ot.PlayerState && kt.data === window.YT.PlayerState.ENDED) && (ie == null || ie());
          },
          onError: (kt) => {
            je.current && (clearTimeout(je.current), je.current = null);
            const Ot = getYouTubeErrorMessage(kt.data);
            console.log("YouTube player error occurred:", kt.data, Ot), qe.current = Ot, Tt(Ot), console.error("YouTube player error:", kt.data, Ot);
          },
          onReady: () => {
            je.current && (clearTimeout(je.current), je.current = null), Ue.current = !0, qe.current = null, vt(!0), Tt(null);
          }
        }
      });
    } catch (kt) {
      je.current && (clearTimeout(je.current), je.current = null);
      const Ot = kt instanceof Error ? kt.message : String(kt);
      qe.current = `Error initializing YouTube player: ${Ot}`, Tt(`Error initializing YouTube player: ${Ot}`), console.error("Error initializing YouTube player:", kt);
    }
  }, [ce, ie, Ge]);
  return useEffect(() => {
    const St = youTubeAPIManager.onAPIReady(() => {
      Xe(!0);
    }), It = we.current;
    return () => {
      if (St(), je.current && (clearTimeout(je.current), je.current = null), Re.current) {
        try {
          Re.current.destroy();
        } catch (Pt) {
          console.warn("Error destroying YouTube player during cleanup:", Pt);
        }
        Re.current = null;
      }
      It && (It.innerHTML = "");
    };
  }, []), useEffect(() => {
    Ge && we.current && (qe.current = null, Ue.current = !1, Tt(null), vt(!1), wt());
  }, [Ge, wt]), useEffect(() => {
    je.current && (clearTimeout(je.current), je.current = null), qe.current = null, Ue.current = !1, Tt(null), vt(!1);
  }, [ce]), console.log(bt), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: me,
      style: {
        position: "relative",
        overflow: "hidden",
        paddingTop: "56.25%",
        width: "100%"
      },
      children: [
        bt && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `
            absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center
            bg-background text-text-muted p-5 box-border text-center border border-stroke rounded
          `,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { size: "xs", weight: "semibold", className: "mb-2", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faWarning }),
                " Video Unavailable"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "xs", children: bt })
            ]
          }
        ),
        !bt && !ot && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute top-0 left-0 w-full h-full flex items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ImageLoader,
          {
            width: 320,
            height: 180,
            style: {
              width: "100%",
              height: "100%"
            }
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            ref: we,
            className: `absolute top-0 left-0 w-full h-full transition-opacity ${bt ? "hidden" : ""}`
          },
          `youtube-player-${ce}`
        )
      ]
    }
  );
}, ZIndex = ({ children: ce, index: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { zIndex: ie }, children: ce }), MenuItemLabel = ({ children: ce, yellow: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("menu-item-label", { "menu-item-label--yellow": ie }), children: ce }), TrackingIndicator = (ce) => {
  switch (ce.status) {
    case "not-tracked":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tracking-indicator tracking-indicator--not-visited" });
    case "not-visited":
    case "unknown":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tracking-indicator tracking-indicator--not-visited" });
    case "in-progress":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tracking-indicator tracking-indicator--in-progress" });
    case "completed":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tracking-indicator tracking-indicator--completed" });
    default:
      return assertUnreachable$1(ce.status);
  }
};
function assertUnreachable$1(ce) {
  throw new Error("Tracking status not expected:" + JSON.stringify(ce));
}
var ProgressIndication = /* @__PURE__ */ ((ce) => (ce.Percentage = "Percentage", ce.CompletedOfTotal = "CompletedOfTotal", ce.PassedFailed = "PassedFailed", ce))(ProgressIndication || {}), PassedFailedStatus = /* @__PURE__ */ ((ce) => (ce.NotStarted = "NotStarted", ce.Incomplete = "Incomplete", ce.Passed = "Passed", ce))(PassedFailedStatus || {});
const createCompletedPercentageDisplayConfiguration = (ce) => ({
  type: "Percentage",
  percentage: ce
}), createCompletedOfTotalProgressDisplayConfiguration = (ce, ie) => ({
  type: "CompletedOfTotal",
  completed: ie,
  total: ce
}), createPassedFailedProgressDisplayConfiguration = (ce) => ({ type: "PassedFailed", status: (() => {
  switch (ce) {
    case "completed":
      return "Passed";
    case "in-progress":
      return "Incomplete";
    case "not-tracked":
    case "unknown":
    case "not-visited":
      return "NotStarted";
    default:
      return assertUnreachable(ce);
  }
})() });
function assertUnreachable(ce) {
  throw new Error("Tracking status not expected:" + JSON.stringify(ce));
}
const CompletionStatusLabel = ({ progressDetails: ce, messages: ie }) => {
  const me = React__default.useCallback(
    (we) => {
      switch (we) {
        case PassedFailedStatus.Passed:
          return ie.passedText;
        case PassedFailedStatus.Incomplete:
          return ie.incompleteText;
        case PassedFailedStatus.NotStarted:
          return ie.notStartedText;
      }
    },
    [ie.incompleteText, ie.notStartedText, ie.passedText]
  );
  if (ce.hasProgress) {
    const { isActive: we, isSemiActive: Re, progress: je, hideChevron: Ue } = ce;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: classNames("completion-status-label", {
          "completion-status-label__active": we,
          "completion-status-label__semi-active": Re
        }),
        children: ce.showItemCompletion ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          je.type === ProgressIndication.PassedFailed && me(je.status),
          je.type === ProgressIndication.Percentage && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            je.percentage,
            "% ",
            ie.completionLabelText
          ] }),
          je.type === ProgressIndication.CompletedOfTotal && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            je.completed,
            "/",
            je.total,
            " ",
            ie.completionLabelText
          ] }),
          !Ue && /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: faChevronRight,
              size: "xs",
              className: classNames("completion-status-label__icon", {
                "completion-status-label__icon--active": we
              })
            }
          )
        ] }) : ie.optionalItemText
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("completion-status-label completion-status-label__disabled"), children: ie.emptyItemText });
};
class MenuItemDragHandle extends React__default.PureComponent {
  render() {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item-drag-handle", ...this.props.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faArrowsV, size: "lg" }) });
  }
}
M1(MenuItemDragHandle, "displayName", "MenuItemDragHandle");
const NESTED_MENU_ITEM_PADDING = 20;
var MenuItemType = /* @__PURE__ */ ((ce) => (ce.ManagerItem = "ManagerItem", ce.StudentItem = "StudentItem", ce.ManagerSubmenu = "ManagerSubmenu", ce.StudentSubmenu = "StudentSubmenu", ce.AddNew = "AddNew", ce.ResourcesFolder = "ResourcesFolder", ce.Resource = "Resource", ce.HomeOverview = "HomeOverview", ce))(MenuItemType || {});
const MenuItem = memo(
  ({ children: ce, menuItemDetails: ie, className: me, elementId: we, onClick: Re }) => {
    const je = {
      studentItem: (cn) => cn.menuItemType === "StudentItem",
      studentSubmenu: (cn) => cn.menuItemType === "StudentSubmenu",
      managerItem: (cn) => cn.menuItemType === "ManagerItem",
      managerSubmenu: (cn) => cn.menuItemType === "ManagerSubmenu",
      resourcesFolder: (cn) => cn.menuItemType === "ResourcesFolder",
      resourceItem: (cn) => cn.menuItemType === "Resource",
      homeOverview: (cn) => cn.menuItemType === "HomeOverview",
      addNewItem: (cn) => cn.menuItemType === "AddNew"
      /* AddNew */
    }, {
      studentItem: Ue,
      studentSubmenu: qe,
      managerItem: Ge,
      managerSubmenu: Xe,
      resourcesFolder: ot,
      resourceItem: vt,
      addNewItem: bt,
      homeOverview: Tt
    } = je, wt = ot(ie), St = vt(ie), It = Tt(ie), Pt = bt(ie), kt = Xe(ie) || qe(ie), Ot = Ue(ie) || qe(ie) ? ie.nestedLevel : 0, Jr = qe(ie) ? ie.hasActiveChild : void 0, en = Ue(ie) || qe(ie) ? ie.disabled : void 0, nn = Ue(ie) || qe(ie) ? ie.locked : void 0, ln = Ue(ie) || qe(ie) ? ie.parentItemId !== null : St, fn = Ue(ie) || qe(ie) || Ge(ie) || wt || St ? ie.active : void 0, vn = Ue(ie) || qe(ie) ? ie.trackingStatus : void 0, Tn = Ge(ie) || Xe(ie) ? ie.dragHandle : null, xn = Ue(ie) ? ie.progress : void 0, bn = Ue(ie) ? ie.ContentItemsComponent : void 0, Sn = Ue(ie) ? ie.showItemCompletion : void 0, Cn = Ue(ie) && !wt, kn = Ue(ie) && ie.hideChevron;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: classNames("menu-item__wrapper", {
          "menu-item__wrapper--has-active-child": Jr,
          "menu-item__wrapper--disabled": en || nn,
          "menu-item__wrapper--child": ln
        }),
        "data-elementid": we,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              style: {
                paddingLeft: Ot * NESTED_MENU_ITEM_PADDING
              },
              className: classNames("menu-item", me, {
                "menu-item--has-active-child": Jr,
                "menu-item--disabled": en || nn,
                "menu-item--child": ln,
                "menu-item--active": fn && !wt,
                "menu-item--active-resources-folder": fn && wt,
                "menu-item--sticky": fn && !kt && !wt
              }),
              onClick: () => {
                !en && !nn && Re && Re();
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "div",
                  {
                    className: classNames("menu-item__appendix", {
                      "menu-item__appendix--add-item": Pt
                    }),
                    children: [
                      Pt && ie.icon,
                      vn && !en && !nn && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__tracking-indicator", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrackingIndicator, { status: vn }) }),
                      nn && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__lock", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faLockAlt }) }),
                      wt && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__resources-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faBook, fixedWidth: !0, size: "lg" }) }),
                      St && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__resource-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faFileAlt, fixedWidth: !0 }) }),
                      It && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__resource-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faHome, fixedWidth: !0 }) })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-item__content-wrapper", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__content", children: ce }),
                  Cn && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CompletionStatusLabel,
                    {
                      progressDetails: xn ? {
                        hasProgress: !0,
                        progress: xn,
                        isActive: fn,
                        showItemCompletion: Sn,
                        hideChevron: kn
                      } : { hasProgress: !1 },
                      messages: ie.messages
                    }
                  )
                ] }),
                Tn && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-item__drag-handle", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemDragHandle, { dragHandleProps: Tn }) }),
                (kt || wt) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "div",
                  {
                    className: classNames("menu-item__arrow", {
                      "menu-item__arrow--locked": nn,
                      "menu-item__arrow--disabled": en,
                      "menu-item__arrow--active": fn || Jr
                    }),
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faChevronRight, fixedWidth: !0, size: "lg", className: "fa-transition" })
                  }
                )
              ]
            }
          ),
          !kt && bn && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: bn })
        ]
      }
    );
  }
), ButtonVariantToColors = {
  danger: "text-red-500",
  primary: "text-accent",
  neutral: "text-text"
}, ActionBoxVariantToClassname = {
  bordered: "rounded-lg px-4 h-10.5 bg-surface border border-stroke border-solid align-start",
  naked: "py-3"
}, ActionBox = ({
  variant: ce = "bordered",
  onClick: ie,
  icon: me,
  text: we,
  actions: Re,
  inactive: je,
  fullWidth: Ue,
  isImageIcon: qe
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: classNames("flex items-center justify-between gap-2", ActionBoxVariantToClassname[ce], {
      "w-full": Ue
    }),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: "flex-1 flex items-center gap-2 overflow-hidden",
          onClick: je ? void 0 : () => ie && ie(),
          children: [
            me && (qe ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-6 w-6 p-1.5 light:bg-grey-700 rounded-full", children: me }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex text-text max-h-6 w-6", children: me })),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: classNames(
                  "text-ellipsis overflow-hidden whitespace-nowrap text--regular text--xs",
                  je ? "text-text-muted" : "text-text",
                  ie ? "cursor-pointer" : ""
                ),
                children: we
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-row gap-4 min-w-fit", children: Re.map((Ge, Xe) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: classNames("text--semibold text--xs", ButtonVariantToColors[Ge.variant], {
            "cursor-pointer": !Ge.disabled,
            "cursor-default opacity-30": Ge.disabled
          }),
          onClick: Ge.disabled ? void 0 : Ge.onClick,
          children: Ge.text
        },
        Xe
      )) })
    ]
  }
);
function isNumber(ce) {
  const ie = parseFloat(ce);
  return !isNaN(ie) && isFinite(ie);
}
function isPercentage(ce) {
  return typeof ce == "string" && ce[ce.length - 1] === "%" && isNumber(ce.substring(0, ce.length - 1));
}
function hideContent(ce, ie, me) {
  ie === 0 && !me && (ce != null && ce.style) && (ce == null ? void 0 : ce.children.length) > 0 && (ce.style.display = "none");
}
function showContent(ce, ie) {
  ie === 0 && (ce != null && ce.style) && (ce.style.display = "");
}
const ANIMATION_STATE_CLASSES = {
  animating: "rah-animating",
  animatingUp: "rah-animating--up",
  animatingDown: "rah-animating--down",
  animatingToHeightZero: "rah-animating--to-height-zero",
  animatingToHeightAuto: "rah-animating--to-height-auto",
  animatingToHeightSpecific: "rah-animating--to-height-specific",
  static: "rah-static",
  staticHeightZero: "rah-static--height-zero",
  staticHeightAuto: "rah-static--height-auto",
  staticHeightSpecific: "rah-static--height-specific"
};
function getStaticStateClasses(ce, ie) {
  return [
    ce.static,
    ie === 0 && ce.staticHeightZero,
    typeof ie == "number" && ie > 0 ? ce.staticHeightSpecific : null,
    ie === "auto" && ce.staticHeightAuto
  ].filter((me) => me).join(" ");
}
const propsToOmitFromDiv = [
  "animateOpacity",
  "animationStateClasses",
  "applyInlineTransitions",
  "children",
  "className",
  "contentClassName",
  "contentRef",
  "delay",
  "duration",
  "easing",
  "height",
  "onHeightAnimationEnd",
  "onHeightAnimationStart",
  "style",
  "disableDisplayNone"
], AnimateHeight = React__default.forwardRef((ce, ie) => {
  const { animateOpacity: me = !1, animationStateClasses: we = {}, applyInlineTransitions: Re = !0, children: je, className: Ue = "", contentClassName: qe, delay: Ge = 0, disableDisplayNone: Xe = !1, duration: ot = 500, easing: vt = "ease", height: bt, onHeightAnimationEnd: Tt, onHeightAnimationStart: wt, style: St, contentRef: It } = ce, Pt = Object.assign({}, ce);
  propsToOmitFromDiv.forEach((si) => {
    delete Pt[si];
  });
  const kt = useRef(bt), Ot = useRef(null), Jr = useRef(), en = useRef(), nn = useRef(Object.assign(Object.assign({}, ANIMATION_STATE_CLASSES), we)), fn = useRef(typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-reduced-motion)").matches : !1), vn = fn.current ? 0 : Ge, Tn = fn.current ? 0 : ot;
  let xn = bt, bn = "visible";
  typeof bt == "number" ? (xn = bt < 0 ? 0 : bt, bn = "hidden") : isPercentage(xn) && (xn = bt === "0%" ? 0 : bt, bn = "hidden");
  const [Sn, Cn] = useState(xn), [kn, cn] = useState(bn), [gn, an] = useState(!1), [un, pn] = useState(getStaticStateClasses(nn.current, bt));
  useEffect(() => {
    hideContent(Ot.current, Sn, Xe);
  }, []), useEffect(() => {
    if (bt !== kt.current && Ot.current) {
      showContent(Ot.current, kt.current), Ot.current.style.overflow = "hidden";
      const si = Ot.current.offsetHeight;
      Ot.current.style.overflow = "";
      const bi = Tn + vn;
      let xi, ji, zi = "hidden", Vi;
      const Hi = kt.current === "auto";
      typeof bt == "number" ? (xi = bt < 0 ? 0 : bt, ji = xi) : isPercentage(bt) ? (xi = bt === "0%" ? 0 : bt, ji = xi) : (xi = si, ji = "auto", zi = void 0), Hi && (ji = xi, xi = si);
      const ii = [
        nn.current.animating,
        (kt.current === "auto" || bt < kt.current) && nn.current.animatingUp,
        (bt === "auto" || bt > kt.current) && nn.current.animatingDown,
        ji === 0 && nn.current.animatingToHeightZero,
        ji === "auto" && nn.current.animatingToHeightAuto,
        typeof ji == "number" && ji > 0 ? nn.current.animatingToHeightSpecific : null
      ].filter((ni) => ni).join(" "), Fi = getStaticStateClasses(nn.current, ji);
      Cn(xi), cn("hidden"), an(!Hi), pn(ii), clearTimeout(en.current), clearTimeout(Jr.current), Hi ? (Vi = !0, en.current = setTimeout(() => {
        Cn(ji), cn(zi), an(Vi), wt == null || wt(ji);
      }, 50), Jr.current = setTimeout(() => {
        an(!1), pn(Fi), hideContent(Ot.current, ji, Xe), Tt == null || Tt(ji);
      }, bi)) : (wt == null || wt(xi), en.current = setTimeout(() => {
        Cn(ji), cn(zi), an(!1), pn(Fi), bt !== "auto" && hideContent(Ot.current, xi, Xe), Tt == null || Tt(xi);
      }, bi));
    }
    return kt.current = bt, () => {
      clearTimeout(en.current), clearTimeout(Jr.current);
    };
  }, [bt]);
  const hn = Object.assign(Object.assign({}, St), { height: Sn, overflow: kn || (St == null ? void 0 : St.overflow) });
  gn && Re && (hn.transition = `height ${Tn}ms ${vt} ${vn}ms`, St != null && St.transition && (hn.transition = `${St.transition}, ${hn.transition}`), hn.WebkitTransition = hn.transition);
  const An = {};
  me && (An.transition = `opacity ${Tn}ms ${vt} ${vn}ms`, An.WebkitTransition = An.transition, Sn === 0 && (An.opacity = 0));
  const qn = typeof Pt["aria-hidden"] < "u" ? Pt["aria-hidden"] : bt === 0;
  return React__default.createElement(
    "div",
    Object.assign({}, Pt, { "aria-hidden": qn, className: `${un} ${Ue}`, style: hn, ref: ie }),
    React__default.createElement("div", { className: qe, style: An, ref: (si) => {
      Ot.current = si, It && (It.current = si);
    } }, je)
  );
}), Accordion = ({ title: ce, children: ie, defaultExpanded: me = !1, onChange: we }) => {
  const [Re, je] = useState(me), Ue = () => {
    const qe = !Re;
    je(qe), we == null || we(qe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "overflow-visible", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between items-center select-none mb-4 transition-colors", tabIndex: 0, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "s", weight: "semibold", children: ce }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: Ue, className: "flex items-center cursor-pointer gap-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: ButtonVariant.TEXT, icon: Re ? faArrowsToLine : faArrowsFromLine, children: Re ? " Collapse" : " Expand" }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AnimateHeight, { duration: 500, height: Re ? "auto" : 0, children: ie })
  ] });
}, AddOrEditImageActionBox = ({
  hasAsset: ce,
  assetName: ie,
  turnOnMediaLibrary: me,
  removeImage: we
}) => ce ? /* @__PURE__ */ jsxRuntimeExports.jsx(
  ActionBox,
  {
    text: ie,
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faImage }),
    actions: [
      { text: "Replace", onClick: me, variant: "primary" },
      { text: "Remove", onClick: we, variant: "danger" }
    ],
    fullWidth: !0
  }
) : /* @__PURE__ */ jsxRuntimeExports.jsx(
  ActionBox,
  {
    text: "No image selected",
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faImage }),
    actions: [{ text: "Add image", onClick: me, variant: "primary" }],
    fullWidth: !0
  }
), Title$1 = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "l", weight: "bold", children: ce }) }), Content = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-8 max-w-935px flex flex-col mt-9 ml-auto mr-auto", children: ce });
Content.Title = Title$1;
const Title = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pl-8 pt-8", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "xxl", weight: "bold", children: ce }) }), Caption = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pl-9", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "grey-300", invertInLightTheme: !0, size: "s", weight: "regular", children: ce }) }), Header$1 = ({ backgroundImageSrc: ce, children: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames("w-full bg-cover bg-center", {
      "bg-surface-elevated": !ce,
      "dark:bg-opacity-40 dark:bg-blend-darken dark:bg-black light:bg-opacity-50 light:bg-blend-lighten light:bg-white": ce
    }),
    style: ce ? { backgroundImage: `url(${ce})` } : {},
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex max-w-935px flex-col pt-7 pb-14 gap-1.5 m-auto", children: ie })
  }
);
Header$1.Title = Title;
Header$1.Caption = Caption;
const AdminLayout = ({ children: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-background h-full overflow-auto pb-[60px]", children: ce });
AdminLayout.Header = Header$1;
AdminLayout.Content = Content;
const AdminLayoutWrapper = ({ children: ce, isSidebarOpen: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("flex flex-col h-full", { "ml-64": ie }), children: ce }), Blurb = ({ title: ce, description: ie, icon: me }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "blurb", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "blurb__icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: me }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "blurb__text", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "m", weight: "semibold", color: "grey-900", children: ce }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "s", color: "grey-500", children: ie })
  ] })
] });
var TransBtn = function(ie) {
  var me = ie.className, we = ie.customizeIcon, Re = ie.customizeIconProps, je = ie.children, Ue = ie.onMouseDown, qe = ie.onClick, Ge = typeof we == "function" ? we(Re) : we;
  return /* @__PURE__ */ React.createElement("span", {
    className: me,
    onMouseDown: function(ot) {
      ot.preventDefault(), Ue == null || Ue(ot);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: qe,
    "aria-hidden": !0
  }, Ge !== void 0 ? Ge : /* @__PURE__ */ React.createElement("span", {
    className: classNames(me.split(/\s+/).map(function(Xe) {
      return "".concat(Xe, "-icon");
    }))
  }, je));
}, useAllowClear = function(ie, me, we, Re, je) {
  var Ue = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, qe = arguments.length > 6 ? arguments[6] : void 0, Ge = arguments.length > 7 ? arguments[7] : void 0, Xe = React__default.useMemo(function() {
    if (_typeof$b(Re) === "object")
      return Re.clearIcon;
    if (je)
      return je;
  }, [Re, je]), ot = React__default.useMemo(function() {
    return !!(!Ue && Re && (we.length || qe) && !(Ge === "combobox" && qe === ""));
  }, [Re, Ue, we.length, qe, Ge]);
  return {
    allowClear: ot,
    clearIcon: /* @__PURE__ */ React__default.createElement(TransBtn, {
      className: "".concat(ie, "-clear"),
      onMouseDown: me,
      customizeIcon: Xe
    }, "×")
  };
}, BaseSelectContext = /* @__PURE__ */ React.createContext(null);
function useBaseProps() {
  return React.useContext(BaseSelectContext);
}
function useDelayReset() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, ie = React.useState(!1), me = _slicedToArray$8(ie, 2), we = me[0], Re = me[1], je = React.useRef(null), Ue = function() {
    window.clearTimeout(je.current);
  };
  React.useEffect(function() {
    return Ue;
  }, []);
  var qe = function(Xe, ot) {
    Ue(), je.current = window.setTimeout(function() {
      Re(Xe), ot && ot();
    }, ce);
  };
  return [we, qe, Ue];
}
function useLock() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, ie = React.useRef(null), me = React.useRef(null);
  React.useEffect(function() {
    return function() {
      window.clearTimeout(me.current);
    };
  }, []);
  function we(Re) {
    (Re || ie.current === null) && (ie.current = Re), window.clearTimeout(me.current), me.current = window.setTimeout(function() {
      ie.current = null;
    }, ce);
  }
  return [function() {
    return ie.current;
  }, we];
}
function useSelectTriggerControl(ce, ie, me, we) {
  var Re = React.useRef(null);
  Re.current = {
    open: ie,
    triggerOpen: me,
    customizedTrigger: we
  }, React.useEffect(function() {
    function je(Ue) {
      var qe;
      if (!((qe = Re.current) !== null && qe !== void 0 && qe.customizedTrigger)) {
        var Ge = Ue.target;
        Ge.shadowRoot && Ue.composed && (Ge = Ue.composedPath()[0] || Ge), Re.current.open && ce().filter(function(Xe) {
          return Xe;
        }).every(function(Xe) {
          return !Xe.contains(Ge) && Xe !== Ge;
        }) && Re.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", je), function() {
      return window.removeEventListener("mousedown", je);
    };
  }, []);
}
function isValidateOpenKey(ce) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    ce && // Other keys
    ![
      // System function button
      KeyCode.ESC,
      KeyCode.SHIFT,
      KeyCode.BACKSPACE,
      KeyCode.TAB,
      KeyCode.WIN_KEY,
      KeyCode.ALT,
      KeyCode.META,
      KeyCode.WIN_KEY_RIGHT,
      KeyCode.CTRL,
      KeyCode.SEMICOLON,
      KeyCode.EQUALS,
      KeyCode.CAPS_LOCK,
      KeyCode.CONTEXT_MENU,
      // F1-F12
      KeyCode.F1,
      KeyCode.F2,
      KeyCode.F3,
      KeyCode.F4,
      KeyCode.F5,
      KeyCode.F6,
      KeyCode.F7,
      KeyCode.F8,
      KeyCode.F9,
      KeyCode.F10,
      KeyCode.F11,
      KeyCode.F12
    ].includes(ce)
  );
}
var attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(ce, ie) {
  return ce.indexOf(ie) === 0;
}
function pickAttrs(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, me;
  ie === !1 ? me = {
    aria: !0,
    data: !0,
    attr: !0
  } : ie === !0 ? me = {
    aria: !0
  } : me = _objectSpread2$2({}, ie);
  var we = {};
  return Object.keys(ce).forEach(function(Re) {
    // Aria
    (me.aria && (Re === "role" || match(Re, ariaPrefix)) || // Data
    me.data && match(Re, dataPrefix) || // Attr
    me.attr && propList.includes(Re)) && (we[Re] = ce[Re]);
  }), we;
}
var _excluded$b = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(ce, ie) {
  var me = ce.prefixCls, we = ce.invalidate, Re = ce.item, je = ce.renderItem, Ue = ce.responsive, qe = ce.responsiveDisabled, Ge = ce.registerSize, Xe = ce.itemKey, ot = ce.className, vt = ce.style, bt = ce.children, Tt = ce.display, wt = ce.order, St = ce.component, It = St === void 0 ? "div" : St, Pt = _objectWithoutProperties$6(ce, _excluded$b), kt = Ue && !Tt;
  function Ot(fn) {
    Ge(Xe, fn);
  }
  React.useEffect(function() {
    return function() {
      Ot(null);
    };
  }, []);
  var Jr = je && Re !== UNDEFINED ? je(Re, {
    index: wt
  }) : bt, en;
  we || (en = {
    opacity: kt ? 0 : 1,
    height: kt ? 0 : UNDEFINED,
    overflowY: kt ? "hidden" : UNDEFINED,
    order: Ue ? wt : UNDEFINED,
    pointerEvents: kt ? "none" : UNDEFINED,
    position: kt ? "absolute" : UNDEFINED
  });
  var nn = {};
  kt && (nn["aria-hidden"] = !0);
  var ln = /* @__PURE__ */ React.createElement(It, _extends$j({
    className: classNames(!we && me, ot),
    style: _objectSpread2$2(_objectSpread2$2({}, en), vt)
  }, nn, Pt, {
    ref: ie
  }), Jr);
  return Ue && (ln = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(vn) {
      var Tn = vn.offsetWidth;
      Ot(Tn);
    },
    disabled: qe
  }, ln)), ln;
}
var Item$1 = /* @__PURE__ */ React.forwardRef(InternalItem);
Item$1.displayName = "Item";
function channelUpdate(ce) {
  if (typeof MessageChannel > "u")
    wrapperRaf$1(ce);
  else {
    var ie = new MessageChannel();
    ie.port1.onmessage = function() {
      return ce();
    }, ie.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var ce = React.useRef(null), ie = function(we) {
    ce.current || (ce.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        ce.current.forEach(function(Re) {
          Re();
        }), ce.current = null;
      });
    })), ce.current.push(we);
  };
  return ie;
}
function useEffectState(ce, ie) {
  var me = React.useState(ie), we = _slicedToArray$8(me, 2), Re = we[0], je = we[1], Ue = useEvent(function(qe) {
    ce(function() {
      je(qe);
    });
  });
  return [Re, Ue];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$a = ["component"], _excluded2$1 = ["className"], _excluded3 = ["className"], InternalRawItem = function(ie, me) {
  var we = React.useContext(OverflowContext);
  if (!we) {
    var Re = ie.component, je = Re === void 0 ? "div" : Re, Ue = _objectWithoutProperties$6(ie, _excluded$a);
    return /* @__PURE__ */ React.createElement(je, _extends$j({}, Ue, {
      ref: me
    }));
  }
  var qe = we.className, Ge = _objectWithoutProperties$6(we, _excluded2$1), Xe = ie.className, ot = _objectWithoutProperties$6(ie, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item$1, _extends$j({
    ref: me,
    className: classNames(qe, Xe)
  }, Ge, ot)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$9 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(ce) {
  return "+ ".concat(ce.length, " ...");
}
function Overflow(ce, ie) {
  var me = ce.prefixCls, we = me === void 0 ? "rc-overflow" : me, Re = ce.data, je = Re === void 0 ? [] : Re, Ue = ce.renderItem, qe = ce.renderRawItem, Ge = ce.itemKey, Xe = ce.itemWidth, ot = Xe === void 0 ? 10 : Xe, vt = ce.ssr, bt = ce.style, Tt = ce.className, wt = ce.maxCount, St = ce.renderRest, It = ce.renderRawRest, Pt = ce.suffix, kt = ce.component, Ot = kt === void 0 ? "div" : kt, Jr = ce.itemComponent, en = ce.onVisibleChange, nn = _objectWithoutProperties$6(ce, _excluded$9), ln = vt === "full", fn = useBatcher(), vn = useEffectState(fn, null), Tn = _slicedToArray$8(vn, 2), xn = Tn[0], bn = Tn[1], Sn = xn || 0, Cn = useEffectState(fn, /* @__PURE__ */ new Map()), kn = _slicedToArray$8(Cn, 2), cn = kn[0], gn = kn[1], an = useEffectState(fn, 0), un = _slicedToArray$8(an, 2), pn = un[0], hn = un[1], An = useEffectState(fn, 0), In = _slicedToArray$8(An, 2), qn = In[0], si = In[1], bi = useEffectState(fn, 0), xi = _slicedToArray$8(bi, 2), ji = xi[0], zi = xi[1], Vi = useState(null), Hi = _slicedToArray$8(Vi, 2), ii = Hi[0], Fi = Hi[1], ni = useState(null), Ui = _slicedToArray$8(ni, 2), ja = Ui[0], Ga = Ui[1], Xa = React.useMemo(function() {
    return ja === null && ln ? Number.MAX_SAFE_INTEGER : ja || 0;
  }, [ja, xn]), Ns = useState(!1), Ya = _slicedToArray$8(Ns, 2), Qa = Ya[0], Ja = Ya[1], Ms = "".concat(we, "-item"), Hs = Math.max(pn, qn), no = wt === RESPONSIVE, Qs = je.length && no, Zs = wt === INVALIDATE, so = Qs || typeof wt == "number" && je.length > wt, io = useMemo$1(function() {
    var to = je;
    return Qs ? xn === null && ln ? to = je : to = je.slice(0, Math.min(je.length, Sn / ot)) : typeof wt == "number" && (to = je.slice(0, wt)), to;
  }, [je, ot, xn, wt, Qs]), dl = useMemo$1(function() {
    return Qs ? je.slice(Xa + 1) : je.slice(io.length);
  }, [je, io, Qs, Xa]), vl = useCallback(function(to, zs) {
    var Gs;
    return typeof Ge == "function" ? Ge(to) : (Gs = Ge && (to == null ? void 0 : to[Ge])) !== null && Gs !== void 0 ? Gs : zs;
  }, [Ge]), lo = useCallback(Ue || function(to) {
    return to;
  }, [Ue]);
  function yl(to, zs, Gs) {
    ja === to && (zs === void 0 || zs === ii) || (Ga(to), Gs || (Ja(to < je.length - 1), en == null || en(to)), zs !== void 0 && Fi(zs));
  }
  function bl(to, zs) {
    bn(zs.clientWidth);
  }
  function Al(to, zs) {
    gn(function(Gs) {
      var Pl = new Map(Gs);
      return zs === null ? Pl.delete(to) : Pl.set(to, zs), Pl;
    });
  }
  function Xl(to, zs) {
    si(zs), hn(qn);
  }
  function $l(to, zs) {
    zi(zs);
  }
  function Bl(to) {
    return cn.get(vl(io[to], to));
  }
  useLayoutEffect$1(function() {
    if (Sn && typeof Hs == "number" && io) {
      var to = ji, zs = io.length, Gs = zs - 1;
      if (!zs) {
        yl(0, null);
        return;
      }
      for (var Pl = 0; Pl < zs; Pl += 1) {
        var Ml = Bl(Pl);
        if (ln && (Ml = Ml || 0), Ml === void 0) {
          yl(Pl - 1, void 0, !0);
          break;
        }
        if (to += Ml, // Only one means `totalWidth` is the final width
        Gs === 0 && to <= Sn || // Last two width will be the final width
        Pl === Gs - 1 && to + Bl(Gs) <= Sn) {
          yl(Gs, null);
          break;
        } else if (to + Hs > Sn) {
          yl(Pl - 1, to - Ml - ji + qn);
          break;
        }
      }
      Pt && Bl(0) + ji > Sn && Fi(null);
    }
  }, [Sn, cn, qn, ji, vl, io]);
  var Fl = Qa && !!dl.length, kl = {};
  ii !== null && Qs && (kl = {
    position: "absolute",
    left: ii,
    top: 0
  });
  var ql = {
    prefixCls: Ms,
    responsive: Qs,
    component: Jr,
    invalidate: Zs
  }, _l = qe ? function(to, zs) {
    var Gs = vl(to, zs);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: Gs,
      value: _objectSpread2$2(_objectSpread2$2({}, ql), {}, {
        order: zs,
        item: to,
        itemKey: Gs,
        registerSize: Al,
        display: zs <= Xa
      })
    }, qe(to, zs));
  } : function(to, zs) {
    var Gs = vl(to, zs);
    return /* @__PURE__ */ React.createElement(Item$1, _extends$j({}, ql, {
      order: zs,
      key: Gs,
      item: to,
      renderItem: lo,
      itemKey: Gs,
      registerSize: Al,
      display: zs <= Xa
    }));
  }, Ol = {
    order: Fl ? Xa : Number.MAX_SAFE_INTEGER,
    className: "".concat(Ms, "-rest"),
    registerSize: Xl,
    display: Fl
  }, Ll = St || defaultRenderRest, Ql = It ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2$2(_objectSpread2$2({}, ql), Ol)
  }, It(dl)) : /* @__PURE__ */ React.createElement(Item$1, _extends$j({}, ql, Ol), typeof Ll == "function" ? Ll(dl) : Ll), wl = /* @__PURE__ */ React.createElement(Ot, _extends$j({
    className: classNames(!Zs && we, Tt),
    style: bt,
    ref: ie
  }, nn), io.map(_l), so ? Ql : null, Pt && /* @__PURE__ */ React.createElement(Item$1, _extends$j({}, ql, {
    responsive: no,
    responsiveDisabled: !Qs,
    order: Xa,
    className: "".concat(Ms, "-suffix"),
    registerSize: $l,
    display: !0,
    style: kl
  }), Pt));
  return no ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: bl,
    disabled: !Qs
  }, wl) : wl;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Input = function(ie, me) {
  var we, Re = ie.prefixCls, je = ie.id, Ue = ie.inputElement, qe = ie.disabled, Ge = ie.tabIndex, Xe = ie.autoFocus, ot = ie.autoComplete, vt = ie.editable, bt = ie.activeDescendantId, Tt = ie.value, wt = ie.maxLength, St = ie.onKeyDown, It = ie.onMouseDown, Pt = ie.onChange, kt = ie.onPaste, Ot = ie.onCompositionStart, Jr = ie.onCompositionEnd, en = ie.onBlur, nn = ie.open, ln = ie.attrs, fn = Ue || /* @__PURE__ */ React.createElement("input", null), vn = fn, Tn = vn.ref, xn = vn.props, bn = xn.onKeyDown, Sn = xn.onChange, Cn = xn.onMouseDown, kn = xn.onCompositionStart, cn = xn.onCompositionEnd, gn = xn.onBlur, an = xn.style;
  return warning$1(!("maxLength" in fn.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), fn = /* @__PURE__ */ React.cloneElement(fn, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
    type: "search"
  }, xn), {}, {
    // Override over origin props
    id: je,
    ref: composeRef(me, Tn),
    disabled: qe,
    tabIndex: Ge,
    autoComplete: ot || "off",
    autoFocus: Xe,
    className: classNames("".concat(Re, "-selection-search-input"), (we = fn) === null || we === void 0 || (we = we.props) === null || we === void 0 ? void 0 : we.className),
    role: "combobox",
    "aria-expanded": nn || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(je, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(je, "_list"),
    "aria-activedescendant": nn ? bt : void 0
  }, ln), {}, {
    value: vt ? Tt : "",
    maxLength: wt,
    readOnly: !vt,
    unselectable: vt ? null : "on",
    style: _objectSpread2$2(_objectSpread2$2({}, an), {}, {
      opacity: vt ? null : 0
    }),
    onKeyDown: function(pn) {
      St(pn), bn && bn(pn);
    },
    onMouseDown: function(pn) {
      It(pn), Cn && Cn(pn);
    },
    onChange: function(pn) {
      Pt(pn), Sn && Sn(pn);
    },
    onCompositionStart: function(pn) {
      Ot(pn), kn && kn(pn);
    },
    onCompositionEnd: function(pn) {
      Jr(pn), cn && cn(pn);
    },
    onPaste: kt,
    onBlur: function(pn) {
      en(pn), gn && gn(pn);
    }
  })), fn;
}, RefInput = /* @__PURE__ */ React.forwardRef(Input);
process.env.NODE_ENV !== "production" && (RefInput.displayName = "Input");
function toArray(ce) {
  return Array.isArray(ce) ? ce : ce !== void 0 ? [ce] : [];
}
var isClient = typeof window < "u" && window.document && window.document.documentElement, isBrowserClient$1 = process.env.NODE_ENV !== "test" && isClient;
function hasValue(ce) {
  return ce != null;
}
function isComboNoValue(ce) {
  return !ce && ce !== 0;
}
function isTitleType$1(ce) {
  return ["string", "number"].includes(_typeof$b(ce));
}
function getTitle(ce) {
  var ie = void 0;
  return ce && (isTitleType$1(ce.title) ? ie = ce.title.toString() : isTitleType$1(ce.label) && (ie = ce.label.toString())), ie;
}
function useLayoutEffect(ce, ie) {
  isBrowserClient$1 ? React.useLayoutEffect(ce, ie) : React.useEffect(ce, ie);
}
function itemKey(ce) {
  var ie;
  return (ie = ce.key) !== null && ie !== void 0 ? ie : ce.value;
}
var onPreventMouseDown = function(ie) {
  ie.preventDefault(), ie.stopPropagation();
}, SelectSelector = function(ie) {
  var me = ie.id, we = ie.prefixCls, Re = ie.values, je = ie.open, Ue = ie.searchValue, qe = ie.autoClearSearchValue, Ge = ie.inputRef, Xe = ie.placeholder, ot = ie.disabled, vt = ie.mode, bt = ie.showSearch, Tt = ie.autoFocus, wt = ie.autoComplete, St = ie.activeDescendantId, It = ie.tabIndex, Pt = ie.removeIcon, kt = ie.maxTagCount, Ot = ie.maxTagTextLength, Jr = ie.maxTagPlaceholder, en = Jr === void 0 ? function(ni) {
    return "+ ".concat(ni.length, " ...");
  } : Jr, nn = ie.tagRender, ln = ie.onToggleOpen, fn = ie.onRemove, vn = ie.onInputChange, Tn = ie.onInputPaste, xn = ie.onInputKeyDown, bn = ie.onInputMouseDown, Sn = ie.onInputCompositionStart, Cn = ie.onInputCompositionEnd, kn = ie.onInputBlur, cn = React.useRef(null), gn = useState(0), an = _slicedToArray$8(gn, 2), un = an[0], pn = an[1], hn = useState(!1), An = _slicedToArray$8(hn, 2), In = An[0], qn = An[1], si = "".concat(we, "-selection"), bi = je || vt === "multiple" && qe === !1 || vt === "tags" ? Ue : "", xi = vt === "tags" || vt === "multiple" && qe === !1 || bt && (je || In);
  useLayoutEffect(function() {
    pn(cn.current.scrollWidth);
  }, [bi]);
  var ji = function(Ui, ja, Ga, Xa, Ns) {
    return /* @__PURE__ */ React.createElement("span", {
      title: getTitle(Ui),
      className: classNames("".concat(si, "-item"), _defineProperty$s({}, "".concat(si, "-item-disabled"), Ga))
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(si, "-item-content")
    }, ja), Xa && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(si, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: Ns,
      customizeIcon: Pt
    }, "×"));
  }, zi = function(Ui, ja, Ga, Xa, Ns, Ya) {
    var Qa = function(Ms) {
      onPreventMouseDown(Ms), ln(!je);
    };
    return /* @__PURE__ */ React.createElement("span", {
      onMouseDown: Qa
    }, nn({
      label: ja,
      value: Ui,
      disabled: Ga,
      closable: Xa,
      onClose: Ns,
      isMaxTag: !!Ya
    }));
  }, Vi = function(Ui) {
    var ja = Ui.disabled, Ga = Ui.label, Xa = Ui.value, Ns = !ot && !ja, Ya = Ga;
    if (typeof Ot == "number" && (typeof Ga == "string" || typeof Ga == "number")) {
      var Qa = String(Ya);
      Qa.length > Ot && (Ya = "".concat(Qa.slice(0, Ot), "..."));
    }
    var Ja = function(Hs) {
      Hs && Hs.stopPropagation(), fn(Ui);
    };
    return typeof nn == "function" ? zi(Xa, Ya, ja, Ns, Ja) : ji(Ui, Ya, ja, Ns, Ja);
  }, Hi = function(Ui) {
    if (!Re.length)
      return null;
    var ja = typeof en == "function" ? en(Ui) : en;
    return typeof nn == "function" ? zi(void 0, ja, !1, !1, void 0, !0) : ji({
      title: ja
    }, ja, !1);
  }, ii = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(si, "-search"),
    style: {
      width: un
    },
    onFocus: function() {
      qn(!0);
    },
    onBlur: function() {
      qn(!1);
    }
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: Ge,
    open: je,
    prefixCls: we,
    id: me,
    inputElement: null,
    disabled: ot,
    autoFocus: Tt,
    autoComplete: wt,
    editable: xi,
    activeDescendantId: St,
    value: bi,
    onKeyDown: xn,
    onMouseDown: bn,
    onChange: vn,
    onPaste: Tn,
    onCompositionStart: Sn,
    onCompositionEnd: Cn,
    onBlur: kn,
    tabIndex: It,
    attrs: pickAttrs(ie, !0)
  }), /* @__PURE__ */ React.createElement("span", {
    ref: cn,
    className: "".concat(si, "-search-mirror"),
    "aria-hidden": !0
  }, bi, " ")), Fi = /* @__PURE__ */ React.createElement(ForwardOverflow, {
    prefixCls: "".concat(si, "-overflow"),
    data: Re,
    renderItem: Vi,
    renderRest: Hi,
    suffix: ii,
    itemKey,
    maxCount: kt
  });
  return /* @__PURE__ */ React.createElement("span", {
    className: "".concat(si, "-wrap")
  }, Fi, !Re.length && !bi && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(si, "-placeholder")
  }, Xe));
}, SingleSelector = function(ie) {
  var me = ie.inputElement, we = ie.prefixCls, Re = ie.id, je = ie.inputRef, Ue = ie.disabled, qe = ie.autoFocus, Ge = ie.autoComplete, Xe = ie.activeDescendantId, ot = ie.mode, vt = ie.open, bt = ie.values, Tt = ie.placeholder, wt = ie.tabIndex, St = ie.showSearch, It = ie.searchValue, Pt = ie.activeValue, kt = ie.maxLength, Ot = ie.onInputKeyDown, Jr = ie.onInputMouseDown, en = ie.onInputChange, nn = ie.onInputPaste, ln = ie.onInputCompositionStart, fn = ie.onInputCompositionEnd, vn = ie.onInputBlur, Tn = ie.title, xn = React.useState(!1), bn = _slicedToArray$8(xn, 2), Sn = bn[0], Cn = bn[1], kn = ot === "combobox", cn = kn || St, gn = bt[0], an = It || "";
  kn && Pt && !Sn && (an = Pt), React.useEffect(function() {
    kn && Cn(!1);
  }, [kn, Pt]);
  var un = ot !== "combobox" && !vt && !St ? !1 : !!an, pn = Tn === void 0 ? getTitle(gn) : Tn, hn = React.useMemo(function() {
    return gn ? null : /* @__PURE__ */ React.createElement("span", {
      className: "".concat(we, "-selection-placeholder"),
      style: un ? {
        visibility: "hidden"
      } : void 0
    }, Tt);
  }, [gn, un, Tt, we]);
  return /* @__PURE__ */ React.createElement("span", {
    className: "".concat(we, "-selection-wrap")
  }, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(we, "-selection-search")
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: je,
    prefixCls: we,
    id: Re,
    open: vt,
    inputElement: me,
    disabled: Ue,
    autoFocus: qe,
    autoComplete: Ge,
    editable: cn,
    activeDescendantId: Xe,
    value: an,
    onKeyDown: Ot,
    onMouseDown: Jr,
    onChange: function(In) {
      Cn(!0), en(In);
    },
    onPaste: nn,
    onCompositionStart: ln,
    onCompositionEnd: fn,
    onBlur: vn,
    tabIndex: wt,
    attrs: pickAttrs(ie, !0),
    maxLength: kn ? kt : void 0
  })), !kn && gn ? /* @__PURE__ */ React.createElement("span", {
    className: "".concat(we, "-selection-item"),
    title: pn,
    style: un ? {
      visibility: "hidden"
    } : void 0
  }, gn.label) : null, hn);
}, Selector = function(ie, me) {
  var we = useRef(null), Re = useRef(!1), je = ie.prefixCls, Ue = ie.open, qe = ie.mode, Ge = ie.showSearch, Xe = ie.tokenWithEnter, ot = ie.disabled, vt = ie.prefix, bt = ie.autoClearSearchValue, Tt = ie.onSearch, wt = ie.onSearchSubmit, St = ie.onToggleOpen, It = ie.onInputKeyDown, Pt = ie.onInputBlur, kt = ie.domRef;
  React.useImperativeHandle(me, function() {
    return {
      focus: function(pn) {
        we.current.focus(pn);
      },
      blur: function() {
        we.current.blur();
      }
    };
  });
  var Ot = useLock(0), Jr = _slicedToArray$8(Ot, 2), en = Jr[0], nn = Jr[1], ln = function(pn) {
    var hn = pn.which, An = we.current instanceof HTMLTextAreaElement;
    !An && Ue && (hn === KeyCode.UP || hn === KeyCode.DOWN) && pn.preventDefault(), It && It(pn), hn === KeyCode.ENTER && qe === "tags" && !Re.current && !Ue && (wt == null || wt(pn.target.value)), !(An && !Ue && ~[KeyCode.UP, KeyCode.DOWN, KeyCode.LEFT, KeyCode.RIGHT].indexOf(hn)) && isValidateOpenKey(hn) && St(!0);
  }, fn = function() {
    nn(!0);
  }, vn = useRef(null), Tn = function(pn) {
    Tt(pn, !0, Re.current) !== !1 && St(!0);
  }, xn = function() {
    Re.current = !0;
  }, bn = function(pn) {
    Re.current = !1, qe !== "combobox" && Tn(pn.target.value);
  }, Sn = function(pn) {
    var hn = pn.target.value;
    if (Xe && vn.current && /[\r\n]/.test(vn.current)) {
      var An = vn.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      hn = hn.replace(An, vn.current);
    }
    vn.current = null, Tn(hn);
  }, Cn = function(pn) {
    var hn = pn.clipboardData, An = hn == null ? void 0 : hn.getData("text");
    vn.current = An || "";
  }, kn = function(pn) {
    var hn = pn.target;
    if (hn !== we.current) {
      var An = document.body.style.msTouchAction !== void 0;
      An ? setTimeout(function() {
        we.current.focus();
      }) : we.current.focus();
    }
  }, cn = function(pn) {
    var hn = en();
    pn.target !== we.current && !hn && !(qe === "combobox" && ot) && pn.preventDefault(), (qe !== "combobox" && (!Ge || !hn) || !Ue) && (Ue && bt !== !1 && Tt("", !0, !1), St());
  }, gn = {
    inputRef: we,
    onInputKeyDown: ln,
    onInputMouseDown: fn,
    onInputChange: Sn,
    onInputPaste: Cn,
    onInputCompositionStart: xn,
    onInputCompositionEnd: bn,
    onInputBlur: Pt
  }, an = qe === "multiple" || qe === "tags" ? /* @__PURE__ */ React.createElement(SelectSelector, _extends$j({}, ie, gn)) : /* @__PURE__ */ React.createElement(SingleSelector, _extends$j({}, ie, gn));
  return /* @__PURE__ */ React.createElement("div", {
    ref: kt,
    className: "".concat(je, "-selector"),
    onClick: kn,
    onMouseDown: cn
  }, vt && /* @__PURE__ */ React.createElement("div", {
    className: "".concat(je, "-prefix")
  }, vt), an);
}, ForwardSelector = /* @__PURE__ */ React.forwardRef(Selector);
process.env.NODE_ENV !== "production" && (ForwardSelector.displayName = "Selector");
var _excluded$8 = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], getBuiltInPlacements = function(ie) {
  var me = ie === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: me,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: me,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: me,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: me,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, SelectTrigger = function(ie, me) {
  var we = ie.prefixCls;
  ie.disabled;
  var Re = ie.visible, je = ie.children, Ue = ie.popupElement, qe = ie.animation, Ge = ie.transitionName, Xe = ie.dropdownStyle, ot = ie.dropdownClassName, vt = ie.direction, bt = vt === void 0 ? "ltr" : vt, Tt = ie.placement, wt = ie.builtinPlacements, St = ie.dropdownMatchSelectWidth, It = ie.dropdownRender, Pt = ie.dropdownAlign, kt = ie.getPopupContainer, Ot = ie.empty, Jr = ie.getTriggerDOMNode, en = ie.onPopupVisibleChange, nn = ie.onPopupMouseEnter, ln = _objectWithoutProperties$6(ie, _excluded$8), fn = "".concat(we, "-dropdown"), vn = Ue;
  It && (vn = It(Ue));
  var Tn = React.useMemo(function() {
    return wt || getBuiltInPlacements(St);
  }, [wt, St]), xn = qe ? "".concat(fn, "-").concat(qe) : Ge, bn = typeof St == "number", Sn = React.useMemo(function() {
    return bn ? null : St === !1 ? "minWidth" : "width";
  }, [St, bn]), Cn = Xe;
  bn && (Cn = _objectSpread2$2(_objectSpread2$2({}, Cn), {}, {
    width: St
  }));
  var kn = React.useRef(null);
  return React.useImperativeHandle(me, function() {
    return {
      getPopupElement: function() {
        var gn;
        return (gn = kn.current) === null || gn === void 0 ? void 0 : gn.popupElement;
      }
    };
  }), /* @__PURE__ */ React.createElement(Trigger$1, _extends$j({}, ln, {
    showAction: en ? ["click"] : [],
    hideAction: en ? ["click"] : [],
    popupPlacement: Tt || (bt === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: Tn,
    prefixCls: fn,
    popupTransitionName: xn,
    popup: /* @__PURE__ */ React.createElement("div", {
      onMouseEnter: nn
    }, vn),
    ref: kn,
    stretch: Sn,
    popupAlign: Pt,
    popupVisible: Re,
    getPopupContainer: kt,
    popupClassName: classNames(ot, _defineProperty$s({}, "".concat(fn, "-empty"), Ot)),
    popupStyle: Cn,
    getTriggerDOMNode: Jr,
    onPopupVisibleChange: en
  }), je);
}, RefSelectTrigger = /* @__PURE__ */ React.forwardRef(SelectTrigger);
process.env.NODE_ENV !== "production" && (RefSelectTrigger.displayName = "SelectTrigger");
function getKey$1(ce, ie) {
  var me = ce.key, we;
  return "value" in ce && (we = ce.value), me ?? (we !== void 0 ? we : "rc-index-key-".concat(ie));
}
function isValidCount(ce) {
  return typeof ce < "u" && !Number.isNaN(ce);
}
function fillFieldNames(ce, ie) {
  var me = ce || {}, we = me.label, Re = me.value, je = me.options, Ue = me.groupLabel, qe = we || (ie ? "children" : "label");
  return {
    label: qe,
    value: Re || "value",
    options: je || "options",
    groupLabel: Ue || qe
  };
}
function flattenOptions(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, me = ie.fieldNames, we = ie.childrenAsData, Re = [], je = fillFieldNames(me, !1), Ue = je.label, qe = je.value, Ge = je.options, Xe = je.groupLabel;
  function ot(vt, bt) {
    Array.isArray(vt) && vt.forEach(function(Tt) {
      if (bt || !(Ge in Tt)) {
        var wt = Tt[qe];
        Re.push({
          key: getKey$1(Tt, Re.length),
          groupOption: bt,
          data: Tt,
          label: Tt[Ue],
          value: wt
        });
      } else {
        var St = Tt[Xe];
        St === void 0 && we && (St = Tt.label), Re.push({
          key: getKey$1(Tt, Re.length),
          group: !0,
          data: Tt,
          label: St
        }), ot(Tt[Ge], !0);
      }
    });
  }
  return ot(ce, !1), Re;
}
function injectPropsWithOption(ce) {
  var ie = _objectSpread2$2({}, ce);
  return "props" in ie || Object.defineProperty(ie, "props", {
    get: function() {
      return warningOnce(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), ie;
    }
  }), ie;
}
var getSeparatedContent = function(ie, me, we) {
  if (!me || !me.length)
    return null;
  var Re = !1, je = function qe(Ge, Xe) {
    var ot = _toArray(Xe), vt = ot[0], bt = ot.slice(1);
    if (!vt)
      return [Ge];
    var Tt = Ge.split(vt);
    return Re = Re || Tt.length > 1, Tt.reduce(function(wt, St) {
      return [].concat(_toConsumableArray$1(wt), _toConsumableArray$1(qe(St, bt)));
    }, []).filter(Boolean);
  }, Ue = je(ie, me);
  return Re ? typeof we < "u" ? Ue.slice(0, we) : Ue : null;
}, SelectContext = /* @__PURE__ */ React.createContext(null);
function Polite(ce) {
  var ie = ce.visible, me = ce.values;
  if (!ie)
    return null;
  var we = 50;
  return /* @__PURE__ */ React.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(me.slice(0, we).map(function(Re) {
    var je = Re.label, Ue = Re.value;
    return ["number", "string"].includes(_typeof$b(je)) ? je : Ue;
  }).join(", ")), me.length > we ? ", ..." : null);
}
var _excluded$7 = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], isMultiple = function(ie) {
  return ie === "tags" || ie === "multiple";
}, BaseSelect = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me, we = ce.id, Re = ce.prefixCls, je = ce.className, Ue = ce.showSearch, qe = ce.tagRender, Ge = ce.direction, Xe = ce.omitDomProps, ot = ce.displayValues, vt = ce.onDisplayValuesChange, bt = ce.emptyOptions, Tt = ce.notFoundContent, wt = Tt === void 0 ? "Not Found" : Tt, St = ce.onClear, It = ce.mode, Pt = ce.disabled, kt = ce.loading, Ot = ce.getInputElement, Jr = ce.getRawInputElement, en = ce.open, nn = ce.defaultOpen, ln = ce.onDropdownVisibleChange, fn = ce.activeValue, vn = ce.onActiveValueChange, Tn = ce.activeDescendantId, xn = ce.searchValue, bn = ce.autoClearSearchValue, Sn = ce.onSearch, Cn = ce.onSearchSplit, kn = ce.tokenSeparators, cn = ce.allowClear, gn = ce.prefix, an = ce.suffixIcon, un = ce.clearIcon, pn = ce.OptionList, hn = ce.animation, An = ce.transitionName, In = ce.dropdownStyle, qn = ce.dropdownClassName, si = ce.dropdownMatchSelectWidth, bi = ce.dropdownRender, xi = ce.dropdownAlign, ji = ce.placement, zi = ce.builtinPlacements, Vi = ce.getPopupContainer, Hi = ce.showAction, ii = Hi === void 0 ? [] : Hi, Fi = ce.onFocus, ni = ce.onBlur, Ui = ce.onKeyUp, ja = ce.onKeyDown, Ga = ce.onMouseDown, Xa = _objectWithoutProperties$6(ce, _excluded$7), Ns = isMultiple(It), Ya = (Ue !== void 0 ? Ue : Ns) || It === "combobox", Qa = _objectSpread2$2({}, Xa);
  DEFAULT_OMIT_PROPS.forEach(function(Tl) {
    delete Qa[Tl];
  }), Xe == null || Xe.forEach(function(Tl) {
    delete Qa[Tl];
  });
  var Ja = React.useState(!1), Ms = _slicedToArray$8(Ja, 2), Hs = Ms[0], no = Ms[1];
  React.useEffect(function() {
    no(isMobile());
  }, []);
  var Qs = React.useRef(null), Zs = React.useRef(null), so = React.useRef(null), io = React.useRef(null), dl = React.useRef(null), vl = React.useRef(!1), lo = useDelayReset(), yl = _slicedToArray$8(lo, 3), bl = yl[0], Al = yl[1], Xl = yl[2];
  React.useImperativeHandle(ie, function() {
    var Tl, uo;
    return {
      focus: (Tl = io.current) === null || Tl === void 0 ? void 0 : Tl.focus,
      blur: (uo = io.current) === null || uo === void 0 ? void 0 : uo.blur,
      scrollTo: function(pm) {
        var zl;
        return (zl = dl.current) === null || zl === void 0 ? void 0 : zl.scrollTo(pm);
      },
      nativeElement: Qs.current || Zs.current
    };
  });
  var $l = React.useMemo(function() {
    var Tl;
    if (It !== "combobox")
      return xn;
    var uo = (Tl = ot[0]) === null || Tl === void 0 ? void 0 : Tl.value;
    return typeof uo == "string" || typeof uo == "number" ? String(uo) : "";
  }, [xn, It, ot]), Bl = It === "combobox" && typeof Ot == "function" && Ot() || null, Fl = typeof Jr == "function" && Jr(), kl = useComposeRef(Zs, Fl == null || (me = Fl.props) === null || me === void 0 ? void 0 : me.ref), ql = React.useState(!1), _l = _slicedToArray$8(ql, 2), Ol = _l[0], Ll = _l[1];
  useLayoutEffect$1(function() {
    Ll(!0);
  }, []);
  var Ql = useMergedState(!1, {
    defaultValue: nn,
    value: en
  }), wl = _slicedToArray$8(Ql, 2), to = wl[0], zs = wl[1], Gs = Ol ? to : !1, Pl = !wt && bt;
  (Pt || Pl && Gs && It === "combobox") && (Gs = !1);
  var Ml = Pl ? !1 : Gs, Ws = React.useCallback(function(Tl) {
    var uo = Tl !== void 0 ? Tl : !Gs;
    Pt || (zs(uo), Gs !== uo && (ln == null || ln(uo)));
  }, [Pt, Gs, zs, ln]), Ks = React.useMemo(function() {
    return (kn || []).some(function(Tl) {
      return [`
`, `\r
`].includes(Tl);
    });
  }, [kn]), Js = React.useContext(SelectContext) || {}, qs = Js.maxCount, ho = Js.rawValues, mn = function(uo, om, pm) {
    if (!(Ns && isValidCount(qs) && (ho == null ? void 0 : ho.size) >= qs)) {
      var zl = !0, rm = uo;
      vn == null || vn(null);
      var Zp = getSeparatedContent(uo, kn, isValidCount(qs) ? qs - ho.size : void 0), Am = pm ? null : Zp;
      return It !== "combobox" && Am && (rm = "", Cn == null || Cn(Am), Ws(!1), zl = !1), Sn && $l !== rm && Sn(rm, {
        source: om ? "typing" : "effect"
      }), zl;
    }
  }, ai = function(uo) {
    !uo || !uo.trim() || Sn(uo, {
      source: "submit"
    });
  };
  React.useEffect(function() {
    !Gs && !Ns && It !== "combobox" && mn("", !1, !1);
  }, [Gs]), React.useEffect(function() {
    to && Pt && zs(!1), Pt && !vl.current && Al(!1);
  }, [Pt]);
  var $i = useLock(), Ha = _slicedToArray$8($i, 2), Va = Ha[0], Us = Ha[1], $s = React.useRef(!1), Za = function(uo) {
    var om = Va(), pm = uo.key, zl = pm === "Enter";
    if (zl && (It !== "combobox" && uo.preventDefault(), Gs || Ws(!0)), Us(!!$l), pm === "Backspace" && !om && Ns && !$l && ot.length) {
      for (var rm = _toConsumableArray$1(ot), Zp = null, Am = rm.length - 1; Am >= 0; Am -= 1) {
        var Sm = rm[Am];
        if (!Sm.disabled) {
          rm.splice(Am, 1), Zp = Sm;
          break;
        }
      }
      Zp && vt(rm, {
        type: "remove",
        values: [Zp]
      });
    }
    for (var mm = arguments.length, Rm = new Array(mm > 1 ? mm - 1 : 0), $m = 1; $m < mm; $m++)
      Rm[$m - 1] = arguments[$m];
    if (Gs && (!zl || !$s.current)) {
      var xm;
      zl && ($s.current = !0), (xm = dl.current) === null || xm === void 0 || xm.onKeyDown.apply(xm, [uo].concat(Rm));
    }
    ja == null || ja.apply(void 0, [uo].concat(Rm));
  }, ml = function(uo) {
    for (var om = arguments.length, pm = new Array(om > 1 ? om - 1 : 0), zl = 1; zl < om; zl++)
      pm[zl - 1] = arguments[zl];
    if (Gs) {
      var rm;
      (rm = dl.current) === null || rm === void 0 || rm.onKeyUp.apply(rm, [uo].concat(pm));
    }
    uo.key === "Enter" && ($s.current = !1), Ui == null || Ui.apply(void 0, [uo].concat(pm));
  }, Ys = function(uo) {
    var om = ot.filter(function(pm) {
      return pm !== uo;
    });
    vt(om, {
      type: "remove",
      values: [uo]
    });
  }, Bs = function() {
    $s.current = !1;
  }, Wa = React.useRef(!1), js = function() {
    Al(!0), Pt || (Fi && !Wa.current && Fi.apply(void 0, arguments), ii.includes("focus") && Ws(!0)), Wa.current = !0;
  }, Fs = function() {
    vl.current = !0, Al(!1, function() {
      Wa.current = !1, vl.current = !1, Ws(!1);
    }), !Pt && ($l && (It === "tags" ? Sn($l, {
      source: "submit"
    }) : It === "multiple" && Sn("", {
      source: "blur"
    })), ni && ni.apply(void 0, arguments));
  }, Xi = [];
  React.useEffect(function() {
    return function() {
      Xi.forEach(function(Tl) {
        return clearTimeout(Tl);
      }), Xi.splice(0, Xi.length);
    };
  }, []);
  var ao = function(uo) {
    var om, pm = uo.target, zl = (om = so.current) === null || om === void 0 ? void 0 : om.getPopupElement();
    if (zl && zl.contains(pm)) {
      var rm = setTimeout(function() {
        var mm = Xi.indexOf(rm);
        if (mm !== -1 && Xi.splice(mm, 1), Xl(), !Hs && !zl.contains(document.activeElement)) {
          var Rm;
          (Rm = io.current) === null || Rm === void 0 || Rm.focus();
        }
      });
      Xi.push(rm);
    }
    for (var Zp = arguments.length, Am = new Array(Zp > 1 ? Zp - 1 : 0), Sm = 1; Sm < Zp; Sm++)
      Am[Sm - 1] = arguments[Sm];
    Ga == null || Ga.apply(void 0, [uo].concat(Am));
  }, Sl = React.useState({}), xl = _slicedToArray$8(Sl, 2), fm = xl[1];
  function Jp() {
    fm({});
  }
  var um;
  Fl && (um = function(uo) {
    Ws(uo);
  }), useSelectTriggerControl(function() {
    var Tl;
    return [Qs.current, (Tl = so.current) === null || Tl === void 0 ? void 0 : Tl.getPopupElement()];
  }, Ml, Ws, !!Fl);
  var sm = React.useMemo(function() {
    return _objectSpread2$2(_objectSpread2$2({}, ce), {}, {
      notFoundContent: wt,
      open: Gs,
      triggerOpen: Ml,
      id: we,
      showSearch: Ya,
      multiple: Ns,
      toggleOpen: Ws
    });
  }, [ce, wt, Ml, Gs, we, Ya, Ns, Ws]), em = !!an || kt, _m;
  em && (_m = /* @__PURE__ */ React.createElement(TransBtn, {
    className: classNames("".concat(Re, "-arrow"), _defineProperty$s({}, "".concat(Re, "-arrow-loading"), kt)),
    customizeIcon: an,
    customizeIconProps: {
      loading: kt,
      searchValue: $l,
      open: Gs,
      focused: bl,
      showSearch: Ya
    }
  }));
  var wm = function() {
    var uo;
    St == null || St(), (uo = io.current) === null || uo === void 0 || uo.focus(), vt([], {
      type: "clear",
      values: ot
    }), mn("", !1, !1);
  }, tm = useAllowClear(Re, wm, ot, cn, un, Pt, $l, It), cm = tm.allowClear, Lm = tm.clearIcon, Om = /* @__PURE__ */ React.createElement(pn, {
    ref: dl
  }), Vm = classNames(Re, je, _defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s({}, "".concat(Re, "-focused"), bl), "".concat(Re, "-multiple"), Ns), "".concat(Re, "-single"), !Ns), "".concat(Re, "-allow-clear"), cn), "".concat(Re, "-show-arrow"), em), "".concat(Re, "-disabled"), Pt), "".concat(Re, "-loading"), kt), "".concat(Re, "-open"), Gs), "".concat(Re, "-customize-input"), Bl), "".concat(Re, "-show-search"), Ya)), ug = /* @__PURE__ */ React.createElement(RefSelectTrigger, {
    ref: so,
    disabled: Pt,
    prefixCls: Re,
    visible: Ml,
    popupElement: Om,
    animation: hn,
    transitionName: An,
    dropdownStyle: In,
    dropdownClassName: qn,
    direction: Ge,
    dropdownMatchSelectWidth: si,
    dropdownRender: bi,
    dropdownAlign: xi,
    placement: ji,
    builtinPlacements: zi,
    getPopupContainer: Vi,
    empty: bt,
    getTriggerDOMNode: function(uo) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Zs.current || uo
      );
    },
    onPopupVisibleChange: um,
    onPopupMouseEnter: Jp
  }, Fl ? /* @__PURE__ */ React.cloneElement(Fl, {
    ref: kl
  }) : /* @__PURE__ */ React.createElement(ForwardSelector, _extends$j({}, ce, {
    domRef: Zs,
    prefixCls: Re,
    inputElement: Bl,
    ref: io,
    id: we,
    prefix: gn,
    showSearch: Ya,
    autoClearSearchValue: bn,
    mode: It,
    activeDescendantId: Tn,
    tagRender: qe,
    values: ot,
    open: Gs,
    onToggleOpen: Ws,
    activeValue: fn,
    searchValue: $l,
    onSearch: mn,
    onSearchSubmit: ai,
    onRemove: Ys,
    tokenWithEnter: Ks,
    onInputBlur: Bs
  }))), qm;
  return Fl ? qm = ug : qm = /* @__PURE__ */ React.createElement("div", _extends$j({
    className: Vm
  }, Qa, {
    ref: Qs,
    onMouseDown: ao,
    onKeyDown: Za,
    onKeyUp: ml,
    onFocus: js,
    onBlur: Fs
  }), /* @__PURE__ */ React.createElement(Polite, {
    visible: bl && !Gs,
    values: ot
  }), ug, _m, cm && Lm), /* @__PURE__ */ React.createElement(BaseSelectContext.Provider, {
    value: sm
  }, qm);
});
process.env.NODE_ENV !== "production" && (BaseSelect.displayName = "BaseSelect");
var OptGroup = function() {
  return null;
};
OptGroup.isSelectOptGroup = !0;
var Option = function() {
  return null;
};
Option.isSelectOption = !0;
function omit(ce, ie) {
  var me = Object.assign({}, ce);
  return Array.isArray(ie) && ie.forEach(function(we) {
    delete me[we];
  }), me;
}
var Filler = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.height, we = ce.offsetY, Re = ce.offsetX, je = ce.children, Ue = ce.prefixCls, qe = ce.onInnerResize, Ge = ce.innerProps, Xe = ce.rtl, ot = ce.extra, vt = {}, bt = {
    display: "flex",
    flexDirection: "column"
  };
  return we !== void 0 && (vt = {
    height: me,
    position: "relative",
    overflow: "hidden"
  }, bt = _objectSpread2$2(_objectSpread2$2({}, bt), {}, _defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s({
    transform: "translateY(".concat(we, "px)")
  }, Xe ? "marginRight" : "marginLeft", -Re), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ React.createElement("div", {
    style: vt
  }, /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(wt) {
      var St = wt.offsetHeight;
      St && qe && qe();
    }
  }, /* @__PURE__ */ React.createElement("div", _extends$j({
    style: bt,
    className: classNames(_defineProperty$s({}, "".concat(Ue, "-holder-inner"), Ue)),
    ref: ie
  }, Ge), je, ot)));
});
Filler.displayName = "Filler";
function Item(ce) {
  var ie = ce.children, me = ce.setRef, we = React.useCallback(function(Re) {
    me(Re);
  }, []);
  return /* @__PURE__ */ React.cloneElement(ie, {
    ref: we
  });
}
function useChildren(ce, ie, me, we, Re, je, Ue, qe) {
  var Ge = qe.getKey;
  return ce.slice(ie, me + 1).map(function(Xe, ot) {
    var vt = ie + ot, bt = Ue(Xe, vt, {
      style: {
        width: we
      },
      offsetX: Re
    }), Tt = Ge(Xe);
    return /* @__PURE__ */ React.createElement(Item, {
      key: Tt,
      setRef: function(St) {
        return je(Xe, St);
      }
    }, bt);
  });
}
function findListDiffIndex(ce, ie, me) {
  var we = ce.length, Re = ie.length, je, Ue;
  if (we === 0 && Re === 0)
    return null;
  we < Re ? (je = ce, Ue = ie) : (je = ie, Ue = ce);
  var qe = {
    __EMPTY_ITEM__: !0
  };
  function Ge(wt) {
    return wt !== void 0 ? me(wt) : qe;
  }
  for (var Xe = null, ot = Math.abs(we - Re) !== 1, vt = 0; vt < Ue.length; vt += 1) {
    var bt = Ge(je[vt]), Tt = Ge(Ue[vt]);
    if (bt !== Tt) {
      Xe = vt, ot = ot || bt !== Ge(Ue[vt + 1]);
      break;
    }
  }
  return Xe === null ? null : {
    index: Xe,
    multiple: ot
  };
}
function useDiffItem(ce, ie, me) {
  var we = React.useState(ce), Re = _slicedToArray$8(we, 2), je = Re[0], Ue = Re[1], qe = React.useState(null), Ge = _slicedToArray$8(qe, 2), Xe = Ge[0], ot = Ge[1];
  return React.useEffect(function() {
    var vt = findListDiffIndex(je || [], ce || [], ie);
    (vt == null ? void 0 : vt.index) !== void 0 && ot(ce[vt.index]), Ue(ce);
  }, [ce]), [Xe];
}
var isFF = (typeof navigator > "u" ? "undefined" : _typeof$b(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const useOriginScroll = function(ce, ie, me, we) {
  var Re = useRef(!1), je = useRef(null);
  function Ue() {
    clearTimeout(je.current), Re.current = !0, je.current = setTimeout(function() {
      Re.current = !1;
    }, 50);
  }
  var qe = useRef({
    top: ce,
    bottom: ie,
    left: me,
    right: we
  });
  return qe.current.top = ce, qe.current.bottom = ie, qe.current.left = me, qe.current.right = we, function(Ge, Xe) {
    var ot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, vt = Ge ? (
      // Pass origin wheel when on the left
      Xe < 0 && qe.current.left || // Pass origin wheel when on the right
      Xe > 0 && qe.current.right
    ) : Xe < 0 && qe.current.top || // Pass origin wheel when on the bottom
    Xe > 0 && qe.current.bottom;
    return ot && vt ? (clearTimeout(je.current), Re.current = !1) : (!vt || Re.current) && Ue(), !Re.current && vt;
  };
};
function useFrameWheel(ce, ie, me, we, Re, je, Ue) {
  var qe = useRef(0), Ge = useRef(null), Xe = useRef(null), ot = useRef(!1), vt = useOriginScroll(ie, me, we, Re);
  function bt(kt, Ot) {
    if (wrapperRaf$1.cancel(Ge.current), !vt(!1, Ot)) {
      var Jr = kt;
      if (!Jr._virtualHandled)
        Jr._virtualHandled = !0;
      else
        return;
      qe.current += Ot, Xe.current = Ot, isFF || Jr.preventDefault(), Ge.current = wrapperRaf$1(function() {
        var en = ot.current ? 10 : 1;
        Ue(qe.current * en, !1), qe.current = 0;
      });
    }
  }
  function Tt(kt, Ot) {
    Ue(Ot, !0), isFF || kt.preventDefault();
  }
  var wt = useRef(null), St = useRef(null);
  function It(kt) {
    if (ce) {
      wrapperRaf$1.cancel(St.current), St.current = wrapperRaf$1(function() {
        wt.current = null;
      }, 2);
      var Ot = kt.deltaX, Jr = kt.deltaY, en = kt.shiftKey, nn = Ot, ln = Jr;
      (wt.current === "sx" || !wt.current && en && Jr && !Ot) && (nn = Jr, ln = 0, wt.current = "sx");
      var fn = Math.abs(nn), vn = Math.abs(ln);
      wt.current === null && (wt.current = je && fn > vn ? "x" : "y"), wt.current === "y" ? bt(kt, ln) : Tt(kt, nn);
    }
  }
  function Pt(kt) {
    ce && (ot.current = kt.detail === Xe.current);
  }
  return [It, Pt];
}
function useGetSize(ce, ie, me, we) {
  var Re = React.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [ce, me.id, we]), je = _slicedToArray$8(Re, 2), Ue = je[0], qe = je[1], Ge = function(ot) {
    var vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ot, bt = Ue.get(ot), Tt = Ue.get(vt);
    if (bt === void 0 || Tt === void 0)
      for (var wt = ce.length, St = qe.length; St < wt; St += 1) {
        var It, Pt = ce[St], kt = ie(Pt);
        Ue.set(kt, St);
        var Ot = (It = me.get(kt)) !== null && It !== void 0 ? It : we;
        if (qe[St] = (qe[St - 1] || 0) + Ot, kt === ot && (bt = St), kt === vt && (Tt = St), bt !== void 0 && Tt !== void 0)
          break;
      }
    return {
      top: qe[bt - 1] || 0,
      bottom: qe[Tt]
    };
  };
  return Ge;
}
var CacheMap = /* @__PURE__ */ function() {
  function ce() {
    _classCallCheck$t(this, ce), _defineProperty$s(this, "maps", void 0), _defineProperty$s(this, "id", 0), _defineProperty$s(this, "diffKeys", /* @__PURE__ */ new Set()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _createClass$r(ce, [{
    key: "set",
    value: function(me, we) {
      this.maps[me] = we, this.id += 1, this.diffKeys.add(me);
    }
  }, {
    key: "get",
    value: function(me) {
      return this.maps[me];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffKeys.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffKeys;
    }
  }]), ce;
}();
function parseNumber(ce) {
  var ie = parseFloat(ce);
  return isNaN(ie) ? 0 : ie;
}
function useHeights(ce, ie, me) {
  var we = React.useState(0), Re = _slicedToArray$8(we, 2), je = Re[0], Ue = Re[1], qe = useRef(/* @__PURE__ */ new Map()), Ge = useRef(new CacheMap()), Xe = useRef(0);
  function ot() {
    Xe.current += 1;
  }
  function vt() {
    var Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    ot();
    var wt = function() {
      var Pt = !1;
      qe.current.forEach(function(kt, Ot) {
        if (kt && kt.offsetParent) {
          var Jr = kt.offsetHeight, en = getComputedStyle(kt), nn = en.marginTop, ln = en.marginBottom, fn = parseNumber(nn), vn = parseNumber(ln), Tn = Jr + fn + vn;
          Ge.current.get(Ot) !== Tn && (Ge.current.set(Ot, Tn), Pt = !0);
        }
      }), Pt && Ue(function(kt) {
        return kt + 1;
      });
    };
    if (Tt)
      wt();
    else {
      Xe.current += 1;
      var St = Xe.current;
      Promise.resolve().then(function() {
        St === Xe.current && wt();
      });
    }
  }
  function bt(Tt, wt) {
    var St = ce(Tt);
    qe.current.get(St), wt ? (qe.current.set(St, wt), vt()) : qe.current.delete(St);
  }
  return useEffect(function() {
    return ot;
  }, []), [bt, vt, Ge.current, je];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(ce, ie, me) {
  var we = useRef(!1), Re = useRef(0), je = useRef(0), Ue = useRef(null), qe = useRef(null), Ge, Xe = function(Tt) {
    if (we.current) {
      var wt = Math.ceil(Tt.touches[0].pageX), St = Math.ceil(Tt.touches[0].pageY), It = Re.current - wt, Pt = je.current - St, kt = Math.abs(It) > Math.abs(Pt);
      kt ? Re.current = wt : je.current = St;
      var Ot = me(kt, kt ? It : Pt, !1, Tt);
      Ot && Tt.preventDefault(), clearInterval(qe.current), Ot && (qe.current = setInterval(function() {
        kt ? It *= SMOOTH_PTG : Pt *= SMOOTH_PTG;
        var Jr = Math.floor(kt ? It : Pt);
        (!me(kt, Jr, !0) || Math.abs(Jr) <= 0.1) && clearInterval(qe.current);
      }, 16));
    }
  }, ot = function() {
    we.current = !1, Ge();
  }, vt = function(Tt) {
    Ge(), Tt.touches.length === 1 && !we.current && (we.current = !0, Re.current = Math.ceil(Tt.touches[0].pageX), je.current = Math.ceil(Tt.touches[0].pageY), Ue.current = Tt.target, Ue.current.addEventListener("touchmove", Xe, {
      passive: !1
    }), Ue.current.addEventListener("touchend", ot, {
      passive: !0
    }));
  };
  Ge = function() {
    Ue.current && (Ue.current.removeEventListener("touchmove", Xe), Ue.current.removeEventListener("touchend", ot));
  }, useLayoutEffect$1(function() {
    return ce && ie.current.addEventListener("touchstart", vt, {
      passive: !0
    }), function() {
      var bt;
      (bt = ie.current) === null || bt === void 0 || bt.removeEventListener("touchstart", vt), Ge(), clearInterval(qe.current);
    };
  }, [ce]);
}
function smoothScrollOffset(ce) {
  return Math.floor(Math.pow(ce, 0.5));
}
function getPageXY(ce, ie) {
  var me = "touches" in ce ? ce.touches[0] : ce;
  return me[ie ? "pageX" : "pageY"] - window[ie ? "scrollX" : "scrollY"];
}
function useScrollDrag(ce, ie, me) {
  React.useEffect(function() {
    var we = ie.current;
    if (ce && we) {
      var Re = !1, je, Ue, qe = function() {
        wrapperRaf$1.cancel(je);
      }, Ge = function bt() {
        qe(), je = wrapperRaf$1(function() {
          me(Ue), bt();
        });
      }, Xe = function(Tt) {
        if (!(Tt.target.draggable || Tt.button !== 0)) {
          var wt = Tt;
          wt._virtualHandled || (wt._virtualHandled = !0, Re = !0);
        }
      }, ot = function() {
        Re = !1, qe();
      }, vt = function(Tt) {
        if (Re) {
          var wt = getPageXY(Tt, !1), St = we.getBoundingClientRect(), It = St.top, Pt = St.bottom;
          if (wt <= It) {
            var kt = It - wt;
            Ue = -smoothScrollOffset(kt), Ge();
          } else if (wt >= Pt) {
            var Ot = wt - Pt;
            Ue = smoothScrollOffset(Ot), Ge();
          } else
            qe();
        }
      };
      return we.addEventListener("mousedown", Xe), we.ownerDocument.addEventListener("mouseup", ot), we.ownerDocument.addEventListener("mousemove", vt), function() {
        we.removeEventListener("mousedown", Xe), we.ownerDocument.removeEventListener("mouseup", ot), we.ownerDocument.removeEventListener("mousemove", vt), qe();
      };
    }
  }, [ce]);
}
var MAX_TIMES = 10;
function useScrollTo(ce, ie, me, we, Re, je, Ue, qe) {
  var Ge = React.useRef(), Xe = React.useState(null), ot = _slicedToArray$8(Xe, 2), vt = ot[0], bt = ot[1];
  return useLayoutEffect$1(function() {
    if (vt && vt.times < MAX_TIMES) {
      if (!ce.current) {
        bt(function(un) {
          return _objectSpread2$2({}, un);
        });
        return;
      }
      je();
      var Tt = vt.targetAlign, wt = vt.originAlign, St = vt.index, It = vt.offset, Pt = ce.current.clientHeight, kt = !1, Ot = Tt, Jr = null;
      if (Pt) {
        for (var en = Tt || wt, nn = 0, ln = 0, fn = 0, vn = Math.min(ie.length - 1, St), Tn = 0; Tn <= vn; Tn += 1) {
          var xn = Re(ie[Tn]);
          ln = nn;
          var bn = me.get(xn);
          fn = ln + (bn === void 0 ? we : bn), nn = fn;
        }
        for (var Sn = en === "top" ? It : Pt - It, Cn = vn; Cn >= 0; Cn -= 1) {
          var kn = Re(ie[Cn]), cn = me.get(kn);
          if (cn === void 0) {
            kt = !0;
            break;
          }
          if (Sn -= cn, Sn <= 0)
            break;
        }
        switch (en) {
          case "top":
            Jr = ln - It;
            break;
          case "bottom":
            Jr = fn - Pt + It;
            break;
          default: {
            var gn = ce.current.scrollTop, an = gn + Pt;
            ln < gn ? Ot = "top" : fn > an && (Ot = "bottom");
          }
        }
        Jr !== null && Ue(Jr), Jr !== vt.lastTop && (kt = !0);
      }
      kt && bt(_objectSpread2$2(_objectSpread2$2({}, vt), {}, {
        times: vt.times + 1,
        targetAlign: Ot,
        lastTop: Jr
      }));
    } else process.env.NODE_ENV !== "production" && (vt == null ? void 0 : vt.times) === MAX_TIMES && warningOnce(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [vt, ce.current]), function(Tt) {
    if (Tt == null) {
      qe();
      return;
    }
    if (wrapperRaf$1.cancel(Ge.current), typeof Tt == "number")
      Ue(Tt);
    else if (Tt && _typeof$b(Tt) === "object") {
      var wt, St = Tt.align;
      "index" in Tt ? wt = Tt.index : wt = ie.findIndex(function(kt) {
        return Re(kt) === Tt.key;
      });
      var It = Tt.offset, Pt = It === void 0 ? 0 : It;
      bt({
        times: 0,
        index: wt,
        offset: Pt,
        originAlign: St
      });
    }
  };
}
var ScrollBar = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.prefixCls, we = ce.rtl, Re = ce.scrollOffset, je = ce.scrollRange, Ue = ce.onStartMove, qe = ce.onStopMove, Ge = ce.onScroll, Xe = ce.horizontal, ot = ce.spinSize, vt = ce.containerSize, bt = ce.style, Tt = ce.thumbStyle, wt = ce.showScrollBar, St = React.useState(!1), It = _slicedToArray$8(St, 2), Pt = It[0], kt = It[1], Ot = React.useState(null), Jr = _slicedToArray$8(Ot, 2), en = Jr[0], nn = Jr[1], ln = React.useState(null), fn = _slicedToArray$8(ln, 2), vn = fn[0], Tn = fn[1], xn = !we, bn = React.useRef(), Sn = React.useRef(), Cn = React.useState(wt), kn = _slicedToArray$8(Cn, 2), cn = kn[0], gn = kn[1], an = React.useRef(), un = function() {
    wt === !0 || wt === !1 || (clearTimeout(an.current), gn(!0), an.current = setTimeout(function() {
      gn(!1);
    }, 3e3));
  }, pn = je - vt || 0, hn = vt - ot || 0, An = React.useMemo(function() {
    if (Re === 0 || pn === 0)
      return 0;
    var Hi = Re / pn;
    return Hi * hn;
  }, [Re, pn, hn]), In = function(ii) {
    ii.stopPropagation(), ii.preventDefault();
  }, qn = React.useRef({
    top: An,
    dragging: Pt,
    pageY: en,
    startTop: vn
  });
  qn.current = {
    top: An,
    dragging: Pt,
    pageY: en,
    startTop: vn
  };
  var si = function(ii) {
    kt(!0), nn(getPageXY(ii, Xe)), Tn(qn.current.top), Ue(), ii.stopPropagation(), ii.preventDefault();
  };
  React.useEffect(function() {
    var Hi = function(Ui) {
      Ui.preventDefault();
    }, ii = bn.current, Fi = Sn.current;
    return ii.addEventListener("touchstart", Hi, {
      passive: !1
    }), Fi.addEventListener("touchstart", si, {
      passive: !1
    }), function() {
      ii.removeEventListener("touchstart", Hi), Fi.removeEventListener("touchstart", si);
    };
  }, []);
  var bi = React.useRef();
  bi.current = pn;
  var xi = React.useRef();
  xi.current = hn, React.useEffect(function() {
    if (Pt) {
      var Hi, ii = function(Ui) {
        var ja = qn.current, Ga = ja.dragging, Xa = ja.pageY, Ns = ja.startTop;
        wrapperRaf$1.cancel(Hi);
        var Ya = bn.current.getBoundingClientRect(), Qa = vt / (Xe ? Ya.width : Ya.height);
        if (Ga) {
          var Ja = (getPageXY(Ui, Xe) - Xa) * Qa, Ms = Ns;
          !xn && Xe ? Ms -= Ja : Ms += Ja;
          var Hs = bi.current, no = xi.current, Qs = no ? Ms / no : 0, Zs = Math.ceil(Qs * Hs);
          Zs = Math.max(Zs, 0), Zs = Math.min(Zs, Hs), Hi = wrapperRaf$1(function() {
            Ge(Zs, Xe);
          });
        }
      }, Fi = function() {
        kt(!1), qe();
      };
      return window.addEventListener("mousemove", ii, {
        passive: !0
      }), window.addEventListener("touchmove", ii, {
        passive: !0
      }), window.addEventListener("mouseup", Fi, {
        passive: !0
      }), window.addEventListener("touchend", Fi, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", ii), window.removeEventListener("touchmove", ii), window.removeEventListener("mouseup", Fi), window.removeEventListener("touchend", Fi), wrapperRaf$1.cancel(Hi);
      };
    }
  }, [Pt]), React.useEffect(function() {
    return un(), function() {
      clearTimeout(an.current);
    };
  }, [Re]), React.useImperativeHandle(ie, function() {
    return {
      delayHidden: un
    };
  });
  var ji = "".concat(me, "-scrollbar"), zi = {
    position: "absolute",
    visibility: cn ? null : "hidden"
  }, Vi = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return Xe ? (zi.height = 8, zi.left = 0, zi.right = 0, zi.bottom = 0, Vi.height = "100%", Vi.width = ot, xn ? Vi.left = An : Vi.right = An) : (zi.width = 8, zi.top = 0, zi.bottom = 0, xn ? zi.right = 0 : zi.left = 0, Vi.width = "100%", Vi.height = ot, Vi.top = An), /* @__PURE__ */ React.createElement("div", {
    ref: bn,
    className: classNames(ji, _defineProperty$s(_defineProperty$s(_defineProperty$s({}, "".concat(ji, "-horizontal"), Xe), "".concat(ji, "-vertical"), !Xe), "".concat(ji, "-visible"), cn)),
    style: _objectSpread2$2(_objectSpread2$2({}, zi), bt),
    onMouseDown: In,
    onMouseMove: un
  }, /* @__PURE__ */ React.createElement("div", {
    ref: Sn,
    className: classNames("".concat(ji, "-thumb"), _defineProperty$s({}, "".concat(ji, "-thumb-moving"), Pt)),
    style: _objectSpread2$2(_objectSpread2$2({}, Vi), Tt),
    onMouseDown: si
  }));
});
process.env.NODE_ENV !== "production" && (ScrollBar.displayName = "ScrollBar");
var MIN_SIZE = 20;
function getSpinSize() {
  var ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, me = ce / ie * ce;
  return isNaN(me) && (me = 0), me = Math.max(me, MIN_SIZE), Math.floor(me);
}
var _excluded$6 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], EMPTY_DATA = [], ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(ce, ie) {
  var me = ce.prefixCls, we = me === void 0 ? "rc-virtual-list" : me, Re = ce.className, je = ce.height, Ue = ce.itemHeight, qe = ce.fullHeight, Ge = qe === void 0 ? !0 : qe, Xe = ce.style, ot = ce.data, vt = ce.children, bt = ce.itemKey, Tt = ce.virtual, wt = ce.direction, St = ce.scrollWidth, It = ce.component, Pt = It === void 0 ? "div" : It, kt = ce.onScroll, Ot = ce.onVirtualScroll, Jr = ce.onVisibleChange, en = ce.innerProps, nn = ce.extraRender, ln = ce.styles, fn = ce.showScrollBar, vn = fn === void 0 ? "optional" : fn, Tn = _objectWithoutProperties$6(ce, _excluded$6), xn = React.useCallback(function(Wa) {
    return typeof bt == "function" ? bt(Wa) : Wa == null ? void 0 : Wa[bt];
  }, [bt]), bn = useHeights(xn), Sn = _slicedToArray$8(bn, 4), Cn = Sn[0], kn = Sn[1], cn = Sn[2], gn = Sn[3], an = !!(Tt !== !1 && je && Ue), un = React.useMemo(function() {
    return Object.values(cn.maps).reduce(function(Wa, js) {
      return Wa + js;
    }, 0);
  }, [cn.id, cn.maps]), pn = an && ot && (Math.max(Ue * ot.length, un) > je || !!St), hn = wt === "rtl", An = classNames(we, _defineProperty$s({}, "".concat(we, "-rtl"), hn), Re), In = ot || EMPTY_DATA, qn = useRef(), si = useRef(), bi = useRef(), xi = useState(0), ji = _slicedToArray$8(xi, 2), zi = ji[0], Vi = ji[1], Hi = useState(0), ii = _slicedToArray$8(Hi, 2), Fi = ii[0], ni = ii[1], Ui = useState(!1), ja = _slicedToArray$8(Ui, 2), Ga = ja[0], Xa = ja[1], Ns = function() {
    Xa(!0);
  }, Ya = function() {
    Xa(!1);
  }, Qa = {
    getKey: xn
  };
  function Ja(Wa) {
    Vi(function(js) {
      var Fs;
      typeof Wa == "function" ? Fs = Wa(js) : Fs = Wa;
      var Xi = Ll(Fs);
      return qn.current.scrollTop = Xi, Xi;
    });
  }
  var Ms = useRef({
    start: 0,
    end: In.length
  }), Hs = useRef(), no = useDiffItem(In, xn), Qs = _slicedToArray$8(no, 1), Zs = Qs[0];
  Hs.current = Zs;
  var so = React.useMemo(function() {
    if (!an)
      return {
        scrollHeight: void 0,
        start: 0,
        end: In.length - 1,
        offset: void 0
      };
    if (!pn) {
      var Wa;
      return {
        scrollHeight: ((Wa = si.current) === null || Wa === void 0 ? void 0 : Wa.offsetHeight) || 0,
        start: 0,
        end: In.length - 1,
        offset: void 0
      };
    }
    for (var js = 0, Fs, Xi, ao, Sl = In.length, xl = 0; xl < Sl; xl += 1) {
      var fm = In[xl], Jp = xn(fm), um = cn.get(Jp), sm = js + (um === void 0 ? Ue : um);
      sm >= zi && Fs === void 0 && (Fs = xl, Xi = js), sm > zi + je && ao === void 0 && (ao = xl), js = sm;
    }
    return Fs === void 0 && (Fs = 0, Xi = 0, ao = Math.ceil(je / Ue)), ao === void 0 && (ao = In.length - 1), ao = Math.min(ao + 1, In.length - 1), {
      scrollHeight: js,
      start: Fs,
      end: ao,
      offset: Xi
    };
  }, [pn, an, zi, In, gn, je]), io = so.scrollHeight, dl = so.start, vl = so.end, lo = so.offset;
  Ms.current.start = dl, Ms.current.end = vl, React.useLayoutEffect(function() {
    var Wa = cn.getRecord();
    if (Wa.size === 1) {
      var js = Array.from(Wa)[0], Fs = In[dl];
      if (Fs) {
        var Xi = xn(Fs);
        if (Xi === js) {
          var ao = cn.get(js), Sl = ao - Ue;
          Ja(function(xl) {
            return xl + Sl;
          });
        }
      }
    }
    cn.resetRecord();
  }, [io]);
  var yl = React.useState({
    width: 0,
    height: je
  }), bl = _slicedToArray$8(yl, 2), Al = bl[0], Xl = bl[1], $l = function(js) {
    Xl({
      width: js.offsetWidth,
      height: js.offsetHeight
    });
  }, Bl = useRef(), Fl = useRef(), kl = React.useMemo(function() {
    return getSpinSize(Al.width, St);
  }, [Al.width, St]), ql = React.useMemo(function() {
    return getSpinSize(Al.height, io);
  }, [Al.height, io]), _l = io - je, Ol = useRef(_l);
  Ol.current = _l;
  function Ll(Wa) {
    var js = Wa;
    return Number.isNaN(Ol.current) || (js = Math.min(js, Ol.current)), js = Math.max(js, 0), js;
  }
  var Ql = zi <= 0, wl = zi >= _l, to = Fi <= 0, zs = Fi >= St, Gs = useOriginScroll(Ql, wl, to, zs), Pl = function() {
    return {
      x: hn ? -Fi : Fi,
      y: zi
    };
  }, Ml = useRef(Pl()), Ws = useEvent(function(Wa) {
    if (Ot) {
      var js = _objectSpread2$2(_objectSpread2$2({}, Pl()), Wa);
      (Ml.current.x !== js.x || Ml.current.y !== js.y) && (Ot(js), Ml.current = js);
    }
  });
  function Ks(Wa, js) {
    var Fs = Wa;
    js ? (flushSync(function() {
      ni(Fs);
    }), Ws()) : Ja(Fs);
  }
  function Js(Wa) {
    var js = Wa.currentTarget.scrollTop;
    js !== zi && Ja(js), kt == null || kt(Wa), Ws();
  }
  var qs = function(js) {
    var Fs = js, Xi = St ? St - Al.width : 0;
    return Fs = Math.max(Fs, 0), Fs = Math.min(Fs, Xi), Fs;
  }, ho = useEvent(function(Wa, js) {
    js ? (flushSync(function() {
      ni(function(Fs) {
        var Xi = Fs + (hn ? -Wa : Wa);
        return qs(Xi);
      });
    }), Ws()) : Ja(function(Fs) {
      var Xi = Fs + Wa;
      return Xi;
    });
  }), mn = useFrameWheel(an, Ql, wl, to, zs, !!St, ho), ai = _slicedToArray$8(mn, 2), $i = ai[0], Ha = ai[1];
  useMobileTouchMove(an, qn, function(Wa, js, Fs, Xi) {
    var ao = Xi;
    return Gs(Wa, js, Fs) ? !1 : !ao || !ao._virtualHandled ? (ao && (ao._virtualHandled = !0), $i({
      preventDefault: function() {
      },
      deltaX: Wa ? js : 0,
      deltaY: Wa ? 0 : js
    }), !0) : !1;
  }), useScrollDrag(pn, qn, function(Wa) {
    Ja(function(js) {
      return js + Wa;
    });
  }), useLayoutEffect$1(function() {
    function Wa(Fs) {
      var Xi = Ql && Fs.detail < 0, ao = wl && Fs.detail > 0;
      an && !Xi && !ao && Fs.preventDefault();
    }
    var js = qn.current;
    return js.addEventListener("wheel", $i, {
      passive: !1
    }), js.addEventListener("DOMMouseScroll", Ha, {
      passive: !0
    }), js.addEventListener("MozMousePixelScroll", Wa, {
      passive: !1
    }), function() {
      js.removeEventListener("wheel", $i), js.removeEventListener("DOMMouseScroll", Ha), js.removeEventListener("MozMousePixelScroll", Wa);
    };
  }, [an, Ql, wl]), useLayoutEffect$1(function() {
    if (St) {
      var Wa = qs(Fi);
      ni(Wa), Ws({
        x: Wa
      });
    }
  }, [Al.width, St]);
  var Va = function() {
    var js, Fs;
    (js = Bl.current) === null || js === void 0 || js.delayHidden(), (Fs = Fl.current) === null || Fs === void 0 || Fs.delayHidden();
  }, Us = useScrollTo(qn, In, cn, Ue, xn, function() {
    return kn(!0);
  }, Ja, Va);
  React.useImperativeHandle(ie, function() {
    return {
      nativeElement: bi.current,
      getScrollInfo: Pl,
      scrollTo: function(js) {
        function Fs(Xi) {
          return Xi && _typeof$b(Xi) === "object" && ("left" in Xi || "top" in Xi);
        }
        Fs(js) ? (js.left !== void 0 && ni(qs(js.left)), Us(js.top)) : Us(js);
      }
    };
  }), useLayoutEffect$1(function() {
    if (Jr) {
      var Wa = In.slice(dl, vl + 1);
      Jr(Wa, In);
    }
  }, [dl, vl, In]);
  var $s = useGetSize(In, xn, cn, Ue), Za = nn == null ? void 0 : nn({
    start: dl,
    end: vl,
    virtual: pn,
    offsetX: Fi,
    offsetY: lo,
    rtl: hn,
    getSize: $s
  }), ml = useChildren(In, dl, vl, St, Fi, Cn, vt, Qa), Ys = null;
  je && (Ys = _objectSpread2$2(_defineProperty$s({}, Ge ? "height" : "maxHeight", je), ScrollStyle), an && (Ys.overflowY = "hidden", St && (Ys.overflowX = "hidden"), Ga && (Ys.pointerEvents = "none")));
  var Bs = {};
  return hn && (Bs.dir = "rtl"), /* @__PURE__ */ React.createElement("div", _extends$j({
    ref: bi,
    style: _objectSpread2$2(_objectSpread2$2({}, Xe), {}, {
      position: "relative"
    }),
    className: An
  }, Bs, Tn), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: $l
  }, /* @__PURE__ */ React.createElement(Pt, {
    className: "".concat(we, "-holder"),
    style: Ys,
    ref: qn,
    onScroll: Js,
    onMouseEnter: Va
  }, /* @__PURE__ */ React.createElement(Filler, {
    prefixCls: we,
    height: io,
    offsetX: Fi,
    offsetY: lo,
    scrollWidth: St,
    onInnerResize: kn,
    ref: si,
    innerProps: en,
    rtl: hn,
    extra: Za
  }, ml))), pn && io > je && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: Bl,
    prefixCls: we,
    scrollOffset: zi,
    scrollRange: io,
    rtl: hn,
    onScroll: Ks,
    onStartMove: Ns,
    onStopMove: Ya,
    spinSize: ql,
    containerSize: Al.height,
    style: ln == null ? void 0 : ln.verticalScrollBar,
    thumbStyle: ln == null ? void 0 : ln.verticalScrollBarThumb,
    showScrollBar: vn
  }), pn && St > Al.width && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: Fl,
    prefixCls: we,
    scrollOffset: Fi,
    scrollRange: St,
    rtl: hn,
    onScroll: Ks,
    onStartMove: Ns,
    onStopMove: Ya,
    spinSize: kl,
    containerSize: Al.width,
    horizontal: !0,
    style: ln == null ? void 0 : ln.horizontalScrollBar,
    thumbStyle: ln == null ? void 0 : ln.horizontalScrollBarThumb,
    showScrollBar: vn
  }));
}
var List = /* @__PURE__ */ React.forwardRef(RawList);
List.displayName = "List";
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var _excluded$5 = ["disabled", "title", "children", "style", "className"];
function isTitleType(ce) {
  return typeof ce == "string" || typeof ce == "number";
}
var OptionList = function(ie, me) {
  var we = useBaseProps(), Re = we.prefixCls, je = we.id, Ue = we.open, qe = we.multiple, Ge = we.mode, Xe = we.searchValue, ot = we.toggleOpen, vt = we.notFoundContent, bt = we.onPopupScroll, Tt = React.useContext(SelectContext), wt = Tt.maxCount, St = Tt.flattenOptions, It = Tt.onActiveValue, Pt = Tt.defaultActiveFirstOption, kt = Tt.onSelect, Ot = Tt.menuItemSelectedIcon, Jr = Tt.rawValues, en = Tt.fieldNames, nn = Tt.virtual, ln = Tt.direction, fn = Tt.listHeight, vn = Tt.listItemHeight, Tn = Tt.optionRender, xn = "".concat(Re, "-item"), bn = useMemo(function() {
    return St;
  }, [Ue, St], function(Hi, ii) {
    return ii[0] && Hi[1] !== ii[1];
  }), Sn = React.useRef(null), Cn = React.useMemo(function() {
    return qe && isValidCount(wt) && (Jr == null ? void 0 : Jr.size) >= wt;
  }, [qe, wt, Jr == null ? void 0 : Jr.size]), kn = function(ii) {
    ii.preventDefault();
  }, cn = function(ii) {
    var Fi;
    (Fi = Sn.current) === null || Fi === void 0 || Fi.scrollTo(typeof ii == "number" ? {
      index: ii
    } : ii);
  }, gn = React.useCallback(function(Hi) {
    return Ge === "combobox" ? !1 : Jr.has(Hi);
  }, [Ge, _toConsumableArray$1(Jr).toString(), Jr.size]), an = function(ii) {
    for (var Fi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, ni = bn.length, Ui = 0; Ui < ni; Ui += 1) {
      var ja = (ii + Ui * Fi + ni) % ni, Ga = bn[ja] || {}, Xa = Ga.group, Ns = Ga.data;
      if (!Xa && !(Ns != null && Ns.disabled) && (gn(Ns.value) || !Cn))
        return ja;
    }
    return -1;
  }, un = React.useState(function() {
    return an(0);
  }), pn = _slicedToArray$8(un, 2), hn = pn[0], An = pn[1], In = function(ii) {
    var Fi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    An(ii);
    var ni = {
      source: Fi ? "keyboard" : "mouse"
    }, Ui = bn[ii];
    if (!Ui) {
      It(null, -1, ni);
      return;
    }
    It(Ui.value, ii, ni);
  };
  useEffect(function() {
    In(Pt !== !1 ? an(0) : -1);
  }, [bn.length, Xe]);
  var qn = React.useCallback(function(Hi) {
    return Ge === "combobox" ? String(Hi).toLowerCase() === Xe.toLowerCase() : Jr.has(Hi);
  }, [Ge, Xe, _toConsumableArray$1(Jr).toString(), Jr.size]);
  useEffect(function() {
    var Hi = setTimeout(function() {
      if (!qe && Ue && Jr.size === 1) {
        var Fi = Array.from(Jr)[0], ni = bn.findIndex(function(Ui) {
          var ja = Ui.data;
          return ja.value === Fi;
        });
        ni !== -1 && (In(ni), cn(ni));
      }
    });
    if (Ue) {
      var ii;
      (ii = Sn.current) === null || ii === void 0 || ii.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(Hi);
    };
  }, [Ue, Xe]);
  var si = function(ii) {
    ii !== void 0 && kt(ii, {
      selected: !Jr.has(ii)
    }), qe || ot(!1);
  };
  if (React.useImperativeHandle(me, function() {
    return {
      onKeyDown: function(ii) {
        var Fi = ii.which, ni = ii.ctrlKey;
        switch (Fi) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var Ui = 0;
            if (Fi === KeyCode.UP ? Ui = -1 : Fi === KeyCode.DOWN ? Ui = 1 : isPlatformMac() && ni && (Fi === KeyCode.N ? Ui = 1 : Fi === KeyCode.P && (Ui = -1)), Ui !== 0) {
              var ja = an(hn + Ui, Ui);
              cn(ja), In(ja, !0);
            }
            break;
          }
          // >>> Select (Tab / Enter)
          case KeyCode.TAB:
          case KeyCode.ENTER: {
            var Ga, Xa = bn[hn];
            Xa && !(Xa != null && (Ga = Xa.data) !== null && Ga !== void 0 && Ga.disabled) && !Cn ? si(Xa.value) : si(void 0), Ue && ii.preventDefault();
            break;
          }
          // >>> Close
          case KeyCode.ESC:
            ot(!1), Ue && ii.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(ii) {
        cn(ii);
      }
    };
  }), bn.length === 0)
    return /* @__PURE__ */ React.createElement("div", {
      role: "listbox",
      id: "".concat(je, "_list"),
      className: "".concat(xn, "-empty"),
      onMouseDown: kn
    }, vt);
  var bi = Object.keys(en).map(function(Hi) {
    return en[Hi];
  }), xi = function(ii) {
    return ii.label;
  };
  function ji(Hi, ii) {
    var Fi = Hi.group;
    return {
      role: Fi ? "presentation" : "option",
      id: "".concat(je, "_list_").concat(ii)
    };
  }
  var zi = function(ii) {
    var Fi = bn[ii];
    if (!Fi)
      return null;
    var ni = Fi.data || {}, Ui = ni.value, ja = Fi.group, Ga = pickAttrs(ni, !0), Xa = xi(Fi);
    return Fi ? /* @__PURE__ */ React.createElement("div", _extends$j({
      "aria-label": typeof Xa == "string" && !ja ? Xa : null
    }, Ga, {
      key: ii
    }, ji(Fi, ii), {
      "aria-selected": qn(Ui)
    }), Ui) : null;
  }, Vi = {
    role: "listbox",
    id: "".concat(je, "_list")
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, nn && /* @__PURE__ */ React.createElement("div", _extends$j({}, Vi, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), zi(hn - 1), zi(hn), zi(hn + 1)), /* @__PURE__ */ React.createElement(List, {
    itemKey: "key",
    ref: Sn,
    data: bn,
    height: fn,
    itemHeight: vn,
    fullHeight: !1,
    onMouseDown: kn,
    onScroll: bt,
    virtual: nn,
    direction: ln,
    innerProps: nn ? null : Vi
  }, function(Hi, ii) {
    var Fi = Hi.group, ni = Hi.groupOption, Ui = Hi.data, ja = Hi.label, Ga = Hi.value, Xa = Ui.key;
    if (Fi) {
      var Ns, Ya = (Ns = Ui.title) !== null && Ns !== void 0 ? Ns : isTitleType(ja) ? ja.toString() : void 0;
      return /* @__PURE__ */ React.createElement("div", {
        className: classNames(xn, "".concat(xn, "-group"), Ui.className),
        title: Ya
      }, ja !== void 0 ? ja : Xa);
    }
    var Qa = Ui.disabled, Ja = Ui.title;
    Ui.children;
    var Ms = Ui.style, Hs = Ui.className, no = _objectWithoutProperties$6(Ui, _excluded$5), Qs = omit(no, bi), Zs = gn(Ga), so = Qa || !Zs && Cn, io = "".concat(xn, "-option"), dl = classNames(xn, io, Hs, _defineProperty$s(_defineProperty$s(_defineProperty$s(_defineProperty$s({}, "".concat(io, "-grouped"), ni), "".concat(io, "-active"), hn === ii && !so), "".concat(io, "-disabled"), so), "".concat(io, "-selected"), Zs)), vl = xi(Hi), lo = !Ot || typeof Ot == "function" || Zs, yl = typeof vl == "number" ? vl : vl || Ga, bl = isTitleType(yl) ? yl.toString() : void 0;
    return Ja !== void 0 && (bl = Ja), /* @__PURE__ */ React.createElement("div", _extends$j({}, pickAttrs(Qs), nn ? {} : ji(Hi, ii), {
      "aria-selected": qn(Ga),
      className: dl,
      title: bl,
      onMouseMove: function() {
        hn === ii || so || In(ii);
      },
      onClick: function() {
        so || si(Ga);
      },
      style: Ms
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(io, "-content")
    }, typeof Tn == "function" ? Tn(Hi, {
      index: ii
    }) : yl), /* @__PURE__ */ React.isValidElement(Ot) || Zs, lo && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(xn, "-option-state"),
      customizeIcon: Ot,
      customizeIconProps: {
        value: Ga,
        disabled: so,
        isSelected: Zs
      }
    }, Zs ? "✓" : null));
  }));
}, RefOptionList = /* @__PURE__ */ React.forwardRef(OptionList);
process.env.NODE_ENV !== "production" && (RefOptionList.displayName = "OptionList");
const useCache = function(ce, ie) {
  var me = React.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), we = React.useMemo(function() {
    var je = me.current, Ue = je.values, qe = je.options, Ge = ce.map(function(vt) {
      if (vt.label === void 0) {
        var bt;
        return _objectSpread2$2(_objectSpread2$2({}, vt), {}, {
          label: (bt = Ue.get(vt.value)) === null || bt === void 0 ? void 0 : bt.label
        });
      }
      return vt;
    }), Xe = /* @__PURE__ */ new Map(), ot = /* @__PURE__ */ new Map();
    return Ge.forEach(function(vt) {
      Xe.set(vt.value, vt), ot.set(vt.value, ie.get(vt.value) || qe.get(vt.value));
    }), me.current.values = Xe, me.current.options = ot, Ge;
  }, [ce, ie]), Re = React.useCallback(function(je) {
    return ie.get(je) || me.current.options.get(je);
  }, [ie]);
  return [we, Re];
};
function includes(ce, ie) {
  return toArray(ce).join("").toUpperCase().includes(ie);
}
const useFilterOptions = function(ce, ie, me, we, Re) {
  return React.useMemo(function() {
    if (!me || we === !1)
      return ce;
    var je = ie.options, Ue = ie.label, qe = ie.value, Ge = [], Xe = typeof we == "function", ot = me.toUpperCase(), vt = Xe ? we : function(Tt, wt) {
      return Re ? includes(wt[Re], ot) : wt[je] ? includes(wt[Ue !== "children" ? Ue : "label"], ot) : includes(wt[qe], ot);
    }, bt = Xe ? function(Tt) {
      return injectPropsWithOption(Tt);
    } : function(Tt) {
      return Tt;
    };
    return ce.forEach(function(Tt) {
      if (Tt[je]) {
        var wt = vt(me, bt(Tt));
        if (wt)
          Ge.push(Tt);
        else {
          var St = Tt[je].filter(function(It) {
            return vt(me, bt(It));
          });
          St.length && Ge.push(_objectSpread2$2(_objectSpread2$2({}, Tt), {}, _defineProperty$s({}, je, St)));
        }
        return;
      }
      vt(me, bt(Tt)) && Ge.push(Tt);
    }), Ge;
  }, [ce, we, Re, me, ie]);
};
var uuid = 0, isBrowserClient = process.env.NODE_ENV !== "test" && canUseDom();
function getUUID() {
  var ce;
  return isBrowserClient ? (ce = uuid, uuid += 1) : ce = "TEST_OR_SSR", ce;
}
function useId(ce) {
  var ie = React.useState(), me = _slicedToArray$8(ie, 2), we = me[0], Re = me[1];
  return React.useEffect(function() {
    Re("rc_select_".concat(getUUID()));
  }, []), ce || we;
}
var _excluded$4 = ["children", "value"], _excluded2 = ["children"];
function convertNodeToOption(ce) {
  var ie = ce, me = ie.key, we = ie.props, Re = we.children, je = we.value, Ue = _objectWithoutProperties$6(we, _excluded$4);
  return _objectSpread2$2({
    key: me,
    value: je !== void 0 ? je : me,
    children: Re
  }, Ue);
}
function convertChildrenToData(ce) {
  var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return toArray$2(ce).map(function(me, we) {
    if (!/* @__PURE__ */ React.isValidElement(me) || !me.type)
      return null;
    var Re = me, je = Re.type.isSelectOptGroup, Ue = Re.key, qe = Re.props, Ge = qe.children, Xe = _objectWithoutProperties$6(qe, _excluded2);
    return ie || !je ? convertNodeToOption(me) : _objectSpread2$2(_objectSpread2$2({
      key: "__RC_SELECT_GRP__".concat(Ue === null ? we : Ue, "__"),
      label: Ue
    }, Xe), {}, {
      options: convertChildrenToData(Ge)
    });
  }).filter(function(me) {
    return me;
  });
}
var useOptions = function(ie, me, we, Re, je) {
  return React.useMemo(function() {
    var Ue = ie, qe = !ie;
    qe && (Ue = convertChildrenToData(me));
    var Ge = /* @__PURE__ */ new Map(), Xe = /* @__PURE__ */ new Map(), ot = function(Tt, wt, St) {
      St && typeof St == "string" && Tt.set(wt[St], wt);
    }, vt = function bt(Tt) {
      for (var wt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, St = 0; St < Tt.length; St += 1) {
        var It = Tt[St];
        !It[we.options] || wt ? (Ge.set(It[we.value], It), ot(Xe, It, we.label), ot(Xe, It, Re), ot(Xe, It, je)) : bt(It[we.options], !0);
      }
    };
    return vt(Ue), {
      options: Ue,
      valueOptions: Ge,
      labelOptions: Xe
    };
  }, [ie, me, we, Re, je]);
};
function useRefFunc(ce) {
  var ie = React.useRef();
  ie.current = ce;
  var me = React.useCallback(function() {
    return ie.current.apply(ie, arguments);
  }, []);
  return me;
}
function warningProps(ce) {
  var ie = ce.mode, me = ce.options, we = ce.children, Re = ce.backfill, je = ce.allowClear, Ue = ce.placeholder, qe = ce.getInputElement, Ge = ce.showSearch, Xe = ce.onSearch, ot = ce.defaultOpen, vt = ce.autoFocus, bt = ce.labelInValue, Tt = ce.value, wt = ce.inputValue, St = ce.optionLabelProp, It = isMultiple(ie), Pt = Ge !== void 0 ? Ge : It || ie === "combobox", kt = me || convertChildrenToData(we);
  if (warningOnce(ie !== "tags" || kt.every(function(nn) {
    return !nn.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), ie === "tags" || ie === "combobox") {
    var Ot = kt.some(function(nn) {
      return nn.options ? nn.options.some(function(ln) {
        return typeof ("value" in ln ? ln.value : ln.key) == "number";
      }) : typeof ("value" in nn ? nn.value : nn.key) == "number";
    });
    warningOnce(!Ot, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (warningOnce(ie !== "combobox" || !St, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), warningOnce(ie === "combobox" || !Re, "`backfill` only works with `combobox` mode."), warningOnce(ie === "combobox" || !qe, "`getInputElement` only work with `combobox` mode."), noteOnce(ie !== "combobox" || !qe || !je || !Ue, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), Xe && !Pt && ie !== "combobox" && ie !== "tags" && warningOnce(!1, "`onSearch` should work with `showSearch` instead of use alone."), noteOnce(!ot || vt, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), Tt != null) {
    var Jr = toArray(Tt);
    warningOnce(!bt || Jr.every(function(nn) {
      return _typeof$b(nn) === "object" && ("key" in nn || "value" in nn);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), warningOnce(!It || Array.isArray(Tt), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (we) {
    var en = null;
    toArray$2(we).some(function(nn) {
      if (!/* @__PURE__ */ React.isValidElement(nn) || !nn.type)
        return !1;
      var ln = nn, fn = ln.type;
      if (fn.isSelectOption)
        return !1;
      if (fn.isSelectOptGroup) {
        var vn = toArray$2(nn.props.children).every(function(Tn) {
          return !/* @__PURE__ */ React.isValidElement(Tn) || !nn.type || Tn.type.isSelectOption ? !0 : (en = Tn.type, !1);
        });
        return !vn;
      }
      return en = fn, !0;
    }), en && warningOnce(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(en.displayName || en.name || en, "`.")), warningOnce(wt === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function warningNullOptions(ce, ie) {
  if (ce) {
    var me = function we(Re) {
      for (var je = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Ue = 0; Ue < Re.length; Ue++) {
        var qe = Re[Ue];
        if (qe[ie == null ? void 0 : ie.value] === null)
          return warningOnce(!1, "`value` in Select options should not be `null`."), !0;
        if (!je && Array.isArray(qe[ie == null ? void 0 : ie.options]) && we(qe[ie == null ? void 0 : ie.options], !0))
          break;
      }
    };
    me(ce);
  }
}
var _excluded$3 = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], OMIT_DOM_PROPS = ["inputValue"];
function isRawValue(ce) {
  return !ce || _typeof$b(ce) !== "object";
}
var Select = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.id, we = ce.mode, Re = ce.prefixCls, je = Re === void 0 ? "rc-select" : Re, Ue = ce.backfill, qe = ce.fieldNames, Ge = ce.inputValue, Xe = ce.searchValue, ot = ce.onSearch, vt = ce.autoClearSearchValue, bt = vt === void 0 ? !0 : vt, Tt = ce.onSelect, wt = ce.onDeselect, St = ce.dropdownMatchSelectWidth, It = St === void 0 ? !0 : St, Pt = ce.filterOption, kt = ce.filterSort, Ot = ce.optionFilterProp, Jr = ce.optionLabelProp, en = ce.options, nn = ce.optionRender, ln = ce.children, fn = ce.defaultActiveFirstOption, vn = ce.menuItemSelectedIcon, Tn = ce.virtual, xn = ce.direction, bn = ce.listHeight, Sn = bn === void 0 ? 200 : bn, Cn = ce.listItemHeight, kn = Cn === void 0 ? 20 : Cn, cn = ce.labelRender, gn = ce.value, an = ce.defaultValue, un = ce.labelInValue, pn = ce.onChange, hn = ce.maxCount, An = _objectWithoutProperties$6(ce, _excluded$3), In = useId(me), qn = isMultiple(we), si = !!(!en && ln), bi = React.useMemo(function() {
    return Pt === void 0 && we === "combobox" ? !1 : Pt;
  }, [Pt, we]), xi = React.useMemo(
    function() {
      return fillFieldNames(qe, si);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(qe),
      si
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), ji = useMergedState("", {
    value: Xe !== void 0 ? Xe : Ge,
    postState: function(Ks) {
      return Ks || "";
    }
  }), zi = _slicedToArray$8(ji, 2), Vi = zi[0], Hi = zi[1], ii = useOptions(en, ln, xi, Ot, Jr), Fi = ii.valueOptions, ni = ii.labelOptions, Ui = ii.options, ja = React.useCallback(function(Ws) {
    var Ks = toArray(Ws);
    return Ks.map(function(Js) {
      var qs, ho, mn, ai, $i;
      if (isRawValue(Js))
        qs = Js;
      else {
        var Ha;
        mn = Js.key, ho = Js.label, qs = (Ha = Js.value) !== null && Ha !== void 0 ? Ha : mn;
      }
      var Va = Fi.get(qs);
      if (Va) {
        var Us;
        if (ho === void 0 && (ho = Va == null ? void 0 : Va[Jr || xi.label]), mn === void 0 && (mn = (Us = Va == null ? void 0 : Va.key) !== null && Us !== void 0 ? Us : qs), ai = Va == null ? void 0 : Va.disabled, $i = Va == null ? void 0 : Va.title, process.env.NODE_ENV !== "production" && !Jr) {
          var $s = Va == null ? void 0 : Va[xi.label];
          $s !== void 0 && !/* @__PURE__ */ React.isValidElement($s) && !/* @__PURE__ */ React.isValidElement(ho) && $s !== ho && warningOnce(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: ho,
        value: qs,
        key: mn,
        disabled: ai,
        title: $i
      };
    });
  }, [xi, Jr, Fi]), Ga = useMergedState(an, {
    value: gn
  }), Xa = _slicedToArray$8(Ga, 2), Ns = Xa[0], Ya = Xa[1], Qa = React.useMemo(function() {
    var Ws, Ks = qn && Ns === null ? [] : Ns, Js = ja(Ks);
    return we === "combobox" && isComboNoValue((Ws = Js[0]) === null || Ws === void 0 ? void 0 : Ws.value) ? [] : Js;
  }, [Ns, ja, we, qn]), Ja = useCache(Qa, Fi), Ms = _slicedToArray$8(Ja, 2), Hs = Ms[0], no = Ms[1], Qs = React.useMemo(function() {
    if (!we && Hs.length === 1) {
      var Ws = Hs[0];
      if (Ws.value === null && (Ws.label === null || Ws.label === void 0))
        return [];
    }
    return Hs.map(function(Ks) {
      var Js;
      return _objectSpread2$2(_objectSpread2$2({}, Ks), {}, {
        label: (Js = typeof cn == "function" ? cn(Ks) : Ks.label) !== null && Js !== void 0 ? Js : Ks.value
      });
    });
  }, [we, Hs, cn]), Zs = React.useMemo(function() {
    return new Set(Hs.map(function(Ws) {
      return Ws.value;
    }));
  }, [Hs]);
  React.useEffect(function() {
    if (we === "combobox") {
      var Ws, Ks = (Ws = Hs[0]) === null || Ws === void 0 ? void 0 : Ws.value;
      Hi(hasValue(Ks) ? String(Ks) : "");
    }
  }, [Hs]);
  var so = useRefFunc(function(Ws, Ks) {
    var Js = Ks ?? Ws;
    return _defineProperty$s(_defineProperty$s({}, xi.value, Ws), xi.label, Js);
  }), io = React.useMemo(function() {
    if (we !== "tags")
      return Ui;
    var Ws = _toConsumableArray$1(Ui), Ks = function(qs) {
      return Fi.has(qs);
    };
    return _toConsumableArray$1(Hs).sort(function(Js, qs) {
      return Js.value < qs.value ? -1 : 1;
    }).forEach(function(Js) {
      var qs = Js.value;
      Ks(qs) || Ws.push(so(qs, Js.label));
    }), Ws;
  }, [so, Ui, Fi, Hs, we]), dl = useFilterOptions(io, xi, Vi, bi, Ot), vl = React.useMemo(function() {
    return we !== "tags" || !Vi || dl.some(function(Ws) {
      return Ws[Ot || "value"] === Vi;
    }) || dl.some(function(Ws) {
      return Ws[xi.value] === Vi;
    }) ? dl : [so(Vi)].concat(_toConsumableArray$1(dl));
  }, [so, Ot, we, dl, Vi, xi]), lo = function Ws(Ks) {
    var Js = _toConsumableArray$1(Ks).sort(function(qs, ho) {
      return kt(qs, ho, {
        searchValue: Vi
      });
    });
    return Js.map(function(qs) {
      return Array.isArray(qs.options) ? _objectSpread2$2(_objectSpread2$2({}, qs), {}, {
        options: qs.options.length > 0 ? Ws(qs.options) : qs.options
      }) : qs;
    });
  }, yl = React.useMemo(function() {
    return kt ? lo(vl) : vl;
  }, [vl, kt, Vi]), bl = React.useMemo(function() {
    return flattenOptions(yl, {
      fieldNames: xi,
      childrenAsData: si
    });
  }, [yl, xi, si]), Al = function(Ks) {
    var Js = ja(Ks);
    if (Ya(Js), pn && // Trigger event only when value changed
    (Js.length !== Hs.length || Js.some(function(mn, ai) {
      var $i;
      return (($i = Hs[ai]) === null || $i === void 0 ? void 0 : $i.value) !== (mn == null ? void 0 : mn.value);
    }))) {
      var qs = un ? Js : Js.map(function(mn) {
        return mn.value;
      }), ho = Js.map(function(mn) {
        return injectPropsWithOption(no(mn.value));
      });
      pn(
        // Value
        qn ? qs : qs[0],
        // Option
        qn ? ho : ho[0]
      );
    }
  }, Xl = React.useState(null), $l = _slicedToArray$8(Xl, 2), Bl = $l[0], Fl = $l[1], kl = React.useState(0), ql = _slicedToArray$8(kl, 2), _l = ql[0], Ol = ql[1], Ll = fn !== void 0 ? fn : we !== "combobox", Ql = React.useCallback(function(Ws, Ks) {
    var Js = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, qs = Js.source, ho = qs === void 0 ? "keyboard" : qs;
    Ol(Ks), Ue && we === "combobox" && Ws !== null && ho === "keyboard" && Fl(String(Ws));
  }, [Ue, we]), wl = function(Ks, Js, qs) {
    var ho = function() {
      var Ys, Bs = no(Ks);
      return [un ? {
        label: Bs == null ? void 0 : Bs[xi.label],
        value: Ks,
        key: (Ys = Bs == null ? void 0 : Bs.key) !== null && Ys !== void 0 ? Ys : Ks
      } : Ks, injectPropsWithOption(Bs)];
    };
    if (Js && Tt) {
      var mn = ho(), ai = _slicedToArray$8(mn, 2), $i = ai[0], Ha = ai[1];
      Tt($i, Ha);
    } else if (!Js && wt && qs !== "clear") {
      var Va = ho(), Us = _slicedToArray$8(Va, 2), $s = Us[0], Za = Us[1];
      wt($s, Za);
    }
  }, to = useRefFunc(function(Ws, Ks) {
    var Js, qs = qn ? Ks.selected : !0;
    qs ? Js = qn ? [].concat(_toConsumableArray$1(Hs), [Ws]) : [Ws] : Js = Hs.filter(function(ho) {
      return ho.value !== Ws;
    }), Al(Js), wl(Ws, qs), we === "combobox" ? Fl("") : (!isMultiple || bt) && (Hi(""), Fl(""));
  }), zs = function(Ks, Js) {
    Al(Ks);
    var qs = Js.type, ho = Js.values;
    (qs === "remove" || qs === "clear") && ho.forEach(function(mn) {
      wl(mn.value, !1, qs);
    });
  }, Gs = function(Ks, Js) {
    if (Hi(Ks), Fl(null), Js.source === "submit") {
      var qs = (Ks || "").trim();
      if (qs) {
        var ho = Array.from(new Set([].concat(_toConsumableArray$1(Zs), [qs])));
        Al(ho), wl(qs, !0), Hi("");
      }
      return;
    }
    Js.source !== "blur" && (we === "combobox" && Al(Ks), ot == null || ot(Ks));
  }, Pl = function(Ks) {
    var Js = Ks;
    we !== "tags" && (Js = Ks.map(function(ho) {
      var mn = ni.get(ho);
      return mn == null ? void 0 : mn.value;
    }).filter(function(ho) {
      return ho !== void 0;
    }));
    var qs = Array.from(new Set([].concat(_toConsumableArray$1(Zs), _toConsumableArray$1(Js))));
    Al(qs), qs.forEach(function(ho) {
      wl(ho, !0);
    });
  }, Ml = React.useMemo(function() {
    var Ws = Tn !== !1 && It !== !1;
    return _objectSpread2$2(_objectSpread2$2({}, ii), {}, {
      flattenOptions: bl,
      onActiveValue: Ql,
      defaultActiveFirstOption: Ll,
      onSelect: to,
      menuItemSelectedIcon: vn,
      rawValues: Zs,
      fieldNames: xi,
      virtual: Ws,
      direction: xn,
      listHeight: Sn,
      listItemHeight: kn,
      childrenAsData: si,
      maxCount: hn,
      optionRender: nn
    });
  }, [hn, ii, bl, Ql, Ll, to, vn, Zs, xi, Tn, It, xn, Sn, kn, si, nn]);
  return process.env.NODE_ENV !== "production" && (warningProps(ce), warningNullOptions(Ui, xi)), /* @__PURE__ */ React.createElement(SelectContext.Provider, {
    value: Ml
  }, /* @__PURE__ */ React.createElement(BaseSelect, _extends$j({}, An, {
    // >>> MISC
    id: In,
    prefixCls: je,
    ref: ie,
    omitDomProps: OMIT_DOM_PROPS,
    mode: we,
    displayValues: Qs,
    onDisplayValuesChange: zs,
    direction: xn,
    searchValue: Vi,
    onSearch: Gs,
    autoClearSearchValue: bt,
    onSearchSplit: Pl,
    dropdownMatchSelectWidth: It,
    OptionList: RefOptionList,
    emptyOptions: !bl.length,
    activeValue: Bl,
    activeDescendantId: "".concat(In, "_list_").concat(_l)
  })));
});
process.env.NODE_ENV !== "production" && (Select.displayName = "Select");
var TypedSelect = Select;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;
const CustomSelect = (ce) => {
  var je;
  const ie = (je = ce.containerRef) == null ? void 0 : je.current, me = "values" in ce && ce.values.length > 0, we = "options" in ce && ce.options.length > 0, Re = ce.disabled || !me && !we;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    TypedSelect,
    {
      disabled: Re,
      id: "my-select",
      optionLabelProp: "children",
      optionFilterProp: "text",
      className: classNames("custom-select", {
        "custom-select--disabled": Re,
        "w-full": ce.fullWidth
      }),
      showSearch: !1,
      suffixIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faChevronDown }),
      value: ce.defaultValue,
      onChange: ce.onChange,
      menuItemSelectedIcon: null,
      dropdownStyle: { position: "relative" },
      loading: ce.loading,
      ref: ce.ref,
      getPopupContainer: ie ? () => ie : void 0,
      children: [
        "options" in ce && ce.options.map((Ue) => /* @__PURE__ */ jsxRuntimeExports.jsx(Option, { value: Ue.value, children: Ue.label }, Ue.value)),
        "values" in ce && ce.values.map((Ue) => /* @__PURE__ */ jsxRuntimeExports.jsx(Option, { value: Ue, children: ce.labelRenderFn(Ue) }, Ue))
      ]
    }
  );
}, DefaultErrorOverlay = ({
  children: ce,
  title: ie,
  description: me,
  error: we = !0
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "default-error-overlay", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    FontAwesomeIcon,
    {
      icon: we ? faExclamationCircle : faCheckCircle,
      className: classNames("default-error-overlay__icon", {
        "default-error-overlay__icon--success": !we
      })
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text,
    {
      className: classNames("default-error-overlay__h1", {
        "default-error-overlay__h1--success": !we
      }),
      children: ie
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "default-error-overlay__detail", children: me }),
  ce
] }), EmptyState = ({ icon: ce, title: ie, description: me, button: we }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center justify-center self-center max-w-max mt-6 mb-6", children: [
  ce && /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ce, className: "mx-auto h-12 w-12 text-text" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "mt-2 text-2xl font-semibold text-text", children: ie }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-4 text-sm font-normal text-text-muted", children: me }),
  we && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-6 flex justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: we.action, variant: ButtonVariant.PRIMARY, children: we.label }) })
] }), FullScreenLoader = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute h-full w-full flex items-center justify-center bg-surface", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderThreeDots, {}) }), GreenInformationBox = ({ title: ce, titleIcon: ie, content: me, className: we }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames("green-information-box", we), children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "green-information-box__title", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "green-information-box__title-icon", icon: ie }),
    ce
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: me })
] }), Header = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full h-10 shrink-0 justify-between items-center border-b border-stroke border-solid px-4 text--semibold text--xs bg-surface text-text", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ce.title }),
  ce.action && ce.action
] }), Label = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full h-6 px-4 py-1 justify-between items-center text-text text--semibold text--xs", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ce.label }),
  ce.action && ce.action
] }), shiftKeyMultiple = 10, useDragToAdjustNumbericValue = (ce, ie, me, we, Re) => {
  const [je, Ue] = useState({ x: 0, y: 0 }), [qe, Ge] = useState(0), [Xe, ot] = useState(0), [vt, bt] = useState(0), Tt = (It) => {
    It.preventDefault();
    const Pt = ie;
    if (!Pt)
      return;
    Ue({ x: It.pageX, y: It.pageY });
    const kt = parseFloat(Pt);
    Ge(kt), It.shiftKey && ot(1), bt(1);
  }, wt = (It) => {
    switch (vt) {
      // check for drag position
      case 1:
        Math.abs(je.y - It.pageY) > 10 ? St() : Math.abs(It.pageX - je.x) && bt(2);
        break;
      // change input value.
      case 2:
        const Pt = qe + (It.pageX - je.x) * (Xe ? shiftKeyMultiple : 1);
        if (we !== void 0 && Pt < we) {
          me(we);
          return;
        }
        if (Re !== void 0 && Pt > Re) {
          me(Re);
          return;
        }
        me(Pt);
        break;
    }
  }, St = () => {
    Ue({ x: 0, y: 0 }), Ge(0), ot(0), bt(0), document.body.style.cssText = "";
  };
  useEffect(() => (ce.current && (vt > 0 && document.addEventListener("mousemove", wt), ce.current.addEventListener("mousedown", Tt), document.addEventListener("mouseup", St)), () => {
    document.removeEventListener("mouseup", St), document.removeEventListener("mousemove", wt), ce.current && ce.current.removeEventListener("mousedown", Tt);
  }), [vt]);
}, isNumberWithinLimits = (ce, ie, me) => !(ie !== void 0 && ce < ie || me !== void 0 && ce > me), NUMBER_REGEX = /[^0-9]-/gim, NumberInput = ({
  value: ce,
  onChange: ie,
  disabled: me,
  className: we,
  inputClassName: Re,
  min: je,
  max: Ue,
  prefixComponent: qe,
  suffixComponent: Ge
}) => {
  const Xe = useRef(null), [ot, vt] = useState(!1), [bt, Tt] = useState(!1), [wt, St] = React__default.useState(ce), It = (kt) => {
    if (!ie)
      return;
    const Ot = kt.replace(NUMBER_REGEX, ""), Jr = parseInt(Ot, 10);
    if (St(isNaN(Jr) ? Ot === "-" ? "-" : "" : Jr), isNumberWithinLimits(Jr, je, Ue) && !isNaN(Jr) && isFinite(Jr)) {
      vt(!1), ie(Jr);
      return;
    }
    vt(!0);
  }, Pt = () => {
    ot && (St(ce), vt(!1));
  };
  return useDragToAdjustNumbericValue(
    Xe,
    ce.toString(),
    (kt) => It(kt.toString()),
    je,
    Ue
  ), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classNames(
        "w-fit flex text-xs text-text border-1 border-solid  bg-surface rounded-1 overflow-hidden [transition:border_0.2s_ease]",
        {
          "border-stroke": !bt && !ot && !me,
          "opacity-50 cursor-default pointer-events-none text-grey-600": me,
          "border-red-500 hover:border-red-500 focus:border-red-500 active:border-red-500": ot,
          "border-accent hover:border-accent": bt && !ot,
          "hover:border-grey-500 active:border-accent": !ot && !bt
        },
        we
      ),
      children: [
        !!qe && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Xe, className: "bg-surface px-1.5 flex justify items-center cursor-ew-resize", children: qe }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            type: "text",
            className: classNames(
              "bg-background w-10 p-1.5 text-center border-solid border-l border-r border-stroke outline-none",
              Re
            ),
            onFocus: () => Tt(!0),
            value: wt,
            onChange: (kt) => It(kt.currentTarget.value),
            min: je,
            max: Ue,
            onBlur: () => {
              Pt(), Tt(!1);
            }
          }
        ),
        !!Ge && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-surface px-1 flex justify items-center select-none text-text-muted", children: Ge })
      ]
    }
  );
};
var AlignType = /* @__PURE__ */ ((ce) => (ce.TopRight = "TopRight", ce.TopLeft = "TopLeft", ce.BottomRight = "BottomRight", ce))(AlignType || {});
const OptionsMenu = ({
  children: ce,
  align: ie = "TopLeft",
  relativePosition: me = !1,
  onClose: we
}) => {
  const Re = React__default.useRef(null);
  useClickOut(!0, Re, we);
  const je = React__default.useMemo(() => ({ closeOptionsMenu: we }), [we]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsMenuContext.Provider, { value: je, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "options-menu__wrapper", ref: Re, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(
        "options-menu",
        {
          "options-menu--align-top-left": ie === "TopLeft"
          /* TopLeft */
        },
        {
          "options-menu--align-top-right": ie === "TopRight"
          /* TopRight */
        },
        {
          "options-menu--align-bottom-right": ie === "BottomRight"
          /* BottomRight */
        },
        { absolute: !me },
        { relative: me }
      ),
      children: ce
    }
  ) }) });
};
OptionsMenu.OptionsMenuItem = OptionsMenuItem;
OptionsMenu.OptionsMenuDivider = OptionsMenuDivider;
const StatusToColors = {
  default: {
    tile: "group/optionTile border-transparent cursor-pointer bg-surface hover:bg-surface-elevated hover:border-stroke",
    icon: "text-text group-hover/optionTile:text-text",
    text: "cursor-pointer text-text group-hover/optionTile:text-text",
    description: "cursor-pointer text-text group-hover/optionTile:text-text"
  },
  active: {
    tile: "border-stroke bg-surface",
    icon: "text-accent",
    text: "cursor-default text-accent",
    description: "cursor-default text-accent"
  }
}, OptionTile = (ce) => {
  const ie = ce.active ? "active" : "default";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: classNames("flex border border-solid rounded p-3 gap-3", StatusToColors[ie].tile),
      onClick: ce.onClick,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("flex h-6 justify-center items-center shrink-0", StatusToColors[ie].icon), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ce.icon, className: "h-3" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col grow-1 shrink-0 basis-0", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("text--semibold text-s ", StatusToColors[ie].text), children: ce.text }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("text--semibold text-xs", StatusToColors[ie].description), children: ce.description })
        ] })
      ]
    }
  );
}, useKeyPress = ({
  targetKeyCodes: ce,
  ignoreInput: ie,
  onKeyUp: me,
  onKeyDown: we
}) => {
  const [Re, je] = useState(!1), Ue = useCallback(
    (Ge) => {
      if (ce.includes(Ge.code)) {
        const Xe = Ge.target;
        if (!ie && Xe.nodeName.toLowerCase() === "input")
          return;
        je(!0), we && we();
      }
    },
    [ie, ce, we]
  ), qe = useCallback(
    (Ge) => {
      if (ce.includes(Ge.code)) {
        const Xe = Ge.target;
        if (!ie && Xe.nodeName.toLowerCase() === "input")
          return;
        je(!1), me && me();
      }
    },
    [ce, ie, me]
  );
  return useEffect(() => (window.addEventListener("keydown", Ue), window.addEventListener("keyup", qe), () => {
    window.removeEventListener("keydown", Ue), window.removeEventListener("keyup", qe);
  }), [Ue, qe]), Re;
}, PREVIOUS_KEY_CODES = ["ArrowLeft", "PageUp"], NEXT_KEY_CODES = ["ArrowRight", "PageDown"], NavigationBarInternal$1 = forwardRef(
  ({ children: ce, progressDisabled: ie, onFinish: me, goToNext: we, goToPrevious: Re, ...je }, Ue) => {
    const qe = React__default.useCallback(() => {
      ie || (me ? me() : we && we());
    }, [we, me, ie]);
    return useKeyPress({ targetKeyCodes: PREVIOUS_KEY_CODES, onKeyDown: Re }), useKeyPress({ targetKeyCodes: NEXT_KEY_CODES, onKeyDown: qe }), /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationBar, { ref: Ue, ...je, children: typeof ce == "function" ? ce(je.autoProgressStarted ?? !1) : ce });
  }
), StudentNavigationBar = {
  ...NavigationBarInternal$1,
  ButtonBox: NavigationBar.ButtonBox,
  Button: NavigationButton
}, NavigationBarInternal = forwardRef(
  ({ children: ce, ...ie }, me) => /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationBar, { ref: me, ...ie, children: ce })
), ManagerNavigationBar = {
  ...NavigationBarInternal,
  ButtonBox: NavigationBar.ButtonBox,
  Button: NavigationButton
};
var lib = {}, slider = {}, innerSlider = {}, initialState = {};
(function(ce) {
  Object.defineProperty(ce, "__esModule", {
    value: !0
  }), ce.default = void 0;
  var ie = {
    animating: !1,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: !1,
    edgeDragged: !1,
    initialized: !1,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: !1,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: !1,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: !1,
    touchObject: {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
  };
  ce.default = ie;
})(initialState);
var FUNC_ERROR_TEXT = "Expected a function", NAN = NaN, symbolTag = "[object Symbol]", reTrim = /^\s+|\s+$/g, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt, freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")(), objectProto = Object.prototype, objectToString = objectProto.toString, nativeMax = Math.max, nativeMin = Math.min, now = function() {
  return root.Date.now();
};
function debounce(ce, ie, me) {
  var we, Re, je, Ue, qe, Ge, Xe = 0, ot = !1, vt = !1, bt = !0;
  if (typeof ce != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  ie = toNumber(ie) || 0, isObject(me) && (ot = !!me.leading, vt = "maxWait" in me, je = vt ? nativeMax(toNumber(me.maxWait) || 0, ie) : je, bt = "trailing" in me ? !!me.trailing : bt);
  function Tt(nn) {
    var ln = we, fn = Re;
    return we = Re = void 0, Xe = nn, Ue = ce.apply(fn, ln), Ue;
  }
  function wt(nn) {
    return Xe = nn, qe = setTimeout(Pt, ie), ot ? Tt(nn) : Ue;
  }
  function St(nn) {
    var ln = nn - Ge, fn = nn - Xe, vn = ie - ln;
    return vt ? nativeMin(vn, je - fn) : vn;
  }
  function It(nn) {
    var ln = nn - Ge, fn = nn - Xe;
    return Ge === void 0 || ln >= ie || ln < 0 || vt && fn >= je;
  }
  function Pt() {
    var nn = now();
    if (It(nn))
      return kt(nn);
    qe = setTimeout(Pt, St(nn));
  }
  function kt(nn) {
    return qe = void 0, bt && we ? Tt(nn) : (we = Re = void 0, Ue);
  }
  function Ot() {
    qe !== void 0 && clearTimeout(qe), Xe = 0, we = Ge = Re = qe = void 0;
  }
  function Jr() {
    return qe === void 0 ? Ue : kt(now());
  }
  function en() {
    var nn = now(), ln = It(nn);
    if (we = arguments, Re = this, Ge = nn, ln) {
      if (qe === void 0)
        return wt(Ge);
      if (vt)
        return qe = setTimeout(Pt, ie), Tt(Ge);
    }
    return qe === void 0 && (qe = setTimeout(Pt, ie)), Ue;
  }
  return en.cancel = Ot, en.flush = Jr, en;
}
function isObject(ce) {
  var ie = typeof ce;
  return !!ce && (ie == "object" || ie == "function");
}
function isObjectLike(ce) {
  return !!ce && typeof ce == "object";
}
function isSymbol(ce) {
  return typeof ce == "symbol" || isObjectLike(ce) && objectToString.call(ce) == symbolTag;
}
function toNumber(ce) {
  if (typeof ce == "number")
    return ce;
  if (isSymbol(ce))
    return NAN;
  if (isObject(ce)) {
    var ie = typeof ce.valueOf == "function" ? ce.valueOf() : ce;
    ce = isObject(ie) ? ie + "" : ie;
  }
  if (typeof ce != "string")
    return ce === 0 ? ce : +ce;
  ce = ce.replace(reTrim, "");
  var me = reIsBinary.test(ce);
  return me || reIsOctal.test(ce) ? freeParseInt(ce.slice(2), me ? 2 : 8) : reIsBadHex.test(ce) ? NAN : +ce;
}
var lodash_debounce = debounce, innerSliderUtils = {}, defaultProps = {};
(function(ce) {
  Object.defineProperty(ce, "__esModule", {
    value: !0
  }), ce.default = void 0;
  var ie = me(React__default);
  function me(Re) {
    return Re && Re.__esModule ? Re : { default: Re };
  }
  var we = {
    accessibility: !0,
    adaptiveHeight: !1,
    afterChange: null,
    appendDots: function(je) {
      return /* @__PURE__ */ ie.default.createElement("ul", {
        style: {
          display: "block"
        }
      }, je);
    },
    arrows: !0,
    autoplay: !1,
    autoplaySpeed: 3e3,
    beforeChange: null,
    centerMode: !1,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function(je) {
      return /* @__PURE__ */ ie.default.createElement("button", null, je + 1);
    },
    dots: !1,
    dotsClass: "slick-dots",
    draggable: !0,
    easing: "linear",
    edgeFriction: 0.35,
    fade: !1,
    focusOnSelect: !1,
    infinite: !0,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !0,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: !1,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: !0,
    swipeEvent: null,
    swipeToSlide: !1,
    touchMove: !0,
    touchThreshold: 5,
    useCSS: !0,
    useTransform: !0,
    variableWidth: !1,
    vertical: !1,
    waitForAnimate: !0,
    asNavFor: null,
    unslick: !1
  };
  ce.default = we;
})(defaultProps);
Object.defineProperty(innerSliderUtils, "__esModule", {
  value: !0
});
innerSliderUtils.checkSpecKeys = innerSliderUtils.checkNavigable = innerSliderUtils.changeSlide = innerSliderUtils.canUseDOM = innerSliderUtils.canGoNext = void 0;
innerSliderUtils.clamp = clamp;
innerSliderUtils.extractObject = void 0;
innerSliderUtils.filterSettings = filterSettings;
innerSliderUtils.validSettings = innerSliderUtils.swipeStart = innerSliderUtils.swipeMove = innerSliderUtils.swipeEnd = innerSliderUtils.slidesOnRight = innerSliderUtils.slidesOnLeft = innerSliderUtils.slideHandler = innerSliderUtils.siblingDirection = innerSliderUtils.safePreventDefault = innerSliderUtils.lazyStartIndex = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.keyHandler = innerSliderUtils.initializedState = innerSliderUtils.getWidth = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackCSS = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTotalSlides = innerSliderUtils.getSwipeDirection = innerSliderUtils.getSlideCount = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getPreClones = innerSliderUtils.getPostClones = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.getNavigableIndexes = innerSliderUtils.getHeight = void 0;
var _react$4 = _interopRequireDefault$4(React__default), _defaultProps = _interopRequireDefault$4(defaultProps);
function _interopRequireDefault$4(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _typeof$5(ce) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$5(ce);
}
function ownKeys$6(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$4(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$6(Object(me), !0).forEach(function(we) {
      _defineProperty$6(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$6(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$6(ce, ie, me) {
  return ie = _toPropertyKey$5(ie), ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _toPropertyKey$5(ce) {
  var ie = _toPrimitive$5(ce, "string");
  return _typeof$5(ie) == "symbol" ? ie : String(ie);
}
function _toPrimitive$5(ce, ie) {
  if (_typeof$5(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$5(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ie === "string" ? String : Number)(ce);
}
function clamp(ce, ie, me) {
  return Math.max(ie, Math.min(ce, me));
}
var safePreventDefault = innerSliderUtils.safePreventDefault = function(ie) {
  var me = ["onTouchStart", "onTouchMove", "onWheel"];
  me.includes(ie._reactName) || ie.preventDefault();
}, getOnDemandLazySlides = innerSliderUtils.getOnDemandLazySlides = function(ie) {
  for (var me = [], we = lazyStartIndex(ie), Re = lazyEndIndex(ie), je = we; je < Re; je++)
    ie.lazyLoadedList.indexOf(je) < 0 && me.push(je);
  return me;
};
innerSliderUtils.getRequiredLazySlides = function(ie) {
  for (var me = [], we = lazyStartIndex(ie), Re = lazyEndIndex(ie), je = we; je < Re; je++)
    me.push(je);
  return me;
};
var lazyStartIndex = innerSliderUtils.lazyStartIndex = function(ie) {
  return ie.currentSlide - lazySlidesOnLeft(ie);
}, lazyEndIndex = innerSliderUtils.lazyEndIndex = function(ie) {
  return ie.currentSlide + lazySlidesOnRight(ie);
}, lazySlidesOnLeft = innerSliderUtils.lazySlidesOnLeft = function(ie) {
  return ie.centerMode ? Math.floor(ie.slidesToShow / 2) + (parseInt(ie.centerPadding) > 0 ? 1 : 0) : 0;
}, lazySlidesOnRight = innerSliderUtils.lazySlidesOnRight = function(ie) {
  return ie.centerMode ? Math.floor((ie.slidesToShow - 1) / 2) + 1 + (parseInt(ie.centerPadding) > 0 ? 1 : 0) : ie.slidesToShow;
}, getWidth = innerSliderUtils.getWidth = function(ie) {
  return ie && ie.offsetWidth || 0;
}, getHeight = innerSliderUtils.getHeight = function(ie) {
  return ie && ie.offsetHeight || 0;
}, getSwipeDirection = innerSliderUtils.getSwipeDirection = function(ie) {
  var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, we, Re, je, Ue;
  return we = ie.startX - ie.curX, Re = ie.startY - ie.curY, je = Math.atan2(Re, we), Ue = Math.round(je * 180 / Math.PI), Ue < 0 && (Ue = 360 - Math.abs(Ue)), Ue <= 45 && Ue >= 0 || Ue <= 360 && Ue >= 315 ? "left" : Ue >= 135 && Ue <= 225 ? "right" : me === !0 ? Ue >= 35 && Ue <= 135 ? "up" : "down" : "vertical";
}, canGoNext = innerSliderUtils.canGoNext = function(ie) {
  var me = !0;
  return ie.infinite || (ie.centerMode && ie.currentSlide >= ie.slideCount - 1 || ie.slideCount <= ie.slidesToShow || ie.currentSlide >= ie.slideCount - ie.slidesToShow) && (me = !1), me;
};
innerSliderUtils.extractObject = function(ie, me) {
  var we = {};
  return me.forEach(function(Re) {
    return we[Re] = ie[Re];
  }), we;
};
innerSliderUtils.initializedState = function(ie) {
  var me = _react$4.default.Children.count(ie.children), we = ie.listRef, Re = Math.ceil(getWidth(we)), je = ie.trackRef && ie.trackRef.node, Ue = Math.ceil(getWidth(je)), qe;
  if (ie.vertical)
    qe = Re;
  else {
    var Ge = ie.centerMode && parseInt(ie.centerPadding) * 2;
    typeof ie.centerPadding == "string" && ie.centerPadding.slice(-1) === "%" && (Ge *= Re / 100), qe = Math.ceil((Re - Ge) / ie.slidesToShow);
  }
  var Xe = we && getHeight(we.querySelector('[data-index="0"]')), ot = Xe * ie.slidesToShow, vt = ie.currentSlide === void 0 ? ie.initialSlide : ie.currentSlide;
  ie.rtl && ie.currentSlide === void 0 && (vt = me - 1 - ie.initialSlide);
  var bt = ie.lazyLoadedList || [], Tt = getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, ie), {}, {
    currentSlide: vt,
    lazyLoadedList: bt
  }));
  bt = bt.concat(Tt);
  var wt = {
    slideCount: me,
    slideWidth: qe,
    listWidth: Re,
    trackWidth: Ue,
    currentSlide: vt,
    slideHeight: Xe,
    listHeight: ot,
    lazyLoadedList: bt
  };
  return ie.autoplaying === null && ie.autoplay && (wt.autoplaying = "playing"), wt;
};
innerSliderUtils.slideHandler = function(ie) {
  var me = ie.waitForAnimate, we = ie.animating, Re = ie.fade, je = ie.infinite, Ue = ie.index, qe = ie.slideCount, Ge = ie.lazyLoad, Xe = ie.currentSlide, ot = ie.centerMode, vt = ie.slidesToScroll, bt = ie.slidesToShow, Tt = ie.useCSS, wt = ie.lazyLoadedList;
  if (me && we) return {};
  var St = Ue, It, Pt, kt, Ot = {}, Jr = {}, en = je ? Ue : clamp(Ue, 0, qe - 1);
  if (Re) {
    if (!je && (Ue < 0 || Ue >= qe)) return {};
    Ue < 0 ? St = Ue + qe : Ue >= qe && (St = Ue - qe), Ge && wt.indexOf(St) < 0 && (wt = wt.concat(St)), Ot = {
      animating: !0,
      currentSlide: St,
      lazyLoadedList: wt,
      targetSlide: St
    }, Jr = {
      animating: !1,
      targetSlide: St
    };
  } else
    It = St, St < 0 ? (It = St + qe, je ? qe % vt !== 0 && (It = qe - qe % vt) : It = 0) : !canGoNext(ie) && St > Xe ? St = It = Xe : ot && St >= qe ? (St = je ? qe : qe - 1, It = je ? 0 : qe - 1) : St >= qe && (It = St - qe, je ? qe % vt !== 0 && (It = 0) : It = qe - bt), !je && St + bt >= qe && (It = qe - bt), Pt = getTrackLeft(_objectSpread$4(_objectSpread$4({}, ie), {}, {
      slideIndex: St
    })), kt = getTrackLeft(_objectSpread$4(_objectSpread$4({}, ie), {}, {
      slideIndex: It
    })), je || (Pt === kt && (St = It), Pt = kt), Ge && (wt = wt.concat(getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, ie), {}, {
      currentSlide: St
    })))), Tt ? (Ot = {
      animating: !0,
      currentSlide: It,
      trackStyle: getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, ie), {}, {
        left: Pt
      })),
      lazyLoadedList: wt,
      targetSlide: en
    }, Jr = {
      animating: !1,
      currentSlide: It,
      trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, ie), {}, {
        left: kt
      })),
      swipeLeft: null,
      targetSlide: en
    }) : Ot = {
      currentSlide: It,
      trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, ie), {}, {
        left: kt
      })),
      lazyLoadedList: wt,
      targetSlide: en
    };
  return {
    state: Ot,
    nextState: Jr
  };
};
innerSliderUtils.changeSlide = function(ie, me) {
  var we, Re, je, Ue, qe, Ge = ie.slidesToScroll, Xe = ie.slidesToShow, ot = ie.slideCount, vt = ie.currentSlide, bt = ie.targetSlide, Tt = ie.lazyLoad, wt = ie.infinite;
  if (Ue = ot % Ge !== 0, we = Ue ? 0 : (ot - vt) % Ge, me.message === "previous")
    je = we === 0 ? Ge : Xe - we, qe = vt - je, Tt && !wt && (Re = vt - je, qe = Re === -1 ? ot - 1 : Re), wt || (qe = bt - Ge);
  else if (me.message === "next")
    je = we === 0 ? Ge : we, qe = vt + je, Tt && !wt && (qe = (vt + Ge) % ot + we), wt || (qe = bt + Ge);
  else if (me.message === "dots")
    qe = me.index * me.slidesToScroll;
  else if (me.message === "children") {
    if (qe = me.index, wt) {
      var St = siblingDirection(_objectSpread$4(_objectSpread$4({}, ie), {}, {
        targetSlide: qe
      }));
      qe > me.currentSlide && St === "left" ? qe = qe - ot : qe < me.currentSlide && St === "right" && (qe = qe + ot);
    }
  } else me.message === "index" && (qe = Number(me.index));
  return qe;
};
innerSliderUtils.keyHandler = function(ie, me, we) {
  return ie.target.tagName.match("TEXTAREA|INPUT|SELECT") || !me ? "" : ie.keyCode === 37 ? we ? "next" : "previous" : ie.keyCode === 39 ? we ? "previous" : "next" : "";
};
innerSliderUtils.swipeStart = function(ie, me, we) {
  return ie.target.tagName === "IMG" && safePreventDefault(ie), !me || !we && ie.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: ie.touches ? ie.touches[0].pageX : ie.clientX,
      startY: ie.touches ? ie.touches[0].pageY : ie.clientY,
      curX: ie.touches ? ie.touches[0].pageX : ie.clientX,
      curY: ie.touches ? ie.touches[0].pageY : ie.clientY
    }
  };
};
innerSliderUtils.swipeMove = function(ie, me) {
  var we = me.scrolling, Re = me.animating, je = me.vertical, Ue = me.swipeToSlide, qe = me.verticalSwiping, Ge = me.rtl, Xe = me.currentSlide, ot = me.edgeFriction, vt = me.edgeDragged, bt = me.onEdge, Tt = me.swiped, wt = me.swiping, St = me.slideCount, It = me.slidesToScroll, Pt = me.infinite, kt = me.touchObject, Ot = me.swipeEvent, Jr = me.listHeight, en = me.listWidth;
  if (!we) {
    if (Re) return safePreventDefault(ie);
    je && Ue && qe && safePreventDefault(ie);
    var nn, ln = {}, fn = getTrackLeft(me);
    kt.curX = ie.touches ? ie.touches[0].pageX : ie.clientX, kt.curY = ie.touches ? ie.touches[0].pageY : ie.clientY, kt.swipeLength = Math.round(Math.sqrt(Math.pow(kt.curX - kt.startX, 2)));
    var vn = Math.round(Math.sqrt(Math.pow(kt.curY - kt.startY, 2)));
    if (!qe && !wt && vn > 10)
      return {
        scrolling: !0
      };
    qe && (kt.swipeLength = vn);
    var Tn = (Ge ? -1 : 1) * (kt.curX > kt.startX ? 1 : -1);
    qe && (Tn = kt.curY > kt.startY ? 1 : -1);
    var xn = Math.ceil(St / It), bn = getSwipeDirection(me.touchObject, qe), Sn = kt.swipeLength;
    return Pt || (Xe === 0 && (bn === "right" || bn === "down") || Xe + 1 >= xn && (bn === "left" || bn === "up") || !canGoNext(me) && (bn === "left" || bn === "up")) && (Sn = kt.swipeLength * ot, vt === !1 && bt && (bt(bn), ln.edgeDragged = !0)), !Tt && Ot && (Ot(bn), ln.swiped = !0), je ? nn = fn + Sn * (Jr / en) * Tn : Ge ? nn = fn - Sn * Tn : nn = fn + Sn * Tn, qe && (nn = fn + Sn * Tn), ln = _objectSpread$4(_objectSpread$4({}, ln), {}, {
      touchObject: kt,
      swipeLeft: nn,
      trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, me), {}, {
        left: nn
      }))
    }), Math.abs(kt.curX - kt.startX) < Math.abs(kt.curY - kt.startY) * 0.8 || kt.swipeLength > 10 && (ln.swiping = !0, safePreventDefault(ie)), ln;
  }
};
innerSliderUtils.swipeEnd = function(ie, me) {
  var we = me.dragging, Re = me.swipe, je = me.touchObject, Ue = me.listWidth, qe = me.touchThreshold, Ge = me.verticalSwiping, Xe = me.listHeight, ot = me.swipeToSlide, vt = me.scrolling, bt = me.onSwipe, Tt = me.targetSlide, wt = me.currentSlide, St = me.infinite;
  if (!we)
    return Re && safePreventDefault(ie), {};
  var It = Ge ? Xe / qe : Ue / qe, Pt = getSwipeDirection(je, Ge), kt = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (vt || !je.swipeLength)
    return kt;
  if (je.swipeLength > It) {
    safePreventDefault(ie), bt && bt(Pt);
    var Ot, Jr, en = St ? wt : Tt;
    switch (Pt) {
      case "left":
      case "up":
        Jr = en + getSlideCount(me), Ot = ot ? checkNavigable(me, Jr) : Jr, kt.currentDirection = 0;
        break;
      case "right":
      case "down":
        Jr = en - getSlideCount(me), Ot = ot ? checkNavigable(me, Jr) : Jr, kt.currentDirection = 1;
        break;
      default:
        Ot = en;
    }
    kt.triggerSlideHandler = Ot;
  } else {
    var nn = getTrackLeft(me);
    kt.trackStyle = getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, me), {}, {
      left: nn
    }));
  }
  return kt;
};
var getNavigableIndexes = innerSliderUtils.getNavigableIndexes = function(ie) {
  for (var me = ie.infinite ? ie.slideCount * 2 : ie.slideCount, we = ie.infinite ? ie.slidesToShow * -1 : 0, Re = ie.infinite ? ie.slidesToShow * -1 : 0, je = []; we < me; )
    je.push(we), we = Re + ie.slidesToScroll, Re += Math.min(ie.slidesToScroll, ie.slidesToShow);
  return je;
}, checkNavigable = innerSliderUtils.checkNavigable = function(ie, me) {
  var we = getNavigableIndexes(ie), Re = 0;
  if (me > we[we.length - 1])
    me = we[we.length - 1];
  else
    for (var je in we) {
      if (me < we[je]) {
        me = Re;
        break;
      }
      Re = we[je];
    }
  return me;
}, getSlideCount = innerSliderUtils.getSlideCount = function(ie) {
  var me = ie.centerMode ? ie.slideWidth * Math.floor(ie.slidesToShow / 2) : 0;
  if (ie.swipeToSlide) {
    var we, Re = ie.listRef, je = Re.querySelectorAll && Re.querySelectorAll(".slick-slide") || [];
    if (Array.from(je).every(function(Ge) {
      if (ie.vertical) {
        if (Ge.offsetTop + getHeight(Ge) / 2 > ie.swipeLeft * -1)
          return we = Ge, !1;
      } else if (Ge.offsetLeft - me + getWidth(Ge) / 2 > ie.swipeLeft * -1)
        return we = Ge, !1;
      return !0;
    }), !we)
      return 0;
    var Ue = ie.rtl === !0 ? ie.slideCount - ie.currentSlide : ie.currentSlide, qe = Math.abs(we.dataset.index - Ue) || 1;
    return qe;
  } else
    return ie.slidesToScroll;
}, checkSpecKeys = innerSliderUtils.checkSpecKeys = function(ie, me) {
  return me.reduce(function(we, Re) {
    return we && ie.hasOwnProperty(Re);
  }, !0) ? null : console.error("Keys Missing:", ie);
}, getTrackCSS = innerSliderUtils.getTrackCSS = function(ie) {
  checkSpecKeys(ie, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var me, we, Re = ie.slideCount + 2 * ie.slidesToShow;
  ie.vertical ? we = Re * ie.slideHeight : me = getTotalSlides(ie) * ie.slideWidth;
  var je = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (ie.useTransform) {
    var Ue = ie.vertical ? "translate3d(0px, " + ie.left + "px, 0px)" : "translate3d(" + ie.left + "px, 0px, 0px)", qe = ie.vertical ? "translate3d(0px, " + ie.left + "px, 0px)" : "translate3d(" + ie.left + "px, 0px, 0px)", Ge = ie.vertical ? "translateY(" + ie.left + "px)" : "translateX(" + ie.left + "px)";
    je = _objectSpread$4(_objectSpread$4({}, je), {}, {
      WebkitTransform: Ue,
      transform: qe,
      msTransform: Ge
    });
  } else
    ie.vertical ? je.top = ie.left : je.left = ie.left;
  return ie.fade && (je = {
    opacity: 1
  }), me && (je.width = me), we && (je.height = we), window && !window.addEventListener && window.attachEvent && (ie.vertical ? je.marginTop = ie.left + "px" : je.marginLeft = ie.left + "px"), je;
}, getTrackAnimateCSS = innerSliderUtils.getTrackAnimateCSS = function(ie) {
  checkSpecKeys(ie, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var me = getTrackCSS(ie);
  return ie.useTransform ? (me.WebkitTransition = "-webkit-transform " + ie.speed + "ms " + ie.cssEase, me.transition = "transform " + ie.speed + "ms " + ie.cssEase) : ie.vertical ? me.transition = "top " + ie.speed + "ms " + ie.cssEase : me.transition = "left " + ie.speed + "ms " + ie.cssEase, me;
}, getTrackLeft = innerSliderUtils.getTrackLeft = function(ie) {
  if (ie.unslick)
    return 0;
  checkSpecKeys(ie, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var me = ie.slideIndex, we = ie.trackRef, Re = ie.infinite, je = ie.centerMode, Ue = ie.slideCount, qe = ie.slidesToShow, Ge = ie.slidesToScroll, Xe = ie.slideWidth, ot = ie.listWidth, vt = ie.variableWidth, bt = ie.slideHeight, Tt = ie.fade, wt = ie.vertical, St = 0, It, Pt, kt = 0;
  if (Tt || ie.slideCount === 1)
    return 0;
  var Ot = 0;
  if (Re ? (Ot = -getPreClones(ie), Ue % Ge !== 0 && me + Ge > Ue && (Ot = -(me > Ue ? qe - (me - Ue) : Ue % Ge)), je && (Ot += parseInt(qe / 2))) : (Ue % Ge !== 0 && me + Ge > Ue && (Ot = qe - Ue % Ge), je && (Ot = parseInt(qe / 2))), St = Ot * Xe, kt = Ot * bt, wt ? It = me * bt * -1 + kt : It = me * Xe * -1 + St, vt === !0) {
    var Jr, en = we && we.node;
    if (Jr = me + getPreClones(ie), Pt = en && en.childNodes[Jr], It = Pt ? Pt.offsetLeft * -1 : 0, je === !0) {
      Jr = Re ? me + getPreClones(ie) : me, Pt = en && en.children[Jr], It = 0;
      for (var nn = 0; nn < Jr; nn++)
        It -= en && en.children[nn] && en.children[nn].offsetWidth;
      It -= parseInt(ie.centerPadding), It += Pt && (ot - Pt.offsetWidth) / 2;
    }
  }
  return It;
}, getPreClones = innerSliderUtils.getPreClones = function(ie) {
  return ie.unslick || !ie.infinite ? 0 : ie.variableWidth ? ie.slideCount : ie.slidesToShow + (ie.centerMode ? 1 : 0);
}, getPostClones = innerSliderUtils.getPostClones = function(ie) {
  return ie.unslick || !ie.infinite ? 0 : ie.slideCount;
}, getTotalSlides = innerSliderUtils.getTotalSlides = function(ie) {
  return ie.slideCount === 1 ? 1 : getPreClones(ie) + ie.slideCount + getPostClones(ie);
}, siblingDirection = innerSliderUtils.siblingDirection = function(ie) {
  return ie.targetSlide > ie.currentSlide ? ie.targetSlide > ie.currentSlide + slidesOnRight(ie) ? "left" : "right" : ie.targetSlide < ie.currentSlide - slidesOnLeft(ie) ? "right" : "left";
}, slidesOnRight = innerSliderUtils.slidesOnRight = function(ie) {
  var me = ie.slidesToShow, we = ie.centerMode, Re = ie.rtl, je = ie.centerPadding;
  if (we) {
    var Ue = (me - 1) / 2 + 1;
    return parseInt(je) > 0 && (Ue += 1), Re && me % 2 === 0 && (Ue += 1), Ue;
  }
  return Re ? 0 : me - 1;
}, slidesOnLeft = innerSliderUtils.slidesOnLeft = function(ie) {
  var me = ie.slidesToShow, we = ie.centerMode, Re = ie.rtl, je = ie.centerPadding;
  if (we) {
    var Ue = (me - 1) / 2 + 1;
    return parseInt(je) > 0 && (Ue += 1), !Re && me % 2 === 0 && (Ue += 1), Ue;
  }
  return Re ? me - 1 : 0;
};
innerSliderUtils.canUseDOM = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
};
var validSettings = innerSliderUtils.validSettings = Object.keys(_defaultProps.default);
function filterSettings(ce) {
  return validSettings.reduce(function(ie, me) {
    return ce.hasOwnProperty(me) && (ie[me] = ce[me]), ie;
  }, {});
}
var track = {};
Object.defineProperty(track, "__esModule", {
  value: !0
});
track.Track = void 0;
var _react$3 = _interopRequireDefault$3(React__default), _classnames$3 = _interopRequireDefault$3(classnamesExports), _innerSliderUtils$3 = innerSliderUtils;
function _interopRequireDefault$3(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _typeof$4(ce) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$4(ce);
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(ce) {
    for (var ie = 1; ie < arguments.length; ie++) {
      var me = arguments[ie];
      for (var we in me)
        Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
    }
    return ce;
  }, _extends$2.apply(this, arguments);
}
function _classCallCheck$3(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, _toPropertyKey$4(we.key), we);
  }
}
function _createClass$3(ce, ie, me) {
  return ie && _defineProperties$3(ce.prototype, ie), Object.defineProperty(ce, "prototype", { writable: !1 }), ce;
}
function _inherits$3(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function");
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), Object.defineProperty(ce, "prototype", { writable: !1 }), ie && _setPrototypeOf$3(ce, ie);
}
function _setPrototypeOf$3(ce, ie) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(we, Re) {
    return we.__proto__ = Re, we;
  }, _setPrototypeOf$3(ce, ie);
}
function _createSuper$3(ce) {
  var ie = _isNativeReflectConstruct$3();
  return function() {
    var we = _getPrototypeOf$3(ce), Re;
    if (ie) {
      var je = _getPrototypeOf$3(this).constructor;
      Re = Reflect.construct(we, arguments, je);
    } else
      Re = we.apply(this, arguments);
    return _possibleConstructorReturn$3(this, Re);
  };
}
function _possibleConstructorReturn$3(ce, ie) {
  if (ie && (_typeof$4(ie) === "object" || typeof ie == "function"))
    return ie;
  if (ie !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(ce);
}
function _assertThisInitialized$3(ce) {
  if (ce === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ce;
}
function _isNativeReflectConstruct$3() {
  try {
    var ce = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$3 = function() {
    return !!ce;
  })();
}
function _getPrototypeOf$3(ce) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(me) {
    return me.__proto__ || Object.getPrototypeOf(me);
  }, _getPrototypeOf$3(ce);
}
function ownKeys$5(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$3(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$5(Object(me), !0).forEach(function(we) {
      _defineProperty$5(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$5(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$5(ce, ie, me) {
  return ie = _toPropertyKey$4(ie), ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _toPropertyKey$4(ce) {
  var ie = _toPrimitive$4(ce, "string");
  return _typeof$4(ie) == "symbol" ? ie : String(ie);
}
function _toPrimitive$4(ce, ie) {
  if (_typeof$4(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$4(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ie === "string" ? String : Number)(ce);
}
var getSlideClasses = function(ie) {
  var me, we, Re, je, Ue;
  ie.rtl ? Ue = ie.slideCount - 1 - ie.index : Ue = ie.index, Re = Ue < 0 || Ue >= ie.slideCount, ie.centerMode ? (je = Math.floor(ie.slidesToShow / 2), we = (Ue - ie.currentSlide) % ie.slideCount === 0, Ue > ie.currentSlide - je - 1 && Ue <= ie.currentSlide + je && (me = !0)) : me = ie.currentSlide <= Ue && Ue < ie.currentSlide + ie.slidesToShow;
  var qe;
  ie.targetSlide < 0 ? qe = ie.targetSlide + ie.slideCount : ie.targetSlide >= ie.slideCount ? qe = ie.targetSlide - ie.slideCount : qe = ie.targetSlide;
  var Ge = Ue === qe;
  return {
    "slick-slide": !0,
    "slick-active": me,
    "slick-center": we,
    "slick-cloned": Re,
    "slick-current": Ge
    // dubious in case of RTL
  };
}, getSlideStyle = function(ie) {
  var me = {};
  return (ie.variableWidth === void 0 || ie.variableWidth === !1) && (me.width = ie.slideWidth), ie.fade && (me.position = "relative", ie.vertical ? me.top = -ie.index * parseInt(ie.slideHeight) : me.left = -ie.index * parseInt(ie.slideWidth), me.opacity = ie.currentSlide === ie.index ? 1 : 0, me.zIndex = ie.currentSlide === ie.index ? 999 : 998, ie.useCSS && (me.transition = "opacity " + ie.speed + "ms " + ie.cssEase + ", visibility " + ie.speed + "ms " + ie.cssEase)), me;
}, getKey = function(ie, me) {
  return ie.key || me;
}, renderSlides = function(ie) {
  var me, we = [], Re = [], je = [], Ue = _react$3.default.Children.count(ie.children), qe = (0, _innerSliderUtils$3.lazyStartIndex)(ie), Ge = (0, _innerSliderUtils$3.lazyEndIndex)(ie);
  return _react$3.default.Children.forEach(ie.children, function(Xe, ot) {
    var vt, bt = {
      message: "children",
      index: ot,
      slidesToScroll: ie.slidesToScroll,
      currentSlide: ie.currentSlide
    };
    !ie.lazyLoad || ie.lazyLoad && ie.lazyLoadedList.indexOf(ot) >= 0 ? vt = Xe : vt = /* @__PURE__ */ _react$3.default.createElement("div", null);
    var Tt = getSlideStyle(_objectSpread$3(_objectSpread$3({}, ie), {}, {
      index: ot
    })), wt = vt.props.className || "", St = getSlideClasses(_objectSpread$3(_objectSpread$3({}, ie), {}, {
      index: ot
    }));
    if (we.push(/* @__PURE__ */ _react$3.default.cloneElement(vt, {
      key: "original" + getKey(vt, ot),
      "data-index": ot,
      className: (0, _classnames$3.default)(St, wt),
      tabIndex: "-1",
      "aria-hidden": !St["slick-active"],
      style: _objectSpread$3(_objectSpread$3({
        outline: "none"
      }, vt.props.style || {}), Tt),
      onClick: function(kt) {
        vt.props && vt.props.onClick && vt.props.onClick(kt), ie.focusOnSelect && ie.focusOnSelect(bt);
      }
    })), ie.infinite && ie.fade === !1) {
      var It = Ue - ot;
      It <= (0, _innerSliderUtils$3.getPreClones)(ie) && (me = -It, me >= qe && (vt = Xe), St = getSlideClasses(_objectSpread$3(_objectSpread$3({}, ie), {}, {
        index: me
      })), Re.push(/* @__PURE__ */ _react$3.default.cloneElement(vt, {
        key: "precloned" + getKey(vt, me),
        "data-index": me,
        tabIndex: "-1",
        className: (0, _classnames$3.default)(St, wt),
        "aria-hidden": !St["slick-active"],
        style: _objectSpread$3(_objectSpread$3({}, vt.props.style || {}), Tt),
        onClick: function(kt) {
          vt.props && vt.props.onClick && vt.props.onClick(kt), ie.focusOnSelect && ie.focusOnSelect(bt);
        }
      }))), me = Ue + ot, me < Ge && (vt = Xe), St = getSlideClasses(_objectSpread$3(_objectSpread$3({}, ie), {}, {
        index: me
      })), je.push(/* @__PURE__ */ _react$3.default.cloneElement(vt, {
        key: "postcloned" + getKey(vt, me),
        "data-index": me,
        tabIndex: "-1",
        className: (0, _classnames$3.default)(St, wt),
        "aria-hidden": !St["slick-active"],
        style: _objectSpread$3(_objectSpread$3({}, vt.props.style || {}), Tt),
        onClick: function(kt) {
          vt.props && vt.props.onClick && vt.props.onClick(kt), ie.focusOnSelect && ie.focusOnSelect(bt);
        }
      }));
    }
  }), ie.rtl ? Re.concat(we, je).reverse() : Re.concat(we, je);
};
track.Track = /* @__PURE__ */ function(ce) {
  _inherits$3(me, ce);
  var ie = _createSuper$3(me);
  function me() {
    var we;
    _classCallCheck$3(this, me);
    for (var Re = arguments.length, je = new Array(Re), Ue = 0; Ue < Re; Ue++)
      je[Ue] = arguments[Ue];
    return we = ie.call.apply(ie, [this].concat(je)), _defineProperty$5(_assertThisInitialized$3(we), "node", null), _defineProperty$5(_assertThisInitialized$3(we), "handleRef", function(qe) {
      we.node = qe;
    }), we;
  }
  return _createClass$3(me, [{
    key: "render",
    value: function() {
      var Re = renderSlides(this.props), je = this.props, Ue = je.onMouseEnter, qe = je.onMouseOver, Ge = je.onMouseLeave, Xe = {
        onMouseEnter: Ue,
        onMouseOver: qe,
        onMouseLeave: Ge
      };
      return /* @__PURE__ */ _react$3.default.createElement("div", _extends$2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, Xe), Re);
    }
  }]), me;
}(_react$3.default.PureComponent);
var dots = {};
function _typeof$3(ce) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$3(ce);
}
Object.defineProperty(dots, "__esModule", {
  value: !0
});
dots.Dots = void 0;
var _react$2 = _interopRequireDefault$2(React__default), _classnames$2 = _interopRequireDefault$2(classnamesExports), _innerSliderUtils$2 = innerSliderUtils;
function _interopRequireDefault$2(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function ownKeys$4(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$2(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$4(Object(me), !0).forEach(function(we) {
      _defineProperty$4(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$4(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$4(ce, ie, me) {
  return ie = _toPropertyKey$3(ie), ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _classCallCheck$2(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, _toPropertyKey$3(we.key), we);
  }
}
function _createClass$2(ce, ie, me) {
  return ie && _defineProperties$2(ce.prototype, ie), Object.defineProperty(ce, "prototype", { writable: !1 }), ce;
}
function _toPropertyKey$3(ce) {
  var ie = _toPrimitive$3(ce, "string");
  return _typeof$3(ie) == "symbol" ? ie : String(ie);
}
function _toPrimitive$3(ce, ie) {
  if (_typeof$3(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$3(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(ce);
}
function _inherits$2(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function");
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), Object.defineProperty(ce, "prototype", { writable: !1 }), ie && _setPrototypeOf$2(ce, ie);
}
function _setPrototypeOf$2(ce, ie) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(we, Re) {
    return we.__proto__ = Re, we;
  }, _setPrototypeOf$2(ce, ie);
}
function _createSuper$2(ce) {
  var ie = _isNativeReflectConstruct$2();
  return function() {
    var we = _getPrototypeOf$2(ce), Re;
    if (ie) {
      var je = _getPrototypeOf$2(this).constructor;
      Re = Reflect.construct(we, arguments, je);
    } else
      Re = we.apply(this, arguments);
    return _possibleConstructorReturn$2(this, Re);
  };
}
function _possibleConstructorReturn$2(ce, ie) {
  if (ie && (_typeof$3(ie) === "object" || typeof ie == "function"))
    return ie;
  if (ie !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(ce);
}
function _assertThisInitialized$2(ce) {
  if (ce === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ce;
}
function _isNativeReflectConstruct$2() {
  try {
    var ce = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!ce;
  })();
}
function _getPrototypeOf$2(ce) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(me) {
    return me.__proto__ || Object.getPrototypeOf(me);
  }, _getPrototypeOf$2(ce);
}
var getDotCount = function(ie) {
  var me;
  return ie.infinite ? me = Math.ceil(ie.slideCount / ie.slidesToScroll) : me = Math.ceil((ie.slideCount - ie.slidesToShow) / ie.slidesToScroll) + 1, me;
};
dots.Dots = /* @__PURE__ */ function(ce) {
  _inherits$2(me, ce);
  var ie = _createSuper$2(me);
  function me() {
    return _classCallCheck$2(this, me), ie.apply(this, arguments);
  }
  return _createClass$2(me, [{
    key: "clickHandler",
    value: function(Re, je) {
      je.preventDefault(), this.props.clickHandler(Re);
    }
  }, {
    key: "render",
    value: function() {
      for (var Re = this.props, je = Re.onMouseEnter, Ue = Re.onMouseOver, qe = Re.onMouseLeave, Ge = Re.infinite, Xe = Re.slidesToScroll, ot = Re.slidesToShow, vt = Re.slideCount, bt = Re.currentSlide, Tt = getDotCount({
        slideCount: vt,
        slidesToScroll: Xe,
        slidesToShow: ot,
        infinite: Ge
      }), wt = {
        onMouseEnter: je,
        onMouseOver: Ue,
        onMouseLeave: qe
      }, St = [], It = 0; It < Tt; It++) {
        var Pt = (It + 1) * Xe - 1, kt = Ge ? Pt : (0, _innerSliderUtils$2.clamp)(Pt, 0, vt - 1), Ot = kt - (Xe - 1), Jr = Ge ? Ot : (0, _innerSliderUtils$2.clamp)(Ot, 0, vt - 1), en = (0, _classnames$2.default)({
          "slick-active": Ge ? bt >= Jr && bt <= kt : bt === Jr
        }), nn = {
          message: "dots",
          index: It,
          slidesToScroll: Xe,
          currentSlide: bt
        }, ln = this.clickHandler.bind(this, nn);
        St = St.concat(/* @__PURE__ */ _react$2.default.createElement("li", {
          key: It,
          className: en
        }, /* @__PURE__ */ _react$2.default.cloneElement(this.props.customPaging(It), {
          onClick: ln
        })));
      }
      return /* @__PURE__ */ _react$2.default.cloneElement(this.props.appendDots(St), _objectSpread$2({
        className: this.props.dotsClass
      }, wt));
    }
  }]), me;
}(_react$2.default.PureComponent);
var arrows = {};
function _typeof$2(ce) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$2(ce);
}
Object.defineProperty(arrows, "__esModule", {
  value: !0
});
arrows.PrevArrow = arrows.NextArrow = void 0;
var _react$1 = _interopRequireDefault$1(React__default), _classnames$1 = _interopRequireDefault$1(classnamesExports), _innerSliderUtils$1 = innerSliderUtils;
function _interopRequireDefault$1(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(ce) {
    for (var ie = 1; ie < arguments.length; ie++) {
      var me = arguments[ie];
      for (var we in me)
        Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
    }
    return ce;
  }, _extends$1.apply(this, arguments);
}
function ownKeys$3(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread$1(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$3(Object(me), !0).forEach(function(we) {
      _defineProperty$3(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$3(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _defineProperty$3(ce, ie, me) {
  return ie = _toPropertyKey$2(ie), ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _classCallCheck$1(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, _toPropertyKey$2(we.key), we);
  }
}
function _createClass$1(ce, ie, me) {
  return ie && _defineProperties$1(ce.prototype, ie), Object.defineProperty(ce, "prototype", { writable: !1 }), ce;
}
function _toPropertyKey$2(ce) {
  var ie = _toPrimitive$2(ce, "string");
  return _typeof$2(ie) == "symbol" ? ie : String(ie);
}
function _toPrimitive$2(ce, ie) {
  if (_typeof$2(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$2(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(ce);
}
function _inherits$1(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function");
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), Object.defineProperty(ce, "prototype", { writable: !1 }), ie && _setPrototypeOf$1(ce, ie);
}
function _setPrototypeOf$1(ce, ie) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(we, Re) {
    return we.__proto__ = Re, we;
  }, _setPrototypeOf$1(ce, ie);
}
function _createSuper$1(ce) {
  var ie = _isNativeReflectConstruct$1();
  return function() {
    var we = _getPrototypeOf$1(ce), Re;
    if (ie) {
      var je = _getPrototypeOf$1(this).constructor;
      Re = Reflect.construct(we, arguments, je);
    } else
      Re = we.apply(this, arguments);
    return _possibleConstructorReturn$1(this, Re);
  };
}
function _possibleConstructorReturn$1(ce, ie) {
  if (ie && (_typeof$2(ie) === "object" || typeof ie == "function"))
    return ie;
  if (ie !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(ce);
}
function _assertThisInitialized$1(ce) {
  if (ce === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ce;
}
function _isNativeReflectConstruct$1() {
  try {
    var ce = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$1 = function() {
    return !!ce;
  })();
}
function _getPrototypeOf$1(ce) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(me) {
    return me.__proto__ || Object.getPrototypeOf(me);
  }, _getPrototypeOf$1(ce);
}
arrows.PrevArrow = /* @__PURE__ */ function(ce) {
  _inherits$1(me, ce);
  var ie = _createSuper$1(me);
  function me() {
    return _classCallCheck$1(this, me), ie.apply(this, arguments);
  }
  return _createClass$1(me, [{
    key: "clickHandler",
    value: function(Re, je) {
      je && je.preventDefault(), this.props.clickHandler(Re, je);
    }
  }, {
    key: "render",
    value: function() {
      var Re = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, je = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (Re["slick-disabled"] = !0, je = null);
      var Ue = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1.default)(Re),
        style: {
          display: "block"
        },
        onClick: je
      }, qe = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, Ge;
      return this.props.prevArrow ? Ge = /* @__PURE__ */ _react$1.default.cloneElement(this.props.prevArrow, _objectSpread$1(_objectSpread$1({}, Ue), qe)) : Ge = /* @__PURE__ */ _react$1.default.createElement("button", _extends$1({
        key: "0",
        type: "button"
      }, Ue), " ", "Previous"), Ge;
    }
  }]), me;
}(_react$1.default.PureComponent);
arrows.NextArrow = /* @__PURE__ */ function(ce) {
  _inherits$1(me, ce);
  var ie = _createSuper$1(me);
  function me() {
    return _classCallCheck$1(this, me), ie.apply(this, arguments);
  }
  return _createClass$1(me, [{
    key: "clickHandler",
    value: function(Re, je) {
      je && je.preventDefault(), this.props.clickHandler(Re, je);
    }
  }, {
    key: "render",
    value: function() {
      var Re = {
        "slick-arrow": !0,
        "slick-next": !0
      }, je = this.clickHandler.bind(this, {
        message: "next"
      });
      (0, _innerSliderUtils$1.canGoNext)(this.props) || (Re["slick-disabled"] = !0, je = null);
      var Ue = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1.default)(Re),
        style: {
          display: "block"
        },
        onClick: je
      }, qe = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, Ge;
      return this.props.nextArrow ? Ge = /* @__PURE__ */ _react$1.default.cloneElement(this.props.nextArrow, _objectSpread$1(_objectSpread$1({}, Ue), qe)) : Ge = /* @__PURE__ */ _react$1.default.createElement("button", _extends$1({
        key: "1",
        type: "button"
      }, Ue), " ", "Next"), Ge;
    }
  }]), me;
}(_react$1.default.PureComponent);
const require$$8 = /* @__PURE__ */ getAugmentedNamespace(ResizeObserver_es);
Object.defineProperty(innerSlider, "__esModule", {
  value: !0
});
innerSlider.InnerSlider = void 0;
var _react = _interopRequireDefault(React__default), _initialState = _interopRequireDefault(initialState), _lodash = _interopRequireDefault(lodash_debounce), _classnames = _interopRequireDefault(classnamesExports), _innerSliderUtils = innerSliderUtils, _track = track, _dots = dots, _arrows = arrows, _resizeObserverPolyfill = _interopRequireDefault(require$$8);
function _interopRequireDefault(ce) {
  return ce && ce.__esModule ? ce : { default: ce };
}
function _typeof$1(ce) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof$1(ce);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(ce) {
    for (var ie = 1; ie < arguments.length; ie++) {
      var me = arguments[ie];
      for (var we in me)
        Object.prototype.hasOwnProperty.call(me, we) && (ce[we] = me[we]);
    }
    return ce;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties$1(ce, ie) {
  if (ce == null) return {};
  var me = _objectWithoutPropertiesLoose$1(ce, ie), we, Re;
  if (Object.getOwnPropertySymbols) {
    var je = Object.getOwnPropertySymbols(ce);
    for (Re = 0; Re < je.length; Re++)
      we = je[Re], !(ie.indexOf(we) >= 0) && Object.prototype.propertyIsEnumerable.call(ce, we) && (me[we] = ce[we]);
  }
  return me;
}
function _objectWithoutPropertiesLoose$1(ce, ie) {
  if (ce == null) return {};
  var me = {}, we = Object.keys(ce), Re, je;
  for (je = 0; je < we.length; je++)
    Re = we[je], !(ie.indexOf(Re) >= 0) && (me[Re] = ce[Re]);
  return me;
}
function ownKeys$2(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$2(Object(me), !0).forEach(function(we) {
      _defineProperty$2(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$2(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _classCallCheck(ce, ie) {
  if (!(ce instanceof ie))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(ce, ie) {
  for (var me = 0; me < ie.length; me++) {
    var we = ie[me];
    we.enumerable = we.enumerable || !1, we.configurable = !0, "value" in we && (we.writable = !0), Object.defineProperty(ce, _toPropertyKey$1(we.key), we);
  }
}
function _createClass(ce, ie, me) {
  return ie && _defineProperties(ce.prototype, ie), Object.defineProperty(ce, "prototype", { writable: !1 }), ce;
}
function _inherits(ce, ie) {
  if (typeof ie != "function" && ie !== null)
    throw new TypeError("Super expression must either be null or a function");
  ce.prototype = Object.create(ie && ie.prototype, { constructor: { value: ce, writable: !0, configurable: !0 } }), Object.defineProperty(ce, "prototype", { writable: !1 }), ie && _setPrototypeOf(ce, ie);
}
function _setPrototypeOf(ce, ie) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(we, Re) {
    return we.__proto__ = Re, we;
  }, _setPrototypeOf(ce, ie);
}
function _createSuper(ce) {
  var ie = _isNativeReflectConstruct();
  return function() {
    var we = _getPrototypeOf(ce), Re;
    if (ie) {
      var je = _getPrototypeOf(this).constructor;
      Re = Reflect.construct(we, arguments, je);
    } else
      Re = we.apply(this, arguments);
    return _possibleConstructorReturn(this, Re);
  };
}
function _possibleConstructorReturn(ce, ie) {
  if (ie && (_typeof$1(ie) === "object" || typeof ie == "function"))
    return ie;
  if (ie !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(ce);
}
function _assertThisInitialized(ce) {
  if (ce === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return ce;
}
function _isNativeReflectConstruct() {
  try {
    var ce = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!ce;
  })();
}
function _getPrototypeOf(ce) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(me) {
    return me.__proto__ || Object.getPrototypeOf(me);
  }, _getPrototypeOf(ce);
}
function _defineProperty$2(ce, ie, me) {
  return ie = _toPropertyKey$1(ie), ie in ce ? Object.defineProperty(ce, ie, { value: me, enumerable: !0, configurable: !0, writable: !0 }) : ce[ie] = me, ce;
}
function _toPropertyKey$1(ce) {
  var ie = _toPrimitive$1(ce, "string");
  return _typeof$1(ie) == "symbol" ? ie : String(ie);
}
function _toPrimitive$1(ce, ie) {
  if (_typeof$1(ce) != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (_typeof$1(we) != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ie === "string" ? String : Number)(ce);
}
innerSlider.InnerSlider = /* @__PURE__ */ function(ce) {
  _inherits(me, ce);
  var ie = _createSuper(me);
  function me(we) {
    var Re;
    _classCallCheck(this, me), Re = ie.call(this, we), _defineProperty$2(_assertThisInitialized(Re), "listRefHandler", function(Ue) {
      return Re.list = Ue;
    }), _defineProperty$2(_assertThisInitialized(Re), "trackRefHandler", function(Ue) {
      return Re.track = Ue;
    }), _defineProperty$2(_assertThisInitialized(Re), "adaptHeight", function() {
      if (Re.props.adaptiveHeight && Re.list) {
        var Ue = Re.list.querySelector('[data-index="'.concat(Re.state.currentSlide, '"]'));
        Re.list.style.height = (0, _innerSliderUtils.getHeight)(Ue) + "px";
      }
    }), _defineProperty$2(_assertThisInitialized(Re), "componentDidMount", function() {
      if (Re.props.onInit && Re.props.onInit(), Re.props.lazyLoad) {
        var Ue = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, Re.props), Re.state));
        Ue.length > 0 && (Re.setState(function(Ge) {
          return {
            lazyLoadedList: Ge.lazyLoadedList.concat(Ue)
          };
        }), Re.props.onLazyLoad && Re.props.onLazyLoad(Ue));
      }
      var qe = _objectSpread({
        listRef: Re.list,
        trackRef: Re.track
      }, Re.props);
      Re.updateState(qe, !0, function() {
        Re.adaptHeight(), Re.props.autoplay && Re.autoPlay("update");
      }), Re.props.lazyLoad === "progressive" && (Re.lazyLoadTimer = setInterval(Re.progressiveLazyLoad, 1e3)), Re.ro = new _resizeObserverPolyfill.default(function(Ge) {
        Re.state.animating ? (Re.onWindowResized(!1), Re.callbackTimers.push(setTimeout(function() {
          return Re.onWindowResized();
        }, Re.props.speed))) : Re.onWindowResized();
        var Xe = Ge.find((ot) => ot.target === Re.list);
        Xe && Re.props.onResize && Re.props.onResize(Xe.contentRect);
      }), Re.ro.observe(Re.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(Ge) {
        Ge.onfocus = Re.props.pauseOnFocus ? Re.onSlideFocus : null, Ge.onblur = Re.props.pauseOnFocus ? Re.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", Re.onWindowResized) : window.attachEvent("onresize", Re.onWindowResized);
    }), _defineProperty$2(_assertThisInitialized(Re), "componentWillUnmount", function() {
      Re.animationEndCallback && clearTimeout(Re.animationEndCallback), Re.lazyLoadTimer && clearInterval(Re.lazyLoadTimer), Re.callbackTimers.length && (Re.callbackTimers.forEach(function(Ue) {
        return clearTimeout(Ue);
      }), Re.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", Re.onWindowResized) : window.detachEvent("onresize", Re.onWindowResized), Re.autoplayTimer && clearInterval(Re.autoplayTimer), Re.ro.disconnect();
    }), _defineProperty$2(_assertThisInitialized(Re), "componentDidUpdate", function(Ue) {
      if (Re.checkImagesLoad(), Re.props.onReInit && Re.props.onReInit(), Re.props.lazyLoad) {
        var qe = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, Re.props), Re.state));
        qe.length > 0 && (Re.setState(function(ot) {
          return {
            lazyLoadedList: ot.lazyLoadedList.concat(qe)
          };
        }), Re.props.onLazyLoad && Re.props.onLazyLoad(qe));
      }
      Re.adaptHeight();
      var Ge = _objectSpread(_objectSpread({
        listRef: Re.list,
        trackRef: Re.track
      }, Re.props), Re.state), Xe = Re.didPropsChange(Ue);
      Xe && Re.updateState(Ge, Xe, function() {
        Re.state.currentSlide >= _react.default.Children.count(Re.props.children) && Re.changeSlide({
          message: "index",
          index: _react.default.Children.count(Re.props.children) - Re.props.slidesToShow,
          currentSlide: Re.state.currentSlide
        }), Re.props.autoplay ? Re.autoPlay("update") : Re.pause("paused");
      });
    }), _defineProperty$2(_assertThisInitialized(Re), "onWindowResized", function(Ue) {
      Re.debouncedResize && Re.debouncedResize.cancel(), Re.debouncedResize = (0, _lodash.default)(function() {
        return Re.resizeWindow(Ue);
      }, 50), Re.debouncedResize();
    }), _defineProperty$2(_assertThisInitialized(Re), "resizeWindow", function() {
      var Ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, qe = !!(Re.track && Re.track.node);
      if (qe) {
        var Ge = _objectSpread(_objectSpread({
          listRef: Re.list,
          trackRef: Re.track
        }, Re.props), Re.state);
        Re.updateState(Ge, Ue, function() {
          Re.props.autoplay ? Re.autoPlay("update") : Re.pause("paused");
        }), Re.setState({
          animating: !1
        }), clearTimeout(Re.animationEndCallback), delete Re.animationEndCallback;
      }
    }), _defineProperty$2(_assertThisInitialized(Re), "updateState", function(Ue, qe, Ge) {
      var Xe = (0, _innerSliderUtils.initializedState)(Ue);
      Ue = _objectSpread(_objectSpread(_objectSpread({}, Ue), Xe), {}, {
        slideIndex: Xe.currentSlide
      });
      var ot = (0, _innerSliderUtils.getTrackLeft)(Ue);
      Ue = _objectSpread(_objectSpread({}, Ue), {}, {
        left: ot
      });
      var vt = (0, _innerSliderUtils.getTrackCSS)(Ue);
      (qe || _react.default.Children.count(Re.props.children) !== _react.default.Children.count(Ue.children)) && (Xe.trackStyle = vt), Re.setState(Xe, Ge);
    }), _defineProperty$2(_assertThisInitialized(Re), "ssrInit", function() {
      if (Re.props.variableWidth) {
        var Ue = 0, qe = 0, Ge = [], Xe = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, Re.props), Re.state), {}, {
          slideCount: Re.props.children.length
        })), ot = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, Re.props), Re.state), {}, {
          slideCount: Re.props.children.length
        }));
        Re.props.children.forEach(function(ln) {
          Ge.push(ln.props.style.width), Ue += ln.props.style.width;
        });
        for (var vt = 0; vt < Xe; vt++)
          qe += Ge[Ge.length - 1 - vt], Ue += Ge[Ge.length - 1 - vt];
        for (var bt = 0; bt < ot; bt++)
          Ue += Ge[bt];
        for (var Tt = 0; Tt < Re.state.currentSlide; Tt++)
          qe += Ge[Tt];
        var wt = {
          width: Ue + "px",
          left: -qe + "px"
        };
        if (Re.props.centerMode) {
          var St = "".concat(Ge[Re.state.currentSlide], "px");
          wt.left = "calc(".concat(wt.left, " + (100% - ").concat(St, ") / 2 ) ");
        }
        return {
          trackStyle: wt
        };
      }
      var It = _react.default.Children.count(Re.props.children), Pt = _objectSpread(_objectSpread(_objectSpread({}, Re.props), Re.state), {}, {
        slideCount: It
      }), kt = (0, _innerSliderUtils.getPreClones)(Pt) + (0, _innerSliderUtils.getPostClones)(Pt) + It, Ot = 100 / Re.props.slidesToShow * kt, Jr = 100 / kt, en = -Jr * ((0, _innerSliderUtils.getPreClones)(Pt) + Re.state.currentSlide) * Ot / 100;
      Re.props.centerMode && (en += (100 - Jr * Ot / 100) / 2);
      var nn = {
        width: Ot + "%",
        left: en + "%"
      };
      return {
        slideWidth: Jr + "%",
        trackStyle: nn
      };
    }), _defineProperty$2(_assertThisInitialized(Re), "checkImagesLoad", function() {
      var Ue = Re.list && Re.list.querySelectorAll && Re.list.querySelectorAll(".slick-slide img") || [], qe = Ue.length, Ge = 0;
      Array.prototype.forEach.call(Ue, function(Xe) {
        var ot = function() {
          return ++Ge && Ge >= qe && Re.onWindowResized();
        };
        if (!Xe.onclick)
          Xe.onclick = function() {
            return Xe.parentNode.focus();
          };
        else {
          var vt = Xe.onclick;
          Xe.onclick = function(bt) {
            vt(bt), Xe.parentNode.focus();
          };
        }
        Xe.onload || (Re.props.lazyLoad ? Xe.onload = function() {
          Re.adaptHeight(), Re.callbackTimers.push(setTimeout(Re.onWindowResized, Re.props.speed));
        } : (Xe.onload = ot, Xe.onerror = function() {
          ot(), Re.props.onLazyLoadError && Re.props.onLazyLoadError();
        }));
      });
    }), _defineProperty$2(_assertThisInitialized(Re), "progressiveLazyLoad", function() {
      for (var Ue = [], qe = _objectSpread(_objectSpread({}, Re.props), Re.state), Ge = Re.state.currentSlide; Ge < Re.state.slideCount + (0, _innerSliderUtils.getPostClones)(qe); Ge++)
        if (Re.state.lazyLoadedList.indexOf(Ge) < 0) {
          Ue.push(Ge);
          break;
        }
      for (var Xe = Re.state.currentSlide - 1; Xe >= -(0, _innerSliderUtils.getPreClones)(qe); Xe--)
        if (Re.state.lazyLoadedList.indexOf(Xe) < 0) {
          Ue.push(Xe);
          break;
        }
      Ue.length > 0 ? (Re.setState(function(ot) {
        return {
          lazyLoadedList: ot.lazyLoadedList.concat(Ue)
        };
      }), Re.props.onLazyLoad && Re.props.onLazyLoad(Ue)) : Re.lazyLoadTimer && (clearInterval(Re.lazyLoadTimer), delete Re.lazyLoadTimer);
    }), _defineProperty$2(_assertThisInitialized(Re), "slideHandler", function(Ue) {
      var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Ge = Re.props, Xe = Ge.asNavFor, ot = Ge.beforeChange, vt = Ge.onLazyLoad, bt = Ge.speed, Tt = Ge.afterChange, wt = Re.state.currentSlide, St = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: Ue
      }, Re.props), Re.state), {}, {
        trackRef: Re.track,
        useCSS: Re.props.useCSS && !qe
      })), It = St.state, Pt = St.nextState;
      if (It) {
        ot && ot(wt, It.currentSlide);
        var kt = It.lazyLoadedList.filter(function(Ot) {
          return Re.state.lazyLoadedList.indexOf(Ot) < 0;
        });
        vt && kt.length > 0 && vt(kt), !Re.props.waitForAnimate && Re.animationEndCallback && (clearTimeout(Re.animationEndCallback), Tt && Tt(wt), delete Re.animationEndCallback), Re.setState(It, function() {
          Xe && Re.asNavForIndex !== Ue && (Re.asNavForIndex = Ue, Xe.innerSlider.slideHandler(Ue)), Pt && (Re.animationEndCallback = setTimeout(function() {
            var Ot = Pt.animating, Jr = _objectWithoutProperties$1(Pt, ["animating"]);
            Re.setState(Jr, function() {
              Re.callbackTimers.push(setTimeout(function() {
                return Re.setState({
                  animating: Ot
                });
              }, 10)), Tt && Tt(It.currentSlide), delete Re.animationEndCallback;
            });
          }, bt));
        });
      }
    }), _defineProperty$2(_assertThisInitialized(Re), "changeSlide", function(Ue) {
      var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Ge = _objectSpread(_objectSpread({}, Re.props), Re.state), Xe = (0, _innerSliderUtils.changeSlide)(Ge, Ue);
      if (!(Xe !== 0 && !Xe) && (qe === !0 ? Re.slideHandler(Xe, qe) : Re.slideHandler(Xe), Re.props.autoplay && Re.autoPlay("update"), Re.props.focusOnSelect)) {
        var ot = Re.list.querySelectorAll(".slick-current");
        ot[0] && ot[0].focus();
      }
    }), _defineProperty$2(_assertThisInitialized(Re), "clickHandler", function(Ue) {
      Re.clickable === !1 && (Ue.stopPropagation(), Ue.preventDefault()), Re.clickable = !0;
    }), _defineProperty$2(_assertThisInitialized(Re), "keyHandler", function(Ue) {
      var qe = (0, _innerSliderUtils.keyHandler)(Ue, Re.props.accessibility, Re.props.rtl);
      qe !== "" && Re.changeSlide({
        message: qe
      });
    }), _defineProperty$2(_assertThisInitialized(Re), "selectHandler", function(Ue) {
      Re.changeSlide(Ue);
    }), _defineProperty$2(_assertThisInitialized(Re), "disableBodyScroll", function() {
      var Ue = function(Ge) {
        Ge = Ge || window.event, Ge.preventDefault && Ge.preventDefault(), Ge.returnValue = !1;
      };
      window.ontouchmove = Ue;
    }), _defineProperty$2(_assertThisInitialized(Re), "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), _defineProperty$2(_assertThisInitialized(Re), "swipeStart", function(Ue) {
      Re.props.verticalSwiping && Re.disableBodyScroll();
      var qe = (0, _innerSliderUtils.swipeStart)(Ue, Re.props.swipe, Re.props.draggable);
      qe !== "" && Re.setState(qe);
    }), _defineProperty$2(_assertThisInitialized(Re), "swipeMove", function(Ue) {
      var qe = (0, _innerSliderUtils.swipeMove)(Ue, _objectSpread(_objectSpread(_objectSpread({}, Re.props), Re.state), {}, {
        trackRef: Re.track,
        listRef: Re.list,
        slideIndex: Re.state.currentSlide
      }));
      qe && (qe.swiping && (Re.clickable = !1), Re.setState(qe));
    }), _defineProperty$2(_assertThisInitialized(Re), "swipeEnd", function(Ue) {
      var qe = (0, _innerSliderUtils.swipeEnd)(Ue, _objectSpread(_objectSpread(_objectSpread({}, Re.props), Re.state), {}, {
        trackRef: Re.track,
        listRef: Re.list,
        slideIndex: Re.state.currentSlide
      }));
      if (qe) {
        var Ge = qe.triggerSlideHandler;
        delete qe.triggerSlideHandler, Re.setState(qe), Ge !== void 0 && (Re.slideHandler(Ge), Re.props.verticalSwiping && Re.enableBodyScroll());
      }
    }), _defineProperty$2(_assertThisInitialized(Re), "touchEnd", function(Ue) {
      Re.swipeEnd(Ue), Re.clickable = !0;
    }), _defineProperty$2(_assertThisInitialized(Re), "slickPrev", function() {
      Re.callbackTimers.push(setTimeout(function() {
        return Re.changeSlide({
          message: "previous"
        });
      }, 0));
    }), _defineProperty$2(_assertThisInitialized(Re), "slickNext", function() {
      Re.callbackTimers.push(setTimeout(function() {
        return Re.changeSlide({
          message: "next"
        });
      }, 0));
    }), _defineProperty$2(_assertThisInitialized(Re), "slickGoTo", function(Ue) {
      var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (Ue = Number(Ue), isNaN(Ue)) return "";
      Re.callbackTimers.push(setTimeout(function() {
        return Re.changeSlide({
          message: "index",
          index: Ue,
          currentSlide: Re.state.currentSlide
        }, qe);
      }, 0));
    }), _defineProperty$2(_assertThisInitialized(Re), "play", function() {
      var Ue;
      if (Re.props.rtl)
        Ue = Re.state.currentSlide - Re.props.slidesToScroll;
      else if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, Re.props), Re.state)))
        Ue = Re.state.currentSlide + Re.props.slidesToScroll;
      else
        return !1;
      Re.slideHandler(Ue);
    }), _defineProperty$2(_assertThisInitialized(Re), "autoPlay", function(Ue) {
      Re.autoplayTimer && clearInterval(Re.autoplayTimer);
      var qe = Re.state.autoplaying;
      if (Ue === "update") {
        if (qe === "hovered" || qe === "focused" || qe === "paused")
          return;
      } else if (Ue === "leave") {
        if (qe === "paused" || qe === "focused")
          return;
      } else if (Ue === "blur" && (qe === "paused" || qe === "hovered"))
        return;
      Re.autoplayTimer = setInterval(Re.play, Re.props.autoplaySpeed + 50), Re.setState({
        autoplaying: "playing"
      });
    }), _defineProperty$2(_assertThisInitialized(Re), "pause", function(Ue) {
      Re.autoplayTimer && (clearInterval(Re.autoplayTimer), Re.autoplayTimer = null);
      var qe = Re.state.autoplaying;
      Ue === "paused" ? Re.setState({
        autoplaying: "paused"
      }) : Ue === "focused" ? (qe === "hovered" || qe === "playing") && Re.setState({
        autoplaying: "focused"
      }) : qe === "playing" && Re.setState({
        autoplaying: "hovered"
      });
    }), _defineProperty$2(_assertThisInitialized(Re), "onDotsOver", function() {
      return Re.props.autoplay && Re.pause("hovered");
    }), _defineProperty$2(_assertThisInitialized(Re), "onDotsLeave", function() {
      return Re.props.autoplay && Re.state.autoplaying === "hovered" && Re.autoPlay("leave");
    }), _defineProperty$2(_assertThisInitialized(Re), "onTrackOver", function() {
      return Re.props.autoplay && Re.pause("hovered");
    }), _defineProperty$2(_assertThisInitialized(Re), "onTrackLeave", function() {
      return Re.props.autoplay && Re.state.autoplaying === "hovered" && Re.autoPlay("leave");
    }), _defineProperty$2(_assertThisInitialized(Re), "onSlideFocus", function() {
      return Re.props.autoplay && Re.pause("focused");
    }), _defineProperty$2(_assertThisInitialized(Re), "onSlideBlur", function() {
      return Re.props.autoplay && Re.state.autoplaying === "focused" && Re.autoPlay("blur");
    }), _defineProperty$2(_assertThisInitialized(Re), "render", function() {
      var Ue = (0, _classnames.default)("slick-slider", Re.props.className, {
        "slick-vertical": Re.props.vertical,
        "slick-initialized": !0
      }), qe = _objectSpread(_objectSpread({}, Re.props), Re.state), Ge = (0, _innerSliderUtils.extractObject)(qe, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), Xe = Re.props.pauseOnHover;
      Ge = _objectSpread(_objectSpread({}, Ge), {}, {
        onMouseEnter: Xe ? Re.onTrackOver : null,
        onMouseLeave: Xe ? Re.onTrackLeave : null,
        onMouseOver: Xe ? Re.onTrackOver : null,
        focusOnSelect: Re.props.focusOnSelect && Re.clickable ? Re.selectHandler : null
      });
      var ot;
      if (Re.props.dots === !0 && Re.state.slideCount >= Re.props.slidesToShow) {
        var vt = (0, _innerSliderUtils.extractObject)(qe, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), bt = Re.props.pauseOnDotsHover;
        vt = _objectSpread(_objectSpread({}, vt), {}, {
          clickHandler: Re.changeSlide,
          onMouseEnter: bt ? Re.onDotsLeave : null,
          onMouseOver: bt ? Re.onDotsOver : null,
          onMouseLeave: bt ? Re.onDotsLeave : null
        }), ot = /* @__PURE__ */ _react.default.createElement(_dots.Dots, vt);
      }
      var Tt, wt, St = (0, _innerSliderUtils.extractObject)(qe, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      St.clickHandler = Re.changeSlide, Re.props.arrows && (Tt = /* @__PURE__ */ _react.default.createElement(_arrows.PrevArrow, St), wt = /* @__PURE__ */ _react.default.createElement(_arrows.NextArrow, St));
      var It = null;
      Re.props.vertical && (It = {
        height: Re.state.listHeight
      });
      var Pt = null;
      Re.props.vertical === !1 ? Re.props.centerMode === !0 && (Pt = {
        padding: "0px " + Re.props.centerPadding
      }) : Re.props.centerMode === !0 && (Pt = {
        padding: Re.props.centerPadding + " 0px"
      });
      var kt = _objectSpread(_objectSpread({}, It), Pt), Ot = Re.props.touchMove, Jr = {
        className: "slick-list",
        style: kt,
        onClick: Re.clickHandler,
        onMouseDown: Ot ? Re.swipeStart : null,
        onMouseMove: Re.state.dragging && Ot ? Re.swipeMove : null,
        onMouseUp: Ot ? Re.swipeEnd : null,
        onMouseLeave: Re.state.dragging && Ot ? Re.swipeEnd : null,
        onTouchStart: Ot ? Re.swipeStart : null,
        onTouchMove: Re.state.dragging && Ot ? Re.swipeMove : null,
        onTouchEnd: Ot ? Re.touchEnd : null,
        onTouchCancel: Re.state.dragging && Ot ? Re.swipeEnd : null,
        onKeyDown: Re.props.accessibility ? Re.keyHandler : null
      }, en = {
        className: Ue,
        dir: "ltr",
        style: Re.props.style
      };
      return Re.props.unslick && (Jr = {
        className: "slick-list"
      }, en = {
        className: Ue
      }), /* @__PURE__ */ _react.default.createElement("div", en, Re.props.unslick ? "" : Tt, /* @__PURE__ */ _react.default.createElement("div", _extends({
        ref: Re.listRefHandler
      }, Jr), /* @__PURE__ */ _react.default.createElement(_track.Track, _extends({
        ref: Re.trackRefHandler
      }, Ge), Re.props.children)), Re.props.unslick ? "" : wt, Re.props.unslick ? "" : ot);
    }), Re.list = null, Re.track = null, Re.state = _objectSpread(_objectSpread({}, _initialState.default), {}, {
      currentSlide: Re.props.initialSlide,
      targetSlide: Re.props.initialSlide ? Re.props.initialSlide : 0,
      slideCount: _react.default.Children.count(Re.props.children)
    }), Re.callbackTimers = [], Re.clickable = !0, Re.debouncedResize = null;
    var je = Re.ssrInit();
    return Re.state = _objectSpread(_objectSpread({}, Re.state), je), Re;
  }
  return _createClass(me, [{
    key: "didPropsChange",
    value: function(Re) {
      for (var je = !1, Ue = 0, qe = Object.keys(this.props); Ue < qe.length; Ue++) {
        var Ge = qe[Ue];
        if (!Re.hasOwnProperty(Ge)) {
          je = !0;
          break;
        }
        if (!(_typeof$1(Re[Ge]) === "object" || typeof Re[Ge] == "function" || isNaN(Re[Ge])) && Re[Ge] !== this.props[Ge]) {
          je = !0;
          break;
        }
      }
      return je || _react.default.Children.count(this.props.children) !== _react.default.Children.count(Re.children);
    }
  }]), me;
}(_react.default.Component);
var camel2hyphen$1 = function(ce) {
  return ce.replace(/[A-Z]/g, function(ie) {
    return "-" + ie.toLowerCase();
  }).toLowerCase();
}, camel2hyphen_1 = camel2hyphen$1, camel2hyphen = camel2hyphen_1, isDimension = function(ce) {
  var ie = /[height|width]$/;
  return ie.test(ce);
}, obj2mq = function(ce) {
  var ie = "", me = Object.keys(ce);
  return me.forEach(function(we, Re) {
    var je = ce[we];
    we = camel2hyphen(we), isDimension(we) && typeof je == "number" && (je = je + "px"), je === !0 ? ie += we : je === !1 ? ie += "not " + we : ie += "(" + we + ": " + je + ")", Re < me.length - 1 && (ie += " and ");
  }), ie;
}, json2mq = function(ce) {
  var ie = "";
  return typeof ce == "string" ? ce : ce instanceof Array ? (ce.forEach(function(me, we) {
    ie += obj2mq(me), we < ce.length - 1 && (ie += ", ");
  }), ie) : obj2mq(ce);
}, json2mq_1 = json2mq, QueryHandler_1, hasRequiredQueryHandler;
function requireQueryHandler() {
  if (hasRequiredQueryHandler) return QueryHandler_1;
  hasRequiredQueryHandler = 1;
  function ce(ie) {
    this.options = ie, !ie.deferSetup && this.setup();
  }
  return ce.prototype = {
    constructor: ce,
    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function() {
      this.options.setup && this.options.setup(), this.initialised = !0;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function() {
      !this.initialised && this.setup(), this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function() {
      this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function() {
      this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function(ie) {
      return this.options === ie || this.options.match === ie;
    }
  }, QueryHandler_1 = ce, QueryHandler_1;
}
var Util, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return Util;
  hasRequiredUtil = 1;
  function ce(we, Re) {
    var je = 0, Ue = we.length, qe;
    for (je; je < Ue && (qe = Re(we[je], je), qe !== !1); je++)
      ;
  }
  function ie(we) {
    return Object.prototype.toString.apply(we) === "[object Array]";
  }
  function me(we) {
    return typeof we == "function";
  }
  return Util = {
    isFunction: me,
    isArray: ie,
    each: ce
  }, Util;
}
var MediaQuery_1, hasRequiredMediaQuery;
function requireMediaQuery() {
  if (hasRequiredMediaQuery) return MediaQuery_1;
  hasRequiredMediaQuery = 1;
  var ce = requireQueryHandler(), ie = requireUtil().each;
  function me(we, Re) {
    this.query = we, this.isUnconditional = Re, this.handlers = [], this.mql = window.matchMedia(we);
    var je = this;
    this.listener = function(Ue) {
      je.mql = Ue.currentTarget || Ue, je.assess();
    }, this.mql.addListener(this.listener);
  }
  return me.prototype = {
    constuctor: me,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function(we) {
      var Re = new ce(we);
      this.handlers.push(Re), this.matches() && Re.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function(we) {
      var Re = this.handlers;
      ie(Re, function(je, Ue) {
        if (je.equals(we))
          return je.destroy(), !Re.splice(Ue, 1);
      });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function() {
      return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */
    clear: function() {
      ie(this.handlers, function(we) {
        we.destroy();
      }), this.mql.removeListener(this.listener), this.handlers.length = 0;
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function() {
      var we = this.matches() ? "on" : "off";
      ie(this.handlers, function(Re) {
        Re[we]();
      });
    }
  }, MediaQuery_1 = me, MediaQuery_1;
}
var MediaQueryDispatch_1, hasRequiredMediaQueryDispatch;
function requireMediaQueryDispatch() {
  if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
  hasRequiredMediaQueryDispatch = 1;
  var ce = requireMediaQuery(), ie = requireUtil(), me = ie.each, we = ie.isFunction, Re = ie.isArray;
  function je() {
    if (!window.matchMedia)
      throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches;
  }
  return je.prototype = {
    constructor: je,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function(Ue, qe, Ge) {
      var Xe = this.queries, ot = Ge && this.browserIsIncapable;
      return Xe[Ue] || (Xe[Ue] = new ce(Ue, ot)), we(qe) && (qe = { match: qe }), Re(qe) || (qe = [qe]), me(qe, function(vt) {
        we(vt) && (vt = { match: vt }), Xe[Ue].addHandler(vt);
      }), this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function(Ue, qe) {
      var Ge = this.queries[Ue];
      return Ge && (qe ? Ge.removeHandler(qe) : (Ge.clear(), delete this.queries[Ue])), this;
    }
  }, MediaQueryDispatch_1 = je, MediaQueryDispatch_1;
}
var src, hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  var ce = requireMediaQueryDispatch();
  return src = new ce(), src;
}
(function(ce) {
  Object.defineProperty(ce, "__esModule", {
    value: !0
  }), ce.default = void 0;
  var ie = Ue(React__default), me = innerSlider, we = Ue(json2mq_1), Re = Ue(defaultProps), je = innerSliderUtils;
  function Ue(vn) {
    return vn && vn.__esModule ? vn : { default: vn };
  }
  function qe(vn) {
    "@babel/helpers - typeof";
    return qe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Tn) {
      return typeof Tn;
    } : function(Tn) {
      return Tn && typeof Symbol == "function" && Tn.constructor === Symbol && Tn !== Symbol.prototype ? "symbol" : typeof Tn;
    }, qe(vn);
  }
  function Ge() {
    return Ge = Object.assign ? Object.assign.bind() : function(vn) {
      for (var Tn = 1; Tn < arguments.length; Tn++) {
        var xn = arguments[Tn];
        for (var bn in xn)
          Object.prototype.hasOwnProperty.call(xn, bn) && (vn[bn] = xn[bn]);
      }
      return vn;
    }, Ge.apply(this, arguments);
  }
  function Xe(vn, Tn) {
    var xn = Object.keys(vn);
    if (Object.getOwnPropertySymbols) {
      var bn = Object.getOwnPropertySymbols(vn);
      Tn && (bn = bn.filter(function(Sn) {
        return Object.getOwnPropertyDescriptor(vn, Sn).enumerable;
      })), xn.push.apply(xn, bn);
    }
    return xn;
  }
  function ot(vn) {
    for (var Tn = 1; Tn < arguments.length; Tn++) {
      var xn = arguments[Tn] != null ? arguments[Tn] : {};
      Tn % 2 ? Xe(Object(xn), !0).forEach(function(bn) {
        en(vn, bn, xn[bn]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(vn, Object.getOwnPropertyDescriptors(xn)) : Xe(Object(xn)).forEach(function(bn) {
        Object.defineProperty(vn, bn, Object.getOwnPropertyDescriptor(xn, bn));
      });
    }
    return vn;
  }
  function vt(vn, Tn) {
    if (!(vn instanceof Tn))
      throw new TypeError("Cannot call a class as a function");
  }
  function bt(vn, Tn) {
    for (var xn = 0; xn < Tn.length; xn++) {
      var bn = Tn[xn];
      bn.enumerable = bn.enumerable || !1, bn.configurable = !0, "value" in bn && (bn.writable = !0), Object.defineProperty(vn, nn(bn.key), bn);
    }
  }
  function Tt(vn, Tn, xn) {
    return Tn && bt(vn.prototype, Tn), Object.defineProperty(vn, "prototype", { writable: !1 }), vn;
  }
  function wt(vn, Tn) {
    if (typeof Tn != "function" && Tn !== null)
      throw new TypeError("Super expression must either be null or a function");
    vn.prototype = Object.create(Tn && Tn.prototype, { constructor: { value: vn, writable: !0, configurable: !0 } }), Object.defineProperty(vn, "prototype", { writable: !1 }), Tn && St(vn, Tn);
  }
  function St(vn, Tn) {
    return St = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(bn, Sn) {
      return bn.__proto__ = Sn, bn;
    }, St(vn, Tn);
  }
  function It(vn) {
    var Tn = Ot();
    return function() {
      var bn = Jr(vn), Sn;
      if (Tn) {
        var Cn = Jr(this).constructor;
        Sn = Reflect.construct(bn, arguments, Cn);
      } else
        Sn = bn.apply(this, arguments);
      return Pt(this, Sn);
    };
  }
  function Pt(vn, Tn) {
    if (Tn && (qe(Tn) === "object" || typeof Tn == "function"))
      return Tn;
    if (Tn !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return kt(vn);
  }
  function kt(vn) {
    if (vn === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return vn;
  }
  function Ot() {
    try {
      var vn = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (Ot = function() {
      return !!vn;
    })();
  }
  function Jr(vn) {
    return Jr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(xn) {
      return xn.__proto__ || Object.getPrototypeOf(xn);
    }, Jr(vn);
  }
  function en(vn, Tn, xn) {
    return Tn = nn(Tn), Tn in vn ? Object.defineProperty(vn, Tn, { value: xn, enumerable: !0, configurable: !0, writable: !0 }) : vn[Tn] = xn, vn;
  }
  function nn(vn) {
    var Tn = ln(vn, "string");
    return qe(Tn) == "symbol" ? Tn : String(Tn);
  }
  function ln(vn, Tn) {
    if (qe(vn) != "object" || !vn) return vn;
    var xn = vn[Symbol.toPrimitive];
    if (xn !== void 0) {
      var bn = xn.call(vn, Tn);
      if (qe(bn) != "object") return bn;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Tn === "string" ? String : Number)(vn);
  }
  var fn = (0, je.canUseDOM)() && requireSrc();
  ce.default = /* @__PURE__ */ function(vn) {
    wt(xn, vn);
    var Tn = It(xn);
    function xn(bn) {
      var Sn;
      return vt(this, xn), Sn = Tn.call(this, bn), en(kt(Sn), "innerSliderRefHandler", function(Cn) {
        return Sn.innerSlider = Cn;
      }), en(kt(Sn), "slickPrev", function() {
        return Sn.innerSlider.slickPrev();
      }), en(kt(Sn), "slickNext", function() {
        return Sn.innerSlider.slickNext();
      }), en(kt(Sn), "slickGoTo", function(Cn) {
        var kn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return Sn.innerSlider.slickGoTo(Cn, kn);
      }), en(kt(Sn), "slickPause", function() {
        return Sn.innerSlider.pause("paused");
      }), en(kt(Sn), "slickPlay", function() {
        return Sn.innerSlider.autoPlay("play");
      }), Sn.state = {
        breakpoint: null
      }, Sn.onInnerResize = Sn.onInnerResize.bind(kt(Sn)), Sn._responsiveMediaHandlers = [], Sn;
    }
    return Tt(xn, [{
      key: "media",
      value: function(Sn, Cn) {
        fn.register(Sn, Cn), this._responsiveMediaHandlers.push({
          query: Sn,
          handler: Cn
        });
      }
      // handles responsive breakpoints
    }, {
      key: "componentDidMount",
      value: function() {
        var Sn = this;
        if (this.props.responsive) {
          var Cn = this.props.responsive.map(function(cn) {
            return cn.breakpoint;
          });
          Cn.sort(function(cn, gn) {
            return cn - gn;
          }), Cn.forEach(function(cn, gn) {
            var an;
            gn === 0 ? an = (0, we.default)({
              minWidth: 0,
              maxWidth: cn
            }) : an = (0, we.default)({
              minWidth: Cn[gn - 1] + 1,
              maxWidth: cn
            }), (0, je.canUseDOM)() && Sn.media(an, function() {
              Sn.setState({
                breakpoint: cn
              });
            });
          });
          var kn = (0, we.default)({
            minWidth: Cn.slice(-1)[0]
          });
          (0, je.canUseDOM)() && this.media(kn, function() {
            Sn.setState({
              breakpoint: null
            });
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._responsiveMediaHandlers.forEach(function(Sn) {
          fn.unregister(Sn.query, Sn.handler);
        });
      }
    }, {
      key: "onInnerResize",
      value: function(Sn) {
        var Cn = this, kn = this.props.responsive;
        if (kn && Sn) {
          var cn = Sn.width, gn = kn.map(function(an) {
            return an.breakpoint;
          }).sort(function(an, un) {
            return an - un;
          }).find(function(an) {
            return an >= cn;
          });
          Cn.setState({
            breakpoint: gn
          });
        }
      }
    }, {
      key: "render",
      value: function() {
        var Sn = this, Cn, kn;
        this.state.breakpoint ? (kn = this.props.responsive.filter(function(si) {
          return si.breakpoint === Sn.state.breakpoint;
        }), Cn = kn[0].settings === "unslick" ? "unslick" : ot(ot(ot({}, Re.default), this.props), kn[0].settings)) : Cn = ot(ot({}, Re.default), this.props), Cn.centerMode && (Cn.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(Cn.slidesToScroll)), Cn.slidesToScroll = 1), Cn.fade && (Cn.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(Cn.slidesToShow)), Cn.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(Cn.slidesToScroll)), Cn.slidesToShow = 1, Cn.slidesToScroll = 1);
        var cn = ie.default.Children.toArray(this.props.children);
        cn = cn.filter(function(si) {
          return typeof si == "string" ? !!si.trim() : !!si;
        }), Cn.variableWidth && (Cn.rows > 1 || Cn.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), Cn.variableWidth = !1);
        for (var gn = [], an = null, un = 0; un < cn.length; un += Cn.rows * Cn.slidesPerRow) {
          for (var pn = [], hn = un; hn < un + Cn.rows * Cn.slidesPerRow; hn += Cn.slidesPerRow) {
            for (var An = [], In = hn; In < hn + Cn.slidesPerRow && (Cn.variableWidth && cn[In].props.style && (an = cn[In].props.style.width), !(In >= cn.length)); In += 1)
              An.push(/* @__PURE__ */ ie.default.cloneElement(cn[In], {
                key: 100 * un + 10 * hn + In,
                tabIndex: -1,
                style: {
                  width: "".concat(100 / Cn.slidesPerRow, "%"),
                  display: "inline-block"
                }
              }));
            pn.push(/* @__PURE__ */ ie.default.createElement("div", {
              key: 10 * un + hn
            }, An));
          }
          Cn.variableWidth ? gn.push(/* @__PURE__ */ ie.default.createElement("div", {
            key: un,
            style: {
              width: an
            }
          }, pn)) : gn.push(/* @__PURE__ */ ie.default.createElement("div", {
            key: un
          }, pn));
        }
        if (Cn === "unslick") {
          var qn = "regular slider " + (this.props.className || "");
          return /* @__PURE__ */ ie.default.createElement("div", {
            className: qn
          }, cn);
        } else gn.length <= Cn.slidesToShow && !Cn.infinite && (Cn.unslick = !0);
        return /* @__PURE__ */ ie.default.createElement(me.InnerSlider, Ge({
          style: this.props.style,
          ref: this.innerSliderRefHandler,
          onResize: this.onInnerResize
        }, (0, je.filterSettings)(Cn)), gn);
      }
    }]), xn;
  }(ie.default.Component);
})(slider);
(function(ce) {
  Object.defineProperty(ce, "__esModule", {
    value: !0
  }), ce.default = void 0;
  var ie = me(slider);
  function me(we) {
    return we && we.__esModule ? we : { default: we };
  }
  ce.default = ie.default;
})(lib);
const Slider = /* @__PURE__ */ getDefaultExportFromCjs(lib), TabSelector = ({
  children: ce,
  fullWidth: ie = !1,
  disabled: me = !1,
  vertical: we = !1
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames(
      "group flex justify-between p-1 border-solid bg-surface border-1 border-stroke rounded-2 select-none",
      { "w-full": ie },
      { "w-fit": !ie },
      { "opacity-70 pointer-events-none": me },
      { "flex-row items-center": !we },
      { "flex-col items-start": we }
    ),
    children: ce
  }
);
TabSelector.Item = TabSelectorItem;
const SLICK_ANIMATION_SPEED = 100, DEFAULT_RESPONSIVE_OBJECTS = [
  {
    breakpoint: 320,
    settings: {
      slidesToShow: 1
    }
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 3
    }
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 5
    }
  }
], TabHeaderSlider = forwardRef((ce, ie) => {
  const {
    tabs: me,
    onAnimationChange: we,
    maxVisibleTabs: Re = 5,
    responsive: je = DEFAULT_RESPONSIVE_OBJECTS,
    onIndexChanged: Ue
  } = ce, qe = React__default.useRef(), [Ge, Xe] = useState(!1), ot = useCallback(() => {
    Xe(!0), we == null || we(!0);
    const bt = setTimeout(() => {
      Xe(!1), we == null || we(!1);
    }, SLICK_ANIMATION_SPEED + 20);
    return () => clearTimeout(bt);
  }, [we]), vt = useCallback(() => {
    var Tt, wt;
    const bt = (Tt = qe.current) == null ? void 0 : Tt.state.breakpoint;
    return ((wt = je.find(
      (St) => St.breakpoint === bt
      // @ts-expect-error settings might be as well string "unslick" and i do not want bother with it now
    )) == null ? void 0 : wt.settings.slidesToShow) ?? Re;
  }, [je, Re]);
  return useImperativeHandle(ie, () => ({
    slideTo: (bt) => {
      var Tt;
      (Tt = qe.current) == null || Tt.slickGoTo(bt - Math.floor(vt() / 2)), ot();
    }
  }), [qe, vt, ot]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "tab-header-slider", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabSelector, { fullWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slider,
    {
      className: classNames("flex justify-center content-center overflow-hidden grow-1 relative"),
      slidesToShow: Math.min(me.length, Re),
      slidesToScroll: 1,
      infinite: !1,
      cssEase: "ease-in-out",
      arrows: !1,
      centerPadding: "0px",
      speed: SLICK_ANIMATION_SPEED,
      centerMode: !1,
      responsive: je,
      swipeToSlide: !0,
      ref: (bt) => {
        bt && (qe.current = bt);
      },
      afterChange: (bt) => {
        Ue == null || Ue(bt, vt());
      },
      children: me
    }
  ) }) });
});
let e = { data: "" }, t = (ce) => typeof window == "object" ? ((ce ? ce.querySelector("#_goober") : window._goober) || Object.assign((ce || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : ce || e, l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, a = /\/\*[^]*?\*\/|  +/g, n = /\n+/g, o = (ce, ie) => {
  let me = "", we = "", Re = "";
  for (let je in ce) {
    let Ue = ce[je];
    je[0] == "@" ? je[1] == "i" ? me = je + " " + Ue + ";" : we += je[1] == "f" ? o(Ue, je) : je + "{" + o(Ue, je[1] == "k" ? "" : ie) + "}" : typeof Ue == "object" ? we += o(Ue, ie ? ie.replace(/([^,])+/g, (qe) => je.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (Ge) => /&/.test(Ge) ? Ge.replace(/&/g, qe) : qe ? qe + " " + Ge : Ge)) : je) : Ue != null && (je = /^--/.test(je) ? je : je.replace(/[A-Z]/g, "-$&").toLowerCase(), Re += o.p ? o.p(je, Ue) : je + ":" + Ue + ";");
  }
  return me + (ie && Re ? ie + "{" + Re + "}" : Re) + we;
}, c$1 = {}, s = (ce) => {
  if (typeof ce == "object") {
    let ie = "";
    for (let me in ce) ie += me + s(ce[me]);
    return ie;
  }
  return ce;
}, i = (ce, ie, me, we, Re) => {
  let je = s(ce), Ue = c$1[je] || (c$1[je] = ((Ge) => {
    let Xe = 0, ot = 11;
    for (; Xe < Ge.length; ) ot = 101 * ot + Ge.charCodeAt(Xe++) >>> 0;
    return "go" + ot;
  })(je));
  if (!c$1[Ue]) {
    let Ge = je !== ce ? ce : ((Xe) => {
      let ot, vt, bt = [{}];
      for (; ot = l.exec(Xe.replace(a, "")); ) ot[4] ? bt.shift() : ot[3] ? (vt = ot[3].replace(n, " ").trim(), bt.unshift(bt[0][vt] = bt[0][vt] || {})) : bt[0][ot[1]] = ot[2].replace(n, " ").trim();
      return bt[0];
    })(ce);
    c$1[Ue] = o(Re ? { ["@keyframes " + Ue]: Ge } : Ge, me ? "" : "." + Ue);
  }
  let qe = me && c$1.g ? c$1.g : null;
  return me && (c$1.g = c$1[Ue]), ((Ge, Xe, ot, vt) => {
    vt ? Xe.data = Xe.data.replace(vt, Ge) : Xe.data.indexOf(Ge) === -1 && (Xe.data = ot ? Ge + Xe.data : Xe.data + Ge);
  })(c$1[Ue], ie, we, qe), Ue;
}, p = (ce, ie, me) => ce.reduce((we, Re, je) => {
  let Ue = ie[je];
  if (Ue && Ue.call) {
    let qe = Ue(me), Ge = qe && qe.props && qe.props.className || /^go/.test(qe) && qe;
    Ue = Ge ? "." + Ge : qe && typeof qe == "object" ? qe.props ? "" : o(qe, "") : qe === !1 ? "" : qe;
  }
  return we + Re + (Ue ?? "");
}, "");
function u$1(ce) {
  let ie = this || {}, me = ce.call ? ce(ie.p) : ce;
  return i(me.unshift ? me.raw ? p(me, [].slice.call(arguments, 1), ie.p) : me.reduce((we, Re) => Object.assign(we, Re && Re.call ? Re(ie.p) : Re), {}) : me, t(ie.target), ie.g, ie.o, ie.k);
}
let d, f$1, g;
u$1.bind({ g: 1 });
let h$1 = u$1.bind({ k: 1 });
function m(ce, ie, me, we) {
  o.p = ie, d = ce, f$1 = me, g = we;
}
function j(ce, ie) {
  let me = this || {};
  return function() {
    let we = arguments;
    function Re(je, Ue) {
      let qe = Object.assign({}, je), Ge = qe.className || Re.className;
      me.p = Object.assign({ theme: f$1 && f$1() }, qe), me.o = / *go\d+/.test(Ge), qe.className = u$1.apply(me, we) + (Ge ? " " + Ge : "");
      let Xe = ce;
      return ce[0] && (Xe = qe.as || ce, delete qe.as), g && Xe[0] && g(qe), d(Xe, qe);
    }
    return Re;
  };
}
var W = (ce) => typeof ce == "function", f = (ce, ie) => W(ce) ? ce(ie) : ce, F = /* @__PURE__ */ (() => {
  let ce = 0;
  return () => (++ce).toString();
})(), A = /* @__PURE__ */ (() => {
  let ce;
  return () => {
    if (ce === void 0 && typeof window < "u") {
      let ie = matchMedia("(prefers-reduced-motion: reduce)");
      ce = !ie || ie.matches;
    }
    return ce;
  };
})(), Y = 20, U = (ce, ie) => {
  switch (ie.type) {
    case 0:
      return { ...ce, toasts: [ie.toast, ...ce.toasts].slice(0, Y) };
    case 1:
      return { ...ce, toasts: ce.toasts.map((je) => je.id === ie.toast.id ? { ...je, ...ie.toast } : je) };
    case 2:
      let { toast: me } = ie;
      return U(ce, { type: ce.toasts.find((je) => je.id === me.id) ? 1 : 0, toast: me });
    case 3:
      let { toastId: we } = ie;
      return { ...ce, toasts: ce.toasts.map((je) => je.id === we || we === void 0 ? { ...je, dismissed: !0, visible: !1 } : je) };
    case 4:
      return ie.toastId === void 0 ? { ...ce, toasts: [] } : { ...ce, toasts: ce.toasts.filter((je) => je.id !== ie.toastId) };
    case 5:
      return { ...ce, pausedAt: ie.time };
    case 6:
      let Re = ie.time - (ce.pausedAt || 0);
      return { ...ce, pausedAt: void 0, toasts: ce.toasts.map((je) => ({ ...je, pauseDuration: je.pauseDuration + Re })) };
  }
}, P = [], y = { toasts: [], pausedAt: void 0 }, u = (ce) => {
  y = U(y, ce), P.forEach((ie) => {
    ie(y);
  });
}, q = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, D = (ce = {}) => {
  let [ie, me] = useState(y), we = useRef(y);
  useEffect(() => (we.current !== y && me(y), P.push(me), () => {
    let je = P.indexOf(me);
    je > -1 && P.splice(je, 1);
  }), []);
  let Re = ie.toasts.map((je) => {
    var Ue, qe, Ge;
    return { ...ce, ...ce[je.type], ...je, removeDelay: je.removeDelay || ((Ue = ce[je.type]) == null ? void 0 : Ue.removeDelay) || (ce == null ? void 0 : ce.removeDelay), duration: je.duration || ((qe = ce[je.type]) == null ? void 0 : qe.duration) || (ce == null ? void 0 : ce.duration) || q[je.type], style: { ...ce.style, ...(Ge = ce[je.type]) == null ? void 0 : Ge.style, ...je.style } };
  });
  return { ...ie, toasts: Re };
}, J = (ce, ie = "blank", me) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: ie, ariaProps: { role: "status", "aria-live": "polite" }, message: ce, pauseDuration: 0, ...me, id: (me == null ? void 0 : me.id) || F() }), x = (ce) => (ie, me) => {
  let we = J(ie, ce, me);
  return u({ type: 2, toast: we }), we.id;
}, c = (ce, ie) => x("blank")(ce, ie);
c.error = x("error");
c.success = x("success");
c.loading = x("loading");
c.custom = x("custom");
c.dismiss = (ce) => {
  u({ type: 3, toastId: ce });
};
c.remove = (ce) => u({ type: 4, toastId: ce });
c.promise = (ce, ie, me) => {
  let we = c.loading(ie.loading, { ...me, ...me == null ? void 0 : me.loading });
  return typeof ce == "function" && (ce = ce()), ce.then((Re) => {
    let je = ie.success ? f(ie.success, Re) : void 0;
    return je ? c.success(je, { id: we, ...me, ...me == null ? void 0 : me.success }) : c.dismiss(we), Re;
  }).catch((Re) => {
    let je = ie.error ? f(ie.error, Re) : void 0;
    je ? c.error(je, { id: we, ...me, ...me == null ? void 0 : me.error }) : c.dismiss(we);
  }), ce;
};
var K = (ce, ie) => {
  u({ type: 1, toast: { id: ce, height: ie } });
}, X = () => {
  u({ type: 5, time: Date.now() });
}, b = /* @__PURE__ */ new Map(), Z = 1e3, ee = (ce, ie = Z) => {
  if (b.has(ce)) return;
  let me = setTimeout(() => {
    b.delete(ce), u({ type: 4, toastId: ce });
  }, ie);
  b.set(ce, me);
}, O = (ce) => {
  let { toasts: ie, pausedAt: me } = D(ce);
  useEffect(() => {
    if (me) return;
    let je = Date.now(), Ue = ie.map((qe) => {
      if (qe.duration === 1 / 0) return;
      let Ge = (qe.duration || 0) + qe.pauseDuration - (je - qe.createdAt);
      if (Ge < 0) {
        qe.visible && c.dismiss(qe.id);
        return;
      }
      return setTimeout(() => c.dismiss(qe.id), Ge);
    });
    return () => {
      Ue.forEach((qe) => qe && clearTimeout(qe));
    };
  }, [ie, me]);
  let we = useCallback(() => {
    me && u({ type: 6, time: Date.now() });
  }, [me]), Re = useCallback((je, Ue) => {
    let { reverseOrder: qe = !1, gutter: Ge = 8, defaultPosition: Xe } = Ue || {}, ot = ie.filter((Tt) => (Tt.position || Xe) === (je.position || Xe) && Tt.height), vt = ot.findIndex((Tt) => Tt.id === je.id), bt = ot.filter((Tt, wt) => wt < vt && Tt.visible).length;
    return ot.filter((Tt) => Tt.visible).slice(...qe ? [bt + 1] : [0, bt]).reduce((Tt, wt) => Tt + (wt.height || 0) + Ge, 0);
  }, [ie]);
  return useEffect(() => {
    ie.forEach((je) => {
      if (je.dismissed) ee(je.id, je.removeDelay);
      else {
        let Ue = b.get(je.id);
        Ue && (clearTimeout(Ue), b.delete(je.id));
      }
    });
  }, [ie]), { toasts: ie, handlers: { updateHeight: K, startPause: X, endPause: we, calculateOffset: Re } };
}, oe = h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, re = h$1`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, se = h$1`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, k = j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(ce) => ce.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${re} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(ce) => ce.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${se} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, ne = h$1`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, V = j("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(ce) => ce.secondary || "#e0e0e0"};
  border-right-color: ${(ce) => ce.primary || "#616161"};
  animation: ${ne} 1s linear infinite;
`, pe = h$1`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, de = h$1`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, _ = j("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(ce) => ce.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${pe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${de} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(ce) => ce.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, ue = j("div")`
  position: absolute;
`, le = j("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, fe = h$1`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Te = j("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${fe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, M = ({ toast: ce }) => {
  let { icon: ie, type: me, iconTheme: we } = ce;
  return ie !== void 0 ? typeof ie == "string" ? React.createElement(Te, null, ie) : ie : me === "blank" ? null : React.createElement(le, null, React.createElement(V, { ...we }), me !== "loading" && React.createElement(ue, null, me === "error" ? React.createElement(k, { ...we }) : React.createElement(_, { ...we })));
}, ye$1 = (ce) => `
0% {transform: translate3d(0,${ce * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, ge = (ce) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${ce * -150}%,-1px) scale(.6); opacity:0;}
`, he = "0%{opacity:0;} 100%{opacity:1;}", xe = "0%{opacity:1;} 100%{opacity:0;}", be = j("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Se = j("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Ae = (ce, ie) => {
  let me = ce.includes("top") ? 1 : -1, [we, Re] = A() ? [he, xe] : [ye$1(me), ge(me)];
  return { animation: ie ? `${h$1(we)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${h$1(Re)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, C = React.memo(({ toast: ce, position: ie, style: me, children: we }) => {
  let Re = ce.height ? Ae(ce.position || ie || "top-center", ce.visible) : { opacity: 0 }, je = React.createElement(M, { toast: ce }), Ue = React.createElement(Se, { ...ce.ariaProps }, f(ce.message, ce));
  return React.createElement(be, { className: ce.className, style: { ...Re, ...me, ...ce.style } }, typeof we == "function" ? we({ icon: je, message: Ue }) : React.createElement(React.Fragment, null, je, Ue));
});
m(React.createElement);
var ve = ({ id: ce, className: ie, style: me, onHeightUpdate: we, children: Re }) => {
  let je = React.useCallback((Ue) => {
    if (Ue) {
      let qe = () => {
        let Ge = Ue.getBoundingClientRect().height;
        we(ce, Ge);
      };
      qe(), new MutationObserver(qe).observe(Ue, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [ce, we]);
  return React.createElement("div", { ref: je, className: ie, style: me }, Re);
}, Ee = (ce, ie) => {
  let me = ce.includes("top"), we = me ? { top: 0 } : { bottom: 0 }, Re = ce.includes("center") ? { justifyContent: "center" } : ce.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: A() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${ie * (me ? 1 : -1)}px)`, ...we, ...Re };
}, De = u$1`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, R = 16, Oe = ({ reverseOrder: ce, position: ie = "top-center", toastOptions: me, gutter: we, children: Re, containerStyle: je, containerClassName: Ue }) => {
  let { toasts: qe, handlers: Ge } = O(me);
  return React.createElement("div", { id: "_rht_toaster", style: { position: "fixed", zIndex: 9999, top: R, left: R, right: R, bottom: R, pointerEvents: "none", ...je }, className: Ue, onMouseEnter: Ge.startPause, onMouseLeave: Ge.endPause }, qe.map((Xe) => {
    let ot = Xe.position || ie, vt = Ge.calculateOffset(Xe, { reverseOrder: ce, gutter: we, defaultPosition: ie }), bt = Ee(ot, vt);
    return React.createElement(ve, { id: Xe.id, key: Xe.id, onHeightUpdate: Ge.updateHeight, className: Xe.visible ? De : "", style: bt }, Xe.type === "custom" ? f(Xe.message, Xe) : Re ? Re(Xe) : React.createElement(C, { toast: Xe, position: ot }));
  }));
}, Vt = c;
const variantToIcon = (ce, ie) => {
  switch (ce) {
    case "success":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie || faCheckCircle, className: "h-5 w-5 text-green-500", "aria-hidden": "true" });
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie || faInfoCircle, className: "h-5 w-5 text-blue-500", "aria-hidden": "true" });
    case "error":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie || faExclamationCircle, className: "h-5 w-5 text-red-500", "aria-hidden": "true" });
    case "warning":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie || faTriangleExclamation, className: "h-5 w-5 text-accent", "aria-hidden": "true" });
  }
}, variantToClassName = {
  success: "text-green-500",
  info: "text-blue-500",
  error: "text-red-500",
  warning: "text-accent"
}, ToastNotification = ({
  title: ce,
  description: ie,
  variant: me,
  icon: we,
  action: Re,
  hideCloseButton: je,
  darkMode: Ue,
  visible: qe,
  onDismiss: Ge
}) => (useOnMount(() => () => {
  Ge == null || Ge();
}), /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames(
      "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 border-1",
      Ue ? "bg-gray-900 border-gray-650" : "bg-white border-gray-350",
      { "animate-fade-in animate-duration-300 animate-ease opacity-100": qe },
      { "animate-fade-out animate-duration-300 animate-ease opacity-0": !qe }
    ),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-shrink-0 pt-0.5", children: variantToIcon(me, we) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-3 w-0 flex-1 pt-0.5", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: classNames("text-sm font-semibold ", Ue ? "text-gray-100" : "text-gray-900"), children: ce }),
        ie && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: classNames("mt-1 text-sm", Ue ? "text-gray-350" : "text-gray-600"), children: ie }),
        Re && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: classNames("text-sm font-semibold mt-2 cursor-pointer", variantToClassName[me]),
            onClick: Re.onClick,
            children: Re.label
          }
        )
      ] }),
      je !== !0 && !!Ge && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-4 flex flex-shrink-0", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          className: "inline-flex rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-grey-500 focus:ring-offset-2",
          onClick: Ge,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Close" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faClose, className: "h-5 w-5", "aria-hidden": "true" })
          ]
        }
      ) })
    ] }) })
  }
)), Toaster = ({ position: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Oe, { position: ce || "top-right" }), PlayButtonTooltip = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Tooltip,
  {
    trigger: ["hover"],
    bodyText: ce.isPlaying ? ce.tooltipTextPause : ce.tooltipTextPlay,
    placement: "top",
    mouseEnterDelay: 1,
    children: ce.children
  }
);
var PlayStatus = /* @__PURE__ */ ((ce) => (ce.Playing = "Playing", ce.NotStartedOrPaused = "NotStartedOrPaused", ce.Finished = "Finished", ce))(PlayStatus || {});
const calculateIcon = (ce) => {
  switch (ce) {
    case "Playing":
      return faPause;
    case "Finished":
      return faUndoAlt;
    case "NotStartedOrPaused":
      return faPlay;
  }
}, PlayButton = (ce) => (
  // offset for the countdown
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: ce.disableOffset ? "" : "mt-7", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    PlayButtonTooltip,
    {
      isPlaying: ce.playStatus === "Playing",
      tooltipTextPlay: ce.tooltipTextPlay,
      tooltipTextPause: ce.tooltipTextPause,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoundButton,
        {
          content: { type: "icon", icon: calculateIcon(ce.playStatus) },
          color: ce.playStatus === "NotStartedOrPaused" ? RoundButtonColor.Yellow : RoundButtonColor.Default,
          showLabel: !0,
          ...ce
        }
      )
    }
  ) })
), RewindButton = ({ rewindTime: ce, direction: ie = "rewind", ...me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RoundButton,
  {
    content: {
      type: "text",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: ie === "rewind" ? faUndoAlt : faRedoAlt }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: classNames("absolute text-8px top-8px bg-inherit line-height-15px px-3px", {
              "right-8px": ie === "rewind",
              "left-8px": ie === "forward"
            }),
            children: ce
          }
        )
      ] })
    },
    ...me
  }
), REWIND_TIME_SEC = 5, WidgetAudioPlayer = ({
  src: ce,
  title: ie,
  requirements: me,
  tooltipTextPlay: we,
  tooltipTextPause: Re
}) => {
  var kt;
  const je = useRef(null), [Ue, qe] = useState(PlayStatus.NotStartedOrPaused), [Ge, Xe] = useState(0), [ot, vt] = useState(0), bt = async () => {
    je.current && (Ue === PlayStatus.Playing ? (je.current.pause(), qe(PlayStatus.NotStartedOrPaused)) : (await je.current.play(), qe(PlayStatus.Playing)));
  }, Tt = () => {
    je.current && (je.current.currentTime = Math.max(0, je.current.currentTime - REWIND_TIME_SEC));
  }, wt = () => {
    je.current && !(me != null && me.isMandatory) && (je.current.currentTime = Math.min(
      je.current.duration,
      je.current.currentTime + REWIND_TIME_SEC
    ));
  }, St = () => {
    je.current && Xe(je.current.currentTime);
  }, It = (Ot) => {
    if (je.current && !(me != null && me.isMandatory)) {
      const Jr = Array.isArray(Ot) ? Ot[0] : Ot;
      je.current.currentTime = Jr;
    }
  }, Pt = (Ot) => {
    console.error("Audio playback error:", Ot), qe(PlayStatus.NotStartedOrPaused);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center gap-2 p-6 border-1 border-stroke rounded-md bg-surface w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "audio",
      {
        ref: je,
        src: ce,
        onTimeUpdate: St,
        onEnded: () => {
          qe(PlayStatus.Finished), me != null && me.isMandatory && me.onEnded();
        },
        onLoadedMetadata: () => je.current && vt(je.current.duration),
        onError: Pt
      },
      ce
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "m", weight: "semibold", children: ie }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center w-full gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Slider$1,
        {
          onChange: It,
          min: 0,
          max: ((kt = je.current) == null ? void 0 : kt.duration) || 0,
          value: Ge,
          step: 0.1,
          styles: {
            rail: { height: 2, backgroundColor: "var(--grey-500" },
            track: { height: 2, backgroundColor: "var(--yellow-600)" },
            handle: {
              height: 11,
              width: 11,
              border: 0,
              backgroundColor: "#FDC23B",
              opacity: 1,
              cursor: me != null && me.isMandatory ? "default" : "grab"
            }
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { size: "xs", className: "whitespace-nowrap inline-block", children: [
        `${Math.floor(Ge / 60)}:${("0" + Math.floor(Ge % 60).toString()).slice(-2)}`,
        " /",
        " ",
        ot ? `${Math.floor(ot / 60)}:${("0" + Math.floor(ot % 60).toString()).slice(-2)}` : "-:--"
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RewindButton, { onClick: Tt, rewindTime: REWIND_TIME_SEC, direction: "rewind", hasBorder: !0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        PlayButton,
        {
          onClick: () => void bt(),
          playStatus: Ue,
          tooltipTextPlay: we,
          tooltipTextPause: Re,
          hasBorder: !0,
          big: !0,
          disableOffset: !0
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        RewindButton,
        {
          onClick: wt,
          rewindTime: REWIND_TIME_SEC,
          direction: "forward",
          disabled: me == null ? void 0 : me.isMandatory,
          hasBorder: !0
        }
      )
    ] })
  ] });
}, MAX_DOT_SIZE = 12, MIN_DOT_SIZE = 0, calculateDotSize = (ce, ie) => {
  const we = Math.abs(ce - ie), Re = we <= 2 ? MAX_DOT_SIZE : we > 5 ? 0 : MAX_DOT_SIZE - we * 0.5;
  return Math.max(Re, MIN_DOT_SIZE);
}, calculateDotOpacity = (ce, ie) => {
  const me = Math.abs(ce - ie);
  return me <= 2 ? 1 : Math.max(0, Math.min(1, 1 - me * 0.2));
}, DotNavigation = ({ total: ce, current: ie, onDotClick: me, className: we = "" }) => {
  const Re = (je) => {
    const Ue = ie === je, qe = calculateDotSize(je, ie), Ge = calculateDotOpacity(je, ie), Xe = qe > 0;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: () => me == null ? void 0 : me(je),
        className: classNames("position-relative flex-col", {
          "pointer-events-none": !Xe
        }),
        style: {
          width: `${qe}px`,
          height: `${qe}px`,
          transition: "all 0.3s ease",
          marginLeft: qe > 0 ? "5px" : "0",
          marginRight: qe > 0 ? "5px" : "0"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: classNames("absolute inset-0 rounded-full transition-all duration-300", {
              "dark:bg-gray-500 light:bg-gray-500": !Ue,
              "dark:bg-white light:bg-black": Ue
            }),
            style: {
              opacity: Xe ? Ge : 0,
              transform: `scale(${Ue ? 1 : 0.8})`,
              transition: "all 0.3s ease"
            }
          }
        )
      },
      je
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `block transition-all-300 ${we} `, children: Array.from({ length: ce }).map((je, Ue) => Re(Ue)) });
}, ImageCarousel = ({ images: ce, onIndexChange: ie }) => {
  const [me, we] = useState(0), Re = getValidIndexForArrayAndCurrentIndex(ce, me), je = useRef(null), Ue = (vt) => {
    we(vt), ie == null || ie(vt);
  }, qe = () => {
    Ue(Re === 0 ? ce.length - 1 : Re - 1);
  }, Ge = () => {
    Ue(Re === ce.length - 1 ? 0 : Re + 1);
  }, Xe = (vt) => {
    Ue(vt);
  }, ot = (vt) => {
    vt === "left" ? Ge() : qe();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center gap-2 p-6 border-1 border-stroke rounded-md bg-surface text-text w-full h-full max-h-200", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: je,
        className: "relative w-full h-full overflow-hidden min-h-100",
        onTouchStart: (vt) => {
          const bt = vt.touches[0].clientX;
          je.current && (je.current.ontouchend = (Tt) => {
            const wt = Tt.changedTouches[0].clientX;
            bt - wt > 50 ? ot("left") : bt - wt < -50 && ot("right");
          });
        },
        children: [
          ce.map((vt, bt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: `absolute inset-0 flex items-center justify-center transition-transform duration-500 ${bt === Re ? "translate-x-0" : bt < Re ? "-translate-x-full" : "translate-x-full"}`,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                SmartImage,
                {
                  src: vt.src,
                  className: "w-auto h-full min-h-80 object-contain cursor-zoom-in",
                  loaderHeight: vt.imageHeight,
                  loaderWidth: vt.imageWidth,
                  enableZoom: !0
                }
              )
            },
            bt
          )),
          ce.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FontAwesomeIcon,
              {
                icon: faChevronLeft,
                onClick: qe,
                size: "xl",
                className: "absolute left-2 top-1/2 transform -translate-y-1/2 cursor-pointer opacity-80 hover:opacity-100 transition-all",
                style: {
                  filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.65))"
                }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              FontAwesomeIcon,
              {
                icon: faChevronRight,
                onClick: Ge,
                size: "xl",
                className: "absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer  opacity-80 hover:opacity-100 transition-all",
                style: {
                  filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.65))"
                }
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex py-2 items-center w-full", children: ce.map((vt, bt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: classNames("w-full", {
          hidden: bt !== Re
        }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: vt.caption })
      },
      bt
    )) }),
    ce.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(DotNavigation, { current: Re, total: ce.length, onDotClick: Xe, className: "mt-2" })
  ] });
}, SlideWidgetBody = forwardRef((ce, ie) => {
  const { title: me, text: we, assetAlignment: Re } = ce;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-surface border-rd-2 border-stroke border-solid border-1 gap-3", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: ie,
      className: classNames("flex flex-col gap-2", {
        "p-8 ": !ce.useCompactLayout,
        "p-4 ": ce.useCompactLayout
      }),
      children: [
        me,
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: classNames("flex justify-center mt-4", {
              "flex-row gap-8": Re === "right",
              "flex-row-reverse gap-8": Re === "left",
              "flex-col gap-3": !Re || Re === "under",
              "gap-2!": ce.useCompactLayout
            }),
            children: [
              we,
              ce.asset && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full flex items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full", children: ce.asset }) })
            ]
          }
        ),
        ce.additionalComponents
      ]
    }
  ) });
}), ScrollGuidedTour = ({ title: ce, description: ie, buttonLabel: me, variant: we, onClose: Re }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { maxWidth: "sm", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "bold", size: "m", children: ce }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, size: "s", children: ie }),
  we === "student" && /* @__PURE__ */ jsxRuntimeExports.jsx(StudentButton, { onClick: Re, children: "Got it!" }),
  we === "manager" && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Re, variant: ButtonVariant.PRIMARY, fullWidth: !0, children: me })
] }), SpriteSvgIcon = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: ce.className, children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: `${ce.spriteUrl}#${ce.iconId}` }) }), IconPickerGridItem = ({ spriteUrl: ce, iconId: ie, onClick: me, isActive: we }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames("flex justify-center w-6 h-6 rounded items-center cursor-pointer", {
      "bg-surface-elevated": we
    }),
    onClick: me,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SpriteSvgIcon,
      {
        spriteUrl: ce,
        iconId: ie,
        className: classNames("w-4 h-4", we ? "fill-accent" : "dark:fill-white light:fill-grey-900")
      }
    )
  }
), ke = {
  0: o$1,
  1: e$1,
  2: a$1,
  3: i$2,
  "360-degrees": t$1,
  4: l$1,
  5: m$1,
  6: n$1,
  7: c$2,
  8: s$1,
  9: p$2,
  anchor: d$2,
  "arrow-down-left": f$2,
  "arrow-down-right": h$2,
  "arrow-down": g$1,
  "arrow-left": u$2,
  "arrow-right": w$2,
  "arrow-rotate-left": b$1,
  "arrow-rotate-right": U$1,
  "arrow-up-left": k$1,
  "arrow-up-right": y$1,
  "arrow-up": v$1,
  bandage: $,
  bomb: x$2,
  book: A$1,
  books: C$1,
  "briefcase-medical": D$1,
  briefcase: z,
  "bullseye-arrow": S$1,
  calculator: M$1,
  camera: q$1,
  "caret-up": P$1,
  cars: R$1,
  check: B$1,
  "chevron-down": L$1,
  "chevron-left": T,
  "chevron-right": E,
  "chevron-up": H,
  circle: F$1,
  clock: G,
  compass: O$1,
  "door-open": j$1,
  "down-from-line": I,
  down: X$1,
  "earth-americas": K$1,
  exclamation: Q,
  fire: V$2,
  flag: N,
  gear: W$2,
  "graduation-cap": Z$2,
  "hand-pointer": J$1,
  handshake: Y$2,
  "heart-crack": _$1,
  heart: rr,
  "helmet-safety": or,
  info: er,
  key: ar,
  "kit-medical": ir,
  left: tr,
  "location-dot": lr,
  "magnifying-glass-minus": mr$1,
  "magnifying-glass-plus": nr,
  "magnifying-glass": cr,
  "map-pin": sr,
  map: pr$1,
  microphone: dr$1,
  minus: fr$2,
  palette: hr$1,
  pencil: gr$1,
  "person-to-door": ur,
  "person-to-portal": wr$1,
  plane: br$1,
  plus: Ur$1,
  question: kr$1,
  radiation: yr$1,
  reply: vr$1,
  right: $r$1,
  road: xr$1,
  "shield-check": Ar$1,
  ship: Cr$1,
  stairs: Dr$1,
  star: zr$1,
  stopwatch: Sr$1,
  "thumbs-up": Mr$1,
  "triangle-exclamation": qr$1,
  up: Pr$1,
  "user-helmet-safety": Rr$1,
  video: Br$1,
  wrench: Lr$1,
  xmark: Tr$1
}, ye = [
  {
    id: "info",
    label: "Info",
    search: [
      "details",
      "help",
      "information",
      "more",
      "support"
    ]
  },
  {
    id: "door-open",
    label: "Door Open",
    search: [
      "enter",
      "exit",
      "welcome"
    ]
  },
  {
    id: "pencil",
    label: "Pencil",
    search: [
      "Lower Left Pencil",
      "design",
      "draw",
      "edit",
      "lead",
      "maintenance",
      "modify",
      "pencil",
      "update",
      "write"
    ]
  },
  {
    id: "7",
    label: "7",
    search: [
      "Digit Seven",
      "seven"
    ]
  },
  {
    id: "up",
    label: "Up",
    search: [
      "upgrade",
      "upload"
    ]
  },
  {
    id: "reply",
    label: "Reply",
    search: [
      "mail",
      "message",
      "respond"
    ]
  },
  {
    id: "compass",
    label: "Compass",
    search: [
      "compass",
      "directions",
      "directory",
      "location",
      "magnetic",
      "menu",
      "navigation",
      "orienteering",
      "safari",
      "travel"
    ]
  },
  {
    id: "heart-crack",
    label: "Heart Crack",
    search: [
      "break",
      "breakup",
      "broken",
      "broken heart",
      "crushed",
      "dislike",
      "dumped",
      "grief",
      "love",
      "lovesick",
      "relationship",
      "sad"
    ]
  },
  {
    id: "8",
    label: "8",
    search: [
      "Digit Eight",
      "eight"
    ]
  },
  {
    id: "flag",
    label: "Flag",
    search: [
      "black flag",
      "country",
      "notice",
      "notification",
      "notify",
      "pole",
      "report",
      "symbol",
      "waving"
    ]
  },
  {
    id: "right",
    label: "Right",
    search: [
      "Rightwards Black Arrow",
      "forward",
      "next"
    ]
  },
  {
    id: "chevron-up",
    label: "Chevron Up",
    search: [
      "arrow",
      "collapse",
      "upgrade",
      "upload"
    ]
  },
  {
    id: "stopwatch",
    label: "Stopwatch",
    search: [
      "clock",
      "reminder",
      "stopwatch",
      "time",
      "waiting"
    ]
  },
  {
    id: "5",
    label: "5",
    search: [
      "Digit Five",
      "five"
    ]
  },
  {
    id: "stairs",
    label: "Stairs",
    search: [
      "exit",
      "steps",
      "up"
    ]
  },
  {
    id: "user-helmet-safety",
    label: "User Helmet Safety",
    search: [
      "construction",
      "construction worker",
      "employee",
      "hardhat",
      "hat",
      "helmet",
      "maintenance",
      "safety",
      "uer",
      "worker"
    ]
  },
  {
    id: "shield-check",
    label: "Shield Check",
    search: [
      "achievement",
      "award",
      "block",
      "defend",
      "enable",
      "protect",
      "safety",
      "security",
      "select",
      "success",
      "tick",
      "todo",
      "validate",
      "warranty",
      "winner",
      "working"
    ]
  },
  {
    id: "6",
    label: "6",
    search: [
      "Digit Six",
      "six"
    ]
  },
  {
    id: "radiation",
    label: "Radiation",
    search: [
      "danger",
      "dangerous",
      "deadly",
      "hazard",
      "nuclear",
      "radioactive",
      "warning"
    ]
  },
  {
    id: "key",
    label: "Key",
    search: [
      "key",
      "lock",
      "password",
      "private",
      "secret",
      "unlock"
    ]
  },
  {
    id: "star",
    label: "Star",
    search: [
      "achievement",
      "award",
      "favorite",
      "important",
      "night",
      "quality",
      "rating",
      "score",
      "star",
      "vip"
    ]
  },
  {
    id: "arrow-up-left",
    label: "Arrow Up Left",
    search: [
      "diagonal",
      "northwest"
    ]
  },
  {
    id: "person-to-portal",
    label: "Person To Portal",
    search: [
      "portal",
      "run",
      "transport",
      "travel",
      "uer"
    ]
  },
  {
    id: "books",
    label: "Books",
    search: [
      "book",
      "books",
      "diary",
      "documentation",
      "journal",
      "knowledge",
      "library",
      "read",
      "research",
      "scholar"
    ]
  },
  {
    id: "fire",
    label: "Fire",
    search: [
      "burn",
      "caliente",
      "fire",
      "flame",
      "heat",
      "hot",
      "popular",
      "tool"
    ]
  },
  {
    id: "microphone",
    label: "Microphone",
    search: [
      "address",
      "audio",
      "information",
      "podcast",
      "public",
      "record",
      "sing",
      "sound",
      "talking",
      "voice"
    ]
  },
  {
    id: "3",
    label: "3",
    search: [
      "Digit Three",
      "three"
    ]
  },
  {
    id: "down-from-line",
    label: "Down From Line",
    search: [
      "download",
      "export",
      "insert",
      "transfer"
    ]
  },
  {
    id: "caret-up",
    label: "Caret Up",
    search: [
      "arrow",
      "collapse",
      "triangle",
      "upgrade"
    ]
  },
  {
    id: "handshake",
    label: "Handshake",
    search: [
      "agreement",
      "greeting",
      "meeting",
      "partnership"
    ]
  },
  {
    id: "360-degrees",
    label: "360 Degrees",
    search: [
      "3D",
      "panorama",
      "revolve",
      "rotate"
    ]
  },
  {
    id: "bomb",
    label: "Bomb",
    search: [
      "bomb",
      "comic",
      "error",
      "explode",
      "fuse",
      "grenade",
      "warning"
    ]
  },
  {
    id: "palette",
    label: "Palette",
    search: [
      "acrylic",
      "art",
      "artist palette",
      "brush",
      "color",
      "fill",
      "museum",
      "paint",
      "painting",
      "palette",
      "pigment",
      "watercolor"
    ]
  },
  {
    id: "bullseye-arrow",
    label: "Bullseye Arrow",
    search: [
      "archery",
      "arrow",
      "bullseye",
      "dart",
      "direct hit",
      "game",
      "goal",
      "hit",
      "objective",
      "robin hood",
      "strategy",
      "target"
    ]
  },
  {
    id: "left",
    label: "Left",
    search: [
      "back",
      "previous"
    ]
  },
  {
    id: "question",
    label: "Question",
    search: [
      "?",
      "Question Mark",
      "faq",
      "help",
      "information",
      "mark",
      "outlined",
      "punctuation",
      "question",
      "red question mark",
      "request",
      "support",
      "unknown",
      "white question mark"
    ]
  },
  {
    id: "road",
    label: "Road",
    search: [
      "highway",
      "map",
      "motorway",
      "pavement",
      "road",
      "route",
      "street",
      "travel"
    ]
  },
  {
    id: "helmet-safety",
    label: "Helmet Safety",
    search: [
      "construction",
      "hardhat",
      "helmet",
      "maintenance",
      "safety"
    ]
  },
  {
    id: "arrow-right",
    label: "Arrow Right",
    search: [
      "Rightwards Arrow",
      "forward",
      "next"
    ]
  },
  {
    id: "heart",
    label: "Heart",
    search: [
      "ace",
      "black",
      "black heart",
      "blue",
      "blue heart",
      "brown",
      "brown heart",
      "card",
      "evil",
      "favorite",
      "game",
      "green",
      "green heart",
      "heart",
      "heart suit",
      "like",
      "love",
      "orange",
      "orange heart",
      "purple",
      "purple heart",
      "red heart",
      "relationship",
      "valentine",
      "white",
      "white heart",
      "wicked",
      "wishlist",
      "yellow",
      "yellow heart"
    ]
  },
  {
    id: "circle",
    label: "Circle",
    search: [
      "Black Circle",
      "Black Large Circle",
      "black circle",
      "blue",
      "blue circle",
      "brown",
      "brown circle",
      "chart",
      "circle",
      "circle-thin",
      "diameter",
      "dot",
      "ellipse",
      "fill",
      "geometric",
      "green",
      "green circle",
      "notification",
      "orange",
      "orange circle",
      "progress",
      "purple",
      "purple circle",
      "red",
      "red circle",
      "round",
      "white circle",
      "yellow",
      "yellow circle"
    ]
  },
  {
    id: "wrench",
    label: "Wrench",
    search: [
      "configuration",
      "construction",
      "equipment",
      "fix",
      "mechanic",
      "modify",
      "plumbing",
      "settings",
      "spanner",
      "tool",
      "update",
      "wrench"
    ]
  },
  {
    id: "arrow-up-right",
    label: "Arrow Up Right",
    search: [
      "diagonal",
      "northeast"
    ]
  },
  {
    id: "hand-pointer",
    label: "Hand Pointer",
    search: [
      "arrow",
      "cursor",
      "select"
    ]
  },
  {
    id: "arrow-rotate-right",
    label: "Arrow Rotate Right",
    search: [
      "Clockwise Open Circle Arrow",
      "forward",
      "refresh",
      "reload",
      "renew",
      "repeat",
      "retry"
    ]
  },
  {
    id: "0",
    label: "0",
    search: [
      "Digit Zero",
      "nada",
      "none",
      "zero",
      "zilch"
    ]
  },
  {
    id: "arrow-left",
    label: "Arrow Left",
    search: [
      "Leftwards Arrow",
      "back",
      "previous"
    ]
  },
  {
    id: "camera",
    label: "Camera",
    search: [
      "image",
      "img",
      "lens",
      "photo",
      "picture",
      "record",
      "shutter",
      "video"
    ]
  },
  {
    id: "arrow-rotate-left",
    label: "Arrow Rotate Left",
    search: [
      "Anticlockwise Open Circle Arrow",
      "back",
      "control z",
      "exchange",
      "oops",
      "return",
      "rotate",
      "swap"
    ]
  },
  {
    id: "arrow-down-right",
    label: "Arrow Down Right",
    search: [
      "diagonal",
      "southeast"
    ]
  },
  {
    id: "minus",
    label: "Minus",
    search: [
      "En Dash",
      "Minus Sign",
      "collapse",
      "delete",
      "hide",
      "math",
      "minify",
      "minus",
      "negative",
      "remove",
      "sign",
      "trash",
      "−"
    ]
  },
  {
    id: "arrow-down-left",
    label: "Arrow Down Left",
    search: [
      "diagonal",
      "southwest"
    ]
  },
  {
    id: "gear",
    label: "Gear",
    search: [
      "cog",
      "cogwheel",
      "configuration",
      "gear",
      "mechanical",
      "modify",
      "settings",
      "sprocket",
      "tool",
      "wheel"
    ]
  },
  {
    id: "clock",
    label: "Clock",
    search: [
      "00",
      "4",
      "4:00",
      "clock",
      "date",
      "four",
      "four o’clock",
      "hour",
      "late",
      "minute",
      "o'clock",
      "o’clock",
      "pending",
      "schedule",
      "ticking",
      "time",
      "timer",
      "timestamp",
      "watch"
    ]
  },
  {
    id: "map-pin",
    label: "Map Pin",
    search: [
      "address",
      "agree",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "marker",
      "navigation",
      "pin",
      "place",
      "position",
      "pushpin",
      "round pushpin",
      "travel"
    ]
  },
  {
    id: "calculator",
    label: "Calculator",
    search: [
      "Pocket Calculator",
      "abacus",
      "addition",
      "arithmetic",
      "counting",
      "math",
      "multiplication",
      "subtraction"
    ]
  },
  {
    id: "ship",
    label: "Ship",
    search: [
      "boat",
      "passenger",
      "sea",
      "ship",
      "water"
    ]
  },
  {
    id: "kit-medical",
    label: "Kit Medical",
    search: [
      "emergency",
      "emt",
      "health",
      "medical",
      "rescue"
    ]
  },
  {
    id: "location-dot",
    label: "Location Dot",
    search: [
      "address",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "navigation",
      "paper",
      "pin",
      "place",
      "point of interest",
      "position",
      "route",
      "travel"
    ]
  },
  {
    id: "arrow-down",
    label: "Arrow Down",
    search: [
      "Downwards Arrow",
      "download"
    ]
  },
  {
    id: "earth-americas",
    label: "Earth Americas",
    search: [
      "all",
      "america",
      "country",
      "earth",
      "global",
      "globe",
      "gps",
      "language",
      "localize",
      "location",
      "map",
      "online",
      "place",
      "planet",
      "translate",
      "travel",
      "world"
    ]
  },
  {
    id: "magnifying-glass",
    label: "Magnifying Glass",
    search: [
      "bigger",
      "enlarge",
      "equipment",
      "find",
      "glass",
      "inspection",
      "magnifier",
      "magnify",
      "magnifying",
      "magnifying glass tilted left",
      "preview",
      "search",
      "tool",
      "zoom"
    ]
  },
  {
    id: "chevron-down",
    label: "Chevron Down",
    search: [
      "arrow",
      "download",
      "expand",
      "insert"
    ]
  },
  {
    id: "arrow-up",
    label: "Arrow Up",
    search: [
      "Upwards Arrow",
      "forward",
      "upgrade",
      "upload"
    ]
  },
  {
    id: "2",
    label: "2",
    search: [
      "Digit Two",
      "two"
    ]
  },
  {
    id: "plus",
    label: "Plus",
    search: [
      "+",
      "Plus Sign",
      "add",
      "create",
      "expand",
      "follow",
      "math",
      "modify",
      "new",
      "plus",
      "positive",
      "shape",
      "sign"
    ]
  },
  {
    id: "xmark",
    label: "Xmark",
    search: [
      "Cancellation X",
      "Multiplication Sign",
      "Multiplication X",
      "cancel",
      "close",
      "cross",
      "cross mark",
      "error",
      "exit",
      "incorrect",
      "mark",
      "multiplication",
      "multiply",
      "notice",
      "notification",
      "notify",
      "problem",
      "sign",
      "uncheck",
      "wrong",
      "x",
      "×"
    ]
  },
  {
    id: "cars",
    label: "Cars",
    search: [
      "automobiles",
      "autos",
      "transportation",
      "travel"
    ]
  },
  {
    id: "map",
    label: "Map",
    search: [
      "address",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "navigation",
      "paper",
      "pin",
      "place",
      "point of interest",
      "position",
      "route",
      "travel",
      "world",
      "world map"
    ]
  },
  {
    id: "chevron-left",
    label: "Chevron Left",
    search: [
      "Left-Pointing Angle Bracket",
      "arrow",
      "back",
      "bracket",
      "previous"
    ]
  },
  {
    id: "person-to-door",
    label: "Person To Door",
    search: [
      "door",
      "exit",
      "leave",
      "uer"
    ]
  },
  {
    id: "briefcase-medical",
    label: "Briefcase Medical",
    search: [
      "doctor",
      "emt",
      "first aid",
      "health"
    ]
  },
  {
    id: "chevron-right",
    label: "Chevron Right",
    search: [
      "Right-Pointing Angle Bracket",
      "arrow",
      "bracket",
      "forward",
      "next"
    ]
  },
  {
    id: "anchor",
    label: "Anchor",
    search: [
      "anchor",
      "berth",
      "boat",
      "dock",
      "embed",
      "link",
      "maritime",
      "moor",
      "port",
      "secure",
      "ship",
      "tool"
    ]
  },
  {
    id: "4",
    label: "4",
    search: [
      "Digit Four",
      "four"
    ]
  },
  {
    id: "book",
    label: "Book",
    search: [
      "book",
      "cover",
      "decorated",
      "diary",
      "documentation",
      "journal",
      "knowledge",
      "library",
      "notebook",
      "notebook with decorative cover",
      "read",
      "research",
      "scholar"
    ]
  },
  {
    id: "check",
    label: "Check",
    search: [
      "Check Mark",
      "accept",
      "agree",
      "check",
      "check mark",
      "checkmark",
      "confirm",
      "correct",
      "coupon",
      "done",
      "enable",
      "mark",
      "notice",
      "notification",
      "notify",
      "ok",
      "select",
      "success",
      "tick",
      "todo",
      "true",
      "validate",
      "working",
      "yes",
      "✓"
    ]
  },
  {
    id: "briefcase",
    label: "Briefcase",
    search: [
      "bag",
      "briefcas",
      "briefcase",
      "business",
      "luggage",
      "offer",
      "office",
      "portfolio",
      "work"
    ]
  },
  {
    id: "triangle-exclamation",
    label: "Triangle Exclamation",
    search: [
      "alert",
      "attention",
      "danger",
      "error",
      "failed",
      "important",
      "notice",
      "notification",
      "notify",
      "problem",
      "required",
      "warnin",
      "warning"
    ]
  },
  {
    id: "bandage",
    label: "Bandage",
    search: [
      "adhesive bandage",
      "bandage",
      "boo boo",
      "first aid",
      "modify",
      "ouch"
    ]
  },
  {
    id: "9",
    label: "9",
    search: [
      "Digit Nine",
      "nine"
    ]
  },
  {
    id: "magnifying-glass-plus",
    label: "Magnifying Glass Plus",
    search: [
      "bigger",
      "enlarge",
      "magnifier",
      "magnify",
      "positive",
      "zoom",
      "zoom in"
    ]
  },
  {
    id: "thumbs-up",
    label: "Thumbs Up",
    search: [
      "+1",
      "agree",
      "approve",
      "favorite",
      "hand",
      "like",
      "ok",
      "okay",
      "social",
      "success",
      "thumb",
      "thumbs up",
      "thumbs-o-up",
      "up",
      "yes",
      "you got it dude"
    ]
  },
  {
    id: "magnifying-glass-minus",
    label: "Magnifying Glass Minus",
    search: [
      "magnifier",
      "minify",
      "negative",
      "smaller",
      "zoom",
      "zoom out"
    ]
  },
  {
    id: "1",
    label: "1",
    search: [
      "Digit One",
      "one"
    ]
  },
  {
    id: "down",
    label: "Down",
    search: [
      "download",
      "insert"
    ]
  },
  {
    id: "plane",
    label: "Plane",
    search: [
      "airplane",
      "airport",
      "destination",
      "fly",
      "location",
      "mode",
      "travel",
      "trip"
    ]
  },
  {
    id: "exclamation",
    label: "Exclamation",
    search: [
      "!",
      "Exclamation Mark",
      "alert",
      "attention",
      "danger",
      "error",
      "exclamation",
      "failed",
      "important",
      "mark",
      "notice",
      "notification",
      "notify",
      "outlined",
      "problem",
      "punctuation",
      "red exclamation mark",
      "required",
      "warning",
      "white exclamation mark"
    ]
  },
  {
    id: "video",
    label: "Video",
    search: [
      "camera",
      "film",
      "movie",
      "record",
      "video-camera"
    ]
  },
  {
    id: "graduation-cap",
    label: "Graduation Cap",
    search: [
      "cap",
      "celebration",
      "ceremony",
      "clothing",
      "college",
      "graduate",
      "graduation",
      "graduation cap",
      "hat",
      "learning",
      "school",
      "student"
    ]
  }
], jt = {
  /***
   * Contains URL to a sprite with SVGs.
   */
  iconsSpriteUrl: r,
  /***
   * Icons available in the bundle.
   */
  icons: {
    /***
     * List of icons with metadata.
     */
    list: ye,
    /***
     * Contains an identifier of the icon and the url to download the icon.
     * Every icon in the sprite is here.
     */
    urls: ke
  }
}, IconsGrid = ({ icons: ce }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-auto h-[180px] dark:bg-grey-1000 light:bg-surface rounded border border-stroke border-stroke", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-row gap-0 items-start justify-start shrink-0 relative p-2 h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FluidGrid, { gridItemWidth: 24, gridRowGap: 12, gridColumnGap: 24, children: ce }) }) });
function isIconSearchedFor(ce, ie) {
  if (!ie || ie.trim() === "")
    return !0;
  const we = ie.toLowerCase();
  return ce.label.toLowerCase().includes(we) ? !0 : ce.search ? ce.search.some((Re) => Re.toLowerCase().includes(we)) : !1;
}
const IconPicker = ({ selectedIcon: ce, defaultIcon: ie, onSelectIcon: me, onCancel: we }) => {
  const [Re, je] = useState(""), [Ue, qe] = useState(ce ?? ie), Ge = () => qe(ie), Xe = lodashExports.debounce((ot) => je(ot), 500);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "bold", size: "m", children: "Select icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { icon: faMagnifyingGlass, placeholder: "Search icon...", onChange: Xe }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconsGrid,
      {
        icons: jt.icons.list.filter((ot) => isIconSearchedFor(ot, Re)).map((ot) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconPickerGridItem,
          {
            spriteUrl: jt.iconsSpriteUrl,
            iconId: ot.id,
            onClick: () => qe(ot.id),
            isActive: ot.id === Ue
          },
          ot.id
        ))
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-row gap-5 items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-16 h-16 flex justify-center items-center bg-no-repeat bg-center light:bg-grey-900 rounded-full p-0 border-6 border-white", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: jt.icons.urls[Ue], alt: "icon", className: "h-7 w-7" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: Ge, variant: ButtonVariant.SECONDARY, children: "Reset to default" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-row justify-end gap-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: we, variant: ButtonVariant.TEXT, children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: () => me(Ue),
          disabled: !Ue,
          variant: ButtonVariant.PRIMARY,
          children: "Select icon"
        }
      )
    ] })
  ] });
}, v = "5.6.7", ip = 0, op = 75, fr = 30, w = 230, h = 268, nm = "medal", assets = [], layers = [
  {
    ind: 1,
    ty: 4,
    nm: "reflection base 2",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 34.275,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 46.023,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0
              ]
            },
            t: 56.464,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 74.261,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 87.174,
            s: [
              100
            ]
          },
          {
            t: 100.087,
            s: [
              0
            ]
          }
        ]
      },
      r: {
        a: 0,
        k: 0
      },
      p: {
        k: [
          {
            i: {
              x: 0.25,
              y: 1
            },
            o: {
              x: 0.75,
              y: 0
            },
            t: 16,
            s: [
              -108.61,
              -23.173,
              0
            ],
            ti: [
              -39,
              0,
              0
            ],
            to: [
              39,
              0,
              0
            ]
          },
          {
            t: 60,
            s: [
              128.39,
              -23.173,
              0
            ]
          }
        ],
        a: 1
      },
      a: {
        a: 0,
        k: [
          -191.75,
          -6.5,
          0
        ]
      },
      s: {
        a: 0,
        k: [
          99.478,
          132.135,
          100
        ]
      }
    },
    shapes: [
      {
        ty: "gr",
        nm: "Rectangle 1",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -19.811,
                    -114
                  ],
                  [
                    -101.311,
                    114
                  ],
                  [
                    -127.018,
                    114
                  ],
                  [
                    -45.518,
                    -114
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                -151,
                -6.5
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ],
    ip: 0,
    op: 76,
    st: 0,
    ef: [
      {
        ty: 28,
        ix: 1,
        nm: "Set Matte",
        mn: "ADBE Set Matte3",
        ef: [
          {
            ix: 1,
            mn: "ADBE Set Matte3-0001",
            nm: "Take Matte From Layer",
            ty: 10,
            v: {
              a: 0,
              k: 2
            }
          },
          {
            ix: 2,
            mn: "ADBE Set Matte3-0002",
            nm: "Use For Matte",
            ty: 7,
            v: {
              a: 0,
              k: 4
            }
          },
          {
            ix: 3,
            mn: "ADBE Set Matte3-0003",
            nm: "Invert Matte",
            ty: 7,
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ix: 4,
            mn: "ADBE Set Matte3-0004",
            nm: "If Layer Sizes Differ",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 5,
            mn: "ADBE Set Matte3-0005",
            nm: "Composite Matte with Original",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 6,
            mn: "ADBE Set Matte3-0006",
            nm: "Premultiply Matte Layer",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          }
        ],
        en: 1
      }
    ],
    parent: 5
  },
  {
    ind: 2,
    ty: 4,
    nm: "medal",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100
      },
      r: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [
          0.25,
          20.9,
          0
        ]
      },
      a: {
        a: 0,
        k: [
          0.25,
          20.9,
          0
        ]
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ]
      }
    },
    shapes: [
      {
        ty: "gr",
        nm: "Group 1",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    2.4,
                    -2.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.7,
                    -2
                  ],
                  [
                    3,
                    1.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.4,
                    0
                  ],
                  [
                    1.6,
                    1.1
                  ],
                  [
                    -0.6,
                    3.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    3.2
                  ],
                  [
                    -3.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -3.3,
                    0
                  ],
                  [
                    -1.4,
                    -0.8
                  ],
                  [
                    -0.8,
                    -1.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    -3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    3.4
                  ],
                  [
                    -2.8,
                    2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.3,
                    0.7
                  ],
                  [
                    -1.8,
                    0
                  ],
                  [
                    -2.8,
                    -2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -2.4,
                    -2.4
                  ],
                  [
                    1,
                    -3.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.5,
                    -3
                  ],
                  [
                    1.7,
                    0
                  ],
                  [
                    1.4,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    3.4,
                    0.5
                  ],
                  [
                    1,
                    3.3
                  ]
                ],
                v: [
                  [
                    33.75,
                    19.6
                  ],
                  [
                    23.35,
                    29.7
                  ],
                  [
                    25.75,
                    43.9
                  ],
                  [
                    22.25,
                    52.6
                  ],
                  [
                    12.95,
                    53.3
                  ],
                  [
                    0.15,
                    46.6
                  ],
                  [
                    -12.65,
                    53.3
                  ],
                  [
                    -16.75,
                    54.3
                  ],
                  [
                    -21.95,
                    52.6
                  ],
                  [
                    -25.45,
                    43.9
                  ],
                  [
                    -23.05,
                    29.7
                  ],
                  [
                    -33.45,
                    19.6
                  ],
                  [
                    -35.65,
                    10.5
                  ],
                  [
                    -28.45,
                    4.5
                  ],
                  [
                    -14.15,
                    2.4
                  ],
                  [
                    -7.75,
                    -10.6
                  ],
                  [
                    0.15,
                    -15.5
                  ],
                  [
                    4.85,
                    -14.2
                  ],
                  [
                    8.15,
                    -10.6
                  ],
                  [
                    14.55,
                    2.4
                  ],
                  [
                    28.85,
                    4.5
                  ],
                  [
                    36.05,
                    10.5
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                0.949019610882,
                0.831372559071,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100,
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Opacity - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Opacity - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Opacity - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            r: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.833
                    ],
                    y: [
                      0.833
                    ]
                  },
                  o: {
                    x: [
                      0.167
                    ],
                    y: [
                      0.167
                    ]
                  },
                  t: 13,
                  s: [
                    -147
                  ]
                },
                {
                  t: 28,
                  s: [
                    0
                  ]
                }
              ],
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Rotation - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Rotation - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Rotation - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            p: {
              a: 0,
              k: [
                0.169,
                19.413
              ],
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Position - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            a: {
              a: 0,
              k: [
                0.169,
                19.413
              ],
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Anchor Point - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Anchor Point - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Anchor Point - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Scale - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0,
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Skew - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Skew - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Skew - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            },
            sa: {
              a: 0,
              k: 0,
              x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Skew Axis - Transform - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Skew Axis - Transform - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Skew Axis - Transform - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
            }
          }
        ]
      },
      {
        ty: "gr",
        nm: "Group 2",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    0,
                    -35.7
                  ],
                  [
                    35.7,
                    0
                  ],
                  [
                    0,
                    35.7
                  ],
                  [
                    -35.7,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    35.7
                  ],
                  [
                    -35.7,
                    0
                  ],
                  [
                    0,
                    -35.7
                  ],
                  [
                    35.7,
                    0
                  ]
                ],
                v: [
                  [
                    65.05,
                    20.9
                  ],
                  [
                    0.25,
                    85.7
                  ],
                  [
                    -64.55,
                    20.9
                  ],
                  [
                    0.25,
                    -43.9
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                0.835294127464,
                0.380392163992,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ],
    ip: 0,
    op: 76,
    st: 0,
    ef: [
      {
        ty: 28,
        ix: 1,
        nm: "Set Matte",
        mn: "ADBE Set Matte3",
        ef: [
          {
            ix: 1,
            mn: "ADBE Set Matte3-0001",
            nm: "Take Matte From Layer",
            ty: 10,
            v: {
              a: 0,
              k: 5
            }
          },
          {
            ix: 2,
            mn: "ADBE Set Matte3-0002",
            nm: "Use For Matte",
            ty: 7,
            v: {
              a: 0,
              k: 4
            }
          },
          {
            ix: 3,
            mn: "ADBE Set Matte3-0003",
            nm: "Invert Matte",
            ty: 7,
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ix: 4,
            mn: "ADBE Set Matte3-0004",
            nm: "If Layer Sizes Differ",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 5,
            mn: "ADBE Set Matte3-0005",
            nm: "Composite Matte with Original",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 6,
            mn: "ADBE Set Matte3-0006",
            nm: "Premultiply Matte Layer",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 2,
        nm: "Rotation - Transform - Overshoot",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 15,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 3,
        nm: "Rotation - Transform - Bounce",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 4,
        nm: "Rotation - Transform - Friction",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      }
    ],
    parent: 3
  },
  {
    ind: 3,
    ty: 4,
    nm: "strap",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100
      },
      r: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 5,
            s: [
              77
            ]
          },
          {
            t: 27.195,
            s: [
              0
            ]
          }
        ],
        x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Rotation - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Rotation - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Rotation - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`
      },
      p: {
        k: [
          {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 12,
            s: [
              0.199,
              -293.842,
              0
            ],
            ti: [
              0,
              -20.167,
              0
            ],
            to: [
              0,
              20.167,
              0
            ]
          },
          {
            t: 26.342,
            s: [
              0.199,
              -172.842,
              0
            ]
          }
        ],
        x: `var $bm_rt;
var amp, freq, decay, n, t, v;
try {
    amp = $bm_div(effect('Position - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;
} catch (e$$4) {
    $bm_rt = value = value;
}`,
        a: 1
      },
      a: {
        a: 0,
        k: [
          0.25,
          -173.723,
          0
        ]
      },
      s: {
        a: 0,
        k: [
          99.478,
          99.478,
          100
        ]
      }
    },
    shapes: [
      {
        ty: "gr",
        nm: "Group 1",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    2.4,
                    3.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    4.7,
                    1
                  ],
                  [
                    4,
                    -2.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -5.5,
                    -8.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.3,
                    0.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -2.7,
                    -4
                  ],
                  [
                    -4.7,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -8.4,
                    5.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.5,
                    0
                  ],
                  [
                    3.4,
                    -2.5
                  ]
                ],
                v: [
                  [
                    42.05,
                    -28.5
                  ],
                  [
                    -52.15,
                    -165.3
                  ],
                  [
                    -63.55,
                    -173
                  ],
                  [
                    -77.15,
                    -170.4
                  ],
                  [
                    -108.25,
                    -150
                  ],
                  [
                    -113.45,
                    -124.9
                  ],
                  [
                    -113.35,
                    -124.8
                  ],
                  [
                    -41.85,
                    -21.7
                  ],
                  [
                    -38.35,
                    -19.8
                  ],
                  [
                    35.85,
                    -16.6
                  ],
                  [
                    40.15,
                    -17.9
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                0.443137258291,
                0.184313729405,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ty: "gr",
        nm: "Group 2",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    8.4,
                    5.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    5.5,
                    -8.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    -2.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -2.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.5,
                    2.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -8.3,
                    -5.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.4,
                    1.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.1,
                    1.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    2.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    5.5,
                    -8.4
                  ]
                ],
                v: [
                  [
                    108.75,
                    -150.4
                  ],
                  [
                    77.65,
                    -170.8
                  ],
                  [
                    52.65,
                    -165.7
                  ],
                  [
                    -3.35,
                    -84.8
                  ],
                  [
                    -3.65,
                    -78.2
                  ],
                  [
                    30.45,
                    -19.8
                  ],
                  [
                    35.75,
                    -16.6
                  ],
                  [
                    35.75,
                    -16.6
                  ],
                  [
                    42.05,
                    -19.9
                  ],
                  [
                    113.85,
                    -125.2
                  ],
                  [
                    113.95,
                    -125.3
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                0.211764708161,
                0.211764708161,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ],
    ip: 0,
    op: 76,
    st: 0,
    ef: [
      {
        ty: 28,
        ix: 1,
        nm: "Set Matte",
        mn: "ADBE Set Matte3",
        ef: [
          {
            ix: 1,
            mn: "ADBE Set Matte3-0001",
            nm: "Take Matte From Layer",
            ty: 10,
            v: {
              a: 0,
              k: 5
            }
          },
          {
            ix: 2,
            mn: "ADBE Set Matte3-0002",
            nm: "Use For Matte",
            ty: 7,
            v: {
              a: 0,
              k: 4
            }
          },
          {
            ix: 3,
            mn: "ADBE Set Matte3-0003",
            nm: "Invert Matte",
            ty: 7,
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ix: 4,
            mn: "ADBE Set Matte3-0004",
            nm: "If Layer Sizes Differ",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 5,
            mn: "ADBE Set Matte3-0005",
            nm: "Composite Matte with Original",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 6,
            mn: "ADBE Set Matte3-0006",
            nm: "Premultiply Matte Layer",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 2,
        nm: "Position - Overshoot",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 3,
        nm: "Position - Bounce",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 4,
        nm: "Position - Friction",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 60,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 5,
        nm: "Rotation - Overshoot",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 6,
        nm: "Rotation - Bounce",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 20,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      },
      {
        ty: 5,
        ix: 7,
        nm: "Rotation - Friction",
        mn: "ADBE Slider Control",
        ef: [
          {
            ix: 1,
            mn: "ADBE Slider Control-0001",
            nm: "Slider",
            ty: 0,
            v: {
              a: 0,
              k: 60,
              x: `var $bm_rt;
$bm_rt = clamp(value, 0, 100);`
            }
          }
        ],
        en: 1
      }
    ],
    parent: 5
  },
  {
    ind: 4,
    ty: 4,
    nm: "reflection base",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 15.261,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 28.174,
            s: [
              100
            ]
          },
          {
            i: {
              x: [
                0.833
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0
              ]
            },
            t: 41.087,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 74.261,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 87.174,
            s: [
              100
            ]
          },
          {
            t: 100.087,
            s: [
              0
            ]
          }
        ]
      },
      r: {
        a: 0,
        k: 0
      },
      p: {
        k: [
          {
            i: {
              x: 0.25,
              y: 1
            },
            o: {
              x: 0.75,
              y: 0
            },
            t: 0,
            s: [
              -195.129,
              -1.822,
              0
            ],
            ti: [
              -61.167,
              0,
              0
            ],
            to: [
              61.167,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.25,
              y: 0.25
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 54,
            s: [
              171.871,
              -1.822,
              0
            ],
            ti: [
              0,
              0,
              0
            ],
            to: [
              0,
              0,
              0
            ]
          },
          {
            t: 113,
            s: [
              171.871,
              -1.822,
              0
            ]
          }
        ],
        a: 1
      },
      a: {
        a: 0,
        k: [
          -191.75,
          -6.5,
          0
        ]
      },
      s: {
        a: 0,
        k: [
          100,
          132.828,
          100
        ]
      }
    },
    shapes: [
      {
        ty: "gr",
        nm: "Rectangle 1",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    22,
                    -114
                  ],
                  [
                    -59.5,
                    114
                  ],
                  [
                    -103.5,
                    114
                  ],
                  [
                    -22,
                    -114
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "fl",
            nm: "Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - Fill",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                -151,
                -6.5
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ],
    ip: 0,
    op: 76,
    st: 0,
    ef: [
      {
        ty: 28,
        ix: 1,
        nm: "Set Matte",
        mn: "ADBE Set Matte3",
        ef: [
          {
            ix: 1,
            mn: "ADBE Set Matte3-0001",
            nm: "Take Matte From Layer",
            ty: 10,
            v: {
              a: 0,
              k: 5
            }
          },
          {
            ix: 2,
            mn: "ADBE Set Matte3-0002",
            nm: "Use For Matte",
            ty: 7,
            v: {
              a: 0,
              k: 4
            }
          },
          {
            ix: 3,
            mn: "ADBE Set Matte3-0003",
            nm: "Invert Matte",
            ty: 7,
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ix: 4,
            mn: "ADBE Set Matte3-0004",
            nm: "If Layer Sizes Differ",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 5,
            mn: "ADBE Set Matte3-0005",
            nm: "Composite Matte with Original",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          },
          {
            ix: 6,
            mn: "ADBE Set Matte3-0006",
            nm: "Premultiply Matte Layer",
            ty: 7,
            v: {
              a: 0,
              k: 1
            }
          }
        ],
        en: 1
      }
    ],
    parent: 5
  },
  {
    ind: 5,
    ty: 4,
    nm: "Base",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 0,
            s: [
              0
            ]
          },
          {
            t: 8,
            s: [
              100
            ]
          }
        ]
      },
      r: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [
          115,
          134,
          0
        ]
      },
      a: {
        a: 0,
        k: [
          -0.05,
          -0.025,
          0
        ]
      },
      s: {
        k: [
          {
            i: {
              x: [
                0.25,
                0.25,
                0.25
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0.186,
                0.186,
                0
              ]
            },
            t: 0,
            s: [
              0,
              0,
              100
            ]
          },
          {
            t: 26,
            s: [
              100.524,
              100.524,
              100
            ]
          }
        ],
        a: 1
      }
    },
    shapes: [
      {
        ty: "gr",
        nm: "path-2",
        bm: 0,
        mn: "ADBE Vector Group",
        it: [
          {
            ty: "sh",
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            ind: 0,
            ks: {
              k: {
                i: [
                  [
                    -23.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -23.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    13,
                    -7.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    13.4,
                    8.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    15.1
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    23.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    15.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -13.6,
                    8.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -13,
                    -7.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -23.7
                  ]
                ],
                v: [
                  [
                    -71.55,
                    -133.75
                  ],
                  [
                    71.55,
                    -133.75
                  ],
                  [
                    114.35,
                    -90.95
                  ],
                  [
                    114.35,
                    47.85
                  ],
                  [
                    93.55,
                    84.55
                  ],
                  [
                    22.05,
                    127.55
                  ],
                  [
                    -21.95,
                    127.55
                  ],
                  [
                    -93.65,
                    84.55
                  ],
                  [
                    -114.45,
                    47.85
                  ],
                  [
                    -114.45,
                    -90.95
                  ]
                ],
                c: !0
              },
              a: 0
            }
          },
          {
            ty: "gf",
            s: {
              a: 0,
              k: [
                -114.4,
                -133.798
              ]
            },
            e: {
              a: 0,
              k: [
                114.424,
                133.823
              ]
            },
            t: 1,
            g: {
              k: {
                a: 0,
                k: [
                  0,
                  1,
                  0.792,
                  0,
                  0.5,
                  1,
                  0.702,
                  0.161,
                  1,
                  1,
                  0.612,
                  0.322
                ]
              },
              p: 3
            },
            nm: "Gradient Fill 1",
            bm: 0,
            mn: "ADBE Vector Graphic - G-Fill",
            o: {
              a: 0,
              k: 100
            },
            r: 1
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ]
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ]
            },
            nm: "Transform",
            sk: {
              a: 0,
              k: 0
            },
            sa: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ],
    ip: 0,
    op: 76,
    st: 0
  }
], markers = [], animation = {
  v,
  ip,
  op,
  fr,
  w,
  h,
  nm,
  assets,
  layers,
  markers
};
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(ce, ie) {
    module.exports = ie();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(ie) {
      _useWebWorker = !!ie;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(ie) {
      locationHref = ie;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(ce) {
      return document.createElement(ce);
    }
    function extendPrototype(ce, ie) {
      var me, we = ce.length, Re;
      for (me = 0; me < we; me += 1) {
        Re = ce[me].prototype;
        for (var je in Re)
          Object.prototype.hasOwnProperty.call(Re, je) && (ie.prototype[je] = Re[je]);
      }
    }
    function getDescriptor(ce, ie) {
      return Object.getOwnPropertyDescriptor(ce, ie);
    }
    function createProxyFunction(ce) {
      function ie() {
      }
      return ie.prototype = ce, ie;
    }
    var audioControllerFactory = function() {
      function ce(ie) {
        this.audios = [], this.audioFactory = ie, this._volume = 1, this._isMuted = !1;
      }
      return ce.prototype = {
        addAudio: function(me) {
          this.audios.push(me);
        },
        pause: function() {
          var me, we = this.audios.length;
          for (me = 0; me < we; me += 1)
            this.audios[me].pause();
        },
        resume: function() {
          var me, we = this.audios.length;
          for (me = 0; me < we; me += 1)
            this.audios[me].resume();
        },
        setRate: function(me) {
          var we, Re = this.audios.length;
          for (we = 0; we < Re; we += 1)
            this.audios[we].setRate(me);
        },
        createAudio: function(me) {
          return this.audioFactory ? this.audioFactory(me) : window.Howl ? new window.Howl({
            src: [me]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(me) {
          this.audioFactory = me;
        },
        setVolume: function(me) {
          this._volume = me, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var me, we = this.audios.length;
          for (me = 0; me < we; me += 1)
            this.audios[me].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new ce();
      };
    }(), createTypedArray = /* @__PURE__ */ function() {
      function ce(me, we) {
        var Re = 0, je = [], Ue;
        switch (me) {
          case "int16":
          case "uint8c":
            Ue = 1;
            break;
          default:
            Ue = 1.1;
            break;
        }
        for (Re = 0; Re < we; Re += 1)
          je.push(Ue);
        return je;
      }
      function ie(me, we) {
        return me === "float32" ? new Float32Array(we) : me === "int16" ? new Int16Array(we) : me === "uint8c" ? new Uint8ClampedArray(we) : ce(me, we);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? ie : ce;
    }();
    function createSizedArray(ce) {
      return Array.apply(null, {
        length: ce
      });
    }
    function _typeof$6(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(me) {
        return typeof me;
      } : _typeof$6 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$6(ce);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var ce = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        BMMath[ce[ie]] = Math[ce[ie]];
    })(), BMMath.random = Math.random, BMMath.abs = function(ce) {
      var ie = _typeof$6(ce);
      if (ie === "object" && ce.length) {
        var me = createSizedArray(ce.length), we, Re = ce.length;
        for (we = 0; we < Re; we += 1)
          me[we] = Math.abs(ce[we]);
        return me;
      }
      return Math.abs(ce);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(ce) {
      ce.style.position = "absolute", ce.style.top = 0, ce.style.left = 0, ce.style.display = "block", ce.style.transformOrigin = "0 0", ce.style.webkitTransformOrigin = "0 0", ce.style.backfaceVisibility = "visible", ce.style.webkitBackfaceVisibility = "visible", ce.style.transformStyle = "preserve-3d", ce.style.webkitTransformStyle = "preserve-3d", ce.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(ce, ie, me, we) {
      this.type = ce, this.currentTime = ie, this.totalTime = me, this.direction = we < 0 ? -1 : 1;
    }
    function BMCompleteEvent(ce, ie) {
      this.type = ce, this.direction = ie < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(ce, ie, me, we) {
      this.type = ce, this.currentLoop = me, this.totalLoops = ie, this.direction = we < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(ce, ie, me) {
      this.type = ce, this.firstFrame = ie, this.totalFrames = me;
    }
    function BMDestroyEvent(ce, ie) {
      this.type = ce, this.target = ie;
    }
    function BMRenderFrameErrorEvent(ce, ie) {
      this.type = "renderFrameError", this.nativeError = ce, this.currentTime = ie;
    }
    function BMConfigErrorEvent(ce) {
      this.type = "configError", this.nativeError = ce;
    }
    var createElementID = /* @__PURE__ */ function() {
      var ce = 0;
      return function() {
        return ce += 1, idPrefix$1 + "__lottie_element_" + ce;
      };
    }();
    function HSVtoRGB(ce, ie, me) {
      var we, Re, je, Ue, qe, Ge, Xe, ot;
      switch (Ue = Math.floor(ce * 6), qe = ce * 6 - Ue, Ge = me * (1 - ie), Xe = me * (1 - qe * ie), ot = me * (1 - (1 - qe) * ie), Ue % 6) {
        case 0:
          we = me, Re = ot, je = Ge;
          break;
        case 1:
          we = Xe, Re = me, je = Ge;
          break;
        case 2:
          we = Ge, Re = me, je = ot;
          break;
        case 3:
          we = Ge, Re = Xe, je = me;
          break;
        case 4:
          we = ot, Re = Ge, je = me;
          break;
        case 5:
          we = me, Re = Ge, je = Xe;
          break;
      }
      return [we, Re, je];
    }
    function RGBtoHSV(ce, ie, me) {
      var we = Math.max(ce, ie, me), Re = Math.min(ce, ie, me), je = we - Re, Ue, qe = we === 0 ? 0 : je / we, Ge = we / 255;
      switch (we) {
        case Re:
          Ue = 0;
          break;
        case ce:
          Ue = ie - me + je * (ie < me ? 6 : 0), Ue /= 6 * je;
          break;
        case ie:
          Ue = me - ce + je * 2, Ue /= 6 * je;
          break;
        case me:
          Ue = ce - ie + je * 4, Ue /= 6 * je;
          break;
      }
      return [Ue, qe, Ge];
    }
    function addSaturationToRGB(ce, ie) {
      var me = RGBtoHSV(ce[0] * 255, ce[1] * 255, ce[2] * 255);
      return me[1] += ie, me[1] > 1 ? me[1] = 1 : me[1] <= 0 && (me[1] = 0), HSVtoRGB(me[0], me[1], me[2]);
    }
    function addBrightnessToRGB(ce, ie) {
      var me = RGBtoHSV(ce[0] * 255, ce[1] * 255, ce[2] * 255);
      return me[2] += ie, me[2] > 1 ? me[2] = 1 : me[2] < 0 && (me[2] = 0), HSVtoRGB(me[0], me[1], me[2]);
    }
    function addHueToRGB(ce, ie) {
      var me = RGBtoHSV(ce[0] * 255, ce[1] * 255, ce[2] * 255);
      return me[0] += ie / 360, me[0] > 1 ? me[0] -= 1 : me[0] < 0 && (me[0] += 1), HSVtoRGB(me[0], me[1], me[2]);
    }
    var rgbToHex = function() {
      var ce = [], ie, me;
      for (ie = 0; ie < 256; ie += 1)
        me = ie.toString(16), ce[ie] = me.length === 1 ? "0" + me : me;
      return function(we, Re, je) {
        return we < 0 && (we = 0), Re < 0 && (Re = 0), je < 0 && (je = 0), "#" + ce[we] + ce[Re] + ce[je];
      };
    }(), setSubframeEnabled = function(ie) {
      subframeEnabled = !!ie;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(ie) {
      expressionsPlugin = ie;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(ie) {
      expressionsInterfaces = ie;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(ie) {
      defaultCurveSegments = ie;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(ie) {
      idPrefix$1 = ie;
    };
    function createNS(ce) {
      return document.createElementNS(svgNS, ce);
    }
    function _typeof$5(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(me) {
        return typeof me;
      } : _typeof$5 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$5(ce);
    }
    var dataManager = /* @__PURE__ */ function() {
      var ce = 1, ie = [], me, we, Re = {
        onmessage: function() {
        },
        postMessage: function(Tt) {
          me({
            data: Tt
          });
        }
      }, je = {
        postMessage: function(Tt) {
          Re.onmessage({
            data: Tt
          });
        }
      };
      function Ue(bt) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var Tt = new Blob(["var _workerSelf = self; self.onmessage = ", bt.toString()], {
            type: "text/javascript"
          }), wt = URL.createObjectURL(Tt);
          return new Worker(wt);
        }
        return me = bt, Re;
      }
      function qe() {
        we || (we = Ue(function(Tt) {
          function wt() {
            function It(kn, cn) {
              var gn, an, un = kn.length, pn, hn, An, In;
              for (an = 0; an < un; an += 1)
                if (gn = kn[an], "ks" in gn && !gn.completed) {
                  if (gn.completed = !0, gn.hasMask) {
                    var qn = gn.masksProperties;
                    for (hn = qn.length, pn = 0; pn < hn; pn += 1)
                      if (qn[pn].pt.k.i)
                        en(qn[pn].pt.k);
                      else
                        for (In = qn[pn].pt.k.length, An = 0; An < In; An += 1)
                          qn[pn].pt.k[An].s && en(qn[pn].pt.k[An].s[0]), qn[pn].pt.k[An].e && en(qn[pn].pt.k[An].e[0]);
                  }
                  gn.ty === 0 ? (gn.layers = Ot(gn.refId, cn), It(gn.layers, cn)) : gn.ty === 4 ? Jr(gn.shapes) : gn.ty === 5 && Sn(gn);
                }
            }
            function Pt(kn, cn) {
              if (kn) {
                var gn = 0, an = kn.length;
                for (gn = 0; gn < an; gn += 1)
                  kn[gn].t === 1 && (kn[gn].data.layers = Ot(kn[gn].data.refId, cn), It(kn[gn].data.layers, cn));
              }
            }
            function kt(kn, cn) {
              for (var gn = 0, an = cn.length; gn < an; ) {
                if (cn[gn].id === kn)
                  return cn[gn];
                gn += 1;
              }
              return null;
            }
            function Ot(kn, cn) {
              var gn = kt(kn, cn);
              return gn ? gn.layers.__used ? JSON.parse(JSON.stringify(gn.layers)) : (gn.layers.__used = !0, gn.layers) : null;
            }
            function Jr(kn) {
              var cn, gn = kn.length, an, un;
              for (cn = gn - 1; cn >= 0; cn -= 1)
                if (kn[cn].ty === "sh")
                  if (kn[cn].ks.k.i)
                    en(kn[cn].ks.k);
                  else
                    for (un = kn[cn].ks.k.length, an = 0; an < un; an += 1)
                      kn[cn].ks.k[an].s && en(kn[cn].ks.k[an].s[0]), kn[cn].ks.k[an].e && en(kn[cn].ks.k[an].e[0]);
                else kn[cn].ty === "gr" && Jr(kn[cn].it);
            }
            function en(kn) {
              var cn, gn = kn.i.length;
              for (cn = 0; cn < gn; cn += 1)
                kn.i[cn][0] += kn.v[cn][0], kn.i[cn][1] += kn.v[cn][1], kn.o[cn][0] += kn.v[cn][0], kn.o[cn][1] += kn.v[cn][1];
            }
            function nn(kn, cn) {
              var gn = cn ? cn.split(".") : [100, 100, 100];
              return kn[0] > gn[0] ? !0 : gn[0] > kn[0] ? !1 : kn[1] > gn[1] ? !0 : gn[1] > kn[1] ? !1 : kn[2] > gn[2] ? !0 : gn[2] > kn[2] ? !1 : null;
            }
            var ln = /* @__PURE__ */ function() {
              var kn = [4, 4, 14];
              function cn(an) {
                var un = an.t.d;
                an.t.d = {
                  k: [{
                    s: un,
                    t: 0
                  }]
                };
              }
              function gn(an) {
                var un, pn = an.length;
                for (un = 0; un < pn; un += 1)
                  an[un].ty === 5 && cn(an[un]);
              }
              return function(an) {
                if (nn(kn, an.v) && (gn(an.layers), an.assets)) {
                  var un, pn = an.assets.length;
                  for (un = 0; un < pn; un += 1)
                    an.assets[un].layers && gn(an.assets[un].layers);
                }
              };
            }(), fn = /* @__PURE__ */ function() {
              var kn = [4, 7, 99];
              return function(cn) {
                if (cn.chars && !nn(kn, cn.v)) {
                  var gn, an = cn.chars.length;
                  for (gn = 0; gn < an; gn += 1) {
                    var un = cn.chars[gn];
                    un.data && un.data.shapes && (Jr(un.data.shapes), un.data.ip = 0, un.data.op = 99999, un.data.st = 0, un.data.sr = 1, un.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, cn.chars[gn].t || (un.data.shapes.push({
                      ty: "no"
                    }), un.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), vn = /* @__PURE__ */ function() {
              var kn = [5, 7, 15];
              function cn(an) {
                var un = an.t.p;
                typeof un.a == "number" && (un.a = {
                  a: 0,
                  k: un.a
                }), typeof un.p == "number" && (un.p = {
                  a: 0,
                  k: un.p
                }), typeof un.r == "number" && (un.r = {
                  a: 0,
                  k: un.r
                });
              }
              function gn(an) {
                var un, pn = an.length;
                for (un = 0; un < pn; un += 1)
                  an[un].ty === 5 && cn(an[un]);
              }
              return function(an) {
                if (nn(kn, an.v) && (gn(an.layers), an.assets)) {
                  var un, pn = an.assets.length;
                  for (un = 0; un < pn; un += 1)
                    an.assets[un].layers && gn(an.assets[un].layers);
                }
              };
            }(), Tn = /* @__PURE__ */ function() {
              var kn = [4, 1, 9];
              function cn(an) {
                var un, pn = an.length, hn, An;
                for (un = 0; un < pn; un += 1)
                  if (an[un].ty === "gr")
                    cn(an[un].it);
                  else if (an[un].ty === "fl" || an[un].ty === "st")
                    if (an[un].c.k && an[un].c.k[0].i)
                      for (An = an[un].c.k.length, hn = 0; hn < An; hn += 1)
                        an[un].c.k[hn].s && (an[un].c.k[hn].s[0] /= 255, an[un].c.k[hn].s[1] /= 255, an[un].c.k[hn].s[2] /= 255, an[un].c.k[hn].s[3] /= 255), an[un].c.k[hn].e && (an[un].c.k[hn].e[0] /= 255, an[un].c.k[hn].e[1] /= 255, an[un].c.k[hn].e[2] /= 255, an[un].c.k[hn].e[3] /= 255);
                    else
                      an[un].c.k[0] /= 255, an[un].c.k[1] /= 255, an[un].c.k[2] /= 255, an[un].c.k[3] /= 255;
              }
              function gn(an) {
                var un, pn = an.length;
                for (un = 0; un < pn; un += 1)
                  an[un].ty === 4 && cn(an[un].shapes);
              }
              return function(an) {
                if (nn(kn, an.v) && (gn(an.layers), an.assets)) {
                  var un, pn = an.assets.length;
                  for (un = 0; un < pn; un += 1)
                    an.assets[un].layers && gn(an.assets[un].layers);
                }
              };
            }(), xn = /* @__PURE__ */ function() {
              var kn = [4, 4, 18];
              function cn(an) {
                var un, pn = an.length, hn, An;
                for (un = pn - 1; un >= 0; un -= 1)
                  if (an[un].ty === "sh")
                    if (an[un].ks.k.i)
                      an[un].ks.k.c = an[un].closed;
                    else
                      for (An = an[un].ks.k.length, hn = 0; hn < An; hn += 1)
                        an[un].ks.k[hn].s && (an[un].ks.k[hn].s[0].c = an[un].closed), an[un].ks.k[hn].e && (an[un].ks.k[hn].e[0].c = an[un].closed);
                  else an[un].ty === "gr" && cn(an[un].it);
              }
              function gn(an) {
                var un, pn, hn = an.length, An, In, qn, si;
                for (pn = 0; pn < hn; pn += 1) {
                  if (un = an[pn], un.hasMask) {
                    var bi = un.masksProperties;
                    for (In = bi.length, An = 0; An < In; An += 1)
                      if (bi[An].pt.k.i)
                        bi[An].pt.k.c = bi[An].cl;
                      else
                        for (si = bi[An].pt.k.length, qn = 0; qn < si; qn += 1)
                          bi[An].pt.k[qn].s && (bi[An].pt.k[qn].s[0].c = bi[An].cl), bi[An].pt.k[qn].e && (bi[An].pt.k[qn].e[0].c = bi[An].cl);
                  }
                  un.ty === 4 && cn(un.shapes);
                }
              }
              return function(an) {
                if (nn(kn, an.v) && (gn(an.layers), an.assets)) {
                  var un, pn = an.assets.length;
                  for (un = 0; un < pn; un += 1)
                    an.assets[un].layers && gn(an.assets[un].layers);
                }
              };
            }();
            function bn(kn) {
              kn.__complete || (Tn(kn), ln(kn), fn(kn), vn(kn), xn(kn), It(kn.layers, kn.assets), Pt(kn.chars, kn.assets), kn.__complete = !0);
            }
            function Sn(kn) {
              kn.t.a.length === 0 && "m" in kn.t.p;
            }
            var Cn = {};
            return Cn.completeData = bn, Cn.checkColors = Tn, Cn.checkChars = fn, Cn.checkPathProperties = vn, Cn.checkShapes = xn, Cn.completeLayers = It, Cn;
          }
          if (je.dataManager || (je.dataManager = wt()), je.assetLoader || (je.assetLoader = /* @__PURE__ */ function() {
            function It(kt) {
              var Ot = kt.getResponseHeader("content-type");
              return Ot && kt.responseType === "json" && Ot.indexOf("json") !== -1 || kt.response && _typeof$5(kt.response) === "object" ? kt.response : kt.response && typeof kt.response == "string" ? JSON.parse(kt.response) : kt.responseText ? JSON.parse(kt.responseText) : null;
            }
            function Pt(kt, Ot, Jr, en) {
              var nn, ln = new XMLHttpRequest();
              try {
                ln.responseType = "json";
              } catch {
              }
              ln.onreadystatechange = function() {
                if (ln.readyState === 4)
                  if (ln.status === 200)
                    nn = It(ln), Jr(nn);
                  else
                    try {
                      nn = It(ln), Jr(nn);
                    } catch (fn) {
                      en && en(fn);
                    }
              };
              try {
                ln.open(["G", "E", "T"].join(""), kt, !0);
              } catch {
                ln.open(["G", "E", "T"].join(""), Ot + "/" + kt, !0);
              }
              ln.send();
            }
            return {
              load: Pt
            };
          }()), Tt.data.type === "loadAnimation")
            je.assetLoader.load(Tt.data.path, Tt.data.fullPath, function(It) {
              je.dataManager.completeData(It), je.postMessage({
                id: Tt.data.id,
                payload: It,
                status: "success"
              });
            }, function() {
              je.postMessage({
                id: Tt.data.id,
                status: "error"
              });
            });
          else if (Tt.data.type === "complete") {
            var St = Tt.data.animation;
            je.dataManager.completeData(St), je.postMessage({
              id: Tt.data.id,
              payload: St,
              status: "success"
            });
          } else Tt.data.type === "loadData" && je.assetLoader.load(Tt.data.path, Tt.data.fullPath, function(It) {
            je.postMessage({
              id: Tt.data.id,
              payload: It,
              status: "success"
            });
          }, function() {
            je.postMessage({
              id: Tt.data.id,
              status: "error"
            });
          });
        }), we.onmessage = function(bt) {
          var Tt = bt.data, wt = Tt.id, St = ie[wt];
          ie[wt] = null, Tt.status === "success" ? St.onComplete(Tt.payload) : St.onError && St.onError();
        });
      }
      function Ge(bt, Tt) {
        ce += 1;
        var wt = "processId_" + ce;
        return ie[wt] = {
          onComplete: bt,
          onError: Tt
        }, wt;
      }
      function Xe(bt, Tt, wt) {
        qe();
        var St = Ge(Tt, wt);
        we.postMessage({
          type: "loadAnimation",
          path: bt,
          fullPath: window.location.origin + window.location.pathname,
          id: St
        });
      }
      function ot(bt, Tt, wt) {
        qe();
        var St = Ge(Tt, wt);
        we.postMessage({
          type: "loadData",
          path: bt,
          fullPath: window.location.origin + window.location.pathname,
          id: St
        });
      }
      function vt(bt, Tt, wt) {
        qe();
        var St = Ge(Tt, wt);
        we.postMessage({
          type: "complete",
          animation: bt,
          id: St
        });
      }
      return {
        loadAnimation: Xe,
        loadData: ot,
        completeAnimation: vt
      };
    }(), ImagePreloader = function() {
      var ce = function() {
        var Pt = createTag("canvas");
        Pt.width = 1, Pt.height = 1;
        var kt = Pt.getContext("2d");
        return kt.fillStyle = "rgba(0,0,0,0)", kt.fillRect(0, 0, 1, 1), Pt;
      }();
      function ie() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function me() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function we(Pt, kt, Ot) {
        var Jr = "";
        if (Pt.e)
          Jr = Pt.p;
        else if (kt) {
          var en = Pt.p;
          en.indexOf("images/") !== -1 && (en = en.split("/")[1]), Jr = kt + en;
        } else
          Jr = Ot, Jr += Pt.u ? Pt.u : "", Jr += Pt.p;
        return Jr;
      }
      function Re(Pt) {
        var kt = 0, Ot = setInterval((function() {
          var Jr = Pt.getBBox();
          (Jr.width || kt > 500) && (this._imageLoaded(), clearInterval(Ot)), kt += 1;
        }).bind(this), 50);
      }
      function je(Pt) {
        var kt = we(Pt, this.assetsPath, this.path), Ot = createNS("image");
        isSafari ? this.testImageLoaded(Ot) : Ot.addEventListener("load", this._imageLoaded, !1), Ot.addEventListener("error", (function() {
          Jr.img = ce, this._imageLoaded();
        }).bind(this), !1), Ot.setAttributeNS("http://www.w3.org/1999/xlink", "href", kt), this._elementHelper.append ? this._elementHelper.append(Ot) : this._elementHelper.appendChild(Ot);
        var Jr = {
          img: Ot,
          assetData: Pt
        };
        return Jr;
      }
      function Ue(Pt) {
        var kt = we(Pt, this.assetsPath, this.path), Ot = createTag("img");
        Ot.crossOrigin = "anonymous", Ot.addEventListener("load", this._imageLoaded, !1), Ot.addEventListener("error", (function() {
          Jr.img = ce, this._imageLoaded();
        }).bind(this), !1), Ot.src = kt;
        var Jr = {
          img: Ot,
          assetData: Pt
        };
        return Jr;
      }
      function qe(Pt) {
        var kt = {
          assetData: Pt
        }, Ot = we(Pt, this.assetsPath, this.path);
        return dataManager.loadData(Ot, (function(Jr) {
          kt.img = Jr, this._footageLoaded();
        }).bind(this), (function() {
          kt.img = {}, this._footageLoaded();
        }).bind(this)), kt;
      }
      function Ge(Pt, kt) {
        this.imagesLoadedCb = kt;
        var Ot, Jr = Pt.length;
        for (Ot = 0; Ot < Jr; Ot += 1)
          Pt[Ot].layers || (!Pt[Ot].t || Pt[Ot].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(Pt[Ot]))) : Pt[Ot].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(Pt[Ot]))));
      }
      function Xe(Pt) {
        this.path = Pt || "";
      }
      function ot(Pt) {
        this.assetsPath = Pt || "";
      }
      function vt(Pt) {
        for (var kt = 0, Ot = this.images.length; kt < Ot; ) {
          if (this.images[kt].assetData === Pt)
            return this.images[kt].img;
          kt += 1;
        }
        return null;
      }
      function bt() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function Tt() {
        return this.totalImages === this.loadedAssets;
      }
      function wt() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function St(Pt, kt) {
        Pt === "svg" ? (this._elementHelper = kt, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function It() {
        this._imageLoaded = ie.bind(this), this._footageLoaded = me.bind(this), this.testImageLoaded = Re.bind(this), this.createFootageData = qe.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return It.prototype = {
        loadAssets: Ge,
        setAssetsPath: ot,
        setPath: Xe,
        loadedImages: Tt,
        loadedFootages: wt,
        destroy: bt,
        getAsset: vt,
        createImgData: Ue,
        createImageData: je,
        imageLoaded: ie,
        footageLoaded: me,
        setCacheType: St
      }, It;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(ie, me) {
        if (this._cbs[ie])
          for (var we = this._cbs[ie], Re = 0; Re < we.length; Re += 1)
            we[Re](me);
      },
      addEventListener: function(ie, me) {
        return this._cbs[ie] || (this._cbs[ie] = []), this._cbs[ie].push(me), (function() {
          this.removeEventListener(ie, me);
        }).bind(this);
      },
      removeEventListener: function(ie, me) {
        if (!me)
          this._cbs[ie] = null;
        else if (this._cbs[ie]) {
          for (var we = 0, Re = this._cbs[ie].length; we < Re; )
            this._cbs[ie][we] === me && (this._cbs[ie].splice(we, 1), we -= 1, Re -= 1), we += 1;
          this._cbs[ie].length || (this._cbs[ie] = null);
        }
      }
    };
    var markerParser = /* @__PURE__ */ function() {
      function ce(ie) {
        for (var me = ie.split(`\r
`), we = {}, Re, je = 0, Ue = 0; Ue < me.length; Ue += 1)
          Re = me[Ue].split(":"), Re.length === 2 && (we[Re[0]] = Re[1].trim(), je += 1);
        if (je === 0)
          throw new Error();
        return we;
      }
      return function(ie) {
        for (var me = [], we = 0; we < ie.length; we += 1) {
          var Re = ie[we], je = {
            time: Re.tm,
            duration: Re.dr
          };
          try {
            je.payload = JSON.parse(ie[we].cm);
          } catch {
            try {
              je.payload = ce(ie[we].cm);
            } catch {
              je.payload = {
                name: ie[we].cm
              };
            }
          }
          me.push(je);
        }
        return me;
      };
    }(), ProjectInterface = /* @__PURE__ */ function() {
      function ce(ie) {
        this.compositions.push(ie);
      }
      return function() {
        function ie(me) {
          for (var we = 0, Re = this.compositions.length; we < Re; ) {
            if (this.compositions[we].data && this.compositions[we].data.nm === me)
              return this.compositions[we].prepareFrame && this.compositions[we].data.xt && this.compositions[we].prepareFrame(this.currentFrame), this.compositions[we].compInterface;
            we += 1;
          }
          return null;
        }
        return ie.compositions = [], ie.currentFrame = 0, ie.registerComposition = ce, ie;
      };
    }(), renderers = {}, registerRenderer = function(ie, me) {
      renderers[ie] = me;
    };
    function getRenderer(ce) {
      return renderers[ce];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var ce in renderers)
        if (renderers[ce])
          return ce;
      return "";
    }
    function _typeof$4(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(me) {
        return typeof me;
      } : _typeof$4 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$4(ce);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(ce) {
      (ce.wrapper || ce.container) && (this.wrapper = ce.wrapper || ce.container);
      var ie = "svg";
      ce.animType ? ie = ce.animType : ce.renderer && (ie = ce.renderer);
      var me = getRenderer(ie);
      this.renderer = new me(this, ce.rendererSettings), this.imagePreloader.setCacheType(ie, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = ie, ce.loop === "" || ce.loop === null || ce.loop === void 0 || ce.loop === !0 ? this.loop = !0 : ce.loop === !1 ? this.loop = !1 : this.loop = parseInt(ce.loop, 10), this.autoplay = "autoplay" in ce ? ce.autoplay : !0, this.name = ce.name ? ce.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(ce, "autoloadSegments") ? ce.autoloadSegments : !0, this.assetsPath = ce.assetsPath, this.initialSegment = ce.initialSegment, ce.audioFactory && this.audioController.setAudioFactory(ce.audioFactory), ce.animationData ? this.setupAnimation(ce.animationData) : ce.path && (ce.path.lastIndexOf("\\") !== -1 ? this.path = ce.path.substr(0, ce.path.lastIndexOf("\\") + 1) : this.path = ce.path.substr(0, ce.path.lastIndexOf("/") + 1), this.fileName = ce.path.substr(ce.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(ce.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(ce) {
      dataManager.completeAnimation(ce, this.configAnimation);
    }, AnimationItem.prototype.setData = function(ce, ie) {
      ie && _typeof$4(ie) !== "object" && (ie = JSON.parse(ie));
      var me = {
        wrapper: ce,
        animationData: ie
      }, we = ce.attributes;
      me.path = we.getNamedItem("data-animation-path") ? we.getNamedItem("data-animation-path").value : we.getNamedItem("data-bm-path") ? we.getNamedItem("data-bm-path").value : we.getNamedItem("bm-path") ? we.getNamedItem("bm-path").value : "", me.animType = we.getNamedItem("data-anim-type") ? we.getNamedItem("data-anim-type").value : we.getNamedItem("data-bm-type") ? we.getNamedItem("data-bm-type").value : we.getNamedItem("bm-type") ? we.getNamedItem("bm-type").value : we.getNamedItem("data-bm-renderer") ? we.getNamedItem("data-bm-renderer").value : we.getNamedItem("bm-renderer") ? we.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var Re = we.getNamedItem("data-anim-loop") ? we.getNamedItem("data-anim-loop").value : we.getNamedItem("data-bm-loop") ? we.getNamedItem("data-bm-loop").value : we.getNamedItem("bm-loop") ? we.getNamedItem("bm-loop").value : "";
      Re === "false" ? me.loop = !1 : Re === "true" ? me.loop = !0 : Re !== "" && (me.loop = parseInt(Re, 10));
      var je = we.getNamedItem("data-anim-autoplay") ? we.getNamedItem("data-anim-autoplay").value : we.getNamedItem("data-bm-autoplay") ? we.getNamedItem("data-bm-autoplay").value : we.getNamedItem("bm-autoplay") ? we.getNamedItem("bm-autoplay").value : !0;
      me.autoplay = je !== "false", me.name = we.getNamedItem("data-name") ? we.getNamedItem("data-name").value : we.getNamedItem("data-bm-name") ? we.getNamedItem("data-bm-name").value : we.getNamedItem("bm-name") ? we.getNamedItem("bm-name").value : "";
      var Ue = we.getNamedItem("data-anim-prerender") ? we.getNamedItem("data-anim-prerender").value : we.getNamedItem("data-bm-prerender") ? we.getNamedItem("data-bm-prerender").value : we.getNamedItem("bm-prerender") ? we.getNamedItem("bm-prerender").value : "";
      Ue === "false" && (me.prerender = !1), me.path ? this.setParams(me) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(ce) {
      ce.op > this.animationData.op && (this.animationData.op = ce.op, this.totalFrames = Math.floor(ce.op - this.animationData.ip));
      var ie = this.animationData.layers, me, we = ie.length, Re = ce.layers, je, Ue = Re.length;
      for (je = 0; je < Ue; je += 1)
        for (me = 0; me < we; ) {
          if (ie[me].id === Re[je].id) {
            ie[me] = Re[je];
            break;
          }
          me += 1;
        }
      if ((ce.chars || ce.fonts) && (this.renderer.globalData.fontManager.addChars(ce.chars), this.renderer.globalData.fontManager.addFonts(ce.fonts, this.renderer.globalData.defs)), ce.assets)
        for (we = ce.assets.length, me = 0; me < we; me += 1)
          this.animationData.assets.push(ce.assets[me]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(ce) {
      this.animationData = ce;
      var ie = getExpressionsPlugin();
      ie && ie.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var ce = this.animationData.segments;
      if (!ce || ce.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var ie = ce.shift();
      this.timeCompleted = ie.time * this.frameRate;
      var me = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(me, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var ce = this.animationData.segments;
      ce || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(ce) {
      if (this.renderer)
        try {
          this.animationData = ce, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(ce), ce.assets || (ce.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(ce.assets), this.markers = markerParser(ce.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (ie) {
          this.triggerConfigError(ie);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var ce = getExpressionsPlugin();
        ce && ce.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(ce, ie) {
      var me = typeof ce == "number" ? ce : void 0, we = typeof ie == "number" ? ie : void 0;
      this.renderer.updateContainerSize(me, we);
    }, AnimationItem.prototype.setSubframe = function(ce) {
      this.isSubframeEnabled = !!ce;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (ce) {
          this.triggerRenderFrameError(ce);
        }
    }, AnimationItem.prototype.play = function(ce) {
      ce && this.name !== ce || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(ce) {
      ce && this.name !== ce || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(ce) {
      ce && this.name !== ce || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(ce) {
      ce && this.name !== ce || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(ce) {
      for (var ie, me = 0; me < this.markers.length; me += 1)
        if (ie = this.markers[me], ie.payload && ie.payload.name === ce)
          return ie;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(ce, ie, me) {
      if (!(me && this.name !== me)) {
        var we = Number(ce);
        if (isNaN(we)) {
          var Re = this.getMarkerData(ce);
          Re && this.goToAndStop(Re.time, !0);
        } else ie ? this.setCurrentRawFrameValue(ce) : this.setCurrentRawFrameValue(ce * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(ce, ie, me) {
      if (!(me && this.name !== me)) {
        var we = Number(ce);
        if (isNaN(we)) {
          var Re = this.getMarkerData(ce);
          Re && (Re.duration ? this.playSegments([Re.time, Re.time + Re.duration], !0) : this.goToAndStop(Re.time, !0));
        } else
          this.goToAndStop(we, ie, me);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(ce) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var ie = this.currentRawFrame + ce * this.frameModifier, me = !1;
        ie >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(ie > this.totalFrames ? ie % this.totalFrames : 0) || (me = !0, ie = this.totalFrames - 1) : ie >= this.totalFrames ? (this.playCount += 1, this.checkSegments(ie % this.totalFrames) || (this.setCurrentRawFrameValue(ie % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(ie) : ie < 0 ? this.checkSegments(ie % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + ie % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (me = !0, ie = 0)) : this.setCurrentRawFrameValue(ie), me && (this.setCurrentRawFrameValue(ie), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(ce, ie) {
      this.playCount = 0, ce[1] < ce[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = ce[0] - ce[1], this.timeCompleted = this.totalFrames, this.firstFrame = ce[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - ie)) : ce[1] > ce[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = ce[1] - ce[0], this.timeCompleted = this.totalFrames, this.firstFrame = ce[0], this.setCurrentRawFrameValue(1e-3 + ie)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(ce, ie) {
      var me = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < ce ? me = ce : this.currentRawFrame + this.firstFrame > ie && (me = ie - ce)), this.firstFrame = ce, this.totalFrames = ie - ce, this.timeCompleted = this.totalFrames, me !== -1 && this.goToAndStop(me, !0);
    }, AnimationItem.prototype.playSegments = function(ce, ie) {
      if (ie && (this.segments.length = 0), _typeof$4(ce[0]) === "object") {
        var me, we = ce.length;
        for (me = 0; me < we; me += 1)
          this.segments.push(ce[me]);
      } else
        this.segments.push(ce);
      this.segments.length && ie && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(ce) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), ce && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(ce) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), ce), !0) : !1;
    }, AnimationItem.prototype.destroy = function(ce) {
      ce && this.name !== ce || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(ce) {
      this.currentRawFrame = ce, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(ce) {
      this.playSpeed = ce, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(ce) {
      this.playDirection = ce < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(ce) {
      this.loop = ce;
    }, AnimationItem.prototype.setVolume = function(ce, ie) {
      ie && this.name !== ie || this.audioController.setVolume(ce);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(ce) {
      ce && this.name !== ce || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(ce) {
      ce && this.name !== ce || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(ce) {
      var ie = "";
      if (ce.e)
        ie = ce.p;
      else if (this.assetsPath) {
        var me = ce.p;
        me.indexOf("images/") !== -1 && (me = me.split("/")[1]), ie = this.assetsPath + me;
      } else
        ie = this.path, ie += ce.u ? ce.u : "", ie += ce.p;
      return ie;
    }, AnimationItem.prototype.getAssetData = function(ce) {
      for (var ie = 0, me = this.assets.length; ie < me; ) {
        if (ce === this.assets[ie].id)
          return this.assets[ie];
        ie += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(ce) {
      return ce ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(ce, ie, me) {
      try {
        var we = this.renderer.getElementByPath(ce);
        we.updateDocumentData(ie, me);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(ce) {
      if (this._cbs && this._cbs[ce])
        switch (ce) {
          case "enterFrame":
            this.triggerEvent(ce, new BMEnterFrameEvent(ce, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(ce, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(ce, new BMCompleteLoopEvent(ce, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(ce, new BMCompleteEvent(ce, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(ce, new BMSegmentStartEvent(ce, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(ce, new BMDestroyEvent(ce, this));
            break;
          default:
            this.triggerEvent(ce);
        }
      ce === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(ce, this.currentFrame, this.totalFrames, this.frameMult)), ce === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(ce, this.loop, this.playCount, this.frameMult)), ce === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(ce, this.frameMult)), ce === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(ce, this.firstFrame, this.totalFrames)), ce === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(ce, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(ce) {
      var ie = new BMRenderFrameErrorEvent(ce, this.currentFrame);
      this.triggerEvent("error", ie), this.onError && this.onError.call(this, ie);
    }, AnimationItem.prototype.triggerConfigError = function(ce) {
      var ie = new BMConfigErrorEvent(ce, this.currentFrame);
      this.triggerEvent("error", ie), this.onError && this.onError.call(this, ie);
    };
    var animationManager = function() {
      var ce = {}, ie = [], me = 0, we = 0, Re = 0, je = !0, Ue = !1;
      function qe(cn) {
        for (var gn = 0, an = cn.target; gn < we; )
          ie[gn].animation === an && (ie.splice(gn, 1), gn -= 1, we -= 1, an.isPaused || vt()), gn += 1;
      }
      function Ge(cn, gn) {
        if (!cn)
          return null;
        for (var an = 0; an < we; ) {
          if (ie[an].elem === cn && ie[an].elem !== null)
            return ie[an].animation;
          an += 1;
        }
        var un = new AnimationItem();
        return bt(un, cn), un.setData(cn, gn), un;
      }
      function Xe() {
        var cn, gn = ie.length, an = [];
        for (cn = 0; cn < gn; cn += 1)
          an.push(ie[cn].animation);
        return an;
      }
      function ot() {
        Re += 1, Tn();
      }
      function vt() {
        Re -= 1;
      }
      function bt(cn, gn) {
        cn.addEventListener("destroy", qe), cn.addEventListener("_active", ot), cn.addEventListener("_idle", vt), ie.push({
          elem: gn,
          animation: cn
        }), we += 1;
      }
      function Tt(cn) {
        var gn = new AnimationItem();
        return bt(gn, null), gn.setParams(cn), gn;
      }
      function wt(cn, gn) {
        var an;
        for (an = 0; an < we; an += 1)
          ie[an].animation.setSpeed(cn, gn);
      }
      function St(cn, gn) {
        var an;
        for (an = 0; an < we; an += 1)
          ie[an].animation.setDirection(cn, gn);
      }
      function It(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.play(cn);
      }
      function Pt(cn) {
        var gn = cn - me, an;
        for (an = 0; an < we; an += 1)
          ie[an].animation.advanceTime(gn);
        me = cn, Re && !Ue ? window.requestAnimationFrame(Pt) : je = !0;
      }
      function kt(cn) {
        me = cn, window.requestAnimationFrame(Pt);
      }
      function Ot(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.pause(cn);
      }
      function Jr(cn, gn, an) {
        var un;
        for (un = 0; un < we; un += 1)
          ie[un].animation.goToAndStop(cn, gn, an);
      }
      function en(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.stop(cn);
      }
      function nn(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.togglePause(cn);
      }
      function ln(cn) {
        var gn;
        for (gn = we - 1; gn >= 0; gn -= 1)
          ie[gn].animation.destroy(cn);
      }
      function fn(cn, gn, an) {
        var un = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), pn, hn = un.length;
        for (pn = 0; pn < hn; pn += 1)
          an && un[pn].setAttribute("data-bm-type", an), Ge(un[pn], cn);
        if (gn && hn === 0) {
          an || (an = "svg");
          var An = document.getElementsByTagName("body")[0];
          An.innerText = "";
          var In = createTag("div");
          In.style.width = "100%", In.style.height = "100%", In.setAttribute("data-bm-type", an), An.appendChild(In), Ge(In, cn);
        }
      }
      function vn() {
        var cn;
        for (cn = 0; cn < we; cn += 1)
          ie[cn].animation.resize();
      }
      function Tn() {
        !Ue && Re && je && (window.requestAnimationFrame(kt), je = !1);
      }
      function xn() {
        Ue = !0;
      }
      function bn() {
        Ue = !1, Tn();
      }
      function Sn(cn, gn) {
        var an;
        for (an = 0; an < we; an += 1)
          ie[an].animation.setVolume(cn, gn);
      }
      function Cn(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.mute(cn);
      }
      function kn(cn) {
        var gn;
        for (gn = 0; gn < we; gn += 1)
          ie[gn].animation.unmute(cn);
      }
      return ce.registerAnimation = Ge, ce.loadAnimation = Tt, ce.setSpeed = wt, ce.setDirection = St, ce.play = It, ce.pause = Ot, ce.stop = en, ce.togglePause = nn, ce.searchAnimations = fn, ce.resize = vn, ce.goToAndStop = Jr, ce.destroy = ln, ce.freeze = xn, ce.unfreeze = bn, ce.setVolume = Sn, ce.mute = Cn, ce.unmute = kn, ce.getRegisteredAnimations = Xe, ce;
    }(), BezierFactory = function() {
      var ce = {};
      ce.getBezierEasing = me;
      var ie = {};
      function me(kt, Ot, Jr, en, nn) {
        var ln = nn || ("bez_" + kt + "_" + Ot + "_" + Jr + "_" + en).replace(/\./g, "p");
        if (ie[ln])
          return ie[ln];
        var fn = new Pt([kt, Ot, Jr, en]);
        return ie[ln] = fn, fn;
      }
      var we = 4, Re = 1e-3, je = 1e-7, Ue = 10, qe = 11, Ge = 1 / (qe - 1), Xe = typeof Float32Array == "function";
      function ot(kt, Ot) {
        return 1 - 3 * Ot + 3 * kt;
      }
      function vt(kt, Ot) {
        return 3 * Ot - 6 * kt;
      }
      function bt(kt) {
        return 3 * kt;
      }
      function Tt(kt, Ot, Jr) {
        return ((ot(Ot, Jr) * kt + vt(Ot, Jr)) * kt + bt(Ot)) * kt;
      }
      function wt(kt, Ot, Jr) {
        return 3 * ot(Ot, Jr) * kt * kt + 2 * vt(Ot, Jr) * kt + bt(Ot);
      }
      function St(kt, Ot, Jr, en, nn) {
        var ln, fn, vn = 0;
        do
          fn = Ot + (Jr - Ot) / 2, ln = Tt(fn, en, nn) - kt, ln > 0 ? Jr = fn : Ot = fn;
        while (Math.abs(ln) > je && ++vn < Ue);
        return fn;
      }
      function It(kt, Ot, Jr, en) {
        for (var nn = 0; nn < we; ++nn) {
          var ln = wt(Ot, Jr, en);
          if (ln === 0) return Ot;
          var fn = Tt(Ot, Jr, en) - kt;
          Ot -= fn / ln;
        }
        return Ot;
      }
      function Pt(kt) {
        this._p = kt, this._mSampleValues = Xe ? new Float32Array(qe) : new Array(qe), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return Pt.prototype = {
        get: function(Ot) {
          var Jr = this._p[0], en = this._p[1], nn = this._p[2], ln = this._p[3];
          return this._precomputed || this._precompute(), Jr === en && nn === ln ? Ot : Ot === 0 ? 0 : Ot === 1 ? 1 : Tt(this._getTForX(Ot), en, ln);
        },
        // Private part
        _precompute: function() {
          var Ot = this._p[0], Jr = this._p[1], en = this._p[2], nn = this._p[3];
          this._precomputed = !0, (Ot !== Jr || en !== nn) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var Ot = this._p[0], Jr = this._p[2], en = 0; en < qe; ++en)
            this._mSampleValues[en] = Tt(en * Ge, Ot, Jr);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(Ot) {
          for (var Jr = this._p[0], en = this._p[2], nn = this._mSampleValues, ln = 0, fn = 1, vn = qe - 1; fn !== vn && nn[fn] <= Ot; ++fn)
            ln += Ge;
          --fn;
          var Tn = (Ot - nn[fn]) / (nn[fn + 1] - nn[fn]), xn = ln + Tn * Ge, bn = wt(xn, Jr, en);
          return bn >= Re ? It(Ot, xn, Jr, en) : bn === 0 ? xn : St(Ot, ln, ln + Ge, Jr, en);
        }
      }, ce;
    }(), pooling = /* @__PURE__ */ function() {
      function ce(ie) {
        return ie.concat(createSizedArray(ie.length));
      }
      return {
        double: ce
      };
    }(), poolFactory = /* @__PURE__ */ function() {
      return function(ce, ie, me) {
        var we = 0, Re = ce, je = createSizedArray(Re), Ue = {
          newElement: qe,
          release: Ge
        };
        function qe() {
          var Xe;
          return we ? (we -= 1, Xe = je[we]) : Xe = ie(), Xe;
        }
        function Ge(Xe) {
          we === Re && (je = pooling.double(je), Re *= 2), me && me(Xe), je[we] = Xe, we += 1;
        }
        return Ue;
      };
    }(), bezierLengthPool = function() {
      function ce() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, ce);
    }(), segmentsLengthPool = function() {
      function ce() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function ie(me) {
        var we, Re = me.lengths.length;
        for (we = 0; we < Re; we += 1)
          bezierLengthPool.release(me.lengths[we]);
        me.lengths.length = 0;
      }
      return poolFactory(8, ce, ie);
    }();
    function bezFunction() {
      var ce = Math;
      function ie(bt, Tt, wt, St, It, Pt) {
        var kt = bt * St + Tt * It + wt * Pt - It * St - Pt * bt - wt * Tt;
        return kt > -1e-3 && kt < 1e-3;
      }
      function me(bt, Tt, wt, St, It, Pt, kt, Ot, Jr) {
        if (wt === 0 && Pt === 0 && Jr === 0)
          return ie(bt, Tt, St, It, kt, Ot);
        var en = ce.sqrt(ce.pow(St - bt, 2) + ce.pow(It - Tt, 2) + ce.pow(Pt - wt, 2)), nn = ce.sqrt(ce.pow(kt - bt, 2) + ce.pow(Ot - Tt, 2) + ce.pow(Jr - wt, 2)), ln = ce.sqrt(ce.pow(kt - St, 2) + ce.pow(Ot - It, 2) + ce.pow(Jr - Pt, 2)), fn;
        return en > nn ? en > ln ? fn = en - nn - ln : fn = ln - nn - en : ln > nn ? fn = ln - nn - en : fn = nn - en - ln, fn > -1e-4 && fn < 1e-4;
      }
      var we = /* @__PURE__ */ function() {
        return function(bt, Tt, wt, St) {
          var It = getDefaultCurveSegments(), Pt, kt, Ot, Jr, en, nn = 0, ln, fn = [], vn = [], Tn = bezierLengthPool.newElement();
          for (Ot = wt.length, Pt = 0; Pt < It; Pt += 1) {
            for (en = Pt / (It - 1), ln = 0, kt = 0; kt < Ot; kt += 1)
              Jr = bmPow(1 - en, 3) * bt[kt] + 3 * bmPow(1 - en, 2) * en * wt[kt] + 3 * (1 - en) * bmPow(en, 2) * St[kt] + bmPow(en, 3) * Tt[kt], fn[kt] = Jr, vn[kt] !== null && (ln += bmPow(fn[kt] - vn[kt], 2)), vn[kt] = fn[kt];
            ln && (ln = bmSqrt(ln), nn += ln), Tn.percents[Pt] = en, Tn.lengths[Pt] = nn;
          }
          return Tn.addedLength = nn, Tn;
        };
      }();
      function Re(bt) {
        var Tt = segmentsLengthPool.newElement(), wt = bt.c, St = bt.v, It = bt.o, Pt = bt.i, kt, Ot = bt._length, Jr = Tt.lengths, en = 0;
        for (kt = 0; kt < Ot - 1; kt += 1)
          Jr[kt] = we(St[kt], St[kt + 1], It[kt], Pt[kt + 1]), en += Jr[kt].addedLength;
        return wt && Ot && (Jr[kt] = we(St[kt], St[0], It[kt], Pt[0]), en += Jr[kt].addedLength), Tt.totalLength = en, Tt;
      }
      function je(bt) {
        this.segmentLength = 0, this.points = new Array(bt);
      }
      function Ue(bt, Tt) {
        this.partialLength = bt, this.point = Tt;
      }
      var qe = /* @__PURE__ */ function() {
        var bt = {};
        return function(Tt, wt, St, It) {
          var Pt = (Tt[0] + "_" + Tt[1] + "_" + wt[0] + "_" + wt[1] + "_" + St[0] + "_" + St[1] + "_" + It[0] + "_" + It[1]).replace(/\./g, "p");
          if (!bt[Pt]) {
            var kt = getDefaultCurveSegments(), Ot, Jr, en, nn, ln, fn = 0, vn, Tn, xn = null;
            Tt.length === 2 && (Tt[0] !== wt[0] || Tt[1] !== wt[1]) && ie(Tt[0], Tt[1], wt[0], wt[1], Tt[0] + St[0], Tt[1] + St[1]) && ie(Tt[0], Tt[1], wt[0], wt[1], wt[0] + It[0], wt[1] + It[1]) && (kt = 2);
            var bn = new je(kt);
            for (en = St.length, Ot = 0; Ot < kt; Ot += 1) {
              for (Tn = createSizedArray(en), ln = Ot / (kt - 1), vn = 0, Jr = 0; Jr < en; Jr += 1)
                nn = bmPow(1 - ln, 3) * Tt[Jr] + 3 * bmPow(1 - ln, 2) * ln * (Tt[Jr] + St[Jr]) + 3 * (1 - ln) * bmPow(ln, 2) * (wt[Jr] + It[Jr]) + bmPow(ln, 3) * wt[Jr], Tn[Jr] = nn, xn !== null && (vn += bmPow(Tn[Jr] - xn[Jr], 2));
              vn = bmSqrt(vn), fn += vn, bn.points[Ot] = new Ue(vn, Tn), xn = Tn;
            }
            bn.segmentLength = fn, bt[Pt] = bn;
          }
          return bt[Pt];
        };
      }();
      function Ge(bt, Tt) {
        var wt = Tt.percents, St = Tt.lengths, It = wt.length, Pt = bmFloor((It - 1) * bt), kt = bt * Tt.addedLength, Ot = 0;
        if (Pt === It - 1 || Pt === 0 || kt === St[Pt])
          return wt[Pt];
        for (var Jr = St[Pt] > kt ? -1 : 1, en = !0; en; )
          if (St[Pt] <= kt && St[Pt + 1] > kt ? (Ot = (kt - St[Pt]) / (St[Pt + 1] - St[Pt]), en = !1) : Pt += Jr, Pt < 0 || Pt >= It - 1) {
            if (Pt === It - 1)
              return wt[Pt];
            en = !1;
          }
        return wt[Pt] + (wt[Pt + 1] - wt[Pt]) * Ot;
      }
      function Xe(bt, Tt, wt, St, It, Pt) {
        var kt = Ge(It, Pt), Ot = 1 - kt, Jr = ce.round((Ot * Ot * Ot * bt[0] + (kt * Ot * Ot + Ot * kt * Ot + Ot * Ot * kt) * wt[0] + (kt * kt * Ot + Ot * kt * kt + kt * Ot * kt) * St[0] + kt * kt * kt * Tt[0]) * 1e3) / 1e3, en = ce.round((Ot * Ot * Ot * bt[1] + (kt * Ot * Ot + Ot * kt * Ot + Ot * Ot * kt) * wt[1] + (kt * kt * Ot + Ot * kt * kt + kt * Ot * kt) * St[1] + kt * kt * kt * Tt[1]) * 1e3) / 1e3;
        return [Jr, en];
      }
      var ot = createTypedArray("float32", 8);
      function vt(bt, Tt, wt, St, It, Pt, kt) {
        It < 0 ? It = 0 : It > 1 && (It = 1);
        var Ot = Ge(It, kt);
        Pt = Pt > 1 ? 1 : Pt;
        var Jr = Ge(Pt, kt), en, nn = bt.length, ln = 1 - Ot, fn = 1 - Jr, vn = ln * ln * ln, Tn = Ot * ln * ln * 3, xn = Ot * Ot * ln * 3, bn = Ot * Ot * Ot, Sn = ln * ln * fn, Cn = Ot * ln * fn + ln * Ot * fn + ln * ln * Jr, kn = Ot * Ot * fn + ln * Ot * Jr + Ot * ln * Jr, cn = Ot * Ot * Jr, gn = ln * fn * fn, an = Ot * fn * fn + ln * Jr * fn + ln * fn * Jr, un = Ot * Jr * fn + ln * Jr * Jr + Ot * fn * Jr, pn = Ot * Jr * Jr, hn = fn * fn * fn, An = Jr * fn * fn + fn * Jr * fn + fn * fn * Jr, In = Jr * Jr * fn + fn * Jr * Jr + Jr * fn * Jr, qn = Jr * Jr * Jr;
        for (en = 0; en < nn; en += 1)
          ot[en * 4] = ce.round((vn * bt[en] + Tn * wt[en] + xn * St[en] + bn * Tt[en]) * 1e3) / 1e3, ot[en * 4 + 1] = ce.round((Sn * bt[en] + Cn * wt[en] + kn * St[en] + cn * Tt[en]) * 1e3) / 1e3, ot[en * 4 + 2] = ce.round((gn * bt[en] + an * wt[en] + un * St[en] + pn * Tt[en]) * 1e3) / 1e3, ot[en * 4 + 3] = ce.round((hn * bt[en] + An * wt[en] + In * St[en] + qn * Tt[en]) * 1e3) / 1e3;
        return ot;
      }
      return {
        getSegmentsLength: Re,
        getNewSegment: vt,
        getPointInSegment: Xe,
        buildBezierData: qe,
        pointOnLine2D: ie,
        pointOnLine3D: me
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(ce, ie) {
      var me = this.offsetTime, we;
      this.propType === "multidimensional" && (we = createTypedArray("float32", this.pv.length));
      for (var Re = ie.lastIndex, je = Re, Ue = this.keyframes.length - 1, qe = !0, Ge, Xe, ot; qe; ) {
        if (Ge = this.keyframes[je], Xe = this.keyframes[je + 1], je === Ue - 1 && ce >= Xe.t - me) {
          Ge.h && (Ge = Xe), Re = 0;
          break;
        }
        if (Xe.t - me > ce) {
          Re = je;
          break;
        }
        je < Ue - 1 ? je += 1 : (Re = 0, qe = !1);
      }
      ot = this.keyframesMetadata[je] || {};
      var vt, bt, Tt, wt, St, It, Pt = Xe.t - me, kt = Ge.t - me, Ot;
      if (Ge.to) {
        ot.bezierData || (ot.bezierData = bez.buildBezierData(Ge.s, Xe.s || Ge.e, Ge.to, Ge.ti));
        var Jr = ot.bezierData;
        if (ce >= Pt || ce < kt) {
          var en = ce >= Pt ? Jr.points.length - 1 : 0;
          for (bt = Jr.points[en].point.length, vt = 0; vt < bt; vt += 1)
            we[vt] = Jr.points[en].point[vt];
        } else {
          ot.__fnct ? It = ot.__fnct : (It = BezierFactory.getBezierEasing(Ge.o.x, Ge.o.y, Ge.i.x, Ge.i.y, Ge.n).get, ot.__fnct = It), Tt = It((ce - kt) / (Pt - kt));
          var nn = Jr.segmentLength * Tt, ln, fn = ie.lastFrame < ce && ie._lastKeyframeIndex === je ? ie._lastAddedLength : 0;
          for (St = ie.lastFrame < ce && ie._lastKeyframeIndex === je ? ie._lastPoint : 0, qe = !0, wt = Jr.points.length; qe; ) {
            if (fn += Jr.points[St].partialLength, nn === 0 || Tt === 0 || St === Jr.points.length - 1) {
              for (bt = Jr.points[St].point.length, vt = 0; vt < bt; vt += 1)
                we[vt] = Jr.points[St].point[vt];
              break;
            } else if (nn >= fn && nn < fn + Jr.points[St + 1].partialLength) {
              for (ln = (nn - fn) / Jr.points[St + 1].partialLength, bt = Jr.points[St].point.length, vt = 0; vt < bt; vt += 1)
                we[vt] = Jr.points[St].point[vt] + (Jr.points[St + 1].point[vt] - Jr.points[St].point[vt]) * ln;
              break;
            }
            St < wt - 1 ? St += 1 : qe = !1;
          }
          ie._lastPoint = St, ie._lastAddedLength = fn - Jr.points[St].partialLength, ie._lastKeyframeIndex = je;
        }
      } else {
        var vn, Tn, xn, bn, Sn;
        if (Ue = Ge.s.length, Ot = Xe.s || Ge.e, this.sh && Ge.h !== 1)
          if (ce >= Pt)
            we[0] = Ot[0], we[1] = Ot[1], we[2] = Ot[2];
          else if (ce <= kt)
            we[0] = Ge.s[0], we[1] = Ge.s[1], we[2] = Ge.s[2];
          else {
            var Cn = createQuaternion(Ge.s), kn = createQuaternion(Ot), cn = (ce - kt) / (Pt - kt);
            quaternionToEuler(we, slerp(Cn, kn, cn));
          }
        else
          for (je = 0; je < Ue; je += 1)
            Ge.h !== 1 && (ce >= Pt ? Tt = 1 : ce < kt ? Tt = 0 : (Ge.o.x.constructor === Array ? (ot.__fnct || (ot.__fnct = []), ot.__fnct[je] ? It = ot.__fnct[je] : (vn = Ge.o.x[je] === void 0 ? Ge.o.x[0] : Ge.o.x[je], Tn = Ge.o.y[je] === void 0 ? Ge.o.y[0] : Ge.o.y[je], xn = Ge.i.x[je] === void 0 ? Ge.i.x[0] : Ge.i.x[je], bn = Ge.i.y[je] === void 0 ? Ge.i.y[0] : Ge.i.y[je], It = BezierFactory.getBezierEasing(vn, Tn, xn, bn).get, ot.__fnct[je] = It)) : ot.__fnct ? It = ot.__fnct : (vn = Ge.o.x, Tn = Ge.o.y, xn = Ge.i.x, bn = Ge.i.y, It = BezierFactory.getBezierEasing(vn, Tn, xn, bn).get, Ge.keyframeMetadata = It), Tt = It((ce - kt) / (Pt - kt)))), Ot = Xe.s || Ge.e, Sn = Ge.h === 1 ? Ge.s[je] : Ge.s[je] + (Ot[je] - Ge.s[je]) * Tt, this.propType === "multidimensional" ? we[je] = Sn : we = Sn;
      }
      return ie.lastIndex = Re, we;
    }
    function slerp(ce, ie, me) {
      var we = [], Re = ce[0], je = ce[1], Ue = ce[2], qe = ce[3], Ge = ie[0], Xe = ie[1], ot = ie[2], vt = ie[3], bt, Tt, wt, St, It;
      return Tt = Re * Ge + je * Xe + Ue * ot + qe * vt, Tt < 0 && (Tt = -Tt, Ge = -Ge, Xe = -Xe, ot = -ot, vt = -vt), 1 - Tt > 1e-6 ? (bt = Math.acos(Tt), wt = Math.sin(bt), St = Math.sin((1 - me) * bt) / wt, It = Math.sin(me * bt) / wt) : (St = 1 - me, It = me), we[0] = St * Re + It * Ge, we[1] = St * je + It * Xe, we[2] = St * Ue + It * ot, we[3] = St * qe + It * vt, we;
    }
    function quaternionToEuler(ce, ie) {
      var me = ie[0], we = ie[1], Re = ie[2], je = ie[3], Ue = Math.atan2(2 * we * je - 2 * me * Re, 1 - 2 * we * we - 2 * Re * Re), qe = Math.asin(2 * me * we + 2 * Re * je), Ge = Math.atan2(2 * me * je - 2 * we * Re, 1 - 2 * me * me - 2 * Re * Re);
      ce[0] = Ue / degToRads, ce[1] = qe / degToRads, ce[2] = Ge / degToRads;
    }
    function createQuaternion(ce) {
      var ie = ce[0] * degToRads, me = ce[1] * degToRads, we = ce[2] * degToRads, Re = Math.cos(ie / 2), je = Math.cos(me / 2), Ue = Math.cos(we / 2), qe = Math.sin(ie / 2), Ge = Math.sin(me / 2), Xe = Math.sin(we / 2), ot = Re * je * Ue - qe * Ge * Xe, vt = qe * Ge * Ue + Re * je * Xe, bt = qe * je * Ue + Re * Ge * Xe, Tt = Re * Ge * Ue - qe * je * Xe;
      return [vt, bt, Tt, ot];
    }
    function getValueAtCurrentTime() {
      var ce = this.comp.renderedFrame - this.offsetTime, ie = this.keyframes[0].t - this.offsetTime, me = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(ce === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= me && ce >= me || this._caching.lastFrame < ie && ce < ie))) {
        this._caching.lastFrame >= ce && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var we = this.interpolateValue(ce, this._caching);
        this.pv = we;
      }
      return this._caching.lastFrame = ce, this.pv;
    }
    function setVValue(ce) {
      var ie;
      if (this.propType === "unidimensional")
        ie = ce * this.mult, mathAbs(this.v - ie) > 1e-5 && (this.v = ie, this._mdf = !0);
      else
        for (var me = 0, we = this.v.length; me < we; )
          ie = ce[me] * this.mult, mathAbs(this.v[me] - ie) > 1e-5 && (this.v[me] = ie, this._mdf = !0), me += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var ce, ie = this.effectsSequence.length, me = this.kf ? this.pv : this.data.k;
        for (ce = 0; ce < ie; ce += 1)
          me = this.effectsSequence[ce](me);
        this.setVValue(me), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(ce) {
      this.effectsSequence.push(ce), this.container.addDynamicProperty(this);
    }
    function ValueProperty(ce, ie, me, we) {
      this.propType = "unidimensional", this.mult = me || 1, this.data = ie, this.v = me ? ie.k * me : ie.k, this.pv = ie.k, this._mdf = !1, this.elem = ce, this.container = we, this.comp = ce.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(ce, ie, me, we) {
      this.propType = "multidimensional", this.mult = me || 1, this.data = ie, this._mdf = !1, this.elem = ce, this.container = we, this.comp = ce.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var Re, je = ie.k.length;
      for (this.v = createTypedArray("float32", je), this.pv = createTypedArray("float32", je), this.vel = createTypedArray("float32", je), Re = 0; Re < je; Re += 1)
        this.v[Re] = ie.k[Re] * this.mult, this.pv[Re] = ie.k[Re];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(ce, ie, me, we) {
      this.propType = "unidimensional", this.keyframes = ie.k, this.keyframesMetadata = [], this.offsetTime = ce.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = ie, this.mult = me || 1, this.elem = ce, this.container = we, this.comp = ce.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(ce, ie, me, we) {
      this.propType = "multidimensional";
      var Re, je = ie.k.length, Ue, qe, Ge, Xe;
      for (Re = 0; Re < je - 1; Re += 1)
        ie.k[Re].to && ie.k[Re].s && ie.k[Re + 1] && ie.k[Re + 1].s && (Ue = ie.k[Re].s, qe = ie.k[Re + 1].s, Ge = ie.k[Re].to, Xe = ie.k[Re].ti, (Ue.length === 2 && !(Ue[0] === qe[0] && Ue[1] === qe[1]) && bez.pointOnLine2D(Ue[0], Ue[1], qe[0], qe[1], Ue[0] + Ge[0], Ue[1] + Ge[1]) && bez.pointOnLine2D(Ue[0], Ue[1], qe[0], qe[1], qe[0] + Xe[0], qe[1] + Xe[1]) || Ue.length === 3 && !(Ue[0] === qe[0] && Ue[1] === qe[1] && Ue[2] === qe[2]) && bez.pointOnLine3D(Ue[0], Ue[1], Ue[2], qe[0], qe[1], qe[2], Ue[0] + Ge[0], Ue[1] + Ge[1], Ue[2] + Ge[2]) && bez.pointOnLine3D(Ue[0], Ue[1], Ue[2], qe[0], qe[1], qe[2], qe[0] + Xe[0], qe[1] + Xe[1], qe[2] + Xe[2])) && (ie.k[Re].to = null, ie.k[Re].ti = null), Ue[0] === qe[0] && Ue[1] === qe[1] && Ge[0] === 0 && Ge[1] === 0 && Xe[0] === 0 && Xe[1] === 0 && (Ue.length === 2 || Ue[2] === qe[2] && Ge[2] === 0 && Xe[2] === 0) && (ie.k[Re].to = null, ie.k[Re].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = ie, this.keyframes = ie.k, this.keyframesMetadata = [], this.offsetTime = ce.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = me || 1, this.elem = ce, this.container = we, this.comp = ce.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var ot = ie.k[0].s.length;
      for (this.v = createTypedArray("float32", ot), this.pv = createTypedArray("float32", ot), Re = 0; Re < ot; Re += 1)
        this.v[Re] = initFrame, this.pv[Re] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", ot)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = /* @__PURE__ */ function() {
      function ce(me, we, Re, je, Ue) {
        we.sid && (we = me.globalData.slotManager.getProp(we));
        var qe;
        if (!we.k.length)
          qe = new ValueProperty(me, we, je, Ue);
        else if (typeof we.k[0] == "number")
          qe = new MultiDimensionalProperty(me, we, je, Ue);
        else
          switch (Re) {
            case 0:
              qe = new KeyframedValueProperty(me, we, je, Ue);
              break;
            case 1:
              qe = new KeyframedMultidimensionalProperty(me, we, je, Ue);
              break;
          }
        return qe.effectsSequence.length && Ue.addDynamicProperty(qe), qe;
      }
      var ie = {
        getProp: ce
      };
      return ie;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(ie) {
        this.dynamicProperties.indexOf(ie) === -1 && (this.dynamicProperties.push(ie), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var ie, me = this.dynamicProperties.length;
        for (ie = 0; ie < me; ie += 1)
          this.dynamicProperties[ie].getValue(), this.dynamicProperties[ie]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(ie) {
        this.container = ie, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function ce() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, ce);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(ce, ie) {
      this.c = ce, this.setLength(ie);
      for (var me = 0; me < ie; )
        this.v[me] = pointPool.newElement(), this.o[me] = pointPool.newElement(), this.i[me] = pointPool.newElement(), me += 1;
    }, ShapePath.prototype.setLength = function(ce) {
      for (; this._maxLength < ce; )
        this.doubleArrayLength();
      this._length = ce;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(ce, ie, me, we, Re) {
      var je;
      switch (this._length = Math.max(this._length, we + 1), this._length >= this._maxLength && this.doubleArrayLength(), me) {
        case "v":
          je = this.v;
          break;
        case "i":
          je = this.i;
          break;
        case "o":
          je = this.o;
          break;
        default:
          je = [];
          break;
      }
      (!je[we] || je[we] && !Re) && (je[we] = pointPool.newElement()), je[we][0] = ce, je[we][1] = ie;
    }, ShapePath.prototype.setTripleAt = function(ce, ie, me, we, Re, je, Ue, qe) {
      this.setXYAt(ce, ie, "v", Ue, qe), this.setXYAt(me, we, "o", Ue, qe), this.setXYAt(Re, je, "i", Ue, qe);
    }, ShapePath.prototype.reverse = function() {
      var ce = new ShapePath();
      ce.setPathData(this.c, this._length);
      var ie = this.v, me = this.o, we = this.i, Re = 0;
      this.c && (ce.setTripleAt(ie[0][0], ie[0][1], we[0][0], we[0][1], me[0][0], me[0][1], 0, !1), Re = 1);
      var je = this._length - 1, Ue = this._length, qe;
      for (qe = Re; qe < Ue; qe += 1)
        ce.setTripleAt(ie[je][0], ie[je][1], we[je][0], we[je][1], me[je][0], me[je][1], qe, !1), je -= 1;
      return ce;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function ce() {
        return new ShapePath();
      }
      function ie(Re) {
        var je = Re._length, Ue;
        for (Ue = 0; Ue < je; Ue += 1)
          pointPool.release(Re.v[Ue]), pointPool.release(Re.i[Ue]), pointPool.release(Re.o[Ue]), Re.v[Ue] = null, Re.i[Ue] = null, Re.o[Ue] = null;
        Re._length = 0, Re.c = !1;
      }
      function me(Re) {
        var je = we.newElement(), Ue, qe = Re._length === void 0 ? Re.v.length : Re._length;
        for (je.setLength(qe), je.c = Re.c, Ue = 0; Ue < qe; Ue += 1)
          je.setTripleAt(Re.v[Ue][0], Re.v[Ue][1], Re.o[Ue][0], Re.o[Ue][1], Re.i[Ue][0], Re.i[Ue][1], Ue);
        return je;
      }
      var we = poolFactory(4, ce, ie);
      return we.clone = me, we;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(ce) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = ce, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var ce;
      for (ce = 0; ce < this._length; ce += 1)
        shapePool.release(this.shapes[ce]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var ce = {
        newShapeCollection: Re,
        release: je
      }, ie = 0, me = 4, we = createSizedArray(me);
      function Re() {
        var Ue;
        return ie ? (ie -= 1, Ue = we[ie]) : Ue = new ShapeCollection(), Ue;
      }
      function je(Ue) {
        var qe, Ge = Ue._length;
        for (qe = 0; qe < Ge; qe += 1)
          shapePool.release(Ue.shapes[qe]);
        Ue._length = 0, ie === me && (we = pooling.double(we), me *= 2), we[ie] = Ue, ie += 1;
      }
      return ce;
    }(), ShapePropertyFactory = function() {
      var ce = -999999;
      function ie(Pt, kt, Ot) {
        var Jr = Ot.lastIndex, en, nn, ln, fn, vn, Tn, xn, bn, Sn, Cn = this.keyframes;
        if (Pt < Cn[0].t - this.offsetTime)
          en = Cn[0].s[0], ln = !0, Jr = 0;
        else if (Pt >= Cn[Cn.length - 1].t - this.offsetTime)
          en = Cn[Cn.length - 1].s ? Cn[Cn.length - 1].s[0] : Cn[Cn.length - 2].e[0], ln = !0;
        else {
          for (var kn = Jr, cn = Cn.length - 1, gn = !0, an, un, pn; gn && (an = Cn[kn], un = Cn[kn + 1], !(un.t - this.offsetTime > Pt)); )
            kn < cn - 1 ? kn += 1 : gn = !1;
          if (pn = this.keyframesMetadata[kn] || {}, ln = an.h === 1, Jr = kn, !ln) {
            if (Pt >= un.t - this.offsetTime)
              bn = 1;
            else if (Pt < an.t - this.offsetTime)
              bn = 0;
            else {
              var hn;
              pn.__fnct ? hn = pn.__fnct : (hn = BezierFactory.getBezierEasing(an.o.x, an.o.y, an.i.x, an.i.y).get, pn.__fnct = hn), bn = hn((Pt - (an.t - this.offsetTime)) / (un.t - this.offsetTime - (an.t - this.offsetTime)));
            }
            nn = un.s ? un.s[0] : an.e[0];
          }
          en = an.s[0];
        }
        for (Tn = kt._length, xn = en.i[0].length, Ot.lastIndex = Jr, fn = 0; fn < Tn; fn += 1)
          for (vn = 0; vn < xn; vn += 1)
            Sn = ln ? en.i[fn][vn] : en.i[fn][vn] + (nn.i[fn][vn] - en.i[fn][vn]) * bn, kt.i[fn][vn] = Sn, Sn = ln ? en.o[fn][vn] : en.o[fn][vn] + (nn.o[fn][vn] - en.o[fn][vn]) * bn, kt.o[fn][vn] = Sn, Sn = ln ? en.v[fn][vn] : en.v[fn][vn] + (nn.v[fn][vn] - en.v[fn][vn]) * bn, kt.v[fn][vn] = Sn;
      }
      function me() {
        var Pt = this.comp.renderedFrame - this.offsetTime, kt = this.keyframes[0].t - this.offsetTime, Ot = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, Jr = this._caching.lastFrame;
        return Jr !== ce && (Jr < kt && Pt < kt || Jr > Ot && Pt > Ot) || (this._caching.lastIndex = Jr < Pt ? this._caching.lastIndex : 0, this.interpolateShape(Pt, this.pv, this._caching)), this._caching.lastFrame = Pt, this.pv;
      }
      function we() {
        this.paths = this.localShapeCollection;
      }
      function Re(Pt, kt) {
        if (Pt._length !== kt._length || Pt.c !== kt.c)
          return !1;
        var Ot, Jr = Pt._length;
        for (Ot = 0; Ot < Jr; Ot += 1)
          if (Pt.v[Ot][0] !== kt.v[Ot][0] || Pt.v[Ot][1] !== kt.v[Ot][1] || Pt.o[Ot][0] !== kt.o[Ot][0] || Pt.o[Ot][1] !== kt.o[Ot][1] || Pt.i[Ot][0] !== kt.i[Ot][0] || Pt.i[Ot][1] !== kt.i[Ot][1])
            return !1;
        return !0;
      }
      function je(Pt) {
        Re(this.v, Pt) || (this.v = shapePool.clone(Pt), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function Ue() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var Pt;
          this.kf ? Pt = this.pv : this.data.ks ? Pt = this.data.ks.k : Pt = this.data.pt.k;
          var kt, Ot = this.effectsSequence.length;
          for (kt = 0; kt < Ot; kt += 1)
            Pt = this.effectsSequence[kt](Pt);
          this.setVValue(Pt), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function qe(Pt, kt, Ot) {
        this.propType = "shape", this.comp = Pt.comp, this.container = Pt, this.elem = Pt, this.data = kt, this.k = !1, this.kf = !1, this._mdf = !1;
        var Jr = Ot === 3 ? kt.pt.k : kt.ks.k;
        this.v = shapePool.clone(Jr), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = we, this.effectsSequence = [];
      }
      function Ge(Pt) {
        this.effectsSequence.push(Pt), this.container.addDynamicProperty(this);
      }
      qe.prototype.interpolateShape = ie, qe.prototype.getValue = Ue, qe.prototype.setVValue = je, qe.prototype.addEffect = Ge;
      function Xe(Pt, kt, Ot) {
        this.propType = "shape", this.comp = Pt.comp, this.elem = Pt, this.container = Pt, this.offsetTime = Pt.data.st, this.keyframes = Ot === 3 ? kt.pt.k : kt.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var Jr = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, Jr), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = ce, this.reset = we, this._caching = {
          lastFrame: ce,
          lastIndex: 0
        }, this.effectsSequence = [me.bind(this)];
      }
      Xe.prototype.getValue = Ue, Xe.prototype.interpolateShape = ie, Xe.prototype.setVValue = je, Xe.prototype.addEffect = Ge;
      var ot = function() {
        var Pt = roundCorner;
        function kt(Ot, Jr) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = Jr.d, this.elem = Ot, this.comp = Ot.comp, this.frameId = -1, this.initDynamicPropertyContainer(Ot), this.p = PropertyFactory.getProp(Ot, Jr.p, 1, 0, this), this.s = PropertyFactory.getProp(Ot, Jr.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return kt.prototype = {
          reset: we,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var Jr = this.p.v[0], en = this.p.v[1], nn = this.s.v[0] / 2, ln = this.s.v[1] / 2, fn = this.d !== 3, vn = this.v;
            vn.v[0][0] = Jr, vn.v[0][1] = en - ln, vn.v[1][0] = fn ? Jr + nn : Jr - nn, vn.v[1][1] = en, vn.v[2][0] = Jr, vn.v[2][1] = en + ln, vn.v[3][0] = fn ? Jr - nn : Jr + nn, vn.v[3][1] = en, vn.i[0][0] = fn ? Jr - nn * Pt : Jr + nn * Pt, vn.i[0][1] = en - ln, vn.i[1][0] = fn ? Jr + nn : Jr - nn, vn.i[1][1] = en - ln * Pt, vn.i[2][0] = fn ? Jr + nn * Pt : Jr - nn * Pt, vn.i[2][1] = en + ln, vn.i[3][0] = fn ? Jr - nn : Jr + nn, vn.i[3][1] = en + ln * Pt, vn.o[0][0] = fn ? Jr + nn * Pt : Jr - nn * Pt, vn.o[0][1] = en - ln, vn.o[1][0] = fn ? Jr + nn : Jr - nn, vn.o[1][1] = en + ln * Pt, vn.o[2][0] = fn ? Jr - nn * Pt : Jr + nn * Pt, vn.o[2][1] = en + ln, vn.o[3][0] = fn ? Jr - nn : Jr + nn, vn.o[3][1] = en - ln * Pt;
          }
        }, extendPrototype([DynamicPropertyContainer], kt), kt;
      }(), vt = function() {
        function Pt(kt, Ot) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = kt, this.comp = kt.comp, this.data = Ot, this.frameId = -1, this.d = Ot.d, this.initDynamicPropertyContainer(kt), Ot.sy === 1 ? (this.ir = PropertyFactory.getProp(kt, Ot.ir, 0, 0, this), this.is = PropertyFactory.getProp(kt, Ot.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(kt, Ot.pt, 0, 0, this), this.p = PropertyFactory.getProp(kt, Ot.p, 1, 0, this), this.r = PropertyFactory.getProp(kt, Ot.r, 0, degToRads, this), this.or = PropertyFactory.getProp(kt, Ot.or, 0, 0, this), this.os = PropertyFactory.getProp(kt, Ot.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return Pt.prototype = {
          reset: we,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var Ot = Math.floor(this.pt.v) * 2, Jr = Math.PI * 2 / Ot, en = !0, nn = this.or.v, ln = this.ir.v, fn = this.os.v, vn = this.is.v, Tn = 2 * Math.PI * nn / (Ot * 2), xn = 2 * Math.PI * ln / (Ot * 2), bn, Sn, Cn, kn, cn = -Math.PI / 2;
            cn += this.r.v;
            var gn = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, bn = 0; bn < Ot; bn += 1) {
              Sn = en ? nn : ln, Cn = en ? fn : vn, kn = en ? Tn : xn;
              var an = Sn * Math.cos(cn), un = Sn * Math.sin(cn), pn = an === 0 && un === 0 ? 0 : un / Math.sqrt(an * an + un * un), hn = an === 0 && un === 0 ? 0 : -an / Math.sqrt(an * an + un * un);
              an += +this.p.v[0], un += +this.p.v[1], this.v.setTripleAt(an, un, an - pn * kn * Cn * gn, un - hn * kn * Cn * gn, an + pn * kn * Cn * gn, un + hn * kn * Cn * gn, bn, !0), en = !en, cn += Jr * gn;
            }
          },
          convertPolygonToPath: function() {
            var Ot = Math.floor(this.pt.v), Jr = Math.PI * 2 / Ot, en = this.or.v, nn = this.os.v, ln = 2 * Math.PI * en / (Ot * 4), fn, vn = -Math.PI * 0.5, Tn = this.data.d === 3 ? -1 : 1;
            for (vn += this.r.v, this.v._length = 0, fn = 0; fn < Ot; fn += 1) {
              var xn = en * Math.cos(vn), bn = en * Math.sin(vn), Sn = xn === 0 && bn === 0 ? 0 : bn / Math.sqrt(xn * xn + bn * bn), Cn = xn === 0 && bn === 0 ? 0 : -xn / Math.sqrt(xn * xn + bn * bn);
              xn += +this.p.v[0], bn += +this.p.v[1], this.v.setTripleAt(xn, bn, xn - Sn * ln * nn * Tn, bn - Cn * ln * nn * Tn, xn + Sn * ln * nn * Tn, bn + Cn * ln * nn * Tn, fn, !0), vn += Jr * Tn;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], Pt), Pt;
      }(), bt = function() {
        function Pt(kt, Ot) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = kt, this.comp = kt.comp, this.frameId = -1, this.d = Ot.d, this.initDynamicPropertyContainer(kt), this.p = PropertyFactory.getProp(kt, Ot.p, 1, 0, this), this.s = PropertyFactory.getProp(kt, Ot.s, 1, 0, this), this.r = PropertyFactory.getProp(kt, Ot.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return Pt.prototype = {
          convertRectToPath: function() {
            var Ot = this.p.v[0], Jr = this.p.v[1], en = this.s.v[0] / 2, nn = this.s.v[1] / 2, ln = bmMin(en, nn, this.r.v), fn = ln * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(Ot + en, Jr - nn + ln, Ot + en, Jr - nn + ln, Ot + en, Jr - nn + fn, 0, !0), this.v.setTripleAt(Ot + en, Jr + nn - ln, Ot + en, Jr + nn - fn, Ot + en, Jr + nn - ln, 1, !0), ln !== 0 ? (this.v.setTripleAt(Ot + en - ln, Jr + nn, Ot + en - ln, Jr + nn, Ot + en - fn, Jr + nn, 2, !0), this.v.setTripleAt(Ot - en + ln, Jr + nn, Ot - en + fn, Jr + nn, Ot - en + ln, Jr + nn, 3, !0), this.v.setTripleAt(Ot - en, Jr + nn - ln, Ot - en, Jr + nn - ln, Ot - en, Jr + nn - fn, 4, !0), this.v.setTripleAt(Ot - en, Jr - nn + ln, Ot - en, Jr - nn + fn, Ot - en, Jr - nn + ln, 5, !0), this.v.setTripleAt(Ot - en + ln, Jr - nn, Ot - en + ln, Jr - nn, Ot - en + fn, Jr - nn, 6, !0), this.v.setTripleAt(Ot + en - ln, Jr - nn, Ot + en - fn, Jr - nn, Ot + en - ln, Jr - nn, 7, !0)) : (this.v.setTripleAt(Ot - en, Jr + nn, Ot - en + fn, Jr + nn, Ot - en, Jr + nn, 2), this.v.setTripleAt(Ot - en, Jr - nn, Ot - en, Jr - nn + fn, Ot - en, Jr - nn, 3))) : (this.v.setTripleAt(Ot + en, Jr - nn + ln, Ot + en, Jr - nn + fn, Ot + en, Jr - nn + ln, 0, !0), ln !== 0 ? (this.v.setTripleAt(Ot + en - ln, Jr - nn, Ot + en - ln, Jr - nn, Ot + en - fn, Jr - nn, 1, !0), this.v.setTripleAt(Ot - en + ln, Jr - nn, Ot - en + fn, Jr - nn, Ot - en + ln, Jr - nn, 2, !0), this.v.setTripleAt(Ot - en, Jr - nn + ln, Ot - en, Jr - nn + ln, Ot - en, Jr - nn + fn, 3, !0), this.v.setTripleAt(Ot - en, Jr + nn - ln, Ot - en, Jr + nn - fn, Ot - en, Jr + nn - ln, 4, !0), this.v.setTripleAt(Ot - en + ln, Jr + nn, Ot - en + ln, Jr + nn, Ot - en + fn, Jr + nn, 5, !0), this.v.setTripleAt(Ot + en - ln, Jr + nn, Ot + en - fn, Jr + nn, Ot + en - ln, Jr + nn, 6, !0), this.v.setTripleAt(Ot + en, Jr + nn - ln, Ot + en, Jr + nn - ln, Ot + en, Jr + nn - fn, 7, !0)) : (this.v.setTripleAt(Ot - en, Jr - nn, Ot - en + fn, Jr - nn, Ot - en, Jr - nn, 1, !0), this.v.setTripleAt(Ot - en, Jr + nn, Ot - en, Jr + nn - fn, Ot - en, Jr + nn, 2, !0), this.v.setTripleAt(Ot + en, Jr + nn, Ot + en - fn, Jr + nn, Ot + en, Jr + nn, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: we
        }, extendPrototype([DynamicPropertyContainer], Pt), Pt;
      }();
      function Tt(Pt, kt, Ot) {
        var Jr;
        if (Ot === 3 || Ot === 4) {
          var en = Ot === 3 ? kt.pt : kt.ks, nn = en.k;
          nn.length ? Jr = new Xe(Pt, kt, Ot) : Jr = new qe(Pt, kt, Ot);
        } else Ot === 5 ? Jr = new bt(Pt, kt) : Ot === 6 ? Jr = new ot(Pt, kt) : Ot === 7 && (Jr = new vt(Pt, kt));
        return Jr.k && Pt.addDynamicProperty(Jr), Jr;
      }
      function wt() {
        return qe;
      }
      function St() {
        return Xe;
      }
      var It = {};
      return It.getShapeProp = Tt, It.getConstructorFunction = wt, It.getKeyframedConstructorFunction = St, It;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = /* @__PURE__ */ function() {
      var ce = Math.cos, ie = Math.sin, me = Math.tan, we = Math.round;
      function Re() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function je(an) {
        if (an === 0)
          return this;
        var un = ce(an), pn = ie(an);
        return this._t(un, -pn, 0, 0, pn, un, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Ue(an) {
        if (an === 0)
          return this;
        var un = ce(an), pn = ie(an);
        return this._t(1, 0, 0, 0, 0, un, -pn, 0, 0, pn, un, 0, 0, 0, 0, 1);
      }
      function qe(an) {
        if (an === 0)
          return this;
        var un = ce(an), pn = ie(an);
        return this._t(un, 0, pn, 0, 0, 1, 0, 0, -pn, 0, un, 0, 0, 0, 0, 1);
      }
      function Ge(an) {
        if (an === 0)
          return this;
        var un = ce(an), pn = ie(an);
        return this._t(un, -pn, 0, 0, pn, un, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Xe(an, un) {
        return this._t(1, un, an, 1, 0, 0);
      }
      function ot(an, un) {
        return this.shear(me(an), me(un));
      }
      function vt(an, un) {
        var pn = ce(un), hn = ie(un);
        return this._t(pn, hn, 0, 0, -hn, pn, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, me(an), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(pn, -hn, 0, 0, hn, pn, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function bt(an, un, pn) {
        return !pn && pn !== 0 && (pn = 1), an === 1 && un === 1 && pn === 1 ? this : this._t(an, 0, 0, 0, 0, un, 0, 0, 0, 0, pn, 0, 0, 0, 0, 1);
      }
      function Tt(an, un, pn, hn, An, In, qn, si, bi, xi, ji, zi, Vi, Hi, ii, Fi) {
        return this.props[0] = an, this.props[1] = un, this.props[2] = pn, this.props[3] = hn, this.props[4] = An, this.props[5] = In, this.props[6] = qn, this.props[7] = si, this.props[8] = bi, this.props[9] = xi, this.props[10] = ji, this.props[11] = zi, this.props[12] = Vi, this.props[13] = Hi, this.props[14] = ii, this.props[15] = Fi, this;
      }
      function wt(an, un, pn) {
        return pn = pn || 0, an !== 0 || un !== 0 || pn !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, an, un, pn, 1) : this;
      }
      function St(an, un, pn, hn, An, In, qn, si, bi, xi, ji, zi, Vi, Hi, ii, Fi) {
        var ni = this.props;
        if (an === 1 && un === 0 && pn === 0 && hn === 0 && An === 0 && In === 1 && qn === 0 && si === 0 && bi === 0 && xi === 0 && ji === 1 && zi === 0)
          return ni[12] = ni[12] * an + ni[15] * Vi, ni[13] = ni[13] * In + ni[15] * Hi, ni[14] = ni[14] * ji + ni[15] * ii, ni[15] *= Fi, this._identityCalculated = !1, this;
        var Ui = ni[0], ja = ni[1], Ga = ni[2], Xa = ni[3], Ns = ni[4], Ya = ni[5], Qa = ni[6], Ja = ni[7], Ms = ni[8], Hs = ni[9], no = ni[10], Qs = ni[11], Zs = ni[12], so = ni[13], io = ni[14], dl = ni[15];
        return ni[0] = Ui * an + ja * An + Ga * bi + Xa * Vi, ni[1] = Ui * un + ja * In + Ga * xi + Xa * Hi, ni[2] = Ui * pn + ja * qn + Ga * ji + Xa * ii, ni[3] = Ui * hn + ja * si + Ga * zi + Xa * Fi, ni[4] = Ns * an + Ya * An + Qa * bi + Ja * Vi, ni[5] = Ns * un + Ya * In + Qa * xi + Ja * Hi, ni[6] = Ns * pn + Ya * qn + Qa * ji + Ja * ii, ni[7] = Ns * hn + Ya * si + Qa * zi + Ja * Fi, ni[8] = Ms * an + Hs * An + no * bi + Qs * Vi, ni[9] = Ms * un + Hs * In + no * xi + Qs * Hi, ni[10] = Ms * pn + Hs * qn + no * ji + Qs * ii, ni[11] = Ms * hn + Hs * si + no * zi + Qs * Fi, ni[12] = Zs * an + so * An + io * bi + dl * Vi, ni[13] = Zs * un + so * In + io * xi + dl * Hi, ni[14] = Zs * pn + so * qn + io * ji + dl * ii, ni[15] = Zs * hn + so * si + io * zi + dl * Fi, this._identityCalculated = !1, this;
      }
      function It(an) {
        var un = an.props;
        return this.transform(un[0], un[1], un[2], un[3], un[4], un[5], un[6], un[7], un[8], un[9], un[10], un[11], un[12], un[13], un[14], un[15]);
      }
      function Pt() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function kt(an) {
        for (var un = 0; un < 16; ) {
          if (an.props[un] !== this.props[un])
            return !1;
          un += 1;
        }
        return !0;
      }
      function Ot(an) {
        var un;
        for (un = 0; un < 16; un += 1)
          an.props[un] = this.props[un];
        return an;
      }
      function Jr(an) {
        var un;
        for (un = 0; un < 16; un += 1)
          this.props[un] = an[un];
      }
      function en(an, un, pn) {
        return {
          x: an * this.props[0] + un * this.props[4] + pn * this.props[8] + this.props[12],
          y: an * this.props[1] + un * this.props[5] + pn * this.props[9] + this.props[13],
          z: an * this.props[2] + un * this.props[6] + pn * this.props[10] + this.props[14]
        };
      }
      function nn(an, un, pn) {
        return an * this.props[0] + un * this.props[4] + pn * this.props[8] + this.props[12];
      }
      function ln(an, un, pn) {
        return an * this.props[1] + un * this.props[5] + pn * this.props[9] + this.props[13];
      }
      function fn(an, un, pn) {
        return an * this.props[2] + un * this.props[6] + pn * this.props[10] + this.props[14];
      }
      function vn() {
        var an = this.props[0] * this.props[5] - this.props[1] * this.props[4], un = this.props[5] / an, pn = -this.props[1] / an, hn = -this.props[4] / an, An = this.props[0] / an, In = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / an, qn = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / an, si = new Matrix();
        return si.props[0] = un, si.props[1] = pn, si.props[4] = hn, si.props[5] = An, si.props[12] = In, si.props[13] = qn, si;
      }
      function Tn(an) {
        var un = this.getInverseMatrix();
        return un.applyToPointArray(an[0], an[1], an[2] || 0);
      }
      function xn(an) {
        var un, pn = an.length, hn = [];
        for (un = 0; un < pn; un += 1)
          hn[un] = Tn(an[un]);
        return hn;
      }
      function bn(an, un, pn) {
        var hn = createTypedArray("float32", 6);
        if (this.isIdentity())
          hn[0] = an[0], hn[1] = an[1], hn[2] = un[0], hn[3] = un[1], hn[4] = pn[0], hn[5] = pn[1];
        else {
          var An = this.props[0], In = this.props[1], qn = this.props[4], si = this.props[5], bi = this.props[12], xi = this.props[13];
          hn[0] = an[0] * An + an[1] * qn + bi, hn[1] = an[0] * In + an[1] * si + xi, hn[2] = un[0] * An + un[1] * qn + bi, hn[3] = un[0] * In + un[1] * si + xi, hn[4] = pn[0] * An + pn[1] * qn + bi, hn[5] = pn[0] * In + pn[1] * si + xi;
        }
        return hn;
      }
      function Sn(an, un, pn) {
        var hn;
        return this.isIdentity() ? hn = [an, un, pn] : hn = [an * this.props[0] + un * this.props[4] + pn * this.props[8] + this.props[12], an * this.props[1] + un * this.props[5] + pn * this.props[9] + this.props[13], an * this.props[2] + un * this.props[6] + pn * this.props[10] + this.props[14]], hn;
      }
      function Cn(an, un) {
        if (this.isIdentity())
          return an + "," + un;
        var pn = this.props;
        return Math.round((an * pn[0] + un * pn[4] + pn[12]) * 100) / 100 + "," + Math.round((an * pn[1] + un * pn[5] + pn[13]) * 100) / 100;
      }
      function kn() {
        for (var an = 0, un = this.props, pn = "matrix3d(", hn = 1e4; an < 16; )
          pn += we(un[an] * hn) / hn, pn += an === 15 ? ")" : ",", an += 1;
        return pn;
      }
      function cn(an) {
        var un = 1e4;
        return an < 1e-6 && an > 0 || an > -1e-6 && an < 0 ? we(an * un) / un : an;
      }
      function gn() {
        var an = this.props, un = cn(an[0]), pn = cn(an[1]), hn = cn(an[4]), An = cn(an[5]), In = cn(an[12]), qn = cn(an[13]);
        return "matrix(" + un + "," + pn + "," + hn + "," + An + "," + In + "," + qn + ")";
      }
      return function() {
        this.reset = Re, this.rotate = je, this.rotateX = Ue, this.rotateY = qe, this.rotateZ = Ge, this.skew = ot, this.skewFromAxis = vt, this.shear = Xe, this.scale = bt, this.setTransform = Tt, this.translate = wt, this.transform = St, this.multiply = It, this.applyToPoint = en, this.applyToX = nn, this.applyToY = ln, this.applyToZ = fn, this.applyToPointArray = Sn, this.applyToTriplePoints = bn, this.applyToPointStringified = Cn, this.toCSS = kn, this.to2dCSS = gn, this.clone = Ot, this.cloneFromProps = Jr, this.equals = kt, this.inversePoints = xn, this.inversePoint = Tn, this.getInverseMatrix = vn, this._t = this.transform, this.isIdentity = Pt, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(me) {
        return typeof me;
      } : _typeof$3 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$3(ce);
    }
    var lottie = {};
    function setLocation(ce) {
      setLocationHref(ce);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(ce) {
      setSubframeEnabled(ce);
    }
    function setPrefix(ce) {
      setIdPrefix(ce);
    }
    function loadAnimation(ce) {
      return animationManager.loadAnimation(ce);
    }
    function setQuality(ce) {
      if (typeof ce == "string")
        switch (ce) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else !isNaN(ce) && ce > 1 && setDefaultCurveSegments(ce);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(ce, ie) {
      ce === "expressions" && setExpressionsPlugin(ie);
    }
    function getFactory(ce) {
      switch (ce) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(ce) {
      for (var ie = queryString.split("&"), me = 0; me < ie.length; me += 1) {
        var we = ie[me].split("=");
        if (decodeURIComponent(we[0]) == ce)
          return decodeURIComponent(we[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (ce) {
    }
    var ShapeModifiers = function() {
      var ce = {}, ie = {};
      ce.registerModifier = me, ce.getModifier = we;
      function me(Re, je) {
        ie[Re] || (ie[Re] = je);
      }
      function we(Re, je, Ue) {
        return new ie[Re](je, Ue);
      }
      return ce;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(ce) {
      if (!this.closed) {
        ce.sh.container.addDynamicProperty(ce.sh);
        var ie = {
          shape: ce.sh,
          data: ce,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(ie), this.addShapeToModifier(ie), this._isAnimated && ce.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(ce, ie) {
      this.shapes = [], this.elem = ce, this.initDynamicPropertyContainer(ce), this.initModifierProperties(ce, ie), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(ce, ie) {
      this.s = PropertyFactory.getProp(ce, ie.s, 0, 0.01, this), this.e = PropertyFactory.getProp(ce, ie.e, 0, 0.01, this), this.o = PropertyFactory.getProp(ce, ie.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = ie.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(ce) {
      ce.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(ce, ie, me, we, Re) {
      var je = [];
      ie <= 1 ? je.push({
        s: ce,
        e: ie
      }) : ce >= 1 ? je.push({
        s: ce - 1,
        e: ie - 1
      }) : (je.push({
        s: ce,
        e: 1
      }), je.push({
        s: 0,
        e: ie - 1
      }));
      var Ue = [], qe, Ge = je.length, Xe;
      for (qe = 0; qe < Ge; qe += 1)
        if (Xe = je[qe], !(Xe.e * Re < we || Xe.s * Re > we + me)) {
          var ot, vt;
          Xe.s * Re <= we ? ot = 0 : ot = (Xe.s * Re - we) / me, Xe.e * Re >= we + me ? vt = 1 : vt = (Xe.e * Re - we) / me, Ue.push([ot, vt]);
        }
      return Ue.length || Ue.push([0, 0]), Ue;
    }, TrimModifier.prototype.releasePathsData = function(ce) {
      var ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        segmentsLengthPool.release(ce[ie]);
      return ce.length = 0, ce;
    }, TrimModifier.prototype.processShapes = function(ce) {
      var ie, me;
      if (this._mdf || ce) {
        var we = this.o.v % 360 / 360;
        if (we < 0 && (we += 1), this.s.v > 1 ? ie = 1 + we : this.s.v < 0 ? ie = 0 + we : ie = this.s.v + we, this.e.v > 1 ? me = 1 + we : this.e.v < 0 ? me = 0 + we : me = this.e.v + we, ie > me) {
          var Re = ie;
          ie = me, me = Re;
        }
        ie = Math.round(ie * 1e4) * 1e-4, me = Math.round(me * 1e4) * 1e-4, this.sValue = ie, this.eValue = me;
      } else
        ie = this.sValue, me = this.eValue;
      var je, Ue, qe = this.shapes.length, Ge, Xe, ot, vt, bt, Tt = 0;
      if (me === ie)
        for (Ue = 0; Ue < qe; Ue += 1)
          this.shapes[Ue].localShapeCollection.releaseShapes(), this.shapes[Ue].shape._mdf = !0, this.shapes[Ue].shape.paths = this.shapes[Ue].localShapeCollection, this._mdf && (this.shapes[Ue].pathsData.length = 0);
      else if (me === 1 && ie === 0 || me === 0 && ie === 1) {
        if (this._mdf)
          for (Ue = 0; Ue < qe; Ue += 1)
            this.shapes[Ue].pathsData.length = 0, this.shapes[Ue].shape._mdf = !0;
      } else {
        var wt = [], St, It;
        for (Ue = 0; Ue < qe; Ue += 1)
          if (St = this.shapes[Ue], !St.shape._mdf && !this._mdf && !ce && this.m !== 2)
            St.shape.paths = St.localShapeCollection;
          else {
            if (je = St.shape.paths, Xe = je._length, bt = 0, !St.shape._mdf && St.pathsData.length)
              bt = St.totalShapeLength;
            else {
              for (ot = this.releasePathsData(St.pathsData), Ge = 0; Ge < Xe; Ge += 1)
                vt = bez.getSegmentsLength(je.shapes[Ge]), ot.push(vt), bt += vt.totalLength;
              St.totalShapeLength = bt, St.pathsData = ot;
            }
            Tt += bt, St.shape._mdf = !0;
          }
        var Pt = ie, kt = me, Ot = 0, Jr;
        for (Ue = qe - 1; Ue >= 0; Ue -= 1)
          if (St = this.shapes[Ue], St.shape._mdf) {
            for (It = St.localShapeCollection, It.releaseShapes(), this.m === 2 && qe > 1 ? (Jr = this.calculateShapeEdges(ie, me, St.totalShapeLength, Ot, Tt), Ot += St.totalShapeLength) : Jr = [[Pt, kt]], Xe = Jr.length, Ge = 0; Ge < Xe; Ge += 1) {
              Pt = Jr[Ge][0], kt = Jr[Ge][1], wt.length = 0, kt <= 1 ? wt.push({
                s: St.totalShapeLength * Pt,
                e: St.totalShapeLength * kt
              }) : Pt >= 1 ? wt.push({
                s: St.totalShapeLength * (Pt - 1),
                e: St.totalShapeLength * (kt - 1)
              }) : (wt.push({
                s: St.totalShapeLength * Pt,
                e: St.totalShapeLength
              }), wt.push({
                s: 0,
                e: St.totalShapeLength * (kt - 1)
              }));
              var en = this.addShapes(St, wt[0]);
              if (wt[0].s !== wt[0].e) {
                if (wt.length > 1) {
                  var nn = St.shape.paths.shapes[St.shape.paths._length - 1];
                  if (nn.c) {
                    var ln = en.pop();
                    this.addPaths(en, It), en = this.addShapes(St, wt[1], ln);
                  } else
                    this.addPaths(en, It), en = this.addShapes(St, wt[1]);
                }
                this.addPaths(en, It);
              }
            }
            St.shape.paths = It;
          }
      }
    }, TrimModifier.prototype.addPaths = function(ce, ie) {
      var me, we = ce.length;
      for (me = 0; me < we; me += 1)
        ie.addShape(ce[me]);
    }, TrimModifier.prototype.addSegment = function(ce, ie, me, we, Re, je, Ue) {
      Re.setXYAt(ie[0], ie[1], "o", je), Re.setXYAt(me[0], me[1], "i", je + 1), Ue && Re.setXYAt(ce[0], ce[1], "v", je), Re.setXYAt(we[0], we[1], "v", je + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(ce, ie, me, we) {
      ie.setXYAt(ce[1], ce[5], "o", me), ie.setXYAt(ce[2], ce[6], "i", me + 1), we && ie.setXYAt(ce[0], ce[4], "v", me), ie.setXYAt(ce[3], ce[7], "v", me + 1);
    }, TrimModifier.prototype.addShapes = function(ce, ie, me) {
      var we = ce.pathsData, Re = ce.shape.paths.shapes, je, Ue = ce.shape.paths._length, qe, Ge, Xe = 0, ot, vt, bt, Tt, wt = [], St, It = !0;
      for (me ? (vt = me._length, St = me._length) : (me = shapePool.newElement(), vt = 0, St = 0), wt.push(me), je = 0; je < Ue; je += 1) {
        for (bt = we[je].lengths, me.c = Re[je].c, Ge = Re[je].c ? bt.length : bt.length + 1, qe = 1; qe < Ge; qe += 1)
          if (ot = bt[qe - 1], Xe + ot.addedLength < ie.s)
            Xe += ot.addedLength, me.c = !1;
          else if (Xe > ie.e) {
            me.c = !1;
            break;
          } else
            ie.s <= Xe && ie.e >= Xe + ot.addedLength ? (this.addSegment(Re[je].v[qe - 1], Re[je].o[qe - 1], Re[je].i[qe], Re[je].v[qe], me, vt, It), It = !1) : (Tt = bez.getNewSegment(Re[je].v[qe - 1], Re[je].v[qe], Re[je].o[qe - 1], Re[je].i[qe], (ie.s - Xe) / ot.addedLength, (ie.e - Xe) / ot.addedLength, bt[qe - 1]), this.addSegmentFromArray(Tt, me, vt, It), It = !1, me.c = !1), Xe += ot.addedLength, vt += 1;
        if (Re[je].c && bt.length) {
          if (ot = bt[qe - 1], Xe <= ie.e) {
            var Pt = bt[qe - 1].addedLength;
            ie.s <= Xe && ie.e >= Xe + Pt ? (this.addSegment(Re[je].v[qe - 1], Re[je].o[qe - 1], Re[je].i[0], Re[je].v[0], me, vt, It), It = !1) : (Tt = bez.getNewSegment(Re[je].v[qe - 1], Re[je].v[0], Re[je].o[qe - 1], Re[je].i[0], (ie.s - Xe) / Pt, (ie.e - Xe) / Pt, bt[qe - 1]), this.addSegmentFromArray(Tt, me, vt, It), It = !1, me.c = !1);
          } else
            me.c = !1;
          Xe += ot.addedLength, vt += 1;
        }
        if (me._length && (me.setXYAt(me.v[St][0], me.v[St][1], "i", St), me.setXYAt(me.v[me._length - 1][0], me.v[me._length - 1][1], "o", me._length - 1)), Xe > ie.e)
          break;
        je < Ue - 1 && (me = shapePool.newElement(), It = !0, wt.push(me), vt = 0);
      }
      return wt;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(ce, ie) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(ce, ie.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(ce, ie) {
      var me = ie / 100, we = [0, 0], Re = ce._length, je = 0;
      for (je = 0; je < Re; je += 1)
        we[0] += ce.v[je][0], we[1] += ce.v[je][1];
      we[0] /= Re, we[1] /= Re;
      var Ue = shapePool.newElement();
      Ue.c = ce.c;
      var qe, Ge, Xe, ot, vt, bt;
      for (je = 0; je < Re; je += 1)
        qe = ce.v[je][0] + (we[0] - ce.v[je][0]) * me, Ge = ce.v[je][1] + (we[1] - ce.v[je][1]) * me, Xe = ce.o[je][0] + (we[0] - ce.o[je][0]) * -me, ot = ce.o[je][1] + (we[1] - ce.o[je][1]) * -me, vt = ce.i[je][0] + (we[0] - ce.i[je][0]) * -me, bt = ce.i[je][1] + (we[1] - ce.i[je][1]) * -me, Ue.setTripleAt(qe, Ge, Xe, ot, vt, bt, je);
      return Ue;
    }, PuckerAndBloatModifier.prototype.processShapes = function(ce) {
      var ie, me, we = this.shapes.length, Re, je, Ue = this.amount.v;
      if (Ue !== 0) {
        var qe, Ge;
        for (me = 0; me < we; me += 1) {
          if (qe = this.shapes[me], Ge = qe.localShapeCollection, !(!qe.shape._mdf && !this._mdf && !ce))
            for (Ge.releaseShapes(), qe.shape._mdf = !0, ie = qe.shape.paths.shapes, je = qe.shape.paths._length, Re = 0; Re < je; Re += 1)
              Ge.addShape(this.processPath(ie[Re], Ue));
          qe.shape.paths = qe.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var ce = [0, 0];
      function ie(Ge) {
        var Xe = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || Xe, this.a && Ge.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && Ge.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && Ge.skewFromAxis(-this.sk.v, this.sa.v), this.r ? Ge.rotate(-this.r.v) : Ge.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? Ge.translate(this.px.v, this.py.v, -this.pz.v) : Ge.translate(this.px.v, this.py.v, 0) : Ge.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function me(Ge) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || Ge) {
            var Xe;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var ot, vt;
              if (Xe = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (ot = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / Xe, 0), vt = this.p.getValueAtTime(this.p.keyframes[0].t / Xe, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (ot = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / Xe, 0), vt = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / Xe, 0)) : (ot = this.p.pv, vt = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / Xe, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                ot = [], vt = [];
                var bt = this.px, Tt = this.py;
                bt._caching.lastFrame + bt.offsetTime <= bt.keyframes[0].t ? (ot[0] = bt.getValueAtTime((bt.keyframes[0].t + 0.01) / Xe, 0), ot[1] = Tt.getValueAtTime((Tt.keyframes[0].t + 0.01) / Xe, 0), vt[0] = bt.getValueAtTime(bt.keyframes[0].t / Xe, 0), vt[1] = Tt.getValueAtTime(Tt.keyframes[0].t / Xe, 0)) : bt._caching.lastFrame + bt.offsetTime >= bt.keyframes[bt.keyframes.length - 1].t ? (ot[0] = bt.getValueAtTime(bt.keyframes[bt.keyframes.length - 1].t / Xe, 0), ot[1] = Tt.getValueAtTime(Tt.keyframes[Tt.keyframes.length - 1].t / Xe, 0), vt[0] = bt.getValueAtTime((bt.keyframes[bt.keyframes.length - 1].t - 0.01) / Xe, 0), vt[1] = Tt.getValueAtTime((Tt.keyframes[Tt.keyframes.length - 1].t - 0.01) / Xe, 0)) : (ot = [bt.pv, Tt.pv], vt[0] = bt.getValueAtTime((bt._caching.lastFrame + bt.offsetTime - 0.01) / Xe, bt.offsetTime), vt[1] = Tt.getValueAtTime((Tt._caching.lastFrame + Tt.offsetTime - 0.01) / Xe, Tt.offsetTime));
              } else
                vt = ce, ot = vt;
              this.v.rotate(-Math.atan2(ot[1] - vt[1], ot[0] - vt[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function we() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function Re() {
      }
      function je(Ge) {
        this._addDynamicProperty(Ge), this.elem.addDynamicProperty(Ge), this._isDirty = !0;
      }
      function Ue(Ge, Xe, ot) {
        if (this.elem = Ge, this.frameId = -1, this.propType = "transform", this.data = Xe, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(ot || Ge), Xe.p && Xe.p.s ? (this.px = PropertyFactory.getProp(Ge, Xe.p.x, 0, 0, this), this.py = PropertyFactory.getProp(Ge, Xe.p.y, 0, 0, this), Xe.p.z && (this.pz = PropertyFactory.getProp(Ge, Xe.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(Ge, Xe.p || {
          k: [0, 0, 0]
        }, 1, 0, this), Xe.rx) {
          if (this.rx = PropertyFactory.getProp(Ge, Xe.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(Ge, Xe.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(Ge, Xe.rz, 0, degToRads, this), Xe.or.k[0].ti) {
            var vt, bt = Xe.or.k.length;
            for (vt = 0; vt < bt; vt += 1)
              Xe.or.k[vt].to = null, Xe.or.k[vt].ti = null;
          }
          this.or = PropertyFactory.getProp(Ge, Xe.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(Ge, Xe.r || {
            k: 0
          }, 0, degToRads, this);
        Xe.sk && (this.sk = PropertyFactory.getProp(Ge, Xe.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(Ge, Xe.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(Ge, Xe.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(Ge, Xe.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), Xe.o ? this.o = PropertyFactory.getProp(Ge, Xe.o, 0, 0.01, Ge) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      Ue.prototype = {
        applyToMatrix: ie,
        getValue: me,
        precalculateMatrix: we,
        autoOrient: Re
      }, extendPrototype([DynamicPropertyContainer], Ue), Ue.prototype.addDynamicProperty = je, Ue.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function qe(Ge, Xe, ot) {
        return new Ue(Ge, Xe, ot);
      }
      return {
        getTransformProperty: qe
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(ce, ie) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(ce, ie.c, 0, null, this), this.o = PropertyFactory.getProp(ce, ie.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(ce, ie.tr, this), this.so = PropertyFactory.getProp(ce, ie.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(ce, ie.tr.eo, 0, 0.01, this), this.data = ie, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(ce, ie, me, we, Re, je) {
      var Ue = je ? -1 : 1, qe = we.s.v[0] + (1 - we.s.v[0]) * (1 - Re), Ge = we.s.v[1] + (1 - we.s.v[1]) * (1 - Re);
      ce.translate(we.p.v[0] * Ue * Re, we.p.v[1] * Ue * Re, we.p.v[2]), ie.translate(-we.a.v[0], -we.a.v[1], we.a.v[2]), ie.rotate(-we.r.v * Ue * Re), ie.translate(we.a.v[0], we.a.v[1], we.a.v[2]), me.translate(-we.a.v[0], -we.a.v[1], we.a.v[2]), me.scale(je ? 1 / qe : qe, je ? 1 / Ge : Ge), me.translate(we.a.v[0], we.a.v[1], we.a.v[2]);
    }, RepeaterModifier.prototype.init = function(ce, ie, me, we) {
      for (this.elem = ce, this.arr = ie, this.pos = me, this.elemsData = we, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(ce), this.initModifierProperties(ce, ie[me]); me > 0; )
        me -= 1, this._elements.unshift(ie[me]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(ce) {
      var ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        ce[ie]._processed = !1, ce[ie].ty === "gr" && this.resetElements(ce[ie].it);
    }, RepeaterModifier.prototype.cloneElements = function(ce) {
      var ie = JSON.parse(JSON.stringify(ce));
      return this.resetElements(ie), ie;
    }, RepeaterModifier.prototype.changeGroupRender = function(ce, ie) {
      var me, we = ce.length;
      for (me = 0; me < we; me += 1)
        ce[me]._render = ie, ce[me].ty === "gr" && this.changeGroupRender(ce[me].it, ie);
    }, RepeaterModifier.prototype.processShapes = function(ce) {
      var ie, me, we, Re, je, Ue = !1;
      if (this._mdf || ce) {
        var qe = Math.ceil(this.c.v);
        if (this._groups.length < qe) {
          for (; this._groups.length < qe; ) {
            var Ge = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            Ge.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, Ge), this._groups.splice(0, 0, Ge), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), Ue = !0;
        }
        je = 0;
        var Xe;
        for (we = 0; we <= this._groups.length - 1; we += 1) {
          if (Xe = je < qe, this._groups[we]._render = Xe, this.changeGroupRender(this._groups[we].it, Xe), !Xe) {
            var ot = this.elemsData[we].it, vt = ot[ot.length - 1];
            vt.transform.op.v !== 0 ? (vt.transform.op._mdf = !0, vt.transform.op.v = 0) : vt.transform.op._mdf = !1;
          }
          je += 1;
        }
        this._currentCopies = qe;
        var bt = this.o.v, Tt = bt % 1, wt = bt > 0 ? Math.floor(bt) : Math.ceil(bt), St = this.pMatrix.props, It = this.rMatrix.props, Pt = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var kt = 0;
        if (bt > 0) {
          for (; kt < wt; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), kt += 1;
          Tt && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, Tt, !1), kt += Tt);
        } else if (bt < 0) {
          for (; kt > wt; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), kt -= 1;
          Tt && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -Tt, !0), kt -= Tt);
        }
        we = this.data.m === 1 ? 0 : this._currentCopies - 1, Re = this.data.m === 1 ? 1 : -1, je = this._currentCopies;
        for (var Ot, Jr; je; ) {
          if (ie = this.elemsData[we].it, me = ie[ie.length - 1].transform.mProps.v.props, Jr = me.length, ie[ie.length - 1].transform.mProps._mdf = !0, ie[ie.length - 1].transform.op._mdf = !0, ie[ie.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (we / (this._currentCopies - 1)), kt !== 0) {
            for ((we !== 0 && Re === 1 || we !== this._currentCopies - 1 && Re === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(It[0], It[1], It[2], It[3], It[4], It[5], It[6], It[7], It[8], It[9], It[10], It[11], It[12], It[13], It[14], It[15]), this.matrix.transform(Pt[0], Pt[1], Pt[2], Pt[3], Pt[4], Pt[5], Pt[6], Pt[7], Pt[8], Pt[9], Pt[10], Pt[11], Pt[12], Pt[13], Pt[14], Pt[15]), this.matrix.transform(St[0], St[1], St[2], St[3], St[4], St[5], St[6], St[7], St[8], St[9], St[10], St[11], St[12], St[13], St[14], St[15]), Ot = 0; Ot < Jr; Ot += 1)
              me[Ot] = this.matrix.props[Ot];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), Ot = 0; Ot < Jr; Ot += 1)
              me[Ot] = this.matrix.props[Ot];
          kt += 1, je -= 1, we += Re;
        }
      } else
        for (je = this._currentCopies, we = 0, Re = 1; je; )
          ie = this.elemsData[we].it, me = ie[ie.length - 1].transform.mProps.v.props, ie[ie.length - 1].transform.mProps._mdf = !1, ie[ie.length - 1].transform.op._mdf = !1, je -= 1, we += Re;
      return Ue;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(ce, ie) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(ce, ie.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(ce, ie) {
      var me = shapePool.newElement();
      me.c = ce.c;
      var we, Re = ce._length, je, Ue, qe, Ge, Xe, ot, vt = 0, bt, Tt, wt, St, It, Pt;
      for (we = 0; we < Re; we += 1)
        je = ce.v[we], qe = ce.o[we], Ue = ce.i[we], je[0] === qe[0] && je[1] === qe[1] && je[0] === Ue[0] && je[1] === Ue[1] ? (we === 0 || we === Re - 1) && !ce.c ? (me.setTripleAt(je[0], je[1], qe[0], qe[1], Ue[0], Ue[1], vt), vt += 1) : (we === 0 ? Ge = ce.v[Re - 1] : Ge = ce.v[we - 1], Xe = Math.sqrt(Math.pow(je[0] - Ge[0], 2) + Math.pow(je[1] - Ge[1], 2)), ot = Xe ? Math.min(Xe / 2, ie) / Xe : 0, It = je[0] + (Ge[0] - je[0]) * ot, bt = It, Pt = je[1] - (je[1] - Ge[1]) * ot, Tt = Pt, wt = bt - (bt - je[0]) * roundCorner, St = Tt - (Tt - je[1]) * roundCorner, me.setTripleAt(bt, Tt, wt, St, It, Pt, vt), vt += 1, we === Re - 1 ? Ge = ce.v[0] : Ge = ce.v[we + 1], Xe = Math.sqrt(Math.pow(je[0] - Ge[0], 2) + Math.pow(je[1] - Ge[1], 2)), ot = Xe ? Math.min(Xe / 2, ie) / Xe : 0, wt = je[0] + (Ge[0] - je[0]) * ot, bt = wt, St = je[1] + (Ge[1] - je[1]) * ot, Tt = St, It = bt - (bt - je[0]) * roundCorner, Pt = Tt - (Tt - je[1]) * roundCorner, me.setTripleAt(bt, Tt, wt, St, It, Pt, vt), vt += 1) : (me.setTripleAt(ce.v[we][0], ce.v[we][1], ce.o[we][0], ce.o[we][1], ce.i[we][0], ce.i[we][1], vt), vt += 1);
      return me;
    }, RoundCornersModifier.prototype.processShapes = function(ce) {
      var ie, me, we = this.shapes.length, Re, je, Ue = this.rd.v;
      if (Ue !== 0) {
        var qe, Ge;
        for (me = 0; me < we; me += 1) {
          if (qe = this.shapes[me], Ge = qe.localShapeCollection, !(!qe.shape._mdf && !this._mdf && !ce))
            for (Ge.releaseShapes(), qe.shape._mdf = !0, ie = qe.shape.paths.shapes, je = qe.shape.paths._length, Re = 0; Re < je; Re += 1)
              Ge.addShape(this.processPath(ie[Re], Ue));
          qe.shape.paths = qe.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(ce, ie) {
      return Math.abs(ce - ie) * 1e5 <= Math.min(Math.abs(ce), Math.abs(ie));
    }
    function floatZero(ce) {
      return Math.abs(ce) <= 1e-5;
    }
    function lerp(ce, ie, me) {
      return ce * (1 - me) + ie * me;
    }
    function lerpPoint(ce, ie, me) {
      return [lerp(ce[0], ie[0], me), lerp(ce[1], ie[1], me)];
    }
    function quadRoots(ce, ie, me) {
      if (ce === 0) return [];
      var we = ie * ie - 4 * ce * me;
      if (we < 0) return [];
      var Re = -ie / (2 * ce);
      if (we === 0) return [Re];
      var je = Math.sqrt(we) / (2 * ce);
      return [Re - je, Re + je];
    }
    function polynomialCoefficients(ce, ie, me, we) {
      return [-ce + 3 * ie - 3 * me + we, 3 * ce - 6 * ie + 3 * me, -3 * ce + 3 * ie, ce];
    }
    function singlePoint(ce) {
      return new PolynomialBezier(ce, ce, ce, ce, !1);
    }
    function PolynomialBezier(ce, ie, me, we, Re) {
      Re && pointEqual(ce, ie) && (ie = lerpPoint(ce, we, 1 / 3)), Re && pointEqual(me, we) && (me = lerpPoint(ce, we, 2 / 3));
      var je = polynomialCoefficients(ce[0], ie[0], me[0], we[0]), Ue = polynomialCoefficients(ce[1], ie[1], me[1], we[1]);
      this.a = [je[0], Ue[0]], this.b = [je[1], Ue[1]], this.c = [je[2], Ue[2]], this.d = [je[3], Ue[3]], this.points = [ce, ie, me, we];
    }
    PolynomialBezier.prototype.point = function(ce) {
      return [((this.a[0] * ce + this.b[0]) * ce + this.c[0]) * ce + this.d[0], ((this.a[1] * ce + this.b[1]) * ce + this.c[1]) * ce + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(ce) {
      return [(3 * ce * this.a[0] + 2 * this.b[0]) * ce + this.c[0], (3 * ce * this.a[1] + 2 * this.b[1]) * ce + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(ce) {
      var ie = this.derivative(ce);
      return Math.atan2(ie[1], ie[0]);
    }, PolynomialBezier.prototype.normalAngle = function(ce) {
      var ie = this.derivative(ce);
      return Math.atan2(ie[0], ie[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var ce = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(ce)) return [];
      var ie = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / ce, me = ie * ie - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / ce;
      if (me < 0) return [];
      var we = Math.sqrt(me);
      return floatZero(we) ? we > 0 && we < 1 ? [ie] : [] : [ie - we, ie + we].filter(function(Re) {
        return Re > 0 && Re < 1;
      });
    }, PolynomialBezier.prototype.split = function(ce) {
      if (ce <= 0) return [singlePoint(this.points[0]), this];
      if (ce >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
      var ie = lerpPoint(this.points[0], this.points[1], ce), me = lerpPoint(this.points[1], this.points[2], ce), we = lerpPoint(this.points[2], this.points[3], ce), Re = lerpPoint(ie, me, ce), je = lerpPoint(me, we, ce), Ue = lerpPoint(Re, je, ce);
      return [new PolynomialBezier(this.points[0], ie, Re, Ue, !0), new PolynomialBezier(Ue, je, we, this.points[3], !0)];
    };
    function extrema(ce, ie) {
      var me = ce.points[0][ie], we = ce.points[ce.points.length - 1][ie];
      if (me > we) {
        var Re = we;
        we = me, me = Re;
      }
      for (var je = quadRoots(3 * ce.a[ie], 2 * ce.b[ie], ce.c[ie]), Ue = 0; Ue < je.length; Ue += 1)
        if (je[Ue] > 0 && je[Ue] < 1) {
          var qe = ce.point(je[Ue])[ie];
          qe < me ? me = qe : qe > we && (we = qe);
        }
      return {
        min: me,
        max: we
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var ce = this.bounds();
      return {
        left: ce.x.min,
        right: ce.x.max,
        top: ce.y.min,
        bottom: ce.y.max,
        width: ce.x.max - ce.x.min,
        height: ce.y.max - ce.y.min,
        cx: (ce.x.max + ce.x.min) / 2,
        cy: (ce.y.max + ce.y.min) / 2
      };
    };
    function intersectData(ce, ie, me) {
      var we = ce.boundingBox();
      return {
        cx: we.cx,
        cy: we.cy,
        width: we.width,
        height: we.height,
        bez: ce,
        t: (ie + me) / 2,
        t1: ie,
        t2: me
      };
    }
    function splitData(ce) {
      var ie = ce.bez.split(0.5);
      return [intersectData(ie[0], ce.t1, ce.t), intersectData(ie[1], ce.t, ce.t2)];
    }
    function boxIntersect(ce, ie) {
      return Math.abs(ce.cx - ie.cx) * 2 < ce.width + ie.width && Math.abs(ce.cy - ie.cy) * 2 < ce.height + ie.height;
    }
    function intersectsImpl(ce, ie, me, we, Re, je) {
      if (boxIntersect(ce, ie)) {
        if (me >= je || ce.width <= we && ce.height <= we && ie.width <= we && ie.height <= we) {
          Re.push([ce.t, ie.t]);
          return;
        }
        var Ue = splitData(ce), qe = splitData(ie);
        intersectsImpl(Ue[0], qe[0], me + 1, we, Re, je), intersectsImpl(Ue[0], qe[1], me + 1, we, Re, je), intersectsImpl(Ue[1], qe[0], me + 1, we, Re, je), intersectsImpl(Ue[1], qe[1], me + 1, we, Re, je);
      }
    }
    PolynomialBezier.prototype.intersections = function(ce, ie, me) {
      ie === void 0 && (ie = 2), me === void 0 && (me = 7);
      var we = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(ce, 0, 1), 0, ie, we, me), we;
    }, PolynomialBezier.shapeSegment = function(ce, ie) {
      var me = (ie + 1) % ce.length();
      return new PolynomialBezier(ce.v[ie], ce.o[ie], ce.i[me], ce.v[me], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(ce, ie) {
      var me = (ie + 1) % ce.length();
      return new PolynomialBezier(ce.v[me], ce.i[me], ce.o[ie], ce.v[ie], !0);
    };
    function crossProduct(ce, ie) {
      return [ce[1] * ie[2] - ce[2] * ie[1], ce[2] * ie[0] - ce[0] * ie[2], ce[0] * ie[1] - ce[1] * ie[0]];
    }
    function lineIntersection(ce, ie, me, we) {
      var Re = [ce[0], ce[1], 1], je = [ie[0], ie[1], 1], Ue = [me[0], me[1], 1], qe = [we[0], we[1], 1], Ge = crossProduct(crossProduct(Re, je), crossProduct(Ue, qe));
      return floatZero(Ge[2]) ? null : [Ge[0] / Ge[2], Ge[1] / Ge[2]];
    }
    function polarOffset(ce, ie, me) {
      return [ce[0] + Math.cos(ie) * me, ce[1] - Math.sin(ie) * me];
    }
    function pointDistance(ce, ie) {
      return Math.hypot(ce[0] - ie[0], ce[1] - ie[1]);
    }
    function pointEqual(ce, ie) {
      return floatEqual(ce[0], ie[0]) && floatEqual(ce[1], ie[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(ce, ie) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(ce, ie.s, 0, null, this), this.frequency = PropertyFactory.getProp(ce, ie.r, 0, null, this), this.pointsType = PropertyFactory.getProp(ce, ie.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(ce, ie, me, we, Re, je, Ue) {
      var qe = me - Math.PI / 2, Ge = me + Math.PI / 2, Xe = ie[0] + Math.cos(me) * we * Re, ot = ie[1] - Math.sin(me) * we * Re;
      ce.setTripleAt(Xe, ot, Xe + Math.cos(qe) * je, ot - Math.sin(qe) * je, Xe + Math.cos(Ge) * Ue, ot - Math.sin(Ge) * Ue, ce.length());
    }
    function getPerpendicularVector(ce, ie) {
      var me = [ie[0] - ce[0], ie[1] - ce[1]], we = -Math.PI * 0.5, Re = [Math.cos(we) * me[0] - Math.sin(we) * me[1], Math.sin(we) * me[0] + Math.cos(we) * me[1]];
      return Re;
    }
    function getProjectingAngle(ce, ie) {
      var me = ie === 0 ? ce.length() - 1 : ie - 1, we = (ie + 1) % ce.length(), Re = ce.v[me], je = ce.v[we], Ue = getPerpendicularVector(Re, je);
      return Math.atan2(0, 1) - Math.atan2(Ue[1], Ue[0]);
    }
    function zigZagCorner(ce, ie, me, we, Re, je, Ue) {
      var qe = getProjectingAngle(ie, me), Ge = ie.v[me % ie._length], Xe = ie.v[me === 0 ? ie._length - 1 : me - 1], ot = ie.v[(me + 1) % ie._length], vt = je === 2 ? Math.sqrt(Math.pow(Ge[0] - Xe[0], 2) + Math.pow(Ge[1] - Xe[1], 2)) : 0, bt = je === 2 ? Math.sqrt(Math.pow(Ge[0] - ot[0], 2) + Math.pow(Ge[1] - ot[1], 2)) : 0;
      setPoint(ce, ie.v[me % ie._length], qe, Ue, we, bt / ((Re + 1) * 2), vt / ((Re + 1) * 2));
    }
    function zigZagSegment(ce, ie, me, we, Re, je) {
      for (var Ue = 0; Ue < we; Ue += 1) {
        var qe = (Ue + 1) / (we + 1), Ge = Re === 2 ? Math.sqrt(Math.pow(ie.points[3][0] - ie.points[0][0], 2) + Math.pow(ie.points[3][1] - ie.points[0][1], 2)) : 0, Xe = ie.normalAngle(qe), ot = ie.point(qe);
        setPoint(ce, ot, Xe, je, me, Ge / ((we + 1) * 2), Ge / ((we + 1) * 2)), je = -je;
      }
      return je;
    }
    ZigZagModifier.prototype.processPath = function(ce, ie, me, we) {
      var Re = ce._length, je = shapePool.newElement();
      if (je.c = ce.c, ce.c || (Re -= 1), Re === 0) return je;
      var Ue = -1, qe = PolynomialBezier.shapeSegment(ce, 0);
      zigZagCorner(je, ce, 0, ie, me, we, Ue);
      for (var Ge = 0; Ge < Re; Ge += 1)
        Ue = zigZagSegment(je, qe, ie, me, we, -Ue), Ge === Re - 1 && !ce.c ? qe = null : qe = PolynomialBezier.shapeSegment(ce, (Ge + 1) % Re), zigZagCorner(je, ce, Ge + 1, ie, me, we, Ue);
      return je;
    }, ZigZagModifier.prototype.processShapes = function(ce) {
      var ie, me, we = this.shapes.length, Re, je, Ue = this.amplitude.v, qe = Math.max(0, Math.round(this.frequency.v)), Ge = this.pointsType.v;
      if (Ue !== 0) {
        var Xe, ot;
        for (me = 0; me < we; me += 1) {
          if (Xe = this.shapes[me], ot = Xe.localShapeCollection, !(!Xe.shape._mdf && !this._mdf && !ce))
            for (ot.releaseShapes(), Xe.shape._mdf = !0, ie = Xe.shape.paths.shapes, je = Xe.shape.paths._length, Re = 0; Re < je; Re += 1)
              ot.addShape(this.processPath(ie[Re], Ue, qe, Ge));
          Xe.shape.paths = Xe.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(ce, ie, me) {
      var we = Math.atan2(ie[0] - ce[0], ie[1] - ce[1]);
      return [polarOffset(ce, we, me), polarOffset(ie, we, me)];
    }
    function offsetSegment(ce, ie) {
      var me, we, Re, je, Ue, qe, Ge;
      Ge = linearOffset(ce.points[0], ce.points[1], ie), me = Ge[0], we = Ge[1], Ge = linearOffset(ce.points[1], ce.points[2], ie), Re = Ge[0], je = Ge[1], Ge = linearOffset(ce.points[2], ce.points[3], ie), Ue = Ge[0], qe = Ge[1];
      var Xe = lineIntersection(me, we, Re, je);
      Xe === null && (Xe = we);
      var ot = lineIntersection(Ue, qe, Re, je);
      return ot === null && (ot = Ue), new PolynomialBezier(me, Xe, ot, qe);
    }
    function joinLines(ce, ie, me, we, Re) {
      var je = ie.points[3], Ue = me.points[0];
      if (we === 3 || pointEqual(je, Ue)) return je;
      if (we === 2) {
        var qe = -ie.tangentAngle(1), Ge = -me.tangentAngle(0) + Math.PI, Xe = lineIntersection(je, polarOffset(je, qe + Math.PI / 2, 100), Ue, polarOffset(Ue, qe + Math.PI / 2, 100)), ot = Xe ? pointDistance(Xe, je) : pointDistance(je, Ue) / 2, vt = polarOffset(je, qe, 2 * ot * roundCorner);
        return ce.setXYAt(vt[0], vt[1], "o", ce.length() - 1), vt = polarOffset(Ue, Ge, 2 * ot * roundCorner), ce.setTripleAt(Ue[0], Ue[1], Ue[0], Ue[1], vt[0], vt[1], ce.length()), Ue;
      }
      var bt = pointEqual(je, ie.points[2]) ? ie.points[0] : ie.points[2], Tt = pointEqual(Ue, me.points[1]) ? me.points[3] : me.points[1], wt = lineIntersection(bt, je, Ue, Tt);
      return wt && pointDistance(wt, je) < Re ? (ce.setTripleAt(wt[0], wt[1], wt[0], wt[1], wt[0], wt[1], ce.length()), wt) : je;
    }
    function getIntersection(ce, ie) {
      var me = ce.intersections(ie);
      return me.length && floatEqual(me[0][0], 1) && me.shift(), me.length ? me[0] : null;
    }
    function pruneSegmentIntersection(ce, ie) {
      var me = ce.slice(), we = ie.slice(), Re = getIntersection(ce[ce.length - 1], ie[0]);
      return Re && (me[ce.length - 1] = ce[ce.length - 1].split(Re[0])[0], we[0] = ie[0].split(Re[1])[1]), ce.length > 1 && ie.length > 1 && (Re = getIntersection(ce[0], ie[ie.length - 1]), Re) ? [[ce[0].split(Re[0])[0]], [ie[ie.length - 1].split(Re[1])[1]]] : [me, we];
    }
    function pruneIntersections(ce) {
      for (var ie, me = 1; me < ce.length; me += 1)
        ie = pruneSegmentIntersection(ce[me - 1], ce[me]), ce[me - 1] = ie[0], ce[me] = ie[1];
      return ce.length > 1 && (ie = pruneSegmentIntersection(ce[ce.length - 1], ce[0]), ce[ce.length - 1] = ie[0], ce[0] = ie[1]), ce;
    }
    function offsetSegmentSplit(ce, ie) {
      var me = ce.inflectionPoints(), we, Re, je, Ue;
      if (me.length === 0)
        return [offsetSegment(ce, ie)];
      if (me.length === 1 || floatEqual(me[1], 1))
        return je = ce.split(me[0]), we = je[0], Re = je[1], [offsetSegment(we, ie), offsetSegment(Re, ie)];
      je = ce.split(me[0]), we = je[0];
      var qe = (me[1] - me[0]) / (1 - me[0]);
      return je = je[1].split(qe), Ue = je[0], Re = je[1], [offsetSegment(we, ie), offsetSegment(Ue, ie), offsetSegment(Re, ie)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(ce, ie) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(ce, ie.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(ce, ie.ml, 0, null, this), this.lineJoin = ie.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(ce, ie, me, we) {
      var Re = shapePool.newElement();
      Re.c = ce.c;
      var je = ce.length();
      ce.c || (je -= 1);
      var Ue, qe, Ge, Xe = [];
      for (Ue = 0; Ue < je; Ue += 1)
        Ge = PolynomialBezier.shapeSegment(ce, Ue), Xe.push(offsetSegmentSplit(Ge, ie));
      if (!ce.c)
        for (Ue = je - 1; Ue >= 0; Ue -= 1)
          Ge = PolynomialBezier.shapeSegmentInverted(ce, Ue), Xe.push(offsetSegmentSplit(Ge, ie));
      Xe = pruneIntersections(Xe);
      var ot = null, vt = null;
      for (Ue = 0; Ue < Xe.length; Ue += 1) {
        var bt = Xe[Ue];
        for (vt && (ot = joinLines(Re, vt, bt[0], me, we)), vt = bt[bt.length - 1], qe = 0; qe < bt.length; qe += 1)
          Ge = bt[qe], ot && pointEqual(Ge.points[0], ot) ? Re.setXYAt(Ge.points[1][0], Ge.points[1][1], "o", Re.length() - 1) : Re.setTripleAt(Ge.points[0][0], Ge.points[0][1], Ge.points[1][0], Ge.points[1][1], Ge.points[0][0], Ge.points[0][1], Re.length()), Re.setTripleAt(Ge.points[3][0], Ge.points[3][1], Ge.points[3][0], Ge.points[3][1], Ge.points[2][0], Ge.points[2][1], Re.length()), ot = Ge.points[3];
      }
      return Xe.length && joinLines(Re, vt, Xe[0][0], me, we), Re;
    }, OffsetPathModifier.prototype.processShapes = function(ce) {
      var ie, me, we = this.shapes.length, Re, je, Ue = this.amount.v, qe = this.miterLimit.v, Ge = this.lineJoin;
      if (Ue !== 0) {
        var Xe, ot;
        for (me = 0; me < we; me += 1) {
          if (Xe = this.shapes[me], ot = Xe.localShapeCollection, !(!Xe.shape._mdf && !this._mdf && !ce))
            for (ot.releaseShapes(), Xe.shape._mdf = !0, ie = Xe.shape.paths.shapes, je = Xe.shape.paths._length, Re = 0; Re < je; Re += 1)
              ot.addShape(this.processPath(ie[Re], Ue, Ge, qe));
          Xe.shape.paths = Xe.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(ce) {
      for (var ie = ce.fStyle ? ce.fStyle.split(" ") : [], me = "normal", we = "normal", Re = ie.length, je, Ue = 0; Ue < Re; Ue += 1)
        switch (je = ie[Ue].toLowerCase(), je) {
          case "italic":
            we = "italic";
            break;
          case "bold":
            me = "700";
            break;
          case "black":
            me = "900";
            break;
          case "medium":
            me = "500";
            break;
          case "regular":
          case "normal":
            me = "400";
            break;
          case "light":
          case "thin":
            me = "200";
            break;
        }
      return {
        style: we,
        weight: ce.fWeight || me
      };
    }
    var FontManager = function() {
      var ce = 5e3, ie = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, me = [];
      me = me.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var we = 127988, Re = 917631, je = 917601, Ue = 917626, qe = 65039, Ge = 8205, Xe = 127462, ot = 127487, vt = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function bt(cn) {
        var gn = cn.split(","), an, un = gn.length, pn = [];
        for (an = 0; an < un; an += 1)
          gn[an] !== "sans-serif" && gn[an] !== "monospace" && pn.push(gn[an]);
        return pn.join(",");
      }
      function Tt(cn, gn) {
        var an = createTag("span");
        an.setAttribute("aria-hidden", !0), an.style.fontFamily = gn;
        var un = createTag("span");
        un.innerText = "giItT1WQy@!-/#", an.style.position = "absolute", an.style.left = "-10000px", an.style.top = "-10000px", an.style.fontSize = "300px", an.style.fontVariant = "normal", an.style.fontStyle = "normal", an.style.fontWeight = "normal", an.style.letterSpacing = "0", an.appendChild(un), document.body.appendChild(an);
        var pn = un.offsetWidth;
        return un.style.fontFamily = bt(cn) + ", " + gn, {
          node: un,
          w: pn,
          parent: an
        };
      }
      function wt() {
        var cn, gn = this.fonts.length, an, un, pn = gn;
        for (cn = 0; cn < gn; cn += 1)
          this.fonts[cn].loaded ? pn -= 1 : this.fonts[cn].fOrigin === "n" || this.fonts[cn].origin === 0 ? this.fonts[cn].loaded = !0 : (an = this.fonts[cn].monoCase.node, un = this.fonts[cn].monoCase.w, an.offsetWidth !== un ? (pn -= 1, this.fonts[cn].loaded = !0) : (an = this.fonts[cn].sansCase.node, un = this.fonts[cn].sansCase.w, an.offsetWidth !== un && (pn -= 1, this.fonts[cn].loaded = !0)), this.fonts[cn].loaded && (this.fonts[cn].sansCase.parent.parentNode.removeChild(this.fonts[cn].sansCase.parent), this.fonts[cn].monoCase.parent.parentNode.removeChild(this.fonts[cn].monoCase.parent)));
        pn !== 0 && Date.now() - this.initTime < ce ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function St(cn, gn) {
        var an = document.body && gn ? "svg" : "canvas", un, pn = getFontProperties(cn);
        if (an === "svg") {
          var hn = createNS("text");
          hn.style.fontSize = "100px", hn.setAttribute("font-family", cn.fFamily), hn.setAttribute("font-style", pn.style), hn.setAttribute("font-weight", pn.weight), hn.textContent = "1", cn.fClass ? (hn.style.fontFamily = "inherit", hn.setAttribute("class", cn.fClass)) : hn.style.fontFamily = cn.fFamily, gn.appendChild(hn), un = hn;
        } else {
          var An = new OffscreenCanvas(500, 500).getContext("2d");
          An.font = pn.style + " " + pn.weight + " 100px " + cn.fFamily, un = An;
        }
        function In(qn) {
          return an === "svg" ? (un.textContent = qn, un.getComputedTextLength()) : un.measureText(qn).width;
        }
        return {
          measureText: In
        };
      }
      function It(cn, gn) {
        if (!cn) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = cn.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, cn.list.forEach(function(ji) {
            ji.helper = St(ji), ji.cache = {};
          }), this.fonts = cn.list;
          return;
        }
        var an = cn.list, un, pn = an.length, hn = pn;
        for (un = 0; un < pn; un += 1) {
          var An = !0, In, qn;
          if (an[un].loaded = !1, an[un].monoCase = Tt(an[un].fFamily, "monospace"), an[un].sansCase = Tt(an[un].fFamily, "sans-serif"), !an[un].fPath)
            an[un].loaded = !0, hn -= 1;
          else if (an[un].fOrigin === "p" || an[un].origin === 3) {
            if (In = document.querySelectorAll('style[f-forigin="p"][f-family="' + an[un].fFamily + '"], style[f-origin="3"][f-family="' + an[un].fFamily + '"]'), In.length > 0 && (An = !1), An) {
              var si = createTag("style");
              si.setAttribute("f-forigin", an[un].fOrigin), si.setAttribute("f-origin", an[un].origin), si.setAttribute("f-family", an[un].fFamily), si.type = "text/css", si.innerText = "@font-face {font-family: " + an[un].fFamily + "; font-style: normal; src: url('" + an[un].fPath + "');}", gn.appendChild(si);
            }
          } else if (an[un].fOrigin === "g" || an[un].origin === 1) {
            for (In = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), qn = 0; qn < In.length; qn += 1)
              In[qn].href.indexOf(an[un].fPath) !== -1 && (An = !1);
            if (An) {
              var bi = createTag("link");
              bi.setAttribute("f-forigin", an[un].fOrigin), bi.setAttribute("f-origin", an[un].origin), bi.type = "text/css", bi.rel = "stylesheet", bi.href = an[un].fPath, document.body.appendChild(bi);
            }
          } else if (an[un].fOrigin === "t" || an[un].origin === 2) {
            for (In = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), qn = 0; qn < In.length; qn += 1)
              an[un].fPath === In[qn].src && (An = !1);
            if (An) {
              var xi = createTag("link");
              xi.setAttribute("f-forigin", an[un].fOrigin), xi.setAttribute("f-origin", an[un].origin), xi.setAttribute("rel", "stylesheet"), xi.setAttribute("href", an[un].fPath), gn.appendChild(xi);
            }
          }
          an[un].helper = St(an[un], gn), an[un].cache = {}, this.fonts.push(an[un]);
        }
        hn === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function Pt(cn) {
        if (cn) {
          this.chars || (this.chars = []);
          var gn, an = cn.length, un, pn = this.chars.length, hn;
          for (gn = 0; gn < an; gn += 1) {
            for (un = 0, hn = !1; un < pn; )
              this.chars[un].style === cn[gn].style && this.chars[un].fFamily === cn[gn].fFamily && this.chars[un].ch === cn[gn].ch && (hn = !0), un += 1;
            hn || (this.chars.push(cn[gn]), pn += 1);
          }
        }
      }
      function kt(cn, gn, an) {
        for (var un = 0, pn = this.chars.length; un < pn; ) {
          if (this.chars[un].ch === cn && this.chars[un].style === gn && this.chars[un].fFamily === an)
            return this.chars[un];
          un += 1;
        }
        return (typeof cn == "string" && cn.charCodeAt(0) !== 13 || !cn) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", cn, gn, an)), ie;
      }
      function Ot(cn, gn, an) {
        var un = this.getFontByName(gn), pn = cn;
        if (!un.cache[pn]) {
          var hn = un.helper;
          if (cn === " ") {
            var An = hn.measureText("|" + cn + "|"), In = hn.measureText("||");
            un.cache[pn] = (An - In) / 100;
          } else
            un.cache[pn] = hn.measureText(cn) / 100;
        }
        return un.cache[pn] * an;
      }
      function Jr(cn) {
        for (var gn = 0, an = this.fonts.length; gn < an; ) {
          if (this.fonts[gn].fName === cn)
            return this.fonts[gn];
          gn += 1;
        }
        return this.fonts[0];
      }
      function en(cn) {
        var gn = 0, an = cn.charCodeAt(0);
        if (an >= 55296 && an <= 56319) {
          var un = cn.charCodeAt(1);
          un >= 56320 && un <= 57343 && (gn = (an - 55296) * 1024 + un - 56320 + 65536);
        }
        return gn;
      }
      function nn(cn, gn) {
        var an = cn.toString(16) + gn.toString(16);
        return vt.indexOf(an) !== -1;
      }
      function ln(cn) {
        return cn === Ge;
      }
      function fn(cn) {
        return cn === qe;
      }
      function vn(cn) {
        var gn = en(cn);
        return gn >= Xe && gn <= ot;
      }
      function Tn(cn) {
        return vn(cn.substr(0, 2)) && vn(cn.substr(2, 2));
      }
      function xn(cn) {
        return me.indexOf(cn) !== -1;
      }
      function bn(cn, gn) {
        var an = en(cn.substr(gn, 2));
        if (an !== we)
          return !1;
        var un = 0;
        for (gn += 2; un < 5; ) {
          if (an = en(cn.substr(gn, 2)), an < je || an > Ue)
            return !1;
          un += 1, gn += 2;
        }
        return en(cn.substr(gn, 2)) === Re;
      }
      function Sn() {
        this.isLoaded = !0;
      }
      var Cn = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      Cn.isModifier = nn, Cn.isZeroWidthJoiner = ln, Cn.isFlagEmoji = Tn, Cn.isRegionalCode = vn, Cn.isCombinedCharacter = xn, Cn.isRegionalFlag = bn, Cn.isVariationSelector = fn, Cn.BLACK_FLAG_CODE_POINT = we;
      var kn = {
        addChars: Pt,
        addFonts: It,
        getCharData: kt,
        getFontByName: Jr,
        measureText: Ot,
        checkLoadedFonts: wt,
        setIsLoaded: Sn
      };
      return Cn.prototype = kn, Cn;
    }();
    function SlotManager(ce) {
      this.animationData = ce;
    }
    SlotManager.prototype.getProp = function(ce) {
      return this.animationData.slots && this.animationData.slots[ce.sid] ? Object.assign(ce, this.animationData.slots[ce.sid].p) : ce;
    };
    function slotFactory(ce) {
      return new SlotManager(ce);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(ie) {
        this.renderableComponents.indexOf(ie) === -1 && this.renderableComponents.push(ie);
      },
      removeRenderableComponent: function(ie) {
        this.renderableComponents.indexOf(ie) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(ie), 1);
      },
      prepareRenderableFrame: function(ie) {
        this.checkLayerLimits(ie);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(ie) {
        this.data.ip - this.data.st <= ie && this.data.op - this.data.st > ie ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var ie, me = this.renderableComponents.length;
        for (ie = 0; ie < me; ie += 1)
          this.renderableComponents[ie].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = /* @__PURE__ */ function() {
      var ce = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(ie) {
        return ce[ie] || "";
      };
    }();
    function SliderEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 0, 0, me);
    }
    function AngleEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 0, 0, me);
    }
    function ColorEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 1, 0, me);
    }
    function PointEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 1, 0, me);
    }
    function LayerIndexEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 0, 0, me);
    }
    function MaskIndexEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 0, 0, me);
    }
    function CheckboxEffect(ce, ie, me) {
      this.p = PropertyFactory.getProp(ie, ce.v, 0, 0, me);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(ce, ie) {
      var me = ce.ef || [];
      this.effectElements = [];
      var we, Re = me.length, je;
      for (we = 0; we < Re; we += 1)
        je = new GroupEffect(me[we], ie), this.effectElements.push(je);
    }
    function GroupEffect(ce, ie) {
      this.init(ce, ie);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(ce, ie) {
      this.data = ce, this.effectElements = [], this.initDynamicPropertyContainer(ie);
      var me, we = this.data.ef.length, Re, je = this.data.ef;
      for (me = 0; me < we; me += 1) {
        switch (Re = null, je[me].ty) {
          case 0:
            Re = new SliderEffect(je[me], ie, this);
            break;
          case 1:
            Re = new AngleEffect(je[me], ie, this);
            break;
          case 2:
            Re = new ColorEffect(je[me], ie, this);
            break;
          case 3:
            Re = new PointEffect(je[me], ie, this);
            break;
          case 4:
          case 7:
            Re = new CheckboxEffect(je[me], ie, this);
            break;
          case 10:
            Re = new LayerIndexEffect(je[me], ie, this);
            break;
          case 11:
            Re = new MaskIndexEffect(je[me], ie, this);
            break;
          case 5:
            Re = new EffectsManager(je[me], ie);
            break;
          // case 6:
          default:
            Re = new NoValueEffect(je[me]);
            break;
        }
        Re && this.effectElements.push(Re);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var ie = 0, me = this.data.masksProperties.length; ie < me; ) {
          if (this.data.masksProperties[ie].mode !== "n" && this.data.masksProperties[ie].cl !== !1)
            return !0;
          ie += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var ie = getExpressionInterfaces();
        if (ie) {
          var me = ie("layer"), we = ie("effects"), Re = ie("shape"), je = ie("text"), Ue = ie("comp");
          this.layerInterface = me(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var qe = we.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(qe), this.data.ty === 0 || this.data.xt ? this.compInterface = Ue(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = Re(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = je(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var ie = getBlendMode(this.data.bm), me = this.baseElement || this.layerElement;
        me.style["mix-blend-mode"] = ie;
      },
      initBaseData: function(ie, me, we) {
        this.globalData = me, this.comp = we, this.data = ie, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(ie, me) {
        var we, Re = this.dynamicProperties.length;
        for (we = 0; we < Re; we += 1)
          (me || this._isParent && this.dynamicProperties[we].propType === "transform") && (this.dynamicProperties[we].getValue(), this.dynamicProperties[we]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(ie) {
        this.dynamicProperties.indexOf(ie) === -1 && this.dynamicProperties.push(ie);
      }
    };
    function FootageElement(ce, ie, me) {
      this.initFrame(), this.initRenderable(), this.assetData = ie.getAssetData(ce.refId), this.footageData = ie.imageLoader.getAsset(this.assetData), this.initBaseData(ce, ie, me);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var ce = getExpressionInterfaces();
      if (ce) {
        var ie = ce("footage");
        this.layerInterface = ie(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(ce, ie, me) {
      this.initFrame(), this.initRenderable(), this.assetData = ie.getAssetData(ce.refId), this.initBaseData(ce, ie, me), this._isPlaying = !1, this._canPlay = !1;
      var we = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(we), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = ce.tm ? PropertyFactory.getProp(this, ce.tm, 0, ie.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, ce.au && ce.au.lv ? ce.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(ce) {
      if (this.prepareRenderableFrame(ce, !0), this.prepareProperties(ce, !0), this.tm._placeholder)
        this._currentTime = ce / this.data.sr;
      else {
        var ie = this.tm.v;
        this._currentTime = ie;
      }
      this._volume = this.lv.v[0];
      var me = this._volume * this._volumeMultiplier;
      this._previousVolume !== me && (this._previousVolume = me, this.audio.volume(me));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(ce) {
      this.audio.rate(ce);
    }, AudioElement.prototype.volume = function(ce) {
      this._volumeMultiplier = ce, this._previousVolume = ce * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(ce) {
      var ie, me = this.layers.length, we;
      for (this.completeLayers = !0, ie = me - 1; ie >= 0; ie -= 1)
        this.elements[ie] || (we = this.layers[ie], we.ip - we.st <= ce - this.layers[ie].st && we.op - we.st > ce - this.layers[ie].st && this.buildItem(ie)), this.completeLayers = this.elements[ie] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(ce) {
      switch (ce.ty) {
        case 2:
          return this.createImage(ce);
        case 0:
          return this.createComp(ce);
        case 1:
          return this.createSolid(ce);
        case 3:
          return this.createNull(ce);
        case 4:
          return this.createShape(ce);
        case 5:
          return this.createText(ce);
        case 6:
          return this.createAudio(ce);
        case 13:
          return this.createCamera(ce);
        case 15:
          return this.createFootage(ce);
        default:
          return this.createNull(ce);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(ce) {
      return new AudioElement(ce, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(ce) {
      return new FootageElement(ce, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var ce, ie = this.layers.length;
      for (ce = 0; ce < ie; ce += 1)
        this.buildItem(ce);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(ce) {
      this.completeLayers = !1;
      var ie, me = ce.length, we, Re = this.layers.length;
      for (ie = 0; ie < me; ie += 1)
        for (we = 0; we < Re; ) {
          if (this.layers[we].id === ce[ie].id) {
            this.layers[we] = ce[ie];
            break;
          }
          we += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(ce) {
      this.globalData.projectInterface = ce;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(ce, ie, me) {
      for (var we = this.elements, Re = this.layers, je = 0, Ue = Re.length; je < Ue; )
        Re[je].ind == ie && (!we[je] || we[je] === !0 ? (this.buildItem(je), this.addPendingElement(ce)) : (me.push(we[je]), we[je].setAsParent(), Re[je].parent !== void 0 ? this.buildElementParenting(ce, Re[je].parent, me) : ce.setHierarchy(me))), je += 1;
    }, BaseRenderer.prototype.addPendingElement = function(ce) {
      this.pendingElements.push(ce);
    }, BaseRenderer.prototype.searchExtraCompositions = function(ce) {
      var ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        if (ce[ie].xt) {
          var we = this.createComp(ce[ie]);
          we.initExpressions(), this.globalData.projectInterface.registerComposition(we);
        }
    }, BaseRenderer.prototype.getElementById = function(ce) {
      var ie, me = this.elements.length;
      for (ie = 0; ie < me; ie += 1)
        if (this.elements[ie].data.ind === ce)
          return this.elements[ie];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(ce) {
      var ie = ce.shift(), me;
      if (typeof ie == "number")
        me = this.elements[ie];
      else {
        var we, Re = this.elements.length;
        for (we = 0; we < Re; we += 1)
          if (this.elements[we].data.nm === ie) {
            me = this.elements[we];
            break;
          }
      }
      return ce.length === 0 ? me : me.getElementByPath(ce);
    }, BaseRenderer.prototype.setupGlobalData = function(ce, ie) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(ce), this.globalData.fontManager.addChars(ce.chars), this.globalData.fontManager.addFonts(ce.fonts, ie), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = ce.fr, this.globalData.nm = ce.nm, this.globalData.compSize = {
        w: ce.w,
        h: ce.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var ie = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: ie,
          localMat: ie,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var ie, me = this.finalTransform.mat, we = 0, Re = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; we < Re; ) {
              if (this.hierarchy[we].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              we += 1;
            }
          if (this.finalTransform._matMdf)
            for (ie = this.finalTransform.mProp.v.props, me.cloneFromProps(ie), we = 0; we < Re; we += 1)
              me.multiply(this.hierarchy[we].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var ie = 0, me = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; ie < me; )
              this.localTransforms[ie]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[ie]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), ie += 1;
          if (this.finalTransform._localMatMdf) {
            var we = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(we), ie = 1; ie < me; ie += 1) {
              var Re = this.localTransforms[ie].matrix;
              we.multiply(Re);
            }
            we.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var je = this.finalTransform.localOpacity;
            for (ie = 0; ie < me; ie += 1)
              je *= this.localTransforms[ie].opacity * 0.01;
            this.finalTransform.localOpacity = je;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var ie = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (ie.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var me = 0, we = ie.length;
            for (me = 0; me < we; me += 1)
              this.localTransforms.push(ie[me]);
          }
        }
      },
      globalToLocal: function(ie) {
        var me = [];
        me.push(this.finalTransform);
        for (var we = !0, Re = this.comp; we; )
          Re.finalTransform ? (Re.data.hasMask && me.splice(0, 0, Re.finalTransform), Re = Re.comp) : we = !1;
        var je, Ue = me.length, qe;
        for (je = 0; je < Ue; je += 1)
          qe = me[je].mat.applyToPointArray(0, 0, 0), ie = [ie[0] - qe[0], ie[1] - qe[1], 0];
        return ie;
      },
      mHelper: new Matrix()
    };
    function MaskElement(ce, ie, me) {
      this.data = ce, this.element = ie, this.globalData = me, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var we = this.globalData.defs, Re, je = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(je), this.solidPath = "";
      var Ue, qe = this.masksProperties, Ge = 0, Xe = [], ot, vt, bt = createElementID(), Tt, wt, St, It, Pt = "clipPath", kt = "clip-path";
      for (Re = 0; Re < je; Re += 1)
        if ((qe[Re].mode !== "a" && qe[Re].mode !== "n" || qe[Re].inv || qe[Re].o.k !== 100 || qe[Re].o.x) && (Pt = "mask", kt = "mask"), (qe[Re].mode === "s" || qe[Re].mode === "i") && Ge === 0 ? (Tt = createNS("rect"), Tt.setAttribute("fill", "#ffffff"), Tt.setAttribute("width", this.element.comp.data.w || 0), Tt.setAttribute("height", this.element.comp.data.h || 0), Xe.push(Tt)) : Tt = null, Ue = createNS("path"), qe[Re].mode === "n")
          this.viewData[Re] = {
            op: PropertyFactory.getProp(this.element, qe[Re].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, qe[Re], 3),
            elem: Ue,
            lastPath: ""
          }, we.appendChild(Ue);
        else {
          Ge += 1, Ue.setAttribute("fill", qe[Re].mode === "s" ? "#000000" : "#ffffff"), Ue.setAttribute("clip-rule", "nonzero");
          var Ot;
          if (qe[Re].x.k !== 0 ? (Pt = "mask", kt = "mask", It = PropertyFactory.getProp(this.element, qe[Re].x, 0, null, this.element), Ot = createElementID(), wt = createNS("filter"), wt.setAttribute("id", Ot), St = createNS("feMorphology"), St.setAttribute("operator", "erode"), St.setAttribute("in", "SourceGraphic"), St.setAttribute("radius", "0"), wt.appendChild(St), we.appendChild(wt), Ue.setAttribute("stroke", qe[Re].mode === "s" ? "#000000" : "#ffffff")) : (St = null, It = null), this.storedData[Re] = {
            elem: Ue,
            x: It,
            expan: St,
            lastPath: "",
            lastOperator: "",
            filterId: Ot,
            lastRadius: 0
          }, qe[Re].mode === "i") {
            vt = Xe.length;
            var Jr = createNS("g");
            for (ot = 0; ot < vt; ot += 1)
              Jr.appendChild(Xe[ot]);
            var en = createNS("mask");
            en.setAttribute("mask-type", "alpha"), en.setAttribute("id", bt + "_" + Ge), en.appendChild(Ue), we.appendChild(en), Jr.setAttribute("mask", "url(" + getLocationHref() + "#" + bt + "_" + Ge + ")"), Xe.length = 0, Xe.push(Jr);
          } else
            Xe.push(Ue);
          qe[Re].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[Re] = {
            elem: Ue,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, qe[Re].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, qe[Re], 3),
            invRect: Tt
          }, this.viewData[Re].prop.k || this.drawPath(qe[Re], this.viewData[Re].prop.v, this.viewData[Re]);
        }
      for (this.maskElement = createNS(Pt), je = Xe.length, Re = 0; Re < je; Re += 1)
        this.maskElement.appendChild(Xe[Re]);
      Ge > 0 && (this.maskElement.setAttribute("id", bt), this.element.maskedElement.setAttribute(kt, "url(" + getLocationHref() + "#" + bt + ")"), we.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(ce) {
      return this.viewData[ce].prop;
    }, MaskElement.prototype.renderFrame = function(ce) {
      var ie = this.element.finalTransform.mat, me, we = this.masksProperties.length;
      for (me = 0; me < we; me += 1)
        if ((this.viewData[me].prop._mdf || ce) && this.drawPath(this.masksProperties[me], this.viewData[me].prop.v, this.viewData[me]), (this.viewData[me].op._mdf || ce) && this.viewData[me].elem.setAttribute("fill-opacity", this.viewData[me].op.v), this.masksProperties[me].mode !== "n" && (this.viewData[me].invRect && (this.element.finalTransform.mProp._mdf || ce) && this.viewData[me].invRect.setAttribute("transform", ie.getInverseMatrix().to2dCSS()), this.storedData[me].x && (this.storedData[me].x._mdf || ce))) {
          var Re = this.storedData[me].expan;
          this.storedData[me].x.v < 0 ? (this.storedData[me].lastOperator !== "erode" && (this.storedData[me].lastOperator = "erode", this.storedData[me].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[me].filterId + ")")), Re.setAttribute("radius", -this.storedData[me].x.v)) : (this.storedData[me].lastOperator !== "dilate" && (this.storedData[me].lastOperator = "dilate", this.storedData[me].elem.setAttribute("filter", null)), this.storedData[me].elem.setAttribute("stroke-width", this.storedData[me].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var ce = "M0,0 ";
      return ce += " h" + this.globalData.compSize.w, ce += " v" + this.globalData.compSize.h, ce += " h-" + this.globalData.compSize.w, ce += " v-" + this.globalData.compSize.h + " ", ce;
    }, MaskElement.prototype.drawPath = function(ce, ie, me) {
      var we = " M" + ie.v[0][0] + "," + ie.v[0][1], Re, je;
      for (je = ie._length, Re = 1; Re < je; Re += 1)
        we += " C" + ie.o[Re - 1][0] + "," + ie.o[Re - 1][1] + " " + ie.i[Re][0] + "," + ie.i[Re][1] + " " + ie.v[Re][0] + "," + ie.v[Re][1];
      if (ie.c && je > 1 && (we += " C" + ie.o[Re - 1][0] + "," + ie.o[Re - 1][1] + " " + ie.i[0][0] + "," + ie.i[0][1] + " " + ie.v[0][0] + "," + ie.v[0][1]), me.lastPath !== we) {
        var Ue = "";
        me.elem && (ie.c && (Ue = ce.inv ? this.solidPath + we : we), me.elem.setAttribute("d", Ue)), me.lastPath = we;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var ce = {};
      ce.createFilter = ie, ce.createAlphaToLuminanceFilter = me;
      function ie(we, Re) {
        var je = createNS("filter");
        return je.setAttribute("id", we), Re !== !0 && (je.setAttribute("filterUnits", "objectBoundingBox"), je.setAttribute("x", "0%"), je.setAttribute("y", "0%"), je.setAttribute("width", "100%"), je.setAttribute("height", "100%")), je;
      }
      function me() {
        var we = createNS("feColorMatrix");
        return we.setAttribute("type", "matrix"), we.setAttribute("color-interpolation-filters", "sRGB"), we.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), we;
      }
      return ce;
    }(), featureSupport = function() {
      var ce = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (ce.maskType = !1), /firefox/i.test(navigator.userAgent) && (ce.svgLumaHidden = !1), ce;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(ce) {
      var ie, me = "SourceGraphic", we = ce.data.ef ? ce.data.ef.length : 0, Re = createElementID(), je = filtersFactory.createFilter(Re, !0), Ue = 0;
      this.filters = [];
      var qe;
      for (ie = 0; ie < we; ie += 1) {
        qe = null;
        var Ge = ce.data.ef[ie].ty;
        if (registeredEffects$1[Ge]) {
          var Xe = registeredEffects$1[Ge].effect;
          qe = new Xe(je, ce.effectsManager.effectElements[ie], ce, idPrefix + Ue, me), me = idPrefix + Ue, registeredEffects$1[Ge].countsAsEffect && (Ue += 1);
        }
        qe && this.filters.push(qe);
      }
      Ue && (ce.globalData.defs.appendChild(je), ce.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + Re + ")")), this.filters.length && ce.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(ce) {
      var ie, me = this.filters.length;
      for (ie = 0; ie < me; ie += 1)
        this.filters[ie].renderFrame(ce);
    }, SVGEffects.prototype.getEffects = function(ce) {
      var ie, me = this.filters.length, we = [];
      for (ie = 0; ie < me; ie += 1)
        this.filters[ie].type === ce && we.push(this.filters[ie]);
      return we;
    };
    function registerEffect$1(ce, ie, me) {
      registeredEffects$1[ce] = {
        effect: ie,
        countsAsEffect: me
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var ie = null;
        if (this.data.td) {
          this.matteMasks = {};
          var me = createNS("g");
          me.setAttribute("id", this.layerId), me.appendChild(this.layerElement), ie = me, this.globalData.defs.appendChild(me);
        } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), ie = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var we = createNS("clipPath"), Re = createNS("path");
          Re.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var je = createElementID();
          if (we.setAttribute("id", je), we.appendChild(Re), this.globalData.defs.appendChild(we), this.checkMasks()) {
            var Ue = createNS("g");
            Ue.setAttribute("clip-path", "url(" + getLocationHref() + "#" + je + ")"), Ue.appendChild(this.layerElement), this.transformedElement = Ue, ie ? ie.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + je + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(ie) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[ie]) {
          var me = this.layerId + "_" + ie, we, Re, je, Ue;
          if (ie === 1 || ie === 3) {
            var qe = createNS("mask");
            qe.setAttribute("id", me), qe.setAttribute("mask-type", ie === 3 ? "luminance" : "alpha"), je = createNS("use"), je.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), qe.appendChild(je), this.globalData.defs.appendChild(qe), !featureSupport.maskType && ie === 1 && (qe.setAttribute("mask-type", "luminance"), we = createElementID(), Re = filtersFactory.createFilter(we), this.globalData.defs.appendChild(Re), Re.appendChild(filtersFactory.createAlphaToLuminanceFilter()), Ue = createNS("g"), Ue.appendChild(je), qe.appendChild(Ue), Ue.setAttribute("filter", "url(" + getLocationHref() + "#" + we + ")"));
          } else if (ie === 2) {
            var Ge = createNS("mask");
            Ge.setAttribute("id", me), Ge.setAttribute("mask-type", "alpha");
            var Xe = createNS("g");
            Ge.appendChild(Xe), we = createElementID(), Re = filtersFactory.createFilter(we);
            var ot = createNS("feComponentTransfer");
            ot.setAttribute("in", "SourceGraphic"), Re.appendChild(ot);
            var vt = createNS("feFuncA");
            vt.setAttribute("type", "table"), vt.setAttribute("tableValues", "1.0 0.0"), ot.appendChild(vt), this.globalData.defs.appendChild(Re);
            var bt = createNS("rect");
            bt.setAttribute("width", this.comp.data.w), bt.setAttribute("height", this.comp.data.h), bt.setAttribute("x", "0"), bt.setAttribute("y", "0"), bt.setAttribute("fill", "#ffffff"), bt.setAttribute("opacity", "0"), Xe.setAttribute("filter", "url(" + getLocationHref() + "#" + we + ")"), Xe.appendChild(bt), je = createNS("use"), je.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), Xe.appendChild(je), featureSupport.maskType || (Ge.setAttribute("mask-type", "luminance"), Re.appendChild(filtersFactory.createAlphaToLuminanceFilter()), Ue = createNS("g"), Xe.appendChild(bt), Ue.appendChild(this.layerElement), Xe.appendChild(Ue)), this.globalData.defs.appendChild(Ge);
          }
          this.matteMasks[ie] = me;
        }
        return this.matteMasks[ie];
      },
      setMatte: function(ie) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + ie + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(ie) {
        this.hierarchy = ie;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var ce = {
        initElement: function(me, we, Re) {
          this.initFrame(), this.initBaseData(me, we, Re), this.initTransform(me, we, Re), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var me = this.baseElement || this.layerElement;
            me.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var me = this.baseElement || this.layerElement;
              me.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(me) {
          this._mdf = !1, this.prepareRenderableFrame(me), this.prepareProperties(me, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(ce)], RenderableDOMElement);
    })();
    function IImageElement(ce, ie, me) {
      this.assetData = ie.getAssetData(ce.refId), this.assetData && this.assetData.sid && (this.assetData = ie.slotManager.getProp(this.assetData)), this.initElement(ce, ie, me), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var ce = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", ce), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(ce, ie) {
      this.elem = ce, this.pos = ie;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(ie) {
        var me, we = this.shapeModifiers.length;
        for (me = 0; me < we; me += 1)
          this.shapeModifiers[me].addShape(ie);
      },
      isShapeInAnimatedModifiers: function(ie) {
        for (var me = 0, we = this.shapeModifiers.length; me < we; )
          if (this.shapeModifiers[me].isAnimatedWithShape(ie))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var ie, me = this.shapes.length;
          for (ie = 0; ie < me; ie += 1)
            this.shapes[ie].sh.reset();
          me = this.shapeModifiers.length;
          var we;
          for (ie = me - 1; ie >= 0 && (we = this.shapeModifiers[ie].processShapes(this._isFirstFrame), !we); ie -= 1)
            ;
        }
      },
      searchProcessedElement: function(ie) {
        for (var me = this.processedElements, we = 0, Re = me.length; we < Re; ) {
          if (me[we].elem === ie)
            return me[we].pos;
          we += 1;
        }
        return 0;
      },
      addProcessedElement: function(ie, me) {
        for (var we = this.processedElements, Re = we.length; Re; )
          if (Re -= 1, we[Re].elem === ie) {
            we[Re].pos = me;
            return;
          }
        we.push(new ProcessedElement(ie, me));
      },
      prepareFrame: function(ie) {
        this.prepareRenderableFrame(ie), this.prepareProperties(ie, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(ce, ie, me) {
      this.caches = [], this.styles = [], this.transformers = ce, this.lStr = "", this.sh = me, this.lvl = ie, this._isAnimated = !!me.k;
      for (var we = 0, Re = ce.length; we < Re; ) {
        if (ce[we].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        we += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(ce, ie) {
      this.data = ce, this.type = ce.ty, this.d = "", this.lvl = ie, this._mdf = !1, this.closed = ce.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(ce, ie, me, we) {
      this.elem = ce, this.frameId = -1, this.dataProps = createSizedArray(ie.length), this.renderer = me, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", ie.length ? ie.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(we);
      var Re, je = ie.length || 0, Ue;
      for (Re = 0; Re < je; Re += 1)
        Ue = PropertyFactory.getProp(ce, ie[Re].v, 0, 0, this), this.k = Ue.k || this.k, this.dataProps[Re] = {
          n: ie[Re].n,
          p: Ue
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(ce) {
      if (!(this.elem.globalData.frameId === this.frameId && !ce) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || ce, this._mdf)) {
        var ie = 0, me = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), ie = 0; ie < me; ie += 1)
          this.dataProps[ie].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[ie].p.v : this.dashArray[ie] = this.dataProps[ie].p.v : this.dashoffset[0] = this.dataProps[ie].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(ce, ie, me) {
      this.initDynamicPropertyContainer(ce), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(ce, ie.o, 0, 0.01, this), this.w = PropertyFactory.getProp(ce, ie.w, 0, null, this), this.d = new DashProperty(ce, ie.d || {}, "svg", this), this.c = PropertyFactory.getProp(ce, ie.c, 1, 255, this), this.style = me, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(ce, ie, me) {
      this.initDynamicPropertyContainer(ce), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(ce, ie.o, 0, 0.01, this), this.c = PropertyFactory.getProp(ce, ie.c, 1, 255, this), this.style = me;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(ce, ie, me) {
      this.initDynamicPropertyContainer(ce), this.getValue = this.iterateDynamicProperties, this.style = me;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(ce, ie, me) {
      this.data = ie, this.c = createTypedArray("uint8c", ie.p * 4);
      var we = ie.k.k[0].s ? ie.k.k[0].s.length - ie.p * 4 : ie.k.k.length - ie.p * 4;
      this.o = createTypedArray("float32", we), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = we, this.initDynamicPropertyContainer(me), this.prop = PropertyFactory.getProp(ce, ie.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(ce, ie) {
      for (var me = 0, we = this.o.length / 2, Re; me < we; ) {
        if (Re = Math.abs(ce[me * 4] - ce[ie * 4 + me * 2]), Re > 0.01)
          return !1;
        me += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var ce = 0, ie = this.data.k.k.length; ce < ie; ) {
          if (!this.comparePoints(this.data.k.k[ce].s, this.data.p))
            return !1;
          ce += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(ce) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || ce) {
        var ie, me = this.data.p * 4, we, Re;
        for (ie = 0; ie < me; ie += 1)
          we = ie % 4 === 0 ? 100 : 255, Re = Math.round(this.prop.v[ie] * we), this.c[ie] !== Re && (this.c[ie] = Re, this._cmdf = !ce);
        if (this.o.length)
          for (me = this.prop.v.length, ie = this.data.p * 4; ie < me; ie += 1)
            we = ie % 2 === 0 ? 100 : 1, Re = ie % 2 === 0 ? Math.round(this.prop.v[ie] * 100) : this.prop.v[ie], this.o[ie - this.data.p * 4] !== Re && (this.o[ie - this.data.p * 4] = Re, this._omdf = !ce);
        this._mdf = !ce;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(ce, ie, me) {
      this.initDynamicPropertyContainer(ce), this.getValue = this.iterateDynamicProperties, this.initGradientData(ce, ie, me);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(ce, ie, me) {
      this.o = PropertyFactory.getProp(ce, ie.o, 0, 0.01, this), this.s = PropertyFactory.getProp(ce, ie.s, 1, null, this), this.e = PropertyFactory.getProp(ce, ie.e, 1, null, this), this.h = PropertyFactory.getProp(ce, ie.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(ce, ie.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(ce, ie.g, this), this.style = me, this.stops = [], this.setGradientData(me.pElem, ie), this.setGradientOpacity(ie, me), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(ce, ie) {
      var me = createElementID(), we = createNS(ie.t === 1 ? "linearGradient" : "radialGradient");
      we.setAttribute("id", me), we.setAttribute("spreadMethod", "pad"), we.setAttribute("gradientUnits", "userSpaceOnUse");
      var Re = [], je, Ue, qe;
      for (qe = ie.g.p * 4, Ue = 0; Ue < qe; Ue += 4)
        je = createNS("stop"), we.appendChild(je), Re.push(je);
      ce.setAttribute(ie.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + me + ")"), this.gf = we, this.cst = Re;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(ce, ie) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var me, we, Re, je = createNS("mask"), Ue = createNS("path");
        je.appendChild(Ue);
        var qe = createElementID(), Ge = createElementID();
        je.setAttribute("id", Ge);
        var Xe = createNS(ce.t === 1 ? "linearGradient" : "radialGradient");
        Xe.setAttribute("id", qe), Xe.setAttribute("spreadMethod", "pad"), Xe.setAttribute("gradientUnits", "userSpaceOnUse"), Re = ce.g.k.k[0].s ? ce.g.k.k[0].s.length : ce.g.k.k.length;
        var ot = this.stops;
        for (we = ce.g.p * 4; we < Re; we += 2)
          me = createNS("stop"), me.setAttribute("stop-color", "rgb(255,255,255)"), Xe.appendChild(me), ot.push(me);
        Ue.setAttribute(ce.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + qe + ")"), ce.ty === "gs" && (Ue.setAttribute("stroke-linecap", lineCapEnum[ce.lc || 2]), Ue.setAttribute("stroke-linejoin", lineJoinEnum[ce.lj || 2]), ce.lj === 1 && Ue.setAttribute("stroke-miterlimit", ce.ml)), this.of = Xe, this.ms = je, this.ost = ot, this.maskId = Ge, ie.msElem = Ue;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(ce, ie, me) {
      this.initDynamicPropertyContainer(ce), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(ce, ie.w, 0, null, this), this.d = new DashProperty(ce, ie.d || {}, "svg", this), this.initGradientData(ce, ie, me), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(ce, ie, me) {
      this.transform = {
        mProps: ce,
        op: ie,
        container: me
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(ie, me, we, Re) {
      if (me === 0)
        return "";
      var je = ie.o, Ue = ie.i, qe = ie.v, Ge, Xe = " M" + Re.applyToPointStringified(qe[0][0], qe[0][1]);
      for (Ge = 1; Ge < me; Ge += 1)
        Xe += " C" + Re.applyToPointStringified(je[Ge - 1][0], je[Ge - 1][1]) + " " + Re.applyToPointStringified(Ue[Ge][0], Ue[Ge][1]) + " " + Re.applyToPointStringified(qe[Ge][0], qe[Ge][1]);
      return we && me && (Xe += " C" + Re.applyToPointStringified(je[Ge - 1][0], je[Ge - 1][1]) + " " + Re.applyToPointStringified(Ue[0][0], Ue[0][1]) + " " + Re.applyToPointStringified(qe[0][0], qe[0][1]), Xe += "z"), Xe;
    }, SVGElementsRenderer = function() {
      var ce = new Matrix(), ie = new Matrix(), me = {
        createRenderFunction: we
      };
      function we(vt) {
        switch (vt.ty) {
          case "fl":
            return qe;
          case "gf":
            return Xe;
          case "gs":
            return Ge;
          case "st":
            return ot;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return Ue;
          case "tr":
            return Re;
          case "no":
            return je;
          default:
            return null;
        }
      }
      function Re(vt, bt, Tt) {
        (Tt || bt.transform.op._mdf) && bt.transform.container.setAttribute("opacity", bt.transform.op.v), (Tt || bt.transform.mProps._mdf) && bt.transform.container.setAttribute("transform", bt.transform.mProps.v.to2dCSS());
      }
      function je() {
      }
      function Ue(vt, bt, Tt) {
        var wt, St, It, Pt, kt, Ot, Jr = bt.styles.length, en = bt.lvl, nn, ln, fn, vn;
        for (Ot = 0; Ot < Jr; Ot += 1) {
          if (Pt = bt.sh._mdf || Tt, bt.styles[Ot].lvl < en) {
            for (ln = ie.reset(), fn = en - bt.styles[Ot].lvl, vn = bt.transformers.length - 1; !Pt && fn > 0; )
              Pt = bt.transformers[vn].mProps._mdf || Pt, fn -= 1, vn -= 1;
            if (Pt)
              for (fn = en - bt.styles[Ot].lvl, vn = bt.transformers.length - 1; fn > 0; )
                ln.multiply(bt.transformers[vn].mProps.v), fn -= 1, vn -= 1;
          } else
            ln = ce;
          if (nn = bt.sh.paths, St = nn._length, Pt) {
            for (It = "", wt = 0; wt < St; wt += 1)
              kt = nn.shapes[wt], kt && kt._length && (It += buildShapeString(kt, kt._length, kt.c, ln));
            bt.caches[Ot] = It;
          } else
            It = bt.caches[Ot];
          bt.styles[Ot].d += vt.hd === !0 ? "" : It, bt.styles[Ot]._mdf = Pt || bt.styles[Ot]._mdf;
        }
      }
      function qe(vt, bt, Tt) {
        var wt = bt.style;
        (bt.c._mdf || Tt) && wt.pElem.setAttribute("fill", "rgb(" + bmFloor(bt.c.v[0]) + "," + bmFloor(bt.c.v[1]) + "," + bmFloor(bt.c.v[2]) + ")"), (bt.o._mdf || Tt) && wt.pElem.setAttribute("fill-opacity", bt.o.v);
      }
      function Ge(vt, bt, Tt) {
        Xe(vt, bt, Tt), ot(vt, bt, Tt);
      }
      function Xe(vt, bt, Tt) {
        var wt = bt.gf, St = bt.g._hasOpacity, It = bt.s.v, Pt = bt.e.v;
        if (bt.o._mdf || Tt) {
          var kt = vt.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          bt.style.pElem.setAttribute(kt, bt.o.v);
        }
        if (bt.s._mdf || Tt) {
          var Ot = vt.t === 1 ? "x1" : "cx", Jr = Ot === "x1" ? "y1" : "cy";
          wt.setAttribute(Ot, It[0]), wt.setAttribute(Jr, It[1]), St && !bt.g._collapsable && (bt.of.setAttribute(Ot, It[0]), bt.of.setAttribute(Jr, It[1]));
        }
        var en, nn, ln, fn;
        if (bt.g._cmdf || Tt) {
          en = bt.cst;
          var vn = bt.g.c;
          for (ln = en.length, nn = 0; nn < ln; nn += 1)
            fn = en[nn], fn.setAttribute("offset", vn[nn * 4] + "%"), fn.setAttribute("stop-color", "rgb(" + vn[nn * 4 + 1] + "," + vn[nn * 4 + 2] + "," + vn[nn * 4 + 3] + ")");
        }
        if (St && (bt.g._omdf || Tt)) {
          var Tn = bt.g.o;
          for (bt.g._collapsable ? en = bt.cst : en = bt.ost, ln = en.length, nn = 0; nn < ln; nn += 1)
            fn = en[nn], bt.g._collapsable || fn.setAttribute("offset", Tn[nn * 2] + "%"), fn.setAttribute("stop-opacity", Tn[nn * 2 + 1]);
        }
        if (vt.t === 1)
          (bt.e._mdf || Tt) && (wt.setAttribute("x2", Pt[0]), wt.setAttribute("y2", Pt[1]), St && !bt.g._collapsable && (bt.of.setAttribute("x2", Pt[0]), bt.of.setAttribute("y2", Pt[1])));
        else {
          var xn;
          if ((bt.s._mdf || bt.e._mdf || Tt) && (xn = Math.sqrt(Math.pow(It[0] - Pt[0], 2) + Math.pow(It[1] - Pt[1], 2)), wt.setAttribute("r", xn), St && !bt.g._collapsable && bt.of.setAttribute("r", xn)), bt.e._mdf || bt.h._mdf || bt.a._mdf || Tt) {
            xn || (xn = Math.sqrt(Math.pow(It[0] - Pt[0], 2) + Math.pow(It[1] - Pt[1], 2)));
            var bn = Math.atan2(Pt[1] - It[1], Pt[0] - It[0]), Sn = bt.h.v;
            Sn >= 1 ? Sn = 0.99 : Sn <= -1 && (Sn = -0.99);
            var Cn = xn * Sn, kn = Math.cos(bn + bt.a.v) * Cn + It[0], cn = Math.sin(bn + bt.a.v) * Cn + It[1];
            wt.setAttribute("fx", kn), wt.setAttribute("fy", cn), St && !bt.g._collapsable && (bt.of.setAttribute("fx", kn), bt.of.setAttribute("fy", cn));
          }
        }
      }
      function ot(vt, bt, Tt) {
        var wt = bt.style, St = bt.d;
        St && (St._mdf || Tt) && St.dashStr && (wt.pElem.setAttribute("stroke-dasharray", St.dashStr), wt.pElem.setAttribute("stroke-dashoffset", St.dashoffset[0])), bt.c && (bt.c._mdf || Tt) && wt.pElem.setAttribute("stroke", "rgb(" + bmFloor(bt.c.v[0]) + "," + bmFloor(bt.c.v[1]) + "," + bmFloor(bt.c.v[2]) + ")"), (bt.o._mdf || Tt) && wt.pElem.setAttribute("stroke-opacity", bt.o.v), (bt.w._mdf || Tt) && (wt.pElem.setAttribute("stroke-width", bt.w.v), wt.msElem && wt.msElem.setAttribute("stroke-width", bt.w.v));
      }
      return me;
    }();
    function SVGShapeElement(ce, ie, me) {
      this.shapes = [], this.shapesData = ce.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(ce, ie, me), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var ce, ie = this.shapes.length, me, we, Re = this.stylesList.length, je, Ue = [], qe = !1;
      for (we = 0; we < Re; we += 1) {
        for (je = this.stylesList[we], qe = !1, Ue.length = 0, ce = 0; ce < ie; ce += 1)
          me = this.shapes[ce], me.styles.indexOf(je) !== -1 && (Ue.push(me), qe = me._isAnimated || qe);
        Ue.length > 1 && qe && this.setShapesAsAnimated(Ue);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(ce) {
      var ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        ce[ie].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(ce, ie) {
      var me, we = new SVGStyleData(ce, ie), Re = we.pElem;
      if (ce.ty === "st")
        me = new SVGStrokeStyleData(this, ce, we);
      else if (ce.ty === "fl")
        me = new SVGFillStyleData(this, ce, we);
      else if (ce.ty === "gf" || ce.ty === "gs") {
        var je = ce.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        me = new je(this, ce, we), this.globalData.defs.appendChild(me.gf), me.maskId && (this.globalData.defs.appendChild(me.ms), this.globalData.defs.appendChild(me.of), Re.setAttribute("mask", "url(" + getLocationHref() + "#" + me.maskId + ")"));
      } else ce.ty === "no" && (me = new SVGNoStyleData(this, ce, we));
      return (ce.ty === "st" || ce.ty === "gs") && (Re.setAttribute("stroke-linecap", lineCapEnum[ce.lc || 2]), Re.setAttribute("stroke-linejoin", lineJoinEnum[ce.lj || 2]), Re.setAttribute("fill-opacity", "0"), ce.lj === 1 && Re.setAttribute("stroke-miterlimit", ce.ml)), ce.r === 2 && Re.setAttribute("fill-rule", "evenodd"), ce.ln && Re.setAttribute("id", ce.ln), ce.cl && Re.setAttribute("class", ce.cl), ce.bm && (Re.style["mix-blend-mode"] = getBlendMode(ce.bm)), this.stylesList.push(we), this.addToAnimatedContents(ce, me), me;
    }, SVGShapeElement.prototype.createGroupElement = function(ce) {
      var ie = new ShapeGroupData();
      return ce.ln && ie.gr.setAttribute("id", ce.ln), ce.cl && ie.gr.setAttribute("class", ce.cl), ce.bm && (ie.gr.style["mix-blend-mode"] = getBlendMode(ce.bm)), ie;
    }, SVGShapeElement.prototype.createTransformElement = function(ce, ie) {
      var me = TransformPropertyFactory.getTransformProperty(this, ce, this), we = new SVGTransformData(me, me.o, ie);
      return this.addToAnimatedContents(ce, we), we;
    }, SVGShapeElement.prototype.createShapeElement = function(ce, ie, me) {
      var we = 4;
      ce.ty === "rc" ? we = 5 : ce.ty === "el" ? we = 6 : ce.ty === "sr" && (we = 7);
      var Re = ShapePropertyFactory.getShapeProp(this, ce, we, this), je = new SVGShapeData(ie, me, Re);
      return this.shapes.push(je), this.addShapeToModifiers(je), this.addToAnimatedContents(ce, je), je;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(ce, ie) {
      for (var me = 0, we = this.animatedContents.length; me < we; ) {
        if (this.animatedContents[me].element === ie)
          return;
        me += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(ce),
        element: ie,
        data: ce
      });
    }, SVGShapeElement.prototype.setElementStyles = function(ce) {
      var ie = ce.styles, me, we = this.stylesList.length;
      for (me = 0; me < we; me += 1)
        this.stylesList[me].closed || ie.push(this.stylesList[me]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var ce, ie = this.itemsData.length;
      for (ce = 0; ce < ie; ce += 1)
        this.prevViewData[ce] = this.itemsData[ce];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), ie = this.dynamicProperties.length, ce = 0; ce < ie; ce += 1)
        this.dynamicProperties[ce].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(ce, ie, me, we, Re, je, Ue) {
      var qe = [].concat(je), Ge, Xe = ce.length - 1, ot, vt, bt = [], Tt = [], wt, St, It;
      for (Ge = Xe; Ge >= 0; Ge -= 1) {
        if (It = this.searchProcessedElement(ce[Ge]), It ? ie[Ge] = me[It - 1] : ce[Ge]._render = Ue, ce[Ge].ty === "fl" || ce[Ge].ty === "st" || ce[Ge].ty === "gf" || ce[Ge].ty === "gs" || ce[Ge].ty === "no")
          It ? ie[Ge].style.closed = !1 : ie[Ge] = this.createStyleElement(ce[Ge], Re), ce[Ge]._render && ie[Ge].style.pElem.parentNode !== we && we.appendChild(ie[Ge].style.pElem), bt.push(ie[Ge].style);
        else if (ce[Ge].ty === "gr") {
          if (!It)
            ie[Ge] = this.createGroupElement(ce[Ge]);
          else
            for (vt = ie[Ge].it.length, ot = 0; ot < vt; ot += 1)
              ie[Ge].prevViewData[ot] = ie[Ge].it[ot];
          this.searchShapes(ce[Ge].it, ie[Ge].it, ie[Ge].prevViewData, ie[Ge].gr, Re + 1, qe, Ue), ce[Ge]._render && ie[Ge].gr.parentNode !== we && we.appendChild(ie[Ge].gr);
        } else ce[Ge].ty === "tr" ? (It || (ie[Ge] = this.createTransformElement(ce[Ge], we)), wt = ie[Ge].transform, qe.push(wt)) : ce[Ge].ty === "sh" || ce[Ge].ty === "rc" || ce[Ge].ty === "el" || ce[Ge].ty === "sr" ? (It || (ie[Ge] = this.createShapeElement(ce[Ge], qe, Re)), this.setElementStyles(ie[Ge])) : ce[Ge].ty === "tm" || ce[Ge].ty === "rd" || ce[Ge].ty === "ms" || ce[Ge].ty === "pb" || ce[Ge].ty === "zz" || ce[Ge].ty === "op" ? (It ? (St = ie[Ge], St.closed = !1) : (St = ShapeModifiers.getModifier(ce[Ge].ty), St.init(this, ce[Ge]), ie[Ge] = St, this.shapeModifiers.push(St)), Tt.push(St)) : ce[Ge].ty === "rp" && (It ? (St = ie[Ge], St.closed = !0) : (St = ShapeModifiers.getModifier(ce[Ge].ty), ie[Ge] = St, St.init(this, ce, Ge, ie), this.shapeModifiers.push(St), Ue = !1), Tt.push(St));
        this.addProcessedElement(ce[Ge], Ge + 1);
      }
      for (Xe = bt.length, Ge = 0; Ge < Xe; Ge += 1)
        bt[Ge].closed = !0;
      for (Xe = Tt.length, Ge = 0; Ge < Xe; Ge += 1)
        Tt[Ge].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var ce, ie = this.stylesList.length;
      for (ce = 0; ce < ie; ce += 1)
        this.stylesList[ce].reset();
      for (this.renderShape(), ce = 0; ce < ie; ce += 1)
        (this.stylesList[ce]._mdf || this._isFirstFrame) && (this.stylesList[ce].msElem && (this.stylesList[ce].msElem.setAttribute("d", this.stylesList[ce].d), this.stylesList[ce].d = "M0 0" + this.stylesList[ce].d), this.stylesList[ce].pElem.setAttribute("d", this.stylesList[ce].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var ce, ie = this.animatedContents.length, me;
      for (ce = 0; ce < ie; ce += 1)
        me = this.animatedContents[ce], (this._isFirstFrame || me.element._isAnimated) && me.data !== !0 && me.fn(me.data, me.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(ce, ie, me, we, Re, je) {
      this.o = ce, this.sw = ie, this.sc = me, this.fc = we, this.m = Re, this.p = je, this._mdf = {
        o: !0,
        sw: !!ie,
        sc: !!me,
        fc: !!we,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(ce, ie, me, we, Re, je) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var Ue = !1;
      return this.o !== ce && (this.o = ce, this._mdf.o = !0, Ue = !0), this.sw !== ie && (this.sw = ie, this._mdf.sw = !0, Ue = !0), this.sc !== me && (this.sc = me, this._mdf.sc = !0, Ue = !0), this.fc !== we && (this.fc = we, this._mdf.fc = !0, Ue = !0), this.m !== Re && (this.m = Re, this._mdf.m = !0, Ue = !0), je.length && (this.p[0] !== je[0] || this.p[1] !== je[1] || this.p[4] !== je[4] || this.p[5] !== je[5] || this.p[12] !== je[12] || this.p[13] !== je[13]) && (this.p = je, this._mdf.p = !0, Ue = !0), Ue;
    };
    function TextProperty(ce, ie) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, ie.d && ie.d.sid && (ie.d = ce.globalData.slotManager.getProp(ie.d)), this.data = ie, this.elem = ce, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(ce, ie) {
      for (var me in ie)
        Object.prototype.hasOwnProperty.call(ie, me) && (ce[me] = ie[me]);
      return ce;
    }, TextProperty.prototype.setCurrentData = function(ce) {
      ce.__complete || this.completeTextData(ce), this.currentData = ce, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(ce) {
      this.effectsSequence.push(ce), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(ce) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !ce)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var ie = this.currentData, me = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var we, Re = this.effectsSequence.length, je = ce || this.data.d.k[this.keysIndex].s;
        for (we = 0; we < Re; we += 1)
          me !== this.keysIndex ? je = this.effectsSequence[we](je, je.t) : je = this.effectsSequence[we](this.currentData, je.t);
        ie !== je && this.setCurrentData(je), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var ce = this.data.d.k, ie = this.elem.comp.renderedFrame, me = 0, we = ce.length; me <= we - 1 && !(me === we - 1 || ce[me + 1].t > ie); )
        me += 1;
      return this.keysIndex !== me && (this.keysIndex = me), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(ce) {
      for (var ie = [], me = 0, we = ce.length, Re, je, Ue = !1, qe = !1, Ge = ""; me < we; )
        Ue = qe, qe = !1, Re = ce.charCodeAt(me), Ge = ce.charAt(me), FontManager.isCombinedCharacter(Re) ? Ue = !0 : Re >= 55296 && Re <= 56319 ? FontManager.isRegionalFlag(ce, me) ? Ge = ce.substr(me, 14) : (je = ce.charCodeAt(me + 1), je >= 56320 && je <= 57343 && (FontManager.isModifier(Re, je) ? (Ge = ce.substr(me, 2), Ue = !0) : FontManager.isFlagEmoji(ce.substr(me, 4)) ? Ge = ce.substr(me, 4) : Ge = ce.substr(me, 2))) : Re > 56319 ? (je = ce.charCodeAt(me + 1), FontManager.isVariationSelector(Re) && (Ue = !0)) : FontManager.isZeroWidthJoiner(Re) && (Ue = !0, qe = !0), Ue ? (ie[ie.length - 1] += Ge, Ue = !1) : ie.push(Ge), me += Ge.length;
      return ie;
    }, TextProperty.prototype.completeTextData = function(ce) {
      ce.__complete = !0;
      var ie = this.elem.globalData.fontManager, me = this.data, we = [], Re, je, Ue, qe = 0, Ge, Xe = me.m.g, ot = 0, vt = 0, bt = 0, Tt = [], wt = 0, St = 0, It, Pt, kt = ie.getFontByName(ce.f), Ot, Jr = 0, en = getFontProperties(kt);
      ce.fWeight = en.weight, ce.fStyle = en.style, ce.finalSize = ce.s, ce.finalText = this.buildFinalText(ce.t), je = ce.finalText.length, ce.finalLineHeight = ce.lh;
      var nn = ce.tr / 1e3 * ce.finalSize, ln;
      if (ce.sz)
        for (var fn = !0, vn = ce.sz[0], Tn = ce.sz[1], xn, bn; fn; ) {
          bn = this.buildFinalText(ce.t), xn = 0, wt = 0, je = bn.length, nn = ce.tr / 1e3 * ce.finalSize;
          var Sn = -1;
          for (Re = 0; Re < je; Re += 1)
            ln = bn[Re].charCodeAt(0), Ue = !1, bn[Re] === " " ? Sn = Re : (ln === 13 || ln === 3) && (wt = 0, Ue = !0, xn += ce.finalLineHeight || ce.finalSize * 1.2), ie.chars ? (Ot = ie.getCharData(bn[Re], kt.fStyle, kt.fFamily), Jr = Ue ? 0 : Ot.w * ce.finalSize / 100) : Jr = ie.measureText(bn[Re], ce.f, ce.finalSize), wt + Jr > vn && bn[Re] !== " " ? (Sn === -1 ? je += 1 : Re = Sn, xn += ce.finalLineHeight || ce.finalSize * 1.2, bn.splice(Re, Sn === Re ? 1 : 0, "\r"), Sn = -1, wt = 0) : (wt += Jr, wt += nn);
          xn += kt.ascent * ce.finalSize / 100, this.canResize && ce.finalSize > this.minimumFontSize && Tn < xn ? (ce.finalSize -= 1, ce.finalLineHeight = ce.finalSize * ce.lh / ce.s) : (ce.finalText = bn, je = ce.finalText.length, fn = !1);
        }
      wt = -nn, Jr = 0;
      var Cn = 0, kn;
      for (Re = 0; Re < je; Re += 1)
        if (Ue = !1, kn = ce.finalText[Re], ln = kn.charCodeAt(0), ln === 13 || ln === 3 ? (Cn = 0, Tt.push(wt), St = wt > St ? wt : St, wt = -2 * nn, Ge = "", Ue = !0, bt += 1) : Ge = kn, ie.chars ? (Ot = ie.getCharData(kn, kt.fStyle, ie.getFontByName(ce.f).fFamily), Jr = Ue ? 0 : Ot.w * ce.finalSize / 100) : Jr = ie.measureText(Ge, ce.f, ce.finalSize), kn === " " ? Cn += Jr + nn : (wt += Jr + nn + Cn, Cn = 0), we.push({
          l: Jr,
          an: Jr,
          add: ot,
          n: Ue,
          anIndexes: [],
          val: Ge,
          line: bt,
          animatorJustifyOffset: 0
        }), Xe == 2) {
          if (ot += Jr, Ge === "" || Ge === " " || Re === je - 1) {
            for ((Ge === "" || Ge === " ") && (ot -= Jr); vt <= Re; )
              we[vt].an = ot, we[vt].ind = qe, we[vt].extra = Jr, vt += 1;
            qe += 1, ot = 0;
          }
        } else if (Xe == 3) {
          if (ot += Jr, Ge === "" || Re === je - 1) {
            for (Ge === "" && (ot -= Jr); vt <= Re; )
              we[vt].an = ot, we[vt].ind = qe, we[vt].extra = Jr, vt += 1;
            ot = 0, qe += 1;
          }
        } else
          we[qe].ind = qe, we[qe].extra = 0, qe += 1;
      if (ce.l = we, St = wt > St ? wt : St, Tt.push(wt), ce.sz)
        ce.boxWidth = ce.sz[0], ce.justifyOffset = 0;
      else
        switch (ce.boxWidth = St, ce.j) {
          case 1:
            ce.justifyOffset = -ce.boxWidth;
            break;
          case 2:
            ce.justifyOffset = -ce.boxWidth / 2;
            break;
          default:
            ce.justifyOffset = 0;
        }
      ce.lineWidths = Tt;
      var cn = me.a, gn, an;
      Pt = cn.length;
      var un, pn, hn = [];
      for (It = 0; It < Pt; It += 1) {
        for (gn = cn[It], gn.a.sc && (ce.strokeColorAnim = !0), gn.a.sw && (ce.strokeWidthAnim = !0), (gn.a.fc || gn.a.fh || gn.a.fs || gn.a.fb) && (ce.fillColorAnim = !0), pn = 0, un = gn.s.b, Re = 0; Re < je; Re += 1)
          an = we[Re], an.anIndexes[It] = pn, (un == 1 && an.val !== "" || un == 2 && an.val !== "" && an.val !== " " || un == 3 && (an.n || an.val == " " || Re == je - 1) || un == 4 && (an.n || Re == je - 1)) && (gn.s.rn === 1 && hn.push(pn), pn += 1);
        me.a[It].s.totalChars = pn;
        var An = -1, In;
        if (gn.s.rn === 1)
          for (Re = 0; Re < je; Re += 1)
            an = we[Re], An != an.anIndexes[It] && (An = an.anIndexes[It], In = hn.splice(Math.floor(Math.random() * hn.length), 1)[0]), an.anIndexes[It] = In;
      }
      ce.yOffset = ce.finalLineHeight || ce.finalSize * 1.2, ce.ls = ce.ls || 0, ce.ascent = kt.ascent * ce.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(ce, ie) {
      ie = ie === void 0 ? this.keysIndex : ie;
      var me = this.copyData({}, this.data.d.k[ie].s);
      me = this.copyData(me, ce), this.data.d.k[ie].s = me, this.recalculate(ie), this.setCurrentData(me), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(ce) {
      var ie = this.data.d.k[ce].s;
      ie.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(ie);
    }, TextProperty.prototype.canResizeFont = function(ce) {
      this.canResize = ce, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(ce) {
      this.minimumFontSize = Math.floor(ce) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var ce = Math.max, ie = Math.min, me = Math.floor;
      function we(je, Ue) {
        this._currentTextLength = -1, this.k = !1, this.data = Ue, this.elem = je, this.comp = je.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(je), this.s = PropertyFactory.getProp(je, Ue.s || {
          k: 0
        }, 0, 0, this), "e" in Ue ? this.e = PropertyFactory.getProp(je, Ue.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(je, Ue.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(je, Ue.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(je, Ue.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(je, Ue.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(je, Ue.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      we.prototype = {
        getMult: function(Ue) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var qe = 0, Ge = 0, Xe = 1, ot = 1;
          this.ne.v > 0 ? qe = this.ne.v / 100 : Ge = -this.ne.v / 100, this.xe.v > 0 ? Xe = 1 - this.xe.v / 100 : ot = 1 + this.xe.v / 100;
          var vt = BezierFactory.getBezierEasing(qe, Ge, Xe, ot).get, bt = 0, Tt = this.finalS, wt = this.finalE, St = this.data.sh;
          if (St === 2)
            wt === Tt ? bt = Ue >= wt ? 1 : 0 : bt = ce(0, ie(0.5 / (wt - Tt) + (Ue - Tt) / (wt - Tt), 1)), bt = vt(bt);
          else if (St === 3)
            wt === Tt ? bt = Ue >= wt ? 0 : 1 : bt = 1 - ce(0, ie(0.5 / (wt - Tt) + (Ue - Tt) / (wt - Tt), 1)), bt = vt(bt);
          else if (St === 4)
            wt === Tt ? bt = 0 : (bt = ce(0, ie(0.5 / (wt - Tt) + (Ue - Tt) / (wt - Tt), 1)), bt < 0.5 ? bt *= 2 : bt = 1 - 2 * (bt - 0.5)), bt = vt(bt);
          else if (St === 5) {
            if (wt === Tt)
              bt = 0;
            else {
              var It = wt - Tt;
              Ue = ie(ce(0, Ue + 0.5 - Tt), wt - Tt);
              var Pt = -It / 2 + Ue, kt = It / 2;
              bt = Math.sqrt(1 - Pt * Pt / (kt * kt));
            }
            bt = vt(bt);
          } else St === 6 ? (wt === Tt ? bt = 0 : (Ue = ie(ce(0, Ue + 0.5 - Tt), wt - Tt), bt = (1 + Math.cos(Math.PI + Math.PI * 2 * Ue / (wt - Tt))) / 2), bt = vt(bt)) : (Ue >= me(Tt) && (Ue - Tt < 0 ? bt = ce(0, ie(ie(wt, 1) - (Tt - Ue), 1)) : bt = ce(0, ie(wt - Ue, 1))), bt = vt(bt));
          if (this.sm.v !== 100) {
            var Ot = this.sm.v * 0.01;
            Ot === 0 && (Ot = 1e-8);
            var Jr = 0.5 - Ot * 0.5;
            bt < Jr ? bt = 0 : (bt = (bt - Jr) / Ot, bt > 1 && (bt = 1));
          }
          return bt * this.a.v;
        },
        getValue: function(Ue) {
          this.iterateDynamicProperties(), this._mdf = Ue || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, Ue && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var qe = this.data.r === 2 ? 1 : 100 / this.data.totalChars, Ge = this.o.v / qe, Xe = this.s.v / qe + Ge, ot = this.e.v / qe + Ge;
          if (Xe > ot) {
            var vt = Xe;
            Xe = ot, ot = vt;
          }
          this.finalS = Xe, this.finalE = ot;
        }
      }, extendPrototype([DynamicPropertyContainer], we);
      function Re(je, Ue, qe) {
        return new we(je, Ue);
      }
      return {
        getTextSelectorProp: Re
      };
    }();
    function TextAnimatorDataProperty(ce, ie, me) {
      var we = {
        propType: !1
      }, Re = PropertyFactory.getProp, je = ie.a;
      this.a = {
        r: je.r ? Re(ce, je.r, 0, degToRads, me) : we,
        rx: je.rx ? Re(ce, je.rx, 0, degToRads, me) : we,
        ry: je.ry ? Re(ce, je.ry, 0, degToRads, me) : we,
        sk: je.sk ? Re(ce, je.sk, 0, degToRads, me) : we,
        sa: je.sa ? Re(ce, je.sa, 0, degToRads, me) : we,
        s: je.s ? Re(ce, je.s, 1, 0.01, me) : we,
        a: je.a ? Re(ce, je.a, 1, 0, me) : we,
        o: je.o ? Re(ce, je.o, 0, 0.01, me) : we,
        p: je.p ? Re(ce, je.p, 1, 0, me) : we,
        sw: je.sw ? Re(ce, je.sw, 0, 0, me) : we,
        sc: je.sc ? Re(ce, je.sc, 1, 0, me) : we,
        fc: je.fc ? Re(ce, je.fc, 1, 0, me) : we,
        fh: je.fh ? Re(ce, je.fh, 0, 0, me) : we,
        fs: je.fs ? Re(ce, je.fs, 0, 0.01, me) : we,
        fb: je.fb ? Re(ce, je.fb, 0, 0.01, me) : we,
        t: je.t ? Re(ce, je.t, 0, 0, me) : we
      }, this.s = TextSelectorProp.getTextSelectorProp(ce, ie.s, me), this.s.t = ie.s.t;
    }
    function TextAnimatorProperty(ce, ie, me) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = ce, this._renderType = ie, this._elem = me, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(me);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var ce, ie = this._textData.a.length, me, we = PropertyFactory.getProp;
      for (ce = 0; ce < ie; ce += 1)
        me = this._textData.a[ce], this._animatorsData[ce] = new TextAnimatorDataProperty(this._elem, me, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: we(this._elem, this._textData.p.a, 0, 0, this),
        f: we(this._elem, this._textData.p.f, 0, 0, this),
        l: we(this._elem, this._textData.p.l, 0, 0, this),
        r: we(this._elem, this._textData.p.r, 0, 0, this),
        p: we(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = we(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(ce, ie) {
      if (this.lettersChangedFlag = ie, !(!this._mdf && !this._isFirstFrame && !ie && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var me = this._moreOptions.alignment.v, we = this._animatorsData, Re = this._textData, je = this.mHelper, Ue = this._renderType, qe = this.renderedLetters.length, Ge, Xe, ot, vt, bt = ce.l, Tt, wt, St, It, Pt, kt, Ot, Jr, en, nn, ln, fn, vn, Tn, xn;
        if (this._hasMaskedPath) {
          if (xn = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var bn = xn.v;
            this._pathData.r.v && (bn = bn.reverse()), Tt = {
              tLength: 0,
              segments: []
            }, vt = bn._length - 1;
            var Sn;
            for (fn = 0, ot = 0; ot < vt; ot += 1)
              Sn = bez.buildBezierData(bn.v[ot], bn.v[ot + 1], [bn.o[ot][0] - bn.v[ot][0], bn.o[ot][1] - bn.v[ot][1]], [bn.i[ot + 1][0] - bn.v[ot + 1][0], bn.i[ot + 1][1] - bn.v[ot + 1][1]]), Tt.tLength += Sn.segmentLength, Tt.segments.push(Sn), fn += Sn.segmentLength;
            ot = vt, xn.v.c && (Sn = bez.buildBezierData(bn.v[ot], bn.v[0], [bn.o[ot][0] - bn.v[ot][0], bn.o[ot][1] - bn.v[ot][1]], [bn.i[0][0] - bn.v[0][0], bn.i[0][1] - bn.v[0][1]]), Tt.tLength += Sn.segmentLength, Tt.segments.push(Sn), fn += Sn.segmentLength), this._pathData.pi = Tt;
          }
          if (Tt = this._pathData.pi, wt = this._pathData.f.v, Ot = 0, kt = 1, It = 0, Pt = !0, nn = Tt.segments, wt < 0 && xn.v.c)
            for (Tt.tLength < Math.abs(wt) && (wt = -Math.abs(wt) % Tt.tLength), Ot = nn.length - 1, en = nn[Ot].points, kt = en.length - 1; wt < 0; )
              wt += en[kt].partialLength, kt -= 1, kt < 0 && (Ot -= 1, en = nn[Ot].points, kt = en.length - 1);
          en = nn[Ot].points, Jr = en[kt - 1], St = en[kt], ln = St.partialLength;
        }
        vt = bt.length, Ge = 0, Xe = 0;
        var Cn = ce.finalSize * 1.2 * 0.714, kn = !0, cn, gn, an, un, pn;
        un = we.length;
        var hn, An = -1, In, qn, si, bi = wt, xi = Ot, ji = kt, zi = -1, Vi, Hi, ii, Fi, ni, Ui, ja, Ga, Xa = "", Ns = this.defaultPropsArray, Ya;
        if (ce.j === 2 || ce.j === 1) {
          var Qa = 0, Ja = 0, Ms = ce.j === 2 ? -0.5 : -1, Hs = 0, no = !0;
          for (ot = 0; ot < vt; ot += 1)
            if (bt[ot].n) {
              for (Qa && (Qa += Ja); Hs < ot; )
                bt[Hs].animatorJustifyOffset = Qa, Hs += 1;
              Qa = 0, no = !0;
            } else {
              for (an = 0; an < un; an += 1)
                cn = we[an].a, cn.t.propType && (no && ce.j === 2 && (Ja += cn.t.v * Ms), gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), hn.length ? Qa += cn.t.v * hn[0] * Ms : Qa += cn.t.v * hn * Ms);
              no = !1;
            }
          for (Qa && (Qa += Ja); Hs < ot; )
            bt[Hs].animatorJustifyOffset = Qa, Hs += 1;
        }
        for (ot = 0; ot < vt; ot += 1) {
          if (je.reset(), Vi = 1, bt[ot].n)
            Ge = 0, Xe += ce.yOffset, Xe += kn ? 1 : 0, wt = bi, kn = !1, this._hasMaskedPath && (Ot = xi, kt = ji, en = nn[Ot].points, Jr = en[kt - 1], St = en[kt], ln = St.partialLength, It = 0), Xa = "", Ga = "", Ui = "", Ya = "", Ns = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (zi !== bt[ot].line) {
                switch (ce.j) {
                  case 1:
                    wt += fn - ce.lineWidths[bt[ot].line];
                    break;
                  case 2:
                    wt += (fn - ce.lineWidths[bt[ot].line]) / 2;
                    break;
                }
                zi = bt[ot].line;
              }
              An !== bt[ot].ind && (bt[An] && (wt += bt[An].extra), wt += bt[ot].an / 2, An = bt[ot].ind), wt += me[0] * bt[ot].an * 5e-3;
              var Qs = 0;
              for (an = 0; an < un; an += 1)
                cn = we[an].a, cn.p.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), hn.length ? Qs += cn.p.v[0] * hn[0] : Qs += cn.p.v[0] * hn), cn.a.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), hn.length ? Qs += cn.a.v[0] * hn[0] : Qs += cn.a.v[0] * hn);
              for (Pt = !0, this._pathData.a.v && (wt = bt[0].an * 0.5 + (fn - this._pathData.f.v - bt[0].an * 0.5 - bt[bt.length - 1].an * 0.5) * An / (vt - 1), wt += this._pathData.f.v); Pt; )
                It + ln >= wt + Qs || !en ? (vn = (wt + Qs - It) / St.partialLength, qn = Jr.point[0] + (St.point[0] - Jr.point[0]) * vn, si = Jr.point[1] + (St.point[1] - Jr.point[1]) * vn, je.translate(-me[0] * bt[ot].an * 5e-3, -(me[1] * Cn) * 0.01), Pt = !1) : en && (It += St.partialLength, kt += 1, kt >= en.length && (kt = 0, Ot += 1, nn[Ot] ? en = nn[Ot].points : xn.v.c ? (kt = 0, Ot = 0, en = nn[Ot].points) : (It -= St.partialLength, en = null)), en && (Jr = St, St = en[kt], ln = St.partialLength));
              In = bt[ot].an / 2 - bt[ot].add, je.translate(-In, 0, 0);
            } else
              In = bt[ot].an / 2 - bt[ot].add, je.translate(-In, 0, 0), je.translate(-me[0] * bt[ot].an * 5e-3, -me[1] * Cn * 0.01, 0);
            for (an = 0; an < un; an += 1)
              cn = we[an].a, cn.t.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), (Ge !== 0 || ce.j !== 0) && (this._hasMaskedPath ? hn.length ? wt += cn.t.v * hn[0] : wt += cn.t.v * hn : hn.length ? Ge += cn.t.v * hn[0] : Ge += cn.t.v * hn));
            for (ce.strokeWidthAnim && (ii = ce.sw || 0), ce.strokeColorAnim && (ce.sc ? Hi = [ce.sc[0], ce.sc[1], ce.sc[2]] : Hi = [0, 0, 0]), ce.fillColorAnim && ce.fc && (Fi = [ce.fc[0], ce.fc[1], ce.fc[2]]), an = 0; an < un; an += 1)
              cn = we[an].a, cn.a.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), hn.length ? je.translate(-cn.a.v[0] * hn[0], -cn.a.v[1] * hn[1], cn.a.v[2] * hn[2]) : je.translate(-cn.a.v[0] * hn, -cn.a.v[1] * hn, cn.a.v[2] * hn));
            for (an = 0; an < un; an += 1)
              cn = we[an].a, cn.s.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), hn.length ? je.scale(1 + (cn.s.v[0] - 1) * hn[0], 1 + (cn.s.v[1] - 1) * hn[1], 1) : je.scale(1 + (cn.s.v[0] - 1) * hn, 1 + (cn.s.v[1] - 1) * hn, 1));
            for (an = 0; an < un; an += 1) {
              if (cn = we[an].a, gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), cn.sk.propType && (hn.length ? je.skewFromAxis(-cn.sk.v * hn[0], cn.sa.v * hn[1]) : je.skewFromAxis(-cn.sk.v * hn, cn.sa.v * hn)), cn.r.propType && (hn.length ? je.rotateZ(-cn.r.v * hn[2]) : je.rotateZ(-cn.r.v * hn)), cn.ry.propType && (hn.length ? je.rotateY(cn.ry.v * hn[1]) : je.rotateY(cn.ry.v * hn)), cn.rx.propType && (hn.length ? je.rotateX(cn.rx.v * hn[0]) : je.rotateX(cn.rx.v * hn)), cn.o.propType && (hn.length ? Vi += (cn.o.v * hn[0] - Vi) * hn[0] : Vi += (cn.o.v * hn - Vi) * hn), ce.strokeWidthAnim && cn.sw.propType && (hn.length ? ii += cn.sw.v * hn[0] : ii += cn.sw.v * hn), ce.strokeColorAnim && cn.sc.propType)
                for (ni = 0; ni < 3; ni += 1)
                  hn.length ? Hi[ni] += (cn.sc.v[ni] - Hi[ni]) * hn[0] : Hi[ni] += (cn.sc.v[ni] - Hi[ni]) * hn;
              if (ce.fillColorAnim && ce.fc) {
                if (cn.fc.propType)
                  for (ni = 0; ni < 3; ni += 1)
                    hn.length ? Fi[ni] += (cn.fc.v[ni] - Fi[ni]) * hn[0] : Fi[ni] += (cn.fc.v[ni] - Fi[ni]) * hn;
                cn.fh.propType && (hn.length ? Fi = addHueToRGB(Fi, cn.fh.v * hn[0]) : Fi = addHueToRGB(Fi, cn.fh.v * hn)), cn.fs.propType && (hn.length ? Fi = addSaturationToRGB(Fi, cn.fs.v * hn[0]) : Fi = addSaturationToRGB(Fi, cn.fs.v * hn)), cn.fb.propType && (hn.length ? Fi = addBrightnessToRGB(Fi, cn.fb.v * hn[0]) : Fi = addBrightnessToRGB(Fi, cn.fb.v * hn));
              }
            }
            for (an = 0; an < un; an += 1)
              cn = we[an].a, cn.p.propType && (gn = we[an].s, hn = gn.getMult(bt[ot].anIndexes[an], Re.a[an].s.totalChars), this._hasMaskedPath ? hn.length ? je.translate(0, cn.p.v[1] * hn[0], -cn.p.v[2] * hn[1]) : je.translate(0, cn.p.v[1] * hn, -cn.p.v[2] * hn) : hn.length ? je.translate(cn.p.v[0] * hn[0], cn.p.v[1] * hn[1], -cn.p.v[2] * hn[2]) : je.translate(cn.p.v[0] * hn, cn.p.v[1] * hn, -cn.p.v[2] * hn));
            if (ce.strokeWidthAnim && (Ui = ii < 0 ? 0 : ii), ce.strokeColorAnim && (ja = "rgb(" + Math.round(Hi[0] * 255) + "," + Math.round(Hi[1] * 255) + "," + Math.round(Hi[2] * 255) + ")"), ce.fillColorAnim && ce.fc && (Ga = "rgb(" + Math.round(Fi[0] * 255) + "," + Math.round(Fi[1] * 255) + "," + Math.round(Fi[2] * 255) + ")"), this._hasMaskedPath) {
              if (je.translate(0, -ce.ls), je.translate(0, me[1] * Cn * 0.01 + Xe, 0), this._pathData.p.v) {
                Tn = (St.point[1] - Jr.point[1]) / (St.point[0] - Jr.point[0]);
                var Zs = Math.atan(Tn) * 180 / Math.PI;
                St.point[0] < Jr.point[0] && (Zs += 180), je.rotate(-Zs * Math.PI / 180);
              }
              je.translate(qn, si, 0), wt -= me[0] * bt[ot].an * 5e-3, bt[ot + 1] && An !== bt[ot + 1].ind && (wt += bt[ot].an / 2, wt += ce.tr * 1e-3 * ce.finalSize);
            } else {
              switch (je.translate(Ge, Xe, 0), ce.ps && je.translate(ce.ps[0], ce.ps[1] + ce.ascent, 0), ce.j) {
                case 1:
                  je.translate(bt[ot].animatorJustifyOffset + ce.justifyOffset + (ce.boxWidth - ce.lineWidths[bt[ot].line]), 0, 0);
                  break;
                case 2:
                  je.translate(bt[ot].animatorJustifyOffset + ce.justifyOffset + (ce.boxWidth - ce.lineWidths[bt[ot].line]) / 2, 0, 0);
                  break;
              }
              je.translate(0, -ce.ls), je.translate(In, 0, 0), je.translate(me[0] * bt[ot].an * 5e-3, me[1] * Cn * 0.01, 0), Ge += bt[ot].l + ce.tr * 1e-3 * ce.finalSize;
            }
            Ue === "html" ? Xa = je.toCSS() : Ue === "svg" ? Xa = je.to2dCSS() : Ns = [je.props[0], je.props[1], je.props[2], je.props[3], je.props[4], je.props[5], je.props[6], je.props[7], je.props[8], je.props[9], je.props[10], je.props[11], je.props[12], je.props[13], je.props[14], je.props[15]], Ya = Vi;
          }
          qe <= ot ? (pn = new LetterProps(Ya, Ui, ja, Ga, Xa, Ns), this.renderedLetters.push(pn), qe += 1, this.lettersChangedFlag = !0) : (pn = this.renderedLetters[ot], this.lettersChangedFlag = pn.update(Ya, Ui, ja, Ga, Xa, Ns) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(ce, ie, me) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(ce, ie, me), this.textProperty = new TextProperty(this, ce.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(ce.t, this.renderType, this), this.initTransform(ce, ie, me), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(ce) {
      this._mdf = !1, this.prepareRenderableFrame(ce), this.prepareProperties(ce, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(ce, ie) {
      var me, we = ie.length, Re, je = "";
      for (me = 0; me < we; me += 1)
        ie[me].ty === "sh" && (Re = ie[me].ks.k, je += buildShapeString(Re, Re.i.length, !0, ce));
      return je;
    }, ITextElement.prototype.updateDocumentData = function(ce, ie) {
      this.textProperty.updateDocumentData(ce, ie);
    }, ITextElement.prototype.canResizeFont = function(ce) {
      this.textProperty.canResizeFont(ce);
    }, ITextElement.prototype.setMinimumFontSize = function(ce) {
      this.textProperty.setMinimumFontSize(ce);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(ce, ie, me, we, Re) {
      switch (ce.ps && ie.translate(ce.ps[0], ce.ps[1] + ce.ascent, 0), ie.translate(0, -ce.ls, 0), ce.j) {
        case 1:
          ie.translate(ce.justifyOffset + (ce.boxWidth - ce.lineWidths[me]), 0, 0);
          break;
        case 2:
          ie.translate(ce.justifyOffset + (ce.boxWidth - ce.lineWidths[me]) / 2, 0, 0);
          break;
      }
      ie.translate(we, Re, 0);
    }, ITextElement.prototype.buildColor = function(ce) {
      return "rgb(" + Math.round(ce[0] * 255) + "," + Math.round(ce[1] * 255) + "," + Math.round(ce[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(ce, ie, me) {
      this.textSpans = [], this.renderType = "svg", this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(ce) {
      for (var ie = 0, me = ce.length, we = [], Re = ""; ie < me; )
        ce[ie] === "\r" || ce[ie] === "" ? (we.push(Re), Re = "") : Re += ce[ie], ie += 1;
      return we.push(Re), we;
    }, SVGTextLottieElement.prototype.buildShapeData = function(ce, ie) {
      if (ce.shapes && ce.shapes.length) {
        var me = ce.shapes[0];
        if (me.it) {
          var we = me.it[me.it.length - 1];
          we.s && (we.s.k[0] = ie, we.s.k[1] = ie);
        }
      }
      return ce;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var ce, ie, me = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(me ? me.l.length : 0), me.fc ? this.layerElement.setAttribute("fill", this.buildColor(me.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), me.sc && (this.layerElement.setAttribute("stroke", this.buildColor(me.sc)), this.layerElement.setAttribute("stroke-width", me.sw)), this.layerElement.setAttribute("font-size", me.finalSize);
      var we = this.globalData.fontManager.getFontByName(me.f);
      if (we.fClass)
        this.layerElement.setAttribute("class", we.fClass);
      else {
        this.layerElement.setAttribute("font-family", we.fFamily);
        var Re = me.fWeight, je = me.fStyle;
        this.layerElement.setAttribute("font-style", je), this.layerElement.setAttribute("font-weight", Re);
      }
      this.layerElement.setAttribute("aria-label", me.t);
      var Ue = me.l || [], qe = !!this.globalData.fontManager.chars;
      ie = Ue.length;
      var Ge, Xe = this.mHelper, ot = "", vt = this.data.singleShape, bt = 0, Tt = 0, wt = !0, St = me.tr * 1e-3 * me.finalSize;
      if (vt && !qe && !me.sz) {
        var It = this.textContainer, Pt = "start";
        switch (me.j) {
          case 1:
            Pt = "end";
            break;
          case 2:
            Pt = "middle";
            break;
          default:
            Pt = "start";
            break;
        }
        It.setAttribute("text-anchor", Pt), It.setAttribute("letter-spacing", St);
        var kt = this.buildTextContents(me.finalText);
        for (ie = kt.length, Tt = me.ps ? me.ps[1] + me.ascent : 0, ce = 0; ce < ie; ce += 1)
          Ge = this.textSpans[ce].span || createNS("tspan"), Ge.textContent = kt[ce], Ge.setAttribute("x", 0), Ge.setAttribute("y", Tt), Ge.style.display = "inherit", It.appendChild(Ge), this.textSpans[ce] || (this.textSpans[ce] = {
            span: null,
            glyph: null
          }), this.textSpans[ce].span = Ge, Tt += me.finalLineHeight;
        this.layerElement.appendChild(It);
      } else {
        var Ot = this.textSpans.length, Jr;
        for (ce = 0; ce < ie; ce += 1) {
          if (this.textSpans[ce] || (this.textSpans[ce] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !qe || !vt || ce === 0) {
            if (Ge = Ot > ce ? this.textSpans[ce].span : createNS(qe ? "g" : "text"), Ot <= ce) {
              if (Ge.setAttribute("stroke-linecap", "butt"), Ge.setAttribute("stroke-linejoin", "round"), Ge.setAttribute("stroke-miterlimit", "4"), this.textSpans[ce].span = Ge, qe) {
                var en = createNS("g");
                Ge.appendChild(en), this.textSpans[ce].childSpan = en;
              }
              this.textSpans[ce].span = Ge, this.layerElement.appendChild(Ge);
            }
            Ge.style.display = "inherit";
          }
          if (Xe.reset(), vt && (Ue[ce].n && (bt = -St, Tt += me.yOffset, Tt += wt ? 1 : 0, wt = !1), this.applyTextPropertiesToMatrix(me, Xe, Ue[ce].line, bt, Tt), bt += Ue[ce].l || 0, bt += St), qe) {
            Jr = this.globalData.fontManager.getCharData(me.finalText[ce], we.fStyle, this.globalData.fontManager.getFontByName(me.f).fFamily);
            var nn;
            if (Jr.t === 1)
              nn = new SVGCompElement(Jr.data, this.globalData, this);
            else {
              var ln = emptyShapeData;
              Jr.data && Jr.data.shapes && (ln = this.buildShapeData(Jr.data, me.finalSize)), nn = new SVGShapeElement(ln, this.globalData, this);
            }
            if (this.textSpans[ce].glyph) {
              var fn = this.textSpans[ce].glyph;
              this.textSpans[ce].childSpan.removeChild(fn.layerElement), fn.destroy();
            }
            this.textSpans[ce].glyph = nn, nn._debug = !0, nn.prepareFrame(0), nn.renderFrame(), this.textSpans[ce].childSpan.appendChild(nn.layerElement), Jr.t === 1 && this.textSpans[ce].childSpan.setAttribute("transform", "scale(" + me.finalSize / 100 + "," + me.finalSize / 100 + ")");
          } else
            vt && Ge.setAttribute("transform", "translate(" + Xe.props[12] + "," + Xe.props[13] + ")"), Ge.textContent = Ue[ce].val, Ge.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        vt && Ge && Ge.setAttribute("d", ot);
      }
      for (; ce < this.textSpans.length; )
        this.textSpans[ce].span.style.display = "none", ce += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var ce = this.layerElement.getBBox();
        this.bbox = {
          top: ce.y,
          left: ce.x,
          width: ce.width,
          height: ce.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var ce, ie = this.textSpans.length, me;
      for (this.renderedFrame = this.comp.renderedFrame, ce = 0; ce < ie; ce += 1)
        me = this.textSpans[ce].glyph, me && (me.prepareFrame(this.comp.renderedFrame - this.data.st), me._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var ce, ie, me = this.textAnimator.renderedLetters, we = this.textProperty.currentData.l;
        ie = we.length;
        var Re, je, Ue;
        for (ce = 0; ce < ie; ce += 1)
          we[ce].n || (Re = me[ce], je = this.textSpans[ce].span, Ue = this.textSpans[ce].glyph, Ue && Ue.renderFrame(), Re._mdf.m && je.setAttribute("transform", Re.m), Re._mdf.o && je.setAttribute("opacity", Re.o), Re._mdf.sw && je.setAttribute("stroke-width", Re.sw), Re._mdf.sc && je.setAttribute("stroke", Re.sc), Re._mdf.fc && je.setAttribute("fill", Re.fc));
      }
    };
    function ISolidElement(ce, ie, me) {
      this.initElement(ce, ie, me);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var ce = createNS("rect");
      ce.setAttribute("width", this.data.sw), ce.setAttribute("height", this.data.sh), ce.setAttribute("fill", this.data.sc), this.layerElement.appendChild(ce);
    };
    function NullElement(ce, ie, me) {
      this.initFrame(), this.initBaseData(ce, ie, me), this.initFrame(), this.initTransform(ce, ie, me), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(ce) {
      this.prepareProperties(ce, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(ce) {
      return new NullElement(ce, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(ce) {
      return new SVGShapeElement(ce, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(ce) {
      return new SVGTextLottieElement(ce, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(ce) {
      return new IImageElement(ce, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(ce) {
      return new ISolidElement(ce, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(ce) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + ce.w + " " + ce.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", ce.w), this.svgElement.setAttribute("height", ce.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var ie = this.globalData.defs;
      this.setupGlobalData(ce, ie), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = ce;
      var me = createNS("clipPath"), we = createNS("rect");
      we.setAttribute("width", ce.w), we.setAttribute("height", ce.h), we.setAttribute("x", 0), we.setAttribute("y", 0);
      var Re = createElementID();
      me.setAttribute("id", Re), me.appendChild(we), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + Re + ")"), ie.appendChild(me), this.layers = ce.layers, this.elements = createSizedArray(ce.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var ce, ie = this.layers ? this.layers.length : 0;
      for (ce = 0; ce < ie; ce += 1)
        this.elements[ce] && this.elements[ce].destroy && this.elements[ce].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(ce) {
      var ie = 0, me = this.layers.length;
      for (ie = 0; ie < me; ie += 1)
        if (this.layers[ie].ind === ce)
          return ie;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(ce) {
      var ie = this.elements;
      if (!(ie[ce] || this.layers[ce].ty === 99)) {
        ie[ce] = !0;
        var me = this.createItem(this.layers[ce]);
        if (ie[ce] = me, getExpressionsPlugin() && (this.layers[ce].ty === 0 && this.globalData.projectInterface.registerComposition(me), me.initExpressions()), this.appendElementInPos(me, ce), this.layers[ce].tt) {
          var we = "tp" in this.layers[ce] ? this.findIndexByInd(this.layers[ce].tp) : ce - 1;
          if (we === -1)
            return;
          if (!this.elements[we] || this.elements[we] === !0)
            this.buildItem(we), this.addPendingElement(me);
          else {
            var Re = ie[we], je = Re.getMatte(this.layers[ce].tt);
            me.setMatte(je);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var ce = this.pendingElements.pop();
        if (ce.checkParenting(), ce.data.tt)
          for (var ie = 0, me = this.elements.length; ie < me; ) {
            if (this.elements[ie] === ce) {
              var we = "tp" in ce.data ? this.findIndexByInd(ce.data.tp) : ie - 1, Re = this.elements[we], je = Re.getMatte(this.layers[ie].tt);
              ce.setMatte(je);
              break;
            }
            ie += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(ce) {
      if (!(this.renderedFrame === ce || this.destroyed)) {
        ce === null ? ce = this.renderedFrame : this.renderedFrame = ce, this.globalData.frameNum = ce, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = ce, this.globalData._mdf = !1;
        var ie, me = this.layers.length;
        for (this.completeLayers || this.checkLayers(ce), ie = me - 1; ie >= 0; ie -= 1)
          (this.completeLayers || this.elements[ie]) && this.elements[ie].prepareFrame(ce - this.layers[ie].st);
        if (this.globalData._mdf)
          for (ie = 0; ie < me; ie += 1)
            (this.completeLayers || this.elements[ie]) && this.elements[ie].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(ce, ie) {
      var me = ce.getBaseElement();
      if (me) {
        for (var we = 0, Re; we < ie; )
          this.elements[we] && this.elements[we] !== !0 && this.elements[we].getBaseElement() && (Re = this.elements[we].getBaseElement()), we += 1;
        Re ? this.layerElement.insertBefore(me, Re) : this.layerElement.appendChild(me);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(ce, ie, me) {
      this.initFrame(), this.initBaseData(ce, ie, me), this.initTransform(ce, ie, me), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !ie.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(ce) {
      if (this._mdf = !1, this.prepareRenderableFrame(ce), this.prepareProperties(ce, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = ce / this.data.sr;
        else {
          var ie = this.tm.v;
          ie === this.data.op && (ie = this.data.op - 1), this.renderedFrame = ie;
        }
        var me, we = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), me = we - 1; me >= 0; me -= 1)
          (this.completeLayers || this.elements[me]) && (this.elements[me].prepareFrame(this.renderedFrame - this.layers[me].st), this.elements[me]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var ce, ie = this.layers.length;
      for (ce = 0; ce < ie; ce += 1)
        (this.completeLayers || this.elements[ce]) && this.elements[ce].renderFrame();
    }, ICompElement.prototype.setElements = function(ce) {
      this.elements = ce;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var ce, ie = this.layers.length;
      for (ce = 0; ce < ie; ce += 1)
        this.elements[ce] && this.elements[ce].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(ce, ie, me) {
      this.layers = ce.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(ce, ie, me), this.tm = ce.tm ? PropertyFactory.getProp(this, ce.tm, 0, ie.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(ce) {
      return new SVGCompElement(ce, this.globalData, this);
    };
    function SVGRenderer(ce, ie) {
      this.animationItem = ce, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var me = "";
      if (ie && ie.title) {
        var we = createNS("title"), Re = createElementID();
        we.setAttribute("id", Re), we.textContent = ie.title, this.svgElement.appendChild(we), me += Re;
      }
      if (ie && ie.description) {
        var je = createNS("desc"), Ue = createElementID();
        je.setAttribute("id", Ue), je.textContent = ie.description, this.svgElement.appendChild(je), me += " " + Ue;
      }
      me && this.svgElement.setAttribute("aria-labelledby", me);
      var qe = createNS("defs");
      this.svgElement.appendChild(qe);
      var Ge = createNS("g");
      this.svgElement.appendChild(Ge), this.layerElement = Ge, this.renderConfig = {
        preserveAspectRatio: ie && ie.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: ie && ie.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: ie && ie.contentVisibility || "visible",
        progressiveLoad: ie && ie.progressiveLoad || !1,
        hideOnTransparent: !(ie && ie.hideOnTransparent === !1),
        viewBoxOnly: ie && ie.viewBoxOnly || !1,
        viewBoxSize: ie && ie.viewBoxSize || !1,
        className: ie && ie.className || "",
        id: ie && ie.id || "",
        focusable: ie && ie.focusable,
        filterSize: {
          width: ie && ie.filterSize && ie.filterSize.width || "100%",
          height: ie && ie.filterSize && ie.filterSize.height || "100%",
          x: ie && ie.filterSize && ie.filterSize.x || "0%",
          y: ie && ie.filterSize && ie.filterSize.y || "0%"
        },
        width: ie && ie.width,
        height: ie && ie.height,
        runExpressions: !ie || ie.runExpressions === void 0 || ie.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: qe,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(ce) {
      return new SVGCompElement(ce, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(ie) {
        var me, we = ie.length, Re = "_";
        for (me = 0; me < we; me += 1)
          Re += ie[me].transform.key + "_";
        var je = this.sequences[Re];
        return je || (je = {
          transforms: [].concat(ie),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[Re] = je, this.sequenceList.push(je)), je;
      },
      processSequence: function(ie, me) {
        for (var we = 0, Re = ie.transforms.length, je = me; we < Re && !me; ) {
          if (ie.transforms[we].transform.mProps._mdf) {
            je = !0;
            break;
          }
          we += 1;
        }
        if (je)
          for (ie.finalTransform.reset(), we = Re - 1; we >= 0; we -= 1)
            ie.finalTransform.multiply(ie.transforms[we].transform.mProps.v);
        ie._mdf = je;
      },
      processSequences: function(ie) {
        var me, we = this.sequenceList.length;
        for (me = 0; me < we; me += 1)
          this.processSequence(this.sequenceList[me], ie);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var ie = "__lottie_element_luma_buffer", me = null, we = null, Re = null;
      function je() {
        var Ge = createNS("svg"), Xe = createNS("filter"), ot = createNS("feColorMatrix");
        return Xe.setAttribute("id", ie), ot.setAttribute("type", "matrix"), ot.setAttribute("color-interpolation-filters", "sRGB"), ot.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), Xe.appendChild(ot), Ge.appendChild(Xe), Ge.setAttribute("id", ie + "_svg"), featureSupport.svgLumaHidden && (Ge.style.display = "none"), Ge;
      }
      function Ue() {
        me || (Re = je(), document.body.appendChild(Re), me = createTag("canvas"), we = me.getContext("2d"), we.filter = "url(#" + ie + ")", we.fillStyle = "rgba(0,0,0,0)", we.fillRect(0, 0, 1, 1));
      }
      function qe(Ge) {
        return me || Ue(), me.width = Ge.width, me.height = Ge.height, we.filter = "url(#" + ie + ")", me;
      }
      return {
        load: Ue,
        get: qe
      };
    };
    function createCanvas(ce, ie) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(ce, ie);
      var me = createTag("canvas");
      return me.width = ce, me.height = ie, me;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(ce) {
      var ie, me = ce.data.ef ? ce.data.ef.length : 0;
      this.filters = [];
      var we;
      for (ie = 0; ie < me; ie += 1) {
        we = null;
        var Re = ce.data.ef[ie].ty;
        if (registeredEffects[Re]) {
          var je = registeredEffects[Re].effect;
          we = new je(ce.effectsManager.effectElements[ie], ce);
        }
        we && this.filters.push(we);
      }
      this.filters.length && ce.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(ce) {
      var ie, me = this.filters.length;
      for (ie = 0; ie < me; ie += 1)
        this.filters[ie].renderFrame(ce);
    }, CVEffects.prototype.getEffects = function(ce) {
      var ie, me = this.filters.length, we = [];
      for (ie = 0; ie < me; ie += 1)
        this.filters[ie].type === ce && we.push(this.filters[ie]);
      return we;
    };
    function registerEffect(ce, ie) {
      registeredEffects[ce] = {
        effect: ie
      };
    }
    function CVMaskElement(ce, ie) {
      this.data = ce, this.element = ie, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var me, we = this.masksProperties.length, Re = !1;
      for (me = 0; me < we; me += 1)
        this.masksProperties[me].mode !== "n" && (Re = !0), this.viewData[me] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[me], 3);
      this.hasMasks = Re, Re && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var ce = this.element.finalTransform.mat, ie = this.element.canvasContext, me, we = this.masksProperties.length, Re, je, Ue;
        for (ie.beginPath(), me = 0; me < we; me += 1)
          if (this.masksProperties[me].mode !== "n") {
            this.masksProperties[me].inv && (ie.moveTo(0, 0), ie.lineTo(this.element.globalData.compSize.w, 0), ie.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), ie.lineTo(0, this.element.globalData.compSize.h), ie.lineTo(0, 0)), Ue = this.viewData[me].v, Re = ce.applyToPointArray(Ue.v[0][0], Ue.v[0][1], 0), ie.moveTo(Re[0], Re[1]);
            var qe, Ge = Ue._length;
            for (qe = 1; qe < Ge; qe += 1)
              je = ce.applyToTriplePoints(Ue.o[qe - 1], Ue.i[qe], Ue.v[qe]), ie.bezierCurveTo(je[0], je[1], je[2], je[3], je[4], je[5]);
            je = ce.applyToTriplePoints(Ue.o[qe - 1], Ue.i[0], Ue.v[0]), ie.bezierCurveTo(je[0], je[1], je[2], je[3], je[4], je[5]);
          }
        this.element.globalData.renderer.save(!0), ie.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var ie = this.globalData.canvasContext, me = assetLoader.createCanvas(ie.canvas.width, ie.canvas.height);
          this.buffers.push(me);
          var we = assetLoader.createCanvas(ie.canvas.width, ie.canvas.height);
          this.buffers.push(we), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var ie = this.globalData;
        if (ie.blendMode !== this.data.bm) {
          ie.blendMode = this.data.bm;
          var me = getBlendMode(this.data.bm);
          ie.canvasContext.globalCompositeOperation = me;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(ie) {
        ie.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var ie = this.buffers[0], me = ie.getContext("2d");
          this.clearCanvas(me), me.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var ie = this.buffers[1], me = ie.getContext("2d");
          this.clearCanvas(me), me.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var we = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (we.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var Re = assetLoader.getLumaCanvas(this.canvasContext.canvas), je = Re.getContext("2d");
            je.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(Re, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(ie, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(ie) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !ie)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var me = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(me), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(me), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(ce, ie, me, we) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var Re = 4;
      ie.ty === "rc" ? Re = 5 : ie.ty === "el" ? Re = 6 : ie.ty === "sr" && (Re = 7), this.sh = ShapePropertyFactory.getShapeProp(ce, ie, Re, ce);
      var je, Ue = me.length, qe;
      for (je = 0; je < Ue; je += 1)
        me[je].closed || (qe = {
          transforms: we.addTransformSequence(me[je].transforms),
          trNodes: []
        }, this.styledShapes.push(qe), me[je].elements.push(qe));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(ce, ie, me) {
      this.shapes = [], this.shapesData = ce.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(ce, ie) {
      var me = {
        data: ce,
        type: ce.ty,
        preTransforms: this.transformsManager.addTransformSequence(ie),
        transforms: [],
        elements: [],
        closed: ce.hd === !0
      }, we = {};
      if (ce.ty === "fl" || ce.ty === "st" ? (we.c = PropertyFactory.getProp(this, ce.c, 1, 255, this), we.c.k || (me.co = "rgb(" + bmFloor(we.c.v[0]) + "," + bmFloor(we.c.v[1]) + "," + bmFloor(we.c.v[2]) + ")")) : (ce.ty === "gf" || ce.ty === "gs") && (we.s = PropertyFactory.getProp(this, ce.s, 1, null, this), we.e = PropertyFactory.getProp(this, ce.e, 1, null, this), we.h = PropertyFactory.getProp(this, ce.h || {
        k: 0
      }, 0, 0.01, this), we.a = PropertyFactory.getProp(this, ce.a || {
        k: 0
      }, 0, degToRads, this), we.g = new GradientProperty(this, ce.g, this)), we.o = PropertyFactory.getProp(this, ce.o, 0, 0.01, this), ce.ty === "st" || ce.ty === "gs") {
        if (me.lc = lineCapEnum[ce.lc || 2], me.lj = lineJoinEnum[ce.lj || 2], ce.lj == 1 && (me.ml = ce.ml), we.w = PropertyFactory.getProp(this, ce.w, 0, null, this), we.w.k || (me.wi = we.w.v), ce.d) {
          var Re = new DashProperty(this, ce.d, "canvas", this);
          we.d = Re, we.d.k || (me.da = we.d.dashArray, me.do = we.d.dashoffset[0]);
        }
      } else
        me.r = ce.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(me), we.style = me, we;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var ce = {
        it: [],
        prevViewData: []
      };
      return ce;
    }, CVShapeElement.prototype.createTransformElement = function(ce) {
      var ie = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, ce.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, ce, this)
        }
      };
      return ie;
    }, CVShapeElement.prototype.createShapeElement = function(ce) {
      var ie = new CVShapeData(this, ce, this.stylesList, this.transformsManager);
      return this.shapes.push(ie), this.addShapeToModifiers(ie), ie;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var ce, ie = this.itemsData.length;
      for (ce = 0; ce < ie; ce += 1)
        this.prevViewData[ce] = this.itemsData[ce];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), ie = this.dynamicProperties.length, ce = 0; ce < ie; ce += 1)
        this.dynamicProperties[ce].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(ce) {
      var ie, me = this.stylesList.length;
      for (ie = 0; ie < me; ie += 1)
        this.stylesList[ie].closed || this.stylesList[ie].transforms.push(ce);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var ce, ie = this.stylesList.length;
      for (ce = 0; ce < ie; ce += 1)
        this.stylesList[ce].closed || this.stylesList[ce].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(ce) {
      var ie, me = ce.length;
      for (ie = 0; ie < me; ie += 1)
        ce[ie].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(ce, ie, me, we, Re) {
      var je, Ue = ce.length - 1, qe, Ge, Xe = [], ot = [], vt, bt, Tt, wt = [].concat(Re);
      for (je = Ue; je >= 0; je -= 1) {
        if (vt = this.searchProcessedElement(ce[je]), vt ? ie[je] = me[vt - 1] : ce[je]._shouldRender = we, ce[je].ty === "fl" || ce[je].ty === "st" || ce[je].ty === "gf" || ce[je].ty === "gs")
          vt ? ie[je].style.closed = !1 : ie[je] = this.createStyleElement(ce[je], wt), Xe.push(ie[je].style);
        else if (ce[je].ty === "gr") {
          if (!vt)
            ie[je] = this.createGroupElement(ce[je]);
          else
            for (Ge = ie[je].it.length, qe = 0; qe < Ge; qe += 1)
              ie[je].prevViewData[qe] = ie[je].it[qe];
          this.searchShapes(ce[je].it, ie[je].it, ie[je].prevViewData, we, wt);
        } else ce[je].ty === "tr" ? (vt || (Tt = this.createTransformElement(ce[je]), ie[je] = Tt), wt.push(ie[je]), this.addTransformToStyleList(ie[je])) : ce[je].ty === "sh" || ce[je].ty === "rc" || ce[je].ty === "el" || ce[je].ty === "sr" ? vt || (ie[je] = this.createShapeElement(ce[je])) : ce[je].ty === "tm" || ce[je].ty === "rd" || ce[je].ty === "pb" || ce[je].ty === "zz" || ce[je].ty === "op" ? (vt ? (bt = ie[je], bt.closed = !1) : (bt = ShapeModifiers.getModifier(ce[je].ty), bt.init(this, ce[je]), ie[je] = bt, this.shapeModifiers.push(bt)), ot.push(bt)) : ce[je].ty === "rp" && (vt ? (bt = ie[je], bt.closed = !0) : (bt = ShapeModifiers.getModifier(ce[je].ty), ie[je] = bt, bt.init(this, ce, je, ie), this.shapeModifiers.push(bt), we = !1), ot.push(bt));
        this.addProcessedElement(ce[je], je + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(Xe), Ue = ot.length, je = 0; je < Ue; je += 1)
        ot[je].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(ce, ie) {
      (ce._opMdf || ie.op._mdf || this._isFirstFrame) && (ie.opacity = ce.opacity, ie.opacity *= ie.op.v, ie._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var ce, ie = this.stylesList.length, me, we, Re, je, Ue, qe, Ge = this.globalData.renderer, Xe = this.globalData.canvasContext, ot, vt;
      for (ce = 0; ce < ie; ce += 1)
        if (vt = this.stylesList[ce], ot = vt.type, !((ot === "st" || ot === "gs") && vt.wi === 0 || !vt.data._shouldRender || vt.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (Ge.save(), Ue = vt.elements, ot === "st" || ot === "gs" ? (Ge.ctxStrokeStyle(ot === "st" ? vt.co : vt.grd), Ge.ctxLineWidth(vt.wi), Ge.ctxLineCap(vt.lc), Ge.ctxLineJoin(vt.lj), Ge.ctxMiterLimit(vt.ml || 0)) : Ge.ctxFillStyle(ot === "fl" ? vt.co : vt.grd), Ge.ctxOpacity(vt.coOp), ot !== "st" && ot !== "gs" && Xe.beginPath(), Ge.ctxTransform(vt.preTransforms.finalTransform.props), we = Ue.length, me = 0; me < we; me += 1) {
            for ((ot === "st" || ot === "gs") && (Xe.beginPath(), vt.da && (Xe.setLineDash(vt.da), Xe.lineDashOffset = vt.do)), qe = Ue[me].trNodes, je = qe.length, Re = 0; Re < je; Re += 1)
              qe[Re].t === "m" ? Xe.moveTo(qe[Re].p[0], qe[Re].p[1]) : qe[Re].t === "c" ? Xe.bezierCurveTo(qe[Re].pts[0], qe[Re].pts[1], qe[Re].pts[2], qe[Re].pts[3], qe[Re].pts[4], qe[Re].pts[5]) : Xe.closePath();
            (ot === "st" || ot === "gs") && (Ge.ctxStroke(), vt.da && Xe.setLineDash(this.dashResetter));
          }
          ot !== "st" && ot !== "gs" && this.globalData.renderer.ctxFill(vt.r), Ge.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(ce, ie, me, we) {
      var Re, je = ie.length - 1, Ue;
      for (Ue = ce, Re = je; Re >= 0; Re -= 1)
        ie[Re].ty === "tr" ? (Ue = me[Re].transform, this.renderShapeTransform(ce, Ue)) : ie[Re].ty === "sh" || ie[Re].ty === "el" || ie[Re].ty === "rc" || ie[Re].ty === "sr" ? this.renderPath(ie[Re], me[Re]) : ie[Re].ty === "fl" ? this.renderFill(ie[Re], me[Re], Ue) : ie[Re].ty === "st" ? this.renderStroke(ie[Re], me[Re], Ue) : ie[Re].ty === "gf" || ie[Re].ty === "gs" ? this.renderGradientFill(ie[Re], me[Re], Ue) : ie[Re].ty === "gr" ? this.renderShape(Ue, ie[Re].it, me[Re].it) : ie[Re].ty;
      we && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(ce, ie) {
      if (this._isFirstFrame || ie._mdf || ce.transforms._mdf) {
        var me = ce.trNodes, we = ie.paths, Re, je, Ue, qe = we._length;
        me.length = 0;
        var Ge = ce.transforms.finalTransform;
        for (Ue = 0; Ue < qe; Ue += 1) {
          var Xe = we.shapes[Ue];
          if (Xe && Xe.v) {
            for (je = Xe._length, Re = 1; Re < je; Re += 1)
              Re === 1 && me.push({
                t: "m",
                p: Ge.applyToPointArray(Xe.v[0][0], Xe.v[0][1], 0)
              }), me.push({
                t: "c",
                pts: Ge.applyToTriplePoints(Xe.o[Re - 1], Xe.i[Re], Xe.v[Re])
              });
            je === 1 && me.push({
              t: "m",
              p: Ge.applyToPointArray(Xe.v[0][0], Xe.v[0][1], 0)
            }), Xe.c && je && (me.push({
              t: "c",
              pts: Ge.applyToTriplePoints(Xe.o[Re - 1], Xe.i[0], Xe.v[0])
            }), me.push({
              t: "z"
            }));
          }
        }
        ce.trNodes = me;
      }
    }, CVShapeElement.prototype.renderPath = function(ce, ie) {
      if (ce.hd !== !0 && ce._shouldRender) {
        var me, we = ie.styledShapes.length;
        for (me = 0; me < we; me += 1)
          this.renderStyledShape(ie.styledShapes[me], ie.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(ce, ie, me) {
      var we = ie.style;
      (ie.c._mdf || this._isFirstFrame) && (we.co = "rgb(" + bmFloor(ie.c.v[0]) + "," + bmFloor(ie.c.v[1]) + "," + bmFloor(ie.c.v[2]) + ")"), (ie.o._mdf || me._opMdf || this._isFirstFrame) && (we.coOp = ie.o.v * me.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(ce, ie, me) {
      var we = ie.style, Re;
      if (!we.grd || ie.g._mdf || ie.s._mdf || ie.e._mdf || ce.t !== 1 && (ie.h._mdf || ie.a._mdf)) {
        var je = this.globalData.canvasContext, Ue = ie.s.v, qe = ie.e.v;
        if (ce.t === 1)
          Re = je.createLinearGradient(Ue[0], Ue[1], qe[0], qe[1]);
        else {
          var Ge = Math.sqrt(Math.pow(Ue[0] - qe[0], 2) + Math.pow(Ue[1] - qe[1], 2)), Xe = Math.atan2(qe[1] - Ue[1], qe[0] - Ue[0]), ot = ie.h.v;
          ot >= 1 ? ot = 0.99 : ot <= -1 && (ot = -0.99);
          var vt = Ge * ot, bt = Math.cos(Xe + ie.a.v) * vt + Ue[0], Tt = Math.sin(Xe + ie.a.v) * vt + Ue[1];
          Re = je.createRadialGradient(bt, Tt, 0, Ue[0], Ue[1], Ge);
        }
        var wt, St = ce.g.p, It = ie.g.c, Pt = 1;
        for (wt = 0; wt < St; wt += 1)
          ie.g._hasOpacity && ie.g._collapsable && (Pt = ie.g.o[wt * 2 + 1]), Re.addColorStop(It[wt * 4] / 100, "rgba(" + It[wt * 4 + 1] + "," + It[wt * 4 + 2] + "," + It[wt * 4 + 3] + "," + Pt + ")");
        we.grd = Re;
      }
      we.coOp = ie.o.v * me.opacity;
    }, CVShapeElement.prototype.renderStroke = function(ce, ie, me) {
      var we = ie.style, Re = ie.d;
      Re && (Re._mdf || this._isFirstFrame) && (we.da = Re.dashArray, we.do = Re.dashoffset[0]), (ie.c._mdf || this._isFirstFrame) && (we.co = "rgb(" + bmFloor(ie.c.v[0]) + "," + bmFloor(ie.c.v[1]) + "," + bmFloor(ie.c.v[2]) + ")"), (ie.o._mdf || me._opMdf || this._isFirstFrame) && (we.coOp = ie.o.v * me.opacity), (ie.w._mdf || this._isFirstFrame) && (we.wi = ie.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(ce, ie, me) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var ce = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(ce.l ? ce.l.length : 0);
      var ie = !1;
      ce.fc ? (ie = !0, this.values.fill = this.buildColor(ce.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = ie;
      var me = !1;
      ce.sc && (me = !0, this.values.stroke = this.buildColor(ce.sc), this.values.sWidth = ce.sw);
      var we = this.globalData.fontManager.getFontByName(ce.f), Re, je, Ue = ce.l, qe = this.mHelper;
      this.stroke = me, this.values.fValue = ce.finalSize + "px " + this.globalData.fontManager.getFontByName(ce.f).fFamily, je = ce.finalText.length;
      var Ge, Xe, ot, vt, bt, Tt, wt, St, It, Pt, kt = this.data.singleShape, Ot = ce.tr * 1e-3 * ce.finalSize, Jr = 0, en = 0, nn = !0, ln = 0;
      for (Re = 0; Re < je; Re += 1) {
        Ge = this.globalData.fontManager.getCharData(ce.finalText[Re], we.fStyle, this.globalData.fontManager.getFontByName(ce.f).fFamily), Xe = Ge && Ge.data || {}, qe.reset(), kt && Ue[Re].n && (Jr = -Ot, en += ce.yOffset, en += nn ? 1 : 0, nn = !1), bt = Xe.shapes ? Xe.shapes[0].it : [], wt = bt.length, qe.scale(ce.finalSize / 100, ce.finalSize / 100), kt && this.applyTextPropertiesToMatrix(ce, qe, Ue[Re].line, Jr, en), It = createSizedArray(wt - 1);
        var fn = 0;
        for (Tt = 0; Tt < wt; Tt += 1)
          if (bt[Tt].ty === "sh") {
            for (vt = bt[Tt].ks.k.i.length, St = bt[Tt].ks.k, Pt = [], ot = 1; ot < vt; ot += 1)
              ot === 1 && Pt.push(qe.applyToX(St.v[0][0], St.v[0][1], 0), qe.applyToY(St.v[0][0], St.v[0][1], 0)), Pt.push(qe.applyToX(St.o[ot - 1][0], St.o[ot - 1][1], 0), qe.applyToY(St.o[ot - 1][0], St.o[ot - 1][1], 0), qe.applyToX(St.i[ot][0], St.i[ot][1], 0), qe.applyToY(St.i[ot][0], St.i[ot][1], 0), qe.applyToX(St.v[ot][0], St.v[ot][1], 0), qe.applyToY(St.v[ot][0], St.v[ot][1], 0));
            Pt.push(qe.applyToX(St.o[ot - 1][0], St.o[ot - 1][1], 0), qe.applyToY(St.o[ot - 1][0], St.o[ot - 1][1], 0), qe.applyToX(St.i[0][0], St.i[0][1], 0), qe.applyToY(St.i[0][0], St.i[0][1], 0), qe.applyToX(St.v[0][0], St.v[0][1], 0), qe.applyToY(St.v[0][0], St.v[0][1], 0)), It[fn] = Pt, fn += 1;
          }
        kt && (Jr += Ue[Re].l, Jr += Ot), this.textSpans[ln] ? this.textSpans[ln].elem = It : this.textSpans[ln] = {
          elem: It
        }, ln += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var ce = this.canvasContext;
      ce.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var ie, me, we, Re, je, Ue, qe = this.textAnimator.renderedLetters, Ge = this.textProperty.currentData.l;
      me = Ge.length;
      var Xe, ot = null, vt = null, bt = null, Tt, wt, St = this.globalData.renderer;
      for (ie = 0; ie < me; ie += 1)
        if (!Ge[ie].n) {
          if (Xe = qe[ie], Xe && (St.save(), St.ctxTransform(Xe.p), St.ctxOpacity(Xe.o)), this.fill) {
            for (Xe && Xe.fc ? ot !== Xe.fc && (St.ctxFillStyle(Xe.fc), ot = Xe.fc) : ot !== this.values.fill && (ot = this.values.fill, St.ctxFillStyle(this.values.fill)), Tt = this.textSpans[ie].elem, Re = Tt.length, this.globalData.canvasContext.beginPath(), we = 0; we < Re; we += 1)
              for (wt = Tt[we], Ue = wt.length, this.globalData.canvasContext.moveTo(wt[0], wt[1]), je = 2; je < Ue; je += 6)
                this.globalData.canvasContext.bezierCurveTo(wt[je], wt[je + 1], wt[je + 2], wt[je + 3], wt[je + 4], wt[je + 5]);
            this.globalData.canvasContext.closePath(), St.ctxFill();
          }
          if (this.stroke) {
            for (Xe && Xe.sw ? bt !== Xe.sw && (bt = Xe.sw, St.ctxLineWidth(Xe.sw)) : bt !== this.values.sWidth && (bt = this.values.sWidth, St.ctxLineWidth(this.values.sWidth)), Xe && Xe.sc ? vt !== Xe.sc && (vt = Xe.sc, St.ctxStrokeStyle(Xe.sc)) : vt !== this.values.stroke && (vt = this.values.stroke, St.ctxStrokeStyle(this.values.stroke)), Tt = this.textSpans[ie].elem, Re = Tt.length, this.globalData.canvasContext.beginPath(), we = 0; we < Re; we += 1)
              for (wt = Tt[we], Ue = wt.length, this.globalData.canvasContext.moveTo(wt[0], wt[1]), je = 2; je < Ue; je += 6)
                this.globalData.canvasContext.bezierCurveTo(wt[je], wt[je + 1], wt[je + 2], wt[je + 3], wt[je + 4], wt[je + 5]);
            this.globalData.canvasContext.closePath(), St.ctxStroke();
          }
          Xe && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(ce, ie, me) {
      this.assetData = ie.getAssetData(ce.refId), this.img = ie.imageLoader.getAsset(this.assetData), this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var ce = createTag("canvas");
        ce.width = this.assetData.w, ce.height = this.assetData.h;
        var ie = ce.getContext("2d"), me = this.img.width, we = this.img.height, Re = me / we, je = this.assetData.w / this.assetData.h, Ue, qe, Ge = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        Re > je && Ge === "xMidYMid slice" || Re < je && Ge !== "xMidYMid slice" ? (qe = we, Ue = qe * je) : (Ue = me, qe = Ue / je), ie.drawImage(this.img, (me - Ue) / 2, (we - qe) / 2, Ue, qe, 0, 0, this.assetData.w, this.assetData.h), this.img = ce;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(ce, ie, me) {
      this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(ce) {
      return new CVShapeElement(ce, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(ce) {
      return new CVTextElement(ce, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(ce) {
      return new CVImageElement(ce, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(ce) {
      return new CVSolidElement(ce, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(ce) {
      ce[0] === 1 && ce[1] === 0 && ce[4] === 0 && ce[5] === 1 && ce[12] === 0 && ce[13] === 0 || this.canvasContext.transform(ce[0], ce[1], ce[4], ce[5], ce[12], ce[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(ce) {
      this.canvasContext.globalAlpha *= ce < 0 ? 0 : ce;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(ce) {
      this.canvasContext.fillStyle = ce;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(ce) {
      this.canvasContext.strokeStyle = ce;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(ce) {
      this.canvasContext.lineWidth = ce;
    }, CanvasRendererBase.prototype.ctxLineCap = function(ce) {
      this.canvasContext.lineCap = ce;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(ce) {
      this.canvasContext.lineJoin = ce;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(ce) {
      this.canvasContext.miterLimit = ce;
    }, CanvasRendererBase.prototype.ctxFill = function(ce) {
      this.canvasContext.fill(ce);
    }, CanvasRendererBase.prototype.ctxFillRect = function(ce, ie, me, we) {
      this.canvasContext.fillRect(ce, ie, me, we);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(ce) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      ce && (this.globalData.blendMode = "source-over"), this.contextData.restore(ce);
    }, CanvasRendererBase.prototype.configAnimation = function(ce) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var ie = this.animationItem.container.style;
        ie.width = "100%", ie.height = "100%";
        var me = "0px 0px 0px";
        ie.transformOrigin = me, ie.mozTransformOrigin = me, ie.webkitTransformOrigin = me, ie["-webkit-transform"] = me, ie.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = ce, this.layers = ce.layers, this.transformCanvas = {
        w: ce.w,
        h: ce.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(ce, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(ce.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(ce, ie) {
      this.reset();
      var me, we;
      ce ? (me = ce, we = ie, this.canvasContext.canvas.width = me, this.canvasContext.canvas.height = we) : (this.animationItem.wrapper && this.animationItem.container ? (me = this.animationItem.wrapper.offsetWidth, we = this.animationItem.wrapper.offsetHeight) : (me = this.canvasContext.canvas.width, we = this.canvasContext.canvas.height), this.canvasContext.canvas.width = me * this.renderConfig.dpr, this.canvasContext.canvas.height = we * this.renderConfig.dpr);
      var Re, je;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var Ue = this.renderConfig.preserveAspectRatio.split(" "), qe = Ue[1] || "meet", Ge = Ue[0] || "xMidYMid", Xe = Ge.substr(0, 4), ot = Ge.substr(4);
        Re = me / we, je = this.transformCanvas.w / this.transformCanvas.h, je > Re && qe === "meet" || je < Re && qe === "slice" ? (this.transformCanvas.sx = me / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = me / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = we / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = we / (this.transformCanvas.h / this.renderConfig.dpr)), Xe === "xMid" && (je < Re && qe === "meet" || je > Re && qe === "slice") ? this.transformCanvas.tx = (me - this.transformCanvas.w * (we / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : Xe === "xMax" && (je < Re && qe === "meet" || je > Re && qe === "slice") ? this.transformCanvas.tx = (me - this.transformCanvas.w * (we / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, ot === "YMid" && (je > Re && qe === "meet" || je < Re && qe === "slice") ? this.transformCanvas.ty = (we - this.transformCanvas.h * (me / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : ot === "YMax" && (je > Re && qe === "meet" || je < Re && qe === "slice") ? this.transformCanvas.ty = (we - this.transformCanvas.h * (me / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = me / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = we / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var ce, ie = this.layers ? this.layers.length : 0;
      for (ce = ie - 1; ce >= 0; ce -= 1)
        this.elements[ce] && this.elements[ce].destroy && this.elements[ce].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(ce, ie) {
      if (!(this.renderedFrame === ce && this.renderConfig.clearCanvas === !0 && !ie || this.destroyed || ce === -1)) {
        this.renderedFrame = ce, this.globalData.frameNum = ce - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || ie, this.globalData.projectInterface.currentFrame = ce;
        var me, we = this.layers.length;
        for (this.completeLayers || this.checkLayers(ce), me = we - 1; me >= 0; me -= 1)
          (this.completeLayers || this.elements[me]) && this.elements[me].prepareFrame(ce - this.layers[me].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), me = we - 1; me >= 0; me -= 1)
            (this.completeLayers || this.elements[me]) && this.elements[me].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(ce) {
      var ie = this.elements;
      if (!(ie[ce] || this.layers[ce].ty === 99)) {
        var me = this.createItem(this.layers[ce], this, this.globalData);
        ie[ce] = me, me.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var ce = this.pendingElements.pop();
        ce.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var ce, ie = 15;
      for (ce = 0; ce < ie; ce += 1) {
        var me = new CanvasContext();
        this.stack[ce] = me;
      }
      this._length = ie, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var ce = this._length * 2, ie = 0;
      for (ie = this._length; ie < ce; ie += 1)
        this.stack[ie] = new CanvasContext();
      this._length = ce;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(ce) {
      this.cArrPos -= 1;
      var ie = this.stack[this.cArrPos], me = ie.transform, we, Re = this.cTr.props;
      for (we = 0; we < 16; we += 1)
        Re[we] = me[we];
      if (ce) {
        this.nativeContext.restore();
        var je = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = je.fillStyle, this.appliedStrokeStyle = je.strokeStyle, this.appliedLineWidth = je.lineWidth, this.appliedLineCap = je.lineCap, this.appliedLineJoin = je.lineJoin, this.appliedMiterLimit = je.miterLimit;
      }
      this.nativeContext.setTransform(me[0], me[1], me[4], me[5], me[12], me[13]), (ce || ie.opacity !== -1 && this.currentOpacity !== ie.opacity) && (this.nativeContext.globalAlpha = ie.opacity, this.currentOpacity = ie.opacity), this.currentFillStyle = ie.fillStyle, this.currentStrokeStyle = ie.strokeStyle, this.currentLineWidth = ie.lineWidth, this.currentLineCap = ie.lineCap, this.currentLineJoin = ie.lineJoin, this.currentMiterLimit = ie.miterLimit;
    }, CVContextData.prototype.save = function(ce) {
      ce && this.nativeContext.save();
      var ie = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var me = this.stack[this.cArrPos], we;
      for (we = 0; we < 16; we += 1)
        me.transform[we] = ie[we];
      this.cArrPos += 1;
      var Re = this.stack[this.cArrPos];
      Re.opacity = me.opacity, Re.fillStyle = me.fillStyle, Re.strokeStyle = me.strokeStyle, Re.lineWidth = me.lineWidth, Re.lineCap = me.lineCap, Re.lineJoin = me.lineJoin, Re.miterLimit = me.miterLimit;
    }, CVContextData.prototype.setOpacity = function(ce) {
      this.stack[this.cArrPos].opacity = ce;
    }, CVContextData.prototype.setContext = function(ce) {
      this.nativeContext = ce;
    }, CVContextData.prototype.fillStyle = function(ce) {
      this.stack[this.cArrPos].fillStyle !== ce && (this.currentFillStyle = ce, this.stack[this.cArrPos].fillStyle = ce);
    }, CVContextData.prototype.strokeStyle = function(ce) {
      this.stack[this.cArrPos].strokeStyle !== ce && (this.currentStrokeStyle = ce, this.stack[this.cArrPos].strokeStyle = ce);
    }, CVContextData.prototype.lineWidth = function(ce) {
      this.stack[this.cArrPos].lineWidth !== ce && (this.currentLineWidth = ce, this.stack[this.cArrPos].lineWidth = ce);
    }, CVContextData.prototype.lineCap = function(ce) {
      this.stack[this.cArrPos].lineCap !== ce && (this.currentLineCap = ce, this.stack[this.cArrPos].lineCap = ce);
    }, CVContextData.prototype.lineJoin = function(ce) {
      this.stack[this.cArrPos].lineJoin !== ce && (this.currentLineJoin = ce, this.stack[this.cArrPos].lineJoin = ce);
    }, CVContextData.prototype.miterLimit = function(ce) {
      this.stack[this.cArrPos].miterLimit !== ce && (this.currentMiterLimit = ce, this.stack[this.cArrPos].miterLimit = ce);
    }, CVContextData.prototype.transform = function(ce) {
      this.transformMat.cloneFromProps(ce);
      var ie = this.cTr;
      this.transformMat.multiply(ie), ie.cloneFromProps(this.transformMat.props);
      var me = ie.props;
      this.nativeContext.setTransform(me[0], me[1], me[4], me[5], me[12], me[13]);
    }, CVContextData.prototype.opacity = function(ce) {
      var ie = this.stack[this.cArrPos].opacity;
      ie *= ce < 0 ? 0 : ce, this.stack[this.cArrPos].opacity !== ie && (this.currentOpacity !== ce && (this.nativeContext.globalAlpha = ce, this.currentOpacity = ce), this.stack[this.cArrPos].opacity = ie);
    }, CVContextData.prototype.fill = function(ce) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(ce);
    }, CVContextData.prototype.fillRect = function(ce, ie, me, we) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(ce, ie, me, we);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(ce, ie, me) {
      this.completeLayers = !1, this.layers = ce.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(ce, ie, me), this.tm = ce.tm ? PropertyFactory.getProp(this, ce.tm, 0, ie.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var ce = this.canvasContext;
      ce.beginPath(), ce.moveTo(0, 0), ce.lineTo(this.data.w, 0), ce.lineTo(this.data.w, this.data.h), ce.lineTo(0, this.data.h), ce.lineTo(0, 0), ce.clip();
      var ie, me = this.layers.length;
      for (ie = me - 1; ie >= 0; ie -= 1)
        (this.completeLayers || this.elements[ie]) && this.elements[ie].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var ce, ie = this.layers.length;
      for (ce = ie - 1; ce >= 0; ce -= 1)
        this.elements[ce] && this.elements[ce].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(ce) {
      return new CVCompElement(ce, this.globalData, this);
    };
    function CanvasRenderer(ce, ie) {
      this.animationItem = ce, this.renderConfig = {
        clearCanvas: ie && ie.clearCanvas !== void 0 ? ie.clearCanvas : !0,
        context: ie && ie.context || null,
        progressiveLoad: ie && ie.progressiveLoad || !1,
        preserveAspectRatio: ie && ie.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: ie && ie.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: ie && ie.contentVisibility || "visible",
        className: ie && ie.className || "",
        id: ie && ie.id || "",
        runExpressions: !ie || ie.runExpressions === void 0 || ie.runExpressions
      }, this.renderConfig.dpr = ie && ie.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = ie && ie.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(ce) {
      return new CVCompElement(ce, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var ie = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var me = this.finalTransform.mat.toCSS();
          ie.transform = me, ie.webkitTransform = me;
        }
        this.finalTransform._opMdf && (ie.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(ce, ie, me) {
      this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var ce;
      this.data.hasMask ? (ce = createNS("rect"), ce.setAttribute("width", this.data.sw), ce.setAttribute("height", this.data.sh), ce.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (ce = createTag("div"), ce.style.width = this.data.sw + "px", ce.style.height = this.data.sh + "px", ce.style.backgroundColor = this.data.sc), this.layerElement.appendChild(ce);
    };
    function HShapeElement(ce, ie, me) {
      this.shapes = [], this.shapesData = ce.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(ce, ie, me), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var ce;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), ce = this.svgElement;
      else {
        ce = createNS("svg");
        var ie = this.comp.data ? this.comp.data : this.globalData.compSize;
        ce.setAttribute("width", ie.w), ce.setAttribute("height", ie.h), ce.appendChild(this.shapesContainer), this.layerElement.appendChild(ce);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = ce;
    }, HShapeElement.prototype.getTransformedPoint = function(ce, ie) {
      var me, we = ce.length;
      for (me = 0; me < we; me += 1)
        ie = ce[me].mProps.v.applyToPointArray(ie[0], ie[1], 0);
      return ie;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(ce, ie) {
      var me = ce.sh.v, we = ce.transformers, Re, je = me._length, Ue, qe, Ge, Xe;
      if (!(je <= 1)) {
        for (Re = 0; Re < je - 1; Re += 1)
          Ue = this.getTransformedPoint(we, me.v[Re]), qe = this.getTransformedPoint(we, me.o[Re]), Ge = this.getTransformedPoint(we, me.i[Re + 1]), Xe = this.getTransformedPoint(we, me.v[Re + 1]), this.checkBounds(Ue, qe, Ge, Xe, ie);
        me.c && (Ue = this.getTransformedPoint(we, me.v[Re]), qe = this.getTransformedPoint(we, me.o[Re]), Ge = this.getTransformedPoint(we, me.i[0]), Xe = this.getTransformedPoint(we, me.v[0]), this.checkBounds(Ue, qe, Ge, Xe, ie));
      }
    }, HShapeElement.prototype.checkBounds = function(ce, ie, me, we, Re) {
      this.getBoundsOfCurve(ce, ie, me, we);
      var je = this.shapeBoundingBox;
      Re.x = bmMin(je.left, Re.x), Re.xMax = bmMax(je.right, Re.xMax), Re.y = bmMin(je.top, Re.y), Re.yMax = bmMax(je.bottom, Re.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(ce, ie, me, we) {
      for (var Re = [[ce[0], we[0]], [ce[1], we[1]]], je, Ue, qe, Ge, Xe, ot, vt, bt = 0; bt < 2; ++bt)
        Ue = 6 * ce[bt] - 12 * ie[bt] + 6 * me[bt], je = -3 * ce[bt] + 9 * ie[bt] - 9 * me[bt] + 3 * we[bt], qe = 3 * ie[bt] - 3 * ce[bt], Ue |= 0, je |= 0, qe |= 0, je === 0 && Ue === 0 || (je === 0 ? (Ge = -qe / Ue, Ge > 0 && Ge < 1 && Re[bt].push(this.calculateF(Ge, ce, ie, me, we, bt))) : (Xe = Ue * Ue - 4 * qe * je, Xe >= 0 && (ot = (-Ue + bmSqrt(Xe)) / (2 * je), ot > 0 && ot < 1 && Re[bt].push(this.calculateF(ot, ce, ie, me, we, bt)), vt = (-Ue - bmSqrt(Xe)) / (2 * je), vt > 0 && vt < 1 && Re[bt].push(this.calculateF(vt, ce, ie, me, we, bt)))));
      this.shapeBoundingBox.left = bmMin.apply(null, Re[0]), this.shapeBoundingBox.top = bmMin.apply(null, Re[1]), this.shapeBoundingBox.right = bmMax.apply(null, Re[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, Re[1]);
    }, HShapeElement.prototype.calculateF = function(ce, ie, me, we, Re, je) {
      return bmPow(1 - ce, 3) * ie[je] + 3 * bmPow(1 - ce, 2) * ce * me[je] + 3 * (1 - ce) * bmPow(ce, 2) * we[je] + bmPow(ce, 3) * Re[je];
    }, HShapeElement.prototype.calculateBoundingBox = function(ce, ie) {
      var me, we = ce.length;
      for (me = 0; me < we; me += 1)
        ce[me] && ce[me].sh ? this.calculateShapeBoundingBox(ce[me], ie) : ce[me] && ce[me].it ? this.calculateBoundingBox(ce[me].it, ie) : ce[me] && ce[me].style && ce[me].w && this.expandStrokeBoundingBox(ce[me].w, ie);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(ce, ie) {
      var me = 0;
      if (ce.keyframes) {
        for (var we = 0; we < ce.keyframes.length; we += 1) {
          var Re = ce.keyframes[we].s;
          Re > me && (me = Re);
        }
        me *= ce.mult;
      } else
        me = ce.v * ce.mult;
      ie.x -= me, ie.xMax += me, ie.y -= me, ie.yMax += me;
    }, HShapeElement.prototype.currentBoxContains = function(ce) {
      return this.currentBBox.x <= ce.x && this.currentBBox.y <= ce.y && this.currentBBox.width + this.currentBBox.x >= ce.x + ce.width && this.currentBBox.height + this.currentBBox.y >= ce.y + ce.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var ce = this.tempBoundingBox, ie = 999999;
        if (ce.x = ie, ce.xMax = -ie, ce.y = ie, ce.yMax = -ie, this.calculateBoundingBox(this.itemsData, ce), ce.width = ce.xMax < ce.x ? 0 : ce.xMax - ce.x, ce.height = ce.yMax < ce.y ? 0 : ce.yMax - ce.y, this.currentBoxContains(ce))
          return;
        var me = !1;
        if (this.currentBBox.w !== ce.width && (this.currentBBox.w = ce.width, this.shapeCont.setAttribute("width", ce.width), me = !0), this.currentBBox.h !== ce.height && (this.currentBBox.h = ce.height, this.shapeCont.setAttribute("height", ce.height), me = !0), me || this.currentBBox.x !== ce.x || this.currentBBox.y !== ce.y) {
          this.currentBBox.w = ce.width, this.currentBBox.h = ce.height, this.currentBBox.x = ce.x, this.currentBBox.y = ce.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var we = this.shapeCont.style, Re = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          we.transform = Re, we.webkitTransform = Re;
        }
      }
    };
    function HTextElement(ce, ie, me) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var ce = createNS("g");
        this.maskedElement.appendChild(ce), this.innerElem = ce;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var ce = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(ce.l ? ce.l.length : 0);
      var ie = this.innerElem.style, me = ce.fc ? this.buildColor(ce.fc) : "rgba(0,0,0,0)";
      ie.fill = me, ie.color = me, ce.sc && (ie.stroke = this.buildColor(ce.sc), ie.strokeWidth = ce.sw + "px");
      var we = this.globalData.fontManager.getFontByName(ce.f);
      if (!this.globalData.fontManager.chars)
        if (ie.fontSize = ce.finalSize + "px", ie.lineHeight = ce.finalSize + "px", we.fClass)
          this.innerElem.className = we.fClass;
        else {
          ie.fontFamily = we.fFamily;
          var Re = ce.fWeight, je = ce.fStyle;
          ie.fontStyle = je, ie.fontWeight = Re;
        }
      var Ue, qe, Ge = ce.l;
      qe = Ge.length;
      var Xe, ot, vt, bt = this.mHelper, Tt, wt = "", St = 0;
      for (Ue = 0; Ue < qe; Ue += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[St] ? Xe = this.textPaths[St] : (Xe = createNS("path"), Xe.setAttribute("stroke-linecap", lineCapEnum[1]), Xe.setAttribute("stroke-linejoin", lineJoinEnum[2]), Xe.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[St] ? (ot = this.textSpans[St], vt = ot.children[0]) : (ot = createTag("div"), ot.style.lineHeight = 0, vt = createNS("svg"), vt.appendChild(Xe), styleDiv(ot)))) : this.isMasked ? Xe = this.textPaths[St] ? this.textPaths[St] : createNS("text") : this.textSpans[St] ? (ot = this.textSpans[St], Xe = this.textPaths[St]) : (ot = createTag("span"), styleDiv(ot), Xe = createTag("span"), styleDiv(Xe), ot.appendChild(Xe)), this.globalData.fontManager.chars) {
          var It = this.globalData.fontManager.getCharData(ce.finalText[Ue], we.fStyle, this.globalData.fontManager.getFontByName(ce.f).fFamily), Pt;
          if (It ? Pt = It.data : Pt = null, bt.reset(), Pt && Pt.shapes && Pt.shapes.length && (Tt = Pt.shapes[0].it, bt.scale(ce.finalSize / 100, ce.finalSize / 100), wt = this.createPathShape(bt, Tt), Xe.setAttribute("d", wt)), this.isMasked)
            this.innerElem.appendChild(Xe);
          else {
            if (this.innerElem.appendChild(ot), Pt && Pt.shapes) {
              document.body.appendChild(vt);
              var kt = vt.getBBox();
              vt.setAttribute("width", kt.width + 2), vt.setAttribute("height", kt.height + 2), vt.setAttribute("viewBox", kt.x - 1 + " " + (kt.y - 1) + " " + (kt.width + 2) + " " + (kt.height + 2));
              var Ot = vt.style, Jr = "translate(" + (kt.x - 1) + "px," + (kt.y - 1) + "px)";
              Ot.transform = Jr, Ot.webkitTransform = Jr, Ge[Ue].yOffset = kt.y - 1;
            } else
              vt.setAttribute("width", 1), vt.setAttribute("height", 1);
            ot.appendChild(vt);
          }
        } else if (Xe.textContent = Ge[Ue].val, Xe.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(Xe);
        else {
          this.innerElem.appendChild(ot);
          var en = Xe.style, nn = "translate3d(0," + -ce.finalSize / 1.2 + "px,0)";
          en.transform = nn, en.webkitTransform = nn;
        }
        this.isMasked ? this.textSpans[St] = Xe : this.textSpans[St] = ot, this.textSpans[St].style.display = "block", this.textPaths[St] = Xe, St += 1;
      }
      for (; St < this.textSpans.length; )
        this.textSpans[St].style.display = "none", St += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var ce;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), ce = this.svgElement.style;
          var ie = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          ce.transform = ie, ce.webkitTransform = ie;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var me, we, Re = 0, je = this.textAnimator.renderedLetters, Ue = this.textProperty.currentData.l;
        we = Ue.length;
        var qe, Ge, Xe;
        for (me = 0; me < we; me += 1)
          Ue[me].n ? Re += 1 : (Ge = this.textSpans[me], Xe = this.textPaths[me], qe = je[Re], Re += 1, qe._mdf.m && (this.isMasked ? Ge.setAttribute("transform", qe.m) : (Ge.style.webkitTransform = qe.m, Ge.style.transform = qe.m)), Ge.style.opacity = qe.o, qe.sw && qe._mdf.sw && Xe.setAttribute("stroke-width", qe.sw), qe.sc && qe._mdf.sc && Xe.setAttribute("stroke", qe.sc), qe.fc && qe._mdf.fc && (Xe.setAttribute("fill", qe.fc), Xe.style.color = qe.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var ot = this.innerElem.getBBox();
          this.currentBBox.w !== ot.width && (this.currentBBox.w = ot.width, this.svgElement.setAttribute("width", ot.width)), this.currentBBox.h !== ot.height && (this.currentBBox.h = ot.height, this.svgElement.setAttribute("height", ot.height));
          var vt = 1;
          if (this.currentBBox.w !== ot.width + vt * 2 || this.currentBBox.h !== ot.height + vt * 2 || this.currentBBox.x !== ot.x - vt || this.currentBBox.y !== ot.y - vt) {
            this.currentBBox.w = ot.width + vt * 2, this.currentBBox.h = ot.height + vt * 2, this.currentBBox.x = ot.x - vt, this.currentBBox.y = ot.y - vt, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), ce = this.svgElement.style;
            var bt = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            ce.transform = bt, ce.webkitTransform = bt;
          }
        }
      }
    };
    function HCameraElement(ce, ie, me) {
      this.initFrame(), this.initBaseData(ce, ie, me), this.initHierarchy();
      var we = PropertyFactory.getProp;
      if (this.pe = we(this, ce.pe, 0, 0, this), ce.ks.p.s ? (this.px = we(this, ce.ks.p.x, 1, 0, this), this.py = we(this, ce.ks.p.y, 1, 0, this), this.pz = we(this, ce.ks.p.z, 1, 0, this)) : this.p = we(this, ce.ks.p, 1, 0, this), ce.ks.a && (this.a = we(this, ce.ks.a, 1, 0, this)), ce.ks.or.k.length && ce.ks.or.k[0].to) {
        var Re, je = ce.ks.or.k.length;
        for (Re = 0; Re < je; Re += 1)
          ce.ks.or.k[Re].to = null, ce.ks.or.k[Re].ti = null;
      }
      this.or = we(this, ce.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = we(this, ce.ks.rx, 0, degToRads, this), this.ry = we(this, ce.ks.ry, 0, degToRads, this), this.rz = we(this, ce.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var ce, ie = this.comp.threeDElements.length, me, we, Re;
      for (ce = 0; ce < ie; ce += 1)
        if (me = this.comp.threeDElements[ce], me.type === "3d") {
          we = me.perspectiveElem.style, Re = me.container.style;
          var je = this.pe.v + "px", Ue = "0px 0px 0px", qe = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          we.perspective = je, we.webkitPerspective = je, Re.transformOrigin = Ue, Re.mozTransformOrigin = Ue, Re.webkitTransformOrigin = Ue, we.transform = qe, we.webkitTransform = qe;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var ce = this._isFirstFrame, ie, me;
      if (this.hierarchy)
        for (me = this.hierarchy.length, ie = 0; ie < me; ie += 1)
          ce = this.hierarchy[ie].finalTransform.mProp._mdf || ce;
      if (ce || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (me = this.hierarchy.length - 1, ie = me; ie >= 0; ie -= 1) {
            var we = this.hierarchy[ie].finalTransform.mProp;
            this.mat.translate(-we.p.v[0], -we.p.v[1], we.p.v[2]), this.mat.rotateX(-we.or.v[0]).rotateY(-we.or.v[1]).rotateZ(we.or.v[2]), this.mat.rotateX(-we.rx.v).rotateY(-we.ry.v).rotateZ(we.rz.v), this.mat.scale(1 / we.s.v[0], 1 / we.s.v[1], 1 / we.s.v[2]), this.mat.translate(we.a.v[0], we.a.v[1], we.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var Re;
          this.p ? Re = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : Re = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var je = Math.sqrt(Math.pow(Re[0], 2) + Math.pow(Re[1], 2) + Math.pow(Re[2], 2)), Ue = [Re[0] / je, Re[1] / je, Re[2] / je], qe = Math.sqrt(Ue[2] * Ue[2] + Ue[0] * Ue[0]), Ge = Math.atan2(Ue[1], qe), Xe = Math.atan2(Ue[0], -Ue[2]);
          this.mat.rotateY(Xe).rotateX(-Ge);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var ot = !this._prevMat.equals(this.mat);
        if ((ot || this.pe._mdf) && this.comp.threeDElements) {
          me = this.comp.threeDElements.length;
          var vt, bt, Tt;
          for (ie = 0; ie < me; ie += 1)
            if (vt = this.comp.threeDElements[ie], vt.type === "3d") {
              if (ot) {
                var wt = this.mat.toCSS();
                Tt = vt.container.style, Tt.transform = wt, Tt.webkitTransform = wt;
              }
              this.pe._mdf && (bt = vt.perspectiveElem.style, bt.perspective = this.pe.v + "px", bt.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(ce) {
      this.prepareProperties(ce, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(ce, ie, me) {
      this.assetData = ie.getAssetData(ce.refId), this.initElement(ce, ie, me);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var ce = this.globalData.getAssetsPath(this.assetData), ie = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", ce), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(ie), ie.crossOrigin = "anonymous", ie.src = ce, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(ce, ie) {
      this.animationItem = ce, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: ie && ie.className || "",
        imagePreserveAspectRatio: ie && ie.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(ie && ie.hideOnTransparent === !1),
        filterSize: {
          width: ie && ie.filterSize && ie.filterSize.width || "400%",
          height: ie && ie.filterSize && ie.filterSize.height || "400%",
          x: ie && ie.filterSize && ie.filterSize.x || "-100%",
          y: ie && ie.filterSize && ie.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var ce = this.pendingElements.pop();
        ce.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(ce, ie) {
      var me = ce.getBaseElement();
      if (me) {
        var we = this.layers[ie];
        if (!we.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(me, ie);
          else {
            for (var Re = 0, je, Ue, qe; Re < ie; )
              this.elements[Re] && this.elements[Re] !== !0 && this.elements[Re].getBaseElement && (Ue = this.elements[Re], qe = this.layers[Re].ddd ? this.getThreeDContainerByPos(Re) : Ue.getBaseElement(), je = qe || je), Re += 1;
            je ? (!we.ddd || !this.supports3d) && this.layerElement.insertBefore(me, je) : (!we.ddd || !this.supports3d) && this.layerElement.appendChild(me);
          }
        else
          this.addTo3dContainer(me, ie);
      }
    }, HybridRendererBase.prototype.createShape = function(ce) {
      return this.supports3d ? new HShapeElement(ce, this.globalData, this) : new SVGShapeElement(ce, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(ce) {
      return this.supports3d ? new HTextElement(ce, this.globalData, this) : new SVGTextLottieElement(ce, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(ce) {
      return this.camera = new HCameraElement(ce, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(ce) {
      return this.supports3d ? new HImageElement(ce, this.globalData, this) : new IImageElement(ce, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(ce) {
      return this.supports3d ? new HSolidElement(ce, this.globalData, this) : new ISolidElement(ce, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(ce) {
      for (var ie = 0, me = this.threeDElements.length; ie < me; ) {
        if (this.threeDElements[ie].startPos <= ce && this.threeDElements[ie].endPos >= ce)
          return this.threeDElements[ie].perspectiveElem;
        ie += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(ce, ie) {
      var me = createTag("div"), we, Re;
      styleDiv(me);
      var je = createTag("div");
      if (styleDiv(je), ie === "3d") {
        we = me.style, we.width = this.globalData.compSize.w + "px", we.height = this.globalData.compSize.h + "px";
        var Ue = "50% 50%";
        we.webkitTransformOrigin = Ue, we.mozTransformOrigin = Ue, we.transformOrigin = Ue, Re = je.style;
        var qe = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        Re.transform = qe, Re.webkitTransform = qe;
      }
      me.appendChild(je);
      var Ge = {
        container: je,
        perspectiveElem: me,
        startPos: ce,
        endPos: ce,
        type: ie
      };
      return this.threeDElements.push(Ge), Ge;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var ce, ie = this.layers.length, me, we = "";
      for (ce = 0; ce < ie; ce += 1)
        this.layers[ce].ddd && this.layers[ce].ty !== 3 ? (we !== "3d" && (we = "3d", me = this.createThreeDContainer(ce, "3d")), me.endPos = Math.max(me.endPos, ce)) : (we !== "2d" && (we = "2d", me = this.createThreeDContainer(ce, "2d")), me.endPos = Math.max(me.endPos, ce));
      for (ie = this.threeDElements.length, ce = ie - 1; ce >= 0; ce -= 1)
        this.resizerElem.appendChild(this.threeDElements[ce].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(ce, ie) {
      for (var me = 0, we = this.threeDElements.length; me < we; ) {
        if (ie <= this.threeDElements[me].endPos) {
          for (var Re = this.threeDElements[me].startPos, je; Re < ie; )
            this.elements[Re] && this.elements[Re].getBaseElement && (je = this.elements[Re].getBaseElement()), Re += 1;
          je ? this.threeDElements[me].container.insertBefore(ce, je) : this.threeDElements[me].container.appendChild(ce);
          break;
        }
        me += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(ce) {
      var ie = createTag("div"), me = this.animationItem.wrapper, we = ie.style;
      we.width = ce.w + "px", we.height = ce.h + "px", this.resizerElem = ie, styleDiv(ie), we.transformStyle = "flat", we.mozTransformStyle = "flat", we.webkitTransformStyle = "flat", this.renderConfig.className && ie.setAttribute("class", this.renderConfig.className), me.appendChild(ie), we.overflow = "hidden";
      var Re = createNS("svg");
      Re.setAttribute("width", "1"), Re.setAttribute("height", "1"), styleDiv(Re), this.resizerElem.appendChild(Re);
      var je = createNS("defs");
      Re.appendChild(je), this.data = ce, this.setupGlobalData(ce, Re), this.globalData.defs = je, this.layers = ce.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var ce, ie = this.layers ? this.layers.length : 0;
      for (ce = 0; ce < ie; ce += 1)
        this.elements[ce] && this.elements[ce].destroy && this.elements[ce].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var ce = this.animationItem.wrapper.offsetWidth, ie = this.animationItem.wrapper.offsetHeight, me = ce / ie, we = this.globalData.compSize.w / this.globalData.compSize.h, Re, je, Ue, qe;
      we > me ? (Re = ce / this.globalData.compSize.w, je = ce / this.globalData.compSize.w, Ue = 0, qe = (ie - this.globalData.compSize.h * (ce / this.globalData.compSize.w)) / 2) : (Re = ie / this.globalData.compSize.h, je = ie / this.globalData.compSize.h, Ue = (ce - this.globalData.compSize.w * (ie / this.globalData.compSize.h)) / 2, qe = 0);
      var Ge = this.resizerElem.style;
      Ge.webkitTransform = "matrix3d(" + Re + ",0,0,0,0," + je + ",0,0,0,0,1,0," + Ue + "," + qe + ",0,1)", Ge.transform = Ge.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var ce = this.globalData.compSize.w, ie = this.globalData.compSize.h, me, we = this.threeDElements.length;
        for (me = 0; me < we; me += 1) {
          var Re = this.threeDElements[me].perspectiveElem.style;
          Re.webkitPerspective = Math.sqrt(Math.pow(ce, 2) + Math.pow(ie, 2)) + "px", Re.perspective = Re.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(ce) {
      var ie, me = ce.length, we = createTag("div");
      for (ie = 0; ie < me; ie += 1)
        if (ce[ie].xt) {
          var Re = this.createComp(ce[ie], we, this.globalData.comp, null);
          Re.initExpressions(), this.globalData.projectInterface.registerComposition(Re);
        }
    };
    function HCompElement(ce, ie, me) {
      this.layers = ce.layers, this.supports3d = !ce.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(ce, ie, me), this.tm = ce.tm ? PropertyFactory.getProp(this, ce.tm, 0, ie.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(ce, ie) {
      for (var me = 0, we; me < ie; )
        this.elements[me] && this.elements[me].getBaseElement && (we = this.elements[me].getBaseElement()), me += 1;
      we ? this.layerElement.insertBefore(ce, we) : this.layerElement.appendChild(ce);
    }, HCompElement.prototype.createComp = function(ce) {
      return this.supports3d ? new HCompElement(ce, this.globalData, this) : new SVGCompElement(ce, this.globalData, this);
    };
    function HybridRenderer(ce, ie) {
      this.animationItem = ce, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: ie && ie.className || "",
        imagePreserveAspectRatio: ie && ie.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(ie && ie.hideOnTransparent === !1),
        filterSize: {
          width: ie && ie.filterSize && ie.filterSize.width || "400%",
          height: ie && ie.filterSize && ie.filterSize.height || "400%",
          x: ie && ie.filterSize && ie.filterSize.x || "-100%",
          y: ie && ie.filterSize && ie.filterSize.y || "-100%"
        },
        runExpressions: !ie || ie.runExpressions === void 0 || ie.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(ce) {
      return this.supports3d ? new HCompElement(ce, this.globalData, this) : new SVGCompElement(ce, this.globalData, this);
    };
    var CompExpressionInterface = /* @__PURE__ */ function() {
      return function(ce) {
        function ie(me) {
          for (var we = 0, Re = ce.layers.length; we < Re; ) {
            if (ce.layers[we].nm === me || ce.layers[we].ind === me)
              return ce.elements[we].layerInterface;
            we += 1;
          }
          return null;
        }
        return Object.defineProperty(ie, "_name", {
          value: ce.data.nm
        }), ie.layer = ie, ie.pixelAspect = 1, ie.height = ce.data.h || ce.globalData.compSize.h, ie.width = ce.data.w || ce.globalData.compSize.w, ie.pixelAspect = 1, ie.frameDuration = 1 / ce.globalData.frameRate, ie.displayStartTime = 0, ie.numLayers = ce.layers.length, ie;
      };
    }();
    function _typeof$2(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(me) {
        return typeof me;
      } : _typeof$2 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$2(ce);
    }
    function seedRandom(ce, ie) {
      var me = this, we = 256, Re = 6, je = 52, Ue = "random", qe = ie.pow(we, Re), Ge = ie.pow(2, je), Xe = Ge * 2, ot = we - 1, vt;
      function bt(Ot, Jr, en) {
        var nn = [];
        Jr = Jr === !0 ? {
          entropy: !0
        } : Jr || {};
        var ln = It(St(Jr.entropy ? [Ot, kt(ce)] : Ot === null ? Pt() : Ot, 3), nn), fn = new Tt(nn), vn = function() {
          for (var xn = fn.g(Re), bn = qe, Sn = 0; xn < Ge; )
            xn = (xn + Sn) * we, bn *= we, Sn = fn.g(1);
          for (; xn >= Xe; )
            xn /= 2, bn /= 2, Sn >>>= 1;
          return (xn + Sn) / bn;
        };
        return vn.int32 = function() {
          return fn.g(4) | 0;
        }, vn.quick = function() {
          return fn.g(4) / 4294967296;
        }, vn.double = vn, It(kt(fn.S), ce), (Jr.pass || en || function(Tn, xn, bn, Sn) {
          return Sn && (Sn.S && wt(Sn, fn), Tn.state = function() {
            return wt(fn, {});
          }), bn ? (ie[Ue] = Tn, xn) : Tn;
        })(vn, ln, "global" in Jr ? Jr.global : this == ie, Jr.state);
      }
      ie["seed" + Ue] = bt;
      function Tt(Ot) {
        var Jr, en = Ot.length, nn = this, ln = 0, fn = nn.i = nn.j = 0, vn = nn.S = [];
        for (en || (Ot = [en++]); ln < we; )
          vn[ln] = ln++;
        for (ln = 0; ln < we; ln++)
          vn[ln] = vn[fn = ot & fn + Ot[ln % en] + (Jr = vn[ln])], vn[fn] = Jr;
        nn.g = function(Tn) {
          for (var xn, bn = 0, Sn = nn.i, Cn = nn.j, kn = nn.S; Tn--; )
            xn = kn[Sn = ot & Sn + 1], bn = bn * we + kn[ot & (kn[Sn] = kn[Cn = ot & Cn + xn]) + (kn[Cn] = xn)];
          return nn.i = Sn, nn.j = Cn, bn;
        };
      }
      function wt(Ot, Jr) {
        return Jr.i = Ot.i, Jr.j = Ot.j, Jr.S = Ot.S.slice(), Jr;
      }
      function St(Ot, Jr) {
        var en = [], nn = _typeof$2(Ot), ln;
        if (Jr && nn == "object")
          for (ln in Ot)
            try {
              en.push(St(Ot[ln], Jr - 1));
            } catch {
            }
        return en.length ? en : nn == "string" ? Ot : Ot + "\0";
      }
      function It(Ot, Jr) {
        for (var en = Ot + "", nn, ln = 0; ln < en.length; )
          Jr[ot & ln] = ot & (nn ^= Jr[ot & ln] * 19) + en.charCodeAt(ln++);
        return kt(Jr);
      }
      function Pt() {
        try {
          var Ot = new Uint8Array(we);
          return (me.crypto || me.msCrypto).getRandomValues(Ot), kt(Ot);
        } catch {
          var Jr = me.navigator, en = Jr && Jr.plugins;
          return [+/* @__PURE__ */ new Date(), me, en, me.screen, kt(ce)];
        }
      }
      function kt(Ot) {
        return String.fromCharCode.apply(0, Ot);
      }
      It(ie.random(), ce);
    }
    function initialize$2(ce) {
      seedRandom([], ce);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(me) {
        return typeof me;
      } : _typeof$1 = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof$1(ce);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(ce) {
        return ce.constructor === Array || ce.constructor === Float32Array;
      }
      function isNumerable(ce, ie) {
        return ce === "number" || ie instanceof Number || ce === "boolean" || ce === "string";
      }
      function $bm_neg(ce) {
        var ie = _typeof$1(ce);
        if (ie === "number" || ce instanceof Number || ie === "boolean")
          return -ce;
        if ($bm_isInstanceOfArray(ce)) {
          var me, we = ce.length, Re = [];
          for (me = 0; me < we; me += 1)
            Re[me] = -ce[me];
          return Re;
        }
        return ce.propType ? ce.v : -ce;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(ce, ie) {
        var me = _typeof$1(ce), we = _typeof$1(ie);
        if (isNumerable(me, ce) && isNumerable(we, ie) || me === "string" || we === "string")
          return ce + ie;
        if ($bm_isInstanceOfArray(ce) && isNumerable(we, ie))
          return ce = ce.slice(0), ce[0] += ie, ce;
        if (isNumerable(me, ce) && $bm_isInstanceOfArray(ie))
          return ie = ie.slice(0), ie[0] = ce + ie[0], ie;
        if ($bm_isInstanceOfArray(ce) && $bm_isInstanceOfArray(ie)) {
          for (var Re = 0, je = ce.length, Ue = ie.length, qe = []; Re < je || Re < Ue; )
            (typeof ce[Re] == "number" || ce[Re] instanceof Number) && (typeof ie[Re] == "number" || ie[Re] instanceof Number) ? qe[Re] = ce[Re] + ie[Re] : qe[Re] = ie[Re] === void 0 ? ce[Re] : ce[Re] || ie[Re], Re += 1;
          return qe;
        }
        return 0;
      }
      var add = sum;
      function sub(ce, ie) {
        var me = _typeof$1(ce), we = _typeof$1(ie);
        if (isNumerable(me, ce) && isNumerable(we, ie))
          return me === "string" && (ce = parseInt(ce, 10)), we === "string" && (ie = parseInt(ie, 10)), ce - ie;
        if ($bm_isInstanceOfArray(ce) && isNumerable(we, ie))
          return ce = ce.slice(0), ce[0] -= ie, ce;
        if (isNumerable(me, ce) && $bm_isInstanceOfArray(ie))
          return ie = ie.slice(0), ie[0] = ce - ie[0], ie;
        if ($bm_isInstanceOfArray(ce) && $bm_isInstanceOfArray(ie)) {
          for (var Re = 0, je = ce.length, Ue = ie.length, qe = []; Re < je || Re < Ue; )
            (typeof ce[Re] == "number" || ce[Re] instanceof Number) && (typeof ie[Re] == "number" || ie[Re] instanceof Number) ? qe[Re] = ce[Re] - ie[Re] : qe[Re] = ie[Re] === void 0 ? ce[Re] : ce[Re] || ie[Re], Re += 1;
          return qe;
        }
        return 0;
      }
      function mul(ce, ie) {
        var me = _typeof$1(ce), we = _typeof$1(ie), Re;
        if (isNumerable(me, ce) && isNumerable(we, ie))
          return ce * ie;
        var je, Ue;
        if ($bm_isInstanceOfArray(ce) && isNumerable(we, ie)) {
          for (Ue = ce.length, Re = createTypedArray("float32", Ue), je = 0; je < Ue; je += 1)
            Re[je] = ce[je] * ie;
          return Re;
        }
        if (isNumerable(me, ce) && $bm_isInstanceOfArray(ie)) {
          for (Ue = ie.length, Re = createTypedArray("float32", Ue), je = 0; je < Ue; je += 1)
            Re[je] = ce * ie[je];
          return Re;
        }
        return 0;
      }
      function div(ce, ie) {
        var me = _typeof$1(ce), we = _typeof$1(ie), Re;
        if (isNumerable(me, ce) && isNumerable(we, ie))
          return ce / ie;
        var je, Ue;
        if ($bm_isInstanceOfArray(ce) && isNumerable(we, ie)) {
          for (Ue = ce.length, Re = createTypedArray("float32", Ue), je = 0; je < Ue; je += 1)
            Re[je] = ce[je] / ie;
          return Re;
        }
        if (isNumerable(me, ce) && $bm_isInstanceOfArray(ie)) {
          for (Ue = ie.length, Re = createTypedArray("float32", Ue), je = 0; je < Ue; je += 1)
            Re[je] = ce / ie[je];
          return Re;
        }
        return 0;
      }
      function mod(ce, ie) {
        return typeof ce == "string" && (ce = parseInt(ce, 10)), typeof ie == "string" && (ie = parseInt(ie, 10)), ce % ie;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(ce, ie, me) {
        if (ie > me) {
          var we = me;
          me = ie, ie = we;
        }
        return Math.min(Math.max(ce, ie), me);
      }
      function radiansToDegrees(ce) {
        return ce / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(ce) {
        return ce * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(ce, ie) {
        if (typeof ce == "number" || ce instanceof Number)
          return ie = ie || 0, Math.abs(ce - ie);
        ie || (ie = helperLengthArray);
        var me, we = Math.min(ce.length, ie.length), Re = 0;
        for (me = 0; me < we; me += 1)
          Re += Math.pow(ie[me] - ce[me], 2);
        return Math.sqrt(Re);
      }
      function normalize(ce) {
        return div(ce, length(ce));
      }
      function rgbToHsl(ce) {
        var ie = ce[0], me = ce[1], we = ce[2], Re = Math.max(ie, me, we), je = Math.min(ie, me, we), Ue, qe, Ge = (Re + je) / 2;
        if (Re === je)
          Ue = 0, qe = 0;
        else {
          var Xe = Re - je;
          switch (qe = Ge > 0.5 ? Xe / (2 - Re - je) : Xe / (Re + je), Re) {
            case ie:
              Ue = (me - we) / Xe + (me < we ? 6 : 0);
              break;
            case me:
              Ue = (we - ie) / Xe + 2;
              break;
            case we:
              Ue = (ie - me) / Xe + 4;
              break;
          }
          Ue /= 6;
        }
        return [Ue, qe, Ge, ce[3]];
      }
      function hue2rgb(ce, ie, me) {
        return me < 0 && (me += 1), me > 1 && (me -= 1), me < 1 / 6 ? ce + (ie - ce) * 6 * me : me < 1 / 2 ? ie : me < 2 / 3 ? ce + (ie - ce) * (2 / 3 - me) * 6 : ce;
      }
      function hslToRgb(ce) {
        var ie = ce[0], me = ce[1], we = ce[2], Re, je, Ue;
        if (me === 0)
          Re = we, Ue = we, je = we;
        else {
          var qe = we < 0.5 ? we * (1 + me) : we + me - we * me, Ge = 2 * we - qe;
          Re = hue2rgb(Ge, qe, ie + 1 / 3), je = hue2rgb(Ge, qe, ie), Ue = hue2rgb(Ge, qe, ie - 1 / 3);
        }
        return [Re, je, Ue, ce[3]];
      }
      function linear(ce, ie, me, we, Re) {
        if ((we === void 0 || Re === void 0) && (we = ie, Re = me, ie = 0, me = 1), me < ie) {
          var je = me;
          me = ie, ie = je;
        }
        if (ce <= ie)
          return we;
        if (ce >= me)
          return Re;
        var Ue = me === ie ? 0 : (ce - ie) / (me - ie);
        if (!we.length)
          return we + (Re - we) * Ue;
        var qe, Ge = we.length, Xe = createTypedArray("float32", Ge);
        for (qe = 0; qe < Ge; qe += 1)
          Xe[qe] = we[qe] + (Re[qe] - we[qe]) * Ue;
        return Xe;
      }
      function random(ce, ie) {
        if (ie === void 0 && (ce === void 0 ? (ce = 0, ie = 1) : (ie = ce, ce = void 0)), ie.length) {
          var me, we = ie.length;
          ce || (ce = createTypedArray("float32", we));
          var Re = createTypedArray("float32", we), je = BMMath.random();
          for (me = 0; me < we; me += 1)
            Re[me] = ce[me] + je * (ie[me] - ce[me]);
          return Re;
        }
        ce === void 0 && (ce = 0);
        var Ue = BMMath.random();
        return ce + Ue * (ie - ce);
      }
      function createPath(ce, ie, me, we) {
        var Re, je = ce.length, Ue = shapePool.newElement();
        Ue.setPathData(!!we, je);
        var qe = [0, 0], Ge, Xe;
        for (Re = 0; Re < je; Re += 1)
          Ge = ie && ie[Re] ? ie[Re] : qe, Xe = me && me[Re] ? me[Re] : qe, Ue.setTripleAt(ce[Re][0], ce[Re][1], Xe[0] + ce[Re][0], Xe[1] + ce[Re][1], Ge[0] + ce[Re][0], Ge[1] + ce[Re][1], Re, !0);
        return Ue;
      }
      function initiateExpression(elem, data, property) {
        function noOp(ce) {
          return ce;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function ce(ie, me) {
          var we, Re, je = this.pv.length ? this.pv.length : 1, Ue = createTypedArray("float32", je);
          ie = 5;
          var qe = Math.floor(time * ie);
          for (we = 0, Re = 0; we < qe; ) {
            for (Re = 0; Re < je; Re += 1)
              Ue[Re] += -me + me * 2 * BMMath.random();
            we += 1;
          }
          var Ge = time * ie, Xe = Ge - Math.floor(Ge), ot = createTypedArray("float32", je);
          if (je > 1) {
            for (Re = 0; Re < je; Re += 1)
              ot[Re] = this.pv[Re] + Ue[Re] + (-me + me * 2 * BMMath.random()) * Xe;
            return ot;
          }
          return this.pv + Ue[0] + (-me + me * 2 * BMMath.random()) * Xe;
        }).bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(ce, ie) {
          return loopIn(ce, ie, !0);
        }
        function loopOutDuration(ce, ie) {
          return loopOut(ce, ie, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(ce, ie) {
          var me = [ie[0] - ce[0], ie[1] - ce[1], ie[2] - ce[2]], we = Math.atan2(me[0], Math.sqrt(me[1] * me[1] + me[2] * me[2])) / degToRads, Re = -Math.atan2(me[1], me[2]) / degToRads;
          return [Re, we, 0];
        }
        function easeOut(ce, ie, me, we, Re) {
          return applyEase(easeOutBez, ce, ie, me, we, Re);
        }
        function easeIn(ce, ie, me, we, Re) {
          return applyEase(easeInBez, ce, ie, me, we, Re);
        }
        function ease(ce, ie, me, we, Re) {
          return applyEase(easeInOutBez, ce, ie, me, we, Re);
        }
        function applyEase(ce, ie, me, we, Re, je) {
          Re === void 0 ? (Re = me, je = we) : ie = (ie - me) / (we - me), ie > 1 ? ie = 1 : ie < 0 && (ie = 0);
          var Ue = ce(ie);
          if ($bm_isInstanceOfArray(Re)) {
            var qe, Ge = Re.length, Xe = createTypedArray("float32", Ge);
            for (qe = 0; qe < Ge; qe += 1)
              Xe[qe] = (je[qe] - Re[qe]) * Ue + Re[qe];
            return Xe;
          }
          return (je - Re) * Ue + Re;
        }
        function nearestKey(ce) {
          var ie, me = data.k.length, we, Re;
          if (!data.k.length || typeof data.k[0] == "number")
            we = 0, Re = 0;
          else if (we = -1, ce *= elem.comp.globalData.frameRate, ce < data.k[0].t)
            we = 1, Re = data.k[0].t;
          else {
            for (ie = 0; ie < me - 1; ie += 1)
              if (ce === data.k[ie].t) {
                we = ie + 1, Re = data.k[ie].t;
                break;
              } else if (ce > data.k[ie].t && ce < data.k[ie + 1].t) {
                ce - data.k[ie].t > data.k[ie + 1].t - ce ? (we = ie + 2, Re = data.k[ie + 1].t) : (we = ie + 1, Re = data.k[ie].t);
                break;
              }
            we === -1 && (we = ie + 1, Re = data.k[ie].t);
          }
          var je = {};
          return je.index = we, je.time = Re / elem.comp.globalData.frameRate, je;
        }
        function key(ce) {
          var ie, me, we;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + ce);
          ce -= 1, ie = {
            time: data.k[ce].t / elem.comp.globalData.frameRate,
            value: []
          };
          var Re = Object.prototype.hasOwnProperty.call(data.k[ce], "s") ? data.k[ce].s : data.k[ce - 1].e;
          for (we = Re.length, me = 0; me < we; me += 1)
            ie[me] = Re[me], ie.value[me] = Re[me];
          return ie;
        }
        function framesToTime(ce, ie) {
          return ie || (ie = elem.comp.globalData.frameRate), ce / ie;
        }
        function timeToFrames(ce, ie) {
          return !ce && ce !== 0 && (ce = time), ie || (ie = elem.comp.globalData.frameRate), ce * ie;
        }
        function seedRandom(ce) {
          BMMath.seedrandom(randSeed + ce);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(ce, ie) {
          return typeof value == "string" ? ie === void 0 ? value.substring(ce) : value.substring(ce, ie) : "";
        }
        function substr(ce, ie) {
          return typeof value == "string" ? ie === void 0 ? value.substr(ce) : value.substr(ce, ie) : "";
        }
        function posterizeTime(ce) {
          time = ce === 0 ? 0 : Math.floor(time * ce) / ce, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(ce) {
          return value = ce, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var ce = {};
      ce.initExpressions = ie, ce.resetFrame = ExpressionManager.resetFrame;
      function ie(me) {
        var we = 0, Re = [];
        function je() {
          we += 1;
        }
        function Ue() {
          we -= 1, we === 0 && Ge();
        }
        function qe(Xe) {
          Re.indexOf(Xe) === -1 && Re.push(Xe);
        }
        function Ge() {
          var Xe, ot = Re.length;
          for (Xe = 0; Xe < ot; Xe += 1)
            Re[Xe].release();
          Re.length = 0;
        }
        me.renderer.compInterface = CompExpressionInterface(me.renderer), me.renderer.globalData.projectInterface.registerComposition(me.renderer), me.renderer.globalData.pushExpression = je, me.renderer.globalData.popExpression = Ue, me.renderer.globalData.registerExpressionProperty = qe;
      }
      return ce;
    }(), MaskManagerInterface = function() {
      function ce(me, we) {
        this._mask = me, this._data = we;
      }
      Object.defineProperty(ce.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(ce.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var ie = function(we) {
        var Re = createSizedArray(we.viewData.length), je, Ue = we.viewData.length;
        for (je = 0; je < Ue; je += 1)
          Re[je] = new ce(we.viewData[je], we.masksProperties[je]);
        var qe = function(Xe) {
          for (je = 0; je < Ue; ) {
            if (we.masksProperties[je].nm === Xe)
              return Re[je];
            je += 1;
          }
          return null;
        };
        return qe;
      };
      return ie;
    }(), ExpressionPropertyInterface = /* @__PURE__ */ function() {
      var ce = {
        pv: 0,
        v: 0,
        mult: 1
      }, ie = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function me(Ue, qe, Ge) {
        Object.defineProperty(Ue, "velocity", {
          get: function() {
            return qe.getVelocityAtTime(qe.comp.currentFrame);
          }
        }), Ue.numKeys = qe.keyframes ? qe.keyframes.length : 0, Ue.key = function(Xe) {
          if (!Ue.numKeys)
            return 0;
          var ot = "";
          "s" in qe.keyframes[Xe - 1] ? ot = qe.keyframes[Xe - 1].s : "e" in qe.keyframes[Xe - 2] ? ot = qe.keyframes[Xe - 2].e : ot = qe.keyframes[Xe - 2].s;
          var vt = Ge === "unidimensional" ? new Number(ot) : Object.assign({}, ot);
          return vt.time = qe.keyframes[Xe - 1].t / qe.elem.comp.globalData.frameRate, vt.value = Ge === "unidimensional" ? ot[0] : ot, vt;
        }, Ue.valueAtTime = qe.getValueAtTime, Ue.speedAtTime = qe.getSpeedAtTime, Ue.velocityAtTime = qe.getVelocityAtTime, Ue.propertyGroup = qe.propertyGroup;
      }
      function we(Ue) {
        (!Ue || !("pv" in Ue)) && (Ue = ce);
        var qe = 1 / Ue.mult, Ge = Ue.pv * qe, Xe = new Number(Ge);
        return Xe.value = Ge, me(Xe, Ue, "unidimensional"), function() {
          return Ue.k && Ue.getValue(), Ge = Ue.v * qe, Xe.value !== Ge && (Xe = new Number(Ge), Xe.value = Ge, me(Xe, Ue, "unidimensional")), Xe;
        };
      }
      function Re(Ue) {
        (!Ue || !("pv" in Ue)) && (Ue = ie);
        var qe = 1 / Ue.mult, Ge = Ue.data && Ue.data.l || Ue.pv.length, Xe = createTypedArray("float32", Ge), ot = createTypedArray("float32", Ge);
        return Xe.value = ot, me(Xe, Ue, "multidimensional"), function() {
          Ue.k && Ue.getValue();
          for (var vt = 0; vt < Ge; vt += 1)
            ot[vt] = Ue.v[vt] * qe, Xe[vt] = ot[vt];
          return Xe;
        };
      }
      function je() {
        return ce;
      }
      return function(Ue) {
        return Ue ? Ue.propType === "unidimensional" ? we(Ue) : Re(Ue) : je;
      };
    }(), TransformExpressionInterface = /* @__PURE__ */ function() {
      return function(ce) {
        function ie(Ue) {
          switch (Ue) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return ie.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return ie.rotation;
            case "ADBE Rotate X":
              return ie.xRotation;
            case "ADBE Rotate Y":
              return ie.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return ie.position;
            case "ADBE Position_0":
              return ie.xPosition;
            case "ADBE Position_1":
              return ie.yPosition;
            case "ADBE Position_2":
              return ie.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return ie.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return ie.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(ie, "rotation", {
          get: ExpressionPropertyInterface(ce.r || ce.rz)
        }), Object.defineProperty(ie, "zRotation", {
          get: ExpressionPropertyInterface(ce.rz || ce.r)
        }), Object.defineProperty(ie, "xRotation", {
          get: ExpressionPropertyInterface(ce.rx)
        }), Object.defineProperty(ie, "yRotation", {
          get: ExpressionPropertyInterface(ce.ry)
        }), Object.defineProperty(ie, "scale", {
          get: ExpressionPropertyInterface(ce.s)
        });
        var me, we, Re, je;
        return ce.p ? je = ExpressionPropertyInterface(ce.p) : (me = ExpressionPropertyInterface(ce.px), we = ExpressionPropertyInterface(ce.py), ce.pz && (Re = ExpressionPropertyInterface(ce.pz))), Object.defineProperty(ie, "position", {
          get: function() {
            return ce.p ? je() : [me(), we(), Re ? Re() : 0];
          }
        }), Object.defineProperty(ie, "xPosition", {
          get: ExpressionPropertyInterface(ce.px)
        }), Object.defineProperty(ie, "yPosition", {
          get: ExpressionPropertyInterface(ce.py)
        }), Object.defineProperty(ie, "zPosition", {
          get: ExpressionPropertyInterface(ce.pz)
        }), Object.defineProperty(ie, "anchorPoint", {
          get: ExpressionPropertyInterface(ce.a)
        }), Object.defineProperty(ie, "opacity", {
          get: ExpressionPropertyInterface(ce.o)
        }), Object.defineProperty(ie, "skew", {
          get: ExpressionPropertyInterface(ce.sk)
        }), Object.defineProperty(ie, "skewAxis", {
          get: ExpressionPropertyInterface(ce.sa)
        }), Object.defineProperty(ie, "orientation", {
          get: ExpressionPropertyInterface(ce.or)
        }), ie;
      };
    }(), LayerExpressionInterface = /* @__PURE__ */ function() {
      function ce(Xe) {
        var ot = new Matrix();
        if (Xe !== void 0) {
          var vt = this._elem.finalTransform.mProp.getValueAtTime(Xe);
          vt.clone(ot);
        } else {
          var bt = this._elem.finalTransform.mProp;
          bt.applyToMatrix(ot);
        }
        return ot;
      }
      function ie(Xe, ot) {
        var vt = this.getMatrix(ot);
        return vt.props[12] = 0, vt.props[13] = 0, vt.props[14] = 0, this.applyPoint(vt, Xe);
      }
      function me(Xe, ot) {
        var vt = this.getMatrix(ot);
        return this.applyPoint(vt, Xe);
      }
      function we(Xe, ot) {
        var vt = this.getMatrix(ot);
        return vt.props[12] = 0, vt.props[13] = 0, vt.props[14] = 0, this.invertPoint(vt, Xe);
      }
      function Re(Xe, ot) {
        var vt = this.getMatrix(ot);
        return this.invertPoint(vt, Xe);
      }
      function je(Xe, ot) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var vt, bt = this._elem.hierarchy.length;
          for (vt = 0; vt < bt; vt += 1)
            this._elem.hierarchy[vt].finalTransform.mProp.applyToMatrix(Xe);
        }
        return Xe.applyToPointArray(ot[0], ot[1], ot[2] || 0);
      }
      function Ue(Xe, ot) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var vt, bt = this._elem.hierarchy.length;
          for (vt = 0; vt < bt; vt += 1)
            this._elem.hierarchy[vt].finalTransform.mProp.applyToMatrix(Xe);
        }
        return Xe.inversePoint(ot);
      }
      function qe(Xe) {
        var ot = new Matrix();
        if (ot.reset(), this._elem.finalTransform.mProp.applyToMatrix(ot), this._elem.hierarchy && this._elem.hierarchy.length) {
          var vt, bt = this._elem.hierarchy.length;
          for (vt = 0; vt < bt; vt += 1)
            this._elem.hierarchy[vt].finalTransform.mProp.applyToMatrix(ot);
          return ot.inversePoint(Xe);
        }
        return ot.inversePoint(Xe);
      }
      function Ge() {
        return [1, 1, 1, 1];
      }
      return function(Xe) {
        var ot;
        function vt(St) {
          Tt.mask = new MaskManagerInterface(St, Xe);
        }
        function bt(St) {
          Tt.effect = St;
        }
        function Tt(St) {
          switch (St) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return Tt.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return ot;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return Tt.effect;
            case "ADBE Text Properties":
              return Tt.textInterface;
            default:
              return null;
          }
        }
        Tt.getMatrix = ce, Tt.invertPoint = Ue, Tt.applyPoint = je, Tt.toWorld = me, Tt.toWorldVec = ie, Tt.fromWorld = Re, Tt.fromWorldVec = we, Tt.toComp = me, Tt.fromComp = qe, Tt.sampleImage = Ge, Tt.sourceRectAtTime = Xe.sourceRectAtTime.bind(Xe), Tt._elem = Xe, ot = TransformExpressionInterface(Xe.finalTransform.mProp);
        var wt = getDescriptor(ot, "anchorPoint");
        return Object.defineProperties(Tt, {
          hasParent: {
            get: function() {
              return Xe.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return Xe.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(ot, "rotation"),
          scale: getDescriptor(ot, "scale"),
          position: getDescriptor(ot, "position"),
          opacity: getDescriptor(ot, "opacity"),
          anchorPoint: wt,
          anchor_point: wt,
          transform: {
            get: function() {
              return ot;
            }
          },
          active: {
            get: function() {
              return Xe.isInRange;
            }
          }
        }), Tt.startTime = Xe.data.st, Tt.index = Xe.data.ind, Tt.source = Xe.data.refId, Tt.height = Xe.data.ty === 0 ? Xe.data.h : 100, Tt.width = Xe.data.ty === 0 ? Xe.data.w : 100, Tt.inPoint = Xe.data.ip / Xe.comp.globalData.frameRate, Tt.outPoint = Xe.data.op / Xe.comp.globalData.frameRate, Tt._name = Xe.data.nm, Tt.registerMaskInterface = vt, Tt.registerEffectsInterface = bt, Tt;
      };
    }(), propertyGroupFactory = /* @__PURE__ */ function() {
      return function(ce, ie) {
        return function(me) {
          return me = me === void 0 ? 1 : me, me <= 0 ? ce : ie(me - 1);
        };
      };
    }(), PropertyInterface = /* @__PURE__ */ function() {
      return function(ce, ie) {
        var me = {
          _name: ce
        };
        function we(Re) {
          return Re = Re === void 0 ? 1 : Re, Re <= 0 ? me : ie(Re - 1);
        }
        return we;
      };
    }(), EffectsExpressionInterface = /* @__PURE__ */ function() {
      var ce = {
        createEffectsInterface: ie
      };
      function ie(Re, je) {
        if (Re.effectsManager) {
          var Ue = [], qe = Re.data.ef, Ge, Xe = Re.effectsManager.effectElements.length;
          for (Ge = 0; Ge < Xe; Ge += 1)
            Ue.push(me(qe[Ge], Re.effectsManager.effectElements[Ge], je, Re));
          var ot = Re.data.ef || [], vt = function(Tt) {
            for (Ge = 0, Xe = ot.length; Ge < Xe; ) {
              if (Tt === ot[Ge].nm || Tt === ot[Ge].mn || Tt === ot[Ge].ix)
                return Ue[Ge];
              Ge += 1;
            }
            return null;
          };
          return Object.defineProperty(vt, "numProperties", {
            get: function() {
              return ot.length;
            }
          }), vt;
        }
        return null;
      }
      function me(Re, je, Ue, qe) {
        function Ge(Tt) {
          for (var wt = Re.ef, St = 0, It = wt.length; St < It; ) {
            if (Tt === wt[St].nm || Tt === wt[St].mn || Tt === wt[St].ix)
              return wt[St].ty === 5 ? ot[St] : ot[St]();
            St += 1;
          }
          throw new Error();
        }
        var Xe = propertyGroupFactory(Ge, Ue), ot = [], vt, bt = Re.ef.length;
        for (vt = 0; vt < bt; vt += 1)
          Re.ef[vt].ty === 5 ? ot.push(me(Re.ef[vt], je.effectElements[vt], je.effectElements[vt].propertyGroup, qe)) : ot.push(we(je.effectElements[vt], Re.ef[vt].ty, qe, Xe));
        return Re.mn === "ADBE Color Control" && Object.defineProperty(Ge, "color", {
          get: function() {
            return ot[0]();
          }
        }), Object.defineProperties(Ge, {
          numProperties: {
            get: function() {
              return Re.np;
            }
          },
          _name: {
            value: Re.nm
          },
          propertyGroup: {
            value: Xe
          }
        }), Ge.enabled = Re.en !== 0, Ge.active = Ge.enabled, Ge;
      }
      function we(Re, je, Ue, qe) {
        var Ge = ExpressionPropertyInterface(Re.p);
        function Xe() {
          return je === 10 ? Ue.comp.compInterface(Re.p.v) : Ge();
        }
        return Re.p.setGroupProperty && Re.p.setGroupProperty(PropertyInterface("", qe)), Xe;
      }
      return ce;
    }(), ShapePathInterface = /* @__PURE__ */ function() {
      return function(ie, me, we) {
        var Re = me.sh;
        function je(qe) {
          return qe === "Shape" || qe === "shape" || qe === "Path" || qe === "path" || qe === "ADBE Vector Shape" || qe === 2 ? je.path : null;
        }
        var Ue = propertyGroupFactory(je, we);
        return Re.setGroupProperty(PropertyInterface("Path", Ue)), Object.defineProperties(je, {
          path: {
            get: function() {
              return Re.k && Re.getValue(), Re;
            }
          },
          shape: {
            get: function() {
              return Re.k && Re.getValue(), Re;
            }
          },
          _name: {
            value: ie.nm
          },
          ix: {
            value: ie.ix
          },
          propertyIndex: {
            value: ie.ix
          },
          mn: {
            value: ie.mn
          },
          propertyGroup: {
            value: we
          }
        }), je;
      };
    }(), ShapeExpressionInterface = /* @__PURE__ */ function() {
      function ce(wt, St, It) {
        var Pt = [], kt, Ot = wt ? wt.length : 0;
        for (kt = 0; kt < Ot; kt += 1)
          wt[kt].ty === "gr" ? Pt.push(me(wt[kt], St[kt], It)) : wt[kt].ty === "fl" ? Pt.push(we(wt[kt], St[kt], It)) : wt[kt].ty === "st" ? Pt.push(Ue(wt[kt], St[kt], It)) : wt[kt].ty === "tm" ? Pt.push(qe(wt[kt], St[kt], It)) : wt[kt].ty === "tr" || (wt[kt].ty === "el" ? Pt.push(Xe(wt[kt], St[kt], It)) : wt[kt].ty === "sr" ? Pt.push(ot(wt[kt], St[kt], It)) : wt[kt].ty === "sh" ? Pt.push(ShapePathInterface(wt[kt], St[kt], It)) : wt[kt].ty === "rc" ? Pt.push(vt(wt[kt], St[kt], It)) : wt[kt].ty === "rd" ? Pt.push(bt(wt[kt], St[kt], It)) : wt[kt].ty === "rp" ? Pt.push(Tt(wt[kt], St[kt], It)) : wt[kt].ty === "gf" ? Pt.push(Re(wt[kt], St[kt], It)) : Pt.push(je(wt[kt], St[kt])));
        return Pt;
      }
      function ie(wt, St, It) {
        var Pt, kt = function(en) {
          for (var nn = 0, ln = Pt.length; nn < ln; ) {
            if (Pt[nn]._name === en || Pt[nn].mn === en || Pt[nn].propertyIndex === en || Pt[nn].ix === en || Pt[nn].ind === en)
              return Pt[nn];
            nn += 1;
          }
          return typeof en == "number" ? Pt[en - 1] : null;
        };
        kt.propertyGroup = propertyGroupFactory(kt, It), Pt = ce(wt.it, St.it, kt.propertyGroup), kt.numProperties = Pt.length;
        var Ot = Ge(wt.it[wt.it.length - 1], St.it[St.it.length - 1], kt.propertyGroup);
        return kt.transform = Ot, kt.propertyIndex = wt.cix, kt._name = wt.nm, kt;
      }
      function me(wt, St, It) {
        var Pt = function(en) {
          switch (en) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return Pt.content;
            // Not necessary for now. Keeping them here in case a new case appears
            // case 'ADBE Vector Transform Group':
            // case 3:
            default:
              return Pt.transform;
          }
        };
        Pt.propertyGroup = propertyGroupFactory(Pt, It);
        var kt = ie(wt, St, Pt.propertyGroup), Ot = Ge(wt.it[wt.it.length - 1], St.it[St.it.length - 1], Pt.propertyGroup);
        return Pt.content = kt, Pt.transform = Ot, Object.defineProperty(Pt, "_name", {
          get: function() {
            return wt.nm;
          }
        }), Pt.numProperties = wt.np, Pt.propertyIndex = wt.ix, Pt.nm = wt.nm, Pt.mn = wt.mn, Pt;
      }
      function we(wt, St, It) {
        function Pt(kt) {
          return kt === "Color" || kt === "color" ? Pt.color : kt === "Opacity" || kt === "opacity" ? Pt.opacity : null;
        }
        return Object.defineProperties(Pt, {
          color: {
            get: ExpressionPropertyInterface(St.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(St.o)
          },
          _name: {
            value: wt.nm
          },
          mn: {
            value: wt.mn
          }
        }), St.c.setGroupProperty(PropertyInterface("Color", It)), St.o.setGroupProperty(PropertyInterface("Opacity", It)), Pt;
      }
      function Re(wt, St, It) {
        function Pt(kt) {
          return kt === "Start Point" || kt === "start point" ? Pt.startPoint : kt === "End Point" || kt === "end point" ? Pt.endPoint : kt === "Opacity" || kt === "opacity" ? Pt.opacity : null;
        }
        return Object.defineProperties(Pt, {
          startPoint: {
            get: ExpressionPropertyInterface(St.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(St.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(St.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: wt.nm
          },
          mn: {
            value: wt.mn
          }
        }), St.s.setGroupProperty(PropertyInterface("Start Point", It)), St.e.setGroupProperty(PropertyInterface("End Point", It)), St.o.setGroupProperty(PropertyInterface("Opacity", It)), Pt;
      }
      function je() {
        function wt() {
          return null;
        }
        return wt;
      }
      function Ue(wt, St, It) {
        var Pt = propertyGroupFactory(ln, It), kt = propertyGroupFactory(nn, Pt);
        function Ot(fn) {
          Object.defineProperty(nn, wt.d[fn].nm, {
            get: ExpressionPropertyInterface(St.d.dataProps[fn].p)
          });
        }
        var Jr, en = wt.d ? wt.d.length : 0, nn = {};
        for (Jr = 0; Jr < en; Jr += 1)
          Ot(Jr), St.d.dataProps[Jr].p.setGroupProperty(kt);
        function ln(fn) {
          return fn === "Color" || fn === "color" ? ln.color : fn === "Opacity" || fn === "opacity" ? ln.opacity : fn === "Stroke Width" || fn === "stroke width" ? ln.strokeWidth : null;
        }
        return Object.defineProperties(ln, {
          color: {
            get: ExpressionPropertyInterface(St.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(St.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(St.w)
          },
          dash: {
            get: function() {
              return nn;
            }
          },
          _name: {
            value: wt.nm
          },
          mn: {
            value: wt.mn
          }
        }), St.c.setGroupProperty(PropertyInterface("Color", Pt)), St.o.setGroupProperty(PropertyInterface("Opacity", Pt)), St.w.setGroupProperty(PropertyInterface("Stroke Width", Pt)), ln;
      }
      function qe(wt, St, It) {
        function Pt(Ot) {
          return Ot === wt.e.ix || Ot === "End" || Ot === "end" ? Pt.end : Ot === wt.s.ix ? Pt.start : Ot === wt.o.ix ? Pt.offset : null;
        }
        var kt = propertyGroupFactory(Pt, It);
        return Pt.propertyIndex = wt.ix, St.s.setGroupProperty(PropertyInterface("Start", kt)), St.e.setGroupProperty(PropertyInterface("End", kt)), St.o.setGroupProperty(PropertyInterface("Offset", kt)), Pt.propertyIndex = wt.ix, Pt.propertyGroup = It, Object.defineProperties(Pt, {
          start: {
            get: ExpressionPropertyInterface(St.s)
          },
          end: {
            get: ExpressionPropertyInterface(St.e)
          },
          offset: {
            get: ExpressionPropertyInterface(St.o)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      function Ge(wt, St, It) {
        function Pt(Ot) {
          return wt.a.ix === Ot || Ot === "Anchor Point" ? Pt.anchorPoint : wt.o.ix === Ot || Ot === "Opacity" ? Pt.opacity : wt.p.ix === Ot || Ot === "Position" ? Pt.position : wt.r.ix === Ot || Ot === "Rotation" || Ot === "ADBE Vector Rotation" ? Pt.rotation : wt.s.ix === Ot || Ot === "Scale" ? Pt.scale : wt.sk && wt.sk.ix === Ot || Ot === "Skew" ? Pt.skew : wt.sa && wt.sa.ix === Ot || Ot === "Skew Axis" ? Pt.skewAxis : null;
        }
        var kt = propertyGroupFactory(Pt, It);
        return St.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", kt)), St.transform.mProps.p.setGroupProperty(PropertyInterface("Position", kt)), St.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", kt)), St.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", kt)), St.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", kt)), St.transform.mProps.sk && (St.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", kt)), St.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", kt))), St.transform.op.setGroupProperty(PropertyInterface("Opacity", kt)), Object.defineProperties(Pt, {
          opacity: {
            get: ExpressionPropertyInterface(St.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(St.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(St.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(St.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(St.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(St.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(St.transform.mProps.sa)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.ty = "tr", Pt.mn = wt.mn, Pt.propertyGroup = It, Pt;
      }
      function Xe(wt, St, It) {
        function Pt(Jr) {
          return wt.p.ix === Jr ? Pt.position : wt.s.ix === Jr ? Pt.size : null;
        }
        var kt = propertyGroupFactory(Pt, It);
        Pt.propertyIndex = wt.ix;
        var Ot = St.sh.ty === "tm" ? St.sh.prop : St.sh;
        return Ot.s.setGroupProperty(PropertyInterface("Size", kt)), Ot.p.setGroupProperty(PropertyInterface("Position", kt)), Object.defineProperties(Pt, {
          size: {
            get: ExpressionPropertyInterface(Ot.s)
          },
          position: {
            get: ExpressionPropertyInterface(Ot.p)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      function ot(wt, St, It) {
        function Pt(Jr) {
          return wt.p.ix === Jr ? Pt.position : wt.r.ix === Jr ? Pt.rotation : wt.pt.ix === Jr ? Pt.points : wt.or.ix === Jr || Jr === "ADBE Vector Star Outer Radius" ? Pt.outerRadius : wt.os.ix === Jr ? Pt.outerRoundness : wt.ir && (wt.ir.ix === Jr || Jr === "ADBE Vector Star Inner Radius") ? Pt.innerRadius : wt.is && wt.is.ix === Jr ? Pt.innerRoundness : null;
        }
        var kt = propertyGroupFactory(Pt, It), Ot = St.sh.ty === "tm" ? St.sh.prop : St.sh;
        return Pt.propertyIndex = wt.ix, Ot.or.setGroupProperty(PropertyInterface("Outer Radius", kt)), Ot.os.setGroupProperty(PropertyInterface("Outer Roundness", kt)), Ot.pt.setGroupProperty(PropertyInterface("Points", kt)), Ot.p.setGroupProperty(PropertyInterface("Position", kt)), Ot.r.setGroupProperty(PropertyInterface("Rotation", kt)), wt.ir && (Ot.ir.setGroupProperty(PropertyInterface("Inner Radius", kt)), Ot.is.setGroupProperty(PropertyInterface("Inner Roundness", kt))), Object.defineProperties(Pt, {
          position: {
            get: ExpressionPropertyInterface(Ot.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(Ot.r)
          },
          points: {
            get: ExpressionPropertyInterface(Ot.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(Ot.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(Ot.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(Ot.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(Ot.is)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      function vt(wt, St, It) {
        function Pt(Jr) {
          return wt.p.ix === Jr ? Pt.position : wt.r.ix === Jr ? Pt.roundness : wt.s.ix === Jr || Jr === "Size" || Jr === "ADBE Vector Rect Size" ? Pt.size : null;
        }
        var kt = propertyGroupFactory(Pt, It), Ot = St.sh.ty === "tm" ? St.sh.prop : St.sh;
        return Pt.propertyIndex = wt.ix, Ot.p.setGroupProperty(PropertyInterface("Position", kt)), Ot.s.setGroupProperty(PropertyInterface("Size", kt)), Ot.r.setGroupProperty(PropertyInterface("Rotation", kt)), Object.defineProperties(Pt, {
          position: {
            get: ExpressionPropertyInterface(Ot.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(Ot.r)
          },
          size: {
            get: ExpressionPropertyInterface(Ot.s)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      function bt(wt, St, It) {
        function Pt(Jr) {
          return wt.r.ix === Jr || Jr === "Round Corners 1" ? Pt.radius : null;
        }
        var kt = propertyGroupFactory(Pt, It), Ot = St;
        return Pt.propertyIndex = wt.ix, Ot.rd.setGroupProperty(PropertyInterface("Radius", kt)), Object.defineProperties(Pt, {
          radius: {
            get: ExpressionPropertyInterface(Ot.rd)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      function Tt(wt, St, It) {
        function Pt(Jr) {
          return wt.c.ix === Jr || Jr === "Copies" ? Pt.copies : wt.o.ix === Jr || Jr === "Offset" ? Pt.offset : null;
        }
        var kt = propertyGroupFactory(Pt, It), Ot = St;
        return Pt.propertyIndex = wt.ix, Ot.c.setGroupProperty(PropertyInterface("Copies", kt)), Ot.o.setGroupProperty(PropertyInterface("Offset", kt)), Object.defineProperties(Pt, {
          copies: {
            get: ExpressionPropertyInterface(Ot.c)
          },
          offset: {
            get: ExpressionPropertyInterface(Ot.o)
          },
          _name: {
            value: wt.nm
          }
        }), Pt.mn = wt.mn, Pt;
      }
      return function(wt, St, It) {
        var Pt;
        function kt(Jr) {
          if (typeof Jr == "number")
            return Jr = Jr === void 0 ? 1 : Jr, Jr === 0 ? It : Pt[Jr - 1];
          for (var en = 0, nn = Pt.length; en < nn; ) {
            if (Pt[en]._name === Jr)
              return Pt[en];
            en += 1;
          }
          return null;
        }
        function Ot() {
          return It;
        }
        return kt.propertyGroup = propertyGroupFactory(kt, Ot), Pt = ce(wt, St, kt.propertyGroup), kt.numProperties = Pt.length, kt._name = "Contents", kt;
      };
    }(), TextExpressionInterface = /* @__PURE__ */ function() {
      return function(ce) {
        var ie;
        function me(we) {
          switch (we) {
            case "ADBE Text Document":
              return me.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(me, "sourceText", {
          get: function() {
            ce.textProperty.getValue();
            var Re = ce.textProperty.currentData.t;
            return (!ie || Re !== ie.value) && (ie = new String(Re), ie.value = Re || new String(Re), Object.defineProperty(ie, "style", {
              get: function() {
                return {
                  fillColor: ce.textProperty.currentData.fc
                };
              }
            })), ie;
          }
        }), me;
      };
    }();
    function _typeof(ce) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(me) {
        return typeof me;
      } : _typeof = function(me) {
        return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
      }, _typeof(ce);
    }
    var FootageInterface = /* @__PURE__ */ function() {
      var ce = function(we) {
        var Re = "", je = we.getFootageData();
        function Ue() {
          return Re = "", je = we.getFootageData(), qe;
        }
        function qe(Ge) {
          if (je[Ge])
            return Re = Ge, je = je[Ge], _typeof(je) === "object" ? qe : je;
          var Xe = Ge.indexOf(Re);
          if (Xe !== -1) {
            var ot = parseInt(Ge.substr(Xe + Re.length), 10);
            return je = je[ot], _typeof(je) === "object" ? qe : je;
          }
          return "";
        }
        return Ue;
      }, ie = function(we) {
        function Re(je) {
          return je === "Outline" ? Re.outlineInterface() : null;
        }
        return Re._name = "Outline", Re.outlineInterface = ce(we), Re;
      };
      return function(me) {
        function we(Re) {
          return Re === "Data" ? we.dataInterface : null;
        }
        return we._name = "Data", we.dataInterface = ie(me), we;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(ce) {
      return interfaces[ce] || null;
    }
    var expressionHelpers = /* @__PURE__ */ function() {
      function ce(Ue, qe, Ge) {
        qe.x && (Ge.k = !0, Ge.x = !0, Ge.initiateExpression = ExpressionManager.initiateExpression, Ge.effectsSequence.push(Ge.initiateExpression(Ue, qe, Ge).bind(Ge)));
      }
      function ie(Ue) {
        return Ue *= this.elem.globalData.frameRate, Ue -= this.offsetTime, Ue !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < Ue ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(Ue, this._cachingAtTime), this._cachingAtTime.lastFrame = Ue), this._cachingAtTime.value;
      }
      function me(Ue) {
        var qe = -0.01, Ge = this.getValueAtTime(Ue), Xe = this.getValueAtTime(Ue + qe), ot = 0;
        if (Ge.length) {
          var vt;
          for (vt = 0; vt < Ge.length; vt += 1)
            ot += Math.pow(Xe[vt] - Ge[vt], 2);
          ot = Math.sqrt(ot) * 100;
        } else
          ot = 0;
        return ot;
      }
      function we(Ue) {
        if (this.vel !== void 0)
          return this.vel;
        var qe = -1e-3, Ge = this.getValueAtTime(Ue), Xe = this.getValueAtTime(Ue + qe), ot;
        if (Ge.length) {
          ot = createTypedArray("float32", Ge.length);
          var vt;
          for (vt = 0; vt < Ge.length; vt += 1)
            ot[vt] = (Xe[vt] - Ge[vt]) / qe;
        } else
          ot = (Xe - Ge) / qe;
        return ot;
      }
      function Re() {
        return this.pv;
      }
      function je(Ue) {
        this.propertyGroup = Ue;
      }
      return {
        searchExpressions: ce,
        getSpeedAtTime: me,
        getVelocityAtTime: we,
        getValueAtTime: ie,
        getStaticValueAtTime: Re,
        setGroupProperty: je
      };
    }();
    function addPropertyDecorator() {
      function ce(bt, Tt, wt) {
        if (!this.k || !this.keyframes)
          return this.pv;
        bt = bt ? bt.toLowerCase() : "";
        var St = this.comp.renderedFrame, It = this.keyframes, Pt = It[It.length - 1].t;
        if (St <= Pt)
          return this.pv;
        var kt, Ot;
        wt ? (Tt ? kt = Math.abs(Pt - this.elem.comp.globalData.frameRate * Tt) : kt = Math.max(0, Pt - this.elem.data.ip), Ot = Pt - kt) : ((!Tt || Tt > It.length - 1) && (Tt = It.length - 1), Ot = It[It.length - 1 - Tt].t, kt = Pt - Ot);
        var Jr, en, nn;
        if (bt === "pingpong") {
          var ln = Math.floor((St - Ot) / kt);
          if (ln % 2 !== 0)
            return this.getValueAtTime((kt - (St - Ot) % kt + Ot) / this.comp.globalData.frameRate, 0);
        } else if (bt === "offset") {
          var fn = this.getValueAtTime(Ot / this.comp.globalData.frameRate, 0), vn = this.getValueAtTime(Pt / this.comp.globalData.frameRate, 0), Tn = this.getValueAtTime(((St - Ot) % kt + Ot) / this.comp.globalData.frameRate, 0), xn = Math.floor((St - Ot) / kt);
          if (this.pv.length) {
            for (nn = new Array(fn.length), en = nn.length, Jr = 0; Jr < en; Jr += 1)
              nn[Jr] = (vn[Jr] - fn[Jr]) * xn + Tn[Jr];
            return nn;
          }
          return (vn - fn) * xn + Tn;
        } else if (bt === "continue") {
          var bn = this.getValueAtTime(Pt / this.comp.globalData.frameRate, 0), Sn = this.getValueAtTime((Pt - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (nn = new Array(bn.length), en = nn.length, Jr = 0; Jr < en; Jr += 1)
              nn[Jr] = bn[Jr] + (bn[Jr] - Sn[Jr]) * ((St - Pt) / this.comp.globalData.frameRate) / 5e-4;
            return nn;
          }
          return bn + (bn - Sn) * ((St - Pt) / 1e-3);
        }
        return this.getValueAtTime(((St - Ot) % kt + Ot) / this.comp.globalData.frameRate, 0);
      }
      function ie(bt, Tt, wt) {
        if (!this.k)
          return this.pv;
        bt = bt ? bt.toLowerCase() : "";
        var St = this.comp.renderedFrame, It = this.keyframes, Pt = It[0].t;
        if (St >= Pt)
          return this.pv;
        var kt, Ot;
        wt ? (Tt ? kt = Math.abs(this.elem.comp.globalData.frameRate * Tt) : kt = Math.max(0, this.elem.data.op - Pt), Ot = Pt + kt) : ((!Tt || Tt > It.length - 1) && (Tt = It.length - 1), Ot = It[Tt].t, kt = Ot - Pt);
        var Jr, en, nn;
        if (bt === "pingpong") {
          var ln = Math.floor((Pt - St) / kt);
          if (ln % 2 === 0)
            return this.getValueAtTime(((Pt - St) % kt + Pt) / this.comp.globalData.frameRate, 0);
        } else if (bt === "offset") {
          var fn = this.getValueAtTime(Pt / this.comp.globalData.frameRate, 0), vn = this.getValueAtTime(Ot / this.comp.globalData.frameRate, 0), Tn = this.getValueAtTime((kt - (Pt - St) % kt + Pt) / this.comp.globalData.frameRate, 0), xn = Math.floor((Pt - St) / kt) + 1;
          if (this.pv.length) {
            for (nn = new Array(fn.length), en = nn.length, Jr = 0; Jr < en; Jr += 1)
              nn[Jr] = Tn[Jr] - (vn[Jr] - fn[Jr]) * xn;
            return nn;
          }
          return Tn - (vn - fn) * xn;
        } else if (bt === "continue") {
          var bn = this.getValueAtTime(Pt / this.comp.globalData.frameRate, 0), Sn = this.getValueAtTime((Pt + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (nn = new Array(bn.length), en = nn.length, Jr = 0; Jr < en; Jr += 1)
              nn[Jr] = bn[Jr] + (bn[Jr] - Sn[Jr]) * (Pt - St) / 1e-3;
            return nn;
          }
          return bn + (bn - Sn) * (Pt - St) / 1e-3;
        }
        return this.getValueAtTime((kt - ((Pt - St) % kt + Pt)) / this.comp.globalData.frameRate, 0);
      }
      function me(bt, Tt) {
        if (!this.k)
          return this.pv;
        if (bt = (bt || 0.4) * 0.5, Tt = Math.floor(Tt || 5), Tt <= 1)
          return this.pv;
        var wt = this.comp.renderedFrame / this.comp.globalData.frameRate, St = wt - bt, It = wt + bt, Pt = Tt > 1 ? (It - St) / (Tt - 1) : 1, kt = 0, Ot = 0, Jr;
        this.pv.length ? Jr = createTypedArray("float32", this.pv.length) : Jr = 0;
        for (var en; kt < Tt; ) {
          if (en = this.getValueAtTime(St + kt * Pt), this.pv.length)
            for (Ot = 0; Ot < this.pv.length; Ot += 1)
              Jr[Ot] += en[Ot];
          else
            Jr += en;
          kt += 1;
        }
        if (this.pv.length)
          for (Ot = 0; Ot < this.pv.length; Ot += 1)
            Jr[Ot] /= Tt;
        else
          Jr /= Tt;
        return Jr;
      }
      function we(bt) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var Tt = this._transformCachingAtTime.v;
        if (Tt.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var wt = this.a.getValueAtTime(bt);
          Tt.translate(-wt[0] * this.a.mult, -wt[1] * this.a.mult, wt[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var St = this.s.getValueAtTime(bt);
          Tt.scale(St[0] * this.s.mult, St[1] * this.s.mult, St[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var It = this.sk.getValueAtTime(bt), Pt = this.sa.getValueAtTime(bt);
          Tt.skewFromAxis(-It * this.sk.mult, Pt * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var kt = this.r.getValueAtTime(bt);
          Tt.rotate(-kt * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var Ot = this.rz.getValueAtTime(bt), Jr = this.ry.getValueAtTime(bt), en = this.rx.getValueAtTime(bt), nn = this.or.getValueAtTime(bt);
          Tt.rotateZ(-Ot * this.rz.mult).rotateY(Jr * this.ry.mult).rotateX(en * this.rx.mult).rotateZ(-nn[2] * this.or.mult).rotateY(nn[1] * this.or.mult).rotateX(nn[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var ln = this.px.getValueAtTime(bt), fn = this.py.getValueAtTime(bt);
          if (this.data.p.z) {
            var vn = this.pz.getValueAtTime(bt);
            Tt.translate(ln * this.px.mult, fn * this.py.mult, -vn * this.pz.mult);
          } else
            Tt.translate(ln * this.px.mult, fn * this.py.mult, 0);
        } else {
          var Tn = this.p.getValueAtTime(bt);
          Tt.translate(Tn[0] * this.p.mult, Tn[1] * this.p.mult, -Tn[2] * this.p.mult);
        }
        return Tt;
      }
      function Re() {
        return this.v.clone(new Matrix());
      }
      var je = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(bt, Tt, wt) {
        var St = je(bt, Tt, wt);
        return St.dynamicProperties.length ? St.getValueAtTime = we.bind(St) : St.getValueAtTime = Re.bind(St), St.setGroupProperty = expressionHelpers.setGroupProperty, St;
      };
      var Ue = PropertyFactory.getProp;
      PropertyFactory.getProp = function(bt, Tt, wt, St, It) {
        var Pt = Ue(bt, Tt, wt, St, It);
        Pt.kf ? Pt.getValueAtTime = expressionHelpers.getValueAtTime.bind(Pt) : Pt.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(Pt), Pt.setGroupProperty = expressionHelpers.setGroupProperty, Pt.loopOut = ce, Pt.loopIn = ie, Pt.smooth = me, Pt.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(Pt), Pt.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(Pt), Pt.numKeys = Tt.a === 1 ? Tt.k.length : 0, Pt.propertyIndex = Tt.ix;
        var kt = 0;
        return wt !== 0 && (kt = createTypedArray("float32", Tt.a === 1 ? Tt.k[0].s.length : Tt.k.length)), Pt._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: kt
        }, expressionHelpers.searchExpressions(bt, Tt, Pt), Pt.k && It.addDynamicProperty(Pt), Pt;
      };
      function qe(bt) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), bt *= this.elem.globalData.frameRate, bt -= this.offsetTime, bt !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < bt ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = bt, this.interpolateShape(bt, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var Ge = ShapePropertyFactory.getConstructorFunction(), Xe = ShapePropertyFactory.getKeyframedConstructorFunction();
      function ot() {
      }
      ot.prototype = {
        vertices: function(Tt, wt) {
          this.k && this.getValue();
          var St = this.v;
          wt !== void 0 && (St = this.getValueAtTime(wt, 0));
          var It, Pt = St._length, kt = St[Tt], Ot = St.v, Jr = createSizedArray(Pt);
          for (It = 0; It < Pt; It += 1)
            Tt === "i" || Tt === "o" ? Jr[It] = [kt[It][0] - Ot[It][0], kt[It][1] - Ot[It][1]] : Jr[It] = [kt[It][0], kt[It][1]];
          return Jr;
        },
        points: function(Tt) {
          return this.vertices("v", Tt);
        },
        inTangents: function(Tt) {
          return this.vertices("i", Tt);
        },
        outTangents: function(Tt) {
          return this.vertices("o", Tt);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(Tt, wt) {
          var St = this.v;
          wt !== void 0 && (St = this.getValueAtTime(wt, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(St));
          for (var It = this._segmentsLength, Pt = It.lengths, kt = It.totalLength * Tt, Ot = 0, Jr = Pt.length, en = 0, nn; Ot < Jr; ) {
            if (en + Pt[Ot].addedLength > kt) {
              var ln = Ot, fn = St.c && Ot === Jr - 1 ? 0 : Ot + 1, vn = (kt - en) / Pt[Ot].addedLength;
              nn = bez.getPointInSegment(St.v[ln], St.v[fn], St.o[ln], St.i[fn], vn, Pt[Ot]);
              break;
            } else
              en += Pt[Ot].addedLength;
            Ot += 1;
          }
          return nn || (nn = St.c ? [St.v[0][0], St.v[0][1]] : [St.v[St._length - 1][0], St.v[St._length - 1][1]]), nn;
        },
        vectorOnPath: function(Tt, wt, St) {
          Tt == 1 ? Tt = this.v.c : Tt == 0 && (Tt = 0.999);
          var It = this.pointOnPath(Tt, wt), Pt = this.pointOnPath(Tt + 1e-3, wt), kt = Pt[0] - It[0], Ot = Pt[1] - It[1], Jr = Math.sqrt(Math.pow(kt, 2) + Math.pow(Ot, 2));
          if (Jr === 0)
            return [0, 0];
          var en = St === "tangent" ? [kt / Jr, Ot / Jr] : [-Ot / Jr, kt / Jr];
          return en;
        },
        tangentOnPath: function(Tt, wt) {
          return this.vectorOnPath(Tt, wt, "tangent");
        },
        normalOnPath: function(Tt, wt) {
          return this.vectorOnPath(Tt, wt, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([ot], Ge), extendPrototype([ot], Xe), Xe.prototype.getValueAtTime = qe, Xe.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var vt = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(bt, Tt, wt, St, It) {
        var Pt = vt(bt, Tt, wt, St, It);
        return Pt.propertyIndex = Tt.ix, Pt.lock = !1, wt === 3 ? expressionHelpers.searchExpressions(bt, Tt.pt, Pt) : wt === 4 && expressionHelpers.searchExpressions(bt, Tt.ks, Pt), Pt.k && bt.addDynamicProperty(Pt), Pt;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function ce() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(ie, me) {
        var we = this.calculateExpression(me);
        if (ie.t !== we) {
          var Re = {};
          return this.copyData(Re, ie), Re.t = we.toString(), Re.__complete = !1, Re;
        }
        return ie;
      }, TextProperty.prototype.searchProperty = function() {
        var ie = this.searchKeyframes(), me = this.searchExpressions();
        return this.kf = ie || me, this.kf;
      }, TextProperty.prototype.searchExpressions = ce;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function ce(ie, me) {
        var we = createNS("feMerge");
        we.setAttribute("result", ie);
        var Re, je;
        for (je = 0; je < me.length; je += 1)
          Re = createNS("feMergeNode"), Re.setAttribute("in", me[je]), we.appendChild(Re), we.appendChild(Re);
        return we;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(ce, ie, me, we, Re) {
      this.filterManager = ie;
      var je = createNS("feColorMatrix");
      je.setAttribute("type", "matrix"), je.setAttribute("color-interpolation-filters", "linearRGB"), je.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = je, je.setAttribute("result", we + "_tint_1"), ce.appendChild(je), je = createNS("feColorMatrix"), je.setAttribute("type", "matrix"), je.setAttribute("color-interpolation-filters", "sRGB"), je.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), je.setAttribute("result", we + "_tint_2"), ce.appendChild(je), this.matrixFilter = je;
      var Ue = this.createMergeNode(we, [Re, we + "_tint_1", we + "_tint_2"]);
      ce.appendChild(Ue);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        var ie = this.filterManager.effectElements[0].p.v, me = this.filterManager.effectElements[1].p.v, we = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + we + " 0"), this.matrixFilter.setAttribute("values", me[0] - ie[0] + " 0 0 0 " + ie[0] + " " + (me[1] - ie[1]) + " 0 0 0 " + ie[1] + " " + (me[2] - ie[2]) + " 0 0 0 " + ie[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(ce, ie, me, we) {
      this.filterManager = ie;
      var Re = createNS("feColorMatrix");
      Re.setAttribute("type", "matrix"), Re.setAttribute("color-interpolation-filters", "sRGB"), Re.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), Re.setAttribute("result", we), ce.appendChild(Re), this.matrixFilter = Re;
    }
    SVGFillFilter.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        var ie = this.filterManager.effectElements[2].p.v, me = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + ie[0] + " 0 0 0 0 " + ie[1] + " 0 0 0 0 " + ie[2] + " 0 0 0 " + me + " 0");
      }
    };
    function SVGStrokeEffect(ce, ie, me) {
      this.initialized = !1, this.filterManager = ie, this.elem = me, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var ce = this.elem.layerElement.children || this.elem.layerElement.childNodes, ie, me, we, Re;
      for (this.filterManager.effectElements[1].p.v === 1 ? (Re = this.elem.maskManager.masksProperties.length, we = 0) : (we = this.filterManager.effectElements[0].p.v - 1, Re = we + 1), me = createNS("g"), me.setAttribute("fill", "none"), me.setAttribute("stroke-linecap", "round"), me.setAttribute("stroke-dashoffset", 1), we; we < Re; we += 1)
        ie = createNS("path"), me.appendChild(ie), this.paths.push({
          p: ie,
          m: we
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var je = createNS("mask"), Ue = createElementID();
        je.setAttribute("id", Ue), je.setAttribute("mask-type", "alpha"), je.appendChild(me), this.elem.globalData.defs.appendChild(je);
        var qe = createNS("g");
        for (qe.setAttribute("mask", "url(" + getLocationHref() + "#" + Ue + ")"); ce[0]; )
          qe.appendChild(ce[0]);
        this.elem.layerElement.appendChild(qe), this.masker = je, me.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (ce = this.elem.layerElement.children || this.elem.layerElement.childNodes; ce.length; )
            this.elem.layerElement.removeChild(ce[0]);
        this.elem.layerElement.appendChild(me), this.elem.layerElement.removeAttribute("mask"), me.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = me;
    }, SVGStrokeEffect.prototype.renderFrame = function(ce) {
      this.initialized || this.initialize();
      var ie, me = this.paths.length, we, Re;
      for (ie = 0; ie < me; ie += 1)
        if (this.paths[ie].m !== -1 && (we = this.elem.maskManager.viewData[this.paths[ie].m], Re = this.paths[ie].p, (ce || this.filterManager._mdf || we.prop._mdf) && Re.setAttribute("d", we.lastPath), ce || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || we.prop._mdf)) {
          var je;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var Ue = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, qe = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, Ge = Re.getTotalLength();
            je = "0 0 0 " + Ge * Ue + " ";
            var Xe = Ge * (qe - Ue), ot = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, vt = Math.floor(Xe / ot), bt;
            for (bt = 0; bt < vt; bt += 1)
              je += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            je += "0 " + Ge * 10 + " 0 0";
          } else
            je = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          Re.setAttribute("stroke-dasharray", je);
        }
      if ((ce || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (ce || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (ce || this.filterManager.effectElements[3].p._mdf)) {
        var Tt = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(Tt[0] * 255) + "," + bmFloor(Tt[1] * 255) + "," + bmFloor(Tt[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(ce, ie, me, we) {
      this.filterManager = ie;
      var Re = createNS("feColorMatrix");
      Re.setAttribute("type", "matrix"), Re.setAttribute("color-interpolation-filters", "linearRGB"), Re.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), ce.appendChild(Re);
      var je = createNS("feComponentTransfer");
      je.setAttribute("color-interpolation-filters", "sRGB"), je.setAttribute("result", we), this.matrixFilter = je;
      var Ue = createNS("feFuncR");
      Ue.setAttribute("type", "table"), je.appendChild(Ue), this.feFuncR = Ue;
      var qe = createNS("feFuncG");
      qe.setAttribute("type", "table"), je.appendChild(qe), this.feFuncG = qe;
      var Ge = createNS("feFuncB");
      Ge.setAttribute("type", "table"), je.appendChild(Ge), this.feFuncB = Ge, ce.appendChild(je);
    }
    SVGTritoneFilter.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        var ie = this.filterManager.effectElements[0].p.v, me = this.filterManager.effectElements[1].p.v, we = this.filterManager.effectElements[2].p.v, Re = we[0] + " " + me[0] + " " + ie[0], je = we[1] + " " + me[1] + " " + ie[1], Ue = we[2] + " " + me[2] + " " + ie[2];
        this.feFuncR.setAttribute("tableValues", Re), this.feFuncG.setAttribute("tableValues", je), this.feFuncB.setAttribute("tableValues", Ue);
      }
    };
    function SVGProLevelsFilter(ce, ie, me, we) {
      this.filterManager = ie;
      var Re = this.filterManager.effectElements, je = createNS("feComponentTransfer");
      (Re[10].p.k || Re[10].p.v !== 0 || Re[11].p.k || Re[11].p.v !== 1 || Re[12].p.k || Re[12].p.v !== 1 || Re[13].p.k || Re[13].p.v !== 0 || Re[14].p.k || Re[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", je)), (Re[17].p.k || Re[17].p.v !== 0 || Re[18].p.k || Re[18].p.v !== 1 || Re[19].p.k || Re[19].p.v !== 1 || Re[20].p.k || Re[20].p.v !== 0 || Re[21].p.k || Re[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", je)), (Re[24].p.k || Re[24].p.v !== 0 || Re[25].p.k || Re[25].p.v !== 1 || Re[26].p.k || Re[26].p.v !== 1 || Re[27].p.k || Re[27].p.v !== 0 || Re[28].p.k || Re[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", je)), (Re[31].p.k || Re[31].p.v !== 0 || Re[32].p.k || Re[32].p.v !== 1 || Re[33].p.k || Re[33].p.v !== 1 || Re[34].p.k || Re[34].p.v !== 0 || Re[35].p.k || Re[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", je)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (je.setAttribute("color-interpolation-filters", "sRGB"), ce.appendChild(je)), (Re[3].p.k || Re[3].p.v !== 0 || Re[4].p.k || Re[4].p.v !== 1 || Re[5].p.k || Re[5].p.v !== 1 || Re[6].p.k || Re[6].p.v !== 0 || Re[7].p.k || Re[7].p.v !== 1) && (je = createNS("feComponentTransfer"), je.setAttribute("color-interpolation-filters", "sRGB"), je.setAttribute("result", we), ce.appendChild(je), this.feFuncRComposed = this.createFeFunc("feFuncR", je), this.feFuncGComposed = this.createFeFunc("feFuncG", je), this.feFuncBComposed = this.createFeFunc("feFuncB", je));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(ce, ie) {
      var me = createNS(ce);
      return me.setAttribute("type", "table"), ie.appendChild(me), me;
    }, SVGProLevelsFilter.prototype.getTableValue = function(ce, ie, me, we, Re) {
      for (var je = 0, Ue = 256, qe, Ge = Math.min(ce, ie), Xe = Math.max(ce, ie), ot = Array.call(null, {
        length: Ue
      }), vt, bt = 0, Tt = Re - we, wt = ie - ce; je <= 256; )
        qe = je / 256, qe <= Ge ? vt = wt < 0 ? Re : we : qe >= Xe ? vt = wt < 0 ? we : Re : vt = we + Tt * Math.pow((qe - ce) / wt, 1 / me), ot[bt] = vt, bt += 1, je += 256 / (Ue - 1);
      return ot.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        var ie, me = this.filterManager.effectElements;
        this.feFuncRComposed && (ce || me[3].p._mdf || me[4].p._mdf || me[5].p._mdf || me[6].p._mdf || me[7].p._mdf) && (ie = this.getTableValue(me[3].p.v, me[4].p.v, me[5].p.v, me[6].p.v, me[7].p.v), this.feFuncRComposed.setAttribute("tableValues", ie), this.feFuncGComposed.setAttribute("tableValues", ie), this.feFuncBComposed.setAttribute("tableValues", ie)), this.feFuncR && (ce || me[10].p._mdf || me[11].p._mdf || me[12].p._mdf || me[13].p._mdf || me[14].p._mdf) && (ie = this.getTableValue(me[10].p.v, me[11].p.v, me[12].p.v, me[13].p.v, me[14].p.v), this.feFuncR.setAttribute("tableValues", ie)), this.feFuncG && (ce || me[17].p._mdf || me[18].p._mdf || me[19].p._mdf || me[20].p._mdf || me[21].p._mdf) && (ie = this.getTableValue(me[17].p.v, me[18].p.v, me[19].p.v, me[20].p.v, me[21].p.v), this.feFuncG.setAttribute("tableValues", ie)), this.feFuncB && (ce || me[24].p._mdf || me[25].p._mdf || me[26].p._mdf || me[27].p._mdf || me[28].p._mdf) && (ie = this.getTableValue(me[24].p.v, me[25].p.v, me[26].p.v, me[27].p.v, me[28].p.v), this.feFuncB.setAttribute("tableValues", ie)), this.feFuncA && (ce || me[31].p._mdf || me[32].p._mdf || me[33].p._mdf || me[34].p._mdf || me[35].p._mdf) && (ie = this.getTableValue(me[31].p.v, me[32].p.v, me[33].p.v, me[34].p.v, me[35].p.v), this.feFuncA.setAttribute("tableValues", ie));
      }
    };
    function SVGDropShadowEffect(ce, ie, me, we, Re) {
      var je = ie.container.globalData.renderConfig.filterSize, Ue = ie.data.fs || je;
      ce.setAttribute("x", Ue.x || je.x), ce.setAttribute("y", Ue.y || je.y), ce.setAttribute("width", Ue.width || je.width), ce.setAttribute("height", Ue.height || je.height), this.filterManager = ie;
      var qe = createNS("feGaussianBlur");
      qe.setAttribute("in", "SourceAlpha"), qe.setAttribute("result", we + "_drop_shadow_1"), qe.setAttribute("stdDeviation", "0"), this.feGaussianBlur = qe, ce.appendChild(qe);
      var Ge = createNS("feOffset");
      Ge.setAttribute("dx", "25"), Ge.setAttribute("dy", "0"), Ge.setAttribute("in", we + "_drop_shadow_1"), Ge.setAttribute("result", we + "_drop_shadow_2"), this.feOffset = Ge, ce.appendChild(Ge);
      var Xe = createNS("feFlood");
      Xe.setAttribute("flood-color", "#00ff00"), Xe.setAttribute("flood-opacity", "1"), Xe.setAttribute("result", we + "_drop_shadow_3"), this.feFlood = Xe, ce.appendChild(Xe);
      var ot = createNS("feComposite");
      ot.setAttribute("in", we + "_drop_shadow_3"), ot.setAttribute("in2", we + "_drop_shadow_2"), ot.setAttribute("operator", "in"), ot.setAttribute("result", we + "_drop_shadow_4"), ce.appendChild(ot);
      var vt = this.createMergeNode(we, [we + "_drop_shadow_4", Re]);
      ce.appendChild(vt);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        if ((ce || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), ce || this.filterManager.effectElements[0].p._mdf) {
          var ie = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(ie[0] * 255), Math.round(ie[1] * 255), Math.round(ie[2] * 255)));
        }
        if ((ce || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), ce || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var me = this.filterManager.effectElements[3].p.v, we = (this.filterManager.effectElements[2].p.v - 90) * degToRads, Re = me * Math.cos(we), je = me * Math.sin(we);
          this.feOffset.setAttribute("dx", Re), this.feOffset.setAttribute("dy", je);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(ce, ie, me) {
      this.initialized = !1, this.filterManager = ie, this.filterElem = ce, this.elem = me, me.matteElement = createNS("g"), me.matteElement.appendChild(me.layerElement), me.matteElement.appendChild(me.transformedElement), me.baseElement = me.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(ce) {
      for (var ie = 0, me = _svgMatteSymbols.length; ie < me; ) {
        if (_svgMatteSymbols[ie] === ce)
          return _svgMatteSymbols[ie];
        ie += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(ce, ie) {
      var me = ce.layerElement.parentNode;
      if (me) {
        for (var we = me.children, Re = 0, je = we.length; Re < je && we[Re] !== ce.layerElement; )
          Re += 1;
        var Ue;
        Re <= je - 2 && (Ue = we[Re + 1]);
        var qe = createNS("use");
        qe.setAttribute("href", "#" + ie), Ue ? me.insertBefore(qe, Ue) : me.appendChild(qe);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(ce, ie) {
      if (!this.findSymbol(ie)) {
        var me = createElementID(), we = createNS("mask");
        we.setAttribute("id", ie.layerId), we.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(ie);
        var Re = ce.globalData.defs;
        Re.appendChild(we);
        var je = createNS("symbol");
        je.setAttribute("id", me), this.replaceInParent(ie, me), je.appendChild(ie.layerElement), Re.appendChild(je);
        var Ue = createNS("use");
        Ue.setAttribute("href", "#" + me), we.appendChild(Ue), ie.data.hd = !1, ie.show();
      }
      ce.setMatte(ie.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var ce = this.filterManager.effectElements[0].p.v, ie = this.elem.comp.elements, me = 0, we = ie.length; me < we; )
        ie[me] && ie[me].data.ind === ce && this.setElementAsMask(this.elem, ie[me]), me += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(ce, ie, me, we) {
      ce.setAttribute("x", "-100%"), ce.setAttribute("y", "-100%"), ce.setAttribute("width", "300%"), ce.setAttribute("height", "300%"), this.filterManager = ie;
      var Re = createNS("feGaussianBlur");
      Re.setAttribute("result", we), ce.appendChild(Re), this.feGaussianBlur = Re;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(ce) {
      if (ce || this.filterManager._mdf) {
        var ie = 0.3, me = this.filterManager.effectElements[0].p.v * ie, we = this.filterManager.effectElements[1].p.v, Re = we == 3 ? 0 : me, je = we == 2 ? 0 : me;
        this.feGaussianBlur.setAttribute("stdDeviation", Re + " " + je);
        var Ue = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", Ue);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(ce) {
      this.effectsManager = ce, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(ce) {
      if (this._opMdf = !1, this._mdf = !1, ce || this.effectsManager._mdf) {
        var ie = this.effectsManager.effectElements, me = ie[0].p.v, we = ie[1].p.v, Re = ie[2].p.v === 1, je = ie[3].p.v, Ue = Re ? je : ie[4].p.v, qe = ie[5].p.v, Ge = ie[6].p.v, Xe = ie[7].p.v;
        this.matrix.reset(), this.matrix.translate(-me[0], -me[1], me[2]), this.matrix.scale(Ue * 0.01, je * 0.01, 1), this.matrix.rotate(-Xe * degToRads), this.matrix.skewFromAxis(-qe * degToRads, (Ge + 90) * degToRads), this.matrix.translate(we[0], we[1], 0), this._mdf = !0, this.opacity !== ie[8].p.v && (this.opacity = ie[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(ce, ie) {
      this.init(ie);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(ce) {
      this.init(ce);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports);
function _arrayLikeToArray(ce, ie) {
  (ie == null || ie > ce.length) && (ie = ce.length);
  for (var me = 0, we = Array(ie); me < ie; me++) we[me] = ce[me];
  return we;
}
function _arrayWithHoles(ce) {
  if (Array.isArray(ce)) return ce;
}
function _defineProperty$1(ce, ie, me) {
  return (ie = _toPropertyKey(ie)) in ce ? Object.defineProperty(ce, ie, {
    value: me,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ce[ie] = me, ce;
}
function _iterableToArrayLimit(ce, ie) {
  var me = ce == null ? null : typeof Symbol < "u" && ce[Symbol.iterator] || ce["@@iterator"];
  if (me != null) {
    var we, Re, je, Ue, qe = [], Ge = !0, Xe = !1;
    try {
      if (je = (me = me.call(ce)).next, ie !== 0) for (; !(Ge = (we = je.call(me)).done) && (qe.push(we.value), qe.length !== ie); Ge = !0) ;
    } catch (ot) {
      Xe = !0, Re = ot;
    } finally {
      try {
        if (!Ge && me.return != null && (Ue = me.return(), Object(Ue) !== Ue)) return;
      } finally {
        if (Xe) throw Re;
      }
    }
    return qe;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ownKeys$1(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread2$1(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys$1(Object(me), !0).forEach(function(we) {
      _defineProperty$1(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys$1(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _objectWithoutProperties(ce, ie) {
  if (ce == null) return {};
  var me, we, Re = _objectWithoutPropertiesLoose(ce, ie);
  if (Object.getOwnPropertySymbols) {
    var je = Object.getOwnPropertySymbols(ce);
    for (we = 0; we < je.length; we++) me = je[we], ie.includes(me) || {}.propertyIsEnumerable.call(ce, me) && (Re[me] = ce[me]);
  }
  return Re;
}
function _objectWithoutPropertiesLoose(ce, ie) {
  if (ce == null) return {};
  var me = {};
  for (var we in ce) if ({}.hasOwnProperty.call(ce, we)) {
    if (ie.includes(we)) continue;
    me[we] = ce[we];
  }
  return me;
}
function _slicedToArray(ce, ie) {
  return _arrayWithHoles(ce) || _iterableToArrayLimit(ce, ie) || _unsupportedIterableToArray(ce, ie) || _nonIterableRest();
}
function _toPrimitive(ce, ie) {
  if (typeof ce != "object" || !ce) return ce;
  var me = ce[Symbol.toPrimitive];
  if (me !== void 0) {
    var we = me.call(ce, ie);
    if (typeof we != "object") return we;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (ie === "string" ? String : Number)(ce);
}
function _toPropertyKey(ce) {
  var ie = _toPrimitive(ce, "string");
  return typeof ie == "symbol" ? ie : ie + "";
}
function _unsupportedIterableToArray(ce, ie) {
  if (ce) {
    if (typeof ce == "string") return _arrayLikeToArray(ce, ie);
    var me = {}.toString.call(ce).slice(8, -1);
    return me === "Object" && ce.constructor && (me = ce.constructor.name), me === "Map" || me === "Set" ? Array.from(ce) : me === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(me) ? _arrayLikeToArray(ce, ie) : void 0;
  }
}
var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"], useLottie = function ce(ie, me) {
  var we = ie.animationData, Re = ie.loop, je = ie.autoplay, Ue = ie.initialSegment, qe = ie.onComplete, Ge = ie.onLoopComplete, Xe = ie.onEnterFrame, ot = ie.onSegmentStart, vt = ie.onConfigReady, bt = ie.onDataReady, Tt = ie.onDataFailed, wt = ie.onLoadedImages, St = ie.onDOMLoaded, It = ie.onDestroy;
  ie.lottieRef, ie.renderer, ie.name, ie.assetsPath, ie.rendererSettings;
  var Pt = _objectWithoutProperties(ie, _excluded$1), kt = useState(!1), Ot = _slicedToArray(kt, 2), Jr = Ot[0], en = Ot[1], nn = useRef(), ln = useRef(null), fn = function() {
    var An;
    (An = nn.current) === null || An === void 0 || An.play();
  }, vn = function() {
    var An;
    (An = nn.current) === null || An === void 0 || An.stop();
  }, Tn = function() {
    var An;
    (An = nn.current) === null || An === void 0 || An.pause();
  }, xn = function(An) {
    var In;
    (In = nn.current) === null || In === void 0 || In.setSpeed(An);
  }, bn = function(An, In) {
    var qn;
    (qn = nn.current) === null || qn === void 0 || qn.goToAndPlay(An, In);
  }, Sn = function(An, In) {
    var qn;
    (qn = nn.current) === null || qn === void 0 || qn.goToAndStop(An, In);
  }, Cn = function(An) {
    var In;
    (In = nn.current) === null || In === void 0 || In.setDirection(An);
  }, kn = function(An, In) {
    var qn;
    (qn = nn.current) === null || qn === void 0 || qn.playSegments(An, In);
  }, cn = function(An) {
    var In;
    (In = nn.current) === null || In === void 0 || In.setSubframe(An);
  }, gn = function(An) {
    var In;
    return (In = nn.current) === null || In === void 0 ? void 0 : In.getDuration(An);
  }, an = function() {
    var An;
    (An = nn.current) === null || An === void 0 || An.destroy(), nn.current = void 0;
  }, un = function() {
    var An = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, In;
    if (ln.current) {
      (In = nn.current) === null || In === void 0 || In.destroy();
      var qn = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, ie), An), {}, {
        container: ln.current
      });
      return nn.current = lottie.loadAnimation(qn), en(!!nn.current), function() {
        var si;
        (si = nn.current) === null || si === void 0 || si.destroy(), nn.current = void 0;
      };
    }
  };
  useEffect(function() {
    var hn = un();
    return function() {
      return hn == null ? void 0 : hn();
    };
  }, [we, Re]), useEffect(function() {
    nn.current && (nn.current.autoplay = !!je);
  }, [je]), useEffect(function() {
    if (nn.current) {
      if (!Ue) {
        nn.current.resetSegments(!0);
        return;
      }
      !Array.isArray(Ue) || !Ue.length || ((nn.current.currentRawFrame < Ue[0] || nn.current.currentRawFrame > Ue[1]) && (nn.current.currentRawFrame = Ue[0]), nn.current.setSegment(Ue[0], Ue[1]));
    }
  }, [Ue]), useEffect(function() {
    var hn = [{
      name: "complete",
      handler: qe
    }, {
      name: "loopComplete",
      handler: Ge
    }, {
      name: "enterFrame",
      handler: Xe
    }, {
      name: "segmentStart",
      handler: ot
    }, {
      name: "config_ready",
      handler: vt
    }, {
      name: "data_ready",
      handler: bt
    }, {
      name: "data_failed",
      handler: Tt
    }, {
      name: "loaded_images",
      handler: wt
    }, {
      name: "DOMLoaded",
      handler: St
    }, {
      name: "destroy",
      handler: It
    }], An = hn.filter(function(qn) {
      return qn.handler != null;
    });
    if (An.length) {
      var In = An.map(
        /**
         * Handle the process of adding an event listener
         * @param {Listener} listener
         * @return {Function} Function that deregister the listener
         */
        function(qn) {
          var si;
          return (si = nn.current) === null || si === void 0 || si.addEventListener(qn.name, qn.handler), function() {
            var bi;
            (bi = nn.current) === null || bi === void 0 || bi.removeEventListener(qn.name, qn.handler);
          };
        }
      );
      return function() {
        In.forEach(function(qn) {
          return qn();
        });
      };
    }
  }, [qe, Ge, Xe, ot, vt, bt, Tt, wt, St, It]);
  var pn = /* @__PURE__ */ React__default.createElement("div", _objectSpread2$1({
    style: me,
    ref: ln
  }, Pt));
  return {
    View: pn,
    play: fn,
    stop: vn,
    pause: Tn,
    setSpeed: xn,
    goToAndStop: Sn,
    goToAndPlay: bn,
    setDirection: Cn,
    playSegments: kn,
    setSubframe: cn,
    getDuration: gn,
    destroy: an,
    animationContainerRef: ln,
    animationLoaded: Jr,
    animationItem: nn.current
  };
};
function getContainerVisibility(ce) {
  var ie = ce.getBoundingClientRect(), me = ie.top, we = ie.height, Re = window.innerHeight - me, je = window.innerHeight + we;
  return Re / je;
}
function getContainerCursorPosition(ce, ie, me) {
  var we = ce.getBoundingClientRect(), Re = we.top, je = we.left, Ue = we.width, qe = we.height, Ge = (ie - je) / Ue, Xe = (me - Re) / qe;
  return {
    x: Ge,
    y: Xe
  };
}
var useInitInteractivity = function ce(ie) {
  var me = ie.wrapperRef, we = ie.animationItem, Re = ie.mode, je = ie.actions;
  useEffect(function() {
    var Ue = me.current;
    if (!(!Ue || !we || !je.length)) {
      we.stop();
      var qe = function() {
        var ot = null, vt = function() {
          var Tt = getContainerVisibility(Ue), wt = je.find(function(It) {
            var Pt = It.visibility;
            return Pt && Tt >= Pt[0] && Tt <= Pt[1];
          });
          if (wt) {
            if (wt.type === "seek" && wt.visibility && wt.frames.length === 2) {
              var St = wt.frames[0] + Math.ceil((Tt - wt.visibility[0]) / (wt.visibility[1] - wt.visibility[0]) * wt.frames[1]);
              //! goToAndStop must be relative to the start of the current segment
              we.goToAndStop(St - we.firstFrame - 1, !0);
            }
            wt.type === "loop" && (ot === null || ot !== wt.frames || we.isPaused) && (we.playSegments(wt.frames, !0), ot = wt.frames), wt.type === "play" && we.isPaused && (we.resetSegments(!0), we.play()), wt.type === "stop" && we.goToAndStop(wt.frames[0] - we.firstFrame - 1, !0);
          }
        };
        return document.addEventListener("scroll", vt), function() {
          document.removeEventListener("scroll", vt);
        };
      }, Ge = function() {
        var ot = function(wt, St) {
          var It = wt, Pt = St;
          if (It !== -1 && Pt !== -1) {
            var kt = getContainerCursorPosition(Ue, It, Pt);
            It = kt.x, Pt = kt.y;
          }
          var Ot = je.find(function(nn) {
            var ln = nn.position;
            return ln && Array.isArray(ln.x) && Array.isArray(ln.y) ? It >= ln.x[0] && It <= ln.x[1] && Pt >= ln.y[0] && Pt <= ln.y[1] : ln && !Number.isNaN(ln.x) && !Number.isNaN(ln.y) ? It === ln.x && Pt === ln.y : !1;
          });
          if (Ot) {
            if (Ot.type === "seek" && Ot.position && Array.isArray(Ot.position.x) && Array.isArray(Ot.position.y) && Ot.frames.length === 2) {
              var Jr = (It - Ot.position.x[0]) / (Ot.position.x[1] - Ot.position.x[0]), en = (Pt - Ot.position.y[0]) / (Ot.position.y[1] - Ot.position.y[0]);
              we.playSegments(Ot.frames, !0), we.goToAndStop(Math.ceil((Jr + en) / 2 * (Ot.frames[1] - Ot.frames[0])), !0);
            }
            Ot.type === "loop" && we.playSegments(Ot.frames, !0), Ot.type === "play" && (we.isPaused && we.resetSegments(!1), we.playSegments(Ot.frames)), Ot.type === "stop" && we.goToAndStop(Ot.frames[0], !0);
          }
        }, vt = function(wt) {
          ot(wt.clientX, wt.clientY);
        }, bt = function() {
          ot(-1, -1);
        };
        return Ue.addEventListener("mousemove", vt), Ue.addEventListener("mouseout", bt), function() {
          Ue.removeEventListener("mousemove", vt), Ue.removeEventListener("mouseout", bt);
        };
      };
      switch (Re) {
        case "scroll":
          return qe();
        case "cursor":
          return Ge();
      }
    }
  }, [Re, we]);
}, useLottieInteractivity = function ce(ie) {
  var me = ie.actions, we = ie.mode, Re = ie.lottieObj, je = Re.animationItem, Ue = Re.View, qe = Re.animationContainerRef;
  return useInitInteractivity({
    actions: me,
    animationItem: je,
    mode: we,
    wrapperRef: qe
  }), Ue;
}, _excluded$2 = ["style", "interactivity"], Lottie = function ce(ie) {
  var me, we, Re, je = ie.style, Ue = ie.interactivity, qe = _objectWithoutProperties(ie, _excluded$2), Ge = useLottie(qe, je), Xe = Ge.View, ot = Ge.play, vt = Ge.stop, bt = Ge.pause, Tt = Ge.setSpeed, wt = Ge.goToAndStop, St = Ge.goToAndPlay, It = Ge.setDirection, Pt = Ge.playSegments, kt = Ge.setSubframe, Ot = Ge.getDuration, Jr = Ge.destroy, en = Ge.animationContainerRef, nn = Ge.animationLoaded, ln = Ge.animationItem;
  return useEffect(function() {
    ie.lottieRef && (ie.lottieRef.current = {
      play: ot,
      stop: vt,
      pause: bt,
      setSpeed: Tt,
      goToAndPlay: St,
      goToAndStop: wt,
      setDirection: It,
      playSegments: Pt,
      setSubframe: kt,
      getDuration: Ot,
      destroy: Jr,
      animationContainerRef: en,
      animationLoaded: nn,
      animationItem: ln
    });
  }, [(me = ie.lottieRef) === null || me === void 0 ? void 0 : me.current]), useLottieInteractivity({
    lottieObj: {
      View: Xe,
      play: ot,
      stop: vt,
      pause: bt,
      setSpeed: Tt,
      goToAndStop: wt,
      goToAndPlay: St,
      setDirection: It,
      playSegments: Pt,
      setSubframe: kt,
      getDuration: Ot,
      destroy: Jr,
      animationContainerRef: en,
      animationLoaded: nn,
      animationItem: ln
    },
    actions: (we = Ue == null ? void 0 : Ue.actions) !== null && we !== void 0 ? we : [],
    mode: (Re = Ue == null ? void 0 : Ue.mode) !== null && Re !== void 0 ? Re : "scroll"
  });
};
const MedalLodge = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(Lottie, { animationData: animation, ...ce }), CongratulationsOverlay = ({
  title: ce,
  subtitle: ie,
  button: me,
  secondaryButton: we,
  isMobile: Re
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "h-full w-full absolute bg-background flex flex-col justify-center items-center overflow-auto py-4 px-2", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames("mb-6", { "w-70": !Re }, { "w-21": Re }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}), children: /* @__PURE__ */ jsxRuntimeExports.jsx(MedalLodge, { loop: !1 }) }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: Re ? "l" : "xxl", weight: "bold", center: !0, className: "mb-6 ", children: ce }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: Re ? "base" : "l", weight: "bold", center: !0, className: "mb-8", children: ie }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-3", children: me }),
  we
] }), VoiceSelector = (ce) => {
  const ie = ce.currentLanguage ?? Object.keys(ce.languages)[0], me = ce.currentVoice ?? ce.languages[ie][0].voiceId, we = (je) => {
    const Ue = ce.languages[je][0].voiceId;
    ce.onChange(je, Ue);
  }, Re = (je) => ce.onChange(ie, je);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "semibold", size: "base", children: "Generate voiceover with AI" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "semibold", size: "s", children: "Language" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CustomSelect,
      {
        fullWidth: !0,
        defaultValue: ie,
        values: Object.keys(ce.languages).map((je) => je),
        onChange: we,
        labelRenderFn: (je) => je
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "semibold", size: "s", children: "Voice" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CustomSelect,
      {
        fullWidth: !0,
        defaultValue: me,
        options: ce.languages[ie].map((je) => ({ label: je.personName, value: je.voiceId })),
        onChange: Re,
        labelRenderFn: (je) => je
      }
    )
  ] });
}, VoiceoverPreviewModal = (ce) => {
  const [ie, me] = useState(!1), we = useSwitch(ce.saveSubtitlesDefault);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "semibold", size: "base", children: "Voiceover" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AudioPlayer, { src: ce.voiceUrl }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "bold", size: "xs", children: "Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "max-h-50 overflow-auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "grey-350", invertInLightTheme: !0, weight: "regular", size: "xs", children: ce.speechText }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, size: "xs", weight: "bold", children: "Generate subtitles" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { checked: we.isOn, onChange: we.toggle }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-row justify-end items-center gap-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: ce.onBack, variant: ButtonVariant.TEXT, children: "Back" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: () => {
            me(!0), ce.onInsert(we.isOn).then(() => me(!1)).catch((Re) => console.log("failed to insert audio: ", Re));
          },
          disabled: ie,
          variant: ButtonVariant.PRIMARY,
          children: ie ? "Inserting audio..." : "Insert audio"
        }
      )
    ] })
  ] });
}, ENGLISH_US = "English (United States)", TextToSpeechWizard = (ce) => {
  var Tt, wt;
  const [ie, me] = useState(void 0), [we, Re] = useState(((Tt = ce.defaultLanguage) == null ? void 0 : Tt.language) || ENGLISH_US), [je, Ue] = useState(((wt = ce.defaultLanguage) == null ? void 0 : wt.voiceId) || ce.languages[ENGLISH_US][0].voiceId), [qe, Ge] = useState(ce.text ?? ""), Xe = useRef(null);
  useEffect(() => () => {
    vt();
  }, []);
  const ot = () => {
    var St;
    vt(), Xe.current = new Audio(
      `${ce.urlPrefix}${((St = ce.languages[we].find((It) => It.voiceId === je)) == null ? void 0 : St.sampleFileName) ?? ""}`
    ), Xe.current.play().catch((It) => console.log("Sample failed to play:", It));
  }, vt = () => {
    Xe.current && (Xe.current.pause(), Xe.current.currentTime = 0);
  }, bt = () => {
    vt(), me(null), ce.onGenerate(we, je, qe).then(me).catch(console.error);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    ie === void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        VoiceSelector,
        {
          languages: ce.languages,
          currentVoice: je,
          currentLanguage: we,
          onChange: (St, It) => {
            Re(St), Ue(It);
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: ButtonVariant.SECONDARY, onClick: ot, icon: faPlay, children: "Play sample track" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { type: "dark" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { color: "white", invertInLightTheme: !0, weight: "semibold", size: "s", children: "Text" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextArea, { fullWidth: !0, onChange: Ge, placeholder: "Paste your script here...", value: qe }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-row justify-end gap-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: ce.onCancel, variant: ButtonVariant.TEXT, children: "Cancel" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: bt, disabled: !qe, variant: ButtonVariant.PRIMARY, children: "Generate voice from text" })
      ] })
    ] }),
    ie === null && /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderThreeDots, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { size: "xs", weight: "regular", children: "This might take couple seconds based on the text length." })
    ] }),
    ie && /* @__PURE__ */ jsxRuntimeExports.jsx(
      VoiceoverPreviewModal,
      {
        speechText: qe,
        voiceUrl: ie,
        saveSubtitlesDefault: ce.saveSubtitlesDefault,
        onInsert: (St) => ce.onInsert(we, je, St),
        onBack: () => {
          me(void 0);
        }
      }
    )
  ] });
}, CollapsibleButton = (ce) => {
  const ie = React__default.useRef(null), { isOpen: me, setIsOpen: we } = useClickOut(!1, ie), Re = () => we((je) => !je);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: ie, className: "relative", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AnimateHeight,
      {
        height: me ? "auto" : 0,
        duration: 500,
        animateOpacity: !0,
        className: classNames(
          "absolute bottom-100% z--1 border-rd-t-22px overflow-hidden transition-all-500 box-content",
          {
            "": me
          }
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-surface", children: ce.children })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoundButton,
      {
        className: classNames("border-rd-b-22px transition-all-500", {
          "important:bg-surface": me
        }),
        content: ce.roundButtonContent,
        onClick: Re,
        color: me ? RoundButtonColor.YellowIcon : RoundButtonColor.Default
      }
    )
  ] });
}, getSpeedText = (ce, ie) => {
  const me = `${ce}`, we = ce.toString().replace(".", "").length > 1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { weight: "semibold", size: we ? "s" : void 0, color: ie ? "accent" : "inherit", children: [
    me,
    /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faXmark$2, fontSize: 16, transform: "down-1" })
  ] });
}, AudioSpeedButton = ({ speed: ce, isActive: ie, onClick: me }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RoundButton,
  {
    onClick: () => me(ce),
    content: {
      type: "text",
      children: getSpeedText(ce, ie)
    }
  }
), audioSpeeds = [0.9, 1, 1.2, 1.4], AudioSpeedCollapsibleToolbar = ({
  currentSpeed: ce,
  isMobile: ie,
  onSpeedChange: me
}) => {
  if (ie) {
    const we = () => {
      const je = (audioSpeeds.indexOf(ce) + 1) % audioSpeeds.length;
      me(audioSpeeds[je]);
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(AudioSpeedButton, { speed: ce, onClick: we });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CollapsibleButton,
    {
      roundButtonContent: {
        type: "text",
        children: getSpeedText(ce, !1)
      },
      children: audioSpeeds.map((we) => /* @__PURE__ */ jsxRuntimeExports.jsx(AudioSpeedButton, { speed: we, isActive: ce === we, onClick: me }, we))
    }
  );
}, CaptionsButton = ({ onClick: ce, captionsEnabled: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RoundButton,
  {
    content: { type: "icon", icon: faClosedCaptioning },
    color: ie ? RoundButtonColor.YellowIcon : RoundButtonColor.Default,
    onClick: ce
  }
), CaptionsButtonWithTooltip = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { bodyText: ce.tooltipText, placement: "top", mouseEnterDelay: 1, trigger: ["hover"], children: /* @__PURE__ */ jsxRuntimeExports.jsx(CaptionsButton, { captionsEnabled: ce.areCaptionsEnabled, onClick: ce.onClick }) }), MuteButtonTooltip = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Tooltip,
  {
    bodyText: ce.isMuted ? ce.tooltipTextUnmute : ce.tooltipTextMute,
    placement: "top",
    mouseEnterDelay: 1,
    trigger: ["hover"],
    children: ce.children
  }
), MuteButton = ({ onClick: ce, isMuted: ie }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RoundButton,
  {
    content: { type: "icon", icon: faVolumeMute },
    onClick: ce,
    color: ie ? RoundButtonColor.YellowIcon : RoundButtonColor.Default
  }
), MuteButtonWithTooltip = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  MuteButtonTooltip,
  {
    isMuted: ce.muted,
    tooltipTextMute: ce.tooltipTextMute,
    tooltipTextUnmute: ce.tooltipTextUnmute,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MuteButton, { onClick: ce.onClick, isMuted: ce.muted })
  }
), RewindButtonWithTooltip = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { bodyText: ce.tooltipText, placement: "top", mouseEnterDelay: 1, trigger: ["hover"], children: /* @__PURE__ */ jsxRuntimeExports.jsx(RewindButton, { onClick: ce.onClick, rewindTime: ce.rewindTime }) }), Toolbar = (ce) => ce.isCollapsible ? /* @__PURE__ */ jsxRuntimeExports.jsx(CollapsibleButton, { roundButtonContent: { type: "icon", icon: faVolumeUp }, children: ce.children }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ce.children }), AudioToolbar = ({
  captionSrc: ce,
  rewindTime: ie,
  captionsEnabled: me,
  isMuted: we,
  isCollapsible: Re,
  audioSpeed: je,
  onRewindBack: Ue,
  onCaptionsClick: qe,
  onToggleMute: Ge,
  onChangeSpeed: Xe,
  tooltipMessages: ot
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Toolbar, { isCollapsible: Re, children: [
  Re && /* @__PURE__ */ jsxRuntimeExports.jsx(AudioSpeedCollapsibleToolbar, { isMobile: !0, currentSpeed: je, onSpeedChange: Xe }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(RewindButtonWithTooltip, { onClick: Ue, rewindTime: ie, tooltipText: ot.rewind }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    MuteButtonWithTooltip,
    {
      muted: we,
      onClick: Ge,
      tooltipTextMute: ot.mute,
      tooltipTextUnmute: ot.unmute
    }
  ),
  ce && /* @__PURE__ */ jsxRuntimeExports.jsx(
    CaptionsButtonWithTooltip,
    {
      areCaptionsEnabled: me,
      onClick: qe,
      tooltipText: ot.subtitles
    }
  )
] });
function addEventListenerWrap(ce, ie, me, we) {
  var Re = ReactDOM__default.unstable_batchedUpdates ? function(Ue) {
    ReactDOM__default.unstable_batchedUpdates(me, Ue);
  } : me;
  return ce != null && ce.addEventListener && ce.addEventListener(ie, Re, we), {
    remove: function() {
      ce != null && ce.removeEventListener && ce.removeEventListener(ie, Re, we);
    }
  };
}
var Portal = /* @__PURE__ */ forwardRef(function(ce, ie) {
  var me = ce.didUpdate, we = ce.getContainer, Re = ce.children, je = useRef(), Ue = useRef();
  useImperativeHandle(ie, function() {
    return {};
  });
  var qe = useRef(!1);
  return !qe.current && canUseDom() && (Ue.current = we(), je.current = Ue.current.parentNode, qe.current = !0), useEffect(function() {
    me == null || me(ce);
  }), useEffect(function() {
    return Ue.current.parentNode === null && je.current !== null && je.current.appendChild(Ue.current), function() {
      var Ge;
      (Ge = Ue.current) === null || Ge === void 0 || (Ge = Ge.parentNode) === null || Ge === void 0 || Ge.removeChild(Ue.current);
    };
  }, []), Ue.current ? /* @__PURE__ */ ReactDOM__default.createPortal(Re, Ue.current) : null;
});
function isPointsEq(ce, ie, me) {
  return me ? ce[0] === ie[0] : ce[0] === ie[0] && ce[1] === ie[1];
}
function getAlignFromPlacement(ce, ie, me) {
  var we = ce[ie] || {};
  return _objectSpread2$2(_objectSpread2$2({}, we), me);
}
function getAlignPopupClassName(ce, ie, me, we) {
  for (var Re = me.points, je = Object.keys(ce), Ue = 0; Ue < je.length; Ue += 1) {
    var qe = je[Ue];
    if (isPointsEq(ce[qe].points, Re, we))
      return "".concat(ie, "-placement-").concat(qe);
  }
  return "";
}
function getMotion(ce) {
  var ie = ce.prefixCls, me = ce.motion, we = ce.animation, Re = ce.transitionName;
  return me || (we ? {
    motionName: "".concat(ie, "-").concat(we)
  } : Re ? {
    motionName: Re
  } : null);
}
function Mask(ce) {
  var ie = ce.prefixCls, me = ce.visible, we = ce.zIndex, Re = ce.mask, je = ce.maskMotion, Ue = ce.maskAnimation, qe = ce.maskTransitionName;
  if (!Re)
    return null;
  var Ge = {};
  return (je || qe || Ue) && (Ge = _objectSpread2$2({
    motionAppear: !0
  }, getMotion({
    motion: je,
    prefixCls: ie,
    transitionName: qe,
    animation: Ue
  }))), /* @__PURE__ */ React.createElement(CSSMotion, _extends$j({}, Ge, {
    visible: me,
    removeOnLeave: !0
  }), function(Xe) {
    var ot = Xe.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex: we
      },
      className: classNames("".concat(ie, "-mask"), ot)
    });
  });
}
function ownKeys(ce, ie) {
  var me = Object.keys(ce);
  if (Object.getOwnPropertySymbols) {
    var we = Object.getOwnPropertySymbols(ce);
    ie && (we = we.filter(function(Re) {
      return Object.getOwnPropertyDescriptor(ce, Re).enumerable;
    })), me.push.apply(me, we);
  }
  return me;
}
function _objectSpread2(ce) {
  for (var ie = 1; ie < arguments.length; ie++) {
    var me = arguments[ie] != null ? arguments[ie] : {};
    ie % 2 ? ownKeys(Object(me), !0).forEach(function(we) {
      _defineProperty(ce, we, me[we]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ce, Object.getOwnPropertyDescriptors(me)) : ownKeys(Object(me)).forEach(function(we) {
      Object.defineProperty(ce, we, Object.getOwnPropertyDescriptor(me, we));
    });
  }
  return ce;
}
function _typeof(ce) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
    return typeof ie;
  } : function(ie) {
    return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
  }, _typeof(ce);
}
function _defineProperty(ce, ie, me) {
  return ie in ce ? Object.defineProperty(ce, ie, {
    value: me,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : ce[ie] = me, ce;
}
var vendorPrefix, jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0)
    return vendorPrefix;
  vendorPrefix = "";
  var ce = document.createElement("p").style, ie = "Transform";
  for (var me in jsCssMap)
    me + ie in ce && (vendorPrefix = me);
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(ce, ie) {
  var me = getTransitionName();
  me && (ce.style[me] = ie, me !== "transitionProperty" && (ce.style.transitionProperty = ie));
}
function setTransform(ce, ie) {
  var me = getTransformName();
  me && (ce.style[me] = ie, me !== "transform" && (ce.style.transform = ie));
}
function getTransitionProperty(ce) {
  return ce.style.transitionProperty || ce.style[getTransitionName()];
}
function getTransformXY(ce) {
  var ie = window.getComputedStyle(ce, null), me = ie.getPropertyValue("transform") || ie.getPropertyValue(getTransformName());
  if (me && me !== "none") {
    var we = me.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(we[12] || we[4], 0),
      y: parseFloat(we[13] || we[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/, matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(ce, ie) {
  var me = window.getComputedStyle(ce, null), we = me.getPropertyValue("transform") || me.getPropertyValue(getTransformName());
  if (we && we !== "none") {
    var Re, je = we.match(matrix2d);
    if (je)
      je = je[1], Re = je.split(",").map(function(qe) {
        return parseFloat(qe, 10);
      }), Re[4] = ie.x, Re[5] = ie.y, setTransform(ce, "matrix(".concat(Re.join(","), ")"));
    else {
      var Ue = we.match(matrix3d)[1];
      Re = Ue.split(",").map(function(qe) {
        return parseFloat(qe, 10);
      }), Re[12] = ie.x, Re[13] = ie.y, setTransform(ce, "matrix3d(".concat(Re.join(","), ")"));
    }
  } else
    setTransform(ce, "translateX(".concat(ie.x, "px) translateY(").concat(ie.y, "px) translateZ(0)"));
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, getComputedStyleX;
function forceRelayout(ce) {
  var ie = ce.style.display;
  ce.style.display = "none", ce.offsetHeight, ce.style.display = ie;
}
function css(ce, ie, me) {
  var we = me;
  if (_typeof(ie) === "object") {
    for (var Re in ie)
      ie.hasOwnProperty(Re) && css(ce, Re, ie[Re]);
    return;
  }
  if (typeof we < "u") {
    typeof we == "number" && (we = "".concat(we, "px")), ce.style[ie] = we;
    return;
  }
  return getComputedStyleX(ce, ie);
}
function getClientPosition(ce) {
  var ie, me, we, Re = ce.ownerDocument, je = Re.body, Ue = Re && Re.documentElement;
  return ie = ce.getBoundingClientRect(), me = Math.floor(ie.left), we = Math.floor(ie.top), me -= Ue.clientLeft || je.clientLeft || 0, we -= Ue.clientTop || je.clientTop || 0, {
    left: me,
    top: we
  };
}
function getScroll(ce, ie) {
  var me = ce["page".concat(ie ? "Y" : "X", "Offset")], we = "scroll".concat(ie ? "Top" : "Left");
  if (typeof me != "number") {
    var Re = ce.document;
    me = Re.documentElement[we], typeof me != "number" && (me = Re.body[we]);
  }
  return me;
}
function getScrollLeft(ce) {
  return getScroll(ce);
}
function getScrollTop(ce) {
  return getScroll(ce, !0);
}
function getOffset(ce) {
  var ie = getClientPosition(ce), me = ce.ownerDocument, we = me.defaultView || me.parentWindow;
  return ie.left += getScrollLeft(we), ie.top += getScrollTop(we), ie;
}
function isWindow(ce) {
  return ce != null && ce == ce.window;
}
function getDocument(ce) {
  return isWindow(ce) ? ce.document : ce.nodeType === 9 ? ce : ce.ownerDocument;
}
function _getComputedStyle(ce, ie, me) {
  var we = me, Re = "", je = getDocument(ce);
  return we = we || je.defaultView.getComputedStyle(ce, null), we && (Re = we.getPropertyValue(ie) || we[ie]), Re;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i"), RE_POS = /^(top|right|bottom|left)$/, CURRENT_STYLE = "currentStyle", RUNTIME_STYLE = "runtimeStyle", LEFT = "left", PX = "px";
function _getComputedStyleIE(ce, ie) {
  var me = ce[CURRENT_STYLE] && ce[CURRENT_STYLE][ie];
  if (_RE_NUM_NO_PX.test(me) && !RE_POS.test(ie)) {
    var we = ce.style, Re = we[LEFT], je = ce[RUNTIME_STYLE][LEFT];
    ce[RUNTIME_STYLE][LEFT] = ce[CURRENT_STYLE][LEFT], we[LEFT] = ie === "fontSize" ? "1em" : me || 0, me = we.pixelLeft + PX, we[LEFT] = Re, ce[RUNTIME_STYLE][LEFT] = je;
  }
  return me === "" ? "auto" : me;
}
typeof window < "u" && (getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE);
function getOffsetDirection(ce, ie) {
  return ce === "left" ? ie.useCssRight ? "right" : ce : ie.useCssBottom ? "bottom" : ce;
}
function oppositeOffsetDirection(ce) {
  if (ce === "left")
    return "right";
  if (ce === "right")
    return "left";
  if (ce === "top")
    return "bottom";
  if (ce === "bottom")
    return "top";
}
function setLeftTop(ce, ie, me) {
  css(ce, "position") === "static" && (ce.style.position = "relative");
  var we = -999, Re = -999, je = getOffsetDirection("left", me), Ue = getOffsetDirection("top", me), qe = oppositeOffsetDirection(je), Ge = oppositeOffsetDirection(Ue);
  je !== "left" && (we = 999), Ue !== "top" && (Re = 999);
  var Xe = "", ot = getOffset(ce);
  ("left" in ie || "top" in ie) && (Xe = getTransitionProperty(ce) || "", setTransitionProperty(ce, "none")), "left" in ie && (ce.style[qe] = "", ce.style[je] = "".concat(we, "px")), "top" in ie && (ce.style[Ge] = "", ce.style[Ue] = "".concat(Re, "px")), forceRelayout(ce);
  var vt = getOffset(ce), bt = {};
  for (var Tt in ie)
    if (ie.hasOwnProperty(Tt)) {
      var wt = getOffsetDirection(Tt, me), St = Tt === "left" ? we : Re, It = ot[Tt] - vt[Tt];
      wt === Tt ? bt[wt] = St + It : bt[wt] = St - It;
    }
  css(ce, bt), forceRelayout(ce), ("left" in ie || "top" in ie) && setTransitionProperty(ce, Xe);
  var Pt = {};
  for (var kt in ie)
    if (ie.hasOwnProperty(kt)) {
      var Ot = getOffsetDirection(kt, me), Jr = ie[kt] - ot[kt];
      kt === Ot ? Pt[Ot] = bt[Ot] + Jr : Pt[Ot] = bt[Ot] - Jr;
    }
  css(ce, Pt);
}
function setTransform$1(ce, ie) {
  var me = getOffset(ce), we = getTransformXY(ce), Re = {
    x: we.x,
    y: we.y
  };
  "left" in ie && (Re.x = we.x + ie.left - me.left), "top" in ie && (Re.y = we.y + ie.top - me.top), setTransformXY(ce, Re);
}
function setOffset(ce, ie, me) {
  if (me.ignoreShake) {
    var we = getOffset(ce), Re = we.left.toFixed(0), je = we.top.toFixed(0), Ue = ie.left.toFixed(0), qe = ie.top.toFixed(0);
    if (Re === Ue && je === qe)
      return;
  }
  me.useCssRight || me.useCssBottom ? setLeftTop(ce, ie, me) : me.useCssTransform && getTransformName() in document.body.style ? setTransform$1(ce, ie) : setLeftTop(ce, ie, me);
}
function each(ce, ie) {
  for (var me = 0; me < ce.length; me++)
    ie(ce[me]);
}
function isBorderBoxFn(ce) {
  return getComputedStyleX(ce, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"], CONTENT_INDEX = -1, PADDING_INDEX = 2, BORDER_INDEX = 1, MARGIN_INDEX = 0;
function swap(ce, ie, me) {
  var we = {}, Re = ce.style, je;
  for (je in ie)
    ie.hasOwnProperty(je) && (we[je] = Re[je], Re[je] = ie[je]);
  me.call(ce);
  for (je in ie)
    ie.hasOwnProperty(je) && (Re[je] = we[je]);
}
function getPBMWidth(ce, ie, me) {
  var we = 0, Re, je, Ue;
  for (je = 0; je < ie.length; je++)
    if (Re = ie[je], Re)
      for (Ue = 0; Ue < me.length; Ue++) {
        var qe = void 0;
        Re === "border" ? qe = "".concat(Re).concat(me[Ue], "Width") : qe = Re + me[Ue], we += parseFloat(getComputedStyleX(ce, qe)) || 0;
      }
  return we;
}
var domUtils = {
  getParent: function ce(ie) {
    var me = ie;
    do
      me.nodeType === 11 && me.host ? me = me.host : me = me.parentNode;
    while (me && me.nodeType !== 1 && me.nodeType !== 9);
    return me;
  }
};
each(["Width", "Height"], function(ce) {
  domUtils["doc".concat(ce)] = function(ie) {
    var me = ie.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      me.documentElement["scroll".concat(ce)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      me.body["scroll".concat(ce)],
      domUtils["viewport".concat(ce)](me)
    );
  }, domUtils["viewport".concat(ce)] = function(ie) {
    var me = "client".concat(ce), we = ie.document, Re = we.body, je = we.documentElement, Ue = je[me];
    return we.compatMode === "CSS1Compat" && Ue || Re && Re[me] || Ue;
  };
});
function getWH(ce, ie, me) {
  var we = me;
  if (isWindow(ce))
    return ie === "width" ? domUtils.viewportWidth(ce) : domUtils.viewportHeight(ce);
  if (ce.nodeType === 9)
    return ie === "width" ? domUtils.docWidth(ce) : domUtils.docHeight(ce);
  var Re = ie === "width" ? ["Left", "Right"] : ["Top", "Bottom"], je = Math.floor(ie === "width" ? ce.getBoundingClientRect().width : ce.getBoundingClientRect().height), Ue = isBorderBoxFn(ce), qe = 0;
  (je == null || je <= 0) && (je = void 0, qe = getComputedStyleX(ce, ie), (qe == null || Number(qe) < 0) && (qe = ce.style[ie] || 0), qe = Math.floor(parseFloat(qe)) || 0), we === void 0 && (we = Ue ? BORDER_INDEX : CONTENT_INDEX);
  var Ge = je !== void 0 || Ue, Xe = je || qe;
  return we === CONTENT_INDEX ? Ge ? Xe - getPBMWidth(ce, ["border", "padding"], Re) : qe : Ge ? we === BORDER_INDEX ? Xe : Xe + (we === PADDING_INDEX ? -getPBMWidth(ce, ["border"], Re) : getPBMWidth(ce, ["margin"], Re)) : qe + getPBMWidth(ce, BOX_MODELS.slice(we), Re);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var ce = arguments.length, ie = new Array(ce), me = 0; me < ce; me++)
    ie[me] = arguments[me];
  var we, Re = ie[0];
  return Re.offsetWidth !== 0 ? we = getWH.apply(void 0, ie) : swap(Re, cssShow, function() {
    we = getWH.apply(void 0, ie);
  }), we;
}
each(["width", "height"], function(ce) {
  var ie = ce.charAt(0).toUpperCase() + ce.slice(1);
  domUtils["outer".concat(ie)] = function(we, Re) {
    return we && getWHIgnoreDisplay(we, ce, Re ? MARGIN_INDEX : BORDER_INDEX);
  };
  var me = ce === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[ce] = function(we, Re) {
    var je = Re;
    if (je !== void 0) {
      if (we) {
        var Ue = isBorderBoxFn(we);
        return Ue && (je += getPBMWidth(we, ["padding", "border"], me)), css(we, ce, je);
      }
      return;
    }
    return we && getWHIgnoreDisplay(we, ce, CONTENT_INDEX);
  };
});
function mix(ce, ie) {
  for (var me in ie)
    ie.hasOwnProperty(me) && (ce[me] = ie[me]);
  return ce;
}
var utils = {
  getWindow: function ce(ie) {
    if (ie && ie.document && ie.setTimeout)
      return ie;
    var me = ie.ownerDocument || ie;
    return me.defaultView || me.parentWindow;
  },
  getDocument,
  offset: function ce(ie, me, we) {
    if (typeof me < "u")
      setOffset(ie, me, we || {});
    else
      return getOffset(ie);
  },
  isWindow,
  each,
  css,
  clone: function ce(ie) {
    var me, we = {};
    for (me in ie)
      ie.hasOwnProperty(me) && (we[me] = ie[me]);
    var Re = ie.overflow;
    if (Re)
      for (me in ie)
        ie.hasOwnProperty(me) && (we.overflow[me] = ie.overflow[me]);
    return we;
  },
  mix,
  getWindowScrollLeft: function ce(ie) {
    return getScrollLeft(ie);
  },
  getWindowScrollTop: function ce(ie) {
    return getScrollTop(ie);
  },
  merge: function ce() {
    for (var ie = {}, me = 0; me < arguments.length; me++)
      utils.mix(ie, me < 0 || arguments.length <= me ? void 0 : arguments[me]);
    return ie;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);
var getParent = utils.getParent;
function getOffsetParent(ce) {
  if (utils.isWindow(ce) || ce.nodeType === 9)
    return null;
  var ie = utils.getDocument(ce), me = ie.body, we, Re = utils.css(ce, "position"), je = Re === "fixed" || Re === "absolute";
  if (!je)
    return ce.nodeName.toLowerCase() === "html" ? null : getParent(ce);
  for (we = getParent(ce); we && we !== me && we.nodeType !== 9; we = getParent(we))
    if (Re = utils.css(we, "position"), Re !== "static")
      return we;
  return null;
}
var getParent$1 = utils.getParent;
function isAncestorFixed(ce) {
  if (utils.isWindow(ce) || ce.nodeType === 9)
    return !1;
  var ie = utils.getDocument(ce), me = ie.body, we = null;
  for (
    we = getParent$1(ce);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    we && we !== me && we !== ie;
    we = getParent$1(we)
  ) {
    var Re = utils.css(we, "position");
    if (Re === "fixed")
      return !0;
  }
  return !1;
}
function getVisibleRectForElement(ce, ie) {
  for (var me = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, we = getOffsetParent(ce), Re = utils.getDocument(ce), je = Re.defaultView || Re.parentWindow, Ue = Re.body, qe = Re.documentElement; we; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || we.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    we !== Ue && we !== qe && utils.css(we, "overflow") !== "visible") {
      var Ge = utils.offset(we);
      Ge.left += we.clientLeft, Ge.top += we.clientTop, me.top = Math.max(me.top, Ge.top), me.right = Math.min(
        me.right,
        // consider area without scrollBar
        Ge.left + we.clientWidth
      ), me.bottom = Math.min(me.bottom, Ge.top + we.clientHeight), me.left = Math.max(me.left, Ge.left);
    } else if (we === Ue || we === qe)
      break;
    we = getOffsetParent(we);
  }
  var Xe = null;
  if (!utils.isWindow(ce) && ce.nodeType !== 9) {
    Xe = ce.style.position;
    var ot = utils.css(ce, "position");
    ot === "absolute" && (ce.style.position = "fixed");
  }
  var vt = utils.getWindowScrollLeft(je), bt = utils.getWindowScrollTop(je), Tt = utils.viewportWidth(je), wt = utils.viewportHeight(je), St = qe.scrollWidth, It = qe.scrollHeight, Pt = window.getComputedStyle(Ue);
  if (Pt.overflowX === "hidden" && (St = je.innerWidth), Pt.overflowY === "hidden" && (It = je.innerHeight), ce.style && (ce.style.position = Xe), ie || isAncestorFixed(ce))
    me.left = Math.max(me.left, vt), me.top = Math.max(me.top, bt), me.right = Math.min(me.right, vt + Tt), me.bottom = Math.min(me.bottom, bt + wt);
  else {
    var kt = Math.max(St, vt + Tt);
    me.right = Math.min(me.right, kt);
    var Ot = Math.max(It, bt + wt);
    me.bottom = Math.min(me.bottom, Ot);
  }
  return me.top >= 0 && me.left >= 0 && me.bottom > me.top && me.right > me.left ? me : null;
}
function adjustForViewport(ce, ie, me, we) {
  var Re = utils.clone(ce), je = {
    width: ie.width,
    height: ie.height
  };
  return we.adjustX && Re.left < me.left && (Re.left = me.left), we.resizeWidth && Re.left >= me.left && Re.left + je.width > me.right && (je.width -= Re.left + je.width - me.right), we.adjustX && Re.left + je.width > me.right && (Re.left = Math.max(me.right - je.width, me.left)), we.adjustY && Re.top < me.top && (Re.top = me.top), we.resizeHeight && Re.top >= me.top && Re.top + je.height > me.bottom && (je.height -= Re.top + je.height - me.bottom), we.adjustY && Re.top + je.height > me.bottom && (Re.top = Math.max(me.bottom - je.height, me.top)), utils.mix(Re, je);
}
function getRegion(ce) {
  var ie, me, we;
  if (!utils.isWindow(ce) && ce.nodeType !== 9)
    ie = utils.offset(ce), me = utils.outerWidth(ce), we = utils.outerHeight(ce);
  else {
    var Re = utils.getWindow(ce);
    ie = {
      left: utils.getWindowScrollLeft(Re),
      top: utils.getWindowScrollTop(Re)
    }, me = utils.viewportWidth(Re), we = utils.viewportHeight(Re);
  }
  return ie.width = me, ie.height = we, ie;
}
function getAlignOffset(ce, ie) {
  var me = ie.charAt(0), we = ie.charAt(1), Re = ce.width, je = ce.height, Ue = ce.left, qe = ce.top;
  return me === "c" ? qe += je / 2 : me === "b" && (qe += je), we === "c" ? Ue += Re / 2 : we === "r" && (Ue += Re), {
    left: Ue,
    top: qe
  };
}
function getElFuturePos(ce, ie, me, we, Re) {
  var je = getAlignOffset(ie, me[1]), Ue = getAlignOffset(ce, me[0]), qe = [Ue.left - je.left, Ue.top - je.top];
  return {
    left: Math.round(ce.left - qe[0] + we[0] - Re[0]),
    top: Math.round(ce.top - qe[1] + we[1] - Re[1])
  };
}
function isFailX(ce, ie, me) {
  return ce.left < me.left || ce.left + ie.width > me.right;
}
function isFailY(ce, ie, me) {
  return ce.top < me.top || ce.top + ie.height > me.bottom;
}
function isCompleteFailX(ce, ie, me) {
  return ce.left > me.right || ce.left + ie.width < me.left;
}
function isCompleteFailY(ce, ie, me) {
  return ce.top > me.bottom || ce.top + ie.height < me.top;
}
function flip(ce, ie, me) {
  var we = [];
  return utils.each(ce, function(Re) {
    we.push(Re.replace(ie, function(je) {
      return me[je];
    }));
  }), we;
}
function flipOffset(ce, ie) {
  return ce[ie] = -ce[ie], ce;
}
function convertOffset(ce, ie) {
  var me;
  return /%$/.test(ce) ? me = parseInt(ce.substring(0, ce.length - 1), 10) / 100 * ie : me = parseInt(ce, 10), me || 0;
}
function normalizeOffset(ce, ie) {
  ce[0] = convertOffset(ce[0], ie.width), ce[1] = convertOffset(ce[1], ie.height);
}
function doAlign(ce, ie, me, we) {
  var Re = me.points, je = me.offset || [0, 0], Ue = me.targetOffset || [0, 0], qe = me.overflow, Ge = me.source || ce;
  je = [].concat(je), Ue = [].concat(Ue), qe = qe || {};
  var Xe = {}, ot = 0, vt = !!(qe && qe.alwaysByViewport), bt = getVisibleRectForElement(Ge, vt), Tt = getRegion(Ge);
  normalizeOffset(je, Tt), normalizeOffset(Ue, ie);
  var wt = getElFuturePos(Tt, ie, Re, je, Ue), St = utils.merge(Tt, wt);
  if (bt && (qe.adjustX || qe.adjustY) && we) {
    if (qe.adjustX && isFailX(wt, Tt, bt)) {
      var It = flip(Re, /[lr]/gi, {
        l: "r",
        r: "l"
      }), Pt = flipOffset(je, 0), kt = flipOffset(Ue, 0), Ot = getElFuturePos(Tt, ie, It, Pt, kt);
      isCompleteFailX(Ot, Tt, bt) || (ot = 1, Re = It, je = Pt, Ue = kt);
    }
    if (qe.adjustY && isFailY(wt, Tt, bt)) {
      var Jr = flip(Re, /[tb]/gi, {
        t: "b",
        b: "t"
      }), en = flipOffset(je, 1), nn = flipOffset(Ue, 1), ln = getElFuturePos(Tt, ie, Jr, en, nn);
      isCompleteFailY(ln, Tt, bt) || (ot = 1, Re = Jr, je = en, Ue = nn);
    }
    ot && (wt = getElFuturePos(Tt, ie, Re, je, Ue), utils.mix(St, wt));
    var fn = isFailX(wt, Tt, bt), vn = isFailY(wt, Tt, bt);
    if (fn || vn) {
      var Tn = Re;
      fn && (Tn = flip(Re, /[lr]/gi, {
        l: "r",
        r: "l"
      })), vn && (Tn = flip(Re, /[tb]/gi, {
        t: "b",
        b: "t"
      })), Re = Tn, je = me.offset || [0, 0], Ue = me.targetOffset || [0, 0];
    }
    Xe.adjustX = qe.adjustX && fn, Xe.adjustY = qe.adjustY && vn, (Xe.adjustX || Xe.adjustY) && (St = adjustForViewport(wt, Tt, bt, Xe));
  }
  return St.width !== Tt.width && utils.css(Ge, "width", utils.width(Ge) + St.width - Tt.width), St.height !== Tt.height && utils.css(Ge, "height", utils.height(Ge) + St.height - Tt.height), utils.offset(Ge, {
    left: St.left,
    top: St.top
  }, {
    useCssRight: me.useCssRight,
    useCssBottom: me.useCssBottom,
    useCssTransform: me.useCssTransform,
    ignoreShake: me.ignoreShake
  }), {
    points: Re,
    offset: je,
    targetOffset: Ue,
    overflow: Xe
  };
}
function isOutOfVisibleRect(ce, ie) {
  var me = getVisibleRectForElement(ce, ie), we = getRegion(ce);
  return !me || we.left + we.width <= me.left || we.top + we.height <= me.top || we.left >= me.right || we.top >= me.bottom;
}
function alignElement(ce, ie, me) {
  var we = me.target || ie, Re = getRegion(we), je = !isOutOfVisibleRect(we, me.overflow && me.overflow.alwaysByViewport);
  return doAlign(ce, Re, me, je);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(ce, ie, me) {
  var we, Re, je = utils.getDocument(ce), Ue = je.defaultView || je.parentWindow, qe = utils.getWindowScrollLeft(Ue), Ge = utils.getWindowScrollTop(Ue), Xe = utils.viewportWidth(Ue), ot = utils.viewportHeight(Ue);
  "pageX" in ie ? we = ie.pageX : we = qe + ie.clientX, "pageY" in ie ? Re = ie.pageY : Re = Ge + ie.clientY;
  var vt = {
    left: we,
    top: Re,
    width: 0,
    height: 0
  }, bt = we >= 0 && we <= qe + Xe && Re >= 0 && Re <= Ge + ot, Tt = [me.points[0], "cc"];
  return doAlign(ce, vt, _objectSpread2(_objectSpread2({}, me), {}, {
    points: Tt
  }), bt);
}
const useBuffer = function(ce, ie) {
  var me = React__default.useRef(!1), we = React__default.useRef(null);
  function Re() {
    window.clearTimeout(we.current);
  }
  function je(Ue) {
    if (Re(), !me.current || Ue === !0) {
      if (ce(Ue) === !1)
        return;
      me.current = !0, we.current = window.setTimeout(function() {
        me.current = !1;
      }, ie);
    } else
      we.current = window.setTimeout(function() {
        me.current = !1, je();
      }, ie);
  }
  return [je, function() {
    me.current = !1, Re();
  }];
};
function isSamePoint(ce, ie) {
  return ce === ie ? !0 : !ce || !ie ? !1 : "pageX" in ie && "pageY" in ie ? ce.pageX === ie.pageX && ce.pageY === ie.pageY : "clientX" in ie && "clientY" in ie ? ce.clientX === ie.clientX && ce.clientY === ie.clientY : !1;
}
function restoreFocus(ce, ie) {
  ce !== document.activeElement && contains(ie, ce) && typeof ce.focus == "function" && ce.focus();
}
function monitorResize(ce, ie) {
  var me = null, we = null;
  function Re(Ue) {
    var qe = _slicedToArray$8(Ue, 1), Ge = qe[0].target;
    if (document.documentElement.contains(Ge)) {
      var Xe = Ge.getBoundingClientRect(), ot = Xe.width, vt = Xe.height, bt = Math.floor(ot), Tt = Math.floor(vt);
      (me !== bt || we !== Tt) && Promise.resolve().then(function() {
        ie({
          width: bt,
          height: Tt
        });
      }), me = bt, we = Tt;
    }
  }
  var je = new index(Re);
  return ce && je.observe(ce), function() {
    je.disconnect();
  };
}
function getElement(ce) {
  return typeof ce != "function" ? null : ce();
}
function getPoint(ce) {
  return _typeof$b(ce) !== "object" || !ce ? null : ce;
}
var Align = function ce(ie, me) {
  var we = ie.children, Re = ie.disabled, je = ie.target, Ue = ie.align, qe = ie.onAlign, Ge = ie.monitorWindowResize, Xe = ie.monitorBufferTime, ot = Xe === void 0 ? 0 : Xe, vt = React__default.useRef({}), bt = React__default.useRef(), Tt = React__default.Children.only(we), wt = React__default.useRef({});
  wt.current.disabled = Re, wt.current.target = je, wt.current.align = Ue, wt.current.onAlign = qe;
  var St = useBuffer(function() {
    var xn = wt.current, bn = xn.disabled, Sn = xn.target, Cn = xn.align, kn = xn.onAlign, cn = bt.current;
    if (!bn && Sn && cn) {
      var gn, an = getElement(Sn), un = getPoint(Sn);
      vt.current.element = an, vt.current.point = un, vt.current.align = Cn;
      var pn = document, hn = pn.activeElement;
      return an && isVisible(an) ? gn = alignElement(cn, an, Cn) : un && (gn = alignPoint(cn, un, Cn)), restoreFocus(hn, cn), kn && gn && kn(cn, gn), !0;
    }
    return !1;
  }, ot), It = _slicedToArray$8(St, 2), Pt = It[0], kt = It[1], Ot = React__default.useState(), Jr = _slicedToArray$8(Ot, 2), en = Jr[0], nn = Jr[1], ln = React__default.useState(), fn = _slicedToArray$8(ln, 2), vn = fn[0], Tn = fn[1];
  return useLayoutEffect$1(function() {
    nn(getElement(je)), Tn(getPoint(je));
  }), React__default.useEffect(function() {
    (vt.current.element !== en || !isSamePoint(vt.current.point, vn) || !isEqual$1(vt.current.align, Ue)) && Pt();
  }), React__default.useEffect(function() {
    var xn = monitorResize(bt.current, Pt);
    return xn;
  }, [bt.current]), React__default.useEffect(function() {
    var xn = monitorResize(en, Pt);
    return xn;
  }, [en]), React__default.useEffect(function() {
    Re ? kt() : Pt();
  }, [Re]), React__default.useEffect(function() {
    if (Ge) {
      var xn = addEventListenerWrap(window, "resize", Pt);
      return xn.remove;
    }
  }, [Ge]), React__default.useEffect(function() {
    return function() {
      kt();
    };
  }, []), React__default.useImperativeHandle(me, function() {
    return {
      forceAlign: function() {
        return Pt(!0);
      }
    };
  }), /* @__PURE__ */ React__default.isValidElement(Tt) && (Tt = /* @__PURE__ */ React__default.cloneElement(Tt, {
    ref: composeRef(Tt.ref, bt)
  })), Tt;
}, RcAlign = /* @__PURE__ */ React__default.forwardRef(Align);
RcAlign.displayName = "Align";
function _regeneratorRuntime() {
  _regeneratorRuntime = function() {
    return ie;
  };
  var ce, ie = {}, me = Object.prototype, we = me.hasOwnProperty, Re = Object.defineProperty || function(cn, gn, an) {
    cn[gn] = an.value;
  }, je = typeof Symbol == "function" ? Symbol : {}, Ue = je.iterator || "@@iterator", qe = je.asyncIterator || "@@asyncIterator", Ge = je.toStringTag || "@@toStringTag";
  function Xe(cn, gn, an) {
    return Object.defineProperty(cn, gn, {
      value: an,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), cn[gn];
  }
  try {
    Xe({}, "");
  } catch {
    Xe = function(an, un, pn) {
      return an[un] = pn;
    };
  }
  function ot(cn, gn, an, un) {
    var pn = gn && gn.prototype instanceof Pt ? gn : Pt, hn = Object.create(pn.prototype), An = new Cn(un || []);
    return Re(hn, "_invoke", {
      value: Tn(cn, an, An)
    }), hn;
  }
  function vt(cn, gn, an) {
    try {
      return {
        type: "normal",
        arg: cn.call(gn, an)
      };
    } catch (un) {
      return {
        type: "throw",
        arg: un
      };
    }
  }
  ie.wrap = ot;
  var bt = "suspendedStart", Tt = "suspendedYield", wt = "executing", St = "completed", It = {};
  function Pt() {
  }
  function kt() {
  }
  function Ot() {
  }
  var Jr = {};
  Xe(Jr, Ue, function() {
    return this;
  });
  var en = Object.getPrototypeOf, nn = en && en(en(kn([])));
  nn && nn !== me && we.call(nn, Ue) && (Jr = nn);
  var ln = Ot.prototype = Pt.prototype = Object.create(Jr);
  function fn(cn) {
    ["next", "throw", "return"].forEach(function(gn) {
      Xe(cn, gn, function(an) {
        return this._invoke(gn, an);
      });
    });
  }
  function vn(cn, gn) {
    function an(pn, hn, An, In) {
      var qn = vt(cn[pn], cn, hn);
      if (qn.type !== "throw") {
        var si = qn.arg, bi = si.value;
        return bi && _typeof$b(bi) == "object" && we.call(bi, "__await") ? gn.resolve(bi.__await).then(function(xi) {
          an("next", xi, An, In);
        }, function(xi) {
          an("throw", xi, An, In);
        }) : gn.resolve(bi).then(function(xi) {
          si.value = xi, An(si);
        }, function(xi) {
          return an("throw", xi, An, In);
        });
      }
      In(qn.arg);
    }
    var un;
    Re(this, "_invoke", {
      value: function(hn, An) {
        function In() {
          return new gn(function(qn, si) {
            an(hn, An, qn, si);
          });
        }
        return un = un ? un.then(In, In) : In();
      }
    });
  }
  function Tn(cn, gn, an) {
    var un = bt;
    return function(pn, hn) {
      if (un === wt) throw Error("Generator is already running");
      if (un === St) {
        if (pn === "throw") throw hn;
        return {
          value: ce,
          done: !0
        };
      }
      for (an.method = pn, an.arg = hn; ; ) {
        var An = an.delegate;
        if (An) {
          var In = xn(An, an);
          if (In) {
            if (In === It) continue;
            return In;
          }
        }
        if (an.method === "next") an.sent = an._sent = an.arg;
        else if (an.method === "throw") {
          if (un === bt) throw un = St, an.arg;
          an.dispatchException(an.arg);
        } else an.method === "return" && an.abrupt("return", an.arg);
        un = wt;
        var qn = vt(cn, gn, an);
        if (qn.type === "normal") {
          if (un = an.done ? St : Tt, qn.arg === It) continue;
          return {
            value: qn.arg,
            done: an.done
          };
        }
        qn.type === "throw" && (un = St, an.method = "throw", an.arg = qn.arg);
      }
    };
  }
  function xn(cn, gn) {
    var an = gn.method, un = cn.iterator[an];
    if (un === ce) return gn.delegate = null, an === "throw" && cn.iterator.return && (gn.method = "return", gn.arg = ce, xn(cn, gn), gn.method === "throw") || an !== "return" && (gn.method = "throw", gn.arg = new TypeError("The iterator does not provide a '" + an + "' method")), It;
    var pn = vt(un, cn.iterator, gn.arg);
    if (pn.type === "throw") return gn.method = "throw", gn.arg = pn.arg, gn.delegate = null, It;
    var hn = pn.arg;
    return hn ? hn.done ? (gn[cn.resultName] = hn.value, gn.next = cn.nextLoc, gn.method !== "return" && (gn.method = "next", gn.arg = ce), gn.delegate = null, It) : hn : (gn.method = "throw", gn.arg = new TypeError("iterator result is not an object"), gn.delegate = null, It);
  }
  function bn(cn) {
    var gn = {
      tryLoc: cn[0]
    };
    1 in cn && (gn.catchLoc = cn[1]), 2 in cn && (gn.finallyLoc = cn[2], gn.afterLoc = cn[3]), this.tryEntries.push(gn);
  }
  function Sn(cn) {
    var gn = cn.completion || {};
    gn.type = "normal", delete gn.arg, cn.completion = gn;
  }
  function Cn(cn) {
    this.tryEntries = [{
      tryLoc: "root"
    }], cn.forEach(bn, this), this.reset(!0);
  }
  function kn(cn) {
    if (cn || cn === "") {
      var gn = cn[Ue];
      if (gn) return gn.call(cn);
      if (typeof cn.next == "function") return cn;
      if (!isNaN(cn.length)) {
        var an = -1, un = function pn() {
          for (; ++an < cn.length; ) if (we.call(cn, an)) return pn.value = cn[an], pn.done = !1, pn;
          return pn.value = ce, pn.done = !0, pn;
        };
        return un.next = un;
      }
    }
    throw new TypeError(_typeof$b(cn) + " is not iterable");
  }
  return kt.prototype = Ot, Re(ln, "constructor", {
    value: Ot,
    configurable: !0
  }), Re(Ot, "constructor", {
    value: kt,
    configurable: !0
  }), kt.displayName = Xe(Ot, Ge, "GeneratorFunction"), ie.isGeneratorFunction = function(cn) {
    var gn = typeof cn == "function" && cn.constructor;
    return !!gn && (gn === kt || (gn.displayName || gn.name) === "GeneratorFunction");
  }, ie.mark = function(cn) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(cn, Ot) : (cn.__proto__ = Ot, Xe(cn, Ge, "GeneratorFunction")), cn.prototype = Object.create(ln), cn;
  }, ie.awrap = function(cn) {
    return {
      __await: cn
    };
  }, fn(vn.prototype), Xe(vn.prototype, qe, function() {
    return this;
  }), ie.AsyncIterator = vn, ie.async = function(cn, gn, an, un, pn) {
    pn === void 0 && (pn = Promise);
    var hn = new vn(ot(cn, gn, an, un), pn);
    return ie.isGeneratorFunction(gn) ? hn : hn.next().then(function(An) {
      return An.done ? An.value : hn.next();
    });
  }, fn(ln), Xe(ln, Ge, "Generator"), Xe(ln, Ue, function() {
    return this;
  }), Xe(ln, "toString", function() {
    return "[object Generator]";
  }), ie.keys = function(cn) {
    var gn = Object(cn), an = [];
    for (var un in gn) an.push(un);
    return an.reverse(), function pn() {
      for (; an.length; ) {
        var hn = an.pop();
        if (hn in gn) return pn.value = hn, pn.done = !1, pn;
      }
      return pn.done = !0, pn;
    };
  }, ie.values = kn, Cn.prototype = {
    constructor: Cn,
    reset: function(gn) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = ce, this.done = !1, this.delegate = null, this.method = "next", this.arg = ce, this.tryEntries.forEach(Sn), !gn) for (var an in this) an.charAt(0) === "t" && we.call(this, an) && !isNaN(+an.slice(1)) && (this[an] = ce);
    },
    stop: function() {
      this.done = !0;
      var gn = this.tryEntries[0].completion;
      if (gn.type === "throw") throw gn.arg;
      return this.rval;
    },
    dispatchException: function(gn) {
      if (this.done) throw gn;
      var an = this;
      function un(si, bi) {
        return An.type = "throw", An.arg = gn, an.next = si, bi && (an.method = "next", an.arg = ce), !!bi;
      }
      for (var pn = this.tryEntries.length - 1; pn >= 0; --pn) {
        var hn = this.tryEntries[pn], An = hn.completion;
        if (hn.tryLoc === "root") return un("end");
        if (hn.tryLoc <= this.prev) {
          var In = we.call(hn, "catchLoc"), qn = we.call(hn, "finallyLoc");
          if (In && qn) {
            if (this.prev < hn.catchLoc) return un(hn.catchLoc, !0);
            if (this.prev < hn.finallyLoc) return un(hn.finallyLoc);
          } else if (In) {
            if (this.prev < hn.catchLoc) return un(hn.catchLoc, !0);
          } else {
            if (!qn) throw Error("try statement without catch or finally");
            if (this.prev < hn.finallyLoc) return un(hn.finallyLoc);
          }
        }
      }
    },
    abrupt: function(gn, an) {
      for (var un = this.tryEntries.length - 1; un >= 0; --un) {
        var pn = this.tryEntries[un];
        if (pn.tryLoc <= this.prev && we.call(pn, "finallyLoc") && this.prev < pn.finallyLoc) {
          var hn = pn;
          break;
        }
      }
      hn && (gn === "break" || gn === "continue") && hn.tryLoc <= an && an <= hn.finallyLoc && (hn = null);
      var An = hn ? hn.completion : {};
      return An.type = gn, An.arg = an, hn ? (this.method = "next", this.next = hn.finallyLoc, It) : this.complete(An);
    },
    complete: function(gn, an) {
      if (gn.type === "throw") throw gn.arg;
      return gn.type === "break" || gn.type === "continue" ? this.next = gn.arg : gn.type === "return" ? (this.rval = this.arg = gn.arg, this.method = "return", this.next = "end") : gn.type === "normal" && an && (this.next = an), It;
    },
    finish: function(gn) {
      for (var an = this.tryEntries.length - 1; an >= 0; --an) {
        var un = this.tryEntries[an];
        if (un.finallyLoc === gn) return this.complete(un.completion, un.afterLoc), Sn(un), It;
      }
    },
    catch: function(gn) {
      for (var an = this.tryEntries.length - 1; an >= 0; --an) {
        var un = this.tryEntries[an];
        if (un.tryLoc === gn) {
          var pn = un.completion;
          if (pn.type === "throw") {
            var hn = pn.arg;
            Sn(un);
          }
          return hn;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(gn, an, un) {
      return this.delegate = {
        iterator: kn(gn),
        resultName: an,
        nextLoc: un
      }, this.method === "next" && (this.arg = ce), It;
    }
  }, ie;
}
function asyncGeneratorStep(ce, ie, me, we, Re, je, Ue) {
  try {
    var qe = ce[je](Ue), Ge = qe.value;
  } catch (Xe) {
    return void me(Xe);
  }
  qe.done ? ie(Ge) : Promise.resolve(Ge).then(we, Re);
}
function _asyncToGenerator(ce) {
  return function() {
    var ie = this, me = arguments;
    return new Promise(function(we, Re) {
      var je = ce.apply(ie, me);
      function Ue(Ge) {
        asyncGeneratorStep(je, we, Re, Ue, qe, "next", Ge);
      }
      function qe(Ge) {
        asyncGeneratorStep(je, we, Re, Ue, qe, "throw", Ge);
      }
      Ue(void 0);
    });
  };
}
var StatusQueue = ["measure", "alignPre", "align", null, "motion"];
const useVisibleStatus = function(ce, ie) {
  var me = useSafeState(null), we = _slicedToArray$8(me, 2), Re = we[0], je = we[1], Ue = useRef();
  function qe(ot) {
    je(ot, !0);
  }
  function Ge() {
    wrapperRaf$1.cancel(Ue.current);
  }
  function Xe(ot) {
    Ge(), Ue.current = wrapperRaf$1(function() {
      qe(function(vt) {
        switch (Re) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return vt;
      }), ot == null || ot();
    });
  }
  return useEffect(function() {
    qe("measure");
  }, [ce]), useEffect(function() {
    switch (Re) {
      case "measure":
        ie();
        break;
    }
    Re && (Ue.current = wrapperRaf$1(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function ot() {
      var vt, bt;
      return _regeneratorRuntime().wrap(function(wt) {
        for (; ; )
          switch (wt.prev = wt.next) {
            case 0:
              vt = StatusQueue.indexOf(Re), bt = StatusQueue[vt + 1], bt && vt !== -1 && qe(bt);
            case 3:
            case "end":
              return wt.stop();
          }
      }, ot);
    }))));
  }, [Re]), useEffect(function() {
    return function() {
      Ge();
    };
  }, []), [Re, Xe];
}, useStretchStyle = function(ce) {
  var ie = React.useState({
    width: 0,
    height: 0
  }), me = _slicedToArray$8(ie, 2), we = me[0], Re = me[1];
  function je(qe) {
    var Ge = qe.offsetWidth, Xe = qe.offsetHeight, ot = qe.getBoundingClientRect(), vt = ot.width, bt = ot.height;
    Math.abs(Ge - vt) < 1 && Math.abs(Xe - bt) < 1 && (Ge = vt, Xe = bt), Re({
      width: Ge,
      height: Xe
    });
  }
  var Ue = React.useMemo(function() {
    var qe = {};
    if (ce) {
      var Ge = we.width, Xe = we.height;
      ce.indexOf("height") !== -1 && Xe ? qe.height = Xe : ce.indexOf("minHeight") !== -1 && Xe && (qe.minHeight = Xe), ce.indexOf("width") !== -1 && Ge ? qe.width = Ge : ce.indexOf("minWidth") !== -1 && Ge && (qe.minWidth = Ge);
    }
    return qe;
  }, [ce, we]);
  return [Ue, je];
};
var PopupInner = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.visible, we = ce.prefixCls, Re = ce.className, je = ce.style, Ue = ce.children, qe = ce.zIndex, Ge = ce.stretch, Xe = ce.destroyPopupOnHide, ot = ce.forceRender, vt = ce.align, bt = ce.point, Tt = ce.getRootDomNode, wt = ce.getClassNameFromAlign, St = ce.onAlign, It = ce.onMouseEnter, Pt = ce.onMouseLeave, kt = ce.onMouseDown, Ot = ce.onTouchStart, Jr = ce.onClick, en = useRef(), nn = useRef(), ln = useState(), fn = _slicedToArray$8(ln, 2), vn = fn[0], Tn = fn[1], xn = useStretchStyle(Ge), bn = _slicedToArray$8(xn, 2), Sn = bn[0], Cn = bn[1];
  function kn() {
    Ge && Cn(Tt());
  }
  var cn = useVisibleStatus(me, kn), gn = _slicedToArray$8(cn, 2), an = gn[0], un = gn[1], pn = useState(0), hn = _slicedToArray$8(pn, 2), An = hn[0], In = hn[1], qn = useRef();
  useLayoutEffect$1(function() {
    an === "alignPre" && In(0);
  }, [an]);
  function si() {
    return bt || Tt;
  }
  function bi() {
    var Fi;
    (Fi = en.current) === null || Fi === void 0 || Fi.forceAlign();
  }
  function xi(Fi, ni) {
    var Ui = wt(ni);
    vn !== Ui && Tn(Ui), In(function(ja) {
      return ja + 1;
    }), an === "align" && (St == null || St(Fi, ni));
  }
  useLayoutEffect$1(function() {
    an === "align" && (An < 3 ? bi() : un(function() {
      var Fi;
      (Fi = qn.current) === null || Fi === void 0 || Fi.call(qn);
    }));
  }, [An]);
  var ji = _objectSpread2$2({}, getMotion(ce));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(Fi) {
    var ni = ji[Fi];
    ji[Fi] = function(Ui, ja) {
      return un(), ni == null ? void 0 : ni(Ui, ja);
    };
  });
  function zi() {
    return new Promise(function(Fi) {
      qn.current = Fi;
    });
  }
  React.useEffect(function() {
    !ji.motionName && an === "motion" && un();
  }, [ji.motionName, an]), React.useImperativeHandle(ie, function() {
    return {
      forceAlign: bi,
      getElement: function() {
        return nn.current;
      }
    };
  });
  var Vi = _objectSpread2$2(_objectSpread2$2({}, Sn), {}, {
    zIndex: qe,
    opacity: an === "motion" || an === "stable" || !me ? void 0 : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !me && an !== "stable" ? "none" : void 0
  }, je), Hi = !0;
  vt != null && vt.points && (an === "align" || an === "stable") && (Hi = !1);
  var ii = Ue;
  return React.Children.count(Ue) > 1 && (ii = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(we, "-content")
  }, Ue)), /* @__PURE__ */ React.createElement(CSSMotion, _extends$j({
    visible: me,
    ref: nn,
    leavedClassName: "".concat(we, "-hidden")
  }, ji, {
    onAppearPrepare: zi,
    onEnterPrepare: zi,
    removeOnLeave: Xe,
    forceRender: ot
  }), function(Fi, ni) {
    var Ui = Fi.className, ja = Fi.style, Ga = classNames(we, Re, vn, Ui);
    return /* @__PURE__ */ React.createElement(RcAlign, {
      target: si(),
      key: "popup",
      ref: en,
      monitorWindowResize: !0,
      disabled: Hi,
      align: vt,
      onAlign: xi
    }, /* @__PURE__ */ React.createElement("div", {
      ref: ni,
      className: Ga,
      onMouseEnter: It,
      onMouseLeave: Pt,
      onMouseDownCapture: kt,
      onTouchStartCapture: Ot,
      onClick: Jr,
      style: _objectSpread2$2(_objectSpread2$2({}, ja), Vi)
    }, ii));
  });
});
PopupInner.displayName = "PopupInner";
var MobilePopupInner = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.prefixCls, we = ce.visible, Re = ce.zIndex, je = ce.children, Ue = ce.mobile;
  Ue = Ue === void 0 ? {} : Ue;
  var qe = Ue.popupClassName, Ge = Ue.popupStyle, Xe = Ue.popupMotion, ot = Xe === void 0 ? {} : Xe, vt = Ue.popupRender, bt = ce.onClick, Tt = React.useRef();
  React.useImperativeHandle(ie, function() {
    return {
      forceAlign: function() {
      },
      getElement: function() {
        return Tt.current;
      }
    };
  });
  var wt = _objectSpread2$2({
    zIndex: Re
  }, Ge), St = je;
  return React.Children.count(je) > 1 && (St = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(me, "-content")
  }, je)), vt && (St = vt(St)), /* @__PURE__ */ React.createElement(CSSMotion, _extends$j({
    visible: we,
    ref: Tt,
    removeOnLeave: !0
  }, ot), function(It, Pt) {
    var kt = It.className, Ot = It.style, Jr = classNames(me, qe, kt);
    return /* @__PURE__ */ React.createElement("div", {
      ref: Pt,
      className: Jr,
      onClick: bt,
      style: _objectSpread2$2(_objectSpread2$2({}, Ot), wt)
    }, St);
  });
});
MobilePopupInner.displayName = "MobilePopupInner";
var _excluded = ["visible", "mobile"], Popup = /* @__PURE__ */ React.forwardRef(function(ce, ie) {
  var me = ce.visible, we = ce.mobile, Re = _objectWithoutProperties$6(ce, _excluded), je = useState(me), Ue = _slicedToArray$8(je, 2), qe = Ue[0], Ge = Ue[1], Xe = useState(!1), ot = _slicedToArray$8(Xe, 2), vt = ot[0], bt = ot[1], Tt = _objectSpread2$2(_objectSpread2$2({}, Re), {}, {
    visible: qe
  });
  useEffect(function() {
    Ge(me), me && we && bt(isMobile());
  }, [me, we]);
  var wt = vt ? /* @__PURE__ */ React.createElement(MobilePopupInner, _extends$j({}, Tt, {
    mobile: we,
    ref: ie
  })) : /* @__PURE__ */ React.createElement(PopupInner, _extends$j({}, Tt, {
    ref: ie
  }));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Mask, Tt), wt);
});
Popup.displayName = "Popup";
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function noop() {
}
function returnEmptyString() {
  return "";
}
function returnDocument(ce) {
  return ce ? ce.ownerDocument : window.document;
}
var ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function generateTrigger(ce) {
  var ie = /* @__PURE__ */ function(me) {
    _inherits$f(Re, me);
    var we = _createSuper$4(Re);
    function Re(je) {
      var Ue;
      _classCallCheck$t(this, Re), Ue = we.call(this, je), _defineProperty$s(_assertThisInitialized$4(Ue), "popupRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$4(Ue), "triggerRef", /* @__PURE__ */ React.createRef()), _defineProperty$s(_assertThisInitialized$4(Ue), "portalContainer", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "attachId", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "clickOutsideHandler", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "touchOutsideHandler", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "contextMenuOutsideHandler1", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "contextMenuOutsideHandler2", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "mouseDownTimeout", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "focusTime", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "preClickTime", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "preTouchTime", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "delayTimer", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "hasPopupMouseDown", void 0), _defineProperty$s(_assertThisInitialized$4(Ue), "onMouseEnter", function(Ge) {
        var Xe = Ue.props.mouseEnterDelay;
        Ue.fireEvents("onMouseEnter", Ge), Ue.delaySetPopupVisible(!0, Xe, Xe ? null : Ge);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onMouseMove", function(Ge) {
        Ue.fireEvents("onMouseMove", Ge), Ue.setPoint(Ge);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onMouseLeave", function(Ge) {
        Ue.fireEvents("onMouseLeave", Ge), Ue.delaySetPopupVisible(!1, Ue.props.mouseLeaveDelay);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onPopupMouseEnter", function() {
        Ue.clearDelayTimer();
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onPopupMouseLeave", function(Ge) {
        var Xe;
        Ge.relatedTarget && !Ge.relatedTarget.setTimeout && contains((Xe = Ue.popupRef.current) === null || Xe === void 0 ? void 0 : Xe.getElement(), Ge.relatedTarget) || Ue.delaySetPopupVisible(!1, Ue.props.mouseLeaveDelay);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onFocus", function(Ge) {
        Ue.fireEvents("onFocus", Ge), Ue.clearDelayTimer(), Ue.isFocusToShow() && (Ue.focusTime = Date.now(), Ue.delaySetPopupVisible(!0, Ue.props.focusDelay));
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onMouseDown", function(Ge) {
        Ue.fireEvents("onMouseDown", Ge), Ue.preClickTime = Date.now();
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onTouchStart", function(Ge) {
        Ue.fireEvents("onTouchStart", Ge), Ue.preTouchTime = Date.now();
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onBlur", function(Ge) {
        Ue.fireEvents("onBlur", Ge), Ue.clearDelayTimer(), Ue.isBlurToHide() && Ue.delaySetPopupVisible(!1, Ue.props.blurDelay);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onContextMenu", function(Ge) {
        Ge.preventDefault(), Ue.fireEvents("onContextMenu", Ge), Ue.setPopupVisible(!0, Ge);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onContextMenuClose", function() {
        Ue.isContextMenuToShow() && Ue.close();
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onClick", function(Ge) {
        if (Ue.fireEvents("onClick", Ge), Ue.focusTime) {
          var Xe;
          if (Ue.preClickTime && Ue.preTouchTime ? Xe = Math.min(Ue.preClickTime, Ue.preTouchTime) : Ue.preClickTime ? Xe = Ue.preClickTime : Ue.preTouchTime && (Xe = Ue.preTouchTime), Math.abs(Xe - Ue.focusTime) < 20)
            return;
          Ue.focusTime = 0;
        }
        Ue.preClickTime = 0, Ue.preTouchTime = 0, Ue.isClickToShow() && (Ue.isClickToHide() || Ue.isBlurToHide()) && Ge && Ge.preventDefault && Ge.preventDefault();
        var ot = !Ue.state.popupVisible;
        (Ue.isClickToHide() && !ot || ot && Ue.isClickToShow()) && Ue.setPopupVisible(!Ue.state.popupVisible, Ge);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onPopupMouseDown", function() {
        if (Ue.hasPopupMouseDown = !0, clearTimeout(Ue.mouseDownTimeout), Ue.mouseDownTimeout = window.setTimeout(function() {
          Ue.hasPopupMouseDown = !1;
        }, 0), Ue.context) {
          var Ge;
          (Ge = Ue.context).onPopupMouseDown.apply(Ge, arguments);
        }
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "onDocumentClick", function(Ge) {
        if (!(Ue.props.mask && !Ue.props.maskClosable)) {
          var Xe = Ge.target, ot = Ue.getRootDomNode(), vt = Ue.getPopupDomNode();
          // mousedown on the target should also close popup when action is contextMenu.
          // https://github.com/ant-design/ant-design/issues/29853
          (!contains(ot, Xe) || Ue.isContextMenuOnly()) && !contains(vt, Xe) && !Ue.hasPopupMouseDown && Ue.close();
        }
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "getRootDomNode", function() {
        var Ge = Ue.props.getTriggerDOMNode;
        if (Ge)
          return Ge(Ue.triggerRef.current);
        try {
          var Xe = findDOMNode(Ue.triggerRef.current);
          if (Xe)
            return Xe;
        } catch {
        }
        return ReactDOM__default.findDOMNode(_assertThisInitialized$4(Ue));
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "getPopupClassNameFromAlign", function(Ge) {
        var Xe = [], ot = Ue.props, vt = ot.popupPlacement, bt = ot.builtinPlacements, Tt = ot.prefixCls, wt = ot.alignPoint, St = ot.getPopupClassNameFromAlign;
        return vt && bt && Xe.push(getAlignPopupClassName(bt, Tt, Ge, wt)), St && Xe.push(St(Ge)), Xe.join(" ");
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "getComponent", function() {
        var Ge = Ue.props, Xe = Ge.prefixCls, ot = Ge.destroyPopupOnHide, vt = Ge.popupClassName, bt = Ge.onPopupAlign, Tt = Ge.popupMotion, wt = Ge.popupAnimation, St = Ge.popupTransitionName, It = Ge.popupStyle, Pt = Ge.mask, kt = Ge.maskAnimation, Ot = Ge.maskTransitionName, Jr = Ge.maskMotion, en = Ge.zIndex, nn = Ge.popup, ln = Ge.stretch, fn = Ge.alignPoint, vn = Ge.mobile, Tn = Ge.forceRender, xn = Ge.onPopupClick, bn = Ue.state, Sn = bn.popupVisible, Cn = bn.point, kn = Ue.getPopupAlign(), cn = {};
        return Ue.isMouseEnterToShow() && (cn.onMouseEnter = Ue.onPopupMouseEnter), Ue.isMouseLeaveToHide() && (cn.onMouseLeave = Ue.onPopupMouseLeave), cn.onMouseDown = Ue.onPopupMouseDown, cn.onTouchStart = Ue.onPopupMouseDown, /* @__PURE__ */ React.createElement(Popup, _extends$j({
          prefixCls: Xe,
          destroyPopupOnHide: ot,
          visible: Sn,
          point: fn && Cn,
          className: vt,
          align: kn,
          onAlign: bt,
          animation: wt,
          getClassNameFromAlign: Ue.getPopupClassNameFromAlign
        }, cn, {
          stretch: ln,
          getRootDomNode: Ue.getRootDomNode,
          style: It,
          mask: Pt,
          zIndex: en,
          transitionName: St,
          maskAnimation: kt,
          maskTransitionName: Ot,
          maskMotion: Jr,
          ref: Ue.popupRef,
          motion: Tt,
          mobile: vn,
          forceRender: Tn,
          onClick: xn
        }), typeof nn == "function" ? nn() : nn);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "attachParent", function(Ge) {
        wrapperRaf$1.cancel(Ue.attachId);
        var Xe = Ue.props, ot = Xe.getPopupContainer, vt = Xe.getDocument, bt = Ue.getRootDomNode(), Tt;
        ot ? (bt || ot.length === 0) && (Tt = ot(bt)) : Tt = vt(Ue.getRootDomNode()).body, Tt ? Tt.appendChild(Ge) : Ue.attachId = wrapperRaf$1(function() {
          Ue.attachParent(Ge);
        });
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "getContainer", function() {
        if (!Ue.portalContainer) {
          var Ge = Ue.props.getDocument, Xe = Ge(Ue.getRootDomNode()).createElement("div");
          Xe.style.position = "absolute", Xe.style.top = "0", Xe.style.left = "0", Xe.style.width = "100%", Ue.portalContainer = Xe;
        }
        return Ue.attachParent(Ue.portalContainer), Ue.portalContainer;
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "setPoint", function(Ge) {
        var Xe = Ue.props.alignPoint;
        !Xe || !Ge || Ue.setState({
          point: {
            pageX: Ge.pageX,
            pageY: Ge.pageY
          }
        });
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "handlePortalUpdate", function() {
        Ue.state.prevPopupVisible !== Ue.state.popupVisible && Ue.props.afterPopupVisibleChange(Ue.state.popupVisible);
      }), _defineProperty$s(_assertThisInitialized$4(Ue), "triggerContextValue", {
        onPopupMouseDown: Ue.onPopupMouseDown
      });
      var qe;
      return "popupVisible" in je ? qe = !!je.popupVisible : qe = !!je.defaultPopupVisible, Ue.state = {
        prevPopupVisible: qe,
        popupVisible: qe
      }, ALL_HANDLERS.forEach(function(Ge) {
        Ue["fire".concat(Ge)] = function(Xe) {
          Ue.fireEvents(Ge, Xe);
        };
      }), Ue;
    }
    return _createClass$r(Re, [{
      key: "componentDidMount",
      value: function() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var Ue = this.props, qe = this.state;
        if (qe.popupVisible) {
          var Ge;
          !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (Ge = Ue.getDocument(this.getRootDomNode()), this.clickOutsideHandler = addEventListenerWrap(Ge, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (Ge = Ge || Ue.getDocument(this.getRootDomNode()), this.touchOutsideHandler = addEventListenerWrap(Ge, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (Ge = Ge || Ue.getDocument(this.getRootDomNode()), this.contextMenuOutsideHandler1 = addEventListenerWrap(Ge, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextMenuClose));
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), wrapperRaf$1.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function() {
        var Ue;
        return ((Ue = this.popupRef.current) === null || Ue === void 0 ? void 0 : Ue.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function() {
        var Ue = this.props, qe = Ue.popupPlacement, Ge = Ue.popupAlign, Xe = Ue.builtinPlacements;
        return qe && Xe ? getAlignFromPlacement(Xe, qe, Ge) : Ge;
      }
    }, {
      key: "setPopupVisible",
      value: (
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */
        function(Ue, qe) {
          var Ge = this.props.alignPoint, Xe = this.state.popupVisible;
          this.clearDelayTimer(), Xe !== Ue && ("popupVisible" in this.props || this.setState({
            popupVisible: Ue,
            prevPopupVisible: Xe
          }), this.props.onPopupVisibleChange(Ue)), Ge && qe && Ue && this.setPoint(qe);
        }
      )
    }, {
      key: "delaySetPopupVisible",
      value: function(Ue, qe, Ge) {
        var Xe = this, ot = qe * 1e3;
        if (this.clearDelayTimer(), ot) {
          var vt = Ge ? {
            pageX: Ge.pageX,
            pageY: Ge.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            Xe.setPopupVisible(Ue, vt), Xe.clearDelayTimer();
          }, ot);
        } else
          this.setPopupVisible(Ue, Ge);
      }
    }, {
      key: "clearDelayTimer",
      value: function() {
        this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
      }
    }, {
      key: "clearOutsideHandler",
      value: function() {
        this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
      }
    }, {
      key: "createTwoChains",
      value: function(Ue) {
        var qe = this.props.children.props, Ge = this.props;
        return qe[Ue] && Ge[Ue] ? this["fire".concat(Ue)] : qe[Ue] || Ge[Ue];
      }
    }, {
      key: "isClickToShow",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.showAction;
        return qe.indexOf("click") !== -1 || Ge.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function() {
        var Ue = this.props.action;
        return Ue === "contextMenu" || Ue.length === 1 && Ue[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.showAction;
        return qe.indexOf("contextMenu") !== -1 || Ge.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.hideAction;
        return qe.indexOf("click") !== -1 || Ge.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.showAction;
        return qe.indexOf("hover") !== -1 || Ge.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.hideAction;
        return qe.indexOf("hover") !== -1 || Ge.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.showAction;
        return qe.indexOf("focus") !== -1 || Ge.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function() {
        var Ue = this.props, qe = Ue.action, Ge = Ue.hideAction;
        return qe.indexOf("focus") !== -1 || Ge.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function() {
        if (this.state.popupVisible) {
          var Ue;
          (Ue = this.popupRef.current) === null || Ue === void 0 || Ue.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function(Ue, qe) {
        var Ge = this.props.children.props[Ue];
        Ge && Ge(qe);
        var Xe = this.props[Ue];
        Xe && Xe(qe);
      }
    }, {
      key: "close",
      value: function() {
        this.setPopupVisible(!1);
      }
    }, {
      key: "render",
      value: function() {
        var Ue = this.state.popupVisible, qe = this.props, Ge = qe.children, Xe = qe.forceRender, ot = qe.alignPoint, vt = qe.className, bt = qe.autoDestroy, Tt = React.Children.only(Ge), wt = {
          key: "trigger"
        };
        this.isContextMenuToShow() ? wt.onContextMenu = this.onContextMenu : wt.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (wt.onClick = this.onClick, wt.onMouseDown = this.onMouseDown, wt.onTouchStart = this.onTouchStart) : (wt.onClick = this.createTwoChains("onClick"), wt.onMouseDown = this.createTwoChains("onMouseDown"), wt.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (wt.onMouseEnter = this.onMouseEnter, ot && (wt.onMouseMove = this.onMouseMove)) : wt.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? wt.onMouseLeave = this.onMouseLeave : wt.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (wt.onFocus = this.onFocus, wt.onBlur = this.onBlur) : (wt.onFocus = this.createTwoChains("onFocus"), wt.onBlur = this.createTwoChains("onBlur"));
        var St = classNames(Tt && Tt.props && Tt.props.className, vt);
        St && (wt.className = St);
        var It = _objectSpread2$2({}, wt);
        supportRef(Tt) && (It.ref = composeRef(this.triggerRef, Tt.ref));
        var Pt = /* @__PURE__ */ React.cloneElement(Tt, It), kt;
        return (Ue || this.popupRef.current || Xe) && (kt = /* @__PURE__ */ React.createElement(ce, {
          key: "portal",
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent())), !Ue && bt && (kt = null), /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
          value: this.triggerContextValue
        }, Pt, kt);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(Ue, qe) {
        var Ge = Ue.popupVisible, Xe = {};
        return Ge !== void 0 && qe.popupVisible !== Ge && (Xe.popupVisible = Ge, Xe.prevPopupVisible = qe.popupVisible), Xe;
      }
    }]), Re;
  }(React.Component);
  return _defineProperty$s(ie, "contextType", TriggerContext), _defineProperty$s(ie, "defaultProps", {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: !1
  }), ie;
}
const Trigger = generateTrigger(Portal), LabeledGraphicMarkerIcon = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute bg-grey-800 rounded-full w-8 h-8 flex justify-center items-center shadow-xs border-1 border-white border-opacity-50", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      src: jt.icons.urls[ce.markerIcon ? ce.markerIcon : "plus"],
      alt: "icon",
      className: "h-5 w-5 text-white z-1 pointer-events-none"
    }
  ) }),
  !ce.visited && /* @__PURE__ */ jsxRuntimeExports.jsx(
    FontAwesomeIcon,
    {
      icon: faCircle,
      fixedWidth: !0,
      size: "3x",
      className: "absolute pointer-events-none text-grey-800",
      beat: !0,
      style: {
        "--fa-animation-duration": "2s"
      }
    }
  )
] }), LabeledGraphicPopup = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    ref: ce.wrapperRef,
    className: classNames("bg-surface p-6 border-solid border-stroke border-1 overflow-auto", {
      "max-w-100 max-h-140 border-rd-2 ": !ce.isMobile,
      "w-full h-100dvh": ce.isMobile
    }),
    children: [
      ce.isMobile && /* @__PURE__ */ jsxRuntimeExports.jsx(
        FontAwesomeIcon,
        {
          icon: faTimes$1,
          className: "absolute top-14px right-24px text-text p-4px cursor-pointer",
          onClick: ce.onClose
        }
      ),
      ce.title && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-text font-700 text-5 mb-4", children: ce.title }),
      ce.media,
      ce.description
    ]
  }
), LabeledGraphicMarker = (ce) => {
  const [ie, me] = useState(ce.visited ?? !1), [we, Re] = useState(!1), je = useRef(null), { isOpen: Ue, setIsOpen: qe } = useClickOut(!1, je), Ge = useRef(null), Xe = useRef(null), ot = (Tt) => {
    ce.onDragStart !== void 0 && (Re(!1), Ge.current = { x: Tt.clientX, y: Tt.clientY });
  }, vt = (Tt) => {
    if (ce.onDragStart !== void 0 && Ge.current) {
      const wt = Tt.clientX - Ge.current.x, St = Tt.clientY - Ge.current.y;
      Math.sqrt(wt * wt + St * St) > 1 && (Re(!0), ce.onDragStart());
    }
  }, bt = () => {
    ce.onDragStart !== void 0 && (Ge.current = null, setTimeout(() => Re(!1), 0));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: Xe,
      className: "absolute z-1",
      style: {
        top: `${ce.y}%`,
        left: `${ce.x}%`
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Trigger,
        {
          prefixCls: classNames("labeled-graphic-popup", { "labeled-graphic-popup--mobile": ce.isMobile }),
          popupVisible: !we && Ue,
          popupMotion: ce.isMobile ? void 0 : {
            motionName: "labeled-graphic-popup-fade",
            motionAppear: !0,
            motionLeave: !0,
            motionEnter: !0,
            motionDeadline: 300
          },
          destroyPopupOnHide: !0,
          popupPlacement: "topLeft",
          alignPoint: !0,
          popupAlign: {
            overflow: {
              adjustX: !0,
              adjustY: !0
            },
            offset: [20, -16]
          },
          builtinPlacements: {
            topLeft: {
              points: ["tl", "tl"]
            }
          },
          getPopupContainer: () => {
            var Tt;
            return (Tt = ce.containerRef) != null && Tt.current ? ce.containerRef.current : document.body;
          },
          popup: ce.isMobile ? ReactDOM__default.createPortal(
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fixed inset-0", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              LabeledGraphicPopup,
              {
                wrapperRef: je,
                title: ce.title,
                description: ce.description,
                media: ce.media,
                isMobile: ce.isMobile,
                onClose: () => qe(!1)
              }
            ) }),
            document.body
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            LabeledGraphicPopup,
            {
              wrapperRef: je,
              title: ce.title,
              description: ce.description,
              media: ce.media,
              isMobile: ce.isMobile,
              onClose: () => qe(!1)
            }
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "cursor-pointer flex justify-center items-center scale-70 md:scale-100",
              onClick: we ? void 0 : () => {
                var Tt;
                qe(!Ue), me(!0), (Tt = ce.onClick) == null || Tt.call(ce);
              },
              onMouseDown: ot,
              onMouseMove: vt,
              onMouseUp: bt,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledGraphicMarkerIcon, { markerIcon: ce.markerIcon, visited: ie })
            }
          )
        }
      )
    }
  );
}, LabeledGraphic = ({
  imageUrl: ce,
  imageHeight: ie,
  imageWidth: me,
  markers: we,
  isMobile: Re,
  onClick: je,
  onMarkerUpdate: Ue
}) => {
  const [qe, Ge] = React__default.useState(!1), Xe = React__default.useRef(null), ot = React__default.useRef(null), [vt, bt] = React__default.useState(null), Tt = (It) => {
    bt(It.id);
  }, wt = (It) => {
    if (vt && Ue && Xe.current) {
      const Pt = Xe.current.getBoundingClientRect(), kt = (It.clientX - Pt.left) / Pt.width * 100, Ot = (It.clientY - Pt.top) / Pt.height * 100;
      Ue(vt, Math.max(0, Math.min(100, kt)), Math.max(0, Math.min(100, Ot)));
    }
  }, St = () => {
    bt(null);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !qe && /* @__PURE__ */ jsxRuntimeExports.jsx(ImageLoader, { height: ie, width: me, style: {} }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "figure",
      {
        className: "relative w-fit display-inherit",
        onMouseMove: wt,
        onMouseUp: St,
        ref: ot,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              ref: Xe,
              src: ce,
              onLoad: () => Ge(!0),
              className: classNames("select-none", { hidden: !qe, "cursor-crosshair": !!je }),
              onClick: (It) => {
                if (je) {
                  const Pt = It.target.getBoundingClientRect(), kt = (It.clientX - Pt.left) / Pt.width * 100, Ot = (It.clientY - Pt.top) / Pt.height * 100;
                  je(kt, Ot);
                }
              },
              draggable: !1
            }
          ),
          qe && /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { className: "important:list-none", children: we.map((It) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            LabeledGraphicMarker,
            {
              ...It,
              onDragStart: Ue ? () => Tt(It) : void 0,
              isMobile: Re,
              containerRef: ot
            }
          ) }, It.id)) })
        ]
      }
    )
  ] });
}, TextOnImageWidget = (ce) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: "p-7 bg-center bg-no-repeat bg-cover relative",
    style: {
      backgroundImage: `url("${ce.imageUrl}")`
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "absolute bottom-0 right-0 w-full h-full",
          style: {
            backgroundColor: ce.overlayColor,
            opacity: ce.overlayOpacity / 100
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-5 mr-5 text-white position-inherit", children: ce.text })
    ]
  }
), TextEditorSettings = ({
  defaultExpanded: ce,
  title: ie,
  fontSize: me = 16,
  lineHeight: we = 120,
  spaceBeforAndAfter: Re = 10,
  color: je,
  isBold: Ue = !1,
  isItalic: qe = !1,
  isUnderline: Ge = !1,
  onFontSizeChange: Xe,
  onLineHeightChange: ot,
  onColorChange: vt,
  onBoldChange: bt,
  onItalicChange: Tt,
  onUnderlineChange: wt,
  onspaceBeforAndAfterChange: St
}) => {
  const [It, Pt] = useState(je), [kt, Ot] = useState(Ue), [Jr, en] = useState(qe), [nn, ln] = useState(Ge), fn = (bn) => {
    Pt(bn), vt == null || vt(bn);
  }, vn = (bn) => {
    Ot(bn), bt == null || bt(bn);
  }, Tn = (bn) => {
    en(bn), Tt == null || Tt(bn);
  }, xn = (bn) => {
    ln(bn), wt == null || wt(bn);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: ie, defaultExpanded: ce, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SettingsTable, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Font size",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberInput,
          {
            prefixComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faTextSize, fixedWidth: !0 }),
            value: me,
            onChange: (bn) => Xe == null ? void 0 : Xe(bn),
            suffixComponent: "px",
            min: 6,
            max: 50
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Line height",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberInput,
          {
            prefixComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faLineHeight, fixedWidth: !0 }),
            value: we,
            onChange: (bn) => ot == null ? void 0 : ot(bn),
            suffixComponent: "%",
            min: 80,
            max: 200
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Space before & after",
        description: "Space between paragraphs.",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberInput,
          {
            prefixComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faArrowDownToLine, fixedWidth: !0 }),
            value: Re,
            onChange: (bn) => St == null ? void 0 : St(bn),
            suffixComponent: "px",
            min: 0,
            max: 50
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Color",
        description: "If setting a custom color, make sure it is visible on your selected appearance.",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ColorPicker,
          {
            color: It ?? void 0,
            onChange: fn,
            resetColorTo: void 0,
            label: It ? void 0 : "Default",
            dialogPosition: "left"
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Bold",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { checked: kt, onChange: () => vn(!kt) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Italic",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { checked: Jr, onChange: () => Tn(!Jr) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SettingsMenuItem,
      {
        title: "Underline",
        ActionComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { checked: nn, onChange: () => xn(!nn) })
      }
    )
  ] }) });
}, DEFAULT_TOAST_DURATION = 5e3, useToastNotifications = () => {
  const ce = useCallback((Ue) => {
    const { title: qe, description: Ge, icon: Xe, variant: ot, duration: vt, toastPosition: bt, hideCloseButton: Tt, id: wt, darkMode: St } = Ue;
    return Vt.custom(
      (It) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        ToastNotification,
        {
          title: qe,
          description: Ge,
          variant: ot,
          visible: It.visible,
          icon: Xe,
          hideCloseButton: Tt,
          darkMode: St,
          onDismiss: () => {
            var Pt;
            Vt.dismiss(It.id), (Pt = Ue.onDismiss) == null || Pt.call(Ue);
          }
        }
      ),
      {
        duration: vt ?? DEFAULT_TOAST_DURATION,
        position: bt,
        id: wt
      }
    );
  }, []), ie = useCallback(
    (Ue) => ce({ ...Ue, variant: "success" }),
    [ce]
  ), me = useCallback(
    (Ue) => ce({ ...Ue, variant: "warning" }),
    [ce]
  ), we = useCallback(
    (Ue) => ce({ ...Ue, variant: "error" }),
    [ce]
  ), Re = useCallback(
    (Ue) => ce({ ...Ue, variant: "info" }),
    [ce]
  );
  return { addSuccessToast: ie, addWarningToast: me, addErrorToast: we, addInfoToast: Re, dismissToast: (Ue) => Vt.dismiss(Ue) };
};
export {
  Accordion,
  Action,
  ActionBox,
  AddOrEditImageActionBox,
  AdminLayout,
  AdminLayoutWrapper,
  AlignType,
  AnimatedBackground,
  AudioElement,
  AudioPlayer,
  AudioSpeedCollapsibleToolbar,
  AudioToolbar,
  BackdropOverlay,
  Badge,
  Blurb,
  Button,
  ButtonVariant,
  Checkbox,
  ChoiceSelection,
  CircleIconButton,
  ColorPicker,
  CompletionStatusLabel,
  CongratulationsOverlay,
  CustomSelect,
  DefaultErrorOverlay,
  DisplayAsset,
  Divider,
  Dock,
  DockItem,
  DockItemStatus,
  DockNavItem,
  DockStatusItem,
  DropdownToggle,
  EmptyState,
  ExternalLinkWrapper,
  FluidGrid,
  FullScreenLoader,
  GreenInformationBox,
  Grid,
  Header,
  Icon,
  IconButton,
  IconPicker,
  ImageCarousel,
  ImageLoader,
  ImageSized,
  ImageWithZoom,
  Label,
  LabeledGraphic,
  LoaderThreeDots,
  ManagerNavigationBar,
  MenuItem,
  MenuItemLabel,
  MenuItemType,
  Modal,
  NavigationBar,
  NumberInput,
  NumericSlider,
  OptionTile,
  OptionsMenu,
  OptionsMenuContext,
  OptionsMenuDivider,
  OptionsMenuItem,
  OptionsMenuItemFontColor,
  Panel,
  PassedFailedStatus,
  PlayButton,
  PlayStatus,
  Popover$1 as Popover,
  PopoverHOC,
  ProgressIndication,
  RoundButton,
  RoundButtonColor,
  Row,
  ScrollGuidedTour,
  SettingsMenuItem,
  SettingsTable,
  Slide,
  SlideWidgetBody,
  SmartImage,
  StudentButton,
  StudentNavigationBar,
  TabHeaderSlider,
  TabSelector,
  TabSelectorItem,
  Text,
  TextArea,
  TextEditorSettings,
  TextInput,
  TextOnImageWidget,
  TextToSpeechWizard,
  ToastNotification,
  Toaster,
  Toggle,
  Tooltip,
  Tree,
  UnderlineTextInput,
  UnderlineTextInputSize,
  UnderlineTextInputWithDefaultValue,
  VideoPlayer,
  WidgetAudioPlayer,
  YouTubeVideoPlayer,
  ZIndex,
  createCompletedOfTotalProgressDisplayConfiguration,
  createCompletedPercentageDisplayConfiguration,
  createPassedFailedProgressDisplayConfiguration,
  useClickOut,
  useKeyPress,
  useOnMount,
  useToastNotifications
};
